import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * An Amazon Web Services Amazon Resource Name (ARN), including the Region and account ID.
   * For more information, refer to [Amazon Resource Names](https://docs.aws.amazon.com/general/latest/gr/aws-arns-and-namespaces.html).
   */
  ARN: { input: any; output: any; }
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: { input: any; output: any; }
  /**
   * A string containing a hexadecimal representation of a color.
   *
   * For example, "#6A8D48".
   *
   */
  Color: { input: any; output: any; }
  /**
   * Represents an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)-encoded date string.
   * For example, September 7, 2019 is represented as `"2019-07-16"`.
   *
   */
  Date: { input: any; output: any; }
  /**
   * Represents an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)-encoded date and time string.
   * For example, 3:50 pm on September 7, 2019 in the time zone of UTC (Coordinated Universal Time) is
   * represented as `"2019-09-07T15:50:00Z`".
   *
   */
  DateTime: { input: any; output: any; }
  /**
   * A signed decimal number, which supports arbitrary precision and is serialized as a string.
   *
   * Example values: `"29.99"`, `"29.999"`.
   *
   */
  Decimal: { input: any; output: any; }
  /**
   * A string containing a strict subset of HTML code. Non-allowed tags will be stripped out.
   * Allowed tags:
   * * `a` (allowed attributes: `href`, `target`)
   * * `b`
   * * `br`
   * * `em`
   * * `i`
   * * `strong`
   * * `u`
   * Use [HTML](https://shopify.dev/api/admin-graphql/latest/scalars/HTML) instead if you need to
   * include other HTML tags.
   *
   * Example value: `"Your current domain is <strong>example.myshopify.com</strong>."`
   *
   */
  FormattedString: { input: any; output: any; }
  /**
   * A string containing HTML code. Refer to the [HTML spec](https://html.spec.whatwg.org/#elements-3) for a
   * complete list of HTML elements.
   *
   * Example value: `"<p>Grey cotton knit sweater.</p>"`
   *
   */
  HTML: { input: any; output: any; }
  /**
   * A [JSON](https://www.json.org/json-en.html) object.
   *
   * Example value:
   * `{
   *   "product": {
   *     "id": "gid://shopify/Product/1346443542550",
   *     "title": "White T-shirt",
   *     "options": [{
   *       "name": "Size",
   *       "values": ["M", "L"]
   *     }]
   *   }
   * }`
   *
   */
  JSON: { input: any; output: any; }
  /** A monetary value string without a currency symbol or code. Example value: `"100.57"`. */
  Money: { input: any; output: any; }
  /**
   * Represents a unique identifier in the Storefront API. A `StorefrontID` value can be used wherever an ID is expected in the Storefront API.
   *
   * Example value: `"Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzEwMDc5Nzg1MTAw"`.
   *
   */
  StorefrontID: { input: any; output: any; }
  /**
   * Represents an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   *
   * For example, `"https://example.myshopify.com"` is a valid URL. It includes a scheme (`https`) and a host
   * (`example.myshopify.com`).
   *
   */
  URL: { input: any; output: any; }
  /**
   * An unsigned 64-bit integer. Represents whole numeric values between 0 and 2^64 - 1 encoded as a string of base-10 digits.
   *
   * Example value: `"50"`.
   *
   */
  UnsignedInt64: { input: any; output: any; }
  /**
   * Time between UTC time and a location's observed time, in the format `"+HH:MM"` or `"-HH:MM"`.
   *
   * Example value: `"-07:00"`.
   *
   */
  UtcOffset: { input: any; output: any; }
};

/**
 * An incomplete checkout where the customer added items and provided contact information but didn't complete the purchase. Tracks the customer's cart contents, pricing details, addresses, and timestamps to enable recovery campaigns and abandonment analytics.
 *
 * The checkout includes a recovery URL that merchants can send to customers to resume their purchase. [`AbandonedCheckoutLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AbandonedCheckoutLineItem) objects preserve the original [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) selections, quantities, and pricing at the time of abandonment.
 */
export type AbandonedCheckout = Navigable & Node & {
  __typename?: 'AbandonedCheckout';
  /** The URL for the buyer to recover their checkout. */
  abandonedCheckoutUrl: Scalars['URL']['output'];
  /**
   * The billing address provided by the buyer.
   * Null if the user didn't provide a billing address.
   */
  billingAddress?: Maybe<MailingAddress>;
  /**
   * The date and time when the buyer completed the checkout.
   * Null if the checkout hasn't been completed.
   */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the checkout was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A list of extra information that has been added to the checkout. */
  customAttributes: Array<Attribute>;
  /**
   * The customer who created this checkout.
   * May be null if the checkout was created from a draft order or via an app.
   */
  customer?: Maybe<Customer>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The discount codes entered by the buyer at checkout. */
  discountCodes: Array<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A list of the line items in this checkout. */
  lineItems: AbandonedCheckoutLineItemConnection;
  /**
   * The number of products in the checkout.
   * @deprecated Use [AbandonedCheckoutLineItem.quantity](https://shopify.dev/api/admin-graphql/unstable/objects/AbandonedCheckoutLineItem#field-quantity) instead.
   */
  lineItemsQuantity: Scalars['Int']['output'];
  /** Unique merchant-facing identifier for the checkout. */
  name: Scalars['String']['output'];
  /** A merchant-facing note added to the checkout. Not visible to the buyer. */
  note: Scalars['String']['output'];
  /**
   * The shipping address to where the line items will be shipped.
   * Null if the user didn't provide a shipping address.
   */
  shippingAddress?: Maybe<MailingAddress>;
  /** The sum of all items in the checkout, including discounts but excluding shipping, taxes and tips. */
  subtotalPriceSet: MoneyBag;
  /** Individual taxes charged on the checkout. */
  taxLines: Array<TaxLine>;
  /** Whether taxes are included in line item and shipping line prices. */
  taxesIncluded: Scalars['Boolean']['output'];
  /** The total amount of discounts to be applied. */
  totalDiscountSet: MoneyBag;
  /** The total duties applied to the checkout. */
  totalDutiesSet?: Maybe<MoneyBag>;
  /** The sum of the prices of all line items in the checkout. */
  totalLineItemsPriceSet: MoneyBag;
  /** The sum of all items in the checkout, including discounts, shipping, taxes, and tips. */
  totalPriceSet: MoneyBag;
  /** The total tax applied to the checkout. */
  totalTaxSet?: Maybe<MoneyBag>;
  /** The date and time when the checkout was most recently updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * An incomplete checkout where the customer added items and provided contact information but didn't complete the purchase. Tracks the customer's cart contents, pricing details, addresses, and timestamps to enable recovery campaigns and abandonment analytics.
 *
 * The checkout includes a recovery URL that merchants can send to customers to resume their purchase. [`AbandonedCheckoutLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AbandonedCheckoutLineItem) objects preserve the original [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) selections, quantities, and pricing at the time of abandonment.
 */
export type AbandonedCheckoutLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple AbandonedCheckouts. */
export type AbandonedCheckoutConnection = {
  __typename?: 'AbandonedCheckoutConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AbandonedCheckoutEdge>;
  /** A list of nodes that are contained in AbandonedCheckoutEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AbandonedCheckout>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AbandonedCheckout and a cursor during pagination. */
export type AbandonedCheckoutEdge = {
  __typename?: 'AbandonedCheckoutEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AbandonedCheckoutEdge. */
  node: AbandonedCheckout;
};

/** A single line item in an abandoned checkout. */
export type AbandonedCheckoutLineItem = Node & {
  __typename?: 'AbandonedCheckoutLineItem';
  /** A list of line item components for this line item. */
  components?: Maybe<Array<AbandonedCheckoutLineItemComponent>>;
  /** A list of extra information that has been added to the line item. */
  customAttributes: Array<Attribute>;
  /** Discount allocations that have been applied on the line item. */
  discountAllocations: DiscountAllocationConnection;
  /** Final total price for the entire quantity of this line item, including discounts. */
  discountedTotalPriceSet: MoneyBag;
  /** The total price for the entire quantity of this line item, after all discounts are applied, at both the line item and code-based line item level. */
  discountedTotalPriceWithCodeDiscount: MoneyBag;
  /** The price of a single variant unit after discounts are applied at the line item level, in shop and presentment currencies. */
  discountedUnitPriceSet: MoneyBag;
  /** The price of a single variant unit after all discounts are applied, at both the line item and code-based line item level. */
  discountedUnitPriceWithCodeDiscount: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The image associated with the line item's variant or product.
   * NULL if the line item has no product, or if neither the variant nor the product have an image.
   */
  image?: Maybe<Image>;
  /** Original total price for the entire quantity of this line item, before discounts. */
  originalTotalPriceSet: MoneyBag;
  /** Original price for a single unit of this line item, before discounts. */
  originalUnitPriceSet: MoneyBag;
  /** The parent relationship for this line item. */
  parentRelationship?: Maybe<AbandonedCheckoutLineItemParentRelationship>;
  /**
   * Product for this line item.
   * NULL for custom line items and products that were deleted after checkout began.
   */
  product?: Maybe<Product>;
  /** The quantity of the line item. */
  quantity: Scalars['Int']['output'];
  /** SKU for the inventory item associated with the variant, if any. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Title of the line item. Defaults to the product's title. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Product variant for this line item.
   * NULL for custom line items and variants that were deleted after checkout began.
   */
  variant?: Maybe<ProductVariant>;
  /**
   * Title of the variant for this line item.
   * NULL for custom line items and products that don't have distinct variants.
   */
  variantTitle?: Maybe<Scalars['String']['output']>;
};


/** A single line item in an abandoned checkout. */
export type AbandonedCheckoutLineItemDiscountAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The list of line item components that belong to a line item. */
export type AbandonedCheckoutLineItemComponent = {
  __typename?: 'AbandonedCheckoutLineItemComponent';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The variant image associated with the line item component.
   * NULL if the variant associated doesn't have an image.
   */
  image?: Maybe<Image>;
  /** The quantity of the line item component. */
  quantity: Scalars['Int']['output'];
  /** Title of the line item component. */
  title: Scalars['String']['output'];
  /** The name of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple AbandonedCheckoutLineItems. */
export type AbandonedCheckoutLineItemConnection = {
  __typename?: 'AbandonedCheckoutLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AbandonedCheckoutLineItemEdge>;
  /** A list of nodes that are contained in AbandonedCheckoutLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AbandonedCheckoutLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AbandonedCheckoutLineItem and a cursor during pagination. */
export type AbandonedCheckoutLineItemEdge = {
  __typename?: 'AbandonedCheckoutLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AbandonedCheckoutLineItemEdge. */
  node: AbandonedCheckoutLineItem;
};

/** The line relationship between two line items in an abandoned checkout. */
export type AbandonedCheckoutLineItemParentRelationship = {
  __typename?: 'AbandonedCheckoutLineItemParentRelationship';
  /** The parent line item of the current line item. */
  parent: AbandonedCheckoutLineItem;
};

/** The set of valid sort keys for the AbandonedCheckout query. */
export enum AbandonedCheckoutSortKeys {
  /** Sort by the `checkout_id` value. */
  CheckoutId = 'CHECKOUT_ID',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `customer_name` value. */
  CustomerName = 'CUSTOMER_NAME',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `total_price` value. */
  TotalPrice = 'TOTAL_PRICE'
}

/**
 * Tracks a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s incomplete shopping journey, whether they abandoned while browsing [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), adding items to cart, or during checkout. Provides data about the customer's behavior and products they interacted with.
 *
 * The abandonment includes fields that indicate whether the customer has completed any [orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) or [draft orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) after the abandonment occurred. It also tracks when emails were sent and how long since the customer's last activity across different abandonment types.
 */
export type Abandonment = Node & {
  __typename?: 'Abandonment';
  /** The abandonment payload for the abandoned checkout. */
  abandonedCheckoutPayload?: Maybe<AbandonedCheckout>;
  /** The abandonment type. */
  abandonmentType: AbandonmentAbandonmentType;
  /** The app associated with an abandoned checkout. */
  app: App;
  /** Permalink to the cart page. */
  cartUrl?: Maybe<Scalars['URL']['output']>;
  /** The date and time when the abandonment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer who abandoned this event. */
  customer: Customer;
  /** Whether the customer has a draft order since this abandonment has been abandoned. */
  customerHasNoDraftOrderSinceAbandonment: Scalars['Boolean']['output'];
  /** Whether the customer has completed an order since this checkout has been abandoned. */
  customerHasNoOrderSinceAbandonment: Scalars['Boolean']['output'];
  /** The number of days since the last abandonment email was sent to the customer. */
  daysSinceLastAbandonmentEmail: Scalars['Int']['output'];
  /** When the email was sent, if that's the case. */
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email state (e.g., sent or not sent). */
  emailState?: Maybe<AbandonmentEmailState>;
  /** The number of hours since the customer has last abandoned a checkout. */
  hoursSinceLastAbandonedCheckout?: Maybe<Scalars['Float']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the products in abandonment are available. */
  inventoryAvailable: Scalars['Boolean']['output'];
  /** Whether the abandonment event comes from a custom storefront channel. */
  isFromCustomStorefront: Scalars['Boolean']['output'];
  /** Whether the abandonment event comes from the Online Store sales channel. */
  isFromOnlineStore: Scalars['Boolean']['output'];
  /** Whether the abandonment event comes from the Shop app sales channel. */
  isFromShopApp: Scalars['Boolean']['output'];
  /** Whether the abandonment event comes from Shop Pay. */
  isFromShopPay: Scalars['Boolean']['output'];
  /** Whether the customer didn't complete another most significant step since this abandonment. */
  isMostSignificantAbandonment: Scalars['Boolean']['output'];
  /** The date for the latest browse abandonment. */
  lastBrowseAbandonmentDate: Scalars['DateTime']['output'];
  /** The date for the latest cart abandonment. */
  lastCartAbandonmentDate: Scalars['DateTime']['output'];
  /** The date for the latest checkout abandonment. */
  lastCheckoutAbandonmentDate: Scalars['DateTime']['output'];
  /** The most recent step type. */
  mostRecentStep: AbandonmentAbandonmentType;
  /** The products added to the cart during the customer abandoned visit. */
  productsAddedToCart: CustomerVisitProductInfoConnection;
  /** The products viewed during the customer abandoned visit. */
  productsViewed: CustomerVisitProductInfoConnection;
  /** The date and time when the visit started. */
  visitStartedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * Tracks a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s incomplete shopping journey, whether they abandoned while browsing [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), adding items to cart, or during checkout. Provides data about the customer's behavior and products they interacted with.
 *
 * The abandonment includes fields that indicate whether the customer has completed any [orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) or [draft orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) after the abandonment occurred. It also tracks when emails were sent and how long since the customer's last activity across different abandonment types.
 */
export type AbandonmentProductsAddedToCartArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Tracks a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s incomplete shopping journey, whether they abandoned while browsing [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), adding items to cart, or during checkout. Provides data about the customer's behavior and products they interacted with.
 *
 * The abandonment includes fields that indicate whether the customer has completed any [orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) or [draft orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) after the abandonment occurred. It also tracks when emails were sent and how long since the customer's last activity across different abandonment types.
 */
export type AbandonmentProductsViewedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies the abandonment type. */
export enum AbandonmentAbandonmentType {
  /** The abandonment event is an abandoned browse. */
  Browse = 'BROWSE',
  /** The abandonment event is an abandoned cart. */
  Cart = 'CART',
  /** The abandonment event is an abandoned checkout. */
  Checkout = 'CHECKOUT'
}

/** Specifies the delivery state of a marketing activity. */
export enum AbandonmentDeliveryState {
  /** The marketing activity action has not yet been sent. */
  NotSent = 'NOT_SENT',
  /** The marketing activity action has been scheduled for later delivery. */
  Scheduled = 'SCHEDULED',
  /** The marketing activity action has been sent. */
  Sent = 'SENT'
}

/** Specifies the email state. */
export enum AbandonmentEmailState {
  /** The email has not yet been sent. */
  NotSent = 'NOT_SENT',
  /** The email has been scheduled for later delivery. */
  Scheduled = 'SCHEDULED',
  /** The email has been sent. */
  Sent = 'SENT'
}

/** Return type for `abandonmentEmailStateUpdate` mutation. */
export type AbandonmentEmailStateUpdatePayload = {
  __typename?: 'AbandonmentEmailStateUpdatePayload';
  /** The updated abandonment. */
  abandonment?: Maybe<Abandonment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<AbandonmentEmailStateUpdateUserError>;
};

/** An error that occurs during the execution of `AbandonmentEmailStateUpdate`. */
export type AbandonmentEmailStateUpdateUserError = DisplayableError & {
  __typename?: 'AbandonmentEmailStateUpdateUserError';
  /** The error code. */
  code?: Maybe<AbandonmentEmailStateUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `AbandonmentEmailStateUpdateUserError`. */
export enum AbandonmentEmailStateUpdateUserErrorCode {
  /** Unable to find an Abandonment for the provided ID. */
  AbandonmentNotFound = 'ABANDONMENT_NOT_FOUND'
}

/** Return type for `abandonmentUpdateActivitiesDeliveryStatuses` mutation. */
export type AbandonmentUpdateActivitiesDeliveryStatusesPayload = {
  __typename?: 'AbandonmentUpdateActivitiesDeliveryStatusesPayload';
  /** The updated abandonment. */
  abandonment?: Maybe<Abandonment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<AbandonmentUpdateActivitiesDeliveryStatusesUserError>;
};

/** An error that occurs during the execution of `AbandonmentUpdateActivitiesDeliveryStatuses`. */
export type AbandonmentUpdateActivitiesDeliveryStatusesUserError = DisplayableError & {
  __typename?: 'AbandonmentUpdateActivitiesDeliveryStatusesUserError';
  /** The error code. */
  code?: Maybe<AbandonmentUpdateActivitiesDeliveryStatusesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `AbandonmentUpdateActivitiesDeliveryStatusesUserError`. */
export enum AbandonmentUpdateActivitiesDeliveryStatusesUserErrorCode {
  /** Unable to find an Abandonment for the provided ID. */
  AbandonmentNotFound = 'ABANDONMENT_NOT_FOUND',
  /** Unable to find delivery status info for the provided ID. */
  DeliveryStatusInfoNotFound = 'DELIVERY_STATUS_INFO_NOT_FOUND',
  /** Unable to find a marketing activity for the provided ID. */
  MarketingActivityNotFound = 'MARKETING_ACTIVITY_NOT_FOUND'
}

/**
 * A permission that controls access to [GraphQL Admin API](https://shopify.dev/docs/api/usage/access-scopes#authenticated-access-scopes) or [Storefront API](https://shopify.dev/docs/api/usage/access-scopes#unauthenticated-access-scopes) types. Each scope defines what data an [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can read or write, following the format `{action}_{resource}` where action is typically "read" or "write".
 *
 * Apps declare required and optional access scopes in their configuration. During installation, merchants review and grant these permissions, determining what shop data the app can access. The granted scopes remain active until the merchant uninstalls the app or revokes them. Apps can programmatically revoke their own dynamically granted optional scopes using [`appRevokeAccessScopes`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/appRevokeAccessScopes).
 */
export type AccessScope = {
  __typename?: 'AccessScope';
  /** A description of the actions that the access scope allows an app to perform. */
  description: Scalars['String']['output'];
  /** A readable string that represents the access scope. The string usually follows the format `{action}_{resource}`. `{action}` is `read` or `write`, and `{resource}` is the resource that the action can be performed on. `{action}` and `{resource}` are separated by an underscore. For example, `read_orders` or `write_products`. */
  handle: Scalars['String']['output'];
};

/** Possible account types that a staff member can have. */
export enum AccountType {
  /** The account of a partner who collaborates with the merchant. */
  Collaborator = 'COLLABORATOR',
  /** The account of a partner collaborator team member. */
  CollaboratorTeamMember = 'COLLABORATOR_TEAM_MEMBER',
  /** The user has not yet accepted the invitation to create an account. */
  Invited = 'INVITED',
  /** The user has not yet accepted the invitation to become the store owner. */
  InvitedStoreOwner = 'INVITED_STORE_OWNER',
  /** The account can access the Shopify admin. */
  Regular = 'REGULAR',
  /** The admin has not yet accepted the request to create a collaborator account. */
  Requested = 'REQUESTED',
  /** The account cannot access the Shopify admin. */
  Restricted = 'RESTRICTED',
  /** The account can be signed into via a SAML provider. */
  Saml = 'SAML'
}

/** Represents an operation publishing all products to a publication. */
export type AddAllProductsOperation = Node & ResourceOperation & {
  __typename?: 'AddAllProductsOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  processedRowCount?: Maybe<Scalars['Int']['output']>;
  /** Represents a rows objects within this background operation. */
  rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  status: ResourceOperationStatus;
};

/**
 * Additional fees applied to an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) beyond the standard product and shipping costs. Additional fees typically include duties, import fees, or other special handling charges that need separate tracking from regular [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects.
 *
 * Each fee includes its name, price in both shop and presentment currencies, and any applicable taxes broken down by [`TaxLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TaxLine).
 */
export type AdditionalFee = Node & {
  __typename?: 'AdditionalFee';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the additional fee. */
  name: Scalars['String']['output'];
  /** The price of the additional fee. */
  price: MoneyBag;
  /** A list of taxes charged on the additional fee. */
  taxLines: Array<TaxLine>;
};

/** A sale associated with an additional fee charge. */
export type AdditionalFeeSale = Sale & {
  __typename?: 'AdditionalFeeSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The additional fees for the associated sale. */
  additionalFee: SaleAdditionalFee;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** A sale associated with an order price adjustment. */
export type AdjustmentSale = Sale & {
  __typename?: 'AdjustmentSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** The set of valid sort keys for the Adjustments query. */
export enum AdjustmentsSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `time` value. */
  Time = 'TIME'
}

/**
 * Represents a discount configuration that applies to all items in a customer's cart without restriction. This object enables store-wide promotions that affect every product equally.
 *
 * For example, a "Sitewide 10% Off Everything" sale would target all items, ensuring that every product in the customer's cart receives the promotional discount regardless of category or collection.
 *
 * This universal targeting approach simplifies promotional campaigns and provides customers with clear, straightforward savings across the entire product catalog.
 */
export type AllDiscountItems = {
  __typename?: 'AllDiscountItems';
  /** Whether all items are eligible for the discount. This value always returns `true`. */
  allItems: Scalars['Boolean']['output'];
};

/** The Android mobile platform application. */
export type AndroidApplication = {
  __typename?: 'AndroidApplication';
  /** Whether Android App Links are supported by this app. */
  appLinksEnabled: Scalars['Boolean']['output'];
  /** The Android application ID. */
  applicationId?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The SHA256 fingerprints of the app's signing certificate. */
  sha256CertFingerprints: Array<Scalars['String']['output']>;
};

/**
 * A version of the API, as defined by [Shopify API versioning](https://shopify.dev/api/usage/versioning).
 * Versions are commonly referred to by their handle (for example, `2021-10`).
 */
export type ApiVersion = {
  __typename?: 'ApiVersion';
  /** The human-readable name of the version. */
  displayName: Scalars['String']['output'];
  /** The unique identifier of an ApiVersion. All supported API versions have a date-based (YYYY-MM) or `unstable` handle. */
  handle: Scalars['String']['output'];
  /** Whether the version is actively supported by Shopify. Supported API versions are guaranteed to be stable. Unsupported API versions include unstable, release candidate, and end-of-life versions that are marked as unsupported. For more information, refer to [Versioning](https://shopify.dev/api/usage/versioning). */
  supported: Scalars['Boolean']['output'];
};

/**
 * A Shopify application that extends store functionality. Apps integrate with Shopify through APIs to add features, automate workflows, or connect external services.
 *
 * Provides metadata about the app including its developer information and listing details in the Shopify App Store. Use the [`installation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App#field-App.fields.installation) field to determine if the app is currently installed on the shop and access installation-specific details like granted [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects. Check [`failedRequirements`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App#field-App.fields.failedRequirements) before installation to identify any prerequisites that must be met.
 */
export type App = Node & {
  __typename?: 'App';
  /** A unique application API identifier. */
  apiKey: Scalars['String']['output'];
  /** App store page URL of the app. */
  appStoreAppUrl?: Maybe<Scalars['URL']['output']>;
  /** App store page URL of the developer who created the app. */
  appStoreDeveloperUrl?: Maybe<Scalars['URL']['output']>;
  /** All requestable access scopes available to the app. */
  availableAccessScopes: Array<AccessScope>;
  /** Banner image for the app. */
  banner: Image;
  /** The sales channels associated with this app. */
  channels: ChannelConnection;
  /** Description of the app. */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the app developer. */
  developerName?: Maybe<Scalars['String']['output']>;
  /** The type of app developer. */
  developerType: AppDeveloperType;
  /**
   * Website of the developer who created the app.
   * @deprecated Use `appStoreDeveloperUrl` instead.
   */
  developerUrl: Scalars['URL']['output'];
  /** Whether the app uses the Embedded App SDK. */
  embedded: Scalars['Boolean']['output'];
  /** Requirements that must be met before the app can be installed. */
  failedRequirements: Array<FailedRequirement>;
  /** A list of app features that are shown in the Shopify App Store listing. */
  features: Array<Scalars['String']['output']>;
  /** Feedback from this app about the store. */
  feedback?: Maybe<AppFeedback>;
  /** Handle of the app. */
  handle?: Maybe<Scalars['String']['output']>;
  /** Icon that represents the app. */
  icon: Image;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Webpage where you can install the app, if app requires explicit user permission. */
  installUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * Corresponding AppInstallation for this shop and App.
   * Returns null if the App isn't installed.
   */
  installation?: Maybe<AppInstallation>;
  /** Whether the app is the [post purchase](https://shopify.dev/apps/checkout/post-purchase) app in use. */
  isPostPurchaseAppInUse: Scalars['Boolean']['output'];
  /**
   * Webpage that the app starts in.
   * @deprecated Use AppInstallation.launchUrl instead
   */
  launchUrl: Scalars['URL']['output'];
  /**
   * Menu items for the app, which also appear as submenu items in left navigation sidebar in the Shopify admin.
   * @deprecated Use AppInstallation.navigationItems instead
   */
  navigationItems: Array<NavigationItem>;
  /** The optional scopes requested by the app. Lists the optional access scopes the app has declared in its configuration. These scopes are optionally requested by the app after installation. */
  optionalAccessScopes: Array<AccessScope>;
  /** Whether the app was previously installed on the current shop. */
  previouslyInstalled: Scalars['Boolean']['output'];
  /** Detailed information about the app pricing. */
  pricingDetails?: Maybe<Scalars['String']['output']>;
  /** Summary of the app pricing details. */
  pricingDetailsSummary: Scalars['String']['output'];
  /** Link to app privacy policy. */
  privacyPolicyUrl?: Maybe<Scalars['URL']['output']>;
  /** The public category for the app. */
  publicCategory: AppPublicCategory;
  /** Whether the app is published to the Shopify App Store. */
  published: Scalars['Boolean']['output'];
  /** The access scopes requested by the app. Lists the access scopes the app has declared in its configuration. Merchant must grant approval to these scopes for the app to be installed. */
  requestedAccessScopes: Array<AccessScope>;
  /** Screenshots of the app. */
  screenshots: Array<Image>;
  /** Whether the app was developed by Shopify. */
  shopifyDeveloped: Scalars['Boolean']['output'];
  /** Name of the app. */
  title: Scalars['String']['output'];
  /**
   * Message that appears when the app is uninstalled. For example:
   * By removing this app, you will no longer be able to publish products to MySocialSite or view this app in your Shopify admin. You can re-enable this channel at any time.
   */
  uninstallMessage: Scalars['String']['output'];
  /**
   * Webpage where you can uninstall the app.
   * @deprecated Use AppInstallation.uninstallUrl instead
   */
  uninstallUrl?: Maybe<Scalars['URL']['output']>;
  /** The webhook API version for the app. */
  webhookApiVersion: Scalars['String']['output'];
};


/**
 * A Shopify application that extends store functionality. Apps integrate with Shopify through APIs to add features, automate workflows, or connect external services.
 *
 * Provides metadata about the app including its developer information and listing details in the Shopify App Store. Use the [`installation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App#field-App.fields.installation) field to determine if the app is currently installed on the shop and access installation-specific details like granted [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects. Check [`failedRequirements`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App#field-App.fields.failedRequirements) before installation to identify any prerequisites that must be met.
 */
export type AppChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A catalog that defines the publication associated with an app. */
export type AppCatalog = Catalog & Node & {
  __typename?: 'AppCatalog';
  /** The apps associated with the catalog. */
  apps: AppConnection;
  /** The channels associated with the catalog. */
  channels: ChannelConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Most recent catalog operations. */
  operations: Array<ResourceOperation>;
  /** The price list associated with the catalog. */
  priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  publication?: Maybe<Publication>;
  /** The status of the catalog. */
  status: CatalogStatus;
  /** The name of the catalog. */
  title: Scalars['String']['output'];
};


/** A catalog that defines the publication associated with an app. */
export type AppCatalogAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A catalog that defines the publication associated with an app. */
export type AppCatalogChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple Apps. */
export type AppConnection = {
  __typename?: 'AppConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppEdge>;
  /** A list of nodes that are contained in AppEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<App>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/**
 * Represents monetary credits that merchants can apply toward future app purchases, subscriptions, or usage-based billing within their Shopify store. App credits provide a flexible way to offer refunds, promotional credits, or compensation without processing external payments.
 *
 * For example, if a merchant experiences service downtime, an app might issue credits equivalent to the affected billing period. These credits can apply to future charges, reducing the merchant's next invoice or extending their subscription period.
 *
 * Use the `AppCredit` object to:
 * - Issue refunds for service interruptions or billing disputes
 * - Provide promotional credits for new merchant onboarding
 * - Compensate merchants for app-related issues or downtime
 * - Create loyalty rewards or referral bonuses within your billing system
 * - Track credit balances and application history for accounting purposes
 *
 * For comprehensive billing strategies and credit management patterns, see the [subscription billing guide](https://shopify.dev/docs/apps/launch/billing/subscription-billing).
 */
export type AppCredit = Node & {
  __typename?: 'AppCredit';
  /** The amount that can be used towards future app purchases in Shopify. */
  amount: MoneyV2;
  /** The date and time when the app credit was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the app credit. */
  description: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the app credit is a test transaction. */
  test: Scalars['Boolean']['output'];
};

/** An auto-generated type for paginating through multiple AppCredits. */
export type AppCreditConnection = {
  __typename?: 'AppCreditConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppCreditEdge>;
  /** A list of nodes that are contained in AppCreditEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppCredit>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppCredit and a cursor during pagination. */
export type AppCreditEdge = {
  __typename?: 'AppCreditEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppCreditEdge. */
  node: AppCredit;
};

/** Possible types of app developer. */
export enum AppDeveloperType {
  /** Indicates the app developer works directly for a Merchant. */
  Merchant = 'MERCHANT',
  /** Indicates the app developer is a Partner. */
  Partner = 'PARTNER',
  /** Indicates the app developer is Shopify. */
  Shopify = 'SHOPIFY',
  /** Indicates the app developer is unknown. It is not categorized as any of the other developer types. */
  Unknown = 'UNKNOWN'
}

/**
 * The details about the app extension that's providing the
 * [discount type](https://help.shopify.com/manual/discounts/discount-types).
 * This information includes the app extension's name and
 * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
 * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
 * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
 * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
 * and other metadata about the discount type, including the discount type's name and description.
 */
export type AppDiscountType = {
  __typename?: 'AppDiscountType';
  /**
   * The name of the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  app: App;
  /**
   * The [App Bridge configuration](https://shopify.dev/docs/api/app-bridge)
   * for the [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  appBridge: FunctionsAppBridge;
  /**
   * The [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets)
   * of the app extension that's providing the [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  appKey: Scalars['String']['output'];
  /**
   * A description of the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types)
   * provided by the app extension.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: DiscountClass;
  /**
   * The list of [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that this app extension supports.
   */
  discountClasses: Array<DiscountClass>;
  /**
   * The
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries)
   * associated with the app extension providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  functionId: Scalars['String']['output'];
  /**
   * The type of line item on an order that the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types) applies to.
   * Valid values: `SHIPPING_LINE` and `LINE_ITEM`.
   * @deprecated Use `discountClasses` instead.
   */
  targetType: DiscountApplicationTargetType;
  /**
   * The name of the [discount type](https://help.shopify.com/manual/discounts/discount-types)
   * that the app extension is providing.
   */
  title: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple AppDiscountTypes. */
export type AppDiscountTypeConnection = {
  __typename?: 'AppDiscountTypeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppDiscountTypeEdge>;
  /** A list of nodes that are contained in AppDiscountTypeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppDiscountType>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppDiscountType and a cursor during pagination. */
export type AppDiscountTypeEdge = {
  __typename?: 'AppDiscountTypeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppDiscountTypeEdge. */
  node: AppDiscountType;
};

/** An auto-generated type which holds one App and a cursor during pagination. */
export type AppEdge = {
  __typename?: 'AppEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppEdge. */
  node: App;
};

/**
 * Reports the status of shops and their resources and displays this information
 * within Shopify admin. AppFeedback is used to notify merchants about steps they need to take
 * to set up an app on their store.
 */
export type AppFeedback = {
  __typename?: 'AppFeedback';
  /** The application associated to the feedback. */
  app: App;
  /** The channel this feedback is for. */
  channel?: Maybe<Channel>;
  /** The date and time when the app feedback was generated. */
  feedbackGeneratedAt: Scalars['DateTime']['output'];
  /** A link to where merchants can resolve errors. */
  link?: Maybe<Link>;
  /** The feedback message presented to the merchant. */
  messages: Array<UserError>;
  /** Conveys the state of the feedback and whether it requires merchant action or not. */
  state: ResourceFeedbackState;
};

/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallation = HasMetafields & Node & {
  __typename?: 'AppInstallation';
  /** The access scopes granted to the application by a merchant during installation. */
  accessScopes: Array<AccessScope>;
  /** The active application subscriptions billed to the shop on a recurring basis. */
  activeSubscriptions: Array<AppSubscription>;
  /** All subscriptions created for a shop. */
  allSubscriptions: AppSubscriptionConnection;
  /** Application which is installed. */
  app: App;
  /**
   * Channel associated with the installed application.
   * @deprecated Use the root-level `channels` query instead.
   */
  channel?: Maybe<Channel>;
  /** Credits that can be used towards future app purchases. */
  credits: AppCreditConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The URL to launch the application. */
  launchUrl: Scalars['URL']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** One-time purchases to a shop. */
  oneTimePurchases: AppPurchaseOneTimeConnection;
  /**
   * The publication associated with the installed application.
   * @deprecated Use the root-level `publications` query instead.
   */
  publication?: Maybe<Publication>;
  /** The records that track the externally-captured revenue for the app. The records are used for revenue attribution purposes. */
  revenueAttributionRecords: AppRevenueAttributionRecordConnection;
  /**
   * Subscriptions charge to a shop on a recurring basis.
   * @deprecated Use `activeSubscriptions` instead.
   */
  subscriptions: Array<AppSubscription>;
  /** The URL to uninstall the application. */
  uninstallUrl?: Maybe<Scalars['URL']['output']>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationAllSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppSubscriptionSortKeys>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationCreditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppTransactionSortKeys>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationOneTimePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppTransactionSortKeys>;
};


/**
 * An app installed on a shop. Each installation tracks the permissions granted to the app through [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, along with billing subscriptions and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 *
 * The installation provides metafields that only the owning [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) can access. These metafields store app-specific configuration that merchants and other apps can't modify. The installation also provides URLs for launching and uninstalling the app, along with any active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects or [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) purchases.
 */
export type AppInstallationRevenueAttributionRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppRevenueAttributionRecordSortKeys>;
};

/**
 * The possible categories of an app installation, based on their purpose
 * or the environment they can run in.
 */
export enum AppInstallationCategory {
  /** Apps that serve as channels through which sales are made, such as the online store. */
  Channel = 'CHANNEL',
  /** Apps that can be used in the POS mobile client. */
  PosEmbedded = 'POS_EMBEDDED'
}

/** An auto-generated type for paginating through multiple AppInstallations. */
export type AppInstallationConnection = {
  __typename?: 'AppInstallationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppInstallationEdge>;
  /** A list of nodes that are contained in AppInstallationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppInstallation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppInstallation and a cursor during pagination. */
export type AppInstallationEdge = {
  __typename?: 'AppInstallationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppInstallationEdge. */
  node: AppInstallation;
};

/** The levels of privacy of an app installation. */
export enum AppInstallationPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** The set of valid sort keys for the AppInstallation query. */
export enum AppInstallationSortKeys {
  /** Sort by the `app_title` value. */
  AppTitle = 'APP_TITLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `installed_at` value. */
  InstalledAt = 'INSTALLED_AT'
}

/**
 * The pricing model for the app subscription.
 * The pricing model input can be either `appRecurringPricingDetails` or `appUsagePricingDetails`.
 */
export type AppPlanInput = {
  /** The pricing details for recurring billing. */
  appRecurringPricingDetails?: InputMaybe<AppRecurringPricingInput>;
  /** The pricing details for usage-based billing. */
  appUsagePricingDetails?: InputMaybe<AppUsagePricingInput>;
};

/**
 * Contains the pricing details for the app plan that a merchant has subscribed to within their current billing arrangement.
 *
 * This simplified object focuses on the essential pricing information merchants need to understand their current subscription costs and billing structure.
 *
 * Details about subscription management and pricing strategies are available in the [app billing documentation](https://shopify.dev/docs/apps/launch/billing).
 */
export type AppPlanV2 = {
  __typename?: 'AppPlanV2';
  /** The plan billed to a shop on a recurring basis. */
  pricingDetails: AppPricingDetails;
};

/**
 * The information about the price that's charged to a shop every plan period.
 * The concrete type can be `AppRecurringPricing` for recurring billing or `AppUsagePricing` for usage-based billing.
 */
export type AppPricingDetails = AppRecurringPricing | AppUsagePricing;

/** The frequency at which the shop is billed for an app subscription. */
export enum AppPricingInterval {
  /** The app subscription bills the shop annually. */
  Annual = 'ANNUAL',
  /** The app subscription bills the shop every 30 days. */
  Every_30Days = 'EVERY_30_DAYS'
}

/** The public-facing category for an app. */
export enum AppPublicCategory {
  /** The app's public category is [custom](https://shopify.dev/apps/distribution#capabilities-and-requirements). */
  Custom = 'CUSTOM',
  /** The app's public category is other. An app is in this category if it's not classified under any of the other app types (private, public, or custom). */
  Other = 'OTHER',
  /** The app's public category is [private](https://shopify.dev/apps/distribution#deprecated-app-types). */
  Private = 'PRIVATE',
  /** The app's public category is [public](https://shopify.dev/apps/distribution#capabilities-and-requirements). */
  Public = 'PUBLIC'
}

/** Services and features purchased once by the store. */
export type AppPurchase = {
  /** The date and time when the app purchase occurred. */
  createdAt: Scalars['DateTime']['output'];
  /** The name of the app purchase. */
  name: Scalars['String']['output'];
  /** The amount to be charged to the store for the app purchase. */
  price: MoneyV2;
  /** The status of the app purchase. */
  status: AppPurchaseStatus;
  /** Whether the app purchase is a test transaction. */
  test: Scalars['Boolean']['output'];
};

/**
 * Represents a one-time purchase of app services or features by a merchant, tracking the transaction details and status throughout the billing lifecycle. This object captures essential information about non-recurring charges, including price and merchant acceptance status.
 *
 * One-time purchases are particularly valuable for apps offering premium features, professional services, or digital products that don't require ongoing subscriptions. For instance, a photography app might sell premium filters as one-time purchases, while a marketing app could charge for individual campaign setups or advanced analytics reports.
 *
 * Use the `AppPurchaseOneTime` object to:
 * - Track the status of individual feature purchases and service charges
 * - Track payment status for premium content or digital products
 * - Access purchase details to enable or disable features based on payment status
 *
 * The purchase status indicates whether the charge is pending merchant approval, has been accepted and processed, or was declined. This status tracking is crucial for apps that need to conditionally enable features based on successful payment completion.
 *
 * Purchase records include creation timestamps, pricing details, and test flags to distinguish between production charges and development testing. The test flag ensures that development and staging environments don't generate actual charges while maintaining realistic billing flow testing.
 *
 * For detailed implementation patterns and billing best practices, see the [one-time-charges page](https://shopify.dev/docs/apps/launch/billing/one-time-charges).
 */
export type AppPurchaseOneTime = AppPurchase & Node & {
  __typename?: 'AppPurchaseOneTime';
  /** The date and time when the app purchase occurred. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the app purchase. */
  name: Scalars['String']['output'];
  /** The amount to be charged to the store for the app purchase. */
  price: MoneyV2;
  /** The status of the app purchase. */
  status: AppPurchaseStatus;
  /** Whether the app purchase is a test transaction. */
  test: Scalars['Boolean']['output'];
};

/** An auto-generated type for paginating through multiple AppPurchaseOneTimes. */
export type AppPurchaseOneTimeConnection = {
  __typename?: 'AppPurchaseOneTimeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppPurchaseOneTimeEdge>;
  /** A list of nodes that are contained in AppPurchaseOneTimeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppPurchaseOneTime>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `appPurchaseOneTimeCreate` mutation. */
export type AppPurchaseOneTimeCreatePayload = {
  __typename?: 'AppPurchaseOneTimeCreatePayload';
  /** The newly created app one-time purchase. */
  appPurchaseOneTime?: Maybe<AppPurchaseOneTime>;
  /**
   * The URL that the merchant can access to approve or decline the newly created app one-time purchase.
   *
   * If the merchant declines, then the merchant is redirected to the app and receives a notification message stating that the charge was declined.
   * If the merchant approves and they're successfully invoiced, then the state of the charge changes from `pending` to `active`.
   *
   * You get paid after the charge is activated.
   */
  confirmationUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one AppPurchaseOneTime and a cursor during pagination. */
export type AppPurchaseOneTimeEdge = {
  __typename?: 'AppPurchaseOneTimeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppPurchaseOneTimeEdge. */
  node: AppPurchaseOneTime;
};

/**
 * The approval status of the app purchase.
 *
 * The merchant is charged for the purchase immediately after approval, and the status changes to `active`.
 * If the payment fails, then the app purchase remains `pending`.
 *
 * Purchases start as `pending` and can change to: `active`, `declined`, `expired`. After a purchase changes, it
 * remains in that final state.
 */
export enum AppPurchaseStatus {
  /**
   * The app purchase has been approved by the merchant and is ready to be activated by the app. App purchases created through the GraphQL Admin API are activated upon approval.
   * @deprecated When a merchant accepts an app purchase, the status immediately changes from `pending` to `active`.
   */
  Accepted = 'ACCEPTED',
  /** The app purchase was approved by the merchant and has been activated by the app. Active app purchases are charged to the merchant and are paid out to the partner. */
  Active = 'ACTIVE',
  /** The app purchase was declined by the merchant. */
  Declined = 'DECLINED',
  /** The app purchase was not accepted within two days of being created. */
  Expired = 'EXPIRED',
  /** The app purchase is pending approval by the merchant. */
  Pending = 'PENDING'
}

/**
 * The pricing information about a subscription app.
 * The object contains an interval (the frequency at which the shop is billed for an app subscription) and
 * a price (the amount to be charged to the subscribing shop at each interval).
 */
export type AppRecurringPricing = {
  __typename?: 'AppRecurringPricing';
  /** The discount applied to the subscription for a given number of billing intervals. */
  discount?: Maybe<AppSubscriptionDiscount>;
  /** The frequency at which the subscribing shop is billed for an app subscription. */
  interval: AppPricingInterval;
  /** The app store pricing plan handle. */
  planHandle?: Maybe<Scalars['String']['output']>;
  /** The amount and currency to be charged to the subscribing shop every billing interval. */
  price: MoneyV2;
};

/** Instructs the app subscription to generate a fixed charge on a recurring basis. The frequency is specified by the billing interval. */
export type AppRecurringPricingInput = {
  /** The discount applied to the subscription for a given number of billing intervals. */
  discount?: InputMaybe<AppSubscriptionDiscountInput>;
  /** How often the app subscription generates a charge. */
  interval?: InputMaybe<AppPricingInterval>;
  /** The amount to be charged to the store every billing interval. */
  price: MoneyInput;
};

/**
 * Tracks revenue that was captured outside of Shopify's billing system but needs to be attributed to the app for comprehensive revenue reporting and partner analytics. This object enables accurate revenue tracking when apps process payments through external systems while maintaining visibility into total app performance.
 *
 * External revenue attribution is essential for apps that offer multiple payment channels or process certain transactions outside Shopify's billing infrastructure. For example, an enterprise app might process large custom contracts through external payment processors, or a marketplace app could handle direct merchant-to-merchant transactions that still generate app commissions.
 *
 * Use the `AppRevenueAttributionRecord` object to:
 * - Report revenue from external payment processors and billing systems
 * - Track commission-based earnings from marketplace or referral activities
 * - Maintain comprehensive revenue analytics across multiple payment channels
 * - Ensure accurate partner revenue sharing and commission calculations
 * - Generate complete financial reports that include all app-generated revenue streams
 * - Support compliance requirements for external revenue documentation
 *
 * Each attribution record includes the captured amount, external transaction timestamp, and idempotency keys to prevent duplicate reporting. The record type field categorizes different revenue streams, enabling detailed analytics and reporting segmentation.
 *
 * Revenue attribution records are particularly important for apps participating in Shopify's partner program, as they ensure accurate revenue sharing calculations and comprehensive performance metrics. The captured timestamp reflects when the external payment was processed, not when the attribution record was created in Shopify.
 *
 * For detailed revenue attribution values, see the [AppRevenueAttributionType enum](https://shopify.dev/docs/api/admin-graphql/latest/enums/AppRevenueAttributionType).
 */
export type AppRevenueAttributionRecord = Node & {
  __typename?: 'AppRevenueAttributionRecord';
  /** The financial amount captured in this attribution. */
  amount: MoneyV2;
  /** The timestamp when the financial amount was captured. */
  capturedAt: Scalars['DateTime']['output'];
  /** The timestamp at which this revenue attribution was issued. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The unique value submitted during the creation of the app revenue attribution record.
   * For more information, refer to
   * [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests).
   */
  idempotencyKey: Scalars['String']['output'];
  /** Indicates whether this is a test submission. */
  test: Scalars['Boolean']['output'];
  /** The type of revenue attribution. */
  type: AppRevenueAttributionType;
};

/** An auto-generated type for paginating through multiple AppRevenueAttributionRecords. */
export type AppRevenueAttributionRecordConnection = {
  __typename?: 'AppRevenueAttributionRecordConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppRevenueAttributionRecordEdge>;
  /** A list of nodes that are contained in AppRevenueAttributionRecordEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppRevenueAttributionRecord>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppRevenueAttributionRecord and a cursor during pagination. */
export type AppRevenueAttributionRecordEdge = {
  __typename?: 'AppRevenueAttributionRecordEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppRevenueAttributionRecordEdge. */
  node: AppRevenueAttributionRecord;
};

/** The set of valid sort keys for the AppRevenueAttributionRecord query. */
export enum AppRevenueAttributionRecordSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Represents the billing types of revenue attribution. */
export enum AppRevenueAttributionType {
  /** App purchase related revenue collection. */
  ApplicationPurchase = 'APPLICATION_PURCHASE',
  /** App subscription revenue collection. */
  ApplicationSubscription = 'APPLICATION_SUBSCRIPTION',
  /** App usage-based revenue collection. */
  ApplicationUsage = 'APPLICATION_USAGE',
  /** Other app revenue collection type. */
  Other = 'OTHER'
}

/** Represents an error that happens while revoking a granted scope. */
export type AppRevokeAccessScopesAppRevokeScopeError = DisplayableError & {
  __typename?: 'AppRevokeAccessScopesAppRevokeScopeError';
  /** The error code. */
  code?: Maybe<AppRevokeAccessScopesAppRevokeScopeErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `AppRevokeAccessScopesAppRevokeScopeError`. */
export enum AppRevokeAccessScopesAppRevokeScopeErrorCode {
  /** The application cannot be found. */
  ApplicationCannotBeFound = 'APPLICATION_CANNOT_BE_FOUND',
  /** App is not installed on shop. */
  AppNotInstalled = 'APP_NOT_INSTALLED',
  /** Already granted implied scopes cannot be revoked. */
  CannotRevokeImpliedScopes = 'CANNOT_REVOKE_IMPLIED_SCOPES',
  /** Required scopes cannot be revoked. */
  CannotRevokeRequiredScopes = 'CANNOT_REVOKE_REQUIRED_SCOPES',
  /** Cannot revoke optional scopes that haven't been declared. */
  CannotRevokeUndeclaredScopes = 'CANNOT_REVOKE_UNDECLARED_SCOPES',
  /** No app found on the access token. */
  MissingSourceApp = 'MISSING_SOURCE_APP',
  /** The requested list of scopes to revoke includes invalid handles. */
  UnknownScopes = 'UNKNOWN_SCOPES'
}

/** Return type for `appRevokeAccessScopes` mutation. */
export type AppRevokeAccessScopesPayload = {
  __typename?: 'AppRevokeAccessScopesPayload';
  /** The list of scope handles that have been revoked. */
  revoked?: Maybe<Array<AccessScope>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<AppRevokeAccessScopesAppRevokeScopeError>;
};

/**
 * A recurring billing agreement that associates an [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) with a merchant's shop. Each subscription contains one or more [`AppSubscriptionLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscriptionLineItem) objects that define the pricing structure. The pricing structure can include recurring charges, usage-based pricing, or both.
 *
 * The subscription tracks billing details including the current period end date, trial days, and [`AppSubscriptionStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/AppSubscriptionStatus).
 *
 * Merchants must approve subscriptions through a [confirmation URL](https://shopify.dev/docs/api/admin-graphql/latest/mutations/appSubscriptionCreate#returns-confirmationUrl) before billing begins. Test subscriptions allow developers to verify billing flows without actual charges.
 *
 * Learn more about [subscription billing](https://shopify.dev/docs/apps/launch/billing/subscription-billing) and [testing charges](https://shopify.dev/docs/apps/launch/billing/managed-pricing#test-charges).
 */
export type AppSubscription = Node & {
  __typename?: 'AppSubscription';
  /** The date and time when the app subscription was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the current app subscription period ends. Returns `null` if the subscription isn't active. */
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The plans attached to the app subscription. */
  lineItems: Array<AppSubscriptionLineItem>;
  /** The name of the app subscription. */
  name: Scalars['String']['output'];
  /** The URL that the merchant is redirected to after approving the app subscription. */
  returnUrl: Scalars['URL']['output'];
  /** The status of the app subscription. */
  status: AppSubscriptionStatus;
  /** Specifies whether the app subscription is a test transaction. */
  test: Scalars['Boolean']['output'];
  /** The number of free trial days, starting at the subscription's creation date, by which billing is delayed. */
  trialDays: Scalars['Int']['output'];
};

/** Return type for `appSubscriptionCancel` mutation. */
export type AppSubscriptionCancelPayload = {
  __typename?: 'AppSubscriptionCancelPayload';
  /** The cancelled app subscription. */
  appSubscription?: Maybe<AppSubscription>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple AppSubscriptions. */
export type AppSubscriptionConnection = {
  __typename?: 'AppSubscriptionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppSubscriptionEdge>;
  /** A list of nodes that are contained in AppSubscriptionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppSubscription>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `appSubscriptionCreate` mutation. */
export type AppSubscriptionCreatePayload = {
  __typename?: 'AppSubscriptionCreatePayload';
  /** The newly-created app subscription. */
  appSubscription?: Maybe<AppSubscription>;
  /** The URL pointing to the page where the merchant approves or declines the charges for an app subscription. */
  confirmationUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Discount applied to the recurring pricing portion of a subscription. */
export type AppSubscriptionDiscount = {
  __typename?: 'AppSubscriptionDiscount';
  /**
   * The total number of billing intervals to which the discount will be applied.
   * The discount will be applied to an indefinite number of billing intervals if this value is blank.
   */
  durationLimitInIntervals?: Maybe<Scalars['Int']['output']>;
  /** The price of the subscription after the discount is applied. */
  priceAfterDiscount: MoneyV2;
  /** The remaining number of billing intervals to which the discount will be applied. */
  remainingDurationInIntervals?: Maybe<Scalars['Int']['output']>;
  /** The value of the discount applied every billing interval. */
  value: AppSubscriptionDiscountValue;
};

/** The fixed amount value of a discount. */
export type AppSubscriptionDiscountAmount = {
  __typename?: 'AppSubscriptionDiscountAmount';
  /** The fixed amount value of a discount. */
  amount: MoneyV2;
};

/** The input fields to specify a discount to the recurring pricing portion of a subscription over a number of billing intervals. */
export type AppSubscriptionDiscountInput = {
  /**
   * The total number of billing intervals to which the discount will be applied. Must be greater than 0.
   * The discount will be applied to an indefinite number of billing intervals if this value is left blank.
   */
  durationLimitInIntervals?: InputMaybe<Scalars['Int']['input']>;
  /** The value to be discounted every billing interval. */
  value?: InputMaybe<AppSubscriptionDiscountValueInput>;
};

/** The percentage value of a discount. */
export type AppSubscriptionDiscountPercentage = {
  __typename?: 'AppSubscriptionDiscountPercentage';
  /** The percentage value of a discount. */
  percentage: Scalars['Float']['output'];
};

/** The value of the discount. */
export type AppSubscriptionDiscountValue = AppSubscriptionDiscountAmount | AppSubscriptionDiscountPercentage;

/** The input fields to specify the value discounted every billing interval. */
export type AppSubscriptionDiscountValueInput = {
  /** The monetary value of a discount. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage value of a discount. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** An auto-generated type which holds one AppSubscription and a cursor during pagination. */
export type AppSubscriptionEdge = {
  __typename?: 'AppSubscriptionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppSubscriptionEdge. */
  node: AppSubscription;
};

/**
 * Represents a component of an app subscription that contains pricing details for either recurring fees or usage-based charges. Each subscription has exactly 1 or 2 line items - one for recurring fees and/or one for usage fees.
 *
 * If a subscription has both recurring and usage pricing, there will be 2 line items. If it only has one type of pricing, the subscription will have a single line item for that pricing model.
 *
 * Use the `AppSubscriptionLineItem` object to:
 * - View the pricing terms a merchant has agreed to
 * - Distinguish between recurring and usage fee components
 * - Access detailed billing information for each pricing component
 *
 * This read-only object provides visibility into the subscription's pricing structure without allowing modifications.
 *
 * Read about subscription pricing models in the [billing architecture guide](https://shopify.dev/docs/apps/launch/billing/subscription-billing).
 */
export type AppSubscriptionLineItem = {
  __typename?: 'AppSubscriptionLineItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The pricing model for the app subscription. */
  plan: AppPlanV2;
  /** A list of the store's usage records for a usage pricing plan. */
  usageRecords: AppUsageRecordConnection;
};


/**
 * Represents a component of an app subscription that contains pricing details for either recurring fees or usage-based charges. Each subscription has exactly 1 or 2 line items - one for recurring fees and/or one for usage fees.
 *
 * If a subscription has both recurring and usage pricing, there will be 2 line items. If it only has one type of pricing, the subscription will have a single line item for that pricing model.
 *
 * Use the `AppSubscriptionLineItem` object to:
 * - View the pricing terms a merchant has agreed to
 * - Distinguish between recurring and usage fee components
 * - Access detailed billing information for each pricing component
 *
 * This read-only object provides visibility into the subscription's pricing structure without allowing modifications.
 *
 * Read about subscription pricing models in the [billing architecture guide](https://shopify.dev/docs/apps/launch/billing/subscription-billing).
 */
export type AppSubscriptionLineItemUsageRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppUsageRecordSortKeys>;
};

/** The input fields to add more than one pricing plan to an app subscription. */
export type AppSubscriptionLineItemInput = {
  /** The pricing model for the app subscription. */
  plan: AppPlanInput;
};

/** Return type for `appSubscriptionLineItemUpdate` mutation. */
export type AppSubscriptionLineItemUpdatePayload = {
  __typename?: 'AppSubscriptionLineItemUpdatePayload';
  /** The updated app subscription. */
  appSubscription?: Maybe<AppSubscription>;
  /** The URL where the merchant approves or declines the updated app subscription line item. */
  confirmationUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The replacement behavior when creating an app subscription for a merchant with an already existing app subscription. */
export enum AppSubscriptionReplacementBehavior {
  /** Cancels the merchant's current app subscription immediately and replaces it with the newly created app subscription. */
  ApplyImmediately = 'APPLY_IMMEDIATELY',
  /** Defers canceling the merchant's current app subscription and applying the newly created app subscription until the start of the next billing cycle. This value is ignored if the new app subscription is using a different currency than the current app subscription, in which case the new app subscription is applied immediately. */
  ApplyOnNextBillingCycle = 'APPLY_ON_NEXT_BILLING_CYCLE',
  /**
   * Cancels the merchant's current app subscription immediately and replaces it with the newly created app subscription, with the exception of
   * the following scenarios where replacing the current app subscription will be deferred until the start of the next billing cycle.
   * 1) The current app subscription is annual and the newly created app subscription is annual, using the same currency, but is of a lesser value.
   * 2) The current app subscription is annual and the newly created app subscription is monthly and using the same currency.
   * 3) The current app subscription and the newly created app subscription are identical except for the `discount` value.
   */
  Standard = 'STANDARD'
}

/** The set of valid sort keys for the AppSubscription query. */
export enum AppSubscriptionSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The status of the app subscription. */
export enum AppSubscriptionStatus {
  /**
   * The app subscription has been approved by the merchant and is ready to be activated by the app.
   * @deprecated When a merchant approves an app subscription, the status immediately transitions from `pending` to `active`.
   */
  Accepted = 'ACCEPTED',
  /** The app subscription has been approved by the merchant. Active app subscriptions are billed to the shop. After payment, partners receive payouts. */
  Active = 'ACTIVE',
  /** The app subscription was cancelled by the app. This could be caused by the app being uninstalled, a new app subscription being activated, or a direct cancellation by the app. This is a terminal state. */
  Cancelled = 'CANCELLED',
  /** The app subscription was declined by the merchant. This is a terminal state. */
  Declined = 'DECLINED',
  /** The app subscription wasn't approved by the merchant within two days of being created. This is a terminal state. */
  Expired = 'EXPIRED',
  /** The app subscription is on hold due to non-payment. The subscription re-activates after payments resume. */
  Frozen = 'FROZEN',
  /** The app subscription is pending approval by the merchant. */
  Pending = 'PENDING'
}

/** Return type for `appSubscriptionTrialExtend` mutation. */
export type AppSubscriptionTrialExtendPayload = {
  __typename?: 'AppSubscriptionTrialExtendPayload';
  /** The app subscription that had its trial extended. */
  appSubscription?: Maybe<AppSubscription>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<AppSubscriptionTrialExtendUserError>;
};

/** An error that occurs during the execution of `AppSubscriptionTrialExtend`. */
export type AppSubscriptionTrialExtendUserError = DisplayableError & {
  __typename?: 'AppSubscriptionTrialExtendUserError';
  /** The error code. */
  code?: Maybe<AppSubscriptionTrialExtendUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `AppSubscriptionTrialExtendUserError`. */
export enum AppSubscriptionTrialExtendUserErrorCode {
  /** The app subscription isn't active. */
  SubscriptionNotActive = 'SUBSCRIPTION_NOT_ACTIVE',
  /** The app subscription wasn't found. */
  SubscriptionNotFound = 'SUBSCRIPTION_NOT_FOUND',
  /** The trial isn't active. */
  TrialNotActive = 'TRIAL_NOT_ACTIVE'
}

/** The set of valid sort keys for the AppTransaction query. */
export enum AppTransactionSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Represents an error that happens while uninstalling an app. */
export type AppUninstallAppUninstallError = DisplayableError & {
  __typename?: 'AppUninstallAppUninstallError';
  /** The error code. */
  code?: Maybe<AppUninstallAppUninstallErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `AppUninstallAppUninstallError`. */
export enum AppUninstallAppUninstallErrorCode {
  /** The app cannot be found. */
  AppNotFound = 'APP_NOT_FOUND',
  /** The app is not installed. */
  AppNotInstalled = 'APP_NOT_INSTALLED',
  /** An error occurred while uninstalling the app. */
  AppUninstallError = 'APP_UNINSTALL_ERROR',
  /** User does not have sufficient permissions to uninstall this app. */
  UserPermissionsInsufficient = 'USER_PERMISSIONS_INSUFFICIENT'
}

/** Return type for `appUninstall` mutation. */
export type AppUninstallPayload = {
  __typename?: 'AppUninstallPayload';
  /** The uninstalled app. */
  app?: Maybe<App>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<AppUninstallAppUninstallError>;
};

/**
 * Defines usage-based pricing terms for app subscriptions where merchants pay based on their actual consumption of app features or services. This pricing model provides flexibility for merchants who want to pay only for what they use rather than fixed monthly fees.
 *
 * For example, an email marketing app might charge variable pricing per email sent, with a monthly cap of variable pricing, allowing small merchants to pay minimal amounts while protecting larger merchants from excessive charges.
 *
 * Use the `AppUsagePricing` object to:
 * - View consumption-based billing for variable app usage
 * - See spending caps that protect merchants from unexpected charges
 *
 * The balance and capped amount fields provide apps with data about current usage costs and remaining budget within the billing period, which apps can present to merchants to promote transparency in variable pricing.
 *
 * For implementation guidance, see the [usage billing documentation](https://shopify.dev/docs/apps/launch/billing/subscription-billing/create-usage-based-subscriptions).
 */
export type AppUsagePricing = {
  __typename?: 'AppUsagePricing';
  /** The total usage records for interval. */
  balanceUsed: MoneyV2;
  /**
   * The capped amount prevents the merchant from being charged for any usage over that amount during a billing period.
   * This prevents billing from exceeding a maximum threshold over the duration of the billing period.
   * For the merchant to continue using the app after exceeding a capped amount, they would need to agree to a new usage charge.
   */
  cappedAmount: MoneyV2;
  /** The frequency with which the app usage records are billed. */
  interval: AppPricingInterval;
  /**
   * The terms and conditions for app usage pricing.
   * Must be present in order to create usage charges.
   * The terms are presented to the merchant when they approve an app's usage charges.
   */
  terms: Scalars['String']['output'];
};

/** The input fields to issue arbitrary charges for app usage associated with a subscription. */
export type AppUsagePricingInput = {
  /** The maximum amount of usage charges that can be incurred within a subscription billing interval. */
  cappedAmount: MoneyInput;
  /** The terms and conditions for app usage. These terms stipulate the pricing model for the charges that an app creates. */
  terms: Scalars['String']['input'];
};

/** Store usage for app subscriptions with usage pricing. */
export type AppUsageRecord = Node & {
  __typename?: 'AppUsageRecord';
  /** The date and time when the usage record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the app usage record. */
  description: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A unique key generated by the client to avoid duplicate charges. */
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** The price of the usage record. */
  price: MoneyV2;
  /** Defines the usage pricing plan the merchant is subscribed to. */
  subscriptionLineItem: AppSubscriptionLineItem;
};

/** An auto-generated type for paginating through multiple AppUsageRecords. */
export type AppUsageRecordConnection = {
  __typename?: 'AppUsageRecordConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<AppUsageRecordEdge>;
  /** A list of nodes that are contained in AppUsageRecordEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<AppUsageRecord>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `appUsageRecordCreate` mutation. */
export type AppUsageRecordCreatePayload = {
  __typename?: 'AppUsageRecordCreatePayload';
  /** The newly created app usage record. */
  appUsageRecord?: Maybe<AppUsageRecord>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one AppUsageRecord and a cursor during pagination. */
export type AppUsageRecordEdge = {
  __typename?: 'AppUsageRecordEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of AppUsageRecordEdge. */
  node: AppUsageRecord;
};

/** The set of valid sort keys for the AppUsageRecord query. */
export enum AppUsageRecordSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The Apple mobile platform application. */
export type AppleApplication = {
  __typename?: 'AppleApplication';
  /** The iOS App Clip application ID. */
  appClipApplicationId?: Maybe<Scalars['String']['output']>;
  /** Whether iOS App Clips are enabled for this app. */
  appClipsEnabled: Scalars['Boolean']['output'];
  /** The iOS App ID. */
  appId?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether iOS shared web credentials are enabled for this app. */
  sharedWebCredentialsEnabled: Scalars['Boolean']['output'];
  /** Whether iOS Universal Links are supported by this app. */
  universalLinksEnabled: Scalars['Boolean']['output'];
};

/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type Article = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Navigable & Node & {
  __typename?: 'Article';
  /** The name of the author of the article. */
  author?: Maybe<ArticleAuthor>;
  /** The blog containing the article. */
  blog: Blog;
  /** The text of the article's body, complete with HTML markup. */
  body: Scalars['HTML']['output'];
  /** List of the article's comments. */
  comments: CommentConnection;
  /** Count of comments. Limited to a maximum of 10000 by default. */
  commentsCount?: Maybe<Count>;
  /** The date and time (ISO 8601 format) when the article was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image associated with the article. */
  image?: Maybe<Image>;
  /** Whether or not the article is visible. */
  isPublished: Scalars['Boolean']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /**
   * The date and time (ISO 8601 format) when the article became or will become visible.
   * Returns null when the article isn't visible.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  summary?: Maybe<Scalars['HTML']['output']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  tags: Array<Scalars['String']['output']>;
  /**
   * The name of the template an article is using if it's using an alternate template.
   * If an article is using the default `article.liquid` template, then the value returned is `null`.
   */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /** The title of the article. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The date and time (ISO 8601 format) when the article was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleCommentsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An article that contains content, author information, and metadata. Articles belong to a [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) and can include HTML-formatted body text, summary text, and an associated image. Merchants publish articles to share content, drive traffic, and engage customers.
 *
 * Articles can be organized with tags and published immediately or scheduled for future publication using the [`publishedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article#field-Article.fields.publishedAt) timestamp. The API manages comments on articles when the blog's comment policy enables them.
 */
export type ArticleTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Represents the author of an article. This object provides the author's full name for attribution purposes.
 *
 * The `ArticleAuthor` is a simple object that contains only the author's name field. When articles are created or updated, the author information is stored and can be displayed alongside the article content.
 *
 * Use the `ArticleAuthor` object to:
 * - Retrieve the author's name for display in article bylines
 * - Show author attribution in article listings
 * - Display who wrote specific content
 *
 * Note: This object only contains the author's full name. It does not include additional author details like bio, email, or social media links.
 */
export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  /** The author's full name. */
  name: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple ArticleAuthors. */
export type ArticleAuthorConnection = {
  __typename?: 'ArticleAuthorConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ArticleAuthorEdge>;
  /** A list of nodes that are contained in ArticleAuthorEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ArticleAuthor>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ArticleAuthor and a cursor during pagination. */
export type ArticleAuthorEdge = {
  __typename?: 'ArticleAuthorEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ArticleAuthorEdge. */
  node: ArticleAuthor;
};

/** The input fields of a blog when an article is created or updated. */
export type ArticleBlogInput = {
  /** The title of the blog. */
  title: Scalars['String']['input'];
};

/** An auto-generated type for paginating through multiple Articles. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ArticleEdge>;
  /** A list of nodes that are contained in ArticleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Article>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create an article. */
export type ArticleCreateInput = {
  /** The name of the author of the article. */
  author: AuthorInput;
  /** The ID of the blog containing the article. */
  blogId?: InputMaybe<Scalars['ID']['input']>;
  /** The text of the article's body, complete with HTML markup. */
  body?: InputMaybe<Scalars['HTML']['input']>;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The image associated with the article. */
  image?: InputMaybe<ArticleImageInput>;
  /** Whether or not the article should be visible. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input fields to create or update a metafield. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the article should become visible. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  summary?: InputMaybe<Scalars['HTML']['input']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default article template is used.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the article. */
  title: Scalars['String']['input'];
};

/** Return type for `articleCreate` mutation. */
export type ArticleCreatePayload = {
  __typename?: 'ArticleCreatePayload';
  /** The article that was created. */
  article?: Maybe<Article>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ArticleCreateUserError>;
};

/** An error that occurs during the execution of `ArticleCreate`. */
export type ArticleCreateUserError = DisplayableError & {
  __typename?: 'ArticleCreateUserError';
  /** The error code. */
  code?: Maybe<ArticleCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ArticleCreateUserError`. */
export enum ArticleCreateUserErrorCode {
  /** Can't create an article author if both author name and user ID are supplied. */
  AmbiguousAuthor = 'AMBIGUOUS_AUTHOR',
  /** Can't create a blog from input if a blog ID is supplied. */
  AmbiguousBlog = 'AMBIGUOUS_BLOG',
  /** Can't create an article if both author name and user ID are blank. */
  AuthorFieldRequired = 'AUTHOR_FIELD_REQUIRED',
  /** User must exist if a user ID is supplied. */
  AuthorMustExist = 'AUTHOR_MUST_EXIST',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Must reference or create a blog when creating an article. */
  BlogReferenceRequired = 'BLOG_REFERENCE_REQUIRED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  InvalidPublishDate = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Image upload failed. */
  UploadFailed = 'UPLOAD_FAILED'
}

/** Return type for `articleDelete` mutation. */
export type ArticleDeletePayload = {
  __typename?: 'ArticleDeletePayload';
  /** The ID of the deleted article. */
  deletedArticleId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ArticleDeleteUserError>;
};

/** An error that occurs during the execution of `ArticleDelete`. */
export type ArticleDeleteUserError = DisplayableError & {
  __typename?: 'ArticleDeleteUserError';
  /** The error code. */
  code?: Maybe<ArticleDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ArticleDeleteUserError`. */
export enum ArticleDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one Article and a cursor during pagination. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ArticleEdge. */
  node: Article;
};

/** The input fields for an image associated with an article. */
export type ArticleImageInput = {
  /** A word or phrase to share the nature or contents of an image. */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the image. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The set of valid sort keys for the Article query. */
export enum ArticleSortKeys {
  /** Sort by the `author` value. */
  Author = 'AUTHOR',
  /** Sort by the `blog_title` value. */
  BlogTitle = 'BLOG_TITLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Possible sort of tags. */
export enum ArticleTagSort {
  /** Sort alphabetically.. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort by popularity, starting with the most popular tag. */
  Popular = 'POPULAR'
}

/** The input fields to update an article. */
export type ArticleUpdateInput = {
  /** The name of the author of the article. */
  author?: InputMaybe<AuthorInput>;
  /** The ID of the blog containing the article. */
  blogId?: InputMaybe<Scalars['ID']['input']>;
  /** The text of the article's body, complete with HTML markup. */
  body?: InputMaybe<Scalars['HTML']['input']>;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The image associated with the article. */
  image?: InputMaybe<ArticleImageInput>;
  /** Whether or not the article should be visible. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input fields to create or update a metafield. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the article should become visible. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  summary?: InputMaybe<Scalars['HTML']['input']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default article template is used.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the article. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `articleUpdate` mutation. */
export type ArticleUpdatePayload = {
  __typename?: 'ArticleUpdatePayload';
  /** The article that was updated. */
  article?: Maybe<Article>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ArticleUpdateUserError>;
};

/** An error that occurs during the execution of `ArticleUpdate`. */
export type ArticleUpdateUserError = DisplayableError & {
  __typename?: 'ArticleUpdateUserError';
  /** The error code. */
  code?: Maybe<ArticleUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ArticleUpdateUserError`. */
export enum ArticleUpdateUserErrorCode {
  /** Can't update an article author if both author name and user ID are supplied. */
  AmbiguousAuthor = 'AMBIGUOUS_AUTHOR',
  /** Can't create a blog from input if a blog ID is supplied. */
  AmbiguousBlog = 'AMBIGUOUS_BLOG',
  /** User must exist if a user ID is supplied. */
  AuthorMustExist = 'AUTHOR_MUST_EXIST',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  InvalidPublishDate = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** Image upload failed. */
  UploadFailed = 'UPLOAD_FAILED'
}

/**
 * A custom property. Attributes are used to store additional information about a Shopify resource, such as
 * products, customers, or orders. Attributes are stored as key-value pairs.
 *
 * For example, a list of attributes might include whether a customer is a first-time buyer (`"customer_first_order": "true"`),
 * whether an order is gift-wrapped (`"gift_wrapped": "true"`), a preferred delivery date
 * (`"preferred_delivery_date": "2025-10-01"`), the discount applied (`"loyalty_discount_applied": "10%"`), and any
 * notes provided by the customer (`"customer_notes": "Please leave at the front door"`).
 */
export type Attribute = {
  __typename?: 'Attribute';
  /** The key or name of the attribute. For example, `"customer_first_order"`. */
  key: Scalars['String']['output'];
  /** The value of the attribute. For example, `"true"`. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The input fields for an attribute. */
export type AttributeInput = {
  /** Key or name of the attribute. */
  key: Scalars['String']['input'];
  /** Value of the attribute. */
  value: Scalars['String']['input'];
};

/** The intended audience for the order status page. */
export enum Audience {
  /** Intended for customer notifications. */
  Customerview = 'CUSTOMERVIEW',
  /** Intended for merchant wanting to preview the order status page. Should be used immediately after querying. */
  Merchantview = 'MERCHANTVIEW'
}

/** The input fields for an author. Either the `name` or `user_id` fields can be supplied, but never both. */
export type AuthorInput = {
  /** The author's full name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of a staff member's account. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Automatic discount applications capture the intentions of a discount that was automatically applied. */
export type AutomaticDiscountApplication = DiscountApplication & {
  __typename?: 'AutomaticDiscountApplication';
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  index: Scalars['Int']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The title of the discount application. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: PricingValue;
};

/** The set of valid sort keys for the AutomaticDiscount query. */
export enum AutomaticDiscountSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Represents an object containing all information for channels available to a shop. */
export type AvailableChannelDefinitionsByChannel = {
  __typename?: 'AvailableChannelDefinitionsByChannel';
  /**
   * The channel definitions for channels installed on a shop.
   * @deprecated Use [`QueryRoot.orderAttributionDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/orderAttributionDefinitions) and select `id`, `handle`, `displayName`, and `icon` instead.
   */
  channelDefinitions: Array<ChannelDefinition>;
  /**
   * The name of the channel.
   * @deprecated Use [`OrderAttributionDefinition.displayName`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.displayName) instead.
   */
  channelName: Scalars['String']['output'];
};

/** The entitlements for B2B. */
export type B2BType = {
  __typename?: 'B2BType';
  /** Whether B2B is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for updating a backup region with exactly one required option. */
export type BackupRegionUpdateInput = {
  /** A country code for the backup region. */
  countryCode: CountryCode;
};

/** Return type for `backupRegionUpdate` mutation. */
export type BackupRegionUpdatePayload = {
  __typename?: 'BackupRegionUpdatePayload';
  /** Returns the updated backup region. */
  backupRegion?: Maybe<MarketRegion>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** The possible types for a badge. */
export enum BadgeType {
  /** This badge has type `attention`. */
  Attention = 'ATTENTION',
  /** This badge has type `critical`. */
  Critical = 'CRITICAL',
  /** This badge has type `default`. */
  Default = 'DEFAULT',
  /** This badge has type `info`. */
  Info = 'INFO',
  /** This badge has type `success`. */
  Success = 'SUCCESS',
  /** This badge has type `warning`. */
  Warning = 'WARNING'
}

/** The set of valid sort keys for the BalanceTransaction query. */
export enum BalanceTransactionSortKeys {
  /** Sort by the `amount` value. */
  Amount = 'AMOUNT',
  /** Sort by the `fee` value. */
  Fee = 'FEE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `net` value. */
  Net = 'NET',
  /** Sort by the `order_name` value. */
  OrderName = 'ORDER_NAME',
  /** Sort by the `payment_method_name` value. */
  PaymentMethodName = 'PAYMENT_METHOD_NAME',
  /** Sort by the `payout_date` value. */
  PayoutDate = 'PAYOUT_DATE',
  /** Sort by the `payout_status` value. */
  PayoutStatus = 'PAYOUT_STATUS',
  /** Sort by the `processed_at` value. */
  ProcessedAt = 'PROCESSED_AT',
  /** Sort by the `transaction_type` value. */
  TransactionType = 'TRANSACTION_TYPE'
}

/** Represents a bank account payment instrument. */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** The type of account holder. */
  accountHolderType: BankAccountHolderType;
  /** The type of bank account. */
  accountType: BankAccountType;
  /** The name of the bank. */
  bankName: Scalars['String']['output'];
  /** The billing address associated with the bank account. */
  billingAddress?: Maybe<CustomerPaymentInstrumentBillingAddress>;
  /** The last four digits of the account number. */
  lastDigits: Scalars['String']['output'];
};

/** The type of bank account holder. */
export enum BankAccountHolderType {
  /** A company account holder. */
  Company = 'COMPANY',
  /** An individual account holder. */
  Individual = 'INDIVIDUAL'
}

/** The type of bank account. */
export enum BankAccountType {
  /** A checking account. */
  Checking = 'CHECKING',
  /** A savings account. */
  Savings = 'SAVINGS'
}

/** The valid types of actions a user should be able to perform in an financial app. */
export enum BankingFinanceAppAccess {
  /** Indication that the user has blocked money movement due to MFA disabled. */
  MoneyMovementBlockedMfa = 'MONEY_MOVEMENT_BLOCKED_MFA',
  /** Indication that the user has restricted money movement. */
  MoneyMovementRestricted = 'MONEY_MOVEMENT_RESTRICTED',
  /** Ability to perform actions that moves money. */
  MoveMoney = 'MOVE_MONEY',
  /** Read access in the financial app. */
  ReadAccess = 'READ_ACCESS'
}

/** Generic payment details that are related to a transaction. */
export type BasePaymentDetails = {
  /** The name of payment method used by the buyer. */
  paymentMethodName?: Maybe<Scalars['String']['output']>;
};

/**
 * Basic events chronicle resource activities such as the creation of an article, the fulfillment of an order, or
 * the addition of a product.
 *
 * ### General events
 *
 * | Action | Description  |
 * |---|---|
 * | `create` | The item was created. |
 * | `destroy` | The item was destroyed. |
 * | `published` | The item was published. |
 * | `unpublished` | The item was unpublished. |
 * | `update` | The item was updated.  |
 *
 * ### Order events
 *
 * Order events can be divided into the following categories:
 *
 * - *Authorization*: Includes whether the authorization succeeded, failed, or is pending.
 * - *Capture*: Includes whether the capture succeeded, failed, or is pending.
 * - *Email*: Includes confirmation or cancellation of the order, as well as shipping.
 * - *Fulfillment*: Includes whether the fulfillment succeeded, failed, or is pending. Also includes cancellation, restocking, and fulfillment updates.
 * - *Order*: Includess the placement, confirmation, closing, re-opening, and cancellation of the order.
 * - *Refund*: Includes whether the refund succeeded, failed, or is pending.
 * - *Sale*: Includes whether the sale succeeded, failed, or is pending.
 * - *Void*: Includes whether the void succeeded, failed, or is pending.
 *
 * | Action  | Message  | Description  |
 * |---|---|---|
 * | `authorization_failure` | The customer, unsuccessfully, tried to authorize: `{money_amount}`. | Authorization failed. The funds cannot be captured. |
 * | `authorization_pending` | Authorization for `{money_amount}` is pending. | Authorization pending. |
 * | `authorization_success` | The customer successfully authorized us to capture: `{money_amount}`. | Authorization was successful and the funds are available for capture. |
 * | `cancelled` | Order was cancelled by `{shop_staff_name}`. | The order was cancelled. |
 * | `capture_failure` | We failed to capture: `{money_amount}`. | The capture failed. The funds cannot be transferred to the shop. |
 * | `capture_pending` | Capture for `{money_amount}` is pending. | The capture is in process. The funds are not yet available to the shop. |
 * | `capture_success` | We successfully captured: `{money_amount}` | The capture was successful and the funds are now available to the shop. |
 * | `closed` | Order was closed. | The order was closed. |
 * | `confirmed` | Received a new order: `{order_number}` by `{customer_name}`. | The order was confirmed. |
 * | `fulfillment_cancelled` | We cancelled `{number_of_line_items}` from being fulfilled by the third party fulfillment service. | Fulfillment for one or more of the line_items failed. |
 * | `fulfillment_pending` | We submitted `{number_of_line_items}` to the third party service. | One or more of the line_items has been assigned to a third party service for fulfillment. |
 * | `fulfillment_success` | We successfully fulfilled line_items. | Fulfillment was successful for one or more line_items. |
 * | `mail_sent` | `{message_type}` email was sent to the customer. | An email was sent to the customer. |
 * | `placed` | Order was placed. | An order was placed by the customer. |
 * | `re_opened` | Order was re-opened. | An order was re-opened. |
 * | `refund_failure` | We failed to refund `{money_amount}`. | The refund failed. The funds are still with the shop. |
 * | `refund_pending` | Refund of `{money_amount}` is still pending. | The refund is in process. The funds are still with shop. |
 * | `refund_success` | We successfully refunded `{money_amount}`. | The refund was successful. The funds have been transferred to the customer. |
 * | `restock_line_items` | We restocked `{number_of_line_items}`. |	One or more of the order's line items have been restocked. |
 * | `sale_failure` | The customer failed to pay `{money_amount}`. | The sale failed. The funds are not available to the shop. |
 * | `sale_pending` | The `{money_amount}` is pending. | The sale is in process. The funds are not yet available to the shop. |
 * | `sale_success` | We successfully captured `{money_amount}`. | The sale was successful. The funds are now with the shop. |
 * | `update` | `{order_number}` was updated. | The order was updated. |
 * | `void_failure` | We failed to void the authorization. | Voiding the authorization failed. The authorization is still valid. |
 * | `void_pending` | Authorization void is pending. | Voiding the authorization is in process. The authorization is still valid. |
 * | `void_success` | We successfully voided the authorization. | Voiding the authorization was successful. The authorization is no longer valid. |
 */
export type BasicEvent = Event & Node & {
  __typename?: 'BasicEvent';
  /** The action that occured. */
  action: Scalars['String']['output'];
  /** Provides additional content for collapsible timeline events. */
  additionalContent?: Maybe<Scalars['JSON']['output']>;
  /** Provides additional data for event consumers. */
  additionalData?: Maybe<Scalars['JSON']['output']>;
  /** The name of the app that created the event. */
  appTitle?: Maybe<Scalars['String']['output']>;
  /** Refers to a certain event and its resources. */
  arguments?: Maybe<Scalars['JSON']['output']>;
  /** Whether the event was created by an app. */
  attributeToApp: Scalars['Boolean']['output'];
  /** Whether the event was caused by an admin user. */
  attributeToUser: Scalars['Boolean']['output'];
  /** The entity which performed the action that generated the event. */
  author?: Maybe<Scalars['String']['output']>;
  /** The date and time when the event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the event is critical. */
  criticalAlert: Scalars['Boolean']['output'];
  /** Whether this event has additional content. */
  hasAdditionalContent: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Human readable text that describes the event. */
  message: Scalars['FormattedString']['output'];
  /** Human readable text that supports the event message. */
  secondaryMessage?: Maybe<Scalars['FormattedString']['output']>;
  /**
   * The resource that generated the event. To see a list of possible types,
   * refer to [HasEvents](https://shopify.dev/docs/api/admin-graphql/unstable/interfaces/HasEvents#implemented-in).
   */
  subject?: Maybe<HasEvents>;
  /** The ID of the resource that generated the event. */
  subjectId: Scalars['ID']['output'];
  /** The type of the resource that generated the event. */
  subjectType: EventSubjectType;
};

/** Represents an error that happens during the execution of a billing attempt mutation. */
export type BillingAttemptUserError = DisplayableError & {
  __typename?: 'BillingAttemptUserError';
  /** The error code. */
  code?: Maybe<BillingAttemptUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BillingAttemptUserError`. */
export enum BillingAttemptUserErrorCode {
  /** Billing cycle charge attempt made more than 24 hours before the billing cycle `billingAttemptExpectedDate`. */
  BillingCycleChargeBeforeExpectedDate = 'BILLING_CYCLE_CHARGE_BEFORE_EXPECTED_DATE',
  /** Billing cycle must not be skipped. */
  BillingCycleSkipped = 'BILLING_CYCLE_SKIPPED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Subscription contract does not exist. */
  ContractNotFound = 'CONTRACT_NOT_FOUND',
  /** Subscription contract cannot be billed if paused. */
  ContractPaused = 'CONTRACT_PAUSED',
  /** Subscription contract cannot be billed once terminated. */
  ContractTerminated = 'CONTRACT_TERMINATED',
  /** Subscription contract is under review, origin order is high risk and unfulfilled. */
  ContractUnderReview = 'CONTRACT_UNDER_REVIEW',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CycleIndexOutOfRange = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CycleStartDateOutOfRange = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Origin time cannot be before the contract creation time. */
  OriginTimeBeforeContractCreation = 'ORIGIN_TIME_BEFORE_CONTRACT_CREATION',
  /** Origin time needs to be within the selected billing cycle's start and end at date. */
  OriginTimeOutOfRange = 'ORIGIN_TIME_OUT_OF_RANGE',
  /** Failed to process the billing attempt. */
  ProcessingFailed = 'PROCESSING_FAILED',
  /** Billing attempt rate limit exceeded - try later. */
  Throttled = 'THROTTLED',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UpcomingCycleLimitExceeded = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type Blog = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & {
  __typename?: 'Blog';
  /** List of the blog's articles. */
  articles: ArticleConnection;
  /** Count of articles. Limited to a maximum of 10000 by default. */
  articlesCount?: Maybe<Count>;
  /** Indicates whether readers can post comments to the blog and if comments are moderated or not. */
  commentPolicy: CommentPolicy;
  /** The date and time when the blog was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** FeedBurner provider details. Any blogs that aren't already integrated with FeedBurner can't use the service. */
  feed?: Maybe<BlogFeed>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A list of tags associated with the 200 most recent blog articles. */
  tags: Array<Scalars['String']['output']>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /** The title of the blog. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The date and time when the blog was update. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogArticlesCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A blog for publishing articles in the online store. Stores can have multiple blogs to organize content by topic or purpose.
 *
 * Each blog contains articles with their associated comments, tags, and metadata. The comment policy controls whether readers can post comments and whether moderation is required. Blogs use customizable URL handles and can apply alternate templates for specialized layouts.
 */
export type BlogTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** An auto-generated type for paginating through multiple Blogs. */
export type BlogConnection = {
  __typename?: 'BlogConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<BlogEdge>;
  /** A list of nodes that are contained in BlogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Blog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create a blog. */
export type BlogCreateInput = {
  /** Indicates whether readers can post comments to the blog and whether comments are moderated. */
  commentPolicy?: InputMaybe<CommentPolicy>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Attaches additional metadata to a store's resources. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the blog. */
  title: Scalars['String']['input'];
};

/** Return type for `blogCreate` mutation. */
export type BlogCreatePayload = {
  __typename?: 'BlogCreatePayload';
  /** The blog that was created. */
  blog?: Maybe<Blog>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BlogCreateUserError>;
};

/** An error that occurs during the execution of `BlogCreate`. */
export type BlogCreateUserError = DisplayableError & {
  __typename?: 'BlogCreateUserError';
  /** The error code. */
  code?: Maybe<BlogCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BlogCreateUserError`. */
export enum BlogCreateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** Return type for `blogDelete` mutation. */
export type BlogDeletePayload = {
  __typename?: 'BlogDeletePayload';
  /** The ID of the deleted blog. */
  deletedBlogId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BlogDeleteUserError>;
};

/** An error that occurs during the execution of `BlogDelete`. */
export type BlogDeleteUserError = DisplayableError & {
  __typename?: 'BlogDeleteUserError';
  /** The error code. */
  code?: Maybe<BlogDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BlogDeleteUserError`. */
export enum BlogDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one Blog and a cursor during pagination. */
export type BlogEdge = {
  __typename?: 'BlogEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of BlogEdge. */
  node: Blog;
};

/**
 * RSS feed provider details for blog syndication. This object contains the location and path information for external feed services that were previously integrated with the blog.
 *
 * The `BlogFeed` object maintains the feed URL and path to ensure existing feed subscriptions continue working.
 *
 * Use the `BlogFeed` object to:
 * - Access RSS feed provider configuration
 * - Retrieve feed location and path information
 * - Maintain existing feed syndication settings
 *
 * > Note:
 * > This is a legacy feature. New integrations with external feed services are not supported.
 */
export type BlogFeed = {
  __typename?: 'BlogFeed';
  /** Blog feed provider url. */
  location: Scalars['URL']['output'];
  /** Blog feed provider path. */
  path: Scalars['String']['output'];
};

/** The set of valid sort keys for the Blog query. */
export enum BlogSortKeys {
  /** Sort by the `handle` value. */
  Handle = 'HANDLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** The input fields to update a blog. */
export type BlogUpdateInput = {
  /** Indicates whether readers can post comments to the blog and whether comments are moderated. */
  commentPolicy?: InputMaybe<CommentPolicy>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Attaches additional metadata to a store's resources. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** Whether to redirect blog posts automatically. */
  redirectArticles?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the blog. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `blogUpdate` mutation. */
export type BlogUpdatePayload = {
  __typename?: 'BlogUpdatePayload';
  /** The blog that was updated. */
  blog?: Maybe<Blog>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BlogUpdateUserError>;
};

/** An error that occurs during the execution of `BlogUpdate`. */
export type BlogUpdateUserError = DisplayableError & {
  __typename?: 'BlogUpdateUserError';
  /** The error code. */
  code?: Maybe<BlogUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BlogUpdateUserError`. */
export enum BlogUpdateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** Possible error codes that can be returned by `BulkMutationUserError`. */
export enum BulkMutationErrorCode {
  /** There was a problem reading the JSONL file. This error might be intermittent, so you can try performing the same query again. */
  InternalFileServerError = 'INTERNAL_FILE_SERVER_ERROR',
  /** The operation did not run because the mutation is invalid. Check your mutation syntax and try again. */
  InvalidMutation = 'INVALID_MUTATION',
  /** The JSONL file submitted via the `stagedUploadsCreate` mutation is invalid. Update the file and try again. */
  InvalidStagedUploadFile = 'INVALID_STAGED_UPLOAD_FILE',
  /** Bulk operations limit reached. Please try again later. */
  LimitReached = 'LIMIT_REACHED',
  /** The JSONL file could not be found. Try [uploading the file](https://shopify.dev/api/usage/bulk-operations/imports#generate-the-uploaded-url-and-parameters) again, and check that you've entered the URL correctly for the `stagedUploadPath` mutation argument. */
  NoSuchFile = 'NO_SUCH_FILE',
  /** The operation did not run because another bulk mutation is already running. [Wait for the operation to finish](https://shopify.dev/api/usage/bulk-operations/imports#wait-for-the-operation-to-finish) before retrying this operation. */
  OperationInProgress = 'OPERATION_IN_PROGRESS'
}

/** Represents an error that happens during execution of a bulk mutation. */
export type BulkMutationUserError = DisplayableError & {
  __typename?: 'BulkMutationUserError';
  /** The error code. */
  code?: Maybe<BulkMutationErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * An asynchronous operation that exports large datasets or imports data in bulk. Create bulk operations using [bulkOperationRunQuery](https://shopify.dev/docs/api/admin-graphql/latest/mutations/bulkOperationRunQuery) to export data or [bulkOperationRunMutation](https://shopify.dev/docs/api/admin-graphql/latest/mutations/bulkOperationRunMutation) to import data.
 *
 * After creation, check the [`status`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation#field-BulkOperation.fields.status) field to track progress. When completed, the [`url`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation#field-BulkOperation.fields.url) field contains a link to download results in [JSONL](http://jsonlines.org/) format. The [`objectCount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation#field-BulkOperation.fields.objectCount) field shows the running total of processed objects, while [`rootObjectCount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation#field-BulkOperation.fields.rootObjectCount) tracks only root-level objects in nested queries.
 *
 * If an operation fails but retrieves partial data, then the [`partialDataUrl`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation#field-BulkOperation.fields.partialDataUrl) field provides access to incomplete results.
 *
 * > Note: `url` and `partialDataUrl` values expire after seven days.
 *
 * Learn more about [exporting](https://shopify.dev/docs/api/usage/bulk-operations/queries) and [importing](https://shopify.dev/docs/api/usage/bulk-operations/imports) data in bulk.
 */
export type BulkOperation = Node & {
  __typename?: 'BulkOperation';
  /** When the bulk operation was successfully completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the bulk operation was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Error code for failed operations. */
  errorCode?: Maybe<BulkOperationErrorCode>;
  /** File size in bytes of the file in the `url` field. */
  fileSize?: Maybe<Scalars['UnsignedInt64']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A running count of all the objects processed.
   * For example, when fetching all the products and their variants, this field counts both products and variants.
   * This field can be used to track operation progress.
   */
  objectCount: Scalars['UnsignedInt64']['output'];
  /**
   * The URL that points to the partial or incomplete response data (in [JSONL](http://jsonlines.org/) format) that was returned by a failed operation.
   * The URL expires 7 days after the operation fails. Returns `null` when there's no data available.
   */
  partialDataUrl?: Maybe<Scalars['URL']['output']>;
  /** GraphQL query document specified in `bulkOperationRunQuery`. */
  query: Scalars['String']['output'];
  /**
   * A running count of all the objects that are processed at the root of the query.
   * For example, when fetching all the products and their variants, this field only counts products.
   * This field can be used to track operation progress.
   */
  rootObjectCount: Scalars['UnsignedInt64']['output'];
  /** Status of the bulk operation. */
  status: BulkOperationStatus;
  /** The bulk operation's type. */
  type: BulkOperationType;
  /**
   * The URL that points to the response data in [JSONL](http://jsonlines.org/) format.
   * The URL expires 7 days after the operation completes.
   */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Return type for `bulkOperationCancel` mutation. */
export type BulkOperationCancelPayload = {
  __typename?: 'BulkOperationCancelPayload';
  /** The bulk operation to be canceled. */
  bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple BulkOperations. */
export type BulkOperationConnection = {
  __typename?: 'BulkOperationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<BulkOperationEdge>;
  /** A list of nodes that are contained in BulkOperationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<BulkOperation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one BulkOperation and a cursor during pagination. */
export type BulkOperationEdge = {
  __typename?: 'BulkOperationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of BulkOperationEdge. */
  node: BulkOperation;
};

/** Error codes for failed bulk operations. */
export enum BulkOperationErrorCode {
  /**
   * The provided operation `query` returned access denied due to missing
   * [access scopes](https://shopify.dev/api/usage/access-scopes).
   * Review the requested object permissions and execute the query as a normal non-bulk GraphQL request to see more details.
   */
  AccessDenied = 'ACCESS_DENIED',
  /**
   * The operation resulted in partial or incomplete data due to internal server errors during execution.
   * These errors might be intermittent, so you can try performing the same query again.
   */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /**
   * The operation resulted in partial or incomplete data due to query timeouts during execution.
   * In some cases, timeouts can be avoided by modifying your `query` to select fewer fields.
   */
  Timeout = 'TIMEOUT'
}

/** Return type for `bulkOperationRunMutation` mutation. */
export type BulkOperationRunMutationPayload = {
  __typename?: 'BulkOperationRunMutationPayload';
  /** The newly created bulk operation. */
  bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BulkMutationUserError>;
};

/** Return type for `bulkOperationRunQuery` mutation. */
export type BulkOperationRunQueryPayload = {
  __typename?: 'BulkOperationRunQueryPayload';
  /** The newly created bulk operation. */
  bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BulkOperationUserError>;
};

/** The valid values for the status of a bulk operation. */
export enum BulkOperationStatus {
  /** The bulk operation has been canceled. */
  Canceled = 'CANCELED',
  /**
   * Cancelation has been initiated on the bulk operation. There may be a short delay from when a cancelation
   * starts until the operation is actually canceled.
   */
  Canceling = 'CANCELING',
  /** The bulk operation has successfully completed. */
  Completed = 'COMPLETED',
  /** The bulk operation has been created. */
  Created = 'CREATED',
  /** The bulk operation URL has expired. */
  Expired = 'EXPIRED',
  /**
   * The bulk operation has failed. For information on why the operation failed, use
   * [BulkOperation.errorCode](https://shopify.dev/api/admin-graphql/latest/enums/bulkoperationerrorcode).
   */
  Failed = 'FAILED',
  /** The bulk operation is running. */
  Running = 'RUNNING'
}

/** The valid values for the bulk operation's type. */
export enum BulkOperationType {
  /** The bulk operation is a mutation. */
  Mutation = 'MUTATION',
  /** The bulk operation is a query. */
  Query = 'QUERY'
}

/** An error in the input of a mutation. Mutations return `UserError` objects to indicate validation failures, such as invalid field values or business logic violations, that prevent the operation from completing. */
export type BulkOperationUserError = DisplayableError & {
  __typename?: 'BulkOperationUserError';
  /** The error code. */
  code?: Maybe<BulkOperationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BulkOperationUserError`. */
export enum BulkOperationUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Bulk operations limit reached. Please try again later. */
  LimitReached = 'LIMIT_REACHED',
  /** A bulk operation is already in progress. */
  OperationInProgress = 'OPERATION_IN_PROGRESS'
}

/** The set of valid sort keys for the BulkOperations query. */
export enum BulkOperationsSortKeys {
  /** Sort by the `completed_at` value. */
  CompletedAt = 'COMPLETED_AT',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT'
}

/** Return type for `bulkProductResourceFeedbackCreate` mutation. */
export type BulkProductResourceFeedbackCreatePayload = {
  __typename?: 'BulkProductResourceFeedbackCreatePayload';
  /** The feedback that's created. */
  feedback?: Maybe<Array<ProductResourceFeedback>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BulkProductResourceFeedbackCreateUserError>;
};

/** An error that occurs during the execution of `BulkProductResourceFeedbackCreate`. */
export type BulkProductResourceFeedbackCreateUserError = DisplayableError & {
  __typename?: 'BulkProductResourceFeedbackCreateUserError';
  /** The error code. */
  code?: Maybe<BulkProductResourceFeedbackCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `BulkProductResourceFeedbackCreateUserError`. */
export enum BulkProductResourceFeedbackCreateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The operation was attempted on too many feedback objects. The maximum number of feedback objects that you can operate on is 50. */
  MaximumFeedbackLimitExceeded = 'MAXIMUM_FEEDBACK_LIMIT_EXCEEDED',
  /** The channel was not found or does not belong to this app. */
  NotFound = 'NOT_FOUND',
  /** The feedback for a later version of this resource was already accepted. */
  OutdatedFeedback = 'OUTDATED_FEEDBACK',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The product wasn't found or isn't available to the channel. */
  ProductNotFound = 'PRODUCT_NOT_FOUND'
}

/** The input fields representing the components of a bundle line item. */
export type BundlesDraftOrderBundleLineItemComponentInput = {
  /** The quantity of the bundle component. */
  quantity: Scalars['Int']['input'];
  /**
   * The UUID of the bundle component. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant corresponding to the bundle component. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents the Bundles feature configuration for the shop. */
export type BundlesFeature = {
  __typename?: 'BundlesFeature';
  /** Whether a shop is configured properly to sell bundles. */
  eligibleForBundles: Scalars['Boolean']['output'];
  /** The reason why a shop is not eligible for bundles. */
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
  /** Whether a shop has any fixed bundle products or has a cartTransform function installed. */
  sellsBundles: Scalars['Boolean']['output'];
};

/** Possible error codes that can be returned by `BusinessCustomerUserError`. */
export enum BusinessCustomerErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Deleting the resource failed. */
  FailedToDelete = 'FAILED_TO_DELETE',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input is invalid. */
  InvalidInput = 'INVALID_INPUT',
  /** The number of resources exceeded the limit. */
  LimitReached = 'LIMIT_REACHED',
  /** The input is empty. */
  NoInput = 'NO_INPUT',
  /** Missing a required field. */
  Required = 'REQUIRED',
  /** The resource wasn't found. */
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The field value is too long. */
  TooLong = 'TOO_LONG',
  /** Unexpected type. */
  UnexpectedType = 'UNEXPECTED_TYPE'
}

/** An error that happens during the execution of a business customer mutation. */
export type BusinessCustomerUserError = DisplayableError & {
  __typename?: 'BusinessCustomerUserError';
  /** The error code. */
  code?: Maybe<BusinessCustomerErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * A legal entity through which a merchant operates. Each business entity contains its own [`BusinessEntityAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BusinessEntityAddress), company information, and can be associated with its own [`ShopifyPaymentsAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsAccount). [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) objects can be assigned to a business entity to determine payment processing and [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) attribution.
 *
 * Every shop must have one primary business entity. Additional entities enable international operations by establishing legal presence in multiple countries.
 *
 * Learn more about [managing multiple legal entities](https://shopify.dev/docs/apps/build/markets/multiple-entities).
 */
export type BusinessEntity = Node & {
  __typename?: 'BusinessEntity';
  /** The address of the merchant's Business Entity. */
  address: BusinessEntityAddress;
  /** Whether the Business Entity is archived from the shop. */
  archived: Scalars['Boolean']['output'];
  /** The name of the company associated with the merchant's Business Entity. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The display name of the merchant's Business Entity. */
  displayName: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The stable central legal entity ID associated with this business entity. */
  legalEntityId?: Maybe<Scalars['BigInt']['output']>;
  /** Whether it's the merchant's primary Business Entity. */
  primary: Scalars['Boolean']['output'];
  /**
   * Returns the Shopify Payments account information for the shop. Includes current balances across all currencies, payout schedules, and bank account configurations.
   *
   * The account includes [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records showing charges, refunds, and adjustments that affect your balance. Also includes [`ShopifyPaymentsDispute`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsDispute) records and [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) history between the account and connected [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) configurations.
   */
  shopifyPaymentsAccount?: Maybe<ShopifyPaymentsAccount>;
};

/** Represents the address of a merchant's Business Entity. */
export type BusinessEntityAddress = {
  __typename?: 'BusinessEntityAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country code of the merchant's Business Entity. */
  countryCode: CountryCode;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Settings describing the behavior of checkout for a B2B buyer. */
export type BuyerExperienceConfiguration = {
  __typename?: 'BuyerExperienceConfiguration';
  /** Whether to checkout to draft order for merchant review. */
  checkoutToDraft: Scalars['Boolean']['output'];
  /** The portion required to be paid at checkout. */
  deposit?: Maybe<DepositConfiguration>;
  /** Whether to allow customers to use editable shipping addresses. */
  editableShippingAddress: Scalars['Boolean']['output'];
  /**
   * Whether a buyer must pay at checkout or they can also choose to pay
   * later using net terms.
   * @deprecated Please use `checkoutToDraft`(must be false) and `paymentTermsTemplate`(must be nil) to derive this instead.
   */
  payNowOnly: Scalars['Boolean']['output'];
  /** Represents the merchant configured payment terms. */
  paymentTermsTemplate?: Maybe<PaymentTermsTemplate>;
};

/** The input fields specifying the behavior of checkout for a B2B buyer. */
export type BuyerExperienceConfigurationInput = {
  /** Whether to checkout to draft order for merchant review. */
  checkoutToDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input fields configuring the deposit a B2B buyer. */
  deposit?: InputMaybe<DepositInput>;
  /** Whether to allow customers to edit their shipping address at checkout. */
  editableShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents the merchant configured payment terms. */
  paymentTermsTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for a buyer signal. */
export type BuyerSignalInput = {
  /** The country code of the buyer. */
  countryCode: CountryCode;
};

/** The input fields for exchange line items on a calculated return. */
export type CalculateExchangeLineItemInput = {
  /** The discount to be applied to the exchange line item. */
  appliedDiscount?: InputMaybe<ExchangeLineItemAppliedDiscountInput>;
  /** The quantity of the item to be added. */
  quantity: Scalars['Int']['input'];
  /** The ID of the product variant to be added to the order as part of an exchange. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields to calculate return amounts associated with an order. */
export type CalculateReturnInput = {
  /** The exchange line items to add to the order. */
  exchangeLineItems?: InputMaybe<Array<CalculateExchangeLineItemInput>>;
  /** The ID of the order that will be returned. */
  orderId: Scalars['ID']['input'];
  /** The line items from the order to include in the return. */
  returnLineItems?: InputMaybe<Array<CalculateReturnLineItemInput>>;
  /** The return shipping fee associated with the return. */
  returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/** The input fields for return line items on a calculated return. */
export type CalculateReturnLineItemInput = {
  /** The ID of the fulfillment line item to be returned. */
  fulfillmentLineItemId: Scalars['ID']['input'];
  /** The quantity of the item to be returned. */
  quantity: Scalars['Int']['input'];
  /** The restocking fee for the return line item. */
  restockingFee?: InputMaybe<RestockingFeeInput>;
};

/** A discount that is automatically applied to an order that is being edited. */
export type CalculatedAutomaticDiscountApplication = CalculatedDiscountApplication & {
  __typename?: 'CalculatedAutomaticDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/** An amount discounting the line that has been allocated by an associated discount application. */
export type CalculatedDiscountAllocation = {
  __typename?: 'CalculatedDiscountAllocation';
  /** The money amount that's allocated by the discount application in shop and presentment currencies. */
  allocatedAmountSet: MoneyBag;
  /** The discount that the allocated amount originated from. */
  discountApplication: CalculatedDiscountApplication;
};

/** A [discount application](https://shopify.dev/api/admin-graphql/latest/interfaces/discountapplication) involved in order editing that might be newly added or have new changes applied. */
export type CalculatedDiscountApplication = {
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/** An auto-generated type for paginating through multiple CalculatedDiscountApplications. */
export type CalculatedDiscountApplicationConnection = {
  __typename?: 'CalculatedDiscountApplicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CalculatedDiscountApplicationEdge>;
  /** A list of nodes that are contained in CalculatedDiscountApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CalculatedDiscountApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CalculatedDiscountApplication and a cursor during pagination. */
export type CalculatedDiscountApplicationEdge = {
  __typename?: 'CalculatedDiscountApplicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CalculatedDiscountApplicationEdge. */
  node: CalculatedDiscountApplication;
};

/** A discount code that is applied to an order that is being edited. */
export type CalculatedDiscountCodeApplication = CalculatedDiscountApplication & {
  __typename?: 'CalculatedDiscountCodeApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  appliedTo: DiscountApplicationLevel;
  /** The string identifying the discount code that was used at the time of application. */
  code: Scalars['String']['output'];
  /** The description of discount application. Indicates the reason why the discount was applied. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/**
 * Calculated pricing, taxes, and discounts for a [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder). Includes the complete financial breakdown with line items, discounts, shipping costs, tax calculations, and totals in both shop and presentment currencies.
 *
 * Available [`ShippingRate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingRate) options are included when a valid shipping address and line items are present.
 *
 * > Note:
 * > Returns alerts and warnings when issues occur during calculation, such as insufficient inventory or incompatible discounts.
 */
export type CalculatedDraftOrder = {
  __typename?: 'CalculatedDraftOrder';
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  acceptAutomaticDiscounts?: Maybe<Scalars['Boolean']['output']>;
  /** The list of alerts raised while calculating. */
  alerts: Array<ResourceAlert>;
  /** Whether all variant prices have been overridden. */
  allVariantPricesOverridden: Scalars['Boolean']['output'];
  /**
   * The amount due later.
   * When there are payment terms, this is the total price minus the deposit amount (if any).
   * When there are no payment terms, this is 0.
   */
  amountDueLaterSet: MoneyBag;
  /**
   * The amount due now.
   * When there are payment terms this is the value of the deposit (0 by default).
   * When there are no payment terms, this is the total price.
   */
  amountDueNowSet: MoneyBag;
  /** Whether any variant prices have been overridden. */
  anyVariantPricesOverridden: Scalars['Boolean']['output'];
  /** The custom order-level discount applied. */
  appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The available shipping rates.
   * Requires a customer with a valid shipping address and at least one line item.
   */
  availableShippingRates: Array<ShippingRate>;
  /** Whether the billing address matches the shipping address. */
  billingAddressMatchesShippingAddress: Scalars['Boolean']['output'];
  /** The shop currency used for calculation. */
  currencyCode: CurrencyCode;
  /** The customer who will be sent an invoice. */
  customer?: Maybe<Customer>;
  /** The portion required to be paid at checkout. */
  deposit?: Maybe<DepositConfiguration>;
  /** All discount codes applied. */
  discountCodes: Array<Scalars['String']['output']>;
  /** The list of the line items in the calculated draft order. */
  lineItems: Array<CalculatedDraftOrderLineItem>;
  /**
   * A subtotal of the line items and corresponding discounts,
   * excluding shipping charges, shipping discounts, taxes, or order discounts.
   */
  lineItemsSubtotalPrice: MoneyBag;
  /**
   * The name of the selected market.
   * @deprecated This field is now incompatible with Markets.
   */
  marketName: Scalars['String']['output'];
  /**
   * The selected country code that determines the pricing.
   * @deprecated This field is now incompatible with Markets.
   */
  marketRegionCountryCode: CountryCode;
  /** The assigned phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The list of platform discounts applied. */
  platformDiscounts: Array<DraftOrderPlatformDiscount>;
  /** The payment currency used for calculation. */
  presentmentCurrencyCode: CurrencyCode;
  /** The purchasing entity. */
  purchasingEntity?: Maybe<PurchasingEntity>;
  /** The line item containing the shipping information and costs. */
  shippingLine?: Maybe<ShippingLine>;
  /**
   * The subtotal, in shop currency, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  subtotalPrice: Scalars['Money']['output'];
  /** The subtotal, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes. */
  subtotalPriceSet: MoneyBag;
  /** The list of of taxes lines charged for each line item and shipping line. */
  taxLines: Array<TaxLine>;
  /** Whether the line item prices include taxes. */
  taxesIncluded: Scalars['Boolean']['output'];
  /** Total discounts. */
  totalDiscountsSet: MoneyBag;
  /** Total price of line items, excluding discounts. */
  totalLineItemsPriceSet: MoneyBag;
  /**
   * The total price, in shop currency, includes taxes, shipping charges, and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  totalPrice: Scalars['Money']['output'];
  /** The total price, includes taxes, shipping charges, and discounts. */
  totalPriceSet: MoneyBag;
  /**
   * The sum of individual line item quantities.
   * If the draft order has bundle items, this is the sum containing the quantities of individual items in the bundle.
   */
  totalQuantityOfLineItems: Scalars['Int']['output'];
  /**
   * The total shipping price in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  totalShippingPrice: Scalars['Money']['output'];
  /** The total shipping price. */
  totalShippingPriceSet: MoneyBag;
  /**
   * The total tax in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  totalTax: Scalars['Money']['output'];
  /** The total tax. */
  totalTaxSet: MoneyBag;
  /**
   * Fingerprint of the current cart.
   * In order to have bundles work, the fingerprint must be passed to
   * each request as it was previously returned, unmodified.
   */
  transformerFingerprint?: Maybe<Scalars['String']['output']>;
  /** The list of warnings raised while calculating. */
  warnings: Array<DraftOrderWarning>;
};

/** The calculated line item for a draft order. */
export type CalculatedDraftOrderLineItem = {
  __typename?: 'CalculatedDraftOrderLineItem';
  /** The custom applied discount. */
  appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The `discountedTotal` divided by `quantity`,
   * equal to the average value of the line item price per unit after discounts are applied.
   * This value doesn't include discounts applied to the entire draft order.
   */
  approximateDiscountedUnitPriceSet: MoneyBag;
  /**
   * The bundle components of the draft order line item.
   * @deprecated Use `components` instead.
   */
  bundleComponents: Array<CalculatedDraftOrderLineItem>;
  /** The components of the draft order line item. */
  components: Array<CalculatedDraftOrderLineItem>;
  /** Whether the line item is custom (`true`) or contains a product variant (`false`). */
  custom: Scalars['Boolean']['output'];
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /** The list of additional information (metafields) with the associated types. */
  customAttributesV2: Array<TypedAttribute>;
  /** The total price with discounts applied. */
  discountedTotal: MoneyV2;
  /** The total price with discounts applied. */
  discountedTotalSet: MoneyBag;
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  discountedUnitPrice: MoneyV2;
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  fulfillmentService?: Maybe<FulfillmentService>;
  /** The image associated with the draft order line item. */
  image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The name of the product. */
  name: Scalars['String']['output'];
  /** The total price, excluding discounts, equal to the original unit price multiplied by quantity. */
  originalTotal: MoneyV2;
  /** The total price excluding discounts, equal to the original unit price multiplied by quantity. */
  originalTotalSet: MoneyBag;
  /** The line item price without any discounts applied. */
  originalUnitPrice: MoneyV2;
  /** The price without any discounts applied. */
  originalUnitPriceSet: MoneyBag;
  /** The original custom line item input price. */
  originalUnitPriceWithCurrency?: Maybe<MoneyV2>;
  /** The price override for the line item. */
  priceOverride?: Maybe<MoneyV2>;
  /** The product for the line item. */
  product?: Maybe<Product>;
  /**
   * The quantity of items. For a bundle item, this is the quantity of bundles,
   * not the quantity of items contained in the bundles themselves.
   */
  quantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The SKU number of the product variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Whether the variant is taxable. */
  taxable: Scalars['Boolean']['output'];
  /** The title of the product or variant. This field only applies to custom line items. */
  title: Scalars['String']['output'];
  /** The total value of the discount. */
  totalDiscount: MoneyV2;
  /** The total discount amount. */
  totalDiscountSet: MoneyBag;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  uuid: Scalars['String']['output'];
  /** The product variant for the line item. */
  variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
  /** The name of the vendor who created the product variant. */
  vendor?: Maybe<Scalars['String']['output']>;
  /** The weight unit and value. */
  weight?: Maybe<Weight>;
};

/** A calculated exchange line item. */
export type CalculatedExchangeLineItem = {
  __typename?: 'CalculatedExchangeLineItem';
  /** The discounts that have been allocated onto the line item by discount applications. */
  calculatedDiscountAllocations: Array<CalculatedDiscountAllocation>;
  /** The unit price of the exchange line item after discounts. */
  discountedUnitPriceSet: MoneyBag;
  /** A globally-unique ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The original unit price of the exchange line item before discounts. */
  originalUnitPriceSet: MoneyBag;
  /** The quantity being exchanged. */
  quantity: Scalars['Int']['output'];
  /** The calculated subtotal set of the exchange line item, including discounts. */
  subtotalSet: MoneyBag;
  /** The total tax of the exchange line item. */
  totalTaxSet: MoneyBag;
  /** The variant being exchanged. */
  variant?: Maybe<ProductVariant>;
};

/** A line item involved in order editing that may be newly added or have new changes applied. */
export type CalculatedLineItem = {
  __typename?: 'CalculatedLineItem';
  /** The discounts that have been allocated onto the line item by discount applications. */
  calculatedDiscountAllocations: Array<CalculatedDiscountAllocation>;
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /**
   * The discounts that have been allocated onto the line item by discount applications.
   * @deprecated Use `calculatedDiscountAllocations` instead.
   */
  discountAllocations: Array<DiscountAllocation>;
  /** The price of a single quantity of the line item with line item discounts applied, in shop and presentment currencies. Discounts applied to the entire order aren't included in this price. */
  discountedUnitPriceSet: MoneyBag;
  /** The total number of items that can be edited. */
  editableQuantity: Scalars['Int']['output'];
  /** The editable quantity prior to any changes made in the current edit. */
  editableQuantityBeforeChanges: Scalars['Int']['output'];
  /** The total price of editable lines in shop and presentment currencies. */
  editableSubtotalSet: MoneyBag;
  /** Whether the calculated line item has a staged discount. */
  hasStagedLineItemDiscount: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image object associated to the line item's variant. */
  image?: Maybe<Image>;
  /** The variant unit price in shop and presentment currencies, without any discounts applied. */
  originalUnitPriceSet: MoneyBag;
  /** The total number of items. */
  quantity: Scalars['Int']['output'];
  /** Whether the line item can be restocked or not. */
  restockable: Scalars['Boolean']['output'];
  /** Whether the changes on the line item will result in a restock. */
  restocking: Scalars['Boolean']['output'];
  /** The variant SKU number. */
  sku?: Maybe<Scalars['String']['output']>;
  /** A list of changes that affect this line item. */
  stagedChanges: Array<OrderStagedChange>;
  /** The title of the product. */
  title: Scalars['String']['output'];
  /** The total price of uneditable lines in shop and presentment currencies. */
  uneditableSubtotalSet: MoneyBag;
  /**
   * The product variant associated with this line item. The value is null for custom line items and items where
   * the variant has been deleted.
   */
  variant?: Maybe<ProductVariant>;
  /** The title of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple CalculatedLineItems. */
export type CalculatedLineItemConnection = {
  __typename?: 'CalculatedLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CalculatedLineItemEdge>;
  /** A list of nodes that are contained in CalculatedLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CalculatedLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CalculatedLineItem and a cursor during pagination. */
export type CalculatedLineItemEdge = {
  __typename?: 'CalculatedLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CalculatedLineItemEdge. */
  node: CalculatedLineItem;
};

/** Represents a discount that was manually created for an order that is being edited. */
export type CalculatedManualDiscountApplication = CalculatedDiscountApplication & {
  __typename?: 'CalculatedManualDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/**
 * An order during an active edit session with all proposed changes applied but not yet committed. When you begin editing an order with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation, the system creates a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) that shows how the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) will look after your changes. The calculated order tracks the original order state and all staged modifications (added or removed [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, quantity adjustments, discount changes, and [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine) updates). Use the calculated order to preview the financial impact of edits before committing them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
 *
 * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
 */
export type CalculatedOrder = Node & {
  __typename?: 'CalculatedOrder';
  /** Returns only the new discount applications being added to the order in the current edit. */
  addedDiscountApplications: CalculatedDiscountApplicationConnection;
  /** Returns only the new line items being added to the order during the current edit. */
  addedLineItems: CalculatedLineItemConnection;
  /** Amount of the order-level discount (doesn't contain any line item discounts) in shop and presentment currencies. */
  cartDiscountAmountSet?: Maybe<MoneyBag>;
  /**
   * Whether the changes have been applied and saved to the order.
   * @deprecated CalculatedOrder for committed order edits is being deprecated, and this field will also be removed in a future version.  See [changelog](https://shopify.dev/changelog/deprecation-notice-calculatedorder-for-committed-order-edits) for more details.
   */
  committed: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * Returns all items on the order that existed before starting the edit.
   * Will include any changes that have been made.
   * Will not include line items added during the current edit.
   */
  lineItems: CalculatedLineItemConnection;
  /** The HTML of the customer notification for the order edit. */
  notificationPreviewHtml?: Maybe<Scalars['HTML']['output']>;
  /** The customer notification title. */
  notificationPreviewTitle: Scalars['String']['output'];
  /** The order without any changes applied. */
  originalOrder: Order;
  /**
   * Returns the shipping lines on the order that existed before starting the edit.
   * Will include any changes that have been made as well as shipping lines added during the current edit.
   * Returns only the first 250 shipping lines.
   */
  shippingLines: Array<CalculatedShippingLine>;
  /** List of changes made to the order during the current edit. */
  stagedChanges: OrderStagedChangeConnection;
  /** The sum of the quantities for the line items that contribute to the order's subtotal. */
  subtotalLineItemsQuantity: Scalars['Int']['output'];
  /** The subtotal of the line items, in shop and presentment currencies, after all the discounts are applied.  The subtotal doesn't include shipping.  The subtotal includes taxes for taxes-included orders and excludes taxes for taxes-excluded orders. */
  subtotalPriceSet?: Maybe<MoneyBag>;
  /** Taxes charged for the line item. */
  taxLines: Array<TaxLine>;
  /** Total price of the order less the total amount received from the customer in shop and presentment currencies. */
  totalOutstandingSet: MoneyBag;
  /** Total amount of the order (includes taxes and discounts) in shop and presentment currencies. */
  totalPriceSet: MoneyBag;
};


/**
 * An order during an active edit session with all proposed changes applied but not yet committed. When you begin editing an order with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation, the system creates a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) that shows how the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) will look after your changes. The calculated order tracks the original order state and all staged modifications (added or removed [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, quantity adjustments, discount changes, and [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine) updates). Use the calculated order to preview the financial impact of edits before committing them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
 *
 * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
 */
export type CalculatedOrderAddedDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order during an active edit session with all proposed changes applied but not yet committed. When you begin editing an order with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation, the system creates a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) that shows how the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) will look after your changes. The calculated order tracks the original order state and all staged modifications (added or removed [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, quantity adjustments, discount changes, and [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine) updates). Use the calculated order to preview the financial impact of edits before committing them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
 *
 * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
 */
export type CalculatedOrderAddedLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order during an active edit session with all proposed changes applied but not yet committed. When you begin editing an order with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation, the system creates a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) that shows how the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) will look after your changes. The calculated order tracks the original order state and all staged modifications (added or removed [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, quantity adjustments, discount changes, and [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine) updates). Use the calculated order to preview the financial impact of edits before committing them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
 *
 * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
 */
export type CalculatedOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order during an active edit session with all proposed changes applied but not yet committed. When you begin editing an order with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation, the system creates a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) that shows how the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) will look after your changes. The calculated order tracks the original order state and all staged modifications (added or removed [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, quantity adjustments, discount changes, and [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine) updates). Use the calculated order to preview the financial impact of edits before committing them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
 *
 * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
 */
export type CalculatedOrderStagedChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The calculated costs of handling a return line item.
 * Typically, this would cover the costs of inspecting, repackaging, and restocking the item.
 */
export type CalculatedRestockingFee = CalculatedReturnFee & {
  __typename?: 'CalculatedRestockingFee';
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The value of the fee as a percentage. */
  percentage: Scalars['Float']['output'];
};

/** A calculated return. */
export type CalculatedReturn = {
  __typename?: 'CalculatedReturn';
  /** A list of calculated exchange line items. */
  exchangeLineItems: Array<CalculatedExchangeLineItem>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A list of calculated return line items. */
  returnLineItems: Array<CalculatedReturnLineItem>;
  /** The calculated return shipping fee. */
  returnShippingFee?: Maybe<CalculatedReturnShippingFee>;
};

/** A calculated return fee. */
export type CalculatedReturnFee = {
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** A calculated return line item. */
export type CalculatedReturnLineItem = {
  __typename?: 'CalculatedReturnLineItem';
  /** The fulfillment line item from which items are returned. */
  fulfillmentLineItem: FulfillmentLineItem;
  /** A globally-unique ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The quantity being returned. */
  quantity: Scalars['Int']['output'];
  /** The restocking fee of the return line item. */
  restockingFee?: Maybe<CalculatedRestockingFee>;
  /** The subtotal of the return line item before order discounts. */
  subtotalBeforeOrderDiscountsSet: MoneyBag;
  /** The subtotal of the return line item. */
  subtotalSet: MoneyBag;
  /** The total tax of the return line item. */
  totalTaxSet: MoneyBag;
};

/** The calculated cost of the return shipping. */
export type CalculatedReturnShippingFee = CalculatedReturnFee & {
  __typename?: 'CalculatedReturnShippingFee';
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** A discount created by a Shopify script for an order that is being edited. */
export type CalculatedScriptDiscountApplication = CalculatedDiscountApplication & {
  __typename?: 'CalculatedScriptDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/** A shipping line item involved in order editing that may be newly added or have new changes applied. */
export type CalculatedShippingLine = {
  __typename?: 'CalculatedShippingLine';
  /** A globally-unique ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The price of the shipping line when sold and before applying discounts. This field includes taxes if `Order.taxesIncluded` is true. Otherwise, this field doesn't include taxes for the shipping line. */
  price: MoneyBag;
  /** The staged status of the shipping line. */
  stagedStatus: CalculatedShippingLineStagedStatus;
  /** The title of the shipping line. */
  title: Scalars['String']['output'];
};

/** Represents the staged status of a CalculatedShippingLine on a CalculatedOrder. */
export enum CalculatedShippingLineStagedStatus {
  /** The shipping line was added as part of the current order edit. */
  Added = 'ADDED',
  /** The shipping line has no staged changes associated with it. */
  None = 'NONE',
  /** The shipping line was removed as part of the current order edit. */
  Removed = 'REMOVED'
}

/** Credit card payment information captured during a transaction. Includes cardholder details, card metadata, verification response codes, and the [`DigitalWallet`](https://shopify.dev/docs/api/admin-graphql/latest/enums/DigitalWallet#valid-values) when used. */
export type CardPaymentDetails = BasePaymentDetails & {
  __typename?: 'CardPaymentDetails';
  /** The response code from the address verification system (AVS). The code is always a single letter. */
  avsResultCode?: Maybe<Scalars['String']['output']>;
  /** The issuer identification number (IIN), formerly known as bank identification number (BIN) of the customer's credit card. This is made up of the first few digits of the credit card number. */
  bin?: Maybe<Scalars['String']['output']>;
  /** The name of the company that issued the customer's credit card. */
  company?: Maybe<Scalars['String']['output']>;
  /** The date and time when the card payment details were created. */
  createdAt: Scalars['DateTime']['output'];
  /** The response code from the credit card company indicating whether the customer entered the card security code, or card verification value, correctly. The code is a single letter or empty string. */
  cvvResultCode?: Maybe<Scalars['String']['output']>;
  /** The month in which the used credit card expires. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** The year in which the used credit card expires. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** The holder of the credit card. */
  name?: Maybe<Scalars['String']['output']>;
  /** The customer's credit card number, with most of the leading digits redacted. */
  number?: Maybe<Scalars['String']['output']>;
  /** The name of payment method used by the buyer. */
  paymentMethodName?: Maybe<Scalars['String']['output']>;
  /** Digital wallet used for the payment. */
  wallet?: Maybe<DigitalWallet>;
};

/** Return type for `carrierServiceCreate` mutation. */
export type CarrierServiceCreatePayload = {
  __typename?: 'CarrierServiceCreatePayload';
  /** The created carrier service. */
  carrierService?: Maybe<DeliveryCarrierService>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CarrierServiceCreateUserError>;
};

/** An error that occurs during the execution of `CarrierServiceCreate`. */
export type CarrierServiceCreateUserError = DisplayableError & {
  __typename?: 'CarrierServiceCreateUserError';
  /** The error code. */
  code?: Maybe<CarrierServiceCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CarrierServiceCreateUserError`. */
export enum CarrierServiceCreateUserErrorCode {
  /** Carrier service creation failed. */
  CarrierServiceCreateFailed = 'CARRIER_SERVICE_CREATE_FAILED'
}

/** Return type for `carrierServiceDelete` mutation. */
export type CarrierServiceDeletePayload = {
  __typename?: 'CarrierServiceDeletePayload';
  /** The ID of the deleted carrier service. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CarrierServiceDeleteUserError>;
};

/** An error that occurs during the execution of `CarrierServiceDelete`. */
export type CarrierServiceDeleteUserError = DisplayableError & {
  __typename?: 'CarrierServiceDeleteUserError';
  /** The error code. */
  code?: Maybe<CarrierServiceDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CarrierServiceDeleteUserError`. */
export enum CarrierServiceDeleteUserErrorCode {
  /** Carrier service deletion failed. */
  CarrierServiceDeleteFailed = 'CARRIER_SERVICE_DELETE_FAILED'
}

/** The set of valid sort keys for the CarrierService query. */
export enum CarrierServiceSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `carrierServiceUpdate` mutation. */
export type CarrierServiceUpdatePayload = {
  __typename?: 'CarrierServiceUpdatePayload';
  /** The updated carrier service. */
  carrierService?: Maybe<DeliveryCarrierService>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CarrierServiceUpdateUserError>;
};

/** An error that occurs during the execution of `CarrierServiceUpdate`. */
export type CarrierServiceUpdateUserError = DisplayableError & {
  __typename?: 'CarrierServiceUpdateUserError';
  /** The error code. */
  code?: Maybe<CarrierServiceUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CarrierServiceUpdateUserError`. */
export enum CarrierServiceUpdateUserErrorCode {
  /** Carrier service update failed. */
  CarrierServiceUpdateFailed = 'CARRIER_SERVICE_UPDATE_FAILED'
}

/**
 * A deployed cart transformation function that actively modifies how products appear and behave in customer carts. Cart transforms enable sophisticated merchandising strategies by programmatically merging, expanding, or updating cart line items based on custom business logic.
 *
 * Use the `CartTransform` object to:
 * - Monitor active bundling and cart modification logic
 * - Track transform function deployment status and configuration
 * - Manage error handling behavior for cart processing failures
 * - Coordinate multiple transforms when running complex merchandising strategies
 * - Analyze transform performance and customer interaction patterns
 *
 * Each cart transform links to a specific [Shopify Function](https://shopify.dev/docs/apps/build/functions) that contains the actual cart modification logic. The `blockOnFailure` setting determines whether cart processing should halt when the transform encounters errors, or whether it should allow customers to proceed with unmodified carts. This flexibility ensures merchants can balance feature richness with checkout reliability.
 *
 * Transform functions operate during cart updates, product additions, and checkout initiation, providing multiple touchpoints to enhance the shopping experience. They integrate seamlessly with existing cart APIs while extending functionality beyond standard product catalog capabilities.
 *
 * The function ID connects to your deployed function code, while the configuration settings control how the transform behaves in different scenarios. Multiple transforms can work together, processing cart modifications in sequence to support complex merchandising workflows.
 *
 * Learn more about [customized bundles](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle), and about the [Cart Transform Function API](https://shopify.dev/docs/api/functions/latest/cart-transform).
 */
export type CartTransform = HasMetafields & Node & {
  __typename?: 'CartTransform';
  /** Whether a run failure will block cart and checkout operations. */
  blockOnFailure: Scalars['Boolean']['output'];
  /** The ID for the Cart Transform function. */
  functionId: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/**
 * A deployed cart transformation function that actively modifies how products appear and behave in customer carts. Cart transforms enable sophisticated merchandising strategies by programmatically merging, expanding, or updating cart line items based on custom business logic.
 *
 * Use the `CartTransform` object to:
 * - Monitor active bundling and cart modification logic
 * - Track transform function deployment status and configuration
 * - Manage error handling behavior for cart processing failures
 * - Coordinate multiple transforms when running complex merchandising strategies
 * - Analyze transform performance and customer interaction patterns
 *
 * Each cart transform links to a specific [Shopify Function](https://shopify.dev/docs/apps/build/functions) that contains the actual cart modification logic. The `blockOnFailure` setting determines whether cart processing should halt when the transform encounters errors, or whether it should allow customers to proceed with unmodified carts. This flexibility ensures merchants can balance feature richness with checkout reliability.
 *
 * Transform functions operate during cart updates, product additions, and checkout initiation, providing multiple touchpoints to enhance the shopping experience. They integrate seamlessly with existing cart APIs while extending functionality beyond standard product catalog capabilities.
 *
 * The function ID connects to your deployed function code, while the configuration settings control how the transform behaves in different scenarios. Multiple transforms can work together, processing cart modifications in sequence to support complex merchandising workflows.
 *
 * Learn more about [customized bundles](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle), and about the [Cart Transform Function API](https://shopify.dev/docs/api/functions/latest/cart-transform).
 */
export type CartTransformMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A deployed cart transformation function that actively modifies how products appear and behave in customer carts. Cart transforms enable sophisticated merchandising strategies by programmatically merging, expanding, or updating cart line items based on custom business logic.
 *
 * Use the `CartTransform` object to:
 * - Monitor active bundling and cart modification logic
 * - Track transform function deployment status and configuration
 * - Manage error handling behavior for cart processing failures
 * - Coordinate multiple transforms when running complex merchandising strategies
 * - Analyze transform performance and customer interaction patterns
 *
 * Each cart transform links to a specific [Shopify Function](https://shopify.dev/docs/apps/build/functions) that contains the actual cart modification logic. The `blockOnFailure` setting determines whether cart processing should halt when the transform encounters errors, or whether it should allow customers to proceed with unmodified carts. This flexibility ensures merchants can balance feature richness with checkout reliability.
 *
 * Transform functions operate during cart updates, product additions, and checkout initiation, providing multiple touchpoints to enhance the shopping experience. They integrate seamlessly with existing cart APIs while extending functionality beyond standard product catalog capabilities.
 *
 * The function ID connects to your deployed function code, while the configuration settings control how the transform behaves in different scenarios. Multiple transforms can work together, processing cart modifications in sequence to support complex merchandising workflows.
 *
 * Learn more about [customized bundles](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle), and about the [Cart Transform Function API](https://shopify.dev/docs/api/functions/latest/cart-transform).
 */
export type CartTransformMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple CartTransforms. */
export type CartTransformConnection = {
  __typename?: 'CartTransformConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CartTransformEdge>;
  /** A list of nodes that are contained in CartTransformEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CartTransform>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `cartTransformCreate` mutation. */
export type CartTransformCreatePayload = {
  __typename?: 'CartTransformCreatePayload';
  /** The newly created cart transform function. */
  cartTransform?: Maybe<CartTransform>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CartTransformCreateUserError>;
};

/** An error that occurs during the execution of `CartTransformCreate`. */
export type CartTransformCreateUserError = DisplayableError & {
  __typename?: 'CartTransformCreateUserError';
  /** The error code. */
  code?: Maybe<CartTransformCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CartTransformCreateUserError`. */
export enum CartTransformCreateUserErrorCode {
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CustomAppFunctionNotEligible = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** A cart transform function already exists for the provided function_id. */
  FunctionAlreadyRegistered = 'FUNCTION_ALREADY_REGISTERED',
  /** Function does not implement the required interface for this cart_transform function. */
  FunctionDoesNotImplement = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** No Shopify Function found for provided function_id. */
  FunctionNotFound = 'FUNCTION_NOT_FOUND',
  /** Failed to create cart transform due to invalid input. */
  InputInvalid = 'INPUT_INVALID',
  /** Could not create or update metafields. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** The maximum number of cart transforms per shop has been reached. */
  MaximumCartTransforms = 'MAXIMUM_CART_TRANSFORMS',
  /** Either function_id or function_handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function_id or function_handle can be provided, not both. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS'
}

/** Return type for `cartTransformDelete` mutation. */
export type CartTransformDeletePayload = {
  __typename?: 'CartTransformDeletePayload';
  /** The globally-unique ID for the deleted cart transform. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CartTransformDeleteUserError>;
};

/** An error that occurs during the execution of `CartTransformDelete`. */
export type CartTransformDeleteUserError = DisplayableError & {
  __typename?: 'CartTransformDeleteUserError';
  /** The error code. */
  code?: Maybe<CartTransformDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CartTransformDeleteUserError`. */
export enum CartTransformDeleteUserErrorCode {
  /** Could not find cart transform for provided id. */
  NotFound = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UnauthorizedAppScope = 'UNAUTHORIZED_APP_SCOPE'
}

/** An auto-generated type which holds one CartTransform and a cursor during pagination. */
export type CartTransformEdge = {
  __typename?: 'CartTransformEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CartTransformEdge. */
  node: CartTransform;
};

/**
 * Controls which cart transformation operations apps can perform in your store. This lets you define exactly what types of cart modifications are allowed based on your checkout setup and business needs.
 *
 * The eligible operations determine what cart transform functions can accomplish, providing a clear boundary for app capabilities within the store's ecosystem.
 *
 * Learn more about [cart transform operations](https://shopify.dev/docs/api/functions/latest/cart-transform#multiple-operations).
 */
export type CartTransformEligibleOperations = {
  __typename?: 'CartTransformEligibleOperations';
  /** The shop is eligible for expand operations. */
  expandOperation: Scalars['Boolean']['output'];
  /** The shop is eligible for merge operations. */
  mergeOperation: Scalars['Boolean']['output'];
  /** The shop is eligible for update operations. */
  updateOperation: Scalars['Boolean']['output'];
};

/**
 * Provides access to the cart transform feature configuration for the merchant's store. This wrapper object indicates whether cart transformation capabilities are enabled and what operations are available.
 *
 * For example, when checking if your app can deploy customized bundle features, you would query this object to confirm cart transforms are supported and review the eligible operations.
 *
 * The feature configuration helps apps determine compatibility before attempting to create transform functions.
 *
 * Learn more about [cart transformation](https://shopify.dev/docs/api/admin-graphql/latest/objects/CartTransform).
 */
export type CartTransformFeature = {
  __typename?: 'CartTransformFeature';
  /** The cart transform operations eligible for the shop. */
  eligibleOperations: CartTransformEligibleOperations;
};

/** The set of valid sort keys for the CashActivities query. */
export enum CashActivitiesSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `time` value. */
  Time = 'TIME'
}

/** An activity on a cash drawer. */
export type CashActivity = {
  /** The amount of cash added or removed as part of the activity. */
  cash: MoneyV2;
  /** The point of sale device payment session associated with the activity. */
  paymentSession: PointOfSaleDevicePaymentSession;
  /** The staff member who performed the activity. */
  staffMember: StaffMember;
  /** The time at which the activity occurred. */
  time: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CashActivities. */
export type CashActivityConnection = {
  __typename?: 'CashActivityConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CashActivityEdge>;
  /** A list of nodes that are contained in CashActivityEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CashActivity>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CashActivity and a cursor during pagination. */
export type CashActivityEdge = {
  __typename?: 'CashActivityEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CashActivityEdge. */
  node: CashActivity;
};

/** A cash adjustment activity. */
export type CashAdjustmentActivity = CashActivity & {
  __typename?: 'CashAdjustmentActivity';
  /** The amount of cash added or removed as part of the activity. */
  cash: MoneyV2;
  /** The gift card associated with the activity. */
  giftCard?: Maybe<GiftCard>;
  /** A note associated with the activity. */
  note?: Maybe<Scalars['String']['output']>;
  /** The point of sale device payment session associated with the activity. */
  paymentSession: PointOfSaleDevicePaymentSession;
  /** The reason code for the activity. */
  reasonCode?: Maybe<CashManagementReasonCode>;
  /** The staff member who performed the activity. */
  staffMember: StaffMember;
  /** The time at which the activity occurred. */
  time: Scalars['DateTime']['output'];
  /** The type of adjustment activity. */
  type: CashAdjustmentActivityType;
};

/** The type of adjustment activity. */
export enum CashAdjustmentActivityType {
  /** A manual cash adjustment. */
  Adjustment = 'ADJUSTMENT',
  /** A cash payout, such as a gift card cash out. */
  CashPayout = 'CASH_PAYOUT',
  /** A closing adjustment. */
  ClosingAdjustment = 'CLOSING_ADJUSTMENT'
}

/** A cash count activity. */
export type CashCountActivity = CashActivity & {
  __typename?: 'CashCountActivity';
  /** The amount of cash added or removed as part of the activity. */
  cash: MoneyV2;
  /** The amount of cash counted during the activity. */
  cashCounted: MoneyV2;
  /** The discrepancy between the counted and expected cash amounts. */
  cashDiscrepancy: MoneyV2;
  /** The expected amount of cash in the drawer at the time of the activity. */
  cashExpected: MoneyV2;
  /** A note associated with the activity. */
  note?: Maybe<Scalars['String']['output']>;
  /** The point of sale device payment session associated with the activity. */
  paymentSession: PointOfSaleDevicePaymentSession;
  /** The reason code for the activity. */
  reasonCode?: Maybe<CashManagementReasonCode>;
  /** The staff member who performed the activity. */
  staffMember: StaffMember;
  /** The time at which the activity occurred. */
  time: Scalars['DateTime']['output'];
  /** The type of count activity. */
  type: CashCountActivityType;
};

/** The type of count activity. */
export enum CashCountActivityType {
  /** A count performed at the closing of a session. */
  Closing = 'CLOSING',
  /** A count performed during a session. */
  MidSession = 'MID_SESSION',
  /** A count performed at the opening of a session. */
  Opening = 'OPENING'
}

/** A cash drawer for cash management. */
export type CashDrawer = Node & {
  __typename?: 'CashDrawer';
  /** The current balance in the cash drawer. */
  balance: MoneyV2;
  /** The activities on the cash drawer. */
  cashActivities: CashActivityConnection;
  /** A unique ID for the cash drawer. */
  id: Scalars['ID']['output'];
  /** The location of the cash drawer. */
  location: Location;
  /** The name of the cash drawer. */
  name: Scalars['String']['output'];
  /** The net sales for this cash drawer. */
  netSales: MoneyV2;
  /** The Point of Sale devices assigned to this cash drawer. */
  pointOfSaleDevices?: Maybe<PointOfSaleDeviceConnection>;
  /** The total adjustments for this cash drawer. */
  totalAdjustments: MoneyV2;
  /** The total discrepancies for this cash drawer. */
  totalDiscrepancies: MoneyV2;
  /** The total refunds for this cash drawer. */
  totalRefunds: MoneyV2;
  /** The total sales for this cash drawer. */
  totalSales: MoneyV2;
};


/** A cash drawer for cash management. */
export type CashDrawerCashActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CashActivitiesSortKeys>;
  staffMemberId?: InputMaybe<Scalars['ID']['input']>;
};


/** A cash drawer for cash management. */
export type CashDrawerNetSalesArgs = {
  dateRange: CashDrawerDateRangeInput;
};


/** A cash drawer for cash management. */
export type CashDrawerPointOfSaleDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A cash drawer for cash management. */
export type CashDrawerTotalAdjustmentsArgs = {
  dateRange: CashDrawerDateRangeInput;
};


/** A cash drawer for cash management. */
export type CashDrawerTotalDiscrepanciesArgs = {
  dateRange: CashDrawerDateRangeInput;
};


/** A cash drawer for cash management. */
export type CashDrawerTotalRefundsArgs = {
  dateRange: CashDrawerDateRangeInput;
};


/** A cash drawer for cash management. */
export type CashDrawerTotalSalesArgs = {
  dateRange: CashDrawerDateRangeInput;
};

/** An auto-generated type for paginating through multiple CashDrawers. */
export type CashDrawerConnection = {
  __typename?: 'CashDrawerConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CashDrawerEdge>;
  /** A list of nodes that are contained in CashDrawerEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CashDrawer>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `cashDrawerCreate` mutation. */
export type CashDrawerCreatePayload = {
  __typename?: 'CashDrawerCreatePayload';
  /** The created cash drawer. */
  cashDrawer?: Maybe<CashDrawer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CashDrawerCreateUserError>;
};

/** An error that occurs during the execution of `CashDrawerCreate`. */
export type CashDrawerCreateUserError = DisplayableError & {
  __typename?: 'CashDrawerCreateUserError';
  /** The error code. */
  code?: Maybe<CashDrawerCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CashDrawerCreateUserError`. */
export enum CashDrawerCreateUserErrorCode {
  /** A cash drawer with this name already exists at the specified location. */
  CashDrawerAlreadyExists = 'CASH_DRAWER_ALREADY_EXISTS',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The name provided is invalid. */
  InvalidName = 'INVALID_NAME',
  /** The location was not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** Failed to create cash drawer. */
  NotSaved = 'NOT_SAVED'
}

/** The input fields for date and time range filter. */
export type CashDrawerDateRangeInput = {
  /** The start of the date and time range. */
  from: Scalars['DateTime']['input'];
  /** The end of the date and time range. */
  to: Scalars['DateTime']['input'];
};

/** An auto-generated type which holds one CashDrawer and a cursor during pagination. */
export type CashDrawerEdge = {
  __typename?: 'CashDrawerEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CashDrawerEdge. */
  node: CashDrawer;
};

/** Return type for `cashDrawerFindOrCreate` mutation. */
export type CashDrawerFindOrCreatePayload = {
  __typename?: 'CashDrawerFindOrCreatePayload';
  /** The cash drawer. */
  cashDrawer?: Maybe<CashDrawer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CashDrawerFindOrCreateUserError>;
};

/** An error that occurs during the execution of `CashDrawerFindOrCreate`. */
export type CashDrawerFindOrCreateUserError = DisplayableError & {
  __typename?: 'CashDrawerFindOrCreateUserError';
  /** The error code. */
  code?: Maybe<CashDrawerFindOrCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CashDrawerFindOrCreateUserError`. */
export enum CashDrawerFindOrCreateUserErrorCode {
  /** The cash drawer assignment already exists. */
  CashDrawerAssignmentAlreadyExists = 'CASH_DRAWER_ASSIGNMENT_ALREADY_EXISTS',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The location was not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** Failed to find or create cash drawer. */
  NotSaved = 'NOT_SAVED',
  /** The point of sale device was not found. */
  PointOfSaleDeviceNotFound = 'POINT_OF_SALE_DEVICE_NOT_FOUND'
}

/** The input fields for updating a cash drawer. */
export type CashDrawerUpdateInput = {
  /** The new name for the cash drawer. */
  name: Scalars['String']['input'];
};

/** Return type for `cashDrawerUpdate` mutation. */
export type CashDrawerUpdatePayload = {
  __typename?: 'CashDrawerUpdatePayload';
  /** The updated cash drawer. */
  cashDrawer?: Maybe<CashDrawer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CashDrawerUpdateUserError>;
};

/** An error that occurs during the execution of `CashDrawerUpdate`. */
export type CashDrawerUpdateUserError = DisplayableError & {
  __typename?: 'CashDrawerUpdateUserError';
  /** The error code. */
  code?: Maybe<CashDrawerUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CashDrawerUpdateUserError`. */
export enum CashDrawerUpdateUserErrorCode {
  /** A cash drawer with this name already exists at the specified location. */
  CashDrawerAlreadyExists = 'CASH_DRAWER_ALREADY_EXISTS',
  /** The cash drawer was not found. */
  CashDrawerNotFound = 'CASH_DRAWER_NOT_FOUND',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The name provided is invalid. */
  InvalidName = 'INVALID_NAME',
  /** Failed to update cash drawer. */
  NotSaved = 'NOT_SAVED'
}

/** Custom reason code. */
export type CashManagementCustomReasonCode = Node & {
  __typename?: 'CashManagementCustomReasonCode';
  /** The code for the custom reason code. */
  code: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Default reason code. */
export type CashManagementDefaultReasonCode = Node & {
  __typename?: 'CashManagementDefaultReasonCode';
  /** The code for the default reason code. */
  code: CashManagementDefaultReasonCodeEnum;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Default reason codes for cash management. */
export enum CashManagementDefaultReasonCodeEnum {
  /** Point of sale device payment session was automatically closed because the device switched to a different location. */
  AutoEndSessionLocationChange = 'AUTO_END_SESSION_LOCATION_CHANGE',
  /** Point of sale device payment session was automatically closed because a staff member logged out. */
  AutoEndSessionLogout = 'AUTO_END_SESSION_LOGOUT',
  /** Point of sale device payment session was automatically opened by a cash payment at checkout. */
  AutoStartSessionCheckout = 'AUTO_START_SESSION_CHECKOUT',
  /** Cash count. */
  CashCount = 'CASH_COUNT',
  /** Cash payout. */
  CashPayout = 'CASH_PAYOUT',
  /** Cash pickup. */
  CashPickup = 'CASH_PICKUP',
  /** Change correction. */
  ChangeCorrection = 'CHANGE_CORRECTION',
  /** Other. */
  Other = 'OTHER',
  /** Petty cash. */
  PettyCash = 'PETTY_CASH',
  /** Tip payout. */
  TipPayout = 'TIP_PAYOUT'
}

/** Reason code for cash management. */
export type CashManagementReasonCode = CashManagementCustomReasonCode | CashManagementDefaultReasonCode | CashManagementSystemReasonCode;

/** An auto-generated type for paginating through multiple CashManagementReasonCodes. */
export type CashManagementReasonCodeConnection = {
  __typename?: 'CashManagementReasonCodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CashManagementReasonCodeEdge>;
  /** A list of nodes that are contained in CashManagementReasonCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CashManagementReasonCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `cashManagementReasonCodeCreate` mutation. */
export type CashManagementReasonCodeCreatePayload = {
  __typename?: 'CashManagementReasonCodeCreatePayload';
  /** The created cash management reason code. */
  reasonCode?: Maybe<CashManagementCustomReasonCode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CashManagementReasonCodeCreateUserError>;
};

/** An error that occurs during the execution of `CashManagementReasonCodeCreate`. */
export type CashManagementReasonCodeCreateUserError = DisplayableError & {
  __typename?: 'CashManagementReasonCodeCreateUserError';
  /** The error code. */
  code?: Maybe<CashManagementReasonCodeCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CashManagementReasonCodeCreateUserError`. */
export enum CashManagementReasonCodeCreateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The reason code already exists. */
  CodeAlreadyExists = 'CODE_ALREADY_EXISTS',
  /** Failed to create cash management reason code. */
  NotSaved = 'NOT_SAVED'
}

/** Return type for `cashManagementReasonCodeDelete` mutation. */
export type CashManagementReasonCodeDeletePayload = {
  __typename?: 'CashManagementReasonCodeDeletePayload';
  /** The deleted cash management reason code gid. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CashManagementReasonCodeDeleteUserError>;
};

/** An error that occurs during the execution of `CashManagementReasonCodeDelete`. */
export type CashManagementReasonCodeDeleteUserError = DisplayableError & {
  __typename?: 'CashManagementReasonCodeDeleteUserError';
  /** The error code. */
  code?: Maybe<CashManagementReasonCodeDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CashManagementReasonCodeDeleteUserError`. */
export enum CashManagementReasonCodeDeleteUserErrorCode {
  /** Database error occurred. */
  DatabaseError = 'DATABASE_ERROR',
  /** SYSTEM type reason codes are not deletable. */
  NotDeletable = 'NOT_DELETABLE',
  /** Reason code not found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one CashManagementReasonCode and a cursor during pagination. */
export type CashManagementReasonCodeEdge = {
  __typename?: 'CashManagementReasonCodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CashManagementReasonCodeEdge. */
  node: CashManagementReasonCode;
};

/** A summary of cash management data. */
export type CashManagementSummary = {
  __typename?: 'CashManagementSummary';
  /** The cumulative cash balance of all cash drawers at the provided end date. */
  cashBalanceAtEnd: MoneyV2;
  /** The cumulative cash balance of all cash drawers at the provided start date. */
  cashBalanceAtStart: MoneyV2;
  /** The net cash flow during the specified period (start date to end date). Calculated as net sales plus adjustments. */
  netCash: MoneyV2;
  /** The number of sessions that were closed during the specified period (start date to end date). */
  sessionsClosed: Scalars['Int']['output'];
  /** The number of sessions that were opened during the specified period (start date to end date). */
  sessionsOpened: Scalars['Int']['output'];
  /** The total cash discrepancies during the specified period (start date to end date). */
  totalDiscrepancies: MoneyV2;
};

/** System reason code. */
export type CashManagementSystemReasonCode = Node & {
  __typename?: 'CashManagementSystemReasonCode';
  /** The code for the system reason code. */
  code: CashManagementSystemReasonCodeEnum;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** System reason codes for cash management. */
export enum CashManagementSystemReasonCodeEnum {
  /** Point of sale device payment session was automatically closed because the device switched to a different location. */
  AutoEndSessionLocationChange = 'AUTO_END_SESSION_LOCATION_CHANGE',
  /** Point of sale device payment session was automatically closed because a staff member logged out. */
  AutoEndSessionLogout = 'AUTO_END_SESSION_LOGOUT',
  /** Point of sale device payment session was automatically opened by a cash payment at checkout. */
  AutoStartSessionCheckout = 'AUTO_START_SESSION_CHECKOUT',
  /** Cash payout. */
  CashPayout = 'CASH_PAYOUT',
  /** Float setup. */
  FloatSetup = 'FLOAT_SETUP',
  /**
   * Other.
   * @deprecated Use CashManagementDefaultReasonCodeEnum.OTHER instead.
   */
  Other = 'OTHER'
}

/** The rounding adjustment applied to total payment or refund received for an Order involving cash payments. */
export type CashRoundingAdjustment = {
  __typename?: 'CashRoundingAdjustment';
  /** The rounding adjustment that can be applied to totalReceived for an Order involving cash payments in shop and presentment currencies. Could be a positive or negative value. Value is 0 if there's no rounding, or for non-cash payments. */
  paymentSet: MoneyBag;
  /** The rounding adjustment that can be applied to totalRefunded for an Order involving cash payments in shop and presentment currencies. Could be a positive or negative value. Value is 0 if there's no rounding, or for non-cash refunds. */
  refundSet: MoneyBag;
};

/** Tracks an adjustment to the cash in a cash tracking session for a point of sale device over the course of a shift. */
export type CashTrackingAdjustment = Node & {
  __typename?: 'CashTrackingAdjustment';
  /** The amount of cash being added or removed. */
  cash: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The note entered when the adjustment was made. */
  note?: Maybe<Scalars['String']['output']>;
  /** The staff member who made the adjustment. */
  staffMember: StaffMember;
  /** The time when the adjustment was made. */
  time: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CashTrackingAdjustments. */
export type CashTrackingAdjustmentConnection = {
  __typename?: 'CashTrackingAdjustmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CashTrackingAdjustmentEdge>;
  /** A list of nodes that are contained in CashTrackingAdjustmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CashTrackingAdjustment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CashTrackingAdjustment and a cursor during pagination. */
export type CashTrackingAdjustmentEdge = {
  __typename?: 'CashTrackingAdjustmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CashTrackingAdjustmentEdge. */
  node: CashTrackingAdjustment;
};

/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSession = Node & {
  __typename?: 'CashTrackingSession';
  /** The adjustments made to the cash drawer during this session. */
  adjustments: CashTrackingAdjustmentConnection;
  /** Whether this session is tracking cash payments. */
  cashTrackingEnabled: Scalars['Boolean']['output'];
  /** The cash transactions made during this session. */
  cashTransactions: OrderTransactionConnection;
  /** The counted cash balance when the session was closed. */
  closingBalance?: Maybe<MoneyV2>;
  /** The note entered when the session was closed. */
  closingNote?: Maybe<Scalars['String']['output']>;
  /** The user who closed the session. */
  closingStaffMember?: Maybe<StaffMember>;
  /** When the session was closed. */
  closingTime?: Maybe<Scalars['DateTime']['output']>;
  /** The expected balance at the end of the session or the expected current balance for sessions that are still open. */
  expectedBalance: MoneyV2;
  /** The amount that was expected to be in the cash drawer at the end of the session, calculated after the session was closed. */
  expectedClosingBalance?: Maybe<MoneyV2>;
  /** The amount expected to be in the cash drawer based on the previous session. */
  expectedOpeningBalance?: Maybe<MoneyV2>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location of the point of sale device during this session. */
  location?: Maybe<Location>;
  /** The net cash sales made for the duration of this cash tracking session. */
  netCashSales: MoneyV2;
  /** The counted cash balance when the session was opened. */
  openingBalance: MoneyV2;
  /** The note entered when the session was opened. */
  openingNote?: Maybe<Scalars['String']['output']>;
  /** The user who opened the session. */
  openingStaffMember?: Maybe<StaffMember>;
  /** When the session was opened. */
  openingTime: Scalars['DateTime']['output'];
  /** The register name for the point of sale device that this session is tracking cash for. */
  registerName: Scalars['String']['output'];
  /** The sum of all adjustments made during the session, excluding the final adjustment. */
  totalAdjustments?: Maybe<MoneyV2>;
  /** The sum of all cash refunds for the duration of this cash tracking session. */
  totalCashRefunds: MoneyV2;
  /** The sum of all cash sales for the duration of this cash tracking session. */
  totalCashSales: MoneyV2;
  /** The total discrepancy for the session including starting and ending. */
  totalDiscrepancy?: Maybe<MoneyV2>;
};


/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSessionAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AdjustmentsSortKeys>;
};


/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSessionCashTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CashTrackingSessionTransactionsSortKeys>;
};

/** An auto-generated type for paginating through multiple CashTrackingSessions. */
export type CashTrackingSessionConnection = {
  __typename?: 'CashTrackingSessionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CashTrackingSessionEdge>;
  /** A list of nodes that are contained in CashTrackingSessionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CashTrackingSession>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CashTrackingSession and a cursor during pagination. */
export type CashTrackingSessionEdge = {
  __typename?: 'CashTrackingSessionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CashTrackingSessionEdge. */
  node: CashTrackingSession;
};

/** The set of valid sort keys for the CashTrackingSessionTransactions query. */
export enum CashTrackingSessionTransactionsSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `processed_at` value. */
  ProcessedAt = 'PROCESSED_AT'
}

/** The set of valid sort keys for the CashTrackingSessions query. */
export enum CashTrackingSessionsSortKeys {
  /** Sort by the `closing_time_asc` value. */
  ClosingTimeAsc = 'CLOSING_TIME_ASC',
  /** Sort by the `closing_time_desc` value. */
  ClosingTimeDesc = 'CLOSING_TIME_DESC',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `opening_time_asc` value. */
  OpeningTimeAsc = 'OPENING_TIME_ASC',
  /** Sort by the `opening_time_desc` value. */
  OpeningTimeDesc = 'OPENING_TIME_DESC',
  /** Sort by the `total_discrepancy_asc` value. */
  TotalDiscrepancyAsc = 'TOTAL_DISCREPANCY_ASC',
  /** Sort by the `total_discrepancy_desc` value. */
  TotalDiscrepancyDesc = 'TOTAL_DISCREPANCY_DESC'
}

/** A cash transaction activity. */
export type CashTransactionActivity = CashActivity & {
  __typename?: 'CashTransactionActivity';
  /** The amount of cash added or removed as part of the activity. */
  cash: MoneyV2;
  /** The order transaction associated with the activity. */
  orderTransaction: OrderTransaction;
  /** The point of sale device payment session associated with the activity. */
  paymentSession: PointOfSaleDevicePaymentSession;
  /** The staff member who performed the activity. */
  staffMember: StaffMember;
  /** The time at which the activity occurred. */
  time: Scalars['DateTime']['output'];
  /** The type of transaction activity. */
  type: CashTransactionActivityType;
};

/** The type of transaction activity. */
export enum CashTransactionActivityType {
  /** Change given to a customer. */
  Change = 'CHANGE',
  /** A cash refund. */
  Refund = 'REFUND',
  /** A cash sale. */
  Sale = 'SALE'
}

/**
 * A list of products with publishing and pricing information.
 * A catalog can be associated with a specific context, such as a [`Market`](https://shopify.dev/api/admin-graphql/current/objects/market), [`CompanyLocation`](https://shopify.dev/api/admin-graphql/current/objects/companylocation), or [`App`](https://shopify.dev/api/admin-graphql/current/objects/app).
 *
 * Catalogs can optionally include a publication to control product visibility and a price list to customize pricing. When a publication isn't associated with a catalog, product availability is determined by the sales channel.
 */
export type Catalog = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Most recent catalog operations. */
  operations: Array<ResourceOperation>;
  /** The price list associated with the catalog. */
  priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  publication?: Maybe<Publication>;
  /** The status of the catalog. */
  status: CatalogStatus;
  /** The name of the catalog. */
  title: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple Catalogs. */
export type CatalogConnection = {
  __typename?: 'CatalogConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CatalogEdge>;
  /** A list of nodes that are contained in CatalogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Catalog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for the context in which the catalog's publishing and pricing rules apply. */
export type CatalogContextInput = {
  /** The IDs of the company locations to associate to the catalog. */
  companyLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the markets to associate to the catalog. */
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `catalogContextUpdate` mutation. */
export type CatalogContextUpdatePayload = {
  __typename?: 'CatalogContextUpdatePayload';
  /** The updated catalog. */
  catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CatalogUserError>;
};

/** The input fields required to create a catalog. */
export type CatalogCreateInput = {
  /** The context associated with the catalog. */
  context: CatalogContextInput;
  /** The ID of the price list to associate to the catalog. */
  priceListId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the publication to associate to the catalog. Only include this if you need to control which products are visible in the catalog. When omitted, product availability is determined by the sales channel. */
  publicationId?: InputMaybe<Scalars['ID']['input']>;
  /** The status of the catalog. */
  status: CatalogStatus;
  /** The name of the catalog. */
  title: Scalars['String']['input'];
};

/** Return type for `catalogCreate` mutation. */
export type CatalogCreatePayload = {
  __typename?: 'CatalogCreatePayload';
  /** The newly created catalog. */
  catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CatalogUserError>;
};

/** A catalog csv operation represents a CSV file import. */
export type CatalogCsvOperation = Node & ResourceOperation & {
  __typename?: 'CatalogCsvOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  processedRowCount?: Maybe<Scalars['Int']['output']>;
  /** Represents a rows objects within this background operation. */
  rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  status: ResourceOperationStatus;
};

/** Return type for `catalogDelete` mutation. */
export type CatalogDeletePayload = {
  __typename?: 'CatalogDeletePayload';
  /** The ID of the deleted catalog. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CatalogUserError>;
};

/** An auto-generated type which holds one Catalog and a cursor during pagination. */
export type CatalogEdge = {
  __typename?: 'CatalogEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CatalogEdge. */
  node: Catalog;
};

/** The set of valid sort keys for the Catalog query. */
export enum CatalogSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `type` value. */
  Type = 'TYPE'
}

/** The state of a catalog. */
export enum CatalogStatus {
  /** The catalog is active. */
  Active = 'ACTIVE',
  /** The catalog is archived. */
  Archived = 'ARCHIVED',
  /** The catalog is in draft. */
  Draft = 'DRAFT'
}

/** The associated catalog's type. */
export enum CatalogType {
  /** Catalogs belonging to apps. */
  App = 'APP',
  /** Catalogs belonging to company locations. */
  CompanyLocation = 'COMPANY_LOCATION',
  /** Catalogs belonging to markets. */
  Market = 'MARKET',
  /** Not associated to a catalog. */
  None = 'NONE'
}

/** The input fields used to update a catalog. */
export type CatalogUpdateInput = {
  /** The context associated with the catalog. */
  context?: InputMaybe<CatalogContextInput>;
  /** The ID of the price list to associate to the catalog. */
  priceListId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the publication to associate to the catalog. */
  publicationId?: InputMaybe<Scalars['ID']['input']>;
  /** The status of the catalog. */
  status?: InputMaybe<CatalogStatus>;
  /** The name of the catalog. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `catalogUpdate` mutation. */
export type CatalogUpdatePayload = {
  __typename?: 'CatalogUpdatePayload';
  /** The updated catalog. */
  catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CatalogUserError>;
};

/** Defines errors encountered while managing a catalog. */
export type CatalogUserError = DisplayableError & {
  __typename?: 'CatalogUserError';
  /** The error code. */
  code?: Maybe<CatalogUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CatalogUserError`. */
export enum CatalogUserErrorCode {
  /** An app catalog cannot be assigned to a price list. */
  AppCatalogPriceListAssignment = 'APP_CATALOG_PRICE_LIST_ASSIGNMENT',
  /** You've reached the maximum number of B2B catalogs allowed for your plan. */
  B2BCatalogLimitReached = 'B2B_CATALOG_LIMIT_REACHED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The catalog can't be associated with more than one market. */
  CannotAddMoreThanOneMarket = 'CANNOT_ADD_MORE_THAN_ONE_MARKET',
  /** Cannot create a catalog for an app. */
  CannotCreateAppCatalog = 'CANNOT_CREATE_APP_CATALOG',
  /** Cannot create a catalog for a market. */
  CannotCreateMarketCatalog = 'CANNOT_CREATE_MARKET_CATALOG',
  /** Cannot delete a catalog for an app. */
  CannotDeleteAppCatalog = 'CANNOT_DELETE_APP_CATALOG',
  /** Cannot delete a catalog for a market. */
  CannotDeleteMarketCatalog = 'CANNOT_DELETE_MARKET_CATALOG',
  /** Cannot modify a catalog for an app. */
  CannotModifyAppCatalog = 'CANNOT_MODIFY_APP_CATALOG',
  /** Cannot modify a catalog for a market. */
  CannotModifyMarketCatalog = 'CANNOT_MODIFY_MARKET_CATALOG',
  /** Quantity price breaks can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CatalogContextDoesNotSupportQuantityPriceBreaks = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS',
  /** Quantity rules can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CatalogContextDoesNotSupportQuantityRules = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** The catalog context is currently being modified. Please try again later. */
  CatalogContextLocked = 'CATALOG_CONTEXT_LOCKED',
  /** Catalog failed to save. */
  CatalogFailedToSave = 'CATALOG_FAILED_TO_SAVE',
  /** Catalogs and condition types are not compatible with each other. */
  CatalogNotCompatibleWithConditionTypes = 'CATALOG_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The catalog wasn't found. */
  CatalogNotFound = 'CATALOG_NOT_FOUND',
  /** A company location catalog outside of a supported plan can only have an archived status. */
  CompanyLocationCatalogStatusPlan = 'COMPANY_LOCATION_CATALOG_STATUS_PLAN',
  /** The company location could not be found. */
  CompanyLocationNotFound = 'COMPANY_LOCATION_NOT_FOUND',
  /** Context driver already assigned to this catalog. */
  ContextAlreadyAssignedToCatalog = 'CONTEXT_ALREADY_ASSIGNED_TO_CATALOG',
  /** Cannot save the catalog because the catalog limit for the context was reached. */
  ContextCatalogLimitReached = 'CONTEXT_CATALOG_LIMIT_REACHED',
  /** The arguments `contextsToAdd` and `contextsToRemove` must match existing catalog context type. */
  ContextDriverMismatch = 'CONTEXT_DRIVER_MISMATCH',
  /** A country catalog cannot be assigned to a price list. */
  CountryCatalogPriceListAssignment = 'COUNTRY_CATALOG_PRICE_LIST_ASSIGNMENT',
  /** A country price list cannot be assigned to a catalog. */
  CountryPriceListAssignment = 'COUNTRY_PRICE_LIST_ASSIGNMENT',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The catalog context type is invalid. */
  InvalidCatalogContextType = 'INVALID_CATALOG_CONTEXT_TYPE',
  /** Cannot change context to specified type. */
  InvalidContextChange = 'INVALID_CONTEXT_CHANGE',
  /** The managed country belongs to another catalog. */
  ManagedCountryBelongsToAnotherCatalog = 'MANAGED_COUNTRY_BELONGS_TO_ANOTHER_CATALOG',
  /** The catalog's market and price list currencies do not match. */
  MarketAndPriceListCurrencyMismatch = 'MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH',
  /** A market catalog must have an active status. */
  MarketCatalogStatus = 'MARKET_CATALOG_STATUS',
  /** Market not found. */
  MarketNotFound = 'MARKET_NOT_FOUND',
  /** Market already belongs to another catalog. */
  MarketTaken = 'MARKET_TAKEN',
  /** Must provide exactly one context type. */
  MustProvideExactlyOneContextType = 'MUST_PROVIDE_EXACTLY_ONE_CONTEXT_TYPE',
  /** Price list failed to save. */
  PriceListFailedToSave = 'PRICE_LIST_FAILED_TO_SAVE',
  /** The price list is currently being modified. Please try again later. */
  PriceListLocked = 'PRICE_LIST_LOCKED',
  /** A price list cannot be assigned to the primary market. */
  PriceListNotAllowedForPrimaryMarket = 'PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET',
  /** Price list not found. */
  PriceListNotFound = 'PRICE_LIST_NOT_FOUND',
  /** Publication not found. */
  PublicationNotFound = 'PUBLICATION_NOT_FOUND',
  /** Must have `contexts_to_add` or `contexts_to_remove` argument. */
  RequiresContextsToAddOrRemove = 'REQUIRES_CONTEXTS_TO_ADD_OR_REMOVE',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Catalogs assigned to company locations can't be set to active with your plan. */
  UnpermittedEntitlementsDirectCatalogAssignment = 'UNPERMITTED_ENTITLEMENTS_DIRECT_CATALOG_ASSIGNMENT',
  /** Managing this catalog is not supported by your plan. */
  UnpermittedEntitlementsMarketCatalogs = 'UNPERMITTED_ENTITLEMENTS_MARKET_CATALOGS',
  /** Can't perform this action on a catalog of this type. */
  UnsupportedCatalogAction = 'UNSUPPORTED_CATALOG_ACTION'
}

/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type Channel = Node & {
  __typename?: 'Channel';
  /** The unique account ID for the merchant on the external platform. This value is opaque to Shopify — its format is determined by the channel, such as an Amazon Seller ID or Google Merchant Center ID. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** The merchant-facing name for the external account. Displayed in Shopify Admin wherever the channel connection is referenced, such as in Markets and order attribution. */
  accountName?: Maybe<Scalars['String']['output']>;
  /** The regions where the channel is currently active, derived from the channel's active product feeds. Empty when the channel has no active product feeds. */
  activeRegions: Array<CountryCode>;
  /** The underlying app used by the channel. */
  app: App;
  /** The list of collection publications. Each record represents information about the publication of a collection. */
  collectionPublicationsV3: ResourcePublicationConnection;
  /** The list of collections published to the channel. */
  collections: CollectionConnection;
  /** A unique, human-readable identifier for the channel within the shop. Set during [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) or auto-generated from the specification handle and account ID. Use with [`channelByHandle`](https://shopify.dev/docs/api/admin-graphql/latest/queries/channelByHandle) for lookups. */
  handle: Scalars['String']['output'];
  /** Whether the collection is available to the channel. */
  hasCollection: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The markets associated with this channel. */
  markets?: Maybe<MarketConnection>;
  /** The number of markets associated with this channel. */
  marketsCount?: Maybe<Count>;
  /** The name of the channel. */
  name: Scalars['String']['output'];
  /**
   * The menu items for the channel, which also appear as submenu items in the left navigation sidebar in the Shopify admin.
   * @deprecated Use [AppInstallation.navigationItems](
   *           https://shopify.dev/api/admin-graphql/current/objects/AppInstallation#field-appinstallation-navigationitems) instead.
   */
  navigationItems: Array<NavigationItem>;
  /**
   * Home page for the channel.
   * @deprecated Use [AppInstallation.launchUrl](
   *           https://shopify.dev/api/admin-graphql/current/objects/AppInstallation#field-appinstallation-launchurl) instead.
   */
  overviewPath?: Maybe<Scalars['URL']['output']>;
  /**
   * The product publications for the products published to the channel.
   * @deprecated Use `productPublicationsV3` instead.
   */
  productPublications: ProductPublicationConnection;
  /** The list of product publication records for products published to this channel. */
  productPublicationsV3: ResourcePublicationConnection;
  /** The list of products published to the channel. */
  products: ProductConnection;
  /** Retrieves the total count of [`products`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) published to a specific sales channel. Limited to a maximum of 10000 by default. */
  productsCount?: Maybe<Count>;
  /** The resource feedback for the channel. Returns `null` when no active feedback exists—for example, after `shopResourceFeedbackCreate` is called with `state: ACCEPTED`, which clears the feedback signal. A `null` result is expected and means the channel has no outstanding feedback. */
  resourceFeedback?: Maybe<AppFeedback>;
  /** The handle of the [channel specification](https://shopify.dev/docs/apps/build/sales-channels/channel-config-extension) bound to this channel. The specification declares the channel's regional coverage, capabilities, and requirements, and is deployed by the Sales Channel application via `shopify app deploy`. */
  specificationHandle?: Maybe<Scalars['String']['output']>;
  /** Whether the channel supports future publishing. */
  supportsFuturePublishing: Scalars['Boolean']['output'];
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelCollectionPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelHasCollectionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelProductPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A connection between a Shopify shop and an external selling platform that supports product syndication and optionally order ingestion. Each channel binds a merchant's account on a specific platform — such as Amazon, eBay, Google, or a point-of-sale system — to the shop, establishing the publishing destination for product feeds.
 *
 * Sales Channel applications use [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) to establish channels after merchant authentication, and can manage multiple channel connections per app. Each channel is bound to a channel specification that declares the platform's regional coverage, capabilities, and requirements.
 *
 * Use channels to manage where catalog items are syndicated, track publication status across platforms, and control [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) visibility for different selling destinations.
 */
export type ChannelProductsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** An auto-generated type for paginating through multiple Channels. */
export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ChannelEdge>;
  /** A list of nodes that are contained in ChannelEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Channel>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). */
export type ChannelCreateInput = {
  /** A unique identifier for the merchant's account on the external platform, such as an Amazon Seller ID or Google Merchant Center ID. Used together with `specificationHandle` to uniquely identify the channel connection. */
  accountId: Scalars['String']['input'];
  /** The merchant-facing name for the external account. Displayed in Shopify Admin wherever the channel connection is referenced, such as in Markets and order attribution. Should match how the merchant recognises the account on the external platform. */
  accountName: Scalars['String']['input'];
  /** A unique, human-readable identifier for the channel within the shop. For example, `amazon-us-A1B2C3D4E5F6G7`. Used for lookups via [`channelByHandle`](https://shopify.dev/docs/api/admin-graphql/latest/queries/channelByHandle). If not provided, auto-generated from the specification handle and account ID. Must be unique across all channels on the shop. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The handle of the [channel specification](https://shopify.dev/docs/apps/build/sales-channels/channel-config-extension) to bind to this channel. The specification must have been deployed by the calling application via `shopify app deploy`. Determines the channel's regional coverage, capabilities, and requirements. */
  specificationHandle: Scalars['String']['input'];
};

/** Return type for `channelCreate` mutation. */
export type ChannelCreatePayload = {
  __typename?: 'ChannelCreatePayload';
  /** The channel that was created. */
  channel?: Maybe<Channel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ChannelCreateUserError>;
};

/** An error that occurs during the execution of `ChannelCreate`. */
export type ChannelCreateUserError = DisplayableError & {
  __typename?: 'ChannelCreateUserError';
  /** The error code. */
  code?: Maybe<ChannelCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ChannelCreateUserError`. */
export enum ChannelCreateUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/**
 * A specific selling surface within a [sales channel](https://shopify.dev/docs/apps/build/sales-channels) platform. A channel definition identifies where products can be sold. Definitions can represent entire platforms (like Facebook or TikTok) or specific sales channels within those platforms, such as Instagram Shops, Instagram Shopping, or TikTok Live.
 *
 * Each definition includes the parent [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) name and subchannel name to indicate the selling surface hierarchy.
 */
export type ChannelDefinition = Node & {
  __typename?: 'ChannelDefinition';
  /**
   * Name of the channel that this sub channel belongs to.
   * @deprecated Use [`OrderAttributionDefinition.displayName`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.displayName) instead.
   */
  channelName: Scalars['String']['output'];
  /**
   * Unique string used as a public identifier for the channel definition.
   * @deprecated Use [`OrderAttributionDefinition.handle`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.handle) instead.
   */
  handle: Scalars['String']['output'];
  /**
   * The unique ID for the channel definition.
   * @deprecated Use [`OrderAttributionDefinition.id`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.id) instead.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this channel definition represents a marketplace.
   * @deprecated Use [`OrderAttributionDefinition.handle`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.handle) instead.
   */
  isMarketplace: Scalars['Boolean']['output'];
  /**
   * Name of the sub channel (e.g. Online Store, Instagram Shopping, TikTok Live).
   * @deprecated Use [`OrderAttributionDefinition.displayName`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.displayName) instead.
   */
  subChannelName: Scalars['String']['output'];
  /**
   * Icon displayed when showing the channel in admin.
   * @deprecated Use [`OrderAttributionDefinition.icon`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttributionDefinition#field-OrderAttributionDefinition.fields.icon) instead.
   */
  svgIcon?: Maybe<Scalars['String']['output']>;
};

/** Return type for `channelDelete` mutation. */
export type ChannelDeletePayload = {
  __typename?: 'ChannelDeletePayload';
  /** The ID of the deleted channel. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ChannelDeleteUserError>;
};

/** An error that occurs during the execution of `ChannelDelete`. */
export type ChannelDeleteUserError = DisplayableError & {
  __typename?: 'ChannelDeleteUserError';
  /** The error code. */
  code?: Maybe<ChannelDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ChannelDeleteUserError`. */
export enum ChannelDeleteUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one Channel and a cursor during pagination. */
export type ChannelEdge = {
  __typename?: 'ChannelEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ChannelEdge. */
  node: Channel;
};

/** Return type for `channelFullSync` mutation. */
export type ChannelFullSyncPayload = {
  __typename?: 'ChannelFullSyncPayload';
  /** Trace information for each country-language product feed that was triggered. Returns one entry per feed. */
  fullSyncTraceInfo?: Maybe<Array<FullSyncTraceInfo>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ChannelFullSyncUserError>;
};

/** An error that occurs during the execution of `ChannelFullSync`. */
export type ChannelFullSyncUserError = DisplayableError & {
  __typename?: 'ChannelFullSyncUserError';
  /** The error code. */
  code?: Maybe<ChannelFullSyncUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ChannelFullSyncUserError`. */
export enum ChannelFullSyncUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/**
 * Identifies the [sales channel](https://shopify.dev/docs/apps/build/sales-channels) and [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) from which an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) originated. Provides attribution details such as the specific platform (Facebook Marketplace, Instagram Shopping) or marketplace where the order was placed.
 *
 * Links to the app that manages the channel and optional [`ChannelDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ChannelDefinition) details that specify the exact sub-channel or selling surface.
 */
export type ChannelInformation = Node & {
  __typename?: 'ChannelInformation';
  /**
   * The app associated with the channel.
   * @deprecated Use [`Order.attribution`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.attribution) for order attribution, or [`Order.app`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.app) and [`Order.publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.publication) for app and sales channel details.
   */
  app: App;
  /**
   * The channel definition associated with the channel.
   * @deprecated Use [`QueryRoot.orderAttributionDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/orderAttributionDefinitions) and select `id`, `handle`, `displayName`, and `icon` instead.
   */
  channelDefinition?: Maybe<ChannelDefinition>;
  /**
   * The unique ID for the channel.
   * @deprecated Use [`Order.attribution.handle`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttribution#field-OrderAttribution.fields.handle) instead.
   */
  channelId: Scalars['ID']['output'];
  /**
   * The publishing destination display name or channel name.
   * @deprecated Use [`Order.attribution.displayName`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttribution#field-OrderAttribution.fields.displayName) instead.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * A globally-unique ID.
   * @deprecated Use [`Order.attribution.handle`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttribution#field-OrderAttribution.fields.handle) instead.
   */
  id: Scalars['ID']['output'];
};

/** The input fields for updating a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). */
export type ChannelUpdateInput = {
  /** An updated identifier for the merchant's account on the external platform. Changing this value signals that the channel connection now represents a different external account. */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** An updated merchant-facing name for the external account. Displayed in Shopify Admin when multiple channels exist for the same app, to help merchants distinguish between connections. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** A new unique identifier for the channel within the shop. Must be unique across all channels on the shop. Handles are typically set at creation and rarely changed — use when correcting a handle or migrating legacy channel records. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The handle of the [channel specification](https://shopify.dev/docs/apps/build/sales-channels/channel-config-extension) to bind to this channel. When changed, the platform re-evaluates the specification's country coverage against the shop's region markets and reconciles product feeds accordingly. */
  specificationHandle?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `channelUpdate` mutation. */
export type ChannelUpdatePayload = {
  __typename?: 'ChannelUpdatePayload';
  /** The channel that was updated. */
  channel?: Maybe<Channel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ChannelUpdateUserError>;
};

/** An error that occurs during the execution of `ChannelUpdate`. */
export type ChannelUpdateUserError = DisplayableError & {
  __typename?: 'ChannelUpdateUserError';
  /** The error code. */
  code?: Maybe<ChannelUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ChannelUpdateUserError`. */
export enum ChannelUpdateUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** A condition checking the channel that the visitor is shopping from. */
export type ChannelsCondition = {
  __typename?: 'ChannelsCondition';
  /** The application level for the condition. */
  applicationLevel?: Maybe<MarketConditionApplicationType>;
  /** The channels that comprise the market. */
  channels: ChannelConnection;
  /** The total number of channels condition. */
  channelsCount?: Maybe<Count>;
};


/** A condition checking the channel that the visitor is shopping from. */
export type ChannelsConditionChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A checkout and account configuration packages branding settings, UI extensions, and overrides for a shop's checkout. */
export type CheckoutAndAccountsConfiguration = CheckoutAndAccountsConfigurationInterface & Node & {
  __typename?: 'CheckoutAndAccountsConfiguration';
  /** The branding configuration. */
  branding?: Maybe<CheckoutAndAccountsConfigurationBranding>;
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the configuration was last edited. */
  editedAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the configuration is published or not. */
  isPublished: Scalars['Boolean']['output'];
  /** The configuration name. */
  name: Scalars['String']['output'];
  /** The list of overrides for the configuration. */
  overrides: Array<CheckoutAndAccountsConfigurationOverride>;
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The branding configuration for checkout and customer accounts. */
export type CheckoutAndAccountsConfigurationBranding = {
  __typename?: 'CheckoutAndAccountsConfigurationBranding';
  /** The components that apply to all surfaces. */
  components?: Maybe<CheckoutAndAccountsConfigurationBrandingComponents>;
  /** The design tokens allow you to set values that represent specific attributes of your brand like color and font. These attributes are used throughout the user interface. This brings consistency and allows you to easily make broad design changes. */
  designTokens?: Maybe<CheckoutAndAccountsConfigurationBrandingDesignTokens>;
  /** The surface-specific customizations. */
  surfaces?: Maybe<CheckoutAndAccountsConfigurationBrandingSurfaces>;
};

/** The container background style. */
export enum CheckoutAndAccountsConfigurationBrandingBackground {
  /** The Base background style. */
  Base = 'BASE',
  /** The Subdued background style. */
  Subdued = 'SUBDUED'
}

/** The base color role customizations for a surface. */
export type CheckoutAndAccountsConfigurationBrandingBaseColorRoles = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingBaseColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing a base group of colors. */
export type CheckoutAndAccountsConfigurationBrandingBaseColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Possible values for the border. */
export enum CheckoutAndAccountsConfigurationBrandingBorder {
  /** The Block End border. */
  BlockEnd = 'BLOCK_END',
  /** The Full border. */
  Full = 'FULL',
  /** The None border. */
  None = 'NONE'
}

/** The container border style. */
export enum CheckoutAndAccountsConfigurationBrandingBorderStyle {
  /** The Base border style. */
  Base = 'BASE',
  /** The Dashed border style. */
  Dashed = 'DASHED',
  /** The Dotted border style. */
  Dotted = 'DOTTED'
}

/** The container border width. */
export enum CheckoutAndAccountsConfigurationBrandingBorderWidth {
  /** The Base border width. */
  Base = 'BASE',
  /** The Large border width. */
  Large = 'LARGE',
  /** The Large 100 border width. */
  Large_100 = 'LARGE_100',
  /** The Large 200 border width. */
  Large_200 = 'LARGE_200'
}

/** The buttons customizations. */
export type CheckoutAndAccountsConfigurationBrandingButton = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingButton';
  /** The block padding. */
  blockPadding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacing>;
  /** The border. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The inline padding. */
  inlinePadding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacing>;
  /** The typography. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyStyle>;
};

/** The input fields for customizing the buttons. */
export type CheckoutAndAccountsConfigurationBrandingButtonInput = {
  /** The block padding. */
  blockPadding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacing>;
  /** The border. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The inline padding. */
  inlinePadding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacing>;
  /** The typography style. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyStyleInput>;
};

/** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
export type CheckoutAndAccountsConfigurationBrandingBuyerJourney = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingBuyerJourney';
  /** An option to display or hide the breadcrumbs that represent the buyer's journey on 3-page checkout. */
  visibility?: Maybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The input fields for updating breadcrumb customizations, which represent the buyer's journey to checkout. */
export type CheckoutAndAccountsConfigurationBrandingBuyerJourneyInput = {
  /** The visibility customizations for updating breadcrumbs, which represent the buyer's journey to checkout. */
  visibility?: InputMaybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The customizations that you can make to cart links at checkout. */
export type CheckoutAndAccountsConfigurationBrandingCartLink = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCartLink';
  /** Whether the cart link is visible at checkout. */
  visibility?: Maybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** Possible values for the cart link content type for the header. */
export enum CheckoutAndAccountsConfigurationBrandingCartLinkContentType {
  /** The checkout header content type icon value. */
  Icon = 'ICON',
  /** The checkout header content type image value. */
  Image = 'IMAGE',
  /** The checkout header content type text value. */
  Text = 'TEXT'
}

/** The input fields for customizing the cart link at Checkout. */
export type CheckoutAndAccountsConfigurationBrandingCartLinkInput = {
  /** The input to update the visibility of cart links in checkout. This hides the cart icon on one-page and the cart link in the breadcrumbs/buyer journey on three-page checkout. */
  visibility?: InputMaybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The checkboxes customizations. */
export type CheckoutAndAccountsConfigurationBrandingCheckbox = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCheckbox';
  /** The corner radius. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
};

/** The input fields for customizing the checkboxes. */
export type CheckoutAndAccountsConfigurationBrandingCheckboxInput = {
  /** The corner radius. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
};

/** The checkout-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutComponents = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCheckoutComponents';
  /** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
  buyerJourney?: Maybe<CheckoutAndAccountsConfigurationBrandingBuyerJourney>;
  /** The checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  cartLink?: Maybe<CheckoutAndAccountsConfigurationBrandingCartLink>;
  /** The content container customizations. */
  content?: Maybe<CheckoutAndAccountsConfigurationBrandingContent>;
  /** The express checkout customizations. */
  expressCheckout?: Maybe<CheckoutAndAccountsConfigurationBrandingExpressCheckout>;
  /** The checkout footer customizations. */
  footer?: Maybe<CheckoutAndAccountsConfigurationBrandingCheckoutFooter>;
  /** The checkout header customizations. */
  header?: Maybe<CheckoutAndAccountsConfigurationBrandingCheckoutHeader>;
  /** The main checkout customizations. */
  main?: Maybe<CheckoutAndAccountsConfigurationBrandingMain>;
  /** The order summary customizations. */
  orderSummary?: Maybe<CheckoutAndAccountsConfigurationBrandingOrderSummary>;
};

/** The input fields for customizing the Checkout components. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutComponentsInput = {
  /** The breadcrumbs that represent a buyer's journey to the checkout. */
  buyerJourney?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBuyerJourneyInput>;
  /** The input for checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  cartLink?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCartLinkInput>;
  /** The content container. */
  content?: InputMaybe<CheckoutAndAccountsConfigurationBrandingContentInput>;
  /** The express checkout. */
  expressCheckout?: InputMaybe<CheckoutAndAccountsConfigurationBrandingExpressCheckoutInput>;
  /** The footer. */
  footer?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCheckoutFooterInput>;
  /** The header. */
  header?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCheckoutHeaderInput>;
  /** The main area. */
  main?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMainInput>;
  /** The order summary. */
  orderSummary?: InputMaybe<CheckoutAndAccountsConfigurationBrandingOrderSummaryInput>;
};

/** A container for the checkout footer section customizations. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutFooter = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCheckoutFooter';
  /** The footer alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The background style of the footer container. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The footer content settings. */
  content?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterContent>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The padding of the footer container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The footer position. */
  position?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterPosition>;
};

/** The input fields for customizing the checkout footer. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutFooterInput = {
  /** The footer alignment settings. You can set the footer native content alignment to the left, center, or right. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The background style of the footer container. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The input field for setting the footer content customizations. */
  content?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterContentInput>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The padding of the footer container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The footer position. */
  position?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterPosition>;
};

/** The checkout header customizations. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutHeader = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCheckoutHeader';
  /** The header alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The background style of the header container. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  cartLink?: Maybe<CheckoutAndAccountsConfigurationBrandingHeaderCartLink>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The store logo. */
  logo?: Maybe<CheckoutAndAccountsConfigurationBrandingLogo>;
  /** The padding of the header container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The header position. */
  position?: Maybe<CheckoutAndAccountsConfigurationBrandingHeaderPosition>;
};

/** The input fields for customizing the checkout header. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutHeaderInput = {
  /** The header alignment. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The background style of the header container. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The input for cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  cartLink?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderCartLinkInput>;
  /** The colors customizations for the header container. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The store logo. */
  logo?: InputMaybe<CheckoutAndAccountsConfigurationBrandingLogoInput>;
  /** The padding of the header container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The header position. */
  position?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderPosition>;
};

/** The checkout-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutSurface = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCheckoutSurface';
  /** The checkout components. */
  components?: Maybe<CheckoutAndAccountsConfigurationBrandingCheckoutComponents>;
};

/** The input fields for customizing the Checkout surface. */
export type CheckoutAndAccountsConfigurationBrandingCheckoutSurfaceInput = {
  /** The Checkout components. */
  components?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCheckoutComponentsInput>;
};

/** The choice list customizations. */
export type CheckoutAndAccountsConfigurationBrandingChoiceList = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingChoiceList';
  /** The 'group' variant of ChoiceList. */
  group?: Maybe<CheckoutAndAccountsConfigurationBrandingChoiceListGroup>;
};

/** The customizations that apply to the 'group' variant of ChoiceList. */
export type CheckoutAndAccountsConfigurationBrandingChoiceListGroup = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingChoiceListGroup';
  /** The spacing between UI elements in the list. */
  spacing?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The input fields for customizing the 'group' variant of ChoiceList. */
export type CheckoutAndAccountsConfigurationBrandingChoiceListGroupInput = {
  /** The spacing between UI elements in the list. */
  spacing?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The input fields for customizing the choice list. */
export type CheckoutAndAccountsConfigurationBrandingChoiceListInput = {
  /** The 'group' variant of ChoiceList. */
  group?: InputMaybe<CheckoutAndAccountsConfigurationBrandingChoiceListGroupInput>;
};

/** The color role customizations for a surface. */
export type CheckoutAndAccountsConfigurationBrandingColorRoles = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing a group of colors used together on a surface. */
export type CheckoutAndAccountsConfigurationBrandingColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The color settings used to customize the user interface. */
export type CheckoutAndAccountsConfigurationBrandingColors = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingColors';
  /** The main colors, used for the surface background, text, links, and more. */
  base?: Maybe<CheckoutAndAccountsConfigurationBrandingBaseColorRoles>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  control?: Maybe<CheckoutAndAccountsConfigurationBrandingControlColorRoles>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  primaryButton?: Maybe<CheckoutAndAccountsConfigurationBrandingPrimaryButtonColorRoles>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  secondaryButton?: Maybe<CheckoutAndAccountsConfigurationBrandingSecondaryButtonColorRoles>;
};

/** The input fields for customizing a base set of colors, from which every component pulls its colors. */
export type CheckoutAndAccountsConfigurationBrandingColorsInput = {
  /** The main colors, used for the surface background, text, links, and more. */
  base?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBaseColorRolesInput>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  control?: InputMaybe<CheckoutAndAccountsConfigurationBrandingControlColorRolesInput>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  primaryButton?: InputMaybe<CheckoutAndAccountsConfigurationBrandingPrimaryButtonColorRolesInput>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  secondaryButton?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSecondaryButtonColorRolesInput>;
};

/** The base component customizations that apply to all surfaces. */
export type CheckoutAndAccountsConfigurationBrandingComponents = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingComponents';
  /** The checkboxes. */
  checkbox?: Maybe<CheckoutAndAccountsConfigurationBrandingCheckbox>;
  /** The choice list. */
  choiceList?: Maybe<CheckoutAndAccountsConfigurationBrandingChoiceList>;
  /** The form controls. */
  control?: Maybe<CheckoutAndAccountsConfigurationBrandingControl>;
  /** The customizations for the page, content, main, and order summary dividers. For example, by setting the borderStyle to `DOTTED`, you can make these dividers render as dotted lines. */
  divider?: Maybe<CheckoutAndAccountsConfigurationBrandingDividerStyle>;
  /** The favicon. */
  favicon?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The footer. */
  footer?: Maybe<CheckoutAndAccountsConfigurationBrandingFooter>;
  /** The header. */
  header?: Maybe<CheckoutAndAccountsConfigurationBrandingHeader>;
  /** The Heading Level 1. */
  headingLevel1?: Maybe<CheckoutAndAccountsConfigurationBrandingHeadingLevel>;
  /** The Heading Level 2. */
  headingLevel2?: Maybe<CheckoutAndAccountsConfigurationBrandingHeadingLevel>;
  /** The Heading Level 3. */
  headingLevel3?: Maybe<CheckoutAndAccountsConfigurationBrandingHeadingLevel>;
  /** The main area. */
  main?: Maybe<CheckoutAndAccountsConfigurationBrandingMain>;
  /** The merchandise thumbnails. */
  merchandiseThumbnail?: Maybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnail>;
  /** The primary buttons. */
  primaryButton?: Maybe<CheckoutAndAccountsConfigurationBrandingButton>;
  /** The secondary buttons. */
  secondaryButton?: Maybe<CheckoutAndAccountsConfigurationBrandingButton>;
  /** The selects. */
  select?: Maybe<CheckoutAndAccountsConfigurationBrandingSelect>;
  /** The shared settings. */
  shared?: Maybe<CheckoutAndAccountsConfigurationBrandingShared>;
  /** The text fields. */
  textField?: Maybe<CheckoutAndAccountsConfigurationBrandingTextField>;
};

/** The input fields for customizing the components. */
export type CheckoutAndAccountsConfigurationBrandingComponentsInput = {
  /** The checkboxes customizations. */
  checkbox?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCheckboxInput>;
  /** The choice list customizations. */
  choiceList?: InputMaybe<CheckoutAndAccountsConfigurationBrandingChoiceListInput>;
  /** The form controls customizations. */
  control?: InputMaybe<CheckoutAndAccountsConfigurationBrandingControlInput>;
  /** The divider customizations. */
  divider?: InputMaybe<CheckoutAndAccountsConfigurationBrandingDividerStyleInput>;
  /** The favicon. */
  favicon?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The footer customizations. */
  footer?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterInput>;
  /** The header customizations. */
  header?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderInput>;
  /** The Heading Level 1 customizations. */
  headingLevel1?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeadingLevelInput>;
  /** The Heading Level 2 customizations. */
  headingLevel2?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeadingLevelInput>;
  /** The Heading Level 3 customizations. */
  headingLevel3?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeadingLevelInput>;
  /** The main area customizations. */
  main?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMainInput>;
  /** The merchandise thumbnails customizations. */
  merchandiseThumbnail?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailInput>;
  /** The primary buttons customizations. */
  primaryButton?: InputMaybe<CheckoutAndAccountsConfigurationBrandingButtonInput>;
  /** The secondary buttons customizations. */
  secondaryButton?: InputMaybe<CheckoutAndAccountsConfigurationBrandingButtonInput>;
  /** The selects customizations. */
  select?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSelectInput>;
  /** The shared customizations. */
  shared?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSharedInput>;
  /** The text fields customizations. */
  textField?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTextFieldInput>;
};

/** The container's divider customizations. */
export type CheckoutAndAccountsConfigurationBrandingContainerDivider = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingContainerDivider';
  /** The divider style. */
  borderStyle?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The divider width. */
  borderWidth?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The divider visibility. */
  visibility?: Maybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The input fields for customizing a container's divider. */
export type CheckoutAndAccountsConfigurationBrandingContainerDividerInput = {
  /** The divider style. */
  borderStyle?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The divider width. */
  borderWidth?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The divider visibility. */
  visibility?: InputMaybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The content customizations. */
export type CheckoutAndAccountsConfigurationBrandingContent = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingContent';
  /** The divider style and visibility. */
  divider?: Maybe<CheckoutAndAccountsConfigurationBrandingContainerDivider>;
};

/** The input fields for customizing the content container. */
export type CheckoutAndAccountsConfigurationBrandingContentInput = {
  /** Divider style and visibility on the content container. */
  divider?: InputMaybe<CheckoutAndAccountsConfigurationBrandingContainerDividerInput>;
};

/** The form controls customizations. */
export type CheckoutAndAccountsConfigurationBrandingControl = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingControl';
  /** The border. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The label position. */
  labelPosition?: Maybe<CheckoutAndAccountsConfigurationBrandingLabelPosition>;
};

/** The form control color customizations. */
export type CheckoutAndAccountsConfigurationBrandingControlColorRoles = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingControlColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The colors of selected controls. */
  selected?: Maybe<CheckoutAndAccountsConfigurationBrandingColorRoles>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing colors for form controls. */
export type CheckoutAndAccountsConfigurationBrandingControlColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The colors of selected controls. */
  selected?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorRolesInput>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for customizing the form controls. */
export type CheckoutAndAccountsConfigurationBrandingControlInput = {
  /** The border. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The label position. */
  labelPosition?: InputMaybe<CheckoutAndAccountsConfigurationBrandingLabelPosition>;
};

/** The options for customizing the corner radius of checkout-related objects. Examples include the primary button, the name text fields and the sections within the main area (if they have borders). */
export enum CheckoutAndAccountsConfigurationBrandingCornerRadius {
  /** The corner radius with a pixel value defined by designTokens.cornerRadius.base. */
  Base = 'BASE',
  /** The corner radius with a pixel value defined by designTokens.cornerRadius.large. */
  Large = 'LARGE',
  /** The 0px corner radius (square corners). */
  None = 'NONE',
  /** The corner radius with a pixel value defined by designTokens.cornerRadius.small. */
  Small = 'SMALL'
}

/** The corner radius variable customizations that define the pixel size of corner radius options. */
export type CheckoutAndAccountsConfigurationBrandingCornerRadiusVariables = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCornerRadiusVariables';
  /** The value in pixels for base corner radii. Example: 5. */
  base?: Maybe<Scalars['Int']['output']>;
  /** The value in pixels for large corner radii. Example: 10. */
  large?: Maybe<Scalars['Int']['output']>;
  /** The value in pixels for small corner radii. Example: 3. */
  small?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for customizing the corner radius variables. */
export type CheckoutAndAccountsConfigurationBrandingCornerRadiusVariablesInput = {
  /** The value in pixels for base corner radii. It should be greater than zero. Example: 5. */
  base?: InputMaybe<Scalars['Int']['input']>;
  /** The value in pixels for large corner radii. It should be greater than zero. Example: 10. */
  large?: InputMaybe<Scalars['Int']['input']>;
  /** The value in pixels for small corner radii. It should be greater than zero. Example: 3. */
  small?: InputMaybe<Scalars['Int']['input']>;
};

/** The custom font customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomFont = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomFont';
  /** Globally unique ID reference to the custom font file. */
  genericFileId?: Maybe<Scalars['ID']['output']>;
  /** The font sources. */
  sources?: Maybe<Scalars['String']['output']>;
  /** The font weight. */
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The custom font group customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomFontGroup = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomFontGroup';
  /** The base custom font. */
  base?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomFont>;
  /** The bold custom font. */
  bold?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomFont>;
  /** The font loading strategy. */
  loadingStrategy?: Maybe<CheckoutAndAccountsConfigurationBrandingFontLoadingStrategy>;
  /** The font group name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing a custom font group. */
export type CheckoutAndAccountsConfigurationBrandingCustomFontGroupInput = {
  /** The base font. */
  base: CheckoutAndAccountsConfigurationBrandingCustomFontInput;
  /** The bold font. */
  bold: CheckoutAndAccountsConfigurationBrandingCustomFontInput;
  /** The font loading strategy. */
  loadingStrategy?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFontLoadingStrategy>;
};

/** The input fields for customizing a custom font. */
export type CheckoutAndAccountsConfigurationBrandingCustomFontInput = {
  /** A globally-unique ID for a font file uploaded via the Files api. Allowed font types are .woff and .woff2. */
  genericFileId: Scalars['ID']['input'];
  /** The font weight. Its value should be between 100 and 900. */
  weight: Scalars['Int']['input'];
};

/** The customer accounts-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsComponents = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsComponents';
  /** The footer customizations. */
  footer?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsFooter>;
  /** The header customizations. */
  header?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsHeader>;
  /** The main customer accounts customizations. */
  main?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsMain>;
};

/** The input fields for customizing the Customer Accounts components. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsComponentsInput = {
  /** The footer customizations. */
  footer?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsFooterInput>;
  /** The header customizations. */
  header?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsHeaderInput>;
  /** The main area customizations. */
  main?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainInput>;
};

/** A container for the customer accounts footer section customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsFooter = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsFooter';
  /** The footer alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The padding of the footer container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The input fields for customizing the customer accounts footer. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsFooterInput = {
  /** The footer alignment settings. You can set the footer native content alignment to the left, center, or right. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The padding of the footer container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The checkout header customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsHeader = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsHeader';
  /** The header alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The store logo. */
  logo?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsLogo>;
  /** The padding of the header container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The input fields for customizing the customer accounts header. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsHeaderInput = {
  /** The header alignment. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The colors customizations for the header container. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The store logo. */
  logo?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsLogoInput>;
  /** The padding of the header container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The customer accounts store logo customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsLogo = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsLogo';
  /** The logo image. */
  image?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The maximum width of the logo. */
  maxWidth?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for customizing the logo. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsLogoInput = {
  /** The logo image. */
  image?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The maximum width of the logo. */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** The customer accounts-specific main customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsMain = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsMain';
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The customer accounts main section. */
  section?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainSection>;
};

/** The input fields for customizing the main container. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainInput = {
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The customizations for the main sections. */
  section?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainSectionInput>;
};

/** The customer accounts branding section customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainSection = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainSection';
  /** The background style of the main sections. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the main sections. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The corner radius of the main sections. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: Maybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** The input fields for customizing the customer accounts branding section. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsMainSectionInput = {
  /** The background style of the main sections. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the main sections. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The corner radius of the main sections. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: InputMaybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** The customer accounts-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsSurface = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingCustomerAccountsSurface';
  /** The customer accounts components. */
  components?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsComponents>;
};

/** The input fields for customizing the Customer Accounts surface. */
export type CheckoutAndAccountsConfigurationBrandingCustomerAccountsSurfaceInput = {
  /** The Customer Accounts components. */
  components?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsComponentsInput>;
};

/** The color customizations. */
export type CheckoutAndAccountsConfigurationBrandingDesignTokenColors = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingDesignTokenColors';
  /** A set of colors used together on a surface. */
  palette?: Maybe<CheckoutAndAccountsConfigurationBrandingPalette>;
};

/** The design token customizations allow you to set values that represent specific attributes of your brand like color and font. These attributes are used throughout the user interface. This brings consistency and allows you to easily make broad design changes. */
export type CheckoutAndAccountsConfigurationBrandingDesignTokens = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingDesignTokens';
  /** The colors for global colors. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingDesignTokenColors>;
  /** The corner radius variables. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadiusVariables>;
  /** The typography. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingTypography>;
};

/** The input fields for customizing the colors. */
export type CheckoutAndAccountsConfigurationBrandingDesignTokensColorsInput = {
  /** The input to update the color palette. */
  palette?: InputMaybe<CheckoutAndAccountsConfigurationBrandingPaletteInput>;
};

/** The input fields for customizing the design tokens. */
export type CheckoutAndAccountsConfigurationBrandingDesignTokensInput = {
  /** The color customizations for global colors. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingDesignTokensColorsInput>;
  /** The corner radius variables. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadiusVariablesInput>;
  /** The typography. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyInput>;
};

/** The customizations for the page, content, main, and order summary dividers. */
export type CheckoutAndAccountsConfigurationBrandingDividerStyle = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingDividerStyle';
  /** The border style for the divider. */
  borderStyle?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width for the divider. */
  borderWidth?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
};

/** The input fields for customizing the global divider. */
export type CheckoutAndAccountsConfigurationBrandingDividerStyleInput = {
  /** The border style for the divider. */
  borderStyle?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width for the divider. */
  borderWidth?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
};

/** The Express Checkout customizations. */
export type CheckoutAndAccountsConfigurationBrandingExpressCheckout = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingExpressCheckout';
  /** The Express Checkout buttons customizations. */
  button?: Maybe<CheckoutAndAccountsConfigurationBrandingExpressCheckoutButton>;
};

/** The Express Checkout button customizations. */
export type CheckoutAndAccountsConfigurationBrandingExpressCheckoutButton = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingExpressCheckoutButton';
  /** The corner radius. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
};

/** The input fields for customizing the express checkout button. */
export type CheckoutAndAccountsConfigurationBrandingExpressCheckoutButtonInput = {
  /** The corner radius. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
};

/** The input fields for customizing the Express Checkout. */
export type CheckoutAndAccountsConfigurationBrandingExpressCheckoutInput = {
  /** The Express Checkout buttons customizations. */
  button?: InputMaybe<CheckoutAndAccountsConfigurationBrandingExpressCheckoutButtonInput>;
};

/** A group of fonts. */
export type CheckoutAndAccountsConfigurationBrandingFontGroup = CheckoutAndAccountsConfigurationBrandingCustomFontGroup | CheckoutAndAccountsConfigurationBrandingShopifyFontGroup;

/** The input fields used to update a font group. */
export type CheckoutAndAccountsConfigurationBrandingFontGroupInput = {
  /** A custom font group. */
  customFontGroup?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomFontGroupInput>;
  /** A Shopify font group. */
  shopifyFontGroup?: InputMaybe<CheckoutAndAccountsConfigurationBrandingShopifyFontGroupInput>;
};

/** The font loading strategy determines how a font face is displayed after it is loaded or failed to load. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display. */
export enum CheckoutAndAccountsConfigurationBrandingFontLoadingStrategy {
  /** The font display strategy is defined by the browser user agent. */
  Auto = 'AUTO',
  /** Gives the font face a short block period and an infinite swap period. */
  Block = 'BLOCK',
  /** Gives the font face an extremely small block period and a short swap period. */
  Fallback = 'FALLBACK',
  /** Gives the font face an extremely small block period and no swap period. */
  Optional = 'OPTIONAL',
  /** Gives the font face an extremely small block period and an infinite swap period. */
  Swap = 'SWAP'
}

/** The font size customizations. */
export type CheckoutAndAccountsConfigurationBrandingFontSize = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingFontSize';
  /** The base font size. */
  base?: Maybe<Scalars['Float']['output']>;
  /** The scale ratio used to derive all font sizes such as small and large. */
  ratio?: Maybe<Scalars['Float']['output']>;
};

/** The input fields for customizing the font size. */
export type CheckoutAndAccountsConfigurationBrandingFontSizeInput = {
  /** The base font size. Its value should be between 12.0 and 18.0. */
  base?: InputMaybe<Scalars['Float']['input']>;
  /** The scale ratio used to derive all font sizes such as small and large. Its value should be between 1.0 and 1.4. */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

/** A container for the footer section customizations. */
export type CheckoutAndAccountsConfigurationBrandingFooter = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingFooter';
  /** The footer alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The background style of the footer container. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The footer content settings. */
  content?: Maybe<CheckoutAndAccountsConfigurationBrandingFooterContent>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The padding of the footer container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** Possible values for the footer alignment. */
export enum CheckoutAndAccountsConfigurationBrandingFooterAlignment {
  /** The checkout footer alignment Center value. */
  Center = 'CENTER',
  /** The checkout footer alignment End value. */
  End = 'END',
  /** The checkout footer alignment Start value. */
  Start = 'START'
}

/** The footer content customizations. */
export type CheckoutAndAccountsConfigurationBrandingFooterContent = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingFooterContent';
  /** The visibility of the footer content. Shopify reserves the right to add required legal notices to the footer and prevent them from being modified or hidden. This setting doesn't control the visibility of those notices. */
  visibility?: Maybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The input fields for customizing the footer content. */
export type CheckoutAndAccountsConfigurationBrandingFooterContentInput = {
  /** The visibility of the footer content. Shopify reserves the right to add required legal notices to the footer and prevent them from being modified or hidden. This setting doesn't control the visibility of those notices. */
  visibility?: InputMaybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The input fields for customizing the checkout footer. */
export type CheckoutAndAccountsConfigurationBrandingFooterInput = {
  /** The footer alignment settings. You can set the footer native content alignment to the left, center, or right. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterAlignment>;
  /** The background style of the footer container. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The input field for setting the footer content customizations. */
  content?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFooterContentInput>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The padding of the footer container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** Possible values for the footer position. */
export enum CheckoutAndAccountsConfigurationBrandingFooterPosition {
  /** The End footer position. */
  End = 'END',
  /** The Inline footer position. */
  Inline = 'INLINE'
}

/** The header customizations. */
export type CheckoutAndAccountsConfigurationBrandingHeader = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingHeader';
  /** The header alignment. */
  alignment?: Maybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The background style of the header container. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The store logo. */
  logo?: Maybe<CheckoutAndAccountsConfigurationBrandingLogo>;
  /** The padding of the header container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The possible header alignments. */
export enum CheckoutAndAccountsConfigurationBrandingHeaderAlignment {
  /** Center alignment. */
  Center = 'CENTER',
  /** End alignment. */
  End = 'END',
  /** Start alignment. */
  Start = 'START'
}

/** The header cart link customizations. */
export type CheckoutAndAccountsConfigurationBrandingHeaderCartLink = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingHeaderCartLink';
  /** The content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  contentType?: Maybe<CheckoutAndAccountsConfigurationBrandingCartLinkContentType>;
  /** The image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  image?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
};

/** The input fields for customizing the cart link for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
export type CheckoutAndAccountsConfigurationBrandingHeaderCartLinkInput = {
  /** The input for the content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  contentType?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCartLinkContentType>;
  /** The input for the image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  image?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
};

/** The input fields for customizing the header. */
export type CheckoutAndAccountsConfigurationBrandingHeaderInput = {
  /** The header alignment. */
  alignment?: InputMaybe<CheckoutAndAccountsConfigurationBrandingHeaderAlignment>;
  /** The background style of the header container. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The colors customizations for the header container. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The store logo. */
  logo?: InputMaybe<CheckoutAndAccountsConfigurationBrandingLogoInput>;
  /** The padding of the header container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The possible header positions. */
export enum CheckoutAndAccountsConfigurationBrandingHeaderPosition {
  /** Inline position. */
  Inline = 'INLINE',
  /** Secondary inline position. */
  InlineSecondary = 'INLINE_SECONDARY',
  /** Start position. */
  Start = 'START'
}

/** The heading level customizations. */
export type CheckoutAndAccountsConfigurationBrandingHeadingLevel = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingHeadingLevel';
  /** The typography. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyStyle>;
};

/** The input fields for customizing the heading level. */
export type CheckoutAndAccountsConfigurationBrandingHeadingLevelInput = {
  /** The typography. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyStyleInput>;
};

/** The image. */
export type CheckoutAndAccountsConfigurationBrandingImage = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingImage';
  /** The image details. */
  image?: Maybe<Image>;
};

/** The input fields for customizing the image. */
export type CheckoutAndAccountsConfigurationBrandingImageInput = {
  /** A globally-unique ID. */
  mediaImageId?: InputMaybe<Scalars['ID']['input']>;
};

/** The image value. */
export type CheckoutAndAccountsConfigurationBrandingImageValue = CheckoutAndAccountsConfigurationBrandingImage;

/** The input fields for customizing Checkout and Customer Accounts branding. */
export type CheckoutAndAccountsConfigurationBrandingInput = {
  /** The customizations that apply to specific components or areas of the user interface. */
  components?: InputMaybe<CheckoutAndAccountsConfigurationBrandingComponentsInput>;
  /** The design tokens allows you to set values that represent specific attributes of your brand like color and font. These attributes are used throughout the user interface. This brings consistency and allows you to easily make broad design changes. */
  designTokens?: InputMaybe<CheckoutAndAccountsConfigurationBrandingDesignTokensInput>;
  /** The surface-level customizations. */
  surfaces?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSurfacesInput>;
};

/** The label position options. */
export enum CheckoutAndAccountsConfigurationBrandingLabelPosition {
  /** The Inside label position. */
  Inside = 'INSIDE',
  /** The Outside label position. */
  Outside = 'OUTSIDE'
}

/** The store logo customizations. */
export type CheckoutAndAccountsConfigurationBrandingLogo = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingLogo';
  /** The logo image. */
  image?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The maximum width of the logo. */
  maxWidth?: Maybe<Scalars['Int']['output']>;
  /** The visibility of the logo. */
  visibility?: Maybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The input fields for customizing the logo. */
export type CheckoutAndAccountsConfigurationBrandingLogoInput = {
  /** The logo image. */
  image?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The maximum width of the logo. */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  /** The visibility of the logo. */
  visibility?: InputMaybe<CheckoutAndAccountsConfigurationBrandingVisibility>;
};

/** The main container customizations. */
export type CheckoutAndAccountsConfigurationBrandingMain = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingMain';
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The main container's divider style and visibility. */
  divider?: Maybe<CheckoutAndAccountsConfigurationBrandingContainerDivider>;
  /** The main sections. */
  section?: Maybe<CheckoutAndAccountsConfigurationBrandingMainSection>;
};

/** The input fields for customizing the main container. */
export type CheckoutAndAccountsConfigurationBrandingMainInput = {
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** Divider style and visibility on the main container. */
  divider?: InputMaybe<CheckoutAndAccountsConfigurationBrandingContainerDividerInput>;
  /** The customizations for the main sections. */
  section?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMainSectionInput>;
};

/** The main sections customizations. */
export type CheckoutAndAccountsConfigurationBrandingMainSection = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingMainSection';
  /** The background style of the main sections. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the main sections. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The corner radius of the main sections. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: Maybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** The input fields for customizing the main sections. */
export type CheckoutAndAccountsConfigurationBrandingMainSectionInput = {
  /** The background style of the main sections. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the main sections. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The corner radius of the main sections. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: InputMaybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** The merchandise thumbnails customizations. */
export type CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnail = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnail';
  /** The merchandise thumbnail badge. */
  badge?: Maybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadge>;
  /** The border. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The property used to customize how the product image fits within merchandise thumbnails. */
  fit?: Maybe<CheckoutAndAccountsConfigurationBrandingObjectFit>;
};

/** The merchandise thumbnail badges customizations. */
export type CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadge = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadge';
  /** The background. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadgeBackground>;
};

/** The merchandise thumbnail badge background. */
export enum CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadgeBackground {
  /** The Accent background. */
  Accent = 'ACCENT',
  /** The Base background. */
  Base = 'BASE'
}

/** The input fields for customizing the merchandise thumbnail badges. */
export type CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadgeInput = {
  /** The background. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadgeBackground>;
};

/** The input fields for customizing the merchandise thumbnails. */
export type CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailInput = {
  /** The aspect ratio. */
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  /** The merchandise thumbnail badge. */
  badge?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMerchandiseThumbnailBadgeInput>;
  /** The border. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The corner radius. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The property used to customize how the product image fits within merchandise thumbnails. */
  fit?: InputMaybe<CheckoutAndAccountsConfigurationBrandingObjectFit>;
};

/** Possible values for object fit. */
export enum CheckoutAndAccountsConfigurationBrandingObjectFit {
  /** The Contain value for fit. The image is scaled to maintain its aspect ratio while fitting within the containing box. The entire image is made to fill the box, while preserving its aspect ratio, so the image will be "letterboxed" if its aspect ratio does not match the aspect ratio of the box. This is the default value. */
  Contain = 'CONTAIN',
  /** The Cover value for fit. The image is sized to maintain its aspect ratio while filling the entire containing box. If the image's aspect ratio does not match the aspect ratio of the containing box, then the object will be clipped to fit. */
  Cover = 'COVER'
}

/** The order summary customizations. */
export type CheckoutAndAccountsConfigurationBrandingOrderSummary = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingOrderSummary';
  /** The background image of the order summary container. */
  backgroundImage?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The order summary container's divider style and visibility. */
  divider?: Maybe<CheckoutAndAccountsConfigurationBrandingContainerDivider>;
  /** The order summary sections. */
  section?: Maybe<CheckoutAndAccountsConfigurationBrandingOrderSummarySection>;
};

/** The input fields for customizing the order summary container. */
export type CheckoutAndAccountsConfigurationBrandingOrderSummaryInput = {
  /** The background image of the order summary container (must not be of SVG format). */
  backgroundImage?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** Divider style and visibility on the order summary container. */
  divider?: InputMaybe<CheckoutAndAccountsConfigurationBrandingContainerDividerInput>;
  /** The customizations for the order summary sections. */
  section?: InputMaybe<CheckoutAndAccountsConfigurationBrandingOrderSummarySectionInput>;
};

/** The order summary sections customizations. */
export type CheckoutAndAccountsConfigurationBrandingOrderSummarySection = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingOrderSummarySection';
  /** The background style of the order summary sections. */
  background?: Maybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the order summary sections. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  borderStyle?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  borderWidth?: Maybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The corner radius of the order summary sections. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  shadow?: Maybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** The input fields for customizing the order summary sections. */
export type CheckoutAndAccountsConfigurationBrandingOrderSummarySectionInput = {
  /** The background style of the order summary sections. */
  background?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBackground>;
  /** The border for the order summary sections. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  borderStyle?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  borderWidth?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorderWidth>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The corner radius of the order summary sections. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  shadow?: InputMaybe<CheckoutAndAccountsConfigurationBrandingShadow>;
};

/** A set of colors used together on a surface. */
export type CheckoutAndAccountsConfigurationBrandingPalette = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingPalette';
  /** A color in the palette (hex value). */
  color1?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color2?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color3?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color4?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color5?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color6?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color7?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color8?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color9?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color10?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color11?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color12?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color13?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color14?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color15?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color16?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color17?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color18?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color19?: Maybe<Scalars['String']['output']>;
  /** A color in the palette (hex value). */
  color20?: Maybe<Scalars['String']['output']>;
};

/** The input fields to update the color palette. */
export type CheckoutAndAccountsConfigurationBrandingPaletteInput = {
  /** A color in the palette (hex value). */
  color1?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color2?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color3?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color4?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color5?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color6?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color7?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color8?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color9?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color10?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color11?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color12?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color13?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color14?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color15?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color16?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color17?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color18?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color19?: InputMaybe<Scalars['String']['input']>;
  /** A color in the palette (hex value). */
  color20?: InputMaybe<Scalars['String']['input']>;
};

/** The primary button color customizations. */
export type CheckoutAndAccountsConfigurationBrandingPrimaryButtonColorRoles = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingPrimaryButtonColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The colors of the button on hover. */
  hover?: Maybe<CheckoutAndAccountsConfigurationBrandingColorRoles>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing colors for primary buttons. */
export type CheckoutAndAccountsConfigurationBrandingPrimaryButtonColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The colors of the button on hover. */
  hover?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorRolesInput>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The secondary button color customizations. */
export type CheckoutAndAccountsConfigurationBrandingSecondaryButtonColorRoles = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSecondaryButtonColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The colors of the button on hover. */
  hover?: Maybe<CheckoutAndAccountsConfigurationBrandingColorRoles>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing colors for secondary buttons. */
export type CheckoutAndAccountsConfigurationBrandingSecondaryButtonColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The colors of the button on hover. */
  hover?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorRolesInput>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The selects customizations. */
export type CheckoutAndAccountsConfigurationBrandingSelect = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSelect';
  /** The border. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingBorder>;
  /** The typography. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyStyle>;
};

/** The input fields for customizing the selects. */
export type CheckoutAndAccountsConfigurationBrandingSelectInput = {
  /** The border. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorder>;
  /** The typography. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyStyleInput>;
};

/** The container shadow. */
export enum CheckoutAndAccountsConfigurationBrandingShadow {
  /** The Base shadow. */
  Base = 'BASE',
  /** The Large 100 shadow. */
  Large_100 = 'LARGE_100',
  /** The Large 200 shadow. */
  Large_200 = 'LARGE_200',
  /** The Small 100 shadow. */
  Small_100 = 'SMALL_100',
  /** The Small 200 shadow. */
  Small_200 = 'SMALL_200'
}

/** The shared customizations. */
export type CheckoutAndAccountsConfigurationBrandingShared = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingShared';
  /** The shared color customizations for semantic and functional colors. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingSharedColors>;
  /** The shared corner radius setting that overrides all other [corner radius](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutAndAccountsConfigurationBrandingCornerRadius) customizations. */
  cornerRadius?: Maybe<CheckoutAndAccountsConfigurationBrandingSharedCornerRadius>;
  /** The shared typography customizations. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingSharedTypographyStyle>;
};

/** Shared color customizations for semantic and functional colors. */
export type CheckoutAndAccountsConfigurationBrandingSharedColors = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSharedColors';
  /** The accent color for interactive elements. */
  accent?: Maybe<Scalars['String']['output']>;
  /** The button color. */
  button?: Maybe<Scalars['String']['output']>;
  /** The form control color. */
  control?: Maybe<Scalars['String']['output']>;
  /** The critical/error color. */
  critical?: Maybe<Scalars['String']['output']>;
  /** The decorative color. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The informational color. */
  info?: Maybe<Scalars['String']['output']>;
  /** The success color. */
  success?: Maybe<Scalars['String']['output']>;
  /** The warning color. */
  warning?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing shared colors. */
export type CheckoutAndAccountsConfigurationBrandingSharedColorsInput = {
  /** The accent color for interactive elements. */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The button color. */
  button?: InputMaybe<Scalars['String']['input']>;
  /** The form control color. */
  control?: InputMaybe<Scalars['String']['input']>;
  /** The critical/error color. */
  critical?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The informational color. */
  info?: InputMaybe<Scalars['String']['input']>;
  /** The success color. */
  success?: InputMaybe<Scalars['String']['input']>;
  /** The warning color. */
  warning?: InputMaybe<Scalars['String']['input']>;
};

/** Possible choices to override corner radius customizations on all applicable objects. Note that this selection can only be used to set the override to `NONE` (0px). */
export enum CheckoutAndAccountsConfigurationBrandingSharedCornerRadius {
  /** Set the shared corner radius override to 0px (square corners). */
  None = 'NONE'
}

/** The input fields for customizing the shared settings. */
export type CheckoutAndAccountsConfigurationBrandingSharedInput = {
  /** The shared color customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSharedColorsInput>;
  /** Select a shared corner radius setting that overrides all other corner radii customizations. */
  cornerRadius?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSharedCornerRadius>;
  /** The shared typography customizations. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSharedTypographyStyleInput>;
};

/** The shared typography customizations. */
export type CheckoutAndAccountsConfigurationBrandingSharedTypographyStyle = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSharedTypographyStyle';
  /** The kerning. */
  kerning?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyLetterCase>;
};

/** The input fields for customizing the shared typography. */
export type CheckoutAndAccountsConfigurationBrandingSharedTypographyStyleInput = {
  /** The kerning. */
  kerning?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyLetterCase>;
};

/** The Shopify font customizations. */
export type CheckoutAndAccountsConfigurationBrandingShopifyFont = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingShopifyFont';
  /** The font sources. */
  sources?: Maybe<Scalars['String']['output']>;
  /** The font weight. */
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The Shopify font group customizations. */
export type CheckoutAndAccountsConfigurationBrandingShopifyFontGroup = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingShopifyFontGroup';
  /** The base Shopify font. */
  base?: Maybe<CheckoutAndAccountsConfigurationBrandingShopifyFont>;
  /** The bold Shopify font. */
  bold?: Maybe<CheckoutAndAccountsConfigurationBrandingShopifyFont>;
  /** The font loading strategy. */
  loadingStrategy?: Maybe<CheckoutAndAccountsConfigurationBrandingFontLoadingStrategy>;
  /** The font group name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** The input fields for customizing a Shopify font group. */
export type CheckoutAndAccountsConfigurationBrandingShopifyFontGroupInput = {
  /** The Shopify base font handle. */
  baseFontHandle: Scalars['String']['input'];
  /** The Shopify bold font handle. */
  boldFontHandle: Scalars['String']['input'];
  /** The font loading strategy. */
  loadingStrategy?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFontLoadingStrategy>;
};

/** The sign-in-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingSignInComponents = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSignInComponents';
  /** The header customizations. */
  header?: Maybe<CheckoutAndAccountsConfigurationBrandingSignInHeader>;
  /** The main customizations. */
  main?: Maybe<CheckoutAndAccountsConfigurationBrandingSignInMain>;
};

/** The input fields for customizing the sign-in components. */
export type CheckoutAndAccountsConfigurationBrandingSignInComponentsInput = {
  /** The header customizations. */
  header?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSignInHeaderInput>;
  /** The main customizations. */
  main?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSignInMainInput>;
};

/** The sign-in header customizations. */
export type CheckoutAndAccountsConfigurationBrandingSignInHeader = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSignInHeader';
  /** The store logo. */
  logo?: Maybe<CheckoutAndAccountsConfigurationBrandingSignInLogo>;
  /** The padding of the header container. */
  padding?: Maybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The input fields for customizing the sign-in header. */
export type CheckoutAndAccountsConfigurationBrandingSignInHeaderInput = {
  /** The store logo. */
  logo?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSignInLogoInput>;
  /** The padding of the header container. */
  padding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSpacingKeyword>;
};

/** The sign-in store logo customizations. */
export type CheckoutAndAccountsConfigurationBrandingSignInLogo = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSignInLogo';
  /** The logo image. */
  image?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The maximum width of the logo. */
  maxWidth?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for customizing the sign-in logo. */
export type CheckoutAndAccountsConfigurationBrandingSignInLogoInput = {
  /** The logo image. */
  image?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The maximum width of the logo. */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** The sign-in-specific main customizations. */
export type CheckoutAndAccountsConfigurationBrandingSignInMain = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSignInMain';
  /** The background image of the main container. */
  backgroundImage?: Maybe<CheckoutAndAccountsConfigurationBrandingImageValue>;
  /** The colors customizations. */
  colors?: Maybe<CheckoutAndAccountsConfigurationBrandingColors>;
  /** The main sections. */
  section?: Maybe<CheckoutAndAccountsConfigurationBrandingMainSection>;
};

/** The input fields for customizing the sign-in main container. */
export type CheckoutAndAccountsConfigurationBrandingSignInMainInput = {
  /** The background image of the main container. */
  backgroundImage?: InputMaybe<CheckoutAndAccountsConfigurationBrandingImageInput>;
  /** The colors customizations. */
  colors?: InputMaybe<CheckoutAndAccountsConfigurationBrandingColorsInput>;
  /** The customizations for the main sections. */
  section?: InputMaybe<CheckoutAndAccountsConfigurationBrandingMainSectionInput>;
};

/** The sign-in-specific component customizations. */
export type CheckoutAndAccountsConfigurationBrandingSignInSurface = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSignInSurface';
  /** The sign-in components. */
  components?: Maybe<CheckoutAndAccountsConfigurationBrandingSignInComponents>;
};

/** The input fields for customizing the sign-in surface. */
export type CheckoutAndAccountsConfigurationBrandingSignInSurfaceInput = {
  /** The sign-in components. */
  components?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSignInComponentsInput>;
};

/** Possible values for the simple border. */
export enum CheckoutAndAccountsConfigurationBrandingSimpleBorder {
  /** The Full simple border. */
  Full = 'FULL',
  /** The None simple border. */
  None = 'NONE'
}

/** Possible values for the spacing. */
export enum CheckoutAndAccountsConfigurationBrandingSpacing {
  /** The Base spacing. */
  Base = 'BASE',
  /** The Extra Loose spacing. */
  ExtraLoose = 'EXTRA_LOOSE',
  /** The Extra Tight spacing. */
  ExtraTight = 'EXTRA_TIGHT',
  /** The Loose spacing. */
  Loose = 'LOOSE',
  /** The None spacing. */
  None = 'NONE',
  /** The Tight spacing. */
  Tight = 'TIGHT'
}

/** The spacing between UI elements. */
export enum CheckoutAndAccountsConfigurationBrandingSpacingKeyword {
  /** The Base spacing. */
  Base = 'BASE',
  /** The Large spacing. */
  Large = 'LARGE',
  /** The Large 100 spacing. */
  Large_100 = 'LARGE_100',
  /** The Large 200 spacing. */
  Large_200 = 'LARGE_200',
  /** The Large 300 spacing. */
  Large_300 = 'LARGE_300',
  /** The Large 400 spacing. */
  Large_400 = 'LARGE_400',
  /** The Large 500 spacing. */
  Large_500 = 'LARGE_500',
  /** The None spacing. */
  None = 'NONE',
  /** The Small spacing. */
  Small = 'SMALL',
  /** The Small 100 spacing. */
  Small_100 = 'SMALL_100',
  /** The Small 200 spacing. */
  Small_200 = 'SMALL_200',
  /** The Small 300 spacing. */
  Small_300 = 'SMALL_300',
  /** The Small 400 spacing. */
  Small_400 = 'SMALL_400',
  /** The Small 500 spacing. */
  Small_500 = 'SMALL_500'
}

/** The surface-specific component customizations for checkout and customer accounts. */
export type CheckoutAndAccountsConfigurationBrandingSurfaces = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingSurfaces';
  /** The checkout-specific component overrides. */
  checkout?: Maybe<CheckoutAndAccountsConfigurationBrandingCheckoutSurface>;
  /** The customer accounts-specific component overrides. */
  customerAccounts?: Maybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsSurface>;
  /** The sign-in-specific component overrides. */
  signIn?: Maybe<CheckoutAndAccountsConfigurationBrandingSignInSurface>;
};

/** The input fields for customizing surfaces branding. */
export type CheckoutAndAccountsConfigurationBrandingSurfacesInput = {
  /** The checkout surface customizations. */
  checkout?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCheckoutSurfaceInput>;
  /** The customer accounts surface customizations. */
  customerAccounts?: InputMaybe<CheckoutAndAccountsConfigurationBrandingCustomerAccountsSurfaceInput>;
  /** The sign-in surface customizations. */
  signIn?: InputMaybe<CheckoutAndAccountsConfigurationBrandingSignInSurfaceInput>;
};

/** The text fields customizations. */
export type CheckoutAndAccountsConfigurationBrandingTextField = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingTextField';
  /** The border. */
  border?: Maybe<CheckoutAndAccountsConfigurationBrandingBorder>;
  /** The typography. */
  typography?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyStyle>;
};

/** The input fields for customizing the text fields. */
export type CheckoutAndAccountsConfigurationBrandingTextFieldInput = {
  /** The border. */
  border?: InputMaybe<CheckoutAndAccountsConfigurationBrandingBorder>;
  /** The typography. */
  typography?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyStyleInput>;
};

/** The typography customizations. */
export type CheckoutAndAccountsConfigurationBrandingTypography = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingTypography';
  /** The font group used for most components such as text, buttons and form controls. */
  primary?: Maybe<CheckoutAndAccountsConfigurationBrandingFontGroup>;
  /** The font group used for heading components by default. */
  secondary?: Maybe<CheckoutAndAccountsConfigurationBrandingFontGroup>;
  /** The font size (base size in pixels and scaling between different sizes). */
  size?: Maybe<CheckoutAndAccountsConfigurationBrandingFontSize>;
};

/** The font selection. */
export enum CheckoutAndAccountsConfigurationBrandingTypographyFont {
  /** The primary font. */
  Primary = 'PRIMARY',
  /** The secondary font. */
  Secondary = 'SECONDARY'
}

/** The input fields for customizing the typography. */
export type CheckoutAndAccountsConfigurationBrandingTypographyInput = {
  /** The font group used for most components such as text, buttons and form controls. */
  primary?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFontGroupInput>;
  /** The font group used for heading components by default. */
  secondary?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFontGroupInput>;
  /** The font size. */
  size?: InputMaybe<CheckoutAndAccountsConfigurationBrandingFontSizeInput>;
};

/** Possible values for the typography kerning. */
export enum CheckoutAndAccountsConfigurationBrandingTypographyKerning {
  /** Base or default kerning. */
  Base = 'BASE',
  /** Extra loose kerning, leaving even more space in between characters. */
  ExtraLoose = 'EXTRA_LOOSE',
  /** Loose kerning, leaving more space than the default in between characters. */
  Loose = 'LOOSE'
}

/** Possible values for the typography letter case. */
export enum CheckoutAndAccountsConfigurationBrandingTypographyLetterCase {
  /** All letters are is lower case. */
  Lower = 'LOWER',
  /** No letter casing applied. */
  None = 'NONE',
  /** Capitalize the first letter of each word. */
  Title = 'TITLE',
  /** All letters are uppercase. */
  Upper = 'UPPER'
}

/** Possible choices for the font size. */
export enum CheckoutAndAccountsConfigurationBrandingTypographySize {
  /** The Base font size. Example: 14px. */
  Base = 'BASE',
  /** The Extra extra large font size. Example: 24px. */
  ExtraExtraLarge = 'EXTRA_EXTRA_LARGE',
  /** The Extra large font size. Example: 21px. */
  ExtraLarge = 'EXTRA_LARGE',
  /** The Extra small font size. Example: 10px. */
  ExtraSmall = 'EXTRA_SMALL',
  /** The Large font size. Example: 19px. */
  Large = 'LARGE',
  /** The Medium font size. Example: 16px. */
  Medium = 'MEDIUM',
  /** The Small font size. Example: 12px. */
  Small = 'SMALL'
}

/** The typography customizations. */
export type CheckoutAndAccountsConfigurationBrandingTypographyStyle = {
  __typename?: 'CheckoutAndAccountsConfigurationBrandingTypographyStyle';
  /** The font. */
  font?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyFont>;
  /** The kerning. */
  kerning?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyLetterCase>;
  /** The font size. */
  size?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographySize>;
  /** The font weight. */
  weight?: Maybe<CheckoutAndAccountsConfigurationBrandingTypographyWeight>;
};

/** The input fields for customizing the typography. */
export type CheckoutAndAccountsConfigurationBrandingTypographyStyleInput = {
  /** The font. */
  font?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyFont>;
  /** The kerning. */
  kerning?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyLetterCase>;
  /** The font size. */
  size?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographySize>;
  /** The font weight. */
  weight?: InputMaybe<CheckoutAndAccountsConfigurationBrandingTypographyWeight>;
};

/** Possible values for the font weight. */
export enum CheckoutAndAccountsConfigurationBrandingTypographyWeight {
  /** The base font's weight in the style's font group (`designTokens.typography.primary` or `secondary`). Set it with `baseFontHandle` on a Shopify font group, or `base.weight` on a custom font group. If the style doesn't set `font`, the secondary font group's base weight applies. */
  Base = 'BASE',
  /** The bold font's weight in the style's font group (`designTokens.typography.primary` or `secondary`). Set it with `boldFontHandle` on a Shopify font group, or `bold.weight` on a custom font group. If the style doesn't set `font`, the secondary font group's bold weight applies. */
  Bold = 'BOLD'
}

/** Possible visibility states. */
export enum CheckoutAndAccountsConfigurationBrandingVisibility {
  /** The Hidden visibility setting. */
  Hidden = 'HIDDEN',
  /** The Visible visibility setting. */
  Visible = 'VISIBLE'
}

/** An auto-generated type for paginating through multiple CheckoutAndAccountsConfigurations. */
export type CheckoutAndAccountsConfigurationConnection = {
  __typename?: 'CheckoutAndAccountsConfigurationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CheckoutAndAccountsConfigurationEdge>;
  /** A list of nodes that are contained in CheckoutAndAccountsConfigurationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CheckoutAndAccountsConfiguration>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CheckoutAndAccountsConfiguration and a cursor during pagination. */
export type CheckoutAndAccountsConfigurationEdge = {
  __typename?: 'CheckoutAndAccountsConfigurationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CheckoutAndAccountsConfigurationEdge. */
  node: CheckoutAndAccountsConfiguration;
};

/** The input fields for checkout and account configurations. */
export type CheckoutAndAccountsConfigurationInput = {
  /** The branding settings of the configuration. */
  branding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingInput>;
  /** The overrides to create/update in the configuration. */
  overrides?: InputMaybe<Array<CheckoutAndAccountsConfigurationOverrideInput>>;
};

/** Represents a checkout and accounts configuration interface. */
export type CheckoutAndAccountsConfigurationInterface = {
  /** The branding configuration. */
  branding?: Maybe<CheckoutAndAccountsConfigurationBranding>;
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the configuration was last edited. */
  editedAt: Scalars['DateTime']['output'];
  /** The configuration name. */
  name: Scalars['String']['output'];
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A checkout and account configuration override modifies a parent configuration for specific markets. */
export type CheckoutAndAccountsConfigurationOverride = CheckoutAndAccountsConfigurationInterface & Node & {
  __typename?: 'CheckoutAndAccountsConfigurationOverride';
  /** The branding configuration. */
  branding?: Maybe<CheckoutAndAccountsConfigurationBranding>;
  /** The date and time when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the configuration was last edited. */
  editedAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The configuration name. */
  name: Scalars['String']['output'];
  /** The date and time when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The input fields for checkout and account configuration overrides. */
export type CheckoutAndAccountsConfigurationOverrideInput = {
  /** The branding settings of the configuration. */
  branding?: InputMaybe<CheckoutAndAccountsConfigurationBrandingInput>;
  /** The ID of the configuration override to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `checkoutAndAccountsConfigurationUpdate` mutation. */
export type CheckoutAndAccountsConfigurationUpdatePayload = {
  __typename?: 'CheckoutAndAccountsConfigurationUpdatePayload';
  /** The updated configuration. */
  configuration?: Maybe<CheckoutAndAccountsConfiguration>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CheckoutAndAccountsConfigurationUserError>;
};

/** An error that occurs during the execution of a mutation for managing checkout and accounts configurations. */
export type CheckoutAndAccountsConfigurationUserError = DisplayableError & {
  __typename?: 'CheckoutAndAccountsConfigurationUserError';
  /** The error code. */
  code?: Maybe<CheckoutAndAccountsConfigurationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
  /** The reason for the error. */
  reason: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CheckoutAndAccountsConfigurationUserError`. */
export enum CheckoutAndAccountsConfigurationUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Internal error. Looks like something went wrong on our end. */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** One or more required fields are missing in the input. */
  Missing = 'MISSING',
  /** One or more requested items couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The request could not be completed — please try again later. */
  Transient = 'TRANSIENT'
}

/** The set of valid sort keys for the CheckoutAndAccountsConfigurationsGraphQL query. */
export enum CheckoutAndAccountsConfigurationsGraphQlSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `edited_at` value. */
  EditedAt = 'EDITED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `is_published` value. */
  IsPublished = 'IS_PUBLISHED'
}

/**
 * Creates a unified visual identity for your checkout that keeps customers engaged and reinforces your brand throughout the purchase process. This comprehensive branding system lets you control every visual aspect of checkout, from colors and fonts to layouts and imagery, so your checkout feels like a natural extension of your store.
 *
 * For example, a luxury fashion retailer can configure their checkout with custom color palettes, premium typography, rounded corners for a softer feel, and branded imagery that matches their main website aesthetic.
 *
 * Use the `Branding` object to:
 * - Configure comprehensive checkout visual identity
 * - Coordinate color schemes across all checkout elements
 * - Apply consistent typography and spacing standards
 * - Manage background imagery and layout customizations
 * - Control visibility of various checkout components
 *
 * The branding configuration includes design system foundations like color roles, typography scales, and spacing units, plus specific customizations for sections, dividers, and interactive elements. This allows merchants to create cohesive checkout experiences that reinforce their brand identity while maintaining usability standards.
 *
 * Different color schemes can be defined for various contexts, ensuring optimal contrast and accessibility across different checkout states and customer preferences.
 */
export type CheckoutBranding = {
  __typename?: 'CheckoutBranding';
  /** The customizations that apply to specific components or areas of the user interface. */
  customizations?: Maybe<CheckoutBrandingCustomizations>;
  /**
   * The design system allows you to set values that represent specific attributes
   * of your brand like color and font. These attributes are used throughout the user
   * interface. This brings consistency and allows you to easily make broad design changes.
   */
  designSystem?: Maybe<CheckoutBrandingDesignSystem>;
};

/** The container background style. */
export enum CheckoutBrandingBackground {
  /** The Base background style. */
  Base = 'BASE',
  /** The Subdued background style. */
  Subdued = 'SUBDUED',
  /** The Transparent background style. */
  Transparent = 'TRANSPARENT'
}

/** Possible values for the background style. */
export enum CheckoutBrandingBackgroundStyle {
  /** The None background style. */
  None = 'NONE',
  /** The Solid background style. */
  Solid = 'SOLID'
}

/** Possible values for the border. */
export enum CheckoutBrandingBorder {
  /** The Block End border. */
  BlockEnd = 'BLOCK_END',
  /** The Full border. */
  Full = 'FULL',
  /** The None border. */
  None = 'NONE'
}

/** The container border style. */
export enum CheckoutBrandingBorderStyle {
  /** The Base border style. */
  Base = 'BASE',
  /** The Dashed border style. */
  Dashed = 'DASHED',
  /** The Dotted border style. */
  Dotted = 'DOTTED'
}

/** The container border width. */
export enum CheckoutBrandingBorderWidth {
  /** The Base border width. */
  Base = 'BASE',
  /** The Large border width. */
  Large = 'LARGE',
  /** The Large 100 border width. */
  Large_100 = 'LARGE_100',
  /** The Large 200 border width. */
  Large_200 = 'LARGE_200'
}

/** The buttons customizations. */
export type CheckoutBrandingButton = {
  __typename?: 'CheckoutBrandingButton';
  /** The background style used for buttons. */
  background?: Maybe<CheckoutBrandingBackgroundStyle>;
  /** The block padding used for buttons. */
  blockPadding?: Maybe<CheckoutBrandingSpacing>;
  /** The border used for buttons. */
  border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for buttons. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The inline padding used for buttons. */
  inlinePadding?: Maybe<CheckoutBrandingSpacing>;
  /** The typography used for buttons. */
  typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/**
 * Defines the color palette specifically for button elements within checkout branding, including hover states. These color roles ensure buttons maintain proper contrast and visual hierarchy throughout the checkout experience.
 *
 * For example, a sports brand might configure bright accent colors for primary action buttons, with darker hover states and contrasting text colors that maintain accessibility standards.
 *
 * Use the `ButtonColorRoles` object to:
 * - Define button color schemes for different states
 * - Ensure proper contrast for accessibility compliance
 * - Coordinate button colors with overall brand palette
 *
 * Button color roles include background, border, text, icon, accent (for focused states), and decorative elements, plus specific hover state colors that provide clear interactive feedback to customers.
 */
export type CheckoutBrandingButtonColorRoles = {
  __typename?: 'CheckoutBrandingButtonColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The colors of the button on hover. */
  hover?: Maybe<CheckoutBrandingColorRoles>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields to set colors for buttons. */
export type CheckoutBrandingButtonColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The colors of the button on hover. */
  hover?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields used to update the buttons customizations. */
export type CheckoutBrandingButtonInput = {
  /** The background style used for buttons. */
  background?: InputMaybe<CheckoutBrandingBackgroundStyle>;
  /** The block padding used for buttons. */
  blockPadding?: InputMaybe<CheckoutBrandingSpacing>;
  /** The border used for buttons. */
  border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for buttons. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The inline padding used for buttons. */
  inlinePadding?: InputMaybe<CheckoutBrandingSpacing>;
  /** The typography style used for buttons. */
  typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/**
 * Controls the visibility settings for checkout breadcrumb navigation that shows customers their progress through the purchase journey. This simple customization allows merchants to show or hide the breadcrumb trail based on their checkout flow preferences.
 *
 * For example, a single-page checkout experience might hide breadcrumbs to create a more streamlined appearance, while multi-step checkouts can display them to help customers understand their progress.
 *
 * The visibility setting provides merchants flexibility in how they present checkout navigation to match their specific user experience strategy.
 *
 * Learn more about [checkout customization](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutBranding).
 */
export type CheckoutBrandingBuyerJourney = {
  __typename?: 'CheckoutBrandingBuyerJourney';
  /** An option to display or hide the breadcrumbs that represent the buyer's journey on 3-page checkout. */
  visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields for updating breadcrumb customizations, which represent the buyer's journey to checkout. */
export type CheckoutBrandingBuyerJourneyInput = {
  /** The visibility customizations for updating breadcrumbs, which represent the buyer's journey to checkout. */
  visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/**
 * Controls the visibility of cart links displayed during checkout. These links allow customers to return to their cart or continue shopping.
 *
 * For example, an electronics store might hide cart links during final checkout steps to reduce distractions, or show them prominently to encourage customers to add accessories before completing their purchase.
 *
 * The `CartLink` object provides visibility settings to control when and how these navigation elements appear based on the merchant's checkout flow strategy.
 */
export type CheckoutBrandingCartLink = {
  __typename?: 'CheckoutBrandingCartLink';
  /** Whether the cart link is visible at checkout. */
  visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** Possible values for the cart link content type for the header. */
export enum CheckoutBrandingCartLinkContentType {
  /** The checkout header content type icon value. */
  Icon = 'ICON',
  /** The checkout header content type image value. */
  Image = 'IMAGE',
  /** The checkout header content type text value. */
  Text = 'TEXT'
}

/** The input fields for updating the cart link customizations at checkout. */
export type CheckoutBrandingCartLinkInput = {
  /** The input to update the visibility of cart links in checkout. This hides the cart icon on one-page and the cart link in the breadcrumbs/buyer journey on three-page checkout. */
  visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/**
 * Defines the visual styling for checkbox elements throughout the checkout interface, focusing on corner radius customization. This allows merchants to align checkbox appearance with their overall design aesthetic.
 *
 * For example, a modern minimalist brand might prefer sharp, square checkboxes while a friendly consumer brand could opt for rounded corners to create a softer, more approachable feel.
 *
 * The corner radius setting ensures checkboxes integrate seamlessly with the overall checkout design language and brand identity.
 */
export type CheckoutBrandingCheckbox = {
  __typename?: 'CheckoutBrandingCheckbox';
  /** The corner radius used for checkboxes. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
};

/** The input fields used to update the checkboxes customizations. */
export type CheckoutBrandingCheckboxInput = {
  /** The corner radius used for checkboxes. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
};

/**
 * Controls spacing customization for the grouped variant of choice list components in checkout forms.
 *
 * The `ChoiceList` object contains settings specifically for the 'group' variant styling through the [`ChoiceListGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutBrandingChoiceListGroup) field, which determines the spacing between choice options.
 */
export type CheckoutBrandingChoiceList = {
  __typename?: 'CheckoutBrandingChoiceList';
  /** The settings that apply to the 'group' variant of ChoiceList. */
  group?: Maybe<CheckoutBrandingChoiceListGroup>;
};

/**
 * Controls the spacing between options in the 'group' variant of [`ChoiceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutBrandingChoiceList) components.
 *
 * This setting adjusts the vertical spacing between choice options to improve readability and visual organization. The spacing value helps create clear separation between options, making it easier for customers to scan and select from available choices.
 *
 * Learn more about [checkout customization](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutBranding).
 */
export type CheckoutBrandingChoiceListGroup = {
  __typename?: 'CheckoutBrandingChoiceListGroup';
  /** The spacing between UI elements in the list. */
  spacing?: Maybe<CheckoutBrandingSpacingKeyword>;
};

/** The input fields to update the settings that apply to the 'group' variant of ChoiceList. */
export type CheckoutBrandingChoiceListGroupInput = {
  /** The spacing between UI elements in the list. */
  spacing?: InputMaybe<CheckoutBrandingSpacingKeyword>;
};

/** The input fields to use to update the choice list customizations. */
export type CheckoutBrandingChoiceListInput = {
  /** The settings that apply to the 'group' variant of ChoiceList. */
  group?: InputMaybe<CheckoutBrandingChoiceListGroupInput>;
};

/**
 * Defines the global color roles for checkout branding. These semantic colors maintain consistency across all checkout elements and provide the foundation for the checkout's visual design system.
 *
 * Use global colors to:
 * - Set brand colors for primary actions and buttons
 * - Define accent colors for links and interactive elements
 * - Configure semantic colors for success, warning, and error states
 * - Apply decorative colors for visual highlights
 *
 * For example, a merchant might set their brand blue for primary buttons, green for success messages, amber for warnings, and red for critical errors, creating a consistent color language throughout checkout.
 *
 * Learn more about [checkout customization](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutBranding).
 */
export type CheckoutBrandingColorGlobal = {
  __typename?: 'CheckoutBrandingColorGlobal';
  /** A color used for interaction, like links and focus states. */
  accent?: Maybe<Scalars['String']['output']>;
  /**
   * A color that's strongly associated with the merchant. Currently used for
   * primary buttons, for example **Pay now**, and secondary buttons, for example **Buy again**.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /** A semantic color used for components that communicate critical content. For example, a blocking error such as the requirement to enter a valid credit card number. */
  critical?: Maybe<Scalars['String']['output']>;
  /** A color used to highlight certain areas of the user interface. For example, the [`Text`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/titles-and-text/text#textprops-propertydetail-appearance) component. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** A semantic color used for components that communicate general, informative content. */
  info?: Maybe<Scalars['String']['output']>;
  /** A semantic color used for components that communicate successful actions or a positive state. */
  success?: Maybe<Scalars['String']['output']>;
  /** A semantic color used for components that display content that requires attention. For example, something that might be wrong, but not blocking. */
  warning?: Maybe<Scalars['String']['output']>;
};

/** The input fields to customize the overall look and feel of the checkout. */
export type CheckoutBrandingColorGlobalInput = {
  /** A color used for interaction, like links and focus states. */
  accent?: InputMaybe<Scalars['String']['input']>;
  /**
   * A color that's strongly associated with the merchant. Currently used for
   * primary buttons, such as **Pay now**, and secondary buttons, such as **Buy again**.
   */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** A semantic color used for components that communicate critical content. For example, a blocking error such as the requirement to enter a valid credit card number. */
  critical?: InputMaybe<Scalars['String']['input']>;
  /** A color used to highlight certain areas of the user interface. For example, the [`Text`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/titles-and-text/text#textprops-propertydetail-appearance) component. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** A semantic color used for components that communicate general, informative content. */
  info?: InputMaybe<Scalars['String']['input']>;
  /** A semantic color used for components that communicate successful actions or a positive state. */
  success?: InputMaybe<Scalars['String']['input']>;
  /** A semantic color used for components that display content that requires attention. For example, something that might be wrong, but not blocking. */
  warning?: InputMaybe<Scalars['String']['input']>;
};

/** A group of colors used together on a surface. */
export type CheckoutBrandingColorRoles = {
  __typename?: 'CheckoutBrandingColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields for a group of colors used together on a surface. */
export type CheckoutBrandingColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A base set of color customizations that's applied to an area of Checkout, from which every component
 * pulls its colors.
 */
export type CheckoutBrandingColorScheme = {
  __typename?: 'CheckoutBrandingColorScheme';
  /** The main colors of a scheme. Used for the surface background, text, links, and more. */
  base?: Maybe<CheckoutBrandingColorRoles>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  control?: Maybe<CheckoutBrandingControlColorRoles>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  primaryButton?: Maybe<CheckoutBrandingButtonColorRoles>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  secondaryButton?: Maybe<CheckoutBrandingButtonColorRoles>;
};

/**
 * The input fields for a base set of color customizations that's applied to an area of Checkout, from which
 * every component pulls its colors.
 */
export type CheckoutBrandingColorSchemeInput = {
  /** The main colors of a scheme. Used for the surface background, text, links, and more. */
  base?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  control?: InputMaybe<CheckoutBrandingControlColorRolesInput>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  primaryButton?: InputMaybe<CheckoutBrandingButtonColorRolesInput>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  secondaryButton?: InputMaybe<CheckoutBrandingButtonColorRolesInput>;
};

/** The possible color schemes. */
export enum CheckoutBrandingColorSchemeSelection {
  /** The COLOR_SCHEME1 color scheme selection. */
  ColorScheme1 = 'COLOR_SCHEME1',
  /** The COLOR_SCHEME2 color scheme selection. */
  ColorScheme2 = 'COLOR_SCHEME2',
  /** The COLOR_SCHEME3 color scheme selection. */
  ColorScheme3 = 'COLOR_SCHEME3',
  /** The COLOR_SCHEME4 color scheme selection. */
  ColorScheme4 = 'COLOR_SCHEME4',
  /** The COLOR_SCHEME5 color scheme selection. */
  ColorScheme5 = 'COLOR_SCHEME5',
  /** The COLOR_SCHEME6 color scheme selection. */
  ColorScheme6 = 'COLOR_SCHEME6',
  /** The TRANSPARENT color scheme selection. */
  Transparent = 'TRANSPARENT'
}

/** The color schemes. */
export type CheckoutBrandingColorSchemes = {
  __typename?: 'CheckoutBrandingColorSchemes';
  /** The primary scheme. By default, it’s used for the main area of the interface. */
  scheme1?: Maybe<CheckoutBrandingColorScheme>;
  /** The secondary scheme. By default, it’s used for secondary areas, like Checkout’s Order Summary. */
  scheme2?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme3?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme4?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme5?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme6?: Maybe<CheckoutBrandingColorScheme>;
};

/** The input fields for the color schemes. */
export type CheckoutBrandingColorSchemesInput = {
  /** The primary scheme. By default, it’s used for the main area of the interface. */
  scheme1?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** The secondary scheme. By default, it’s used for secondary areas, like Checkout’s Order Summary. */
  scheme2?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme3?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme4?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme5?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  scheme6?: InputMaybe<CheckoutBrandingColorSchemeInput>;
};

/** The possible colors. */
export enum CheckoutBrandingColorSelection {
  /** Transparent color selection. */
  Transparent = 'TRANSPARENT'
}

/** The color settings for global colors and color schemes. */
export type CheckoutBrandingColors = {
  __typename?: 'CheckoutBrandingColors';
  /** A group of global colors for customizing the overall look and feel of the user interface. */
  global?: Maybe<CheckoutBrandingColorGlobal>;
  /** A set of color schemes which apply to different areas of the user interface. */
  schemes?: Maybe<CheckoutBrandingColorSchemes>;
};

/** The input fields used to update the color settings for global colors and color schemes. */
export type CheckoutBrandingColorsInput = {
  /** The input to update global colors for customizing the overall look and feel of the user interface. */
  global?: InputMaybe<CheckoutBrandingColorGlobalInput>;
  /** The input to define color schemes which apply to different areas of the user interface. */
  schemes?: InputMaybe<CheckoutBrandingColorSchemesInput>;
};

/** The container's divider customizations. */
export type CheckoutBrandingContainerDivider = {
  __typename?: 'CheckoutBrandingContainerDivider';
  /** The divider style. */
  borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The divider width. */
  borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The divider visibility. */
  visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields used to update a container's divider customizations. */
export type CheckoutBrandingContainerDividerInput = {
  /** The divider style. */
  borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The divider width. */
  borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The divider visibility. */
  visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The content container customizations. */
export type CheckoutBrandingContent = {
  __typename?: 'CheckoutBrandingContent';
  /** The content container's divider style and visibility. */
  divider?: Maybe<CheckoutBrandingContainerDivider>;
};

/** The input fields used to update the content container customizations. */
export type CheckoutBrandingContentInput = {
  /** Divider style and visibility on the content container. */
  divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
};

/** The form controls customizations. */
export type CheckoutBrandingControl = {
  __typename?: 'CheckoutBrandingControl';
  /** The border used for form controls. */
  border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** Set to TRANSPARENT to define transparent form controls. If null, form controls inherit colors from their scheme settings (for example, the main section inherits from `design_system.colors.schemes.scheme1.control` by default). Note that usage of the `customizations.control.color` setting to customize the form control color is deprecated. */
  color?: Maybe<CheckoutBrandingColorSelection>;
  /** The corner radius used for form controls. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The label position used for form controls. */
  labelPosition?: Maybe<CheckoutBrandingLabelPosition>;
};

/** Colors for form controls. */
export type CheckoutBrandingControlColorRoles = {
  __typename?: 'CheckoutBrandingControlColorRoles';
  /** The color of accented objects (links and focused state). */
  accent?: Maybe<Scalars['String']['output']>;
  /** The color of the background. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color of borders. */
  border?: Maybe<Scalars['String']['output']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: Maybe<Scalars['String']['output']>;
  /** The color of icons. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The colors of selected controls. */
  selected?: Maybe<CheckoutBrandingColorRoles>;
  /** The color of text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The input fields to define colors for form controls. */
export type CheckoutBrandingControlColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  accent?: InputMaybe<Scalars['String']['input']>;
  /** The color of the background. */
  background?: InputMaybe<Scalars['String']['input']>;
  /** The color of borders. */
  border?: InputMaybe<Scalars['String']['input']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  decorative?: InputMaybe<Scalars['String']['input']>;
  /** The color of icons. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The colors of selected controls. */
  selected?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The color of text. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields used to update the form controls customizations. */
export type CheckoutBrandingControlInput = {
  /** The border used for form controls. */
  border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** Set to TRANSPARENT to define transparent form controls. If null, form controls inherit colors from their scheme settings (for example, the main section inherits from `design_system.colors.schemes.scheme1.control` by default). Note that usage of the `customizations.control.color` setting to customize the form control color is deprecated. */
  color?: InputMaybe<CheckoutBrandingColorSelection>;
  /** The corner radius used for form controls. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The label position used for form controls. */
  labelPosition?: InputMaybe<CheckoutBrandingLabelPosition>;
};

/**
 * The options for customizing the corner radius of checkout-related objects. Examples include the primary
 * button, the name text fields and the sections within the main area (if they have borders).
 * Refer to this complete [list](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius#fieldswith)
 * for objects with customizable corner radii.
 *
 * The design system defines the corner radius pixel size for each option. Modify the defaults by setting the
 * [designSystem.cornerRadius](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CheckoutBrandingDesignSystemInput#field-checkoutbrandingdesignsysteminput-cornerradius)
 * input fields.
 */
export enum CheckoutBrandingCornerRadius {
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.base. */
  Base = 'BASE',
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.large. */
  Large = 'LARGE',
  /** The 0px corner radius (square corners). */
  None = 'NONE',
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.small. */
  Small = 'SMALL'
}

/** Define the pixel size of corner radius options. */
export type CheckoutBrandingCornerRadiusVariables = {
  __typename?: 'CheckoutBrandingCornerRadiusVariables';
  /** The value in pixels for base corner radii. Example: 5. */
  base?: Maybe<Scalars['Int']['output']>;
  /** The value in pixels for large corner radii. Example: 10. */
  large?: Maybe<Scalars['Int']['output']>;
  /** The value in pixels for small corner radii. Example: 3. */
  small?: Maybe<Scalars['Int']['output']>;
};

/** The input fields used to update the corner radius variables. */
export type CheckoutBrandingCornerRadiusVariablesInput = {
  /** The value in pixels for base corner radii. It should be greater than zero. Example: 5. */
  base?: InputMaybe<Scalars['Int']['input']>;
  /** The value in pixels for large corner radii. It should be greater than zero. Example: 10. */
  large?: InputMaybe<Scalars['Int']['input']>;
  /** The value in pixels for small corner radii. It should be greater than zero. Example: 3. */
  small?: InputMaybe<Scalars['Int']['input']>;
};

/** A custom font. */
export type CheckoutBrandingCustomFont = CheckoutBrandingFont & {
  __typename?: 'CheckoutBrandingCustomFont';
  /** Globally unique ID reference to the custom font file. */
  genericFileId?: Maybe<Scalars['ID']['output']>;
  /** The font sources. */
  sources?: Maybe<Scalars['String']['output']>;
  /** The font weight. */
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The input fields required to update a custom font group. */
export type CheckoutBrandingCustomFontGroupInput = {
  /** The base font. */
  base: CheckoutBrandingCustomFontInput;
  /** The bold font. */
  bold: CheckoutBrandingCustomFontInput;
  /** The font loading strategy. */
  loadingStrategy?: InputMaybe<CheckoutBrandingFontLoadingStrategy>;
};

/** The input fields required to update a font. */
export type CheckoutBrandingCustomFontInput = {
  /**
   * A globally-unique ID for a font file uploaded via the Files api.
   * Allowed font types are .woff and .woff2.
   */
  genericFileId: Scalars['ID']['input'];
  /** The font weight. Its value should be between 100 and 900. */
  weight: Scalars['Int']['input'];
};

/** The customizations that apply to specific components or areas of the user interface. */
export type CheckoutBrandingCustomizations = {
  __typename?: 'CheckoutBrandingCustomizations';
  /** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
  buyerJourney?: Maybe<CheckoutBrandingBuyerJourney>;
  /** The checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  cartLink?: Maybe<CheckoutBrandingCartLink>;
  /** The checkboxes customizations. */
  checkbox?: Maybe<CheckoutBrandingCheckbox>;
  /** The choice list customizations. */
  choiceList?: Maybe<CheckoutBrandingChoiceList>;
  /** The content container customizations. */
  content?: Maybe<CheckoutBrandingContent>;
  /** The form controls customizations. */
  control?: Maybe<CheckoutBrandingControl>;
  /** The customizations for the page, content, main, and order summary dividers. For example, by setting the borderStyle to `DOTTED`, you can make these dividers render as dotted lines. */
  divider?: Maybe<CheckoutBrandingDividerStyle>;
  /** The express checkout customizations. */
  expressCheckout?: Maybe<CheckoutBrandingExpressCheckout>;
  /** The favicon image. */
  favicon?: Maybe<CheckoutBrandingImage>;
  /** The footer customizations. */
  footer?: Maybe<CheckoutBrandingFooter>;
  /** The global customizations. */
  global?: Maybe<CheckoutBrandingGlobal>;
  /** The header customizations. */
  header?: Maybe<CheckoutBrandingHeader>;
  /** The Heading Level 1 customizations. */
  headingLevel1?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The Heading Level 2 customizations. */
  headingLevel2?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The Heading Level 3 customizations. */
  headingLevel3?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The main area customizations. */
  main?: Maybe<CheckoutBrandingMain>;
  /** The merchandise thumbnails customizations. */
  merchandiseThumbnail?: Maybe<CheckoutBrandingMerchandiseThumbnail>;
  /** The order summary customizations. */
  orderSummary?: Maybe<CheckoutBrandingOrderSummary>;
  /** The primary buttons customizations. */
  primaryButton?: Maybe<CheckoutBrandingButton>;
  /** The secondary buttons customizations. */
  secondaryButton?: Maybe<CheckoutBrandingButton>;
  /** The selects customizations. */
  select?: Maybe<CheckoutBrandingSelect>;
  /** The text fields customizations. */
  textField?: Maybe<CheckoutBrandingTextField>;
};

/** The input fields used to update the components customizations. */
export type CheckoutBrandingCustomizationsInput = {
  /** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
  buyerJourney?: InputMaybe<CheckoutBrandingBuyerJourneyInput>;
  /** The input for checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  cartLink?: InputMaybe<CheckoutBrandingCartLinkInput>;
  /** The checkboxes customizations. */
  checkbox?: InputMaybe<CheckoutBrandingCheckboxInput>;
  /** The choice list customizations. */
  choiceList?: InputMaybe<CheckoutBrandingChoiceListInput>;
  /** The content container customizations. */
  content?: InputMaybe<CheckoutBrandingContentInput>;
  /** The form controls customizations. */
  control?: InputMaybe<CheckoutBrandingControlInput>;
  /** The input for the page, content, main, and order summary dividers customizations. For example, by setting the borderStyle to `DOTTED`, you can make these dividers render as dotted lines. */
  divider?: InputMaybe<CheckoutBrandingDividerStyleInput>;
  /** The express checkout customizations. */
  expressCheckout?: InputMaybe<CheckoutBrandingExpressCheckoutInput>;
  /** The favicon image (must be of PNG format). */
  favicon?: InputMaybe<CheckoutBrandingImageInput>;
  /** The footer customizations. */
  footer?: InputMaybe<CheckoutBrandingFooterInput>;
  /** The global customizations. */
  global?: InputMaybe<CheckoutBrandingGlobalInput>;
  /** The header customizations. */
  header?: InputMaybe<CheckoutBrandingHeaderInput>;
  /** The Heading Level 1 customizations. */
  headingLevel1?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The Heading Level 2 customizations. */
  headingLevel2?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The Heading Level 3 customizations. */
  headingLevel3?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The main area customizations. */
  main?: InputMaybe<CheckoutBrandingMainInput>;
  /** The merchandise thumbnails customizations. */
  merchandiseThumbnail?: InputMaybe<CheckoutBrandingMerchandiseThumbnailInput>;
  /** The order summary customizations. */
  orderSummary?: InputMaybe<CheckoutBrandingOrderSummaryInput>;
  /** The primary buttons customizations. */
  primaryButton?: InputMaybe<CheckoutBrandingButtonInput>;
  /** The secondary buttons customizations. */
  secondaryButton?: InputMaybe<CheckoutBrandingButtonInput>;
  /** The selects customizations. */
  select?: InputMaybe<CheckoutBrandingSelectInput>;
  /** The text fields customizations. */
  textField?: InputMaybe<CheckoutBrandingTextFieldInput>;
};

/**
 * The design system allows you to set values that represent specific attributes
 * of your brand like color and font. These attributes are used throughout the user
 * interface. This brings consistency and allows you to easily make broad design changes.
 */
export type CheckoutBrandingDesignSystem = {
  __typename?: 'CheckoutBrandingDesignSystem';
  /** The color settings for global colors and color schemes. */
  colors?: Maybe<CheckoutBrandingColors>;
  /** The corner radius variables. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadiusVariables>;
  /** The typography. */
  typography?: Maybe<CheckoutBrandingTypography>;
};

/** The input fields used to update the design system. */
export type CheckoutBrandingDesignSystemInput = {
  /** The color settings for global colors and color schemes. */
  colors?: InputMaybe<CheckoutBrandingColorsInput>;
  /** The corner radius variables. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadiusVariablesInput>;
  /** The typography. */
  typography?: InputMaybe<CheckoutBrandingTypographyInput>;
};

/** The customizations for the page, content, main, and order summary dividers. */
export type CheckoutBrandingDividerStyle = {
  __typename?: 'CheckoutBrandingDividerStyle';
  /** The border style for the divider. */
  borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width for the divider. */
  borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
};

/** The input fields used to update the page, content, main and order summary dividers customizations. */
export type CheckoutBrandingDividerStyleInput = {
  /** The border style for the divider. */
  borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width for the divider. */
  borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
};

/** The Express Checkout customizations. */
export type CheckoutBrandingExpressCheckout = {
  __typename?: 'CheckoutBrandingExpressCheckout';
  /** The Express Checkout buttons customizations. */
  button?: Maybe<CheckoutBrandingExpressCheckoutButton>;
};

/** The Express Checkout button customizations. */
export type CheckoutBrandingExpressCheckoutButton = {
  __typename?: 'CheckoutBrandingExpressCheckoutButton';
  /** The corner radius used for the Express Checkout buttons. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
};

/** The input fields to use to update the express checkout customizations. */
export type CheckoutBrandingExpressCheckoutButtonInput = {
  /** The corner radius used for Express Checkout buttons. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
};

/** The input fields to use to update the Express Checkout customizations. */
export type CheckoutBrandingExpressCheckoutInput = {
  /** The Express Checkout buttons customizations. */
  button?: InputMaybe<CheckoutBrandingExpressCheckoutButtonInput>;
};

/** A font. */
export type CheckoutBrandingFont = {
  /** The font sources. */
  sources?: Maybe<Scalars['String']['output']>;
  /** The font weight. */
  weight?: Maybe<Scalars['Int']['output']>;
};

/**
 * A font group. To learn more about updating fonts, refer to the
 * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert)
 * mutation and the checkout branding [tutorial](https://shopify.dev/docs/apps/checkout/styling).
 */
export type CheckoutBrandingFontGroup = {
  __typename?: 'CheckoutBrandingFontGroup';
  /** The base font. */
  base?: Maybe<CheckoutBrandingFont>;
  /** The bold font. */
  bold?: Maybe<CheckoutBrandingFont>;
  /** The font loading strategy. */
  loadingStrategy?: Maybe<CheckoutBrandingFontLoadingStrategy>;
  /** The font group name. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * The input fields used to update a font group. To learn more about updating fonts, refer to the
 * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert)
 * mutation and the checkout branding [tutorial](https://shopify.dev/docs/apps/checkout/styling).
 */
export type CheckoutBrandingFontGroupInput = {
  /** A custom font group. */
  customFontGroup?: InputMaybe<CheckoutBrandingCustomFontGroupInput>;
  /** A Shopify font group. */
  shopifyFontGroup?: InputMaybe<CheckoutBrandingShopifyFontGroupInput>;
};

/**
 * The font loading strategy determines how a font face is displayed after it is loaded or failed to load.
 * For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display.
 */
export enum CheckoutBrandingFontLoadingStrategy {
  /** The font display strategy is defined by the browser user agent. */
  Auto = 'AUTO',
  /** Gives the font face a short block period and an infinite swap period. */
  Block = 'BLOCK',
  /** Gives the font face an extremely small block period and a short swap period. */
  Fallback = 'FALLBACK',
  /** Gives the font face an extremely small block period and no swap period. */
  Optional = 'OPTIONAL',
  /** Gives the font face an extremely small block period and an infinite swap period. */
  Swap = 'SWAP'
}

/** The font size. */
export type CheckoutBrandingFontSize = {
  __typename?: 'CheckoutBrandingFontSize';
  /** The base font size. */
  base?: Maybe<Scalars['Float']['output']>;
  /** The scale ratio used to derive all font sizes such as small and large. */
  ratio?: Maybe<Scalars['Float']['output']>;
};

/** The input fields used to update the font size. */
export type CheckoutBrandingFontSizeInput = {
  /** The base font size. Its value should be between 12.0 and 18.0. */
  base?: InputMaybe<Scalars['Float']['input']>;
  /** The scale ratio used to derive all font sizes such as small and large. Its value should be between 1.0 and 1.4. */
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

/** A container for the footer section customizations. */
export type CheckoutBrandingFooter = {
  __typename?: 'CheckoutBrandingFooter';
  /** The footer alignment. */
  alignment?: Maybe<CheckoutBrandingFooterAlignment>;
  /** The selected color scheme of the footer container. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The footer content settings. */
  content?: Maybe<CheckoutBrandingFooterContent>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The padding of the footer container. */
  padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The footer position. */
  position?: Maybe<CheckoutBrandingFooterPosition>;
};

/** Possible values for the footer alignment. */
export enum CheckoutBrandingFooterAlignment {
  /** The checkout footer alignment Center value. */
  Center = 'CENTER',
  /** The checkout footer alignment End value. */
  End = 'END',
  /** The checkout footer alignment Start value. */
  Start = 'START'
}

/** The footer content customizations. */
export type CheckoutBrandingFooterContent = {
  __typename?: 'CheckoutBrandingFooterContent';
  /** The visibility of the footer content. Shopify reserves the right to add required legal notices to the footer and prevent them from being modified or hidden. This setting doesn't control the visibility of those notices. */
  visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields for footer content customizations. */
export type CheckoutBrandingFooterContentInput = {
  /** The visibility of the footer content. Shopify reserves the right to add required legal notices to the footer and prevent them from being modified or hidden. This setting doesn't control the visibility of those notices. */
  visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The input fields when mutating the checkout footer settings. */
export type CheckoutBrandingFooterInput = {
  /** The footer alignment settings. You can set the footer native content alignment to the left, center, or right. */
  alignment?: InputMaybe<CheckoutBrandingFooterAlignment>;
  /** The selected color scheme of the footer container. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The input field for setting the footer content customizations. */
  content?: InputMaybe<CheckoutBrandingFooterContentInput>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The padding of the footer container. */
  padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The input field for setting the footer position customizations. */
  position?: InputMaybe<CheckoutBrandingFooterPosition>;
};

/** Possible values for the footer position. */
export enum CheckoutBrandingFooterPosition {
  /** The End footer position. */
  End = 'END',
  /** The Inline footer position. */
  Inline = 'INLINE'
}

/** The global customizations. */
export type CheckoutBrandingGlobal = {
  __typename?: 'CheckoutBrandingGlobal';
  /**
   * The global corner radius setting that overrides all other [corner radius](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
   * customizations.
   */
  cornerRadius?: Maybe<CheckoutBrandingGlobalCornerRadius>;
  /** The global typography customizations. */
  typography?: Maybe<CheckoutBrandingTypographyStyleGlobal>;
};

/**
 * Possible choices to override corner radius customizations on all applicable objects. Note that this selection
 * can only be used to set the override to `NONE` (0px).
 *
 * For more customizations options, set the [corner radius](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
 * selection on specific objects while leaving the global corner radius unset.
 */
export enum CheckoutBrandingGlobalCornerRadius {
  /** Set the global corner radius override to 0px (square corners). */
  None = 'NONE'
}

/** The input fields used to update the global customizations. */
export type CheckoutBrandingGlobalInput = {
  /**
   * Select a global corner radius setting that overrides all other [corner radii](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
   * customizations.
   */
  cornerRadius?: InputMaybe<CheckoutBrandingGlobalCornerRadius>;
  /** The global typography customizations. */
  typography?: InputMaybe<CheckoutBrandingTypographyStyleGlobalInput>;
};

/** The header customizations. */
export type CheckoutBrandingHeader = {
  __typename?: 'CheckoutBrandingHeader';
  /** The header alignment. */
  alignment?: Maybe<CheckoutBrandingHeaderAlignment>;
  /** The background image of the header. */
  banner?: Maybe<CheckoutBrandingImage>;
  /** The cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  cartLink?: Maybe<CheckoutBrandingHeaderCartLink>;
  /** The selected color scheme of the header container. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The divided setting. */
  divided?: Maybe<Scalars['Boolean']['output']>;
  /** The store logo. */
  logo?: Maybe<CheckoutBrandingLogo>;
  /** The padding of the header container. */
  padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The header position. */
  position?: Maybe<CheckoutBrandingHeaderPosition>;
};

/** The possible header alignments. */
export enum CheckoutBrandingHeaderAlignment {
  /** Center alignment. */
  Center = 'CENTER',
  /** End alignment. */
  End = 'END',
  /** Start alignment. */
  Start = 'START'
}

/** The header cart link customizations. */
export type CheckoutBrandingHeaderCartLink = {
  __typename?: 'CheckoutBrandingHeaderCartLink';
  /** The content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  contentType?: Maybe<CheckoutBrandingCartLinkContentType>;
  /** The image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  image?: Maybe<Image>;
};

/** The input fields for header cart link customizations. */
export type CheckoutBrandingHeaderCartLinkInput = {
  /** The input for the content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  contentType?: InputMaybe<CheckoutBrandingCartLinkContentType>;
  /** The input for the image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  image?: InputMaybe<CheckoutBrandingImageInput>;
};

/** The input fields used to update the header customizations. */
export type CheckoutBrandingHeaderInput = {
  /** The header alignment. */
  alignment?: InputMaybe<CheckoutBrandingHeaderAlignment>;
  /** The background image of the header (must not be of SVG format). */
  banner?: InputMaybe<CheckoutBrandingImageInput>;
  /** The input for cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  cartLink?: InputMaybe<CheckoutBrandingHeaderCartLinkInput>;
  /** The selected color scheme of the header container. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The divided setting. */
  divided?: InputMaybe<Scalars['Boolean']['input']>;
  /** The store logo. */
  logo?: InputMaybe<CheckoutBrandingLogoInput>;
  /** The padding of the header container. */
  padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The header position. */
  position?: InputMaybe<CheckoutBrandingHeaderPosition>;
};

/** The possible header positions. */
export enum CheckoutBrandingHeaderPosition {
  /** Inline position. */
  Inline = 'INLINE',
  /** Secondary inline position. */
  InlineSecondary = 'INLINE_SECONDARY',
  /** Start position. */
  Start = 'START'
}

/** The heading level customizations. */
export type CheckoutBrandingHeadingLevel = {
  __typename?: 'CheckoutBrandingHeadingLevel';
  /** The typography customizations used for headings. */
  typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields for heading level customizations. */
export type CheckoutBrandingHeadingLevelInput = {
  /** The typography customizations used for headings. */
  typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/** A checkout branding image. */
export type CheckoutBrandingImage = {
  __typename?: 'CheckoutBrandingImage';
  /** The image details. */
  image?: Maybe<Image>;
};

/** The input fields used to update a checkout branding image uploaded via the Files API. */
export type CheckoutBrandingImageInput = {
  /** A globally-unique ID. */
  mediaImageId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields used to upsert the checkout branding settings. */
export type CheckoutBrandingInput = {
  /** The customizations that apply to specific components or areas of the user interface. */
  customizations?: InputMaybe<CheckoutBrandingCustomizationsInput>;
  /**
   * The design system allows you to set values that represent specific attributes
   * of your brand like color and font. These attributes are used throughout the user
   * interface. This brings consistency and allows you to easily make broad design changes.
   */
  designSystem?: InputMaybe<CheckoutBrandingDesignSystemInput>;
};

/** Possible values for the label position. */
export enum CheckoutBrandingLabelPosition {
  /** The Inside label position. */
  Inside = 'INSIDE',
  /** The Outside label position. */
  Outside = 'OUTSIDE'
}

/** The store logo customizations. */
export type CheckoutBrandingLogo = {
  __typename?: 'CheckoutBrandingLogo';
  /** The logo image. */
  image?: Maybe<Image>;
  /** The maximum width of the logo. */
  maxWidth?: Maybe<Scalars['Int']['output']>;
  /** The visibility of the logo. */
  visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields used to update the logo customizations. */
export type CheckoutBrandingLogoInput = {
  /** The logo image (must not be of SVG format). */
  image?: InputMaybe<CheckoutBrandingImageInput>;
  /** The maximum width of the logo. */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  /** The visibility of the logo. */
  visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The main container customizations. */
export type CheckoutBrandingMain = {
  __typename?: 'CheckoutBrandingMain';
  /** The background image of the main container. */
  backgroundImage?: Maybe<CheckoutBrandingImage>;
  /** The selected color scheme of the main container. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The main container's divider style and visibility. */
  divider?: Maybe<CheckoutBrandingContainerDivider>;
  /** The settings for the main sections. */
  section?: Maybe<CheckoutBrandingMainSection>;
};

/** The input fields used to update the main container customizations. */
export type CheckoutBrandingMainInput = {
  /** The background image of the main container (must not be of SVG format). */
  backgroundImage?: InputMaybe<CheckoutBrandingImageInput>;
  /** The selected color scheme for the main container of the checkout. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** Divider style and visibility on the main container. */
  divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
  /** The settings for the main sections. */
  section?: InputMaybe<CheckoutBrandingMainSectionInput>;
};

/** The main sections customizations. */
export type CheckoutBrandingMainSection = {
  __typename?: 'CheckoutBrandingMainSection';
  /** The background style of the main sections. */
  background?: Maybe<CheckoutBrandingBackground>;
  /** The border for the main sections. */
  border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme of the main sections. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the main sections. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: Maybe<CheckoutBrandingShadow>;
};

/** The input fields used to update the main sections customizations. */
export type CheckoutBrandingMainSectionInput = {
  /** The background style of the main sections. */
  background?: InputMaybe<CheckoutBrandingBackground>;
  /** The border for the main sections. */
  border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the main sections. */
  borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width of the main sections. */
  borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme for the main sections. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the main sections. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The padding of the main sections. */
  padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  shadow?: InputMaybe<CheckoutBrandingShadow>;
};

/** The merchandise thumbnails customizations. */
export type CheckoutBrandingMerchandiseThumbnail = {
  __typename?: 'CheckoutBrandingMerchandiseThumbnail';
  /** The settings for the merchandise thumbnail badge. */
  badge?: Maybe<CheckoutBrandingMerchandiseThumbnailBadge>;
  /** The border used for merchandise thumbnails. */
  border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for merchandise thumbnails. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The property used to customize how the product image fits within merchandise thumbnails. */
  fit?: Maybe<CheckoutBrandingObjectFit>;
};

/** The merchandise thumbnail badges customizations. */
export type CheckoutBrandingMerchandiseThumbnailBadge = {
  __typename?: 'CheckoutBrandingMerchandiseThumbnailBadge';
  /** The background used for merchandise thumbnail badges. */
  background?: Maybe<CheckoutBrandingMerchandiseThumbnailBadgeBackground>;
};

/** The merchandise thumbnail badge background. */
export enum CheckoutBrandingMerchandiseThumbnailBadgeBackground {
  /** The Accent background. */
  Accent = 'ACCENT',
  /** The Base background. */
  Base = 'BASE'
}

/** The input fields used to update the merchandise thumbnail badges customizations. */
export type CheckoutBrandingMerchandiseThumbnailBadgeInput = {
  /** The background used for merchandise thumbnail badges. */
  background?: InputMaybe<CheckoutBrandingMerchandiseThumbnailBadgeBackground>;
};

/** The input fields used to update the merchandise thumbnails customizations. */
export type CheckoutBrandingMerchandiseThumbnailInput = {
  /** The settings for the merchandise thumbnail badge. */
  badge?: InputMaybe<CheckoutBrandingMerchandiseThumbnailBadgeInput>;
  /** The border used for merchandise thumbnails. */
  border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for merchandise thumbnails. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The property used to customize how the product image fits within merchandise thumbnails. */
  fit?: InputMaybe<CheckoutBrandingObjectFit>;
};

/** Possible values for object fit. */
export enum CheckoutBrandingObjectFit {
  /** The Contain value for fit. The image is scaled to maintain its aspect ratio while fitting within the containing box. The entire image is made to fill the box, while preserving its aspect ratio, so the image will be "letterboxed" if its aspect ratio does not match the aspect ratio of the box. This is the default value. */
  Contain = 'CONTAIN',
  /** The Cover value for fit. The image is sized to maintain its aspect ratio while filling the entire containing box. If the image’s aspect ratio does not match the aspect ratio of the containing box, then the object will be clipped to fit. */
  Cover = 'COVER'
}

/** The order summary customizations. */
export type CheckoutBrandingOrderSummary = {
  __typename?: 'CheckoutBrandingOrderSummary';
  /** The background image of the order summary container. */
  backgroundImage?: Maybe<CheckoutBrandingImage>;
  /** The selected color scheme of the order summary container. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The order summary container's divider style and visibility. */
  divider?: Maybe<CheckoutBrandingContainerDivider>;
  /** The settings for the order summary sections. */
  section?: Maybe<CheckoutBrandingOrderSummarySection>;
};

/** The input fields used to update the order summary container customizations. */
export type CheckoutBrandingOrderSummaryInput = {
  /** The background image of the order summary container (must not be of SVG format). */
  backgroundImage?: InputMaybe<CheckoutBrandingImageInput>;
  /** The selected color scheme for the order summary container of the checkout. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** Divider style and visibility on the order summary container. */
  divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
  /** The settings for the order summary sections. */
  section?: InputMaybe<CheckoutBrandingOrderSummarySectionInput>;
};

/** The order summary sections customizations. */
export type CheckoutBrandingOrderSummarySection = {
  __typename?: 'CheckoutBrandingOrderSummarySection';
  /** The background style of the order summary sections. */
  background?: Maybe<CheckoutBrandingBackground>;
  /** The border for the order summary sections. */
  border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme of the order summary sections. */
  colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the order summary sections. */
  cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  shadow?: Maybe<CheckoutBrandingShadow>;
};

/** The input fields used to update the order summary sections customizations. */
export type CheckoutBrandingOrderSummarySectionInput = {
  /** The background style of the order summary sections. */
  background?: InputMaybe<CheckoutBrandingBackground>;
  /** The border for the order summary sections. */
  border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme for the order summary sections. */
  colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the order summary sections. */
  cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  shadow?: InputMaybe<CheckoutBrandingShadow>;
};

/** The selects customizations. */
export type CheckoutBrandingSelect = {
  __typename?: 'CheckoutBrandingSelect';
  /** The border used for selects. */
  border?: Maybe<CheckoutBrandingBorder>;
  /** The typography customizations used for selects. */
  typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields used to update the selects customizations. */
export type CheckoutBrandingSelectInput = {
  /** The border used for selects. */
  border?: InputMaybe<CheckoutBrandingBorder>;
  /** The typography customizations used for selects. */
  typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/** The container shadow. */
export enum CheckoutBrandingShadow {
  /** The Base shadow. */
  Base = 'BASE',
  /** The Large 100 shadow. */
  Large_100 = 'LARGE_100',
  /** The Large 200 shadow. */
  Large_200 = 'LARGE_200',
  /** The Small 100 shadow. */
  Small_100 = 'SMALL_100',
  /** The Small 200 shadow. */
  Small_200 = 'SMALL_200'
}

/** A Shopify font. */
export type CheckoutBrandingShopifyFont = CheckoutBrandingFont & {
  __typename?: 'CheckoutBrandingShopifyFont';
  /** The font sources. */
  sources?: Maybe<Scalars['String']['output']>;
  /** The font weight. */
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The input fields used to update a Shopify font group. */
export type CheckoutBrandingShopifyFontGroupInput = {
  /** The base font weight. */
  baseWeight?: InputMaybe<Scalars['Int']['input']>;
  /** The bold font weight. */
  boldWeight?: InputMaybe<Scalars['Int']['input']>;
  /** The font loading strategy. */
  loadingStrategy?: InputMaybe<CheckoutBrandingFontLoadingStrategy>;
  /** The Shopify font name from [the list of available fonts](https://shopify.dev/themes/architecture/settings/fonts#available-fonts), such as `Alegreya Sans` or `Anonymous Pro`. */
  name: Scalars['String']['input'];
};

/** Possible values for the simple border. */
export enum CheckoutBrandingSimpleBorder {
  /** The Full simple border. */
  Full = 'FULL',
  /** The None simple border. */
  None = 'NONE'
}

/** Possible values for the spacing. */
export enum CheckoutBrandingSpacing {
  /** The Base spacing. */
  Base = 'BASE',
  /** The Extra Loose spacing. */
  ExtraLoose = 'EXTRA_LOOSE',
  /** The Extra Tight spacing. */
  ExtraTight = 'EXTRA_TIGHT',
  /** The Loose spacing. */
  Loose = 'LOOSE',
  /** The None spacing. */
  None = 'NONE',
  /** The Tight spacing. */
  Tight = 'TIGHT'
}

/** The spacing between UI elements. */
export enum CheckoutBrandingSpacingKeyword {
  /** The Base spacing. */
  Base = 'BASE',
  /** The Large spacing. */
  Large = 'LARGE',
  /** The Large 100 spacing. */
  Large_100 = 'LARGE_100',
  /** The Large 200 spacing. */
  Large_200 = 'LARGE_200',
  /** The Large 300 spacing. */
  Large_300 = 'LARGE_300',
  /** The Large 400 spacing. */
  Large_400 = 'LARGE_400',
  /** The Large 500 spacing. */
  Large_500 = 'LARGE_500',
  /** The None spacing. */
  None = 'NONE',
  /** The Small spacing. */
  Small = 'SMALL',
  /** The Small 100 spacing. */
  Small_100 = 'SMALL_100',
  /** The Small 200 spacing. */
  Small_200 = 'SMALL_200',
  /** The Small 300 spacing. */
  Small_300 = 'SMALL_300',
  /** The Small 400 spacing. */
  Small_400 = 'SMALL_400',
  /** The Small 500 spacing. */
  Small_500 = 'SMALL_500'
}

/** The text fields customizations. */
export type CheckoutBrandingTextField = {
  __typename?: 'CheckoutBrandingTextField';
  /** The border used for text fields. */
  border?: Maybe<CheckoutBrandingBorder>;
  /** The typography customizations used for text fields. */
  typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields used to update the text fields customizations. */
export type CheckoutBrandingTextFieldInput = {
  /** The border used for text fields. */
  border?: InputMaybe<CheckoutBrandingBorder>;
  /** The typography customizations used for text fields. */
  typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/**
 * The typography settings used for checkout-related text. Use these settings to customize the
 * font family and size for primary and secondary text elements.
 *
 * Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for further information on typography customization.
 */
export type CheckoutBrandingTypography = {
  __typename?: 'CheckoutBrandingTypography';
  /** A font group used for most components such as text, buttons and form controls. */
  primary?: Maybe<CheckoutBrandingFontGroup>;
  /** A font group used for heading components by default. */
  secondary?: Maybe<CheckoutBrandingFontGroup>;
  /** The font size design system (base size in pixels and scaling between different sizes). */
  size?: Maybe<CheckoutBrandingFontSize>;
};

/** The font selection. */
export enum CheckoutBrandingTypographyFont {
  /** The primary font. */
  Primary = 'PRIMARY',
  /** The secondary font. */
  Secondary = 'SECONDARY'
}

/**
 * The input fields used to update the typography. Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for more information on how to set these fields.
 */
export type CheckoutBrandingTypographyInput = {
  /** A font group used for most components such as text, buttons and form controls. */
  primary?: InputMaybe<CheckoutBrandingFontGroupInput>;
  /** A font group used for heading components by default. */
  secondary?: InputMaybe<CheckoutBrandingFontGroupInput>;
  /** The font size. */
  size?: InputMaybe<CheckoutBrandingFontSizeInput>;
};

/** Possible values for the typography kerning. */
export enum CheckoutBrandingTypographyKerning {
  /** Base or default kerning. */
  Base = 'BASE',
  /** Extra loose kerning, leaving even more space in between characters. */
  ExtraLoose = 'EXTRA_LOOSE',
  /** Loose kerning, leaving more space than the default in between characters. */
  Loose = 'LOOSE'
}

/** Possible values for the typography letter case. */
export enum CheckoutBrandingTypographyLetterCase {
  /** All letters are is lower case. */
  Lower = 'LOWER',
  /** No letter casing applied. */
  None = 'NONE',
  /** Capitalize the first letter of each word. */
  Title = 'TITLE',
  /** All letters are uppercase. */
  Upper = 'UPPER'
}

/**
 * Possible choices for the font size.
 *
 * Note that the value in pixels of these settings can be customized with the
 * [typography size](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CheckoutBrandingFontSizeInput)
 * object. Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for more information.
 */
export enum CheckoutBrandingTypographySize {
  /** The base font size. Example: 14px. */
  Base = 'BASE',
  /** The extra extra large font size. Example: 24px. */
  ExtraExtraLarge = 'EXTRA_EXTRA_LARGE',
  /** The extra large font size. Example: 21px. */
  ExtraLarge = 'EXTRA_LARGE',
  /** The extra small font size. Example: 10px. */
  ExtraSmall = 'EXTRA_SMALL',
  /** The large font size. Example: 19px. */
  Large = 'LARGE',
  /** The medium font size. Example: 16px. */
  Medium = 'MEDIUM',
  /** The small font size. Example: 12px. */
  Small = 'SMALL'
}

/** The typography customizations. */
export type CheckoutBrandingTypographyStyle = {
  __typename?: 'CheckoutBrandingTypographyStyle';
  /** The font. */
  font?: Maybe<CheckoutBrandingTypographyFont>;
  /** The kerning. */
  kerning?: Maybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: Maybe<CheckoutBrandingTypographyLetterCase>;
  /** The font size. */
  size?: Maybe<CheckoutBrandingTypographySize>;
  /** The font weight. */
  weight?: Maybe<CheckoutBrandingTypographyWeight>;
};

/** The global typography customizations. */
export type CheckoutBrandingTypographyStyleGlobal = {
  __typename?: 'CheckoutBrandingTypographyStyleGlobal';
  /** The kerning. */
  kerning?: Maybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: Maybe<CheckoutBrandingTypographyLetterCase>;
};

/** The input fields used to update the global typography customizations. */
export type CheckoutBrandingTypographyStyleGlobalInput = {
  /** The kerning. */
  kerning?: InputMaybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: InputMaybe<CheckoutBrandingTypographyLetterCase>;
};

/** The input fields used to update the typography customizations. */
export type CheckoutBrandingTypographyStyleInput = {
  /** The font. */
  font?: InputMaybe<CheckoutBrandingTypographyFont>;
  /** The kerning. */
  kerning?: InputMaybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  letterCase?: InputMaybe<CheckoutBrandingTypographyLetterCase>;
  /** The font size. */
  size?: InputMaybe<CheckoutBrandingTypographySize>;
  /** The font weight. */
  weight?: InputMaybe<CheckoutBrandingTypographyWeight>;
};

/** Possible values for the font weight. */
export enum CheckoutBrandingTypographyWeight {
  /** The base weight. */
  Base = 'BASE',
  /** The bold weight. */
  Bold = 'BOLD'
}

/** Return type for `checkoutBrandingUpsert` mutation. */
export type CheckoutBrandingUpsertPayload = {
  __typename?: 'CheckoutBrandingUpsertPayload';
  /** Returns the new checkout branding settings. */
  checkoutBranding?: Maybe<CheckoutBranding>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CheckoutBrandingUpsertUserError>;
};

/** An error that occurs during the execution of `CheckoutBrandingUpsert`. */
export type CheckoutBrandingUpsertUserError = DisplayableError & {
  __typename?: 'CheckoutBrandingUpsertUserError';
  /** The error code. */
  code?: Maybe<CheckoutBrandingUpsertUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CheckoutBrandingUpsertUserError`. */
export enum CheckoutBrandingUpsertUserErrorCode {
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR'
}

/** Possible visibility states. */
export enum CheckoutBrandingVisibility {
  /** The Hidden visibility setting. */
  Hidden = 'HIDDEN',
  /** The Visible visibility setting. */
  Visible = 'VISIBLE'
}

/** A checkout profile defines the branding settings and the UI extensions for a store's checkout. A checkout profile could be published or draft. A store might have at most one published checkout profile, which is used to render their live checkout. The store could also have multiple draft profiles that were created, previewed, and published using the admin checkout editor. */
export type CheckoutProfile = Node & {
  __typename?: 'CheckoutProfile';
  /** The date and time when the checkout profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the checkout profile was last edited. */
  editedAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the checkout profile is published or not. */
  isPublished: Scalars['Boolean']['output'];
  /** The profile name. */
  name: Scalars['String']['output'];
  /** Whether the checkout profile Thank You Page and Order Status Page are actively using extensibility or not. */
  typOspPagesActive: Scalars['Boolean']['output'];
  /** The date and time when the checkout profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CheckoutProfiles. */
export type CheckoutProfileConnection = {
  __typename?: 'CheckoutProfileConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CheckoutProfileEdge>;
  /** A list of nodes that are contained in CheckoutProfileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CheckoutProfile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CheckoutProfile and a cursor during pagination. */
export type CheckoutProfileEdge = {
  __typename?: 'CheckoutProfileEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CheckoutProfileEdge. */
  node: CheckoutProfile;
};

/** The set of valid sort keys for the CheckoutProfile query. */
export enum CheckoutProfileSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `edited_at` value. */
  EditedAt = 'EDITED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `is_published` value. */
  IsPublished = 'IS_PUBLISHED',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The input fields for adding products to the Combined Listing. */
export type ChildProductRelationInput = {
  /** The ID of the child product. */
  childProductId: Scalars['ID']['input'];
  /** The parent option values. */
  selectedParentOptionValues: Array<SelectedVariantOptionInput>;
};

/** The set of valid sort keys for the CodeDiscount query. */
export enum CodeDiscountSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `ends_at` value. */
  EndsAt = 'ENDS_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `starts_at` value. */
  StartsAt = 'STARTS_AT',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type Collection = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & Publishable & {
  __typename?: 'Collection';
  /** Collection duplicate operations involving this collection, either as a source (copying products from this collection to another) or a target (copying products to this collection from another). */
  activeOperations: CollectionOperations;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  availablePublicationsCount?: Maybe<Count>;
  /** The date and time when the collection was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A single-line, text-only description of the collection, stripped of any HTML tags and formatting that were included in the description. */
  description: Scalars['String']['output'];
  /** The description of the collection, including any HTML tags and formatting. This content is typically displayed to customers, such as on an online store, depending on the theme. */
  descriptionHtml: Scalars['HTML']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** Information about the collection that's provided through resource feedback. */
  feedback?: Maybe<ResourceFeedback>;
  /**
   * A unique string that identifies the collection. If a handle isn't specified when a collection is created, it's automatically generated from the collection's original title, and typically includes words from the title separated by hyphens. For example, a collection that was created with the title `Summer Catalog 2022` might have the handle `summer-catalog-2022`.
   *
   * If the title is changed, the handle doesn't automatically change.
   *
   * The handle can be used in themes by the Liquid templating language to refer to the collection, but using the ID is preferred because it never changes.
   */
  handle: Scalars['String']['output'];
  /** Whether the collection includes the specified product. */
  hasProduct: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image associated with the collection. */
  image?: Maybe<Image>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The products that are included in the collection. */
  products: ProductConnection;
  /** The number of products in the collection. */
  productsCount?: Maybe<Count>;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  publicationCount: Scalars['Int']['output'];
  /**
   * The channels where the collection is published.
   * @deprecated Use `resourcePublications` instead.
   */
  publications: CollectionPublicationConnection;
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  publishedOnCurrentChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  publishedOnPublication: Scalars['Boolean']['output'];
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  resourcePublications: ResourcePublicationConnection;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   */
  resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * By default, only publications to `APP` catalog types are returned.
   * For `Product` and `ProductVariant`, use the `catalogType` argument to retrieve
   * publications for other catalog types, such as `COMPANY_LOCATION` (B2B) or `MARKET`.
   * `Collection` only supports publications to `APP` catalog types.
   */
  resourcePublicationsV2: ResourcePublicationV2Connection;
  /**
   * Specifies the rules that determine whether a product is included.
   * @deprecated Use `sources` instead.
   */
  ruleSet?: Maybe<CollectionRuleSet>;
  /** If the default SEO fields for page title and description have been modified, contains the modified information. */
  seo: Seo;
  /** The order in which the products in the collection are displayed by default in the Shopify admin and in sales channels, such as an online store. */
  sortOrder: CollectionSortOrder;
  /** The sources that provide products for this collection. Each source represents a way products are included in the collection, such as through conditions and rules. */
  sources: Array<CollectionSource>;
  /**
   * The Storefront GraphQL API ID of the `Collection`.
   *
   * As of the `2022-04` version release, the Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  storefrontId: Scalars['StorefrontID']['output'];
  /**
   * Whether this collection is eligible to be referenced as a sub-collection from
   * another collection's source. Returns one state per role (inclusion / exclusion).
   *
   * Use this to filter ineligible targets up front and surface the reason.
   */
  subCollectionEligibility: CollectionSubCollectionEligibility;
  /** The suffix of the Liquid template being used to show the collection in an online store. For example, if the value is `custom`, then the collection is using the `collection.custom.liquid` template. If the value is `null`, then the collection is using the default `collection.liquid` template. */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /** The name of the collection. It's displayed in the Shopify admin and is typically displayed in sales channels, such as an online store. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  unpublishedPublications: PublicationConnection;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the collection was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionHasProductArgs = {
  id: Scalars['ID']['input'];
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductCollectionSortKeys>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionPublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionPublishedOnChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionPublishedOnPublicationArgs = {
  publicationId: Scalars['ID']['input'];
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Collection` object represents a group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that merchants can organize to make their stores easier to browse and help customers find related products.
 * Collections serve as the primary way to categorize and display products across
 * [online stores](https://shopify.dev/docs/apps/build/online-store),
 * [sales channels](https://shopify.dev/docs/apps/build/sales-channels), and marketing campaigns.
 *
 * The `Collection` object provides information to:
 *
 * - Organize products by category, season, or promotion.
 * - Automate product grouping using rules (for example, by tag, type, or price).
 * - Configure product sorting and display order (for example, alphabetical, best-selling, price, or manual).
 * - Manage collection visibility and publication across sales channels.
 * - Add rich descriptions, images, and metadata to enhance discovery.
 *
 * > Note:
 * > Collections are unpublished by default. To make them available to customers,
 * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
 * mutation after creation.
 *
 * Collections can be displayed in a store with Shopify's theme system through [Liquid templates](https://shopify.dev/docs/storefronts/themes/architecture/templates/collection)
 * and can be customized with [template suffixes](https://shopify.dev/docs/storefronts/themes/architecture/templates/alternate-templates)
 * for unique layouts. They also support advanced features like translated content, resource feedback,
 * and contextual publication for location-based catalogs.
 *
 * Learn about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
 */
export type CollectionUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `collectionAddProducts` mutation. */
export type CollectionAddProductsPayload = {
  __typename?: 'CollectionAddProductsPayload';
  /** The updated collection. Returns `null` if an error is raised. */
  collection?: Maybe<Collection>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `collectionAddProductsV2` mutation. */
export type CollectionAddProductsV2Payload = {
  __typename?: 'CollectionAddProductsV2Payload';
  /** The asynchronous job adding the products. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CollectionAddProductsV2UserError>;
};

/** An error that occurs during the execution of `CollectionAddProductsV2`. */
export type CollectionAddProductsV2UserError = DisplayableError & {
  __typename?: 'CollectionAddProductsV2UserError';
  /** The error code. */
  code?: Maybe<CollectionAddProductsV2UserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CollectionAddProductsV2UserError`. */
export enum CollectionAddProductsV2UserErrorCode {
  /** Can't manually add products to a smart collection. */
  CantAddToSmartCollection = 'CANT_ADD_TO_SMART_COLLECTION',
  /** Collection doesn't exist. */
  CollectionDoesNotExist = 'COLLECTION_DOES_NOT_EXIST'
}

/** A non-metaobject metafield definition usable as a collection condition. */
export type CollectionConditionBasicMetafieldDefinition = CollectionConditionMetafieldDefinitionInterface & {
  __typename?: 'CollectionConditionBasicMetafieldDefinition';
  /** The description of the metafield definition. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the underlying metafield definition. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The human-readable name of the metafield definition. */
  name: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
  /** The data type of the metafield definition. */
  type: MetafieldDefinitionType;
  /** A list of validation options for the metafields that belong to the metafield definition. */
  validations: Array<MetafieldDefinitionValidation>;
};

/** Specifies whether products must match any or all conditions to be included in the collection. */
export enum CollectionConditionMatchType {
  /** Products match only if they satisfy all of the conditions. */
  All = 'ALL',
  /** Products match if they satisfy one or more of the conditions. */
  Any = 'ANY'
}

/** Common fields exposed by every metafield definition usable as a collection condition. */
export type CollectionConditionMetafieldDefinitionInterface = {
  /** The description of the metafield definition. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the underlying metafield definition. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The human-readable name of the metafield definition. */
  name: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
  /** The data type of the metafield definition. */
  type: MetafieldDefinitionType;
  /** A list of validation options for the metafields that belong to the metafield definition. */
  validations: Array<MetafieldDefinitionValidation>;
};

/** A metaobject-reference metafield definition usable as a collection condition. */
export type CollectionConditionMetaobjectMetafieldDefinition = CollectionConditionMetafieldDefinitionInterface & {
  __typename?: 'CollectionConditionMetaobjectMetafieldDefinition';
  /** The description of the metafield definition. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the underlying metafield definition. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The metaobject definition referenced by this metafield definition. */
  metaobjectDefinition: MetaobjectDefinition;
  /** The human-readable name of the metafield definition. */
  name: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
  /** The data type of the metafield definition. */
  type: MetafieldDefinitionType;
  /** A list of validation options for the metafields that belong to the metafield definition. */
  validations: Array<MetafieldDefinitionValidation>;
};

/** A collection source that uses conditions and selections to determine which products are included. */
export type CollectionConditionsSource = CollectionSource & Node & {
  __typename?: 'CollectionConditionsSource';
  /** The app that created this source, if applicable. In the case of shareable sources, this app manages this source's conditions and selections exclusively. */
  app?: Maybe<App>;
  /** An optional description of the source. */
  description?: Maybe<Scalars['String']['output']>;
  /** The rules and selections for excluding products from the collection. */
  exclusion?: Maybe<CollectionSourceExclusion>;
  /** The unique identifier for this source. */
  id: Scalars['ID']['output'];
  /** The rules and selections for including products in the collection. */
  inclusion: CollectionSourceInclusion;
  /**
   * The products that are members of this source: products matched by the source's inclusion
   * conditions and manual selections, with the source's exclusion conditions, excluded
   * collections, and manual exclusions removed.
   */
  products: ProductConnection;
  /** Whether this source can be shared across multiple collections. */
  shareable: Scalars['Boolean']['output'];
  /** Whether conditions match products or individual variants. */
  targetType: CollectionSourceTargetType;
  /** The title of the source. */
  title: Scalars['String']['output'];
};


/** A collection source that uses conditions and selections to determine which products are included. */
export type CollectionConditionsSourceProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple CollectionConditionsSources. */
export type CollectionConditionsSourceConnection = {
  __typename?: 'CollectionConditionsSourceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionConditionsSourceEdge>;
  /** A list of nodes that are contained in CollectionConditionsSourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CollectionConditionsSource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `collectionConditionsSourceCreate` mutation. */
export type CollectionConditionsSourceCreatePayload = {
  __typename?: 'CollectionConditionsSourceCreatePayload';
  /** The created collection source. */
  source?: Maybe<CollectionConditionsSource>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `collectionConditionsSourceDelete` mutation. */
export type CollectionConditionsSourceDeletePayload = {
  __typename?: 'CollectionConditionsSourceDeletePayload';
  /** The ID of the deleted collection source. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one CollectionConditionsSource and a cursor during pagination. */
export type CollectionConditionsSourceEdge = {
  __typename?: 'CollectionConditionsSourceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionConditionsSourceEdge. */
  node: CollectionConditionsSource;
};

/** The set of valid sort keys for the CollectionConditionsSource query. */
export enum CollectionConditionsSourceSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** Return type for `collectionConditionsSourceUpdate` mutation. */
export type CollectionConditionsSourceUpdatePayload = {
  __typename?: 'CollectionConditionsSourceUpdatePayload';
  /** The updated collection source. */
  source?: Maybe<CollectionConditionsSource>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An app together with the shareable collection sources it publishes for the shop. */
export type CollectionConditionsSourcesByApp = {
  __typename?: 'CollectionConditionsSourcesByApp';
  /** The app that publishes the collection sources. */
  app: App;
  /** The shareable collection sources owned by this app. */
  sources: CollectionConditionsSourceConnection;
};


/** An app together with the shareable collection sources it publishes for the shop. */
export type CollectionConditionsSourcesByAppSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CollectionConditionsSourceSortKeys>;
};

/** An auto-generated type for paginating through multiple CollectionConditionsSourcesByApps. */
export type CollectionConditionsSourcesByAppConnection = {
  __typename?: 'CollectionConditionsSourcesByAppConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionConditionsSourcesByAppEdge>;
  /** A list of nodes that are contained in CollectionConditionsSourcesByAppEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CollectionConditionsSourcesByApp>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CollectionConditionsSourcesByApp and a cursor during pagination. */
export type CollectionConditionsSourcesByAppEdge = {
  __typename?: 'CollectionConditionsSourcesByAppEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionConditionsSourcesByAppEdge. */
  node: CollectionConditionsSourcesByApp;
};

/** An auto-generated type for paginating through multiple Collections. */
export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionEdge>;
  /** A list of nodes that are contained in CollectionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Collection>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields required to create a collection source. */
export type CollectionCreateConditionsSourceInput = {
  /** An optional description of the source. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The exclusion rules for the source. */
  exclusion?: InputMaybe<CollectionCreateSourceExclusionInput>;
  /** The inclusion rules for the source. */
  inclusion?: InputMaybe<CollectionCreateSourceInclusionInput>;
  /** What granularity this source operates at. Defaults to PRODUCTS. */
  targetType?: InputMaybe<CollectionSourceTargetType>;
  /** The title of the source. */
  title: Scalars['String']['input'];
};

/** The input fields required to create a collection. */
export type CollectionCreateInput = {
  /** The description of the collection, in HTML format. */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** A unique human-friendly string for the collection. Automatically generated from the collection's title. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The image associated with the collection. */
  image?: InputMaybe<ImageInput>;
  /** The metafields to associate with the collection. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** SEO information for the collection. */
  seo?: InputMaybe<SeoInput>;
  /** The order in which the collection's products are sorted. */
  sortOrder?: InputMaybe<CollectionSortOrder>;
  /** The sources to create for the collection. */
  sources?: InputMaybe<Array<CollectionCreateSourceTargetInput>>;
  /** The theme template used when viewing the collection in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the collection. */
  title: Scalars['String']['input'];
};

/** Return type for `collectionCreate` mutation. */
export type CollectionCreatePayload = {
  __typename?: 'CollectionCreatePayload';
  /** The collection that has been created. */
  collection?: Maybe<Collection>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for creating exclusion rules for a collection source. */
export type CollectionCreateSourceExclusionInput = {
  /** The conditions that products must match to be excluded from the collection. */
  conditions?: InputMaybe<Array<CollectionSourceExclusionConditionInput>>;
  /** Whether products must match all or any of the conditions to be excluded. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The products to explicitly exclude from the collection. */
  selections?: InputMaybe<Array<CollectionExclusionProductSelectionInput>>;
};

/** The input fields for creating inclusion rules for a collection source. */
export type CollectionCreateSourceInclusionInput = {
  /** The conditions that products must match to be included in the collection. */
  conditions?: InputMaybe<Array<CollectionSourceInclusionConditionInput>>;
  /** Whether products must match all or any of the conditions. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The products to explicitly include in the collection. */
  selections?: InputMaybe<Array<CollectionInclusionProductSelectionInput>>;
};

/** The input fields for adding a source to a collection — provide exactly one field that represents the type of source to create. */
export type CollectionCreateSourceTargetInput = {
  /** An existing shareable source to link to the collection. */
  shareableSource?: InputMaybe<CollectionShareableSourceInput>;
  /** Net new conditions-based source (target_type products or variants) to create — must belong to one collection. */
  source?: InputMaybe<CollectionCreateConditionsSourceInput>;
  /** Net new sub-collection source (target_type collections) whose membership comes from one or more referenced collections. */
  subCollections?: InputMaybe<CollectionCreateSubCollectionsSourceInput>;
};

/** The input fields required to create a sub-collection source — a source whose membership comes from one or more referenced collections. */
export type CollectionCreateSubCollectionsSourceInput = {
  /** The global IDs of the sub-collections whose products supply this source. */
  collectionIds: Array<Scalars['ID']['input']>;
  /** An optional description of the source. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The title of the source. */
  title: Scalars['String']['input'];
};

/** The input fields for specifying the collection to delete. */
export type CollectionDeleteInput = {
  /** The ID of the collection to be deleted. */
  id: Scalars['ID']['input'];
};

/** Return type for `collectionDelete` mutation. */
export type CollectionDeletePayload = {
  __typename?: 'CollectionDeletePayload';
  /** The ID of the collection that was deleted. Returns `null` if the collection doesn't exist. */
  deletedCollectionId?: Maybe<Scalars['ID']['output']>;
  /** The shop associated with the collection. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for duplicating a collection. */
export type CollectionDuplicateInput = {
  /** The ID of the collection to be duplicated. */
  collectionId: Scalars['ID']['input'];
  /** Whether to duplicate the collection's publications (channel availability). When `true` (default), the duplicated collection will be published to the same channels as the original. When `false`, the duplicated collection will be unpublished on all channels. */
  copyPublications?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new title of the collection. */
  newTitle: Scalars['String']['input'];
};

/** Represents an in-progress collection duplication operation. Collection duplication is a synchronous operation for simple collections, and an asynchronous operation for collections containing too many products to process synchronously. */
export type CollectionDuplicateOperation = {
  __typename?: 'CollectionDuplicateOperation';
  /** Whether the collection is the source that products are being duplicated from, or the target collection that products are being duplicated onto. */
  collectionRole: CollectionDuplicateOperationRole;
  /** The background job performing the duplication. */
  job: Job;
};

/** The role a collection plays in a duplication operation. */
export enum CollectionDuplicateOperationRole {
  /** Products are being duplicated from this collection. */
  Source = 'SOURCE',
  /** Products are being duplicated onto this collection. */
  Target = 'TARGET'
}

/** Return type for `collectionDuplicate` mutation. */
export type CollectionDuplicatePayload = {
  __typename?: 'CollectionDuplicatePayload';
  /**
   * The newly created duplicate collection. Will contain all data if duplication completed synchronously.
   * If async processing is required, the collection will be created but products will be added in the background
   * and can be tracked via the job field or the collection's active_operations field.
   */
  collection?: Maybe<Collection>;
  /** The background job copying manually included products onto the target collection. Only returned if async processing is required, otherwise products will be copied synchronously when the collection is created. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CollectionDuplicateUserError>;
};

/** Errors related to collection duplication. */
export type CollectionDuplicateUserError = DisplayableError & {
  __typename?: 'CollectionDuplicateUserError';
  /** The error code. */
  code?: Maybe<CollectionDuplicateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CollectionDuplicateUserError`. */
export enum CollectionDuplicateUserErrorCode {
  /** The collection title must not be blank. */
  Blank = 'BLANK',
  /** The collection was not found. Please check the collection ID and try again. */
  CollectionNotFound = 'COLLECTION_NOT_FOUND',
  /** The duplicated collection isn't valid. */
  Invalid = 'INVALID',
  /** The URL handle generated from the new title is already in use. Please choose a different title. */
  Taken = 'TAKEN',
  /** The collection title or URL handle is too long. */
  TooLong = 'TOO_LONG',
  /** The shop has reached its limit of collection sources with conditions. */
  TooManyConditionBackedSources = 'TOO_MANY_CONDITION_BACKED_SOURCES',
  /** The shop has reached its limit of collections with sub-collection exclusions. */
  TooManySubCollectionExclusionCollections = 'TOO_MANY_SUB_COLLECTION_EXCLUSION_COLLECTIONS',
  /** The shop has reached its limit of collections with sub-collection inclusions. */
  TooManySubCollectionInclusionCollections = 'TOO_MANY_SUB_COLLECTION_INCLUSION_COLLECTIONS'
}

/** An auto-generated type which holds one Collection and a cursor during pagination. */
export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionEdge. */
  node: Collection;
};

/** Represents a product that has been manually selected for exclusion from a collection. */
export type CollectionExclusionProductSelection = {
  __typename?: 'CollectionExclusionProductSelection';
  /** The product that's manually excluded from the collection. */
  product: Product;
};

/** An auto-generated type for paginating through multiple CollectionExclusionProductSelections. */
export type CollectionExclusionProductSelectionConnection = {
  __typename?: 'CollectionExclusionProductSelectionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionExclusionProductSelectionEdge>;
  /** A list of nodes that are contained in CollectionExclusionProductSelectionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CollectionExclusionProductSelection>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CollectionExclusionProductSelection and a cursor during pagination. */
export type CollectionExclusionProductSelectionEdge = {
  __typename?: 'CollectionExclusionProductSelectionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionExclusionProductSelectionEdge. */
  node: CollectionExclusionProductSelection;
};

/** The input fields for selecting specific products to exclude from a collection. */
export type CollectionExclusionProductSelectionInput = {
  /** The ID of the product to exclude from the collection. */
  productId: Scalars['ID']['input'];
};

/** The input fields for identifying a collection. */
export type CollectionIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the collection. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The handle of the collection. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the collection. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents a product that has been manually selected for inclusion in a collection. */
export type CollectionInclusionProductSelection = {
  __typename?: 'CollectionInclusionProductSelection';
  /** The product that's manually included in the collection. */
  product: Product;
  /**
   * The IDs of variants of this product that have been manually included
   * in the collection. Null when no variant-level manual selections exist
   * for this product; non-empty when one or more variants have been
   * manually included.
   */
  variantIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An auto-generated type for paginating through multiple CollectionInclusionProductSelections. */
export type CollectionInclusionProductSelectionConnection = {
  __typename?: 'CollectionInclusionProductSelectionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionInclusionProductSelectionEdge>;
  /** A list of nodes that are contained in CollectionInclusionProductSelectionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CollectionInclusionProductSelection>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CollectionInclusionProductSelection and a cursor during pagination. */
export type CollectionInclusionProductSelectionEdge = {
  __typename?: 'CollectionInclusionProductSelectionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionInclusionProductSelectionEdge. */
  node: CollectionInclusionProductSelection;
};

/** The input fields for selecting specific products to include in a collection. */
export type CollectionInclusionProductSelectionInput = {
  /** The ID of the product to include in the collection. */
  productId: Scalars['ID']['input'];
  /** The IDs of the product variants to include in the collection. */
  variantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields required to create a collection. */
export type CollectionInput = {
  /** The description of the collection, in HTML format. */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** A unique human-friendly string for the collection. Automatically generated from the collection's title. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the collection to update or create a new collection if absent. Required for updating a collection. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The image associated with the collection. */
  image?: InputMaybe<ImageInput>;
  /** The metafields to associate with the collection. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** Initial list of collection products. Only valid with `collectionCreate`. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Indicates whether a redirect is required after a new handle has been provided.
   * If true, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The rules used to assign products to the collection. This is the legacy smart-collection model;
   * use `sources` with `conditions` instead. Each `ruleSet` rule has an equivalent `condition`.
   */
  ruleSet?: InputMaybe<CollectionRuleSetInput>;
  /** SEO information for the collection. */
  seo?: InputMaybe<SeoInput>;
  /** The order in which the collection's products are sorted. */
  sortOrder?: InputMaybe<CollectionSortOrder>;
  /** The theme template used when viewing the collection in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the collection. Required for creating a new collection. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Represents operations involving a collection. */
export type CollectionOperations = {
  __typename?: 'CollectionOperations';
  /** Collection duplicate operations. */
  duplicate: Array<CollectionDuplicateOperation>;
};

/**
 * Represents the publication status and settings for a collection across different sales channels. This tracks where collections are published, when they were published, and any channel-specific configuration.
 *
 * For example, a "Holiday Gifts" collection might be published to the online store and Facebook Shop but not to the POS channel, with different publication dates for each channel based on marketing strategy.
 *
 * Use `CollectionPublication` to:
 * - Track collection visibility across multiple sales channels
 * - Manage channel-specific collection settings and availability
 * - Monitor publication history and timing for collections
 * - Control where collections appear in customer-facing channels
 * - Implement channel-specific collection management workflows
 *
 * Each publication record includes the channel information, publication status, and timing details. This enables merchants to control collection visibility strategically across their sales channels.
 *
 * Collections can have different publication settings per channel, allowing for targeted marketing and inventory management. For instance, wholesale collections might only be published to B2B channels while retail collections appear in consumer-facing channels.
 *
 * The publication system integrates with Shopify's broader channel management, ensuring collections appear consistently across the merchant's sales ecosystem while respecting channel-specific rules and permissions.
 *
 * Learn more about [sales channel management](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
 */
export type CollectionPublication = {
  __typename?: 'CollectionPublication';
  /**
   * The channel where the collection will be published.
   * @deprecated Use `publication` instead.
   */
  channel: Channel;
  /** The collection to be published on the publication. */
  collection: Collection;
  /** Whether the publication is published or not. */
  isPublished: Scalars['Boolean']['output'];
  /** The publication where the collection will be published. */
  publication: Publication;
  /** The date that the publication was or is going to be published. */
  publishDate: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CollectionPublications. */
export type CollectionPublicationConnection = {
  __typename?: 'CollectionPublicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CollectionPublicationEdge>;
  /** A list of nodes that are contained in CollectionPublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CollectionPublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CollectionPublication and a cursor during pagination. */
export type CollectionPublicationEdge = {
  __typename?: 'CollectionPublicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionPublicationEdge. */
  node: CollectionPublication;
};

/** The input fields for publications to which a collection will be published. */
export type CollectionPublicationInput = {
  /** The ID of the publication. */
  publicationId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for specifying a collection to publish and the sales channels to publish it to. */
export type CollectionPublishInput = {
  /** The channels where the collection will be published. */
  collectionPublications: Array<CollectionPublicationInput>;
  /** The collection to create or update publications for. */
  id: Scalars['ID']['input'];
};

/** Return type for `collectionPublish` mutation. */
export type CollectionPublishPayload = {
  __typename?: 'CollectionPublishPayload';
  /** The published collection. */
  collection?: Maybe<Collection>;
  /** The channels where the collection has been published. */
  collectionPublications?: Maybe<Array<CollectionPublication>>;
  /** The shop associated with the collection. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `collectionRemoveProducts` mutation. */
export type CollectionRemoveProductsPayload = {
  __typename?: 'CollectionRemoveProductsPayload';
  /** The asynchronous job removing the products. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `collectionReorderProducts` mutation. */
export type CollectionReorderProductsPayload = {
  __typename?: 'CollectionReorderProductsPayload';
  /** The asynchronous job reordering the products. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CollectionReorderProductsUserError>;
};

/** Errors related to order customer removal. */
export type CollectionReorderProductsUserError = DisplayableError & {
  __typename?: 'CollectionReorderProductsUserError';
  /** The error code. */
  code?: Maybe<CollectionReorderProductsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CollectionReorderProductsUserError`. */
export enum CollectionReorderProductsUserErrorCode {
  /** The collection was not found. Please check the collection ID and try again. */
  CollectionNotFound = 'COLLECTION_NOT_FOUND',
  /** The move is invalid. */
  InvalidMove = 'INVALID_MOVE',
  /** The collection is not manually sorted. Can't reorder products unless collection is manually sorted. */
  ManuallySortedCollection = 'MANUALLY_SORTED_COLLECTION',
  /** Products are currently being reordered. Please try again later. */
  TooManyAttemptsToReorderProducts = 'TOO_MANY_ATTEMPTS_TO_REORDER_PRODUCTS'
}

/** Represents at rule that's used to assign products to a collection. */
export type CollectionRule = {
  __typename?: 'CollectionRule';
  /** The attribute that the rule focuses on. For example, `title` or `product_type`. */
  column: CollectionRuleColumn;
  /** The value that the operator is applied to. For example, `Hats`. */
  condition: Scalars['String']['output'];
  /** The value that the operator is applied to. */
  conditionObject?: Maybe<CollectionRuleConditionObject>;
  /** The type of operator that the rule is based on. For example, `equals`, `contains`, or `not_equals`. */
  relation: CollectionRuleRelation;
};

/** Specifies the taxonomy category to used for the condition. */
export type CollectionRuleCategoryCondition = {
  __typename?: 'CollectionRuleCategoryCondition';
  /** The taxonomy category used as condition. */
  value: TaxonomyCategory;
};

/** Specifies the attribute of a product being used to populate the collection. */
export enum CollectionRuleColumn {
  /**
   * An attribute evaluated based on the `compare_at_price` attribute of the product's variants.
   * With `is_set` relation, the rule matches products with at least one variant with `compare_at_price` set.
   * With `is_not_set` relation, the rule matches matches products with at least one variant with `compare_at_price` not set.
   */
  IsPriceReduced = 'IS_PRICE_REDUCED',
  /**
   * This rule type is designed to dynamically include products in a collection based on their category id.
   * When a specific product category is set as a condition, this rule will match products that are directly assigned to the specified category.
   */
  ProductCategoryId = 'PRODUCT_CATEGORY_ID',
  /**
   * This rule type is designed to dynamically include products in a collection based on their category id.
   * When a specific product category is set as a condition, this rule will not only match products that are
   * directly assigned to the specified category but also include any products categorized under any descendant of that category.
   */
  ProductCategoryIdWithDescendants = 'PRODUCT_CATEGORY_ID_WITH_DESCENDANTS',
  /** This category includes metafield definitions that have the `useAsCollectionCondition` flag set to true. */
  ProductMetafieldDefinition = 'PRODUCT_METAFIELD_DEFINITION',
  /** The [`product_taxonomy_node_id`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-Product.fields.productCategory) attribute. */
  ProductTaxonomyNodeId = 'PRODUCT_TAXONOMY_NODE_ID',
  /** The [`tag`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-Product.fields.tags) attribute. */
  Tag = 'TAG',
  /** The [`title`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-Product.fields.title) attribute. */
  Title = 'TITLE',
  /** The [`type`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-Product.fields.productType) attribute. */
  Type = 'TYPE',
  /** The [`variant_compare_at_price`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-ProductVariant.fields.compareAtPrice) attribute. */
  VariantCompareAtPrice = 'VARIANT_COMPARE_AT_PRICE',
  /** The [`variant_inventory`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-ProductVariant.fields.inventoryQuantity) attribute. */
  VariantInventory = 'VARIANT_INVENTORY',
  /** This category includes metafield definitions that have the `useAsCollectionCondition` flag set to true. */
  VariantMetafieldDefinition = 'VARIANT_METAFIELD_DEFINITION',
  /** The [`variant_price`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-ProductVariant.fields.price) attribute. */
  VariantPrice = 'VARIANT_PRICE',
  /** The [`variant_title`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-ProductVariant.fields.title) attribute. */
  VariantTitle = 'VARIANT_TITLE',
  /** The [`variant_weight`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-ProductVariant.fields.inventoryItem.measurement.weight) attribute. */
  VariantWeight = 'VARIANT_WEIGHT',
  /** The [`vendor`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-Product.fields.vendor) attribute. */
  Vendor = 'VENDOR'
}

/** Specifies object for the condition of the rule. */
export type CollectionRuleConditionObject = CollectionRuleCategoryCondition | CollectionRuleMetafieldCondition | CollectionRuleProductCategoryCondition | CollectionRuleTextCondition;

/**
 * Defines the available columns and relationships that can be used when creating rules for collections. This provides the schema for building automated collection logic based on product attributes.
 *
 * For example, merchants can create rules like "product type equals 'Shirts'" or "vendor contains 'Nike'" using the conditions defined in this object to automatically populate collections.
 *
 * Use `CollectionRuleConditions` to:
 * - Discovering valid field options for collection rule interfaces
 * - Understanding which conditions are available for automated collections
 * - Exploring available product attributes for collection automation
 * - Learning about proper field relationships for rule implementation
 *
 * The conditions define which product fields can be used in collection rules and what types of comparisons are allowed for each field.
 *
 * Learn more about [collections with conditions](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
 */
export type CollectionRuleConditions = {
  __typename?: 'CollectionRuleConditions';
  /** Allowed relations of the rule. */
  allowedRelations: Array<CollectionRuleRelation>;
  /** Most commonly used relation for this rule. */
  defaultRelation: CollectionRuleRelation;
  /** Additional attributes defining the rule. */
  ruleObject?: Maybe<CollectionRuleConditionsRuleObject>;
  /** Type of the rule. */
  ruleType: CollectionRuleColumn;
};

/** Specifies object with additional rule attributes. */
export type CollectionRuleConditionsRuleObject = CollectionRuleMetafieldCondition;

/** The input fields for a rule to associate with a collection. */
export type CollectionRuleInput = {
  /** The attribute that the rule focuses on. For example, `title` or `product_type`. */
  column: CollectionRuleColumn;
  /** The value that the operator is applied to. For example, `Hats`. */
  condition: Scalars['String']['input'];
  /**
   * The object ID that points to additional attributes for the collection rule.
   * This is only required when using metafield definition rules.
   */
  conditionObjectId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of operator that the rule is based on. For example, `equals`, `contains`, or `not_equals`. */
  relation: CollectionRuleRelation;
};

/** Identifies a metafield definition used as a rule for the collection. */
export type CollectionRuleMetafieldCondition = {
  __typename?: 'CollectionRuleMetafieldCondition';
  /** The metafield definition associated with the condition. */
  metafieldDefinition: MetafieldDefinition;
};

/** Specifies the condition for a Product Category field. */
export type CollectionRuleProductCategoryCondition = {
  __typename?: 'CollectionRuleProductCategoryCondition';
  /** The value of the condition. */
  value: ProductTaxonomyNode;
};

/** Specifies the relationship between the `column` and the `condition`. */
export enum CollectionRuleRelation {
  /** The attribute contains the condition. */
  Contains = 'CONTAINS',
  /** The attribute ends with the condition. */
  EndsWith = 'ENDS_WITH',
  /** The attribute is equal to the condition. */
  Equals = 'EQUALS',
  /** The attribute is greater than the condition. */
  GreaterThan = 'GREATER_THAN',
  /** The attribute is not set (equal to `null`). */
  IsNotSet = 'IS_NOT_SET',
  /** The attribute is set (not equal to `null`). */
  IsSet = 'IS_SET',
  /** The attribute is less than the condition. */
  LessThan = 'LESS_THAN',
  /** The attribute does not contain the condition. */
  NotContains = 'NOT_CONTAINS',
  /** The attribute does not equal the condition. */
  NotEquals = 'NOT_EQUALS',
  /** The attribute starts with the condition. */
  StartsWith = 'STARTS_WITH'
}

/** The set of rules that are used to determine which products are included in the collection. */
export type CollectionRuleSet = {
  __typename?: 'CollectionRuleSet';
  /**
   * Whether products must match any or all of the rules to be included in the collection.
   * If true, then products must match at least one of the rules to be included in the collection.
   * If false, then products must match all of the rules to be included in the collection.
   */
  appliedDisjunctively: Scalars['Boolean']['output'];
  /** The rules used to assign products to the collection. */
  rules: Array<CollectionRule>;
};

/** The input fields for a rule set of the collection. */
export type CollectionRuleSetInput = {
  /**
   * Whether products must match any or all of the rules to be included in the collection.
   * If true, then products must match at least one of the rules to be included in the collection.
   * If false, then products must match all of the rules to be included in the collection.
   */
  appliedDisjunctively: Scalars['Boolean']['input'];
  /** The rules used to assign products to the collection. */
  rules?: InputMaybe<Array<CollectionRuleInput>>;
};

/** Specifies the condition for a text field. */
export type CollectionRuleTextCondition = {
  __typename?: 'CollectionRuleTextCondition';
  /** The value of the condition. */
  value: Scalars['String']['output'];
};

/** The input fields for linking an existing shareable source to a collection. */
export type CollectionShareableSourceInput = {
  /** The ID of an existing shareable source to link to the collection. */
  sourceId: Scalars['ID']['input'];
};

/** The set of valid sort keys for the Collection query. */
export enum CollectionSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Specifies the sort order for the products in the collection. */
export enum CollectionSortOrder {
  /** Alphabetically, in ascending order (A - Z). */
  AlphaAsc = 'ALPHA_ASC',
  /** Alphabetically, in descending order (Z - A). */
  AlphaDesc = 'ALPHA_DESC',
  /** By best-selling products. */
  BestSelling = 'BEST_SELLING',
  /** By date created, in ascending order (oldest - newest). */
  Created = 'CREATED',
  /** By date created, in descending order (newest - oldest). */
  CreatedDesc = 'CREATED_DESC',
  /** In the order set manually by the merchant. */
  Manual = 'MANUAL',
  /** By most relevant products. */
  MostRelevant = 'MOST_RELEVANT',
  /** By price, in ascending order (lowest - highest). */
  PriceAsc = 'PRICE_ASC',
  /** By price, in descending order (highest - lowest). */
  PriceDesc = 'PRICE_DESC'
}

/** A source that provides products for a collection. */
export type CollectionSource = {
  /** The app that created this source, if applicable. In the case of shareable sources, this app manages this source's conditions and selections exclusively. */
  app?: Maybe<App>;
  /** An optional description of the source. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this source. */
  id: Scalars['ID']['output'];
  /** The title of the source. */
  title: Scalars['String']['output'];
};

/** Defines the rules and selections for excluding products from a collection. */
export type CollectionSourceExclusion = {
  __typename?: 'CollectionSourceExclusion';
  /** The conditions that determine which products are excluded from the collection. */
  conditions: Array<CollectionSourceExclusionCondition>;
  /**
   * Specifies whether products must match any or all non-collection exclusion conditions. Collection exclusion
   * conditions are always applied independently with ANY semantics, so this field returns ANY for
   * collection-only exclusions and null when collection and non-collection exclusion conditions are mixed.
   */
  matchType?: Maybe<CollectionConditionMatchType>;
  /** The products that have been manually selected for exclusion from the collection. */
  selections: CollectionExclusionProductSelectionConnection;
};


/** Defines the rules and selections for excluding products from a collection. */
export type CollectionSourceExclusionSelectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A condition that determines which products should be excluded from a collection. */
export type CollectionSourceExclusionCondition = {
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
};

/** A condition based on collections for excluding products from a collection. */
export type CollectionSourceExclusionConditionCollection = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionCollection';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Collection exclusion conditions always match any referenced collection. */
  matchType: CollectionConditionMatchType;
  /** The collection values whose products are excluded. */
  values: Array<Collection>;
};

/** The input fields for an exclusion condition based on collections. */
export type CollectionSourceExclusionConditionCollectionInput = {
  /** The collection IDs whose products are excluded. */
  values: Array<Scalars['ID']['input']>;
};

/** The input fields for a condition that determines which products are excluded from a collection. Exactly one condition type must be provided. */
export type CollectionSourceExclusionConditionInput = {
  /** A condition based on collections. */
  collection?: InputMaybe<CollectionSourceExclusionConditionCollectionInput>;
  /** A condition based on product categories. */
  productCategory?: InputMaybe<CollectionSourceExclusionConditionProductCategoryInput>;
  /** A condition based on product tags. */
  productTag?: InputMaybe<CollectionSourceExclusionConditionProductTagInput>;
  /** A condition based on product types. */
  productType?: InputMaybe<CollectionSourceExclusionConditionProductTypeInput>;
  /** A condition based on product vendors. */
  productVendor?: InputMaybe<CollectionSourceExclusionConditionProductVendorInput>;
};

/** A condition based on product category IDs for excluding products from a collection. */
export type CollectionSourceExclusionConditionProductCategory = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionProductCategory';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product category ID and the condition values. */
  relation: CollectionSourceExclusionConditionProductCategoryRelation;
  /** The product category values to match against. */
  values: Array<CollectionSourceExclusionConditionProductCategoryValue>;
};

/** The input fields for an exclusion condition based on product categories. */
export type CollectionSourceExclusionConditionProductCategoryInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product category and the condition values. */
  relation: CollectionSourceExclusionConditionProductCategoryRelation;
  /** The product category values to match against. */
  values: Array<CollectionSourceExclusionConditionProductCategoryValueInput>;
};

/** The relation for comparing product categories in exclusion conditions. */
export enum CollectionSourceExclusionConditionProductCategoryRelation {
  /** The product category equals the specified value. */
  Equals = 'EQUALS'
}

/** A value for a product category exclusion condition. */
export type CollectionSourceExclusionConditionProductCategoryValue = {
  __typename?: 'CollectionSourceExclusionConditionProductCategoryValue';
  /** The product category to match against. */
  category: TaxonomyCategory;
  /** Whether to include descendants of the product category. */
  includeDescendants: Scalars['Boolean']['output'];
};

/** The input fields for a product category value in an exclusion condition. */
export type CollectionSourceExclusionConditionProductCategoryValueInput = {
  /** The ID of the product category. */
  categoryId: Scalars['ID']['input'];
  /** Whether to include descendants of the product category. */
  includeDescendants?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A condition based on product tags for excluding products from a collection. */
export type CollectionSourceExclusionConditionProductTag = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionProductTag';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product tag and the condition values. */
  relation: CollectionSourceExclusionConditionProductTagRelation;
  /** The tag values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for an exclusion condition based on product tags. */
export type CollectionSourceExclusionConditionProductTagInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product tag and the condition values. */
  relation: CollectionSourceExclusionConditionProductTagRelation;
  /** The tag values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relationship between the product tag and the condition values. */
export enum CollectionSourceExclusionConditionProductTagRelation {
  /** The product is tagged with the specified value. */
  TaggedWith = 'TAGGED_WITH'
}

/** A condition based on product types for excluding products from a collection. */
export type CollectionSourceExclusionConditionProductType = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionProductType';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product type and the condition values. */
  relation: CollectionSourceExclusionConditionProductTypeRelation;
  /** The product type values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for an exclusion condition based on product types. */
export type CollectionSourceExclusionConditionProductTypeInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product type and the condition values. */
  relation: CollectionSourceExclusionConditionProductTypeRelation;
  /** The product type values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relation for comparing product types in exclusion conditions. */
export enum CollectionSourceExclusionConditionProductTypeRelation {
  /** The product type contains the specified value. */
  Contains = 'CONTAINS',
  /** The product type equals the specified value. */
  Equals = 'EQUALS'
}

/** A condition based on product vendors for excluding products from a collection. */
export type CollectionSourceExclusionConditionProductVendor = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionProductVendor';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product vendor and the condition values. */
  relation: CollectionSourceExclusionConditionProductVendorRelation;
  /** The product vendor values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for an exclusion condition based on product vendors. */
export type CollectionSourceExclusionConditionProductVendorInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product vendor and the condition values. */
  relation: CollectionSourceExclusionConditionProductVendorRelation;
  /** The product vendor values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relation for comparing product vendors in exclusion conditions. */
export enum CollectionSourceExclusionConditionProductVendorRelation {
  /** The product vendor contains the specified value. */
  Contains = 'CONTAINS',
  /** The product vendor equals the specified value. */
  Equals = 'EQUALS'
}

/** An exclusion condition introduced in a newer API version that is not modeled by this version of the API. Clients should treat the relation and values as opaque strings. */
export type CollectionSourceExclusionConditionUnknown = CollectionSourceExclusionCondition & {
  __typename?: 'CollectionSourceExclusionConditionUnknown';
  /** The unique identifier for this exclusion condition. */
  id: Scalars['ID']['output'];
  /** Whether products must match any or all values. Null when the condition has no concept of a match type. */
  matchType?: Maybe<CollectionConditionMatchType>;
  /** The relation, as a raw string. Nullable and not coerced into an enum because the set of possible relations is open-ended for unknown condition types, and some future conditions may not have a relation at all. */
  relation?: Maybe<Scalars['String']['output']>;
  /** The condition values, as raw strings. Nullable because some future condition types may have no values at all. */
  values?: Maybe<Array<Scalars['String']['output']>>;
};

/** The input fields for updating an exclusion condition based on collections. */
export type CollectionSourceExclusionConditionUpdateCollectionInput = {
  /** The collection IDs whose products are excluded. */
  values: Array<Scalars['ID']['input']>;
};

/** The input fields for updating a condition that determines which products are excluded from a collection. Exactly one condition type must be provided. */
export type CollectionSourceExclusionConditionUpdateInput = {
  /** An update to an exclusion condition based on collections. */
  collection?: InputMaybe<CollectionSourceExclusionConditionUpdateCollectionInput>;
  /** An update to an exclusion condition based on product categories. */
  productCategory?: InputMaybe<CollectionSourceExclusionConditionUpdateProductCategoryInput>;
  /** An update to an exclusion condition based on product tags. */
  productTag?: InputMaybe<CollectionSourceExclusionConditionUpdateProductTagInput>;
  /** An update to an exclusion condition based on product types. */
  productType?: InputMaybe<CollectionSourceExclusionConditionUpdateProductTypeInput>;
  /** An update to an exclusion condition based on product vendors. */
  productVendor?: InputMaybe<CollectionSourceExclusionConditionUpdateProductVendorInput>;
};

/** The input fields for updating an exclusion condition based on product categories. */
export type CollectionSourceExclusionConditionUpdateProductCategoryInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product category and the condition values. */
  relation?: InputMaybe<CollectionSourceExclusionConditionProductCategoryRelation>;
  /** The product category values to match against. */
  values?: InputMaybe<Array<CollectionSourceExclusionConditionProductCategoryValueInput>>;
};

/** The input fields for updating an exclusion condition based on product tags. */
export type CollectionSourceExclusionConditionUpdateProductTagInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product tag and the condition values. */
  relation?: InputMaybe<CollectionSourceExclusionConditionProductTagRelation>;
  /** The tag values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating an exclusion condition based on product types. */
export type CollectionSourceExclusionConditionUpdateProductTypeInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product type and the condition values. */
  relation?: InputMaybe<CollectionSourceExclusionConditionProductTypeRelation>;
  /** The product type values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating an exclusion condition based on product vendors. */
export type CollectionSourceExclusionConditionUpdateProductVendorInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product vendor and the condition values. */
  relation?: InputMaybe<CollectionSourceExclusionConditionProductVendorRelation>;
  /** The product vendor values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Defines the rules and selections for including products in a collection. */
export type CollectionSourceInclusion = {
  __typename?: 'CollectionSourceInclusion';
  /** The conditions that determine which products are included in the collection. */
  conditions: Array<CollectionSourceInclusionCondition>;
  /** Specifies whether products must match any or all conditions. Only relevant when conditions are present. */
  matchType?: Maybe<CollectionConditionMatchType>;
  /** The products that have been manually selected for inclusion in the collection. */
  selections: CollectionInclusionProductSelectionConnection;
};


/** Defines the rules and selections for including products in a collection. */
export type CollectionSourceInclusionSelectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A condition that determines which products should be included in a collection.
 *
 * This is an interface implemented by a concrete type per condition kind (for example,
 * `CollectionSourceInclusionConditionProductTag` or `CollectionSourceInclusionConditionVariantTitle`).
 * Fields such as `relation` are defined on each concrete type and return a type-specific enum (for example,
 * `CollectionSourceInclusionConditionProductTagRelation` versus
 * `CollectionSourceInclusionConditionVariantTitleRelation`). Conditions are mutually exclusive concrete
 * types, but may contain overlapping field names such as `relation`. If your GraphQL tooling flags these
 * as ambiguous, give each field a distinct alias (for example, `tagRelation: relation` and
 * `variantTitleRelation: relation`) or use inline fragments.
 */
export type CollectionSourceInclusionCondition = {
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
};

/**
 * A condition that determines which products are included in a collection.
 *
 * Available condition types, grouped by what they filter on:
 *
 * - **Product attributes**: `productTag`, `productTitle`, `productType`, `productVendor`, `productStatus`,
 * `productCategory`.
 * - **Variant attributes**: `variantTitle`, `variantPrice`, `variantCompareAtPrice`, `variantInventory`,
 * `variantWeight`.
 * - **Pricing**: `isPriceReduced`.
 * - **Metafields**: `metafieldBoolean`, `metafieldDecimal`, `metafieldString`, `metafieldStringList`,
 * `metafieldMetaobject`, `metafieldMetaobjectList`, and either `metafieldInteger` or `metafieldInt` for
 * integer metafields. Use `metafieldInteger` before API version 2026-10 and `metafieldInt` from 2026-10
 * onward. `metafieldInteger` is deprecated as of 2026-10 and removed as of 2027-01.
 *
 * Each condition type specifies its own `relation` (for example, `EQUALS`, `CONTAINS`, `TAGGED_WITH`) and
 * value shape. Combine multiple conditions in a single source's `inclusion.conditions` list and use the
 * source's `matchType` to require that products match `ANY` or `ALL` of them.
 */
export type CollectionSourceInclusionConditionInput = {
  /** A condition based on boolean metafield values. */
  metafieldBoolean?: InputMaybe<CollectionSourceInclusionConditionMetafieldBooleanInput>;
  /** A condition based on decimal metafield values. */
  metafieldDecimal?: InputMaybe<CollectionSourceInclusionConditionMetafieldDecimalInput>;
  /** A condition based on integer metafield values. */
  metafieldInteger?: InputMaybe<CollectionSourceInclusionConditionMetafieldIntegerInput>;
  /** A condition based on single metaobject reference metafield values. */
  metafieldMetaobject?: InputMaybe<CollectionSourceInclusionConditionMetafieldMetaobjectInput>;
  /** A condition based on metaobject list reference metafield values. */
  metafieldMetaobjectList?: InputMaybe<CollectionSourceInclusionConditionMetafieldMetaobjectListInput>;
  /** A condition based on string metafield values. */
  metafieldString?: InputMaybe<CollectionSourceInclusionConditionMetafieldStringInput>;
  /** A condition based on string list metafield values. */
  metafieldStringList?: InputMaybe<CollectionSourceInclusionConditionMetafieldStringListInput>;
  /** A condition based on product categories. */
  productCategory?: InputMaybe<CollectionSourceInclusionConditionProductCategoryInput>;
  /** A condition based on product status. */
  productStatus?: InputMaybe<CollectionSourceInclusionConditionProductStatusInput>;
  /** A condition based on product tags. */
  productTag?: InputMaybe<CollectionSourceInclusionConditionProductTagInput>;
  /** A condition based on product titles. */
  productTitle?: InputMaybe<CollectionSourceInclusionConditionProductTitleInput>;
  /** A condition based on product types. */
  productType?: InputMaybe<CollectionSourceInclusionConditionProductTypeInput>;
  /** A condition based on product vendors. */
  productVendor?: InputMaybe<CollectionSourceInclusionConditionProductVendorInput>;
  /** A condition based on variant compare at prices. */
  variantCompareAtPrice?: InputMaybe<CollectionSourceInclusionConditionVariantCompareAtPriceInput>;
  /** A condition based on variant inventory quantities. */
  variantInventory?: InputMaybe<CollectionSourceInclusionConditionVariantInventoryInput>;
  /** A condition based on variant prices. */
  variantPrice?: InputMaybe<CollectionSourceInclusionConditionVariantPriceInput>;
  /** A condition based on variant titles. */
  variantTitle?: InputMaybe<CollectionSourceInclusionConditionVariantTitleInput>;
  /** A condition based on variant weights. */
  variantWeight?: InputMaybe<CollectionSourceInclusionConditionVariantWeightInput>;
};

/**
 * A condition that determines which products should be included in a collection.
 *
 * This is an interface implemented by a concrete type per condition kind (for example,
 * `CollectionSourceInclusionConditionProductTag` or `CollectionSourceInclusionConditionVariantTitle`).
 * Fields such as `relation` are defined on each concrete type and return a type-specific enum (for example,
 * `CollectionSourceInclusionConditionProductTagRelation` versus
 * `CollectionSourceInclusionConditionVariantTitleRelation`). Conditions are mutually exclusive concrete
 * types, but may contain overlapping field names such as `relation`. If your GraphQL tooling flags these
 * as ambiguous, give each field a distinct alias (for example, `tagRelation: relation` and
 * `variantTitleRelation: relation`) or use inline fragments.
 */
export type CollectionSourceInclusionConditionMetafield = {
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
};

/** A condition based on boolean metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldBoolean = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldBoolean';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the metafield value and the condition. */
  relation: CollectionSourceInclusionConditionMetafieldBooleanRelation;
  /** The boolean value to match against. */
  value: Scalars['Boolean']['output'];
};

/** The input fields for a condition based on boolean metafield values. */
export type CollectionSourceInclusionConditionMetafieldBooleanInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldBooleanRelation;
  /** The boolean value to match against. */
  value: Scalars['Boolean']['input'];
};

/** The relation for comparing boolean metafield values. */
export enum CollectionSourceInclusionConditionMetafieldBooleanRelation {
  /** The metafield value equals the condition value. */
  Equals = 'EQUALS'
}

/** A condition based on decimal metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldDecimal = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldDecimal';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldDecimalRelation;
  /** The decimal value to match against. */
  value: Scalars['Decimal']['output'];
};

/** The input fields for a condition based on decimal metafield values. */
export type CollectionSourceInclusionConditionMetafieldDecimalInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldDecimalRelation;
  /** The decimal value to match against. */
  value: Scalars['Decimal']['input'];
};

/** The relation for comparing decimal metafield values. */
export enum CollectionSourceInclusionConditionMetafieldDecimalRelation {
  /** The metafield value equals the specified value. */
  Equals = 'EQUALS',
  /** The metafield value is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The metafield value is less than the specified value. */
  LessThan = 'LESS_THAN'
}

/** A condition based on integer metafield values for including products in a collection. This object is deprecated as of API version 2026-10 in favor of `CollectionSourceInclusionConditionMetafieldInt`, which supports the full integer metafield value range. On those versions this legacy type is only returned to queries that reference it without also referencing `CollectionSourceInclusionConditionMetafieldInt`. As of API version 2027-01, this legacy type is removed entirely. */
export type CollectionSourceInclusionConditionMetafieldInteger = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldInteger';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldIntegerRelation;
  /** The integer value to match against. */
  value: Scalars['Int']['output'];
};

/** The input fields for a condition based on integer metafield values. */
export type CollectionSourceInclusionConditionMetafieldIntegerInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldIntegerRelation;
  /** The integer value to match against. */
  value: Scalars['Int']['input'];
};

/** The relation for comparing integer metafield values. */
export enum CollectionSourceInclusionConditionMetafieldIntegerRelation {
  /** The metafield value equals the specified value. */
  Equals = 'EQUALS',
  /** The metafield value is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The metafield value is less than the specified value. */
  LessThan = 'LESS_THAN'
}

/** A condition based on single metaobject reference metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldMetaobject = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldMetaobject';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldMetaobjectRelation;
  /** The metaobject to match against. */
  value: Metaobject;
};

/** The input fields for a condition based on single metaobject reference metafield values. */
export type CollectionSourceInclusionConditionMetafieldMetaobjectInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** The relationship between the metafield value and the condition value. */
  relation: CollectionSourceInclusionConditionMetafieldMetaobjectRelation;
  /** The metaobject ID to match against. */
  value: Scalars['ID']['input'];
};

/** A condition based on list of metaobject reference metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldMetaobjectList = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldMetaobjectList';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldMetaobjectListRelation;
  /** The metaobjects to match against. */
  values: Array<Metaobject>;
};

/** The input fields for a condition based on metaobject list reference metafield values. */
export type CollectionSourceInclusionConditionMetafieldMetaobjectListInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldMetaobjectListRelation;
  /** The metaobject IDs to match against. */
  values: Array<Scalars['ID']['input']>;
};

/** The relationship between the metaobject value and the condition values. */
export enum CollectionSourceInclusionConditionMetafieldMetaobjectListRelation {
  /** Matches if the supplied metaobject value is equal to one or more of the values in the metafield's metaobject list. */
  Includes = 'INCLUDES'
}

/** The relation for comparing metaobject metafield values. */
export enum CollectionSourceInclusionConditionMetafieldMetaobjectRelation {
  /** The metaobject value equals the condition value. */
  Equals = 'EQUALS'
}

/** A condition based on string metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldString = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldString';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldStringRelation;
  /** The string values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on string metafield values. */
export type CollectionSourceInclusionConditionMetafieldStringInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldStringRelation;
  /** The string values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** A condition based on list of string metafield values for including products in a collection. */
export type CollectionSourceInclusionConditionMetafieldStringList = CollectionSourceInclusionCondition & CollectionSourceInclusionConditionMetafield & {
  __typename?: 'CollectionSourceInclusionConditionMetafieldStringList';
  /** The metafield definition to use for the condition. */
  definition: MetafieldDefinition;
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldStringListRelation;
  /** The string values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on string list metafield values. */
export type CollectionSourceInclusionConditionMetafieldStringListInput = {
  /** The ID of the metafield definition. */
  definitionId: Scalars['ID']['input'];
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the metafield value and the condition values. */
  relation: CollectionSourceInclusionConditionMetafieldStringListRelation;
  /** The string values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relationship between the metafield value and the condition values. */
export enum CollectionSourceInclusionConditionMetafieldStringListRelation {
  /** The metafield value includes the specified value. */
  Includes = 'INCLUDES'
}

/** The relationship between the metafield value and the condition values. */
export enum CollectionSourceInclusionConditionMetafieldStringRelation {
  /** The metafield value equals the specified value. */
  Equals = 'EQUALS'
}

/** A condition based on product category IDs for including products in a collection. */
export type CollectionSourceInclusionConditionProductCategory = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductCategory';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product category ID and the condition values. */
  relation: CollectionSourceInclusionConditionProductCategoryRelation;
  /** The product category values to match against. */
  values: Array<CollectionSourceInclusionConditionProductCategoryValue>;
};

/** The input fields for a condition based on product categories. */
export type CollectionSourceInclusionConditionProductCategoryInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product category and the condition values. */
  relation: CollectionSourceInclusionConditionProductCategoryRelation;
  /** The product category values to match against. */
  values: Array<CollectionSourceInclusionConditionProductCategoryValueInput>;
};

/** The relation for comparing product category IDs. */
export enum CollectionSourceInclusionConditionProductCategoryRelation {
  /** The product category ID equals the specified value. */
  Equals = 'EQUALS',
  /** The product category ID does not equal the specified value. */
  NotEquals = 'NOT_EQUALS'
}

/** A value for a product category condition. */
export type CollectionSourceInclusionConditionProductCategoryValue = {
  __typename?: 'CollectionSourceInclusionConditionProductCategoryValue';
  /** The product category to match against. */
  category: TaxonomyCategory;
  /** Whether to include descendants of the product category. */
  includeDescendants: Scalars['Boolean']['output'];
};

/** The input fields for a product category value in a collection condition. */
export type CollectionSourceInclusionConditionProductCategoryValueInput = {
  /** The ID of the product category. */
  categoryId: Scalars['ID']['input'];
  /** Whether to include descendants of the product category. */
  includeDescendants: Scalars['Boolean']['input'];
};

/** A condition based on product status for including products in a collection. */
export type CollectionSourceInclusionConditionProductStatus = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductStatus';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product status and the condition values. */
  relation: CollectionSourceInclusionConditionProductStatusRelation;
  /** The product status values to match against. */
  values: Array<ProductStatus>;
};

/** The input fields for a condition based on product status. */
export type CollectionSourceInclusionConditionProductStatusInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product status and the condition values. */
  relation: CollectionSourceInclusionConditionProductStatusRelation;
  /** The product status values to match against. */
  values: Array<ProductStatus>;
};

/** The relation for comparing product status. */
export enum CollectionSourceInclusionConditionProductStatusRelation {
  /** The product status equals the specified value. */
  Equals = 'EQUALS',
  /** The product status does not equal the specified value. */
  NotEquals = 'NOT_EQUALS'
}

/** A condition based on product tags for including products in a collection. */
export type CollectionSourceInclusionConditionProductTag = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductTag';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product tag and the condition values. */
  relation: CollectionSourceInclusionConditionProductTagRelation;
  /** The tag values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on product tags. */
export type CollectionSourceInclusionConditionProductTagInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product tag and the condition values. */
  relation: CollectionSourceInclusionConditionProductTagRelation;
  /** The tag values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relationship between the product tag and the condition values. */
export enum CollectionSourceInclusionConditionProductTagRelation {
  /** The product is not tagged with the specified value. */
  NotTaggedWith = 'NOT_TAGGED_WITH',
  /** The product is tagged with the specified value. */
  TaggedWith = 'TAGGED_WITH'
}

/** A condition based on product titles for including products in a collection. */
export type CollectionSourceInclusionConditionProductTitle = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductTitle';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product title and the condition values. */
  relation: CollectionSourceInclusionConditionProductTitleRelation;
  /** The title values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on product titles. */
export type CollectionSourceInclusionConditionProductTitleInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product title and the condition values. */
  relation: CollectionSourceInclusionConditionProductTitleRelation;
  /** The title values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relationship between the product title and the condition values. */
export enum CollectionSourceInclusionConditionProductTitleRelation {
  /** The product title contains the specified value. */
  Contains = 'CONTAINS',
  /** The product title does not contain the specified value. */
  DoesNotContain = 'DOES_NOT_CONTAIN',
  /** The product title ends with the specified value. */
  EndsWith = 'ENDS_WITH',
  /** The product title equals the specified value. */
  Equals = 'EQUALS',
  /** The product title does not equal the specified value. */
  NotEquals = 'NOT_EQUALS',
  /** The product title starts with the specified value. */
  StartsWith = 'STARTS_WITH'
}

/** A condition based on product types for including products in a collection. */
export type CollectionSourceInclusionConditionProductType = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductType';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product type and the condition values. */
  relation: CollectionSourceInclusionConditionProductTypeRelation;
  /** The product type values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on product types. */
export type CollectionSourceInclusionConditionProductTypeInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product type and the condition values. */
  relation: CollectionSourceInclusionConditionProductTypeRelation;
  /** The product type values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relation for comparing product types. */
export enum CollectionSourceInclusionConditionProductTypeRelation {
  /** The product type contains the specified value. */
  Contains = 'CONTAINS',
  /** The product type does not contain the specified value. */
  DoesNotContain = 'DOES_NOT_CONTAIN',
  /** The product type ends with the specified value. */
  EndsWith = 'ENDS_WITH',
  /** The product type equals the specified value. */
  Equals = 'EQUALS',
  /** The product type does not equal the specified value. */
  NotEquals = 'NOT_EQUALS',
  /** The product type starts with the specified value. */
  StartsWith = 'STARTS_WITH'
}

/** A condition based on product vendors for including products in a collection. */
export type CollectionSourceInclusionConditionProductVendor = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionProductVendor';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Specifies whether products must match any or all values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product vendor and the condition values. */
  relation: CollectionSourceInclusionConditionProductVendorRelation;
  /** The product vendor values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on product vendors. */
export type CollectionSourceInclusionConditionProductVendorInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the product vendor and the condition values. */
  relation: CollectionSourceInclusionConditionProductVendorRelation;
  /** The product vendor values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relation for comparing product vendors. */
export enum CollectionSourceInclusionConditionProductVendorRelation {
  /** The product vendor contains the specified value. */
  Contains = 'CONTAINS',
  /** The product vendor does not contain the specified value. */
  DoesNotContain = 'DOES_NOT_CONTAIN',
  /** The product vendor ends with the specified value. */
  EndsWith = 'ENDS_WITH',
  /** The product vendor equals the specified value. */
  Equals = 'EQUALS',
  /** The product vendor does not equal the specified value. */
  NotEquals = 'NOT_EQUALS',
  /** The product vendor starts with the specified value. */
  StartsWith = 'STARTS_WITH'
}

/** An inclusion condition introduced in a newer API version that is not modeled by this version of the API. Clients should treat the relation and values as opaque strings. */
export type CollectionSourceInclusionConditionUnknown = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionUnknown';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Whether products must match any or all values. Null when the condition has no concept of a match type. */
  matchType?: Maybe<CollectionConditionMatchType>;
  /** The relation, as a raw string. Nullable and not coerced into an enum because the set of possible relations is open-ended for unknown condition types, and some future conditions may not have a relation at all. */
  relation?: Maybe<Scalars['String']['output']>;
  /** The condition values, as raw strings. Nullable because some future condition types may have no values at all. */
  values?: Maybe<Array<Scalars['String']['output']>>;
};

/** The input fields for updating a condition that determines which products are included in a collection. Exactly one condition type must be provided. */
export type CollectionSourceInclusionConditionUpdateInput = {
  /** An update to a condition based on boolean metafield values. */
  metafieldBoolean?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldBooleanInput>;
  /** An update to a condition based on decimal metafield values. */
  metafieldDecimal?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldDecimalInput>;
  /** An update to a condition based on integer metafield values. */
  metafieldInteger?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldIntegerInput>;
  /** An update to a condition based on single metaobject reference metafield values. */
  metafieldMetaobject?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldMetaobjectInput>;
  /** An update to a condition based on metaobject list reference metafield values. */
  metafieldMetaobjectList?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldMetaobjectListInput>;
  /** An update to a condition based on string metafield values. */
  metafieldString?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldStringInput>;
  /** An update to a condition based on string list metafield values. */
  metafieldStringList?: InputMaybe<CollectionSourceInclusionConditionUpdateMetafieldStringListInput>;
  /** An update to a condition based on product categories. */
  productCategory?: InputMaybe<CollectionSourceInclusionConditionUpdateProductCategoryInput>;
  /** An update to a condition based on product status. */
  productStatus?: InputMaybe<CollectionSourceInclusionConditionUpdateProductStatusInput>;
  /** An update to a condition based on product tags. */
  productTag?: InputMaybe<CollectionSourceInclusionConditionUpdateProductTagInput>;
  /** An update to a condition based on product titles. */
  productTitle?: InputMaybe<CollectionSourceInclusionConditionUpdateProductTitleInput>;
  /** An update to a condition based on product types. */
  productType?: InputMaybe<CollectionSourceInclusionConditionUpdateProductTypeInput>;
  /** An update to a condition based on product vendors. */
  productVendor?: InputMaybe<CollectionSourceInclusionConditionUpdateProductVendorInput>;
  /** An update to a condition based on variant compare at prices. */
  variantCompareAtPrice?: InputMaybe<CollectionSourceInclusionConditionUpdateVariantCompareAtPriceInput>;
  /** An update to a condition based on variant inventory quantities. */
  variantInventory?: InputMaybe<CollectionSourceInclusionConditionUpdateVariantInventoryInput>;
  /** An update to a condition based on variant prices. */
  variantPrice?: InputMaybe<CollectionSourceInclusionConditionUpdateVariantPriceInput>;
  /** An update to a condition based on variant titles. */
  variantTitle?: InputMaybe<CollectionSourceInclusionConditionUpdateVariantTitleInput>;
  /** An update to a condition based on variant weights. */
  variantWeight?: InputMaybe<CollectionSourceInclusionConditionUpdateVariantWeightInput>;
};

/** The input fields for updating a condition based on boolean metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldBooleanInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** The relationship between the metafield value and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldBooleanRelation>;
  /** The boolean value to match against. */
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for updating a condition based on decimal metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldDecimalInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** The relationship between the metafield value and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldDecimalRelation>;
  /** The decimal value to match against. */
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

/** The input fields for updating a condition based on integer metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldIntegerInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** The relationship between the metafield value and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldIntegerRelation>;
  /** The integer value to match against. */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields for updating a condition based on single metaobject reference metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldMetaobjectInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** The relationship between the metafield value and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldMetaobjectRelation>;
  /** The metaobject ID to match against. */
  value?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for updating a condition based on metaobject list reference metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldMetaobjectListInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the metafield value and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldMetaobjectListRelation>;
  /** The metaobject IDs to match against. */
  values?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields for updating a condition based on string metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldStringInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the metafield value and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldStringRelation>;
  /** The string values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on string list metafield values. */
export type CollectionSourceInclusionConditionUpdateMetafieldStringListInput = {
  /** The ID of the metafield definition. */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the metafield value and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionMetafieldStringListRelation>;
  /** The string values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on product categories. */
export type CollectionSourceInclusionConditionUpdateProductCategoryInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product category and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductCategoryRelation>;
  /** The product category values to match against. */
  values?: InputMaybe<Array<CollectionSourceInclusionConditionProductCategoryValueInput>>;
};

/** The input fields for updating a condition based on product status. */
export type CollectionSourceInclusionConditionUpdateProductStatusInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product status and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductStatusRelation>;
  /** The product status values to match against. */
  values?: InputMaybe<Array<ProductStatus>>;
};

/** The input fields for updating a condition based on product tags. */
export type CollectionSourceInclusionConditionUpdateProductTagInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product tag and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductTagRelation>;
  /** The tag values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on product titles. */
export type CollectionSourceInclusionConditionUpdateProductTitleInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product title and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductTitleRelation>;
  /** The title values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on product types. */
export type CollectionSourceInclusionConditionUpdateProductTypeInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product type and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductTypeRelation>;
  /** The product type values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on product vendors. */
export type CollectionSourceInclusionConditionUpdateProductVendorInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the product vendor and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionProductVendorRelation>;
  /** The product vendor values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on variant compare at prices. */
export type CollectionSourceInclusionConditionUpdateVariantCompareAtPriceInput = {
  /** The relationship between the variant compare at price and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionVariantCompareAtPriceRelation>;
  /** The variant compare at price to match against. Required for numeric relations and must be absent for IS_SET or IS_NOT_SET. */
  value?: InputMaybe<MoneyInput>;
};

/** The input fields for updating a condition based on variant inventory quantities. */
export type CollectionSourceInclusionConditionUpdateVariantInventoryInput = {
  /** The relationship between the variant inventory and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionVariantInventoryRelation>;
  /** The variant inventory quantity to match against. */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields for updating a condition based on variant prices. */
export type CollectionSourceInclusionConditionUpdateVariantPriceInput = {
  /** The relationship between the variant price and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionVariantPriceRelation>;
  /** The variant price to match against. */
  value?: InputMaybe<MoneyInput>;
};

/** The input fields for updating a condition based on variant titles. */
export type CollectionSourceInclusionConditionUpdateVariantTitleInput = {
  /** Whether to match any or all of the values. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The relationship between the variant title and the condition values. */
  relation?: InputMaybe<CollectionSourceInclusionConditionVariantTitleRelation>;
  /** The variant title values to match against. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for updating a condition based on variant weights. */
export type CollectionSourceInclusionConditionUpdateVariantWeightInput = {
  /** The relationship between the variant weight and the condition value. */
  relation?: InputMaybe<CollectionSourceInclusionConditionVariantWeightRelation>;
  /** The variant weight to match against. */
  value?: InputMaybe<WeightInput>;
};

/** A condition based on variant compare at prices for including products in a collection. */
export type CollectionSourceInclusionConditionVariantCompareAtPrice = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionVariantCompareAtPrice';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the variant compare at price and the condition values. */
  relation: CollectionSourceInclusionConditionVariantCompareAtPriceRelation;
  /** The variant compare at price to match against. Null when the relation is IS_SET or IS_NOT_SET. */
  value?: Maybe<MoneyV2>;
};

/** The input fields for a condition based on variant compare at prices. */
export type CollectionSourceInclusionConditionVariantCompareAtPriceInput = {
  /** The relationship between the variant compare at price and the condition value. */
  relation: CollectionSourceInclusionConditionVariantCompareAtPriceRelation;
  /** The variant compare at price to match against. Required for numeric relations and must be absent for IS_SET or IS_NOT_SET. */
  value?: InputMaybe<MoneyInput>;
};

/** The relation for comparing variant compare at prices. */
export enum CollectionSourceInclusionConditionVariantCompareAtPriceRelation {
  /** The variant compare at price equals the specified value. */
  Equals = 'EQUALS',
  /** The variant compare at price is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The variant does not have a compare at price set. */
  IsNotSet = 'IS_NOT_SET',
  /** The variant has a compare at price set (indicating a price reduction). */
  IsSet = 'IS_SET',
  /** The variant compare at price is less than the specified value. */
  LessThan = 'LESS_THAN',
  /** The variant compare at price does not equal the specified value. */
  NotEquals = 'NOT_EQUALS'
}

/** A condition based on variant inventory quantities for including products in a collection. */
export type CollectionSourceInclusionConditionVariantInventory = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionVariantInventory';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the variant inventory and the condition values. */
  relation: CollectionSourceInclusionConditionVariantInventoryRelation;
  /** The variant inventory to match against. */
  value: Scalars['Int']['output'];
};

/** The input fields for a condition based on variant inventory quantities. */
export type CollectionSourceInclusionConditionVariantInventoryInput = {
  /** The relationship between the variant inventory and the condition value. */
  relation: CollectionSourceInclusionConditionVariantInventoryRelation;
  /** The variant inventory quantity to match against. */
  value: Scalars['Int']['input'];
};

/** The relation for comparing variant inventory quantities. */
export enum CollectionSourceInclusionConditionVariantInventoryRelation {
  /** The variant inventory equals the specified value. */
  Equals = 'EQUALS',
  /** The variant inventory is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The variant inventory is less than the specified value. */
  LessThan = 'LESS_THAN'
}

/** A condition based on variant prices for including products in a collection. */
export type CollectionSourceInclusionConditionVariantPrice = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionVariantPrice';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the variant price and the condition values. */
  relation: CollectionSourceInclusionConditionVariantPriceRelation;
  /** The variant price to match against. */
  value: MoneyV2;
};

/** The input fields for a condition based on variant prices. */
export type CollectionSourceInclusionConditionVariantPriceInput = {
  /** The relationship between the variant price and the condition value. */
  relation: CollectionSourceInclusionConditionVariantPriceRelation;
  /** The variant price to match against. */
  value: MoneyInput;
};

/** The relation for comparing variant prices. */
export enum CollectionSourceInclusionConditionVariantPriceRelation {
  /** The variant price equals the specified value. */
  Equals = 'EQUALS',
  /** The variant price is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The variant price is less than the specified value. */
  LessThan = 'LESS_THAN',
  /** The variant price does not equal the specified value. */
  NotEquals = 'NOT_EQUALS'
}

/** A condition based on variant titles for including products in a collection. */
export type CollectionSourceInclusionConditionVariantTitle = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionVariantTitle';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** Determines how many values a metafield must match against in order to satisfy this condition. Will be either at least one given value, or all of the given values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the variant title and the condition values. */
  relation: CollectionSourceInclusionConditionVariantTitleRelation;
  /** The variant title values to match against. */
  values: Array<Scalars['String']['output']>;
};

/** The input fields for a condition based on variant titles. */
export type CollectionSourceInclusionConditionVariantTitleInput = {
  /** Whether to match any or all of the values. */
  matchType: CollectionConditionMatchType;
  /** The relationship between the variant title and the condition values. */
  relation: CollectionSourceInclusionConditionVariantTitleRelation;
  /** The variant title values to match against. */
  values: Array<Scalars['String']['input']>;
};

/** The relation for comparing variant titles. */
export enum CollectionSourceInclusionConditionVariantTitleRelation {
  /** The variant title contains the specified value. */
  Contains = 'CONTAINS',
  /** The variant title does not contain the specified value. */
  DoesNotContain = 'DOES_NOT_CONTAIN',
  /** The variant title ends with the specified value. */
  EndsWith = 'ENDS_WITH',
  /** The variant title equals the specified value. */
  Equals = 'EQUALS',
  /** The variant title does not equal the specified value. */
  NotEquals = 'NOT_EQUALS',
  /** The variant title starts with the specified value. */
  StartsWith = 'STARTS_WITH'
}

/** A condition based on variant weights for including products in a collection. */
export type CollectionSourceInclusionConditionVariantWeight = CollectionSourceInclusionCondition & {
  __typename?: 'CollectionSourceInclusionConditionVariantWeight';
  /** The unique identifier for this condition. */
  id: Scalars['ID']['output'];
  /** The relationship between the variant weight and the condition values. */
  relation: CollectionSourceInclusionConditionVariantWeightRelation;
  /** The variant weight to match against. */
  value: Weight;
};

/** The input fields for a condition based on variant weights. */
export type CollectionSourceInclusionConditionVariantWeightInput = {
  /** The relationship between the variant weight and the condition value. */
  relation: CollectionSourceInclusionConditionVariantWeightRelation;
  /** The variant weight to match against. */
  value: WeightInput;
};

/** The relation for comparing variant weights. */
export enum CollectionSourceInclusionConditionVariantWeightRelation {
  /** The variant weight equals the specified value. */
  Equals = 'EQUALS',
  /** The variant weight is greater than the specified value. */
  GreaterThan = 'GREATER_THAN',
  /** The variant weight is less than the specified value. */
  LessThan = 'LESS_THAN',
  /** The variant weight does not equal the specified value. */
  NotEquals = 'NOT_EQUALS'
}

/** Conditions that target variants cause either the entire product to be included when satisfied or only the matching variants. */
export enum CollectionSourceTargetType {
  /** The entire product is included if any variant satisfies the conditions. */
  Products = 'PRODUCTS',
  /** Individual variants are included if they satisfy the conditions. */
  Variants = 'VARIANTS'
}

/** Whether a collection can be referenced as a sub-collection target by another collection's source. Use this to surface ineligible targets up front (with reasons). */
export type CollectionSubCollectionEligibility = {
  __typename?: 'CollectionSubCollectionEligibility';
  /** Eligibility for use as an exclusion target of a sub-collection source. */
  exclusion: CollectionSubCollectionEligibilityState;
  /** Eligibility for use as the inclusion target of a sub-collection source. */
  inclusion: CollectionSubCollectionEligibilityState;
};

/** Whether a collection is eligible for one role (inclusion or exclusion) in a sub-collection relationship, plus the reason it isn't if applicable. */
export type CollectionSubCollectionEligibilityState = {
  __typename?: 'CollectionSubCollectionEligibilityState';
  /** Whether the collection can be used in this sub-collection role. */
  eligible: Scalars['Boolean']['output'];
  /** Stable identifier describing why the collection is ineligible. Null when `eligible` is true. Clients can map this to user-facing copy or use it as a feature flag. */
  ineligibleReason?: Maybe<SubCollectionIneligibleReason>;
};

/**
 * A collection source whose membership comes from one or more referenced collections (sub-collections).
 *
 * Sub-collection sources are always non-shareable. Sharing a sub-collection source across owners is not
 * supported because the collection references are owner-bound.
 */
export type CollectionSubCollectionsSource = CollectionSource & Node & {
  __typename?: 'CollectionSubCollectionsSource';
  /** The app that created this source, if applicable. In the case of shareable sources, this app manages this source's conditions and selections exclusively. */
  app?: Maybe<App>;
  /** The referenced sub-collections that supply products to this source. */
  collections: Array<Collection>;
  /** An optional description of the source. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this source. */
  id: Scalars['ID']['output'];
  /** The title of the source. */
  title: Scalars['String']['output'];
};

/** The input fields for specifying the collection to unpublish and the sales channels to remove it from. */
export type CollectionUnpublishInput = {
  /** The channels where the collection is published. */
  collectionPublications: Array<CollectionPublicationInput>;
  /** The collection to create or update publications for. */
  id: Scalars['ID']['input'];
};

/** Return type for `collectionUnpublish` mutation. */
export type CollectionUnpublishPayload = {
  __typename?: 'CollectionUnpublishPayload';
  /** The collection that has been unpublished. */
  collection?: Maybe<Collection>;
  /** The shop associated with the collection. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for updating a shareable collection source. */
export type CollectionUpdateConditionsSourceInput = {
  /** An optional description of the source. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The exclusion rules for the source. */
  exclusion?: InputMaybe<CollectionUpdateSourceExclusionInput>;
  /** The ID of the source to update. */
  id: Scalars['ID']['input'];
  /** The inclusion rules for the source. */
  inclusion?: InputMaybe<CollectionUpdateSourceInclusionInput>;
  /** The title of the source. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields required to update a collection. */
export type CollectionUpdateInput = {
  /** The description of the collection, in HTML format. */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** A unique human-friendly string for the collection. Automatically generated from the collection's title. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the collection to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The image associated with the collection. */
  image?: InputMaybe<ImageInput>;
  /** The metafields to associate with the collection. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /**
   * Indicates whether a redirect is required after a new handle has been provided.
   * If true, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /** SEO information for the collection. */
  seo?: InputMaybe<SeoInput>;
  /** The order in which the collection's products are sorted. */
  sortOrder?: InputMaybe<CollectionSortOrder>;
  /** The sources to create for the collection. */
  sourcesToCreate?: InputMaybe<Array<CollectionCreateSourceTargetInput>>;
  /** The IDs of the sources to delete from the collection. */
  sourcesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The sources to update for the collection. */
  sourcesToUpdate?: InputMaybe<Array<CollectionUpdateSourceTargetInput>>;
  /** The theme template used when viewing the collection in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the collection. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `collectionUpdate` mutation. */
export type CollectionUpdatePayload = {
  __typename?: 'CollectionUpdatePayload';
  /** The updated collection. */
  collection?: Maybe<Collection>;
  /** The asynchronous job updating the products based on the new rule set. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for updating an exclusion condition in a collection source. */
export type CollectionUpdateSourceExclusionConditionInput = {
  /** The updated exclusion condition. */
  condition: CollectionSourceExclusionConditionUpdateInput;
  /** The ID of the exclusion condition to update. */
  id: Scalars['ID']['input'];
};

/** The input fields for updating exclusion rules for a collection source. */
export type CollectionUpdateSourceExclusionInput = {
  /** The exclusion conditions to create for the source. */
  conditionsToCreate?: InputMaybe<Array<CollectionSourceExclusionConditionInput>>;
  /** The IDs of the exclusion conditions to delete from the source. */
  conditionsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The exclusion conditions to update for the source. */
  conditionsToUpdate?: InputMaybe<Array<CollectionUpdateSourceExclusionConditionInput>>;
  /** Whether products must match all or any of the conditions to be excluded. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The product selections to add to the source. */
  selectionsToAdd?: InputMaybe<Array<CollectionExclusionProductSelectionInput>>;
  /** The product selections to remove from the source. */
  selectionsToRemove?: InputMaybe<Array<CollectionExclusionProductSelectionInput>>;
};

/** The input fields for updating a condition in a collection source. */
export type CollectionUpdateSourceInclusionConditionInput = {
  /** The updated condition. */
  condition: CollectionSourceInclusionConditionUpdateInput;
  /** The ID of the condition to update. */
  id: Scalars['ID']['input'];
};

/** The input fields for updating inclusion rules for a collection source. */
export type CollectionUpdateSourceInclusionInput = {
  /** The conditions to create for the source. */
  conditionsToCreate?: InputMaybe<Array<CollectionSourceInclusionConditionInput>>;
  /** The IDs of the conditions to delete from the source. */
  conditionsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The conditions to update for the source. */
  conditionsToUpdate?: InputMaybe<Array<CollectionUpdateSourceInclusionConditionInput>>;
  /** Whether products must match all or any of the conditions. */
  matchType?: InputMaybe<CollectionConditionMatchType>;
  /** The product selections to add to the source. */
  selectionsToAdd?: InputMaybe<Array<CollectionInclusionProductSelectionInput>>;
  /** The product selections to remove from the source. For sources that target variants, omitting variant IDs will remove all for the product. */
  selectionsToRemove?: InputMaybe<Array<CollectionInclusionProductSelectionInput>>;
};

/** The input fields for updating a collection source - provide the one field that represents the type of source to update. */
export type CollectionUpdateSourceTargetInput = {
  /** An update to a shareable conditions-based source. */
  condition?: InputMaybe<CollectionUpdateConditionsSourceInput>;
  /** An update to a sub-collection source whose membership comes from one or more referenced collections. */
  subCollections?: InputMaybe<CollectionUpdateSubCollectionsSourceInput>;
};

/** The input fields for updating a sub-collection source — a source whose membership comes from one or more referenced collections. */
export type CollectionUpdateSubCollectionsSourceInput = {
  /** The global IDs of the sub-collections whose products supply this source. When provided, it replaces the source's current referenced collections. */
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** An optional description of the source. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the source to update. */
  id: Scalars['ID']['input'];
  /** The title of the source. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The data type of a column. */
export enum ColumnDataType {
  /** Represents an array of values. */
  Array = 'ARRAY',
  /** Represents a boolean value. */
  Boolean = 'BOOLEAN',
  /** Represents a hex color value. */
  Color = 'COLOR',
  /** Represents a cumulative value. */
  Cumulative = 'CUMULATIVE',
  /** Represents a duration in days. */
  DayDuration = 'DAY_DURATION',
  /** Represents a day of week value. */
  DayOfWeek = 'DAY_OF_WEEK',
  /** Represents a day-level timestamp value. */
  DayTimestamp = 'DAY_TIMESTAMP',
  /** Represents a decimal value. */
  Decimal = 'DECIMAL',
  /** Represents an entity reference value. */
  Entity = 'ENTITY',
  /** Represents a floating point value. */
  Float = 'FLOAT',
  /** Represents a geographic coordinate value. */
  GeoCoordinate = 'GEO_COORDINATE',
  /** Represents a duration in hours. */
  HourDuration = 'HOUR_DURATION',
  /** Represents an hour of day value. */
  HourOfDay = 'HOUR_OF_DAY',
  /** Represents a hour-level timestamp value. */
  HourTimestamp = 'HOUR_TIMESTAMP',
  /** Represents an identity value. */
  Identity = 'IDENTITY',
  /** Represents an integer value. */
  Integer = 'INTEGER',
  /** Represents a duration in milliseconds. */
  MillisecondDuration = 'MILLISECOND_DURATION',
  /** Represents a duration in minutes. */
  MinuteDuration = 'MINUTE_DURATION',
  /** Represents a minute-level timestamp value. */
  MinuteTimestamp = 'MINUTE_TIMESTAMP',
  /** Represents a monetary value. */
  Money = 'MONEY',
  /** Represents a month of year value. */
  MonthOfYear = 'MONTH_OF_YEAR',
  /** Represents a month-level timestamp value. */
  MonthTimestamp = 'MONTH_TIMESTAMP',
  /** Represents a multiplier value. */
  Multiplier = 'MULTIPLIER',
  /** Represents a percentage value. */
  Percent = 'PERCENT',
  /** Represents a quarter-level timestamp value. */
  QuarterTimestamp = 'QUARTER_TIMESTAMP',
  /** Represents a rating value. */
  Rating = 'RATING',
  /** Represents a duration in seconds. */
  SecondDuration = 'SECOND_DURATION',
  /** Represents a second-level timestamp value. */
  SecondTimestamp = 'SECOND_TIMESTAMP',
  /** Represents a string value. */
  String = 'STRING',
  /** Represents a string identity value. */
  StringIdentity = 'STRING_IDENTITY',
  /** Represents a timestamp value in seconds. */
  Timestamp = 'TIMESTAMP',
  /** Represents a unitless scalar value. */
  UnitlessScalar = 'UNITLESS_SCALAR',
  /** Represents an unspecified data type. */
  Unspecified = 'UNSPECIFIED',
  /** Represents a week of year value. */
  WeekOfYear = 'WEEK_OF_YEAR',
  /** Represents a week-level timestamp value. */
  WeekTimestamp = 'WEEK_TIMESTAMP',
  /** Represents a year-level timestamp value. */
  YearTimestamp = 'YEAR_TIMESTAMP'
}

/** A combined listing of products. */
export type CombinedListing = {
  __typename?: 'CombinedListing';
  /** A list of child products in the combined listing. */
  combinedListingChildren: CombinedListingChildConnection;
  /** The parent product. */
  parentProduct: Product;
};


/** A combined listing of products. */
export type CombinedListingCombinedListingChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A child of a combined listing. */
export type CombinedListingChild = {
  __typename?: 'CombinedListingChild';
  /** The parent variant. */
  parentVariant: ProductVariant;
  /** The child product. */
  product: Product;
};

/** An auto-generated type for paginating through multiple CombinedListingChildren. */
export type CombinedListingChildConnection = {
  __typename?: 'CombinedListingChildConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CombinedListingChildEdge>;
  /** A list of nodes that are contained in CombinedListingChildEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CombinedListingChild>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CombinedListingChild and a cursor during pagination. */
export type CombinedListingChildEdge = {
  __typename?: 'CombinedListingChildEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CombinedListingChildEdge. */
  node: CombinedListingChild;
};

/** Return type for `combinedListingUpdate` mutation. */
export type CombinedListingUpdatePayload = {
  __typename?: 'CombinedListingUpdatePayload';
  /** The parent product. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CombinedListingUpdateUserError>;
};

/** An error that occurs during the execution of `CombinedListingUpdate`. */
export type CombinedListingUpdateUserError = DisplayableError & {
  __typename?: 'CombinedListingUpdateUserError';
  /** The error code. */
  code?: Maybe<CombinedListingUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CombinedListingUpdateUserError`. */
export enum CombinedListingUpdateUserErrorCode {
  /** Unable to add duplicated products. */
  CannotHaveDuplicatedProducts = 'CANNOT_HAVE_DUPLICATED_PRODUCTS',
  /** Unable to add a product that is a parent. */
  CannotHaveParentAsChild = 'CANNOT_HAVE_PARENT_AS_CHILD',
  /** Unable to add products with repeated options. */
  CannotHaveRepeatedOptions = 'CANNOT_HAVE_REPEATED_OPTIONS',
  /** Option values cannot be repeated. */
  CannotHaveRepeatedOptionValues = 'CANNOT_HAVE_REPEATED_OPTION_VALUES',
  /** Unable to add options values that are already in use. */
  CantAddOptionsValuesIfAlreadyExists = 'CANT_ADD_OPTIONS_VALUES_IF_ALREADY_EXISTS',
  /** Combined listings feature is not enabled. */
  CombinedListingsNotEnabled = 'COMBINED_LISTINGS_NOT_ENABLED',
  /** Cannot perform edit and remove on same products. */
  EditAndRemoveOnSameProducts = 'EDIT_AND_REMOVE_ON_SAME_PRODUCTS',
  /** Unable to add products. */
  FailedToAddProducts = 'FAILED_TO_ADD_PRODUCTS',
  /** Unable to remove products. */
  FailedToRemoveProducts = 'FAILED_TO_REMOVE_PRODUCTS',
  /** Unable to update products. */
  FailedToUpdateProducts = 'FAILED_TO_UPDATE_PRODUCTS',
  /** The same metafield cannot be linked to multiple options. */
  LinkedMetafieldsCannotBeRepeated = 'LINKED_METAFIELDS_CANNOT_BE_REPEATED',
  /** An option linked to a metafield cannot be linked to a different metafield. */
  LinkedMetafieldCannotBeChanged = 'LINKED_METAFIELD_CANNOT_BE_CHANGED',
  /** Linked metafield value missing from `optionsAndValues` field. */
  LinkedMetafieldValueMissing = 'LINKED_METAFIELD_VALUE_MISSING',
  /** Linked options are currently not supported for this shop. */
  LinkedOptionsNotSupportedForShop = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** The optionsAndValues field is required for this operation. */
  MissingOptionValues = 'MISSING_OPTION_VALUES',
  /** Selected option values cannot be empty. */
  MustHaveSelectedOptionValues = 'MUST_HAVE_SELECTED_OPTION_VALUES',
  /** All child products must include the same options. */
  OptionsMustBeEqualToTheOtherComponents = 'OPTIONS_MUST_BE_EQUAL_TO_THE_OTHER_COMPONENTS',
  /** Unable to add products with blank option names. */
  OptionNameCannotBeBlank = 'OPTION_NAME_CANNOT_BE_BLANK',
  /** Option name contains invalid characters. */
  OptionNameContainsInvalidCharacters = 'OPTION_NAME_CONTAINS_INVALID_CHARACTERS',
  /** Option does not exist. */
  OptionNotFound = 'OPTION_NOT_FOUND',
  /** Unable to update options with blank option values. */
  OptionValuesCannotBeBlank = 'OPTION_VALUES_CANNOT_BE_BLANK',
  /** Unable to update options with no option values. */
  OptionValuesCannotBeEmpty = 'OPTION_VALUES_CANNOT_BE_EMPTY',
  /** The options_and_values field must contain all option values used in the combined listing. */
  OptionValuesMustBeComplete = 'OPTION_VALUES_MUST_BE_COMPLETE',
  /** Parent product cannot be a combined listing child. */
  ParentProductCannotBeCombinedListingChild = 'PARENT_PRODUCT_CANNOT_BE_COMBINED_LISTING_CHILD',
  /** Unable to update components for a product that isn't a combined listing. */
  ParentProductMustBeACombinedListing = 'PARENT_PRODUCT_MUST_BE_A_COMBINED_LISTING',
  /** The combined listing parent product must have a product category to use linked metafield options. */
  ParentProductMustHaveCategory = 'PARENT_PRODUCT_MUST_HAVE_CATEGORY',
  /** Parent product not found. */
  ParentProductNotFound = 'PARENT_PRODUCT_NOT_FOUND',
  /** Unable to add a product that is already a child. */
  ProductIsAlreadyAChild = 'PRODUCT_IS_ALREADY_A_CHILD',
  /** Failed to remove mebmership due to invalid input. */
  ProductMembershipNotFound = 'PRODUCT_MEMBERSHIP_NOT_FOUND',
  /** Unable to add products that do not exist. */
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  /** The title cannot be longer than 255 characters. */
  TitleTooLong = 'TITLE_TOO_LONG',
  /** You have reached the maximum number of products that can be added to an individual combined listing. */
  TooManyProducts = 'TOO_MANY_PRODUCTS',
  /** You have reached the maximum number of variants across all products for an individual combined listing. */
  TooManyVariants = 'TOO_MANY_VARIANTS',
  /** An unexpected error occurred. */
  UnexpectedError = 'UNEXPECTED_ERROR'
}

/** The role of the combined listing. */
export enum CombinedListingsRole {
  /** The product is the child of a combined listing. */
  Child = 'CHILD',
  /** The product is the parent of a combined listing. */
  Parent = 'PARENT'
}

/** A comment on an article. */
export type Comment = HasEvents & Node & {
  __typename?: 'Comment';
  /** The article associated with the comment. */
  article?: Maybe<Article>;
  /** The comment’s author. */
  author: CommentAuthor;
  /** The content of the comment. */
  body: Scalars['String']['output'];
  /** The content of the comment, complete with HTML formatting. */
  bodyHtml: Scalars['HTML']['output'];
  /** The date and time when the comment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The IP address of the commenter. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Whether or not the comment is published. */
  isPublished: Scalars['Boolean']['output'];
  /** The date and time when the comment was published. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the comment. */
  status: CommentStatus;
  /** The date and time when the comment was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user agent of the commenter. */
  userAgent?: Maybe<Scalars['String']['output']>;
};


/** A comment on an article. */
export type CommentEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Return type for `commentApprove` mutation. */
export type CommentApprovePayload = {
  __typename?: 'CommentApprovePayload';
  /** The comment that was approved. */
  comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CommentApproveUserError>;
};

/** An error that occurs during the execution of `CommentApprove`. */
export type CommentApproveUserError = DisplayableError & {
  __typename?: 'CommentApproveUserError';
  /** The error code. */
  code?: Maybe<CommentApproveUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CommentApproveUserError`. */
export enum CommentApproveUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/**
 * The author of a comment on a blog article, containing the commenter's name and email address. This information helps merchants moderate comments and potentially engage with their community.
 *
 * For example, when reviewing pending comments, merchants can see the commenter's name and email to help with moderation decisions or to enable follow-up communication if needed.
 *
 * Use the `CommentAuthor` object to:
 * - Display comment attribution
 * - Support comment moderation workflows
 * - Enable merchant-to-reader communication
 */
export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The author's email. */
  email: Scalars['String']['output'];
  /** The author’s name. */
  name: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple Comments. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CommentEdge>;
  /** A list of nodes that are contained in CommentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Comment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `commentDelete` mutation. */
export type CommentDeletePayload = {
  __typename?: 'CommentDeletePayload';
  /** The ID of the comment that was deleted. */
  deletedCommentId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CommentDeleteUserError>;
};

/** An error that occurs during the execution of `CommentDelete`. */
export type CommentDeleteUserError = DisplayableError & {
  __typename?: 'CommentDeleteUserError';
  /** The error code. */
  code?: Maybe<CommentDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CommentDeleteUserError`. */
export enum CommentDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one Comment and a cursor during pagination. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CommentEdge. */
  node: Comment;
};

/**
 * A comment that staff members add to the timeline of [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order), [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder), [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer), [`InventoryTransfer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransfer), [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company), [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation), or [`PriceRule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceRule) objects. Staff use comments to document internal notes, communicate with team members, and track important information about these types.
 *
 * The comment includes information like the [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) who authored it, when it was created, and whether it's editable or deletable. Comments can have file attachments and reference related objects like [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) or [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects through embeds.
 */
export type CommentEvent = Event & Node & {
  __typename?: 'CommentEvent';
  /** The action that occured. */
  action: Scalars['String']['output'];
  /** The name of the app that created the event. */
  appTitle?: Maybe<Scalars['String']['output']>;
  /** The attachments associated with the comment event. */
  attachments: Array<CommentEventAttachment>;
  /** Whether the event was created by an app. */
  attributeToApp: Scalars['Boolean']['output'];
  /** Whether the event was caused by an admin user. */
  attributeToUser: Scalars['Boolean']['output'];
  /** The name of the user that authored the comment event. */
  author: StaffMember;
  /** Whether the comment event can be deleted. If true, then the comment event can be deleted. */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the comment event can be edited. If true, then the comment event can be edited. */
  canEdit: Scalars['Boolean']['output'];
  /** The date and time when the event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the event is critical. */
  criticalAlert: Scalars['Boolean']['output'];
  /** Whether the comment event has been edited. If true, then the comment event has been edited. */
  edited: Scalars['Boolean']['output'];
  /** The object reference associated with the comment event. For example, a product or discount). */
  embed?: Maybe<CommentEventEmbed>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Human readable text that describes the event. */
  message: Scalars['FormattedString']['output'];
  /** The raw body of the comment event. */
  rawMessage: Scalars['String']['output'];
  /** The parent subject to which the comment event belongs. */
  subject?: Maybe<CommentEventSubject>;
};

/** A file attachment associated to a comment event. */
export type CommentEventAttachment = {
  __typename?: 'CommentEventAttachment';
  /** The file extension of the comment event attachment, indicating the file format. */
  fileExtension?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image attached to the comment event. */
  image?: Maybe<Image>;
  /** The filename of the comment event attachment. */
  name: Scalars['String']['output'];
  /** The size of the attachment. */
  size: Scalars['Int']['output'];
  /** The URL of the attachment. */
  url: Scalars['URL']['output'];
};

/** The main embed of a comment event. */
export type CommentEventEmbed = Customer | DraftOrder | InventoryTransfer | Order | Product | ProductVariant;

/** The subject line of a comment event. */
export type CommentEventSubject = {
  /** Whether the timeline subject has a timeline comment. If true, then a timeline comment exists. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Return type for `commentNotSpam` mutation. */
export type CommentNotSpamPayload = {
  __typename?: 'CommentNotSpamPayload';
  /** The comment that was marked as not spam. */
  comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CommentNotSpamUserError>;
};

/** An error that occurs during the execution of `CommentNotSpam`. */
export type CommentNotSpamUserError = DisplayableError & {
  __typename?: 'CommentNotSpamUserError';
  /** The error code. */
  code?: Maybe<CommentNotSpamUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CommentNotSpamUserError`. */
export enum CommentNotSpamUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** Possible comment policies for a blog. */
export enum CommentPolicy {
  /** Readers can post comments to blog articles without moderation. */
  AutoPublished = 'AUTO_PUBLISHED',
  /** Readers cannot post comments to blog articles. */
  Closed = 'CLOSED',
  /** Readers can post comments to blog articles, but comments must be moderated before they appear. */
  Moderated = 'MODERATED'
}

/** The set of valid sort keys for the Comment query. */
export enum CommentSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Return type for `commentSpam` mutation. */
export type CommentSpamPayload = {
  __typename?: 'CommentSpamPayload';
  /** The comment that was marked as spam. */
  comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CommentSpamUserError>;
};

/** An error that occurs during the execution of `CommentSpam`. */
export type CommentSpamUserError = DisplayableError & {
  __typename?: 'CommentSpamUserError';
  /** The error code. */
  code?: Maybe<CommentSpamUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CommentSpamUserError`. */
export enum CommentSpamUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** The status of a comment. */
export enum CommentStatus {
  /** The comment is pending approval. */
  Pending = 'PENDING',
  /** The comment is published. */
  Published = 'PUBLISHED',
  /** The comment has been removed. */
  Removed = 'REMOVED',
  /** The comment is marked as spam. */
  Spam = 'SPAM',
  /** The comment is unapproved. */
  Unapproved = 'UNAPPROVED'
}

/** Return type for `companiesDelete` mutation. */
export type CompaniesDeletePayload = {
  __typename?: 'CompaniesDeletePayload';
  /** A list of IDs of the deleted companies. */
  deletedCompanyIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type Company = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & Navigable & Node & {
  __typename?: 'Company';
  /**
   * The number of contacts that belong to the company.
   * @deprecated Use `contactsCount` instead.
   */
  contactCount: Scalars['Int']['output'];
  /** The list of roles for the company contacts. */
  contactRoles: CompanyContactRoleConnection;
  /** The list of contacts in the company. */
  contacts: CompanyContactConnection;
  /** The number of contacts that belong to the company. */
  contactsCount?: Maybe<Count>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was created in Shopify. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company became the customer. */
  customerSince: Scalars['DateTime']['output'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The role proposed by default for a contact at the company. */
  defaultRole?: Maybe<CompanyContactRole>;
  /** The list of the company's draft orders. */
  draftOrders: DraftOrderConnection;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A unique externally-supplied ID for the company. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Whether the merchant added a timeline comment to the company. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The lifetime duration of the company, since it became a customer of the shop. Examples: `2 days`, `3 months`, `1 year`. */
  lifetimeDuration: Scalars['String']['output'];
  /** The list of locations in the company. */
  locations: CompanyLocationConnection;
  /** The number of locations that belong to the company. */
  locationsCount?: Maybe<Count>;
  /** The main contact for the company. */
  mainContact?: Maybe<CompanyContact>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The name of the company. */
  name: Scalars['String']['output'];
  /** A note about the company. */
  note?: Maybe<Scalars['String']['output']>;
  /** The list of the company's orders. */
  orders: OrderConnection;
  /** The total number of orders placed for this company, across all its locations. */
  ordersCount?: Maybe<Count>;
  /** The total amount spent by this company, across all its locations. */
  totalSpent: MoneyV2;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyContactRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyContactRoleSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyContactSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A business entity that purchases from the shop as part of B2B commerce. Companies organize multiple locations and contacts who can place orders on behalf of the organization. [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects can have custom pricing through [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) and [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) configurations. */
export type CompanyOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};

/** Represents a billing or shipping address for a company location. */
export type CompanyAddress = Node & {
  __typename?: 'CompanyAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1: Scalars['String']['output'];
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the company. */
  companyName: Scalars['String']['output'];
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  countryCode: CountryCode;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company address was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The first name of the recipient. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The formatted version of the address. */
  formattedAddress: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the recipient. */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * A unique phone number for the customer.
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  phone?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /** The identity of the recipient e.g. 'Receiving Department'. */
  recipient?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company address was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  zoneCode?: Maybe<Scalars['String']['output']>;
};


/** Represents a billing or shipping address for a company location. */
export type CompanyAddressFormattedAddressArgs = {
  withCompanyName?: InputMaybe<Scalars['Boolean']['input']>;
  withName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `companyAddressDelete` mutation. */
export type CompanyAddressDeletePayload = {
  __typename?: 'CompanyAddressDeletePayload';
  /** The ID of the deleted address. */
  deletedAddressId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The input fields to create or update the address of a company location. */
export type CompanyAddressInput = {
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The name of the city, district, village, or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code ([ISO 3166-1 alpha-2]](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format) for the country of the address. For example, `US`` for the United States. */
  countryCode?: InputMaybe<CountryCode>;
  /** The first name of the recipient. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the recipient. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A phone number for the recipient. Formatted using E.164 standard. For example, _+16135551111_. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The identity of the recipient e.g. 'Receiving Department'. */
  recipient?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
  /** The alphanumeric code for the region of the address, such as the province, state, or district. For example, `ON` for Ontario, Canada. */
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

/** The valid values for the address type of a company. */
export enum CompanyAddressType {
  /** The address is a billing address. */
  Billing = 'BILLING',
  /** The address is a shipping address. */
  Shipping = 'SHIPPING'
}

/** Return type for `companyAssignCustomerAsContact` mutation. */
export type CompanyAssignCustomerAsContactPayload = {
  __typename?: 'CompanyAssignCustomerAsContactPayload';
  /** The created company contact. */
  companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyAssignMainContact` mutation. */
export type CompanyAssignMainContactPayload = {
  __typename?: 'CompanyAssignMainContactPayload';
  /** The company for which the main contact is assigned. */
  company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An auto-generated type for paginating through multiple Companies. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyEdge>;
  /** A list of nodes that are contained in CompanyEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Company>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/**
 * A person who acts on behalf of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) to make B2B purchases. Company contacts are associated with [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) accounts and can place orders on behalf of their company.
 *
 * Each contact can be assigned to one or more [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects with specific roles that determine their permissions and access to catalogs, pricing, and payment terms configured for those locations.
 */
export type CompanyContact = Node & {
  __typename?: 'CompanyContact';
  /** The company to which the contact belongs. */
  company: Company;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was created at Shopify. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer associated to this contact. */
  customer: Customer;
  /** The list of draft orders for the company contact. */
  draftOrders: DraftOrderConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the contact is the main contact of the company. */
  isMainContact: Scalars['Boolean']['output'];
  /** The lifetime duration of the company contact, since its creation date on Shopify. Examples: `1 year`, `2 months`, `3 days`. */
  lifetimeDuration: Scalars['String']['output'];
  /** The company contact's locale (language). */
  locale?: Maybe<Scalars['String']['output']>;
  /** The list of orders for the company contact. */
  orders: OrderConnection;
  /** The list of roles assigned to this company contact. */
  roleAssignments: CompanyContactRoleAssignmentConnection;
  /** The company contact's job title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A person who acts on behalf of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) to make B2B purchases. Company contacts are associated with [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) accounts and can place orders on behalf of their company.
 *
 * Each contact can be assigned to one or more [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects with specific roles that determine their permissions and access to catalogs, pricing, and payment terms configured for those locations.
 */
export type CompanyContactDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/**
 * A person who acts on behalf of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) to make B2B purchases. Company contacts are associated with [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) accounts and can place orders on behalf of their company.
 *
 * Each contact can be assigned to one or more [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects with specific roles that determine their permissions and access to catalogs, pricing, and payment terms configured for those locations.
 */
export type CompanyContactOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/**
 * A person who acts on behalf of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) to make B2B purchases. Company contacts are associated with [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) accounts and can place orders on behalf of their company.
 *
 * Each contact can be assigned to one or more [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects with specific roles that determine their permissions and access to catalogs, pricing, and payment terms configured for those locations.
 */
export type CompanyContactRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyContactRoleAssignmentSortKeys>;
};

/** Return type for `companyContactAssignRole` mutation. */
export type CompanyContactAssignRolePayload = {
  __typename?: 'CompanyContactAssignRolePayload';
  /** The company contact role assignment. */
  companyContactRoleAssignment?: Maybe<CompanyContactRoleAssignment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyContactAssignRoles` mutation. */
export type CompanyContactAssignRolesPayload = {
  __typename?: 'CompanyContactAssignRolesPayload';
  /** A list of newly created assignments of company contacts to a company location. */
  roleAssignments?: Maybe<Array<CompanyContactRoleAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An auto-generated type for paginating through multiple CompanyContacts. */
export type CompanyContactConnection = {
  __typename?: 'CompanyContactConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyContactEdge>;
  /** A list of nodes that are contained in CompanyContactEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CompanyContact>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `companyContactCreate` mutation. */
export type CompanyContactCreatePayload = {
  __typename?: 'CompanyContactCreatePayload';
  /** The created company contact. */
  companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyContactDelete` mutation. */
export type CompanyContactDeletePayload = {
  __typename?: 'CompanyContactDeletePayload';
  /** The ID of the deleted company contact. */
  deletedCompanyContactId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one CompanyContact and a cursor during pagination. */
export type CompanyContactEdge = {
  __typename?: 'CompanyContactEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyContactEdge. */
  node: CompanyContact;
};

/** The input fields for company contact attributes when creating or updating a company contact. */
export type CompanyContactInput = {
  /** The unique email address of the company contact. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The company contact's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The company contact's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The contact's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the company contact. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The title of the company contact. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `companyContactRemoveFromCompany` mutation. */
export type CompanyContactRemoveFromCompanyPayload = {
  __typename?: 'CompanyContactRemoveFromCompanyPayload';
  /** The ID of the removed company contact. */
  removedCompanyContactId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyContactRevokeRole` mutation. */
export type CompanyContactRevokeRolePayload = {
  __typename?: 'CompanyContactRevokeRolePayload';
  /** The role assignment that was revoked. */
  revokedCompanyContactRoleAssignmentId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyContactRevokeRoles` mutation. */
export type CompanyContactRevokeRolesPayload = {
  __typename?: 'CompanyContactRevokeRolesPayload';
  /** A list of role assignment IDs that were removed from the company contact. */
  revokedRoleAssignmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The role for a [company contact](https://shopify.dev/api/admin-graphql/latest/objects/companycontact). */
export type CompanyContactRole = Node & {
  __typename?: 'CompanyContactRole';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of a role. For example, `admin` or `buyer`. */
  name: Scalars['String']['output'];
  /** A note for the role. */
  note?: Maybe<Scalars['String']['output']>;
};

/** The input fields for the role and location to assign to a company contact. */
export type CompanyContactRoleAssign = {
  /** The role ID. */
  companyContactRoleId: Scalars['ID']['input'];
  /** The location. */
  companyLocationId: Scalars['ID']['input'];
};

/** The CompanyContactRoleAssignment describes the company and location associated to a company contact's role. */
export type CompanyContactRoleAssignment = Node & {
  __typename?: 'CompanyContactRoleAssignment';
  /** The company this role assignment belongs to. */
  company: Company;
  /** The company contact for whom this role is assigned. */
  companyContact: CompanyContact;
  /** The company location to which the role is assigned. */
  companyLocation: CompanyLocation;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the assignment record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The role that's assigned to the company contact. */
  role: CompanyContactRole;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the assignment record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CompanyContactRoleAssignments. */
export type CompanyContactRoleAssignmentConnection = {
  __typename?: 'CompanyContactRoleAssignmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyContactRoleAssignmentEdge>;
  /** A list of nodes that are contained in CompanyContactRoleAssignmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CompanyContactRoleAssignment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyContactRoleAssignment and a cursor during pagination. */
export type CompanyContactRoleAssignmentEdge = {
  __typename?: 'CompanyContactRoleAssignmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyContactRoleAssignmentEdge. */
  node: CompanyContactRoleAssignment;
};

/** The set of valid sort keys for the CompanyContactRoleAssignment query. */
export enum CompanyContactRoleAssignmentSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `location_name` value. */
  LocationName = 'LOCATION_NAME',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** An auto-generated type for paginating through multiple CompanyContactRoles. */
export type CompanyContactRoleConnection = {
  __typename?: 'CompanyContactRoleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyContactRoleEdge>;
  /** A list of nodes that are contained in CompanyContactRoleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CompanyContactRole>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyContactRole and a cursor during pagination. */
export type CompanyContactRoleEdge = {
  __typename?: 'CompanyContactRoleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyContactRoleEdge. */
  node: CompanyContactRole;
};

/** The set of valid sort keys for the CompanyContactRole query. */
export enum CompanyContactRoleSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `companyContactSendWelcomeEmail` mutation. */
export type CompanyContactSendWelcomeEmailPayload = {
  __typename?: 'CompanyContactSendWelcomeEmailPayload';
  /** The company contact to whom a welcome email was sent. */
  companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The set of valid sort keys for the CompanyContact query. */
export enum CompanyContactSortKeys {
  /** Sort by the `company_id` value. */
  CompanyId = 'COMPANY_ID',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `email` value. */
  Email = 'EMAIL',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `name_email` value. */
  NameEmail = 'NAME_EMAIL',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `companyContactUpdate` mutation. */
export type CompanyContactUpdatePayload = {
  __typename?: 'CompanyContactUpdatePayload';
  /** The updated company contact. */
  companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyContactsDelete` mutation. */
export type CompanyContactsDeletePayload = {
  __typename?: 'CompanyContactsDeletePayload';
  /** The list of IDs of the deleted company contacts. */
  deletedCompanyContactIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The input fields and values for creating a company and its associated resources. */
export type CompanyCreateInput = {
  /** The attributes for the company. */
  company: CompanyInput;
  /** The attributes for the company contact. */
  companyContact?: InputMaybe<CompanyContactInput>;
  /** The attributes for the company location. */
  companyLocation?: InputMaybe<CompanyLocationInput>;
};

/** Return type for `companyCreate` mutation. */
export type CompanyCreatePayload = {
  __typename?: 'CompanyCreatePayload';
  /** The created company. */
  company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyDelete` mutation. */
export type CompanyDeletePayload = {
  __typename?: 'CompanyDeletePayload';
  /** The ID of the deleted company. */
  deletedCompanyId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one Company and a cursor during pagination. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyEdge. */
  node: Company;
};

/** The input fields for company attributes when creating or updating a company. */
export type CompanyInput = {
  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at
   *           which the company became the customer.
   */
  customerSince?: InputMaybe<Scalars['DateTime']['input']>;
  /** A unique externally-supplied ID for the company. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A note about the company. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocation = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & HasStoreCreditAccounts & Navigable & Node & {
  __typename?: 'CompanyLocation';
  /** The address used as billing address for the location. */
  billingAddress?: Maybe<CompanyAddress>;
  /** The configuration for the buyer's B2B checkout. */
  buyerExperienceConfiguration?: Maybe<BuyerExperienceConfiguration>;
  /** The list of catalogs associated with the company location. */
  catalogs: CatalogConnection;
  /** The number of catalogs associated with the company location. Limited to a maximum of 10000 by default. */
  catalogsCount?: Maybe<Count>;
  /** The company that the company location belongs to. */
  company: Company;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was created in Shopify. */
  createdAt: Scalars['DateTime']['output'];
  /** The location's currency based on the shipping address. If the shipping address is empty, then the value is the shop's primary market. */
  currency: CurrencyCode;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The list of draft orders for the company location. */
  draftOrders: DraftOrderConnection;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A unique externally-supplied ID for the company location. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Whether the merchant added a timeline comment to the company location. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the company location is assigned a specific catalog. */
  inCatalog: Scalars['Boolean']['output'];
  /** The preferred locale of the company location. */
  locale?: Maybe<Scalars['String']['output']>;
  /**
   * The market that applies to the location's shipping address country. In cases where multiple markets match, this returns the most-specific country region market. If the shipping address is empty, then the value is the shop's backup region market.
   * @deprecated This `market` field will be removed in a future version of the API.
   */
  market: Market;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The name of the company location. */
  name: Scalars['String']['output'];
  /** A note about the company location. */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The total number of orders placed for the location.
   * @deprecated Use `ordersCount` instead.
   */
  orderCount: Scalars['Int']['output'];
  /** The list of orders for the company location. */
  orders: OrderConnection;
  /** The total number of orders placed for the location. */
  ordersCount?: Maybe<Count>;
  /** The phone number of the company location. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The list of roles assigned to the company location. */
  roleAssignments: CompanyContactRoleAssignmentConnection;
  /** The address used as shipping address for the location. */
  shippingAddress?: Maybe<CompanyAddress>;
  /** The list of staff members assigned to the company location. */
  staffMemberAssignments: CompanyLocationStaffMemberAssignmentConnection;
  /**
   * Returns a list of store credit accounts that belong to the owner resource.
   * A store credit account owner can hold multiple accounts each with a different currency.
   */
  storeCreditAccounts: StoreCreditAccountConnection;
  /**
   * The list of tax exemptions applied to the location.
   * @deprecated Use `taxSettings` instead.
   */
  taxExemptions: Array<TaxExemption>;
  /**
   * The tax registration ID for the company location.
   * @deprecated Use `taxSettings` instead.
   */
  taxRegistrationId?: Maybe<Scalars['String']['output']>;
  /** The tax settings for the company location. */
  taxSettings: CompanyLocationTaxSettings;
  /** The total amount spent by the location. */
  totalSpent: MoneyV2;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationCatalogsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationInCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyContactRoleAssignmentSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationStaffMemberAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyLocationStaffMemberAssignmentSortKeys>;
};


/**
 * A location or branch of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) that's a customer of the shop. Company locations enable B2B customers to manage multiple branches with distinct billing and shipping addresses, tax settings, and checkout configurations.
 *
 * Each location can have its own [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects that determine which products are published and their pricing. The [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) determines checkout behavior including [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and whether orders require merchant review. B2B customers select which location they're purchasing for, which determines the applicable catalogs, pricing, [`TaxExemption`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption) values, and checkout settings for their [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects.
 */
export type CompanyLocationStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `companyLocationAssignAddress` mutation. */
export type CompanyLocationAssignAddressPayload = {
  __typename?: 'CompanyLocationAssignAddressPayload';
  /** The list of updated addresses on the company location. */
  addresses?: Maybe<Array<CompanyAddress>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignRoles` mutation. */
export type CompanyLocationAssignRolesPayload = {
  __typename?: 'CompanyLocationAssignRolesPayload';
  /** A list of newly created assignments of company contacts to a company location. */
  roleAssignments?: Maybe<Array<CompanyContactRoleAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignStaffMembers` mutation. */
export type CompanyLocationAssignStaffMembersPayload = {
  __typename?: 'CompanyLocationAssignStaffMembersPayload';
  /** The list of created staff member assignments. */
  companyLocationStaffMemberAssignments?: Maybe<Array<CompanyLocationStaffMemberAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignTaxExemptions` mutation. */
export type CompanyLocationAssignTaxExemptionsPayload = {
  __typename?: 'CompanyLocationAssignTaxExemptionsPayload';
  /** The updated company location. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/**
 * A list of products with publishing and pricing information associated with company locations.
 *
 * Company location catalogs can include an optional publication to control product visibility and a price list to customize pricing. When a publication isn't associated with the catalog, product availability is determined by the sales channel.
 */
export type CompanyLocationCatalog = Catalog & Node & {
  __typename?: 'CompanyLocationCatalog';
  /** The company locations associated with the catalog. */
  companyLocations: CompanyLocationConnection;
  /** The number of company locations associated with the catalog. */
  companyLocationsCount?: Maybe<Count>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Most recent catalog operations. */
  operations: Array<ResourceOperation>;
  /** The price list associated with the catalog. */
  priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  publication?: Maybe<Publication>;
  /** The status of the catalog. */
  status: CatalogStatus;
  /** The name of the catalog. */
  title: Scalars['String']['output'];
};


/**
 * A list of products with publishing and pricing information associated with company locations.
 *
 * Company location catalogs can include an optional publication to control product visibility and a price list to customize pricing. When a publication isn't associated with the catalog, product availability is determined by the sales channel.
 */
export type CompanyLocationCatalogCompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};

/** An auto-generated type for paginating through multiple CompanyLocations. */
export type CompanyLocationConnection = {
  __typename?: 'CompanyLocationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyLocationEdge>;
  /** A list of nodes that are contained in CompanyLocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CompanyLocation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `companyLocationCreate` mutation. */
export type CompanyLocationCreatePayload = {
  __typename?: 'CompanyLocationCreatePayload';
  /** The created company location. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationCreateTaxRegistration` mutation. */
export type CompanyLocationCreateTaxRegistrationPayload = {
  __typename?: 'CompanyLocationCreateTaxRegistrationPayload';
  /** The company location with the created tax registration. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationDelete` mutation. */
export type CompanyLocationDeletePayload = {
  __typename?: 'CompanyLocationDeletePayload';
  /** The ID of the deleted company location. */
  deletedCompanyLocationId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one CompanyLocation and a cursor during pagination. */
export type CompanyLocationEdge = {
  __typename?: 'CompanyLocationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyLocationEdge. */
  node: CompanyLocation;
};

/** The input fields for company location when creating or updating a company location. */
export type CompanyLocationInput = {
  /** The input fields to create or update the billing address for a company location. */
  billingAddress?: InputMaybe<CompanyAddressInput>;
  /** Whether the billing address is the same as the shipping address. If the value is true, then the input for `billingAddress` is ignored. */
  billingSameAsShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The configuration for the buyer's checkout at the company location. */
  buyerExperienceConfiguration?: InputMaybe<BuyerExperienceConfigurationInput>;
  /** A unique externally-supplied ID for the company location. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The preferred locale of the company location. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company location. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A note about the company location. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the company location. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The input fields to create or update the shipping address for a company location. */
  shippingAddress?: InputMaybe<CompanyAddressInput>;
  /** Whether the location is exempt from taxes. */
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of tax exemptions to apply to the company location. */
  taxExemptions?: InputMaybe<Array<TaxExemption>>;
  /** The tax registration ID of the company location. */
  taxRegistrationId?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `companyLocationRemoveStaffMembers` mutation. */
export type CompanyLocationRemoveStaffMembersPayload = {
  __typename?: 'CompanyLocationRemoveStaffMembersPayload';
  /** The list of IDs of the deleted staff member assignment. */
  deletedCompanyLocationStaffMemberAssignmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeRoles` mutation. */
export type CompanyLocationRevokeRolesPayload = {
  __typename?: 'CompanyLocationRevokeRolesPayload';
  /** A list of role assignment IDs that were removed from the company location. */
  revokedRoleAssignmentIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeTaxExemptions` mutation. */
export type CompanyLocationRevokeTaxExemptionsPayload = {
  __typename?: 'CompanyLocationRevokeTaxExemptionsPayload';
  /** The updated company location. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeTaxRegistration` mutation. */
export type CompanyLocationRevokeTaxRegistrationPayload = {
  __typename?: 'CompanyLocationRevokeTaxRegistrationPayload';
  /** The updated company location. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The input fields for the role and contact to assign on a location. */
export type CompanyLocationRoleAssign = {
  /** The company contact ID.. */
  companyContactId: Scalars['ID']['input'];
  /** The role ID. */
  companyContactRoleId: Scalars['ID']['input'];
};

/** The set of valid sort keys for the CompanyLocation query. */
export enum CompanyLocationSortKeys {
  /** Sort by the `company_and_location_name` value. */
  CompanyAndLocationName = 'COMPANY_AND_LOCATION_NAME',
  /** Sort by the `company_id` value. */
  CompanyId = 'COMPANY_ID',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** A representation of store's staff member who is assigned to a [company location](https://shopify.dev/api/admin-graphql/latest/objects/CompanyLocation) of the shop. The staff member's actions will be limited to objects associated with the assigned company location. */
export type CompanyLocationStaffMemberAssignment = Node & {
  __typename?: 'CompanyLocationStaffMemberAssignment';
  /** The company location the staff member is assigned to. */
  companyLocation: CompanyLocation;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Represents the data of a staff member who's assigned to a company location. */
  staffMember: StaffMember;
};

/** An auto-generated type for paginating through multiple CompanyLocationStaffMemberAssignments. */
export type CompanyLocationStaffMemberAssignmentConnection = {
  __typename?: 'CompanyLocationStaffMemberAssignmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CompanyLocationStaffMemberAssignmentEdge>;
  /** A list of nodes that are contained in CompanyLocationStaffMemberAssignmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CompanyLocationStaffMemberAssignment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyLocationStaffMemberAssignment and a cursor during pagination. */
export type CompanyLocationStaffMemberAssignmentEdge = {
  __typename?: 'CompanyLocationStaffMemberAssignmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CompanyLocationStaffMemberAssignmentEdge. */
  node: CompanyLocationStaffMemberAssignment;
};

/** The set of valid sort keys for the CompanyLocationStaffMemberAssignment query. */
export enum CompanyLocationStaffMemberAssignmentSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents the tax settings for a company location. */
export type CompanyLocationTaxSettings = {
  __typename?: 'CompanyLocationTaxSettings';
  /** Whether the location is exempt from taxes. */
  taxExempt: Scalars['Boolean']['output'];
  /** The list of tax exemptions applied to the location. */
  taxExemptions: Array<TaxExemption>;
  /** The tax registration ID for the company location. */
  taxRegistrationId?: Maybe<Scalars['String']['output']>;
};

/** Return type for `companyLocationTaxSettingsUpdate` mutation. */
export type CompanyLocationTaxSettingsUpdatePayload = {
  __typename?: 'CompanyLocationTaxSettingsUpdatePayload';
  /** The company location with the updated tax settings. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The input fields for company location when creating or updating a company location. */
export type CompanyLocationUpdateInput = {
  /** The configuration for the buyer's checkout at the company location. */
  buyerExperienceConfiguration?: InputMaybe<BuyerExperienceConfigurationInput>;
  /** A unique externally-supplied ID for the company location. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The preferred locale of the company location. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company location. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A note about the company location. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the company location. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `companyLocationUpdate` mutation. */
export type CompanyLocationUpdatePayload = {
  __typename?: 'CompanyLocationUpdatePayload';
  /** The updated company location. */
  companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** A condition checking the company location a visitor is purchasing for. */
export type CompanyLocationsCondition = {
  __typename?: 'CompanyLocationsCondition';
  /** The application level for the condition. */
  applicationLevel?: Maybe<MarketConditionApplicationType>;
  /** The company locations that comprise the market. */
  companyLocations: CompanyLocationConnection;
};


/** A condition checking the company location a visitor is purchasing for. */
export type CompanyLocationsConditionCompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `companyLocationsDelete` mutation. */
export type CompanyLocationsDeletePayload = {
  __typename?: 'CompanyLocationsDeletePayload';
  /** A list of IDs of the deleted company locations. */
  deletedCompanyLocationIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** Return type for `companyRevokeMainContact` mutation. */
export type CompanyRevokeMainContactPayload = {
  __typename?: 'CompanyRevokeMainContactPayload';
  /** The company from which the main contact is revoked. */
  company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** The set of valid sort keys for the Company query. */
export enum CompanySortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `order_count` value. */
  OrderCount = 'ORDER_COUNT',
  /** Sort by the `since_date` value. */
  SinceDate = 'SINCE_DATE',
  /** Sort by the `total_spent` value. */
  TotalSpent = 'TOTAL_SPENT',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `companyUpdate` mutation. */
export type CompanyUpdatePayload = {
  __typename?: 'CompanyUpdatePayload';
  /** The updated company. */
  company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BusinessCustomerUserError>;
};

/** An option on the bundle parent product that is consolidated from multiple different components. */
export type ComponentizedProductsBundleConsolidatedOption = {
  __typename?: 'ComponentizedProductsBundleConsolidatedOption';
  /** The name of the consolidated option. */
  name: Scalars['String']['output'];
  /** The selections of the consolidated option. */
  selections: Array<ComponentizedProductsBundleConsolidatedOptionSelection>;
};

/** An option selection for a bundle consolidated option. */
export type ComponentizedProductsBundleConsolidatedOptionSelection = {
  __typename?: 'ComponentizedProductsBundleConsolidatedOptionSelection';
  /** The component values that are included in the consolidated option selection. */
  components: Array<ComponentizedProductsBundleConsolidatedOptionSelectionComponent>;
  /** The value of the consolidated option on the bundle parent. */
  value: Scalars['String']['output'];
};

/** A component that's included in a bundle consolidated option selection. */
export type ComponentizedProductsBundleConsolidatedOptionSelectionComponent = {
  __typename?: 'ComponentizedProductsBundleConsolidatedOptionSelectionComponent';
  /** The ID of the component's option that's included in this consolidated option selection. */
  optionId: Scalars['ID']['output'];
  /** The value of the component's option value that's included in this consolidated option selection. */
  value: Scalars['String']['output'];
};

/**
 * A consent policy describes the level of consent that the merchant requires from the user before actually
 * collecting and processing the data.
 */
export type ConsentPolicy = Node & {
  __typename?: 'ConsentPolicy';
  /** Whether consent is required for the region. */
  consentRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The `ISO 3166` country code for which the policy applies. */
  countryCode?: Maybe<PrivacyCountryCode>;
  /** Whether data sale opt-out is required for the region. */
  dataSaleOptOutRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The global ID of the consent policy. IDs prefixed with `SD-` are system default policies. */
  id: Scalars['ID']['output'];
  /** The `ISO 3166` region code for which the policy applies. */
  regionCode?: Maybe<Scalars['String']['output']>;
  /** The global ID of the shop that owns the policy. */
  shopId: Scalars['ID']['output'];
};

/** The errors encountered while performing mutations on consent policies. */
export type ConsentPolicyError = DisplayableError & {
  __typename?: 'ConsentPolicyError';
  /** The error code. */
  code?: Maybe<ConsentPolicyErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ConsentPolicyError`. */
export enum ConsentPolicyErrorCode {
  /** Country code is required. */
  CountryCodeRequired = 'COUNTRY_CODE_REQUIRED',
  /** Region code must match the country code. */
  RegionCodeMustMatchCountryCode = 'REGION_CODE_MUST_MATCH_COUNTRY_CODE',
  /** Region code is required for countries with existing regional policies. */
  RegionCodeRequired = 'REGION_CODE_REQUIRED',
  /** Shopify's cookie banner must be disabled. */
  ShopifyCookieBannerNotDisabled = 'SHOPIFY_COOKIE_BANNER_NOT_DISABLED',
  /** Unsupported consent policy. */
  UnsuportedConsentPolicy = 'UNSUPORTED_CONSENT_POLICY'
}

/** The input fields for a consent policy to be updated or created. */
export type ConsentPolicyInput = {
  /** Whether consent is required for the region. */
  consentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The `ISO 3166` country code for which the policy applies. */
  countryCode?: InputMaybe<PrivacyCountryCode>;
  /** Whether data sale opt-out is required for the region. */
  dataSaleOptOutRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The `ISO 3166` region code for which the policy applies. */
  regionCode?: InputMaybe<Scalars['String']['input']>;
};

/** A country or region code. */
export type ConsentPolicyRegion = {
  __typename?: 'ConsentPolicyRegion';
  /** The `ISO 3166` country code for which the policy applies. */
  countryCode?: Maybe<PrivacyCountryCode>;
  /** The `ISO 3166` region code for which the policy applies. */
  regionCode?: Maybe<Scalars['String']['output']>;
};

/** Return type for `consentPolicyUpdate` mutation. */
export type ConsentPolicyUpdatePayload = {
  __typename?: 'ConsentPolicyUpdatePayload';
  /** All updated and created consent policies. The consent policies that haven't been modified as part of the mutation aren't returned. */
  updatedPolicies?: Maybe<Array<ConsentPolicy>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ConsentPolicyError>;
};

/** The input fields for the context data that determines the pricing of a variant. Refer to [Product](https://shopify.dev/docs/api/admin-graphql/latest/queries/product?example=Get+the+price+range+for+a+product+for+buyers+from+Canada)for more information on how to use this input object. */
export type ContextualPricingContext = {
  /** The CompanyLocation ID used to fetch company location specific prices. */
  companyLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The country code used to fetch country-specific prices. */
  country?: InputMaybe<CountryCode>;
  /** The Location ID used to fetch location specific prices. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

/** The context data that determines the publication status of a product. */
export type ContextualPublicationContext = {
  /** The company location ID used to fetch company-specific publication. */
  companyLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The country code used to fetch country-specific publication. */
  country?: InputMaybe<CountryCode>;
  /** The Location ID used to fetch the publication status of a product. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

/** A shop's banner settings. */
export type CookieBanner = HasPublishedTranslations & {
  __typename?: 'CookieBanner';
  /** Indicates if the banner is auto managed. */
  autoManaged: Scalars['Boolean']['output'];
  /** Indicates if the banner is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/** A shop's banner settings. */
export type CookieBannerTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** A numeric count with precision information indicating whether the count is exact or an estimate. */
export type Count = {
  __typename?: 'Count';
  /** The count of elements. */
  count: Scalars['Int']['output'];
  /** The count's precision, or the exactness of the value. */
  precision: CountPrecision;
};

/** The precision of the value returned by a count field. */
export enum CountPrecision {
  /** The count is at least the value. A limit was imposed and reached. */
  AtLeast = 'AT_LEAST',
  /** The count is exactly the value. A write may not be reflected instantaneously. */
  Exact = 'EXACT'
}

/** The list of all the countries from the combined shipping zones for the shop. */
export type CountriesInShippingZones = {
  __typename?: 'CountriesInShippingZones';
  /** The list of all the countries from all the combined shipping zones. */
  countryCodes: Array<CountryCode>;
  /** Whether 'Rest of World' has been defined in any of the shipping zones. */
  includeRestOfWorld: Scalars['Boolean']['output'];
};

/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
 * If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
 * of another country. For example, the territories associated with Spain are represented by the country code `ES`,
 * and the territories associated with the United States of America are represented by the country code `US`.
 */
export enum CountryCode {
  /** Ascension Island. */
  Ac = 'AC',
  /** Andorra. */
  Ad = 'AD',
  /** United Arab Emirates. */
  Ae = 'AE',
  /** Afghanistan. */
  Af = 'AF',
  /** Antigua & Barbuda. */
  Ag = 'AG',
  /** Anguilla. */
  Ai = 'AI',
  /** Albania. */
  Al = 'AL',
  /** Armenia. */
  Am = 'AM',
  /** Netherlands Antilles. */
  An = 'AN',
  /** Angola. */
  Ao = 'AO',
  /** Argentina. */
  Ar = 'AR',
  /** Austria. */
  At = 'AT',
  /** Australia. */
  Au = 'AU',
  /** Aruba. */
  Aw = 'AW',
  /** Åland Islands. */
  Ax = 'AX',
  /** Azerbaijan. */
  Az = 'AZ',
  /** Bosnia & Herzegovina. */
  Ba = 'BA',
  /** Barbados. */
  Bb = 'BB',
  /** Bangladesh. */
  Bd = 'BD',
  /** Belgium. */
  Be = 'BE',
  /** Burkina Faso. */
  Bf = 'BF',
  /** Bulgaria. */
  Bg = 'BG',
  /** Bahrain. */
  Bh = 'BH',
  /** Burundi. */
  Bi = 'BI',
  /** Benin. */
  Bj = 'BJ',
  /** St. Barthélemy. */
  Bl = 'BL',
  /** Bermuda. */
  Bm = 'BM',
  /** Brunei. */
  Bn = 'BN',
  /** Bolivia. */
  Bo = 'BO',
  /** Caribbean Netherlands. */
  Bq = 'BQ',
  /** Brazil. */
  Br = 'BR',
  /** Bahamas. */
  Bs = 'BS',
  /** Bhutan. */
  Bt = 'BT',
  /** Bouvet Island. */
  Bv = 'BV',
  /** Botswana. */
  Bw = 'BW',
  /** Belarus. */
  By = 'BY',
  /** Belize. */
  Bz = 'BZ',
  /** Canada. */
  Ca = 'CA',
  /** Cocos (Keeling) Islands. */
  Cc = 'CC',
  /** Congo - Kinshasa. */
  Cd = 'CD',
  /** Central African Republic. */
  Cf = 'CF',
  /** Congo - Brazzaville. */
  Cg = 'CG',
  /** Switzerland. */
  Ch = 'CH',
  /** Côte d’Ivoire. */
  Ci = 'CI',
  /** Cook Islands. */
  Ck = 'CK',
  /** Chile. */
  Cl = 'CL',
  /** Cameroon. */
  Cm = 'CM',
  /** China. */
  Cn = 'CN',
  /** Colombia. */
  Co = 'CO',
  /** Costa Rica. */
  Cr = 'CR',
  /** Cuba. */
  Cu = 'CU',
  /** Cape Verde. */
  Cv = 'CV',
  /** Curaçao. */
  Cw = 'CW',
  /** Christmas Island. */
  Cx = 'CX',
  /** Cyprus. */
  Cy = 'CY',
  /** Czechia. */
  Cz = 'CZ',
  /** Germany. */
  De = 'DE',
  /** Djibouti. */
  Dj = 'DJ',
  /** Denmark. */
  Dk = 'DK',
  /** Dominica. */
  Dm = 'DM',
  /** Dominican Republic. */
  Do = 'DO',
  /** Algeria. */
  Dz = 'DZ',
  /** Ecuador. */
  Ec = 'EC',
  /** Estonia. */
  Ee = 'EE',
  /** Egypt. */
  Eg = 'EG',
  /** Western Sahara. */
  Eh = 'EH',
  /** Eritrea. */
  Er = 'ER',
  /** Spain. */
  Es = 'ES',
  /** Ethiopia. */
  Et = 'ET',
  /** Finland. */
  Fi = 'FI',
  /** Fiji. */
  Fj = 'FJ',
  /** Falkland Islands. */
  Fk = 'FK',
  /** Faroe Islands. */
  Fo = 'FO',
  /** France. */
  Fr = 'FR',
  /** Gabon. */
  Ga = 'GA',
  /** United Kingdom. */
  Gb = 'GB',
  /** Grenada. */
  Gd = 'GD',
  /** Georgia. */
  Ge = 'GE',
  /** French Guiana. */
  Gf = 'GF',
  /** Guernsey. */
  Gg = 'GG',
  /** Ghana. */
  Gh = 'GH',
  /** Gibraltar. */
  Gi = 'GI',
  /** Greenland. */
  Gl = 'GL',
  /** Gambia. */
  Gm = 'GM',
  /** Guinea. */
  Gn = 'GN',
  /** Guadeloupe. */
  Gp = 'GP',
  /** Equatorial Guinea. */
  Gq = 'GQ',
  /** Greece. */
  Gr = 'GR',
  /** South Georgia & South Sandwich Islands. */
  Gs = 'GS',
  /** Guatemala. */
  Gt = 'GT',
  /** Guinea-Bissau. */
  Gw = 'GW',
  /** Guyana. */
  Gy = 'GY',
  /** Hong Kong SAR. */
  Hk = 'HK',
  /** Heard & McDonald Islands. */
  Hm = 'HM',
  /** Honduras. */
  Hn = 'HN',
  /** Croatia. */
  Hr = 'HR',
  /** Haiti. */
  Ht = 'HT',
  /** Hungary. */
  Hu = 'HU',
  /** Indonesia. */
  Id = 'ID',
  /** Ireland. */
  Ie = 'IE',
  /** Israel. */
  Il = 'IL',
  /** Isle of Man. */
  Im = 'IM',
  /** India. */
  In = 'IN',
  /** British Indian Ocean Territory. */
  Io = 'IO',
  /** Iraq. */
  Iq = 'IQ',
  /** Iran. */
  Ir = 'IR',
  /** Iceland. */
  Is = 'IS',
  /** Italy. */
  It = 'IT',
  /** Jersey. */
  Je = 'JE',
  /** Jamaica. */
  Jm = 'JM',
  /** Jordan. */
  Jo = 'JO',
  /** Japan. */
  Jp = 'JP',
  /** Kenya. */
  Ke = 'KE',
  /** Kyrgyzstan. */
  Kg = 'KG',
  /** Cambodia. */
  Kh = 'KH',
  /** Kiribati. */
  Ki = 'KI',
  /** Comoros. */
  Km = 'KM',
  /** St. Kitts & Nevis. */
  Kn = 'KN',
  /** North Korea. */
  Kp = 'KP',
  /** South Korea. */
  Kr = 'KR',
  /** Kuwait. */
  Kw = 'KW',
  /** Cayman Islands. */
  Ky = 'KY',
  /** Kazakhstan. */
  Kz = 'KZ',
  /** Laos. */
  La = 'LA',
  /** Lebanon. */
  Lb = 'LB',
  /** St. Lucia. */
  Lc = 'LC',
  /** Liechtenstein. */
  Li = 'LI',
  /** Sri Lanka. */
  Lk = 'LK',
  /** Liberia. */
  Lr = 'LR',
  /** Lesotho. */
  Ls = 'LS',
  /** Lithuania. */
  Lt = 'LT',
  /** Luxembourg. */
  Lu = 'LU',
  /** Latvia. */
  Lv = 'LV',
  /** Libya. */
  Ly = 'LY',
  /** Morocco. */
  Ma = 'MA',
  /** Monaco. */
  Mc = 'MC',
  /** Moldova. */
  Md = 'MD',
  /** Montenegro. */
  Me = 'ME',
  /** St. Martin. */
  Mf = 'MF',
  /** Madagascar. */
  Mg = 'MG',
  /** North Macedonia. */
  Mk = 'MK',
  /** Mali. */
  Ml = 'ML',
  /** Myanmar (Burma). */
  Mm = 'MM',
  /** Mongolia. */
  Mn = 'MN',
  /** Macao SAR. */
  Mo = 'MO',
  /** Martinique. */
  Mq = 'MQ',
  /** Mauritania. */
  Mr = 'MR',
  /** Montserrat. */
  Ms = 'MS',
  /** Malta. */
  Mt = 'MT',
  /** Mauritius. */
  Mu = 'MU',
  /** Maldives. */
  Mv = 'MV',
  /** Malawi. */
  Mw = 'MW',
  /** Mexico. */
  Mx = 'MX',
  /** Malaysia. */
  My = 'MY',
  /** Mozambique. */
  Mz = 'MZ',
  /** Namibia. */
  Na = 'NA',
  /** New Caledonia. */
  Nc = 'NC',
  /** Niger. */
  Ne = 'NE',
  /** Norfolk Island. */
  Nf = 'NF',
  /** Nigeria. */
  Ng = 'NG',
  /** Nicaragua. */
  Ni = 'NI',
  /** Netherlands. */
  Nl = 'NL',
  /** Norway. */
  No = 'NO',
  /** Nepal. */
  Np = 'NP',
  /** Nauru. */
  Nr = 'NR',
  /** Niue. */
  Nu = 'NU',
  /** New Zealand. */
  Nz = 'NZ',
  /** Oman. */
  Om = 'OM',
  /** Panama. */
  Pa = 'PA',
  /** Peru. */
  Pe = 'PE',
  /** French Polynesia. */
  Pf = 'PF',
  /** Papua New Guinea. */
  Pg = 'PG',
  /** Philippines. */
  Ph = 'PH',
  /** Pakistan. */
  Pk = 'PK',
  /** Poland. */
  Pl = 'PL',
  /** St. Pierre & Miquelon. */
  Pm = 'PM',
  /** Pitcairn Islands. */
  Pn = 'PN',
  /** Palestinian Territories. */
  Ps = 'PS',
  /** Portugal. */
  Pt = 'PT',
  /** Paraguay. */
  Py = 'PY',
  /** Qatar. */
  Qa = 'QA',
  /** Réunion. */
  Re = 'RE',
  /** Romania. */
  Ro = 'RO',
  /** Serbia. */
  Rs = 'RS',
  /** Russia. */
  Ru = 'RU',
  /** Rwanda. */
  Rw = 'RW',
  /** Saudi Arabia. */
  Sa = 'SA',
  /** Solomon Islands. */
  Sb = 'SB',
  /** Seychelles. */
  Sc = 'SC',
  /** Sudan. */
  Sd = 'SD',
  /** Sweden. */
  Se = 'SE',
  /** Singapore. */
  Sg = 'SG',
  /** St. Helena. */
  Sh = 'SH',
  /** Slovenia. */
  Si = 'SI',
  /** Svalbard & Jan Mayen. */
  Sj = 'SJ',
  /** Slovakia. */
  Sk = 'SK',
  /** Sierra Leone. */
  Sl = 'SL',
  /** San Marino. */
  Sm = 'SM',
  /** Senegal. */
  Sn = 'SN',
  /** Somalia. */
  So = 'SO',
  /** Suriname. */
  Sr = 'SR',
  /** South Sudan. */
  Ss = 'SS',
  /** São Tomé & Príncipe. */
  St = 'ST',
  /** El Salvador. */
  Sv = 'SV',
  /** Sint Maarten. */
  Sx = 'SX',
  /** Syria. */
  Sy = 'SY',
  /** Eswatini. */
  Sz = 'SZ',
  /** Tristan da Cunha. */
  Ta = 'TA',
  /** Turks & Caicos Islands. */
  Tc = 'TC',
  /** Chad. */
  Td = 'TD',
  /** French Southern Territories. */
  Tf = 'TF',
  /** Togo. */
  Tg = 'TG',
  /** Thailand. */
  Th = 'TH',
  /** Tajikistan. */
  Tj = 'TJ',
  /** Tokelau. */
  Tk = 'TK',
  /** Timor-Leste. */
  Tl = 'TL',
  /** Turkmenistan. */
  Tm = 'TM',
  /** Tunisia. */
  Tn = 'TN',
  /** Tonga. */
  To = 'TO',
  /** Türkiye. */
  Tr = 'TR',
  /** Trinidad & Tobago. */
  Tt = 'TT',
  /** Tuvalu. */
  Tv = 'TV',
  /** Taiwan. */
  Tw = 'TW',
  /** Tanzania. */
  Tz = 'TZ',
  /** Ukraine. */
  Ua = 'UA',
  /** Uganda. */
  Ug = 'UG',
  /** U.S. Outlying Islands. */
  Um = 'UM',
  /** United States. */
  Us = 'US',
  /** Uruguay. */
  Uy = 'UY',
  /** Uzbekistan. */
  Uz = 'UZ',
  /** Vatican City. */
  Va = 'VA',
  /** St. Vincent & Grenadines. */
  Vc = 'VC',
  /** Venezuela. */
  Ve = 'VE',
  /** British Virgin Islands. */
  Vg = 'VG',
  /** Vietnam. */
  Vn = 'VN',
  /** Vanuatu. */
  Vu = 'VU',
  /** Wallis & Futuna. */
  Wf = 'WF',
  /** Samoa. */
  Ws = 'WS',
  /** Kosovo. */
  Xk = 'XK',
  /** Yemen. */
  Ye = 'YE',
  /** Mayotte. */
  Yt = 'YT',
  /** South Africa. */
  Za = 'ZA',
  /** Zambia. */
  Zm = 'ZM',
  /** Zimbabwe. */
  Zw = 'ZW',
  /** Unknown Region. */
  Zz = 'ZZ'
}

/** The country-specific harmonized system code and ISO country code for an inventory item. */
export type CountryHarmonizedSystemCode = {
  __typename?: 'CountryHarmonizedSystemCode';
  /** The ISO 3166-1 alpha-2 country code for the country that issued the specified harmonized system code. */
  countryCode: CountryCode;
  /** The country-specific harmonized system code. These are usually longer than 6 digits. */
  harmonizedSystemCode: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple CountryHarmonizedSystemCodes. */
export type CountryHarmonizedSystemCodeConnection = {
  __typename?: 'CountryHarmonizedSystemCodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CountryHarmonizedSystemCodeEdge>;
  /** A list of nodes that are contained in CountryHarmonizedSystemCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CountryHarmonizedSystemCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CountryHarmonizedSystemCode and a cursor during pagination. */
export type CountryHarmonizedSystemCodeEdge = {
  __typename?: 'CountryHarmonizedSystemCodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CountryHarmonizedSystemCodeEdge. */
  node: CountryHarmonizedSystemCode;
};

/** The input fields required to specify a harmonized system code. */
export type CountryHarmonizedSystemCodeInput = {
  /** The ISO 3166-1 alpha-2 country code for the country that issued the specified harmonized system code. Represents global harmonized system code when set to null. */
  countryCode?: InputMaybe<CountryCode>;
  /** Country specific harmonized system code. */
  harmonizedSystemCode: Scalars['String']['input'];
};

/** The input fields required to create a media object. */
export type CreateMediaInput = {
  /** The alt text associated with the media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** The original source of the media object. This might be an external URL or a staged upload URL. */
  originalSource: Scalars['String']['input'];
};

/** The part of the image that should remain after cropping. */
export enum CropRegion {
  /** Keep the bottom of the image. */
  Bottom = 'BOTTOM',
  /** Keep the center of the image. */
  Center = 'CENTER',
  /** Keep the left of the image. */
  Left = 'LEFT',
  /** Keep the right of the image. */
  Right = 'RIGHT',
  /** Keep the top of the image. */
  Top = 'TOP'
}

/**
 * The currency codes that represent the world currencies throughout the Admin API. Currency codes include
 * [standard ISO 4217 codes](https://en.wikipedia.org/wiki/ISO_4217), legacy codes, non-standard codes,
 * digital currency codes.
 */
export enum CurrencyCode {
  /** United Arab Emirates Dirham (AED). */
  Aed = 'AED',
  /** Afghan Afghani (AFN). */
  Afn = 'AFN',
  /** Albanian Lek (ALL). */
  All = 'ALL',
  /** Armenian Dram (AMD). */
  Amd = 'AMD',
  /**
   * Netherlands Antillean Guilder.
   * @deprecated Use `XCG` instead.
   */
  Ang = 'ANG',
  /** Angolan Kwanza (AOA). */
  Aoa = 'AOA',
  /** Argentine Pesos (ARS). */
  Ars = 'ARS',
  /** Australian Dollars (AUD). */
  Aud = 'AUD',
  /** Aruban Florin (AWG). */
  Awg = 'AWG',
  /** Azerbaijani Manat (AZN). */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark (BAM). */
  Bam = 'BAM',
  /** Barbadian Dollar (BBD). */
  Bbd = 'BBD',
  /** Bangladesh Taka (BDT). */
  Bdt = 'BDT',
  /** Bulgarian Lev (BGN). */
  Bgn = 'BGN',
  /** Bahraini Dinar (BHD). */
  Bhd = 'BHD',
  /** Burundian Franc (BIF). */
  Bif = 'BIF',
  /** Bermudian Dollar (BMD). */
  Bmd = 'BMD',
  /** Brunei Dollar (BND). */
  Bnd = 'BND',
  /** Bolivian Boliviano (BOB). */
  Bob = 'BOB',
  /** Brazilian Real (BRL). */
  Brl = 'BRL',
  /** Bahamian Dollar (BSD). */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum (BTN). */
  Btn = 'BTN',
  /** Botswana Pula (BWP). */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN). */
  Byn = 'BYN',
  /**
   * Belarusian Ruble (BYR).
   * @deprecated Use `BYN` instead.
   */
  Byr = 'BYR',
  /** Belize Dollar (BZD). */
  Bzd = 'BZD',
  /** Canadian Dollars (CAD). */
  Cad = 'CAD',
  /** Congolese franc (CDF). */
  Cdf = 'CDF',
  /** Swiss Francs (CHF). */
  Chf = 'CHF',
  /** Chilean Peso (CLP). */
  Clp = 'CLP',
  /** Chinese Yuan Renminbi (CNY). */
  Cny = 'CNY',
  /** Colombian Peso (COP). */
  Cop = 'COP',
  /** Costa Rican Colones (CRC). */
  Crc = 'CRC',
  /** Cape Verdean escudo (CVE). */
  Cve = 'CVE',
  /** Czech Koruny (CZK). */
  Czk = 'CZK',
  /** Djiboutian Franc (DJF). */
  Djf = 'DJF',
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Dominican Peso (DOP). */
  Dop = 'DOP',
  /** Algerian Dinar (DZD). */
  Dzd = 'DZD',
  /** Egyptian Pound (EGP). */
  Egp = 'EGP',
  /** Eritrean Nakfa (ERN). */
  Ern = 'ERN',
  /** Ethiopian Birr (ETB). */
  Etb = 'ETB',
  /** Euro (EUR). */
  Eur = 'EUR',
  /** Fijian Dollars (FJD). */
  Fjd = 'FJD',
  /** Falkland Islands Pounds (FKP). */
  Fkp = 'FKP',
  /** United Kingdom Pounds (GBP). */
  Gbp = 'GBP',
  /** Georgian Lari (GEL). */
  Gel = 'GEL',
  /** Ghanaian Cedi (GHS). */
  Ghs = 'GHS',
  /** Gibraltar Pounds (GIP). */
  Gip = 'GIP',
  /** Gambian Dalasi (GMD). */
  Gmd = 'GMD',
  /** Guinean Franc (GNF). */
  Gnf = 'GNF',
  /** Guatemalan Quetzal (GTQ). */
  Gtq = 'GTQ',
  /** Guyanese Dollar (GYD). */
  Gyd = 'GYD',
  /** Hong Kong Dollars (HKD). */
  Hkd = 'HKD',
  /** Honduran Lempira (HNL). */
  Hnl = 'HNL',
  /** Croatian Kuna (HRK). */
  Hrk = 'HRK',
  /** Haitian Gourde (HTG). */
  Htg = 'HTG',
  /** Hungarian Forint (HUF). */
  Huf = 'HUF',
  /** Indonesian Rupiah (IDR). */
  Idr = 'IDR',
  /** Israeli New Shekel (NIS). */
  Ils = 'ILS',
  /** Indian Rupees (INR). */
  Inr = 'INR',
  /** Iraqi Dinar (IQD). */
  Iqd = 'IQD',
  /** Iranian Rial (IRR). */
  Irr = 'IRR',
  /** Icelandic Kronur (ISK). */
  Isk = 'ISK',
  /** Jersey Pound. */
  Jep = 'JEP',
  /** Jamaican Dollars (JMD). */
  Jmd = 'JMD',
  /** Jordanian Dinar (JOD). */
  Jod = 'JOD',
  /** Japanese Yen (JPY). */
  Jpy = 'JPY',
  /** Kenyan Shilling (KES). */
  Kes = 'KES',
  /** Kyrgyzstani Som (KGS). */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Kiribati Dollar (KID). */
  Kid = 'KID',
  /** Comorian Franc (KMF). */
  Kmf = 'KMF',
  /** South Korean Won (KRW). */
  Krw = 'KRW',
  /** Kuwaiti Dinar (KWD). */
  Kwd = 'KWD',
  /** Cayman Dollars (KYD). */
  Kyd = 'KYD',
  /** Kazakhstani Tenge (KZT). */
  Kzt = 'KZT',
  /** Laotian Kip (LAK). */
  Lak = 'LAK',
  /** Lebanese Pounds (LBP). */
  Lbp = 'LBP',
  /** Sri Lankan Rupees (LKR). */
  Lkr = 'LKR',
  /** Liberian Dollar (LRD). */
  Lrd = 'LRD',
  /** Lesotho Loti (LSL). */
  Lsl = 'LSL',
  /** Lithuanian Litai (LTL). */
  Ltl = 'LTL',
  /** Latvian Lati (LVL). */
  Lvl = 'LVL',
  /** Libyan Dinar (LYD). */
  Lyd = 'LYD',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu (MDL). */
  Mdl = 'MDL',
  /** Malagasy Ariary (MGA). */
  Mga = 'MGA',
  /** Macedonia Denar (MKD). */
  Mkd = 'MKD',
  /** Burmese Kyat (MMK). */
  Mmk = 'MMK',
  /** Mongolian Tugrik. */
  Mnt = 'MNT',
  /** Macanese Pataca (MOP). */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (MRU). */
  Mru = 'MRU',
  /** Mauritian Rupee (MUR). */
  Mur = 'MUR',
  /** Maldivian Rufiyaa (MVR). */
  Mvr = 'MVR',
  /** Malawian Kwacha (MWK). */
  Mwk = 'MWK',
  /** Mexican Pesos (MXN). */
  Mxn = 'MXN',
  /** Malaysian Ringgits (MYR). */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira (NGN). */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (NIO). */
  Nio = 'NIO',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Nepalese Rupee (NPR). */
  Npr = 'NPR',
  /** New Zealand Dollars (NZD). */
  Nzd = 'NZD',
  /** Omani Rial (OMR). */
  Omr = 'OMR',
  /** Panamian Balboa (PAB). */
  Pab = 'PAB',
  /** Peruvian Nuevo Sol (PEN). */
  Pen = 'PEN',
  /** Papua New Guinean Kina (PGK). */
  Pgk = 'PGK',
  /** Philippine Peso (PHP). */
  Php = 'PHP',
  /** Pakistani Rupee (PKR). */
  Pkr = 'PKR',
  /** Polish Zlotych (PLN). */
  Pln = 'PLN',
  /** Paraguayan Guarani (PYG). */
  Pyg = 'PYG',
  /** Qatari Rial (QAR). */
  Qar = 'QAR',
  /** Romanian Lei (RON). */
  Ron = 'RON',
  /** Serbian dinar (RSD). */
  Rsd = 'RSD',
  /** Russian Rubles (RUB). */
  Rub = 'RUB',
  /** Rwandan Franc (RWF). */
  Rwf = 'RWF',
  /** Saudi Riyal (SAR). */
  Sar = 'SAR',
  /** Solomon Islands Dollar (SBD). */
  Sbd = 'SBD',
  /** Seychellois Rupee (SCR). */
  Scr = 'SCR',
  /** Sudanese Pound (SDG). */
  Sdg = 'SDG',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK',
  /** Singapore Dollars (SGD). */
  Sgd = 'SGD',
  /** Saint Helena Pounds (SHP). */
  Shp = 'SHP',
  /** Sierra Leonean Leone (SLL). */
  Sll = 'SLL',
  /** Somali Shilling (SOS). */
  Sos = 'SOS',
  /** Surinamese Dollar (SRD). */
  Srd = 'SRD',
  /** South Sudanese Pound (SSP). */
  Ssp = 'SSP',
  /**
   * Sao Tome And Principe Dobra (STD).
   * @deprecated Use `STN` instead.
   */
  Std = 'STD',
  /** Sao Tome And Principe Dobra (STN). */
  Stn = 'STN',
  /** Syrian Pound (SYP). */
  Syp = 'SYP',
  /** Swazi Lilangeni (SZL). */
  Szl = 'SZL',
  /** Thai baht (THB). */
  Thb = 'THB',
  /** Tajikistani Somoni (TJS). */
  Tjs = 'TJS',
  /** Turkmenistani Manat (TMT). */
  Tmt = 'TMT',
  /** Tunisian Dinar (TND). */
  Tnd = 'TND',
  /** Tongan Pa'anga (TOP). */
  Top = 'TOP',
  /** Turkish Lira (TRY). */
  Try = 'TRY',
  /** Trinidad and Tobago Dollars (TTD). */
  Ttd = 'TTD',
  /** Taiwan Dollars (TWD). */
  Twd = 'TWD',
  /** Tanzanian Shilling (TZS). */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia (UAH). */
  Uah = 'UAH',
  /** Ugandan Shilling (UGX). */
  Ugx = 'UGX',
  /** United States Dollars (USD). */
  Usd = 'USD',
  /** United States Dollars Coin (USDC). */
  Usdc = 'USDC',
  /** Uruguayan Pesos (UYU). */
  Uyu = 'UYU',
  /** Uzbekistan som (UZS). */
  Uzs = 'UZS',
  /** Venezuelan Bolivares (VED). */
  Ved = 'VED',
  /**
   * Venezuelan Bolivares (VEF).
   * @deprecated Use `VES` instead.
   */
  Vef = 'VEF',
  /** Venezuelan Bolivares Soberanos (VES). */
  Ves = 'VES',
  /** Vietnamese đồng (VND). */
  Vnd = 'VND',
  /** Vanuatu Vatu (VUV). */
  Vuv = 'VUV',
  /** Samoan Tala (WST). */
  Wst = 'WST',
  /** Central African CFA Franc (XAF). */
  Xaf = 'XAF',
  /** East Caribbean Dollar (XCD). */
  Xcd = 'XCD',
  /** Caribbean Guilder (XCG). */
  Xcg = 'XCG',
  /** West African CFA franc (XOF). */
  Xof = 'XOF',
  /** CFP Franc (XPF). */
  Xpf = 'XPF',
  /** Unrecognized currency. */
  Xxx = 'XXX',
  /** Yemeni Rial (YER). */
  Yer = 'YER',
  /** South African Rand (ZAR). */
  Zar = 'ZAR',
  /** Zambian Kwacha (ZMW). */
  Zmw = 'ZMW'
}

/** Represents a currency exchange adjustment applied to an order transaction. */
export type CurrencyExchangeAdjustment = Node & {
  __typename?: 'CurrencyExchangeAdjustment';
  /** The adjustment amount in both shop and presentment currencies. */
  adjustment: MoneyV2;
  /** The final amount in both shop and presentment currencies after the adjustment. */
  finalAmountSet: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The original amount in both shop and presentment currencies before the adjustment. */
  originalAmountSet: MoneyV2;
};

/** Currency formats configured for the merchant. These formats are available to use within Liquid. */
export type CurrencyFormats = {
  __typename?: 'CurrencyFormats';
  /** Money without currency in HTML. */
  moneyFormat: Scalars['FormattedString']['output'];
  /** Money without currency in emails. */
  moneyInEmailsFormat: Scalars['String']['output'];
  /** Money with currency in HTML. */
  moneyWithCurrencyFormat: Scalars['FormattedString']['output'];
  /** Money with currency in emails. */
  moneyWithCurrencyInEmailsFormat: Scalars['String']['output'];
};

/** A setting for a presentment currency. */
export type CurrencySetting = {
  __typename?: 'CurrencySetting';
  /** The currency's ISO code. */
  currencyCode: CurrencyCode;
  /** The full name of the currency. */
  currencyName: Scalars['String']['output'];
  /** Whether the currency is enabled or not. An enabled currency setting is visible to buyers and allows orders to be generated with that currency as presentment. */
  enabled: Scalars['Boolean']['output'];
  /** The manual rate, if enabled, that applies to this currency when converting from shop currency. This rate is specific to the associated market's currency setting. */
  manualRate?: Maybe<Scalars['Decimal']['output']>;
  /** The date and time when the active exchange rate for the currency was last modified. It can be the automatic rate's creation date, or the manual rate's last updated at date if active. */
  rateUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An auto-generated type for paginating through multiple CurrencySettings. */
export type CurrencySettingConnection = {
  __typename?: 'CurrencySettingConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CurrencySettingEdge>;
  /** A list of nodes that are contained in CurrencySettingEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CurrencySetting>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CurrencySetting and a cursor during pagination. */
export type CurrencySettingEdge = {
  __typename?: 'CurrencySettingEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CurrencySettingEdge. */
  node: CurrencySetting;
};

/** The input fields for a custom shipping package used to pack shipment. */
export type CustomShippingPackageInput = {
  /** The default package is the one used to calculate shipping costs on checkout. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Outside dimensions of the empty shipping package. */
  dimensions?: InputMaybe<ObjectDimensionsInput>;
  /** Descriptive name for the package. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Type of package. */
  type?: InputMaybe<ShippingPackageType>;
  /** Weight of the empty shipping package. */
  weight?: InputMaybe<WeightInput>;
};

/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type Customer = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & HasStoreCreditAccounts & LegacyInteroperability & Node & {
  __typename?: 'Customer';
  /**
   * A list of addresses associated with the customer. Limited to 250 addresses. Use `addressesV2` for paginated access to all addresses.
   * @deprecated Limited to 250 addresses. Use `addressesV2` for paginated access to all addresses.
   */
  addresses: Array<MailingAddress>;
  /** The addresses associated with the customer. */
  addressesV2: MailingAddressConnection;
  /** The total amount that the customer has spent on orders in their lifetime. */
  amountSpent: MoneyV2;
  /**
   * Whether the merchant can delete the customer from their store.
   *
   * A customer can be deleted from a store only if they haven't yet made an order. After a customer makes an
   * order, they can't be deleted from a store.
   */
  canDelete: Scalars['Boolean']['output'];
  /** A list of the customer's company contact profiles. */
  companyContactProfiles: Array<CompanyContact>;
  /** The date and time when the customer was added to the store. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the customer has opted out of having their data sold. */
  dataSaleOptOut: Scalars['Boolean']['output'];
  /** The default address associated with the customer. */
  defaultAddress?: Maybe<MailingAddress>;
  /** The customer's default email address. */
  defaultEmailAddress?: Maybe<CustomerEmailAddress>;
  /** The customer's default phone number. */
  defaultPhoneNumber?: Maybe<CustomerPhoneNumber>;
  /**
   * The full name of the customer, based on the values for first_name and last_name. If the first_name and
   * last_name are not available, then this falls back to the customer's email address, and if that is not available, the customer's phone number.
   */
  displayName: Scalars['String']['output'];
  /**
   * The customer's email address.
   * @deprecated Use `defaultEmailAddress.emailAddress` instead.
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The current email marketing state for the customer.
   * If the customer doesn't have an email address, then this property is `null`.
   * @deprecated Use `defaultEmailAddress.marketingState`, `defaultEmailAddress.marketingOptInLevel`, `defaultEmailAddress.marketingUpdatedAt`, and `defaultEmailAddress.sourceLocation` instead.
   */
  emailMarketingConsent?: Maybe<CustomerEmailMarketingConsentState>;
  /** A list of events associated with the customer. */
  events: EventConnection;
  /** The customer's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the merchant has added timeline comments about the customer on the customer's page.
   * @deprecated To query for comments on the timeline, use the `events` connection and a 'query' argument containing `verb:comment`, or look for a 'CommentEvent' in the `__typename` of `events`.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The identity provider subject identifiers associated with this customer. */
  identityProviderSubjects: Array<IdentityProviderSubject>;
  /** The image associated with the customer. */
  image: Image;
  /** The customer's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The customer's last order. */
  lastOrder?: Maybe<Order>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /**
   * The amount of time since the customer was first added to the store.
   *
   * Example: 'about 12 years'.
   */
  lifetimeDuration: Scalars['String']['output'];
  /** The customer's locale. */
  locale: Scalars['String']['output'];
  /**
   * The market that applies to the customer’s default address country. In cases where multiple markets match, this returns the most-specific country region market.
   * @deprecated This `market` field will be removed in a future version of the API.
   */
  market?: Maybe<Market>;
  /** Whether the customer can be merged with another customer. */
  mergeable: CustomerMergeable;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A unique identifier for the customer that's used with Multipass login. */
  multipassIdentifier?: Maybe<Scalars['String']['output']>;
  /** A note about the customer. */
  note?: Maybe<Scalars['String']['output']>;
  /** The number of orders that the customer has made at the store in their lifetime. */
  numberOfOrders: Scalars['UnsignedInt64']['output'];
  /** A list of the customer's orders. */
  orders: OrderConnection;
  /** A list of the customer's payment methods. */
  paymentMethods: CustomerPaymentMethodConnection;
  /**
   * The customer's phone number.
   * @deprecated Use `defaultPhoneNumber.phoneNumber` instead.
   */
  phone?: Maybe<Scalars['String']['output']>;
  /** Possible subscriber states of a customer defined by their subscription contracts. */
  productSubscriberStatus: CustomerProductSubscriberStatus;
  /**
   * The current SMS marketing state for the customer's phone number.
   *
   * If the customer does not have a phone number, then this property is `null`.
   * @deprecated Use `defaultPhoneNumber.marketingState`, `defaultPhoneNumber.marketingOptInLevel`, `defaultPhoneNumber.marketingUpdatedAt`, `defaultPhoneNumber.marketingCollectedFrom`, and `defaultPhoneNumber.sourceLocation` instead.
   */
  smsMarketingConsent?: Maybe<CustomerSmsMarketingConsentState>;
  /**
   * The state of the customer's account with the shop.
   *
   * Please note that this only meaningful when Classic Customer Accounts is active.
   */
  state: CustomerState;
  /** The statistics for a given customer. */
  statistics: CustomerStatistics;
  /**
   * Returns a list of store credit accounts that belong to the owner resource.
   * A store credit account owner can hold multiple accounts each with a different currency.
   */
  storeCreditAccounts: StoreCreditAccountConnection;
  /** A list of the customer's subscription contracts. */
  subscriptionContracts: SubscriptionContractConnection;
  /** A comma separated list of tags that have been added to the customer. */
  tags: Array<Scalars['String']['output']>;
  /** Whether the customer is exempt from being charged taxes on their orders. */
  taxExempt: Scalars['Boolean']['output'];
  /** The list of tax exemptions applied to the customer. */
  taxExemptions: Array<TaxExemption>;
  /** The customer's tax settings. */
  taxSettings: TaxSettings;
  /**
   * The URL to unsubscribe the customer from the mailing list.
   * @deprecated Use `defaultEmailAddress.marketingUnsubscribeUrl` instead.
   */
  unsubscribeUrl: Scalars['URL']['output'];
  /** The date and time when the customer was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Whether the email address is formatted correctly.
   *
   * Returns `true` when the email is formatted correctly and
   * belongs to an existing domain. This doesn't guarantee that
   * the email address actually exists.
   * @deprecated Use `defaultEmailAddress.validFormat` instead.
   */
  validEmailAddress: Scalars['Boolean']['output'];
  /** Whether the customer has verified their email address. Defaults to `true` if the customer is created through the Shopify admin or API. */
  verifiedEmail: Scalars['Boolean']['output'];
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerAddressesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerAddressesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Information about a customer of the shop, such as the customer's contact details, purchase history, and marketing preferences.
 *
 * Tracks the customer's total spending through the [`amountSpent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-amountSpent) field and provides access to associated data such as payment methods and subscription contracts.
 *
 * > Caution:
 * > Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An app extension page for the customer account navigation menu. */
export type CustomerAccountAppExtensionPage = CustomerAccountPage & Navigable & Node & {
  __typename?: 'CustomerAccountAppExtensionPage';
  /** The UUID of the app extension. */
  appExtensionUuid?: Maybe<Scalars['String']['output']>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** A unique, human-friendly string for the customer account page. */
  handle: Scalars['String']['output'];
  /** The unique ID for the customer account page. */
  id: Scalars['ID']['output'];
  /** The title of the customer account page. */
  title: Scalars['String']['output'];
};

/** A native page for the customer account navigation menu. */
export type CustomerAccountNativePage = CustomerAccountPage & Navigable & Node & {
  __typename?: 'CustomerAccountNativePage';
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** A unique, human-friendly string for the customer account page. */
  handle: Scalars['String']['output'];
  /** The unique ID for the customer account page. */
  id: Scalars['ID']['output'];
  /** The type of customer account native page. */
  pageType: CustomerAccountNativePagePageType;
  /** The title of the customer account page. */
  title: Scalars['String']['output'];
};

/** The type of customer account native page. */
export enum CustomerAccountNativePagePageType {
  /** An orders page type. */
  NativeOrders = 'NATIVE_ORDERS',
  /** A profile page type. */
  NativeProfile = 'NATIVE_PROFILE',
  /** A settings page type. */
  NativeSettings = 'NATIVE_SETTINGS',
  /** An unknown page type. Represents new page types that may be added in future versions. */
  Unknown = 'UNKNOWN'
}

/** A customer account page. */
export type CustomerAccountPage = {
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** A unique, human-friendly string for the customer account page. */
  handle: Scalars['String']['output'];
  /** The unique ID for the customer account page. */
  id: Scalars['ID']['output'];
  /** The title of the customer account page. */
  title: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple CustomerAccountPages. */
export type CustomerAccountPageConnection = {
  __typename?: 'CustomerAccountPageConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CustomerAccountPageEdge>;
  /** A list of nodes that are contained in CustomerAccountPageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CustomerAccountPage>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerAccountPage and a cursor during pagination. */
export type CustomerAccountPageEdge = {
  __typename?: 'CustomerAccountPageEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerAccountPageEdge. */
  node: CustomerAccountPage;
};

/** Information about the shop's customer account-related settings. Includes the [customer account version](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerAccountsV2#field-CustomerAccountsV2.fields.customerAccountsVersion) which indicates whether the merchant is using new customer accounts or legacy customer accounts, along with other account configuration such as login requirements. */
export type CustomerAccountsV2 = {
  __typename?: 'CustomerAccountsV2';
  /** Indicates which version of customer accounts the merchant is using in online store and checkout. */
  customerAccountsVersion: CustomerAccountsVersion;
  /** Login links are shown in online store and checkout. */
  loginLinksVisibleOnStorefrontAndCheckout: Scalars['Boolean']['output'];
  /** Customers are required to log in to their account before checkout. */
  loginRequiredAtCheckout: Scalars['Boolean']['output'];
  /** The root url for the customer accounts pages. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The login redirection target for customer accounts. */
export enum CustomerAccountsVersion {
  /** The customer is redirected to the classic customer accounts login page. */
  Classic = 'CLASSIC',
  /** The customer is redirected to the new customer accounts login page. */
  NewCustomerAccounts = 'NEW_CUSTOMER_ACCOUNTS'
}

/** Return type for `customerAddTaxExemptions` mutation. */
export type CustomerAddTaxExemptionsPayload = {
  __typename?: 'CustomerAddTaxExemptionsPayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerAddressCreate` mutation. */
export type CustomerAddressCreatePayload = {
  __typename?: 'CustomerAddressCreatePayload';
  /** The created address. */
  address?: Maybe<MailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerAddressDelete` mutation. */
export type CustomerAddressDeletePayload = {
  __typename?: 'CustomerAddressDeletePayload';
  /** The ID of the address deleted from the customer. */
  deletedAddressId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerAddressUpdate` mutation. */
export type CustomerAddressUpdatePayload = {
  __typename?: 'CustomerAddressUpdatePayload';
  /** The updated address. */
  address?: Maybe<MailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Possible error codes that can be returned by `CustomerCancelDataErasureUserError`. */
export enum CustomerCancelDataErasureErrorCode {
  /** Customer does not exist. */
  DoesNotExist = 'DOES_NOT_EXIST',
  /** Failed to cancel customer data erasure. */
  FailedToCancel = 'FAILED_TO_CANCEL',
  /** Customer's data is not scheduled for erasure. */
  NotBeingErased = 'NOT_BEING_ERASED',
  /** Only the original requester can cancel this data erasure. */
  UnauthorizedCancellation = 'UNAUTHORIZED_CANCELLATION'
}

/** Return type for `customerCancelDataErasure` mutation. */
export type CustomerCancelDataErasurePayload = {
  __typename?: 'CustomerCancelDataErasurePayload';
  /** The ID of the customer whose pending data erasure has been cancelled. */
  customerId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerCancelDataErasureUserError>;
};

/** An error that occurs when cancelling a customer data erasure request. */
export type CustomerCancelDataErasureUserError = DisplayableError & {
  __typename?: 'CustomerCancelDataErasureUserError';
  /** The error code. */
  code?: Maybe<CustomerCancelDataErasureErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple Customers. */
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CustomerEdge>;
  /** A list of nodes that are contained in CustomerEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Customer>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The source that collected the customer's consent to receive marketing materials. */
export enum CustomerConsentCollectedFrom {
  /** The customer consent was collected outside of Shopify. */
  Other = 'OTHER',
  /** The customer consent was collected by Shopify. */
  Shopify = 'SHOPIFY'
}

/** Return type for `customerCreate` mutation. */
export type CustomerCreatePayload = {
  __typename?: 'CustomerCreatePayload';
  /** The created customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Represents a card instrument for customer payment method. */
export type CustomerCreditCard = {
  __typename?: 'CustomerCreditCard';
  /** The billing address of the card. */
  billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** The brand of the card. */
  brand: Scalars['String']['output'];
  /** Whether the card is about to expire. */
  expiresSoon: Scalars['Boolean']['output'];
  /** The expiry month of the card. */
  expiryMonth: Scalars['Int']['output'];
  /** The expiry year of the card. */
  expiryYear: Scalars['Int']['output'];
  /** The card's BIN number. */
  firstDigits?: Maybe<Scalars['String']['output']>;
  /** The payment method can be revoked if there are no active subscription contracts. */
  isRevocable: Scalars['Boolean']['output'];
  /** The last 4 digits of the card. */
  lastDigits: Scalars['String']['output'];
  /** The masked card number with only the last 4 digits displayed. */
  maskedNumber: Scalars['String']['output'];
  /** The name of the card holder. */
  name: Scalars['String']['output'];
  /** The source of the card if coming from a wallet such as Apple Pay. */
  source?: Maybe<Scalars['String']['output']>;
  /** The last 4 digits of the Device Account Number. */
  virtualLastDigits?: Maybe<Scalars['String']['output']>;
};

/** The billing address of a credit card payment instrument. */
export type CustomerCreditCardBillingAddress = {
  __typename?: 'CustomerCreditCardBillingAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  countryCode?: Maybe<CountryCode>;
  /** The first name in the billing address. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last name in the billing address. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** The input fields to delete a customer. */
export type CustomerDeleteInput = {
  /** The ID of the customer to delete. */
  id: Scalars['ID']['input'];
};

/** Return type for `customerDelete` mutation. */
export type CustomerDeletePayload = {
  __typename?: 'CustomerDeletePayload';
  /** The ID of the deleted customer. */
  deletedCustomerId?: Maybe<Scalars['ID']['output']>;
  /** The shop of the deleted customer. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one Customer and a cursor during pagination. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerEdge. */
  node: Customer;
};

/**
 * A customer's email address with marketing consent. This includes the email address, marketing subscription status, and opt-in level according to [M3AAWG best practices guidelines](https://www.m3aawg.org/news/updated-m3aawg-best-practices-for-senders-urge-opt-in-only-mailings-address-sender-transparency).
 *
 * It also provides the timestamp of when customers last updated marketing consent and URLs for unsubscribing from marketing emails or opting in or out of email open tracking. The [`sourceLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerEmailAddress#field-CustomerEmailAddress.fields.sourceLocation) field indicates where the customer consented to receive marketing material.
 */
export type CustomerEmailAddress = {
  __typename?: 'CustomerEmailAddress';
  /** The customer's default email address. */
  emailAddress: Scalars['String']['output'];
  /**
   * The marketing subscription opt-in level, as described by the M3AAWG best practices guidelines,
   * received when the marketing consent was updated.
   */
  marketingOptInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /** Whether the customer has subscribed to email marketing. */
  marketingState: CustomerEmailAddressMarketingState;
  /** The URL to unsubscribe a member from all mailing lists. */
  marketingUnsubscribeUrl: Scalars['URL']['output'];
  /**
   * The date and time at which the marketing consent was updated.
   *
   * No date is provided if the email address never updated its marketing consent.
   */
  marketingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the customer has opted in to having their opened emails tracked. */
  openTrackingLevel: CustomerEmailAddressOpenTrackingLevel;
  /** The URL that can be used to opt a customer in or out of email open tracking. */
  openTrackingUrl: Scalars['URL']['output'];
  /** The location where the customer consented to receive marketing material by email. */
  sourceLocation?: Maybe<Location>;
  /**
   * Whether the email address is formatted correctly.
   *
   * Returns `true` when the email is formatted correctly. This doesn't guarantee that the email address
   * actually exists.
   */
  validFormat: Scalars['Boolean']['output'];
};

/** Possible marketing states for the customer’s email address. */
export enum CustomerEmailAddressMarketingState {
  /** The customer’s email address marketing state is invalid. */
  Invalid = 'INVALID',
  /** The customer is not subscribed to email marketing. */
  NotSubscribed = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to email marketing. */
  Pending = 'PENDING',
  /** The customer is subscribed to email marketing. */
  Subscribed = 'SUBSCRIBED',
  /** The customer is not subscribed to email marketing but was previously subscribed. */
  Unsubscribed = 'UNSUBSCRIBED'
}

/** The different levels related to whether a customer has opted in to having their opened emails tracked. */
export enum CustomerEmailAddressOpenTrackingLevel {
  /** The customer has opted in to having their open emails tracked. */
  OptedIn = 'OPTED_IN',
  /** The customer has opted out of having their open emails tracked. */
  OptedOut = 'OPTED_OUT',
  /** The customer has not specified whether they want to opt in or out of having their open emails tracked. */
  Unknown = 'UNKNOWN'
}

/**
 * Information that describes when a customer consented to
 *         receiving marketing material by email.
 */
export type CustomerEmailMarketingConsentInput = {
  /**
   * The latest date and time when the customer consented or objected to
   *           receiving marketing material by email.
   */
  consentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The customer opt-in level at the time of subscribing to marketing material. */
  marketingOptInLevel?: InputMaybe<CustomerMarketingOptInLevel>;
  /** The marketing state to set. Accepted values: SUBSCRIBED, UNSUBSCRIBED, and PENDING. NOT_SUBSCRIBED, REDACTED, and INVALID are rejected if sent as input. */
  marketingState: CustomerEmailMarketingState;
  /** Identifies the location where the customer consented to receiving marketing material by email. */
  sourceLocationId?: InputMaybe<Scalars['ID']['input']>;
};

/** The record of when a customer consented to receive marketing material by email. */
export type CustomerEmailMarketingConsentState = {
  __typename?: 'CustomerEmailMarketingConsentState';
  /**
   * The date and time at which the customer consented to receive marketing material by email.
   * The customer's consent state reflects the consent record with the most recent `consent_updated_at` date.
   * If no date is provided, then the date and time at which the consent information was sent is used.
   */
  consentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The marketing subscription opt-in level, as described by the M3AAWG best practices guidelines,
   * that the customer gave when they consented to receive marketing material by email.
   */
  marketingOptInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /** The current email marketing state for the customer. */
  marketingState: CustomerEmailMarketingState;
  /** The location where the customer consented to receive marketing material by email. */
  sourceLocation?: Maybe<Location>;
};

/** The input fields for the email consent information to update for a given customer ID. */
export type CustomerEmailMarketingConsentUpdateInput = {
  /** The ID of the customer for which to update the email marketing consent information. The customer must have a unique email address associated to the record. If not, add the email address using the `customerUpdate` mutation first. */
  customerId: Scalars['ID']['input'];
  /** The marketing consent information when the customer consented to receiving marketing material by email. */
  emailMarketingConsent: CustomerEmailMarketingConsentInput;
};

/** Return type for `customerEmailMarketingConsentUpdate` mutation. */
export type CustomerEmailMarketingConsentUpdatePayload = {
  __typename?: 'CustomerEmailMarketingConsentUpdatePayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerEmailMarketingConsentUpdateUserError>;
};

/** An error that occurs during the execution of `CustomerEmailMarketingConsentUpdate`. */
export type CustomerEmailMarketingConsentUpdateUserError = DisplayableError & {
  __typename?: 'CustomerEmailMarketingConsentUpdateUserError';
  /** The error code. */
  code?: Maybe<CustomerEmailMarketingConsentUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerEmailMarketingConsentUpdateUserError`. */
export enum CustomerEmailMarketingConsentUpdateUserErrorCode {
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Missing a required argument. */
  MissingArgument = 'MISSING_ARGUMENT'
}

/** The possible email marketing states for a customer. */
export enum CustomerEmailMarketingState {
  /** This value is internally-set and read-only. */
  Invalid = 'INVALID',
  /**
   * Default state for customers who have never subscribed to email marketing.
   * This value cannot be set via the mutation; use UNSUBSCRIBED instead to indicate
   * a customer has opted out.
   */
  NotSubscribed = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to email marketing. */
  Pending = 'PENDING',
  /** The customer's personal data is erased. This value is internally-set and read-only. */
  Redacted = 'REDACTED',
  /** The customer is subscribed to email marketing. */
  Subscribed = 'SUBSCRIBED',
  /** The customer isn't currently subscribed to email marketing but was previously subscribed. */
  Unsubscribed = 'UNSUBSCRIBED'
}

/** Return type for `customerGenerateAccountActivationUrl` mutation. */
export type CustomerGenerateAccountActivationUrlPayload = {
  __typename?: 'CustomerGenerateAccountActivationUrlPayload';
  /** The generated account activation URL. */
  accountActivationUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for identifying a customer. */
export type CustomerIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the customer. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The email address of the customer. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the customer. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The phone number of the customer. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields and values to use when creating or updating a customer. */
export type CustomerInput = {
  addresses?: InputMaybe<Array<MailingAddressInput>>;
  /** The unique email address of the customer. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Information that describes when the customer consented to receiving marketing
   *         material by email. The `email` field is required when creating a customer with email marketing
   *         consent information.
   */
  emailMarketingConsent?: InputMaybe<CustomerEmailMarketingConsentInput>;
  /** The customer's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the customer to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The customer's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Additional metafields to associate to the customer. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** A unique identifier for the customer that's used with Multipass login. */
  multipassIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** A note about the customer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The unique phone number for the customer. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * The marketing consent information when the customer consented to receiving marketing
   *         material by SMS. The `phone` field is required when creating a customer with SMS
   *         marketing consent information.
   */
  smsMarketingConsent?: InputMaybe<CustomerSmsMarketingConsentInput>;
  /**
   * A list of tags to associate with the customer. Can be an array or a comma-separated list. Example values: `["tag1", "tag2", "tag3"]`, `"tag1, tag2, tag3"`
   *
   * Updating `tags` overwrites any existing tags that were previously added to the customer. To add new tags without overwriting
   * existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the customer is exempt from paying taxes on their order. */
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of tax exemptions to apply to the customer. */
  taxExemptions?: InputMaybe<Array<TaxExemption>>;
  /**
   * The marketing consent information when the customer consented to receiving marketing
   *         material by WhatsApp. The `phone` field is required when creating a customer with WhatsApp
   *         marketing consent information.
   */
  whatsAppMarketingConsent?: InputMaybe<CustomerMarketingConsentInput>;
};

/** Tracks a customer's path to purchase through their online store visits. The journey captures key moments like shop sessions that led to the order, helping merchants understand customer behavior and marketing attribution within a 30-day window. Includes the first and last sessions before an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order), the time between initial visit and conversion, and the customer's order position in their purchase history. */
export type CustomerJourney = {
  __typename?: 'CustomerJourney';
  /** The position of the current order within the customer's order history. */
  customerOrderIndex: Scalars['Int']['output'];
  /** The amount of days between first session and order creation date. First session represents first session since the last order, or first session within the 30 day attribution window, if more than 30 days has passed since the last order. */
  daysToConversion: Scalars['Int']['output'];
  /** The customer's first session going into the shop. */
  firstVisit: CustomerVisit;
  /** The last session before an order is made. */
  lastVisit?: Maybe<CustomerVisit>;
  /** Events preceding a customer order, such as shop sessions. */
  moments: Array<CustomerMoment>;
};

/**
 * A [`CustomerJourney`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerJourney) through the online store leading up to an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks session data, attribution sources, and the timeline from first visit to purchase conversion.
 *
 * The summary includes the customer's position in their order history, days between first visit and order creation, and details about their first and last sessions. Use the [`moments`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerJourneySummary#field-moments) connection to access the complete timeline of customer interactions before the purchase.
 */
export type CustomerJourneySummary = {
  __typename?: 'CustomerJourneySummary';
  /** The position of the current order within the customer's order history. Test orders aren't included. */
  customerOrderIndex?: Maybe<Scalars['Int']['output']>;
  /** The number of days between the first session and the order creation date. The first session represents the first session since the last order, or the first session within the 30 day attribution window, if more than 30 days have passed since the last order. */
  daysToConversion?: Maybe<Scalars['Int']['output']>;
  /** The customer's first session going into the shop. */
  firstVisit?: Maybe<CustomerVisit>;
  /** The last session before an order is made. */
  lastVisit?: Maybe<CustomerVisit>;
  /** The events preceding a customer's order, such as shop sessions. */
  moments?: Maybe<CustomerMomentConnection>;
  /** The total number of customer moments associated with this order. Returns null if the order is still in the process of being attributed. */
  momentsCount?: Maybe<Count>;
  /** Whether the attributed sessions for the order have been created yet. */
  ready: Scalars['Boolean']['output'];
};


/**
 * A [`CustomerJourney`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerJourney) through the online store leading up to an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks session data, attribution sources, and the timeline from first visit to purchase conversion.
 *
 * The summary includes the customer's position in their order history, days between first visit and order creation, and details about their first and last sessions. Use the [`moments`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerJourneySummary#field-moments) connection to access the complete timeline of customer interactions before the purchase.
 */
export type CustomerJourneySummaryMomentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The marketing consent information for a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) on a specific marketing channel. Channel-specific types like [`CustomerWhatsAppMarketingConsent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerWhatsAppMarketingConsent) implement this interface. */
export type CustomerMarketingConsent = {
  /** The [source](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerConsentCollectedFrom) from which the marketing consent was collected. */
  collectedFrom?: Maybe<CustomerConsentCollectedFrom>;
  /** The [marketing subscription opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingOptInLevel) that was set when the customer's marketing consent was last updated. Follows M3AAWG best practices guidelines. */
  optInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /** The [location](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where the customer consented to receive marketing material. */
  sourceLocation?: Maybe<Location>;
  /** The customer's current [marketing consent state](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingConsentState) for this channel. */
  state: CustomerMarketingConsentState;
  /**
   * The date and time when the marketing consent was updated.
   *
   * No date is provided if the customer has never updated their marketing consent for this channel.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An error from a customer marketing consent mutation, such as [`customerWhatsAppMarketingConsentUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate). */
export type CustomerMarketingConsentError = DisplayableError & {
  __typename?: 'CustomerMarketingConsentError';
  /** The error code. */
  code?: Maybe<CustomerMarketingConsentErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerMarketingConsentError`. */
export enum CustomerMarketingConsentErrorCode {
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Missing a required argument. */
  MissingArgument = 'MISSING_ARGUMENT'
}

/** The input fields for marketing consent information when a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) consents to receive marketing material on a specific channel. Channel-specific consent mutations like [`customerWhatsAppMarketingConsentUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate) use this input. */
export type CustomerMarketingConsentInput = {
  /** The [marketing subscription opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingOptInLevel) that was set when the customer consented to receive marketing information. */
  optInLevel?: InputMaybe<CustomerMarketingOptInLevel>;
  /** Identifies the [location](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where the customer consented to receiving marketing material. */
  sourceLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The [marketing consent state](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingConsentState) to set for the customer on this channel. */
  state: CustomerMarketingConsentState;
  /**
   * The date and time when the customer consented to receive marketing material.
   * If no date is provided, then the date and time when the consent information was sent is used.
   */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The valid marketing consent states for a customer on a specific marketing channel. The [`CustomerMarketingConsent`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/CustomerMarketingConsent) interface and channel-specific consent mutations use these values. */
export enum CustomerMarketingConsentState {
  /** The customer has never subscribed to marketing on this channel. This is the default state for any channel the customer hasn't interacted with. Read-only: can't be set as an input. */
  NeverSubscribed = 'NEVER_SUBSCRIBED',
  /** The customer is in the process of subscribing to marketing on this channel, for example, pending an opt-in confirmation. */
  Pending = 'PENDING',
  /** The customer's personal data is erased. This value is internally-set and read-only. */
  Redacted = 'REDACTED',
  /** The customer is subscribed to marketing on this channel. */
  Subscribed = 'SUBSCRIBED',
  /** The customer isn't currently subscribed to marketing on this channel but was previously subscribed. */
  Unsubscribed = 'UNSUBSCRIBED'
}

/**
 * The possible values for the marketing subscription opt-in level enabled at the time the customer consented to receive marketing information.
 *
 * The levels are defined by [the M3AAWG best practices guideline
 *   document](https://www.m3aawg.org/sites/maawg/files/news/M3AAWG_Senders_BCP_Ver3-2015-02.pdf).
 */
export enum CustomerMarketingOptInLevel {
  /**
   * After providing their information, the customer receives a confirmation and is required to
   * perform a intermediate step before receiving marketing information.
   */
  ConfirmedOptIn = 'CONFIRMED_OPT_IN',
  /**
   * After providing their information, the customer receives marketing information without any
   * intermediate steps.
   */
  SingleOptIn = 'SINGLE_OPT_IN',
  /** The customer receives marketing information but how they were opted in is unknown. */
  Unknown = 'UNKNOWN'
}

/** The error blocking a customer merge. */
export type CustomerMergeError = {
  __typename?: 'CustomerMergeError';
  /** The list of fields preventing the customer from being merged. */
  errorFields: Array<CustomerMergeErrorFieldType>;
  /** The customer merge error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerMergeUserError`. */
export enum CustomerMergeErrorCode {
  /** The customer cannot be merged because it has associated gift cards. */
  CustomerHasGiftCards = 'CUSTOMER_HAS_GIFT_CARDS',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The customer cannot be merged. */
  InvalidCustomer = 'INVALID_CUSTOMER',
  /** The customer ID is invalid. */
  InvalidCustomerId = 'INVALID_CUSTOMER_ID',
  /** The customer is missing the attribute requested for override. */
  MissingOverrideAttribute = 'MISSING_OVERRIDE_ATTRIBUTE',
  /** The override attribute is invalid. */
  OverrideAttributeInvalid = 'OVERRIDE_ATTRIBUTE_INVALID'
}

/** The types of the hard blockers preventing a customer from being merged to another customer. */
export enum CustomerMergeErrorFieldType {
  /** The customer is a company contact. */
  CompanyContact = 'COMPANY_CONTACT',
  /** The customer has payment methods. */
  CustomerPaymentMethods = 'CUSTOMER_PAYMENT_METHODS',
  /** The customer does not exist. */
  DeletedAt = 'DELETED_AT',
  /** The customer has gift cards. */
  GiftCards = 'GIFT_CARDS',
  /** The customer has a merge in progress. */
  MergeInProgress = 'MERGE_IN_PROGRESS',
  /** The customer has a multipass identifier. */
  MultipassIdentifier = 'MULTIPASS_IDENTIFIER',
  /** The override fields are invalid. */
  OverrideFields = 'OVERRIDE_FIELDS',
  /** The customer has a pending data request. */
  PendingDataRequest = 'PENDING_DATA_REQUEST',
  /** The customer has a pending or completed redaction. */
  RedactedAt = 'REDACTED_AT',
  /** The customer has store credit. */
  StoreCredit = 'STORE_CREDIT',
  /** The customer has a subscription history. */
  Subscriptions = 'SUBSCRIPTIONS'
}

/**
 * The input fields to override default customer merge rules. These overrides are field-specific; they don't
 * provide a general way to force a particular customer ID to survive the merge.
 */
export type CustomerMergeOverrideFields = {
  /** The ID of the customer whose default address will be kept. */
  customerIdOfDefaultAddressToKeep?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The ID of the customer whose email will be kept. The selected customer must have an email address. When
   * this field is provided and valid, the selected customer is also the resulting customer after the merge.
   */
  customerIdOfEmailToKeep?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the customer whose first name will be kept. */
  customerIdOfFirstNameToKeep?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the customer whose last name will be kept. */
  customerIdOfLastNameToKeep?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the customer whose phone number will be kept. */
  customerIdOfPhoneNumberToKeep?: InputMaybe<Scalars['ID']['input']>;
  /** The note to keep. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The tags to keep. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `customerMerge` mutation. */
export type CustomerMergePayload = {
  __typename?: 'CustomerMergePayload';
  /** The asynchronous job for merging the customers. */
  job?: Maybe<Job>;
  /** The ID of the customer that's kept after the merge. Treat this ID as authoritative. */
  resultingCustomerId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerMergeUserError>;
};

/**
 * A preview of the results of a customer merge request. Use `resultingCustomerId` to check which customer
 * would be kept before running `customerMerge`.
 */
export type CustomerMergePreview = {
  __typename?: 'CustomerMergePreview';
  /** The fields that can be used to override the default fields. */
  alternateFields?: Maybe<CustomerMergePreviewAlternateFields>;
  /** The fields that will block the merge if the two customers are merged. */
  blockingFields?: Maybe<CustomerMergePreviewBlockingFields>;
  /** The errors blocking the customer merge. */
  customerMergeErrors?: Maybe<Array<CustomerMergeError>>;
  /** The fields that will be kept if the two customers are merged. */
  defaultFields?: Maybe<CustomerMergePreviewDefaultFields>;
  /** The ID of the customer that would be kept if the two customers were merged. */
  resultingCustomerId?: Maybe<Scalars['ID']['output']>;
};

/** The fields that can be used to override the default fields. */
export type CustomerMergePreviewAlternateFields = {
  __typename?: 'CustomerMergePreviewAlternateFields';
  /** The default address of a customer. */
  defaultAddress?: Maybe<MailingAddress>;
  /** The email state of a customer. */
  email?: Maybe<CustomerEmailAddress>;
  /** The first name of a customer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last name of a customer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number state of a customer. */
  phoneNumber?: Maybe<CustomerPhoneNumber>;
};

/** The blocking fields of a customer merge preview. These fields will block customer merge unless edited. */
export type CustomerMergePreviewBlockingFields = {
  __typename?: 'CustomerMergePreviewBlockingFields';
  /** The merged note resulting from a customer merge. The merged note is over the 5000 character limit and will block customer merge. */
  note?: Maybe<Scalars['String']['output']>;
  /** The merged tags resulting from a customer merge. The merged tags are over the 250 limit and will block customer merge. */
  tags: Array<Scalars['String']['output']>;
};

/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFields = {
  __typename?: 'CustomerMergePreviewDefaultFields';
  /** The merged addresses resulting from a customer merge. */
  addresses: MailingAddressConnection;
  /** The default address resulting from a customer merge. */
  defaultAddress?: Maybe<MailingAddress>;
  /** The total number of customer-specific discounts resulting from a customer merge. */
  discountNodeCount: Scalars['UnsignedInt64']['output'];
  /** The merged customer-specific discounts resulting from a customer merge. */
  discountNodes: DiscountNodeConnection;
  /** The full name of the customer, based on the values for `first_name` and `last_name`. If `first_name` and `last_name` aren't available, then this field falls back to the customer's email address. If the customer's email isn't available, then this field falls back to the customer's phone number. */
  displayName: Scalars['String']['output'];
  /** The total number of merged draft orders. */
  draftOrderCount: Scalars['UnsignedInt64']['output'];
  /** The merged draft orders resulting from a customer merge. */
  draftOrders: DraftOrderConnection;
  /** The email state of a customer. */
  email?: Maybe<CustomerEmailAddress>;
  /** The first name resulting from a customer merge. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The total number of merged gift cards. */
  giftCardCount: Scalars['UnsignedInt64']['output'];
  /** The merged gift cards resulting from a customer merge. */
  giftCards: GiftCardConnection;
  /** The last name resulting from a customer merge. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The total number of merged metafields. */
  metafieldCount: Scalars['UnsignedInt64']['output'];
  /** The merged note resulting from a customer merge. */
  note?: Maybe<Scalars['String']['output']>;
  /** The total number of merged orders. */
  orderCount: Scalars['UnsignedInt64']['output'];
  /** The merged orders resulting from a customer merge. */
  orders: OrderConnection;
  /** The phone number state of a customer. */
  phoneNumber?: Maybe<CustomerPhoneNumber>;
  /** The merged tags resulting from a customer merge. */
  tags: Array<Scalars['String']['output']>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DiscountSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<GiftCardSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};

/** A merge request for merging two customers. */
export type CustomerMergeRequest = {
  __typename?: 'CustomerMergeRequest';
  /** The merge errors that occurred during the customer merge request. */
  customerMergeErrors: Array<CustomerMergeError>;
  /** The UUID of the merge job. */
  jobId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the customer that was kept after the merge. Treat this ID as authoritative. */
  resultingCustomerId: Scalars['ID']['output'];
  /** The status of the customer merge request. */
  status: CustomerMergeRequestStatus;
};

/** The status of the customer merge request. */
export enum CustomerMergeRequestStatus {
  /** The customer merge request has been completed. */
  Completed = 'COMPLETED',
  /** The customer merge request has failed. */
  Failed = 'FAILED',
  /** The customer merge request is currently in progress. */
  InProgress = 'IN_PROGRESS',
  /** The customer merge request has been requested. */
  Requested = 'REQUESTED'
}

/** An error that occurs while merging two customers. */
export type CustomerMergeUserError = DisplayableError & {
  __typename?: 'CustomerMergeUserError';
  /** The error code. */
  code?: Maybe<CustomerMergeErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** An object that represents whether a customer can be merged with another customer. */
export type CustomerMergeable = {
  __typename?: 'CustomerMergeable';
  /** The list of fields preventing the customer from being merged. */
  errorFields: Array<CustomerMergeErrorFieldType>;
  /** Whether the customer can be merged with another customer. */
  isMergeable: Scalars['Boolean']['output'];
  /** The merge request if one is currently in progress. */
  mergeInProgress?: Maybe<CustomerMergeRequest>;
  /** The reason why the customer can't be merged with another customer. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Represents a session preceding an order, often used for building a timeline of events leading to an order. */
export type CustomerMoment = {
  /** The date and time when the customer's session occurred. */
  occurredAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple CustomerMoments. */
export type CustomerMomentConnection = {
  __typename?: 'CustomerMomentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CustomerMomentEdge>;
  /** A list of nodes that are contained in CustomerMomentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CustomerMoment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerMoment and a cursor during pagination. */
export type CustomerMomentEdge = {
  __typename?: 'CustomerMomentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerMomentEdge. */
  node: CustomerMoment;
};

/** All possible instruments for CustomerPaymentMethods. */
export type CustomerPaymentInstrument = BankAccount | CustomerCreditCard | CustomerPaypalBillingAgreement | CustomerShopPayAgreement;

/** The billing address of a payment instrument. */
export type CustomerPaymentInstrumentBillingAddress = {
  __typename?: 'CustomerPaymentInstrumentBillingAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  countryCode?: Maybe<CountryCode>;
  /** The name of the buyer of the address. */
  name?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * A customer's saved payment method. Stores the payment instrument details and billing information for recurring charges.
 *
 * The payment method supports types included in the [`CustomerPaymentInstrument`](https://shopify.dev/docs/api/admin-graphql/latest/unions/CustomerPaymentInstrument) union.
 */
export type CustomerPaymentMethod = Node & {
  __typename?: 'CustomerPaymentMethod';
  /** The customer to whom the payment method belongs. */
  customer?: Maybe<Customer>;
  /** The ID of this payment method. */
  id: Scalars['ID']['output'];
  /** The instrument for this payment method. */
  instrument?: Maybe<CustomerPaymentInstrument>;
  /** The mandates associated with the payment method. */
  mandates: PaymentMandateResourceConnection;
  /** The time that the payment method was revoked. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The revocation reason for this payment method. */
  revokedReason?: Maybe<CustomerPaymentMethodRevocationReason>;
  /** List Subscription Contracts. */
  subscriptionContracts: SubscriptionContractConnection;
};


/**
 * A customer's saved payment method. Stores the payment instrument details and billing information for recurring charges.
 *
 * The payment method supports types included in the [`CustomerPaymentInstrument`](https://shopify.dev/docs/api/admin-graphql/latest/unions/CustomerPaymentInstrument) union.
 */
export type CustomerPaymentMethodMandatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A customer's saved payment method. Stores the payment instrument details and billing information for recurring charges.
 *
 * The payment method supports types included in the [`CustomerPaymentInstrument`](https://shopify.dev/docs/api/admin-graphql/latest/unions/CustomerPaymentInstrument) union.
 */
export type CustomerPaymentMethodSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple CustomerPaymentMethods. */
export type CustomerPaymentMethodConnection = {
  __typename?: 'CustomerPaymentMethodConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CustomerPaymentMethodEdge>;
  /** A list of nodes that are contained in CustomerPaymentMethodEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CustomerPaymentMethod>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `customerPaymentMethodCreateFromDuplicationData` mutation. */
export type CustomerPaymentMethodCreateFromDuplicationDataPayload = {
  __typename?: 'CustomerPaymentMethodCreateFromDuplicationDataPayload';
  /** The customer payment method. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodCreateFromDuplicationDataUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodCreateFromDuplicationData`. */
export type CustomerPaymentMethodCreateFromDuplicationDataUserError = DisplayableError & {
  __typename?: 'CustomerPaymentMethodCreateFromDuplicationDataUserError';
  /** The error code. */
  code?: Maybe<CustomerPaymentMethodCreateFromDuplicationDataUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodCreateFromDuplicationDataUserError`. */
export enum CustomerPaymentMethodCreateFromDuplicationDataUserErrorCode {
  /** Customer doesn't exist. */
  CustomerDoesNotExist = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid encrypted duplication data. */
  InvalidEncryptedDuplicationData = 'INVALID_ENCRYPTED_DUPLICATION_DATA',
  /** Too many requests. */
  TooManyRequests = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodCreditCardCreate` mutation. */
export type CustomerPaymentMethodCreditCardCreatePayload = {
  __typename?: 'CustomerPaymentMethodCreditCardCreatePayload';
  /** The customer payment method. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** If the card verification result is processing. When this is true, customer_payment_method will be null. */
  processing?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerPaymentMethodCreditCardUpdate` mutation. */
export type CustomerPaymentMethodCreditCardUpdatePayload = {
  __typename?: 'CustomerPaymentMethodCreditCardUpdatePayload';
  /** The customer payment method. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** If the card verification result is processing. When this is true, customer_payment_method will be null. */
  processing?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one CustomerPaymentMethod and a cursor during pagination. */
export type CustomerPaymentMethodEdge = {
  __typename?: 'CustomerPaymentMethodEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerPaymentMethodEdge. */
  node: CustomerPaymentMethod;
};

/** Return type for `customerPaymentMethodGetDuplicationData` mutation. */
export type CustomerPaymentMethodGetDuplicationDataPayload = {
  __typename?: 'CustomerPaymentMethodGetDuplicationDataPayload';
  /** The encrypted data from the payment method to be duplicated. */
  encryptedDuplicationData?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodGetDuplicationDataUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodGetDuplicationData`. */
export type CustomerPaymentMethodGetDuplicationDataUserError = DisplayableError & {
  __typename?: 'CustomerPaymentMethodGetDuplicationDataUserError';
  /** The error code. */
  code?: Maybe<CustomerPaymentMethodGetDuplicationDataUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodGetDuplicationDataUserError`. */
export enum CustomerPaymentMethodGetDuplicationDataUserErrorCode {
  /** Customer doesn't exist. */
  CustomerDoesNotExist = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid payment instrument. */
  InvalidInstrument = 'INVALID_INSTRUMENT',
  /** Must be targeted to another shop in the same organization. */
  InvalidOrganizationShop = 'INVALID_ORGANIZATION_SHOP',
  /** Payment method doesn't exist. */
  PaymentMethodDoesNotExist = 'PAYMENT_METHOD_DOES_NOT_EXIST',
  /** Target shop cannot be the same as the source. */
  SameShop = 'SAME_SHOP',
  /** Too many requests. */
  TooManyRequests = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodGetUpdateUrl` mutation. */
export type CustomerPaymentMethodGetUpdateUrlPayload = {
  __typename?: 'CustomerPaymentMethodGetUpdateUrlPayload';
  /** The URL to redirect the customer to update the payment method. */
  updatePaymentMethodUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodGetUpdateUrlUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodGetUpdateUrl`. */
export type CustomerPaymentMethodGetUpdateUrlUserError = DisplayableError & {
  __typename?: 'CustomerPaymentMethodGetUpdateUrlUserError';
  /** The error code. */
  code?: Maybe<CustomerPaymentMethodGetUpdateUrlUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodGetUpdateUrlUserError`. */
export enum CustomerPaymentMethodGetUpdateUrlUserErrorCode {
  /** Customer doesn't exist. */
  CustomerDoesNotExist = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid payment instrument. */
  InvalidInstrument = 'INVALID_INSTRUMENT',
  /** Payment method doesn't exist. */
  PaymentMethodDoesNotExist = 'PAYMENT_METHOD_DOES_NOT_EXIST',
  /** Too many requests. */
  TooManyRequests = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodPaypalBillingAgreementCreate` mutation. */
export type CustomerPaymentMethodPaypalBillingAgreementCreatePayload = {
  __typename?: 'CustomerPaymentMethodPaypalBillingAgreementCreatePayload';
  /** The customer payment method. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodUserError>;
};

/** Return type for `customerPaymentMethodPaypalBillingAgreementUpdate` mutation. */
export type CustomerPaymentMethodPaypalBillingAgreementUpdatePayload = {
  __typename?: 'CustomerPaymentMethodPaypalBillingAgreementUpdatePayload';
  /** The customer payment method. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodUserError>;
};

/** Return type for `customerPaymentMethodRemoteCreate` mutation. */
export type CustomerPaymentMethodRemoteCreatePayload = {
  __typename?: 'CustomerPaymentMethodRemoteCreatePayload';
  /** The customer payment method. Note that the returned payment method may initially be in an incomplete state. Developers should poll this payment method using the customerPaymentMethod query until all required payment details have been processed. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerPaymentMethodRemoteUserError>;
};

/** The input fields for a remote gateway payment method, only one remote reference permitted. */
export type CustomerPaymentMethodRemoteInput = {
  /** The input fields for a remote authorize net customer profile. */
  authorizeNetCustomerPaymentProfile?: InputMaybe<RemoteAuthorizeNetCustomerPaymentProfileInput>;
  /** The input fields for a remote Braintree customer profile. */
  braintreePaymentMethod?: InputMaybe<RemoteBraintreePaymentMethodInput>;
  /** Input containing the fields for a remote stripe credit card. */
  stripePaymentMethod?: InputMaybe<RemoteStripePaymentMethodInput>;
};

/** An error in the input of a mutation. Mutations return `UserError` objects to indicate validation failures, such as invalid field values or business logic violations, that prevent the operation from completing. */
export type CustomerPaymentMethodRemoteUserError = DisplayableError & {
  __typename?: 'CustomerPaymentMethodRemoteUserError';
  /** The error code. */
  code?: Maybe<CustomerPaymentMethodRemoteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodRemoteUserError`. */
export enum CustomerPaymentMethodRemoteUserErrorCode {
  /** Authorize.net is not enabled for subscriptions. */
  AuthorizeNetNotEnabledForSubscriptions = 'AUTHORIZE_NET_NOT_ENABLED_FOR_SUBSCRIPTIONS',
  /** Braintree is not enabled for subscriptions. */
  BraintreeNotEnabledForSubscriptions = 'BRAINTREE_NOT_ENABLED_FOR_SUBSCRIPTIONS',
  /** Exactly one remote reference is required. */
  ExactlyOneRemoteReferenceRequired = 'EXACTLY_ONE_REMOTE_REFERENCE_REQUIRED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN'
}

/** The revocation reason types for a customer payment method. */
export enum CustomerPaymentMethodRevocationReason {
  /** The Authorize.net payment gateway is not enabled. */
  AuthorizeNetGatewayNotEnabled = 'AUTHORIZE_NET_GATEWAY_NOT_ENABLED',
  /** Authorize.net did not return any payment methods. Make sure that the correct Authorize.net account is linked. */
  AuthorizeNetReturnedNoPaymentMethod = 'AUTHORIZE_NET_RETURNED_NO_PAYMENT_METHOD',
  /** Failed to contact Braintree API. */
  BraintreeApiAuthenticationError = 'BRAINTREE_API_AUTHENTICATION_ERROR',
  /** The Braintree payment gateway is not enabled. */
  BraintreeGatewayNotEnabled = 'BRAINTREE_GATEWAY_NOT_ENABLED',
  /** The Braintree payment method type should be a credit card or Apple Pay card. */
  BraintreePaymentMethodNotCard = 'BRAINTREE_PAYMENT_METHOD_NOT_CARD',
  /** Braintree returned no payment methods. Make sure the correct Braintree account is linked. */
  BraintreeReturnedNoPaymentMethod = 'BRAINTREE_RETURNED_NO_PAYMENT_METHOD',
  /** The customer redacted their payment method. */
  CustomerRedacted = 'CUSTOMER_REDACTED',
  /** CVV attempts limit exceeded. */
  CvvAttemptsLimitExceeded = 'CVV_ATTEMPTS_LIMIT_EXCEEDED',
  /** The billing address failed to retrieve. */
  FailedToRetrieveBillingAddress = 'FAILED_TO_RETRIEVE_BILLING_ADDRESS',
  /** The credit card failed to update. */
  FailedToUpdateCreditCard = 'FAILED_TO_UPDATE_CREDIT_CARD',
  /** The payment method was manually revoked. */
  ManuallyRevoked = 'MANUALLY_REVOKED',
  /** The payment method was replaced with an existing payment method. The associated contracts have been migrated to the other payment method. */
  Merged = 'MERGED',
  /** Verification of payment method failed. */
  PaymentMethodVerificationFailed = 'PAYMENT_METHOD_VERIFICATION_FAILED',
  /** Failed to contact the Stripe API. */
  StripeApiAuthenticationError = 'STRIPE_API_AUTHENTICATION_ERROR',
  /** Invalid request. Failed to retrieve payment method from Stripe. */
  StripeApiInvalidRequestError = 'STRIPE_API_INVALID_REQUEST_ERROR',
  /** The Stripe payment gateway is not enabled. */
  StripeGatewayNotEnabled = 'STRIPE_GATEWAY_NOT_ENABLED',
  /** The Stripe payment method type should be card. */
  StripePaymentMethodNotCard = 'STRIPE_PAYMENT_METHOD_NOT_CARD',
  /** Stripe did not return any payment methods. Make sure that the correct Stripe account is linked. */
  StripeReturnedNoPaymentMethod = 'STRIPE_RETURNED_NO_PAYMENT_METHOD',
  /** Verification of the payment method failed due to 3DS not being supported. */
  ThreeDSecureFlowInVerificationNotImplemented = 'THREE_D_SECURE_FLOW_IN_VERIFICATION_NOT_IMPLEMENTED',
  /** Too many consecutive failed attempts. */
  TooManyConsecutiveFailures = 'TOO_MANY_CONSECUTIVE_FAILURES'
}

/** Return type for `customerPaymentMethodRevoke` mutation. */
export type CustomerPaymentMethodRevokePayload = {
  __typename?: 'CustomerPaymentMethodRevokePayload';
  /** The ID of the revoked customer payment method. */
  revokedCustomerPaymentMethodId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerPaymentMethodSendUpdateEmail` mutation. */
export type CustomerPaymentMethodSendUpdateEmailPayload = {
  __typename?: 'CustomerPaymentMethodSendUpdateEmailPayload';
  /** The customer to whom an update payment method email was sent. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An error in the input of a mutation. Mutations return `UserError` objects to indicate validation failures, such as invalid field values or business logic violations, that prevent the operation from completing. */
export type CustomerPaymentMethodUserError = DisplayableError & {
  __typename?: 'CustomerPaymentMethodUserError';
  /** The error code. */
  code?: Maybe<CustomerPaymentMethodUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodUserError`. */
export enum CustomerPaymentMethodUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN'
}

/** Represents a PayPal instrument for customer payment method. */
export type CustomerPaypalBillingAgreement = {
  __typename?: 'CustomerPaypalBillingAgreement';
  /** The billing address of this payment method. */
  billingAddress?: Maybe<CustomerPaymentInstrumentBillingAddress>;
  /** Whether the PayPal billing agreement is inactive. */
  inactive: Scalars['Boolean']['output'];
  /** Whether the payment method can be revoked.The payment method can be revoked if there are no active subscription contracts. */
  isRevocable: Scalars['Boolean']['output'];
  /** The customers's PayPal account email address. */
  paypalAccountEmail?: Maybe<Scalars['String']['output']>;
};

/** A phone number. */
export type CustomerPhoneNumber = {
  __typename?: 'CustomerPhoneNumber';
  /**
   * The source from which the SMS marketing information for the customer was collected.
   * @deprecated Use `smsMarketingConsent.collectedFrom` instead.
   */
  marketingCollectedFrom?: Maybe<CustomerConsentCollectedFrom>;
  /**
   * The marketing subscription opt-in level, as described by the M3AAWG best practices guidelines,
   * received when the marketing consent was updated.
   * @deprecated Use `smsMarketingConsent.optInLevel` instead.
   */
  marketingOptInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /**
   * Whether the customer has subscribed to SMS marketing material.
   * @deprecated Use `smsMarketingConsent.state` instead.
   */
  marketingState: CustomerSmsMarketingState;
  /**
   * The date and time at which the marketing consent was updated.
   *
   * No date is provided if the email address never updated its marketing consent.
   * @deprecated Use `smsMarketingConsent.updatedAt` instead.
   */
  marketingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A customer's phone number. */
  phoneNumber: Scalars['String']['output'];
  /**
   * The location where the customer consented to receive marketing material by SMS.
   * @deprecated Use `smsMarketingConsent.sourceLocation` instead.
   */
  sourceLocation?: Maybe<Location>;
  /** The [WhatsApp marketing consent](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerWhatsAppMarketingConsent) information for the customer's phone number. Update with the [`customerWhatsAppMarketingConsentUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate) mutation. */
  whatsAppMarketingConsent: CustomerWhatsAppMarketingConsent;
};

/** The valid tiers for the predicted spend of a customer with a shop. */
export enum CustomerPredictedSpendTier {
  /** The customer's spending is predicted to be in the top spending range for the shop in the following year. */
  High = 'HIGH',
  /** The customer's spending is predicted to be zero, or in the lowest spending range for the shop in the following year. */
  Low = 'LOW',
  /** The customer's spending is predicted to be in the normal spending range for the shop in the following year. */
  Medium = 'MEDIUM'
}

/** The possible product subscription states for a customer, as defined by the customer's subscription contracts. */
export enum CustomerProductSubscriberStatus {
  /** The customer has at least one active subscription contract. */
  Active = 'ACTIVE',
  /**
   * The customer's last subscription contract was cancelled and there are no other active or paused
   * subscription contracts.
   */
  Cancelled = 'CANCELLED',
  /**
   * The customer's last subscription contract expired and there are no other active or paused
   * subscription contracts.
   */
  Expired = 'EXPIRED',
  /**
   * The customer's last subscription contract failed and there are no other active or paused
   * subscription contracts.
   */
  Failed = 'FAILED',
  /** The customer has never had a subscription contract. */
  NeverSubscribed = 'NEVER_SUBSCRIBED',
  /**
   * The customer has at least one paused subscription contract and there are no other active
   * subscription contracts.
   */
  Paused = 'PAUSED'
}

/** Return type for `customerRemoveTaxExemptions` mutation. */
export type CustomerRemoveTaxExemptionsPayload = {
  __typename?: 'CustomerRemoveTaxExemptionsPayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerReplaceTaxExemptions` mutation. */
export type CustomerReplaceTaxExemptionsPayload = {
  __typename?: 'CustomerReplaceTaxExemptionsPayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Possible error codes that can be returned by `CustomerRequestDataErasureUserError`. */
export enum CustomerRequestDataErasureErrorCode {
  /** Customer does not exist. */
  DoesNotExist = 'DOES_NOT_EXIST',
  /** Failed to request customer data erasure. */
  FailedToRequest = 'FAILED_TO_REQUEST'
}

/** Return type for `customerRequestDataErasure` mutation. */
export type CustomerRequestDataErasurePayload = {
  __typename?: 'CustomerRequestDataErasurePayload';
  /** The ID of the customer that will be erased. */
  customerId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerRequestDataErasureUserError>;
};

/** An error that occurs when requesting a customer data erasure. */
export type CustomerRequestDataErasureUserError = DisplayableError & {
  __typename?: 'CustomerRequestDataErasureUserError';
  /** The error code. */
  code?: Maybe<CustomerRequestDataErasureErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The RFM (Recency, Frequency, Monetary) group for a customer. */
export enum CustomerRfmGroup {
  /** Customers with recent purchases, some orders, and moderate spend. */
  Active = 'ACTIVE',
  /** Customers without recent purchases, fewer orders, and with lower spend. */
  AlmostLost = 'ALMOST_LOST',
  /** Customers without recent purchases, but with a strong history of orders and spend. */
  AtRisk = 'AT_RISK',
  /** Customers with very recent purchases, many orders, and the most spend. */
  Champions = 'CHAMPIONS',
  /** Customers without recent orders, with infrequent orders, and with low spend. */
  Dormant = 'DORMANT',
  /** Customers with recent purchases, many orders, and the most spend. */
  Loyal = 'LOYAL',
  /** Customers with recent purchases, some orders, and moderate spend. */
  NeedsAttention = 'NEEDS_ATTENTION',
  /** Customers with very recent purchases, few orders, and low spend. */
  New = 'NEW',
  /** Customers without recent purchases, but with a very strong history of orders and spend. */
  PreviouslyLoyal = 'PREVIOUSLY_LOYAL',
  /** Customers with recent purchases, few orders, and low spend. */
  Promising = 'PROMISING',
  /** Customers with no orders yet. */
  Prospects = 'PROSPECTS'
}

/** The set of valid sort keys for the CustomerSavedSearch query. */
export enum CustomerSavedSearchSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME'
}

/** The member of a segment. */
export type CustomerSegmentMember = HasMetafields & {
  __typename?: 'CustomerSegmentMember';
  /** The total amount of money that the member has spent on orders. */
  amountSpent?: Maybe<MoneyV2>;
  /** The member's default address. */
  defaultAddress?: Maybe<MailingAddress>;
  /** The member's default email address. */
  defaultEmailAddress?: Maybe<CustomerEmailAddress>;
  /** The member's default phone number. */
  defaultPhoneNumber?: Maybe<CustomerPhoneNumber>;
  /** The full name of the member, which is based on the values of the `first_name` and `last_name` fields. If the member's first name and last name aren't available, then the customer's email address is used. If the customer's email address isn't available, then the customer's phone number is used. */
  displayName: Scalars['String']['output'];
  /** The member's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The member’s ID. */
  id: Scalars['ID']['output'];
  /** The member's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The ID of the member's most recent order. */
  lastOrderId?: Maybe<Scalars['ID']['output']>;
  /** Whether the customer can be merged with another customer. */
  mergeable: CustomerMergeable;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A note about the member. */
  note?: Maybe<Scalars['String']['output']>;
  /** The total number of orders that the member has made. */
  numberOfOrders?: Maybe<Scalars['UnsignedInt64']['output']>;
};


/** The member of a segment. */
export type CustomerSegmentMemberMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** The member of a segment. */
export type CustomerSegmentMemberMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for the `CustomerSegmentMembers` object. */
export type CustomerSegmentMemberConnection = {
  __typename?: 'CustomerSegmentMemberConnection';
  /** A list of edges. */
  edges: Array<CustomerSegmentMemberEdge>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
  /** The statistics for a given segment. */
  statistics: SegmentStatistics;
  /** The total number of members in a given segment. */
  totalCount: Scalars['Int']['output'];
};

/** An auto-generated type which holds one CustomerSegmentMember and a cursor during pagination. */
export type CustomerSegmentMemberEdge = {
  __typename?: 'CustomerSegmentMemberEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerSegmentMemberEdge. */
  node: CustomerSegmentMember;
};

/** A job to determine a list of members, such as customers, that are associated with an individual segment. */
export type CustomerSegmentMembersQuery = JobResult & Node & {
  __typename?: 'CustomerSegmentMembersQuery';
  /** The current total number of members in a given segment. */
  currentCount: Scalars['Int']['output'];
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
};

/** Return type for `customerSegmentMembersQueryCreate` mutation. */
export type CustomerSegmentMembersQueryCreatePayload = {
  __typename?: 'CustomerSegmentMembersQueryCreatePayload';
  /** The newly created customer segment members query. */
  customerSegmentMembersQuery?: Maybe<CustomerSegmentMembersQuery>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerSegmentMembersQueryUserError>;
};

/** The input fields and values for creating a customer segment members query. */
export type CustomerSegmentMembersQueryInput = {
  /** The query that's used to filter the members. The query is composed of a combination of conditions on facts about customers such as `email_subscription_status = 'SUBSCRIBED'` with [this syntax](https://shopify.dev/api/shopifyql/segment-query-language-reference). */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Reverse the order of the list. The sorting behaviour defaults to ascending order. */
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the segment. */
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Sort the list by a given key. */
  sortKey?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a customer segment members query custom error. */
export type CustomerSegmentMembersQueryUserError = DisplayableError & {
  __typename?: 'CustomerSegmentMembersQueryUserError';
  /** The error code. */
  code?: Maybe<CustomerSegmentMembersQueryUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerSegmentMembersQueryUserError`. */
export enum CustomerSegmentMembersQueryUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `customerSendAccountInviteEmail` mutation. */
export type CustomerSendAccountInviteEmailPayload = {
  __typename?: 'CustomerSendAccountInviteEmailPayload';
  /** The customer to whom an account invite email was sent. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerSendAccountInviteEmailUserError>;
};

/** Defines errors for customerSendAccountInviteEmail mutation. */
export type CustomerSendAccountInviteEmailUserError = DisplayableError & {
  __typename?: 'CustomerSendAccountInviteEmailUserError';
  /** The error code. */
  code?: Maybe<CustomerSendAccountInviteEmailUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerSendAccountInviteEmailUserError`. */
export enum CustomerSendAccountInviteEmailUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** The input fields required to identify a customer. */
export type CustomerSetIdentifiers = {
  /** Custom ID of customer to upsert. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** Email address of the customer to upsert. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of customer to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Phone number of the customer to upsert. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields and values to use when creating or updating a customer. */
export type CustomerSetInput = {
  /** The addresses for a customer. */
  addresses?: InputMaybe<Array<MailingAddressInput>>;
  /** The unique email address of the customer. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The customer's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** A note about the customer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The unique phone number for the customer. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * A list of tags to associate with the customer. Can be an array or a comma-separated list. Example values: `["tag1", "tag2", "tag3"]`, `"tag1, tag2, tag3"`
   *
   * Updating `tags` overwrites any existing tags that were previously added to the customer. To add new tags without overwriting
   * existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the customer is exempt from paying taxes on their order. */
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of tax exemptions to apply to the customer. */
  taxExemptions?: InputMaybe<Array<TaxExemption>>;
};

/** Return type for `customerSet` mutation. */
export type CustomerSetPayload = {
  __typename?: 'CustomerSetPayload';
  /** The created or updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerSetUserError>;
};

/** Defines errors for CustomerSet mutation. */
export type CustomerSetUserError = DisplayableError & {
  __typename?: 'CustomerSetUserError';
  /** The error code. */
  code?: Maybe<CustomerSetUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerSetUserError`. */
export enum CustomerSetUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The id field is not allowed if identifier is provided. */
  IdNotAllowed = 'ID_NOT_ALLOWED',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The identifier value does not match the value of the corresponding field in the input. */
  InputMismatch = 'INPUT_MISMATCH',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input argument `metafields` (if present) must contain the `customId` value. */
  MetafieldMismatch = 'METAFIELD_MISMATCH',
  /** The input field corresponding to the identifier is required. */
  MissingFieldRequired = 'MISSING_FIELD_REQUIRED',
  /** Resource matching the identifier was not found. */
  NotFound = 'NOT_FOUND',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT'
}

/** Represents a Shop Pay card instrument for customer payment method. */
export type CustomerShopPayAgreement = {
  __typename?: 'CustomerShopPayAgreement';
  /** The billing address of the card. */
  billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** Whether the card is about to expire. */
  expiresSoon: Scalars['Boolean']['output'];
  /** The expiry month of the card. */
  expiryMonth: Scalars['Int']['output'];
  /** The expiry year of the card. */
  expiryYear: Scalars['Int']['output'];
  /** Whether the Shop Pay billing agreement is inactive. */
  inactive: Scalars['Boolean']['output'];
  /** The payment method can be revoked if there are no active subscription contracts. */
  isRevocable: Scalars['Boolean']['output'];
  /** The last 4 digits of the card. */
  lastDigits: Scalars['String']['output'];
  /** The masked card number with only the last 4 digits displayed. */
  maskedNumber: Scalars['String']['output'];
  /** The name of the card holder. */
  name: Scalars['String']['output'];
};

/** An error that occurs during execution of an SMS marketing consent mutation. */
export type CustomerSmsMarketingConsentError = DisplayableError & {
  __typename?: 'CustomerSmsMarketingConsentError';
  /** The error code. */
  code?: Maybe<CustomerSmsMarketingConsentErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `CustomerSmsMarketingConsentError`. */
export enum CustomerSmsMarketingConsentErrorCode {
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Missing a required argument. */
  MissingArgument = 'MISSING_ARGUMENT'
}

/**
 * The marketing consent information when the customer consented to
 *         receiving marketing material by SMS.
 */
export type CustomerSmsMarketingConsentInput = {
  /**
   * The date and time when the customer consented to receive marketing material by SMS.
   * If no date is provided, then the date and time when the consent information was sent is used.
   */
  consentUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The marketing subscription opt-in level that was set when the customer consented to receive marketing information. */
  marketingOptInLevel?: InputMaybe<CustomerMarketingOptInLevel>;
  /** The current SMS marketing state for the customer. */
  marketingState: CustomerSmsMarketingState;
  /** Identifies the location where the customer consented to receiving marketing material by SMS. */
  sourceLocationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * The record of when a customer consented to receive marketing material by SMS.
 *
 * The customer's consent state reflects the record with the most recent date when consent was updated.
 */
export type CustomerSmsMarketingConsentState = {
  __typename?: 'CustomerSmsMarketingConsentState';
  /** The source from which the SMS marketing information for the customer was collected. */
  consentCollectedFrom?: Maybe<CustomerConsentCollectedFrom>;
  /**
   * The date and time when the customer consented to receive marketing material by SMS.
   * If no date is provided, then the date and time when the consent information was sent is used.
   */
  consentUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The marketing subscription opt-in level that was set when the customer consented to receive marketing information. */
  marketingOptInLevel: CustomerMarketingOptInLevel;
  /** The current SMS marketing state for the customer. */
  marketingState: CustomerSmsMarketingState;
  /** The location where the customer consented to receive marketing material by SMS. */
  sourceLocation?: Maybe<Location>;
};

/** The input fields for updating SMS marketing consent information for a given customer ID. */
export type CustomerSmsMarketingConsentUpdateInput = {
  /** The ID of the customer to update the SMS marketing consent information for. The customer must have a unique phone number associated to the record. If not, add the phone number using the `customerUpdate` mutation first. */
  customerId: Scalars['ID']['input'];
  /** The marketing consent information when the customer consented to receiving marketing material by SMS. */
  smsMarketingConsent: CustomerSmsMarketingConsentInput;
};

/** Return type for `customerSmsMarketingConsentUpdate` mutation. */
export type CustomerSmsMarketingConsentUpdatePayload = {
  __typename?: 'CustomerSmsMarketingConsentUpdatePayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerSmsMarketingConsentError>;
};

/** The valid SMS marketing states for a customer’s phone number. */
export enum CustomerSmsMarketingState {
  /** The customer hasn't subscribed to SMS marketing. */
  NotSubscribed = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to SMS marketing. */
  Pending = 'PENDING',
  /** The customer's personal data is erased. This value is internally-set and read-only. */
  Redacted = 'REDACTED',
  /** The customer is subscribed to SMS marketing. */
  Subscribed = 'SUBSCRIBED',
  /** The customer isn't currently subscribed to SMS marketing but was previously subscribed. */
  Unsubscribed = 'UNSUBSCRIBED'
}

/** The set of valid sort keys for the Customer query. */
export enum CustomerSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `location` value. */
  Location = 'LOCATION',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The valid values for the state of a customer's account with a shop. */
export enum CustomerState {
  /** The customer declined the email invite to create an account. */
  Declined = 'DECLINED',
  /** The customer doesn't have an active account. Customer accounts can be disabled from the Shopify admin at any time. */
  Disabled = 'DISABLED',
  /** The customer has created an account. */
  Enabled = 'ENABLED',
  /** The customer has received an email invite to create an account. */
  Invited = 'INVITED'
}

/** A customer's computed statistics. */
export type CustomerStatistics = {
  __typename?: 'CustomerStatistics';
  /** The predicted spend tier of a customer with a shop. */
  predictedSpendTier?: Maybe<CustomerPredictedSpendTier>;
  /** The RFM (Recency, Frequency, Monetary) group of the customer. */
  rfmGroup?: Maybe<CustomerRfmGroup>;
};

/** Return type for `customerUpdateDefaultAddress` mutation. */
export type CustomerUpdateDefaultAddressPayload = {
  __typename?: 'CustomerUpdateDefaultAddressPayload';
  /** The customer whose address was updated. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `customerUpdate` mutation. */
export type CustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  /** The updated customer. */
  customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * A customer's session on the online store. Tracks how the [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) arrived at the store, including the landing page, referral source, and any associated marketing campaigns.
 *
 * The visit captures attribution data such as [`UTMParameters`](https://shopify.dev/docs/api/admin-graphql/latest/objects/UTMParameters), referral codes, and the [`MarketingEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketingEvent) that drove the session. This information helps merchants understand which marketing efforts successfully bring customers to their store.
 */
export type CustomerVisit = CustomerMoment & Node & {
  __typename?: 'CustomerVisit';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** URL of the first page the customer landed on for the session. */
  landingPage?: Maybe<Scalars['URL']['output']>;
  /** Landing page information with URL linked in HTML. For example, the first page the customer visited was store.myshopify.com/products/1. */
  landingPageHtml?: Maybe<Scalars['HTML']['output']>;
  /**
   * Represent actions taken by an app, on behalf of a merchant,
   * to market Shopify resources such as products, collections, and discounts.
   */
  marketingEvent?: Maybe<MarketingEvent>;
  /** The date and time when the customer's session occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * Marketing referral code from the link that the customer clicked to visit the store.
   * Supports the following URL attributes: _ref_, _source_, or _r_.
   * For example, if the URL is myshopifystore.com/products/slide?ref=j2tj1tn2, then this value is j2tj1tn2.
   */
  referralCode?: Maybe<Scalars['String']['output']>;
  /** Referral information with URLs linked in HTML. */
  referralInfoHtml: Scalars['FormattedString']['output'];
  /**
   * Webpage where the customer clicked a link that sent them to the online store.
   * For example, _https://randomblog.com/page1_ or _android-app://com.google.android.gm_.
   */
  referrerUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * Source from which the customer visited the store, such as a platform (Facebook, Google), email, direct,
   * a website domain, QR code, or unknown.
   */
  source: Scalars['String']['output'];
  /** Describes the source explicitly for first or last session. */
  sourceDescription?: Maybe<Scalars['String']['output']>;
  /** Type of marketing tactic. */
  sourceType?: Maybe<MarketingTactic>;
  /** A set of UTM parameters gathered from the URL parameters of the referrer. */
  utmParameters?: Maybe<UtmParameters>;
};

/** This type returns the information about the product and product variant from a customer visit. */
export type CustomerVisitProductInfo = {
  __typename?: 'CustomerVisitProductInfo';
  /** The product information. If `null`, then the product was deleted from the store. */
  product?: Maybe<Product>;
  /** The quantity of the product that the customer requested. */
  quantity: Scalars['Int']['output'];
  /** The product variant information, if the product variant exists. */
  variant?: Maybe<ProductVariant>;
};

/** An auto-generated type for paginating through multiple CustomerVisitProductInfos. */
export type CustomerVisitProductInfoConnection = {
  __typename?: 'CustomerVisitProductInfoConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<CustomerVisitProductInfoEdge>;
  /** A list of nodes that are contained in CustomerVisitProductInfoEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<CustomerVisitProductInfo>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerVisitProductInfo and a cursor during pagination. */
export type CustomerVisitProductInfoEdge = {
  __typename?: 'CustomerVisitProductInfoEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of CustomerVisitProductInfoEdge. */
  node: CustomerVisitProductInfo;
};

/** The WhatsApp marketing consent information for a [customer's phone number](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPhoneNumber). Implements the [`CustomerMarketingConsent`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/CustomerMarketingConsent) interface. Use the [`customerWhatsAppMarketingConsentUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate) mutation to update it. */
export type CustomerWhatsAppMarketingConsent = CustomerMarketingConsent & {
  __typename?: 'CustomerWhatsAppMarketingConsent';
  /** The [source](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerConsentCollectedFrom) from which the marketing consent was collected. */
  collectedFrom?: Maybe<CustomerConsentCollectedFrom>;
  /** The [marketing subscription opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingOptInLevel) that was set when the customer's marketing consent was last updated. Follows M3AAWG best practices guidelines. */
  optInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /** The [location](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where the customer consented to receive marketing material. */
  sourceLocation?: Maybe<Location>;
  /** The customer's current [marketing consent state](https://shopify.dev/docs/api/admin-graphql/latest/enums/CustomerMarketingConsentState) for this channel. */
  state: CustomerMarketingConsentState;
  /**
   * The date and time when the marketing consent was updated.
   *
   * No date is provided if the customer has never updated their marketing consent for this channel.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The input fields to update a customer's WhatsApp marketing consent information. */
export type CustomerWhatsAppMarketingConsentUpdateInput = {
  /** The ID of the [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) to update the WhatsApp marketing consent information for. The customer must have a unique phone number associated with their record. If not, then add the phone number using the [`customerUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerUpdate) mutation first. */
  customerId: Scalars['ID']['input'];
  /** The marketing consent information when the customer consented to receiving marketing material by WhatsApp. */
  whatsAppMarketingConsent: CustomerMarketingConsentInput;
};

/** Return type for `customerWhatsAppMarketingConsentUpdate` mutation. */
export type CustomerWhatsAppMarketingConsentUpdatePayload = {
  __typename?: 'CustomerWhatsAppMarketingConsentUpdatePayload';
  /** The [customer phone number](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPhoneNumber) with the updated WhatsApp marketing consent information. */
  customerPhoneNumber?: Maybe<CustomerPhoneNumber>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<CustomerMarketingConsentError>;
};

/** A shop's data sale opt out page. */
export type DataSaleOptOutPage = {
  __typename?: 'DataSaleOptOutPage';
  /** If the data sale opt out page is auto managed. */
  autoManaged: Scalars['Boolean']['output'];
};

/** Return type for `dataSaleOptOut` mutation. */
export type DataSaleOptOutPayload = {
  __typename?: 'DataSaleOptOutPayload';
  /** The ID of the customer whose email address has been opted out of data sale. */
  customerId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DataSaleOptOutUserError>;
};

/** An error that occurs during the execution of `DataSaleOptOut`. */
export type DataSaleOptOutUserError = DisplayableError & {
  __typename?: 'DataSaleOptOutUserError';
  /** The error code. */
  code?: Maybe<DataSaleOptOutUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DataSaleOptOutUserError`. */
export enum DataSaleOptOutUserErrorCode {
  /** Data sale opt out failed. */
  Failed = 'FAILED'
}

/** Days of the week from Monday to Sunday. */
export enum DayOfTheWeek {
  /** Friday. */
  Friday = 'FRIDAY',
  /** Monday. */
  Monday = 'MONDAY',
  /** Saturday. */
  Saturday = 'SATURDAY',
  /** Sunday. */
  Sunday = 'SUNDAY',
  /** Thursday. */
  Thursday = 'THURSDAY',
  /** Tuesday. */
  Tuesday = 'TUESDAY',
  /** Wednesday. */
  Wednesday = 'WEDNESDAY'
}

/**
 * A token that delegates a set of scopes from the original permission.
 *
 * To learn more about creating delegate access tokens, refer to
 * [Delegate OAuth access tokens to subsystems](https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/use-delegate-tokens).
 */
export type DelegateAccessToken = {
  __typename?: 'DelegateAccessToken';
  /** The list of permissions associated with the token. */
  accessScopes: Array<Scalars['String']['output']>;
  /** The issued delegate access token. */
  accessToken: Scalars['String']['output'];
  /** The date and time when the delegate access token was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of seconds until the delegate access token expires. */
  expiresIn?: Maybe<Scalars['Int']['output']>;
};

/** Return type for `delegateAccessTokenCreate` mutation. */
export type DelegateAccessTokenCreatePayload = {
  __typename?: 'DelegateAccessTokenCreatePayload';
  /** The delegate access token. */
  delegateAccessToken?: Maybe<DelegateAccessToken>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DelegateAccessTokenCreateUserError>;
};

/** An error that occurs during the execution of `DelegateAccessTokenCreate`. */
export type DelegateAccessTokenCreateUserError = DisplayableError & {
  __typename?: 'DelegateAccessTokenCreateUserError';
  /** The error code. */
  code?: Maybe<DelegateAccessTokenCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DelegateAccessTokenCreateUserError`. */
export enum DelegateAccessTokenCreateUserErrorCode {
  /** The parent access token can't be a delegate token. */
  DelegateAccessToken = 'DELEGATE_ACCESS_TOKEN',
  /** The access scope can't be empty. */
  EmptyAccessScope = 'EMPTY_ACCESS_SCOPE',
  /** The delegate token can't expire after the parent token. */
  ExpiresAfterParent = 'EXPIRES_AFTER_PARENT',
  /** The expires_in value must be greater than 0. */
  NegativeExpiresIn = 'NEGATIVE_EXPIRES_IN',
  /** Persistence failed. */
  PersistenceFailed = 'PERSISTENCE_FAILED',
  /** The parent access token can't have a refresh token. */
  RefreshToken = 'REFRESH_TOKEN',
  /** Unknown scopes. */
  UnknownScopes = 'UNKNOWN_SCOPES'
}

/** Return type for `delegateAccessTokenDestroy` mutation. */
export type DelegateAccessTokenDestroyPayload = {
  __typename?: 'DelegateAccessTokenDestroyPayload';
  /** The user's shop. */
  shop: Shop;
  /** The status of the delegate access token destroy operation. Returns true if successful. */
  status?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DelegateAccessTokenDestroyUserError>;
};

/** An error that occurs during the execution of `DelegateAccessTokenDestroy`. */
export type DelegateAccessTokenDestroyUserError = DisplayableError & {
  __typename?: 'DelegateAccessTokenDestroyUserError';
  /** The error code. */
  code?: Maybe<DelegateAccessTokenDestroyUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DelegateAccessTokenDestroyUserError`. */
export enum DelegateAccessTokenDestroyUserErrorCode {
  /** Access denied. */
  AccessDenied = 'ACCESS_DENIED',
  /** Access token not found. */
  AccessTokenNotFound = 'ACCESS_TOKEN_NOT_FOUND',
  /** Cannot delete parent access token. */
  CanOnlyDeleteDelegateTokens = 'CAN_ONLY_DELETE_DELEGATE_TOKENS',
  /** Persistence failed. */
  PersistenceFailed = 'PERSISTENCE_FAILED'
}

/** The input fields for a delegate access token. */
export type DelegateAccessTokenInput = {
  /** The list of scopes that will be delegated to the new access token. */
  delegateAccessScope: Array<Scalars['String']['input']>;
  /** The amount of time, in seconds, after which the delegate access token is no longer valid. */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Deletion events chronicle the destruction of resources (e.g. products and collections).
 * Once deleted, the deletion event is the only trace of the original's existence,
 * as the resource itself has been removed and can no longer be accessed.
 */
export type DeletionEvent = {
  __typename?: 'DeletionEvent';
  /** The date and time when the deletion event for the related resource was generated. */
  occurredAt: Scalars['DateTime']['output'];
  /** The ID of the resource that was deleted. */
  subjectId: Scalars['ID']['output'];
  /** The type of resource that was deleted. */
  subjectType: DeletionEventSubjectType;
};

/** An auto-generated type for paginating through multiple DeletionEvents. */
export type DeletionEventConnection = {
  __typename?: 'DeletionEventConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeletionEventEdge>;
  /** A list of nodes that are contained in DeletionEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeletionEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeletionEvent and a cursor during pagination. */
export type DeletionEventEdge = {
  __typename?: 'DeletionEventEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeletionEventEdge. */
  node: DeletionEvent;
};

/** The set of valid sort keys for the DeletionEvent query. */
export enum DeletionEventSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The supported subject types of deletion events. */
export enum DeletionEventSubjectType {
  Collection = 'COLLECTION',
  Product = 'PRODUCT'
}

/** A shipping service and a list of countries that the service is available for. */
export type DeliveryAvailableService = {
  __typename?: 'DeliveryAvailableService';
  /** The countries the service provider ships to. */
  countries: DeliveryCountryCodesOrRestOfWorld;
  /** The name of the service. */
  name: Scalars['String']['output'];
};

/** Represents a branded promise presented to buyers. */
export type DeliveryBrandedPromise = {
  __typename?: 'DeliveryBrandedPromise';
  /** The handle of the branded promise.  For example: `shop_promise`. */
  handle: Scalars['String']['output'];
  /** The name of the branded promise.  For example: `Shop Promise`. */
  name: Scalars['String']['output'];
};

/**
 * A shipping option with rates calculated by a carrier service.
 *
 * Carrier-calculated options fetch real-time rates from carriers(e.g., UPS, FedEx) at checkout
 * instead of using merchant-defined fixed prices.
 */
export type DeliveryCarrierCalculatedOptionDefinition = DeliveryOptionDefinition & {
  __typename?: 'DeliveryCarrierCalculatedOptionDefinition';
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: Maybe<Scalars['String']['output']>;
  /** The cart subtotal required for free shipping. Null if no threshold is set. */
  freeDeliveryMinimumValue?: Maybe<MoneyV2>;
  /** A globally unique ID for this shipping option. */
  id: Scalars['ID']['output'];
  /** Collections that any rate group in this shipping option applies to. */
  includedCollections?: Maybe<CollectionConnection>;
  /** Origin locations that any rate group in this shipping option applies to. */
  includedLocations?: Maybe<LocationConnection>;
  /** Whether this shipping option is active and shown to buyers. */
  isActive: Scalars['Boolean']['output'];
  /** The rate groups for this carrier-calculated shipping option. */
  rateGroups?: Maybe<DeliveryCarrierCalculatedRateGroupConnection>;
};


/**
 * A shipping option with rates calculated by a carrier service.
 *
 * Carrier-calculated options fetch real-time rates from carriers(e.g., UPS, FedEx) at checkout
 * instead of using merchant-defined fixed prices.
 */
export type DeliveryCarrierCalculatedOptionDefinitionIncludedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates calculated by a carrier service.
 *
 * Carrier-calculated options fetch real-time rates from carriers(e.g., UPS, FedEx) at checkout
 * instead of using merchant-defined fixed prices.
 */
export type DeliveryCarrierCalculatedOptionDefinitionIncludedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates calculated by a carrier service.
 *
 * Carrier-calculated options fetch real-time rates from carriers(e.g., UPS, FedEx) at checkout
 * instead of using merchant-defined fixed prices.
 */
export type DeliveryCarrierCalculatedOptionDefinitionRateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating a carrier-calculated shipping option. */
export type DeliveryCarrierCalculatedOptionDefinitionCreateInput = {
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** Whether this shipping option is active and shown to buyers. Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rate groups to create for this shipping option. At this time, only a single rate group is supported for carrier calculated shipping options. */
  rateGroups: Array<DeliveryCarrierCalculatedRateGroupCreateInput>;
};

/** The input fields for updating a carrier-calculated shipping option. */
export type DeliveryCarrierCalculatedOptionDefinitionUpdateInput = {
  /** The currency used for all money values in this shipping option. */
  currency?: InputMaybe<CurrencyCode>;
  /** Description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Null clears the existing threshold. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** The ID of the carrier-calculated shipping option to update. */
  id: Scalars['ID']['input'];
  /** Whether this shipping option is active and shown to buyers. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Rate groups to create for this shipping option. At this time, only a single rate group is supported for carrier calculated shipping options. */
  rateGroupsToCreate?: InputMaybe<Array<DeliveryCarrierCalculatedRateGroupCreateInput>>;
  /** The IDs of rate groups to delete from this shipping option. */
  rateGroupsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rate groups to update for this shipping option. Only the existing single rate group is supported. */
  rateGroupsToUpdate?: InputMaybe<Array<DeliveryCarrierCalculatedRateGroupUpdateInput>>;
};

/**
 * A rate group for a carrier-calculated shipping option.
 *
 * Sets the carrier service, rate adjustments,
 * and carrier-provided services offered at checkout.
 */
export type DeliveryCarrierCalculatedRateGroup = DeliveryOptionDefinitionRateGroup & {
  __typename?: 'DeliveryCarrierCalculatedRateGroup';
  /** The flat amount added to or subtracted from carrier rates. */
  absoluteAdjustment?: Maybe<MoneyV2>;
  /**
   * Whether new services from this carrier are automatically included at checkout.
   * When true, buyers see any service that isn't excluded.
   * When false, buyers see only included services.
   */
  autoIncludeNewServices: Scalars['Boolean']['output'];
  /** The carrier service that provides rates for this rate group. */
  carrierService: DeliveryCarrierService;
  /** Conditions that limit this rate group to specific collections or origin locations. */
  conditions: DeliveryRateGroupConditions;
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The percentage added to or subtracted from carrier rates.
   * Applied after `absoluteAdjustment`. A value of 10 means +10%.
   */
  percentageAdjustment?: Maybe<Scalars['Int']['output']>;
  /** Carrier-provided services included or excluded for this rate group. */
  serviceConfiguration: Array<DeliveryCarrierCalculatedRateGroupService>;
};

/** An auto-generated type for paginating through multiple DeliveryCarrierCalculatedRateGroups. */
export type DeliveryCarrierCalculatedRateGroupConnection = {
  __typename?: 'DeliveryCarrierCalculatedRateGroupConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryCarrierCalculatedRateGroupEdge>;
  /** A list of nodes that are contained in DeliveryCarrierCalculatedRateGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryCarrierCalculatedRateGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a rate group for a carrier-calculated shipping option. */
export type DeliveryCarrierCalculatedRateGroupCreateInput = {
  /** The flat amount added to or subtracted from carrier rates. */
  absoluteAdjustment?: InputMaybe<MoneyInput>;
  /**
   * Whether new services from this carrier are automatically included at checkout.
   * When omitted, defaults to true. Set to false to offer only explicitly
   * included services for carriers that support service discovery.
   */
  autoIncludeNewServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the carrier service to use for this rate group. */
  carrierServiceId: Scalars['ID']['input'];
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsCreateInput>;
  /** The percentage added to or subtracted from carrier rates. */
  percentageAdjustment?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Carrier-provided services to include or exclude.
   * Services not listed follow the default behavior based on `autoIncludeNewServices`.
   */
  serviceConfiguration?: InputMaybe<Array<DeliveryCarrierCalculatedRateGroupServiceInput>>;
};

/** An auto-generated type which holds one DeliveryCarrierCalculatedRateGroup and a cursor during pagination. */
export type DeliveryCarrierCalculatedRateGroupEdge = {
  __typename?: 'DeliveryCarrierCalculatedRateGroupEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryCarrierCalculatedRateGroupEdge. */
  node: DeliveryCarrierCalculatedRateGroup;
};

/**
 * A carrier-provided service within a carrier-calculated rate group.
 *
 * Represents an individual service that the merchant has explicitly included or excluded.
 */
export type DeliveryCarrierCalculatedRateGroupService = {
  __typename?: 'DeliveryCarrierCalculatedRateGroupService';
  /** The name of the carrier-provided service. */
  name: Scalars['String']['output'];
  /** Whether this service is included or excluded at checkout. */
  status: DeliveryCarrierCalculatedRateGroupServiceStatus;
};

/** The input fields for including or excluding a carrier-provided service in a rate group. */
export type DeliveryCarrierCalculatedRateGroupServiceInput = {
  /** The name of the carrier-provided service. */
  name: Scalars['String']['input'];
  /** Whether this service is included or excluded at checkout. */
  status: DeliveryCarrierCalculatedRateGroupServiceStatus;
};

/** Whether a carrier-provided service is included at checkout. */
export enum DeliveryCarrierCalculatedRateGroupServiceStatus {
  /** The service is excluded at checkout. */
  Excluded = 'EXCLUDED',
  /** The service is included at checkout. */
  Included = 'INCLUDED'
}

/** The input fields for updating a rate group for a carrier-calculated shipping option. */
export type DeliveryCarrierCalculatedRateGroupUpdateInput = {
  /** The flat amount added to or subtracted from carrier rates. */
  absoluteAdjustment?: InputMaybe<MoneyInput>;
  /**
   * Whether new services from this carrier are automatically included at checkout.
   * When true, buyers see any service that isn't excluded.
   * When false, buyers see only included services.
   */
  autoIncludeNewServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the carrier service that provides rates for this shipping option. */
  carrierServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsUpdateInput>;
  /** The ID of the rate group to update */
  id: Scalars['ID']['input'];
  /** The percentage added to or subtracted from carrier rates. */
  percentageAdjustment?: InputMaybe<Scalars['Int']['input']>;
  /** Carrier-provided services to include or exclude. Replaces the existing configuration. */
  serviceConfiguration?: InputMaybe<Array<DeliveryCarrierCalculatedRateGroupServiceInput>>;
};

/**
 * A carrier service (also known as a carrier calculated service or shipping service) provides real-time shipping rates to Shopify. Some common carrier services include Canada Post, FedEx, UPS, and USPS. The term **carrier** is often used interchangeably with the terms **shipping company** and **rate provider**.
 *
 * Using the CarrierService resource, you can add a carrier service to a shop and then provide a list of applicable shipping rates at checkout. You can even use the cart data to adjust shipping rates and offer shipping discounts based on what is in the customer's cart.
 *
 * ## Requirements for accessing the CarrierService resource
 * To access the CarrierService resource, add the `write_shipping` permission to your app's requested scopes. For more information, see [API access scopes](https://shopify.dev/docs/admin-api/access-scopes).
 *
 * Your app's request to create a carrier service will fail unless the store installing your carrier service meets one of the following requirements:
 * * It's on the Advanced Shopify plan or higher.
 * * It's on the Shopify plan with yearly billing, or the carrier service feature has been added to the store for a monthly fee. For more information, contact [Shopify Support](https://help.shopify.com/questions).
 * * It's a development store that isn't on the Basic plan.
 *
 * > Note:
 * > If a store changes its Shopify plan, then the store's association with a carrier service is deactivated if the store no long meets one of the requirements above.
 *
 * ## Providing shipping rates to Shopify
 * When adding a carrier service to a store, you need to provide a POST endpoint rooted in the `callbackUrl` property where Shopify can retrieve applicable shipping rates. The callback URL should be a public endpoint that expects these requests from Shopify.
 *
 * ### Example shipping rate request sent to a carrier service
 *
 * ```json
 * {
 *   "rate": {
 *     "origin": {
 *       "country": "CA",
 *       "postal_code": "K2P1L4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": null,
 *       "address1": "150 Elgin St.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": "Jamie D's Emporium"
 *     },
 *     "destination": {
 *       "country": "CA",
 *       "postal_code": "K1M1M4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": "Bob Norman",
 *       "address1": "24 Sussex Dr.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": null
 *     },
 *     "items": [{
 *       "name": "Short Sleeve T-Shirt",
 *       "sku": "",
 *       "quantity": 1,
 *       "grams": 1000,
 *       "price": 1999,
 *       "vendor": "Jamie D's Emporium",
 *       "requires_shipping": true,
 *       "taxable": true,
 *       "fulfillment_service": "manual",
 *       "properties": null,
 *       "product_id": 48447225880,
 *       "variant_id": 258644705304
 *     }],
 *     "currency": "USD",
 *     "locale": "en",
 *     "order_totals": {
 *       "subtotal_price": "1999",
 *       "total_price": "2199",
 *       "discount_amount": "150"
 *     },
 *     "customer": {
 *       "id": 207119551,
 *       "tags": ["VIP", "wholesale"]
 *     }
 *   }
 * }
 * ```
 *
 * ### Example response
 * ```json
 * {
 *    "rates": [
 *        {
 *            "service_name": "canadapost-overnight",
 *            "service_code": "ON",
 *            "total_price": "1295",
 *            "description": "This is the fastest option by far",
 *            "currency": "CAD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-2dayground",
 *            "service_code": "2D",
 *            "total_price": "2934",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-priorityovernight",
 *            "service_code": "1D",
 *            "total_price": "3587",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "metafields": [
 *                {
 *                    "key": "tracking_url",
 *                    "value": "abc123",
 *                    "namespace": "carrier_service_metadata",
 *                    "type": "single_line_text_field"
 *                }
 *            ]
 *        }
 *    ]
 * }
 * ```
 *
 * The `address3`, `fax`, `address_type`, and `company_name` fields are returned by specific [ActiveShipping](https://github.com/Shopify/active_shipping) providers. For API-created carrier services, you should use only the following shipping address fields:
 * * `address1`
 * * `address2`
 * * `city`
 * * `zip`
 * * `province`
 * * `country`
 *
 * Other values remain as `null` and are not sent to the callback URL.
 *
 * ### Response fields
 *
 * When Shopify requests shipping rates using your callback URL, the response object `rates` must be a JSON array of objects with the following fields.  Required fields must be included in the response for the carrier service integration to work properly.
 *
 * | Field                   | Required | Description                                                                                                                                                                                                  |
 * | ----------------------- | -------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
 * | `service_name`          | Yes      | The name of the rate, which customers see at checkout. For example: `Expedited Mail`.                                                                                                                        |
 * | `description`           | Yes      | A description of the rate, which customers see at checkout. For example: `Includes tracking and insurance`.                                                                                                  |
 * | `service_code`          | Yes      | A unique code associated with the rate that must be consistent across requests. For example: `expedited_mail`.                                                                                               |
 * | `currency`              | Yes      | The currency of the shipping rate.                                                                                                                                                                           |
 * | `total_price`           | Yes      | The total price expressed in subunits. If the currency doesn't use subunits, then the value must be multiplied by 100. For example: `"total_price": 500` for 5.00 CAD, `"total_price": 100000` for 1000 JPY. |
 * | `phone_required`        | No       | Whether the customer must provide a phone number at checkout.                                                                                                                                                |
 * | `min_delivery_date`     | No       | The earliest delivery date for the displayed rate.                                                                                                                                                           |
 * | `max_delivery_date`     | No       | The latest delivery date for the displayed rate to still be valid.                                                                                                                                           |
 * | `metafields`            | No       | An array of metafield objects to attach custom metadata to the shipping rate.                                                                                                                                |
 *
 * ### Special conditions
 *
 * * To indicate that this carrier service cannot handle this shipping request, return an empty array and any successful (20x) HTTP code.
 * * To force backup rates instead, return a 40x or 50x HTTP code with any content. A good choice is the regular 404 Not Found code.
 * * Redirects (30x codes) will only be followed for the same domain as the original callback URL. Attempting to redirect to a different domain will trigger backup rates.
 * * There is no retry mechanism. The response must be successful on the first try, within the time budget listed below. Timeouts or errors will trigger backup rates.
 * * The `service_code` must be stable and consistent across requests for the same shipping option. It should not contain dynamic values like session IDs, timestamps, or request-specific identifiers. Use metafields for passing dynamic or session-specific data.
 *
 * ## Response Timeouts
 *
 * The read timeout for rate requests are dynamic, based on the number of requests per minute (RPM). These limits are applied to each shop-app pair. The timeout values are as follows.
 *
 * | RPM Range     | Timeout    |
 * | ------------- | ---------- |
 * | Under 1500    | 10s        |
 * | 1500 to 3000  | 5s         |
 * | Over 3000     | 3s         |
 *
 * > Note:
 * > These values are upper limits and should not be interpretted as a goal to develop towards. Shopify is constantly evaluating the performance of the platform and working towards improving resilience as well as app capabilities. As such, these numbers may be adjusted outside of our normal versioning timelines.
 *
 * ## Server-side caching of requests
 * Shopify provides server-side caching to reduce the number of requests it makes. Any shipping rate request that identically matches the following fields will be retrieved from Shopify's cache of the initial response:
 * * variant IDs
 * * default shipping box weight and dimensions
 * * variant quantities
 * * carrier service ID
 * * origin address
 * * destination address
 * * item weights and signatures
 *
 * If any of these fields differ, or if the cache has expired since the original request, then new shipping rates are requested. The cache expires 15 minutes after rates are successfully returned. If an error occurs, then the cache expires after 30 seconds. The fields and cache duration are subject to change without notice.
 */
export type DeliveryCarrierService = Node & {
  __typename?: 'DeliveryCarrierService';
  /** Whether the carrier service is active. */
  active: Scalars['Boolean']['output'];
  /** The list of services offered for given destinations. */
  availableServicesForCountries: Array<DeliveryAvailableService>;
  /** The URL endpoint that Shopify needs to retrieve shipping rates. */
  callbackUrl?: Maybe<Scalars['URL']['output']>;
  /** The date and time when the carrier service was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The properly formatted name of the shipping service provider, ready to display. */
  formattedName?: Maybe<Scalars['String']['output']>;
  /** The logo of the service provider. */
  icon: Image;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the shipping service provider. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  supportsServiceDiscovery: Scalars['Boolean']['output'];
};


/**
 * A carrier service (also known as a carrier calculated service or shipping service) provides real-time shipping rates to Shopify. Some common carrier services include Canada Post, FedEx, UPS, and USPS. The term **carrier** is often used interchangeably with the terms **shipping company** and **rate provider**.
 *
 * Using the CarrierService resource, you can add a carrier service to a shop and then provide a list of applicable shipping rates at checkout. You can even use the cart data to adjust shipping rates and offer shipping discounts based on what is in the customer's cart.
 *
 * ## Requirements for accessing the CarrierService resource
 * To access the CarrierService resource, add the `write_shipping` permission to your app's requested scopes. For more information, see [API access scopes](https://shopify.dev/docs/admin-api/access-scopes).
 *
 * Your app's request to create a carrier service will fail unless the store installing your carrier service meets one of the following requirements:
 * * It's on the Advanced Shopify plan or higher.
 * * It's on the Shopify plan with yearly billing, or the carrier service feature has been added to the store for a monthly fee. For more information, contact [Shopify Support](https://help.shopify.com/questions).
 * * It's a development store that isn't on the Basic plan.
 *
 * > Note:
 * > If a store changes its Shopify plan, then the store's association with a carrier service is deactivated if the store no long meets one of the requirements above.
 *
 * ## Providing shipping rates to Shopify
 * When adding a carrier service to a store, you need to provide a POST endpoint rooted in the `callbackUrl` property where Shopify can retrieve applicable shipping rates. The callback URL should be a public endpoint that expects these requests from Shopify.
 *
 * ### Example shipping rate request sent to a carrier service
 *
 * ```json
 * {
 *   "rate": {
 *     "origin": {
 *       "country": "CA",
 *       "postal_code": "K2P1L4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": null,
 *       "address1": "150 Elgin St.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": "Jamie D's Emporium"
 *     },
 *     "destination": {
 *       "country": "CA",
 *       "postal_code": "K1M1M4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": "Bob Norman",
 *       "address1": "24 Sussex Dr.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": null
 *     },
 *     "items": [{
 *       "name": "Short Sleeve T-Shirt",
 *       "sku": "",
 *       "quantity": 1,
 *       "grams": 1000,
 *       "price": 1999,
 *       "vendor": "Jamie D's Emporium",
 *       "requires_shipping": true,
 *       "taxable": true,
 *       "fulfillment_service": "manual",
 *       "properties": null,
 *       "product_id": 48447225880,
 *       "variant_id": 258644705304
 *     }],
 *     "currency": "USD",
 *     "locale": "en",
 *     "order_totals": {
 *       "subtotal_price": "1999",
 *       "total_price": "2199",
 *       "discount_amount": "150"
 *     },
 *     "customer": {
 *       "id": 207119551,
 *       "tags": ["VIP", "wholesale"]
 *     }
 *   }
 * }
 * ```
 *
 * ### Example response
 * ```json
 * {
 *    "rates": [
 *        {
 *            "service_name": "canadapost-overnight",
 *            "service_code": "ON",
 *            "total_price": "1295",
 *            "description": "This is the fastest option by far",
 *            "currency": "CAD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-2dayground",
 *            "service_code": "2D",
 *            "total_price": "2934",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-priorityovernight",
 *            "service_code": "1D",
 *            "total_price": "3587",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "metafields": [
 *                {
 *                    "key": "tracking_url",
 *                    "value": "abc123",
 *                    "namespace": "carrier_service_metadata",
 *                    "type": "single_line_text_field"
 *                }
 *            ]
 *        }
 *    ]
 * }
 * ```
 *
 * The `address3`, `fax`, `address_type`, and `company_name` fields are returned by specific [ActiveShipping](https://github.com/Shopify/active_shipping) providers. For API-created carrier services, you should use only the following shipping address fields:
 * * `address1`
 * * `address2`
 * * `city`
 * * `zip`
 * * `province`
 * * `country`
 *
 * Other values remain as `null` and are not sent to the callback URL.
 *
 * ### Response fields
 *
 * When Shopify requests shipping rates using your callback URL, the response object `rates` must be a JSON array of objects with the following fields.  Required fields must be included in the response for the carrier service integration to work properly.
 *
 * | Field                   | Required | Description                                                                                                                                                                                                  |
 * | ----------------------- | -------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
 * | `service_name`          | Yes      | The name of the rate, which customers see at checkout. For example: `Expedited Mail`.                                                                                                                        |
 * | `description`           | Yes      | A description of the rate, which customers see at checkout. For example: `Includes tracking and insurance`.                                                                                                  |
 * | `service_code`          | Yes      | A unique code associated with the rate that must be consistent across requests. For example: `expedited_mail`.                                                                                               |
 * | `currency`              | Yes      | The currency of the shipping rate.                                                                                                                                                                           |
 * | `total_price`           | Yes      | The total price expressed in subunits. If the currency doesn't use subunits, then the value must be multiplied by 100. For example: `"total_price": 500` for 5.00 CAD, `"total_price": 100000` for 1000 JPY. |
 * | `phone_required`        | No       | Whether the customer must provide a phone number at checkout.                                                                                                                                                |
 * | `min_delivery_date`     | No       | The earliest delivery date for the displayed rate.                                                                                                                                                           |
 * | `max_delivery_date`     | No       | The latest delivery date for the displayed rate to still be valid.                                                                                                                                           |
 * | `metafields`            | No       | An array of metafield objects to attach custom metadata to the shipping rate.                                                                                                                                |
 *
 * ### Special conditions
 *
 * * To indicate that this carrier service cannot handle this shipping request, return an empty array and any successful (20x) HTTP code.
 * * To force backup rates instead, return a 40x or 50x HTTP code with any content. A good choice is the regular 404 Not Found code.
 * * Redirects (30x codes) will only be followed for the same domain as the original callback URL. Attempting to redirect to a different domain will trigger backup rates.
 * * There is no retry mechanism. The response must be successful on the first try, within the time budget listed below. Timeouts or errors will trigger backup rates.
 * * The `service_code` must be stable and consistent across requests for the same shipping option. It should not contain dynamic values like session IDs, timestamps, or request-specific identifiers. Use metafields for passing dynamic or session-specific data.
 *
 * ## Response Timeouts
 *
 * The read timeout for rate requests are dynamic, based on the number of requests per minute (RPM). These limits are applied to each shop-app pair. The timeout values are as follows.
 *
 * | RPM Range     | Timeout    |
 * | ------------- | ---------- |
 * | Under 1500    | 10s        |
 * | 1500 to 3000  | 5s         |
 * | Over 3000     | 3s         |
 *
 * > Note:
 * > These values are upper limits and should not be interpretted as a goal to develop towards. Shopify is constantly evaluating the performance of the platform and working towards improving resilience as well as app capabilities. As such, these numbers may be adjusted outside of our normal versioning timelines.
 *
 * ## Server-side caching of requests
 * Shopify provides server-side caching to reduce the number of requests it makes. Any shipping rate request that identically matches the following fields will be retrieved from Shopify's cache of the initial response:
 * * variant IDs
 * * default shipping box weight and dimensions
 * * variant quantities
 * * carrier service ID
 * * origin address
 * * destination address
 * * item weights and signatures
 *
 * If any of these fields differ, or if the cache has expired since the original request, then new shipping rates are requested. The cache expires 15 minutes after rates are successfully returned. If an error occurs, then the cache expires after 30 seconds. The fields and cache duration are subject to change without notice.
 */
export type DeliveryCarrierServiceAvailableServicesForCountriesArgs = {
  countryCodes?: InputMaybe<Array<CountryCode>>;
  origins?: InputMaybe<Array<Scalars['ID']['input']>>;
  restOfWorld: Scalars['Boolean']['input'];
};

/**
 * Links a [`DeliveryCarrierService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryCarrierService) with the associated shop [locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where it can calculate shipping rates. Each pairing indicates the locations that can use a specific carrier service for real-time rate calculations during checkout.
 *
 * The carrier service provides the shipping rate calculation logic, while the locations represent physical or virtual fulfillment points that can ship orders using that service.
 */
export type DeliveryCarrierServiceAndLocations = {
  __typename?: 'DeliveryCarrierServiceAndLocations';
  /** The carrier service. */
  carrierService: DeliveryCarrierService;
  /** The list of locations that support this carrier service. */
  locations: Array<Location>;
};

/** An auto-generated type for paginating through multiple DeliveryCarrierServices. */
export type DeliveryCarrierServiceConnection = {
  __typename?: 'DeliveryCarrierServiceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryCarrierServiceEdge>;
  /** A list of nodes that are contained in DeliveryCarrierServiceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryCarrierService>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields required to create a carrier service. */
export type DeliveryCarrierServiceCreateInput = {
  /** Whether this carrier service is active. If `true`, then the service will be available to serve rates in checkout. */
  active: Scalars['Boolean']['input'];
  /** The URL endpoint that Shopify needs to retrieve shipping rates. This must be a public URL. */
  callbackUrl: Scalars['URL']['input'];
  /** The name of the shipping service as seen by merchants and their customers. */
  name: Scalars['String']['input'];
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  supportsServiceDiscovery: Scalars['Boolean']['input'];
};

/** An auto-generated type which holds one DeliveryCarrierService and a cursor during pagination. */
export type DeliveryCarrierServiceEdge = {
  __typename?: 'DeliveryCarrierServiceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryCarrierServiceEdge. */
  node: DeliveryCarrierService;
};

/** The input fields used to update a carrier service. */
export type DeliveryCarrierServiceUpdateInput = {
  /** Whether this carrier service is active. If `true`, then the service will be available to serve rates in checkout. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL endpoint that Shopify needs to retrieve shipping rates. This must be a public URL. */
  callbackUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The global ID of the carrier service to update. */
  id: Scalars['ID']['input'];
  /** The name of the shipping service as seen by merchants and their customers. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  supportsServiceDiscovery?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A condition that must pass for a delivery method definition to be applied to an order. */
export type DeliveryCondition = Node & {
  __typename?: 'DeliveryCondition';
  /** The value (weight or price) that the condition field is compared to. */
  conditionCriteria: DeliveryConditionCriteria;
  /** The field to compare the criterion value against, using the operator. */
  field: DeliveryConditionField;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The operator to compare the field and criterion value. */
  operator: DeliveryConditionOperator;
};

/** The value (weight or price) that the condition field is compared to. */
export type DeliveryConditionCriteria = MoneyV2 | Weight;

/** The field type that the condition will be applied to. */
export enum DeliveryConditionField {
  /** The condition will check against the total price of the order. */
  TotalPrice = 'TOTAL_PRICE',
  /** The condition will check against the total weight of the order. */
  TotalWeight = 'TOTAL_WEIGHT'
}

/** The operator to use to determine if the condition passes. */
export enum DeliveryConditionOperator {
  /** The condition will check whether the field is greater than or equal to the criterion. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** The condition will check if the field is less than or equal to the criterion. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO'
}

/** A country that is used to define a shipping zone. */
export type DeliveryCountry = Node & {
  __typename?: 'DeliveryCountry';
  /**
   * A two-letter country code in ISO 3166-1 alpha-2 standard.
   * It also includes a flag indicating whether the country should be
   * a part of the 'Rest Of World' shipping zone.
   */
  code: DeliveryCountryCodeOrRestOfWorld;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The full name of the country. */
  name: Scalars['String']['output'];
  /** The list of regions associated with this country. */
  provinces: Array<DeliveryProvince>;
  /** The translated name of the country. The translation returned is based on the system's locale. */
  translatedName: Scalars['String']['output'];
};

/** The country details and the associated shipping zone. */
export type DeliveryCountryAndZone = {
  __typename?: 'DeliveryCountryAndZone';
  /** The country details. */
  country: DeliveryCountry;
  /** The name of the shipping zone. */
  zone: Scalars['String']['output'];
};

/** The country code and whether the country is a part of the 'Rest Of World' shipping zone. */
export type DeliveryCountryCodeOrRestOfWorld = {
  __typename?: 'DeliveryCountryCodeOrRestOfWorld';
  /** The country code in the ISO 3166-1 alpha-2 format. */
  countryCode?: Maybe<CountryCode>;
  /** Whether the country is a part of the 'Rest of World' shipping zone. */
  restOfWorld: Scalars['Boolean']['output'];
};

/**
 * The list of country codes and information whether the countries
 * are a part of the 'Rest Of World' shipping zone.
 */
export type DeliveryCountryCodesOrRestOfWorld = {
  __typename?: 'DeliveryCountryCodesOrRestOfWorld';
  /** List of applicable country codes in the ISO 3166-1 alpha-2 format. */
  countryCodes: Array<CountryCode>;
  /** Whether the countries are a part of the 'Rest of World' shipping zone. */
  restOfWorld: Scalars['Boolean']['output'];
};

/** The input fields to specify a country. */
export type DeliveryCountryInput = {
  /** The country code of the country in the ISO 3166-1 alpha-2 format. */
  code?: InputMaybe<CountryCode>;
  /** Associate all available provinces with this country. */
  includeAllProvinces?: InputMaybe<Scalars['Boolean']['input']>;
  /** The regions associated with this country. */
  provinces?: InputMaybe<Array<DeliveryProvinceInput>>;
  /** Whether the country is a part of the 'Rest of World' shipping zone. */
  restOfWorld?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A delivery customization. */
export type DeliveryCustomization = HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'DeliveryCustomization';
  /** The enabled status of the delivery customization. */
  enabled: Scalars['Boolean']['output'];
  /** The error history on the most recent version of the delivery customization. */
  errorHistory?: Maybe<FunctionsErrorHistory>;
  /** The ID of the Shopify Function implementing the delivery customization. */
  functionId: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The Shopify Function implementing the delivery customization. */
  shopifyFunction: ShopifyFunction;
  /** The title of the delivery customization. */
  title: Scalars['String']['output'];
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `deliveryCustomizationActivation` mutation. */
export type DeliveryCustomizationActivationPayload = {
  __typename?: 'DeliveryCustomizationActivationPayload';
  /** The IDs of the updated delivery customizations. */
  ids?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryCustomizationError>;
};

/** An auto-generated type for paginating through multiple DeliveryCustomizations. */
export type DeliveryCustomizationConnection = {
  __typename?: 'DeliveryCustomizationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryCustomizationEdge>;
  /** A list of nodes that are contained in DeliveryCustomizationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryCustomization>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `deliveryCustomizationCreate` mutation. */
export type DeliveryCustomizationCreatePayload = {
  __typename?: 'DeliveryCustomizationCreatePayload';
  /** Returns the created delivery customization. */
  deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryCustomizationError>;
};

/** Return type for `deliveryCustomizationDelete` mutation. */
export type DeliveryCustomizationDeletePayload = {
  __typename?: 'DeliveryCustomizationDeletePayload';
  /** Returns the deleted delivery customization ID. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryCustomizationError>;
};

/** An auto-generated type which holds one DeliveryCustomization and a cursor during pagination. */
export type DeliveryCustomizationEdge = {
  __typename?: 'DeliveryCustomizationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryCustomizationEdge. */
  node: DeliveryCustomization;
};

/** An error that occurs during the execution of a delivery customization mutation. */
export type DeliveryCustomizationError = DisplayableError & {
  __typename?: 'DeliveryCustomizationError';
  /** The error code. */
  code?: Maybe<DeliveryCustomizationErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DeliveryCustomizationError`. */
export enum DeliveryCustomizationErrorCode {
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CustomAppFunctionNotEligible = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Shop must be on a Shopify Plus plan to activate delivery customizations from a custom app. */
  DeliveryCustomizationFunctionNotEligible = 'DELIVERY_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE',
  /** Delivery customization not found. */
  DeliveryCustomizationNotFound = 'DELIVERY_CUSTOMIZATION_NOT_FOUND',
  /** Function does not implement the required interface for this delivery customization. */
  FunctionDoesNotImplement = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function ID cannot be changed. */
  FunctionIdCannotBeChanged = 'FUNCTION_ID_CANNOT_BE_CHANGED',
  /** Function not found. */
  FunctionNotFound = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FunctionPendingDeletion = 'FUNCTION_PENDING_DELETION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Could not create or update metafields. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** Maximum delivery customizations are already enabled. */
  MaximumActiveDeliveryCustomizations = 'MAXIMUM_ACTIVE_DELIVERY_CUSTOMIZATIONS',
  /** The maximum number of delivery customizations per shop has been reached. */
  MaximumDeliveryCustomizations = 'MAXIMUM_DELIVERY_CUSTOMIZATIONS',
  /** Either function_id or function_handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function_id or function_handle can be provided, not both. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS',
  /** Required input field must be present. */
  RequiredInputField = 'REQUIRED_INPUT_FIELD',
  /** Unauthorized app scope. */
  UnauthorizedAppScope = 'UNAUTHORIZED_APP_SCOPE'
}

/** The input fields to create and update a delivery customization. */
export type DeliveryCustomizationInput = {
  /** The enabled status of the delivery customization. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Function handle scoped to your current app ID. Only finds functions within your app. */
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  /** Additional metafields to associate to the delivery customization. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The title of the delivery customization. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `deliveryCustomizationUpdate` mutation. */
export type DeliveryCustomizationUpdatePayload = {
  __typename?: 'DeliveryCustomizationUpdatePayload';
  /** Returns the updated delivery customization. */
  deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryCustomizationError>;
};

/**
 * A fixed-price shipping rate.
 *
 * Flat rates charge the same price regardless of cart value or weight,
 * and may include optional transit time estimates.
 */
export type DeliveryFlatRate = DeliveryRate & {
  __typename?: 'DeliveryFlatRate';
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The fixed price charged for this rate. */
  price: MoneyV2;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: Maybe<Scalars['Int']['output']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for creating a flat rate. */
export type DeliveryFlatRateCreateInput = {
  /** The fixed price charged for this rate. */
  price: MoneyInput;
  /** The maximum estimated transit time in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum estimated transit time in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A flat rate group for a shipping option.
 *
 * Contains one fixed-price rate and optional collection or origin location conditions.
 */
export type DeliveryFlatRateGroup = DeliveryOptionDefinitionRateGroup & {
  __typename?: 'DeliveryFlatRateGroup';
  /** Conditions that limit this rate group to specific collections or origin locations. */
  conditions: DeliveryRateGroupConditions;
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The fixed-price rate and optional transit time. */
  rate: DeliveryFlatRate;
};

/** An auto-generated type for paginating through multiple DeliveryFlatRateGroups. */
export type DeliveryFlatRateGroupConnection = {
  __typename?: 'DeliveryFlatRateGroupConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryFlatRateGroupEdge>;
  /** A list of nodes that are contained in DeliveryFlatRateGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryFlatRateGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a flat rate group. */
export type DeliveryFlatRateGroupCreateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsCreateInput>;
  /** The fixed-price rate and optional transit time. */
  rate: DeliveryFlatRateCreateInput;
};

/** An auto-generated type which holds one DeliveryFlatRateGroup and a cursor during pagination. */
export type DeliveryFlatRateGroupEdge = {
  __typename?: 'DeliveryFlatRateGroupEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryFlatRateGroupEdge. */
  node: DeliveryFlatRateGroup;
};

/** The input fields for updating a flat rate group. */
export type DeliveryFlatRateGroupUpdateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsUpdateInput>;
  /** The globally unique ID of the flat rate group to update. */
  id: Scalars['ID']['input'];
  /** Updates to the fixed-price rate and optional transit time. */
  rate?: InputMaybe<DeliveryFlatRateUpdateInput>;
};

/**
 * A shipping option with fixed-price rates.
 *
 * Flat rate options charge the same price regardless of cart value or weight.
 */
export type DeliveryFlatRateOptionDefinition = DeliveryOptionDefinition & {
  __typename?: 'DeliveryFlatRateOptionDefinition';
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: Maybe<Scalars['String']['output']>;
  /** The cart subtotal required for free shipping. Null if no threshold is set. */
  freeDeliveryMinimumValue?: Maybe<MoneyV2>;
  /** A globally unique ID for this shipping option. */
  id: Scalars['ID']['output'];
  /** Collections that any rate group in this shipping option applies to. */
  includedCollections?: Maybe<CollectionConnection>;
  /** Origin locations that any rate group in this shipping option applies to. */
  includedLocations?: Maybe<LocationConnection>;
  /** Whether this shipping option is active and shown to buyers. */
  isActive: Scalars['Boolean']['output'];
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['output'];
  /** The flat rate groups for this shipping option. */
  rateGroups?: Maybe<DeliveryFlatRateGroupConnection>;
};


/**
 * A shipping option with fixed-price rates.
 *
 * Flat rate options charge the same price regardless of cart value or weight.
 */
export type DeliveryFlatRateOptionDefinitionIncludedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with fixed-price rates.
 *
 * Flat rate options charge the same price regardless of cart value or weight.
 */
export type DeliveryFlatRateOptionDefinitionIncludedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with fixed-price rates.
 *
 * Flat rate options charge the same price regardless of cart value or weight.
 */
export type DeliveryFlatRateOptionDefinitionRateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating a flat rate shipping option. */
export type DeliveryFlatRateOptionDefinitionCreateInput = {
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** Whether this shipping option is active and shown to buyers. Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['input'];
  /** The flat rate groups for this shipping option. */
  rateGroups?: InputMaybe<Array<DeliveryFlatRateGroupCreateInput>>;
};

/** The input fields for updating a flat rate shipping option. */
export type DeliveryFlatRateOptionDefinitionUpdateInput = {
  /** The currency used for all money values in this shipping option. */
  currency?: InputMaybe<CurrencyCode>;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Null clears the threshold. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** The globally unique ID of the flat rate shipping option to update. */
  id: Scalars['ID']['input'];
  /** Whether this shipping option is active and shown to buyers. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rate groups to create for this shipping option. */
  rateGroupsToCreate?: InputMaybe<Array<DeliveryFlatRateGroupCreateInput>>;
  /** The IDs of rate groups to delete from this shipping option. */
  rateGroupsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rate groups to update for this shipping option. */
  rateGroupsToUpdate?: InputMaybe<Array<DeliveryFlatRateGroupUpdateInput>>;
};

/** The input fields for updating a flat rate. */
export type DeliveryFlatRateUpdateInput = {
  /** The fixed price charged for this rate. */
  price?: InputMaybe<MoneyInput>;
  /** The maximum estimated transit time in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum estimated transit time in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Local pickup settings associated with a location. */
export type DeliveryLocalPickupSettings = {
  __typename?: 'DeliveryLocalPickupSettings';
  /** Additional instructions or information related to the local pickup. */
  instructions: Scalars['String']['output'];
  /** The estimated pickup time to show customers at checkout. */
  pickupTime: DeliveryLocalPickupTime;
};

/** Possible pickup time values that a location enabled for local pickup can have. */
export enum DeliveryLocalPickupTime {
  /**
   * Custom pickup time. Unrecognized pickup time enum value.
   * @deprecated Custom pickup time is no longer supported.
   */
  Custom = 'CUSTOM',
  /** Usually ready in 5+ days. */
  FiveOrMoreDays = 'FIVE_OR_MORE_DAYS',
  /** Usually ready in 4 hours. */
  FourHours = 'FOUR_HOURS',
  /** Usually ready in 1 hour. */
  OneHour = 'ONE_HOUR',
  /** Usually ready in 24 hours. */
  TwentyFourHours = 'TWENTY_FOUR_HOURS',
  /** Usually ready in 2 hours. */
  TwoHours = 'TWO_HOURS',
  /** Usually ready in 2-4 days. */
  TwoToFourDays = 'TWO_TO_FOUR_DAYS'
}

/**
 * A location group is a collection of locations. They share zones and delivery methods across delivery
 * profiles.
 */
export type DeliveryLocationGroup = Node & {
  __typename?: 'DeliveryLocationGroup';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A list of all locations that are part of this location group. */
  locations: LocationConnection;
  /** A count of all locations that are part of this location group. */
  locationsCount?: Maybe<Count>;
};


/**
 * A location group is a collection of locations. They share zones and delivery methods across delivery
 * profiles.
 */
export type DeliveryLocationGroupLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};

/** Links a location group with a zone and the associated method definitions. */
export type DeliveryLocationGroupZone = {
  __typename?: 'DeliveryLocationGroupZone';
  /** The number of method definitions for the zone. */
  methodDefinitionCounts: DeliveryMethodDefinitionCounts;
  /** The method definitions associated to a zone and location group. */
  methodDefinitions: DeliveryMethodDefinitionConnection;
  /** The zone associated to a location group. */
  zone: DeliveryZone;
};


/** Links a location group with a zone and the associated method definitions. */
export type DeliveryLocationGroupZoneMethodDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eligible?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MethodDefinitionSortKeys>;
  type?: InputMaybe<DeliveryMethodDefinitionType>;
};

/** An auto-generated type for paginating through multiple DeliveryLocationGroupZones. */
export type DeliveryLocationGroupZoneConnection = {
  __typename?: 'DeliveryLocationGroupZoneConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryLocationGroupZoneEdge>;
  /** A list of nodes that are contained in DeliveryLocationGroupZoneEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryLocationGroupZone>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeliveryLocationGroupZone and a cursor during pagination. */
export type DeliveryLocationGroupZoneEdge = {
  __typename?: 'DeliveryLocationGroupZoneEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryLocationGroupZoneEdge. */
  node: DeliveryLocationGroupZone;
};

/** The input fields for a delivery zone associated to a location group and profile. */
export type DeliveryLocationGroupZoneInput = {
  /** A list of countries to associate with the zone. */
  countries?: InputMaybe<Array<DeliveryCountryInput>>;
  /** A globally-unique ID of the zone. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A list of method definitions to create. */
  methodDefinitionsToCreate?: InputMaybe<Array<DeliveryMethodDefinitionInput>>;
  /** A list of method definitions to update. */
  methodDefinitionsToUpdate?: InputMaybe<Array<DeliveryMethodDefinitionInput>>;
  /** The name of the zone. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for a local pickup setting associated with a location. */
export type DeliveryLocationLocalPickupEnableInput = {
  /** The instructions for the local pickup. */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the location associated with the location setting. */
  locationId: Scalars['ID']['input'];
  /** The time of the local pickup. */
  pickupTime: DeliveryLocalPickupTime;
};

/** Represents an error that happened when changing local pickup settings for a location. */
export type DeliveryLocationLocalPickupSettingsError = DisplayableError & {
  __typename?: 'DeliveryLocationLocalPickupSettingsError';
  /** The error code. */
  code?: Maybe<DeliveryLocationLocalPickupSettingsErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DeliveryLocationLocalPickupSettingsError`. */
export enum DeliveryLocationLocalPickupSettingsErrorCode {
  /** Provided locationId is not for an active location belonging to this store. */
  ActiveLocationNotFound = 'ACTIVE_LOCATION_NOT_FOUND',
  /** Custom pickup time is not allowed for local pickup settings. */
  CustomPickupTimeNotAllowed = 'CUSTOM_PICKUP_TIME_NOT_ALLOWED',
  /** An error occurred while changing the local pickup settings. */
  GenericError = 'GENERIC_ERROR'
}

/**
 * Information about the delivery method selected for a [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder). Includes the method type, expected delivery timeframe, and any additional information needed for delivery.
 *
 * The delivery method stores details from checkout such as the carrier, branded promises like Shop Promise, and the delivery option name shown to the buyer. Additional information like delivery instructions or contact phone numbers helps fulfill the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) correctly.
 */
export type DeliveryMethod = Node & {
  __typename?: 'DeliveryMethod';
  /** The Additional information to consider when performing the delivery. */
  additionalInformation?: Maybe<DeliveryMethodAdditionalInformation>;
  /** The branded promise that was presented to the buyer during checkout.  For example: Shop Promise. */
  brandedPromise?: Maybe<DeliveryBrandedPromise>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The latest delivery date and time when the fulfillment is expected to arrive at the buyer's location. */
  maxDeliveryDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The type of the delivery method. */
  methodType: DeliveryMethodType;
  /** The earliest delivery date and time when the fulfillment is expected to arrive at the buyer's location. */
  minDeliveryDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the delivery option that was presented to the buyer during checkout. */
  presentedName?: Maybe<Scalars['String']['output']>;
  /** A reference to the shipping method. */
  serviceCode?: Maybe<Scalars['String']['output']>;
  /** Source reference is promise provider specific data associated with delivery promise. */
  sourceReference?: Maybe<Scalars['String']['output']>;
};

/** Additional information included on a delivery method that will help during the delivery process. */
export type DeliveryMethodAdditionalInformation = {
  __typename?: 'DeliveryMethodAdditionalInformation';
  /** The delivery instructions to follow when performing the delivery. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The phone number to contact when performing the delivery. */
  phone?: Maybe<Scalars['String']['output']>;
};

/**
 * A method definition contains the delivery rate and the conditions that must be met for the method to be
 * applied.
 */
export type DeliveryMethodDefinition = Node & {
  __typename?: 'DeliveryMethodDefinition';
  /** Whether this method definition is active. */
  active: Scalars['Boolean']['output'];
  /** The description of the method definition. Only available on shipping rates that are custom. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The method conditions that must pass for this method definition to be applied to an order. */
  methodConditions: Array<DeliveryCondition>;
  /** The name of the method definition. */
  name: Scalars['String']['output'];
  /** The provided rate for this method definition, from a rate definition or participant. */
  rateProvider: DeliveryRateProvider;
};

/** An auto-generated type for paginating through multiple DeliveryMethodDefinitions. */
export type DeliveryMethodDefinitionConnection = {
  __typename?: 'DeliveryMethodDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryMethodDefinitionEdge>;
  /** A list of nodes that are contained in DeliveryMethodDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryMethodDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The number of method definitions for a zone, separated into merchant-owned and participant definitions. */
export type DeliveryMethodDefinitionCounts = {
  __typename?: 'DeliveryMethodDefinitionCounts';
  /** The number of participant method definitions for the specified zone. */
  participantDefinitionsCount: Scalars['Int']['output'];
  /** The number of merchant-defined method definitions for the specified zone. */
  rateDefinitionsCount: Scalars['Int']['output'];
};

/** An auto-generated type which holds one DeliveryMethodDefinition and a cursor during pagination. */
export type DeliveryMethodDefinitionEdge = {
  __typename?: 'DeliveryMethodDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryMethodDefinitionEdge. */
  node: DeliveryMethodDefinition;
};

/** The input fields for a method definition. */
export type DeliveryMethodDefinitionInput = {
  /** Whether to use this method definition during rate calculation. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of conditions to update on the method definition. */
  conditionsToUpdate?: InputMaybe<Array<DeliveryUpdateConditionInput>>;
  /** The description of the method definition. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A globally-unique ID of the method definition. Use only when updating a method definition. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the method definition. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A participant to apply to the method definition. */
  participant?: InputMaybe<DeliveryParticipantInput>;
  /** A list of price conditions on the method definition. */
  priceConditionsToCreate?: InputMaybe<Array<DeliveryPriceConditionInput>>;
  /** A rate definition to apply to the method definition. */
  rateDefinition?: InputMaybe<DeliveryRateDefinitionInput>;
  /** A list of weight conditions on the method definition. */
  weightConditionsToCreate?: InputMaybe<Array<DeliveryWeightConditionInput>>;
};

/** The different types of method definitions to filter by. */
export enum DeliveryMethodDefinitionType {
  /** A static merchant-defined rate. */
  Merchant = 'MERCHANT',
  /** A dynamic participant rate. */
  Participant = 'PARTICIPANT'
}

/** Possible method types that a delivery method can have. */
export enum DeliveryMethodType {
  /** The order is delivered using a local delivery service. */
  Local = 'LOCAL',
  /** Non-physical items, no delivery needed. */
  None = 'NONE',
  /** The order is delivered to a pickup point. */
  PickupPoint = 'PICKUP_POINT',
  /** The order is picked up by the customer. */
  PickUp = 'PICK_UP',
  /** In-store sale, no delivery needed. */
  Retail = 'RETAIL',
  /** The order is shipped. */
  Shipping = 'SHIPPING'
}

/** A shipping option shown to buyers at checkout. Implemented by concrete option types. */
export type DeliveryOptionDefinition = {
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: Maybe<Scalars['String']['output']>;
  /** The cart subtotal required for free shipping. Null if no threshold is set. */
  freeDeliveryMinimumValue?: Maybe<MoneyV2>;
  /** A globally unique ID for this shipping option. */
  id: Scalars['ID']['output'];
  /** Collections that any rate group in this shipping option applies to. */
  includedCollections?: Maybe<CollectionConnection>;
  /** Origin locations that any rate group in this shipping option applies to. */
  includedLocations?: Maybe<LocationConnection>;
  /** Whether this shipping option is active and shown to buyers. */
  isActive: Scalars['Boolean']['output'];
};


/** A shipping option shown to buyers at checkout. Implemented by concrete option types. */
export type DeliveryOptionDefinitionIncludedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A shipping option shown to buyers at checkout. Implemented by concrete option types. */
export type DeliveryOptionDefinitionIncludedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DeliveryOptionDefinitions. */
export type DeliveryOptionDefinitionConnection = {
  __typename?: 'DeliveryOptionDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryOptionDefinitionEdge>;
  /** A list of nodes that are contained in DeliveryOptionDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryOptionDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a shipping option. Provide exactly one option type. */
export type DeliveryOptionDefinitionCreateInput = {
  /** A carrier-calculated shipping option. */
  carrierCalculated?: InputMaybe<DeliveryCarrierCalculatedOptionDefinitionCreateInput>;
  /** A flat rate shipping option. */
  flatRate?: InputMaybe<DeliveryFlatRateOptionDefinitionCreateInput>;
  /** A value-based shipping option. */
  valueBased?: InputMaybe<DeliveryValueBasedOptionDefinitionCreateInput>;
  /** A weight-based shipping option. */
  weightBased?: InputMaybe<DeliveryWeightBasedOptionDefinitionCreateInput>;
};

/** An auto-generated type which holds one DeliveryOptionDefinition and a cursor during pagination. */
export type DeliveryOptionDefinitionEdge = {
  __typename?: 'DeliveryOptionDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryOptionDefinitionEdge. */
  node: DeliveryOptionDefinition;
};

/** A delivery rate group within an option definition. */
export type DeliveryOptionDefinitionRateGroup = {
  /** Conditions that scope this rate group to specific collections or origin locations. */
  conditions: DeliveryRateGroupConditions;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** The input fields for updating a shipping option. Provide exactly one option type. */
export type DeliveryOptionDefinitionUpdateInput = {
  /** A carrier-calculated shipping option to update. */
  carrierCalculated?: InputMaybe<DeliveryCarrierCalculatedOptionDefinitionUpdateInput>;
  /** A flat rate shipping option to update. */
  flatRate?: InputMaybe<DeliveryFlatRateOptionDefinitionUpdateInput>;
  /** A value-based shipping option to update. */
  valueBased?: InputMaybe<DeliveryValueBasedOptionDefinitionUpdateInput>;
  /** A weight-based shipping option to update. */
  weightBased?: InputMaybe<DeliveryWeightBasedOptionDefinitionUpdateInput>;
};

/**
 * A participant defines carrier-calculated rates for shipping services
 * with a possible merchant-defined fixed fee or a percentage-of-rate fee.
 */
export type DeliveryParticipant = Node & {
  __typename?: 'DeliveryParticipant';
  /** Whether to display new shipping services automatically to the customer when the service becomes available. */
  adaptToNewServicesFlag: Scalars['Boolean']['output'];
  /** The carrier used for this participant. */
  carrierService: DeliveryCarrierService;
  /** The merchant-defined fixed fee for this participant. */
  fixedFee?: Maybe<MoneyV2>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The carrier-specific services offered by the participant, and whether each service is active. */
  participantServices: Array<DeliveryParticipantService>;
  /** The merchant-defined percentage-of-rate fee for this participant. */
  percentageOfRateFee: Scalars['Float']['output'];
};

/** The input fields for a participant. */
export type DeliveryParticipantInput = {
  /** Whether to automatically display new shipping services to the customer when a service becomes available. */
  adaptToNewServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the carrier service for this participant. */
  carrierServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** The fixed feed that's defined by the merchant for this participant. */
  fixedFee?: InputMaybe<MoneyInput>;
  /** The ID of the participant. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The list of shipping services offered by the participant. */
  participantServices?: InputMaybe<Array<DeliveryParticipantServiceInput>>;
  /** The merchant-defined percentage-of-rate fee for this participant. */
  percentageOfRateFee?: InputMaybe<Scalars['Float']['input']>;
};

/** A mail service provided by the participant. */
export type DeliveryParticipantService = {
  __typename?: 'DeliveryParticipantService';
  /** Whether the service is active. */
  active: Scalars['Boolean']['output'];
  /** The name of the service. */
  name: Scalars['String']['output'];
};

/** The input fields for a shipping service provided by a participant. */
export type DeliveryParticipantServiceInput = {
  /** Whether the service is active. */
  active: Scalars['Boolean']['input'];
  /** The name of the service. */
  name: Scalars['String']['input'];
};

/** The input fields for a price-based condition of a delivery method definition. */
export type DeliveryPriceConditionInput = {
  /** The monetary value to compare the price of an order to. */
  criteria?: InputMaybe<MoneyInput>;
  /** The operator to use for comparison. */
  operator?: InputMaybe<DeliveryConditionOperator>;
};

/** How many product variants are in a profile. This count is capped at 500. */
export type DeliveryProductVariantsCount = {
  __typename?: 'DeliveryProductVariantsCount';
  /** Whether the count has reached the cap of 500. */
  capped: Scalars['Boolean']['output'];
  /** The product variant count. */
  count: Scalars['Int']['output'];
};

/**
 * A shipping profile that defines shipping rates for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. Delivery profiles determine which products can ship from which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to which zones, and at what rates.
 *
 * Profiles can associate with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to provide custom shipping rules for subscriptions, such as free shipping or restricted delivery zones. The default profile applies to all products that aren't assigned to other profiles.
 *
 * Learn more about [building delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
 */
export type DeliveryProfile = Node & {
  __typename?: 'DeliveryProfile';
  /** The number of active shipping rates for the profile. */
  activeMethodDefinitionsCount: Scalars['Int']['output'];
  /** Whether this delivery profile covers every shippable product variant in the shop. Rates from a profile with `coversAllItems: true` apply to all items at checkout, overriding any explicit product or variant assignments. */
  coversAllItems: Scalars['Boolean']['output'];
  /** The date and time when the delivery profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this is the default profile. */
  default: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The number of locations without rates defined. */
  locationsWithoutRatesCount: Scalars['Int']['output'];
  /** The name of the delivery profile. */
  name: Scalars['String']['output'];
  /** The number of active origin locations for the profile. */
  originLocationCount: Scalars['Int']['output'];
  /** How many product variants are in this profile. */
  productVariantsCount?: Maybe<Count>;
  /**
   * How many product variants are in this profile.
   * @deprecated Use `productVariantsCount` instead.
   */
  productVariantsCountV2: DeliveryProductVariantsCount;
  /** The products and variants associated with this profile. */
  profileItems: DeliveryProfileItemConnection;
  /** The location groups and associated zones using this profile. */
  profileLocationGroups: Array<DeliveryProfileLocationGroup>;
  /** Selling plan groups associated with the specified delivery profile. */
  sellingPlanGroups: SellingPlanGroupConnection;
  /** List of locations that haven't been assigned to a location group for this profile. */
  unassignedLocations: Array<Location>;
  /** List of locations that have not been assigned to a location group for this profile. */
  unassignedLocationsPaginated: LocationConnection;
  /** The version of the delivery profile. */
  version: Scalars['Int']['output'];
  /** The number of countries with active rates to deliver to. */
  zoneCountryCount: Scalars['Int']['output'];
};


/**
 * A shipping profile that defines shipping rates for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. Delivery profiles determine which products can ship from which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to which zones, and at what rates.
 *
 * Profiles can associate with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to provide custom shipping rules for subscriptions, such as free shipping or restricted delivery zones. The default profile applies to all products that aren't assigned to other profiles.
 *
 * Learn more about [building delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
 */
export type DeliveryProfileProfileItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping profile that defines shipping rates for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. Delivery profiles determine which products can ship from which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to which zones, and at what rates.
 *
 * Profiles can associate with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to provide custom shipping rules for subscriptions, such as free shipping or restricted delivery zones. The default profile applies to all products that aren't assigned to other profiles.
 *
 * Learn more about [building delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
 */
export type DeliveryProfileProfileLocationGroupsArgs = {
  locationGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A shipping profile that defines shipping rates for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. Delivery profiles determine which products can ship from which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to which zones, and at what rates.
 *
 * Profiles can associate with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to provide custom shipping rules for subscriptions, such as free shipping or restricted delivery zones. The default profile applies to all products that aren't assigned to other profiles.
 *
 * Learn more about [building delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
 */
export type DeliveryProfileSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping profile that defines shipping rates for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. Delivery profiles determine which products can ship from which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to which zones, and at what rates.
 *
 * Profiles can associate with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to provide custom shipping rules for subscriptions, such as free shipping or restricted delivery zones. The default profile applies to all products that aren't assigned to other profiles.
 *
 * Learn more about [building delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
 */
export type DeliveryProfileUnassignedLocationsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DeliveryProfiles. */
export type DeliveryProfileConnection = {
  __typename?: 'DeliveryProfileConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryProfileEdge>;
  /** A list of nodes that are contained in DeliveryProfileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryProfile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `deliveryProfileCreate` mutation. */
export type DeliveryProfileCreatePayload = {
  __typename?: 'DeliveryProfileCreatePayload';
  /** The delivery profile that was created. */
  profile?: Maybe<DeliveryProfile>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one DeliveryProfile and a cursor during pagination. */
export type DeliveryProfileEdge = {
  __typename?: 'DeliveryProfileEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryProfileEdge. */
  node: DeliveryProfile;
};

/** The input fields for a delivery profile. */
export type DeliveryProfileInput = {
  /** The list of condition IDs to delete. */
  conditionsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Whether this delivery profile covers all items in the shop. This field is only supported on
   * app-owned shipping profiles. Set it to `true` to make the profile cover all shippable items,
   * or `false` to disable this behavior. When omitted
   * on create, the profile is created with `coversAllItems: false`. When omitted on update, the
   * existing value is preserved.
   */
  coversAllItems?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The list of location groups to be created in the delivery profile.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 location groups per each request.
   */
  locationGroupsToCreate?: InputMaybe<Array<DeliveryProfileLocationGroupInput>>;
  /** The list of location groups to be deleted from the delivery profile. */
  locationGroupsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The list of location groups to be updated in the delivery profile.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 location groups per each request.
   */
  locationGroupsToUpdate?: InputMaybe<Array<DeliveryProfileLocationGroupInput>>;
  /** The list of method definition IDs to delete. */
  methodDefinitionsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the delivery profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of location groups associated with the delivery profile. */
  profileLocationGroups?: InputMaybe<Array<DeliveryProfileLocationGroupInput>>;
  /** The list of selling plan groups to be associated with the delivery profile. */
  sellingPlanGroupsToAssociate?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The list of selling plan groups to be dissociated with the delivery profile. */
  sellingPlanGroupsToDissociate?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The list of product variant IDs to be associated with the delivery profile. */
  variantsToAssociate?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The list of product variant IDs to be dissociated from the delivery profile.
   * The dissociated product variants are moved back to the default delivery profile.
   */
  variantsToDissociate?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The list of zone IDs to delete. */
  zonesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A product and the subset of associated variants that are part of this delivery profile. */
export type DeliveryProfileItem = Node & {
  __typename?: 'DeliveryProfileItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A product associated with this profile. */
  product: Product;
  /** The product variants associated with this delivery profile. */
  variants: ProductVariantConnection;
};


/** A product and the subset of associated variants that are part of this delivery profile. */
export type DeliveryProfileItemVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DeliveryProfileItems. */
export type DeliveryProfileItemConnection = {
  __typename?: 'DeliveryProfileItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryProfileItemEdge>;
  /** A list of nodes that are contained in DeliveryProfileItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryProfileItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeliveryProfileItem and a cursor during pagination. */
export type DeliveryProfileItemEdge = {
  __typename?: 'DeliveryProfileItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryProfileItemEdge. */
  node: DeliveryProfileItem;
};

/** Links a location group with zones. Both are associated to a delivery profile. */
export type DeliveryProfileLocationGroup = {
  __typename?: 'DeliveryProfileLocationGroup';
  /** The countries already selected in any zone for the specified location group. */
  countriesInAnyZone: Array<DeliveryCountryAndZone>;
  /** The collection of locations that make up the specified location group. */
  locationGroup: DeliveryLocationGroup;
  /** The applicable zones associated to the specified location group. */
  locationGroupZones: DeliveryLocationGroupZoneConnection;
};


/** Links a location group with zones. Both are associated to a delivery profile. */
export type DeliveryProfileLocationGroupLocationGroupZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for a location group associated to a delivery profile. */
export type DeliveryProfileLocationGroupInput = {
  /** The globally-unique ID of the delivery profile location group. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The list of location IDs to be moved to this location group. */
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The list of location IDs to be added to this location group.
   *
   * **Note:** due to API input array limits, a maximum of 250 items can be sent per each request.
   */
  locationsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The list of location IDs to be removed from this location group.
   *
   * **Note:** due to API input array limits, a maximum of 250 items can be sent per each request.
   */
  locationsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The list of location group zones to create.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 zones per each request.
   */
  zonesToCreate?: InputMaybe<Array<DeliveryLocationGroupZoneInput>>;
  /**
   * The list of location group zones to update.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 zones per each request.
   */
  zonesToUpdate?: InputMaybe<Array<DeliveryLocationGroupZoneInput>>;
};

/** Return type for `deliveryProfileRemove` mutation. */
export type DeliveryProfileRemovePayload = {
  __typename?: 'DeliveryProfileRemovePayload';
  /** The delivery profile deletion job triggered by the mutation. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `deliveryProfileUpdate` mutation. */
export type DeliveryProfileUpdatePayload = {
  __typename?: 'DeliveryProfileUpdatePayload';
  /** The delivery profile that was updated. */
  profile?: Maybe<DeliveryProfile>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Returns enabled delivery promise participants. */
export type DeliveryPromiseParticipant = Node & {
  __typename?: 'DeliveryPromiseParticipant';
  /** The ID of the promise participant. */
  id: Scalars['ID']['output'];
  /** The resource that the participant is attached to. */
  owner?: Maybe<DeliveryPromiseParticipantOwner>;
  /** The owner type of the participant. */
  ownerType: DeliveryPromiseParticipantOwnerType;
};

/** An auto-generated type for paginating through multiple DeliveryPromiseParticipants. */
export type DeliveryPromiseParticipantConnection = {
  __typename?: 'DeliveryPromiseParticipantConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryPromiseParticipantEdge>;
  /** A list of nodes that are contained in DeliveryPromiseParticipantEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryPromiseParticipant>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeliveryPromiseParticipant and a cursor during pagination. */
export type DeliveryPromiseParticipantEdge = {
  __typename?: 'DeliveryPromiseParticipantEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryPromiseParticipantEdge. */
  node: DeliveryPromiseParticipant;
};

/** The object that the participant references. */
export type DeliveryPromiseParticipantOwner = ProductVariant;

/** The type of object that the participant is attached to. */
export enum DeliveryPromiseParticipantOwnerType {
  /** A product variant. */
  Productvariant = 'PRODUCTVARIANT'
}

/** Return type for `deliveryPromiseParticipantsUpdate` mutation. */
export type DeliveryPromiseParticipantsUpdatePayload = {
  __typename?: 'DeliveryPromiseParticipantsUpdatePayload';
  /** The promise participants that were added. */
  promiseParticipants?: Maybe<Array<DeliveryPromiseParticipant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A delivery promise provider. Currently restricted to select approved delivery promise partners. */
export type DeliveryPromiseProvider = Node & {
  __typename?: 'DeliveryPromiseProvider';
  /** Whether the delivery promise provider is active. Defaults to `true` when creating a provider. */
  active: Scalars['Boolean']['output'];
  /** The number of seconds to add to the current time as a buffer when looking up delivery promises. Represents how long the shop requires before releasing an order to the fulfillment provider. */
  fulfillmentDelay?: Maybe<Scalars['Int']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location associated with this delivery promise provider. */
  location: Location;
  /** The time zone to be used for interpreting day of week and cutoff times in delivery schedules when looking up delivery promises. */
  timeZone: Scalars['String']['output'];
};

/** Return type for `deliveryPromiseProviderUpsert` mutation. */
export type DeliveryPromiseProviderUpsertPayload = {
  __typename?: 'DeliveryPromiseProviderUpsertPayload';
  /** The created or updated delivery promise provider. */
  deliveryPromiseProvider?: Maybe<DeliveryPromiseProvider>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryPromiseProviderUpsertUserError>;
};

/** An error that occurs during the execution of `DeliveryPromiseProviderUpsert`. */
export type DeliveryPromiseProviderUpsertUserError = DisplayableError & {
  __typename?: 'DeliveryPromiseProviderUpsertUserError';
  /** The error code. */
  code?: Maybe<DeliveryPromiseProviderUpsertUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DeliveryPromiseProviderUpsertUserError`. */
export enum DeliveryPromiseProviderUpsertUserErrorCode {
  /** The time zone is invalid. */
  InvalidTimeZone = 'INVALID_TIME_ZONE',
  /** The location doesn't belong to the app. */
  MustBelongToApp = 'MUST_BELONG_TO_APP',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** The delivery promise settings. */
export type DeliveryPromiseSetting = {
  __typename?: 'DeliveryPromiseSetting';
  /** Whether delivery dates is enabled. */
  deliveryDatesEnabled: Scalars['Boolean']['output'];
  /** The number of business days required for processing the order before the package is handed off to the carrier. Expressed as an ISO8601 duration. */
  processingTime?: Maybe<Scalars['String']['output']>;
};

/** A region that is used to define a shipping zone. */
export type DeliveryProvince = Node & {
  __typename?: 'DeliveryProvince';
  /** The code of the region. */
  code: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The full name of the region. */
  name: Scalars['String']['output'];
  /** The translated name of the region. The translation returned is based on the system's locale. */
  translatedName: Scalars['String']['output'];
};

/** The input fields to specify a region. */
export type DeliveryProvinceInput = {
  /** The code of the region. */
  code: Scalars['String']['input'];
};

/**
 * A shipping rate with a price and optional transit time.
 *
 * Rates define the price charged to buyers for a shipping option.
 */
export type DeliveryRate = {
  /** The price charged for this rate. */
  price: MoneyV2;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: Maybe<Scalars['Int']['output']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for conditions that limit a rate group to specific collections or origin locations. */
export type DeliveryRateConditionsCreateInput = {
  /** Collection IDs to add. The rate group applies only to products in these collections. */
  collectionsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Origin location IDs to add. The rate group applies only to shipments from these locations. */
  originLocationsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields for conditions that limit a rate group to specific collections or origin locations. */
export type DeliveryRateConditionsUpdateInput = {
  /** Collection IDs to add. The rate group applies only to products in these collections. */
  collectionsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collection IDs to remove. */
  collectionsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Origin location IDs to add. The rate group applies only to shipments from these locations. */
  originLocationsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Origin location IDs to remove. */
  originLocationsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether to remove all collection conditions so the rate group applies to all products. */
  resetToAllProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The merchant-defined rate of the [DeliveryMethodDefinition](https://shopify.dev/api/admin-graphql/latest/objects/DeliveryMethodDefinition). */
export type DeliveryRateDefinition = Node & {
  __typename?: 'DeliveryRateDefinition';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The price of this rate. */
  price: MoneyV2;
};

/** The input fields for a rate definition. */
export type DeliveryRateDefinitionInput = {
  /** A globally-unique ID of the rate definition. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The price of the rate definition. */
  price: MoneyInput;
};

/**
 * Conditions that limit a rate group to specific collections or origin locations.
 *
 * When conditions are set, the rate group applies only to matching shipments.
 */
export type DeliveryRateGroupConditions = {
  __typename?: 'DeliveryRateGroupConditions';
  /** Collections this rate group applies to. Null means the rate group applies to all products. */
  collections?: Maybe<CollectionConnection>;
  /** The number of collections this rate group applies to. Null when it applies to all products. */
  collectionsCount?: Maybe<Count>;
  /** Origin locations this rate group applies to. */
  originLocations: LocationConnection;
  /** The number of origin locations this rate group applies to. */
  originLocationsCount: Count;
};


/**
 * Conditions that limit a rate group to specific collections or origin locations.
 *
 * When conditions are set, the rate group applies only to matching shipments.
 */
export type DeliveryRateGroupConditionsCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Conditions that limit a rate group to specific collections or origin locations.
 *
 * When conditions are set, the rate group applies only to matching shipments.
 */
export type DeliveryRateGroupConditionsOriginLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A rate provided by a merchant-defined rate or a participant. */
export type DeliveryRateProvider = DeliveryParticipant | DeliveryRateDefinition;

/** Return type for `deliverySettingUpdate` mutation. */
export type DeliverySettingUpdatePayload = {
  __typename?: 'DeliverySettingUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `deliveryShippingOriginAssign` mutation. */
export type DeliveryShippingOriginAssignPayload = {
  __typename?: 'DeliveryShippingOriginAssignPayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for updating the condition of a delivery method definition. */
export type DeliveryUpdateConditionInput = {
  /** The value that will be used in comparison. */
  criteria?: InputMaybe<Scalars['Float']['input']>;
  /** The unit associated with the value that will be used in comparison. */
  criteriaUnit?: InputMaybe<Scalars['String']['input']>;
  /** The property of an order that will be used in comparison. */
  field?: InputMaybe<DeliveryConditionField>;
  /** A globally-unique ID of the condition. */
  id: Scalars['ID']['input'];
  /** The operator to use for comparison. */
  operator?: InputMaybe<DeliveryConditionOperator>;
};

/**
 * A shipping option with rates based on cart value.
 *
 * Value-based options charge different rates depending on cart value,
 * using tiers that define price thresholds (e.g., "$5 shipping under $50, $2 shipping over $50").
 */
export type DeliveryValueBasedOptionDefinition = DeliveryOptionDefinition & {
  __typename?: 'DeliveryValueBasedOptionDefinition';
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: Maybe<Scalars['String']['output']>;
  /** The cart subtotal required for free shipping. Null if no threshold is set. */
  freeDeliveryMinimumValue?: Maybe<MoneyV2>;
  /** A globally unique ID for this shipping option. */
  id: Scalars['ID']['output'];
  /** Collections that any rate group in this shipping option applies to. */
  includedCollections?: Maybe<CollectionConnection>;
  /** Origin locations that any rate group in this shipping option applies to. */
  includedLocations?: Maybe<LocationConnection>;
  /** Whether this shipping option is active and shown to buyers. */
  isActive: Scalars['Boolean']['output'];
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['output'];
  /** The rate groups for this value-based shipping option. */
  rateGroups?: Maybe<DeliveryValueBasedRateGroupConnection>;
};


/**
 * A shipping option with rates based on cart value.
 *
 * Value-based options charge different rates depending on cart value,
 * using tiers that define price thresholds (e.g., "$5 shipping under $50, $2 shipping over $50").
 */
export type DeliveryValueBasedOptionDefinitionIncludedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates based on cart value.
 *
 * Value-based options charge different rates depending on cart value,
 * using tiers that define price thresholds (e.g., "$5 shipping under $50, $2 shipping over $50").
 */
export type DeliveryValueBasedOptionDefinitionIncludedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates based on cart value.
 *
 * Value-based options charge different rates depending on cart value,
 * using tiers that define price thresholds (e.g., "$5 shipping under $50, $2 shipping over $50").
 */
export type DeliveryValueBasedOptionDefinitionRateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating a value-based shipping option. */
export type DeliveryValueBasedOptionDefinitionCreateInput = {
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** Whether this shipping option is active and shown to buyers. Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['input'];
  /** Rate groups to create for this shipping option. */
  rateGroups: Array<DeliveryValueBasedRateGroupCreateInput>;
};

/** The input fields for updating a value-based shipping option. */
export type DeliveryValueBasedOptionDefinitionUpdateInput = {
  /** The currency used for all money values in this shipping option. */
  currency?: InputMaybe<CurrencyCode>;
  /** Description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Null clears the threshold. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** The ID of the value-based shipping option to update. */
  id: Scalars['ID']['input'];
  /** Whether this shipping option is active and shown to buyers. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rate groups to create for this shipping option. */
  rateGroupsToCreate?: InputMaybe<Array<DeliveryValueBasedRateGroupCreateInput>>;
  /** The IDs of rate groups to delete from this shipping option. */
  rateGroupsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rate groups to update for this shipping option. */
  rateGroupsToUpdate?: InputMaybe<Array<DeliveryValueBasedRateGroupUpdateInput>>;
};

/**
 * A value-based shipping rate.
 *
 * Defines price, optional transit time estimates, and the cart-value range for this rate.
 */
export type DeliveryValueBasedRate = DeliveryRate & {
  __typename?: 'DeliveryValueBasedRate';
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The maximum cart value (inclusive) for this rate. Null means no upper limit. */
  maxValue?: Maybe<MoneyV2>;
  /** The minimum cart value (inclusive) for this rate. */
  minValue: MoneyV2;
  /** The price charged for this rate. */
  price: MoneyV2;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: Maybe<Scalars['Int']['output']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: Maybe<Scalars['Int']['output']>;
};

/** An auto-generated type for paginating through multiple DeliveryValueBasedRates. */
export type DeliveryValueBasedRateConnection = {
  __typename?: 'DeliveryValueBasedRateConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryValueBasedRateEdge>;
  /** A list of nodes that are contained in DeliveryValueBasedRateEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryValueBasedRate>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a value-based rate. */
export type DeliveryValueBasedRateCreateInput = {
  /** The maximum cart value (inclusive) for this rate. Omit for no upper limit. */
  maxValue?: InputMaybe<MoneyInput>;
  /** The minimum cart value (inclusive) for this rate. */
  minValue: MoneyInput;
  /** The price charged for this rate. */
  price: MoneyInput;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** An auto-generated type which holds one DeliveryValueBasedRate and a cursor during pagination. */
export type DeliveryValueBasedRateEdge = {
  __typename?: 'DeliveryValueBasedRateEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryValueBasedRateEdge. */
  node: DeliveryValueBasedRate;
};

/**
 * A rate group for a value-based shipping option.
 *
 * Contains rates that define price tiers based on cart value.
 */
export type DeliveryValueBasedRateGroup = DeliveryOptionDefinitionRateGroup & {
  __typename?: 'DeliveryValueBasedRateGroup';
  /** Conditions that limit this rate group to specific collections or origin locations. */
  conditions: DeliveryRateGroupConditions;
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The value-based rates in this rate group. */
  rates: DeliveryValueBasedRateConnection;
};


/**
 * A rate group for a value-based shipping option.
 *
 * Contains rates that define price tiers based on cart value.
 */
export type DeliveryValueBasedRateGroupRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DeliveryValueBasedRateGroups. */
export type DeliveryValueBasedRateGroupConnection = {
  __typename?: 'DeliveryValueBasedRateGroupConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryValueBasedRateGroupEdge>;
  /** A list of nodes that are contained in DeliveryValueBasedRateGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryValueBasedRateGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a rate group for a value-based shipping option. */
export type DeliveryValueBasedRateGroupCreateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions: DeliveryRateConditionsCreateInput;
  /** The rates to create in this rate group. */
  rates: Array<DeliveryValueBasedRateCreateInput>;
};

/** An auto-generated type which holds one DeliveryValueBasedRateGroup and a cursor during pagination. */
export type DeliveryValueBasedRateGroupEdge = {
  __typename?: 'DeliveryValueBasedRateGroupEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryValueBasedRateGroupEdge. */
  node: DeliveryValueBasedRateGroup;
};

/** The input fields for updating a rate group for a value-based shipping option. */
export type DeliveryValueBasedRateGroupUpdateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsUpdateInput>;
  /** The ID of the rate group to update. */
  id: Scalars['ID']['input'];
  /** Rates to create within this rate group. */
  ratesToCreate?: InputMaybe<Array<DeliveryValueBasedRateCreateInput>>;
  /** IDs of rates to delete from this rate group. */
  ratesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rates to update within this rate group. */
  ratesToUpdate?: InputMaybe<Array<DeliveryValueBasedRateUpdateInput>>;
};

/** The input fields for updating a value-based rate. */
export type DeliveryValueBasedRateUpdateInput = {
  /** The ID of the rate to update. */
  id: Scalars['ID']['input'];
  /** The maximum cart value (inclusive) for this rate. Set to null for no upper limit. */
  maxValue?: InputMaybe<MoneyInput>;
  /** The minimum cart value for this rate. */
  minValue?: InputMaybe<MoneyInput>;
  /** The price charged for this rate. */
  price?: InputMaybe<MoneyInput>;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A shipping option with rates based on package weight.
 *
 * Rates contain tiers that define package-weight thresholds. Checkout selects the
 * appropriate tier using the package weight of the shipping allocation, or the
 * combined package weight when allocations are grouped for weight conditions.
 */
export type DeliveryWeightBasedOptionDefinition = DeliveryOptionDefinition & {
  __typename?: 'DeliveryWeightBasedOptionDefinition';
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: Maybe<Scalars['String']['output']>;
  /** The cart subtotal required for free shipping. Null if no threshold is set. */
  freeDeliveryMinimumValue?: Maybe<MoneyV2>;
  /** A globally unique ID for this shipping option. */
  id: Scalars['ID']['output'];
  /** Collections that any rate group in this shipping option applies to. */
  includedCollections?: Maybe<CollectionConnection>;
  /** Origin locations that any rate group in this shipping option applies to. */
  includedLocations?: Maybe<LocationConnection>;
  /** Whether this shipping option is active and shown to buyers. */
  isActive: Scalars['Boolean']['output'];
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['output'];
  /** The rate groups for this weight-based shipping option. */
  rateGroups?: Maybe<DeliveryWeightBasedRateGroupConnection>;
};


/**
 * A shipping option with rates based on package weight.
 *
 * Rates contain tiers that define package-weight thresholds. Checkout selects the
 * appropriate tier using the package weight of the shipping allocation, or the
 * combined package weight when allocations are grouped for weight conditions.
 */
export type DeliveryWeightBasedOptionDefinitionIncludedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates based on package weight.
 *
 * Rates contain tiers that define package-weight thresholds. Checkout selects the
 * appropriate tier using the package weight of the shipping allocation, or the
 * combined package weight when allocations are grouped for weight conditions.
 */
export type DeliveryWeightBasedOptionDefinitionIncludedLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipping option with rates based on package weight.
 *
 * Rates contain tiers that define package-weight thresholds. Checkout selects the
 * appropriate tier using the package weight of the shipping allocation, or the
 * combined package weight when allocations are grouped for weight conditions.
 */
export type DeliveryWeightBasedOptionDefinitionRateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating a weight-based shipping option. */
export type DeliveryWeightBasedOptionDefinitionCreateInput = {
  /** The currency used for all money values in this shipping option. */
  currency: CurrencyCode;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** Whether this shipping option is active and shown to buyers. Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name: Scalars['String']['input'];
  /** The weight-based rate groups for this shipping option. At this time, only a single rate group is supported for weight-based shipping options. */
  rateGroups: Array<DeliveryWeightBasedRateGroupCreateInput>;
};

/** The input fields for updating a weight-based shipping option. */
export type DeliveryWeightBasedOptionDefinitionUpdateInput = {
  /** The currency used for all money values in this shipping option. */
  currency?: InputMaybe<CurrencyCode>;
  /** Optional description shown to buyers. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The cart subtotal required for free shipping. Null clears the threshold. Currency must match the shipping option's currency. */
  freeDeliveryMinimumValue?: InputMaybe<MoneyInput>;
  /** The globally unique ID of the weight-based shipping option to update. */
  id: Scalars['ID']['input'];
  /** Whether this shipping option is active and shown to buyers. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name shown to buyers for this shipping option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rate groups to create for this shipping option. At this time, only a single rate group is supported for weight-based shipping options. */
  rateGroupsToCreate?: InputMaybe<Array<DeliveryWeightBasedRateGroupCreateInput>>;
  /** The IDs of rate groups to delete from this shipping option. */
  rateGroupsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rate groups to update for this shipping option. Only the existing single rate group is supported. */
  rateGroupsToUpdate?: InputMaybe<Array<DeliveryWeightBasedRateGroupUpdateInput>>;
};

/**
 * A weight-based shipping rate.
 *
 * Weight-based rates charge different prices depending on package weight, which can
 * include packaging weight in addition to item weight, and may include optional
 * transit time estimates.
 */
export type DeliveryWeightBasedRate = DeliveryRate & {
  __typename?: 'DeliveryWeightBasedRate';
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The maximum package weight for this rate tier. */
  maxWeight?: Maybe<Weight>;
  /** The minimum package weight for this rate tier. */
  minWeight: Weight;
  /** The price charged for this rate. */
  price: MoneyV2;
  /** The maximum transit time estimate in seconds. */
  transitTimeMaxSeconds?: Maybe<Scalars['Int']['output']>;
  /** The minimum transit time estimate in seconds. */
  transitTimeMinSeconds?: Maybe<Scalars['Int']['output']>;
};

/** An auto-generated type for paginating through multiple DeliveryWeightBasedRates. */
export type DeliveryWeightBasedRateConnection = {
  __typename?: 'DeliveryWeightBasedRateConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryWeightBasedRateEdge>;
  /** A list of nodes that are contained in DeliveryWeightBasedRateEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryWeightBasedRate>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a weight-based rate. */
export type DeliveryWeightBasedRateCreateInput = {
  /** The maximum package weight for this rate tier. If omitted, the tier has no upper weight limit. */
  maxWeight?: InputMaybe<WeightInput>;
  /** The minimum package weight for this rate tier. */
  minWeight: WeightInput;
  /** The price charged for this rate tier. */
  price: MoneyInput;
  /** The maximum estimated transit time in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum estimated transit time in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** An auto-generated type which holds one DeliveryWeightBasedRate and a cursor during pagination. */
export type DeliveryWeightBasedRateEdge = {
  __typename?: 'DeliveryWeightBasedRateEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryWeightBasedRateEdge. */
  node: DeliveryWeightBasedRate;
};

/**
 * A rate group for a weight-based shipping option.
 *
 * Contains rates that define price tiers based on package weight.
 */
export type DeliveryWeightBasedRateGroup = DeliveryOptionDefinitionRateGroup & {
  __typename?: 'DeliveryWeightBasedRateGroup';
  /** Conditions that limit this rate group to specific collections or origin locations. */
  conditions: DeliveryRateGroupConditions;
  /** A globally unique ID. */
  id: Scalars['ID']['output'];
  /** The weight-based rates in this rate group. */
  rates: DeliveryWeightBasedRateConnection;
};


/**
 * A rate group for a weight-based shipping option.
 *
 * Contains rates that define price tiers based on package weight.
 */
export type DeliveryWeightBasedRateGroupRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DeliveryWeightBasedRateGroups. */
export type DeliveryWeightBasedRateGroupConnection = {
  __typename?: 'DeliveryWeightBasedRateGroupConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DeliveryWeightBasedRateGroupEdge>;
  /** A list of nodes that are contained in DeliveryWeightBasedRateGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DeliveryWeightBasedRateGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a weight-based rate group. */
export type DeliveryWeightBasedRateGroupCreateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions: DeliveryRateConditionsCreateInput;
  /** The weight-based rates for this rate group. */
  rates: Array<DeliveryWeightBasedRateCreateInput>;
};

/** An auto-generated type which holds one DeliveryWeightBasedRateGroup and a cursor during pagination. */
export type DeliveryWeightBasedRateGroupEdge = {
  __typename?: 'DeliveryWeightBasedRateGroupEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DeliveryWeightBasedRateGroupEdge. */
  node: DeliveryWeightBasedRateGroup;
};

/** The input fields for updating a weight-based rate group. */
export type DeliveryWeightBasedRateGroupUpdateInput = {
  /** Collection and origin location conditions for this rate group. */
  conditions?: InputMaybe<DeliveryRateConditionsUpdateInput>;
  /** The ID of the rate group to update. */
  id: Scalars['ID']['input'];
  /** Rates to create in this rate group. */
  ratesToCreate?: InputMaybe<Array<DeliveryWeightBasedRateCreateInput>>;
  /** IDs of rates to delete from this rate group. */
  ratesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Rates to update in this rate group. */
  ratesToUpdate?: InputMaybe<Array<DeliveryWeightBasedRateUpdateInput>>;
};

/** The input fields for updating a weight-based rate. */
export type DeliveryWeightBasedRateUpdateInput = {
  /** The globally unique ID of the weight-based rate to update. */
  id: Scalars['ID']['input'];
  /** The maximum package weight for this rate tier. Null means no upper weight limit. */
  maxWeight?: InputMaybe<WeightInput>;
  /** The minimum package weight for this rate tier. */
  minWeight?: InputMaybe<WeightInput>;
  /** The price charged for this rate tier. */
  price?: InputMaybe<MoneyInput>;
  /** The maximum estimated transit time in seconds. */
  transitTimeMaxSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum estimated transit time in seconds. */
  transitTimeMinSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields for a weight-based condition of a delivery method definition. */
export type DeliveryWeightConditionInput = {
  /** The weight value to compare the weight of an order to. */
  criteria?: InputMaybe<WeightInput>;
  /** The operator to use for comparison. */
  operator?: InputMaybe<DeliveryConditionOperator>;
};

/** A zone is a group of countries that have the same shipping rates. Customers can order products from a store only if they choose a shipping destination that's included in one of the store's zones. */
export type DeliveryZone = Node & {
  __typename?: 'DeliveryZone';
  /** The list of countries within the zone. */
  countries: Array<DeliveryCountry>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the zone. */
  name: Scalars['String']['output'];
};

/** Configuration of the deposit. */
export type DepositConfiguration = DepositPercentage;

/** The input fields configuring the deposit requirement. */
export type DepositInput = {
  /** The percentage of the order total that should be paid as a deposit. Must be between 1 and 99, inclusive. */
  percentage: Scalars['Float']['input'];
};

/** A percentage deposit. */
export type DepositPercentage = {
  __typename?: 'DepositPercentage';
  /** The percentage value of the deposit. */
  percentage: Scalars['Float']['output'];
};

/** Digital wallet, such as Apple Pay, which can be used for accelerated checkouts. */
export enum DigitalWallet {
  /** Amazon Pay. */
  AmazonPay = 'AMAZON_PAY',
  /** Android Pay. */
  AndroidPay = 'ANDROID_PAY',
  /** Apple Pay. */
  ApplePay = 'APPLE_PAY',
  /** Facebook Pay. */
  FacebookPay = 'FACEBOOK_PAY',
  /** Google Pay. */
  GooglePay = 'GOOGLE_PAY',
  /** Shopify Pay. */
  ShopifyPay = 'SHOPIFY_PAY'
}

/** A discount offers promotional value and can be applied by entering a code or automatically when conditions are met. Discounts can provide fixed amounts, percentage reductions, free shipping, or Buy X Get Y (BXGY) benefits on specific products or the entire order. For more complex scenarios, developers can use Function-backed discounts to create custom discount configurations. */
export type Discount = DiscountAutomaticApp | DiscountAutomaticBasic | DiscountAutomaticBxgy | DiscountAutomaticFreeShipping | DiscountCodeApp | DiscountCodeBasic | DiscountCodeBxgy | DiscountCodeFreeShipping;

/**
 * The actual amount discounted on a line item or shipping line. While [`DiscountApplication`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/DiscountApplication) captures the discount's intentions and rules, The `DiscountAllocation` object shows the final calculated discount amount applied to each line.
 *
 * The allocation includes the discounted amount in both shop and presentment currencies, with a reference to the originating discount application.
 */
export type DiscountAllocation = {
  __typename?: 'DiscountAllocation';
  /**
   * The money amount that's allocated to a line based on the associated discount application.
   * @deprecated Use `allocatedAmountSet` instead.
   */
  allocatedAmount: MoneyV2;
  /** The money amount that's allocated to a line based on the associated discount application in shop and presentment currencies. */
  allocatedAmountSet: MoneyBag;
  /** The discount application that the allocated amount originated from. */
  discountApplication: DiscountApplication;
};

/** An auto-generated type for paginating through multiple DiscountAllocations. */
export type DiscountAllocationConnection = {
  __typename?: 'DiscountAllocationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountAllocationEdge>;
  /** A list of nodes that are contained in DiscountAllocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountAllocation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountAllocation and a cursor during pagination. */
export type DiscountAllocationEdge = {
  __typename?: 'DiscountAllocationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountAllocationEdge. */
  node: DiscountAllocation;
};

/** The fixed amount value of a discount, and whether the amount is applied to each entitled item or spread evenly across the entitled items. */
export type DiscountAmount = {
  __typename?: 'DiscountAmount';
  /** The value of the discount. */
  amount: MoneyV2;
  /** If true, then the discount is applied to each of the entitled items. If false, then the amount is split across all of the entitled items. */
  appliesOnEachItem: Scalars['Boolean']['output'];
};

/** The input fields for the value of the discount and how it is applied. */
export type DiscountAmountInput = {
  /** The value of the discount. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** If true, then the discount is applied to each of the entitled items. If false, then the amount is split across all of the entitled items. */
  appliesOnEachItem?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application on an order's line items or shipping lines.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type DiscountApplication = {
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  index: Scalars['Int']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/** The method by which the discount's value is allocated onto its entitled lines. */
export enum DiscountApplicationAllocationMethod {
  /** The value is spread across all entitled lines. */
  Across = 'ACROSS',
  /** The value is applied onto every entitled line. */
  Each = 'EACH',
  /**
   * The value is specifically applied onto a particular line.
   * @deprecated Use ACROSS instead.
   */
  One = 'ONE'
}

/** An auto-generated type for paginating through multiple DiscountApplications. */
export type DiscountApplicationConnection = {
  __typename?: 'DiscountApplicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountApplicationEdge>;
  /** A list of nodes that are contained in DiscountApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountApplication and a cursor during pagination. */
export type DiscountApplicationEdge = {
  __typename?: 'DiscountApplicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountApplicationEdge. */
  node: DiscountApplication;
};

/** The level at which the discount's value is applied. */
export enum DiscountApplicationLevel {
  /**
   * The discount is applied at the line level.
   * Line level discounts are factored into the discountedUnitPriceSet on line items.
   */
  Line = 'LINE',
  /**
   * The discount is applied at the order level.
   * Order level discounts are not factored into the discountedUnitPriceSet on line items.
   */
  Order = 'ORDER'
}

/**
 * The lines on the order to which the discount is applied, of the type defined by
 * the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
 * `LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
 * The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.
 */
export enum DiscountApplicationTargetSelection {
  /** The discount is allocated onto all the lines. */
  All = 'ALL',
  /** The discount is allocated onto only the lines that it's entitled for. */
  Entitled = 'ENTITLED',
  /** The discount is allocated onto explicitly chosen lines. */
  Explicit = 'EXPLICIT'
}

/** The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards. */
export enum DiscountApplicationTargetType {
  /** The discount applies onto line items. */
  LineItem = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  ShippingLine = 'SHIPPING_LINE'
}

/**
 * The types of automatic discounts applied in the cart and at checkout when an order meets specific criteria.
 *
 * Includes [`DiscountAutomaticApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticApp) for custom logic using the [Discount Function API](https://shopify.dev/docs/api/functions/latest/discount), [`DiscountAutomaticBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic) for percentage or fixed amount reductions, [`DiscountAutomaticBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBxgy) for Buy X Get Y promotions, and [`DiscountAutomaticFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping) for delivery incentives.
 */
export type DiscountAutomatic = DiscountAutomaticApp | DiscountAutomaticBasic | DiscountAutomaticBxgy | DiscountAutomaticFreeShipping;

/** Return type for `discountAutomaticActivate` mutation. */
export type DiscountAutomaticActivatePayload = {
  __typename?: 'DiscountAutomaticActivatePayload';
  /** The activated automatic discount. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountAutomaticApp` object stores information about automatic discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountAutomaticApp`when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountCodeApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeApp)
 * object has similar functionality to the `DiscountAutomaticApp` object, with the exception that `DiscountCodeApp`
 * stores information about discount codes that are managed by an app using Shopify Functions.
 * >
 * > API versions prior to `2025-10` only return automatic discounts with `context` set to `all`, discounts with other values are filtered out.
 */
export type DiscountAutomaticApp = {
  __typename?: 'DiscountAutomaticApp';
  /**
   * The details about the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   * This information includes the app extension's name and
   * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
   * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
   * and other metadata about the discount type, including the discount type's name and description.
   */
  appDiscountType: AppDiscountType;
  /** Whether the discount applies on one-time purchases. */
  appliesOnOneTimePurchase: Scalars['Boolean']['output'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: DiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The [globally-unique ID](https://shopify.dev/docs/api/usage/gids)
   * for the discount.
   */
  discountId: Scalars['ID']['output'];
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The [error history](https://shopify.dev/docs/apps/build/functions/monitoring-and-errors)
   * for the latest version of the discount type that the app provides.
   */
  errorHistory?: Maybe<FunctionsErrorHistory>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit: Scalars['Int']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Return type for `discountAutomaticAppCreate` mutation. */
export type DiscountAutomaticAppCreatePayload = {
  __typename?: 'DiscountAutomaticAppCreatePayload';
  /** The automatic discount that the app manages. */
  automaticAppDiscount?: Maybe<DiscountAutomaticApp>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating an automatic discount
 * that's managed by an app.
 *
 * Use these input fields when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountAutomaticAppInput = {
  /** Whether the discount applies on one-time purchases. */
  appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   * Discounts automatically apply on Point of Sale (POS) for Pro locations. For app discounts using Admin UI Extensions, merchants can control POS eligibility when the context is set to ALL.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** Determines which discount effects the discount can apply. */
  discountClasses?: InputMaybe<Array<DiscountClass>>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The handle of the function providing the discount. */
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  /**
   * Additional metafields to associate to the discount.
   * [Metafields](https://shopify.dev/docs/apps/build/custom-data)
   * provide dynamic function configuration with
   * different parameters, such as `percentage` for a percentage discount. Merchants can set metafield values
   * in the Shopify admin, which makes the discount function more flexible and customizable.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `discountAutomaticAppUpdate` mutation. */
export type DiscountAutomaticAppUpdatePayload = {
  __typename?: 'DiscountAutomaticAppUpdatePayload';
  /** The updated automatic discount that the app provides. */
  automaticAppDiscount?: Maybe<DiscountAutomaticApp>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountAutomaticBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are automatically applied on a cart and at checkout. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountAutomaticBasic` object stores information about automatic amount off discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBasic)
 * object has similar functionality to the `DiscountAutomaticBasic` object, but customers need to enter a code to
 * receive a discount.
 * >
 * > API versions prior to `2025-10` only return automatic discounts with `context` set to `all`, discounts with other values are filtered out.
 */
export type DiscountAutomaticBasic = {
  __typename?: 'DiscountAutomaticBasic';
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets: DiscountCustomerGets;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: MerchandiseDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit: Scalars['Int']['output'];
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic#field-summary)
   * field.
   */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The number of times that the discount has been used.
   * @deprecated Use `asyncUsageCount` instead.
   */
  usageCount: Scalars['Int']['output'];
};

/** Return type for `discountAutomaticBasicCreate` mutation. */
export type DiscountAutomaticBasicCreatePayload = {
  __typename?: 'DiscountAutomaticBasicCreatePayload';
  /** The automatic discount that was created. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating an
 * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that's automatically applied on a cart and at checkout.
 *
 * During creation the required fields are:
 *   - `customerGets`
 *   - `startsAt`
 *   - `title`
 */
export type DiscountAutomaticBasicInput = {
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   * Discounts automatically apply on Point of Sale (POS) for Pro locations when the context is not set to ALL.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** Information about the qualifying items and their discount. */
  customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `discountAutomaticBasicUpdate` mutation. */
export type DiscountAutomaticBasicUpdatePayload = {
  __typename?: 'DiscountAutomaticBasicUpdatePayload';
  /** The automatic discount that was updated. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountAutomaticBulkDelete` mutation. */
export type DiscountAutomaticBulkDeletePayload = {
  __typename?: 'DiscountAutomaticBulkDeletePayload';
  /** The asynchronous job removing the automatic discounts. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountAutomaticBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are automatically applied on a cart and at checkout. BXGY discounts incentivize customers by offering
 * them additional items at a discounted price or for free when they purchase a specified quantity of items.
 *
 * The `DiscountAutomaticBxgy` object stores information about automatic BXGY discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBxgy)
 * object has similar functionality to the `DiscountAutomaticBxgy` object, but customers need to enter a code to
 * receive a discount.
 * >
 * > API versions prior to `2025-10` only return automatic discounts with `context` set to `all`, discounts with other values are filtered out.
 */
export type DiscountAutomaticBxgy = HasEvents & Node & {
  __typename?: 'DiscountAutomaticBxgy';
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  customerBuys: DiscountCustomerBuys;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets: DiscountCustomerGets;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: MerchandiseDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /**
   * A legacy unique ID for the discount.
   * @deprecated Use DiscountAutomaticNode.id instead.
   */
  id: Scalars['ID']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The number of times that the discount has been used.
   * @deprecated Use `asyncUsageCount` instead.
   */
  usageCount: Scalars['Int']['output'];
  /** The maximum number of times that the discount can be applied to an order. */
  usesPerOrderLimit?: Maybe<Scalars['Int']['output']>;
};


/**
 * The `DiscountAutomaticBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are automatically applied on a cart and at checkout. BXGY discounts incentivize customers by offering
 * them additional items at a discounted price or for free when they purchase a specified quantity of items.
 *
 * The `DiscountAutomaticBxgy` object stores information about automatic BXGY discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBxgy)
 * object has similar functionality to the `DiscountAutomaticBxgy` object, but customers need to enter a code to
 * receive a discount.
 * >
 * > API versions prior to `2025-10` only return automatic discounts with `context` set to `all`, discounts with other values are filtered out.
 */
export type DiscountAutomaticBxgyEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Return type for `discountAutomaticBxgyCreate` mutation. */
export type DiscountAutomaticBxgyCreatePayload = {
  __typename?: 'DiscountAutomaticBxgyCreatePayload';
  /** The automatic discount that was created. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that's automatically applied on a cart and at checkout.
 *
 * When creating, required fields are:
 *   - `customerBuys`
 *   - `customerGets`
 *   - `startsAt`
 *   - `title`
 */
export type DiscountAutomaticBxgyInput = {
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   * Discounts automatically apply on Point of Sale (POS) for Pro locations when the context is not set to ALL.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  customerBuys?: InputMaybe<DiscountCustomerBuysInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of times that the discount can be applied to an order. */
  usesPerOrderLimit?: InputMaybe<Scalars['UnsignedInt64']['input']>;
};

/** Return type for `discountAutomaticBxgyUpdate` mutation. */
export type DiscountAutomaticBxgyUpdatePayload = {
  __typename?: 'DiscountAutomaticBxgyUpdatePayload';
  /** The automatic discount that was updated. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** An auto-generated type for paginating through multiple DiscountAutomatics. */
export type DiscountAutomaticConnection = {
  __typename?: 'DiscountAutomaticConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountAutomaticEdge>;
  /** A list of nodes that are contained in DiscountAutomaticEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountAutomatic>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `discountAutomaticDeactivate` mutation. */
export type DiscountAutomaticDeactivatePayload = {
  __typename?: 'DiscountAutomaticDeactivatePayload';
  /** The deactivated automatic discount. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountAutomaticDelete` mutation. */
export type DiscountAutomaticDeletePayload = {
  __typename?: 'DiscountAutomaticDeletePayload';
  /** The ID of the automatic discount that was deleted. */
  deletedAutomaticDiscountId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** An auto-generated type which holds one DiscountAutomatic and a cursor during pagination. */
export type DiscountAutomaticEdge = {
  __typename?: 'DiscountAutomaticEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountAutomaticEdge. */
  node: DiscountAutomatic;
};

/**
 * The `DiscountAutomaticFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are automatically applied on a cart and at checkout. Free shipping discounts are promotional deals that
 * merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountAutomaticFreeShipping` object stores information about automatic free shipping discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeFreeShipping)
 * object has similar functionality to the `DiscountAutomaticFreeShipping` object, but customers need to enter a code to
 * receive a discount.
 * >
 * > API versions prior to `2025-10` only return automatic discounts with `context` set to `all`, discounts with other values are filtered out.
 */
export type DiscountAutomaticFreeShipping = {
  __typename?: 'DiscountAutomaticFreeShipping';
  /**
   * Whether the discount applies on one-time purchases.
   * A one-time purchase is a transaction where you pay a
   * single time for a product, without any ongoing
   * commitments or recurring charges.
   */
  appliesOnOneTimePurchase: Scalars['Boolean']['output'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The countries that qualify for the discount.
   * You can define
   * [a list of countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountries)
   * or specify [all countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountryAll)
   * to be eligible for the discount.
   */
  destinationSelection: DiscountShippingDestinationSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: ShippingDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** The maximum shipping price amount accepted to qualify for the discount. */
  maximumShippingPrice?: Maybe<MoneyV2>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit: Scalars['Int']['output'];
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping#field-summary)
   * field.
   */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the discount was used. */
  totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Return type for `discountAutomaticFreeShippingCreate` mutation. */
export type DiscountAutomaticFreeShippingCreatePayload = {
  __typename?: 'DiscountAutomaticFreeShippingCreatePayload';
  /** The automatic free shipping discount that was created. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that's automatically applied on a cart and at checkout.
 *
 * When creating, required fields are:
 * - `startsAt`
 * - `title`
 */
export type DiscountAutomaticFreeShippingInput = {
  /** Whether the discount applies on regular one-time-purchase items. */
  appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with the shipping discount.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   * Discounts automatically apply on Point of Sale (POS) for Pro locations when the context is not set to ALL.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** A list of destinations where the discount will apply. */
  destination?: InputMaybe<DiscountShippingDestinationSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum shipping price that qualifies for the discount. */
  maximumShippingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `discountAutomaticFreeShippingUpdate` mutation. */
export type DiscountAutomaticFreeShippingUpdatePayload = {
  __typename?: 'DiscountAutomaticFreeShippingUpdatePayload';
  /** The automatic discount that was updated. */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'DiscountAutomaticNode';
  /** A discount that's applied automatically when an order meets specific criteria. Learn more about [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts). */
  automaticDiscount: DiscountAutomatic;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DiscountAutomaticNodes. */
export type DiscountAutomaticNodeConnection = {
  __typename?: 'DiscountAutomaticNodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountAutomaticNodeEdge>;
  /** A list of nodes that are contained in DiscountAutomaticNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountAutomaticNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountAutomaticNode and a cursor during pagination. */
export type DiscountAutomaticNodeEdge = {
  __typename?: 'DiscountAutomaticNodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountAutomaticNodeEdge. */
  node: DiscountAutomaticNode;
};

/** Return type for `discountBulkTagsAdd` mutation. */
export type DiscountBulkTagsAddPayload = {
  __typename?: 'DiscountBulkTagsAddPayload';
  /** The asynchronous job that adds the tags. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountBulkTagsRemove` mutation. */
export type DiscountBulkTagsRemovePayload = {
  __typename?: 'DiscountBulkTagsRemovePayload';
  /** The asynchronous job that removes the tags. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** All buyers are eligible for the discount. */
export enum DiscountBuyerSelection {
  /** All buyers are eligible for the discount. */
  All = 'ALL'
}

/**
 * Indicates that a discount applies to all buyers without restrictions, enabling universal promotions that reach every customer. This selection removes buyer-specific limitations from discount eligibility.
 *
 * For example, a flash sale or grand opening promotion would target all buyers to maximize participation and store visibility.
 *
 * Learn more about [discount targeting](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountApplication).
 */
export type DiscountBuyerSelectionAll = {
  __typename?: 'DiscountBuyerSelectionAll';
  /** All buyers are eligible for the discount. */
  all: DiscountBuyerSelection;
};

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum DiscountClass {
  /**
   * The discount is combined with an
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  Order = 'ORDER',
  /**
   * The discount is combined with a
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  Product = 'PRODUCT',
  /**
   * The discount is combined with a
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  Shipping = 'SHIPPING'
}

/** The type of discount associated with the discount code. For example, the discount code might offer a basic discount of a fixed percentage, or a fixed amount, on specific products or the order. Alternatively, the discount might offer the customer free shipping on their order. A third option is a Buy X, Get Y (BXGY) discount, which offers a customer discounts on select products if they add a specific product to their order. */
export type DiscountCode = DiscountCodeApp | DiscountCodeBasic | DiscountCodeBxgy | DiscountCodeFreeShipping;

/** Return type for `discountCodeActivate` mutation. */
export type DiscountCodeActivatePayload = {
  __typename?: 'DiscountCodeActivatePayload';
  /** The activated code discount. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountCodeApp` object stores information about code discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountCodeApp` when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountAutomaticApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticApp)
 * object has similar functionality to the `DiscountCodeApp` object, with the exception that `DiscountAutomaticApp`
 * stores information about automatic discounts that are managed by an app using Shopify Functions.
 */
export type DiscountCodeApp = {
  __typename?: 'DiscountCodeApp';
  /**
   * The details about the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   * This information includes the app extension's name and
   * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
   * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
   * and other metadata about the discount type, including the discount type's name and description.
   */
  appDiscountType: AppDiscountType;
  /** Whether the discount applies on regular one-time-purchase items. */
  appliesOnOneTimePurchase: Scalars['Boolean']['output'];
  /** Whether the discount applies to subscriptions items. */
  appliesOnSubscription: Scalars['Boolean']['output'];
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /** A list codes that customers can use to redeem the discount. */
  codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The customers that can use the discount.
   * @deprecated Use `context` instead.
   */
  customerSelection: DiscountCustomerSelection;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: DiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The [globally-unique ID](https://shopify.dev/docs/api/usage/gids)
   * for the discount.
   */
  discountId: Scalars['ID']['output'];
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The [error history](https://shopify.dev/docs/apps/build/functions/monitoring-and-errors)
   * for the latest version of the discount type that the app provides.
   */
  errorHistory?: Maybe<FunctionsErrorHistory>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: Maybe<Scalars['Int']['output']>;
  /** A list of URLs that the app can use to share the discount. */
  shareableUrls: Array<DiscountShareableUrl>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the discount was used. */
  totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: Maybe<Scalars['Int']['output']>;
};


/**
 * The `DiscountCodeApp` object stores information about code discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountCodeApp` when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountAutomaticApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticApp)
 * object has similar functionality to the `DiscountCodeApp` object, with the exception that `DiscountAutomaticApp`
 * stores information about automatic discounts that are managed by an app using Shopify Functions.
 */
export type DiscountCodeAppCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeAppCreate` mutation. */
export type DiscountCodeAppCreatePayload = {
  __typename?: 'DiscountCodeAppCreatePayload';
  /** The discount that the app provides. */
  codeAppDiscount?: Maybe<DiscountCodeApp>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating a code discount, where the discount type is provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 *
 * Use these input fields when you need advanced or custom discount capabilities that aren't supported by [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountCodeAppInput = {
  /** Whether the discount applies on regular one-time-purchase items. */
  appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the discount applies to subscriptions items. */
  appliesOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The code that customers use to apply the discount. */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** Determines which discount effects the discount can apply. */
  discountClasses?: InputMaybe<Array<DiscountClass>>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The handle of the function providing the discount. */
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  /** Additional metafields to associate to the discount. [Metafields](https://shopify.dev/docs/apps/build/custom-data) provide dynamic function configuration with different parameters, such as `percentage` for a percentage discount. Merchants can set metafield values in the Shopify admin, which makes the discount function more flexible and customizable. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The number of times a discount applies on recurring purchases (subscriptions).         0 will apply infinitely whereas 1 will only apply to the first checkout. */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `discountCodeAppUpdate` mutation. */
export type DiscountCodeAppUpdatePayload = {
  __typename?: 'DiscountCodeAppUpdatePayload';
  /** The updated discount that the app provides. */
  codeAppDiscount?: Maybe<DiscountCodeApp>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * Discount code applications capture the intentions of a discount code at
 * the time that it is applied onto an order.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type DiscountCodeApplication = DiscountApplication & {
  __typename?: 'DiscountCodeApplication';
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The string identifying the discount code that was used at the time of application. */
  code: Scalars['String']['output'];
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  index: Scalars['Int']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  value: PricingValue;
};

/**
 * The `DiscountCodeBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are applied on a cart and at checkout when a customer enters a code. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountCodeBasic` object stores information about amount off code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic)
 * object has similar functionality to the `DiscountCodeBasic` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBasic = {
  __typename?: 'DiscountCodeBasic';
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /** A list codes that customers can use to redeem the discount. */
  codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets: DiscountCustomerGets;
  /**
   * The customers that can use the discount.
   * @deprecated Use `context` instead.
   */
  customerSelection: DiscountCustomerSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: MerchandiseDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: Maybe<Scalars['Int']['output']>;
  /** A list of URLs that the app can use to share the discount. */
  shareableUrls: Array<DiscountShareableUrl>;
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBasic#field-summary)
   * field.
   */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the discount was used. */
  totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: Maybe<Scalars['Int']['output']>;
};


/**
 * The `DiscountCodeBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are applied on a cart and at checkout when a customer enters a code. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountCodeBasic` object stores information about amount off code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic)
 * object has similar functionality to the `DiscountCodeBasic` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBasicCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeBasicCreate` mutation. */
export type DiscountCodeBasicCreatePayload = {
  __typename?: 'DiscountCodeBasicCreatePayload';
  /** The discount code that was created. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off.
 *
 * When creating, required fields are:
 *   - `code`
 *   - `context` (or deprecated `customerSelection`)
 *   - `customerGets`
 *   - `startsAt`
 *   - `title`
 */
export type DiscountCodeBasicInput = {
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The code that customers use to apply the discount. */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /** The number of billing cycles for which the discount can be applied, which is useful for subscription-based discounts. For example, if you set this field to `3`, then the discount only applies to the first three billing cycles of a subscription. If you specify `0`, then the discount applies indefinitely. */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `discountCodeBasicUpdate` mutation. */
export type DiscountCodeBasicUpdatePayload = {
  __typename?: 'DiscountCodeBasicUpdatePayload';
  /** The discount code that was updated. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountCodeBulkActivate` mutation. */
export type DiscountCodeBulkActivatePayload = {
  __typename?: 'DiscountCodeBulkActivatePayload';
  /** The asynchronous job that activates the discounts. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountCodeBulkDeactivate` mutation. */
export type DiscountCodeBulkDeactivatePayload = {
  __typename?: 'DiscountCodeBulkDeactivatePayload';
  /** The asynchronous job that deactivates the discounts. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountCodeBulkDelete` mutation. */
export type DiscountCodeBulkDeletePayload = {
  __typename?: 'DiscountCodeBulkDeletePayload';
  /** The asynchronous job that deletes the discounts. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountCodeBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are applied on a cart and at checkout when a customer enters a code. BXGY discounts incentivize customers
 * by offering them additional items at a discounted price or for free when they purchase a specified quantity
 * of items.
 *
 * The `DiscountCodeBxgy` object stores information about BXGY code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBxgy)
 * object has similar functionality to the `DiscountCodeBxgy` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBxgy = {
  __typename?: 'DiscountCodeBxgy';
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /** A list codes that customers can use to redeem the discount. */
  codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  customerBuys: DiscountCustomerBuys;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets: DiscountCustomerGets;
  /**
   * The customers that can use the discount.
   * @deprecated Use `context` instead.
   */
  customerSelection: DiscountCustomerSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: MerchandiseDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A list of URLs that the app can use to share the discount. */
  shareableUrls: Array<DiscountShareableUrl>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the discount was used. */
  totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of times that the discount can be applied to an order. */
  usesPerOrderLimit?: Maybe<Scalars['Int']['output']>;
};


/**
 * The `DiscountCodeBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are applied on a cart and at checkout when a customer enters a code. BXGY discounts incentivize customers
 * by offering them additional items at a discounted price or for free when they purchase a specified quantity
 * of items.
 *
 * The `DiscountCodeBxgy` object stores information about BXGY code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBxgy)
 * object has similar functionality to the `DiscountCodeBxgy` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBxgyCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeBxgyCreate` mutation. */
export type DiscountCodeBxgyCreatePayload = {
  __typename?: 'DiscountCodeBxgyCreatePayload';
  /** The code discount that was created. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that's applied on a cart and at checkout when a customer enters a code.
 *
 * When creating, required fields are:
 *   - `code`
 *   - `context` (or deprecated `customerSelection`)
 *   - `customerBuys`
 *   - `customerGets`
 *   - `startsAt`
 *   - `title`
 */
export type DiscountCodeBxgyInput = {
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The code that customers use to apply the discount. */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types),
   * and the product discount tags that determine which product discounts can apply
   * together on the same cart line.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  customerBuys?: InputMaybe<DiscountCustomerBuysInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of times that the discount can be applied to an order. */
  usesPerOrderLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `discountCodeBxgyUpdate` mutation. */
export type DiscountCodeBxgyUpdatePayload = {
  __typename?: 'DiscountCodeBxgyUpdatePayload';
  /** The code discount that was updated. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountCodeDeactivate` mutation. */
export type DiscountCodeDeactivatePayload = {
  __typename?: 'DiscountCodeDeactivatePayload';
  /** The deactivated code discount. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** Return type for `discountCodeDelete` mutation. */
export type DiscountCodeDeletePayload = {
  __typename?: 'DiscountCodeDeletePayload';
  /** The ID of the code discount that was deleted. */
  deletedCodeDiscountId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountCodeFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are applied on a cart and at checkout when a customer enters a code. Free shipping discounts are
 * promotional deals that merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountCodeFreeShipping` object stores information about free shipping code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The
 * [`DiscountAutomaticFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping)
 * object has similar functionality to the `DiscountCodeFreeShipping` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeFreeShipping = {
  __typename?: 'DiscountCodeFreeShipping';
  /**
   * Whether the discount applies on one-time purchases.
   * A one-time purchase is a transaction where you pay a
   * single time for a product, without any ongoing
   * commitments or recurring charges.
   */
  appliesOnOneTimePurchase: Scalars['Boolean']['output'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription: Scalars['Boolean']['output'];
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer: Scalars['Boolean']['output'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  asyncUsageCount: Scalars['Int']['output'];
  /** A list codes that customers can use to redeem the discount. */
  codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The context defining which buyers can use the discount. */
  context: DiscountContext;
  /** The date and time when the discount was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The customers that can use the discount.
   * @deprecated Use `context` instead.
   */
  customerSelection: DiscountCustomerSelection;
  /**
   * The countries that qualify for the discount.
   * You can define
   * [a list of countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountries)
   * or specify [all countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountryAll)
   * to be eligible for the discount.
   */
  destinationSelection: DiscountShippingDestinationSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: ShippingDiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** The maximum shipping price amount accepted to qualify for the discount. */
  maximumShippingPrice?: Maybe<MoneyV2>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: Maybe<Scalars['Int']['output']>;
  /** A list of URLs that the app can use to share the discount. */
  shareableUrls: Array<DiscountShareableUrl>;
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeFreeShipping#field-summary)
   * field.
   */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt: Scalars['DateTime']['output'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  summary: Scalars['String']['output'];
  /**
   * A list of searchable keywords that are associated with the discount.
   * For example, a merchant might apply the `loyalty` tag to discounts
   * that are associated with their loyalty program.
   */
  tags: Array<Scalars['String']['output']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the discount was used. */
  totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: Maybe<Scalars['Int']['output']>;
};


/**
 * The `DiscountCodeFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are applied on a cart and at checkout when a customer enters a code. Free shipping discounts are
 * promotional deals that merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountCodeFreeShipping` object stores information about free shipping code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The
 * [`DiscountAutomaticFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping)
 * object has similar functionality to the `DiscountCodeFreeShipping` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeFreeShippingCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeFreeShippingCreate` mutation. */
export type DiscountCodeFreeShippingCreatePayload = {
  __typename?: 'DiscountCodeFreeShippingCreatePayload';
  /** The discount code that was created. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The input fields for creating or updating a [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code.
 *
 * When creating, required fields are:
 *   - `code`
 *   - `context` (or deprecated `customerSelection`)
 *   - `startsAt`
 *   - `title`
 */
export type DiscountCodeFreeShippingInput = {
  /** Whether the discount applies on one-time purchases. A one-time purchase is a transaction where you pay a single time for a product, without any ongoing commitments or recurring charges. */
  appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the discount applies on subscription items. [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts) enable customers to purchase products on a recurring basis. */
  appliesOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a customer can only use the discount once. */
  appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The code that customers use to apply the discount. */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with the shipping discount.
   */
  combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The context defining which buyers can use the discount.
   * You can target specific customer IDs, customer segments, or make the discount available to all buyers.
   */
  context?: InputMaybe<DiscountContextInput>;
  /** The shipping destinations where the free shipping discount can be applied. You can specify whether the discount applies to all countries, or specify individual countries. */
  destination?: InputMaybe<DiscountShippingDestinationSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The maximum shipping price, in the shop's currency, that qualifies for free shipping.
   * <br/><br/>
   * For example, if set to 20.00, then only shipping rates that cost $20.00 or less will be made free. To apply the discount to all shipping rates, specify `null`.
   */
  maximumShippingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied, which is useful for subscription-based discounts.
   * <br/><br/>
   * For example, if set to `3`, then the discount only applies to the first three billing cycles of a subscription. If set to `0`, then the discount applies indefinitely.
   */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the discount becomes active and is available to customers. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A list of searchable keywords that are associated with the discount.
   *
   * Use these tags on product discounts to determine which other product discounts can
   * apply to the same cart line when you configure
   * `productDiscountsWithTagsOnSameCartLine` in `combinesWith`.
   *
   * For example, you can apply a `loyalty` tag to discounts
   * that are associated with a loyalty program.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the discount.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of times the discount can be redeemed.
   * For unlimited usage, specify `null`.
   */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `discountCodeFreeShippingUpdate` mutation. */
export type DiscountCodeFreeShippingUpdatePayload = {
  __typename?: 'DiscountCodeFreeShippingUpdatePayload';
  /** The discount code that was updated. */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'DiscountCodeNode';
  /** The underlying code discount object. */
  codeDiscount: DiscountCode;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DiscountCodeNodes. */
export type DiscountCodeNodeConnection = {
  __typename?: 'DiscountCodeNodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountCodeNodeEdge>;
  /** A list of nodes that are contained in DiscountCodeNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountCodeNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountCodeNode and a cursor during pagination. */
export type DiscountCodeNodeEdge = {
  __typename?: 'DiscountCodeNodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountCodeNodeEdge. */
  node: DiscountCodeNode;
};

/** Return type for `discountCodeRedeemCodeBulkDelete` mutation. */
export type DiscountCodeRedeemCodeBulkDeletePayload = {
  __typename?: 'DiscountCodeRedeemCodeBulkDeletePayload';
  /** The asynchronous job that deletes the discount codes. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** The set of valid sort keys for the DiscountCode query. */
export enum DiscountCodeSortKeys {
  /** Sort by the `code` value. */
  Code = 'CODE',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE'
}

/** A list of collections that the discount can have as a prerequisite or a list of collections to which the discount can be applied. */
export type DiscountCollections = {
  __typename?: 'DiscountCollections';
  /** The list of collections that the discount can have as a prerequisite or the list of collections to which the discount can be applied. */
  collections: CollectionConnection;
};


/** A list of collections that the discount can have as a prerequisite or a list of collections to which the discount can be applied. */
export type DiscountCollectionsCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for collections attached to a discount. */
export type DiscountCollectionsInput = {
  /** Specifies list of collection ids to add. */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Specifies list of collection ids to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * The [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that you can use in combination with
 * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountCombinesWith = {
  __typename?: 'DiscountCombinesWith';
  /**
   * Whether the discount combines with the
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  orderDiscounts: Scalars['Boolean']['output'];
  /**
   * Whether the discount combines with the
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  productDiscounts: Scalars['Boolean']['output'];
  /**
   * Controls which product discounts can apply together on the same cart line. By
   * default, only one product discount applies per line. Available only on a Shopify
   * Plus plan and requires the `productDiscounts` field to be set to `true`.
   *
   * For discounts to apply together, they must match tags in both directions. Each
   * discount has two tag sets: the tags that identify the discount, and the tags that
   * it agrees to apply with. Use the `tags` field on the discount input to set the
   * discount's own tags. This field returns the tags that this discount agrees to
   * apply with. Two discounts apply together only if each one allows at least one tag
   * that the other is tagged with. Any number of product discounts can apply to the
   * same line if this two-way match holds for every pair in the group.
   *
   * Example: Discount A is tagged with `LOYALTY` and allows `SEASONAL`, and Discount B
   * is tagged with `SEASONAL` and allows `LOYALTY`. They apply together. To add a
   * third discount, it must meet the same mutual-match rule with both A and B.
   *
   * Buy X Get Y discounts stack only on the customer-gets products (GY), not the
   * customer-buys products (BX). See
   * [Limitations for discount combinations](https://help.shopify.com/manual/discounts/discount-combinations#considerations)
   * for details.
   */
  productDiscountsWithTagsOnSameCartLine?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Whether the discount combines with the
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  shippingDiscounts: Scalars['Boolean']['output'];
};

/** The input fields to determine which discount classes the discount can combine with. */
export type DiscountCombinesWithInput = {
  /**
   * Whether the discount combines with the
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  orderDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the discount combines with the
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  productDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Controls which product discounts can apply together on the same cart line. By
   * default, only one product discount applies per line. Available only on a Shopify
   * Plus plan and requires the `productDiscounts` field to be set to `true`.
   *
   * For discounts to apply together, they must match tags in both directions. Each
   * discount has two tag sets: the tags that identify the discount, and the tags that
   * it agrees to apply with. Use the `tags` field on the discount input to set the
   * discount's own tags. Use this field to set the tags that the discount can apply
   * with. Two discounts apply together only if each one allows at least one tag that
   * the other is tagged with. Any number of product discounts can apply to the same
   * line if this two-way match holds for every pair in the group.
   *
   * Example: Discount A is tagged with `LOYALTY` and allows `SEASONAL`, and Discount B
   * is tagged with `SEASONAL` and allows `LOYALTY`. They apply together. To add a
   * third discount, it must meet the same mutual-match rule with both A and B.
   *
   * Buy X Get Y discounts stack only on the customer-gets products (GY), not the
   * customer-buys products (BX). See
   * [Limitations for discount combinations](https://help.shopify.com/manual/discounts/discount-combinations#considerations)
   * for details.
   */
  productDiscountsWithTagsOnSameCartLine?: InputMaybe<ProductDiscountsWithTagsOnSameCartLineInput>;
  /**
   * Whether the discount combines
   * with the
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  shippingDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The type used to define which buyers can use the discount. */
export type DiscountContext = DiscountBuyerSelectionAll | DiscountCustomerSegments | DiscountCustomers | DiscountMarkets;

/** The input fields for the buyers who can use this discount. */
export type DiscountContextInput = {
  /** All buyers are eligible for this discount. */
  all?: InputMaybe<DiscountBuyerSelection>;
  /** The list of customer segment IDs to add or remove from the list of customer segments. */
  customerSegments?: InputMaybe<DiscountCustomerSegmentsInput>;
  /** The list of customer IDs to add or remove from the list of customers. */
  customers?: InputMaybe<DiscountCustomersInput>;
  /** The list of market IDs to add or remove from the list of markets. */
  markets?: InputMaybe<DiscountMarketsInput>;
};

/**
 * Defines the geographic scope where a shipping discount can be applied based on customer shipping destinations. This configuration determines which countries are eligible for the promotional offer.
 *
 * For example, a "Free Shipping to EU" promotion would specify European Union countries, while a domestic-only sale might target just the store's home country.
 *
 * The object includes both specific country selections and an option to include all remaining countries not explicitly listed, providing flexible geographic targeting for international merchants.
 */
export type DiscountCountries = {
  __typename?: 'DiscountCountries';
  /** The codes for the countries where the discount can be applied. */
  countries: Array<CountryCode>;
  /**
   * Whether the discount is applicable to countries that haven't been defined in the shop's shipping zones.
   * @deprecated This field is being retired. Discounts that set `includeRestOfWorld: true` will be converted to an explicit list of countries, and `countries` will then return every country where the discount applies.
   */
  includeRestOfWorld: Scalars['Boolean']['output'];
};

/** The input fields for a list of countries to add or remove from the free shipping discount. */
export type DiscountCountriesInput = {
  /** The country codes to add to the list of countries where the discount applies. */
  add?: InputMaybe<Array<CountryCode>>;
  /** The country codes to remove from the list of countries where the discount applies. */
  remove?: InputMaybe<Array<CountryCode>>;
};

/**
 * Indicates that a shipping discount applies to all countries without restriction, enabling merchants to create truly global promotions. This object represents universal geographic eligibility for shipping discount offers.
 *
 * For example, an online store launching a "Worldwide Free Shipping" campaign would use this configuration to ensure customers from any country can benefit from the promotion.
 *
 * This setting simplifies international discount management by eliminating the need to manually select individual countries or regions, making it ideal for digital products or stores with comprehensive global shipping capabilities.
 */
export type DiscountCountryAll = {
  __typename?: 'DiscountCountryAll';
  /** Whether the discount can be applied to all countries as shipping destination. This value is always `true`. */
  allCountries: Scalars['Boolean']['output'];
};

/**
 * Creates the broadest possible discount reach by targeting all customers, regardless of their purchase history or segment membership. This gives merchants maximum flexibility to run store-wide promotions without worrying about customer eligibility restrictions.
 *
 * For example, a flash sale or grand opening promotion would target all customers to maximize participation and store visibility.
 *
 * Learn more about [customer targeting](https://help.shopify.com/manual/discounts/).
 */
export type DiscountCustomerAll = {
  __typename?: 'DiscountCustomerAll';
  /** Whether the discount can be applied by all customers. This value is always `true`. */
  allCustomers: Scalars['Boolean']['output'];
};

/** The prerequisite items and prerequisite value that a customer must have on the order for the discount to be applicable. */
export type DiscountCustomerBuys = {
  __typename?: 'DiscountCustomerBuys';
  /** If the discount is applicable when a customer buys a one-time purchase. */
  isOneTimePurchase: Scalars['Boolean']['output'];
  /** If the discount is applicable when a customer buys a subscription purchase. */
  isSubscription: Scalars['Boolean']['output'];
  /** The items required for the discount to be applicable. */
  items: DiscountItems;
  /** The prerequisite value. */
  value: DiscountCustomerBuysValue;
};

/** The input fields for prerequisite items and quantity for the discount. */
export type DiscountCustomerBuysInput = {
  /** If the discount is applicable when a customer buys a one-time purchase. */
  isOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the discount is applicable when a customer buys a subscription purchase. */
  isSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IDs of items that the customer buys. The items can be either collections or products. */
  items?: InputMaybe<DiscountItemsInput>;
  /** The quantity of prerequisite items. */
  value?: InputMaybe<DiscountCustomerBuysValueInput>;
};

/** The prerequisite for the discount to be applicable. For example, the discount might require a customer to buy a minimum quantity of select items. Alternatively, the discount might require a customer to spend a minimum amount on select items. */
export type DiscountCustomerBuysValue = DiscountPurchaseAmount | DiscountQuantity;

/** The input fields for prerequisite quantity or minimum purchase amount required for the discount. */
export type DiscountCustomerBuysValueInput = {
  /** The prerequisite minimum purchase amount required for the discount to be applicable. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** The quantity of prerequisite items. */
  quantity?: InputMaybe<Scalars['UnsignedInt64']['input']>;
};

/** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
export type DiscountCustomerGets = {
  __typename?: 'DiscountCustomerGets';
  /** Whether the discount applies on regular one-time-purchase items. */
  appliesOnOneTimePurchase: Scalars['Boolean']['output'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription: Scalars['Boolean']['output'];
  /** The items to which the discount applies. */
  items: DiscountItems;
  /** Entitled quantity and the discount value. */
  value: DiscountCustomerGetsValue;
};

/** Specifies the items that will be discounted, the quantity of items that will be discounted, and the value of discount. */
export type DiscountCustomerGetsInput = {
  /** Whether the discount applies on regular one-time-purchase items. */
  appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  appliesOnSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IDs of the items that the customer gets. The items can be either collections or products. */
  items?: InputMaybe<DiscountItemsInput>;
  /** The quantity of items discounted and the discount value. */
  value?: InputMaybe<DiscountCustomerGetsValueInput>;
};

/** The type of the discount value and how it will be applied. For example, it might be a percentage discount on a fixed number of items. Alternatively, it might be a fixed amount evenly distributed across all items or on each individual item. A third example is a percentage discount on all items. */
export type DiscountCustomerGetsValue = DiscountAmount | DiscountOnQuantity | DiscountPercentage;

/** The input fields for the quantity of items discounted and the discount value. */
export type DiscountCustomerGetsValueInput = {
  /**
   * The value of the discount.
   *
   * Note: BXGY doesn't support discountAmount.
   */
  discountAmount?: InputMaybe<DiscountAmountInput>;
  /** The quantity of the items that are discounted and the discount value. */
  discountOnQuantity?: InputMaybe<DiscountOnQuantityInput>;
  /**
   * The percentage value of the discount. Value must be between 0.00 - 1.00.
   *
   * Note: BXGY doesn't support percentage.
   */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Represents customer segments that are eligible to receive a specific discount, allowing merchants to target promotions to defined groups of customers. This enables personalized marketing campaigns based on customer behavior and characteristics.
 *
 * For example, a "VIP Customer 15% Off" promotion might target a segment of high-value repeat customers, while a "New Customer Welcome" discount could focus on first-time buyers.
 *
 * Segment-based discounts help merchants create more relevant promotional experiences and improve conversion rates by showing the right offers to the right customers at the right time.
 */
export type DiscountCustomerSegments = {
  __typename?: 'DiscountCustomerSegments';
  /** The list of customer segments who are eligible for the discount. */
  segments: Array<Segment>;
};

/** The input fields for which customer segments to add to or remove from the discount. */
export type DiscountCustomerSegmentsInput = {
  /** A list of customer segments to add to the current list of customer segments. */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of customer segments to remove from the current list of customer segments. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The type used for targeting a set of customers who are eligible for the discount. For example, the discount might be available to all customers or it might only be available to a specific set of customers. You can define the set of customers by targeting a list of customer segments, or by targeting a list of specific customers. */
export type DiscountCustomerSelection = DiscountCustomerAll | DiscountCustomerSegments | DiscountCustomerSelectionUnknown | DiscountCustomers;

/** The input fields for the customers who can use this discount. */
export type DiscountCustomerSelectionInput = {
  /** Whether all customers can use this discount. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of customer segment IDs to add or remove from the list of customer segments. */
  customerSegments?: InputMaybe<DiscountCustomerSegmentsInput>;
  /** The list of customer IDs to add or remove from the list of customers. */
  customers?: InputMaybe<DiscountCustomersInput>;
};

/** An unrecognized customer selection type. Use the `context` field on the parent discount type instead. */
export type DiscountCustomerSelectionUnknown = {
  __typename?: 'DiscountCustomerSelectionUnknown';
  /** The underlying customer selection type. */
  customerSelectionType: Scalars['String']['output'];
};

/**
 * Defines customer targeting for discounts through specific individual customers. This object allows merchants to create exclusive discounts that are only available to explicitly selected customers.
 *
 * For example, a VIP customer appreciation discount might target specific high-value customers by individually selecting them, or a beta program discount could be offered to selected early adopters.
 *
 * Use `DiscountCustomers` to:
 * - Target specific individual customers for exclusive promotions
 * - Create personalized discount experiences for selected customers
 * - Offer special discounts to VIP or loyal customers
 * - Provide exclusive access to promotions for specific individuals
 *
 * This targeting method requires you to add each customer who should be eligible for the discount. For broader targeting based on customer attributes or segments, use [`DiscountCustomerSegments`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCustomerSegments) instead.
 *
 * Learn more about creating customer-specific discounts using [`discountCodeBasicCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicCreate) and [`discountCodeBasicUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicUpdate).
 */
export type DiscountCustomers = {
  __typename?: 'DiscountCustomers';
  /** The list of individual customers eligible for the discount. */
  customers: Array<Customer>;
};

/** The input fields for which customers to add to or remove from the discount. */
export type DiscountCustomersInput = {
  /** A list of customers to add to the current list of customers who can use the discount. */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of customers to remove from the current list of customers who can use the discount. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The type of discount that will be applied. Currently, only a percentage discount is supported. */
export type DiscountEffect = DiscountAmount | DiscountPercentage;

/** The input fields for how the discount will be applied. Currently, only percentage off is supported. */
export type DiscountEffectInput = {
  /** The value of the discount. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage value of the discount. Value must be between 0.00 - 1.00. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Possible error codes that can be returned by `DiscountUserError`. */
export enum DiscountErrorCode {
  /** The active period overlaps with other automatic discounts. At any given time, only 25 automatic discounts can be active. */
  ActivePeriodOverlap = 'ACTIVE_PERIOD_OVERLAP',
  /** A discount cannot have both appliesOnOneTimePurchase and appliesOnSubscription set to false. */
  AppliesOnNothing = 'APPLIES_ON_NOTHING',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The attribute selection contains conflicting settings. */
  Conflict = 'CONFLICT',
  /** Discounts and condition types are not compatible with each other. */
  DiscountNotCompatibleWithConditionTypes = 'DISCOUNT_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The input value is already present. */
  Duplicate = 'DUPLICATE',
  /** The end date should be after the start date. */
  EndDateBeforeStartDate = 'END_DATE_BEFORE_START_DATE',
  /** The input value should be equal to the value allowed. */
  EqualTo = 'EQUAL_TO',
  /** The value exceeded the maximum allowed value. */
  ExceededMax = 'EXCEEDED_MAX',
  /** The input value should be greater than the minimum allowed value. */
  GreaterThan = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** The value is already present through another selection. */
  ImplicitDuplicate = 'IMPLICIT_DUPLICATE',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The `combinesWith` settings are invalid for the discount class. */
  InvalidCombinesWithForDiscountClass = 'INVALID_COMBINES_WITH_FOR_DISCOUNT_CLASS',
  /** The discountClass is invalid for the price rule. */
  InvalidDiscountClassForPriceRule = 'INVALID_DISCOUNT_CLASS_FOR_PRICE_RULE',
  /** The `productDiscounts` field can't be set to false when `productDiscountsWithTagsOnSameCartLine` tags exist on the discount. */
  InvalidProductDiscountsFalseWithExistingTagsOnSameCartLine = 'INVALID_PRODUCT_DISCOUNTS_FALSE_WITH_EXISTING_TAGS_ON_SAME_CART_LINE',
  /** The `productDiscountsWithTagsOnSameCartLine` field is only valid for discounts with the PRODUCT discount class. */
  InvalidProductDiscountsWithTagsOnSameCartLineForDiscountClass = 'INVALID_PRODUCT_DISCOUNTS_WITH_TAGS_ON_SAME_CART_LINE_FOR_DISCOUNT_CLASS',
  /** The `productDiscountsWithTagsOnSameCartLine` field can only be specified when `productDiscounts` is true. */
  InvalidProductDiscountsWithTagsOnSameCartLineWithoutProductDiscounts = 'INVALID_PRODUCT_DISCOUNTS_WITH_TAGS_ON_SAME_CART_LINE_WITHOUT_PRODUCT_DISCOUNTS',
  /** The tag title exceeds the maximum length of 255 characters. */
  InvalidTagLength = 'INVALID_TAG_LENGTH',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The active period overlaps with too many other app-provided discounts. There's a limit on the number of app discounts that can be active at any given time. */
  MaxAppDiscounts = 'MAX_APP_DISCOUNTS',
  /** Specify a minimum subtotal or a quantity, but not both. */
  MinimumSubtotalAndQuantityRangeBothPresent = 'MINIMUM_SUBTOTAL_AND_QUANTITY_RANGE_BOTH_PRESENT',
  /** Missing a required argument. */
  MissingArgument = 'MISSING_ARGUMENT',
  /** Either function ID or function handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function ID or function handle is allowed. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS',
  /** Recurring cycle limit must be 1 when discount does not apply to subscription items. */
  MultipleRecurringCycleLimitForNonSubscriptionItems = 'MULTIPLE_RECURRING_CYCLE_LIMIT_FOR_NON_SUBSCRIPTION_ITEMS',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The shop's plan does not allow setting `productDiscountsWithTagsOnSameCartLine`. */
  ProductDiscountsWithTagsOnSameCartLineNotEntitled = 'PRODUCT_DISCOUNTS_WITH_TAGS_ON_SAME_CART_LINE_NOT_ENTITLED',
  /** Recurring cycle limit must be a valid integer greater than or equal to 0. */
  RecurringCycleLimitNotAValidInteger = 'RECURRING_CYCLE_LIMIT_NOT_A_VALID_INTEGER',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** Too many arguments provided. */
  TooManyArguments = 'TOO_MANY_ARGUMENTS',
  /** The number of tags in `productDiscountsWithTagsOnSameCartLine` exceeds the maximum of 10. */
  TooManyProductDiscountsWithTagsOnSameCartLine = 'TOO_MANY_PRODUCT_DISCOUNTS_WITH_TAGS_ON_SAME_CART_LINE',
  /** The number of tags exceeds the maximum of 5. */
  TooManyTags = 'TOO_MANY_TAGS',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** The value is outside of the allowed range. */
  ValueOutsideRange = 'VALUE_OUTSIDE_RANGE'
}

/** The type used to target the items required for discount eligibility, or the items to which the application of a discount might apply. For example, for a customer to be eligible for a discount, they're required to add an item from a specified collection to their order. Alternatively, a customer might be required to add a specific product or product variant. When using this type to target which items the discount will apply to, the discount might apply to all items on the order, or to specific products and product variants, or items in a given collection. */
export type DiscountItems = AllDiscountItems | DiscountCollections | DiscountProducts;

/** The input fields for the items attached to a discount. You can specify the discount items by product ID or collection ID. */
export type DiscountItemsInput = {
  /** Whether all items should be selected for the discount. Not supported for Buy X get Y discounts. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** The collections that are attached to a discount. */
  collections?: InputMaybe<DiscountCollectionsInput>;
  /**
   * The
   * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and
   * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant)
   * that the discount applies to.
   */
  products?: InputMaybe<DiscountProductsInput>;
};

/** Markets where the discount is available. */
export type DiscountMarkets = {
  __typename?: 'DiscountMarkets';
  /** The list of markets where the discount is available. */
  markets: MarketConnection;
  /** The number of markets where the discount is available. */
  marketsCount: Scalars['Int']['output'];
};


/** Markets where the discount is available. */
export type DiscountMarketsMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for the markets where the discount is available. */
export type DiscountMarketsInput = {
  /** The list of market IDs to add. */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The list of market IDs to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Specifies the minimum item quantity required for discount eligibility, helping merchants create volume-based promotions that encourage larger purchases. This threshold applies to qualifying items in the customer's cart.
 *
 * For example, a "Buy 3, Get 10% Off" promotion would set the minimum quantity to 3 items.
 *
 * Learn more about [discount requirements](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountApplication).
 */
export type DiscountMinimumQuantity = {
  __typename?: 'DiscountMinimumQuantity';
  /** The minimum quantity of items that's required for the discount to be applied. */
  greaterThanOrEqualToQuantity: Scalars['UnsignedInt64']['output'];
};

/** The input fields for the minimum quantity required for the discount. */
export type DiscountMinimumQuantityInput = {
  /** The minimum quantity of items that's required for the discount to be applied. */
  greaterThanOrEqualToQuantity?: InputMaybe<Scalars['UnsignedInt64']['input']>;
};

/** The type of minimum requirement that must be met for the discount to be applied. For example, a customer must spend a minimum subtotal to be eligible for the discount. Alternatively, a customer must purchase a minimum quantity of items to be eligible for the discount. */
export type DiscountMinimumRequirement = DiscountMinimumQuantity | DiscountMinimumSubtotal;

/** The input fields for the minimum quantity or subtotal required for a discount. */
export type DiscountMinimumRequirementInput = {
  /** The minimum required quantity. */
  quantity?: InputMaybe<DiscountMinimumQuantityInput>;
  /** The minimum required subtotal. */
  subtotal?: InputMaybe<DiscountMinimumSubtotalInput>;
};

/** The minimum subtotal required for the discount to apply. */
export type DiscountMinimumSubtotal = {
  __typename?: 'DiscountMinimumSubtotal';
  /** The minimum subtotal that's required for the discount to be applied. */
  greaterThanOrEqualToSubtotal: MoneyV2;
};

/** The input fields for the minimum subtotal required for a discount. */
export type DiscountMinimumSubtotalInput = {
  /** The minimum subtotal that's required for the discount to be applied. */
  greaterThanOrEqualToSubtotal?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'DiscountNode';
  /**
   * A discount that's applied at checkout or on cart.
   *
   *
   * Discounts can be [automatic or code-based](https://shopify.dev/docs/apps/build/discounts#discount-methods).
   */
  discount: Discount;
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple DiscountNodes. */
export type DiscountNodeConnection = {
  __typename?: 'DiscountNodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountNodeEdge>;
  /** A list of nodes that are contained in DiscountNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountNode and a cursor during pagination. */
export type DiscountNodeEdge = {
  __typename?: 'DiscountNodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountNodeEdge. */
  node: DiscountNode;
};

/**
 * Defines quantity-based discount rules that specify how many items are eligible for a discount effect. This object enables bulk purchase incentives and tiered pricing strategies.
 *
 * For example, a "Buy 4 candles, get 2 candles 50% off (mix and match)" promotion would specify a quantity threshold of 2 items that will receive a percentage discount effect, encouraging customers to purchase more items to unlock savings.
 *
 * The configuration combines quantity requirements with discount effects, allowing merchants to create sophisticated pricing rules that reward larger purchases and increase average order values.
 */
export type DiscountOnQuantity = {
  __typename?: 'DiscountOnQuantity';
  /** The discount's effect on qualifying items. */
  effect: DiscountEffect;
  /** The number of items being discounted. The customer must have at least this many items of specified products or product variants in their order to be eligible for the discount. */
  quantity: DiscountQuantity;
};

/** The input fields for the quantity of items discounted and the discount value. */
export type DiscountOnQuantityInput = {
  /** The percentage value of the discount. */
  effect?: InputMaybe<DiscountEffectInput>;
  /** The quantity of items that are discounted. */
  quantity?: InputMaybe<Scalars['UnsignedInt64']['input']>;
};

/**
 * Creates percentage-based discounts that reduce item prices by a specified percentage amount. This gives merchants a flexible way to offer proportional savings that automatically scale with order value.
 *
 * For example, a "20% off all winter clothing" promotion would use this object to apply consistent percentage savings across different price points.
 *
 * Learn more about [discount types](https://help.shopify.com/manual/discounts/).
 */
export type DiscountPercentage = {
  __typename?: 'DiscountPercentage';
  /** The percentage value of the discount. */
  percentage: Scalars['Float']['output'];
};

/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProducts = {
  __typename?: 'DiscountProducts';
  /** The list of product variants that the discount can have as a prerequisite or the list of product variants to which the discount can be applied. */
  productVariants: ProductVariantConnection;
  /** The list of products that the discount can have as a prerequisite or the list of products to which the discount can be applied. */
  products: ProductConnection;
};


/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProductsProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProductsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The input fields for adding and removing
 * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and
 * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant)
 * as prerequisites or as eligible items for a discount.
 */
export type DiscountProductsInput = {
  /** The IDs of the product variants to add as prerequisites or as eligible items for a discount. */
  productVariantsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the product variants to remove as prerequisites or as eligible items for a discount. */
  productVariantsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the products to add as prerequisites or as eligible items for a discount. */
  productsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the products to remove as prerequisites or as eligible items for a discount. */
  productsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A purchase amount in the context of a discount. This object can be used to define the minimum purchase amount required for a discount to be applicable. */
export type DiscountPurchaseAmount = {
  __typename?: 'DiscountPurchaseAmount';
  /** The purchase amount in decimal format. */
  amount: Scalars['Decimal']['output'];
};

/**
 * Defines a quantity threshold for discount eligibility or application. This simple object specifies the number of items required to trigger or calculate discount benefits.
 *
 * For example, a "Buy 3, Get 1 Free" promotion would use DiscountQuantity to define the minimum purchase quantity of 3 items, or a bulk discount might specify quantity tiers like 10+ items for wholesale pricing.
 *
 * The quantity value determines how discounts interact with cart contents, whether setting minimum purchase requirements or defining quantity-based discount calculations.
 */
export type DiscountQuantity = {
  __typename?: 'DiscountQuantity';
  /** The quantity of items. */
  quantity: Scalars['UnsignedInt64']['output'];
};

/** A code that a customer can use at checkout to receive a discount. For example, a customer can use the redeem code 'SUMMER20' at checkout to receive a 20% discount on their entire order. */
export type DiscountRedeemCode = {
  __typename?: 'DiscountRedeemCode';
  /** The number of times that the discount redeem code has been used. This value is updated asynchronously and can be different than the actual usage count. */
  asyncUsageCount: Scalars['Int']['output'];
  /** The code that a customer can use at checkout to receive a discount. */
  code: Scalars['String']['output'];
  /** The date and time when the discount redeem code was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The application that created the discount redeem code. */
  createdBy?: Maybe<App>;
  /** A globally-unique ID of the discount redeem code. */
  id: Scalars['ID']['output'];
};

/** Return type for `discountRedeemCodeBulkAdd` mutation. */
export type DiscountRedeemCodeBulkAddPayload = {
  __typename?: 'DiscountRedeemCodeBulkAddPayload';
  /**
   * The ID of bulk operation that creates multiple unique discount codes.
   * You can use the
   * [`discountRedeemCodeBulkCreation` query](https://shopify.dev/api/admin-graphql/latest/queries/discountRedeemCodeBulkCreation)
   * to track the status of the bulk operation.
   */
  bulkCreation?: Maybe<DiscountRedeemCodeBulkCreation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DiscountUserError>;
};

/** The properties and status of a bulk discount redeem code creation operation. */
export type DiscountRedeemCodeBulkCreation = Node & {
  __typename?: 'DiscountRedeemCodeBulkCreation';
  /** The result of each code creation operation associated with the bulk creation operation including any errors that might have occurred during the operation. */
  codes: DiscountRedeemCodeBulkCreationCodeConnection;
  /** The number of codes to create. */
  codesCount: Scalars['Int']['output'];
  /** The date and time when the bulk creation was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The code discount associated with the created codes. */
  discountCode?: Maybe<DiscountCodeNode>;
  /** Whether the bulk creation is still queued (`false`) or has been run (`true`). */
  done: Scalars['Boolean']['output'];
  /** The number of codes that weren't created successfully. */
  failedCount: Scalars['Int']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The number of codes created successfully. */
  importedCount: Scalars['Int']['output'];
};


/** The properties and status of a bulk discount redeem code creation operation. */
export type DiscountRedeemCodeBulkCreationCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A result of a discount redeem code creation operation created by a bulk creation. */
export type DiscountRedeemCodeBulkCreationCode = {
  __typename?: 'DiscountRedeemCodeBulkCreationCode';
  /** The code to use in the discount redeem code creation operation. */
  code: Scalars['String']['output'];
  /**
   * The successfully created discount redeem code.
   *
   * If the discount redeem code couldn't be created, then this field is `null``.
   */
  discountRedeemCode?: Maybe<DiscountRedeemCode>;
  /** A list of errors that occurred during the creation operation of the discount redeem code. */
  errors: Array<DiscountUserError>;
};

/** An auto-generated type for paginating through multiple DiscountRedeemCodeBulkCreationCodes. */
export type DiscountRedeemCodeBulkCreationCodeConnection = {
  __typename?: 'DiscountRedeemCodeBulkCreationCodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountRedeemCodeBulkCreationCodeEdge>;
  /** A list of nodes that are contained in DiscountRedeemCodeBulkCreationCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountRedeemCodeBulkCreationCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountRedeemCodeBulkCreationCode and a cursor during pagination. */
export type DiscountRedeemCodeBulkCreationCodeEdge = {
  __typename?: 'DiscountRedeemCodeBulkCreationCodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountRedeemCodeBulkCreationCodeEdge. */
  node: DiscountRedeemCodeBulkCreationCode;
};

/** An auto-generated type for paginating through multiple DiscountRedeemCodes. */
export type DiscountRedeemCodeConnection = {
  __typename?: 'DiscountRedeemCodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DiscountRedeemCodeEdge>;
  /** A list of nodes that are contained in DiscountRedeemCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DiscountRedeemCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountRedeemCode and a cursor during pagination. */
export type DiscountRedeemCodeEdge = {
  __typename?: 'DiscountRedeemCodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountRedeemCodeEdge. */
  node: DiscountRedeemCode;
};

/** The input fields for the redeem code to attach to a discount. */
export type DiscountRedeemCodeInput = {
  /** The code that a customer can use at checkout to receive the associated discount. */
  code: Scalars['String']['input'];
};

/** A shareable URL for a discount code. */
export type DiscountShareableUrl = {
  __typename?: 'DiscountShareableUrl';
  /** The image URL of the item (product or collection) to which the discount applies. */
  targetItemImage?: Maybe<Image>;
  /** The type of page that's associated with the URL. */
  targetType: DiscountShareableUrlTargetType;
  /** The title of the page that's associated with the URL. */
  title: Scalars['String']['output'];
  /** The URL for the discount code. */
  url: Scalars['URL']['output'];
};

/** The type of page where a shareable discount URL lands. */
export enum DiscountShareableUrlTargetType {
  /** The URL lands on a collection page. */
  Collection = 'COLLECTION',
  /** The URL lands on a home page. */
  Home = 'HOME',
  /** The URL lands on a product page. */
  Product = 'PRODUCT'
}

/** The type used to target the eligible countries of an order's shipping destination for which the discount applies. For example, the discount might be applicable when shipping to all countries, or only to a set of countries. */
export type DiscountShippingDestinationSelection = DiscountCountries | DiscountCountryAll;

/** The input fields for the destinations where the free shipping discount will be applied. */
export type DiscountShippingDestinationSelectionInput = {
  /** Whether the discount code applies to all countries. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of countries where the discount code will apply. */
  countries?: InputMaybe<DiscountCountriesInput>;
};

/** The set of valid sort keys for the Discount query. */
export enum DiscountSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `ends_at` value. */
  EndsAt = 'ENDS_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `starts_at` value. */
  StartsAt = 'STARTS_AT',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/**
 * The status of the discount that describes its availability,
 * expiration, or pending activation.
 */
export enum DiscountStatus {
  /** The discount is currently available for use. */
  Active = 'ACTIVE',
  /** The discount has reached its end date and is no longer valid. */
  Expired = 'EXPIRED',
  /** The discount is set to become active at a future date. */
  Scheduled = 'SCHEDULED'
}

/** The set of valid sort keys for the DiscountTag query. */
export enum DiscountTagSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** The type of line (line item or shipping line) on an order that the subscription discount is applicable towards. */
export enum DiscountTargetType {
  /** The discount applies onto line items. */
  LineItem = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  ShippingLine = 'SHIPPING_LINE'
}

/** The type of the subscription discount. */
export enum DiscountType {
  /** Automatic discount type. */
  AutomaticDiscount = 'AUTOMATIC_DISCOUNT',
  /** Code discount type. */
  CodeDiscount = 'CODE_DISCOUNT',
  /** Manual discount type. */
  Manual = 'MANUAL'
}

/** An error that occurs during the execution of a discount mutation. */
export type DiscountUserError = DisplayableError & {
  __typename?: 'DiscountUserError';
  /** The error code. */
  code?: Maybe<DiscountErrorCode>;
  /** Extra information about this error. */
  extraInfo?: Maybe<Scalars['String']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Represents an error in the input of a mutation. */
export type DisplayableError = {
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Return type for `disputeEvidenceUpdate` mutation. */
export type DisputeEvidenceUpdatePayload = {
  __typename?: 'DisputeEvidenceUpdatePayload';
  /** The updated dispute evidence. */
  disputeEvidence?: Maybe<ShopifyPaymentsDisputeEvidence>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DisputeEvidenceUpdateUserError>;
};

/** An error that occurs during the execution of `DisputeEvidenceUpdate`. */
export type DisputeEvidenceUpdateUserError = DisplayableError & {
  __typename?: 'DisputeEvidenceUpdateUserError';
  /** The error code. */
  code?: Maybe<DisputeEvidenceUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `DisputeEvidenceUpdateUserError`. */
export enum DisputeEvidenceUpdateUserErrorCode {
  /** Dispute evidence could not be found. */
  DisputeEvidenceNotFound = 'DISPUTE_EVIDENCE_NOT_FOUND',
  /** Evidence already accepted. */
  EvidenceAlreadyAccepted = 'EVIDENCE_ALREADY_ACCEPTED',
  /** Evidence past due date. */
  EvidencePastDueDate = 'EVIDENCE_PAST_DUE_DATE',
  /** The provider is reviewing the dispute. */
  EvidenceUnderReview = 'EVIDENCE_UNDER_REVIEW',
  /** Combined files size is too large. */
  FilesSizeExceededLimit = 'FILES_SIZE_EXCEEDED_LIMIT',
  /** File upload failed. Please try again. */
  FileNotFound = 'FILE_NOT_FOUND',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Individual file size is too large. */
  TooLarge = 'TOO_LARGE'
}

/** The possible statuses of a dispute. */
export enum DisputeStatus {
  Accepted = 'ACCEPTED',
  /**
   * Status previously used by Stripe to indicate that a dispute led to a refund.
   * @deprecated CHARGE_REFUNDED is no longer supported.
   */
  ChargeRefunded = 'CHARGE_REFUNDED',
  Lost = 'LOST',
  NeedsResponse = 'NEEDS_RESPONSE',
  /** A dispute that was prevented from becoming a formal chargeback. */
  Prevented = 'PREVENTED',
  UnderReview = 'UNDER_REVIEW',
  Won = 'WON'
}

/** The possible types for a dispute. */
export enum DisputeType {
  /** The dispute has turned into a chargeback. */
  Chargeback = 'CHARGEBACK',
  /** The dispute is in the inquiry phase. */
  Inquiry = 'INQUIRY'
}

/** A distance, which includes a numeric value and a unit of measurement. */
export type Distance = {
  __typename?: 'Distance';
  /** The unit of measurement for `value`. */
  unit: DistanceUnit;
  /** The distance value using the unit system specified with `unit`. */
  value: Scalars['Float']['output'];
};

/** Units of measurement for distance. */
export enum DistanceUnit {
  /** Metric system unit of distance. */
  Kilometers = 'KILOMETERS',
  /** Imperial system unit of distance. */
  Miles = 'MILES'
}

/** A unique string that represents the address of a Shopify store on the Internet. */
export type Domain = Node & {
  __typename?: 'Domain';
  /** The date and time when the domain was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The host name of the domain. For example, `example.com`. */
  host: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The localization of the domain, if the domain doesn't redirect. */
  localization?: Maybe<DomainLocalization>;
  /** The web presence of the domain. */
  marketWebPresence?: Maybe<MarketWebPresence>;
  /** Whether SSL is enabled. */
  sslEnabled: Scalars['Boolean']['output'];
  /** The URL of the domain (for example, `https://example.com`). */
  url: Scalars['URL']['output'];
};

/** The country and language settings assigned to a domain. */
export type DomainLocalization = {
  __typename?: 'DomainLocalization';
  /** The ISO codes for the domain’s alternate locales. For example, `["en"]`. */
  alternateLocales: Array<Scalars['String']['output']>;
  /** The ISO code for the country assigned to the domain. For example, `"CA"` or "*" for a domain set to "Rest of world". */
  country?: Maybe<Scalars['String']['output']>;
  /** The ISO code for the domain’s default locale. For example, `"en"`. */
  defaultLocale: Scalars['String']['output'];
};

/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrder = CommentEventSubject & HasEvents & HasLocalizationExtensions & HasLocalizedFields & HasMetafields & LegacyInteroperability & Navigable & Node & {
  __typename?: 'DraftOrder';
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  acceptAutomaticDiscounts?: Maybe<Scalars['Boolean']['output']>;
  /** Whether all variant prices have been overridden. */
  allVariantPricesOverridden: Scalars['Boolean']['output'];
  /** Whether discount codes are allowed during checkout of this draft order. */
  allowDiscountCodesInCheckout: Scalars['Boolean']['output'];
  /**
   * The amount due later.
   * When there are payment terms, this is the total price minus the deposit amount (if any).
   * When there are no payment terms, this is 0.
   */
  amountDueLaterSet: MoneyBag;
  /**
   * The amount due now.
   * When there are payment terms this is the value of the deposit (0 by default).
   * When there are no payment terms, this is the total price.
   */
  amountDueNowSet: MoneyBag;
  /** Whether any variant prices have been overridden. */
  anyVariantPricesOverridden: Scalars['Boolean']['output'];
  /** The custom order-level discount applied. */
  appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /** The billing address of the customer. */
  billingAddress?: Maybe<MailingAddress>;
  /** Whether the billing address matches the shipping address. */
  billingAddressMatchesShippingAddress: Scalars['Boolean']['output'];
  /**
   * The date and time when the draft order was converted to a new order,
   * and had it's status changed to **Completed**.
   */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the draft order was created in Shopify. */
  createdAt: Scalars['DateTime']['output'];
  /** The shop currency used for calculation. */
  currencyCode: CurrencyCode;
  /** The custom information added to the draft order on behalf of the customer. */
  customAttributes: Array<Attribute>;
  /** The customer who will be sent an invoice. */
  customer?: Maybe<Customer>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The portion required to be paid at checkout. */
  deposit?: Maybe<DepositConfiguration>;
  /** All discount codes applied. */
  discountCodes: Array<Scalars['String']['output']>;
  /** The email address of the customer, which is used to send notifications. */
  email?: Maybe<Scalars['String']['output']>;
  /** The list of events associated with the draft order. */
  events: EventConnection;
  /** Whether the merchant has added timeline comments to the draft order. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The subject defined for the draft invoice email template. */
  invoiceEmailTemplateSubject: Scalars['String']['output'];
  /** The date and time when the invoice was last emailed to the customer. */
  invoiceSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The link to the checkout, which is sent to the customer in the invoice email. */
  invoiceUrl?: Maybe<Scalars['URL']['output']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The list of the line items in the draft order. */
  lineItems: DraftOrderLineItemConnection;
  /**
   * A subtotal of the line items and corresponding discounts,
   * excluding shipping charges, shipping discounts, taxes, or order discounts.
   */
  lineItemsSubtotalPrice: MoneyBag;
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  localizationExtensions: LocalizationExtensionConnection;
  /** List of localized fields for the resource. */
  localizedFields: LocalizedFieldConnection;
  /**
   * The name of the selected market.
   * @deprecated This field is now incompatible with Markets.
   */
  marketName: Scalars['String']['output'];
  /**
   * The selected country code that determines the pricing.
   * @deprecated This field is now incompatible with Markets.
   */
  marketRegionCountryCode: CountryCode;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The identifier for the draft order, which is unique within the store. For example, _#D1223_. */
  name: Scalars['String']['output'];
  /** The text from an optional note attached to the draft order. */
  note2?: Maybe<Scalars['String']['output']>;
  /** The order that was created from the draft order. */
  order?: Maybe<Order>;
  /** The associated payment terms for this draft order. */
  paymentTerms?: Maybe<PaymentTerms>;
  /** The assigned phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The list of platform discounts applied. */
  platformDiscounts: Array<DraftOrderPlatformDiscount>;
  /** The purchase order number. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The payment currency used for calculation. */
  presentmentCurrencyCode: CurrencyCode;
  /** The purchasing entity. */
  purchasingEntity?: Maybe<PurchasingEntity>;
  /**
   * Whether the draft order is ready and can be completed.
   * Draft orders might have asynchronous operations that can take time to finish.
   */
  ready: Scalars['Boolean']['output'];
  /** The time after which inventory will automatically be restocked. */
  reserveInventoryUntil?: Maybe<Scalars['DateTime']['output']>;
  /** The shipping address of the customer. */
  shippingAddress?: Maybe<MailingAddress>;
  /** The line item containing the shipping information and costs. */
  shippingLine?: Maybe<ShippingLine>;
  /** The status of the draft order. */
  status: DraftOrderStatus;
  /**
   * The subtotal, in shop currency, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  subtotalPrice: Scalars['Money']['output'];
  /** The subtotal, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes. */
  subtotalPriceSet: MoneyBag;
  /**
   * The comma separated list of tags associated with the draft order.
   * Updating `tags` overwrites any existing tags that were previously added to the draft order.
   * To add new tags without overwriting existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd) mutation.
   */
  tags: Array<Scalars['String']['output']>;
  /** Whether the draft order is tax exempt. */
  taxExempt: Scalars['Boolean']['output'];
  /** The list of of taxes lines charged for each line item and shipping line. */
  taxLines: Array<TaxLine>;
  /** Whether the line item prices include taxes. */
  taxesIncluded: Scalars['Boolean']['output'];
  /** Total discounts. */
  totalDiscountsSet: MoneyBag;
  /** Total price of line items, excluding discounts. */
  totalLineItemsPriceSet: MoneyBag;
  /**
   * The total price, in shop currency, includes taxes, shipping charges, and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  totalPrice: Scalars['Money']['output'];
  /** The total price, includes taxes, shipping charges, and discounts. */
  totalPriceSet: MoneyBag;
  /**
   * The sum of individual line item quantities.
   * If the draft order has bundle items, this is the sum containing the quantities of individual items in the bundle.
   */
  totalQuantityOfLineItems: Scalars['Int']['output'];
  /**
   * The total shipping price in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  totalShippingPrice: Scalars['Money']['output'];
  /** The total shipping price. */
  totalShippingPriceSet: MoneyBag;
  /**
   * The total tax in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  totalTax: Scalars['Money']['output'];
  /** The total tax. */
  totalTaxSet: MoneyBag;
  /** The total weight in grams of the draft order. */
  totalWeight: Scalars['UnsignedInt64']['output'];
  /**
   * Fingerprint of the current cart.
   * In order to have bundles work, the fingerprint must be passed to
   * each request as it was previously returned, unmodified.
   */
  transformerFingerprint?: Maybe<Scalars['String']['output']>;
  /**
   * The date and time when the draft order was last changed.
   * The format is YYYY-MM-DD HH:mm:ss. For example, 2016-02-05 17:04:01.
   */
  updatedAt: Scalars['DateTime']['output'];
  /** Whether the draft order will be visible to the customer on the self-serve portal. */
  visibleToCustomer: Scalars['Boolean']['output'];
  /** The list of warnings raised while calculating. */
  warnings: Array<DraftOrderWarning>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderLocalizedFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizedFieldPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The order-level discount applied to a draft order. */
export type DraftOrderAppliedDiscount = {
  __typename?: 'DraftOrderAppliedDiscount';
  /**
   * Amount of the order-level discount that's applied to the draft order in shop currency.
   * @deprecated Use `amountSet` instead.
   */
  amount: Scalars['Money']['output'];
  /** The amount of money discounted, with values shown in both shop currency and presentment currency. */
  amountSet: MoneyBag;
  /**
   * Amount of money discounted.
   * @deprecated Use `amountSet` instead.
   */
  amountV2: MoneyV2;
  /** Description of the order-level discount. */
  description: Scalars['String']['output'];
  /** Name of the order-level discount. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The order level discount amount. If `valueType` is `"percentage"`,
   * then `value` is the percentage discount.
   */
  value: Scalars['Float']['output'];
  /** Type of the order-level discount. */
  valueType: DraftOrderAppliedDiscountType;
};

/** The input fields for applying an order-level discount to a draft order. */
export type DraftOrderAppliedDiscountInput = {
  /** The applied amount of the discount in the specified currency. */
  amountWithCurrency?: InputMaybe<MoneyInput>;
  /** Reason for the discount. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Title of the discount. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The value of the discount.
   * If the type of the discount is fixed amount, then this is a fixed amount in your shop currency.
   * If the type is percentage, then this is the percentage.
   */
  value: Scalars['Float']['input'];
  /** The type of discount. */
  valueType: DraftOrderAppliedDiscountType;
};

/** The valid discount types that can be applied to a draft order. */
export enum DraftOrderAppliedDiscountType {
  /** A fixed amount in the store's currency. */
  FixedAmount = 'FIXED_AMOUNT',
  /** A percentage of the order subtotal. */
  Percentage = 'PERCENTAGE'
}

/** The available delivery options for a draft order. */
export type DraftOrderAvailableDeliveryOptions = {
  __typename?: 'DraftOrderAvailableDeliveryOptions';
  /** The available local delivery rates for the draft order. Requires a customer with a valid shipping address and at least one line item. */
  availableLocalDeliveryRates: Array<DraftOrderShippingRate>;
  /** The available local pickup options for the draft order. Requires at least one line item. */
  availableLocalPickupOptions: Array<PickupInStoreLocation>;
  /** The available shipping rates for the draft order. Requires a customer with a valid shipping address and at least one line item. */
  availableShippingRates: Array<DraftOrderShippingRate>;
  /** Returns information about pagination of local pickup options. */
  pageInfo: PageInfo;
};

/** The input fields used to determine available delivery options for a draft order. */
export type DraftOrderAvailableDeliveryOptionsInput = {
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  acceptAutomaticDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The discount that will be applied to the draft order.
   * A draft order line item can have one discount. A draft order can also have one order-level discount.
   */
  appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  /** Discount codes that will be attempted to be applied to the draft order. If the draft isn't eligible for any given discount code it will be skipped during calculation. */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Product variant line item or custom line item associated to the draft order.
   * Each draft order must include at least one line item.
   */
  lineItems?: InputMaybe<Array<DraftOrderLineItemInput>>;
  /** The selected country code that determines the pricing of the draft order. */
  marketRegionCountryCode?: InputMaybe<CountryCode>;
  /** The purchasing entity for the draft order. */
  purchasingEntity?: InputMaybe<PurchasingEntityInput>;
  /** The mailing address to where the order will be shipped. */
  shippingAddress?: InputMaybe<MailingAddressInput>;
};

/** Return type for `draftOrderBulkAddTags` mutation. */
export type DraftOrderBulkAddTagsPayload = {
  __typename?: 'DraftOrderBulkAddTagsPayload';
  /** The asynchronous job for adding tags to the draft orders. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `draftOrderBulkDelete` mutation. */
export type DraftOrderBulkDeletePayload = {
  __typename?: 'DraftOrderBulkDeletePayload';
  /** The asynchronous job for deleting the draft orders. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `draftOrderBulkRemoveTags` mutation. */
export type DraftOrderBulkRemoveTagsPayload = {
  __typename?: 'DraftOrderBulkRemoveTagsPayload';
  /** The asynchronous job for removing tags from the draft orders. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A warning indicating that a bundle was added to a draft order. */
export type DraftOrderBundleAddedWarning = DraftOrderWarning & {
  __typename?: 'DraftOrderBundleAddedWarning';
  /** The error code. */
  errorCode: Scalars['String']['output'];
  /** The input field that the warning applies to. */
  field: Scalars['String']['output'];
  /** The warning message. */
  message: Scalars['String']['output'];
};

/** Return type for `draftOrderCalculate` mutation. */
export type DraftOrderCalculatePayload = {
  __typename?: 'DraftOrderCalculatePayload';
  /** The calculated properties for a draft order. */
  calculatedDraftOrder?: Maybe<CalculatedDraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `draftOrderComplete` mutation. */
export type DraftOrderCompletePayload = {
  __typename?: 'DraftOrderCompletePayload';
  /** The completed draft order. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple DraftOrders. */
export type DraftOrderConnection = {
  __typename?: 'DraftOrderConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DraftOrderEdge>;
  /** A list of nodes that are contained in DraftOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DraftOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `draftOrderCreateFromOrder` mutation. */
export type DraftOrderCreateFromOrderPayload = {
  __typename?: 'DraftOrderCreateFromOrderPayload';
  /** The created draft order. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `draftOrderCreate` mutation. */
export type DraftOrderCreatePayload = {
  __typename?: 'DraftOrderCreatePayload';
  /** The created draft order. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields to specify the draft order to delete by its ID. */
export type DraftOrderDeleteInput = {
  /** The ID of the draft order to delete. */
  id: Scalars['ID']['input'];
};

/** Return type for `draftOrderDelete` mutation. */
export type DraftOrderDeletePayload = {
  __typename?: 'DraftOrderDeletePayload';
  /** The ID of the deleted draft order. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A warning indicating that a discount cannot be applied to a draft order. */
export type DraftOrderDiscountNotAppliedWarning = DraftOrderWarning & {
  __typename?: 'DraftOrderDiscountNotAppliedWarning';
  /** The code of the discount that can't be applied. */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** The title of the discount that can't be applied. */
  discountTitle?: Maybe<Scalars['String']['output']>;
  /** The error code. */
  errorCode: Scalars['String']['output'];
  /** The input field that the warning applies to. */
  field: Scalars['String']['output'];
  /** The warning message. */
  message: Scalars['String']['output'];
  /**
   * The price rule that can't be applied.
   * @deprecated Use discountCode and discountTitle instead. This field will be removed in 2026-10.
   */
  priceRule?: Maybe<PriceRule>;
};

/** Return type for `draftOrderDuplicate` mutation. */
export type DraftOrderDuplicatePayload = {
  __typename?: 'DraftOrderDuplicatePayload';
  /** The newly duplicated draft order. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one DraftOrder and a cursor during pagination. */
export type DraftOrderEdge = {
  __typename?: 'DraftOrderEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DraftOrderEdge. */
  node: DraftOrder;
};

/** The input fields used to create or update a draft order. */
export type DraftOrderInput = {
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  acceptAutomaticDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether discount codes are allowed during checkout of this draft order. */
  allowDiscountCodesInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The discount that will be applied to the draft order.
   * A draft order line item can have one discount. A draft order can also have one order-level discount.
   */
  appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  /** The mailing address associated with the payment method. */
  billingAddress?: InputMaybe<MailingAddressInput>;
  /** The extra information added to the draft order on behalf of the customer. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /** The input fields configuring the deposit requirement. */
  deposit?: InputMaybe<DepositInput>;
  /**
   * The list of discount codes that will be attempted to be applied to the draft order.
   * If the draft isn't eligible for any given discount code it will be skipped during calculation.
   */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * The list of product variant or custom line item.
   * Each draft order must include at least one line item.
   * Accepts a maximum of 499 line items.
   */
  lineItems?: InputMaybe<Array<DraftOrderLineItemInput>>;
  /** The localized fields attached to the draft order. For example, Tax IDs. */
  localizedFields?: InputMaybe<Array<LocalizedFieldInput>>;
  /** The list of metafields attached to the draft order. An existing metafield can not be used when creating a draft order. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The text of an optional note that a shop owner can attach to the draft order. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The fields used to create payment terms. */
  paymentTerms?: InputMaybe<PaymentTermsInput>;
  /** The customer's phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The purchase order number. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The payment currency of the customer for this draft order. */
  presentmentCurrencyCode?: InputMaybe<CurrencyCode>;
  /** The purchasing entity for the draft order. */
  purchasingEntity?: InputMaybe<PurchasingEntityInput>;
  /** The time after which inventory reservation will expire. */
  reserveInventoryUntil?: InputMaybe<Scalars['DateTime']['input']>;
  /** The unique token identifying the draft order. */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address to where the order will be shipped. */
  shippingAddress?: InputMaybe<MailingAddressInput>;
  /** The shipping line object, which details the shipping method used. */
  shippingLine?: InputMaybe<ShippingLineInput>;
  /**
   * The source channel that the order is attributed to. Set this to the handle of an order attribution definition configured for your sales channel app, such as `youtube` or `channel:amazon-us`.
   * To set up order attribution for your app, follow the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution).
   */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** A comma separated list of tags that have been added to the draft order. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Whether or not taxes are exempt for the draft order.
   * If false, then Shopify will refer to the taxable field for each line item.
   * If a customer is applied to the draft order, then Shopify will use the customer's tax exempt field instead.
   */
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fingerprint to guarantee bundles are handled correctly. */
  transformerFingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use the customer's default address. */
  useCustomerDefaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the draft order will be visible to the customer on the self-serve portal. */
  visibleToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `draftOrderInvoicePreview` mutation. */
export type DraftOrderInvoicePreviewPayload = {
  __typename?: 'DraftOrderInvoicePreviewPayload';
  /** The draft order invoice email rendered as HTML to allow previewing. */
  previewHtml?: Maybe<Scalars['HTML']['output']>;
  /** The subject preview for the draft order invoice email. */
  previewSubject?: Maybe<Scalars['HTML']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `draftOrderInvoiceSend` mutation. */
export type DraftOrderInvoiceSendPayload = {
  __typename?: 'DraftOrderInvoiceSendPayload';
  /** The draft order an invoice email is sent for. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * A line item in a draft order. Line items are either [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects or custom items created manually with specific pricing and attributes.
 *
 * Each line item includes [quantity](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem#field-DraftOrderLineItem.fields.quantity), [pricing](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem#field-DraftOrderLineItem.fields.originalUnitPrice), [discounts](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem#field-DraftOrderLineItem.fields.discountedTotal), [tax information](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem#field-DraftOrderLineItem.fields.taxLines), and [custom attributes](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem#field-DraftOrderLineItem.fields.customAttributes). For [bundle products](https://shopify.dev/docs/apps/build/products/bundles), the line item includes components that define the individual products within the bundle.
 */
export type DraftOrderLineItem = Node & {
  __typename?: 'DraftOrderLineItem';
  /** The custom applied discount. */
  appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The `discountedTotal` divided by `quantity`,
   * equal to the average value of the line item price per unit after discounts are applied.
   * This value doesn't include discounts applied to the entire draft order.
   */
  approximateDiscountedUnitPriceSet: MoneyBag;
  /**
   * The list of bundle components if applicable.
   * @deprecated Use `components` instead.
   */
  bundleComponents: Array<DraftOrderLineItem>;
  /** The components of the draft order line item. */
  components: Array<DraftOrderLineItem>;
  /** Whether the line item is custom (`true`) or contains a product variant (`false`). */
  custom: Scalars['Boolean']['output'];
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /** The list of additional information (metafields) with the associated types. */
  customAttributesV2: Array<TypedAttribute>;
  /**
   * The line item price, in shop currency, after discounts are applied.
   * @deprecated Use `discountedTotalSet` instead.
   */
  discountedTotal: Scalars['Money']['output'];
  /** The total price with discounts applied. */
  discountedTotalSet: MoneyBag;
  /**
   * The `discountedTotal` divided by `quantity`, equal to the value of the discount per unit in the shop currency.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  discountedUnitPrice: Scalars['Money']['output'];
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  fulfillmentService?: Maybe<FulfillmentService>;
  /**
   * The weight of the line item in grams.
   * @deprecated Use `weight` instead.
   */
  grams?: Maybe<Scalars['Int']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image of the product variant. */
  image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The name of the product. */
  name: Scalars['String']['output'];
  /**
   * The total price, in shop currency, excluding discounts, equal to the original unit price multiplied by quantity.
   * @deprecated Use `originalTotalSet` instead.
   */
  originalTotal: Scalars['Money']['output'];
  /** The total price excluding discounts, equal to the original unit price multiplied by quantity. */
  originalTotalSet: MoneyBag;
  /**
   * The price, in shop currency, without any discounts applied.
   * @deprecated Use `originalUnitPriceWithCurrency` instead.
   */
  originalUnitPrice: Scalars['Money']['output'];
  /** The price without any discounts applied. */
  originalUnitPriceSet: MoneyBag;
  /** The original custom line item input price. */
  originalUnitPriceWithCurrency?: Maybe<MoneyV2>;
  /** The price override for the line item. */
  priceOverride?: Maybe<MoneyV2>;
  /** The product for the line item. */
  product?: Maybe<Product>;
  /**
   * The quantity of items. For a bundle item, this is the quantity of bundles,
   * not the quantity of items contained in the bundles themselves.
   */
  quantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The SKU number of the product variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /** A list of tax lines. */
  taxLines: Array<TaxLine>;
  /** Whether the variant is taxable. */
  taxable: Scalars['Boolean']['output'];
  /** The title of the product or variant. This field only applies to custom line items. */
  title: Scalars['String']['output'];
  /**
   * The total discount applied in shop currency.
   * @deprecated Use `totalDiscountSet` instead.
   */
  totalDiscount: Scalars['Money']['output'];
  /** The total discount amount. */
  totalDiscountSet: MoneyBag;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  uuid: Scalars['String']['output'];
  /** The product variant for the line item. */
  variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
  /** The name of the vendor who created the product variant. */
  vendor?: Maybe<Scalars['String']['output']>;
  /** The weight unit and value. */
  weight?: Maybe<Weight>;
};

/** The input fields representing the components of a line item. */
export type DraftOrderLineItemComponentInput = {
  /** The quantity of the component. */
  quantity: Scalars['Int']['input'];
  /**
   * The UUID of the component. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with parent line items.
   */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant corresponding to the component. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** An auto-generated type for paginating through multiple DraftOrderLineItems. */
export type DraftOrderLineItemConnection = {
  __typename?: 'DraftOrderLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<DraftOrderLineItemEdge>;
  /** A list of nodes that are contained in DraftOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<DraftOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one DraftOrderLineItem and a cursor during pagination. */
export type DraftOrderLineItemEdge = {
  __typename?: 'DraftOrderLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of DraftOrderLineItemEdge. */
  node: DraftOrderLineItem;
};

/** The input fields for a line item included in a draft order. */
export type DraftOrderLineItemInput = {
  /** The custom discount to be applied. */
  appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  /** The components of the draft order line item. */
  components?: InputMaybe<Array<DraftOrderLineItemComponentInput>>;
  /** A generic custom attribute using a key value pair. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /**
   * If the line item doesn't already have a price override input, setting `generatePriceOverride` to `true` will
   * create a price override from the current price.
   */
  generatePriceOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The price in presentment currency, without any discounts applied, for a custom line item.
   * If this value is provided, `original_unit_price` will be ignored. This field is ignored when `variantId` is provided.
   * Note: All presentment currencies for a single draft should be the same and match the
   * presentment currency of the draft order.
   */
  originalUnitPriceWithCurrency?: InputMaybe<MoneyInput>;
  /**
   * The price override for the line item. Should be set in presentment currency.
   *
   * This price will be used in place of the product variant's catalog price in this draft order.
   *
   * If the override's presentment currency doesn't match the draft order's presentment currency, it will be
   * converted over to match the draft order's presentment currency. This will occur if the input is defined in a
   * differing currency, or if some other event causes the draft order's currency to change.
   *
   * Price overrides can't be applied to bundle components. If this line item becomes part of a bundle the price
   * override will be removed. In the case of a cart transform, this may mean that a price override is applied to
   * this line item earlier in its lifecycle, and is removed later when the transform occurs.
   */
  priceOverride?: InputMaybe<MoneyInput>;
  /** The line item quantity. */
  quantity: Scalars['Int']['input'];
  /** Whether physical shipping is required for a custom line item. This field is ignored when `variantId` is provided. */
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU number for custom line items only. This field is ignored when `variantId` is provided. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Whether the custom line item is taxable. This field is ignored when `variantId` is provided. */
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Title of the line item. This field is ignored when `variantId` is provided. */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the product variant corresponding to the line item.
   * Must be null for custom line items, otherwise required.
   */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The weight unit and value inputs for custom line items only.
   * This field is ignored when `variantId` is provided.
   */
  weight?: InputMaybe<WeightInput>;
};

/** A warning indicating that the market region country code is not supported with Markets. */
export type DraftOrderMarketRegionCountryCodeNotSupportedWarning = DraftOrderWarning & {
  __typename?: 'DraftOrderMarketRegionCountryCodeNotSupportedWarning';
  /** The error code. */
  errorCode: Scalars['String']['output'];
  /** The input field that the warning applies to. */
  field: Scalars['String']['output'];
  /** The warning message. */
  message: Scalars['String']['output'];
};

/** The platform discounts applied to the draft order. */
export type DraftOrderPlatformDiscount = {
  __typename?: 'DraftOrderPlatformDiscount';
  /** Price reduction allocations across the draft order's lines. */
  allocations: Array<DraftOrderPlatformDiscountAllocation>;
  /** Whether the discount is an automatic discount. */
  automaticDiscount: Scalars['Boolean']['output'];
  /** Whether the discount is a buy x get y discount. */
  bxgyDiscount: Scalars['Boolean']['output'];
  /** If a code-based discount, the code used to add the discount. */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * The discount class.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: DiscountClass;
  /** The discount classes. */
  discountClasses: Array<DiscountClass>;
  /** The discount node for the platform discount. */
  discountNode?: Maybe<DiscountNode>;
  /** The ID of the discount. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the discount is line, order or shipping level. */
  presentationLevel: Scalars['String']['output'];
  /** The short summary of the discount. */
  shortSummary: Scalars['String']['output'];
  /** The summary of the discount. */
  summary: Scalars['String']['output'];
  /** The name of the discount. */
  title: Scalars['String']['output'];
  /** The discount total amount in shop currency. */
  totalAmount: MoneyV2;
  /** The amount of money discounted, with values shown in both shop currency and presentment currency. */
  totalAmountPriceSet: MoneyBag;
};

/** Price reduction allocations across the draft order's lines. */
export type DraftOrderPlatformDiscountAllocation = {
  __typename?: 'DraftOrderPlatformDiscountAllocation';
  /** The ID of the allocation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The quantity of the target being discounted. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Amount of the discount allocated to the target. */
  reductionAmount: MoneyV2;
  /** Amount of the discount allocated to the target in both shop currency and presentment currency. */
  reductionAmountSet: MoneyBag;
  /** The element of the draft being discounted. */
  target?: Maybe<DraftOrderPlatformDiscountAllocationTarget>;
};

/** The element of the draft being discounted. */
export type DraftOrderPlatformDiscountAllocationTarget = CalculatedDraftOrderLineItem | DraftOrderLineItem | ShippingLine;

/** A shipping rate is an additional cost added to the cost of the products that were ordered. */
export type DraftOrderShippingRate = {
  __typename?: 'DraftOrderShippingRate';
  /** The code of the shipping rate. */
  code: Scalars['String']['output'];
  /** Unique identifier for this shipping rate. */
  handle: Scalars['String']['output'];
  /** The cost associated with the shipping rate. */
  price: MoneyV2;
  /** The source of the shipping rate. */
  source: Scalars['String']['output'];
  /** The name of the shipping rate. */
  title: Scalars['String']['output'];
};

/** The set of valid sort keys for the DraftOrder query. */
export enum DraftOrderSortKeys {
  /** Sort by the `customer_name` value. */
  CustomerName = 'CUSTOMER_NAME',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `number` value. */
  Number = 'NUMBER',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `status` value. */
  Status = 'STATUS',
  /** Sort by the `total_price` value. */
  TotalPrice = 'TOTAL_PRICE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The valid statuses for a draft order. */
export enum DraftOrderStatus {
  /** The draft order has been paid. */
  Completed = 'COMPLETED',
  /** An invoice for the draft order has been sent to the customer. */
  InvoiceSent = 'INVOICE_SENT',
  /** The draft order is open. It has not been paid, and an invoice hasn't been sent. */
  Open = 'OPEN'
}

/** Represents a draft order tag. */
export type DraftOrderTag = Node & {
  __typename?: 'DraftOrderTag';
  /** Handle of draft order tag. */
  handle: Scalars['String']['output'];
  /** ID of draft order tag. */
  id: Scalars['ID']['output'];
  /** Title of draft order tag. */
  title: Scalars['String']['output'];
};

/** Return type for `draftOrderUpdate` mutation. */
export type DraftOrderUpdatePayload = {
  __typename?: 'DraftOrderUpdatePayload';
  /** The updated draft order. */
  draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A warning that is displayed to the merchant when a change is made to a draft order. */
export type DraftOrderWarning = {
  /** The error code. */
  errorCode: Scalars['String']['output'];
  /** The input field that the warning applies to. */
  field: Scalars['String']['output'];
  /** The warning message. */
  message: Scalars['String']['output'];
};

/** The duty details for a line item. */
export type Duty = Node & {
  __typename?: 'Duty';
  /** The ISO 3166-1 alpha-2 country code of the country of origin used in calculating the duty. */
  countryCodeOfOrigin?: Maybe<CountryCode>;
  /** The harmonized system code of the item used in calculating the duty. */
  harmonizedSystemCode?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The amount of the duty. */
  price: MoneyBag;
  /** A list of taxes charged on the duty. */
  taxLines: Array<TaxLine>;
};

/** A sale associated with a duty charge. */
export type DutySale = Sale & {
  __typename?: 'DutySale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The duty for the associated sale. */
  duty: Duty;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** The attribute editable information. */
export type EditableProperty = {
  __typename?: 'EditableProperty';
  /** Whether the attribute is locked for editing. */
  locked: Scalars['Boolean']['output'];
  /** The reason the attribute is locked for editing. */
  reason?: Maybe<Scalars['FormattedString']['output']>;
};

/** The input fields for an email. */
export type EmailInput = {
  /** Specifies any bcc recipients for the email. */
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specifies the email body. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Specifies a custom message to include in the email. */
  customMessage?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the email sender. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the email subject. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the email recipient. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** The shop's entitlements. */
export type EntitlementsType = {
  __typename?: 'EntitlementsType';
  /** The shop's B2B entitlements. */
  b2b: B2BType;
  /** Represents the markets for the shop. */
  markets: MarketsType;
};

/** An error that occurs during the execution of a server pixel mutation. */
export type ErrorsServerPixelUserError = DisplayableError & {
  __typename?: 'ErrorsServerPixelUserError';
  /** The error code. */
  code?: Maybe<ErrorsServerPixelUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ErrorsServerPixelUserError`. */
export enum ErrorsServerPixelUserErrorCode {
  /** A server pixel already exists for this app and shop. Only one server pixel can exist for any app and shop combination. */
  AlreadyExists = 'ALREADY_EXISTS',
  /** Server Pixel must be configured with a valid AWS Event Bridge or GCP pub/sub endpoint address to be connected. */
  NeedsConfigurationToConnect = 'NEEDS_CONFIGURATION_TO_CONNECT',
  /** A server pixel doesn't exist for this app and shop. */
  NotFound = 'NOT_FOUND',
  /** PubSubProject and PubSubTopic values resulted in an address that is not a valid GCP pub/sub format.Address format should be pubsub://project:topic. */
  PubSubError = 'PUB_SUB_ERROR'
}

/** An error that occurs during the execution of a web pixel mutation. */
export type ErrorsWebPixelUserError = DisplayableError & {
  __typename?: 'ErrorsWebPixelUserError';
  /** The error code. */
  code?: Maybe<ErrorsWebPixelUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ErrorsWebPixelUserError`. */
export enum ErrorsWebPixelUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The provided settings is not a valid JSON. */
  InvalidConfigurationJson = 'INVALID_CONFIGURATION_JSON',
  /** The provided runtime context is invalid. */
  InvalidRuntimeContext = 'INVALID_RUNTIME_CONTEXT',
  /** The provided settings does not match the expected settings definition on the app. */
  InvalidSettings = 'INVALID_SETTINGS',
  /** The settings definition of the web pixel extension is in an invalid state on the app. */
  InvalidSettingsDefinition = 'INVALID_SETTINGS_DEFINITION',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** No extension found. */
  NoExtension = 'NO_EXTENSION',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /**
   * An error occurred and the web pixel couldnt be deleted.
   * @deprecated `UNABLE_TO_DELETE` is deprecated. Use `UNEXPECTED_ERROR` instead.
   */
  UnableToDelete = 'UNABLE_TO_DELETE',
  /** An unexpected error occurred. */
  UnexpectedError = 'UNEXPECTED_ERROR'
}

/**
 * Events chronicle resource activities such as the creation of an article, the fulfillment of an order, or the
 * addition of a product.
 */
export type Event = {
  /** The action that occured. */
  action: Scalars['String']['output'];
  /** The name of the app that created the event. */
  appTitle?: Maybe<Scalars['String']['output']>;
  /** Whether the event was created by an app. */
  attributeToApp: Scalars['Boolean']['output'];
  /** Whether the event was caused by an admin user. */
  attributeToUser: Scalars['Boolean']['output'];
  /** The date and time when the event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the event is critical. */
  criticalAlert: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Human readable text that describes the event. */
  message: Scalars['FormattedString']['output'];
};

/** Return type for `eventBridgeServerPixelUpdate` mutation. */
export type EventBridgeServerPixelUpdatePayload = {
  __typename?: 'EventBridgeServerPixelUpdatePayload';
  /** The server pixel as configured by the mutation. */
  serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsServerPixelUserError>;
};

/** Return type for `eventBridgeWebhookSubscriptionCreate` mutation. */
export type EventBridgeWebhookSubscriptionCreatePayload = {
  __typename?: 'EventBridgeWebhookSubscriptionCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
  /** The webhook subscription that was created. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** The input fields for an EventBridge webhook subscription. */
export type EventBridgeWebhookSubscriptionInput = {
  /** The ARN of the EventBridge partner event source. */
  arn?: InputMaybe<Scalars['ARN']['input']>;
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The format in which the webhook subscription should send the data. */
  format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. Only the fields specified will be included in the webhook payload. If null, then all fields will be included. Learn more about [modifying webhook payloads](https://shopify.dev/docs/apps/build/webhooks/customize/modify_payloads). */
  includeFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  metafieldNamespaces?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of identifiers specifying metafields to include in the webhook payload. */
  metafields?: InputMaybe<Array<HasMetafieldsMetafieldIdentifierInput>>;
  /** A human-readable name for the webhook subscription. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `eventBridgeWebhookSubscriptionUpdate` mutation. */
export type EventBridgeWebhookSubscriptionUpdatePayload = {
  __typename?: 'EventBridgeWebhookSubscriptionUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
  /** The webhook subscription that was updated. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An auto-generated type for paginating through multiple Events. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<EventEdge>;
  /** A list of nodes that are contained in EventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Event>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one Event and a cursor during pagination. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of EventEdge. */
  node: Event;
};

/** The set of valid sort keys for the Event query. */
export enum EventSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The type of the resource that generated the event. */
export enum EventSubjectType {
  /** A Article resource generated the event. */
  Article = 'ARTICLE',
  /** A Blog resource generated the event. */
  Blog = 'BLOG',
  /** A Collection resource generated the event. */
  Collection = 'COLLECTION',
  /** A Comment resource generated the event. */
  Comment = 'COMMENT',
  /** A Company resource generated the event. */
  Company = 'COMPANY',
  /** A CompanyLocation resource generated the event. */
  CompanyLocation = 'COMPANY_LOCATION',
  /** A Customer resource generated the event. */
  Customer = 'CUSTOMER',
  /** A DiscountAutomaticBxgy resource generated the event. */
  DiscountAutomaticBxgy = 'DISCOUNT_AUTOMATIC_BXGY',
  /** A DiscountAutomaticNode resource generated the event. */
  DiscountAutomaticNode = 'DISCOUNT_AUTOMATIC_NODE',
  /** A DiscountCodeNode resource generated the event. */
  DiscountCodeNode = 'DISCOUNT_CODE_NODE',
  /** A DiscountNode resource generated the event. */
  DiscountNode = 'DISCOUNT_NODE',
  /** A DraftOrder resource generated the event. */
  DraftOrder = 'DRAFT_ORDER',
  /** A InventoryTransfer resource generated the event. */
  InventoryTransfer = 'INVENTORY_TRANSFER',
  /** A Order resource generated the event. */
  Order = 'ORDER',
  /** A Page resource generated the event. */
  Page = 'PAGE',
  /** A PriceRule resource generated the event. */
  PriceRule = 'PRICE_RULE',
  /** A Product resource generated the event. */
  Product = 'PRODUCT',
  /** A ProductVariant resource generated the event. */
  ProductVariant = 'PRODUCT_VARIANT',
  /**
   * Subject type is not available. This usually means that the subject isn't available in the current
   *         version of the API, using a newer API version may resolve this.
   */
  Unknown = 'UNKNOWN'
}

/** An item for exchange. */
export type ExchangeLineItem = Node & {
  __typename?: 'ExchangeLineItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The order line item for the exchange. If the exchange line has been processed multiple times, this will be the first associated line item and won't reflect all processed values.
   * @deprecated Use `lineItems` instead.
   */
  lineItem?: Maybe<LineItem>;
  /** The order line items for the exchange. */
  lineItems?: Maybe<Array<LineItem>>;
  /** The quantity of the exchange item that can be processed. */
  processableQuantity: Scalars['Int']['output'];
  /** The quantity of the exchange item that have been processed. */
  processedQuantity: Scalars['Int']['output'];
  /** The number of units ordered, including refunded and removed units. */
  quantity: Scalars['Int']['output'];
  /** The quantity of the exchange item that haven't been processed. */
  unprocessedQuantity: Scalars['Int']['output'];
  /** The ID of the variant at time of return creation. */
  variantId?: Maybe<Scalars['ID']['output']>;
};

/** The input fields for an applied discount on a calculated exchange line item. */
export type ExchangeLineItemAppliedDiscountInput = {
  /** The description of the discount. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The value of the discount as a fixed amount or a percentage. */
  value: ExchangeLineItemAppliedDiscountValueInput;
};

/**
 * The input value for an applied discount on a calculated exchange line item.
 * Can either specify the value as a fixed amount or a percentage.
 */
export type ExchangeLineItemAppliedDiscountValueInput = {
  /** The value of the discount as a fixed amount. */
  amount?: InputMaybe<MoneyInput>;
  /** The value of the discount as a percentage. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** An auto-generated type for paginating through multiple ExchangeLineItems. */
export type ExchangeLineItemConnection = {
  __typename?: 'ExchangeLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ExchangeLineItemEdge>;
  /** A list of nodes that are contained in ExchangeLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ExchangeLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ExchangeLineItem and a cursor during pagination. */
export type ExchangeLineItemEdge = {
  __typename?: 'ExchangeLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ExchangeLineItemEdge. */
  node: ExchangeLineItem;
};

/** The input fields for new line items to be added to the order as part of an exchange. */
export type ExchangeLineItemInput = {
  /** The discount to be applied to the exchange line item. */
  appliedDiscount?: InputMaybe<ExchangeLineItemAppliedDiscountInput>;
  /** The gift card codes associated with the physical gift cards. */
  giftCardCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The quantity of the item to be added. */
  quantity: Scalars['Int']['input'];
  /** The ID of the product variant to be added to the order as part of an exchange. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for removing an exchange line item from a return. */
export type ExchangeLineItemRemoveFromReturnInput = {
  /** The ID of the exchange line item to remove. */
  exchangeLineItemId: Scalars['ID']['input'];
  /** The quantity of the associated exchange line item to be removed. */
  quantity: Scalars['Int']['input'];
};

/** An exchange where existing items on an order are returned and new items are added to the order. */
export type ExchangeV2 = Node & {
  __typename?: 'ExchangeV2';
  /** The details of the new items in the exchange. */
  additions: ExchangeV2Additions;
  /** The date and time when the exchange was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the exchange was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location where the exchange happened. */
  location?: Maybe<Location>;
  /** Mirrored from Admin Exchanges. */
  mirrored: Scalars['Boolean']['output'];
  /** The text of an optional note that a shop owner can attach to the exchange. */
  note?: Maybe<Scalars['String']['output']>;
  /** The refunds processed during the exchange. */
  refunds: Array<Refund>;
  /** The details of the returned items in the exchange. */
  returns: ExchangeV2Returns;
  /** The staff member associated with the exchange. */
  staffMember?: Maybe<StaffMember>;
  /** The amount of money that was paid or refunded as part of the exchange. */
  totalAmountProcessedSet: MoneyBag;
  /** The difference in values of the items that were exchanged. */
  totalPriceSet: MoneyBag;
  /** The order transactions related to the exchange. */
  transactions: Array<OrderTransaction>;
};

/** New items associated to the exchange. */
export type ExchangeV2Additions = {
  __typename?: 'ExchangeV2Additions';
  /** The list of new items for the exchange. */
  lineItems: Array<ExchangeV2LineItem>;
  /** The subtotal of the items being added, including discounts. */
  subtotalPriceSet: MoneyBag;
  /** The summary of all taxes of the items being added. */
  taxLines: Array<TaxLine>;
  /** The total price of the items being added, including discounts and taxes. */
  totalPriceSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple ExchangeV2s. */
export type ExchangeV2Connection = {
  __typename?: 'ExchangeV2Connection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ExchangeV2Edge>;
  /** A list of nodes that are contained in ExchangeV2Edge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ExchangeV2>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ExchangeV2 and a cursor during pagination. */
export type ExchangeV2Edge = {
  __typename?: 'ExchangeV2Edge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ExchangeV2Edge. */
  node: ExchangeV2;
};

/** Contains information about an item in the exchange. */
export type ExchangeV2LineItem = {
  __typename?: 'ExchangeV2LineItem';
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /** The total line price, in shop and presentment currencies, after discounts are applied. */
  discountedTotalSet: MoneyBag;
  /**
   * The price, in shop and presentment currencies,
   * of a single variant unit after line item discounts are applied.
   */
  discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  fulfillmentService?: Maybe<FulfillmentService>;
  /** Indiciates if this line item is a gift card. */
  giftCard: Scalars['Boolean']['output'];
  /** The gift cards associated with the line item. */
  giftCards: Array<GiftCard>;
  /** Whether the line item represents the purchase of a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The line item associated with this object. */
  lineItem?: Maybe<LineItem>;
  /** The name of the product. */
  name: Scalars['String']['output'];
  /** The total price, in shop and presentment currencies, before discounts are applied. */
  originalTotalSet: MoneyBag;
  /**
   * The price, in shop and presentment currencies,
   * of a single variant unit before line item discounts are applied.
   */
  originalUnitPriceSet: MoneyBag;
  /** The number of products that were purchased. */
  quantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The SKU number of the product variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The TaxLine object connected to this line item. */
  taxLines: Array<TaxLine>;
  /** Whether the variant is taxable. */
  taxable: Scalars['Boolean']['output'];
  /** The title of the product or variant. This field only applies to custom line items. */
  title: Scalars['String']['output'];
  /** The product variant of the line item. */
  variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
  /** The name of the vendor who created the product variant. */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Return items associated to the exchange. */
export type ExchangeV2Returns = {
  __typename?: 'ExchangeV2Returns';
  /** The list of return items for the exchange. */
  lineItems: Array<ExchangeV2LineItem>;
  /** The amount of the order-level discount for the items and shipping being returned, which doesn't contain any line item discounts. */
  orderDiscountAmountSet: MoneyBag;
  /** The amount of money to be refunded for shipping. */
  shippingRefundAmountSet: MoneyBag;
  /** The subtotal of the items being returned. */
  subtotalPriceSet: MoneyBag;
  /** The summary of all taxes of the items being returned. */
  taxLines: Array<TaxLine>;
  /** The amount of money to be refunded for tip. */
  tipRefundAmountSet: MoneyBag;
  /** The total value of the items being returned. */
  totalPriceSet: MoneyBag;
};

/** Represents a video hosted outside of Shopify. */
export type ExternalVideo = File & Media & Node & {
  __typename?: 'ExternalVideo';
  /** A word or phrase to describe the contents or the function of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The embed URL of the video for the respective host. */
  embedUrl: Scalars['URL']['output'];
  /**
   * The URL.
   * @deprecated Use `originUrl` instead.
   */
  embeddedUrl: Scalars['URL']['output'];
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** The host of the external video. */
  host: MediaHost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  mediaErrors: Array<MediaError>;
  /** The warnings attached to the media. */
  mediaWarnings: Array<MediaWarning>;
  /** The origin URL of the video on the respective host. */
  originUrl: Scalars['URL']['output'];
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** Current status of the media. */
  status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Requirements that must be met before an app can be installed. */
export type FailedRequirement = {
  __typename?: 'FailedRequirement';
  /** Action to be taken to resolve a failed requirement, including URL link. */
  action?: Maybe<NavigationItem>;
  /**
   * A concise set of copy strings to be displayed to merchants, to guide them in resolving problems your app
   * encounters when trying to make use of their Shop and its resources.
   */
  message: Scalars['String']['output'];
};

/** A additional cost, charged by the merchant, on an order. Examples include return shipping fees and restocking fees. */
export type Fee = {
  /** The unique ID for the Fee. */
  id: Scalars['ID']['output'];
};

/** A sale associated with a fee. */
export type FeeSale = Sale & {
  __typename?: 'FeeSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The fee associated with the sale. It can be null if the fee was deleted. */
  fee?: Maybe<Fee>;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** A file interface. */
export type File = {
  /** A word or phrase to describe the contents or the function of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Return type for `fileAcknowledgeUpdateFailed` mutation. */
export type FileAcknowledgeUpdateFailedPayload = {
  __typename?: 'FileAcknowledgeUpdateFailedPayload';
  /** The updated file(s). */
  files?: Maybe<Array<File>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FilesUserError>;
};

/** An auto-generated type for paginating through multiple Files. */
export type FileConnection = {
  __typename?: 'FileConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FileEdge>;
  /** A list of nodes that are contained in FileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<File>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The possible content types for a file object. */
export enum FileContentType {
  /** An externally hosted video. */
  ExternalVideo = 'EXTERNAL_VIDEO',
  /** A Shopify-hosted generic file. */
  File = 'FILE',
  /** A Shopify-hosted image. */
  Image = 'IMAGE',
  /** A Shopify-hosted 3D model. */
  Model_3D = 'MODEL_3D',
  /** A Shopify-hosted video file. It's recommended to use this type for all video files. */
  Video = 'VIDEO'
}

/** The input fields that are required to create a file object. */
export type FileCreateInput = {
  /** The alt text description of the file for screen readers and accessibility. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The file content type. If omitted, then Shopify will attempt to determine the content type during file processing. */
  contentType?: InputMaybe<FileContentType>;
  /** How to handle if filename is already in use. */
  duplicateResolutionMode?: InputMaybe<FileCreateInputDuplicateResolutionMode>;
  /**
   * The name of the file. If provided, then the file is created with the specified filename.
   * If not provided, then the filename from the `originalSource` is used.
   */
  filename?: InputMaybe<Scalars['String']['input']>;
  /**
   * The source URL of the file. An external URL can be used for images, generic files, or external videos.
   * Videos and 3D models require a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  originalSource: Scalars['String']['input'];
};

/** The input fields for handling if filename is already in use. */
export enum FileCreateInputDuplicateResolutionMode {
  /** Append a UUID if filename is already in use. */
  AppendUuid = 'APPEND_UUID',
  /** Raise an error if filename is already in use. */
  RaiseError = 'RAISE_ERROR',
  /** Replace the existing file if filename is already in use. */
  Replace = 'REPLACE'
}

/** Return type for `fileCreate` mutation. */
export type FileCreatePayload = {
  __typename?: 'FileCreatePayload';
  /** The newly created files. */
  files?: Maybe<Array<File>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FilesUserError>;
};

/** Return type for `fileDelete` mutation. */
export type FileDeletePayload = {
  __typename?: 'FileDeletePayload';
  /** The IDs of the deleted files. */
  deletedFileIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FilesUserError>;
};

/** An auto-generated type which holds one File and a cursor during pagination. */
export type FileEdge = {
  __typename?: 'FileEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FileEdge. */
  node: File;
};

/**
 * A file error. This typically occurs when there is an issue with the file itself causing it to fail validation.
 * Check the file before attempting to upload again.
 */
export type FileError = {
  __typename?: 'FileError';
  /** Code representing the type of error. */
  code: FileErrorCode;
  /** Additional details regarding the error. */
  details?: Maybe<Scalars['String']['output']>;
  /** Translated error message. */
  message: Scalars['String']['output'];
};

/** The error types for a file. */
export enum FileErrorCode {
  /** File could not be created because a file with the same name already exists. */
  DuplicateFilenameError = 'DUPLICATE_FILENAME_ERROR',
  /** File could not be created because embed permissions are disabled for this video. */
  ExternalVideoEmbedDisabled = 'EXTERNAL_VIDEO_EMBED_DISABLED',
  /** File could not be created because video is either not found or still transcoding. */
  ExternalVideoEmbedNotFoundOrTranscoding = 'EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING',
  /** File could not be created because the external video has an invalid aspect ratio. */
  ExternalVideoInvalidAspectRatio = 'EXTERNAL_VIDEO_INVALID_ASPECT_RATIO',
  /** File could not be created because the external video could not be found. */
  ExternalVideoNotFound = 'EXTERNAL_VIDEO_NOT_FOUND',
  /** File could not be created because the external video is not listed or is private. */
  ExternalVideoUnlisted = 'EXTERNAL_VIDEO_UNLISTED',
  /** File could not be created because the cumulative file storage limit would be exceeded. */
  FileStorageLimitExceeded = 'FILE_STORAGE_LIMIT_EXCEEDED',
  /** File could not be processed because the source could not be downloaded. */
  GenericFileDownloadFailure = 'GENERIC_FILE_DOWNLOAD_FAILURE',
  /** File could not be created because the size is too large. */
  GenericFileInvalidSize = 'GENERIC_FILE_INVALID_SIZE',
  /** File could not be processed because the image could not be downloaded. */
  ImageDownloadFailure = 'IMAGE_DOWNLOAD_FAILURE',
  /** File could not be processed because the image could not be processed. */
  ImageProcessingFailure = 'IMAGE_PROCESSING_FAILURE',
  /** File could not be created because the image has an invalid aspect ratio. */
  InvalidImageAspectRatio = 'INVALID_IMAGE_ASPECT_RATIO',
  /** File could not be created because the image size is too large. */
  InvalidImageFileSize = 'INVALID_IMAGE_FILE_SIZE',
  /** File could not be created because the image's resolution exceeds the max limit. */
  InvalidImageResolution = 'INVALID_IMAGE_RESOLUTION',
  /** File could not be processed because the signed URL was invalid. */
  InvalidSignedUrl = 'INVALID_SIGNED_URL',
  /** File timed out because it is currently being modified by another operation. */
  MediaTimeoutError = 'MEDIA_TIMEOUT_ERROR',
  /** File could not be created because the model file failed processing. */
  Model3DGlbOutputCreationError = 'MODEL3D_GLB_OUTPUT_CREATION_ERROR',
  /** File could not be created because the model can't be converted to USDZ format. */
  Model3DGlbToUsdzConversionError = 'MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR',
  /** File could not be created because the model file failed processing. */
  Model3DProcessingFailure = 'MODEL3D_PROCESSING_FAILURE',
  /** File could not be created because the model's thumbnail generation failed. */
  Model3DThumbnailGenerationError = 'MODEL3D_THUMBNAIL_GENERATION_ERROR',
  /** There was an issue while trying to generate a new thumbnail. */
  Model3DThumbnailRegenerationError = 'MODEL3D_THUMBNAIL_REGENERATION_ERROR',
  /** Model failed validation. */
  Model3DValidationError = 'MODEL3D_VALIDATION_ERROR',
  /** File error has occurred for an unknown reason. */
  Unknown = 'UNKNOWN',
  /** File could not be created because the image is an unsupported file type. */
  UnsupportedImageFileType = 'UNSUPPORTED_IMAGE_FILE_TYPE',
  /** File could not be created because it has an invalid file type. */
  VideoInvalidFiletypeError = 'VIDEO_INVALID_FILETYPE_ERROR',
  /** File could not be created because it does not meet the maximum duration requirement. */
  VideoMaxDurationError = 'VIDEO_MAX_DURATION_ERROR',
  /** File could not be created because it does not meet the maximum height requirement. */
  VideoMaxHeightError = 'VIDEO_MAX_HEIGHT_ERROR',
  /** File could not be created because it does not meet the maximum width requirement. */
  VideoMaxWidthError = 'VIDEO_MAX_WIDTH_ERROR',
  /** File could not be created because the metadata could not be read. */
  VideoMetadataReadError = 'VIDEO_METADATA_READ_ERROR',
  /** File could not be created because it does not meet the minimum duration requirement. */
  VideoMinDurationError = 'VIDEO_MIN_DURATION_ERROR',
  /** File could not be created because it does not meet the minimum height requirement. */
  VideoMinHeightError = 'VIDEO_MIN_HEIGHT_ERROR',
  /** File could not be created because it does not meet the minimum width requirement. */
  VideoMinWidthError = 'VIDEO_MIN_WIDTH_ERROR',
  /** Video failed validation. */
  VideoValidationError = 'VIDEO_VALIDATION_ERROR'
}

/** The input fields required to create or update a file object. */
export type FileSetInput = {
  /** The alt text description of the file for screen readers and accessibility. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The file content type. If omitted, then Shopify will attempt to determine the content type during file processing. */
  contentType?: InputMaybe<FileContentType>;
  /** How to handle if filename is already in use. */
  duplicateResolutionMode?: InputMaybe<FileCreateInputDuplicateResolutionMode>;
  /**
   * The name of the file. If provided, then the file is created with the specified filename.
   * If not provided, then the filename from the `originalSource` is used.
   */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The ID of an existing file. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The source URL of the file. An external URL can be used for images, generic files, or external videos.
   * Videos and 3D models require a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  originalSource?: InputMaybe<Scalars['String']['input']>;
};

/** The set of valid sort keys for the File query. */
export enum FileSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `filename` value. */
  Filename = 'FILENAME',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `original_upload_size` value. */
  OriginalUploadSize = 'ORIGINAL_UPLOAD_SIZE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The possible statuses for a file object. */
export enum FileStatus {
  /** File processing has failed. */
  Failed = 'FAILED',
  /** File is being processed. */
  Processing = 'PROCESSING',
  /** File is ready to be displayed. */
  Ready = 'READY',
  /** File has been uploaded but hasn't been processed. */
  Uploaded = 'UPLOADED'
}

/** The input fields that are required to update a file object. */
export type FileUpdateInput = {
  /** The alt text description of the file for screen readers and accessibility. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The name of the file including its extension. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the file to be updated. */
  id: Scalars['ID']['input'];
  /**
   * The source from which to update a media image or generic file.
   * This can be an external URL or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  originalSource?: InputMaybe<Scalars['String']['input']>;
  /**
   * The source from which to update the media preview image.
   * May be an external URL or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  previewImageSource?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the references to add to the file. Currently only accepts product IDs. */
  referencesToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the references to remove from the file. Currently only accepts product IDs. */
  referencesToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `fileUpdate` mutation. */
export type FileUpdatePayload = {
  __typename?: 'FileUpdatePayload';
  /** The list of updated files. */
  files?: Maybe<Array<File>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FilesUserError>;
};

/** Possible error codes that can be returned by `FilesUserError`. */
export enum FilesErrorCode {
  /** The alt value exceeds the maximum limit of 512 characters. */
  AltValueLimitExceeded = 'ALT_VALUE_LIMIT_EXCEEDED',
  /** The search term must not be blank. */
  BlankSearch = 'BLANK_SEARCH',
  /** The provided filename already exists. */
  FilenameAlreadyExists = 'FILENAME_ALREADY_EXISTS',
  /** File does not exist. */
  FileDoesNotExist = 'FILE_DOES_NOT_EXIST',
  /** File has a pending operation. */
  FileLocked = 'FILE_LOCKED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Duplicate resolution mode is not supported for this file type. */
  InvalidDuplicateModeForType = 'INVALID_DUPLICATE_MODE_FOR_TYPE',
  /** Invalid duplicate resolution mode provided. */
  InvalidDuplicateResolutionMode = 'INVALID_DUPLICATE_RESOLUTION_MODE',
  /** File cannot be updated in a failed state. */
  InvalidFailedMediaState = 'INVALID_FAILED_MEDIA_STATE',
  /** The provided filename is invalid. */
  InvalidFilename = 'INVALID_FILENAME',
  /** Invalid filename extension. */
  InvalidFilenameExtension = 'INVALID_FILENAME_EXTENSION',
  /** Invalid image source url value provided. */
  InvalidImageSourceUrl = 'INVALID_IMAGE_SOURCE_URL',
  /** Search query isn't supported. */
  InvalidQuery = 'INVALID_QUERY',
  /** Media cannot be modified. It is currently being modified by another operation. */
  MediaCannotBeModified = 'MEDIA_CANNOT_BE_MODIFIED',
  /** Cannot create file with custom filename which does not match original source extension. */
  MismatchedFilenameAndOriginalSource = 'MISMATCHED_FILENAME_AND_ORIGINAL_SOURCE',
  /** At least one argument is required. */
  MissingArguments = 'MISSING_ARGUMENTS',
  /** Duplicate resolution mode REPLACE cannot be used without specifying filename. */
  MissingFilenameForDuplicateModeReplace = 'MISSING_FILENAME_FOR_DUPLICATE_MODE_REPLACE',
  /** Exceeded the limit of non-image media per shop. */
  NonImageMediaPerShopLimitExceeded = 'NON_IMAGE_MEDIA_PER_SHOP_LIMIT_EXCEEDED',
  /** The file is not in the READY state. */
  NonReadyState = 'NON_READY_STATE',
  /** Exceeded the limit of media per product. */
  ProductMediaLimitExceeded = 'PRODUCT_MEDIA_LIMIT_EXCEEDED',
  /** One or more associated products are suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** The target resource does not exist. */
  ReferenceTargetDoesNotExist = 'REFERENCE_TARGET_DOES_NOT_EXIST',
  /** Specify one argument: search, IDs, or deleteAll. */
  TooManyArguments = 'TOO_MANY_ARGUMENTS',
  /** Cannot add more than 10000 references to a file. */
  TooManyFileReference = 'TOO_MANY_FILE_REFERENCE',
  /** The file type is not supported. */
  UnacceptableAsset = 'UNACCEPTABLE_ASSET',
  /** The file is not supported on trial accounts. Select a plan to upload this file. */
  UnacceptableTrialAsset = 'UNACCEPTABLE_TRIAL_ASSET',
  /** The file is not supported on trial accounts that have not validated their email. Either select a plan or verify the shop owner email to upload this file. */
  UnacceptableUnverifiedTrialAsset = 'UNACCEPTABLE_UNVERIFIED_TRIAL_ASSET',
  /** The file type is not supported for referencing. */
  UnsupportedFileReference = 'UNSUPPORTED_FILE_REFERENCE',
  /** Filename update is only supported on Image and GenericFile. */
  UnsupportedMediaTypeForFilenameUpdate = 'UNSUPPORTED_MEDIA_TYPE_FOR_FILENAME_UPDATE'
}

/** An error that happens during the execution of a Files API query or mutation. */
export type FilesUserError = DisplayableError & {
  __typename?: 'FilesUserError';
  /** The error code. */
  code?: Maybe<FilesErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** A filter option is one possible value in a search filter. */
export type FilterOption = {
  __typename?: 'FilterOption';
  /** The filter option's label for display purposes. */
  label: Scalars['String']['output'];
  /** The filter option's value. */
  value: Scalars['String']['output'];
};

/** Current user's access policy for a finance app. */
export type FinanceAppAccessPolicy = {
  __typename?: 'FinanceAppAccessPolicy';
  /** Current shop staff's access within the app. */
  access: Array<BankingFinanceAppAccess>;
};

/** Shopify Payments account information shared with embedded finance applications. */
export type FinanceKycInformation = {
  __typename?: 'FinanceKycInformation';
  /** The legal entity business address. */
  businessAddress?: Maybe<ShopifyPaymentsAddressBasic>;
  /** The legal entity business type. */
  businessType?: Maybe<ShopifyPaymentsBusinessType>;
  /** Business industry. */
  industry?: Maybe<ShopifyPaymentsMerchantCategoryCode>;
  /** Returns the business legal name. */
  legalName?: Maybe<Scalars['String']['output']>;
  /** The shop owner information for financial KYC purposes. */
  shopOwner: FinancialKycShopOwner;
  /** Tax identification information. */
  taxIdentification?: Maybe<ShopifyPaymentsTaxIdentification>;
};

/** Represents the shop owner information for financial KYC purposes. */
export type FinancialKycShopOwner = {
  __typename?: 'FinancialKycShopOwner';
  /** The email of the shop owner. */
  email: Scalars['String']['output'];
  /** The first name of the shop owner. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the shop owner. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the shop owner. */
  phone?: Maybe<Scalars['String']['output']>;
};

/** An amount that's allocated to a line item based on an associated discount application. */
export type FinancialSummaryDiscountAllocation = {
  __typename?: 'FinancialSummaryDiscountAllocation';
  /** The money amount that's allocated per unit on the associated line based on the discount application in shop and presentment currencies. If the allocated amount for the line cannot be evenly divided by the quantity, then this amount will be an approximate amount, avoiding fractional pennies. For example, if the associated line had a quantity of 3 with a discount of 4 cents, then the discount distribution would be [0.01, 0.01, 0.02]. This field returns the highest number of the distribution. In this example, this would be 0.02. */
  approximateAllocatedAmountPerItem: MoneyBag;
  /** The discount application that the allocated amount originated from. */
  discountApplication: FinancialSummaryDiscountApplication;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application on an order's line items or shipping lines.
 */
export type FinancialSummaryDiscountApplication = {
  __typename?: 'FinancialSummaryDiscountApplication';
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
};

/** Return type for `flowGenerateSignature` mutation. */
export type FlowGenerateSignaturePayload = {
  __typename?: 'FlowGenerateSignaturePayload';
  /** The payload used to generate the signature. */
  payload?: Maybe<Scalars['String']['output']>;
  /** The generated signature. */
  signature?: Maybe<Scalars['String']['output']>;
  /** The target URL corresponding to the requested payload schema: action runtime URL, validation URL, or custom configuration page preview URL. */
  targetUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `flowTriggerReceive` mutation. */
export type FlowTriggerReceivePayload = {
  __typename?: 'FlowTriggerReceivePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * A shipment of one or more items from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks which [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects ship, their quantities, and the shipment's tracking information.
 *
 * Includes tracking details such as the carrier, tracking numbers, and URLs. The fulfillment connects to both the original order and any associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) objects record milestones throughout the shipment lifecycle, from creation through delivery.
 *
 * Multiple fulfillments can exist for a single order when items either ship separately or from different locations.
 */
export type Fulfillment = LegacyInteroperability & Node & {
  __typename?: 'Fulfillment';
  /** The date and time when the fulfillment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date that this fulfillment was delivered. */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human readable display status for this fulfillment. */
  displayStatus?: Maybe<FulfillmentDisplayStatus>;
  /** The estimated date that this fulfillment will arrive. */
  estimatedDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  /** The history of events associated with this fulfillment. */
  events: FulfillmentEventConnection;
  /** List of the fulfillment's line items. */
  fulfillmentLineItems: FulfillmentLineItemConnection;
  /** A paginated list of fulfillment orders for the fulfillment. */
  fulfillmentOrders: FulfillmentOrderConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The date and time when the fulfillment went into transit. */
  inTransitAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The location that the fulfillment was processed at. */
  location?: Maybe<Location>;
  /** Human readable reference identifier for this fulfillment. */
  name: Scalars['String']['output'];
  /** The order for which the fulfillment was created. */
  order: Order;
  /** The address at which the fulfillment occurred. This field is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
  originAddress?: Maybe<FulfillmentOriginAddress>;
  /** Whether any of the line items in the fulfillment require shipping. */
  requiresShipping: Scalars['Boolean']['output'];
  /** Fulfillment service associated with the fulfillment. */
  service?: Maybe<FulfillmentService>;
  /** The optional shipping label for this fulfillment. */
  shippingLabel?: Maybe<ShippingLabel>;
  /** The status of the fulfillment. */
  status: FulfillmentStatus;
  /** Sum of all line item quantities for the fulfillment. */
  totalQuantity: Scalars['Int']['output'];
  /**
   * Tracking information associated with the fulfillment,
   * such as the tracking company, tracking number, and tracking URL.
   */
  trackingInfo: Array<FulfillmentTrackingInfo>;
  /** The date and time when the fulfillment was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A shipment of one or more items from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks which [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects ship, their quantities, and the shipment's tracking information.
 *
 * Includes tracking details such as the carrier, tracking numbers, and URLs. The fulfillment connects to both the original order and any associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) objects record milestones throughout the shipment lifecycle, from creation through delivery.
 *
 * Multiple fulfillments can exist for a single order when items either ship separately or from different locations.
 */
export type FulfillmentEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<FulfillmentEventSortKeys>;
};


/**
 * A shipment of one or more items from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks which [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects ship, their quantities, and the shipment's tracking information.
 *
 * Includes tracking details such as the carrier, tracking numbers, and URLs. The fulfillment connects to both the original order and any associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) objects record milestones throughout the shipment lifecycle, from creation through delivery.
 *
 * Multiple fulfillments can exist for a single order when items either ship separately or from different locations.
 */
export type FulfillmentFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipment of one or more items from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks which [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects ship, their quantities, and the shipment's tracking information.
 *
 * Includes tracking details such as the carrier, tracking numbers, and URLs. The fulfillment connects to both the original order and any associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) objects record milestones throughout the shipment lifecycle, from creation through delivery.
 *
 * Multiple fulfillments can exist for a single order when items either ship separately or from different locations.
 */
export type FulfillmentFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A shipment of one or more items from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Tracks which [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects ship, their quantities, and the shipment's tracking information.
 *
 * Includes tracking details such as the carrier, tracking numbers, and URLs. The fulfillment connects to both the original order and any associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) objects record milestones throughout the shipment lifecycle, from creation through delivery.
 *
 * Multiple fulfillments can exist for a single order when items either ship separately or from different locations.
 */
export type FulfillmentTrackingInfoArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `fulfillmentCancel` mutation. */
export type FulfillmentCancelPayload = {
  __typename?: 'FulfillmentCancelPayload';
  /** The canceled fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple Fulfillments. */
export type FulfillmentConnection = {
  __typename?: 'FulfillmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentEdge>;
  /** A list of nodes that are contained in FulfillmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Fulfillment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** A fulfillment constraint rule. */
export type FulfillmentConstraintRule = HasMetafields & Node & {
  __typename?: 'FulfillmentConstraintRule';
  /** Delivery method types that the function is associated with. */
  deliveryMethodTypes: Array<DeliveryMethodType>;
  /** The ID for the fulfillment constraint function. */
  function: ShopifyFunction;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRuleMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRuleMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `fulfillmentConstraintRuleCreate` mutation. */
export type FulfillmentConstraintRuleCreatePayload = {
  __typename?: 'FulfillmentConstraintRuleCreatePayload';
  /** The newly created fulfillment constraint rule. */
  fulfillmentConstraintRule?: Maybe<FulfillmentConstraintRule>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentConstraintRuleCreateUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleCreate`. */
export type FulfillmentConstraintRuleCreateUserError = DisplayableError & {
  __typename?: 'FulfillmentConstraintRuleCreateUserError';
  /** The error code. */
  code?: Maybe<FulfillmentConstraintRuleCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleCreateUserError`. */
export enum FulfillmentConstraintRuleCreateUserErrorCode {
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CustomAppFunctionNotEligible = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** A fulfillment constraint rule already exists for the provided function_id. */
  FunctionAlreadyRegistered = 'FUNCTION_ALREADY_REGISTERED',
  /** Function does not implement the required interface for this fulfillment constraint rule. */
  FunctionDoesNotImplement = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** No Shopify Function found for provided function_id. */
  FunctionNotFound = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion and cannot have new rules created against it. */
  FunctionPendingDeletion = 'FUNCTION_PENDING_DELETION',
  /** Failed to create fulfillment constraint rule due to invalid input. */
  InputInvalid = 'INPUT_INVALID',
  /** Maximum number of fulfillment constraint rules reached. Limit is 10. */
  MaximumFulfillmentConstraintRulesReached = 'MAXIMUM_FULFILLMENT_CONSTRAINT_RULES_REACHED',
  /** Either function_id or function_handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function_id or function_handle can be provided, not both. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS'
}

/** Return type for `fulfillmentConstraintRuleDelete` mutation. */
export type FulfillmentConstraintRuleDeletePayload = {
  __typename?: 'FulfillmentConstraintRuleDeletePayload';
  /** Whether or not the fulfillment constraint rule was successfully deleted. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentConstraintRuleDeleteUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleDelete`. */
export type FulfillmentConstraintRuleDeleteUserError = DisplayableError & {
  __typename?: 'FulfillmentConstraintRuleDeleteUserError';
  /** The error code. */
  code?: Maybe<FulfillmentConstraintRuleDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleDeleteUserError`. */
export enum FulfillmentConstraintRuleDeleteUserErrorCode {
  /** Could not find fulfillment constraint rule for provided id. */
  NotFound = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UnauthorizedAppScope = 'UNAUTHORIZED_APP_SCOPE'
}

/** Return type for `fulfillmentConstraintRuleUpdate` mutation. */
export type FulfillmentConstraintRuleUpdatePayload = {
  __typename?: 'FulfillmentConstraintRuleUpdatePayload';
  /** The updated fulfillment constraint rule. */
  fulfillmentConstraintRule?: Maybe<FulfillmentConstraintRule>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentConstraintRuleUpdateUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleUpdate`. */
export type FulfillmentConstraintRuleUpdateUserError = DisplayableError & {
  __typename?: 'FulfillmentConstraintRuleUpdateUserError';
  /** The error code. */
  code?: Maybe<FulfillmentConstraintRuleUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleUpdateUserError`. */
export enum FulfillmentConstraintRuleUpdateUserErrorCode {
  /** Could not find fulfillment constraint rule for provided id. */
  NotFound = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UnauthorizedAppScope = 'UNAUTHORIZED_APP_SCOPE'
}

/** Return type for `fulfillmentCreate` mutation. */
export type FulfillmentCreatePayload = {
  __typename?: 'FulfillmentCreatePayload';
  /** The created fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentCreateV2` mutation. */
export type FulfillmentCreateV2Payload = {
  __typename?: 'FulfillmentCreateV2Payload';
  /** The created fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The display status of a fulfillment. */
export enum FulfillmentDisplayStatus {
  /** Displayed as **Attempted delivery**. */
  AttemptedDelivery = 'ATTEMPTED_DELIVERY',
  /** Displayed as **Canceled**. */
  Canceled = 'CANCELED',
  /** Displayed as **Picked up by carrier**. */
  CarrierPickedUp = 'CARRIER_PICKED_UP',
  /** Displayed as **Confirmed**. */
  Confirmed = 'CONFIRMED',
  /** Displayed as **Delayed**. */
  Delayed = 'DELAYED',
  /** Displayed as **Delivered**. */
  Delivered = 'DELIVERED',
  /** Displayed as **Failure**. */
  Failure = 'FAILURE',
  /** Displayed as **Fulfilled**. */
  Fulfilled = 'FULFILLED',
  /** Displayed as **In transit**. */
  InTransit = 'IN_TRANSIT',
  /** Displayed as **Label printed**. */
  LabelPrinted = 'LABEL_PRINTED',
  /** Displayed as **Label purchased**. */
  LabelPurchased = 'LABEL_PURCHASED',
  /** Displayed as **Label voided**. */
  LabelVoided = 'LABEL_VOIDED',
  /** Displayed as **Marked as fulfilled**. */
  MarkedAsFulfilled = 'MARKED_AS_FULFILLED',
  /** Displayed as **Not delivered**. */
  NotDelivered = 'NOT_DELIVERED',
  /** Displayed as **Out for delivery**. */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** Displayed as **Picked up**. */
  PickedUp = 'PICKED_UP',
  /** Displayed as **Ready for pickup**. */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** Displayed as **Submitted**. */
  Submitted = 'SUBMITTED'
}

/** An auto-generated type which holds one Fulfillment and a cursor during pagination. */
export type FulfillmentEdge = {
  __typename?: 'FulfillmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentEdge. */
  node: Fulfillment;
};

/**
 * A tracking event that records the status and location of a fulfillment at a specific point in time. Each event captures details such as the [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent#field-FulfillmentEvent.fields.status) (for example, in transit, out for delivery, delivered) and any [messages](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent#field-FulfillmentEvent.fields.message) associated with the event.
 *
 * Fulfillment events provide a chronological history of a package's journey from shipment to delivery. They include timestamps, geographic coordinates, and estimated delivery dates to track fulfillment progress.
 */
export type FulfillmentEvent = Node & {
  __typename?: 'FulfillmentEvent';
  /** The street address where this fulfillment event occurred. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The city where this fulfillment event occurred. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country where this fulfillment event occurred. */
  country?: Maybe<Scalars['String']['output']>;
  /** The date and time when the fulfillment event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The estimated delivery date and time of the fulfillment. */
  estimatedDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time at which this fulfillment event happened. */
  happenedAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The latitude where this fulfillment event occurred. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude where this fulfillment event occurred. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** A message associated with this fulfillment event. */
  message?: Maybe<Scalars['String']['output']>;
  /** The province where this fulfillment event occurred. */
  province?: Maybe<Scalars['String']['output']>;
  /** The status of this fulfillment event. */
  status: FulfillmentEventStatus;
  /** The zip code of the location where this fulfillment event occurred. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple FulfillmentEvents. */
export type FulfillmentEventConnection = {
  __typename?: 'FulfillmentEventConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentEventEdge>;
  /** A list of nodes that are contained in FulfillmentEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `fulfillmentEventCreate` mutation. */
export type FulfillmentEventCreatePayload = {
  __typename?: 'FulfillmentEventCreatePayload';
  /** The created fulfillment event. */
  fulfillmentEvent?: Maybe<FulfillmentEvent>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one FulfillmentEvent and a cursor during pagination. */
export type FulfillmentEventEdge = {
  __typename?: 'FulfillmentEventEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentEventEdge. */
  node: FulfillmentEvent;
};

/** The input fields used to create a fulfillment event. */
export type FulfillmentEventInput = {
  /** The street address where this fulfillment event occurred. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The city where this fulfillment event occurred. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country where this fulfillment event occurred. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The estimated delivery date and time of the fulfillment. */
  estimatedDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID for the fulfillment that's associated with this fulfillment event. */
  fulfillmentId: Scalars['ID']['input'];
  /** The time at which this fulfillment event happened. */
  happenedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The latitude where this fulfillment event occurred. */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude where this fulfillment event occurred. */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** A message associated with this fulfillment event. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The province where this fulfillment event occurred. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** The status of this fulfillment event. */
  status: FulfillmentEventStatus;
  /** The zip code of the location where this fulfillment event occurred. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** The set of valid sort keys for the FulfillmentEvent query. */
export enum FulfillmentEventSortKeys {
  /** Sort by the `happened_at` value. */
  HappenedAt = 'HAPPENED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The status that describes a fulfillment or delivery event. */
export enum FulfillmentEventStatus {
  /** A delivery was attempted. */
  AttemptedDelivery = 'ATTEMPTED_DELIVERY',
  /** The fulfillment has been picked up by the carrier. */
  CarrierPickedUp = 'CARRIER_PICKED_UP',
  /** The fulfillment is confirmed. This is the default value when no other information is available. */
  Confirmed = 'CONFIRMED',
  /** The fulfillment is delayed. */
  Delayed = 'DELAYED',
  /** The fulfillment was successfully delivered. */
  Delivered = 'DELIVERED',
  /** The fulfillment request failed. */
  Failure = 'FAILURE',
  /** The fulfillment is in transit. */
  InTransit = 'IN_TRANSIT',
  /** A purchased shipping label has been printed. */
  LabelPrinted = 'LABEL_PRINTED',
  /** A shipping label has been purchased. */
  LabelPurchased = 'LABEL_PURCHASED',
  /** The fulfillment is out for delivery. */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** The fulfillment is ready to be picked up. */
  ReadyForPickup = 'READY_FOR_PICKUP'
}

/** A fulfillment hold currently applied on a fulfillment order. */
export type FulfillmentHold = Node & {
  __typename?: 'FulfillmentHold';
  /** The localized reason for the fulfillment hold for display purposes. */
  displayReason: Scalars['String']['output'];
  /**
   * An identifier an app can use to reference one of many holds it applied to a fulfillment order.
   * This field must be unique among the holds that a single app applies to a single fulfillment order.
   */
  handle?: Maybe<Scalars['String']['output']>;
  /** The app that created the fulfillment hold. */
  heldByApp?: Maybe<App>;
  /** A boolean value that indicates whether the requesting app created the fulfillment hold. */
  heldByRequestingApp: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The reason for the fulfillment hold. */
  reason: FulfillmentHoldReason;
  /** Additional information about the fulfillment hold reason. */
  reasonNotes?: Maybe<Scalars['String']['output']>;
};

/** The reason for a fulfillment hold. */
export enum FulfillmentHoldReason {
  /** The fulfillment hold is applied because payment is pending. */
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** The fulfillment hold is applied because of return items not yet received during an exchange. */
  AwaitingReturnItems = 'AWAITING_RETURN_ITEMS',
  /** The fulfillment hold is applied because of a high risk of fraud. */
  HighRiskOfFraud = 'HIGH_RISK_OF_FRAUD',
  /** The fulfillment hold is applied because of an incorrect address. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The fulfillment hold is applied because inventory is out of stock. */
  InventoryOutOfStock = 'INVENTORY_OUT_OF_STOCK',
  /** The fulfillment hold is applied because of a post purchase upsell offer. */
  OnlineStorePostPurchaseCrossSell = 'ONLINE_STORE_POST_PURCHASE_CROSS_SELL',
  /** The fulfillment hold is applied for another reason. */
  Other = 'OTHER',
  /** The fulfillment hold is applied because of an unknown delivery date. */
  UnknownDeliveryDate = 'UNKNOWN_DELIVERY_DATE'
}

/** The input fields used to create a fulfillment from fulfillment orders. */
export type FulfillmentInput = {
  /**
   * Pairs of `fulfillment_order_id` and `fulfillment_order_line_items` that represent the fulfillment
   * order line items that have to be fulfilled for each fulfillment order.  For any given pair, if the
   * fulfillment order line items are left blank then all the fulfillment order line items of the
   * associated fulfillment order ID will be fulfilled.
   */
  lineItemsByFulfillmentOrder: Array<FulfillmentOrderLineItemsInput>;
  /**
   * Whether the customer is notified.
   * If `true`, then a notification is sent when the fulfillment is created. The default value is `false`.
   */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address information about the location from which the order was fulfilled. */
  originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /**
   * The fulfillment's tracking information, including a tracking URL, a tracking number,
   * and the company associated with the fulfillment.
   */
  trackingInfo?: InputMaybe<FulfillmentTrackingInput>;
};

/**
 * A line item from an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) that's included in a [`Fulfillment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Fulfillment). Links the fulfillment to specific items from the original order, tracking how many units were fulfilled.
 *
 * > Note: The discounted total excludes order-level discounts, showing only line-item specific discount amounts.
 */
export type FulfillmentLineItem = Node & {
  __typename?: 'FulfillmentLineItem';
  /** The date and time when the fulfillment line item was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The total price after discounts are applied.
   * @deprecated Use `discountedTotalSet` instead.
   */
  discountedTotal: Scalars['Money']['output'];
  /** The total price after discounts are applied in shop and presentment currencies. This value doesn't include order-level discounts. */
  discountedTotalSet: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The associated order's line item. */
  lineItem: LineItem;
  /**
   * The total price before discounts are applied.
   * @deprecated Use `originalTotalSet` instead.
   */
  originalTotal: Scalars['Money']['output'];
  /** The total price before discounts are applied in shop and presentment currencies. */
  originalTotalSet: MoneyBag;
  /** Number of line items in the fulfillment. */
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** An auto-generated type for paginating through multiple FulfillmentLineItems. */
export type FulfillmentLineItemConnection = {
  __typename?: 'FulfillmentLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentLineItemEdge>;
  /** A list of nodes that are contained in FulfillmentLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentLineItem and a cursor during pagination. */
export type FulfillmentLineItemEdge = {
  __typename?: 'FulfillmentLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentLineItemEdge. */
  node: FulfillmentLineItem;
};

/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrder = Node & {
  __typename?: 'FulfillmentOrder';
  /**
   * The fulfillment order's assigned location. This is the location where the fulfillment is expected to happen.
   *
   * The fulfillment order's assigned location might change in the following cases:
   *
   * - The fulfillment order has been entirely moved to a new location. For example, the [fulfillmentOrderMove](
   *   https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
   *   ) mutation has been called, and you see the original fulfillment order in the [movedFulfillmentOrder](
   *   https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove#field-fulfillmentordermovepayload-movedfulfillmentorder
   *   ) field within the mutation's response.
   * - Work on the fulfillment order hasn't yet begun, which means that the fulfillment order has the
   *     [OPEN](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-open),
   *     [SCHEDULED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-scheduled), or
   *     [ON_HOLD](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-onhold)
   *     status, and the shop's location properties might be undergoing edits (for example, in the Shopify admin).
   */
  assignedLocation: FulfillmentOrderAssignedLocation;
  /**
   * ID of the channel that created the order.
   * @deprecated Use [`order.attribution.handle`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderAttribution#field-OrderAttribution.fields.handle) instead.
   */
  channelId?: Maybe<Scalars['ID']['output']>;
  /** Date and time when the fulfillment order was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery method of this fulfillment order. */
  deliveryMethod?: Maybe<DeliveryMethod>;
  /** The destination where the items should be sent. */
  destination?: Maybe<FulfillmentOrderDestination>;
  /** The date and time at which the fulfillment order will be fulfillable. When this date and time is reached, the scheduled fulfillment order is automatically transitioned to open. For example, the `fulfill_at` date for a subscription order might be the 1st of each month, a pre-order `fulfill_at` date would be `nil`, and a standard order `fulfill_at` date would be the order creation date. */
  fulfillAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest date and time by which all items in the fulfillment order need to be fulfilled. */
  fulfillBy?: Maybe<Scalars['DateTime']['output']>;
  /** The fulfillment holds applied on the fulfillment order. */
  fulfillmentHolds: Array<FulfillmentHold>;
  /** Fulfillment orders eligible for merging with the given fulfillment order. */
  fulfillmentOrdersForMerge: FulfillmentOrderConnection;
  /** A list of fulfillments for the fulfillment order. */
  fulfillments: FulfillmentConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The duties delivery method of this fulfillment order. */
  internationalDuties?: Maybe<FulfillmentOrderInternationalDuties>;
  /** A list of the fulfillment order's line items. */
  lineItems: FulfillmentOrderLineItemConnection;
  /** A list of locations that the fulfillment order can potentially move to. */
  locationsForMove: FulfillmentOrderLocationForMoveConnection;
  /** A list of requests sent by the merchant or an order management app to the fulfillment service for the fulfillment order. */
  merchantRequests: FulfillmentOrderMerchantRequestConnection;
  /** The order that's associated with the fulfillment order. */
  order: Order;
  /** ID of the order that's associated with the fulfillment order. */
  orderId: Scalars['ID']['output'];
  /**
   * The unique identifier for the order that appears on the order page in the Shopify admin and the <b>Order status</b> page.
   * For example, "#1001", "EN1001", or "1001-A".
   * This value isn't unique across multiple stores.
   */
  orderName: Scalars['String']['output'];
  /**
   * The date and time when the order was processed.
   * This date and time might not match the date and time when the order was created.
   */
  orderProcessedAt: Scalars['DateTime']['output'];
  /** The total weight of all line items in the fulfillment order that aren't yet fulfilled. */
  remainingLineItemsWeight?: Maybe<Weight>;
  /** The request status of the fulfillment order. */
  requestStatus: FulfillmentOrderRequestStatus;
  /** The status of the fulfillment order. */
  status: FulfillmentOrderStatus;
  /** The actions that can be performed on this fulfillment order. */
  supportedActions: Array<FulfillmentOrderSupportedAction>;
  /** The date and time when the fulfillment order was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderFulfillmentOrdersForMergeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderLocationsForMoveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderMerchantRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<FulfillmentOrderMerchantRequestKind>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `fulfillmentOrderAcceptCancellationRequest` mutation. */
export type FulfillmentOrderAcceptCancellationRequestPayload = {
  __typename?: 'FulfillmentOrderAcceptCancellationRequestPayload';
  /** The fulfillment order whose cancellation request was accepted. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentOrderAcceptFulfillmentRequest` mutation. */
export type FulfillmentOrderAcceptFulfillmentRequestPayload = {
  __typename?: 'FulfillmentOrderAcceptFulfillmentRequestPayload';
  /** The fulfillment order whose fulfillment request was accepted. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The actions that can be taken on a fulfillment order. */
export enum FulfillmentOrderAction {
  /** Cancels a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderCancel`. */
  CancelFulfillmentOrder = 'CANCEL_FULFILLMENT_ORDER',
  /** Creates a fulfillment for selected line items in the fulfillment order. The corresponding mutation for this action is `fulfillmentCreateV2`. */
  CreateFulfillment = 'CREATE_FULFILLMENT',
  /** Opens an external URL to initiate the fulfillment process outside Shopify. This action should be paired with `FulfillmentOrderSupportedAction.externalUrl`. */
  External = 'EXTERNAL',
  /** Applies a fulfillment hold on the fulfillment order. The corresponding mutation for this action is `fulfillmentOrderHold`. */
  Hold = 'HOLD',
  /** Marks the fulfillment order as open. The corresponding mutation for this action is `fulfillmentOrderOpen`. */
  MarkAsOpen = 'MARK_AS_OPEN',
  /** Merges a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderMerge`. */
  Merge = 'MERGE',
  /** Moves a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderMove`. */
  Move = 'MOVE',
  /** Releases the fulfillment hold on the fulfillment order. The corresponding mutation for this action is `fulfillmentOrderReleaseHold`. */
  ReleaseHold = 'RELEASE_HOLD',
  /** Report the progress of the fulfillment order, marking as in progress if it's not already in progress. */
  ReportProgress = 'REPORT_PROGRESS',
  /** Sends a cancellation request to the fulfillment service of a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderSubmitCancellationRequest`. */
  RequestCancellation = 'REQUEST_CANCELLATION',
  /** Sends a request for fulfilling selected line items in a fulfillment order to a fulfillment service. The corresponding mutation for this action is `fulfillmentOrderSubmitFulfillmentRequest`. */
  RequestFulfillment = 'REQUEST_FULFILLMENT',
  /** Splits a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderSplit`. */
  Split = 'SPLIT'
}

/**
 * The fulfillment order's assigned location. This is the location where the fulfillment is expected to happen.
 *
 *  The fulfillment order's assigned location might change in the following cases:
 *
 *   - The fulfillment order has been entirely moved to a new location. For example, the [fulfillmentOrderMove](
 *     https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
 *     ) mutation has been called, and you see the original fulfillment order in the [movedFulfillmentOrder](
 *     https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove#field-fulfillmentordermovepayload-movedfulfillmentorder
 *     ) field within the mutation's response.
 *
 *   - Work on the fulfillment order has not yet begun, which means that the fulfillment order has the
 *       [OPEN](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-open),
 *       [SCHEDULED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-scheduled), or
 *       [ON_HOLD](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-onhold)
 *       status, and the shop's location properties might be undergoing edits (for example, in the Shopify admin).
 *
 * If the [fulfillmentOrderMove](
 * https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
 * ) mutation has moved the fulfillment order's line items to a new location,
 * but hasn't moved the fulfillment order instance itself, then the original fulfillment order's assigned location
 * doesn't change.
 * This happens if the fulfillment order is being split during the move, or if all line items can be moved
 * to an existing fulfillment order at a new location.
 *
 * Once the fulfillment order has been taken into work or canceled,
 * which means that the fulfillment order has the
 * [IN_PROGRESS](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-inprogress),
 * [CLOSED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-closed),
 * [CANCELLED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-cancelled), or
 * [INCOMPLETE](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-incomplete)
 * status, `FulfillmentOrderAssignedLocation` acts as a snapshot of the shop's location content.
 * Up-to-date shop's location data may be queried through [location](
 *   https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderAssignedLocation#field-fulfillmentorderassignedlocation-location
 * ) connection.
 */
export type FulfillmentOrderAssignedLocation = {
  __typename?: 'FulfillmentOrderAssignedLocation';
  /** The first line of the address for the location. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address for the location. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the location. */
  city?: Maybe<Scalars['String']['output']>;
  /** The two-letter country code of the location. */
  countryCode: CountryCode;
  /**
   * The location where the fulfillment is expected to happen. This value might be different from
   * `FulfillmentOrderAssignedLocation` if the location's attributes were updated
   * after the fulfillment order was taken into work of canceled.
   */
  location?: Maybe<Location>;
  /** The name of the location. */
  name: Scalars['String']['output'];
  /** The phone number of the location. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The province of the location. */
  province?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the location. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** The assigment status to be used to filter fulfillment orders. */
export enum FulfillmentOrderAssignmentStatus {
  /**
   * Fulfillment orders for which the merchant has requested cancellation of
   * the previously accepted fulfillment request.
   */
  CancellationRequested = 'CANCELLATION_REQUESTED',
  /**
   * Fulfillment orders for which the merchant's fulfillment request has been accepted.
   * Any number of fulfillments can be created on these fulfillment orders
   * to completely fulfill the requested items.
   */
  FulfillmentAccepted = 'FULFILLMENT_ACCEPTED',
  /** Fulfillment orders for which the merchant has requested fulfillment. */
  FulfillmentRequested = 'FULFILLMENT_REQUESTED',
  /** Fulfillment orders for which the merchant hasn't yet requested fulfillment. */
  FulfillmentUnsubmitted = 'FULFILLMENT_UNSUBMITTED'
}

/** Represents an error that occurs while cancelling a fulfillment order. */
export type FulfillmentOrderCancelError = DisplayableError & {
  __typename?: 'FulfillmentOrderCancelError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderCancelErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderCancelError`. */
export enum FulfillmentOrderCancelErrorCode {
  /** Cannot cancel fulfillment order with reported progress. Mark as unfulfilled first. */
  FulfillmentOrderHasManuallyReportedProgress = 'FULFILLMENT_ORDER_HAS_MANUALLY_REPORTED_PROGRESS'
}

/** Return type for `fulfillmentOrderCancel` mutation. */
export type FulfillmentOrderCancelPayload = {
  __typename?: 'FulfillmentOrderCancelPayload';
  /** The fulfillment order that was marked as canceled. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The fulfillment order that was created to replace the canceled fulfillment order. */
  replacementFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderCancelError>;
};

/** Return type for `fulfillmentOrderClose` mutation. */
export type FulfillmentOrderClosePayload = {
  __typename?: 'FulfillmentOrderClosePayload';
  /** The fulfillment order that was marked as incomplete. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrders. */
export type FulfillmentOrderConnection = {
  __typename?: 'FulfillmentOrderConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentOrderEdge>;
  /** A list of nodes that are contained in FulfillmentOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Represents the destination where the items should be sent upon fulfillment. */
export type FulfillmentOrderDestination = Node & {
  __typename?: 'FulfillmentOrderDestination';
  /** The first line of the address of the destination. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address of the destination. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the destination. */
  city?: Maybe<Scalars['String']['output']>;
  /** The company of the destination. */
  company?: Maybe<Scalars['String']['output']>;
  /** The two-letter country code of the destination. */
  countryCode?: Maybe<CountryCode>;
  /** The email of the customer at the destination. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer at the destination. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the customer at the destination. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The location designated for the pick-up of the fulfillment order. */
  location?: Maybe<Location>;
  /** The phone number of the customer at the destination. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The province of the destination. */
  province?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the destination. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type which holds one FulfillmentOrder and a cursor during pagination. */
export type FulfillmentOrderEdge = {
  __typename?: 'FulfillmentOrderEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentOrderEdge. */
  node: FulfillmentOrder;
};

/** The input fields for the fulfillment hold applied on the fulfillment order. */
export type FulfillmentOrderHoldInput = {
  /** A configurable ID used to track the automation system releasing these holds. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The fulfillment order line items to be placed on hold.
   *
   * If left blank, all line items of the fulfillment order are placed on hold.
   *
   * Not supported when placing a hold on a fulfillment order that is already held.
   * If supplied when a fulfillment order is already on hold, [a user error](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderHoldUserErrorCode#value-fulfillmentordernotsplittable)
   * will be returned indicating that the fulfillment order is not able to be split.
   */
  fulfillmentOrderLineItems?: InputMaybe<Array<FulfillmentOrderLineItemInput>>;
  /**
   * An identifier that an app can use to reference one of the holds that it applies to a
   * fulfillment order.
   *
   * This field must be unique among the holds that a single app applies to a single fulfillment order.
   * It prevents apps from inadvertently creating duplicate holds.
   * This field cannot exceed 64 characters.
   *
   * For example, an app can place multiple holds on a single fulfillment order each with a different `handle`.
   * If an app attempts to place two holds with the same `handle`, the second hold will be rejected with
   * [a duplicate hold user error](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderHoldUserErrorCode#value-duplicatefulfillmentholdhandle).
   * The same `handle` can however be re-used on different fulfillment orders and by different apps.
   *
   * By default, `handle` will be an empty string. If an app wishes to place multiple holds on a single
   * fulfillment order, then a different `handle` must be provided for each.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether the merchant receives a notification about the fulfillment hold. The default value is `false`. */
  notifyMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  /** The reason for the fulfillment hold. */
  reason: FulfillmentHoldReason;
  /** Additional information about the fulfillment hold reason. */
  reasonNotes?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `fulfillmentOrderHold` mutation. */
export type FulfillmentOrderHoldPayload = {
  __typename?: 'FulfillmentOrderHoldPayload';
  /** The fulfillment hold created for the fulfillment order. Null if no hold was created. */
  fulfillmentHold?: Maybe<FulfillmentHold>;
  /** The fulfillment order on which a fulfillment hold was applied. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The remaining fulfillment order containing the line items to which the hold wasn't applied,
   * if specific line items were specified to be placed on hold.
   */
  remainingFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderHoldUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderHold`. */
export type FulfillmentOrderHoldUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderHoldUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderHoldUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderHoldUserError`. */
export enum FulfillmentOrderHoldUserErrorCode {
  /** The fulfillment order line items are not unique. */
  DuplicatedFulfillmentOrderLineItems = 'DUPLICATED_FULFILLMENT_ORDER_LINE_ITEMS',
  /** The handle provided for the fulfillment hold is already in use by this app for another hold on this fulfillment order. */
  DuplicateFulfillmentHoldHandle = 'DUPLICATE_FULFILLMENT_HOLD_HANDLE',
  /** The maximum number of fulfillment holds for this fulfillment order has been reached for this app. An app can only have up to 10 holds on a single fulfillment order at any one time. */
  FulfillmentOrderHoldLimitReached = 'FULFILLMENT_ORDER_HOLD_LIMIT_REACHED',
  /** The fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order is not in a splittable state. */
  FulfillmentOrderNotSplittable = 'FULFILLMENT_ORDER_NOT_SPLITTABLE',
  /** The fulfillment order line item quantity must be greater than 0. */
  GreaterThanZero = 'GREATER_THAN_ZERO',
  /** The fulfillment order line item quantity is invalid. */
  InvalidLineItemQuantity = 'INVALID_LINE_ITEM_QUANTITY',
  /** The input value is already taken. */
  Taken = 'TAKEN'
}

/** The international duties relevant to a fulfillment order. */
export type FulfillmentOrderInternationalDuties = {
  __typename?: 'FulfillmentOrderInternationalDuties';
  /** The method of duties payment. Example values: `DDP`, `DAP`. */
  incoterm: Scalars['String']['output'];
};

/**
 * Associates an order line item with the quantities that require fulfillment as part of a fulfillment order. Each Fulfillment Order Line Item object tracks the total quantity to fulfill and the remaining quantity yet to be fulfilled, along with details about the line item being fulfilled and pricing information.
 *
 * The line item provides additional fulfillment data including whether the item requires shipping. Financial summaries show pricing details with discounts applied, while warning messages alert merchants to any issues that might affect fulfillment.
 */
export type FulfillmentOrderLineItem = Node & {
  __typename?: 'FulfillmentOrderLineItem';
  /** The financial summary for the Fulfillment Order's Line Items. */
  financialSummaries: Array<FulfillmentOrderLineItemFinancialSummary>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image associated to the line item's variant. */
  image?: Maybe<Image>;
  /** The ID of the inventory item. */
  inventoryItemId?: Maybe<Scalars['ID']['output']>;
  /** The associated order line item. */
  lineItem: LineItem;
  /**
   * The variant unit price without discounts applied, in shop and presentment currencies.
   * @deprecated Use `financialSummaries` instead.
   */
  originalUnitPriceSet: MoneyBag;
  /** The title of the product. */
  productTitle: Scalars['String']['output'];
  /** The number of units remaining to be fulfilled. */
  remainingQuantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The shipping line associated with this line item. */
  shippingLine?: Maybe<ShippingLine>;
  /** The variant SKU number. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The total number of units to be fulfilled. */
  totalQuantity: Scalars['Int']['output'];
  /** The product variant associated to the fulfillment order line item. */
  variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  variantTitle?: Maybe<Scalars['String']['output']>;
  /** The name of the vendor who made the variant. */
  vendor?: Maybe<Scalars['String']['output']>;
  /** Warning messages for a fulfillment order line item. */
  warnings: Array<FulfillmentOrderLineItemWarning>;
  /** The weight of a line item unit. */
  weight?: Maybe<Weight>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrderLineItems. */
export type FulfillmentOrderLineItemConnection = {
  __typename?: 'FulfillmentOrderLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentOrderLineItemEdge>;
  /** A list of nodes that are contained in FulfillmentOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderLineItem and a cursor during pagination. */
export type FulfillmentOrderLineItemEdge = {
  __typename?: 'FulfillmentOrderLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentOrderLineItemEdge. */
  node: FulfillmentOrderLineItem;
};

/** The financial details of a fulfillment order line item. */
export type FulfillmentOrderLineItemFinancialSummary = {
  __typename?: 'FulfillmentOrderLineItemFinancialSummary';
  /** The approximate split price of a line item unit, in shop and presentment currencies. This value doesn't include discounts applied to the entire order.For the full picture of applied discounts, see discountAllocations. */
  approximateDiscountedUnitPriceSet: MoneyBag;
  /** The discounts that have been allocated onto the line item by discount applications, not including order edits and refunds. */
  discountAllocations: Array<FinancialSummaryDiscountAllocation>;
  /** The variant unit price without discounts applied, in shop and presentment currencies. */
  originalUnitPriceSet: MoneyBag;
  /** Number of line items that this financial summary applies to. */
  quantity: Scalars['Int']['output'];
};

/** The input fields used to include the quantity of the fulfillment order line item that should be fulfilled. */
export type FulfillmentOrderLineItemInput = {
  /** The ID of the fulfillment order line item. */
  id: Scalars['ID']['input'];
  /** The quantity of the fulfillment order line item. */
  quantity: Scalars['Int']['input'];
};

/** A fulfillment order line item warning. For example, a warning about why a fulfillment request was rejected. */
export type FulfillmentOrderLineItemWarning = {
  __typename?: 'FulfillmentOrderLineItemWarning';
  /** The description of warning. */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of warning. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The input fields used to include the line items of a specified fulfillment order that should be fulfilled. */
export type FulfillmentOrderLineItemsInput = {
  /** The ID of the fulfillment order. */
  fulfillmentOrderId: Scalars['ID']['input'];
  /**
   * The fulfillment order line items to be fulfilled.
   * If left blank, all line items of the fulfillment order will be fulfilled.
   * Accepts a maximum of 512 line items.
   */
  fulfillmentOrderLineItems?: InputMaybe<Array<FulfillmentOrderLineItemInput>>;
};

/** The input fields for marking fulfillment order line items as ready for pickup. */
export type FulfillmentOrderLineItemsPreparedForPickupInput = {
  /** The fulfillment orders associated with the line items which are ready to be picked up by a customer. */
  lineItemsByFulfillmentOrder: Array<PreparedFulfillmentOrderLineItemsInput>;
};

/** Return type for `fulfillmentOrderLineItemsPreparedForPickup` mutation. */
export type FulfillmentOrderLineItemsPreparedForPickupPayload = {
  __typename?: 'FulfillmentOrderLineItemsPreparedForPickupPayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderLineItemsPreparedForPickupUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderLineItemsPreparedForPickup`. */
export type FulfillmentOrderLineItemsPreparedForPickupUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderLineItemsPreparedForPickupUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderLineItemsPreparedForPickupUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderLineItemsPreparedForPickupUserError`. */
export enum FulfillmentOrderLineItemsPreparedForPickupUserErrorCode {
  /** Invalid fulfillment order ID provided. */
  FulfillmentOrderInvalid = 'FULFILLMENT_ORDER_INVALID',
  /** The fulfillment order does not have any line items that can be prepared. */
  NoLineItemsToPrepareForFulfillmentOrder = 'NO_LINE_ITEMS_TO_PREPARE_FOR_FULFILLMENT_ORDER',
  /** Unable to prepare quantity. */
  UnableToPrepareQuantity = 'UNABLE_TO_PREPARE_QUANTITY'
}

/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMove = {
  __typename?: 'FulfillmentOrderLocationForMove';
  /** Fulfillment order line items that can be moved from their current location to the given location. */
  availableLineItems: FulfillmentOrderLineItemConnection;
  /**
   * Total number of fulfillment order line items that can be moved from their current assigned location to the
   * given location.
   */
  availableLineItemsCount?: Maybe<Count>;
  /** The location being considered as the fulfillment order's new assigned location. */
  location: Location;
  /**
   * A human-readable string with the reason why the fulfillment order, or some of its line items, can't be
   * moved to the location.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the fulfillment order can be moved to the location. */
  movable: Scalars['Boolean']['output'];
  /** Fulfillment order line items that cannot be moved from their current location to the given location. */
  unavailableLineItems: FulfillmentOrderLineItemConnection;
  /**
   * Total number of fulfillment order line items that can't be moved from their current assigned location to the
   * given location.
   */
  unavailableLineItemsCount?: Maybe<Count>;
};


/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMoveAvailableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMoveUnavailableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrderLocationForMoves. */
export type FulfillmentOrderLocationForMoveConnection = {
  __typename?: 'FulfillmentOrderLocationForMoveConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentOrderLocationForMoveEdge>;
  /** A list of nodes that are contained in FulfillmentOrderLocationForMoveEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentOrderLocationForMove>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderLocationForMove and a cursor during pagination. */
export type FulfillmentOrderLocationForMoveEdge = {
  __typename?: 'FulfillmentOrderLocationForMoveEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentOrderLocationForMoveEdge. */
  node: FulfillmentOrderLocationForMove;
};

/**
 * A request made by the merchant or an order management app to a fulfillment service
 * for a fulfillment order.
 */
export type FulfillmentOrderMerchantRequest = Node & {
  __typename?: 'FulfillmentOrderMerchantRequest';
  /** The fulfillment order associated with the merchant request. */
  fulfillmentOrder: FulfillmentOrder;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The kind of request made. */
  kind: FulfillmentOrderMerchantRequestKind;
  /** The optional message that the merchant included in the request. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Additional options requested by the merchant. These depend on the `kind` of the request.
   * For example, for a `FULFILLMENT_REQUEST`, one option is `notify_customer`, which indicates whether the
   * merchant intends to notify the customer upon fulfillment. The fulfillment service can then set
   * `notifyCustomer` when making calls to `FulfillmentCreate`.
   */
  requestOptions?: Maybe<Scalars['JSON']['output']>;
  /** The response from the fulfillment service. */
  responseData?: Maybe<Scalars['JSON']['output']>;
  /** The timestamp when the request was made. */
  sentAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple FulfillmentOrderMerchantRequests. */
export type FulfillmentOrderMerchantRequestConnection = {
  __typename?: 'FulfillmentOrderMerchantRequestConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<FulfillmentOrderMerchantRequestEdge>;
  /** A list of nodes that are contained in FulfillmentOrderMerchantRequestEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<FulfillmentOrderMerchantRequest>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderMerchantRequest and a cursor during pagination. */
export type FulfillmentOrderMerchantRequestEdge = {
  __typename?: 'FulfillmentOrderMerchantRequestEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentOrderMerchantRequestEdge. */
  node: FulfillmentOrderMerchantRequest;
};

/** The kinds of request merchants can make to a fulfillment service. */
export enum FulfillmentOrderMerchantRequestKind {
  /** The merchant requests cancellation of an `IN_PROGRESS` fulfillment order. */
  CancellationRequest = 'CANCELLATION_REQUEST',
  /** The merchant requests fulfillment for an `OPEN` fulfillment order. */
  FulfillmentRequest = 'FULFILLMENT_REQUEST'
}

/** The input fields for merging fulfillment orders. */
export type FulfillmentOrderMergeInput = {
  /** The details of the fulfillment orders to be merged. */
  mergeIntents: Array<FulfillmentOrderMergeInputMergeIntent>;
};

/** The input fields for merging fulfillment orders into a single merged fulfillment order. */
export type FulfillmentOrderMergeInputMergeIntent = {
  /** The ID of the fulfillment order to be merged. */
  fulfillmentOrderId: Scalars['ID']['input'];
  /** The fulfillment order line items to be merged. */
  fulfillmentOrderLineItems?: InputMaybe<Array<FulfillmentOrderLineItemInput>>;
};

/** Return type for `fulfillmentOrderMerge` mutation. */
export type FulfillmentOrderMergePayload = {
  __typename?: 'FulfillmentOrderMergePayload';
  /** The result of the fulfillment order merges. */
  fulfillmentOrderMerges?: Maybe<Array<FulfillmentOrderMergeResult>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderMergeUserError>;
};

/** The result of merging a set of fulfillment orders. */
export type FulfillmentOrderMergeResult = {
  __typename?: 'FulfillmentOrderMergeResult';
  /** The new fulfillment order as a result of the merge. */
  fulfillmentOrder: FulfillmentOrder;
};

/** An error that occurs during the execution of `FulfillmentOrderMerge`. */
export type FulfillmentOrderMergeUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderMergeUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderMergeUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderMergeUserError`. */
export enum FulfillmentOrderMergeUserErrorCode {
  /** The fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order line item quantity must be greater than 0. */
  GreaterThan = 'GREATER_THAN',
  /** The fulfillment order line item quantity is invalid. */
  InvalidLineItemQuantity = 'INVALID_LINE_ITEM_QUANTITY'
}

/** Represents a user error that occurs while moving a fulfillment order. */
export type FulfillmentOrderMoveFulfillmentOrderMoveUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderMoveFulfillmentOrderMoveUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderMoveFulfillmentOrderMoveUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderMoveFulfillmentOrderMoveUserError`. */
export enum FulfillmentOrderMoveFulfillmentOrderMoveUserErrorCode {
  /** Cannot move a fulfillment order that has progress reported. */
  CannotMoveFulfillmentOrderWithReportedProgress = 'CANNOT_MOVE_FULFILLMENT_ORDER_WITH_REPORTED_PROGRESS'
}

/** Return type for `fulfillmentOrderMove` mutation. */
export type FulfillmentOrderMovePayload = {
  __typename?: 'FulfillmentOrderMovePayload';
  /**
   * The fulfillment order which now contains the moved line items and is assigned to the destination location.
   *
   * If the original fulfillment order doesn't have any line items which are fully or partially fulfilled, the original fulfillment order will be moved to the new location.
   * However if this isn't the case, the moved fulfillment order will differ from the original one.
   */
  movedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The final state of the original fulfillment order.
   *
   * As a result of the move operation, the original fulfillment order might be moved to the new location
   * or remain in the original location. The original fulfillment order might have the same status or be closed.
   */
  originalFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** This field is deprecated. */
  remainingFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderMoveFulfillmentOrderMoveUserError>;
};

/** Return type for `fulfillmentOrderOpen` mutation. */
export type FulfillmentOrderOpenPayload = {
  __typename?: 'FulfillmentOrderOpenPayload';
  /** The fulfillment order that was transitioned to open and is fulfillable. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentOrderRejectCancellationRequest` mutation. */
export type FulfillmentOrderRejectCancellationRequestPayload = {
  __typename?: 'FulfillmentOrderRejectCancellationRequestPayload';
  /** The fulfillment order whose cancellation request was rejected. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentOrderRejectFulfillmentRequest` mutation. */
export type FulfillmentOrderRejectFulfillmentRequestPayload = {
  __typename?: 'FulfillmentOrderRejectFulfillmentRequestPayload';
  /** The fulfillment order whose fulfillment request was rejected. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The reason for a fulfillment order rejection. */
export enum FulfillmentOrderRejectionReason {
  /** The fulfillment order was rejected because of an incorrect address. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The fulfillment order was rejected because product information is incorrect to be able to ship. */
  IncorrectProductInfo = 'INCORRECT_PRODUCT_INFO',
  /** The fulfillment order was rejected because of an ineligible product. */
  IneligibleProduct = 'INELIGIBLE_PRODUCT',
  /** The fulfillment order was rejected because international address shipping hasn't been enabled. */
  InternationalShippingUnavailable = 'INTERNATIONAL_SHIPPING_UNAVAILABLE',
  /** The fulfillment order was rejected because of invalid customer contact information. */
  InvalidContactInformation = 'INVALID_CONTACT_INFORMATION',
  /** The fulfillment order was rejected because of an invalid SKU. */
  InvalidSku = 'INVALID_SKU',
  /** The fulfillment order was rejected because inventory is out of stock. */
  InventoryOutOfStock = 'INVENTORY_OUT_OF_STOCK',
  /** The fulfillment order was rejected because the merchant is blocked or suspended. */
  MerchantBlockedOrSuspended = 'MERCHANT_BLOCKED_OR_SUSPENDED',
  /** The fulfillment order was rejected because customs information was missing for international shipping. */
  MissingCustomsInfo = 'MISSING_CUSTOMS_INFO',
  /** The fulfillment order was rejected because the order is too large. */
  OrderTooLarge = 'ORDER_TOO_LARGE',
  /** The fulfillment order was rejected for another reason. */
  Other = 'OTHER',
  /** The fulfillment order was rejected because the package preference was not set. */
  PackagePreferenceNotSet = 'PACKAGE_PREFERENCE_NOT_SET',
  /** The fulfillment order was rejected because the payment method was declined. */
  PaymentDeclined = 'PAYMENT_DECLINED',
  /** The fulfillment order was rejected because of an undeliverable destination. */
  UndeliverableDestination = 'UNDELIVERABLE_DESTINATION'
}

/** Return type for `fulfillmentOrderReleaseHold` mutation. */
export type FulfillmentOrderReleaseHoldPayload = {
  __typename?: 'FulfillmentOrderReleaseHoldPayload';
  /** The fulfillment order on which the hold was released. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderReleaseHoldUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderReleaseHold`. */
export type FulfillmentOrderReleaseHoldUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderReleaseHoldUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderReleaseHoldUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderReleaseHoldUserError`. */
export enum FulfillmentOrderReleaseHoldUserErrorCode {
  /** The fulfillment order wasn't found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The app doesn't have access to release the fulfillment hold. */
  InvalidAccess = 'INVALID_ACCESS'
}

/** The input fields for the progress report for the fulfillment order. */
export type FulfillmentOrderReportProgressInput = {
  /** Additional information for the progress report. */
  reasonNotes?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `fulfillmentOrderReportProgress` mutation. */
export type FulfillmentOrderReportProgressPayload = {
  __typename?: 'FulfillmentOrderReportProgressPayload';
  /** The fulfillment order on which a mark as in progress update has been specified. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderReportProgressUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderReportProgress`. */
export type FulfillmentOrderReportProgressUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderReportProgressUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderReportProgressUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderReportProgressUserError`. */
export enum FulfillmentOrderReportProgressUserErrorCode {
  /** The fulfillment order contains picked items. */
  FulfillmentOrderContainsPickedItems = 'FULFILLMENT_ORDER_CONTAINS_PICKED_ITEMS',
  /** Progress cannot be reported for a fulfillment order with this delivery method. */
  FulfillmentOrderInvalidDeliveryMethod = 'FULFILLMENT_ORDER_INVALID_DELIVERY_METHOD',
  /** The fulfillment order is not assigned to the requesting fulfillment service. */
  FulfillmentOrderInvalidFulfillmentServiceOwnership = 'FULFILLMENT_ORDER_INVALID_FULFILLMENT_SERVICE_OWNERSHIP',
  /** The fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order status is invalid. */
  FulfillmentOrderStatusInvalid = 'FULFILLMENT_ORDER_STATUS_INVALID',
  /** The action is not supported for the fulfillment order. */
  FulfillmentOrderUnsupportedAction = 'FULFILLMENT_ORDER_UNSUPPORTED_ACTION',
  /** Marketplace apps are not eligible to report progress on fulfillment orders. */
  MarketplaceAppNotEligible = 'MARKETPLACE_APP_NOT_ELIGIBLE'
}

/** The request status of a fulfillment order. */
export enum FulfillmentOrderRequestStatus {
  /** The fulfillment service accepted the merchant's fulfillment request. */
  Accepted = 'ACCEPTED',
  /** The fulfillment service accepted the merchant's fulfillment cancellation request. */
  CancellationAccepted = 'CANCELLATION_ACCEPTED',
  /** The fulfillment service rejected the merchant's fulfillment cancellation request. */
  CancellationRejected = 'CANCELLATION_REJECTED',
  /** The merchant requested a cancellation of the fulfillment request for this fulfillment order. */
  CancellationRequested = 'CANCELLATION_REQUESTED',
  /** The fulfillment service closed the fulfillment order without completing it. */
  Closed = 'CLOSED',
  /** The fulfillment service rejected the merchant's fulfillment request. */
  Rejected = 'REJECTED',
  /** The merchant requested fulfillment for this fulfillment order. */
  Submitted = 'SUBMITTED',
  /**
   * The initial request status for the newly-created fulfillment orders. This is the only valid
   * request status for fulfillment orders that aren't assigned to a fulfillment service.
   */
  Unsubmitted = 'UNSUBMITTED'
}

/** Return type for `fulfillmentOrderReschedule` mutation. */
export type FulfillmentOrderReschedulePayload = {
  __typename?: 'FulfillmentOrderReschedulePayload';
  /**
   * A fulfillment order with the rescheduled line items.
   *
   * Fulfillment orders may be merged if they have the same `fulfillAt` datetime.
   *
   * If the fulfillment order is merged then the resulting fulfillment order will be returned.
   * Otherwise the original fulfillment order will be returned with an updated `fulfillAt` datetime.
   */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderRescheduleUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderReschedule`. */
export type FulfillmentOrderRescheduleUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderRescheduleUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderRescheduleUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderRescheduleUserError`. */
export enum FulfillmentOrderRescheduleUserErrorCode {
  /** Fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND'
}

/** The set of valid sort keys for the FulfillmentOrder query. */
export enum FulfillmentOrderSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The input fields for the split applied to the fulfillment order. */
export type FulfillmentOrderSplitInput = {
  /** The ID of the fulfillment order to be split. */
  fulfillmentOrderId: Scalars['ID']['input'];
  /** The fulfillment order line items to be split out. */
  fulfillmentOrderLineItems: Array<FulfillmentOrderLineItemInput>;
};

/** Return type for `fulfillmentOrderSplit` mutation. */
export type FulfillmentOrderSplitPayload = {
  __typename?: 'FulfillmentOrderSplitPayload';
  /** The result of the fulfillment order splits. */
  fulfillmentOrderSplits?: Maybe<Array<FulfillmentOrderSplitResult>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrderSplitUserError>;
};

/** The result of splitting a fulfillment order. */
export type FulfillmentOrderSplitResult = {
  __typename?: 'FulfillmentOrderSplitResult';
  /** The original fulfillment order as a result of the split. */
  fulfillmentOrder: FulfillmentOrder;
  /** The remaining fulfillment order as a result of the split. */
  remainingFulfillmentOrder: FulfillmentOrder;
  /** The replacement fulfillment order if the original fulfillment order wasn't in a state to be split. */
  replacementFulfillmentOrder?: Maybe<FulfillmentOrder>;
};

/** An error that occurs during the execution of `FulfillmentOrderSplit`. */
export type FulfillmentOrderSplitUserError = DisplayableError & {
  __typename?: 'FulfillmentOrderSplitUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrderSplitUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrderSplitUserError`. */
export enum FulfillmentOrderSplitUserErrorCode {
  /** The fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order line item quantity must be greater than 0. */
  GreaterThan = 'GREATER_THAN',
  /** The fulfillment order line item quantity is invalid. */
  InvalidLineItemQuantity = 'INVALID_LINE_ITEM_QUANTITY',
  /** The fulfillment order must have at least one line item input to split. */
  NoLineItemsProvidedToSplit = 'NO_LINE_ITEMS_PROVIDED_TO_SPLIT'
}

/** The status of a fulfillment order. */
export enum FulfillmentOrderStatus {
  /** The fulfillment order has been cancelled by the merchant. */
  Cancelled = 'CANCELLED',
  /** The fulfillment order has been completed and closed. */
  Closed = 'CLOSED',
  /** The fulfillment order cannot be completed as requested. */
  Incomplete = 'INCOMPLETE',
  /** The fulfillment order is being processed. */
  InProgress = 'IN_PROGRESS',
  /** The fulfillment order is on hold. The fulfillment process can't be initiated until the hold on the fulfillment order is released. */
  OnHold = 'ON_HOLD',
  /** The fulfillment order is ready for fulfillment. */
  Open = 'OPEN',
  /** The fulfillment order is deferred and will be ready for fulfillment after the date and time specified in `fulfill_at`. */
  Scheduled = 'SCHEDULED'
}

/** Return type for `fulfillmentOrderSubmitCancellationRequest` mutation. */
export type FulfillmentOrderSubmitCancellationRequestPayload = {
  __typename?: 'FulfillmentOrderSubmitCancellationRequestPayload';
  /** The fulfillment order specified in the cancelation request. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentOrderSubmitFulfillmentRequest` mutation. */
export type FulfillmentOrderSubmitFulfillmentRequestPayload = {
  __typename?: 'FulfillmentOrderSubmitFulfillmentRequestPayload';
  /** The original fulfillment order intended to request fulfillment for. */
  originalFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The fulfillment order that was submitted to the fulfillment service. This will be the same as
   * the original fulfillment order field. The exception to this is partial fulfillment requests or
   * fulfillment request for cancelled or incomplete fulfillment orders.
   */
  submittedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * This field will only be present for partial fulfillment requests. This will represent the new
   * fulfillment order with the remaining line items not submitted to the fulfillment service.
   */
  unsubmittedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** One of the actions that the fulfillment order supports in its current state. */
export type FulfillmentOrderSupportedAction = {
  __typename?: 'FulfillmentOrderSupportedAction';
  /** The action value. */
  action: FulfillmentOrderAction;
  /**
   * The external URL to be used to initiate the fulfillment process outside Shopify.
   * Applicable only when the `action` value is `EXTERNAL`.
   */
  externalUrl?: Maybe<Scalars['URL']['output']>;
};

/** Return type for `fulfillmentOrdersReroute` mutation. */
export type FulfillmentOrdersReroutePayload = {
  __typename?: 'FulfillmentOrdersReroutePayload';
  /** The fulfillment orders which contains the moved line items. */
  movedFulfillmentOrders?: Maybe<Array<FulfillmentOrder>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrdersRerouteUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrdersReroute`. */
export type FulfillmentOrdersRerouteUserError = DisplayableError & {
  __typename?: 'FulfillmentOrdersRerouteUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrdersRerouteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrdersRerouteUserError`. */
export enum FulfillmentOrdersRerouteUserErrorCode {
  /** Cannot move a fulfillment order that has progress reported. */
  CannotMoveFulfillmentOrderWithReportedProgress = 'CANNOT_MOVE_FULFILLMENT_ORDER_WITH_REPORTED_PROGRESS',
  /** Cannot reassign location for fulfillment orders. */
  CannotReassignLocationForFulfillmentOrders = 'CANNOT_REASSIGN_LOCATION_FOR_FULFILLMENT_ORDERS',
  /** The delivery method type is not supported. */
  DeliveryMethodTypeNotSupported = 'DELIVERY_METHOD_TYPE_NOT_SUPPORTED',
  /** Fulfillment orders must belong to the same location. */
  FulfillmentOrdersMustBelongToSameLocation = 'FULFILLMENT_ORDERS_MUST_BELONG_TO_SAME_LOCATION',
  /** Fulfillment orders are not from the same order. */
  FulfillmentOrdersNotFromTheSameOrder = 'FULFILLMENT_ORDERS_NOT_FROM_THE_SAME_ORDER',
  /** All fulfillment orders must have status and request status compatible with reroutable states. */
  FulfillmentOrdersStateNotSupported = 'FULFILLMENT_ORDERS_STATE_NOT_SUPPORTED',
  /** Fulfillment order could not be found. */
  FulfillmentOrderNotFound = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** No fulfillment order IDs were provided. */
  NoFulfillmentOrderIds = 'NO_FULFILLMENT_ORDER_IDS',
  /** This feature is only supported for multi-location shops. */
  SingleLocationShopNotSupported = 'SINGLE_LOCATION_SHOP_NOT_SUPPORTED'
}

/** Return type for `fulfillmentOrdersSetFulfillmentDeadline` mutation. */
export type FulfillmentOrdersSetFulfillmentDeadlinePayload = {
  __typename?: 'FulfillmentOrdersSetFulfillmentDeadlinePayload';
  /** Whether the fulfillment deadline was successfully set. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<FulfillmentOrdersSetFulfillmentDeadlineUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrdersSetFulfillmentDeadline`. */
export type FulfillmentOrdersSetFulfillmentDeadlineUserError = DisplayableError & {
  __typename?: 'FulfillmentOrdersSetFulfillmentDeadlineUserError';
  /** The error code. */
  code?: Maybe<FulfillmentOrdersSetFulfillmentDeadlineUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `FulfillmentOrdersSetFulfillmentDeadlineUserError`. */
export enum FulfillmentOrdersSetFulfillmentDeadlineUserErrorCode {
  /** The fulfillment orders could not be found. */
  FulfillmentOrdersNotFound = 'FULFILLMENT_ORDERS_NOT_FOUND'
}

/** The address at which the fulfillment occurred. This object is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
export type FulfillmentOriginAddress = {
  __typename?: 'FulfillmentOriginAddress';
  /** The street address of the fulfillment location. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city in which the fulfillment location is located. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country code of the fulfillment location. */
  countryCode: Scalars['String']['output'];
  /** The province code of the fulfillment location. */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip code of the fulfillment location. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** The input fields used to include the address at which the fulfillment occurred. This input object is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
export type FulfillmentOriginAddressInput = {
  /** The street address of the fulfillment location. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The city in which the fulfillment location is located. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country of the fulfillment location. */
  countryCode: Scalars['String']['input'];
  /** The province of the fulfillment location. */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** The zip code of the fulfillment location. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A **Fulfillment Service** is a third party warehouse that prepares and ships orders
 * on behalf of the store owner. Fulfillment services charge a fee to package and ship items
 * and update product inventory levels. Some well known fulfillment services with Shopify integrations
 * include: Amazon, Shipwire, and Rakuten. When an app registers a new `FulfillmentService` on a store,
 * Shopify automatically creates a `Location` that's associated to the fulfillment service.
 * To learn more about fulfillment services, refer to
 * [Manage fulfillments as a fulfillment service app](https://shopify.dev/apps/fulfillment/fulfillment-service-apps)
 * guide.
 *
 * ## Mutations
 *
 * You can work with the `FulfillmentService` object with the
 * [fulfillmentServiceCreate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceCreate),
 * [fulfillmentServiceUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceUpdate),
 * and [fulfillmentServiceDelete](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceDelete)
 * mutations.
 *
 * ## Hosted endpoints
 *
 * Fulfillment service providers integrate with Shopify by providing Shopify with a set of hosted endpoints that
 * Shopify can query on certain conditions.
 * These endpoints must have a common prefix, and this prefix should be supplied in the `callbackUrl` parameter
 * in the
 * [fulfillmentServiceCreate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceCreate)
 * mutation.
 *
 * - Shopify sends POST requests to the `<callbackUrl>/fulfillment_order_notification` endpoint
 *   to notify the fulfillment service about fulfillment requests and fulfillment cancellation requests.
 *
 *   For more information, refer to
 *   [Receive fulfillment requests and cancellations](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#step-2-receive-fulfillment-requests-and-cancellations).
 * - Shopify sends GET requests to the `<callbackUrl>/fetch_tracking_numbers` endpoint to retrieve tracking numbers for orders
 *   if `trackingSupport` is set to `true`.
 *
 *   For more information, refer to
 *   [Enable tracking support](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#step-8-enable-tracking-support-optional).
 *
 *   Fulfillment services can also update tracking information using the
 *   [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate) mutation,
 *   rather than waiting for Shopify to ask for tracking numbers.
 * - Shopify sends GET requests to the `<callbackUrl>/fetch_stock` endpoint to retrieve
 *   on hand inventory levels for the fulfillment service location if `inventoryManagement` is set to `true`.
 *
 *   For more information, refer to
 *   [Sharing inventory levels with Shopify](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-10-optional-share-inventory-levels-with-shopify).
 *
 * To make sure you have everything set up correctly, you can test the `callbackUrl`-prefixed endpoints
 * in your development store.
 *
 * ## Resources and webhooks
 *
 * There are a variety of objects and webhooks that enable a fulfillment service to work.
 * To exchange fulfillment information with Shopify, fulfillment services use the
 * [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder),
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment) and
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order) objects and related mutations.
 * To act on fulfillment process events that happen on the Shopify side,
 * besides awaiting calls to `callbackUrl`-prefixed endpoints,
 * fulfillment services can subscribe to the
 * [fulfillment order](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * and [order](https://shopify.dev/api/admin-rest/latest/resources/webhook)
 * webhooks.
 */
export type FulfillmentService = {
  __typename?: 'FulfillmentService';
  /**
   * The callback URL that the fulfillment service has registered for requests. The following considerations apply:
   *
   * - Shopify queries the `<callbackUrl>/fetch_tracking_numbers` endpoint to retrieve tracking numbers
   *     for orders, if `trackingSupport` is set to `true`.
   * - Shopify queries the `<callbackUrl>/fetch_stock` endpoint to retrieve inventory levels,
   *     if `inventoryManagement` is set to `true`.
   * - Shopify uses the `<callbackUrl>/fulfillment_order_notification` endpoint to send
   *     [fulfillment and cancellation requests](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-9-optional-enable-tracking-support).
   */
  callbackUrl?: Maybe<Scalars['URL']['output']>;
  /** The date and time when the fulfillment service was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Whether the fulfillment service uses the [fulfillment order based workflow](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments) for managing fulfillments.
   *
   * As the migration is now finished, the `fulfillmentOrdersOptIn` property is [deprecated](
   * https://shopify.dev/changelog/deprecation-of-the-fulfillmentservice-fulfillmentordersoptin-field)
   * and is always set to `true` on correctly functioning fulfillment services.
   * @deprecated Migration period ended. All correctly functioning fulfillment services have `fulfillmentOrdersOptIn` set to `true`.
   */
  fulfillmentOrdersOptIn: Scalars['Boolean']['output'];
  /** Human-readable unique identifier for this fulfillment service. */
  handle: Scalars['String']['output'];
  /** The ID of the fulfillment service. */
  id: Scalars['ID']['output'];
  /** Whether the fulfillment service tracks product inventory and provides updates to Shopify. */
  inventoryManagement: Scalars['Boolean']['output'];
  /** Location associated with the fulfillment service. */
  location?: Maybe<Location>;
  /** Whether the fulfillment service requires products to be physically shipped. */
  requiresShippingMethod: Scalars['Boolean']['output'];
  /** The name of the fulfillment service as seen by merchants. */
  serviceName: Scalars['String']['output'];
  /** Whether the fulfillment service implemented the /fetch_tracking_numbers endpoint. */
  trackingSupport: Scalars['Boolean']['output'];
  /** Type associated with the fulfillment service. */
  type: FulfillmentServiceType;
};

/** Return type for `fulfillmentServiceCreate` mutation. */
export type FulfillmentServiceCreatePayload = {
  __typename?: 'FulfillmentServiceCreatePayload';
  /** The created fulfillment service. */
  fulfillmentService?: Maybe<FulfillmentService>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Actions that can be taken at the location when a client requests the deletion of the fulfillment service. */
export enum FulfillmentServiceDeleteInventoryAction {
  /** Deactivate and delete the inventory and location. */
  Delete = 'DELETE',
  /** Keep the inventory in place and convert the Fulfillment Service's location to be merchant managed. */
  Keep = 'KEEP',
  /** Transfer the inventory and other dependencies to the provided location. */
  Transfer = 'TRANSFER'
}

/** Return type for `fulfillmentServiceDelete` mutation. */
export type FulfillmentServiceDeletePayload = {
  __typename?: 'FulfillmentServiceDeletePayload';
  /** The ID of the deleted fulfillment service. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The type of a fulfillment service. */
export enum FulfillmentServiceType {
  /** Fulfillment by gift card. */
  GiftCard = 'GIFT_CARD',
  /** Manual fulfillment by the merchant. */
  Manual = 'MANUAL',
  /** Fullfillment by a third-party fulfillment service. */
  ThirdParty = 'THIRD_PARTY'
}

/** Return type for `fulfillmentServiceUpdate` mutation. */
export type FulfillmentServiceUpdatePayload = {
  __typename?: 'FulfillmentServiceUpdatePayload';
  /** The updated fulfillment service. */
  fulfillmentService?: Maybe<FulfillmentService>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The status of a fulfillment. */
export enum FulfillmentStatus {
  /** The fulfillment was canceled. */
  Cancelled = 'CANCELLED',
  /** There was an error with the fulfillment request. */
  Error = 'ERROR',
  /** The fulfillment request failed. */
  Failure = 'FAILURE',
  /**
   * The third-party fulfillment service has acknowledged the fulfillment and is processing it.
   * @deprecated This is a legacy status and is due to be deprecated.
   */
  Open = 'OPEN',
  /**
   * Shopify has created the fulfillment and is waiting for the third-party fulfillment service to transition it to `open` or `success`.
   * @deprecated This is a legacy status and is due to be deprecated.
   */
  Pending = 'PENDING',
  /** The fulfillment was completed successfully. */
  Success = 'SUCCESS'
}

/** Represents the tracking information for a fulfillment. */
export type FulfillmentTrackingInfo = {
  __typename?: 'FulfillmentTrackingInfo';
  /**
   * The name of the tracking company.
   *
   * For tracking company names from the list below
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface. This doesn't mean
   * that Shopify automatically updates the fulfillment's `shipment_status` field in Admin.
   *
   * For tracking companies whose `shipment_status` field is updated automatically, see the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers).
   *
   * ### Supported tracking companies
   *
   * The following tracking companies display for shops located in any country:
   *
   *   * 4PX
   *   * AGS
   *   * Amazon
   *   * Amazon Logistics UK
   *   * An Post
   *   * Anjun Logistics
   *   * APC
   *   * Asendia USA
   *   * Australia Post
   *   * Bonshaw
   *   * BPost
   *   * BPost International
   *   * Better Trucks
   *   * Canada Post
   *   * Canpar
   *   * CDL Last Mile
   *   * China Post
   *   * Chronopost
   *   * Chukou1
   *   * Colissimo
   *   * Comingle
   *   * Coordinadora
   *   * Correios
   *   * Correos
   *   * CTT
   *   * CTT Express
   *   * Cyprus Post
   *   * Delnext
   *   * Deutsche Post
   *   * DHL eCommerce
   *   * DHL eCommerce Asia
   *   * DHL Express
   *   * DPD
   *   * DPD Local
   *   * DPD UK
   *   * DTD Express
   *   * DX
   *   * Eagle
   *   * Estes
   *   * Evri
   *   * FedEx
   *   * FedEx Freight
   *   * First Global Logistics
   *   * First Line
   *   * FSC
   *   * Fulfilla
   *   * GLS
   *   * Guangdong Weisuyi Information Technology (WSE)
   *   * Heppner Internationale Spedition GmbH & Co.
   *   * Iceland Post
   *   * IDEX
   *   * Israel Post
   *   * Japan Post (EN)
   *   * Japan Post (JA)
   *   * La Poste Colissimo
   *   * La Poste Burkina Faso
   *   * Lasership
   *   * Latvia Post
   *   * Lietuvos Paštas
   *   * Logisters
   *   * Lone Star Overnight
   *   * M3 Logistics
   *   * Meteor Space
   *   * Mondial Relay
   *   * New Zealand Post
   *   * NinjaVan
   *   * North Russia Supply Chain (Shenzhen) Co.
   *   * OnTrac
   *   * Packeta
   *   * Pago Logistics
   *   * Ping An Da Tengfei Express
   *   * Pitney Bowes
   *   * Portal PostNord
   *   * Poste Italiane
   *   * PostNL
   *   * PostNord DK
   *   * PostNord NO
   *   * PostNord SE
   *   * Purolator
   *   * Qxpress
   *   * Qyun Express
   *   * Royal Mail
   *   * Royal Shipments
   *   * Sagawa (EN)
   *   * Sagawa (JA)
   *   * Sendle
   *   * SF Express
   *   * SFC Fulfillment
   *   * ShipBob
   *   * SHREE NANDAN COURIER
   *   * Singapore Post
   *   * Southwest Air Cargo
   *   * SpeedX
   *   * StarTrack
   *   * Step Forward Freight
   *   * Swiss Post
   *   * TForce Final Mile
   *   * Tinghao
   *   * TNT
   *   * Toll IPEC
   *   * United Delivery Service
   *   * Uni Uni
   *   * UPS
   *   * USPS
   *   * Venipak
   *   * We Post
   *   * Whistl
   *   * Wizmo
   *   * WMYC
   *   * Xpedigo
   *   * XPO Logistics
   *   * Yamato (EN)
   *   * Yamato (JA)
   *   * YiFan Express
   *   * YunExpress
   *
   * The following tracking companies are displayed for shops located in specific countries:
   *
   *   * **Australia**: Australia Post, Sendle, Aramex Australia, TNT Australia, Hunter Express, Couriers Please, Bonds, Allied Express, Direct Couriers, Northline, GO Logistics
   *   * **Austria**: Österreichische Post
   *   * **Bulgaria**: Speedy
   *   * **Canada**: Intelcom, BoxKnight, Loomis, GLS
   *   * **China**: China Post, DHL eCommerce Asia, WanbExpress, YunExpress, Anjun Logistics, SFC Fulfillment, FSC
   *   * **Czechia**: Zásilkovna
   *   * **Germany**: Deutsche Post (DE), Deutsche Post (EN), DHL, DHL Express, Swiship, Hermes, GLS
   *   * **Spain**: SEUR
   *   * **France**: Colissimo, Mondial Relay, Colis Privé, GLS
   *   * **United Kingdom**: Evri, DPD UK, Parcelforce, Yodel, DHL Parcel, Tuffnells
   *   * **Greece**: ACS Courier
   *   * **Hong Kong SAR**: SF Express
   *   * **Ireland**: Fastway, DPD Ireland
   *   * **India**: DTDC, India Post, Delhivery, Gati KWE, Professional Couriers, XpressBees, Ecom Express, Ekart, Shadowfax, Bluedart
   *   * **Italy**: BRT, GLS Italy
   *   * **Japan**: エコ配, 西濃運輸, 西濃スーパーエキスプレス, 福山通運, 日本通運, 名鉄運輸, 第一貨物
   *   * **Netherlands**: DHL Parcel, DPD
   *   * **Norway**: Bring
   *   * **Poland**: Inpost
   *   * **Turkey**: PTT, Yurtiçi Kargo, Aras Kargo, Sürat Kargo
   *   * **United States**: GLS, Alliance Air Freight, Pilot Freight, LSO, Old Dominion, Pandion, R+L Carriers, Southwest Air Cargo
   *   * **South Africa**: Fastway, Skynet.
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number is clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking url provided in the `url` field.
   * * [Shopify-known tracking company name](#supported-tracking-companies) specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URL.
   */
  number?: Maybe<Scalars['String']['output']>;
  /**
   * The URLs to track the fulfillment.
   *
   * The tracking URL is displayed in the merchant's admin on the order page.
   * The tracking URL is displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, it's also displayed in the customer's order history.
   */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Return type for `fulfillmentTrackingInfoUpdate` mutation. */
export type FulfillmentTrackingInfoUpdatePayload = {
  __typename?: 'FulfillmentTrackingInfoUpdatePayload';
  /** The updated fulfillment with tracking information. */
  fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `fulfillmentTrackingInfoUpdateV2` mutation. */
export type FulfillmentTrackingInfoUpdateV2Payload = {
  __typename?: 'FulfillmentTrackingInfoUpdateV2Payload';
  /** The updated fulfillment with tracking information. */
  fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * The input fields that specify all possible fields for tracking information.
 *
 * > Note:
 * > If you provide the `url` field, you should not provide the `urls` field.
 * >
 * > If you provide the `number` field, you should not provide the `numbers` field.
 * >
 * > If you provide the `url` field, you should provide the `number` field.
 * >
 * > If you provide the `urls` field, you should provide the `numbers` field.
 */
export type FulfillmentTrackingInput = {
  /**
   * The name of the tracking company.
   *
   * If you specify a tracking company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies),
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface. This doesn't mean
   * that Shopify automatically updates the fulfillment's `shipment_status` field in Admin.
   * The same tracking company will be applied to all tracking numbers specified.
   *
   * For tracking companies whose `shipment_status` field is updated automatically, see the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers).
   *
   * > Note:
   * > Send the tracking company name exactly as written in
   * > [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * > (capitalization matters).
   */
  company?: InputMaybe<Scalars['String']['input']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking url provided in the `url` field.
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URL.
   */
  number?: InputMaybe<Scalars['String']['input']>;
  /**
   * The tracking numbers of the fulfillment, one or many.
   *
   * With multiple tracking numbers, you can provide tracking information
   * for all shipments associated with the fulfillment, if there are more than one.
   * For example, if you're shipping assembly parts of one furniture item in several boxes.
   *
   * Tracking numbers will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking URLs provided in the `urls` field.
   *   The tracking URLs will be matched to the tracking numbers based on their positions in the arrays.
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build tracking URLs automatically for all tracking numbers specified.
   *   The same tracking company will be applied to all tracking numbers.
   * * Tracking numbers have a Shopify-known format.
   *   Shopify will guess tracking providers and build tracking URLs based on the tracking number formats.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URLs.
   */
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The URL to track the fulfillment.
   *
   * The tracking URL is displayed in the merchant's admin on the order page.
   * The tracking URL is displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, it's also displayed in the customer's order history.
   *
   * The URL must be an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   * For example, `"https://www.myshipping.com/track/?tracknumbers=TRACKING_NUMBER"` is a valid URL.
   * It includes a scheme (`https`) and a host (`myshipping.com`).
   */
  url?: InputMaybe<Scalars['URL']['input']>;
  /**
   * The URLs to track the fulfillment, one or many.
   *
   * The tracking URLs are displayed in the merchant's admin on the order page.
   * The tracking URLs are displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, the tracking URLs are also displayed in the customer's order history.
   *
   * If you're not specifying a
   * [Shopify-known](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * tracking company name in the `company` field,
   * then provide tracking URLs for all tracking numbers from the `numbers` field.
   *
   * Tracking URLs from the `urls` array field are being matched with the tracking numbers from the `numbers` array
   * field correspondingly their positions in the arrays.
   *
   * Each URL must be an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   * For example, `"https://www.myshipping.com/track/?tracknumbers=TRACKING_NUMBER"` is a valid URL.
   * It includes a scheme (`https`) and a host (`myshipping.com`).
   */
  urls?: InputMaybe<Array<Scalars['URL']['input']>>;
};

/** The input fields used to create a fulfillment from fulfillment orders. */
export type FulfillmentV2Input = {
  /**
   * Pairs of `fulfillment_order_id` and `fulfillment_order_line_items` that represent the fulfillment
   * order line items that have to be fulfilled for each fulfillment order.  For any given pair, if the
   * fulfillment order line items are left blank then all the fulfillment order line items of the
   * associated fulfillment order ID will be fulfilled.
   */
  lineItemsByFulfillmentOrder: Array<FulfillmentOrderLineItemsInput>;
  /**
   * Whether the customer is notified.
   * If `true`, then a notification is sent when the fulfillment is created. The default value is `false`.
   */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address information about the location from which the order was fulfilled. */
  originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /**
   * The fulfillment's tracking information, including a tracking URL, a tracking number,
   * and the company associated with the fulfillment.
   */
  trackingInfo?: InputMaybe<FulfillmentTrackingInput>;
};

/** Trace information for a single country-language product feed sync triggered by [`channelFullSync`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelFullSync). */
export type FullSyncTraceInfo = {
  __typename?: 'FullSyncTraceInfo';
  /** The country of the product feed that was triggered. */
  country: CountryCode;
  /** The language of the product feed that was triggered. */
  language: LanguageCode;
  /** The operation ID of a successfully initiated product full sync operation. This field is set to nil when the full sync operation isn't successfully initiated. */
  operationId?: Maybe<Scalars['ID']['output']>;
};

/** The App Bridge information for a Shopify Function. */
export type FunctionsAppBridge = {
  __typename?: 'FunctionsAppBridge';
  /** The relative path for creating a customization. */
  createPath: Scalars['String']['output'];
  /** The relative path for viewing a customization. */
  detailsPath: Scalars['String']['output'];
};

/** The error history from running a Shopify Function. */
export type FunctionsErrorHistory = {
  __typename?: 'FunctionsErrorHistory';
  /** The date and time that the first error occurred. */
  errorsFirstOccurredAt: Scalars['DateTime']['output'];
  /** The date and time that the first error occurred. */
  firstOccurredAt: Scalars['DateTime']['output'];
  /** Whether the merchant has shared all the recent errors with the developer. */
  hasBeenSharedSinceLastError: Scalars['Boolean']['output'];
  /** Whether the merchant has shared all the recent errors with the developer. */
  hasSharedRecentErrors: Scalars['Boolean']['output'];
};

/** Represents any file other than HTML. */
export type GenericFile = File & Node & {
  __typename?: 'GenericFile';
  /** A word or phrase to describe the contents or the function of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The generic file's MIME type. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The generic file's size in bytes. */
  originalFileSize?: Maybe<Scalars['Int']['output']>;
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The generic file's URL. */
  url?: Maybe<Scalars['URL']['output']>;
};

/**
 * A gift card that customers use as a payment method. Stores the initial value, current balance, and expiration date.
 *
 * You can issue gift cards to a specific [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) or send them to a [`GiftCardRecipient`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardRecipient) with a personalized message. The card tracks its transaction history through [`GiftCardCreditTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardCreditTransaction) and [`GiftCardDebitTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardDebitTransaction) records. You can create and deactivate gift cards using the [`GiftCardCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardCreate) and [`GiftCardDeactivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardDeactivate) mutations, respectively.
 *
 * > Note: After a gift card is deactivated, it can't be used for further purchases or re-enabled.
 */
export type GiftCard = Node & {
  __typename?: 'GiftCard';
  /** The gift card's remaining balance. */
  balance: MoneyV2;
  /** The date and time at which the gift card was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The strategy used to convert the gift card's balance when it's redeemed in a currency other than the one it was issued in. */
  crossCurrencyRedemptionStrategy: GiftCardCrossCurrencyRedemptionStrategy;
  /** The customer that the gift card was sold or issued to, as opposed to the gift recipient. This customer can be reassigned. */
  customer?: Maybe<Customer>;
  /** The date and time at which the gift card was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the gift card is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The date at which the gift card will expire. */
  expiresOn?: Maybe<Scalars['Date']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The initial value of the gift card. */
  initialValue: MoneyV2;
  /** Whether the gift card is redeemable in any active market currency. */
  isRedeemable: Scalars['Boolean']['output'];
  /** The final four characters of the gift card code. */
  lastCharacters: Scalars['String']['output'];
  /** The line item from an order that initiated the creation of this gift card. This value is `null` if the gift card was issued manually. */
  lineItem?: Maybe<LineItem>;
  /** The gift card code. Everything but the final four characters is masked. */
  maskedCode: Scalars['String']['output'];
  /** The note associated with the gift card, which isn't visible to the customer. */
  note?: Maybe<Scalars['String']['output']>;
  /** The order associated with the gift card. This value is `null` if the gift card was issued manually. */
  order?: Maybe<Order>;
  /** The recipient of the gift card and the details sent with it: preferred name, message, and send time. */
  recipientAttributes?: Maybe<GiftCardRecipient>;
  /** The theme template used to render the gift card online. */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /** The transaction history of the gift card. */
  transactions?: Maybe<GiftCardTransactionConnection>;
  /** The date and time at which the gift card was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A gift card that customers use as a payment method. Stores the initial value, current balance, and expiration date.
 *
 * You can issue gift cards to a specific [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) or send them to a [`GiftCardRecipient`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardRecipient) with a personalized message. The card tracks its transaction history through [`GiftCardCreditTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardCreditTransaction) and [`GiftCardDebitTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardDebitTransaction) records. You can create and deactivate gift cards using the [`GiftCardCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardCreate) and [`GiftCardDeactivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardDeactivate) mutations, respectively.
 *
 * > Note: After a gift card is deactivated, it can't be used for further purchases or re-enabled.
 */
export type GiftCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A cash out transaction where the gift card balance was redeemed for cash. */
export type GiftCardCashOutTransaction = GiftCardTransaction & HasMetafields & Node & {
  __typename?: 'GiftCardCashOutTransaction';
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  giftCard: GiftCard;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A note about the transaction. */
  note?: Maybe<Scalars['String']['output']>;
  /** The date and time when the transaction was processed. */
  processedAt: Scalars['DateTime']['output'];
};


/** A cash out transaction where the gift card balance was redeemed for cash. */
export type GiftCardCashOutTransactionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A cash out transaction where the gift card balance was redeemed for cash. */
export type GiftCardCashOutTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents information about the configuration of gift cards on the shop. */
export type GiftCardConfiguration = {
  __typename?: 'GiftCardConfiguration';
  /** The default expiration configuration of gift cards on the shop. This field is null if the shop hasn't set a default expiration for gift cards. */
  expirationConfiguration?: Maybe<GiftCardExpirationConfiguration>;
  /** The issue limit for gift cards in the default shop currency. */
  issueLimit: MoneyV2;
  /** The purchase limit for gift cards in the default shop currency. */
  purchaseLimit: MoneyV2;
};

/** The supported units for gift card expiration. */
export enum GiftCardConfigurationExpirationUnit {
  /** Gift cards expire in days. */
  Days = 'DAYS',
  /** Gift cards expire in months. */
  Months = 'MONTHS',
  /** Gift cards expire in years. */
  Years = 'YEARS'
}

/** An auto-generated type for paginating through multiple GiftCards. */
export type GiftCardConnection = {
  __typename?: 'GiftCardConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<GiftCardEdge>;
  /** A list of nodes that are contained in GiftCardEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<GiftCard>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to issue a gift card. */
export type GiftCardCreateInput = {
  /**
   * The gift card's code. It must be 8-20 characters long and contain only letters(a-z) and numbers(0-9).
   * It isn't case sensitive. If not provided, then a random code will be generated.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The strategy used to convert the gift card's balance when it's redeemed in a currency other than the one it was issued in. When not provided, defaults to `MARKET_FX` for gift cards issued in the shop's currency, and `NONE` for gift cards issued in a different currency. */
  crossCurrencyRedemptionStrategy?: InputMaybe<GiftCardCrossCurrencyRedemptionStrategy>;
  /** The ID of the customer the gift card is issued to, as opposed to the gift recipient. Requires `write_customers` access_scope. */
  customerId?: InputMaybe<Scalars['ID']['input']>;
  /** The date at which the gift card will expire. If not provided, then the gift card will never expire. */
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
  /** The initial amount of the gift card. */
  initialAmount?: InputMaybe<MoneyInput>;
  /** The note associated with the gift card, which isn't visible to the customer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The recipient attributes of the gift card. */
  recipientAttributes?: InputMaybe<GiftCardRecipientInput>;
  /**
   * The suffix of the Liquid template that's used to render the gift card online.
   * For example, if the value is `birthday`, then the gift card is rendered using the template `gift_card.birthday.liquid`.
   * If not provided, then the default `gift_card.liquid` template is used.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `giftCardCreate` mutation. */
export type GiftCardCreatePayload = {
  __typename?: 'GiftCardCreatePayload';
  /** The created gift card. */
  giftCard?: Maybe<GiftCard>;
  /** The created gift card's code. */
  giftCardCode?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardUserError>;
};

/** The input fields for a gift card credit transaction. */
export type GiftCardCreditInput = {
  /** The amount to credit the gift card. */
  creditAmount: MoneyInput;
  /** A note about the credit. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The date and time the credit was processed. Defaults to current date and time. */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Return type for `giftCardCredit` mutation. */
export type GiftCardCreditPayload = {
  __typename?: 'GiftCardCreditPayload';
  /** The gift card credit transaction that was created. */
  giftCardCreditTransaction?: Maybe<GiftCardCreditTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardTransactionUserError>;
};

/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransaction = GiftCardTransaction & HasMetafields & Node & {
  __typename?: 'GiftCardCreditTransaction';
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  giftCard: GiftCard;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A note about the transaction. */
  note?: Maybe<Scalars['String']['output']>;
  /** The date and time when the transaction was processed. */
  processedAt: Scalars['DateTime']['output'];
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The strategy used to convert the gift card's balance when it is redeemed in a currency other than the one it was issued in. */
export enum GiftCardCrossCurrencyRedemptionStrategy {
  /** The gift card is redeemed using the automatic or manual exchange rate configured in the market's currency setting when converting from shop currency. Only applicable for gift cards issued in the shop currency. */
  MarketFx = 'MARKET_FX',
  /** The gift card can only be redeemed in the currency it was issued in. It cannot be used for purchases in other currencies. */
  None = 'NONE',
  /** The gift card is redeemed using standard spot exchange rates between the redemption currency and the gift card currency. */
  SpotFx = 'SPOT_FX'
}

/** Return type for `giftCardDeactivate` mutation. */
export type GiftCardDeactivatePayload = {
  __typename?: 'GiftCardDeactivatePayload';
  /** The deactivated gift card. */
  giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardDeactivateUserError>;
};

/** An error that occurs during the execution of `GiftCardDeactivate`. */
export type GiftCardDeactivateUserError = DisplayableError & {
  __typename?: 'GiftCardDeactivateUserError';
  /** The error code. */
  code?: Maybe<GiftCardDeactivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `GiftCardDeactivateUserError`. */
export enum GiftCardDeactivateUserErrorCode {
  /** The gift card could not be found. */
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND'
}

/** The input fields for a gift card debit transaction. */
export type GiftCardDebitInput = {
  /** The amount to debit the gift card. */
  debitAmount: MoneyInput;
  /** A note about the debit. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The date and time the debit was processed. Defaults to current date and time. */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Return type for `giftCardDebit` mutation. */
export type GiftCardDebitPayload = {
  __typename?: 'GiftCardDebitPayload';
  /** The gift card debit transaction that was created. */
  giftCardDebitTransaction?: Maybe<GiftCardDebitTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardTransactionUserError>;
};

/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransaction = GiftCardTransaction & HasMetafields & Node & {
  __typename?: 'GiftCardDebitTransaction';
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  giftCard: GiftCard;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A note about the transaction. */
  note?: Maybe<Scalars['String']['output']>;
  /** The date and time when the transaction was processed. */
  processedAt: Scalars['DateTime']['output'];
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type which holds one GiftCard and a cursor during pagination. */
export type GiftCardEdge = {
  __typename?: 'GiftCardEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of GiftCardEdge. */
  node: GiftCard;
};

/** Possible error codes that can be returned by `GiftCardUserError`. */
export enum GiftCardErrorCode {
  /** The customer could not be found. */
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  /** The gift card's value exceeds the allowed limits. */
  GiftCardLimitExceeded = 'GIFT_CARD_LIMIT_EXCEEDED',
  /** The input value should be greater than the minimum allowed value. */
  GreaterThan = 'GREATER_THAN',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Missing a required argument. */
  MissingArgument = 'MISSING_ARGUMENT',
  /** The recipient could not be found. */
  RecipientNotFound = 'RECIPIENT_NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too big. */
  TooBig = 'TOO_BIG',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT'
}

/** Represents the default expiration configuration of gift cards on the shop. */
export type GiftCardExpirationConfiguration = {
  __typename?: 'GiftCardExpirationConfiguration';
  /** The unit for the default gift card expiration. */
  expirationUnit: GiftCardConfigurationExpirationUnit;
  /** The value for the default gift card expiration. */
  expirationValue: Scalars['Int']['output'];
};

/**
 * The input fields for creating or updating a gift card product with the
 * [`giftCardProductSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet)
 * mutation.
 *
 * For list fields like
 * [`variants`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet#arguments-input.fields.variants),
 * the mutation creates new entries, updates existing ones, and deletes any entries not included
 * in the input. All other fields update only when explicitly provided, leaving omitted fields
 * unchanged.
 */
export type GiftCardProductSetInput = {
  /** The IDs of collections that this product will be a member of. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Whether gift cards fulfilled from this product are redeemable in any payment currency supported by the store.
   *
   * > Note
   * > This value can't be changed after the product is created.
   */
  crossCurrencyRedeemable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /**
   * The files to associate with the product.
   *
   * Complexity cost: 1.9 per file.
   */
  files?: InputMaybe<Array<FileSetInput>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  giftCardTemplateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-readable string that's used to identify the product in URLs. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated (unless that handle
   * is already taken, in which case a suffix is added to make the handle unique).
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /**
   * The issuance currency for gift cards fulfilled from this product.
   *
   * > Note
   * > This value can't be changed after the product is created.
   */
  issuanceCurrency?: InputMaybe<CurrencyCode>;
  /**
   * The metafields to associate with this product.
   *
   * Complexity cost: 0.4 per metafield.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** List of custom product options and option values (maximum of 3 per product). */
  productOptions?: InputMaybe<Array<OptionSetInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo?: InputMaybe<SeoInput>;
  /** The status of the product. */
  status?: InputMaybe<ProductStatus>;
  /**
   * A list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name for the product that displays to customers. If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated.
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * A list of variants associated with the gift card product.
   *
   * Complexity cost: 0.2 per variant.
   */
  variants?: InputMaybe<Array<GiftCardProductVariantSetInput>>;
  /** The name of the product's vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `giftCardProductSet` mutation. */
export type GiftCardProductSetPayload = {
  __typename?: 'GiftCardProductSetPayload';
  /** The gift card product object. */
  product?: Maybe<Product>;
  /** The product set operation, returned when run in asynchronous mode. */
  productSetOperation?: Maybe<ProductSetOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardProductSetUserError>;
};

/** Defines errors for GiftCardProductSet mutation. */
export type GiftCardProductSetUserError = DisplayableError & {
  __typename?: 'GiftCardProductSetUserError';
  /** The error code. */
  code?: Maybe<GiftCardProductSetUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `GiftCardProductSetUserError`. */
export enum GiftCardProductSetUserErrorCode {
  /** An option cannot have both metafield linked and nonlinked option values. */
  CannotCombineLinkedAndNonlinkedOptionValues = 'CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** Duplicated metafield value for linked option. */
  DuplicatedMetafieldValue = 'DUPLICATED_METAFIELD_VALUE',
  /** Duplicated option name. */
  DuplicatedOptionName = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DuplicatedOptionValue = 'DUPLICATED_OPTION_VALUE',
  /** Duplicated value. */
  DuplicatedValue = 'DUPLICATED_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DuplicateLinkedOption = 'DUPLICATE_LINKED_OPTION',
  /** Something went wrong, please try again. */
  GenericError = 'GENERIC_ERROR',
  /** Gift card products can only be created after they have been activated. */
  GiftCardsNotActivated = 'GIFT_CARDS_NOT_ACTIVATED',
  /** The product gift_card attribute cannot be changed after creation. */
  GiftCardAttributeCannotBeChanged = 'GIFT_CARD_ATTRIBUTE_CANNOT_BE_CHANGED',
  /** Handle already in use. Please provide a new handle. */
  HandleNotUnique = 'HANDLE_NOT_UNIQUE',
  /** The id field is not allowed if identifier is provided. */
  IdNotAllowed = 'ID_NOT_ALLOWED',
  /** The identifier value does not match the value of the corresponding field in the input. */
  InputMismatch = 'INPUT_MISMATCH',
  /** Input is not valid. */
  InvalidInput = 'INVALID_INPUT',
  /** Metafield is not valid. */
  InvalidMetafield = 'INVALID_METAFIELD',
  /** Invalid metafield value for linked option. */
  InvalidMetafieldValueForLinkedOption = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** Product is not valid. */
  InvalidProduct = 'INVALID_PRODUCT',
  /** Product variant is not valid. */
  InvalidVariant = 'INVALID_VARIANT',
  /** Error processing request in the background job. */
  JobError = 'JOB_ERROR',
  /** No valid metafield definition found for linked option. */
  LinkedMetafieldDefinitionNotFound = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Linked options are currently not supported for this shop. */
  LinkedOptionsNotSupportedForShop = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** The input argument `metafields` (if present) must contain the `customId` value. */
  MetafieldMismatch = 'METAFIELD_MISMATCH',
  /** The input field corresponding to the identifier is required. */
  MissingFieldRequired = 'MISSING_FIELD_REQUIRED',
  /** Resource matching the identifier was not found. */
  NotFound = 'NOT_FOUND',
  /** Options over limit. */
  OptionsOverLimit = 'OPTIONS_OVER_LIMIT',
  /** Option does not exist. */
  OptionDoesNotExist = 'OPTION_DOES_NOT_EXIST',
  /** Each option must have at least one option value specified. */
  OptionValuesMissing = 'OPTION_VALUES_MISSING',
  /** Option values over limit. */
  OptionValuesOverLimit = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value does not exist. */
  OptionValueDoesNotExist = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** The specified product is not a gift card. The giftCardProductSet mutation can only be used with gift card products. */
  ProductMustBeGiftCard = 'PRODUCT_MUST_BE_GIFT_CARD',
  /** Must specify product options when updating variants. */
  ProductOptionsInputMissing = 'PRODUCT_OPTIONS_INPUT_MISSING',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Product variant does not exist. */
  ProductVariantDoesNotExist = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Must specify variants when updating options. */
  VariantsInputMissing = 'VARIANTS_INPUT_MISSING',
  /** Number of product variants exceeds shop limit. */
  VariantsOverLimit = 'VARIANTS_OVER_LIMIT'
}

/**
 * The gift card configuration settings for a
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product),
 * including the
 * [`issuanceCurrency`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardProductSettings#field-GiftCardProductSettings.fields.issuanceCurrency)
 * and whether the gift card can be redeemed across currencies via
 * [`crossCurrencyRedeemable`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCardProductSettings#field-GiftCardProductSettings.fields.crossCurrencyRedeemable).
 * Configure these settings when creating a gift card product with the
 * [`giftCardProductSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet)
 * mutation.
 */
export type GiftCardProductSettings = {
  __typename?: 'GiftCardProductSettings';
  /** Whether the gift card can be redeemed in currencies other than the issuance currency. */
  crossCurrencyRedeemable: Scalars['Boolean']['output'];
  /**
   * The currency in which the gift card fulfilled by this product is issued.
   * When this field isn't set the gift card will be issued in the shop's currency, the return value of this field will be `null`.
   * When this field is set the gift card product can only be purchased in the issuance currency. A checkout violation will prevent purchases if the checkout currency doesn't match the issuance currency.
   * Extra care should be taken to only publish a gift card product with an issuance currency in markets where that currency can be guaranteed.
   */
  issuanceCurrency?: Maybe<CurrencyCode>;
};

/**
 * The input fields for specifying a gift card product variant to create or update with the
 * [`giftCardProductSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet)
 * mutation.
 *
 * Include an
 * [`id`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/GiftCardProductSetVariantInput#field-GiftCardProductSetVariantInput.fields.id)
 * to update an existing variant, or omit it to create a new one. Gift card variant defaults are
 * applied automatically, meaning variants are set to non-taxable, don't require shipping, and their inventory is untracked.
 */
export type GiftCardProductVariantSetInput = {
  /** The value of the barcode associated with the product. */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /**
   * The file to associate with the variant.
   *
   * Complexity cost: 0.6 per variant file.
   *
   * Any file specified here must also be specified in the `files` input for the product.
   */
  file?: InputMaybe<FileSetInput>;
  /** Specifies the product variant to update or create a new variant if absent. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Additional customizable information about the product variant.
   *
   * Complexity cost: 0.4 per variant metafield.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The custom properties that a shop owner uses to define product variants. */
  optionValues: Array<VariantOptionValueInput>;
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The price of the variant. */
  price?: InputMaybe<Scalars['Money']['input']>;
  /** Indicates whether the product variant is created as published or unpublished. This option is only available for new product variants. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU for the variant. Case-sensitive string. */
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a recipient who will receive the issued gift card. */
export type GiftCardRecipient = {
  __typename?: 'GiftCardRecipient';
  /** The message sent with the gift card. */
  message?: Maybe<Scalars['String']['output']>;
  /** The preferred name of the recipient who will receive the gift card. */
  preferredName?: Maybe<Scalars['String']['output']>;
  /** The recipient who will receive the gift card. */
  recipient: Customer;
  /** The scheduled datetime on which the gift card will be sent to the recipient. The gift card will be sent within an hour of the specified datetime. */
  sendNotificationAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The input fields to add a recipient to a gift card. */
export type GiftCardRecipientInput = {
  /** The ID of the customer who will be the recipient of the gift card. Requires `write_customers` access_scope. */
  id: Scalars['ID']['input'];
  /** The personalized message intended for the recipient. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The preferred name of the recipient. */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /** The scheduled datetime on which the gift card will be sent to the recipient. The gift card will be sent within an hour of the specified datetime. */
  sendNotificationAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A sale associated with a gift card. */
export type GiftCardSale = Sale & {
  __typename?: 'GiftCardSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line item for the associated sale. */
  lineItem: LineItem;
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** Return type for `giftCardSendNotificationToCustomer` mutation. */
export type GiftCardSendNotificationToCustomerPayload = {
  __typename?: 'GiftCardSendNotificationToCustomerPayload';
  /** The gift card that was sent. */
  giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardSendNotificationToCustomerUserError>;
};

/** An error that occurs during the execution of `GiftCardSendNotificationToCustomer`. */
export type GiftCardSendNotificationToCustomerUserError = DisplayableError & {
  __typename?: 'GiftCardSendNotificationToCustomerUserError';
  /** The error code. */
  code?: Maybe<GiftCardSendNotificationToCustomerUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `GiftCardSendNotificationToCustomerUserError`. */
export enum GiftCardSendNotificationToCustomerUserErrorCode {
  /** The customer could not be found. */
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  /** The gift card could not be found. */
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND',
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `giftCardSendNotificationToRecipient` mutation. */
export type GiftCardSendNotificationToRecipientPayload = {
  __typename?: 'GiftCardSendNotificationToRecipientPayload';
  /** The gift card that was sent. */
  giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<GiftCardSendNotificationToRecipientUserError>;
};

/** An error that occurs during the execution of `GiftCardSendNotificationToRecipient`. */
export type GiftCardSendNotificationToRecipientUserError = DisplayableError & {
  __typename?: 'GiftCardSendNotificationToRecipientUserError';
  /** The error code. */
  code?: Maybe<GiftCardSendNotificationToRecipientUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `GiftCardSendNotificationToRecipientUserError`. */
export enum GiftCardSendNotificationToRecipientUserErrorCode {
  /** The gift card could not be found. */
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The recipient could not be found. */
  RecipientNotFound = 'RECIPIENT_NOT_FOUND'
}

/** The set of valid sort keys for the GiftCard query. */
export enum GiftCardSortKeys {
  /** Sort by the `amount_spent` value. */
  AmountSpent = 'AMOUNT_SPENT',
  /** Sort by the `balance` value. */
  Balance = 'BALANCE',
  /** Sort by the `code` value. */
  Code = 'CODE',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `customer_name` value. */
  CustomerName = 'CUSTOMER_NAME',
  /** Sort by the `disabled_at` value. */
  DisabledAt = 'DISABLED_AT',
  /** Sort by the `expires_on` value. */
  ExpiresOn = 'EXPIRES_ON',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `initial_value` value. */
  InitialValue = 'INITIAL_VALUE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Interface for a gift card transaction. */
export type GiftCardTransaction = {
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  giftCard: GiftCard;
  /** The unique ID for the transaction. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** A note about the transaction. */
  note?: Maybe<Scalars['String']['output']>;
  /** The date and time when the transaction was processed. */
  processedAt: Scalars['DateTime']['output'];
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple GiftCardTransactions. */
export type GiftCardTransactionConnection = {
  __typename?: 'GiftCardTransactionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<GiftCardTransactionEdge>;
  /** A list of nodes that are contained in GiftCardTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<GiftCardTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one GiftCardTransaction and a cursor during pagination. */
export type GiftCardTransactionEdge = {
  __typename?: 'GiftCardTransactionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of GiftCardTransactionEdge. */
  node: GiftCardTransaction;
};

/** Represents an error that happens during the execution of a gift card transaction mutation. */
export type GiftCardTransactionUserError = DisplayableError & {
  __typename?: 'GiftCardTransactionUserError';
  /** The error code. */
  code?: Maybe<GiftCardTransactionUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `GiftCardTransactionUserError`. */
export enum GiftCardTransactionUserErrorCode {
  /** The gift card's value exceeds the allowed limits. */
  GiftCardLimitExceeded = 'GIFT_CARD_LIMIT_EXCEEDED',
  /** The gift card could not be found. */
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND',
  /** The gift card does not have sufficient funds to satisfy the request. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The currency provided does not match the currency of the gift card. */
  MismatchingCurrency = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used. */
  NegativeOrZeroAmount = 'NEGATIVE_OR_ZERO_AMOUNT'
}

/** The input fields to update a gift card. */
export type GiftCardUpdateInput = {
  /** The strategy used to convert the gift card's balance when it's redeemed in a currency other than the one it was issued in. */
  crossCurrencyRedemptionStrategy?: InputMaybe<GiftCardCrossCurrencyRedemptionStrategy>;
  /** The ID of the customer the gift card is issued to, as opposed to the gift recipient. Replaces the current customer, if any. Requires `write_customers` access_scope. */
  customerId?: InputMaybe<Scalars['ID']['input']>;
  /** The date at which the gift card will expire. If set to `null`, then the gift card will never expire. */
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
  /** The note associated with the gift card, which isn't visible to the customer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The recipient attributes of the gift card. */
  recipientAttributes?: InputMaybe<GiftCardRecipientInput>;
  /**
   * The suffix of the Liquid template that's used to render the gift card online.
   * For example, if the value is `birthday`, then the gift card is rendered using the template `gift_card.birthday.liquid`.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `giftCardUpdate` mutation. */
export type GiftCardUpdatePayload = {
  __typename?: 'GiftCardUpdatePayload';
  /** The updated gift card. */
  giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Represents an error that happens during the execution of a gift card mutation. */
export type GiftCardUserError = DisplayableError & {
  __typename?: 'GiftCardUserError';
  /** The error code. */
  code?: Maybe<GiftCardErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * Represents a summary of the current version of data in a resource.
 *
 * The `compare_digest` field can be used as input for mutations that implement a compare-and-swap mechanism.
 */
export type HasCompareDigest = {
  /** The data stored in the resource, represented as a digest. */
  compareDigest: Scalars['String']['output'];
};

/** Represents an object that has a list of events. */
export type HasEvents = {
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
};


/** Represents an object that has a list of events. */
export type HasEventsEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Localization extensions associated with the specified resource. For example, the tax id for government invoice. */
export type HasLocalizationExtensions = {
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  localizationExtensions: LocalizationExtensionConnection;
};


/** Localization extensions associated with the specified resource. For example, the tax id for government invoice. */
export type HasLocalizationExtensionsLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Localized fields associated with the specified resource. */
export type HasLocalizedFields = {
  /** List of localized fields for the resource. */
  localizedFields: LocalizedFieldConnection;
};


/** Localized fields associated with the specified resource. */
export type HasLocalizedFieldsLocalizedFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizedFieldPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Resources that metafield definitions can be applied to. */
export type HasMetafieldDefinitions = {
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
};


/** Resources that metafield definitions can be applied to. */
export type HasMetafieldDefinitionsMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};

/** Represents information about the metafields associated to the specified resource. */
export type HasMetafields = {
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields that identify metafield definitions. */
export type HasMetafieldsMetafieldIdentifierInput = {
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['input'];
  /**
   * The container for a group of metafields that the metafield definition will be associated with. If omitted, the
   * app-reserved namespace will be used.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Published translations associated with the resource. */
export type HasPublishedTranslations = {
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/** Published translations associated with the resource. */
export type HasPublishedTranslationsTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents information about the store credit accounts associated to the specified owner. */
export type HasStoreCreditAccounts = {
  /**
   * Returns a list of store credit accounts that belong to the owner resource.
   * A store credit account owner can hold multiple accounts each with a different currency.
   */
  storeCreditAccounts: StoreCreditAccountConnection;
};


/** Represents information about the store credit accounts associated to the specified owner. */
export type HasStoreCreditAccountsStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a customer's identity provider subject identifier. */
export type IdentityProviderSubject = Node & {
  __typename?: 'IdentityProviderSubject';
  /** The date and time when the provider subject was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID for the provider subject. */
  id: Scalars['ID']['output'];
  /** The merchant-configured name of the third-party identity provider. */
  providerName?: Maybe<Scalars['String']['output']>;
  /** The unique subject identifier assigned to the customer by the authentication provider. */
  subject: Scalars['String']['output'];
  /** The date and time when the provider subject was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an image resource. */
export type Image = HasMetafields & HasPublishedTranslations & {
  __typename?: 'Image';
  /** A word or phrase to share the nature or contents of an image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The original height of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  height?: Maybe<Scalars['Int']['output']>;
  /** A unique ID for the image. */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /**
   * The location of the original image as a URL.
   *
   * If there are any existing transformations in the original source URL, they will remain and not be stripped.
   * @deprecated Use `url` instead.
   */
  originalSrc: Scalars['URL']['output'];
  /**
   * The location of the image as a URL.
   * @deprecated Use `url` instead.
   */
  src: Scalars['URL']['output'];
  /**
   * The ThumbHash of the image.
   *
   * Useful to display placeholder images while the original image is loading.
   */
  thumbhash?: Maybe<Scalars['String']['output']>;
  /**
   * The location of the transformed image as a URL.
   *
   * All transformation arguments are considered "best-effort". If they can be applied to an image, they will be.
   * Otherwise any transformations which an image type doesn't support will be ignored.
   * @deprecated Use `url(transform:)` instead
   */
  transformedSrc: Scalars['URL']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /**
   * The location of the image as a URL.
   *
   * If no transform options are specified, then the original image will be preserved including any pre-applied transforms.
   *
   * All transformation options are considered "best-effort". Any transformation that the original image type doesn't support will be ignored.
   *
   * If you need multiple variations of the same image, then you can use [GraphQL aliases](https://graphql.org/learn/queries/#aliases).
   */
  url: Scalars['URL']['output'];
  /** The original width of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents an image resource. */
export type ImageMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an image resource. */
export type ImageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents an image resource. */
export type ImageTransformedSrcArgs = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  preferredContentType?: InputMaybe<ImageContentType>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an image resource. */
export type ImageTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


/** Represents an image resource. */
export type ImageUrlArgs = {
  transform?: InputMaybe<ImageTransformInput>;
};

/** An auto-generated type for paginating through multiple Images. */
export type ImageConnection = {
  __typename?: 'ImageConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ImageEdge>;
  /** A list of nodes that are contained in ImageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Image>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** List of supported image content types. */
export enum ImageContentType {
  /** A JPG image. */
  Jpg = 'JPG',
  /** A PNG image. */
  Png = 'PNG',
  /** A WEBP image. */
  Webp = 'WEBP'
}

/** An auto-generated type which holds one Image and a cursor during pagination. */
export type ImageEdge = {
  __typename?: 'ImageEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ImageEdge. */
  node: Image;
};

/** The input fields for an image. */
export type ImageInput = {
  /** A word or phrase to share the nature or contents of an image. */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** A globally-unique ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The URL of the image. May be a staged upload URL. */
  src?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The available options for transforming an image.
 *
 * All transformation options are considered best effort. Any transformation that the original image type doesn't support will be ignored.
 */
export type ImageTransformInput = {
  /**
   * The region of the image to remain after cropping.
   * Must be used in conjunction with the `maxWidth` and/or `maxHeight` fields, where the `maxWidth` and `maxHeight` aren't equal.
   * The `crop` argument should coincide with the smaller value. A smaller `maxWidth` indicates a `LEFT` or `RIGHT` crop, while
   * a smaller `maxHeight` indicates a `TOP` or `BOTTOM` crop. For example, `{ maxWidth: 5, maxHeight: 10, crop: LEFT }` will result
   * in an image with a width of 5 and height of 10, where the right side of the image is removed.
   */
  crop?: InputMaybe<CropRegion>;
  /** Image height in pixels between 1 and 5760. */
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Image width in pixels between 1 and 5760. */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Convert the source image into the preferred content type.
   * Supported conversions: `.svg` to `.png`, any file type to `.jpg`, and any file type to `.webp`.
   */
  preferredContentType?: InputMaybe<ImageContentType>;
  /** Image size multiplier for high-resolution retina displays. Must be within 1..3. */
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A parameter to upload an image.
 *
 * Deprecated in favor of
 * [StagedUploadParameter](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadParameter),
 * which is used in
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget)
 * and returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type ImageUploadParameter = {
  __typename?: 'ImageUploadParameter';
  /** The parameter name. */
  name: Scalars['String']['output'];
  /** The parameter value. */
  value: Scalars['String']['output'];
};

/** Answers the question if prices include duties and / or taxes. */
export enum InclusiveDutiesPricingStrategy {
  /** Add duties at checkout when configured to collect. */
  AddDutiesAtCheckout = 'ADD_DUTIES_AT_CHECKOUT',
  /** Include duties in price when configured to collect. */
  IncludeDutiesInPrice = 'INCLUDE_DUTIES_IN_PRICE'
}

/** Answers the question if prices include duties and / or taxes. */
export enum InclusiveTaxPricingStrategy {
  /** Add taxes at checkout when configured to collect. */
  AddTaxesAtCheckout = 'ADD_TAXES_AT_CHECKOUT',
  /** Include taxes in price when configured to collect. */
  IncludesTaxesInPrice = 'INCLUDES_TAXES_IN_PRICE',
  /** Include taxes in price based on country when configured to collect. */
  IncludesTaxesInPriceBasedOnCountry = 'INCLUDES_TAXES_IN_PRICE_BASED_ON_COUNTRY'
}

/** The input fields for the incoming line item. */
export type IncomingRequestLineItemInput = {
  /** The ID of the rejected line item. */
  fulfillmentOrderLineItemId: Scalars['ID']['input'];
  /** The rejection message of the line item. */
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `inventoryActivate` mutation. */
export type InventoryActivatePayload = {
  __typename?: 'InventoryActivatePayload';
  /** The inventory level that was activated. */
  inventoryLevel?: Maybe<InventoryLevel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields required to adjust inventory quantities. */
export type InventoryAdjustQuantitiesInput = {
  /** The quantity changes of items at locations to be made. */
  changes: Array<InventoryChangeInput>;
  /**
   * The quantity [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * to be adjusted.
   */
  name: Scalars['String']['input'];
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  reason: Scalars['String']['input'];
  /**
   * A URI that represents why the inventory change happened, identifying the source system and document that caused this adjustment. Enables complete audit trails and brand visibility in Shopify admin inventory history.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[entity-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/PurchaseOrder/PO-2024-001 (stock received)
   * - gid://3pl-system/CycleCount/CC-2024-0125 (cycle count adjustment)
   * - gid://pos-app/Transaction/TXN-98765 (in-store sale)
   * - gid://erp-connector/SyncJob/SYNC-2024-11-21-001 (ERP sync)
   * - gid://shopify/Order/1234567890 (Shopify order reference)
   *
   * Benefits: Your app name appears directly in merchant inventory history, reducing support tickets and providing clear audit trails for compliance.
   *
   * Alternative formats (also supported): https://myapp.com/documents/12345, custom-scheme://identifier
   *
   * Requirements: Valid URI with scheme and content. For GID format, all components (app, entity, id) must be present.
   */
  referenceDocumentUri?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `inventoryAdjustQuantities` mutation. */
export type InventoryAdjustQuantitiesPayload = {
  __typename?: 'InventoryAdjustQuantitiesPayload';
  /** The group of changes made by the operation. */
  inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryAdjustQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventoryAdjustQuantities`. */
export type InventoryAdjustQuantitiesUserError = DisplayableError & {
  __typename?: 'InventoryAdjustQuantitiesUserError';
  /** The error code. */
  code?: Maybe<InventoryAdjustQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryAdjustQuantitiesUserError`. */
export enum InventoryAdjustQuantitiesUserErrorCode {
  /** The quantities couldn't be adjusted. Try again. */
  AdjustQuantitiesFailed = 'ADJUST_QUANTITIES_FAILED',
  /** The changeFromQuantity argument no longer matches the persisted quantity. */
  ChangeFromQuantityStale = 'CHANGE_FROM_QUANTITY_STALE',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** Internal (gid://shopify/) ledger documents are not allowed to be adjusted via API. */
  InternalLedgerDocument = 'INTERNAL_LEDGER_DOCUMENT',
  /** A ledger document URI is not allowed when adjusting available. */
  InvalidAvailableDocument = 'INVALID_AVAILABLE_DOCUMENT',
  /** The specified inventory item could not be found. */
  InvalidInventoryItem = 'INVALID_INVENTORY_ITEM',
  /** The specified ledger document is invalid. */
  InvalidLedgerDocument = 'INVALID_LEDGER_DOCUMENT',
  /** The specified location could not be found. */
  InvalidLocation = 'INVALID_LOCATION',
  /** A ledger document URI is required except when adjusting available. */
  InvalidQuantityDocument = 'INVALID_QUANTITY_DOCUMENT',
  /** The specified quantity name is invalid. */
  InvalidQuantityName = 'INVALID_QUANTITY_NAME',
  /** The quantity can't be higher than 2,000,000,000. */
  InvalidQuantityTooHigh = 'INVALID_QUANTITY_TOO_HIGH',
  /** The quantity can't be lower than -2,000,000,000. */
  InvalidQuantityTooLow = 'INVALID_QUANTITY_TOO_LOW',
  /** The specified reason is invalid. */
  InvalidReason = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  InvalidReferenceDocument = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ItemNotStockedAtLocation = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** All changes must have the same ledger document URI or, in the case of adjusting available, no ledger document URI. */
  MaxOneLedgerDocument = 'MAX_ONE_LEDGER_DOCUMENT',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NonMutableInventoryItem = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The service is temporarily unavailable. Try again later. */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

/**
 * Records a batch of inventory changes made together in a single operation. Tracks which [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) or [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) initiated the changes, when they occurred, and why they were made.
 *
 * Provides an audit trail through its reason and reference document URI. The reference document URI links to the source that triggered the adjustment, such as an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order), [`InventoryTransfer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransfer), or external system event. Use the [`changes`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryAdjustmentGroup#field-InventoryAdjustmentGroup.fields.changes) field to retrieve the specific quantity adjustments for each inventory state at affected [locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location).
 */
export type InventoryAdjustmentGroup = Node & {
  __typename?: 'InventoryAdjustmentGroup';
  /** The app that triggered the inventory event, if one exists. */
  app?: Maybe<App>;
  /** The set of inventory quantity changes that occurred in the inventory event. */
  changes: Array<InventoryChange>;
  /** The date and time the inventory adjustment group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The reason for the group of adjustments. */
  reason: Scalars['String']['output'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously committed, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  referenceDocumentUri?: Maybe<Scalars['String']['output']>;
  /** The staff member associated with the inventory event. */
  staffMember?: Maybe<StaffMember>;
};


/**
 * Records a batch of inventory changes made together in a single operation. Tracks which [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) or [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) initiated the changes, when they occurred, and why they were made.
 *
 * Provides an audit trail through its reason and reference document URI. The reference document URI links to the source that triggered the adjustment, such as an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order), [`InventoryTransfer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransfer), or external system event. Use the [`changes`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryAdjustmentGroup#field-InventoryAdjustmentGroup.fields.changes) field to retrieve the specific quantity adjustments for each inventory state at affected [locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location).
 */
export type InventoryAdjustmentGroupChangesArgs = {
  inventoryItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantityNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields required to adjust the available quantity of a product variant at a location. */
export type InventoryAdjustmentInput = {
  /** The adjustment of the available quantity at the location. If the value is `null`, then the product variant is no longer stocked at the location. */
  adjustment?: InputMaybe<Scalars['Int']['input']>;
  /** The quantity to compare against before applying the delta. This field is mandatory- you must explicitly pass in a value (even if it's `null`), or else you will get an error. */
  changeFromQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the location where the available quantity should be adjusted. */
  locationId: Scalars['ID']['input'];
};

/** The input fields to specify whether the inventory item should be activated or not at the specified location. */
export type InventoryBulkToggleActivationInput = {
  /** Whether the inventory item can be stocked at the specified location. To deactivate, set the value to false which removes an inventory item's quantities from that location, and turns off inventory at that location. */
  activate: Scalars['Boolean']['input'];
  /** The ID of the location to modify the inventory item's stocked status. */
  locationId: Scalars['ID']['input'];
};

/** Return type for `inventoryBulkToggleActivation` mutation. */
export type InventoryBulkToggleActivationPayload = {
  __typename?: 'InventoryBulkToggleActivationPayload';
  /** The inventory item that was updated. */
  inventoryItem?: Maybe<InventoryItem>;
  /** The activated inventory levels. */
  inventoryLevels?: Maybe<Array<InventoryLevel>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryBulkToggleActivationUserError>;
};

/** An error that occurred while setting the activation status of an inventory item. */
export type InventoryBulkToggleActivationUserError = DisplayableError & {
  __typename?: 'InventoryBulkToggleActivationUserError';
  /** The error code. */
  code?: Maybe<InventoryBulkToggleActivationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryBulkToggleActivationUserError`. */
export enum InventoryBulkToggleActivationUserErrorCode {
  /** Cannot unstock an inventory item from the only location at which it is stocked. */
  CannotDeactivateFromOnlyLocation = 'CANNOT_DEACTIVATE_FROM_ONLY_LOCATION',
  /**
   * Cannot unstock this inventory item from this location because it has committed and incoming quantities.
   * @deprecated This error code is deprecated. Both INCOMING_INVENTORY_AT_LOCATION and COMMITTED_INVENTORY_AT_LOCATION codes will be returned as individual errors instead.
   */
  CommittedAndIncomingInventoryAtLocation = 'COMMITTED_AND_INCOMING_INVENTORY_AT_LOCATION',
  /** Cannot unstock this inventory item from this location because it has committed quantities. */
  CommittedInventoryAtLocation = 'COMMITTED_INVENTORY_AT_LOCATION',
  /** Failed to stock this inventory item at this location. */
  FailedToStockAtLocation = 'FAILED_TO_STOCK_AT_LOCATION',
  /** Failed to unstock this inventory item from this location. */
  FailedToUnstockFromLocation = 'FAILED_TO_UNSTOCK_FROM_LOCATION',
  /** An error occurred while setting the activation status. */
  GenericError = 'GENERIC_ERROR',
  /** Cannot unstock this inventory item from this location because it has incoming quantities. */
  IncomingInventoryAtLocation = 'INCOMING_INVENTORY_AT_LOCATION',
  /** The inventory item was not found. */
  InventoryItemNotFound = 'INVENTORY_ITEM_NOT_FOUND',
  /** Cannot stock this inventory item at this location because it is managed by a third-party fulfillment service. */
  InventoryManagedBy_3RdParty = 'INVENTORY_MANAGED_BY_3RD_PARTY',
  /** Cannot stock this inventory item at this location because it is managed by Shopify. */
  InventoryManagedByShopify = 'INVENTORY_MANAGED_BY_SHOPIFY',
  /** The location was not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** Cannot stock this inventory item at this location because the variant is missing a SKU. */
  MissingSku = 'MISSING_SKU',
  /** Cannot unstock this inventory item from this location because it has unavailable quantities. */
  ReservedInventoryAtLocation = 'RESERVED_INVENTORY_AT_LOCATION'
}

/**
 * A change in an inventory quantity of an inventory item at a location. Each change tracks how inventory moves between different states like available, committed, reserved, or damaged.
 *
 * The change captures the [amount changed](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryChange#field-InventoryChange.fields.delta), the resulting [quantity](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryChange#field-InventoryChange.fields.quantityAfterChange), and links to the associated [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) and [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location).
 *
 * The [`name`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryChange#field-InventoryChange.fields.name) field indicates which inventory state changed, such as `available`, `reserved`, or `damaged`. The [`ledgerDocumentUri`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryChange#field-InventoryChange.fields.ledgerDocumentUri) field provides an audit trail by referencing the source document or system that triggered the change.
 */
export type InventoryChange = {
  __typename?: 'InventoryChange';
  /** The amount by which the inventory quantity was changed. */
  delta: Scalars['Int']['output'];
  /** The inventory item associated with this inventory change. */
  item?: Maybe<InventoryItem>;
  /** A URI that represents what the inventory quantity change was applied to. */
  ledgerDocumentUri?: Maybe<Scalars['String']['output']>;
  /** The location associated with this inventory change. */
  location?: Maybe<Location>;
  /**
   * The [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * of the inventory quantity that was changed.
   */
  name: Scalars['String']['output'];
  /** The quantity of named inventory after the change. */
  quantityAfterChange?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for the change to be made to an inventory item at a location. */
export type InventoryChangeInput = {
  /**
   * The quantity currently expected at this location, before the delta is applied.
   *
   * This field enables a compare-and-swap (CAS) safety check. If the location’s current quantity doesn't match the value you provide, then the mutation fails with a `CHANGE_FROM_QUANTITY_STALE` error. This prevents unintended overwrites when the request is based on stale inventory data.
   *
   * To skip the CAS check, pass `null`. Use this only when your system is the source of truth for this inventory and you don’t need to protect against concurrent updates.
   * This field is mandatory: you must explicitly pass in a value, even if that value is `null`, or the mutation returns an error.
   *
   * For more information, refer to the [compare and swap documentation](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#compare-and-swap).
   */
  changeFromQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The amount by which the inventory quantity will be changed. */
  delta: Scalars['Int']['input'];
  /** Specifies the inventory item to which the change will be applied. */
  inventoryItemId: Scalars['ID']['input'];
  /**
   * A non-Shopify URI that identifies what specific inventory transaction or ledger entry was changed. Represents the exact inventory movement being referenced, distinct from the business reason for the change.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[transaction-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/InventoryTransaction/TXN-2024-001 (specific transaction)
   * - gid://3pl-system/StockMovement/SM-2024-0125 (stock movement record)
   * - gid://pos-app/InventoryUpdate/UPD-98765 (POS inventory update)
   * - gid://erp-connector/LedgerEntry/LE-2024-11-21-001 (ledger entry)
   *
   * Requirements: Valid non-Shopify URI with scheme and content. Required for all quantity names except `available`. Cannot use gid://shopify/* format.
   */
  ledgerDocumentUri?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the location at which the change will be applied. */
  locationId: Scalars['ID']['input'];
};

/** Return type for `inventoryDeactivate` mutation. */
export type InventoryDeactivatePayload = {
  __typename?: 'InventoryDeactivatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). It holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
 *
 * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
 *
 * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItem = LegacyInteroperability & Node & {
  __typename?: 'InventoryItem';
  /** The ISO 3166-1 alpha-2 country code of where the item originated from. */
  countryCodeOfOrigin?: Maybe<CountryCode>;
  /** A list of country specific harmonized system codes. */
  countryHarmonizedSystemCodes: CountryHarmonizedSystemCodeConnection;
  /** The date and time when the inventory item was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of inventory items that share the same SKU with this item. */
  duplicateSkuCount: Scalars['Int']['output'];
  /** The harmonized system code of the item. This must be a number between 6 and 13 digits. */
  harmonizedSystemCode?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The URL that points to the inventory history for the item. */
  inventoryHistoryUrl?: Maybe<Scalars['URL']['output']>;
  /** The inventory item's quantities at the specified location. */
  inventoryLevel?: Maybe<InventoryLevel>;
  /** A list of the inventory item's quantities for each location that the inventory item can be stocked at. */
  inventoryLevels: InventoryLevelConnection;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The number of locations where this inventory item is stocked. */
  locationsCount?: Maybe<Count>;
  /** The packaging dimensions of the inventory item. */
  measurement: InventoryItemMeasurement;
  /** The ISO 3166-2 alpha-2 province code of where the item originated from. */
  provinceCodeOfOrigin?: Maybe<Scalars['String']['output']>;
  /** Whether a customer needs to provide a shipping address when placing an order containing the inventory item. */
  requiresShipping: Scalars['Boolean']['output'];
  /** Inventory item SKU. Case-sensitive string. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Whether inventory levels are tracked for the item. */
  tracked: Scalars['Boolean']['output'];
  /** Whether the value of the `tracked` field for the inventory item can be changed. */
  trackedEditable: EditableProperty;
  /** Unit cost associated with the inventory item. The shop's currency is used. Note: the user must have "View product costs" permission granted in order to access this field once product granular permissions are enabled. */
  unitCost?: Maybe<MoneyV2>;
  /** The date and time when the inventory item was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The variant that owns this inventory item.
   * @deprecated Use `variants` instead.
   */
  variant: ProductVariant;
  /** A paginated list of the variants that reference this inventory item. */
  variants?: Maybe<ProductVariantConnection>;
};


/**
 * An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). It holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
 *
 * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
 *
 * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemCountryHarmonizedSystemCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). It holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
 *
 * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
 *
 * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemInventoryLevelArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
};


/**
 * An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). It holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
 *
 * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
 *
 * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemInventoryLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). It holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
 *
 * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
 *
 * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An auto-generated type for paginating through multiple InventoryItems. */
export type InventoryItemConnection = {
  __typename?: 'InventoryItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryItemEdge>;
  /** A list of nodes that are contained in InventoryItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryItem and a cursor during pagination. */
export type InventoryItemEdge = {
  __typename?: 'InventoryItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryItemEdge. */
  node: InventoryItem;
};

/** The input fields for an inventory item. */
export type InventoryItemInput = {
  /** Unit cost associated with the inventory item, the currency is the shop's default currency. */
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  /** The country where the item was manufactured or produced, specified using the standard two-letter [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code. */
  countryCodeOfOrigin?: InputMaybe<CountryCode>;
  /** List of country-specific harmonized system codes. */
  countryHarmonizedSystemCodes?: InputMaybe<Array<CountryHarmonizedSystemCodeInput>>;
  /** The harmonized system code of the inventory item. This must be a number between 6 and 13 digits. */
  harmonizedSystemCode?: InputMaybe<Scalars['String']['input']>;
  /** The measurements of an inventory item. */
  measurement?: InputMaybe<InventoryItemMeasurementInput>;
  /** The province where the item was manufactured or produced, specified using the standard two-letter [ISO 3166-2 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-2) province code. */
  provinceCodeOfOrigin?: InputMaybe<Scalars['String']['input']>;
  /** Whether the inventory item needs to be physically shipped to the customer. Items that require shipping are physical products, while digital goods and services typically don't require shipping and can be fulfilled electronically. */
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU (stock keeping unit) of the inventory item. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Whether the inventory item is tracked. */
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Weight information for an [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) when packaged. Provides the weight specification used for inventory management and shipping calculations. Learn more about [managing inventory](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps). */
export type InventoryItemMeasurement = Node & {
  __typename?: 'InventoryItemMeasurement';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The weight of the inventory item. */
  weight?: Maybe<Weight>;
};

/** The input fields for an inventory item measurement. */
export type InventoryItemMeasurementInput = {
  /** Shipping package associated with inventory item. */
  shippingPackageId?: InputMaybe<Scalars['ID']['input']>;
  /** The weight of the inventory item. */
  weight?: InputMaybe<WeightInput>;
};

/** Return type for `inventoryItemUpdate` mutation. */
export type InventoryItemUpdatePayload = {
  __typename?: 'InventoryItemUpdatePayload';
  /** The inventory item that was updated. */
  inventoryItem?: Maybe<InventoryItem>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * The quantities of an inventory item at a specific location. Each inventory level connects one [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) to one [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location), tracking multiple quantity states like available, on-hand, incoming, and committed.
 *
 * The [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field provides access to different inventory states. Learn [more about inventory states and relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevel = Node & {
  __typename?: 'InventoryLevel';
  /** Whether the inventory items associated with the inventory level can be deactivated. */
  canDeactivate: Scalars['Boolean']['output'];
  /** The date and time when the inventory level was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Describes either the impact of deactivating the inventory level, or why the inventory level can't be deactivated. */
  deactivationAlert?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the inventory level is active. */
  isActive: Scalars['Boolean']['output'];
  /** Inventory item associated with the inventory level. */
  item: InventoryItem;
  /** The location associated with the inventory level. */
  location: Location;
  /**
   * The quantity of an inventory item at a specific location, for a quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states).
   */
  quantities: Array<InventoryQuantity>;
  /**
   * Scheduled changes for the requested quantity names.
   * @deprecated Scheduled changes will be phased out in a future version.
   */
  scheduledChanges: InventoryScheduledChangeConnection;
  /** The date and time when the inventory level was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The quantities of an inventory item at a specific location. Each inventory level connects one [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) to one [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location), tracking multiple quantity states like available, on-hand, incoming, and committed.
 *
 * The [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field provides access to different inventory states. Learn [more about inventory states and relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevelQuantitiesArgs = {
  names: Array<Scalars['String']['input']>;
};


/**
 * The quantities of an inventory item at a specific location. Each inventory level connects one [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) to one [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location), tracking multiple quantity states like available, on-hand, incoming, and committed.
 *
 * The [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field provides access to different inventory states. Learn [more about inventory states and relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevelScheduledChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ScheduledChangeSortKeys>;
};

/** An auto-generated type for paginating through multiple InventoryLevels. */
export type InventoryLevelConnection = {
  __typename?: 'InventoryLevelConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryLevelEdge>;
  /** A list of nodes that are contained in InventoryLevelEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryLevel>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryLevel and a cursor during pagination. */
export type InventoryLevelEdge = {
  __typename?: 'InventoryLevelEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryLevelEdge. */
  node: InventoryLevel;
};

/** The input fields for an inventory level. */
export type InventoryLevelInput = {
  /** The available quantity of an inventory item at a location. */
  availableQuantity: Scalars['Int']['input'];
  /** The ID of a location associated with the inventory level. */
  locationId: Scalars['ID']['input'];
};

/** The input fields required to move inventory quantities. */
export type InventoryMoveQuantitiesInput = {
  /** The quantity changes of items at locations to be made. */
  changes: Array<InventoryMoveQuantityChange>;
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  reason: Scalars['String']['input'];
  /**
   * A URI that represents why the inventory change happened, identifying the source system and document that caused this adjustment. Enables complete audit trails and brand visibility in Shopify admin inventory history.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[entity-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/PurchaseOrder/PO-2024-001 (stock received)
   * - gid://3pl-system/CycleCount/CC-2024-0125 (cycle count adjustment)
   * - gid://pos-app/Transaction/TXN-98765 (in-store sale)
   * - gid://erp-connector/SyncJob/SYNC-2024-11-21-001 (ERP sync)
   * - gid://shopify/Order/1234567890 (Shopify order reference)
   *
   * Benefits: Your app name appears directly in merchant inventory history, reducing support tickets and providing clear audit trails for compliance.
   *
   * Alternative formats (also supported): https://myapp.com/documents/12345, custom-scheme://identifier
   *
   * Requirements: Valid URI with scheme and content. For GID format, all components (app, entity, id) must be present.
   */
  referenceDocumentUri: Scalars['String']['input'];
};

/** Return type for `inventoryMoveQuantities` mutation. */
export type InventoryMoveQuantitiesPayload = {
  __typename?: 'InventoryMoveQuantitiesPayload';
  /** The group of changes made by the operation. */
  inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryMoveQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventoryMoveQuantities`. */
export type InventoryMoveQuantitiesUserError = DisplayableError & {
  __typename?: 'InventoryMoveQuantitiesUserError';
  /** The error code. */
  code?: Maybe<InventoryMoveQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryMoveQuantitiesUserError`. */
export enum InventoryMoveQuantitiesUserErrorCode {
  /** The changeFromQuantity argument no longer matches the persisted quantity. */
  ChangeFromQuantityStale = 'CHANGE_FROM_QUANTITY_STALE',
  /** The quantities can't be moved between different locations. */
  DifferentLocations = 'DIFFERENT_LOCATIONS',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** Internal (gid://shopify/) ledger documents are not allowed to be adjusted via API. */
  InternalLedgerDocument = 'INTERNAL_LEDGER_DOCUMENT',
  /** A ledger document URI is not allowed when adjusting available. */
  InvalidAvailableDocument = 'INVALID_AVAILABLE_DOCUMENT',
  /** The specified inventory item could not be found. */
  InvalidInventoryItem = 'INVALID_INVENTORY_ITEM',
  /** The specified ledger document is invalid. */
  InvalidLedgerDocument = 'INVALID_LEDGER_DOCUMENT',
  /** The specified location could not be found. */
  InvalidLocation = 'INVALID_LOCATION',
  /** A ledger document URI is required except when adjusting available. */
  InvalidQuantityDocument = 'INVALID_QUANTITY_DOCUMENT',
  /** The specified quantity name is invalid. */
  InvalidQuantityName = 'INVALID_QUANTITY_NAME',
  /** The quantity can't be negative. */
  InvalidQuantityNegative = 'INVALID_QUANTITY_NEGATIVE',
  /** The quantity can't be higher than 2,000,000,000. */
  InvalidQuantityTooHigh = 'INVALID_QUANTITY_TOO_HIGH',
  /** The specified reason is invalid. */
  InvalidReason = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  InvalidReferenceDocument = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ItemNotStockedAtLocation = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** Only a maximum of 2 ledger document URIs across all changes is allowed. */
  MaximumLedgerDocumentUris = 'MAXIMUM_LEDGER_DOCUMENT_URIS',
  /** The quantities couldn't be moved. Try again. */
  MoveQuantitiesFailed = 'MOVE_QUANTITIES_FAILED',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NonMutableInventoryItem = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The quantity names for each change can't be the same. */
  SameQuantityName = 'SAME_QUANTITY_NAME',
  /** The service is temporarily unavailable. Try again later. */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

/**
 * Represents the change to be made to an inventory item at a location.
 * The change can either involve the same quantity name between different locations,
 * or involve different quantity names between the same location.
 */
export type InventoryMoveQuantityChange = {
  /** Details about where the move will be made from. */
  from: InventoryMoveQuantityTerminalInput;
  /** Specifies the inventory item to which the change will be applied. */
  inventoryItemId: Scalars['ID']['input'];
  /** The amount by which the inventory quantity will be changed. */
  quantity: Scalars['Int']['input'];
  /** Details about where the move will be made to. */
  to: InventoryMoveQuantityTerminalInput;
};

/** The input fields representing the change to be made to an inventory item at a location. */
export type InventoryMoveQuantityTerminalInput = {
  /**
   * The quantity currently expected at this location, before the move is applied.
   *
   * This field enables a compare-and-swap (CAS) safety check. If the location’s current quantity doesn't match the value you provide, then the mutation fails with a `CHANGE_FROM_QUANTITY_STALE` error. This helps prevent unintended overwrites when the request is based on stale inventory data.
   *
   * To skip the CAS check, pass `null`. Use this only when your system is the source of truth for this inventory and you don’t need to protect against concurrent updates.
   * This field is mandatory: you must explicitly pass in a value, even if that value is `null`, or the mutation returns an error.
   *
   * For more information, refer to the [compare and swap documentation](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#compare-and-swap).
   */
  changeFromQuantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A non-Shopify URI that identifies what specific inventory transaction or ledger entry was changed. Represents the exact inventory movement being referenced, distinct from the business reason for the change.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[transaction-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/InventoryTransaction/TXN-2024-001 (specific transaction)
   * - gid://3pl-system/StockMovement/SM-2024-0125 (stock movement record)
   * - gid://pos-app/InventoryUpdate/UPD-98765 (POS inventory update)
   * - gid://erp-connector/LedgerEntry/LE-2024-11-21-001 (ledger entry)
   *
   * Requirements: Valid non-Shopify URI with scheme and content. Required for all quantity names except `available`. Cannot use gid://shopify/* format.
   */
  ledgerDocumentUri?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the location at which the change will be applied. */
  locationId: Scalars['ID']['input'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states) to be
   * moved.
   */
  name: Scalars['String']['input'];
};

/** General inventory properties for the shop. */
export type InventoryProperties = {
  __typename?: 'InventoryProperties';
  /** All the quantity names. */
  quantityNames: Array<InventoryQuantityName>;
};

/**
 * The `InventoryQuantity` object lets you manage and track inventory quantities for specific [states](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states).
 * Inventory quantities represent different states of items such as available for purchase, committed to orders, draft orders, transfers, or shipments, reserved by the merchant, incoming from suppliers, or set aside for quality control or safety stock.
 *
 * You can use [inventory levels](https://shopify.dev/docs/api/admin-graphql/latest/objects/inventorylevel) to manage where inventory items are stocked. You can also [make inventory adjustments](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryAdjustQuantities) to apply changes to inventory quantities.
 *
 * Inventory quantities can be managed by a merchant or by [fulfillment services](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentservice) that handle inventory tracking.
 * Learn more about working with [Shopify's inventory management system](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps).
 */
export type InventoryQuantity = Node & {
  __typename?: 'InventoryQuantity';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The inventory state [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * that identifies the inventory quantity.
   */
  name: Scalars['String']['output'];
  /**
   * The quantity of an inventory item at a specific location, for a quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states).
   */
  quantity: Scalars['Int']['output'];
  /** When the inventory quantity was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The input fields for the quantity to be set for an inventory item at a location. */
export type InventoryQuantityInput = {
  /**
   * The quantity currently expected at this location, before setting the new quantity.
   *
   * This field enables a compare-and-swap (CAS) safety check. If the location’s current quantity doesn't match the value you provide, then the mutation fails with a `CHANGE_FROM_QUANTITY_STALE` error. This helps prevent unintended overwrites when the request is based on stale inventory data.
   *
   * To skip the CAS check, pass `null`. Use this only when your system is the source of truth for this inventory and you don’t need to protect against concurrent updates.
   * This field is mandatory: you must explicitly pass in a value, even if that value is `null`, or the mutation returns an error.
   *
   * For more information, refer to the [compare and swap documentation](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#compare-and-swap).
   */
  changeFromQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the inventory item to which the quantity will be set. */
  inventoryItemId: Scalars['ID']['input'];
  /** Specifies the location at which the quantity will be set. */
  locationId: Scalars['ID']['input'];
  /** The quantity to which the inventory quantity will be set. */
  quantity: Scalars['Int']['input'];
};

/** Details about an individual quantity name. */
export type InventoryQuantityName = {
  __typename?: 'InventoryQuantityName';
  /** List of quantity names that this quantity name belongs to. */
  belongsTo: Array<Scalars['String']['output']>;
  /** List of quantity names that comprise this quantity name. */
  comprises: Array<Scalars['String']['output']>;
  /** The display name for quantity names translated into applicable language. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Whether the quantity name has been used by the merchant. */
  isInUse: Scalars['Boolean']['output'];
  /**
   * The [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states) of
   * the inventory quantity. Used by
   * [inventory queries and mutations](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#graphql-queries-and-mutations).
   */
  name: Scalars['String']['output'];
};

/** Returns the scheduled changes to inventory states related to the ledger document. */
export type InventoryScheduledChange = {
  __typename?: 'InventoryScheduledChange';
  /** The date and time that the scheduled change is expected to happen. */
  expectedAt: Scalars['DateTime']['output'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition from.
   */
  fromName: Scalars['String']['output'];
  /** The quantities of an inventory item that are related to a specific location. */
  inventoryLevel: InventoryLevel;
  /** A freeform URI that represents what changed the inventory quantities. */
  ledgerDocumentUri: Scalars['URL']['output'];
  /** The quantity of the scheduled change associated with the ledger document in the `fromName` state. */
  quantity: Scalars['Int']['output'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition to.
   */
  toName: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple InventoryScheduledChanges. */
export type InventoryScheduledChangeConnection = {
  __typename?: 'InventoryScheduledChangeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryScheduledChangeEdge>;
  /** A list of nodes that are contained in InventoryScheduledChangeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryScheduledChange>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryScheduledChange and a cursor during pagination. */
export type InventoryScheduledChangeEdge = {
  __typename?: 'InventoryScheduledChangeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryScheduledChangeEdge. */
  node: InventoryScheduledChange;
};

/** The input fields required to set inventory on hand quantities. */
export type InventorySetOnHandQuantitiesInput = {
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  reason: Scalars['String']['input'];
  /**
   * A URI that represents why the inventory change happened, identifying the source system and document that caused this adjustment. Enables complete audit trails and brand visibility in Shopify admin inventory history.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[entity-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/PurchaseOrder/PO-2024-001 (stock received)
   * - gid://3pl-system/CycleCount/CC-2024-0125 (cycle count adjustment)
   * - gid://pos-app/Transaction/TXN-98765 (in-store sale)
   * - gid://erp-connector/SyncJob/SYNC-2024-11-21-001 (ERP sync)
   * - gid://shopify/Order/1234567890 (Shopify order reference)
   *
   * Benefits: Your app name appears directly in merchant inventory history, reducing support tickets and providing clear audit trails for compliance.
   *
   * Alternative formats (also supported): https://myapp.com/documents/12345, custom-scheme://identifier
   *
   * Requirements: Valid URI with scheme and content. For GID format, all components (app, entity, id) must be present.
   */
  referenceDocumentUri?: InputMaybe<Scalars['String']['input']>;
  /** The value to which the on hand quantity will be set. */
  setQuantities: Array<InventorySetQuantityInput>;
};

/** Return type for `inventorySetOnHandQuantities` mutation. */
export type InventorySetOnHandQuantitiesPayload = {
  __typename?: 'InventorySetOnHandQuantitiesPayload';
  /** The group of changes made by the operation. */
  inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventorySetOnHandQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventorySetOnHandQuantities`. */
export type InventorySetOnHandQuantitiesUserError = DisplayableError & {
  __typename?: 'InventorySetOnHandQuantitiesUserError';
  /** The error code. */
  code?: Maybe<InventorySetOnHandQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventorySetOnHandQuantitiesUserError`. */
export enum InventorySetOnHandQuantitiesUserErrorCode {
  /** The changeFromQuantity argument no longer matches the persisted quantity. */
  ChangeFromQuantityStale = 'CHANGE_FROM_QUANTITY_STALE',
  /** The compareQuantity value does not match persisted value. */
  CompareQuantityStale = 'COMPARE_QUANTITY_STALE',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The specified inventory item could not be found. */
  InvalidInventoryItem = 'INVALID_INVENTORY_ITEM',
  /** The specified location could not be found. */
  InvalidLocation = 'INVALID_LOCATION',
  /** The quantity can't be negative. */
  InvalidQuantityNegative = 'INVALID_QUANTITY_NEGATIVE',
  /** The total quantity can't be higher than 1,000,000,000. */
  InvalidQuantityTooHigh = 'INVALID_QUANTITY_TOO_HIGH',
  /** The specified reason is invalid. */
  InvalidReason = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  InvalidReferenceDocument = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ItemNotStockedAtLocation = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NonMutableInventoryItem = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The service is temporarily unavailable. Try again later. */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  /** The on-hand quantities couldn't be set. Try again. */
  SetOnHandQuantitiesFailed = 'SET_ON_HAND_QUANTITIES_FAILED'
}

/** The input fields required to set inventory quantities. */
export type InventorySetQuantitiesInput = {
  /** The name of quantities to be changed. The only accepted values are: `available` or `on_hand`. */
  name: Scalars['String']['input'];
  /** The values to which each quantities will be set. */
  quantities: Array<InventoryQuantityInput>;
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  reason: Scalars['String']['input'];
  /**
   * A URI that represents why the inventory change happened, identifying the source system and document that caused this adjustment. Enables complete audit trails and brand visibility in Shopify admin inventory history.
   *
   * Preferred format - Global ID (GID): gid://[your-app-name]/[entity-type]/[id]
   *
   * Examples:
   * - gid://warehouse-app/PurchaseOrder/PO-2024-001 (stock received)
   * - gid://3pl-system/CycleCount/CC-2024-0125 (cycle count adjustment)
   * - gid://pos-app/Transaction/TXN-98765 (in-store sale)
   * - gid://erp-connector/SyncJob/SYNC-2024-11-21-001 (ERP sync)
   * - gid://shopify/Order/1234567890 (Shopify order reference)
   *
   * Benefits: Your app name appears directly in merchant inventory history, reducing support tickets and providing clear audit trails for compliance.
   *
   * Alternative formats (also supported): https://myapp.com/documents/12345, custom-scheme://identifier
   *
   * Requirements: Valid URI with scheme and content. For GID format, all components (app, entity, id) must be present.
   */
  referenceDocumentUri?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `inventorySetQuantities` mutation. */
export type InventorySetQuantitiesPayload = {
  __typename?: 'InventorySetQuantitiesPayload';
  /** The group of changes made by the operation. */
  inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventorySetQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventorySetQuantities`. */
export type InventorySetQuantitiesUserError = DisplayableError & {
  __typename?: 'InventorySetQuantitiesUserError';
  /** The error code. */
  code?: Maybe<InventorySetQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventorySetQuantitiesUserError`. */
export enum InventorySetQuantitiesUserErrorCode {
  /** The changeFromQuantity value does not match persisted value. */
  ChangeFromQuantityStale = 'CHANGE_FROM_QUANTITY_STALE',
  /** The compareQuantity argument must be given to each quantity or ignored using ignoreCompareQuantity. */
  CompareQuantityRequired = 'COMPARE_QUANTITY_REQUIRED',
  /** The compareQuantity value does not match persisted value. */
  CompareQuantityStale = 'COMPARE_QUANTITY_STALE',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The specified inventory item could not be found. */
  InvalidInventoryItem = 'INVALID_INVENTORY_ITEM',
  /** The specified location could not be found. */
  InvalidLocation = 'INVALID_LOCATION',
  /** The quantity name must be either 'available' or 'on_hand'. */
  InvalidName = 'INVALID_NAME',
  /** The quantity can't be negative. */
  InvalidQuantityNegative = 'INVALID_QUANTITY_NEGATIVE',
  /** The total quantity can't be higher than 1,000,000,000. */
  InvalidQuantityTooHigh = 'INVALID_QUANTITY_TOO_HIGH',
  /** The total quantity can't be lower than -1,000,000,000. */
  InvalidQuantityTooLow = 'INVALID_QUANTITY_TOO_LOW',
  /** The specified reason is invalid. */
  InvalidReason = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  InvalidReferenceDocument = 'INVALID_REFERENCE_DOCUMENT',
  /** The specified inventory item is not stocked at the location. */
  ItemNotStockedAtLocation = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NonMutableInventoryItem = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The combination of inventoryItemId and locationId must be unique. */
  NoDuplicateInventoryItemIdGroupIdPair = 'NO_DUPLICATE_INVENTORY_ITEM_ID_GROUP_ID_PAIR'
}

/** The input fields for the quantity to be set for an inventory item at a location. */
export type InventorySetQuantityInput = {
  /** The current quantity to be compared against the persisted quantity. This field is mandatory- you must explicitly pass in a value (even if it's `null`), or else you will get an error. For more information, refer to the [Compare and Swap documentation](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#compare-and-swap). */
  changeFromQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the inventory item to which the quantity will be set. */
  inventoryItemId: Scalars['ID']['input'];
  /** Specifies the location at which the quantity will be set. */
  locationId: Scalars['ID']['input'];
  /** The quantity to which the inventory quantity will be set. */
  quantity: Scalars['Int']['input'];
};

/** Represents an inventory shipment. */
export type InventoryShipment = Node & {
  __typename?: 'InventoryShipment';
  /** A unique barcode for the shipment. */
  barcode?: Maybe<Scalars['String']['output']>;
  /** The date the shipment was created in UTC. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the shipment was initially received in UTC. */
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  /** The date the shipment was shipped in UTC. */
  dateShipped?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The total quantity of all items in the shipment. */
  lineItemTotalQuantity: Scalars['Int']['output'];
  /** The line items included in this shipment. */
  lineItems?: Maybe<InventoryShipmentLineItemConnection>;
  /** The number of line items associated with the inventory shipment. Limited to a maximum of 10000 by default. */
  lineItemsCount?: Maybe<Count>;
  /** The name of the inventory shipment. */
  name: Scalars['String']['output'];
  /** The current status of the shipment. */
  status: InventoryShipmentStatus;
  /** The total quantity of items accepted across all line items in this shipment. */
  totalAcceptedQuantity: Scalars['Int']['output'];
  /** The total quantity of items accepted, rejected, or marked as canceled across all line items in this shipment. */
  totalReceivedQuantity: Scalars['Int']['output'];
  /** The total quantity of items rejected across all line items in this shipment. */
  totalRejectedQuantity: Scalars['Int']['output'];
  /** The tracking information for the shipment. */
  tracking?: Maybe<InventoryShipmentTracking>;
};


/** Represents an inventory shipment. */
export type InventoryShipmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShipmentLineItemSortKeys>;
};


/** Represents an inventory shipment. */
export type InventoryShipmentLineItemsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `inventoryShipmentAddItems` mutation. */
export type InventoryShipmentAddItemsPayload = {
  __typename?: 'InventoryShipmentAddItemsPayload';
  /** The list of added line items. */
  addedItems?: Maybe<Array<InventoryShipmentLineItem>>;
  /** The inventory shipment with the added items. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentAddItemsUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentAddItems`. */
export type InventoryShipmentAddItemsUserError = DisplayableError & {
  __typename?: 'InventoryShipmentAddItemsUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentAddItemsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentAddItemsUserError`. */
export enum InventoryShipmentAddItemsUserErrorCode {
  /** Failed to activate inventory at location. */
  ActivationFailed = 'ACTIVATION_FAILED',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** An auto-generated type for paginating through multiple InventoryShipments. */
export type InventoryShipmentConnection = {
  __typename?: 'InventoryShipmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryShipmentEdge>;
  /** A list of nodes that are contained in InventoryShipmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryShipment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `inventoryShipmentCreateInTransit` mutation. */
export type InventoryShipmentCreateInTransitPayload = {
  __typename?: 'InventoryShipmentCreateInTransitPayload';
  /** The created inventory shipment. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentCreateInTransitUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentCreateInTransit`. */
export type InventoryShipmentCreateInTransitUserError = DisplayableError & {
  __typename?: 'InventoryShipmentCreateInTransitUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentCreateInTransitUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentCreateInTransitUserError`. */
export enum InventoryShipmentCreateInTransitUserErrorCode {
  /** This barcode is already assigned to another shipment. */
  BarcodeDuplicate = 'BARCODE_DUPLICATE',
  /** Barcode must be 255 characters or less. */
  BarcodeTooLong = 'BARCODE_TOO_LONG',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** The shipment input cannot be empty. */
  EmptyShipmentInput = 'EMPTY_SHIPMENT_INPUT',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** One or more items are not valid. */
  InvalidItem = 'INVALID_ITEM',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** The shipment input is invalid. */
  InvalidShipmentInput = 'INVALID_SHIPMENT_INPUT',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The URL is invalid. */
  InvalidUrl = 'INVALID_URL',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The list of line items is empty. */
  ItemsEmpty = 'ITEMS_EMPTY',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** The input fields to add a shipment. */
export type InventoryShipmentCreateInput = {
  /** A unique barcode for the shipment. */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** The date the shipment was created. */
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  /** The list of line items for the inventory shipment. */
  lineItems: Array<InventoryShipmentLineItemInput>;
  /** The ID of the inventory movement (transfer or purchase order) this shipment belongs to. */
  movementId: Scalars['ID']['input'];
  /** The tracking information for the shipment. */
  trackingInput?: InputMaybe<InventoryShipmentTrackingInput>;
};

/** Return type for `inventoryShipmentCreate` mutation. */
export type InventoryShipmentCreatePayload = {
  __typename?: 'InventoryShipmentCreatePayload';
  /** The created inventory shipment. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentCreateUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentCreate`. */
export type InventoryShipmentCreateUserError = DisplayableError & {
  __typename?: 'InventoryShipmentCreateUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentCreateUserError`. */
export enum InventoryShipmentCreateUserErrorCode {
  /** This barcode is already assigned to another shipment. */
  BarcodeDuplicate = 'BARCODE_DUPLICATE',
  /** Barcode must be 255 characters or less. */
  BarcodeTooLong = 'BARCODE_TOO_LONG',
  /** Bundled items cannot be used for this operation. */
  BundledItem = 'BUNDLED_ITEM',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** The shipment input cannot be empty. */
  EmptyShipmentInput = 'EMPTY_SHIPMENT_INPUT',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The idempotency record was found but the associated scheduled changes no longer exist. */
  IdempotencyRecordNotFound = 'IDEMPOTENCY_RECORD_NOT_FOUND',
  /** One or more items are not valid. */
  InvalidItem = 'INVALID_ITEM',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** The shipment input is invalid. */
  InvalidShipmentInput = 'INVALID_SHIPMENT_INPUT',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The URL is invalid. */
  InvalidUrl = 'INVALID_URL',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** Return type for `inventoryShipmentDelete` mutation. */
export type InventoryShipmentDeletePayload = {
  __typename?: 'InventoryShipmentDeletePayload';
  /** The ID of the inventory shipment that was deleted. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentDeleteUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentDelete`. */
export type InventoryShipmentDeleteUserError = DisplayableError & {
  __typename?: 'InventoryShipmentDeleteUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentDeleteUserError`. */
export enum InventoryShipmentDeleteUserErrorCode {
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/** An auto-generated type which holds one InventoryShipment and a cursor during pagination. */
export type InventoryShipmentEdge = {
  __typename?: 'InventoryShipmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryShipmentEdge. */
  node: InventoryShipment;
};

/** Represents a single line item within an inventory shipment. */
export type InventoryShipmentLineItem = Node & {
  __typename?: 'InventoryShipmentLineItem';
  /** The quantity of items that were accepted in this shipment line item. */
  acceptedQuantity: Scalars['Int']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The inventory item associated with this line item. */
  inventoryItem?: Maybe<InventoryItem>;
  /** The quantity of items in this shipment line item. */
  quantity: Scalars['Int']['output'];
  /** The quantity of items that were rejected in this shipment line item. */
  rejectedQuantity: Scalars['Int']['output'];
  /** The total quantity of units that haven't been accepted, rejected, or marked as canceled in this shipment line item. */
  unreceivedQuantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple InventoryShipmentLineItems. */
export type InventoryShipmentLineItemConnection = {
  __typename?: 'InventoryShipmentLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryShipmentLineItemEdge>;
  /** A list of nodes that are contained in InventoryShipmentLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryShipmentLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryShipmentLineItem and a cursor during pagination. */
export type InventoryShipmentLineItemEdge = {
  __typename?: 'InventoryShipmentLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryShipmentLineItemEdge. */
  node: InventoryShipmentLineItem;
};

/** The input fields for a line item on an inventory shipment. */
export type InventoryShipmentLineItemInput = {
  /** The inventory item ID for the shipment line item. */
  inventoryItemId: Scalars['ID']['input'];
  /** The quantity for the shipment line item. */
  quantity: Scalars['Int']['input'];
};

/** Return type for `inventoryShipmentMarkInTransit` mutation. */
export type InventoryShipmentMarkInTransitPayload = {
  __typename?: 'InventoryShipmentMarkInTransitPayload';
  /** The marked in transit inventory shipment. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentMarkInTransitUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentMarkInTransit`. */
export type InventoryShipmentMarkInTransitUserError = DisplayableError & {
  __typename?: 'InventoryShipmentMarkInTransitUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentMarkInTransitUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentMarkInTransitUserError`. */
export enum InventoryShipmentMarkInTransitUserErrorCode {
  /** Failed to activate inventory at location. */
  ActivationFailed = 'ACTIVATION_FAILED',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The list of line items is empty. */
  ItemsEmpty = 'ITEMS_EMPTY',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** The input fields to receive an item on an inventory shipment. */
export type InventoryShipmentReceiveItemInput = {
  /** The quantity for the item to be received. */
  quantity: Scalars['Int']['input'];
  /** The reason for received item. */
  reason: InventoryShipmentReceiveLineItemReason;
  /** The shipment line item ID to be received. */
  shipmentLineItemId: Scalars['ID']['input'];
};

/** The reason for receiving a line item on an inventory shipment. */
export enum InventoryShipmentReceiveLineItemReason {
  /** The line item was accepted. */
  Accepted = 'ACCEPTED',
  /** The line item was rejected. */
  Rejected = 'REJECTED'
}

/** Return type for `inventoryShipmentReceive` mutation. */
export type InventoryShipmentReceivePayload = {
  __typename?: 'InventoryShipmentReceivePayload';
  /** The inventory shipment with received items. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentReceiveUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentReceive`. */
export type InventoryShipmentReceiveUserError = DisplayableError & {
  __typename?: 'InventoryShipmentReceiveUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentReceiveUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentReceiveUserError`. */
export enum InventoryShipmentReceiveUserErrorCode {
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/** Return type for `inventoryShipmentRemoveItems` mutation. */
export type InventoryShipmentRemoveItemsPayload = {
  __typename?: 'InventoryShipmentRemoveItemsPayload';
  /** The inventory shipment with items removed. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentRemoveItemsUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentRemoveItems`. */
export type InventoryShipmentRemoveItemsUserError = DisplayableError & {
  __typename?: 'InventoryShipmentRemoveItemsUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentRemoveItemsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentRemoveItemsUserError`. */
export enum InventoryShipmentRemoveItemsUserErrorCode {
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/** Return type for `inventoryShipmentSetBarcode` mutation. */
export type InventoryShipmentSetBarcodePayload = {
  __typename?: 'InventoryShipmentSetBarcodePayload';
  /** The inventory shipment with the updated barcode. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentSetBarcodeUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentSetBarcode`. */
export type InventoryShipmentSetBarcodeUserError = DisplayableError & {
  __typename?: 'InventoryShipmentSetBarcodeUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentSetBarcodeUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentSetBarcodeUserError`. */
export enum InventoryShipmentSetBarcodeUserErrorCode {
  /** This barcode is already assigned to another shipment. */
  BarcodeDuplicate = 'BARCODE_DUPLICATE',
  /** Barcode must be 255 characters or less. */
  BarcodeTooLong = 'BARCODE_TOO_LONG',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/** Return type for `inventoryShipmentSetTracking` mutation. */
export type InventoryShipmentSetTrackingPayload = {
  __typename?: 'InventoryShipmentSetTrackingPayload';
  /** The inventory shipment with the edited tracking info. */
  inventoryShipment?: Maybe<InventoryShipment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentSetTrackingUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentSetTracking`. */
export type InventoryShipmentSetTrackingUserError = DisplayableError & {
  __typename?: 'InventoryShipmentSetTrackingUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentSetTrackingUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentSetTrackingUserError`. */
export enum InventoryShipmentSetTrackingUserErrorCode {
  /** The URL is invalid. */
  InvalidUrl = 'INVALID_URL',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/** The set of valid sort keys for the InventoryShipment query. */
export enum InventoryShipmentSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `status` value. */
  Status = 'STATUS'
}

/** The status of an inventory shipment. */
export enum InventoryShipmentStatus {
  /** The inventory shipment has been created but not yet shipped. */
  Draft = 'DRAFT',
  /** The inventory shipment is currently in transit. */
  InTransit = 'IN_TRANSIT',
  /** Status not included in the current enumeration set. */
  Other = 'OTHER',
  /** The inventory shipment has been partially received at the destination. */
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  /** The inventory shipment has been completely received at the destination. */
  Received = 'RECEIVED'
}

/** Represents the tracking information for an inventory shipment. */
export type InventoryShipmentTracking = {
  __typename?: 'InventoryShipmentTracking';
  /** The estimated date and time that the shipment will arrive. */
  arrivesAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the shipping carrier company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The tracking number used by the carrier to identify the shipment. */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The URL to track the shipment.
   *
   * Given a tracking number and a shipping carrier company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#field-company),
   * Shopify will return a generated tracking URL if no tracking URL was set manually.
   */
  trackingUrl?: Maybe<Scalars['URL']['output']>;
};

/** The input fields for an inventory shipment's tracking information. */
export type InventoryShipmentTrackingInput = {
  /** The estimated date and time that the shipment will arrive. */
  arrivesAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The name of the shipping carrier company.
   *
   * Given a shipping carrier company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#field-company),
   * Shopify can build a tracking URL for a provided tracking number.
   */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The tracking number for the shipment. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * The URL to track the shipment.
   *
   * Use this field to specify a custom tracking URL. If no custom tracking URL is set, Shopify will automatically provide
   * this field on query for a tracking number and a supported shipping carrier company from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#field-company).
   */
  trackingUrl?: InputMaybe<Scalars['URL']['input']>;
};

/** The input fields for a line item on an inventory shipment. */
export type InventoryShipmentUpdateItemQuantitiesInput = {
  /** The quantity for the shipment line item. */
  quantity: Scalars['Int']['input'];
  /** The ID for the inventory shipment line item. */
  shipmentLineItemId: Scalars['ID']['input'];
};

/** Return type for `inventoryShipmentUpdateItemQuantities` mutation. */
export type InventoryShipmentUpdateItemQuantitiesPayload = {
  __typename?: 'InventoryShipmentUpdateItemQuantitiesPayload';
  /** The inventory shipment with updated item quantities. */
  shipment?: Maybe<InventoryShipment>;
  /** The updated item quantities. */
  updatedLineItems?: Maybe<Array<InventoryShipmentLineItem>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryShipmentUpdateItemQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventoryShipmentUpdateItemQuantities`. */
export type InventoryShipmentUpdateItemQuantitiesUserError = DisplayableError & {
  __typename?: 'InventoryShipmentUpdateItemQuantitiesUserError';
  /** The error code. */
  code?: Maybe<InventoryShipmentUpdateItemQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryShipmentUpdateItemQuantitiesUserError`. */
export enum InventoryShipmentUpdateItemQuantitiesUserErrorCode {
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** Current shipment status does not support this operation. */
  InvalidShipmentStatus = 'INVALID_SHIPMENT_STATUS',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The shipment was not found. */
  ShipmentNotFound = 'SHIPMENT_NOT_FOUND'
}

/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransfer = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'InventoryTransfer';
  /** The date and time the inventory transfer was created in UTC format. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** Snapshot of the destination location (name, address, when snapped) with an optional link to the live Location object. If the original location is deleted, the snapshot data will still be available but the location link will be nil. */
  destination?: Maybe<LocationSnapshot>;
  /** The list of events associated with the inventory transfer. */
  events: EventConnection;
  /** Whether the merchant has added timeline comments to the inventory transfer. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The line items associated with the inventory transfer. */
  lineItems: InventoryTransferLineItemConnection;
  /** The number of line items associated with the inventory transfer. Limited to a maximum of 10000 by default. */
  lineItemsCount?: Maybe<Count>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The name of the inventory transfer. */
  name: Scalars['String']['output'];
  /** Additional note attached to the inventory transfer. */
  note?: Maybe<Scalars['String']['output']>;
  /** Snapshot of the origin location (name, address, when snapped) with an optional link to the live Location object. If the original location is deleted, the snapshot data will still be available but the location link will be nil. */
  origin?: Maybe<LocationSnapshot>;
  /** The total quantity of items accepted, rejected, or marked as canceled in the transfer. */
  receivedQuantity: Scalars['Int']['output'];
  /** The reference name of the inventory transfer. */
  referenceName?: Maybe<Scalars['String']['output']>;
  /** The shipments associated with the inventory transfer. */
  shipments: InventoryShipmentConnection;
  /** The current status of the transfer. */
  status: InventoryTransferStatus;
  /** A list of tags that have been added to the inventory transfer. */
  tags: Array<Scalars['String']['output']>;
  /** The total quantity of items being transferred. */
  totalQuantity: Scalars['Int']['output'];
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferLineItemsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Tracks the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects. A transfer includes origin and destination information, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects with quantities, and shipment details.
 *
 * Transfers progress through multiple [`statuses`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus). The transfer maintains [`LocationSnapshot`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LocationSnapshot) objects of location details to preserve historical data even if locations change or are deleted later.
 */
export type InventoryTransferShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `inventoryTransferCancel` mutation. */
export type InventoryTransferCancelPayload = {
  __typename?: 'InventoryTransferCancelPayload';
  /** The cancelled inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferCancelUserError>;
};

/** An error that occurs during the execution of `InventoryTransferCancel`. */
export type InventoryTransferCancelUserError = DisplayableError & {
  __typename?: 'InventoryTransferCancelUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferCancelUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferCancelUserError`. */
export enum InventoryTransferCancelUserErrorCode {
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** Shipment already exists for the transfer. */
  ShipmentExists = 'SHIPMENT_EXISTS',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND'
}

/** An auto-generated type for paginating through multiple InventoryTransfers. */
export type InventoryTransferConnection = {
  __typename?: 'InventoryTransferConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryTransferEdge>;
  /** A list of nodes that are contained in InventoryTransferEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryTransfer>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create an inventory transfer. */
export type InventoryTransferCreateAsReadyToShipInput = {
  /** The date and time the inventory transfer was created. If left blank, defaults to the current date and time in UTC format. */
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  /** The destination location for the inventory transfer. */
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The list of line items for the inventory transfer. */
  lineItems?: Array<InventoryTransferLineItemInput>;
  /** The metafields to attach to the inventory transfer. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** A note to add to the Inventory Transfer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The origin location for the inventory transfer. */
  originLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The reference name to add to the inventory transfer. */
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /** The tags to add to the inventory transfer. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `inventoryTransferCreateAsReadyToShip` mutation. */
export type InventoryTransferCreateAsReadyToShipPayload = {
  __typename?: 'InventoryTransferCreateAsReadyToShipPayload';
  /** The created inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferCreateAsReadyToShipUserError>;
};

/** An error that occurs during the execution of `InventoryTransferCreateAsReadyToShip`. */
export type InventoryTransferCreateAsReadyToShipUserError = DisplayableError & {
  __typename?: 'InventoryTransferCreateAsReadyToShipUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferCreateAsReadyToShipUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferCreateAsReadyToShipUserError`. */
export enum InventoryTransferCreateAsReadyToShipUserErrorCode {
  /** Bundled items cannot be used for this operation. */
  BundledItem = 'BUNDLED_ITEM',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** One or more metafields are not valid. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** One or more tags are not valid. */
  InvalidTag = 'INVALID_TAG',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The list of line items is empty. */
  ItemsEmpty = 'ITEMS_EMPTY',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** A location is required for this operation. */
  LocationRequired = 'LOCATION_REQUIRED',
  /** The tag exceeds the maximum length. */
  TagExceedsMaxLength = 'TAG_EXCEEDS_MAX_LENGTH',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The origin location cannot be the same as the destination location. */
  TransferOriginCannotBeTheSameAsDestination = 'TRANSFER_ORIGIN_CANNOT_BE_THE_SAME_AS_DESTINATION',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** The input fields to create an inventory transfer. */
export type InventoryTransferCreateInput = {
  /** The date and time the inventory transfer was created. If left blank, defaults to the current date and time in UTC format. */
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  /** The destination location for the inventory transfer. */
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The list of line items for the inventory transfer. */
  lineItems?: Array<InventoryTransferLineItemInput>;
  /** The metafields to attach to the inventory transfer. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** A note to add to the Inventory Transfer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The origin location for the inventory transfer. */
  originLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The reference name to add to the inventory transfer. */
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /** The tags to add to the inventory transfer. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `inventoryTransferCreate` mutation. */
export type InventoryTransferCreatePayload = {
  __typename?: 'InventoryTransferCreatePayload';
  /** The created inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferCreateUserError>;
};

/** An error that occurs during the execution of `InventoryTransferCreate`. */
export type InventoryTransferCreateUserError = DisplayableError & {
  __typename?: 'InventoryTransferCreateUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferCreateUserError`. */
export enum InventoryTransferCreateUserErrorCode {
  /** Bundled items cannot be used for this operation. */
  BundledItem = 'BUNDLED_ITEM',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** One or more metafields are not valid. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** One or more tags are not valid. */
  InvalidTag = 'INVALID_TAG',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The tag exceeds the maximum length. */
  TagExceedsMaxLength = 'TAG_EXCEEDS_MAX_LENGTH',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The origin location cannot be the same as the destination location. */
  TransferOriginCannotBeTheSameAsDestination = 'TRANSFER_ORIGIN_CANNOT_BE_THE_SAME_AS_DESTINATION',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** Return type for `inventoryTransferDelete` mutation. */
export type InventoryTransferDeletePayload = {
  __typename?: 'InventoryTransferDeletePayload';
  /** The ID of the deleted inventory transfer. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferDeleteUserError>;
};

/** An error that occurs during the execution of `InventoryTransferDelete`. */
export type InventoryTransferDeleteUserError = DisplayableError & {
  __typename?: 'InventoryTransferDeleteUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferDeleteUserError`. */
export enum InventoryTransferDeleteUserErrorCode {
  /** A resource was not in the correct state for the operation to succeed. */
  InvalidState = 'INVALID_STATE',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND'
}

/** Return type for `inventoryTransferDuplicate` mutation. */
export type InventoryTransferDuplicatePayload = {
  __typename?: 'InventoryTransferDuplicatePayload';
  /** The duplicated inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferDuplicateUserError>;
};

/** An error that occurs during the execution of `InventoryTransferDuplicate`. */
export type InventoryTransferDuplicateUserError = DisplayableError & {
  __typename?: 'InventoryTransferDuplicateUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferDuplicateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferDuplicateUserError`. */
export enum InventoryTransferDuplicateUserErrorCode {
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND'
}

/** An auto-generated type which holds one InventoryTransfer and a cursor during pagination. */
export type InventoryTransferEdge = {
  __typename?: 'InventoryTransferEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryTransferEdge. */
  node: InventoryTransfer;
};

/** The input fields to edit an inventory transfer. */
export type InventoryTransferEditInput = {
  /** The date the inventory transfer was created. */
  dateCreated?: InputMaybe<Scalars['Date']['input']>;
  /**
   * The destination location for the inventory transfer. The destination location can only be
   * changed for draft transfers.
   */
  destinationId?: InputMaybe<Scalars['ID']['input']>;
  /** The metafields to attach to the inventory transfer. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** A note to add to the Inventory Transfer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * The origin location for the inventory transfer. The origin location can only be changed
   * for draft transfers.
   */
  originId?: InputMaybe<Scalars['ID']['input']>;
  /** The reference name to add to the inventory transfer. */
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /** The tags to add to the inventory transfer. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `inventoryTransferEdit` mutation. */
export type InventoryTransferEditPayload = {
  __typename?: 'InventoryTransferEditPayload';
  /** The edited inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferEditUserError>;
};

/** An error that occurs during the execution of `InventoryTransferEdit`. */
export type InventoryTransferEditUserError = DisplayableError & {
  __typename?: 'InventoryTransferEditUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferEditUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferEditUserError`. */
export enum InventoryTransferEditUserErrorCode {
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** One or more metafields are not valid. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** One or more tags are not valid. */
  InvalidTag = 'INVALID_TAG',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The tag exceeds the maximum length. */
  TagExceedsMaxLength = 'TAG_EXCEEDS_MAX_LENGTH',
  /** The location of a transfer cannot be updated. Only Draft Transfers can mutate their locations. */
  TransferLocationImmutable = 'TRANSFER_LOCATION_IMMUTABLE',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The origin location cannot be the same as the destination location. */
  TransferOriginCannotBeTheSameAsDestination = 'TRANSFER_ORIGIN_CANNOT_BE_THE_SAME_AS_DESTINATION'
}

/** Represents a line item belonging to an inventory transfer. */
export type InventoryTransferLineItem = Node & {
  __typename?: 'InventoryTransferLineItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The inventory item associated with this line item. */
  inventoryItem?: Maybe<InventoryItem>;
  /** The quantity of the item that has been picked for a draft shipment but not yet shipped. */
  pickedForShipmentQuantity: Scalars['Int']['output'];
  /** The quantity of the item that can be actioned upon, such as editing the item quantity on the transfer or adding to a shipment. */
  processableQuantity: Scalars['Int']['output'];
  /** The quantity of the item that can be shipped. */
  shippableQuantity: Scalars['Int']['output'];
  /** The quantity of the item that has been shipped. */
  shippedQuantity: Scalars['Int']['output'];
  /** The title of the product associated with this line item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The total quantity of items being transferred. */
  totalQuantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple InventoryTransferLineItems. */
export type InventoryTransferLineItemConnection = {
  __typename?: 'InventoryTransferLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<InventoryTransferLineItemEdge>;
  /** A list of nodes that are contained in InventoryTransferLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<InventoryTransferLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryTransferLineItem and a cursor during pagination. */
export type InventoryTransferLineItemEdge = {
  __typename?: 'InventoryTransferLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of InventoryTransferLineItemEdge. */
  node: InventoryTransferLineItem;
};

/** The input fields for a line item on an inventory transfer. */
export type InventoryTransferLineItemInput = {
  /** The inventory item ID for the transfer line item. */
  inventoryItemId: Scalars['ID']['input'];
  /** The quantity for the transfer line item. */
  quantity: Scalars['Int']['input'];
};

/** Represents an update to a single transfer line item. */
export type InventoryTransferLineItemUpdate = {
  __typename?: 'InventoryTransferLineItemUpdate';
  /** The delta quantity for the transfer line item. */
  deltaQuantity?: Maybe<Scalars['Int']['output']>;
  /** The inventory item ID for the transfer line item. */
  inventoryItemId?: Maybe<Scalars['ID']['output']>;
  /** The new quantity for the transfer line item. */
  newQuantity?: Maybe<Scalars['Int']['output']>;
};

/** Return type for `inventoryTransferMarkAsReadyToShip` mutation. */
export type InventoryTransferMarkAsReadyToShipPayload = {
  __typename?: 'InventoryTransferMarkAsReadyToShipPayload';
  /** The ready to ship inventory transfer. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferMarkAsReadyToShipUserError>;
};

/** An error that occurs during the execution of `InventoryTransferMarkAsReadyToShip`. */
export type InventoryTransferMarkAsReadyToShipUserError = DisplayableError & {
  __typename?: 'InventoryTransferMarkAsReadyToShipUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferMarkAsReadyToShipUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferMarkAsReadyToShipUserError`. */
export enum InventoryTransferMarkAsReadyToShipUserErrorCode {
  /** One or more items are not valid. */
  InvalidItem = 'INVALID_ITEM',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The list of line items is empty. */
  ItemsEmpty = 'ITEMS_EMPTY',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** A location is required for this operation. */
  LocationRequired = 'LOCATION_REQUIRED',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND'
}

/** The input fields to remove inventory items from a transfer. */
export type InventoryTransferRemoveItemsInput = {
  /** The ID of the inventory transfer where the items will be removed. */
  id: Scalars['ID']['input'];
  /**
   * The IDs of the [`InventoryTransferLineItem`s](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem)
   * to be removed from the transfer. Passing an empty array is a no-op and returns
   * the transfer unchanged.
   */
  transferLineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `inventoryTransferRemoveItems` mutation. */
export type InventoryTransferRemoveItemsPayload = {
  __typename?: 'InventoryTransferRemoveItemsPayload';
  /** The transfer with line items removed. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The line items that have had their shippable quantity removed. */
  removedQuantities?: Maybe<Array<InventoryTransferLineItemUpdate>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferRemoveItemsUserError>;
};

/** An error that occurs during the execution of `InventoryTransferRemoveItems`. */
export type InventoryTransferRemoveItemsUserError = DisplayableError & {
  __typename?: 'InventoryTransferRemoveItemsUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferRemoveItemsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferRemoveItemsUserError`. */
export enum InventoryTransferRemoveItemsUserErrorCode {
  /** The item cannot be removed because all of its quantity is fully allocated to one or more shipments (including draft shipments where the item has been picked). The error name refers to the underlying allocation check; it triggers regardless of whether the shipments have actually shipped. */
  AllQuantityShipped = 'ALL_QUANTITY_SHIPPED',
  /** A `READY_TO_SHIP` transfer must have at least one line item; you cannot remove every line item from one. To empty a `READY_TO_SHIP` transfer, cancel it instead. */
  CantRemoveAllItemsFromReadyToShipTransfer = 'CANT_REMOVE_ALL_ITEMS_FROM_READY_TO_SHIP_TRANSFER',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The line item cannot be removed because it appears on a draft shipment with quantity `0`. */
  ItemPresentOnDraftShipmentWithZeroQuantity = 'ITEM_PRESENT_ON_DRAFT_SHIPMENT_WITH_ZERO_QUANTITY',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND'
}

/** The input fields to the InventoryTransferSetItems mutation. */
export type InventoryTransferSetItemsInput = {
  /** The ID of the inventory transfer where the items will be set. */
  id: Scalars['ID']['input'];
  /** The line items to set on the Transfer. Only the items included in this list are affected; items already on the transfer that aren't referenced here will stay unchanged. Each inventory item may appear at most once in this list; duplicate `inventoryItemId` entries are rejected. */
  lineItems: Array<InventoryTransferLineItemInput>;
};

/** Return type for `inventoryTransferSetItems` mutation. */
export type InventoryTransferSetItemsPayload = {
  __typename?: 'InventoryTransferSetItemsPayload';
  /** The Transfer with its line items updated. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /** The updated line items. */
  updatedLineItems?: Maybe<Array<InventoryTransferLineItemUpdate>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<InventoryTransferSetItemsUserError>;
};

/** An error that occurs during the execution of `InventoryTransferSetItems`. */
export type InventoryTransferSetItemsUserError = DisplayableError & {
  __typename?: 'InventoryTransferSetItemsUserError';
  /** The error code. */
  code?: Maybe<InventoryTransferSetItemsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `InventoryTransferSetItemsUserError`. */
export enum InventoryTransferSetItemsUserErrorCode {
  /** Bundled items cannot be used for this operation. */
  BundledItem = 'BUNDLED_ITEM',
  /** A single item can't be listed twice. */
  DuplicateItem = 'DUPLICATE_ITEM',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** A previous request with this idempotency key failed. Retry with a new idempotency key. */
  IdempotencyPreviousAttemptFailed = 'IDEMPOTENCY_PREVIOUS_ATTEMPT_FAILED',
  /** The quantity is invalid. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** Current transfer status does not support this operation. */
  InvalidTransferStatus = 'INVALID_TRANSFER_STATUS',
  /** The item is not stocked at the intended location. */
  InventoryStateNotActive = 'INVENTORY_STATE_NOT_ACTIVE',
  /** The item was not found. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The location selected is not active. */
  LocationNotActive = 'LOCATION_NOT_ACTIVE',
  /** The location selected can't be found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** The transfer was not found. */
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  /** The item does not track inventory. */
  UntrackedItem = 'UNTRACKED_ITEM'
}

/** The status of a transfer. */
export enum InventoryTransferStatus {
  /** The inventory transfer has been canceled. */
  Canceled = 'CANCELED',
  /** The inventory transfer has been created but not yet finalized. */
  Draft = 'DRAFT',
  /** The inventory transfer is in progress, with a shipment currently underway or received. */
  InProgress = 'IN_PROGRESS',
  /** Status not included in the current enumeration set. */
  Other = 'OTHER',
  /** The inventory transfer has been created, but not yet shipped. */
  ReadyToShip = 'READY_TO_SHIP',
  /** The inventory transfer has been completely received at the destination. */
  Transferred = 'TRANSFERRED'
}

/** The financial transfer details for a return outcome that results in an invoice. */
export type InvoiceReturnOutcome = {
  __typename?: 'InvoiceReturnOutcome';
  /** The total monetary value to be invoiced in shop and presentment currencies. */
  amount: MoneyBag;
};

/** A job corresponds to some long running task that the client should poll for status. */
export type Job = {
  __typename?: 'Job';
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
  /** This field will only resolve once the job is done. Can be used to ask for object(s) that have been changed by the job. */
  query?: Maybe<QueryRoot>;
};

/** A job corresponds to some long running task that the client should poll for status. */
export type JobResult = {
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
};

/** Language codes supported by Shopify. */
export enum LanguageCode {
  /** Afrikaans. */
  Af = 'AF',
  /** Akan. */
  Ak = 'AK',
  /** Amharic. */
  Am = 'AM',
  /** Arabic. */
  Ar = 'AR',
  /** Assamese. */
  As = 'AS',
  /** Azerbaijani. */
  Az = 'AZ',
  /** Belarusian. */
  Be = 'BE',
  /** Bulgarian. */
  Bg = 'BG',
  /** Bambara. */
  Bm = 'BM',
  /** Bangla. */
  Bn = 'BN',
  /** Tibetan. */
  Bo = 'BO',
  /** Breton. */
  Br = 'BR',
  /** Bosnian. */
  Bs = 'BS',
  /** Catalan. */
  Ca = 'CA',
  /** Chechen. */
  Ce = 'CE',
  /** Central Kurdish. */
  Ckb = 'CKB',
  /** Czech. */
  Cs = 'CS',
  /** Church Slavic. */
  Cu = 'CU',
  /** Welsh. */
  Cy = 'CY',
  /** Danish. */
  Da = 'DA',
  /** German. */
  De = 'DE',
  /** Dzongkha. */
  Dz = 'DZ',
  /** Ewe. */
  Ee = 'EE',
  /** Greek. */
  El = 'EL',
  /** English. */
  En = 'EN',
  /** Esperanto. */
  Eo = 'EO',
  /** Spanish. */
  Es = 'ES',
  /** Estonian. */
  Et = 'ET',
  /** Basque. */
  Eu = 'EU',
  /** Persian. */
  Fa = 'FA',
  /** Fulah. */
  Ff = 'FF',
  /** Finnish. */
  Fi = 'FI',
  /** Filipino. */
  Fil = 'FIL',
  /** Faroese. */
  Fo = 'FO',
  /** French. */
  Fr = 'FR',
  /** Western Frisian. */
  Fy = 'FY',
  /** Irish. */
  Ga = 'GA',
  /** Scottish Gaelic. */
  Gd = 'GD',
  /** Galician. */
  Gl = 'GL',
  /** Gujarati. */
  Gu = 'GU',
  /** Manx. */
  Gv = 'GV',
  /** Hausa. */
  Ha = 'HA',
  /** Hebrew. */
  He = 'HE',
  /** Hindi. */
  Hi = 'HI',
  /** Croatian. */
  Hr = 'HR',
  /** Hungarian. */
  Hu = 'HU',
  /** Armenian. */
  Hy = 'HY',
  /** Interlingua. */
  Ia = 'IA',
  /** Indonesian. */
  Id = 'ID',
  /** Igbo. */
  Ig = 'IG',
  /** Sichuan Yi. */
  Ii = 'II',
  /** Icelandic. */
  Is = 'IS',
  /** Italian. */
  It = 'IT',
  /** Japanese. */
  Ja = 'JA',
  /** Javanese. */
  Jv = 'JV',
  /** Georgian. */
  Ka = 'KA',
  /** Kikuyu. */
  Ki = 'KI',
  /** Kazakh. */
  Kk = 'KK',
  /** Kalaallisut. */
  Kl = 'KL',
  /** Khmer. */
  Km = 'KM',
  /** Kannada. */
  Kn = 'KN',
  /** Korean. */
  Ko = 'KO',
  /** Kashmiri. */
  Ks = 'KS',
  /** Kurdish. */
  Ku = 'KU',
  /** Cornish. */
  Kw = 'KW',
  /** Kyrgyz. */
  Ky = 'KY',
  /** Luxembourgish. */
  Lb = 'LB',
  /** Ganda. */
  Lg = 'LG',
  /** Lingala. */
  Ln = 'LN',
  /** Lao. */
  Lo = 'LO',
  /** Lithuanian. */
  Lt = 'LT',
  /** Luba-Katanga. */
  Lu = 'LU',
  /** Latvian. */
  Lv = 'LV',
  /** Malagasy. */
  Mg = 'MG',
  /** Māori. */
  Mi = 'MI',
  /** Macedonian. */
  Mk = 'MK',
  /** Malayalam. */
  Ml = 'ML',
  /** Mongolian. */
  Mn = 'MN',
  /** Marathi. */
  Mr = 'MR',
  /** Malay. */
  Ms = 'MS',
  /** Maltese. */
  Mt = 'MT',
  /** Burmese. */
  My = 'MY',
  /** Norwegian (Bokmål). */
  Nb = 'NB',
  /** North Ndebele. */
  Nd = 'ND',
  /** Nepali. */
  Ne = 'NE',
  /** Dutch. */
  Nl = 'NL',
  /** Norwegian Nynorsk. */
  Nn = 'NN',
  /** Norwegian. */
  No = 'NO',
  /** Oromo. */
  Om = 'OM',
  /** Odia. */
  Or = 'OR',
  /** Ossetic. */
  Os = 'OS',
  /** Punjabi. */
  Pa = 'PA',
  /** Polish. */
  Pl = 'PL',
  /** Pashto. */
  Ps = 'PS',
  /** Portuguese. */
  Pt = 'PT',
  /** Portuguese (Brazil). */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal). */
  PtPt = 'PT_PT',
  /** Quechua. */
  Qu = 'QU',
  /** Romansh. */
  Rm = 'RM',
  /** Rundi. */
  Rn = 'RN',
  /** Romanian. */
  Ro = 'RO',
  /** Russian. */
  Ru = 'RU',
  /** Kinyarwanda. */
  Rw = 'RW',
  /** Sanskrit. */
  Sa = 'SA',
  /** Sardinian. */
  Sc = 'SC',
  /** Sindhi. */
  Sd = 'SD',
  /** Northern Sami. */
  Se = 'SE',
  /** Sango. */
  Sg = 'SG',
  /** Sinhala. */
  Si = 'SI',
  /** Slovak. */
  Sk = 'SK',
  /** Slovenian. */
  Sl = 'SL',
  /** Shona. */
  Sn = 'SN',
  /** Somali. */
  So = 'SO',
  /** Albanian. */
  Sq = 'SQ',
  /** Serbian. */
  Sr = 'SR',
  /** Sundanese. */
  Su = 'SU',
  /** Swedish. */
  Sv = 'SV',
  /** Swahili. */
  Sw = 'SW',
  /** Tamil. */
  Ta = 'TA',
  /** Telugu. */
  Te = 'TE',
  /** Tajik. */
  Tg = 'TG',
  /** Thai. */
  Th = 'TH',
  /** Tigrinya. */
  Ti = 'TI',
  /** Turkmen. */
  Tk = 'TK',
  /** Tongan. */
  To = 'TO',
  /** Turkish. */
  Tr = 'TR',
  /** Tatar. */
  Tt = 'TT',
  /** Uyghur. */
  Ug = 'UG',
  /** Ukrainian. */
  Uk = 'UK',
  /** Urdu. */
  Ur = 'UR',
  /** Uzbek. */
  Uz = 'UZ',
  /** Vietnamese. */
  Vi = 'VI',
  /** Volapük. */
  Vo = 'VO',
  /** Wolof. */
  Wo = 'WO',
  /** Xhosa. */
  Xh = 'XH',
  /** Yiddish. */
  Yi = 'YI',
  /** Yoruba. */
  Yo = 'YO',
  /** Chinese. */
  Zh = 'ZH',
  /** Chinese (Simplified). */
  ZhCn = 'ZH_CN',
  /** Chinese (Traditional). */
  ZhTw = 'ZH_TW',
  /** Zulu. */
  Zu = 'ZU'
}

/**
 * Interoperability metadata for types that directly correspond to a REST Admin API resource.
 * For example, on the Product type, LegacyInteroperability returns metadata for the corresponding [Product object](https://shopify.dev/api/admin-graphql/latest/objects/product) in the REST Admin API.
 */
export type LegacyInteroperability = {
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
};

/** Units of measurement for length. */
export enum LengthUnit {
  /** 100 centimeters equals 1 meter. */
  Centimeters = 'CENTIMETERS',
  /** Imperial system unit of length. */
  Feet = 'FEET',
  /** 12 inches equals 1 foot. */
  Inches = 'INCHES',
  /** Metric system unit of length. */
  Meters = 'METERS',
  /** 1000 millimeters equals 1 meter. */
  Millimeters = 'MILLIMETERS',
  /** 1 yard equals 3 feet. */
  Yards = 'YARDS'
}

/**
 * The total number of pending orders on a shop if less then a maximum, or that maximum.
 * The atMax field indicates when this maximum has been reached.
 */
export type LimitedPendingOrderCount = {
  __typename?: 'LimitedPendingOrderCount';
  /** This is set when the number of pending orders has reached the maximum. */
  atMax: Scalars['Boolean']['output'];
  /**
   * The number of pendings orders on the shop.
   * Limited to a maximum of 10000.
   */
  count: Scalars['Int']['output'];
};

/**
 * The `LineItem` object represents a single product or service that a customer purchased in an
 * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
 * Each line item is associated with a
 * [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
 * and can have multiple [discount allocations](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAllocation).
 * Line items contain details about what was purchased, including the product variant, quantity, pricing,
 * and fulfillment status.
 *
 * Use the `LineItem` object to manage the following processes:
 *
 * - [Track the quantity of items](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/build-fulfillment-solutions) ordered, fulfilled, and unfulfilled.
 * - [Calculate prices](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders), including discounts and taxes.
 * - Manage fulfillment through [fulfillment services](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps).
 * - Manage [returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management) and [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges).
 * - Handle [subscriptions](https://shopify.dev/docs/apps/build/purchase-options/subscriptions) and recurring orders.
 *
 * Line items can also include custom attributes and properties, allowing merchants to add specific details
 * about each item in an order. Learn more about
 * [managing orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type LineItem = Node & {
  __typename?: 'LineItem';
  /**
   * Whether the line item can be restocked.
   * @deprecated Use `restockable` instead.
   */
  canRestock: Scalars['Boolean']['output'];
  /** The subscription contract associated with this line item. */
  contract?: Maybe<SubscriptionContract>;
  /** The date and time when the line item was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The number of units ordered, excluding refunded and removed units. */
  currentQuantity: Scalars['Int']['output'];
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /** The discounts that have been allocated to the line item by discount applications, including discounts allocated to refunded and removed quantities. */
  discountAllocations: Array<DiscountAllocation>;
  /**
   * The total discounted price of the line item in shop currency, including refunded and removed quantities. This value doesn't include order-level discounts.
   * @deprecated Use `discountedTotalSet` instead.
   */
  discountedTotal: Scalars['Money']['output'];
  /** The total discounted price of the line item in shop and presentment currencies, including refunded and removed quantities. This value doesn't include order-level discounts. Code-based discounts aren't included by default. */
  discountedTotalSet: MoneyBag;
  /**
   * The approximate unit price of the line item in shop currency. This value includes line-level discounts and discounts applied to refunded and removed quantities. It doesn't include order-level or code-based discounts.
   * @deprecated Use `discountedUnitPriceSet` instead.
   */
  discountedUnitPrice: Scalars['Money']['output'];
  /** The approximate unit price of the line item in shop and presentment currencies. This value includes discounts applied to refunded and removed quantities. */
  discountedUnitPriceAfterAllDiscountsSet: MoneyBag;
  /** The approximate unit price of the line item in shop and presentment currencies. This value includes line-level discounts and discounts applied to refunded and removed quantities. It doesn't include order-level or code-based discounts. */
  discountedUnitPriceSet: MoneyBag;
  /** The duties associated with the line item. */
  duties: Array<Duty>;
  /**
   * The total number of units to fulfill.
   * @deprecated Use [FulfillmentOrderLineItem#remainingQuantity](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderLineItem#field-fulfillmentorderlineitem-remainingquantity) instead.
   */
  fulfillableQuantity: Scalars['Int']['output'];
  /**
   * The fulfillment service that stocks the product variant belonging to a line item.
   *
   * This is a third-party fulfillment service in the following scenarios:
   *
   * **Scenario 1**
   * - The product variant is stocked by a single fulfillment service.
   * - The [FulfillmentService](/api/admin-graphql/latest/objects/FulfillmentService) is a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   * **Scenario 2**
   * - Multiple fulfillment services stock the product variant.
   * - The last time that the line item was unfulfilled, it was awaiting fulfillment by a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   * If none of the above conditions are met, then the fulfillment service has the `manual` handle.
   * @deprecated
   * The [relationship between a product variant and a fulfillment service was changed](/changelog/fulfillment-service-sku-sharing). A [ProductVariant](/api/admin-graphql/latest/objects/ProductVariant) can be stocked by multiple fulfillment services. As a result, we recommend that you use the [inventoryItem field](/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-inventoryitem) if you need to determine where a product variant is stocked.
   *
   * If you need to determine whether a product is a gift card, then you should continue to use this field until an alternative is available.
   *
   * Altering the locations which stock a product variant won't change the value of this field for existing orders.
   *
   * Learn about [managing inventory quantities and states](/apps/fulfillment/inventory-management-apps/quantities-states).
   *
   */
  fulfillmentService?: Maybe<FulfillmentService>;
  /**
   * The line item's fulfillment status. Returns 'fulfilled' if fulfillableQuantity >= quantity,
   * 'partial' if  fulfillableQuantity > 0, and 'unfulfilled' otherwise.
   * @deprecated Use [FulfillmentOrderLineItem#remainingQuantity](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderLineItem#field-fulfillmentorderlineitem-remainingquantity) instead
   */
  fulfillmentStatus: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image associated to the line item's variant. */
  image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The line item group associated to the line item. */
  lineItemGroup?: Maybe<LineItemGroup>;
  /** Whether the line item can be edited or not. */
  merchantEditable: Scalars['Boolean']['output'];
  /** The title of the product, optionally appended with the title of the variant (if applicable). */
  name: Scalars['String']['output'];
  /** The total number of units that can't be fulfilled. For example, if items have been refunded, or the item is not something that can be fulfilled, like a tip. Please see the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object for more fulfillment details. */
  nonFulfillableQuantity: Scalars['Int']['output'];
  /**
   * In shop currency, the total price of the line item when the order was created.
   * This value doesn't include discounts.
   * @deprecated Use `originalTotalSet` instead.
   */
  originalTotal: Scalars['Money']['output'];
  /**
   * In shop and presentment currencies, the total price of the line item when the order was created.
   * This value doesn't include discounts.
   */
  originalTotalSet: MoneyBag;
  /**
   * In shop currency, the unit price of the line item when the order was created. This value doesn't include discounts.
   * @deprecated Use `originalUnitPriceSet` instead.
   */
  originalUnitPrice: Scalars['Money']['output'];
  /** In shop and presentment currencies, the unit price of the line item when the order was created. This value doesn't include discounts. */
  originalUnitPriceSet: MoneyBag;
  /**
   * The total price of the line item in shop and presentment currencies,
   * after all discounts are applied and excluding refunded and removed quantities.
   * This value doesn't include taxes.
   */
  priceAfterAllDiscountsBeforeTaxesSet: MoneyBag;
  /** The Product object associated with this line item's variant. */
  product?: Maybe<Product>;
  /** The number of units ordered, including refunded and removed units. */
  quantity: Scalars['Int']['output'];
  /** The number of units ordered, excluding refunded units and removed units. */
  refundableQuantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** Whether the line item can be restocked. */
  restockable: Scalars['Boolean']['output'];
  /** The selling plan details associated with the line item. */
  sellingPlan?: Maybe<LineItemSellingPlan>;
  /** The variant SKU number. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Staff attributed to the line item. */
  staffMember?: Maybe<StaffMember>;
  /** Return reasons suggested based on the line item's product category in Shopify's product taxonomy. Use [`returnReasonDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/returnReasonDefinitions) to access the full library of available reasons. */
  suggestedReturnReasonDefinitions?: Maybe<ReturnReasonDefinitionConnection>;
  /** The taxes charged for the line item, including taxes charged for refunded and removed quantities. */
  taxLines: Array<TaxLine>;
  /** Whether the variant is taxable. */
  taxable: Scalars['Boolean']['output'];
  /** The title of the product at time of order creation. */
  title: Scalars['String']['output'];
  /**
   * The total discount allocated to the line item in shop currency, including the total allocated to refunded and removed quantities. This value doesn't include order-level discounts.
   * @deprecated Use `totalDiscountSet` instead.
   */
  totalDiscount: Scalars['Money']['output'];
  /** The total discount allocated to the line item in shop and presentment currencies, including the total allocated to refunded and removed quantities. This value doesn't include order-level discounts. */
  totalDiscountSet: MoneyBag;
  /**
   * In shop currency, the total discounted price of the unfulfilled quantity for the line item.
   * @deprecated Use `unfulfilledDiscountedTotalSet` instead.
   */
  unfulfilledDiscountedTotal: Scalars['Money']['output'];
  /** In shop and presentment currencies, the total discounted price of the unfulfilled quantity for the line item. */
  unfulfilledDiscountedTotalSet: MoneyBag;
  /**
   * In shop currency, the total price of the unfulfilled quantity for the line item. This value doesn't include discounts.
   * @deprecated Use `unfulfilledOriginalTotalSet` instead.
   */
  unfulfilledOriginalTotal: Scalars['Money']['output'];
  /** In shop and presentment currencies, the total price of the unfulfilled quantity for the line item. This value doesn't include discounts. */
  unfulfilledOriginalTotalSet: MoneyBag;
  /** The number of units not yet fulfilled. */
  unfulfilledQuantity: Scalars['Int']['output'];
  /** The Variant object associated with this line item. */
  variant?: Maybe<ProductVariant>;
  /** The title of the variant at time of order creation. */
  variantTitle?: Maybe<Scalars['String']['output']>;
  /** The name of the vendor who made the variant. */
  vendor?: Maybe<Scalars['String']['output']>;
  /** The weight of a line item unit. */
  weight?: Maybe<Weight>;
};


/**
 * The `LineItem` object represents a single product or service that a customer purchased in an
 * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
 * Each line item is associated with a
 * [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
 * and can have multiple [discount allocations](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAllocation).
 * Line items contain details about what was purchased, including the product variant, quantity, pricing,
 * and fulfillment status.
 *
 * Use the `LineItem` object to manage the following processes:
 *
 * - [Track the quantity of items](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/build-fulfillment-solutions) ordered, fulfilled, and unfulfilled.
 * - [Calculate prices](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders), including discounts and taxes.
 * - Manage fulfillment through [fulfillment services](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps).
 * - Manage [returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management) and [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges).
 * - Handle [subscriptions](https://shopify.dev/docs/apps/build/purchase-options/subscriptions) and recurring orders.
 *
 * Line items can also include custom attributes and properties, allowing merchants to add specific details
 * about each item in an order. Learn more about
 * [managing orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type LineItemDiscountedTotalSetArgs = {
  withCodeDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `LineItem` object represents a single product or service that a customer purchased in an
 * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
 * Each line item is associated with a
 * [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
 * and can have multiple [discount allocations](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAllocation).
 * Line items contain details about what was purchased, including the product variant, quantity, pricing,
 * and fulfillment status.
 *
 * Use the `LineItem` object to manage the following processes:
 *
 * - [Track the quantity of items](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/build-fulfillment-solutions) ordered, fulfilled, and unfulfilled.
 * - [Calculate prices](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders), including discounts and taxes.
 * - Manage fulfillment through [fulfillment services](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps).
 * - Manage [returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management) and [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges).
 * - Handle [subscriptions](https://shopify.dev/docs/apps/build/purchase-options/subscriptions) and recurring orders.
 *
 * Line items can also include custom attributes and properties, allowing merchants to add specific details
 * about each item in an order. Learn more about
 * [managing orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type LineItemSuggestedReturnReasonDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `LineItem` object represents a single product or service that a customer purchased in an
 * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
 * Each line item is associated with a
 * [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
 * and can have multiple [discount allocations](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAllocation).
 * Line items contain details about what was purchased, including the product variant, quantity, pricing,
 * and fulfillment status.
 *
 * Use the `LineItem` object to manage the following processes:
 *
 * - [Track the quantity of items](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/build-fulfillment-solutions) ordered, fulfilled, and unfulfilled.
 * - [Calculate prices](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders), including discounts and taxes.
 * - Manage fulfillment through [fulfillment services](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps).
 * - Manage [returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management) and [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges).
 * - Handle [subscriptions](https://shopify.dev/docs/apps/build/purchase-options/subscriptions) and recurring orders.
 *
 * Line items can also include custom attributes and properties, allowing merchants to add specific details
 * about each item in an order. Learn more about
 * [managing orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type LineItemTaxLinesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** An auto-generated type for paginating through multiple LineItems. */
export type LineItemConnection = {
  __typename?: 'LineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<LineItemEdge>;
  /** A list of nodes that are contained in LineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<LineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one LineItem and a cursor during pagination. */
export type LineItemEdge = {
  __typename?: 'LineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of LineItemEdge. */
  node: LineItem;
};

/**
 * The information for [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) that are part of a bundle. When a bundle is purchased, each component line item references its [`LineItemGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItemGroup) through the [`lineItemGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem#field-lineItemGroup) field to maintain the relationship with the bundle.
 *
 * The parent bundle's product, variant, and custom attributes enable apps to group and display bundle components in order management systems, transactional emails, and other contexts where understanding the bundle structure is needed.
 *
 * Learn more about [product bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles).
 */
export type LineItemGroup = Node & {
  __typename?: 'LineItemGroup';
  /** A list of attributes that represent custom features or special requests. */
  customAttributes: Array<Attribute>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** ID of the product of the line item group. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** Quantity of the line item group on the order. */
  quantity: Scalars['Int']['output'];
  /** Title of the line item group. */
  title: Scalars['String']['output'];
  /** ID of the variant of the line item group. */
  variantId?: Maybe<Scalars['ID']['output']>;
  /** SKU of the variant of the line item group. */
  variantSku?: Maybe<Scalars['String']['output']>;
};

/** Represents the selling plan for a line item. */
export type LineItemSellingPlan = {
  __typename?: 'LineItemSellingPlan';
  /** The name of the selling plan for display purposes. */
  name: Scalars['String']['output'];
  /** The ID of the selling plan associated with the line item. */
  sellingPlanId?: Maybe<Scalars['ID']['output']>;
};

/** A link to direct users to. */
export type Link = HasPublishedTranslations & {
  __typename?: 'Link';
  /** A context-sensitive label for the link. */
  label: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The URL that the link visits. */
  url: Scalars['URL']['output'];
};


/** A link to direct users to. */
export type LinkTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * The identifier for the metafield linked to this option.
 *
 * This API is currently in early access. See [Metafield-linked product options](https://shopify.dev/docs/api/admin/migrate/new-product-model/metafield-linked) for more details.
 */
export type LinkedMetafield = {
  __typename?: 'LinkedMetafield';
  /** Key of the metafield the option is linked to. */
  key?: Maybe<Scalars['String']['output']>;
  /** Namespace of the metafield the option is linked to. */
  namespace?: Maybe<Scalars['String']['output']>;
};

/** The input fields required to link a product option to a metafield. */
export type LinkedMetafieldCreateInput = {
  /** The key of the metafield this option is linked to. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield this option is linked to. */
  namespace: Scalars['String']['input'];
  /** Values associated with the option. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for linking a combined listing option to a metafield. */
export type LinkedMetafieldInput = {
  /** The key of the linked metafield. */
  key: Scalars['String']['input'];
  /** The namespace of the linked metafield. */
  namespace: Scalars['String']['input'];
  /** The values of the linked metafield. */
  values: Array<Scalars['String']['input']>;
};

/**
 * The input fields required to link a product option to a metafield.
 *
 * This API is currently in early access. See [Metafield-linked product options](https://shopify.dev/docs/api/admin/migrate/new-product-model/metafield-linked) for more details.
 */
export type LinkedMetafieldUpdateInput = {
  /** The key of the metafield this option is linked to. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield this option is linked to. */
  namespace: Scalars['String']['input'];
};

/** Local payment methods payment details related to a transaction. */
export type LocalPaymentMethodsPaymentDetails = BasePaymentDetails & {
  __typename?: 'LocalPaymentMethodsPaymentDetails';
  /** The descriptor by the payment provider. Only available for Amazon Pay and Buy with Prime. */
  paymentDescriptor?: Maybe<Scalars['String']['output']>;
  /** The name of payment method used by the buyer. */
  paymentMethodName?: Maybe<Scalars['String']['output']>;
};

/** A locale. */
export type Locale = {
  __typename?: 'Locale';
  /** Locale ISO code. */
  isoCode: Scalars['String']['output'];
  /** Human-readable locale name. */
  name: Scalars['String']['output'];
};

/** Specifies the type of the underlying localizable content. This can be used to conditionally render different UI elements such as input fields. */
export enum LocalizableContentType {
  /** A file reference. */
  FileReference = 'FILE_REFERENCE',
  /** An HTML. */
  Html = 'HTML',
  /** An inline rich text. */
  InlineRichText = 'INLINE_RICH_TEXT',
  /** A JSON. */
  Json = 'JSON',
  /** A JSON string. */
  JsonString = 'JSON_STRING',
  /** A link. */
  Link = 'LINK',
  /** A list of file references. */
  ListFileReference = 'LIST_FILE_REFERENCE',
  /** A list of links. */
  ListLink = 'LIST_LINK',
  /** A list of multi-line texts. */
  ListMultiLineTextField = 'LIST_MULTI_LINE_TEXT_FIELD',
  /** A list of single-line texts. */
  ListSingleLineTextField = 'LIST_SINGLE_LINE_TEXT_FIELD',
  /** A list of URLs. */
  ListUrl = 'LIST_URL',
  /** A multi-line text. */
  MultiLineTextField = 'MULTI_LINE_TEXT_FIELD',
  /** A rich text. */
  RichTextField = 'RICH_TEXT_FIELD',
  /** A single-line text. */
  SingleLineTextField = 'SINGLE_LINE_TEXT_FIELD',
  /** A string. */
  String = 'STRING',
  /** A URI. */
  Uri = 'URI',
  /** A URL. */
  Url = 'URL'
}

/** Represents the value captured by a localization extension. Localization extensions are additional fields required by certain countries on international orders. For example, some countries require additional fields for customs information or tax identification numbers. */
export type LocalizationExtension = {
  __typename?: 'LocalizationExtension';
  /** Country ISO 3166-1 alpha-2 code. */
  countryCode: CountryCode;
  /** The localized extension keys that are allowed. */
  key: LocalizationExtensionKey;
  /** The purpose of this localization extension. */
  purpose: LocalizationExtensionPurpose;
  /** The localized extension title. */
  title: Scalars['String']['output'];
  /** The value of the field. */
  value: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple LocalizationExtensions. */
export type LocalizationExtensionConnection = {
  __typename?: 'LocalizationExtensionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<LocalizationExtensionEdge>;
  /** A list of nodes that are contained in LocalizationExtensionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<LocalizationExtension>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one LocalizationExtension and a cursor during pagination. */
export type LocalizationExtensionEdge = {
  __typename?: 'LocalizationExtensionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of LocalizationExtensionEdge. */
  node: LocalizationExtension;
};

/** The input fields for a LocalizationExtensionInput. */
export type LocalizationExtensionInput = {
  /** The key for the localization extension. */
  key: LocalizationExtensionKey;
  /** The localization extension value. */
  value: Scalars['String']['input'];
};

/** The key of a localization extension. */
export enum LocalizationExtensionKey {
  /** Extension key 'shipping_credential_br' for country BR. */
  ShippingCredentialBr = 'SHIPPING_CREDENTIAL_BR',
  /** Extension key 'shipping_credential_cl' for country CL. */
  ShippingCredentialCl = 'SHIPPING_CREDENTIAL_CL',
  /** Extension key 'shipping_credential_cn' for country CN. */
  ShippingCredentialCn = 'SHIPPING_CREDENTIAL_CN',
  /** Extension key 'shipping_credential_co' for country CO. */
  ShippingCredentialCo = 'SHIPPING_CREDENTIAL_CO',
  /** Extension key 'shipping_credential_cr' for country CR. */
  ShippingCredentialCr = 'SHIPPING_CREDENTIAL_CR',
  /** Extension key 'shipping_credential_ec' for country EC. */
  ShippingCredentialEc = 'SHIPPING_CREDENTIAL_EC',
  /** Extension key 'shipping_credential_es' for country ES. */
  ShippingCredentialEs = 'SHIPPING_CREDENTIAL_ES',
  /** Extension key 'shipping_credential_gt' for country GT. */
  ShippingCredentialGt = 'SHIPPING_CREDENTIAL_GT',
  /** Extension key 'shipping_credential_id' for country ID. */
  ShippingCredentialId = 'SHIPPING_CREDENTIAL_ID',
  /** Extension key 'shipping_credential_kr' for country KR. */
  ShippingCredentialKr = 'SHIPPING_CREDENTIAL_KR',
  /** Extension key 'shipping_credential_mx' for country MX. */
  ShippingCredentialMx = 'SHIPPING_CREDENTIAL_MX',
  /** Extension key 'shipping_credential_my' for country MY. */
  ShippingCredentialMy = 'SHIPPING_CREDENTIAL_MY',
  /** Extension key 'shipping_credential_pe' for country PE. */
  ShippingCredentialPe = 'SHIPPING_CREDENTIAL_PE',
  /** Extension key 'shipping_credential_pt' for country PT. */
  ShippingCredentialPt = 'SHIPPING_CREDENTIAL_PT',
  /** Extension key 'shipping_credential_py' for country PY. */
  ShippingCredentialPy = 'SHIPPING_CREDENTIAL_PY',
  /** Extension key 'shipping_credential_tr' for country TR. */
  ShippingCredentialTr = 'SHIPPING_CREDENTIAL_TR',
  /** Extension key 'shipping_credential_tw' for country TW. */
  ShippingCredentialTw = 'SHIPPING_CREDENTIAL_TW',
  /** Extension key 'shipping_credential_type_co' for country CO. */
  ShippingCredentialTypeCo = 'SHIPPING_CREDENTIAL_TYPE_CO',
  /** Extension key 'tax_credential_br' for country BR. */
  TaxCredentialBr = 'TAX_CREDENTIAL_BR',
  /** Extension key 'tax_credential_cl' for country CL. */
  TaxCredentialCl = 'TAX_CREDENTIAL_CL',
  /** Extension key 'tax_credential_co' for country CO. */
  TaxCredentialCo = 'TAX_CREDENTIAL_CO',
  /** Extension key 'tax_credential_cr' for country CR. */
  TaxCredentialCr = 'TAX_CREDENTIAL_CR',
  /** Extension key 'tax_credential_ec' for country EC. */
  TaxCredentialEc = 'TAX_CREDENTIAL_EC',
  /** Extension key 'tax_credential_es' for country ES. */
  TaxCredentialEs = 'TAX_CREDENTIAL_ES',
  /** Extension key 'tax_credential_gt' for country GT. */
  TaxCredentialGt = 'TAX_CREDENTIAL_GT',
  /** Extension key 'tax_credential_id' for country ID. */
  TaxCredentialId = 'TAX_CREDENTIAL_ID',
  /** Extension key 'tax_credential_it' for country IT. */
  TaxCredentialIt = 'TAX_CREDENTIAL_IT',
  /** Extension key 'tax_credential_mx' for country MX. */
  TaxCredentialMx = 'TAX_CREDENTIAL_MX',
  /** Extension key 'tax_credential_my' for country MY. */
  TaxCredentialMy = 'TAX_CREDENTIAL_MY',
  /** Extension key 'tax_credential_pe' for country PE. */
  TaxCredentialPe = 'TAX_CREDENTIAL_PE',
  /** Extension key 'tax_credential_pt' for country PT. */
  TaxCredentialPt = 'TAX_CREDENTIAL_PT',
  /** Extension key 'tax_credential_py' for country PY. */
  TaxCredentialPy = 'TAX_CREDENTIAL_PY',
  /** Extension key 'tax_credential_tr' for country TR. */
  TaxCredentialTr = 'TAX_CREDENTIAL_TR',
  /** Extension key 'tax_credential_type_co' for country CO. */
  TaxCredentialTypeCo = 'TAX_CREDENTIAL_TYPE_CO',
  /** Extension key 'tax_credential_type_mx' for country MX. */
  TaxCredentialTypeMx = 'TAX_CREDENTIAL_TYPE_MX',
  /** Extension key 'tax_credential_use_mx' for country MX. */
  TaxCredentialUseMx = 'TAX_CREDENTIAL_USE_MX',
  /** Extension key 'tax_email_it' for country IT. */
  TaxEmailIt = 'TAX_EMAIL_IT'
}

/** The purpose of a localization extension. */
export enum LocalizationExtensionPurpose {
  /** Extensions that are used for shipping purposes, for example, customs clearance. */
  Shipping = 'SHIPPING',
  /** Extensions that are used for taxes purposes, for example, invoicing. */
  Tax = 'TAX'
}

/** Represents the value captured by a localized field. Localized fields are additional fields required by certain countries on international orders. For example, some countries require additional fields for customs information or tax identification numbers. */
export type LocalizedField = {
  __typename?: 'LocalizedField';
  /** Country ISO 3166-1 alpha-2 code. */
  countryCode: CountryCode;
  /** The localized field keys that are allowed. */
  key: LocalizedFieldKey;
  /** The purpose of this localized field. */
  purpose: LocalizedFieldPurpose;
  /** The localized field title. */
  title: Scalars['String']['output'];
  /** The value of the field. */
  value: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple LocalizedFields. */
export type LocalizedFieldConnection = {
  __typename?: 'LocalizedFieldConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<LocalizedFieldEdge>;
  /** A list of nodes that are contained in LocalizedFieldEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<LocalizedField>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one LocalizedField and a cursor during pagination. */
export type LocalizedFieldEdge = {
  __typename?: 'LocalizedFieldEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of LocalizedFieldEdge. */
  node: LocalizedField;
};

/** The input fields for a LocalizedFieldInput. */
export type LocalizedFieldInput = {
  /** The key for the localized field. */
  key: LocalizedFieldKey;
  /** The localized field value. */
  value: Scalars['String']['input'];
};

/** The key of a localized field. */
export enum LocalizedFieldKey {
  /** Localized field key 'shipping_credential_br' for country Brazil. */
  ShippingCredentialBr = 'SHIPPING_CREDENTIAL_BR',
  /** Localized field key 'shipping_credential_cl' for country Chile. */
  ShippingCredentialCl = 'SHIPPING_CREDENTIAL_CL',
  /** Localized field key 'shipping_credential_cn' for country China. */
  ShippingCredentialCn = 'SHIPPING_CREDENTIAL_CN',
  /** Localized field key 'shipping_credential_co' for country Colombia. */
  ShippingCredentialCo = 'SHIPPING_CREDENTIAL_CO',
  /** Localized field key 'shipping_credential_cr' for country Costa Rica. */
  ShippingCredentialCr = 'SHIPPING_CREDENTIAL_CR',
  /** Localized field key 'shipping_credential_ec' for country Ecuador. */
  ShippingCredentialEc = 'SHIPPING_CREDENTIAL_EC',
  /** Localized field key 'shipping_credential_es' for country Spain. */
  ShippingCredentialEs = 'SHIPPING_CREDENTIAL_ES',
  /** Localized field key 'shipping_credential_gt' for country Guatemala. */
  ShippingCredentialGt = 'SHIPPING_CREDENTIAL_GT',
  /** Localized field key 'shipping_credential_id' for country Indonesia. */
  ShippingCredentialId = 'SHIPPING_CREDENTIAL_ID',
  /** Localized field key 'shipping_credential_kr' for country South Korea. */
  ShippingCredentialKr = 'SHIPPING_CREDENTIAL_KR',
  /** Localized field key 'shipping_credential_mx' for country Mexico. */
  ShippingCredentialMx = 'SHIPPING_CREDENTIAL_MX',
  /** Localized field key 'shipping_credential_my' for country Malaysia. */
  ShippingCredentialMy = 'SHIPPING_CREDENTIAL_MY',
  /** Localized field key 'shipping_credential_pe' for country Peru. */
  ShippingCredentialPe = 'SHIPPING_CREDENTIAL_PE',
  /** Localized field key 'shipping_credential_pt' for country Portugal. */
  ShippingCredentialPt = 'SHIPPING_CREDENTIAL_PT',
  /** Localized field key 'shipping_credential_py' for country Paraguay. */
  ShippingCredentialPy = 'SHIPPING_CREDENTIAL_PY',
  /** Localized field key 'shipping_credential_tr' for country Turkey. */
  ShippingCredentialTr = 'SHIPPING_CREDENTIAL_TR',
  /** Localized field key 'shipping_credential_tw' for country Taiwan. */
  ShippingCredentialTw = 'SHIPPING_CREDENTIAL_TW',
  /** Localized field key 'shipping_credential_type_co' for country Colombia. */
  ShippingCredentialTypeCo = 'SHIPPING_CREDENTIAL_TYPE_CO',
  /** Localized field key 'tax_credential_br' for country Brazil. */
  TaxCredentialBr = 'TAX_CREDENTIAL_BR',
  /** Localized field key 'tax_credential_cl' for country Chile. */
  TaxCredentialCl = 'TAX_CREDENTIAL_CL',
  /** Localized field key 'tax_credential_co' for country Colombia. */
  TaxCredentialCo = 'TAX_CREDENTIAL_CO',
  /** Localized field key 'tax_credential_cr' for country Costa Rica. */
  TaxCredentialCr = 'TAX_CREDENTIAL_CR',
  /** Localized field key 'tax_credential_ec' for country Ecuador. */
  TaxCredentialEc = 'TAX_CREDENTIAL_EC',
  /** Localized field key 'tax_credential_es' for country Spain. */
  TaxCredentialEs = 'TAX_CREDENTIAL_ES',
  /** Localized field key 'tax_credential_gt' for country Guatemala. */
  TaxCredentialGt = 'TAX_CREDENTIAL_GT',
  /** Localized field key 'tax_credential_id' for country Indonesia. */
  TaxCredentialId = 'TAX_CREDENTIAL_ID',
  /** Localized field key 'tax_credential_it' for country Italy. */
  TaxCredentialIt = 'TAX_CREDENTIAL_IT',
  /** Localized field key 'tax_credential_mx' for country Mexico. */
  TaxCredentialMx = 'TAX_CREDENTIAL_MX',
  /** Localized field key 'tax_credential_my' for country Malaysia. */
  TaxCredentialMy = 'TAX_CREDENTIAL_MY',
  /** Localized field key 'tax_credential_pe' for country Peru. */
  TaxCredentialPe = 'TAX_CREDENTIAL_PE',
  /** Localized field key 'tax_credential_pt' for country Portugal. */
  TaxCredentialPt = 'TAX_CREDENTIAL_PT',
  /** Localized field key 'tax_credential_py' for country Paraguay. */
  TaxCredentialPy = 'TAX_CREDENTIAL_PY',
  /** Localized field key 'tax_credential_tr' for country Turkey. */
  TaxCredentialTr = 'TAX_CREDENTIAL_TR',
  /** Localized field key 'tax_credential_type_co' for country Colombia. */
  TaxCredentialTypeCo = 'TAX_CREDENTIAL_TYPE_CO',
  /** Localized field key 'tax_credential_type_mx' for country Mexico. */
  TaxCredentialTypeMx = 'TAX_CREDENTIAL_TYPE_MX',
  /** Localized field key 'tax_credential_use_mx' for country Mexico. */
  TaxCredentialUseMx = 'TAX_CREDENTIAL_USE_MX',
  /** Localized field key 'tax_email_it' for country Italy. */
  TaxEmailIt = 'TAX_EMAIL_IT'
}

/** The purpose of a localized field. */
export enum LocalizedFieldPurpose {
  /** Fields that are used for shipping purposes, for example, customs clearance. */
  Shipping = 'SHIPPING',
  /** Fields that are used for taxes purposes, for example, invoicing. */
  Tax = 'TAX'
}

/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type Location = HasMetafieldDefinitions & HasMetafields & LegacyInteroperability & Node & {
  __typename?: 'Location';
  /**
   * Whether the location can be reactivated. If `false`, then trying to activate the location with the
   * [`LocationActivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationActivate)
   * mutation will return an error that describes why the location can't be activated.
   */
  activatable: Scalars['Boolean']['output'];
  /** The address of this location. */
  address: LocationAddress;
  /** Whether the location address has been verified. */
  addressVerified: Scalars['Boolean']['output'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) that the location was added to a shop. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Whether this location can be deactivated. If `true`, then the location can be deactivated by calling the
   * [`LocationDeactivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationDeactivate)
   * mutation. If `false`, then calling the mutation to deactivate it will return an error that describes why the
   * location can't be deactivated.
   */
  deactivatable: Scalars['Boolean']['output'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) that the location was deactivated at. For example, 3:30 pm on September 7, 2019 in the time zone of UTC (Universal Time Coordinated) is represented as `"2019-09-07T15:50:00Z`". */
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  /** Whether this location can be deleted. */
  deletable: Scalars['Boolean']['output'];
  /** Name of the service provider that fulfills from this location. */
  fulfillmentService?: Maybe<FulfillmentService>;
  /** Whether this location can fulfill online orders. */
  fulfillsOnlineOrders: Scalars['Boolean']['output'];
  /** Whether this location has active inventory. */
  hasActiveInventory: Scalars['Boolean']['output'];
  /** Whether this location has orders that need to be fulfilled. */
  hasUnfulfilledOrders: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The quantities of an inventory item at this location. */
  inventoryLevel?: Maybe<InventoryLevel>;
  /** A list of the quantities of the inventory items that can be stocked at this location. */
  inventoryLevels: InventoryLevelConnection;
  /**
   * Whether the location is active. A deactivated location can be activated (change `isActive: true`) if it has
   * `activatable` set to `true` by calling the
   * [`locationActivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationActivate)
   * mutation.
   */
  isActive: Scalars['Boolean']['output'];
  /** Whether this location is a fulfillment service. */
  isFulfillmentService: Scalars['Boolean']['output'];
  /**
   * Whether the location is your primary location for shipping inventory.
   * @deprecated The concept of a primary location is deprecated, shipsInventory can be used to get a fallback location
   */
  isPrimary: Scalars['Boolean']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** Local pickup settings for the location. */
  localPickupSettingsV2?: Maybe<DeliveryLocalPickupSettings>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The name of the location. */
  name: Scalars['String']['output'];
  /** Legacy field indicating this location was designated for shipping. All locations with valid addresses can now ship. */
  shipsInventory: Scalars['Boolean']['output'];
  /** List of suggested addresses for this location (empty if none). */
  suggestedAddresses: Array<LocationSuggestedAddress>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the location was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type LocationInventoryLevelArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryItemId: Scalars['ID']['input'];
};


/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type LocationInventoryLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type LocationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type LocationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A physical location where merchants store and fulfill inventory. Locations include retail stores, warehouses, popups, dropshippers, or other places where inventory is managed or stocked.
 *
 * Active locations can fulfill online orders when configured with shipping rates, local pickup, or local delivery options. Locations track inventory quantities for [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and process [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) fulfillment. Third-party apps using [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can create and manage their own locations.
 */
export type LocationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `locationActivate` mutation. */
export type LocationActivatePayload = {
  __typename?: 'LocationActivatePayload';
  /** The location that was activated. */
  location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  locationActivateUserErrors: Array<LocationActivateUserError>;
};

/** An error that occurs while activating a location. */
export type LocationActivateUserError = DisplayableError & {
  __typename?: 'LocationActivateUserError';
  /** The error code. */
  code?: Maybe<LocationActivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `LocationActivateUserError`. */
export enum LocationActivateUserErrorCode {
  /** An error occurred while activating the location. */
  GenericError = 'GENERIC_ERROR',
  /** There is already an active location with this name. */
  HasNonUniqueName = 'HAS_NON_UNIQUE_NAME',
  /** This location currently cannot be activated as inventory, pending orders or transfers are being relocated from this location. */
  HasOngoingRelocation = 'HAS_ONGOING_RELOCATION',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** Shop has reached its location limit. */
  LocationLimit = 'LOCATION_LIMIT',
  /** Location not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND'
}

/** The input fields to use to specify the address while adding a location. */
export type LocationAddAddressInput = {
  /** The first line of the address. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The name of the city, district, village, or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code of country for the address. */
  countryCode: CountryCode;
  /** The phone number of the location. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * The code for the region of the address, such as the state, province, or district.
   * For example CA for California, United States.
   */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** The ZIP code or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields to use to add a location. */
export type LocationAddInput = {
  /** The address of the location. */
  address: LocationAddAddressInput;
  /** Whether inventory at this location is available for sale online. */
  fulfillsOnlineOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional customizable information to associate with the location. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The name of the location. */
  name: Scalars['String']['input'];
};

/** Return type for `locationAdd` mutation. */
export type LocationAddPayload = {
  __typename?: 'LocationAddPayload';
  /** The location that was added. */
  location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<LocationAddUserError>;
};

/** An error that occurs while adding a location. */
export type LocationAddUserError = DisplayableError & {
  __typename?: 'LocationAddUserError';
  /** The error code. */
  code?: Maybe<LocationAddUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `LocationAddUserError`. */
export enum LocationAddUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  AppNotAuthorized = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** An error occurred while adding the location. */
  GenericError = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The ZIP code is not a valid US ZIP code. */
  InvalidUsZipcode = 'INVALID_US_ZIPCODE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UnstructuredReservedNamespace = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** Represents the address of a location. */
export type LocationAddress = {
  __typename?: 'LocationAddress';
  /** The first line of the address for the location. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address for the location. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the location. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the location. */
  country?: Maybe<Scalars['String']['output']>;
  /** The country code of the location. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address for the location. */
  formatted: Array<Scalars['String']['output']>;
  /** The approximate latitude coordinates of the location. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The approximate longitude coordinates of the location. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The phone number of the location. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The province of the location. */
  province?: Maybe<Scalars['String']['output']>;
  /** The code for the province, state, or district of the address of the location. */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the location. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple Locations. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<LocationEdge>;
  /** A list of nodes that are contained in LocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Location>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `locationDeactivate` mutation. */
export type LocationDeactivatePayload = {
  __typename?: 'LocationDeactivatePayload';
  /** The location that was deactivated. */
  location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  locationDeactivateUserErrors: Array<LocationDeactivateUserError>;
};

/** The possible errors that can be returned when executing the `locationDeactivate` mutation. */
export type LocationDeactivateUserError = DisplayableError & {
  __typename?: 'LocationDeactivateUserError';
  /** The error code. */
  code?: Maybe<LocationDeactivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `LocationDeactivateUserError`. */
export enum LocationDeactivateUserErrorCode {
  /** At least one location must fulfill online orders. */
  CannotDisableOnlineOrderFulfillment = 'CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT',
  /** Destination location is the same as the location to be deactivated. */
  DestinationLocationIsTheSameLocation = 'DESTINATION_LOCATION_IS_THE_SAME_LOCATION',
  /** Destination location is not found or inactive. */
  DestinationLocationNotFoundOrInactive = 'DESTINATION_LOCATION_NOT_FOUND_OR_INACTIVE',
  /** Destination location is not Shopify managed. */
  DestinationLocationNotShopifyManaged = 'DESTINATION_LOCATION_NOT_SHOPIFY_MANAGED',
  /** Failed to relocate active inventories to the destination location. */
  FailedToRelocateActiveInventories = 'FAILED_TO_RELOCATE_ACTIVE_INVENTORIES',
  /** Failed to relocate incoming movements to the destination location. */
  FailedToRelocateIncomingMovements = 'FAILED_TO_RELOCATE_INCOMING_MOVEMENTS',
  /** Failed to relocate open purchase orders to the destination location. */
  FailedToRelocateOpenPurchaseOrders = 'FAILED_TO_RELOCATE_OPEN_PURCHASE_ORDERS',
  /** Location could not be deactivated without specifying where to relocate inventory at the location. */
  HasActiveInventoryError = 'HAS_ACTIVE_INVENTORY_ERROR',
  /** Location needs to be removed from Shopify POS for Retail subscription in Point of Sale channel. */
  HasActiveRetailSubscriptions = 'HAS_ACTIVE_RETAIL_SUBSCRIPTIONS',
  /** Location could not be deactivated because it has pending orders. */
  HasFulfillmentOrdersError = 'HAS_FULFILLMENT_ORDERS_ERROR',
  /**
   * Location could not be deactivated because it has incoming inventory quantities from third party
   *         applications.
   */
  HasIncomingFromExternalDocumentSources = 'HAS_INCOMING_FROM_EXTERNAL_DOCUMENT_SOURCES',
  /** Location could not be deactivated because it has open Shopify Fulfillment Network transfers. */
  HasIncomingMovementsError = 'HAS_INCOMING_MOVEMENTS_ERROR',
  /** Location could not be deactivated because it has open purchase orders. */
  HasOpenPurchaseOrdersError = 'HAS_OPEN_PURCHASE_ORDERS_ERROR',
  /** This request is currently in progress, please try again. */
  IdempotencyConcurrentRequest = 'IDEMPOTENCY_CONCURRENT_REQUEST',
  /** The same idempotency key cannot be used with different operation parameters. */
  IdempotencyKeyParameterMismatch = 'IDEMPOTENCY_KEY_PARAMETER_MISMATCH',
  /** Location not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND',
  /** Location either has a fulfillment service or is the only location with a shipping address. */
  PermanentlyBlockedFromDeactivationError = 'PERMANENTLY_BLOCKED_FROM_DEACTIVATION_ERROR',
  /** Location has incoming inventory. The location can be deactivated after the inventory has been received. */
  TemporarilyBlockedFromDeactivationError = 'TEMPORARILY_BLOCKED_FROM_DEACTIVATION_ERROR'
}

/** Return type for `locationDelete` mutation. */
export type LocationDeletePayload = {
  __typename?: 'LocationDeletePayload';
  /** The ID of the location that was deleted. */
  deletedLocationId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  locationDeleteUserErrors: Array<LocationDeleteUserError>;
};

/** An error that occurs while deleting a location. */
export type LocationDeleteUserError = DisplayableError & {
  __typename?: 'LocationDeleteUserError';
  /** The error code. */
  code?: Maybe<LocationDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `LocationDeleteUserError`. */
export enum LocationDeleteUserErrorCode {
  /** An error occurred while deleting the location. */
  GenericError = 'GENERIC_ERROR',
  /** The location cannot be deleted while it has any active Retail subscriptions in the Point of Sale channel. */
  LocationHasActiveRetailSubscription = 'LOCATION_HAS_ACTIVE_RETAIL_SUBSCRIPTION',
  /** The location cannot be deleted while it has inventory. */
  LocationHasInventory = 'LOCATION_HAS_INVENTORY',
  /** The location cannot be deleted while it has pending orders. */
  LocationHasPendingOrders = 'LOCATION_HAS_PENDING_ORDERS',
  /** The location cannot be deleted while it is active. */
  LocationIsActive = 'LOCATION_IS_ACTIVE',
  /** Location not found. */
  LocationNotFound = 'LOCATION_NOT_FOUND'
}

/** An auto-generated type which holds one Location and a cursor during pagination. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of LocationEdge. */
  node: Location;
};

/** The input fields to use to edit the address of a location. */
export type LocationEditAddressInput = {
  /** The first line of the address. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The name of the city, district, village, or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code of country for the address. */
  countryCode?: InputMaybe<CountryCode>;
  /** The phone number of the location. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * The code for the region of the address, such as the state, province, or district.
   * For example CA for California, United States.
   */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** The ZIP code or postal code of the location. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields to use to edit a location. */
export type LocationEditInput = {
  /** The address of the location. */
  address?: InputMaybe<LocationEditAddressInput>;
  /**
   * Whether inventory at this location is available for sale online.
   *
   * **Note:** This can't be disabled for fulfillment service locations.
   */
  fulfillsOnlineOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional customizable information to associate with the location. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The name of the location. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `locationEdit` mutation. */
export type LocationEditPayload = {
  __typename?: 'LocationEditPayload';
  /** The location that was edited. */
  location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<LocationEditUserError>;
};

/** An error that occurs while editing a location. */
export type LocationEditUserError = DisplayableError & {
  __typename?: 'LocationEditUserError';
  /** The error code. */
  code?: Maybe<LocationEditUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `LocationEditUserError`. */
export enum LocationEditUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  AppNotAuthorized = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** At least one location must fulfill online orders. */
  CannotDisableOnlineOrderFulfillment = 'CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT',
  /** Cannot modify the online order fulfillment preference for fulfillment service locations. */
  CannotModifyOnlineOrderFulfillmentForFsLocation = 'CANNOT_MODIFY_ONLINE_ORDER_FULFILLMENT_FOR_FS_LOCATION',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** An error occurred while editing the location. */
  GenericError = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The ZIP code is not a valid US ZIP code. */
  InvalidUsZipcode = 'INVALID_US_ZIPCODE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UnstructuredReservedNamespace = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** The input fields for identifying a location. */
export type LocationIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the location. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The ID of the location. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `locationLocalPickupDisable` mutation. */
export type LocationLocalPickupDisablePayload = {
  __typename?: 'LocationLocalPickupDisablePayload';
  /** The ID of the location for which local pickup was disabled. */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryLocationLocalPickupSettingsError>;
};

/** Return type for `locationLocalPickupEnable` mutation. */
export type LocationLocalPickupEnablePayload = {
  __typename?: 'LocationLocalPickupEnablePayload';
  /** The local pickup settings that were enabled. */
  localPickupSettings?: Maybe<DeliveryLocalPickupSettings>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<DeliveryLocationLocalPickupSettingsError>;
};

/** A snapshot of location details including name and address captured at a specific point in time. Refer to the parent model to know the lifecycle. */
export type LocationSnapshot = {
  __typename?: 'LocationSnapshot';
  /** The address details of the location as they were when the snapshot was recorded. */
  address: LocationAddress;
  /** A reference to the live Location object, if it still exists and is accessible. This provides current details of the location, which may differ from the snapshotted name and address. */
  location?: Maybe<Location>;
  /** The name of the location as it was when the snapshot was recorded. */
  name: Scalars['String']['output'];
  /** The date and time when these snapshot details (name and address) were recorded. */
  snapshottedAt: Scalars['DateTime']['output'];
};

/** The set of valid sort keys for the Location query. */
export enum LocationSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE'
}

/** Represents a suggested address for a location. */
export type LocationSuggestedAddress = {
  __typename?: 'LocationSuggestedAddress';
  /** The first line of the suggested address. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the suggested address. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the suggested address. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the suggested address. */
  country?: Maybe<Scalars['String']['output']>;
  /** The country code of the suggested address. */
  countryCode?: Maybe<CountryCode>;
  /** A formatted version of the suggested address. */
  formatted: Array<Scalars['String']['output']>;
  /** The province of the suggested address. */
  province?: Maybe<Scalars['String']['output']>;
  /** The code for the province, state, or district of the suggested address. */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the suggested address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** A condition checking the location that the visitor is shopping from. */
export type LocationsCondition = {
  __typename?: 'LocationsCondition';
  /** The application level for the condition. */
  applicationLevel?: Maybe<MarketConditionApplicationType>;
  /** The locations that comprise the market. */
  locations: LocationConnection;
};


/** A condition checking the location that the visitor is shopping from. */
export type LocationsConditionLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A physical mailing address. For example, a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s default address and an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)'s billing address are both mailing addresses. Stores standard address components, customer name information, and company details.
 *
 * The address includes geographic coordinates ([`latitude`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.latitude) and [`longitude`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.longitude)). You can format addresses for display using the [`formatted`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.formatted) field with options to include or exclude name and company information.
 */
export type MailingAddress = Node & {
  __typename?: 'MailingAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the customer's company or organization. */
  company?: Maybe<Scalars['String']['output']>;
  /** Whether the address corresponds to recognized latitude and longitude values. */
  coordinatesValidated: Scalars['Boolean']['output'];
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   * @deprecated Use `countryCodeV2` instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   */
  countryCodeV2?: Maybe<CountryCode>;
  /** The first name of the customer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address, customized by the provided arguments. */
  formatted: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the customer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the customer address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the customer address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The full name of the customer, based on firstName and lastName. */
  name?: Maybe<Scalars['String']['output']>;
  /** A unique phone number for the customer. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The time zone of the address. */
  timeZone?: Maybe<Scalars['String']['output']>;
  /**
   * The validation status that's leveraged by the address validation feature in the Shopify Admin.
   * See ["Validating addresses in your Shopify admin"](https://help.shopify.com/manual/fulfillment/managing-orders/validating-order-address) for more details.
   */
  validationResultSummary?: Maybe<MailingAddressValidationResult>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};


/**
 * A physical mailing address. For example, a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s default address and an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)'s billing address are both mailing addresses. Stores standard address components, customer name information, and company details.
 *
 * The address includes geographic coordinates ([`latitude`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.latitude) and [`longitude`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.longitude)). You can format addresses for display using the [`formatted`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress#field-MailingAddress.fields.formatted) field with options to include or exclude name and company information.
 */
export type MailingAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']['input']>;
  withName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple MailingAddresses. */
export type MailingAddressConnection = {
  __typename?: 'MailingAddressConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MailingAddressEdge>;
  /** A list of nodes that are contained in MailingAddressEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MailingAddress>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MailingAddress and a cursor during pagination. */
export type MailingAddressEdge = {
  __typename?: 'MailingAddressEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MailingAddressEdge. */
  node: MailingAddress;
};

/** The input fields to create or update a mailing address. */
export type MailingAddressInput = {
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The name of the city, district, village, or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer's company or organization. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code for the country of the address. */
  countryCode?: InputMaybe<CountryCode>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * The code for the region of the address, such as the province, state, or district.
   * For example QC for Quebec, Canada.
   */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Highest level of validation concerns identified for the address. */
export enum MailingAddressValidationResult {
  /** Indicates that the address has been validated and is very likely to contain invalid information. */
  Error = 'ERROR',
  /** Indicates that the address has been validated and no issues were found. */
  NoIssues = 'NO_ISSUES',
  /** Indicates that the address has been validated and might contain invalid information. */
  Warning = 'WARNING'
}

/** The type of resource a payment mandate can be used for. */
export enum MandateResourceType {
  /** A credential stored on file for checkout. */
  Checkout = 'CHECKOUT',
  /** A credential stored on file for merchant and customer initiated transactions. */
  CredentialOnFile = 'CREDENTIAL_ON_FILE',
  /** A credential stored on file for a Draft Order. */
  DraftOrder = 'DRAFT_ORDER',
  /** A credential stored on file for an Order. */
  Order = 'ORDER',
  /** A credential stored for subscription billing attempts. */
  Subscriptions = 'SUBSCRIPTIONS'
}

/**
 * Manual discount applications capture the intentions of a discount that was manually created for an order.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type ManualDiscountApplication = DiscountApplication & {
  __typename?: 'ManualDiscountApplication';
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /** The description of the discount application. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  index: Scalars['Int']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The title of the discount application. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: PricingValue;
};

/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type Market = HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'Market';
  /** Whether the market has a customization with the given ID. */
  assignedCustomization: Scalars['Boolean']['output'];
  /** The catalogs that belong to the market. */
  catalogs: MarketCatalogConnection;
  /** The number of catalogs that belong to the market. */
  catalogsCount?: Maybe<Count>;
  /** The conditions under which a visitor is in the market. */
  conditions?: Maybe<MarketConditions>;
  /** The market’s currency settings. */
  currencySettings?: Maybe<MarketCurrencySettings>;
  /** The delivery settings for this market. */
  delivery: MarketDeliveryConfigurations;
  /** The discounts that are available in this market. */
  discounts?: Maybe<DiscountNodeConnection>;
  /** The number of discounts that are assigned to this market. */
  discountsCount?: Maybe<Count>;
  /**
   * Whether the market is enabled to receive visitors and sales. **Note**: Regions in inactive
   * markets can't be selected on the storefront or in checkout.
   * @deprecated Use `status` instead.
   */
  enabled: Scalars['Boolean']['output'];
  /** A short, human-readable unique identifier for the market. This is changeable by the merchant. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The name of the market. Not shown to customers. */
  name: Scalars['String']['output'];
  /** The inclusive pricing strategy for a market. This determines if prices include duties and / or taxes. */
  priceInclusions?: Maybe<MarketPriceInclusions>;
  /**
   * The market’s price list, which specifies a percentage-based price adjustment as well as
   * fixed price overrides for specific variants.
   *
   * Markets with multiple catalogs can have multiple price lists. To query which price lists are connected to
   * a market, please query for price lists through the catalogs connection.
   * @deprecated Use `catalogs` instead.
   */
  priceList?: Maybe<PriceList>;
  /**
   * Whether the market is the shop’s primary market.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  primary: Scalars['Boolean']['output'];
  /**
   * The regions that comprise the market.
   * @deprecated This field is deprecated and will be removed in the future. Use `conditions.regionConditions` instead.
   */
  regions: MarketRegionConnection;
  /** Status of the market. Replaces the enabled field. */
  status: MarketStatus;
  /** The type of the market. */
  type: MarketType;
  /**
   * The market’s web presence, which defines its SEO strategy. This can be a different domain,
   * subdomain, or subfolders of the primary domain. Each web presence comprises one or more
   * language variants. If a market doesn't have its own web presence, then the market is accessible on the
   * primary market's domains using [country
   * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
   * If it's the primary market and it has multiple web presences, then this field will return the primary domain web presence.
   * @deprecated Use `webPresences` instead.
   */
  webPresence?: Maybe<MarketWebPresence>;
  /**
   * The market’s web presences, which defines its SEO strategy. This can be a different domain,
   * subdomain, or subfolders of the primary domain. Each web presence comprises one or more
   * language variants. If a market doesn't have any web presences, then the market is accessible on the
   * primary market's domains using [country
   * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
   */
  webPresences: MarketWebPresenceConnection;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketAssignedCustomizationArgs = {
  customizationId: Scalars['ID']['input'];
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A merchant-defined group of buyers identified by conditions such as their
 * region, retail location, or company location. Each market allows configuration
 * of a distinct, localized buyer experience. Customizations include, but are
 * not limited to,
 * [currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [pricing and product availability](https://shopify.dev/apps/internationalization/product-price-lists),
 * [web presence](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence),
 * and content translations.
 */
export type MarketWebPresencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A catalog for managing product availability and pricing for specific [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) contexts. Each catalog links to one or more markets. The catalog can optionally include a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) to control which [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects customers see, and a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) for market-specific pricing adjustments. When a publication isn't associated with the catalog, product availability is determined by the sales channel.
 *
 * Use catalogs to create distinct shopping experiences for different geographic regions or customer segments.
 *
 * Learn more about [building a catalog](https://shopify.dev/docs/apps/build/markets/build-catalog) and [managing markets](https://shopify.dev/docs/apps/build/markets).
 */
export type MarketCatalog = Catalog & Node & {
  __typename?: 'MarketCatalog';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The markets associated with the catalog. */
  markets: MarketConnection;
  /** The number of markets associated with the catalog. */
  marketsCount?: Maybe<Count>;
  /** Most recent catalog operations. */
  operations: Array<ResourceOperation>;
  /** The price list associated with the catalog. */
  priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  publication?: Maybe<Publication>;
  /** The status of the catalog. */
  status: CatalogStatus;
  /** The name of the catalog. */
  title: Scalars['String']['output'];
};


/**
 * A catalog for managing product availability and pricing for specific [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) contexts. Each catalog links to one or more markets. The catalog can optionally include a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) to control which [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects customers see, and a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) for market-specific pricing adjustments. When a publication isn't associated with the catalog, product availability is determined by the sales channel.
 *
 * Use catalogs to create distinct shopping experiences for different geographic regions or customer segments.
 *
 * Learn more about [building a catalog](https://shopify.dev/docs/apps/build/markets/build-catalog) and [managing markets](https://shopify.dev/docs/apps/build/markets).
 */
export type MarketCatalogMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<MarketStatus>;
  type?: InputMaybe<MarketType>;
};


/**
 * A catalog for managing product availability and pricing for specific [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) contexts. Each catalog links to one or more markets. The catalog can optionally include a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) to control which [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects customers see, and a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) for market-specific pricing adjustments. When a publication isn't associated with the catalog, product availability is determined by the sales channel.
 *
 * Use catalogs to create distinct shopping experiences for different geographic regions or customer segments.
 *
 * Learn more about [building a catalog](https://shopify.dev/docs/apps/build/markets/build-catalog) and [managing markets](https://shopify.dev/docs/apps/build/markets).
 */
export type MarketCatalogMarketsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MarketStatus>;
  type?: InputMaybe<MarketType>;
};

/** An auto-generated type for paginating through multiple MarketCatalogs. */
export type MarketCatalogConnection = {
  __typename?: 'MarketCatalogConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketCatalogEdge>;
  /** A list of nodes that are contained in MarketCatalogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketCatalog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketCatalog and a cursor during pagination. */
export type MarketCatalogEdge = {
  __typename?: 'MarketCatalogEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketCatalogEdge. */
  node: MarketCatalog;
};

/** The application level for a market condition. */
export enum MarketConditionApplicationType {
  /** The condition matches all records of a given type. */
  All = 'ALL',
  /** The condition matches specified records of a given type. */
  Specified = 'SPECIFIED'
}

/** The condition types for the condition set. */
export enum MarketConditionType {
  /** The condition checks the channel that the visitor is shopping from. */
  Channel = 'CHANNEL',
  /** The condition checks the company location that the visitor is purchasing for. */
  CompanyLocation = 'COMPANY_LOCATION',
  /** The condition checks the location that the visitor is shopping from. */
  Location = 'LOCATION',
  /** The condition checks the visitor's region. */
  Region = 'REGION'
}

/** The conditions that determine whether a visitor is in a market. */
export type MarketConditions = {
  __typename?: 'MarketConditions';
  /** The channel conditions that determine whether a visitor is in the market. */
  channelsCondition?: Maybe<ChannelsCondition>;
  /** The company location conditions that determine whether a visitor is in the market. */
  companyLocationsCondition?: Maybe<CompanyLocationsCondition>;
  /** The set of condition types that are defined for the market. */
  conditionTypes: Array<MarketConditionType>;
  /** The retail location conditions that determine whether a visitor is in the market. */
  locationsCondition?: Maybe<LocationsCondition>;
  /** The region conditions that determine whether a visitor is in the market. */
  regionsCondition?: Maybe<RegionsCondition>;
};

/** The input fields required to create or update a channel market condition. */
export type MarketConditionsChannelsInput = {
  /** A list of channel IDs to include in the market condition. */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields required to create or update a company location market condition. */
export type MarketConditionsCompanyLocationsInput = {
  /** A type of market condition (e.g. ALL) to apply. */
  applicationLevel?: InputMaybe<MarketConditionApplicationType>;
  /** A list of company location IDs to include in the market condition. */
  companyLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields required to create or update the market conditions. */
export type MarketConditionsInput = {
  /** The channels to include in the market conditions. */
  channelsCondition?: InputMaybe<MarketConditionsChannelsInput>;
  /** The company locations to include in the market conditions. */
  companyLocationsCondition?: InputMaybe<MarketConditionsCompanyLocationsInput>;
  /** The locations to include in the market conditions. */
  locationsCondition?: InputMaybe<MarketConditionsLocationsInput>;
  /** The regions to include in the market conditions. */
  regionsCondition?: InputMaybe<MarketConditionsRegionsInput>;
};

/** The input fields required to create or update a location market condition. */
export type MarketConditionsLocationsInput = {
  /** A type of market condition (e.g. ALL) to apply. */
  applicationLevel?: InputMaybe<MarketConditionApplicationType>;
  /** A list of location IDs to include in the market condition. */
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields to specify a region condition. */
export type MarketConditionsRegionInput = {
  /** A country code to which this condition should apply. */
  countryCode: CountryCode;
  /** A subdivision such as a province or state. */
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields required to create or update a region market condition. */
export type MarketConditionsRegionsInput = {
  /** A type of market condition (e.g. ALL) to apply. */
  applicationLevel?: InputMaybe<MarketConditionApplicationType>;
  /** A list of market region IDs to include in the market condition. */
  regionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of market regions to include in the market condition. */
  regions?: InputMaybe<Array<MarketConditionsRegionInput>>;
};

/** The input fields required to update a market condition. */
export type MarketConditionsUpdateInput = {
  /** The conditions to update to the market condition. */
  conditionsToAdd?: InputMaybe<MarketConditionsInput>;
  /** The conditions to delete from the market condition. */
  conditionsToDelete?: InputMaybe<MarketConditionsInput>;
};

/** An auto-generated type for paginating through multiple Markets. */
export type MarketConnection = {
  __typename?: 'MarketConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketEdge>;
  /** A list of nodes that are contained in MarketEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Market>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields required to create a market. */
export type MarketCreateInput = {
  /** Catalog IDs to include in the market. */
  catalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The conditions that apply to the market. */
  conditions?: InputMaybe<MarketConditionsInput>;
  /** Currency settings for the market. */
  currencySettings?: InputMaybe<MarketCurrencySettingsUpdateInput>;
  /** Delivery settings for the market. */
  delivery?: InputMaybe<MarketDeliveryConfigurationsCreateInput>;
  /** Discounts that are eligible for this market. */
  discounts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * A unique identifier for the market. For example `"ca"`.
   * If the handle isn't provided, then the handle is auto-generated based on the country or name.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether to update duplicate region or wildcard markets' status to draft. */
  makeDuplicateUniqueMarketsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the market. Not shown to customers. */
  name: Scalars['String']['input'];
  /** The strategy used to determine how prices are displayed to the customer. */
  priceInclusions?: InputMaybe<MarketPriceInclusionsInput>;
  /** The status of the market. */
  status?: InputMaybe<MarketStatus>;
  /** Web presence IDs to include in the market. */
  webPresences?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `marketCreate` mutation. */
export type MarketCreatePayload = {
  __typename?: 'MarketCreatePayload';
  /** The market object. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** A market's currency settings. */
export type MarketCurrencySettings = {
  __typename?: 'MarketCurrencySettings';
  /** The currency which this market's customers must use if local currencies are disabled. */
  baseCurrency: CurrencySetting;
  /**
   * Whether or not local currencies are enabled. If enabled, then prices will
   * be converted to give each customer the best experience based on their
   * region. If disabled, then all customers in this market will see prices
   * in the market's base currency.
   */
  localCurrencies: Scalars['Boolean']['output'];
  /** Whether or not rounding is enabled on multi-currency prices. */
  roundingEnabled: Scalars['Boolean']['output'];
};

/** The input fields used to update the currency settings of a market. */
export type MarketCurrencySettingsUpdateInput = {
  /** The currency which this market’s customers must use if local currencies are disabled. */
  baseCurrency?: InputMaybe<CurrencyCode>;
  /** The manual exchange rate that will be used to convert shop currency prices. If null, then the automatic exchange rates will be used. */
  baseCurrencyManualRate?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * Whether or not local currencies are enabled. If enabled, then prices will
   * be converted to give each customer the best experience based on their
   * region. If disabled, then all customers in this market will see prices
   * in the market's base currency.
   */
  localCurrencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not rounding is enabled on multi-currency prices. */
  roundingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `marketCurrencySettingsUpdate` mutation. */
export type MarketCurrencySettingsUpdatePayload = {
  __typename?: 'MarketCurrencySettingsUpdatePayload';
  /**
   * The market object.
   * @deprecated Use `marketCreate` and `marketUpdate` mutations instead.
   */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketCurrencySettingsUserError>;
};

/** Error codes for failed market multi-currency operations. */
export type MarketCurrencySettingsUserError = DisplayableError & {
  __typename?: 'MarketCurrencySettingsUserError';
  /** The error code. */
  code?: Maybe<MarketCurrencySettingsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MarketCurrencySettingsUserError`. */
export enum MarketCurrencySettingsUserErrorCode {
  /** Local currencies must be enabled when adaptive pricing is active. */
  AdaptivePricingRequiresLocalCurrencies = 'ADAPTIVE_PRICING_REQUIRES_LOCAL_CURRENCIES',
  /** The currency settings of the given market cannot be changed because the market manager has exclusive control of pricing. */
  ManagedMarket = 'MANAGED_MARKET',
  /** The specified market wasn't found. */
  MarketNotFound = 'MARKET_NOT_FOUND',
  /** The shop's payment gateway does not support enabling more than one currency. */
  MultipleCurrenciesNotSupported = 'MULTIPLE_CURRENCIES_NOT_SUPPORTED',
  /** Can't enable or disable local currencies on a single country market. */
  NoLocalCurrenciesOnSingleCountryMarket = 'NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET',
  /** The primary market must use the shop currency. */
  PrimaryMarketUsesShopCurrency = 'PRIMARY_MARKET_USES_SHOP_CURRENCY',
  /** This action is restricted if unified markets is enabled. */
  UnifiedMarketsEnabled = 'UNIFIED_MARKETS_ENABLED',
  /** The specified currency is not supported. */
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY'
}

/** Return type for `marketDelete` mutation. */
export type MarketDeletePayload = {
  __typename?: 'MarketDeletePayload';
  /** The ID of the deleted market. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** Delivery configurations for a market. Container type for shipping configuration. */
export type MarketDeliveryConfigurations = {
  __typename?: 'MarketDeliveryConfigurations';
  /** The shipping configuration for this market. Null means the market inherits shipping from its parent. */
  shipping?: Maybe<ShippingConfiguration>;
};

/** The input fields for configuring delivery for a new market. */
export type MarketDeliveryConfigurationsCreateInput = {
  /** The shipping configuration for the market. */
  shipping?: InputMaybe<ShippingConfigurationCreateInput>;
};

/** The input fields for configuring delivery for an existing market. */
export type MarketDeliveryConfigurationsUpdateInput = {
  /** When true, removes the shipping configuration so the market inherits shipping from its parent. */
  removeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping configuration changes. When omitted, shipping is not changed. */
  shipping?: InputMaybe<ShippingConfigurationUpdateInput>;
};

/** An auto-generated type which holds one Market and a cursor during pagination. */
export type MarketEdge = {
  __typename?: 'MarketEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketEdge. */
  node: Market;
};

/** The market localizable content of a resource's field. */
export type MarketLocalizableContent = {
  __typename?: 'MarketLocalizableContent';
  /** The hash digest representation of the content value. */
  digest?: Maybe<Scalars['String']['output']>;
  /** The resource field that's being localized. */
  key: Scalars['String']['output'];
  /** The content value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A resource that has market localizable fields. */
export type MarketLocalizableResource = {
  __typename?: 'MarketLocalizableResource';
  /** The market localizable content. */
  marketLocalizableContent: Array<MarketLocalizableContent>;
  /** Market localizations for the market localizable content. */
  marketLocalizations: Array<MarketLocalization>;
  /** The GID of the resource. */
  resourceId: Scalars['ID']['output'];
};


/** A resource that has market localizable fields. */
export type MarketLocalizableResourceMarketLocalizationsArgs = {
  marketId: Scalars['ID']['input'];
};

/** An auto-generated type for paginating through multiple MarketLocalizableResources. */
export type MarketLocalizableResourceConnection = {
  __typename?: 'MarketLocalizableResourceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketLocalizableResourceEdge>;
  /** A list of nodes that are contained in MarketLocalizableResourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketLocalizableResource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketLocalizableResource and a cursor during pagination. */
export type MarketLocalizableResourceEdge = {
  __typename?: 'MarketLocalizableResourceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketLocalizableResourceEdge. */
  node: MarketLocalizableResource;
};

/** The type of resources that are market localizable. */
export enum MarketLocalizableResourceType {
  /** A metafield. Market localizable fields: `value`. */
  Metafield = 'METAFIELD',
  /** A Metaobject. Market Localizable fields are determined by the Metaobject type. */
  Metaobject = 'METAOBJECT'
}

/** The market localization of a field within a resource, which is determined by the market ID. */
export type MarketLocalization = {
  __typename?: 'MarketLocalization';
  /** A reference to the value being localized on the resource that this market localization belongs to. */
  key: Scalars['String']['output'];
  /** The market that the localization is specific to. */
  market: Market;
  /** Whether the original content has changed since this market localization was updated. */
  outdated: Scalars['Boolean']['output'];
  /** The date and time when the market localization was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The value of the market localization. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The input fields and values for creating or updating a market localization. */
export type MarketLocalizationRegisterInput = {
  /** A reference to the value being localized on the resource that this market localization belongs to. */
  key: Scalars['String']['input'];
  /** The ID of the market that the localization is specific to. */
  marketId: Scalars['ID']['input'];
  /** A hash digest representation of the content being localized. */
  marketLocalizableContentDigest: Scalars['String']['input'];
  /** The value of the market localization. */
  value: Scalars['String']['input'];
};

/** Return type for `marketLocalizationsRegister` mutation. */
export type MarketLocalizationsRegisterPayload = {
  __typename?: 'MarketLocalizationsRegisterPayload';
  /** The market localizations that were created or updated. */
  marketLocalizations?: Maybe<Array<MarketLocalization>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TranslationUserError>;
};

/** Return type for `marketLocalizationsRemove` mutation. */
export type MarketLocalizationsRemovePayload = {
  __typename?: 'MarketLocalizationsRemovePayload';
  /** The market localizations that were deleted. */
  marketLocalizations?: Maybe<Array<MarketLocalization>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TranslationUserError>;
};

/** The inclusive pricing strategy for a market. */
export type MarketPriceInclusions = {
  __typename?: 'MarketPriceInclusions';
  /** Whether adaptive pricing is enabled for the market. Only applicable to Managed Markets and must be ignored otherwise. */
  adaptivePricingEnabled: Scalars['Boolean']['output'];
  /** The inclusive duties pricing strategy of the market. This determines if prices include duties. */
  inclusiveDutiesPricingStrategy: InclusiveDutiesPricingStrategy;
  /** The inclusive tax pricing strategy of the market. This determines if prices include taxes. */
  inclusiveTaxPricingStrategy: InclusiveTaxPricingStrategy;
};

/** The input fields used to create a price inclusion. */
export type MarketPriceInclusionsInput = {
  /** Whether adaptive pricing is enabled for the market. Only applicable for Markets with Managed Market enabled. When enabled, forces a state of `INCLUDES_TAXES_IN_PRICE_BASED_ON_COUNTRY`, `INCLUDE_DUTIES_IN_PRICE`, and `DDP`. When disabled, defaults to `INCLUDES_TAXES_IN_PRICE_BASED_ON_COUNTRY`, `ADD_DUTIES_AT_CHECKOUT`, and `DDP` unless otherwise specified. */
  adaptivePricingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The inclusive duties pricing strategy for the market. */
  dutiesPricingStrategy?: InputMaybe<InclusiveDutiesPricingStrategy>;
  /** The inclusive tax pricing strategy for the market. */
  taxPricingStrategy?: InputMaybe<InclusiveTaxPricingStrategy>;
};

/** A geographic region which comprises a market. */
export type MarketRegion = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the region. */
  name: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple MarketRegions. */
export type MarketRegionConnection = {
  __typename?: 'MarketRegionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketRegionEdge>;
  /** A list of nodes that are contained in MarketRegionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketRegion>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** A country which comprises a market. */
export type MarketRegionCountry = MarketRegion & Node & {
  __typename?: 'MarketRegionCountry';
  /** The ISO code identifying the country. */
  code: CountryCode;
  /** The currency which this country uses given its market settings. */
  currency: CurrencySetting;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the region. */
  name: Scalars['String']['output'];
};

/** The input fields for creating a market region with exactly one required option. */
export type MarketRegionCreateInput = {
  /** A country code for the region. */
  countryCode: CountryCode;
};

/** Return type for `marketRegionDelete` mutation. */
export type MarketRegionDeletePayload = {
  __typename?: 'MarketRegionDeletePayload';
  /** The ID of the deleted market region. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The parent market object of the deleted region. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** An auto-generated type which holds one MarketRegion and a cursor during pagination. */
export type MarketRegionEdge = {
  __typename?: 'MarketRegionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketRegionEdge. */
  node: MarketRegion;
};

/** A subdivision of a country which comprises a market. */
export type MarketRegionSubdivision = MarketRegion & Node & {
  __typename?: 'MarketRegionSubdivision';
  /** The ISO code identifying the subdivision. */
  code: Scalars['String']['output'];
  /** The country the subdivision belongs to. */
  country: MarketRegionSubdivisionCountry;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the region. */
  name: Scalars['String']['output'];
};

/** A country that a subdivision belongs to. */
export type MarketRegionSubdivisionCountry = {
  __typename?: 'MarketRegionSubdivisionCountry';
  /** The ISO code identifying the country. */
  code: CountryCode;
  /** The name of the country. */
  name: Scalars['String']['output'];
};

/** Return type for `marketRegionsCreate` mutation. */
export type MarketRegionsCreatePayload = {
  __typename?: 'MarketRegionsCreatePayload';
  /** The market object. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** Return type for `marketRegionsDelete` mutation. */
export type MarketRegionsDeletePayload = {
  __typename?: 'MarketRegionsDeletePayload';
  /** The ID of the deleted market region. */
  deletedIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** The possible market statuses. */
export enum MarketStatus {
  /** The market is active. */
  Active = 'ACTIVE',
  /** The market is in draft. */
  Draft = 'DRAFT'
}

/** The market types. */
export enum MarketType {
  /** The market applies to the visitor based on the channel. */
  Channel = 'CHANNEL',
  /** The market applies to the visitor based on the company location. */
  CompanyLocation = 'COMPANY_LOCATION',
  /** The market applies to the visitor based on the location. */
  Location = 'LOCATION',
  /** The market does not apply to any visitor. */
  None = 'NONE',
  /** The market applies to the visitor based on region. */
  Region = 'REGION'
}

/** The input fields used to update a market. */
export type MarketUpdateInput = {
  /** Catalog IDs to include in the market. */
  catalogsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Catalog IDs to remove from the market. */
  catalogsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The conditions to update. */
  conditions?: InputMaybe<MarketConditionsUpdateInput>;
  /** Currency settings for the market. */
  currencySettings?: InputMaybe<MarketCurrencySettingsUpdateInput>;
  /** Delivery setting updates. When omitted, delivery settings are not changed. */
  delivery?: InputMaybe<MarketDeliveryConfigurationsUpdateInput>;
  /** The discounts to add to the market. */
  discountsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The discounts to remove from the market. */
  discountsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the market. For example `"ca"`. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether to update duplicate region or wildcard markets' status to draft. */
  makeDuplicateUniqueMarketsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the market. Not shown to customers. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The strategy used to determine how prices are displayed to the customer. */
  priceInclusions?: InputMaybe<MarketPriceInclusionsInput>;
  /** Remove any currency settings that are defined for the market. */
  removeCurrencySettings?: InputMaybe<Scalars['Boolean']['input']>;
  /** The price inclusions to remove from the market. */
  removePriceInclusions?: InputMaybe<Scalars['Boolean']['input']>;
  /** The status of the market. */
  status?: InputMaybe<MarketStatus>;
  /** The web presences to add to the market. */
  webPresencesToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The web presences to remove from the market. */
  webPresencesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `marketUpdate` mutation. */
export type MarketUpdatePayload = {
  __typename?: 'MarketUpdatePayload';
  /** The market object. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** Defines errors encountered while managing a Market. */
export type MarketUserError = DisplayableError & {
  __typename?: 'MarketUserError';
  /** The error code. */
  code?: Maybe<MarketUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MarketUserError`. */
export enum MarketUserErrorCode {
  /** The given priceInclusions setup is not compatible with adaptive pricing. */
  AdaptivePricingRequiredSetupError = 'ADAPTIVE_PRICING_REQUIRED_SETUP_ERROR',
  /** Local currencies must be enabled when adaptive pricing is active. */
  AdaptivePricingRequiresLocalCurrencies = 'ADAPTIVE_PRICING_REQUIRES_LOCAL_CURRENCIES',
  /** Adaptive pricing can only be enabled for Markets with Managed Markets enabled. */
  AdaptivePricingRequiresManagedMarkets = 'ADAPTIVE_PRICING_REQUIRES_MANAGED_MARKETS',
  /** The maximum number of active B2B catalogs allowed by your plan has been reached. */
  B2BCatalogLimitReached = 'B2B_CATALOG_LIMIT_REACHED',
  /** B2B markets must be merchant managed. */
  B2BMarketMustBeMerchantManaged = 'B2B_MARKET_MUST_BE_MERCHANT_MANAGED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Can't activate this market because the B2B catalog limit has been reached. */
  CannotActivateMarketB2BCatalogLimitReached = 'CANNOT_ACTIVATE_MARKET_B2B_CATALOG_LIMIT_REACHED',
  /** Can't add all subdivisions for a country to a market. */
  CannotAddAllSubdivisionsForACountryToAMarket = 'CANNOT_ADD_ALL_SUBDIVISIONS_FOR_A_COUNTRY_TO_A_MARKET',
  /** Can't add customer account domain to a market. */
  CannotAddCustomerDomain = 'CANNOT_ADD_CUSTOMER_DOMAIN',
  /**
   * Can't add regions to the primary market.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  CannotAddRegionsToPrimaryMarket = 'CANNOT_ADD_REGIONS_TO_PRIMARY_MARKET',
  /**
   * Can't add the web presence to the primary market.
   * @deprecated No longer used
   */
  CannotAddWebPresenceToPrimaryMarket = 'CANNOT_ADD_WEB_PRESENCE_TO_PRIMARY_MARKET',
  /** Can't delete the only region in a market. */
  CannotDeleteOnlyRegion = 'CANNOT_DELETE_ONLY_REGION',
  /** Can't delete the primary market. */
  CannotDeletePrimaryMarket = 'CANNOT_DELETE_PRIMARY_MARKET',
  /**
   * Can't delete the primary market's web presence.
   * @deprecated No longer used
   */
  CannotDeletePrimaryMarketWebPresence = 'CANNOT_DELETE_PRIMARY_MARKET_WEB_PRESENCE',
  /** Can't delete the last subdivision-driven market. */
  CannotDeleteSubdivisionMarket = 'CANNOT_DELETE_SUBDIVISION_MARKET',
  /** Can't disable the primary market. */
  CannotDisablePrimaryMarket = 'CANNOT_DISABLE_PRIMARY_MARKET',
  /** Can't have both subfolder and domain web presences. */
  CannotHaveBothSubfolderAndDomainWebPresences = 'CANNOT_HAVE_BOTH_SUBFOLDER_AND_DOMAIN_WEB_PRESENCES',
  /** Can't have multiple subfolder web presences per market. */
  CannotHaveMultipleSubfoldersPerMarket = 'CANNOT_HAVE_MULTIPLE_SUBFOLDERS_PER_MARKET',
  /** Can't pass both `subfolderSuffix` and `domainId`. */
  CannotHaveSubfolderAndDomain = 'CANNOT_HAVE_SUBFOLDER_AND_DOMAIN',
  /** Can't set default locale to null. */
  CannotSetDefaultLocaleToNull = 'CANNOT_SET_DEFAULT_LOCALE_TO_NULL',
  /** Catalogs with volume pricing or quantity rules are not supported for the specified condition types. */
  CatalogsWithVolumePricingOrQuantityRulesNotSupported = 'CATALOGS_WITH_VOLUME_PRICING_OR_QUANTITY_RULES_NOT_SUPPORTED',
  /** Catalog condition types must be the same for all conditions on a catalog. */
  CatalogConditionTypesMustBeTheSame = 'CATALOG_CONDITION_TYPES_MUST_BE_THE_SAME',
  /** Catalogs and condition types are not compatible with each other. */
  CatalogNotCompatibleWithConditionTypes = 'CATALOG_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** A market can only have market catalogs. */
  CatalogTypeNotSupported = 'CATALOG_TYPE_NOT_SUPPORTED',
  /** A channel driver must have a channel specification. */
  ChannelDriverMustHaveChannelSpecification = 'CHANNEL_DRIVER_MUST_HAVE_CHANNEL_SPECIFICATION',
  /** A channel market must have a single channel driver. */
  ChannelMarketMustHaveSingleChannelDriver = 'CHANNEL_MARKET_MUST_HAVE_SINGLE_CHANNEL_DRIVER',
  /** The selected channel is not valid for a channel market. */
  ChannelNotValidForChannelMarket = 'CHANNEL_NOT_VALID_FOR_CHANNEL_MARKET',
  /** One or more condition IDs were not found. */
  ConditionsNotFound = 'CONDITIONS_NOT_FOUND',
  /** Contains regions that cannot be managed. */
  ContainsRegionsThatCannotBeManaged = 'CONTAINS_REGIONS_THAT_CANNOT_BE_MANAGED',
  /** One or more customizations were not found. */
  CustomizationsNotFound = 'CUSTOMIZATIONS_NOT_FOUND',
  /** The language isn't enabled on the store. */
  DisabledLanguage = 'DISABLED_LANGUAGE',
  /** One or more discounts exceed the maximum number of markets allowed. */
  DiscountExceedsMarketLimit = 'DISCOUNT_EXCEEDS_MARKET_LIMIT',
  /** The shop does not have discounts enabled for B2B markets. */
  DiscountNotCompatibleWithB2BMarket = 'DISCOUNT_NOT_COMPATIBLE_WITH_B2B_MARKET',
  /** One or more discounts do not have market eligibility. */
  DiscountNotMarketContextual = 'DISCOUNT_NOT_MARKET_CONTEXTUAL',
  /** Domain was not found. */
  DomainNotFound = 'DOMAIN_NOT_FOUND',
  /** Duplicates found in languages. */
  DuplicateLanguages = 'DUPLICATE_LANGUAGES',
  /** Duplicate region market. */
  DuplicateRegionMarket = 'DUPLICATE_REGION_MARKET',
  /** Duplicate unique market. */
  DuplicateUniqueMarket = 'DUPLICATE_UNIQUE_MARKET',
  /** Exceeds max multi-context markets. */
  ExceedsMaxMultiContextMarkets = 'EXCEEDS_MAX_MULTI_CONTEXT_MARKETS',
  /** An error occurred. See the message for details. */
  GenericError = 'GENERIC_ERROR',
  /** Global-e pricing configurations can only be edited by Global-e. */
  GlobalEPricingStrategyNotPermitted = 'GLOBAL_E_PRICING_STRATEGY_NOT_PERMITTED',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** Inclusive pricing cannot be added to a market with the specified condition types. */
  InclusivePricingNotCompatibleWithConditionTypes = 'INCLUSIVE_PRICING_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The specified conditions are not compatible with each other. */
  IncompatibleConditions = 'INCOMPATIBLE_CONDITIONS',
  /** The selected customization can't be applied to this configuration. */
  IncompatibleConfiguration = 'INCOMPATIBLE_CONFIGURATION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Channel ids are invalid. */
  InvalidChannelIds = 'INVALID_CHANNEL_IDS',
  /** A country condition and a subdivision condition belonging to the same country cannot be added to the same market. */
  InvalidCountryAndSubdivisionConditions = 'INVALID_COUNTRY_AND_SUBDIVISION_CONDITIONS',
  /** Can't add selected customizations to a market with a subdivision condition. */
  InvalidCustomizationForSubdivisionCondition = 'INVALID_CUSTOMIZATION_FOR_SUBDIVISION_CONDITION',
  /** The province format is invalid. */
  InvalidProvinceFormat = 'INVALID_PROVINCE_FORMAT',
  /**
   * Can't add selected responders to a province driven market.
   * @deprecated No longer used
   */
  InvalidResponderForProvinceDrivenMarket = 'INVALID_RESPONDER_FOR_PROVINCE_DRIVEN_MARKET',
  /** Invalid combination of status and enabled. */
  InvalidStatusAndEnabledCombination = 'INVALID_STATUS_AND_ENABLED_COMBINATION',
  /** The subdivision format is invalid. */
  InvalidSubdivisionFormat = 'INVALID_SUBDIVISION_FORMAT',
  /** Location match all is only valid with one non-match all region. */
  LocationMatchAllRequiresOneSpecificRegion = 'LOCATION_MATCH_ALL_REQUIRES_ONE_SPECIFIC_REGION',
  /** A location's country does not match the region's country. */
  LocationRegionCountryMismatch = 'LOCATION_REGION_COUNTRY_MISMATCH',
  /** The currency settings of the given market cannot be changed because the market manager has exclusive control of pricing. */
  ManagedMarket = 'MANAGED_MARKET',
  /** Catalogs created by Managed Markets cannot be added to a market. */
  ManagedMarketsCatalogNotAllowed = 'MANAGED_MARKETS_CATALOG_NOT_ALLOWED',
  /** Resources created by Managed Markets cannot be added to a market. */
  ManagedMarketsResourceNotAllowed = 'MANAGED_MARKETS_RESOURCE_NOT_ALLOWED',
  /** A Managed Market must use currencies that correspond to all of its countries. */
  ManagedMarketCurrencyMustMatchCountry = 'MANAGED_MARKET_CURRENCY_MUST_MATCH_COUNTRY',
  /** A direct connection catalog can't be attached to a market. */
  MarketCantHaveDirectConnectionCatalog = 'MARKET_CANT_HAVE_DIRECT_CONNECTION_CATALOG',
  /** Market managers and condition types are not compatible with each other. */
  MarketManagerNotCompatibleWithConditionTypes = 'MARKET_MANAGER_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /**
   * Market and condition types are not compatible with each other.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  MarketNotCompatibleWithConditionTypes = 'MARKET_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The market wasn't found. */
  MarketNotFound = 'MARKET_NOT_FOUND',
  /** Can't add another web presence to the market. */
  MarketReachedWebPresenceLimit = 'MARKET_REACHED_WEB_PRESENCE_LIMIT',
  /** Another modification to this market is in progress. */
  MarketUpdateConcurrentModification = 'MARKET_UPDATE_CONCURRENT_MODIFICATION',
  /** The country code is missing. */
  MissingCountryCode = 'MISSING_COUNTRY_CODE',
  /** The province code is missing. */
  MissingProvinceCode = 'MISSING_PROVINCE_CODE',
  /** The subdivision code is missing. */
  MissingSubdivisionCode = 'MISSING_SUBDIVISION_CODE',
  /** All retail locations in a market must be in the same country. */
  MixedCountryLocationsNotAllowed = 'MIXED_COUNTRY_LOCATIONS_NOT_ALLOWED',
  /** All regions in a market that includes a subdivision must be in the same country. */
  MixedCountrySubdivisionsNotAllowed = 'MIXED_COUNTRY_SUBDIVISIONS_NOT_ALLOWED',
  /** The shop's payment gateway does not support enabling more than one currency. */
  MultipleCurrenciesNotSupported = 'MULTIPLE_CURRENCIES_NOT_SUPPORTED',
  /** Can’t delete, disable, or change the type of the last region market. */
  MustHaveAtLeastOneActiveRegionMarket = 'MUST_HAVE_AT_LEAST_ONE_ACTIVE_REGION_MARKET',
  /** Your shop is not entitled to activate markets of this type. */
  NotEntitledToActivateMarket = 'NOT_ENTITLED_TO_ACTIVATE_MARKET',
  /** No languages selected. */
  NoLanguages = 'NO_LANGUAGES',
  /**
   * Can't enable or disable local currencies on a single country market.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  NoLocalCurrenciesOnSingleCountryMarket = 'NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET',
  /**
   * Rounding is not supported if unified markets are not enabled.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  NoRoundingOnLegacyMarket = 'NO_ROUNDING_ON_LEGACY_MARKET',
  /** POS location markets must be merchant managed. */
  PosLocationMarketMustBeMerchantManaged = 'POS_LOCATION_MARKET_MUST_BE_MERCHANT_MANAGED',
  /**
   * The primary market must use the primary domain.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  PrimaryMarketMustUsePrimaryDomain = 'PRIMARY_MARKET_MUST_USE_PRIMARY_DOMAIN',
  /** The province doesn't exist. */
  ProvinceDoesNotExist = 'PROVINCE_DOES_NOT_EXIST',
  /** The market region wasn't found. */
  RegionNotFound = 'REGION_NOT_FOUND',
  /** The selected region is not supported for the selected channel. */
  RegionNotSupportedForChannel = 'REGION_NOT_SUPPORTED_FOR_CHANNEL',
  /** Cannot add region-specific language. */
  RegionSpecificLanguage = 'REGION_SPECIFIC_LANGUAGE',
  /** One of `subfolderSuffix` or `domainId` is required. */
  RequiresDomainOrSubfolder = 'REQUIRES_DOMAIN_OR_SUBFOLDER',
  /**
   * Exactly one input option is required.
   * @deprecated No longer used
   */
  RequiresExactlyOneOption = 'REQUIRES_EXACTLY_ONE_OPTION',
  /** Retail location currency must be local. */
  RetailLocationCurrencyMustBeLocal = 'RETAIL_LOCATION_CURRENCY_MUST_BE_LOCAL',
  /** Shipping and condition types are not compatible with each other. */
  ShippingNotCompatibleWithConditionTypes = 'SHIPPING_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The shop must have a web presence that uses the primary domain. */
  ShopMustHavePrimaryDomainWebPresence = 'SHOP_MUST_HAVE_PRIMARY_DOMAIN_WEB_PRESENCE',
  /**
   * Can't have more than 50 markets.
   * @deprecated No longer used
   */
  ShopReachedMarketsLimit = 'SHOP_REACHED_MARKETS_LIMIT',
  /** Specified conditions cannot be empty. */
  SpecifiedConditionsCannotBeEmpty = 'SPECIFIED_CONDITIONS_CANNOT_BE_EMPTY',
  /** With an ID list in input, SPECIFIED is not needed. */
  SpecifiedNotValidForInput = 'SPECIFIED_NOT_VALID_FOR_INPUT',
  /** The subdivision doesn't exist. */
  SubdivisionDoesNotExist = 'SUBDIVISION_DOES_NOT_EXIST',
  /** A market that includes a subdivision requires another market that includes the whole country. If the subdivision market is active, the country market must also be active. */
  SubdivisionMarketRequiresCountryCoverage = 'SUBDIVISION_MARKET_REQUIRES_COUNTRY_COVERAGE',
  /** The selected subdivision does not belong to the selected country. */
  SubdivisionMustBelongToCountry = 'SUBDIVISION_MUST_BELONG_TO_COUNTRY',
  /** The subfolder suffix is invalid, please provide a different value. */
  SubfolderSuffixCannotBeScriptCode = 'SUBFOLDER_SUFFIX_CANNOT_BE_SCRIPT_CODE',
  /** The subfolder suffix must be at least 2 letters. */
  SubfolderSuffixMustBeAtLeast_2Letters = 'SUBFOLDER_SUFFIX_MUST_BE_AT_LEAST_2_LETTERS',
  /**
   * The subfolder suffix must contain only letters.
   * @deprecated No longer used
   */
  SubfolderSuffixMustContainOnlyLetters = 'SUBFOLDER_SUFFIX_MUST_CONTAIN_ONLY_LETTERS',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /**
   * Unified markets are not enabled.
   * @deprecated This will no longer be used after legacy markets are removed in April 2026
   */
  UnifiedMarketsNotEnabled = 'UNIFIED_MARKETS_NOT_ENABLED',
  /** Managing this catalog is not supported by your plan. */
  UnpermittedEntitlementsMarketCatalogs = 'UNPERMITTED_ENTITLEMENTS_MARKET_CATALOGS',
  /** The language isn't published to the store. */
  UnpublishedLanguage = 'UNPUBLISHED_LANGUAGE',
  /** Can't add unsupported country or region. */
  UnsupportedCountryRegion = 'UNSUPPORTED_COUNTRY_REGION',
  /** The specified currency is not supported. */
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY',
  /** The user doesn't have permission access to create or edit markets. */
  UserLacksPermission = 'USER_LACKS_PERMISSION',
  /** Web presences and condition types are not compatible with each other. */
  WebPresenceNotCompatibleWithConditionTypes = 'WEB_PRESENCE_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The market web presence wasn't found. */
  WebPresenceNotFound = 'WEB_PRESENCE_NOT_FOUND',
  /** Can't add web presence to the another market. */
  WebPresenceReachedMarketsLimit = 'WEB_PRESENCE_REACHED_MARKETS_LIMIT',
  /**
   * A web presence cannot be added to a market with type retail location.
   * @deprecated No longer used
   */
  WebPresenceRetailLocation = 'WEB_PRESENCE_RETAIL_LOCATION',
  /** Matching ALL or NONE isn't supported for this driver type. */
  WildcardNotSupported = 'WILDCARD_NOT_SUPPORTED'
}

/**
 * The market’s web presence, which defines its SEO strategy. This can be a different domain
 * (e.g. `example.ca`), subdomain (e.g. `ca.example.com`), or subfolders of the primary
 * domain (e.g. `example.com/en-ca`). Each web presence comprises one or more language
 * variants. If a market does not have its own web presence, it is accessible on the shop’s
 * primary domain via [country
 * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
 *
 * Note: while the domain/subfolders defined by a market’s web presence are not applicable to
 * custom storefronts, which must manage their own domains and routing, the languages chosen
 * here do govern [the languages available on the Storefront
 * API](https://shopify.dev/custom-storefronts/internationalization/multiple-languages) for the countries in
 * this market.
 */
export type MarketWebPresence = Node & {
  __typename?: 'MarketWebPresence';
  /**
   * The ShopLocale object for the alternate locales. When a domain is used, these locales will be
   * available as language-specific subfolders. For example, if English is an
   * alternate locale, and `example.ca` is the market’s domain, then
   * `example.ca/en` will load in English.
   */
  alternateLocales: Array<ShopLocale>;
  /**
   * The ShopLocale object for the default locale. When a domain is used, this is the locale that will
   * be used when the domain root is accessed. For example, if French is the default locale,
   * and `example.ca` is the market’s domain, then `example.ca` will load in French.
   */
  defaultLocale: ShopLocale;
  /**
   * The web presence’s domain.
   * This field will be null if `subfolderSuffix` isn't null.
   */
  domain?: Maybe<Domain>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The associated market. This can be null for a web presence that isn't associated with a market.
   * @deprecated Use `markets` instead.
   */
  market?: Maybe<Market>;
  /** The associated markets for this web presence. */
  markets?: Maybe<MarketConnection>;
  /** The list of root URLs for each of the web presence’s locales. As of version `2024-04` this value will no longer have a trailing slash. */
  rootUrls: Array<MarketWebPresenceRootUrl>;
  /** The market-specific suffix of the subfolders defined by the web presence. Example: in `/en-us` the subfolder suffix is `us`. This field will be null if `domain` isn't null. */
  subfolderSuffix?: Maybe<Scalars['String']['output']>;
};


/**
 * The market’s web presence, which defines its SEO strategy. This can be a different domain
 * (e.g. `example.ca`), subdomain (e.g. `ca.example.com`), or subfolders of the primary
 * domain (e.g. `example.com/en-ca`). Each web presence comprises one or more language
 * variants. If a market does not have its own web presence, it is accessible on the shop’s
 * primary domain via [country
 * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
 *
 * Note: while the domain/subfolders defined by a market’s web presence are not applicable to
 * custom storefronts, which must manage their own domains and routing, the languages chosen
 * here do govern [the languages available on the Storefront
 * API](https://shopify.dev/custom-storefronts/internationalization/multiple-languages) for the countries in
 * this market.
 */
export type MarketWebPresenceMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple MarketWebPresences. */
export type MarketWebPresenceConnection = {
  __typename?: 'MarketWebPresenceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketWebPresenceEdge>;
  /** A list of nodes that are contained in MarketWebPresenceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketWebPresence>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields used to create a web presence for a market. */
export type MarketWebPresenceCreateInput = {
  /** The alternate locales for the market’s web presence. */
  alternateLocales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default locale for the market’s web presence. */
  defaultLocale: Scalars['String']['input'];
  /** The web presence's domain ID. This field must be `null` if the `subfolderSuffix` isn't `null`. */
  domainId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * For example: in `/en-us`, the subfolder suffix is `us`.
   * Only ASCII characters are allowed. This field must be `null` if the `domainId` isn't `null`.
   */
  subfolderSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `marketWebPresenceCreate` mutation. */
export type MarketWebPresenceCreatePayload = {
  __typename?: 'MarketWebPresenceCreatePayload';
  /** The market object. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** Return type for `marketWebPresenceDelete` mutation. */
export type MarketWebPresenceDeletePayload = {
  __typename?: 'MarketWebPresenceDeletePayload';
  /** The ID of the deleted web presence. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The market for which the web presence was deleted. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** An auto-generated type which holds one MarketWebPresence and a cursor during pagination. */
export type MarketWebPresenceEdge = {
  __typename?: 'MarketWebPresenceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketWebPresenceEdge. */
  node: MarketWebPresence;
};

/**
 * The URL for the homepage of the online store in the context of a particular market and a
 * particular locale.
 */
export type MarketWebPresenceRootUrl = {
  __typename?: 'MarketWebPresenceRootUrl';
  /** The locale that the storefront loads in. */
  locale: Scalars['String']['output'];
  /** The URL. */
  url: Scalars['URL']['output'];
};

/** The input fields used to update a web presence for a market. */
export type MarketWebPresenceUpdateInput = {
  /** The alternate locales for the market’s web presence. */
  alternateLocales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default locale for the market’s web presence. */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  /** The web presence's domain ID. This field must be null if `subfolderSuffix` is not null. */
  domainId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * Example: in `/en-us` the subfolder suffix is `us`.
   * Only ASCII characters are allowed. This field must be null if `domainId` is not null.
   */
  subfolderSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `marketWebPresenceUpdate` mutation. */
export type MarketWebPresenceUpdatePayload = {
  __typename?: 'MarketWebPresenceUpdatePayload';
  /** The market object. */
  market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** Return type for `marketingActivitiesDeleteAllExternal` mutation. */
export type MarketingActivitiesDeleteAllExternalPayload = {
  __typename?: 'MarketingActivitiesDeleteAllExternalPayload';
  /** The asynchronous job that performs the deletion. The status of the job may be used to determine when it's safe again to create new activities. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/**
 * The marketing activity resource represents marketing that a
 *         merchant created through an app.
 */
export type MarketingActivity = Node & {
  __typename?: 'MarketingActivity';
  /** The URL of the marketing activity listing page in the marketing section. */
  activityListUrl?: Maybe<Scalars['URL']['output']>;
  /** The amount spent on the marketing activity. */
  adSpend?: Maybe<MoneyV2>;
  /** The app which created this marketing activity. */
  app: App;
  /** The errors generated when an app publishes the marketing activity. */
  appErrors?: Maybe<MarketingActivityExtensionAppErrors>;
  /** The allocated budget for the marketing activity. */
  budget?: Maybe<MarketingBudget>;
  /** The date and time when the marketing activity was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The completed content in the marketing activity creation form. */
  formData?: Maybe<Scalars['String']['output']>;
  /** The hierarchy level of the marketing activity. */
  hierarchyLevel?: Maybe<MarketingActivityHierarchyLevel>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the marketing activity is in the main workflow version of the marketing automation. */
  inMainWorkflowVersion: Scalars['Boolean']['output'];
  /** The marketing activity represents an external marketing activity. */
  isExternal: Scalars['Boolean']['output'];
  /**
   * The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation.
   * @deprecated Use `marketingChannelType` instead.
   */
  marketingChannel: MarketingChannel;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  marketingChannelType: MarketingChannel;
  /** Associated marketing event of this marketing activity. */
  marketingEvent?: Maybe<MarketingEvent>;
  /** ID of the parent activity of this marketing activity. */
  parentActivityId?: Maybe<Scalars['ID']['output']>;
  /** ID of the parent activity of this marketing activity. */
  parentRemoteId?: Maybe<Scalars['String']['output']>;
  /** A contextual description of the marketing activity based on the platform and tactic used. */
  sourceAndMedium: Scalars['String']['output'];
  /** The current state of the marketing activity. */
  status: MarketingActivityStatus;
  /**
   * The severity of the marketing activity's status.
   * @deprecated Use `statusBadgeTypeV2` instead.
   */
  statusBadgeType?: Maybe<MarketingActivityStatusBadgeType>;
  /** The severity of the marketing activity's status. */
  statusBadgeTypeV2?: Maybe<BadgeType>;
  /** The rendered status of the marketing activity. */
  statusLabel: Scalars['String']['output'];
  /**
   * The [date and time](
   *           https://help.shopify.com/https://en.wikipedia.org/wiki/ISO_8601
   *           ) when the activity's status last changed.
   */
  statusTransitionedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The method of marketing used for this marketing activity. */
  tactic: MarketingTactic;
  /** The status to which the marketing activity is currently transitioning. */
  targetStatus?: Maybe<MarketingActivityStatus>;
  /** The marketing activity's title, which is rendered on the marketing listing page. */
  title: Scalars['String']['output'];
  /** The date and time when the marketing activity was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The value portion of the URL query parameter used in attributing sessions to this activity. */
  urlParameterValue?: Maybe<Scalars['String']['output']>;
  /**
   * The set of [Urchin Tracking Module](
   *           https://help.shopify.com/https://en.wikipedia.org/wiki/UTM_parameters
   *           ) used in the URL for tracking this marketing activity.
   */
  utmParameters?: Maybe<UtmParameters>;
};

/** The input fields combining budget amount and its marketing budget type. */
export type MarketingActivityBudgetInput = {
  /** Budget type for marketing activity. */
  budgetType?: InputMaybe<MarketingBudgetBudgetType>;
  /** Amount of budget for the marketing activity. */
  total?: InputMaybe<MoneyInput>;
};

/** An auto-generated type for paginating through multiple MarketingActivities. */
export type MarketingActivityConnection = {
  __typename?: 'MarketingActivityConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketingActivityEdge>;
  /** A list of nodes that are contained in MarketingActivityEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketingActivity>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating an externally-managed marketing activity. */
export type MarketingActivityCreateExternalInput = {
  /** The amount spent on the marketing activity. */
  adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  channelHandle?: InputMaybe<Scalars['String']['input']>;
  /** The date and time at which the activity ended. If omitted or set to `null`, the current time will be used if the status is set to `INACTIVE` or `DELETED_EXTERNALLY`. */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** The hierarchy level of the activity within a campaign. The hierarchy level can't be updated. */
  hierarchyLevel?: InputMaybe<MarketingActivityHierarchyLevel>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  marketingChannelType: MarketingChannel;
  /** The ID for the parent marketing activity, if creating hierarchical activities. */
  parentActivityId?: InputMaybe<Scalars['ID']['input']>;
  /** The remote ID for the parent marketing activity, if creating hierarchical activities. */
  parentRemoteId?: InputMaybe<Scalars['String']['input']>;
  /** The domain from which ad clicks are forwarded to the shop. */
  referringDomain?: InputMaybe<Scalars['String']['input']>;
  /** A custom unique identifier for the marketing activity, which can be used to manage the activity and send engagement metrics without having to store our marketing activity ID in your systems. */
  remoteId?: InputMaybe<Scalars['String']['input']>;
  /** The URL for a preview image that's used for the marketing activity. */
  remotePreviewImageUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  remoteUrl: Scalars['URL']['input'];
  /** The date and time at which the activity is scheduled to end. */
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity is scheduled to start. */
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity started. If omitted or set to `null`, the current time will be used. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** The status of the marketing activity. If status isn't set it will default to UNDEFINED. */
  status?: InputMaybe<MarketingActivityExternalStatus>;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  tactic: MarketingTactic;
  /** The title of the marketing activity. */
  title: Scalars['String']['input'];
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  urlParameterValue?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters) that are associated with a related marketing campaign. Either the URL parameter value or UTM can be set, but not both. */
  utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityCreateExternal` mutation. */
export type MarketingActivityCreateExternalPayload = {
  __typename?: 'MarketingActivityCreateExternalPayload';
  /** The external marketing activity that was created. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** The input fields required to create a marketing activity. Marketing activity app extensions are deprecated and will be removed in the near future. */
export type MarketingActivityCreateInput = {
  /** The ID of the marketing activity extension. */
  marketingActivityExtensionId: Scalars['ID']['input'];
  /** The current state of the marketing activity. */
  status: MarketingActivityStatus;
};

/** Return type for `marketingActivityCreate` mutation. */
export type MarketingActivityCreatePayload = {
  __typename?: 'MarketingActivityCreatePayload';
  /**
   * The created marketing activity.
   * @deprecated Marketing activity app extensions are deprecated and will be removed in the near future.
   */
  marketingActivity?: Maybe<MarketingActivity>;
  /**
   * The path to return back to shopify admin from embedded editor.
   * @deprecated Marketing activity app extensions are deprecated and will be removed in the near future.
   */
  redirectPath?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `marketingActivityDeleteExternal` mutation. */
export type MarketingActivityDeleteExternalPayload = {
  __typename?: 'MarketingActivityDeleteExternalPayload';
  /** The ID of the marketing activity that was deleted, if one was deleted. */
  deletedMarketingActivityId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** An auto-generated type which holds one MarketingActivity and a cursor during pagination. */
export type MarketingActivityEdge = {
  __typename?: 'MarketingActivityEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketingActivityEdge. */
  node: MarketingActivity;
};

/** The error code resulted from the marketing activity extension integration. */
export enum MarketingActivityExtensionAppErrorCode {
  /** The app is either not responding or returning unexpected data. */
  ApiError = 'API_ERROR',
  /** The app needs to be installed. */
  InstallRequiredError = 'INSTALL_REQUIRED_ERROR',
  /** The shop/user must be onboarded to use the app. */
  NotOnboardedError = 'NOT_ONBOARDED_ERROR',
  /** The app has returned an error when invoking the platform. */
  PlatformError = 'PLATFORM_ERROR',
  /** The app has returned validation errors. */
  ValidationError = 'VALIDATION_ERROR'
}

/** Represents errors returned from apps when using the marketing activity extension. */
export type MarketingActivityExtensionAppErrors = {
  __typename?: 'MarketingActivityExtensionAppErrors';
  /** The app error type. */
  code: MarketingActivityExtensionAppErrorCode;
  /** The list of errors returned by the app. */
  userErrors: Array<UserError>;
};

/** Set of possible statuses for an external marketing activity. */
export enum MarketingActivityExternalStatus {
  /** This marketing activity is currently running. */
  Active = 'ACTIVE',
  /** This marketing activity was deleted and it was triggered from outside of Shopify. */
  DeletedExternally = 'DELETED_EXTERNALLY',
  /** This marketing activity has completed running. */
  Inactive = 'INACTIVE',
  /** This marketing activity is currently not running. */
  Paused = 'PAUSED',
  /** This marketing activity is scheduled to run. */
  Scheduled = 'SCHEDULED',
  /** The marketing activity's status is unknown. */
  Undefined = 'UNDEFINED'
}

/** Hierarchy levels for external marketing activities. */
export enum MarketingActivityHierarchyLevel {
  /** An advertisement activity. Must be parented by an ad group or a campaign activity, and must be assigned tracking parameters (URL or UTM). */
  Ad = 'AD',
  /** A group of advertisement activities. Must be parented by a campaign activity. */
  AdGroup = 'AD_GROUP',
  /** A campaign activity. May contain either ad groups or ads as child activities. If childless, then the campaign activity should have tracking parameters assigned (URL or UTM) otherwise it won't appear in marketing reports. */
  Campaign = 'CAMPAIGN'
}

/** The set of valid sort keys for the MarketingActivity query. */
export enum MarketingActivitySortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** Status helps to identify if this marketing activity has been completed, queued, failed etc. */
export enum MarketingActivityStatus {
  /** This marketing activity is currently running. */
  Active = 'ACTIVE',
  /** This marketing activity is permanently unavailable. */
  Deleted = 'DELETED',
  /** This marketing activity was deleted and it was triggered from outside of Shopify. */
  DeletedExternally = 'DELETED_EXTERNALLY',
  /** This marketing activity is disconnected and no longer editable. */
  Disconnected = 'DISCONNECTED',
  /** This marketing activity has been edited, but it is not yet created. */
  Draft = 'DRAFT',
  /** This marketing activity is unable to run. */
  Failed = 'FAILED',
  /** This marketing activity has completed running. */
  Inactive = 'INACTIVE',
  /** This marketing activity is currently not running. */
  Paused = 'PAUSED',
  /** This marketing activity is pending creation on the app's marketing platform. */
  Pending = 'PENDING',
  /** This marketing activity is scheduled to run. */
  Scheduled = 'SCHEDULED',
  /** The marketing activity's status is unknown. */
  Undefined = 'UNDEFINED'
}

/** StatusBadgeType helps to identify the color of the status badge. */
export enum MarketingActivityStatusBadgeType {
  /** This status badge has type attention. */
  Attention = 'ATTENTION',
  /** This status badge has type critical. */
  Critical = 'CRITICAL',
  /** This status badge has type default. */
  Default = 'DEFAULT',
  /** This status badge has type info. */
  Info = 'INFO',
  /** This status badge has type success. */
  Success = 'SUCCESS',
  /** This status badge has type warning. */
  Warning = 'WARNING'
}

/** The input fields required to update an externally managed marketing activity. */
export type MarketingActivityUpdateExternalInput = {
  /** The amount spent on the marketing activity. */
  adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The date and time at which the activity ended. */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  marketingChannelType?: InputMaybe<MarketingChannel>;
  /** The domain from which ad clicks are forwarded to the shop. */
  referringDomain?: InputMaybe<Scalars['String']['input']>;
  /** The URL for a preview image that's used for the marketing activity. */
  remotePreviewImageUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  remoteUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The date and time at which the activity is scheduled to end. */
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity is scheduled to start. */
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity started. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** The status of the marketing activity. */
  status?: InputMaybe<MarketingActivityExternalStatus>;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  tactic?: InputMaybe<MarketingTactic>;
  /** The title of the marketing activity. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `marketingActivityUpdateExternal` mutation. */
export type MarketingActivityUpdateExternalPayload = {
  __typename?: 'MarketingActivityUpdateExternalPayload';
  /** The updated marketing activity. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** The input fields required to update a marketing activity. Marketing activity app extensions are deprecated and will be removed in the near future. */
export type MarketingActivityUpdateInput = {
  /** The ID of the marketing activity. */
  id: Scalars['ID']['input'];
};

/** Return type for `marketingActivityUpdate` mutation. */
export type MarketingActivityUpdatePayload = {
  __typename?: 'MarketingActivityUpdatePayload';
  /** The updated marketing activity. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** The redirect path from the embedded editor to the Shopify admin. */
  redirectPath?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for creating or updating an externally-managed marketing activity. */
export type MarketingActivityUpsertExternalInput = {
  /** The amount spent on the marketing activity. */
  adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  channelHandle?: InputMaybe<Scalars['String']['input']>;
  /** The date and time at which the activity started. On creation, if this field is omitted or set to `null`, the current time will be used if the status is set to `INACTIVE` or `DELETED_EXTERNALLY` . */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** The hierarchy level of the activity within a campaign. The hierarchy level can't be updated. */
  hierarchyLevel?: InputMaybe<MarketingActivityHierarchyLevel>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  marketingChannelType: MarketingChannel;
  /** The remote ID for the parent marketing activity, if creating hierarchical activities. */
  parentRemoteId?: InputMaybe<Scalars['String']['input']>;
  /** The domain from which ad clicks are forwarded to the shop. */
  referringDomain?: InputMaybe<Scalars['String']['input']>;
  /** A custom unique identifier for the marketing activity, which can be used to manage the activity and send engagement metrics without having to store our marketing activity ID in your systems. */
  remoteId: Scalars['String']['input'];
  /** The URL for a preview image that's used for the marketing activity. */
  remotePreviewImageUrl?: InputMaybe<Scalars['URL']['input']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  remoteUrl: Scalars['URL']['input'];
  /** The date and time at which the activity is scheduled to end. */
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity is scheduled to start. */
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date and time at which the activity started. On creation, if this field is omitted or set to `null`, the current time will be used. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** The status of the marketing activity. */
  status: MarketingActivityExternalStatus;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  tactic: MarketingTactic;
  /** The title of the marketing activity. */
  title: Scalars['String']['input'];
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  urlParameterValue?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters) that are associated with a related marketing campaign. Either the URL parameter value or UTM can be set, but not both. */
  utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityUpsertExternal` mutation. */
export type MarketingActivityUpsertExternalPayload = {
  __typename?: 'MarketingActivityUpsertExternalPayload';
  /** The external marketing activity that was created or updated. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** An error that occurs during the execution of marketing activity and engagement mutations. */
export type MarketingActivityUserError = DisplayableError & {
  __typename?: 'MarketingActivityUserError';
  /** The error code. */
  code?: Maybe<MarketingActivityUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MarketingActivityUserError`. */
export enum MarketingActivityUserErrorCode {
  /** The marketing activity must be an external activity. */
  ActivityNotExternal = 'ACTIVITY_NOT_EXTERNAL',
  /** This activity has child activities and thus cannot be deleted. Child activities must be deleted before a parent activity. */
  CannotDeleteActivityWithChildEvents = 'CANNOT_DELETE_ACTIVITY_WITH_CHILD_EVENTS',
  /** The activity's tactic can not be updated from STOREFRONT_APP. */
  CannotUpdateTacticIfOriginallyStorefrontApp = 'CANNOT_UPDATE_TACTIC_IF_ORIGINALLY_STOREFRONT_APP',
  /** The activity's tactic can not be updated to STOREFRONT_APP. This type of tactic can only be specified when creating a new activity. */
  CannotUpdateTacticToStorefrontApp = 'CANNOT_UPDATE_TACTIC_TO_STOREFRONT_APP',
  /** All currency codes provided in the input need to match. */
  CurrencyCodeMismatchInput = 'CURRENCY_CODE_MISMATCH_INPUT',
  /** A mutation can not be ran because a job to delete all external activities has been enqueued, which happens either from calling the marketingActivitiesDeleteAllExternal mutation or as a result of an app uninstall. */
  DeleteJobEnqueued = 'DELETE_JOB_ENQUEUED',
  /** The job to delete all external activities failed to enqueue. */
  DeleteJobFailedToEnqueue = 'DELETE_JOB_FAILED_TO_ENQUEUE',
  /** The channel handle value cannot be modified. */
  ImmutableChannelHandle = 'IMMUTABLE_CHANNEL_HANDLE',
  /** The hierarchy level cannot be modified. */
  ImmutableHierarchyLevel = 'IMMUTABLE_HIERARCHY_LEVEL',
  /** The parent activity cannot be modified. */
  ImmutableParentId = 'IMMUTABLE_PARENT_ID',
  /** The URL parameter value cannot be modified. */
  ImmutableUrlParameter = 'IMMUTABLE_URL_PARAMETER',
  /** The UTM parameters cannot be modified. */
  ImmutableUtmParameters = 'IMMUTABLE_UTM_PARAMETERS',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The channel handle is not recognized. */
  InvalidChannelHandle = 'INVALID_CHANNEL_HANDLE',
  /** Either the marketing activity ID or remote ID must be provided for the activity to be deleted. */
  InvalidDeleteActivityExternalArguments = 'INVALID_DELETE_ACTIVITY_EXTERNAL_ARGUMENTS',
  /** Either the channel_handle or delete_engagements_for_all_channels must be provided when deleting a marketing engagement. */
  InvalidDeleteEngagementsArguments = 'INVALID_DELETE_ENGAGEMENTS_ARGUMENTS',
  /** Either the marketing activity ID, remote ID, or UTM must be provided. */
  InvalidMarketingActivityExternalArguments = 'INVALID_MARKETING_ACTIVITY_EXTERNAL_ARGUMENTS',
  /** For activity level engagement, either the marketing activity ID or remote ID must be provided. For channel level engagement, the channel handle must be provided. */
  InvalidMarketingEngagementArguments = 'INVALID_MARKETING_ENGAGEMENT_ARGUMENTS',
  /** No identifier found. For activity level engagement, either the marketing activity ID or remote ID must be provided. For channel level engagement, the channel handle must be provided. */
  InvalidMarketingEngagementArgumentMissing = 'INVALID_MARKETING_ENGAGEMENT_ARGUMENT_MISSING',
  /** The remote ID does not correspond to an existing activity. */
  InvalidRemoteId = 'INVALID_REMOTE_ID',
  /** The currency codes provided need to match the referenced marketing activity's currency code. */
  MarketingActivityCurrencyCodeMismatch = 'MARKETING_ACTIVITY_CURRENCY_CODE_MISMATCH',
  /** Marketing activity does not exist. */
  MarketingActivityDoesNotExist = 'MARKETING_ACTIVITY_DOES_NOT_EXIST',
  /** A marketing activity with the same remote ID already exists. */
  MarketingActivityWithRemoteIdAlreadyExists = 'MARKETING_ACTIVITY_WITH_REMOTE_ID_ALREADY_EXISTS',
  /** A marketing activity with the same URL parameter value already exists. */
  MarketingActivityWithUrlParameterValueAlreadyExists = 'MARKETING_ACTIVITY_WITH_URL_PARAMETER_VALUE_ALREADY_EXISTS',
  /** A marketing activity with the same UTM campaign, medium, and source already exists. */
  MarketingActivityWithUtmCampaignAlreadyExists = 'MARKETING_ACTIVITY_WITH_UTM_CAMPAIGN_ALREADY_EXISTS',
  /** Marketing activity is not valid, the associated marketing event does not exist. */
  MarketingEventDoesNotExist = 'MARKETING_EVENT_DOES_NOT_EXIST',
  /** Non-hierarchical marketing activities must have UTM parameters or a URL parameter value. */
  NonHierarchialRequiresUtmUrlParameter = 'NON_HIERARCHIAL_REQUIRES_UTM_URL_PARAMETER',
  /** The input value is already taken. */
  Taken = 'TAKEN'
}

/** This type combines budget amount and its marketing budget type. */
export type MarketingBudget = {
  __typename?: 'MarketingBudget';
  /** The budget type for a marketing activity. */
  budgetType: MarketingBudgetBudgetType;
  /** The amount of budget for marketing activity. */
  total: MoneyV2;
};

/** The budget type for a marketing activity. */
export enum MarketingBudgetBudgetType {
  /** A daily budget. */
  Daily = 'DAILY',
  /** A budget for the lifetime of a marketing activity. */
  Lifetime = 'LIFETIME'
}

/** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
export enum MarketingChannel {
  /** Displayed ads. */
  Display = 'DISPLAY',
  /** Email. */
  Email = 'EMAIL',
  /** Referral links. */
  Referral = 'REFERRAL',
  /** Paid search. */
  Search = 'SEARCH',
  /** Social media. */
  Social = 'SOCIAL'
}

/** Marketing engagement represents customer activity taken on a marketing activity. */
export type MarketingEngagement = {
  __typename?: 'MarketingEngagement';
  /** The total ad spend for the marketing content. Recurring weekly, monthly, or yearly spend needs to be divided into daily amounts. */
  adSpend?: Maybe<MoneyV2>;
  /** The number of all conversions from the marketing content. This field supports ad platforms that track conversions beyond traditional sales metrics. All conversions include both primary and secondary conversion goals as defined by the ad platform, such as purchases, add-to-carts, page views, and sign-ups. */
  allConversions?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The unique string identifier of the channel to which the engagement metrics are being provided.
   * @deprecated Channel-level engagements are deprecated. Provide engagement metrics on a marketing activity using `marketingActivityId` or `remoteId` instead.
   */
  channelHandle?: Maybe<Scalars['String']['output']>;
  /** The total number of interactions, such as a button press or a screen touch, that occurred on the marketing content. */
  clicksCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of comments on the marketing content. */
  commentsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of complaints on the marketing content. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were marked as spam. For social media platforms, this represents the number of dislikes or the number of times marketing content was reported. */
  complaintsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of fails for the marketing content. For message-based platforms such as email or SMS, this represents the number of bounced marketing emails or messages. */
  failsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of favorites, likes, saves, or bookmarks on the marketing content. */
  favoritesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of customers that have placed their first order. Doesn't include adjustments such as edits, exchanges, or returns. */
  firstTimeCustomers?: Maybe<Scalars['Decimal']['output']>;
  /** The total number of times marketing content was displayed to users, whether or not an interaction occurred. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were delivered. */
  impressionsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Specifies how the provided metrics have been aggregated. Cumulative metrics are aggregated from the first day of reporting up to and including `occuredOn`. Non-cumulative metrics are aggregated over the single day indicated in `occuredOn`. Cumulative metrics will monotonically increase in time as each record includes the previous day's values, and so on. Non-cumulative metrics are required going forward; cumulative metrics are deprecated.
   * @deprecated Cumulative metrics are being phased out. Send non-cumulative engagement metrics instead (values aggregated over the single day indicated in `occurredOn`, with `isCumulative: false`). Existing activities that have been sending cumulative metrics can migrate to non-cumulative at any time.
   */
  isCumulative: Scalars['Boolean']['output'];
  /** The marketing activity object related to this engagement. This corresponds to the marketingActivityId passed in on creation of the engagement. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** The calendar date (in the time zone offset specified by the utcOffset field) for which the metrics are being reported. For example, a shop in UTC-5 would set utcOffset="-05:00" and aggregate all engagements from 05:00:00Z up to 29:00:00Z (5am UTC next day) for each call. */
  occurredOn: Scalars['Date']['output'];
  /** The number of orders generated from the marketing content. */
  orders?: Maybe<Scalars['Decimal']['output']>;
  /** The number of primary conversions from the marketing content. This field supports ad platforms that track conversions beyond traditional sales metrics. Primary conversions represent the main conversion goal defined by the ad platform, such as purchases, sign-ups, or add-to-carts. */
  primaryConversions?: Maybe<Scalars['Decimal']['output']>;
  /** The number of returning customers that have placed an order. Doesn't include adjustments such as edits, exchanges, or returns. */
  returningCustomers?: Maybe<Scalars['Decimal']['output']>;
  /** The amount of sales generated from the marketing content. */
  sales?: Maybe<MoneyV2>;
  /** The total number of marketing emails or messages that were sent. */
  sendsCount?: Maybe<Scalars['Int']['output']>;
  /** The number of online store sessions generated from the marketing content. */
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of times marketing content was distributed or reposted to either one's own network of followers through a social media platform or other digital channels. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were forwarded. */
  sharesCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of unique clicks on the marketing content. */
  uniqueClicksCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of all users who saw marketing content since it was published. For  message-based platforms such as email or SMS, this represents the number of unique users that opened a  marketing email or message. For video-based content, this represents the number of unique users that  played video content. */
  uniqueViewsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of unsubscribes on the marketing content. For social media platforms, this represents the number of unfollows. */
  unsubscribesCount?: Maybe<Scalars['Int']['output']>;
  /** The UTC offset for the time zone in which the metrics are being reported, in the format `"+HH:MM"` or `"-HH:MM"`. Used in combination with occurredOn when aggregating daily metrics. Must match the account settings for the shop to minimize eventual discrepancies in reporting. */
  utcOffset: Scalars['UtcOffset']['output'];
  /** The total number of views on the marketing content. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were opened. For video-based content, this represents the number of times videos were played. */
  viewsCount?: Maybe<Scalars['Int']['output']>;
};

/** Return type for `marketingEngagementCreate` mutation. */
export type MarketingEngagementCreatePayload = {
  __typename?: 'MarketingEngagementCreatePayload';
  /** The marketing engagement that was created. This represents customer activity taken on a marketing activity. */
  marketingEngagement?: Maybe<MarketingEngagement>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** The input fields for a marketing engagement. */
export type MarketingEngagementInput = {
  /** The total ad spend for the marketing content. Recurring weekly, monthly, or yearly spend needs to be divided into daily amounts. */
  adSpend?: InputMaybe<MoneyInput>;
  /** The number of all conversions from the marketing content. This field supports ad platforms that track conversions beyond traditional sales metrics. All conversions include both primary and secondary conversion goals as defined by the ad platform, such as purchases, add-to-carts, page views, and sign-ups. */
  allConversions?: InputMaybe<Scalars['Decimal']['input']>;
  /** The total number of interactions, such as a button press or a screen touch, that occurred on the marketing content. */
  clicksCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of comments on the marketing content. */
  commentsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of complaints on the marketing content. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were marked as spam. For social media platforms, this represents the number of dislikes or the number of times marketing content was reported. */
  complaintsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of fails for the marketing content. For message-based platforms such as email or SMS, this represents the number of bounced marketing emails or messages. */
  failsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of favorites, likes, saves, or bookmarks on the marketing content. */
  favoritesCount?: InputMaybe<Scalars['Int']['input']>;
  /** The number of customers that have placed their first order. Doesn't include adjustments such as edits, exchanges, or returns. */
  firstTimeCustomers?: InputMaybe<Scalars['Decimal']['input']>;
  /** The total number of times marketing content was displayed to users, whether or not an interaction occurred. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were delivered. */
  impressionsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The calendar date (in the time zone offset specified by the utcOffset field) for which the metrics are being reported. For example, a shop in UTC-5 would set utcOffset="-05:00" and aggregate all engagements from 05:00:00Z up to 29:00:00Z (5am UTC next day) for each call. */
  occurredOn: Scalars['Date']['input'];
  /** The number of orders generated from the marketing content. */
  orders?: InputMaybe<Scalars['Decimal']['input']>;
  /** The number of primary conversions from the marketing content. This field supports ad platforms that track conversions beyond traditional sales metrics. Primary conversions represent the main conversion goal defined by the ad platform, such as purchases, sign-ups, or add-to-carts. */
  primaryConversions?: InputMaybe<Scalars['Decimal']['input']>;
  /** The number of returning customers that have placed an order. Doesn't include adjustments such as edits, exchanges, or returns. */
  returningCustomers?: InputMaybe<Scalars['Decimal']['input']>;
  /** The amount of sales generated from the marketing content. */
  sales?: InputMaybe<MoneyInput>;
  /** The total number of marketing emails or messages that were sent. */
  sendsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The number of online store sessions generated from the marketing content. */
  sessionsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of times marketing content was distributed or reposted to either one's own network of followers through a social media platform or other digital channels. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were forwarded. */
  sharesCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of unique clicks on the marketing content. */
  uniqueClicksCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of all users who saw marketing content since it was published. For  message-based platforms such as email or SMS, this represents the number of unique users that opened a  marketing email or message. For video-based content, this represents the number of unique users that  played video content. */
  uniqueViewsCount?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of unsubscribes on the marketing content. For social media platforms, this represents the number of unfollows. */
  unsubscribesCount?: InputMaybe<Scalars['Int']['input']>;
  /** The UTC offset for the time zone in which the metrics are being reported, in the format `"+HH:MM"` or `"-HH:MM"`. Used in combination with occurredOn when aggregating daily metrics. Must match the account settings for the shop to minimize eventual discrepancies in reporting. */
  utcOffset: Scalars['UtcOffset']['input'];
  /** The total number of views on the marketing content. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were opened. For video-based content, this represents the number of times videos were played. */
  viewsCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `marketingEngagementsDelete` mutation. */
export type MarketingEngagementsDeletePayload = {
  __typename?: 'MarketingEngagementsDeletePayload';
  /** Informational message about the engagement data that has been marked for deletion. */
  result?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketingActivityUserError>;
};

/** Represents actions that market a merchant's store or products. */
export type MarketingEvent = LegacyInteroperability & Node & {
  __typename?: 'MarketingEvent';
  /** The app that the marketing event is attributed to. */
  app: App;
  /**
   * The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation.
   * @deprecated Use `marketingChannelType` instead.
   */
  channel?: Maybe<MarketingChannel>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  channelHandle?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the marketing event. */
  description?: Maybe<Scalars['String']['output']>;
  /** The date and time when the marketing event ended. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The URL where the marketing event can be managed. */
  manageUrl?: Maybe<Scalars['URL']['output']>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  marketingChannelType?: Maybe<MarketingChannel>;
  /** The URL where the marketing event can be previewed. */
  previewUrl?: Maybe<Scalars['URL']['output']>;
  /** An optional ID that helps Shopify validate engagement data. */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** The date and time when the marketing event is scheduled to end. */
  scheduledToEndAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Where the `MarketingEvent` occurred and what kind of content was used.
   * Because `utmSource` and `utmMedium` are often used interchangeably, this is
   * based on a combination of `marketingChannel`, `referringDomain`, and `type` to
   * provide a consistent representation for any given piece of marketing
   * regardless of the app that created it.
   */
  sourceAndMedium: Scalars['String']['output'];
  /** The date and time when the marketing event started. */
  startedAt: Scalars['DateTime']['output'];
  /**
   * The display text for the marketing event type.
   * @deprecated Use `sourceAndMedium` instead.
   */
  targetTypeDisplayText: Scalars['String']['output'];
  /** The marketing event type. */
  type: MarketingTactic;
  /** The name of the marketing campaign. */
  utmCampaign?: Maybe<Scalars['String']['output']>;
  /** The medium that the marketing campaign is using. Example values: `cpc`, `banner`. */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** The referrer of the marketing event. Example values: `google`, `newsletter`. */
  utmSource?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple MarketingEvents. */
export type MarketingEventConnection = {
  __typename?: 'MarketingEventConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MarketingEventEdge>;
  /** A list of nodes that are contained in MarketingEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MarketingEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketingEvent and a cursor during pagination. */
export type MarketingEventEdge = {
  __typename?: 'MarketingEventEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MarketingEventEdge. */
  node: MarketingEvent;
};

/** The set of valid sort keys for the MarketingEvent query. */
export enum MarketingEventSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `started_at` value. */
  StartedAt = 'STARTED_AT'
}

/** The available types of tactics for a marketing activity. */
export enum MarketingTactic {
  /** An abandoned cart recovery email. */
  AbandonedCart = 'ABANDONED_CART',
  /** An ad, such as a Facebook ad. */
  Ad = 'AD',
  /** An affiliate link. */
  Affiliate = 'AFFILIATE',
  /** A link. */
  Link = 'LINK',
  /** A loyalty program. */
  Loyalty = 'LOYALTY',
  /** A messaging app, such as Facebook Messenger. */
  Message = 'MESSAGE',
  /** A newsletter. */
  Newsletter = 'NEWSLETTER',
  /** A notification in the Shopify admin. */
  Notification = 'NOTIFICATION',
  /** A blog post. */
  Post = 'POST',
  /** A retargeting ad. */
  Retargeting = 'RETARGETING',
  /** Search engine optimization. */
  Seo = 'SEO',
  /** A popup on the online store. */
  StorefrontApp = 'STOREFRONT_APP',
  /** A transactional email. */
  Transactional = 'TRANSACTIONAL'
}

/** The entitlements for B2B markets. */
export type MarketsB2BEntitlement = {
  __typename?: 'MarketsB2BEntitlement';
  /** The entitlements for B2B market catalogs. */
  catalogs: MarketsCatalogsEntitlement;
  /** Whether B2B markets are enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The entitlements for catalogs. */
export type MarketsCatalogsEntitlement = {
  __typename?: 'MarketsCatalogsEntitlement';
  /** Whether catalogs are enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The maximum number of catalogs allowed. */
  limit: Scalars['Int']['output'];
};

/** The entitlements for region markets. */
export type MarketsRegionsEntitlement = {
  __typename?: 'MarketsRegionsEntitlement';
  /** The entitlements for region market catalogs. */
  catalogs: MarketsCatalogsEntitlement;
  /** Whether region markets are enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The resolved values based on the markets configuration for a buyer signal. Resolved values include the resolved catalogs, web presences, currency, and price inclusivity. */
export type MarketsResolvedValues = {
  __typename?: 'MarketsResolvedValues';
  /** The resolved catalogs. */
  catalogs: MarketCatalogConnection;
  /** The resolved currency code. */
  currencyCode: CurrencyCode;
  /** The resolved price inclusivity attributes. */
  priceInclusivity: ResolvedPriceInclusivity;
  /** The resolved web presences ordered by priority. */
  webPresences: MarketWebPresenceConnection;
};


/** The resolved values based on the markets configuration for a buyer signal. Resolved values include the resolved catalogs, web presences, currency, and price inclusivity. */
export type MarketsResolvedValuesCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The resolved values based on the markets configuration for a buyer signal. Resolved values include the resolved catalogs, web presences, currency, and price inclusivity. */
export type MarketsResolvedValuesWebPresencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The entitlements for retail markets. */
export type MarketsRetailEntitlement = {
  __typename?: 'MarketsRetailEntitlement';
  /** The entitlements for retail market catalogs. */
  catalogs: MarketsCatalogsEntitlement;
  /** Whether retail markets are enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The set of valid sort keys for the Markets query. */
export enum MarketsSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `market_condition_types` value. */
  MarketConditionTypes = 'MARKET_CONDITION_TYPES',
  /** Sort by the `market_type` value. */
  MarketType = 'MARKET_TYPE',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `status` value. */
  Status = 'STATUS',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The entitlements for themes. */
export type MarketsThemesEntitlement = {
  __typename?: 'MarketsThemesEntitlement';
  /** Whether themes are enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** Markets entitlement information. */
export type MarketsType = {
  __typename?: 'MarketsType';
  /** The entitlements for B2B markets. */
  b2b: MarketsB2BEntitlement;
  /** The entitlements for region markets. */
  regions: MarketsRegionsEntitlement;
  /** The entitlements for retail markets. */
  retail: MarketsRetailEntitlement;
  /** The entitlements for themes. */
  themes: MarketsThemesEntitlement;
};

/** Represents a media interface. */
export type Media = {
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  mediaErrors: Array<MediaError>;
  /** The warnings attached to the media. */
  mediaWarnings: Array<MediaWarning>;
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** Current status of the media. */
  status: MediaStatus;
};

/** An auto-generated type for paginating through multiple Media. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MediaEdge>;
  /** A list of nodes that are contained in MediaEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Media>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The possible content types for a media object. */
export enum MediaContentType {
  /** An externally hosted video. */
  ExternalVideo = 'EXTERNAL_VIDEO',
  /** A Shopify-hosted image. */
  Image = 'IMAGE',
  /** A 3d model. */
  Model_3D = 'MODEL_3D',
  /** A Shopify-hosted video. */
  Video = 'VIDEO'
}

/** An auto-generated type which holds one Media and a cursor during pagination. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MediaEdge. */
  node: Media;
};

/**
 * Represents a media error. This typically occurs when there is an issue with the media itself causing it to fail validation.
 * Check the media before attempting to upload again.
 */
export type MediaError = {
  __typename?: 'MediaError';
  /** Code representing the type of error. */
  code: MediaErrorCode;
  /** Additional details regarding the error. */
  details?: Maybe<Scalars['String']['output']>;
  /** Translated error message. */
  message: Scalars['String']['output'];
};

/** Error types for media. */
export enum MediaErrorCode {
  /** Media could not be created because a file with the same name already exists. */
  DuplicateFilenameError = 'DUPLICATE_FILENAME_ERROR',
  /** Media could not be created because embed permissions are disabled for this video. */
  ExternalVideoEmbedDisabled = 'EXTERNAL_VIDEO_EMBED_DISABLED',
  /** Media could not be created because video is either not found or still transcoding. */
  ExternalVideoEmbedNotFoundOrTranscoding = 'EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING',
  /** Media could not be created because the external video has an invalid aspect ratio. */
  ExternalVideoInvalidAspectRatio = 'EXTERNAL_VIDEO_INVALID_ASPECT_RATIO',
  /** Media could not be created because the external video could not be found. */
  ExternalVideoNotFound = 'EXTERNAL_VIDEO_NOT_FOUND',
  /** Media could not be created because the external video is not listed or is private. */
  ExternalVideoUnlisted = 'EXTERNAL_VIDEO_UNLISTED',
  /** Media could not be created because the cumulative file storage limit would be exceeded. */
  FileStorageLimitExceeded = 'FILE_STORAGE_LIMIT_EXCEEDED',
  /** File could not be processed because the source could not be downloaded. */
  GenericFileDownloadFailure = 'GENERIC_FILE_DOWNLOAD_FAILURE',
  /** File could not be created because the size is too large. */
  GenericFileInvalidSize = 'GENERIC_FILE_INVALID_SIZE',
  /** Media could not be processed because the image could not be downloaded. */
  ImageDownloadFailure = 'IMAGE_DOWNLOAD_FAILURE',
  /** Media could not be processed because the image could not be processed. */
  ImageProcessingFailure = 'IMAGE_PROCESSING_FAILURE',
  /** Media could not be created because the image has an invalid aspect ratio. */
  InvalidImageAspectRatio = 'INVALID_IMAGE_ASPECT_RATIO',
  /** Media could not be created because the image size is too large. */
  InvalidImageFileSize = 'INVALID_IMAGE_FILE_SIZE',
  /** Media could not be created because the image's resolution exceeds the max limit. */
  InvalidImageResolution = 'INVALID_IMAGE_RESOLUTION',
  /** Media could not be processed because the signed URL was invalid. */
  InvalidSignedUrl = 'INVALID_SIGNED_URL',
  /** Media timed out because it is currently being modified by another operation. */
  MediaTimeoutError = 'MEDIA_TIMEOUT_ERROR',
  /** Media could not be created because the model file failed processing. */
  Model3DGlbOutputCreationError = 'MODEL3D_GLB_OUTPUT_CREATION_ERROR',
  /** Media could not be created because the model can't be converted to USDZ format. */
  Model3DGlbToUsdzConversionError = 'MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR',
  /** Media could not be created because the model file failed processing. */
  Model3DProcessingFailure = 'MODEL3D_PROCESSING_FAILURE',
  /** Media could not be created because the model's thumbnail generation failed. */
  Model3DThumbnailGenerationError = 'MODEL3D_THUMBNAIL_GENERATION_ERROR',
  /** There was an issue while trying to generate a new thumbnail. */
  Model3DThumbnailRegenerationError = 'MODEL3D_THUMBNAIL_REGENERATION_ERROR',
  /** Model failed validation. */
  Model3DValidationError = 'MODEL3D_VALIDATION_ERROR',
  /** Media error has occured for unknown reason. */
  Unknown = 'UNKNOWN',
  /** Media could not be created because the image is an unsupported file type. */
  UnsupportedImageFileType = 'UNSUPPORTED_IMAGE_FILE_TYPE',
  /** Media could not be created because it has an invalid file type. */
  VideoInvalidFiletypeError = 'VIDEO_INVALID_FILETYPE_ERROR',
  /** Media could not be created because it does not meet the maximum duration requirement. */
  VideoMaxDurationError = 'VIDEO_MAX_DURATION_ERROR',
  /** Media could not be created because it does not meet the maximum height requirement. */
  VideoMaxHeightError = 'VIDEO_MAX_HEIGHT_ERROR',
  /** Media could not be created because it does not meet the maximum width requirement. */
  VideoMaxWidthError = 'VIDEO_MAX_WIDTH_ERROR',
  /** Media could not be created because the metadata could not be read. */
  VideoMetadataReadError = 'VIDEO_METADATA_READ_ERROR',
  /** Media could not be created because it does not meet the minimum duration requirement. */
  VideoMinDurationError = 'VIDEO_MIN_DURATION_ERROR',
  /** Media could not be created because it does not meet the minimum height requirement. */
  VideoMinHeightError = 'VIDEO_MIN_HEIGHT_ERROR',
  /** Media could not be created because it does not meet the minimum width requirement. */
  VideoMinWidthError = 'VIDEO_MIN_WIDTH_ERROR',
  /** Video failed validation. */
  VideoValidationError = 'VIDEO_VALIDATION_ERROR'
}

/** Host for a Media Resource. */
export enum MediaHost {
  /** Host for Vimeo embedded videos. */
  Vimeo = 'VIMEO',
  /** Host for YouTube embedded videos. */
  Youtube = 'YOUTUBE'
}

/**
 * The `MediaImage` object represents an image hosted on Shopify's
 * [content delivery network (CDN)](https://shopify.dev/docs/storefronts/themes/best-practices/performance/platform#shopify-cdn).
 * Shopify CDN is a content system that serves as the primary way to store,
 * manage, and deliver visual content for products, variants, and other resources across the Shopify platform.
 *
 * The `MediaImage` object provides information to:
 *
 * - Store and display product and variant images across online stores, admin interfaces, and mobile apps.
 * - Retrieve visual branding elements, including logos, banners, favicons, and background images in checkout flows.
 * - Retrieve signed URLs for secure, time-limited access to original image files.
 *
 * Each `MediaImage` object provides both the processed image data (with automatic optimization and CDN delivery)
 * and access to the original source file. The image processing is handled asynchronously, so images
 * might not be immediately available after upload. The
 * [`status`](https://shopify.dev/docs/api/admin-graphql/latest/objects/mediaimage#field-MediaImage.fields.status)
 * field indicates when processing is complete and the image is ready for use.
 *
 * The `MediaImage` object implements the [`Media`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Media)
 * interface alongside other media types, like videos and 3D models.
 *
 * Learn about
 * managing media for [products](https://shopify.dev/docs/apps/build/online-store/product-media),
 * [product variants](https://shopify.dev/docs/apps/build/online-store/product-variant-media), and
 * [asynchronous media management](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components#asynchronous-media-management).
 */
export type MediaImage = File & HasMetafields & HasPublishedTranslations & Media & Node & {
  __typename?: 'MediaImage';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image for the media. Returns `null` until `status` is `READY`. */
  image?: Maybe<Image>;
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  mediaErrors: Array<MediaError>;
  /** The warnings attached to the media. */
  mediaWarnings: Array<MediaWarning>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   * @deprecated No longer supported. Use metaobjects instead.
   */
  metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   * @deprecated No longer supported. Use metaobjects instead.
   */
  metafields: MetafieldConnection;
  /** The MIME type of the image. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The original source of the image. */
  originalSource?: Maybe<MediaImageOriginalSource>;
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** Current status of the media. */
  status: MediaStatus;
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The `MediaImage` object represents an image hosted on Shopify's
 * [content delivery network (CDN)](https://shopify.dev/docs/storefronts/themes/best-practices/performance/platform#shopify-cdn).
 * Shopify CDN is a content system that serves as the primary way to store,
 * manage, and deliver visual content for products, variants, and other resources across the Shopify platform.
 *
 * The `MediaImage` object provides information to:
 *
 * - Store and display product and variant images across online stores, admin interfaces, and mobile apps.
 * - Retrieve visual branding elements, including logos, banners, favicons, and background images in checkout flows.
 * - Retrieve signed URLs for secure, time-limited access to original image files.
 *
 * Each `MediaImage` object provides both the processed image data (with automatic optimization and CDN delivery)
 * and access to the original source file. The image processing is handled asynchronously, so images
 * might not be immediately available after upload. The
 * [`status`](https://shopify.dev/docs/api/admin-graphql/latest/objects/mediaimage#field-MediaImage.fields.status)
 * field indicates when processing is complete and the image is ready for use.
 *
 * The `MediaImage` object implements the [`Media`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Media)
 * interface alongside other media types, like videos and 3D models.
 *
 * Learn about
 * managing media for [products](https://shopify.dev/docs/apps/build/online-store/product-media),
 * [product variants](https://shopify.dev/docs/apps/build/online-store/product-variant-media), and
 * [asynchronous media management](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components#asynchronous-media-management).
 */
export type MediaImageMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `MediaImage` object represents an image hosted on Shopify's
 * [content delivery network (CDN)](https://shopify.dev/docs/storefronts/themes/best-practices/performance/platform#shopify-cdn).
 * Shopify CDN is a content system that serves as the primary way to store,
 * manage, and deliver visual content for products, variants, and other resources across the Shopify platform.
 *
 * The `MediaImage` object provides information to:
 *
 * - Store and display product and variant images across online stores, admin interfaces, and mobile apps.
 * - Retrieve visual branding elements, including logos, banners, favicons, and background images in checkout flows.
 * - Retrieve signed URLs for secure, time-limited access to original image files.
 *
 * Each `MediaImage` object provides both the processed image data (with automatic optimization and CDN delivery)
 * and access to the original source file. The image processing is handled asynchronously, so images
 * might not be immediately available after upload. The
 * [`status`](https://shopify.dev/docs/api/admin-graphql/latest/objects/mediaimage#field-MediaImage.fields.status)
 * field indicates when processing is complete and the image is ready for use.
 *
 * The `MediaImage` object implements the [`Media`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Media)
 * interface alongside other media types, like videos and 3D models.
 *
 * Learn about
 * managing media for [products](https://shopify.dev/docs/apps/build/online-store/product-media),
 * [product variants](https://shopify.dev/docs/apps/build/online-store/product-variant-media), and
 * [asynchronous media management](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components#asynchronous-media-management).
 */
export type MediaImageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `MediaImage` object represents an image hosted on Shopify's
 * [content delivery network (CDN)](https://shopify.dev/docs/storefronts/themes/best-practices/performance/platform#shopify-cdn).
 * Shopify CDN is a content system that serves as the primary way to store,
 * manage, and deliver visual content for products, variants, and other resources across the Shopify platform.
 *
 * The `MediaImage` object provides information to:
 *
 * - Store and display product and variant images across online stores, admin interfaces, and mobile apps.
 * - Retrieve visual branding elements, including logos, banners, favicons, and background images in checkout flows.
 * - Retrieve signed URLs for secure, time-limited access to original image files.
 *
 * Each `MediaImage` object provides both the processed image data (with automatic optimization and CDN delivery)
 * and access to the original source file. The image processing is handled asynchronously, so images
 * might not be immediately available after upload. The
 * [`status`](https://shopify.dev/docs/api/admin-graphql/latest/objects/mediaimage#field-MediaImage.fields.status)
 * field indicates when processing is complete and the image is ready for use.
 *
 * The `MediaImage` object implements the [`Media`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Media)
 * interface alongside other media types, like videos and 3D models.
 *
 * Learn about
 * managing media for [products](https://shopify.dev/docs/apps/build/online-store/product-media),
 * [product variants](https://shopify.dev/docs/apps/build/online-store/product-variant-media), and
 * [asynchronous media management](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components#asynchronous-media-management).
 */
export type MediaImageTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** The original source for an image. */
export type MediaImageOriginalSource = {
  __typename?: 'MediaImageOriginalSource';
  /** The size of the original file in bytes. */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** The URL of the original image, valid only for a short period. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Represents the preview image for a media. */
export type MediaPreviewImage = {
  __typename?: 'MediaPreviewImage';
  /** The preview image for the media. Returns `null` until `status` is `READY`. */
  image?: Maybe<Image>;
  /** Current status of the preview image. */
  status: MediaPreviewImageStatus;
};

/** The possible statuses for a media preview image. */
export enum MediaPreviewImageStatus {
  /** Preview image processing has failed. */
  Failed = 'FAILED',
  /** Preview image is being processed. */
  Processing = 'PROCESSING',
  /** Preview image is ready to be displayed. */
  Ready = 'READY',
  /** Preview image is uploaded but not yet processed. */
  Uploaded = 'UPLOADED'
}

/** The possible statuses for a media object. */
export enum MediaStatus {
  /** Media processing has failed. */
  Failed = 'FAILED',
  /** Media is being processed. */
  Processing = 'PROCESSING',
  /** Media is ready to be displayed. */
  Ready = 'READY',
  /** Media has been uploaded but not yet processed. */
  Uploaded = 'UPLOADED'
}

/** Represents an error that happens during execution of a Media query or mutation. */
export type MediaUserError = DisplayableError & {
  __typename?: 'MediaUserError';
  /** The error code. */
  code?: Maybe<MediaUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MediaUserError`. */
export enum MediaUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Invalid media type. */
  InvalidMediaType = 'INVALID_MEDIA_TYPE',
  /** Exceeded the maximum number of 100 variant-media pairs per mutation call. */
  MaximumVariantMediaPairsExceeded = 'MAXIMUM_VARIANT_MEDIA_PAIRS_EXCEEDED',
  /** Media cannot be modified. It is currently being modified by another operation. */
  MediaCannotBeModified = 'MEDIA_CANNOT_BE_MODIFIED',
  /** Media does not exist. */
  MediaDoesNotExist = 'MEDIA_DOES_NOT_EXIST',
  /** Media does not exist on the given product. */
  MediaDoesNotExistOnProduct = 'MEDIA_DOES_NOT_EXIST_ON_PRODUCT',
  /** The specified media is not attached to the specified variant. */
  MediaIsNotAttachedToVariant = 'MEDIA_IS_NOT_ATTACHED_TO_VARIANT',
  /** Missing arguments. */
  MissingArguments = 'MISSING_ARGUMENTS',
  /** Model3d creation throttle was exceeded. */
  Model3DThrottleExceeded = 'MODEL3D_THROTTLE_EXCEEDED',
  /** Model validation failed. */
  Model3DValidationError = 'MODEL3D_VALIDATION_ERROR',
  /** Non-ready media are not supported. */
  NonReadyMedia = 'NON_READY_MEDIA',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Exceeded the limit of media per product. */
  ProductMediaLimitExceeded = 'PRODUCT_MEDIA_LIMIT_EXCEEDED',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Product variant already has attached media. */
  ProductVariantAlreadyHasMedia = 'PRODUCT_VARIANT_ALREADY_HAS_MEDIA',
  /** Variant does not exist on the given product. */
  ProductVariantDoesNotExistOnProduct = 'PRODUCT_VARIANT_DOES_NOT_EXIST_ON_PRODUCT',
  /** Variant specified in more than one pair. */
  ProductVariantSpecifiedMultipleTimes = 'PRODUCT_VARIANT_SPECIFIED_MULTIPLE_TIMES',
  /** Exceeded the limit of media per shop. */
  ShopMediaLimitExceeded = 'SHOP_MEDIA_LIMIT_EXCEEDED',
  /** Only one mediaId is allowed per variant-media input pair. */
  TooManyMediaPerInputPair = 'TOO_MANY_MEDIA_PER_INPUT_PAIR',
  /** Video creation throttle was exceeded. */
  VideoThrottleExceeded = 'VIDEO_THROTTLE_EXCEEDED',
  /** Video validation failed. */
  VideoValidationError = 'VIDEO_VALIDATION_ERROR'
}

/**
 * Represents a media warning. This occurs when there is a non-blocking concern regarding your media.
 * Consider reviewing your media to ensure it is correct and its parameters are as expected.
 */
export type MediaWarning = {
  __typename?: 'MediaWarning';
  /** The code representing the type of warning. */
  code: MediaWarningCode;
  /** Translated warning message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Warning types for media. */
export enum MediaWarningCode {
  /** 3D model physical size might be invalid. The dimensions of your model are very large. Consider reviewing your model to ensure they are correct. */
  ModelLargePhysicalSize = 'MODEL_LARGE_PHYSICAL_SIZE',
  /** The thumbnail failed to regenerate.Try applying the changes again to regenerate the thumbnail. */
  ModelPreviewImageFail = 'MODEL_PREVIEW_IMAGE_FAIL',
  /** 3D model physical size might be invalid. The dimensions of your model are very small. Consider reviewing your model to ensure they are correct. */
  ModelSmallPhysicalSize = 'MODEL_SMALL_PHYSICAL_SIZE'
}

/**
 * Navigation menus that organize links into logical structures to guide customers through a store. Menus serve as the backbone of store navigation, making it easy for customers to find products, pages, and other content through organized hierarchical links.
 *
 * For example, a merchant might create a main navigation menu with top-level categories like "Products," "About Us," and "Contact," where each category can contain nested menu items linking to specific collections, pages, or external resources.
 *
 * Use the `Menu` object to:
 * - Build and customize store navigation structures
 * - Organize hierarchical menu systems with nested items
 * - Work with default menus that can't be deleted
 * - Access menu items for building navigation
 *
 * Menus can be designated as default navigation elements (like main menu or footer), which can't be deleted and have restricted handle updates. The handle provides a unique identifier that themes can reference, while the items collection enables nested navigation structures.
 *
 * Each menu contains menu items that can link to various resource types. This flexibility lets merchants create navigation experiences that guide customers through their store.
 */
export type Menu = HasPublishedTranslations & Node & {
  __typename?: 'Menu';
  /** The date and time when the menu was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The menu's handle. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the menu is a default. The handle for default menus can't be updated and default menus can't be deleted. */
  isDefault: Scalars['Boolean']['output'];
  /** A list of items on the menu sorted by position. */
  items: Array<MenuItem>;
  /** The menu's title. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/**
 * Navigation menus that organize links into logical structures to guide customers through a store. Menus serve as the backbone of store navigation, making it easy for customers to find products, pages, and other content through organized hierarchical links.
 *
 * For example, a merchant might create a main navigation menu with top-level categories like "Products," "About Us," and "Contact," where each category can contain nested menu items linking to specific collections, pages, or external resources.
 *
 * Use the `Menu` object to:
 * - Build and customize store navigation structures
 * - Organize hierarchical menu systems with nested items
 * - Work with default menus that can't be deleted
 * - Access menu items for building navigation
 *
 * Menus can be designated as default navigation elements (like main menu or footer), which can't be deleted and have restricted handle updates. The handle provides a unique identifier that themes can reference, while the items collection enables nested navigation structures.
 *
 * Each menu contains menu items that can link to various resource types. This flexibility lets merchants create navigation experiences that guide customers through their store.
 */
export type MenuItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Navigation menus that organize links into logical structures to guide customers through a store. Menus serve as the backbone of store navigation, making it easy for customers to find products, pages, and other content through organized hierarchical links.
 *
 * For example, a merchant might create a main navigation menu with top-level categories like "Products," "About Us," and "Contact," where each category can contain nested menu items linking to specific collections, pages, or external resources.
 *
 * Use the `Menu` object to:
 * - Build and customize store navigation structures
 * - Organize hierarchical menu systems with nested items
 * - Work with default menus that can't be deleted
 * - Access menu items for building navigation
 *
 * Menus can be designated as default navigation elements (like main menu or footer), which can't be deleted and have restricted handle updates. The handle provides a unique identifier that themes can reference, while the items collection enables nested navigation structures.
 *
 * Each menu contains menu items that can link to various resource types. This flexibility lets merchants create navigation experiences that guide customers through their store.
 */
export type MenuTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** An auto-generated type for paginating through multiple Menus. */
export type MenuConnection = {
  __typename?: 'MenuConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MenuEdge>;
  /** A list of nodes that are contained in MenuEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Menu>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `menuCreate` mutation. */
export type MenuCreatePayload = {
  __typename?: 'MenuCreatePayload';
  /** The created menu. */
  menu?: Maybe<Menu>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MenuCreateUserError>;
};

/** An error that occurs during the execution of `MenuCreate`. */
export type MenuCreateUserError = DisplayableError & {
  __typename?: 'MenuCreateUserError';
  /** The error code. */
  code?: Maybe<MenuCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MenuCreateUserError`. */
export enum MenuCreateUserErrorCode {
  /** The menu cannot be nested more than 3 level deep. */
  NestingTooDeep = 'NESTING_TOO_DEEP',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** Return type for `menuDelete` mutation. */
export type MenuDeletePayload = {
  __typename?: 'MenuDeletePayload';
  /** The ID of the deleted menu. */
  deletedMenuId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MenuDeleteUserError>;
};

/** An error that occurs during the execution of `MenuDelete`. */
export type MenuDeleteUserError = DisplayableError & {
  __typename?: 'MenuDeleteUserError';
  /** The error code. */
  code?: Maybe<MenuDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MenuDeleteUserError`. */
export enum MenuDeleteUserErrorCode {
  /** Menu does not exist. */
  MenuDoesNotExist = 'MENU_DOES_NOT_EXIST',
  /** Default menu cannot be deleted. */
  UnableToDeleteDefaultMenu = 'UNABLE_TO_DELETE_DEFAULT_MENU'
}

/** An auto-generated type which holds one Menu and a cursor during pagination. */
export type MenuEdge = {
  __typename?: 'MenuEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MenuEdge. */
  node: Menu;
};

/**
 * Individual navigation links that make up store menus, giving customers clickable paths to explore the store. Menu items are the building blocks that connect shoppers to products, collections, pages, or external resources.
 *
 * For example, within a "Products" menu, individual menu items might link to specific collections like "Summer Collection" or "Best Sellers," each with its own title, URL, and resource connection.
 *
 * Use the `MenuItem` object to:
 * - Define individual navigation links and their destinations
 * - Create nested menu hierarchies through item relationships
 * - Use tags for collection filtering
 * - Connect menu links to specific store resources
 *
 * Menu items support various link types, enabling connections to internal store content or external websites. The nested items capability allows for dropdown or multi-level navigation structures that help organize complex store catalogs.
 */
export type MenuItem = {
  __typename?: 'MenuItem';
  /** A globally-unique ID of the navigation menu item. */
  id: Scalars['ID']['output'];
  /** List of the menu items nested under this item sorted by position. */
  items: Array<MenuItem>;
  /** The ID of the resource to link to. */
  resourceId?: Maybe<Scalars['ID']['output']>;
  /** The menu item's tags to filter a collection. */
  tags: Array<Scalars['String']['output']>;
  /** The menu item's title. */
  title: Scalars['String']['output'];
  /** The menu item's type. */
  type: MenuItemType;
  /** The menu item's url. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The input fields required to create a valid menu item. */
export type MenuItemCreateInput = {
  /** List of the menu items nested under this item sorted by position. */
  items?: InputMaybe<Array<MenuItemCreateInput>>;
  /** The menu item's association with an existing resource. */
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  /** The menu item's tags to filter a collection. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The menu item's title. */
  title: Scalars['String']['input'];
  /** The menu item's type. */
  type: MenuItemType;
  /** The menu item's url to be used when the item doesn't point to a resource. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A menu item type. */
export enum MenuItemType {
  /** The article menu item type. */
  Article = 'ARTICLE',
  /** The blog menu item type. */
  Blog = 'BLOG',
  /** The catalog menu item type. */
  Catalog = 'CATALOG',
  /** The collection menu item type. */
  Collection = 'COLLECTION',
  /** The collections menu item type. */
  Collections = 'COLLECTIONS',
  /** The customer_account_page menu item type. */
  CustomerAccountPage = 'CUSTOMER_ACCOUNT_PAGE',
  /** The frontpage menu item type. */
  Frontpage = 'FRONTPAGE',
  /** The http menu item type. */
  Http = 'HTTP',
  /** The metaobject menu item type. */
  Metaobject = 'METAOBJECT',
  /** The page menu item type. */
  Page = 'PAGE',
  /** The product menu item type. */
  Product = 'PRODUCT',
  /** The search menu item type. */
  Search = 'SEARCH',
  /** The shop_policy menu item type. */
  ShopPolicy = 'SHOP_POLICY'
}

/** The input fields required to update a valid menu item. */
export type MenuItemUpdateInput = {
  /** A globally-unique ID of the online store navigation menu item. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of the menu items nested under this item sorted by position. */
  items?: InputMaybe<Array<MenuItemUpdateInput>>;
  /** The menu item's association with an existing resource. */
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  /** The menu item's tags to filter a collection. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The menu item's title. */
  title: Scalars['String']['input'];
  /** The menu item's type. */
  type: MenuItemType;
  /** The menu item's url to be used when the item doesn't point to a resource. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The set of valid sort keys for the Menu query. */
export enum MenuSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `menuUpdate` mutation. */
export type MenuUpdatePayload = {
  __typename?: 'MenuUpdatePayload';
  /** The updated menu. */
  menu?: Maybe<Menu>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MenuUpdateUserError>;
};

/** An error that occurs during the execution of `MenuUpdate`. */
export type MenuUpdateUserError = DisplayableError & {
  __typename?: 'MenuUpdateUserError';
  /** The error code. */
  code?: Maybe<MenuUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MenuUpdateUserError`. */
export enum MenuUpdateUserErrorCode {
  /** The menu cannot be nested more than 3 level deep. */
  NestingTooDeep = 'NESTING_TOO_DEEP',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum MerchandiseDiscountClass {
  /**
   * The discount is combined with an
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  Order = 'ORDER',
  /**
   * The discount is combined with a
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  Product = 'PRODUCT'
}

/** Merchant approval for accelerated onboarding to channel integration apps. */
export type MerchantApprovalSignals = {
  __typename?: 'MerchantApprovalSignals';
  /** Whether the shop's Shopify Payments account identity is verified. Returns `false` if the identity is unverified or if the shop doesn't have a Shopify Payments account. */
  identityVerified: Scalars['Boolean']['output'];
  /** Whether Shopify has pre-verified the merchant's business for onboarding to channel integration apps. Returns `false` if the shop isn't marked for verification. */
  verifiedByShopify: Scalars['Boolean']['output'];
  /** Which tier of the Shopify verification was determined for the merchant's business for onboarding to channel integration apps. */
  verifiedByShopifyTier: Scalars['String']['output'];
};

/**
 * Metafields enable you to attach additional information to a Shopify resource, such as a [Product](https://shopify.dev/api/admin-graphql/latest/objects/product) or a [Collection](https://shopify.dev/api/admin-graphql/latest/objects/collection).
 * For more information about where you can attach metafields refer to [HasMetafields](https://shopify.dev/api/admin-graphql/latest/interfaces/HasMetafields).
 * Some examples of the data that metafields enable you to store are specifications, size charts, downloadable documents, release dates, images, or part numbers.
 * Metafields are identified by an owner resource, namespace, and key. and store a value along with type information for that value.
 */
export type Metafield = HasCompareDigest & HasPublishedTranslations & LegacyInteroperability & Node & {
  __typename?: 'Metafield';
  /** The data stored in the resource, represented as a digest. */
  compareDigest: Scalars['String']['output'];
  /** The date and time when the metafield was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The metafield definition that the metafield belongs to, if any. */
  definition?: Maybe<MetafieldDefinition>;
  /**
   * The description of the metafield.
   * @deprecated This field will be removed in a future release. Use the `description` on the metafield definition instead.
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The data stored in the metafield in JSON format. */
  jsonValue: Scalars['JSON']['output'];
  /** The unique identifier for the metafield within its namespace. */
  key: Scalars['String']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The container for a group of metafields that the metafield is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource that the metafield is attached to. */
  owner: HasMetafields;
  /** The type of resource that the metafield is attached to. */
  ownerType: MetafieldOwnerType;
  /** Returns a reference object if the metafield definition's type is a resource reference. */
  reference?: Maybe<MetafieldReference>;
  /** A list of reference objects if the metafield's type is a resource reference list. */
  references?: Maybe<MetafieldReferenceConnection>;
  /** The size of the metafield value in bytes. */
  sizeInBytes: Scalars['Int']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /**
   * The type of data that's stored in the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  type: Scalars['String']['output'];
  /** The date and time when the metafield was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  value: Scalars['String']['output'];
};


/**
 * Metafields enable you to attach additional information to a Shopify resource, such as a [Product](https://shopify.dev/api/admin-graphql/latest/objects/product) or a [Collection](https://shopify.dev/api/admin-graphql/latest/objects/collection).
 * For more information about where you can attach metafields refer to [HasMetafields](https://shopify.dev/api/admin-graphql/latest/interfaces/HasMetafields).
 * Some examples of the data that metafields enable you to store are specifications, size charts, downloadable documents, release dates, images, or part numbers.
 * Metafields are identified by an owner resource, namespace, and key. and store a value along with type information for that value.
 */
export type MetafieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Metafields enable you to attach additional information to a Shopify resource, such as a [Product](https://shopify.dev/api/admin-graphql/latest/objects/product) or a [Collection](https://shopify.dev/api/admin-graphql/latest/objects/collection).
 * For more information about where you can attach metafields refer to [HasMetafields](https://shopify.dev/api/admin-graphql/latest/interfaces/HasMetafields).
 * Some examples of the data that metafields enable you to store are specifications, size charts, downloadable documents, release dates, images, or part numbers.
 * Metafields are identified by an owner resource, namespace, and key. and store a value along with type information for that value.
 */
export type MetafieldTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Access permissions for the definition's metafields. */
export type MetafieldAccess = {
  __typename?: 'MetafieldAccess';
  /** The access permitted on the Admin API. */
  admin?: Maybe<MetafieldAdminAccess>;
  /** The access permitted on the Customer Account API. */
  customerAccount: MetafieldCustomerAccountAccess;
  /** The access permitted on the Storefront API. */
  storefront?: Maybe<MetafieldStorefrontAccess>;
};

/** The input fields that set access permissions for the definition's metafields. */
export type MetafieldAccessInput = {
  /** The access permitted on the Admin API. */
  admin?: InputMaybe<MetafieldAdminAccessInput>;
  /** The access permitted on the Customer Account API. */
  customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The access permitted on the Storefront API. */
  storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** The input fields for the access settings for the metafields under the definition. */
export type MetafieldAccessUpdateInput = {
  /** The admin access setting to use for the metafields under this definition. */
  admin?: InputMaybe<MetafieldAdminAccessInput>;
  /** The Customer Account API access setting to use for the metafields under this definition. */
  customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The storefront access setting to use for the metafields under this definition. */
  storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** Metafield access permissions for the Admin API. */
export enum MetafieldAdminAccess {
  /** The merchant has read-only access. No other apps have access. */
  MerchantRead = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MerchantReadWrite = 'MERCHANT_READ_WRITE',
  /** The merchant and other apps have no access. */
  Private = 'PRIVATE',
  /** The merchant and other apps have read-only access. */
  PublicRead = 'PUBLIC_READ',
  /** The merchant and other apps have read and write access. */
  PublicReadWrite = 'PUBLIC_READ_WRITE'
}

/** Metafield access permissions for the Admin API. */
export enum MetafieldAdminAccessInput {
  /** The merchant has read-only access. No other apps have access. */
  MerchantRead = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MerchantReadWrite = 'MERCHANT_READ_WRITE'
}

/** Provides the capabilities of a metafield definition. */
export type MetafieldCapabilities = {
  __typename?: 'MetafieldCapabilities';
  /** Indicate whether a metafield definition is configured for filtering. */
  adminFilterable: MetafieldCapabilityAdminFilterable;
  /** Indicate whether a metafield definition can be queried in analytics. */
  analyticsQueryable: MetafieldCapabilityAnalyticsQueryable;
  /** The capability configuration for automatically copying values from a cart metafield to the corresponding order metafield when an order is created. */
  cartToOrderCopyable: MetafieldCapabilityCartToOrderCopyable;
  /** Indicate whether a metafield definition can be used as a smart collection condition. */
  smartCollectionCondition: MetafieldCapabilitySmartCollectionCondition;
  /** Indicate whether the metafield values for a metafield definition are required to be unique. */
  uniqueValues: MetafieldCapabilityUniqueValues;
};

/** Information about the admin filterable capability on a metafield definition. */
export type MetafieldCapabilityAdminFilterable = {
  __typename?: 'MetafieldCapabilityAdminFilterable';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** Determines the metafield definition's filter status for use in admin filtering. */
  status: MetafieldDefinitionAdminFilterStatus;
};

/** The input fields for enabling and disabling the admin filterable capability. */
export type MetafieldCapabilityAdminFilterableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The analytics queryable capability of a metafield definition. */
export type MetafieldCapabilityAnalyticsQueryable = {
  __typename?: 'MetafieldCapabilityAnalyticsQueryable';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for the analytics queryable capability. */
export type MetafieldCapabilityAnalyticsQueryableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/**
 * Information about the cart to order copyable capability on a metafield definition.
 * Only order metafield definitions are eligible to have this capability enabled.
 *
 * When enabled, the value from a cart metafield is automatically copied to the corresponding
 * order metafield when an order is created. The namespace and key must match between the cart and order metafields.
 */
export type MetafieldCapabilityCartToOrderCopyable = {
  __typename?: 'MetafieldCapabilityCartToOrderCopyable';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/**
 * The input fields for enabling or disabling the "Cart to order copyable" capability.
 * This capability is only available for order metafield definitions.
 *
 * When enabled, the value from a cart metafield is automatically copied to the corresponding
 * order metafield when an order is created. The namespace and key must match between the cart and order metafields.
 */
export type MetafieldCapabilityCartToOrderCopyableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The input fields for creating a metafield capability. */
export type MetafieldCapabilityCreateInput = {
  /** The input for updating the admin filterable capability. */
  adminFilterable?: InputMaybe<MetafieldCapabilityAdminFilterableInput>;
  /** The input for the analytics queryable capability. */
  analyticsQueryable?: InputMaybe<MetafieldCapabilityAnalyticsQueryableInput>;
  /** The input for updating the cart to order copyable capability. */
  cartToOrderCopyable?: InputMaybe<MetafieldCapabilityCartToOrderCopyableInput>;
  /** The input for updating the smart collection condition capability. */
  smartCollectionCondition?: InputMaybe<MetafieldCapabilitySmartCollectionConditionInput>;
  /** The input for updating the unique values capability. */
  uniqueValues?: InputMaybe<MetafieldCapabilityUniqueValuesInput>;
};

/** Information about the smart collection condition capability on a metafield definition. */
export type MetafieldCapabilitySmartCollectionCondition = {
  __typename?: 'MetafieldCapabilitySmartCollectionCondition';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for enabling and disabling the smart collection condition capability. */
export type MetafieldCapabilitySmartCollectionConditionInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** Information about the unique values capability on a metafield definition. */
export type MetafieldCapabilityUniqueValues = {
  __typename?: 'MetafieldCapabilityUniqueValues';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for enabling and disabling the unique values capability. */
export type MetafieldCapabilityUniqueValuesInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The input fields for updating a metafield capability. */
export type MetafieldCapabilityUpdateInput = {
  /** The input for updating the admin filterable capability. */
  adminFilterable?: InputMaybe<MetafieldCapabilityAdminFilterableInput>;
  /** The input for the analytics queryable capability. */
  analyticsQueryable?: InputMaybe<MetafieldCapabilityAnalyticsQueryableInput>;
  /** The input for updating the cart to order copyable capability. */
  cartToOrderCopyable?: InputMaybe<MetafieldCapabilityCartToOrderCopyableInput>;
  /** The input for updating the smart collection condition capability. */
  smartCollectionCondition?: InputMaybe<MetafieldCapabilitySmartCollectionConditionInput>;
  /** The input for updating the unique values capability. */
  uniqueValues?: InputMaybe<MetafieldCapabilityUniqueValuesInput>;
};

/** An auto-generated type for paginating through multiple Metafields. */
export type MetafieldConnection = {
  __typename?: 'MetafieldConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetafieldEdge>;
  /** A list of nodes that are contained in MetafieldEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Metafield>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Metafield access permissions for the Customer Account API. */
export enum MetafieldCustomerAccountAccess {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  Read = 'READ',
  /** Read and write access. */
  ReadWrite = 'READ_WRITE'
}

/** Metafield access permissions for the Customer Account API. */
export enum MetafieldCustomerAccountAccessInput {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  Read = 'READ',
  /** Read and write access. */
  ReadWrite = 'READ_WRITE'
}

/**
 * Defines the structure, validation rules, and permissions for [`Metafield`](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) objects attached to a specific owner type. Each definition establishes a schema that metafields must follow, including the data type and validation constraints.
 *
 * The definition controls access permissions across different APIs, determines whether the metafield can be used for filtering or as a collection condition, and can be constrained to specific resource subtypes.
 */
export type MetafieldDefinition = Node & {
  __typename?: 'MetafieldDefinition';
  /** The access settings associated with the metafield definition. */
  access: MetafieldAccess;
  /** The capabilities of the metafield definition. */
  capabilities: MetafieldCapabilities;
  /**
   * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
   * that determine what subtypes of resources a metafield definition applies to.
   */
  constraints?: Maybe<MetafieldDefinitionConstraints>;
  /** The description of the metafield definition. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The metafields that belong to the metafield definition. */
  metafields: MetafieldConnection;
  /** The count of the metafields that belong to the metafield definition. */
  metafieldsCount: Scalars['Int']['output'];
  /** The human-readable name of the metafield definition. */
  name: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
  /** The position of the metafield definition in the pinned list. */
  pinnedPosition?: Maybe<Scalars['Int']['output']>;
  /** The standard metafield definition template associated with the metafield definition. */
  standardTemplate?: Maybe<StandardMetafieldDefinitionTemplate>;
  /**
   * The type of data that each of the metafields that belong to the metafield definition will store.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  type: MetafieldDefinitionType;
  /** Whether the metafield definition can be used as a collection condition. */
  useAsCollectionCondition: Scalars['Boolean']['output'];
  /** The validation status for the metafields that belong to the metafield definition. */
  validationStatus: MetafieldDefinitionValidationStatus;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  validations: Array<MetafieldDefinitionValidation>;
};


/**
 * Defines the structure, validation rules, and permissions for [`Metafield`](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) objects attached to a specific owner type. Each definition establishes a schema that metafields must follow, including the data type and validation constraints.
 *
 * The definition controls access permissions across different APIs, determines whether the metafield can be used for filtering or as a collection condition, and can be constrained to specific resource subtypes.
 */
export type MetafieldDefinitionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  validationStatus?: InputMaybe<MetafieldValidationStatus>;
};


/**
 * Defines the structure, validation rules, and permissions for [`Metafield`](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) objects attached to a specific owner type. Each definition establishes a schema that metafields must follow, including the data type and validation constraints.
 *
 * The definition controls access permissions across different APIs, determines whether the metafield can be used for filtering or as a collection condition, and can be constrained to specific resource subtypes.
 */
export type MetafieldDefinitionMetafieldsCountArgs = {
  validationStatus?: InputMaybe<MetafieldValidationStatus>;
};

/** Possible filter statuses associated with a metafield definition for use in admin filtering. */
export enum MetafieldDefinitionAdminFilterStatus {
  /** The metafield definition has failed to be enabled for admin filtering. */
  Failed = 'FAILED',
  /** The metafield definition allows admin filtering by matching metafield values. */
  Filterable = 'FILTERABLE',
  /** The metafield definition's metafields are currently being processed for admin filtering. */
  InProgress = 'IN_PROGRESS',
  /** The metafield definition cannot be used for admin filtering. */
  NotFilterable = 'NOT_FILTERABLE'
}

/** An auto-generated type for paginating through multiple MetafieldDefinitions. */
export type MetafieldDefinitionConnection = {
  __typename?: 'MetafieldDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetafieldDefinitionEdge>;
  /** A list of nodes that are contained in MetafieldDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MetafieldDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Metafield definition constraint criteria to filter metafield definitions by. */
export enum MetafieldDefinitionConstraintStatus {
  /** Returns both constrained and unconstrained metafield definitions. */
  ConstrainedAndUnconstrained = 'CONSTRAINED_AND_UNCONSTRAINED',
  /** Only returns metafield definitions that are constrained to a resource subtype. */
  ConstrainedOnly = 'CONSTRAINED_ONLY',
  /** Only returns metafield definitions that are not constrained to a resource subtype. */
  UnconstrainedOnly = 'UNCONSTRAINED_ONLY'
}

/** The input fields used to identify a subtype of a resource for the purposes of metafield definition constraints. */
export type MetafieldDefinitionConstraintSubtypeIdentifier = {
  /** The category of the resource subtype. */
  key: Scalars['String']['input'];
  /** The specific subtype value within the identified subtype category. */
  value: Scalars['String']['input'];
};

/** A constraint subtype value that the metafield definition applies to. */
export type MetafieldDefinitionConstraintValue = {
  __typename?: 'MetafieldDefinitionConstraintValue';
  /** The subtype value of the constraint. */
  value: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple MetafieldDefinitionConstraintValues. */
export type MetafieldDefinitionConstraintValueConnection = {
  __typename?: 'MetafieldDefinitionConstraintValueConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetafieldDefinitionConstraintValueEdge>;
  /** A list of nodes that are contained in MetafieldDefinitionConstraintValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MetafieldDefinitionConstraintValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldDefinitionConstraintValue and a cursor during pagination. */
export type MetafieldDefinitionConstraintValueEdge = {
  __typename?: 'MetafieldDefinitionConstraintValueEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldDefinitionConstraintValueEdge. */
  node: MetafieldDefinitionConstraintValue;
};

/**
 * The inputs fields for modifying a metafield definition's constraint subtype values.
 * Exactly one option is required.
 */
export type MetafieldDefinitionConstraintValueUpdateInput = {
  /** The constraint subtype value to create. */
  create?: InputMaybe<Scalars['String']['input']>;
  /** The constraint subtype value to delete. */
  delete?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
 * that determine what subtypes of resources a metafield definition applies to.
 */
export type MetafieldDefinitionConstraints = {
  __typename?: 'MetafieldDefinitionConstraints';
  /** The category of resource subtypes that the definition applies to. */
  key?: Maybe<Scalars['String']['output']>;
  /** The specific constraint subtype values that the definition applies to. */
  values: MetafieldDefinitionConstraintValueConnection;
};


/**
 * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
 * that determine what subtypes of resources a metafield definition applies to.
 */
export type MetafieldDefinitionConstraintsValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The input fields required to create metafield definition [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions).
 * Each constraint applies a metafield definition to a subtype of a resource.
 */
export type MetafieldDefinitionConstraintsInput = {
  /** The category of resource subtypes that the definition applies to. */
  key: Scalars['String']['input'];
  /** The specific constraint subtype values that the definition applies to. */
  values: Array<Scalars['String']['input']>;
};

/**
 * The input fields required to update metafield definition [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions).
 * Each constraint applies a metafield definition to a subtype of a resource.
 */
export type MetafieldDefinitionConstraintsUpdatesInput = {
  /**
   * The category of resource subtypes that the definition applies to.
   * If omitted and the definition is already constrained, the existing constraint key will be used.
   * If set to `null`, all constraints will be removed.
   */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The specific constraint subtype values to create or delete. */
  values?: InputMaybe<Array<MetafieldDefinitionConstraintValueUpdateInput>>;
};

/** Return type for `metafieldDefinitionCreate` mutation. */
export type MetafieldDefinitionCreatePayload = {
  __typename?: 'MetafieldDefinitionCreatePayload';
  /** The metafield definition that was created. */
  createdDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldDefinitionCreateUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionCreate`. */
export type MetafieldDefinitionCreateUserError = DisplayableError & {
  __typename?: 'MetafieldDefinitionCreateUserError';
  /** The error code. */
  code?: Maybe<MetafieldDefinitionCreateUserErrorCode>;
  /** The index of the array element that's causing the error. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The key of the failing validation element. */
  elementKey?: Maybe<Scalars['String']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionCreateUserError`. */
export enum MetafieldDefinitionCreateUserErrorCode {
  /** Admin access can only be specified for app-owned metafield definitions. */
  AdminAccessInputNotAllowed = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** A capability is required for the definition type but is disabled. */
  CapabilityRequiredButDisabled = 'CAPABILITY_REQUIRED_BUT_DISABLED',
  /** A duplicate option. */
  DuplicateOption = 'DUPLICATE_OPTION',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The metafield definition capability is invalid. */
  InvalidCapability = 'INVALID_CAPABILITY',
  /** A field contains an invalid character. */
  InvalidCharacter = 'INVALID_CHARACTER',
  /** The metafield definition constraints are invalid. */
  InvalidConstraints = 'INVALID_CONSTRAINTS',
  /** The input combination is invalid. */
  InvalidInputCombination = 'INVALID_INPUT_COMBINATION',
  /** An invalid option. */
  InvalidOption = 'INVALID_OPTION',
  /** The maximum limit of definitions per owner type has exceeded. */
  LimitExceeded = 'LIMIT_EXCEEDED',
  /** You have reached the maximum allowed definitions for automated collections. */
  OwnerTypeLimitExceededForAutomatedCollections = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS',
  /** You have reached the maximum allowed definitions to be used as admin filters. */
  OwnerTypeLimitExceededForUseAsAdminFilters = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_USE_AS_ADMIN_FILTERS',
  /** The pinned limit has been reached for the owner type. */
  PinnedLimitReached = 'PINNED_LIMIT_REACHED',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** This namespace and key combination is reserved for standard definitions. */
  ReservedNamespaceKey = 'RESERVED_NAMESPACE_KEY',
  /** The definition limit per owner type has exceeded. */
  ResourceTypeLimitExceeded = 'RESOURCE_TYPE_LIMIT_EXCEEDED',
  /** The definition limit per owner type for the app has exceeded. */
  ResourceTypeLimitExceededByApp = 'RESOURCE_TYPE_LIMIT_EXCEEDED_BY_APP',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** The definition type is not eligible to be used as collection condition. */
  TypeNotAllowedForConditions = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** This namespace and key combination is already in use for a set of your metafields. */
  UnstructuredAlreadyExists = 'UNSTRUCTURED_ALREADY_EXISTS',
  /** The metafield definition does not support pinning. */
  UnsupportedPinning = 'UNSUPPORTED_PINNING'
}

/** Return type for `metafieldDefinitionDelete` mutation. */
export type MetafieldDefinitionDeletePayload = {
  __typename?: 'MetafieldDefinitionDeletePayload';
  /** The metafield definition that was deleted. */
  deletedDefinition?: Maybe<MetafieldDefinitionIdentifier>;
  /** The ID of the deleted metafield definition. */
  deletedDefinitionId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldDefinitionDeleteUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionDelete`. */
export type MetafieldDefinitionDeleteUserError = DisplayableError & {
  __typename?: 'MetafieldDefinitionDeleteUserError';
  /** The error code. */
  code?: Maybe<MetafieldDefinitionDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionDeleteUserError`. */
export enum MetafieldDefinitionDeleteUserErrorCode {
  /** Definition is managed by app configuration and cannot be modified through the API. */
  AppConfigManaged = 'APP_CONFIG_MANAGED',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** Deleting an id type metafield definition requires deletion of its associated metafields. */
  IdTypeDeletionError = 'ID_TYPE_DELETION_ERROR',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** Action cannot proceed. Definition is currently in use. */
  MetafieldDefinitionInUse = 'METAFIELD_DEFINITION_IN_USE',
  /** Definition not found. */
  NotFound = 'NOT_FOUND',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** Deleting a reference type metafield definition requires deletion of its associated metafields. */
  ReferenceTypeDeletionError = 'REFERENCE_TYPE_DELETION_ERROR',
  /** Deleting a definition in a reserved namespace requires deletion of its associated metafields. */
  ReservedNamespaceOrphanedMetafields = 'RESERVED_NAMESPACE_ORPHANED_METAFIELDS',
  /** Definition is required by an installed app and cannot be deleted. */
  StandardMetafieldDefinitionDependentOnApp = 'STANDARD_METAFIELD_DEFINITION_DEPENDENT_ON_APP'
}

/** An auto-generated type which holds one MetafieldDefinition and a cursor during pagination. */
export type MetafieldDefinitionEdge = {
  __typename?: 'MetafieldDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldDefinitionEdge. */
  node: MetafieldDefinition;
};

/** Identifies a metafield definition by its owner type, namespace, and key. */
export type MetafieldDefinitionIdentifier = {
  __typename?: 'MetafieldDefinitionIdentifier';
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
};

/** The input fields that identify metafield definitions. */
export type MetafieldDefinitionIdentifierInput = {
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['input'];
  /**
   * The container for a group of metafields that the metafield definition will be associated with. If omitted, the
   * app-reserved namespace will be used.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
};

/** The input fields required to create a metafield definition. */
export type MetafieldDefinitionInput = {
  /** The access settings that apply to each of the metafields that belong to the metafield definition. */
  access?: InputMaybe<MetafieldAccessInput>;
  /** The capabilities of the metafield definition. */
  capabilities?: InputMaybe<MetafieldCapabilityCreateInput>;
  /**
   * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
   * that determine what resources a metafield definition applies to.
   */
  constraints?: InputMaybe<MetafieldDefinitionConstraintsInput>;
  /** The description for the metafield definition. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier for the metafield definition within its namespace.
   *
   * Must be 2-64 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  key: Scalars['String']['input'];
  /** The human-readable name for the metafield definition. */
  name: Scalars['String']['input'];
  /**
   * The container for a group of metafields that the metafield definition will be associated with. If omitted, the
   * app-reserved namespace will be used.
   *
   * Must be 3-255 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The resource type that the metafield definition is attached to. */
  ownerType: MetafieldOwnerType;
  /**
   * Whether to [pin](https://help.shopify.com/manual/custom-data/metafields/pinning-metafield-definitions)
   * the metafield definition.
   */
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The type of data that each of the metafields that belong to the metafield definition will store.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  type: Scalars['String']['input'];
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  validations?: InputMaybe<Array<MetafieldDefinitionValidationInput>>;
};

/** Return type for `metafieldDefinitionPin` mutation. */
export type MetafieldDefinitionPinPayload = {
  __typename?: 'MetafieldDefinitionPinPayload';
  /** The metafield definition that was pinned. */
  pinnedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldDefinitionPinUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionPin`. */
export type MetafieldDefinitionPinUserError = DisplayableError & {
  __typename?: 'MetafieldDefinitionPinUserError';
  /** The error code. */
  code?: Maybe<MetafieldDefinitionPinUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionPinUserError`. */
export enum MetafieldDefinitionPinUserErrorCode {
  /** The metafield definition is already pinned. */
  AlreadyPinned = 'ALREADY_PINNED',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The metafield definition was not found. */
  NotFound = 'NOT_FOUND',
  /** The pinned limit has been reached for owner type. */
  PinnedLimitReached = 'PINNED_LIMIT_REACHED',
  /** The metafield definition does not support pinning. */
  UnsupportedPinning = 'UNSUPPORTED_PINNING'
}

/** Possible metafield definition pinned statuses. */
export enum MetafieldDefinitionPinnedStatus {
  /** All metafield definitions. */
  Any = 'ANY',
  /** Only metafield definitions that are pinned. */
  Pinned = 'PINNED',
  /** Only metafield definitions that are not pinned. */
  Unpinned = 'UNPINNED'
}

/** The set of valid sort keys for the MetafieldDefinition query. */
export enum MetafieldDefinitionSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `pinned_position` value. */
  PinnedPosition = 'PINNED_POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE'
}

/**
 * The type and name for the optional validation configuration of a metafield.
 *
 * For example, a supported validation might consist of a `max` name and a `number_integer` type.
 * This validation can then be used to enforce a maximum character length for a `single_line_text_field` metafield.
 */
export type MetafieldDefinitionSupportedValidation = {
  __typename?: 'MetafieldDefinitionSupportedValidation';
  /** The name of the metafield definition validation. */
  name: Scalars['String']['output'];
  /** The type of input for the validation. */
  type: Scalars['String']['output'];
};

/** A metafield definition type provides basic foundation and validation for a metafield. */
export type MetafieldDefinitionType = {
  __typename?: 'MetafieldDefinitionType';
  /** The category associated with the metafield definition type. */
  category: Scalars['String']['output'];
  /**
   * The name of the type for the metafield definition.
   * See the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  name: Scalars['String']['output'];
  /** The supported validations for a metafield definition type. */
  supportedValidations: Array<MetafieldDefinitionSupportedValidation>;
  /** Whether metafields without a definition can be migrated to a definition of this type. */
  supportsDefinitionMigrations: Scalars['Boolean']['output'];
  /**
   * The value type for a metafield created with this definition type.
   * @deprecated `valueType` is deprecated and `name` should be used for type information.
   */
  valueType: MetafieldValueType;
};

/** Return type for `metafieldDefinitionUnpin` mutation. */
export type MetafieldDefinitionUnpinPayload = {
  __typename?: 'MetafieldDefinitionUnpinPayload';
  /** The metafield definition that was unpinned. */
  unpinnedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldDefinitionUnpinUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionUnpin`. */
export type MetafieldDefinitionUnpinUserError = DisplayableError & {
  __typename?: 'MetafieldDefinitionUnpinUserError';
  /** The error code. */
  code?: Maybe<MetafieldDefinitionUnpinUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionUnpinUserError`. */
export enum MetafieldDefinitionUnpinUserErrorCode {
  /** Definition is managed by app configuration and cannot be modified through the API. */
  AppConfigManaged = 'APP_CONFIG_MANAGED',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The metafield definition was not found. */
  NotFound = 'NOT_FOUND',
  /** The metafield definition isn't pinned. */
  NotPinned = 'NOT_PINNED'
}

/** The input fields required to update a metafield definition. */
export type MetafieldDefinitionUpdateInput = {
  /** The access settings that apply to each of the metafields that belong to the metafield definition. */
  access?: InputMaybe<MetafieldAccessUpdateInput>;
  /** The capabilities of the metafield definition. */
  capabilities?: InputMaybe<MetafieldCapabilityUpdateInput>;
  /**
   * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
   * that determine what resources a metafield definition applies to.
   */
  constraintsUpdates?: InputMaybe<MetafieldDefinitionConstraintsUpdatesInput>;
  /** The description for the metafield definition. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier for the metafield definition within its namespace. Used to help identify the metafield
   * definition, but can't be updated itself.
   */
  key: Scalars['String']['input'];
  /** The human-readable name for the metafield definition. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The container for a group of metafields that the metafield definition is associated with. Used to help identify
   * the metafield definition, but can't be updated itself. If omitted, the app-reserved namespace will be used.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /**
   * The resource type that the metafield definition is attached to. Used to help identify the metafield definition,
   * but can't be updated itself.
   */
  ownerType: MetafieldOwnerType;
  /** Whether to pin the metafield definition. */
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  validations?: InputMaybe<Array<MetafieldDefinitionValidationInput>>;
};

/** Return type for `metafieldDefinitionUpdate` mutation. */
export type MetafieldDefinitionUpdatePayload = {
  __typename?: 'MetafieldDefinitionUpdatePayload';
  /** The metafield definition that was updated. */
  updatedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldDefinitionUpdateUserError>;
  /** The asynchronous job updating the metafield definition's validation_status. */
  validationJob?: Maybe<Job>;
};

/** An error that occurs during the execution of `MetafieldDefinitionUpdate`. */
export type MetafieldDefinitionUpdateUserError = DisplayableError & {
  __typename?: 'MetafieldDefinitionUpdateUserError';
  /** The error code. */
  code?: Maybe<MetafieldDefinitionUpdateUserErrorCode>;
  /** The index of the array element that's causing the error. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The key of the failing validation element. */
  elementKey?: Maybe<Scalars['String']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionUpdateUserError`. */
export enum MetafieldDefinitionUpdateUserErrorCode {
  /** Admin access can only be specified for app-owned metafield definitions. */
  AdminAccessInputNotAllowed = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** Definition is managed by app configuration and cannot be modified through the API. */
  AppConfigManaged = 'APP_CONFIG_MANAGED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The metafield definition capability cannot be disabled. */
  CapabilityCannotBeDisabled = 'CAPABILITY_CANNOT_BE_DISABLED',
  /** A capability is required for the definition type but is disabled. */
  CapabilityRequiredButDisabled = 'CAPABILITY_REQUIRED_BUT_DISABLED',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** A duplicate option. */
  DuplicateOption = 'DUPLICATE_OPTION',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The metafield definition capability is invalid. */
  InvalidCapability = 'INVALID_CAPABILITY',
  /** The metafield definition constraints are invalid. */
  InvalidConstraints = 'INVALID_CONSTRAINTS',
  /** An invalid input. */
  InvalidInput = 'INVALID_INPUT',
  /** The input combination is invalid. */
  InvalidInputCombination = 'INVALID_INPUT_COMBINATION',
  /** An invalid option. */
  InvalidOption = 'INVALID_OPTION',
  /** Action cannot proceed. Definition is currently in use. */
  MetafieldDefinitionInUse = 'METAFIELD_DEFINITION_IN_USE',
  /** You cannot change the metaobject definition pointed to by a metaobject reference metafield definition. */
  MetaobjectDefinitionChanged = 'METAOBJECT_DEFINITION_CHANGED',
  /** The metafield definition wasn't found. */
  NotFound = 'NOT_FOUND',
  /** You have reached the maximum allowed definitions for automated collections. */
  OwnerTypeLimitExceededForAutomatedCollections = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS',
  /** You have reached the maximum allowed definitions to be used as admin filters. */
  OwnerTypeLimitExceededForUseAsAdminFilters = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_USE_AS_ADMIN_FILTERS',
  /** The pinned limit has been reached for the owner type. */
  PinnedLimitReached = 'PINNED_LIMIT_REACHED',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The definition type is not eligible to be used as collection condition. */
  TypeNotAllowedForConditions = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** The metafield definition does not support pinning. */
  UnsupportedPinning = 'UNSUPPORTED_PINNING'
}

/**
 * A configured metafield definition validation.
 *
 * For example, for a metafield definition of `number_integer` type, you can set a validation with the name `max`
 * and a value of `15`. This validation will ensure that the value of the metafield is a number less than or equal to 15.
 *
 * Refer to the [list of supported validations](https://shopify.dev/docs/apps/build/metafields/list-of-validation-options).
 */
export type MetafieldDefinitionValidation = {
  __typename?: 'MetafieldDefinitionValidation';
  /** The validation name. */
  name: Scalars['String']['output'];
  /** The name for the metafield type of this validation. */
  type: Scalars['String']['output'];
  /** The validation value. */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * The name and value for a metafield definition validation.
 *
 * For example, for a metafield definition of `single_line_text_field` type, you can set a validation with the name `min` and a value of `10`.
 * This validation will ensure that the value of the metafield is at least 10 characters.
 *
 * Refer to the [list of supported validations](https://shopify.dev/docs/apps/build/metafields/list-of-validation-options).
 */
export type MetafieldDefinitionValidationInput = {
  /** The name for the metafield definition validation. */
  name: Scalars['String']['input'];
  /** The value for the metafield definition validation. */
  value: Scalars['String']['input'];
};

/** Possible metafield definition validation statuses. */
export enum MetafieldDefinitionValidationStatus {
  /** All of this definition's metafields are valid. */
  AllValid = 'ALL_VALID',
  /** Asynchronous validation of this definition's metafields is in progress. */
  InProgress = 'IN_PROGRESS',
  /** Some of this definition's metafields are invalid. */
  SomeInvalid = 'SOME_INVALID'
}

/** An auto-generated type which holds one Metafield and a cursor during pagination. */
export type MetafieldEdge = {
  __typename?: 'MetafieldEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldEdge. */
  node: Metafield;
};

/** Identifies a metafield by its owner resource, namespace, and key. */
export type MetafieldIdentifier = {
  __typename?: 'MetafieldIdentifier';
  /** The key of the metafield. */
  key: Scalars['String']['output'];
  /** The namespace of the metafield. */
  namespace: Scalars['String']['output'];
  /** GID of the owner resource that the metafield belongs to. */
  ownerId: Scalars['ID']['output'];
};

/** The input fields that identify metafields. */
export type MetafieldIdentifierInput = {
  /** The key of the metafield. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield. */
  namespace: Scalars['String']['input'];
  /** The unique ID of the resource that the metafield is attached to. */
  ownerId: Scalars['ID']['input'];
};

/**
 * The input fields to use to create or update a metafield through a mutation on the owning resource.
 * An alternative way to create or update a metafield is by using the
 * [metafieldsSet](https://shopify.dev/api/admin-graphql/latest/mutations/metafieldsSet) mutation.
 */
export type MetafieldInput = {
  /** The unique ID of the metafield. Using `namespace` and `key` is preferred for creating and updating. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The unique identifier for a metafield within its namespace.
   *
   * Required when creating a metafield, but optional when updating. Used to help identify the metafield when
   * updating, but can't be updated itself.
   *
   * Must be 2-64 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  key?: InputMaybe<Scalars['String']['input']>;
  /**
   * The container for a group of metafields that the metafield is or will be associated with. Used in tandem with
   * `key` to lookup a metafield on a resource, preventing conflicts with other metafields with the same `key`.
   *
   * Required when creating a metafield, but optional when updating. Used to help identify the metafield when
   * updating, but can't be updated itself.
   *
   * Must be 3-255 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /**
   * The type of data that's stored in the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   *
   * Required when creating or updating a metafield without a definition.
   */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Possible types of a metafield's owner resource. */
export enum MetafieldOwnerType {
  /** The Api Permission metafield owner type. */
  ApiPermission = 'API_PERMISSION',
  /** The Article metafield owner type. */
  Article = 'ARTICLE',
  /** The Blog metafield owner type. */
  Blog = 'BLOG',
  /** The Cart Transform metafield owner type. */
  Carttransform = 'CARTTRANSFORM',
  /** The Collection metafield owner type. */
  Collection = 'COLLECTION',
  /** The Company metafield owner type. */
  Company = 'COMPANY',
  /** The Company Location metafield owner type. */
  CompanyLocation = 'COMPANY_LOCATION',
  /** The Customer metafield owner type. */
  Customer = 'CUSTOMER',
  /** The Delivery Customization metafield owner type. */
  DeliveryCustomization = 'DELIVERY_CUSTOMIZATION',
  /** The Discount metafield owner type. */
  Discount = 'DISCOUNT',
  /** The draft order metafield owner type. */
  Draftorder = 'DRAFTORDER',
  /** The Fulfillment Constraint Rule metafield owner type. */
  FulfillmentConstraintRule = 'FULFILLMENT_CONSTRAINT_RULE',
  /** The GiftCardTransaction metafield owner type. */
  GiftCardTransaction = 'GIFT_CARD_TRANSACTION',
  /** The Location metafield owner type. */
  Location = 'LOCATION',
  /** The Market metafield owner type. */
  Market = 'MARKET',
  /**
   * The Media Image metafield owner type.
   * @deprecated `MEDIA_IMAGE` is deprecated.
   */
  MediaImage = 'MEDIA_IMAGE',
  /** The Order metafield owner type. */
  Order = 'ORDER',
  /** The Order Routing Location Rule metafield owner type. */
  OrderRoutingLocationRule = 'ORDER_ROUTING_LOCATION_RULE',
  /** The Page metafield owner type. */
  Page = 'PAGE',
  /** The Payment Customization metafield owner type. */
  PaymentCustomization = 'PAYMENT_CUSTOMIZATION',
  /** The Product metafield owner type. */
  Product = 'PRODUCT',
  /** The Product Variant metafield owner type. */
  Productvariant = 'PRODUCTVARIANT',
  /** The Selling Plan metafield owner type. */
  SellingPlan = 'SELLING_PLAN',
  /** The Shop metafield owner type. */
  Shop = 'SHOP',
  /** The Transfer metafield owner type. */
  Transfer = 'TRANSFER',
  /** The Validation metafield owner type. */
  Validation = 'VALIDATION'
}

/** The resource referenced by the metafield value. */
export type MetafieldReference = Article | Collection | Company | Customer | GenericFile | MediaImage | Metaobject | Model3d | Order | Page | Product | ProductVariant | TaxonomyValue | Video;

/** An auto-generated type for paginating through multiple MetafieldReferences. */
export type MetafieldReferenceConnection = {
  __typename?: 'MetafieldReferenceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetafieldReferenceEdge>;
  /** A list of nodes that are contained in MetafieldReferenceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Maybe<MetafieldReference>>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldReference and a cursor during pagination. */
export type MetafieldReferenceEdge = {
  __typename?: 'MetafieldReferenceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldReferenceEdge. */
  node?: Maybe<MetafieldReference>;
};

/** Types of resources that may use metafields to reference other resources. */
export type MetafieldReferencer = AppInstallation | Article | Blog | Collection | Company | CompanyLocation | Customer | DeliveryCustomization | DiscountAutomaticNode | DiscountCodeNode | DiscountNode | DraftOrder | FulfillmentOrder | Location | Market | Metaobject | Order | Page | PaymentCustomization | Product | ProductVariant | Shop;

/**
 * Defines a relation between two resources via a reference metafield.
 * The referencer owns the joining field with a given namespace and key,
 * while the target is referenced by the field.
 */
export type MetafieldRelation = {
  __typename?: 'MetafieldRelation';
  /** The key of the field making the reference. */
  key: Scalars['String']['output'];
  /** The name of the field making the reference. */
  name: Scalars['String']['output'];
  /** The namespace of the metafield making the reference, or type of the metaobject. */
  namespace: Scalars['String']['output'];
  /** The resource making the reference. */
  referencer: MetafieldReferencer;
  /**
   * The referenced resource.
   * @deprecated No longer supported. Access the object directly instead.
   */
  target: MetafieldReference;
};

/** An auto-generated type for paginating through multiple MetafieldRelations. */
export type MetafieldRelationConnection = {
  __typename?: 'MetafieldRelationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetafieldRelationEdge>;
  /** A list of nodes that are contained in MetafieldRelationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MetafieldRelation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldRelation and a cursor during pagination. */
export type MetafieldRelationEdge = {
  __typename?: 'MetafieldRelationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldRelationEdge. */
  node: MetafieldRelation;
};

/** Metafield access permissions for the Storefront API. */
export enum MetafieldStorefrontAccess {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  PublicRead = 'PUBLIC_READ'
}

/** Metafield access permissions for the Storefront API. */
export enum MetafieldStorefrontAccessInput {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  PublicRead = 'PUBLIC_READ'
}

/** Possible metafield validation statuses. */
export enum MetafieldValidationStatus {
  /** Any validation status (valid or invalid). */
  Any = 'ANY',
  /** Invalid (according to definition). */
  Invalid = 'INVALID',
  /** Valid (according to definition). */
  Valid = 'VALID'
}

/**
 * Legacy type information for the stored value.
 * Replaced by `type`.
 */
export enum MetafieldValueType {
  /** A `true` or `false` value. */
  Boolean = 'BOOLEAN',
  /** A whole number. */
  Integer = 'INTEGER',
  /** A JSON string. */
  JsonString = 'JSON_STRING',
  /** A text field. */
  String = 'STRING'
}

/** Return type for `metafieldsDelete` mutation. */
export type MetafieldsDeletePayload = {
  __typename?: 'MetafieldsDeletePayload';
  /** List of metafield identifiers that were deleted, null if the corresponding metafield isn't found. */
  deletedMetafields?: Maybe<Array<Maybe<MetafieldIdentifier>>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for a metafield value to set. */
export type MetafieldsSetInput = {
  /** The `compareDigest` value obtained from a previous query. Provide this with updates to ensure the metafield is modified safely. */
  compareDigest?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier for a metafield within its namespace.
   *
   * Must be 2-64 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  key: Scalars['String']['input'];
  /**
   * The container for a group of metafields that the metafield is or will be associated with. Used in tandem
   * with `key` to lookup a metafield on a resource, preventing conflicts with other metafields with the
   * same `key`. If omitted the app-reserved namespace will be used.
   *
   * Must be 3-255 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID of the resource that the metafield is attached to. */
  ownerId: Scalars['ID']['input'];
  /**
   * The type of data that's stored in the metafield.
   * The type must be one of the [supported types](https://shopify.dev/apps/metafields/types).
   *
   * Required when there's no corresponding definition for the given `namespace`, `key`, and
   * owner resource type (derived from `ownerId`).
   */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  value: Scalars['String']['input'];
};

/** Return type for `metafieldsSet` mutation. */
export type MetafieldsSetPayload = {
  __typename?: 'MetafieldsSetPayload';
  /** The list of metafields that were set. */
  metafields?: Maybe<Array<Metafield>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetafieldsSetUserError>;
};

/** An error that occurs during the execution of `MetafieldsSet`. */
export type MetafieldsSetUserError = DisplayableError & {
  __typename?: 'MetafieldsSetUserError';
  /** The error code. */
  code?: Maybe<MetafieldsSetUserErrorCode>;
  /** The index of the array element that's causing the error. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldsSetUserError`. */
export enum MetafieldsSetUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  AppNotAuthorized = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The compareDigest is invalid. */
  InvalidCompareDigest = 'INVALID_COMPARE_DIGEST',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The metafield has been modified since it was loaded. */
  StaleObject = 'STALE_OBJECT',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT'
}

/**
 * An instance of custom structured data defined by a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition). [Metaobjects](https://shopify.dev/docs/apps/build/custom-data#what-are-metaobjects) store reusable data that extends beyond Shopify's standard resources, such as product highlights, size charts, or custom content sections.
 *
 * Each metaobject includes fields that match the field types and validation rules specified in its definition, which also determines the metaobject's capabilities, such as storefront visibility, publishing and translation support. [`Metafields`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) can reference metaobjects to connect custom data with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects, [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects, and other Shopify resources.
 */
export type Metaobject = Node & {
  __typename?: 'Metaobject';
  /** Metaobject capabilities for this Metaobject. */
  capabilities: MetaobjectCapabilityData;
  /** When the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The app used to create the object. */
  createdBy: App;
  /** The app used to create the object. */
  createdByApp: App;
  /** The staff member who created the metaobject. */
  createdByStaff?: Maybe<StaffMember>;
  /** The MetaobjectDefinition that models this object type. */
  definition: MetaobjectDefinition;
  /** The preferred display name field value of the metaobject. */
  displayName: Scalars['String']['output'];
  /** The field for an object key, or null if the key has no field definition. */
  field?: Maybe<MetaobjectField>;
  /** All ordered fields of the metaobject with their definitions and values. */
  fields: Array<MetaobjectField>;
  /** The unique handle of the object, useful as a custom ID. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** List of back references metafields that belong to the resource. */
  referencedBy: MetafieldRelationConnection;
  /**
   * The staff member who created the metaobject.
   * @deprecated Use `createdByStaff` instead.
   */
  staffMember?: Maybe<StaffMember>;
  /** The recommended field to visually represent this metaobject. May be a file reference or color         field. */
  thumbnailField?: Maybe<MetaobjectField>;
  /** The type of the metaobject. */
  type: Scalars['String']['output'];
  /** When the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The values of the metaobject. */
  values: Scalars['JSON']['output'];
};


/**
 * An instance of custom structured data defined by a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition). [Metaobjects](https://shopify.dev/docs/apps/build/custom-data#what-are-metaobjects) store reusable data that extends beyond Shopify's standard resources, such as product highlights, size charts, or custom content sections.
 *
 * Each metaobject includes fields that match the field types and validation rules specified in its definition, which also determines the metaobject's capabilities, such as storefront visibility, publishing and translation support. [`Metafields`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) can reference metaobjects to connect custom data with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects, [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects, and other Shopify resources.
 */
export type MetaobjectFieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * An instance of custom structured data defined by a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition). [Metaobjects](https://shopify.dev/docs/apps/build/custom-data#what-are-metaobjects) store reusable data that extends beyond Shopify's standard resources, such as product highlights, size charts, or custom content sections.
 *
 * Each metaobject includes fields that match the field types and validation rules specified in its definition, which also determines the metaobject's capabilities, such as storefront visibility, publishing and translation support. [`Metafields`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) can reference metaobjects to connect custom data with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects, [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects, and other Shopify resources.
 */
export type MetaobjectReferencedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Access permissions for the definition's metaobjects. */
export type MetaobjectAccess = {
  __typename?: 'MetaobjectAccess';
  /** The access permitted on the Admin API. */
  admin: MetaobjectAdminAccess;
  /** The access permitted on the Customer Account API. */
  customerAccount: MetaobjectCustomerAccountAccess;
  /** The access permitted on the Storefront API. */
  storefront: MetaobjectStorefrontAccess;
};

/** The input fields that set access permissions for the definition's metaobjects. */
export type MetaobjectAccessInput = {
  /** The access permitted on the Admin API. */
  admin?: InputMaybe<MetaobjectAdminAccessInput>;
  /** The access permitted on the Customer Account API. */
  customerAccount?: InputMaybe<MetaobjectCustomerAccountAccess>;
  /** The access permitted on the Storefront API. */
  storefront?: InputMaybe<MetaobjectStorefrontAccess>;
};

/**
 * Metaobject access permissions for the Admin API. When the metaobject is app-owned, the owning app always has
 * full access.
 */
export enum MetaobjectAdminAccess {
  /** The merchant has read-only access. No other apps have access. */
  MerchantRead = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MerchantReadWrite = 'MERCHANT_READ_WRITE',
  /**
   * The merchant and other apps have no access.
   * @deprecated Use MERCHANT_READ instead. Removed in API version 2027-01.
   */
  Private = 'PRIVATE',
  /**
   * The merchant and other apps have read-only access.
   * @deprecated Use MERCHANT_READ instead. Removed in API version 2027-01.
   */
  PublicRead = 'PUBLIC_READ',
  /** The merchant and other apps have read and write access. */
  PublicReadWrite = 'PUBLIC_READ_WRITE'
}

/**
 * Metaobject access permissions for the Admin API. When the metaobject is app-owned, the owning app always has
 * full access.
 */
export enum MetaobjectAdminAccessInput {
  /** The merchant has read-only access. No other apps have access. */
  MerchantRead = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MerchantReadWrite = 'MERCHANT_READ_WRITE'
}

/** Return type for `metaobjectBulkDelete` mutation. */
export type MetaobjectBulkDeletePayload = {
  __typename?: 'MetaobjectBulkDeletePayload';
  /** The asynchronous job that deletes the metaobjects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/**
 * Specifies the condition by which metaobjects are deleted.
 * Exactly one field of input is required.
 */
export type MetaobjectBulkDeleteWhereCondition = {
  /** A list of metaobjects IDs to delete. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Deletes all metaobjects with the specified `type`. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Provides the capabilities of a metaobject definition. */
export type MetaobjectCapabilities = {
  __typename?: 'MetaobjectCapabilities';
  /** Indicates whether a metaobject definition can be displayed as a page on the Online Store. */
  onlineStore?: Maybe<MetaobjectCapabilitiesOnlineStore>;
  /** Indicate whether a metaobject definition is publishable. */
  publishable: MetaobjectCapabilitiesPublishable;
  /** Indicate whether a metaobject definition is renderable and exposes SEO data. */
  renderable?: Maybe<MetaobjectCapabilitiesRenderable>;
  /** Indicate whether a metaobject definition is translatable. */
  translatable: MetaobjectCapabilitiesTranslatable;
};

/** The Online Store capability of a metaobject definition. */
export type MetaobjectCapabilitiesOnlineStore = {
  __typename?: 'MetaobjectCapabilitiesOnlineStore';
  /** The data associated with the Online Store capability. */
  data?: Maybe<MetaobjectCapabilityDefinitionDataOnlineStore>;
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The publishable capability of a metaobject definition. */
export type MetaobjectCapabilitiesPublishable = {
  __typename?: 'MetaobjectCapabilitiesPublishable';
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The renderable capability of a metaobject definition. */
export type MetaobjectCapabilitiesRenderable = {
  __typename?: 'MetaobjectCapabilitiesRenderable';
  /** The data associated with the renderable capability. */
  data?: Maybe<MetaobjectCapabilityDefinitionDataRenderable>;
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The translatable capability of a metaobject definition. */
export type MetaobjectCapabilitiesTranslatable = {
  __typename?: 'MetaobjectCapabilitiesTranslatable';
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for creating a metaobject capability. */
export type MetaobjectCapabilityCreateInput = {
  /** The input for enabling the Online Store capability. */
  onlineStore?: InputMaybe<MetaobjectCapabilityOnlineStoreInput>;
  /** The input for enabling the publishable capability. */
  publishable?: InputMaybe<MetaobjectCapabilityPublishableInput>;
  /** The input for enabling the renderable capability. */
  renderable?: InputMaybe<MetaobjectCapabilityRenderableInput>;
  /** The input for enabling the translatable capability. */
  translatable?: InputMaybe<MetaobjectCapabilityTranslatableInput>;
};

/** Provides the capabilities of a metaobject. */
export type MetaobjectCapabilityData = {
  __typename?: 'MetaobjectCapabilityData';
  /** The Online Store capability for this metaobject. */
  onlineStore?: Maybe<MetaobjectCapabilityDataOnlineStore>;
  /** The publishable capability for this metaobject. */
  publishable?: Maybe<MetaobjectCapabilityDataPublishable>;
};

/** The input fields for metaobject capabilities. */
export type MetaobjectCapabilityDataInput = {
  /** Online Store capability input. */
  onlineStore?: InputMaybe<MetaobjectCapabilityDataOnlineStoreInput>;
  /** Publishable capability input. */
  publishable?: InputMaybe<MetaobjectCapabilityDataPublishableInput>;
};

/** The Online Store capability for the parent metaobject. */
export type MetaobjectCapabilityDataOnlineStore = {
  __typename?: 'MetaobjectCapabilityDataOnlineStore';
  /** The theme template used when viewing the metaobject in a store. */
  templateSuffix?: Maybe<Scalars['String']['output']>;
};

/** The input fields for the Online Store capability to control renderability on the Online Store. */
export type MetaobjectCapabilityDataOnlineStoreInput = {
  /** The theme template used when viewing the metaobject in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** The publishable capability for the parent metaobject. */
export type MetaobjectCapabilityDataPublishable = {
  __typename?: 'MetaobjectCapabilityDataPublishable';
  /** The visibility status of this metaobject across all channels. */
  status: MetaobjectStatus;
};

/** The input fields for publishable capability to adjust visibility on channels. */
export type MetaobjectCapabilityDataPublishableInput = {
  /** The visibility status of this metaobject across all channels. */
  status: MetaobjectStatus;
};

/** The Online Store capability data for the metaobject definition. */
export type MetaobjectCapabilityDefinitionDataOnlineStore = {
  __typename?: 'MetaobjectCapabilityDefinitionDataOnlineStore';
  /** Flag indicating if a sufficient number of redirects are available to redirect all published entries. */
  canCreateRedirects: Scalars['Boolean']['output'];
  /** The URL handle for accessing pages of this metaobject type in the Online Store. */
  urlHandle: Scalars['String']['output'];
};

/** The input fields of the Online Store capability. */
export type MetaobjectCapabilityDefinitionDataOnlineStoreInput = {
  /** Whether to redirect published metaobjects automatically when the URL handle changes. */
  createRedirects?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL handle for accessing pages of this metaobject type in the Online Store. */
  urlHandle: Scalars['String']['input'];
};

/** The renderable capability data for the metaobject definition. */
export type MetaobjectCapabilityDefinitionDataRenderable = {
  __typename?: 'MetaobjectCapabilityDefinitionDataRenderable';
  /** The metaobject field used as an alias for the SEO page description. */
  metaDescriptionKey?: Maybe<Scalars['String']['output']>;
  /** The metaobject field used as an alias for the SEO page title. */
  metaTitleKey?: Maybe<Scalars['String']['output']>;
};

/** The input fields of the renderable capability for SEO aliases. */
export type MetaobjectCapabilityDefinitionDataRenderableInput = {
  /** The metaobject field used as an alias for the SEO page description. */
  metaDescriptionKey?: InputMaybe<Scalars['String']['input']>;
  /** The metaobject field used as an alias for the SEO page title. */
  metaTitleKey?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for enabling and disabling the Online Store capability. */
export type MetaobjectCapabilityOnlineStoreInput = {
  /** The data associated with the Online Store capability. */
  data?: InputMaybe<MetaobjectCapabilityDefinitionDataOnlineStoreInput>;
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The input fields for enabling and disabling the publishable capability. */
export type MetaobjectCapabilityPublishableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The input fields for enabling and disabling the renderable capability. */
export type MetaobjectCapabilityRenderableInput = {
  /** The data associated with the renderable capability. */
  data?: InputMaybe<MetaobjectCapabilityDefinitionDataRenderableInput>;
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** The input fields for enabling and disabling the translatable capability. */
export type MetaobjectCapabilityTranslatableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/** Metaobject Capabilities types which can be enabled. */
export enum MetaobjectCapabilityType {
  /** Allows for a Metaobject to be rendered as an Online Store page. */
  OnlineStore = 'ONLINE_STORE',
  /** Allows for a Metaobject to be conditionally publishable. */
  Publishable = 'PUBLISHABLE',
  /** Allows for a Metaobject to have attributes of a renderable page such as SEO. */
  Renderable = 'RENDERABLE',
  /** Allows for a Metaobject to be translated using the translation api. */
  Translatable = 'TRANSLATABLE'
}

/** The input fields for updating a metaobject capability. */
export type MetaobjectCapabilityUpdateInput = {
  /** The input for enabling the Online Store capability. */
  onlineStore?: InputMaybe<MetaobjectCapabilityOnlineStoreInput>;
  /** The input for updating the publishable capability. */
  publishable?: InputMaybe<MetaobjectCapabilityPublishableInput>;
  /** The input for enabling the renderable capability. */
  renderable?: InputMaybe<MetaobjectCapabilityRenderableInput>;
  /** The input for updating the translatable capability. */
  translatable?: InputMaybe<MetaobjectCapabilityTranslatableInput>;
};

/** An auto-generated type for paginating through multiple Metaobjects. */
export type MetaobjectConnection = {
  __typename?: 'MetaobjectConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetaobjectEdge>;
  /** A list of nodes that are contained in MetaobjectEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Metaobject>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a metaobject. */
export type MetaobjectCreateInput = {
  /** Capabilities for the metaobject. */
  capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  fields?: InputMaybe<Array<MetaobjectFieldInput>>;
  /** A unique handle for the metaobject. This value is auto-generated when omitted. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The type of the metaobject. Must match an existing metaobject definition type. */
  type: Scalars['String']['input'];
  /** The field values for the metaobject as a JSON object, keyed by field definition key. Cannot be used in conjunction with `fields`. */
  values?: InputMaybe<Scalars['JSON']['input']>;
};

/** Return type for `metaobjectCreate` mutation. */
export type MetaobjectCreatePayload = {
  __typename?: 'MetaobjectCreatePayload';
  /** The created metaobject. */
  metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** Metaobject access permissions for the Customer Account API. */
export enum MetaobjectCustomerAccountAccess {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  Read = 'READ'
}

/**
 * Defines the structure and configuration for a custom data type in Shopify. Each definition specifies the fields, validation rules, and capabilities that apply to all [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) entries created from it.
 *
 * The definition includes field definitions that determine what data to store, access controls for [the Shopify admin](https://shopify.dev/docs/apps/build/custom-data/permissions#admin-permissions) and [Storefront](https://shopify.dev/docs/apps/build/custom-data/permissions#storefront-permissions) APIs, and capabilities such as publishability and translatability. You can track which [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) or [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) created the definition and optionally base it on a [`StandardMetaobjectDefinitionTemplate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StandardMetaobjectDefinitionTemplate).
 */
export type MetaobjectDefinition = Node & {
  __typename?: 'MetaobjectDefinition';
  /** Access configuration for the metaobject definition. */
  access: MetaobjectAccess;
  /** The capabilities of the metaobject definition. */
  capabilities: MetaobjectCapabilities;
  /** The date and time when the metaobject definition was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The app used to create the metaobject definition. */
  createdByApp: App;
  /** The staff member who created the metaobject definition. */
  createdByStaff?: Maybe<StaffMember>;
  /** The administrative description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The key of a field to reference as the display name for each object. */
  displayNameKey?: Maybe<Scalars['String']['output']>;
  /** The fields defined for this object type. */
  fieldDefinitions: Array<MetaobjectFieldDefinition>;
  /** Whether this metaobject definition has field whose type can visually represent a metaobject with        the `thumbnailField`. */
  hasThumbnailField: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A paginated connection to the metaobjects associated with the definition. */
  metaobjects: MetaobjectConnection;
  /** The count of metaobjects created for the definition. */
  metaobjectsCount: Scalars['Int']['output'];
  /** The human-readable name. */
  name: Scalars['String']['output'];
  /** The standard metaobject template associated with the definition. */
  standardTemplate?: Maybe<StandardMetaobjectDefinitionTemplate>;
  /** The type of the object definition. Defines the namespace of associated metafields. */
  type: Scalars['String']['output'];
  /** The date and time when the metaobject definition was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * Defines the structure and configuration for a custom data type in Shopify. Each definition specifies the fields, validation rules, and capabilities that apply to all [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) entries created from it.
 *
 * The definition includes field definitions that determine what data to store, access controls for [the Shopify admin](https://shopify.dev/docs/apps/build/custom-data/permissions#admin-permissions) and [Storefront](https://shopify.dev/docs/apps/build/custom-data/permissions#storefront-permissions) APIs, and capabilities such as publishability and translatability. You can track which [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) or [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) created the definition and optionally base it on a [`StandardMetaobjectDefinitionTemplate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StandardMetaobjectDefinitionTemplate).
 */
export type MetaobjectDefinitionMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple MetaobjectDefinitions. */
export type MetaobjectDefinitionConnection = {
  __typename?: 'MetaobjectDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MetaobjectDefinitionEdge>;
  /** A list of nodes that are contained in MetaobjectDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MetaobjectDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a metaobject definition. */
export type MetaobjectDefinitionCreateInput = {
  /** Access configuration for the metaobjects created with this definition. */
  access?: InputMaybe<MetaobjectAccessInput>;
  /** The capabilities of the metaobject definition. */
  capabilities?: InputMaybe<MetaobjectCapabilityCreateInput>;
  /** An administrative description of the definition. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key of a field to reference as the display name for metaobjects of this type. */
  displayNameKey?: InputMaybe<Scalars['String']['input']>;
  /** A set of field definitions to create on this metaobject definition. */
  fieldDefinitions?: InputMaybe<Array<MetaobjectFieldDefinitionCreateInput>>;
  /** A human-readable name for the definition. This can be changed at any time. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The type of the metaobject definition. This can't be changed.
   *
   * Must be 3-255 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  type: Scalars['String']['input'];
};

/** Return type for `metaobjectDefinitionCreate` mutation. */
export type MetaobjectDefinitionCreatePayload = {
  __typename?: 'MetaobjectDefinitionCreatePayload';
  /** The created metaobject definition. */
  metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** Return type for `metaobjectDefinitionDelete` mutation. */
export type MetaobjectDefinitionDeletePayload = {
  __typename?: 'MetaobjectDefinitionDeletePayload';
  /** The ID of the deleted metaobjects definition. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** An auto-generated type which holds one MetaobjectDefinition and a cursor during pagination. */
export type MetaobjectDefinitionEdge = {
  __typename?: 'MetaobjectDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetaobjectDefinitionEdge. */
  node: MetaobjectDefinition;
};

/** The input fields for updating a metaobject definition. */
export type MetaobjectDefinitionUpdateInput = {
  /** Access configuration for the metaobjects created with this definition. */
  access?: InputMaybe<MetaobjectAccessInput>;
  /** The capabilities of the metaobject definition. */
  capabilities?: InputMaybe<MetaobjectCapabilityUpdateInput>;
  /** An administrative description of the definition. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key of a metafield to reference as the display name for objects of this type. */
  displayNameKey?: InputMaybe<Scalars['String']['input']>;
  /** A set of operations for modifying field definitions. */
  fieldDefinitions?: InputMaybe<Array<MetaobjectFieldDefinitionOperationInput>>;
  /** A human-readable name for the definition. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the field order should be reset while updating.
   * If `true`, then the order is assigned based on submitted fields followed by alphabetized field omissions.
   * If `false`, then no changes are made to the existing field order and new fields are appended at the end.
   */
  resetFieldOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `metaobjectDefinitionUpdate` mutation. */
export type MetaobjectDefinitionUpdatePayload = {
  __typename?: 'MetaobjectDefinitionUpdatePayload';
  /** The updated metaobject definition. */
  metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** Return type for `metaobjectDelete` mutation. */
export type MetaobjectDeletePayload = {
  __typename?: 'MetaobjectDeletePayload';
  /** The ID of the deleted metaobject. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** An auto-generated type which holds one Metaobject and a cursor during pagination. */
export type MetaobjectEdge = {
  __typename?: 'MetaobjectEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetaobjectEdge. */
  node: Metaobject;
};

/** Provides a field definition and the data value assigned to it. */
export type MetaobjectField = {
  __typename?: 'MetaobjectField';
  /** The field definition for this object key. */
  definition: MetaobjectFieldDefinition;
  /** The assigned field value in JSON format. */
  jsonValue?: Maybe<Scalars['JSON']['output']>;
  /** The object key of this field. */
  key: Scalars['String']['output'];
  /** For resource reference fields, provides the referenced object. */
  reference?: Maybe<MetafieldReference>;
  /** For resource reference list fields, provides the list of referenced objects. */
  references?: Maybe<MetafieldReferenceConnection>;
  /** For file reference or color fields, provides visual attributes for this field. */
  thumbnail?: Maybe<MetaobjectThumbnail>;
  /** The type of the field. */
  type: Scalars['String']['output'];
  /** The assigned field value, always stored as a string regardless of the field type. */
  value?: Maybe<Scalars['String']['output']>;
};


/** Provides a field definition and the data value assigned to it. */
export type MetaobjectFieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Information about the admin filterable capability. */
export type MetaobjectFieldCapabilityAdminFilterable = {
  __typename?: 'MetaobjectFieldCapabilityAdminFilterable';
  /** Indicates if the definition is eligible to have the capability. */
  eligible: Scalars['Boolean']['output'];
  /** Indicates if the capability is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** The input fields for enabling and disabling the admin filterable capability. */
export type MetaobjectFieldCapabilityAdminFilterableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  enabled: Scalars['Boolean']['input'];
};

/**
 * Defines a field for a MetaobjectDefinition with properties
 * such as the field's data type and validations.
 */
export type MetaobjectFieldDefinition = {
  __typename?: 'MetaobjectFieldDefinition';
  /** Capabilities available for this metaobject field definition. */
  capabilities: MetaobjectFieldDefinitionCapabilities;
  /** The administrative description. */
  description?: Maybe<Scalars['String']['output']>;
  /** A key name used to identify the field within the metaobject composition. */
  key: Scalars['String']['output'];
  /** The human-readable name. */
  name: Scalars['String']['output'];
  /** Required status of the field within the metaobject composition. */
  required: Scalars['Boolean']['output'];
  /** The type of data that the field stores. */
  type: MetafieldDefinitionType;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the field. For example, a field with the type `date` can set a minimum date requirement.
   */
  validations: Array<MetafieldDefinitionValidation>;
};

/** Capabilities available for a metaobject field definition. */
export type MetaobjectFieldDefinitionCapabilities = {
  __typename?: 'MetaobjectFieldDefinitionCapabilities';
  /** Indicate whether a metaobject field definition is configured for filtering. */
  adminFilterable: MetaobjectFieldCapabilityAdminFilterable;
};

/** The input fields for creating capabilities on a metaobject field definition. */
export type MetaobjectFieldDefinitionCapabilityCreateInput = {
  /** The input for configuring the admin filterable capability. */
  adminFilterable?: InputMaybe<MetaobjectFieldCapabilityAdminFilterableInput>;
};

/** The input fields for creating a metaobject field definition. */
export type MetaobjectFieldDefinitionCreateInput = {
  /** Capabilities configuration for this field. */
  capabilities?: InputMaybe<MetaobjectFieldDefinitionCapabilityCreateInput>;
  /** An administrative description of the field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The key of the new field definition. This can't be changed.
   *
   * Must be 2-64 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  key: Scalars['String']['input'];
  /** A human-readable name for the field. This can be changed at any time. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether metaobjects require a saved value for the field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** The metafield type applied to values of the field. */
  type: Scalars['String']['input'];
  /** Custom validations that apply to values assigned to the field. */
  validations?: InputMaybe<Array<MetafieldDefinitionValidationInput>>;
};

/** The input fields for deleting a metaobject field definition. */
export type MetaobjectFieldDefinitionDeleteInput = {
  /** The key of the field definition to delete. */
  key: Scalars['String']['input'];
};

/** The input fields for possible operations for modifying field definitions. Exactly one option is required. */
export type MetaobjectFieldDefinitionOperationInput = {
  /** The input fields for creating a metaobject field definition. */
  create?: InputMaybe<MetaobjectFieldDefinitionCreateInput>;
  /** The input fields for deleting a metaobject field definition. */
  delete?: InputMaybe<MetaobjectFieldDefinitionDeleteInput>;
  /** The input fields for updating a metaobject field definition. */
  update?: InputMaybe<MetaobjectFieldDefinitionUpdateInput>;
};

/** The input fields for updating a metaobject field definition. */
export type MetaobjectFieldDefinitionUpdateInput = {
  /** Capabilities configuration for this field. */
  capabilities?: InputMaybe<MetaobjectFieldDefinitionCapabilityCreateInput>;
  /** An administrative description of the field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key of the field definition to update. */
  key: Scalars['String']['input'];
  /** A human-readable name for the field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether metaobjects require a saved value for the field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom validations that apply to values assigned to the field. */
  validations?: InputMaybe<Array<MetafieldDefinitionValidationInput>>;
};

/** The input fields for a metaobject field value. */
export type MetaobjectFieldInput = {
  /** The key of the field. */
  key: Scalars['String']['input'];
  /** The value of the field. */
  value: Scalars['String']['input'];
};

/** The input fields for retrieving a metaobject by handle. */
export type MetaobjectHandleInput = {
  /** The handle of the metaobject to create or update. */
  handle: Scalars['String']['input'];
  /** The type of the metaobject. Must match an existing metaobject definition type. */
  type: Scalars['String']['input'];
};

/** Defines visibility status for metaobjects. */
export enum MetaobjectStatus {
  /** The metaobjects is active for public use. */
  Active = 'ACTIVE',
  /** The metaobjects is an internal record. */
  Draft = 'DRAFT'
}

/** Metaobject access permissions for the Storefront API. */
export enum MetaobjectStorefrontAccess {
  /** No access. */
  None = 'NONE',
  /** Read-only access. */
  PublicRead = 'PUBLIC_READ'
}

/** Provides attributes for visual representation. */
export type MetaobjectThumbnail = {
  __typename?: 'MetaobjectThumbnail';
  /** The file to be used for visual representation of this metaobject. */
  file?: Maybe<File>;
  /** The hexadecimal color code to be used for respresenting this metaobject. */
  hex?: Maybe<Scalars['String']['output']>;
};

/** The input fields for updating a metaobject. */
export type MetaobjectUpdateInput = {
  /** Capabilities for the metaobject. */
  capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  fields?: InputMaybe<Array<MetaobjectFieldInput>>;
  /** A unique handle for the metaobject. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether to create a redirect for the metaobject. */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The field values for the metaobject as a JSON object, keyed by field definition key. This is a full replacement — omitted keys are cleared on an existing record. Cannot be used in conjunction with `fields`. */
  values?: InputMaybe<Scalars['JSON']['input']>;
};

/** Return type for `metaobjectUpdate` mutation. */
export type MetaobjectUpdatePayload = {
  __typename?: 'MetaobjectUpdatePayload';
  /** The updated metaobject. */
  metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** The input fields for upserting a metaobject. */
export type MetaobjectUpsertInput = {
  /** Capabilities for the metaobject. */
  capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  fields?: InputMaybe<Array<MetaobjectFieldInput>>;
  /** The handle of the metaobject. */
  handle?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `metaobjectUpsert` mutation. */
export type MetaobjectUpsertPayload = {
  __typename?: 'MetaobjectUpsertPayload';
  /** The created or updated metaobject. */
  metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** Defines errors encountered while managing metaobject resources. */
export type MetaobjectUserError = DisplayableError & {
  __typename?: 'MetaobjectUserError';
  /** The error code. */
  code?: Maybe<MetaobjectUserErrorCode>;
  /** The index of the failing list element in an array. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The key of the failing object element. */
  elementKey?: Maybe<Scalars['String']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetaobjectUserError`. */
export enum MetaobjectUserErrorCode {
  /** Admin access can only be specified on metaobject definitions that have an app-reserved type. */
  AdminAccessInputNotAllowed = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** Definition is managed by app configuration and cannot be modified through the API. */
  AppConfigManaged = 'APP_CONFIG_MANAGED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The capability you are using is not enabled. */
  CapabilityNotEnabled = 'CAPABILITY_NOT_ENABLED',
  /** The display name cannot be the same when using the metaobject as a product option. */
  DisplayNameConflict = 'DISPLAY_NAME_CONFLICT',
  /** Duplicate inputs were provided for this field key. */
  DuplicateFieldInput = 'DUPLICATE_FIELD_INPUT',
  /** Renderable data input is referencing an invalid field. */
  FieldTypeInvalid = 'FIELD_TYPE_INVALID',
  /** The targeted object cannot be modified. */
  Immutable = 'IMMUTABLE',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The maximum number of input metaobjects has been exceeded. */
  InputLimitExceeded = 'INPUT_LIMIT_EXCEEDED',
  /** An unexpected error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The value for the metafield definition option was invalid. */
  InvalidOption = 'INVALID_OPTION',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The maximum number of metaobjects definitions has been exceeded. */
  MaxDefinitionsExceeded = 'MAX_DEFINITIONS_EXCEEDED',
  /** The maximum number of metaobjects per shop has been exceeded. */
  MaxObjectsExceeded = 'MAX_OBJECTS_EXCEEDED',
  /** The input is missing required keys. */
  MissingRequiredKeys = 'MISSING_REQUIRED_KEYS',
  /** Not authorized. */
  NotAuthorized = 'NOT_AUTHORIZED',
  /** Missing required fields were found for this object. */
  ObjectFieldRequired = 'OBJECT_FIELD_REQUIRED',
  /** The specified field key is already in use. */
  ObjectFieldTaken = 'OBJECT_FIELD_TAKEN',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The requested record couldn't be found. */
  RecordNotFound = 'RECORD_NOT_FOUND',
  /** The action cannot be completed because associated metaobjects are referenced by another resource. */
  ReferenceExistsError = 'REFERENCE_EXISTS_ERROR',
  /** The provided name is reserved for system use. */
  ReservedName = 'RESERVED_NAME',
  /** Definition is required by an installed app and cannot be deleted. */
  StandardMetaobjectDefinitionDependentOnApp = 'STANDARD_METAOBJECT_DEFINITION_DEPENDENT_ON_APP',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** No field definition found for this key. */
  UndefinedObjectField = 'UNDEFINED_OBJECT_FIELD',
  /** No metaobject definition found for this type. */
  UndefinedObjectType = 'UNDEFINED_OBJECT_TYPE',
  /** The Online Store URL handle cannot be blank. */
  UrlHandleBlank = 'URL_HANDLE_BLANK',
  /** The Online Store URL handle is invalid. */
  UrlHandleInvalid = 'URL_HANDLE_INVALID',
  /** The Online Store URL handle is already taken. */
  UrlHandleTaken = 'URL_HANDLE_TAKEN'
}

/** The set of valid sort keys for the MethodDefinition query. */
export enum MethodDefinitionSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `rate_provider_type` value. */
  RateProviderType = 'RATE_PROVIDER_TYPE'
}

/**
 * You can use the `MobilePlatformApplication` resource to enable
 * [shared web credentials](https://developer.apple.com/documentation/security/shared_web_credentials) for Shopify iOS apps,
 * as well as to create [iOS universal link](https://developer.apple.com/ios/universal-links/)
 * or [Android app link](https://developer.android.com/training/app-links/) verification endpoints for merchant Shopify iOS or Android apps.
 * Shared web credentials let iOS users access a native app after logging into the respective website in Safari without re-entering
 * their username and password. If a user changes their credentials in the app, then those changes are reflected in Safari.
 * You must use a custom domain to integrate shared web credentials with Shopify. With each platform's link system,
 * users can tap a link to a shop's website and get seamlessly redirected to a merchant's installed app without going
 * through a browser or manually selecting an app.
 *
 * For full configuration instructions on iOS shared web credentials,
 * see the [associated domains setup](https://developer.apple.com/documentation/security/password_autofill/setting_up_an_app_s_associated_domains) technical documentation.
 *
 * For full configuration instructions on iOS universal links or Android App Links,
 * see the respective [iOS universal link](https://developer.apple.com/documentation/uikit/core_app/allowing_apps_and_websites_to_link_to_your_content)
 * or [Android app link](https://developer.android.com/training/app-links) technical documentation.
 */
export type MobilePlatformApplication = AndroidApplication | AppleApplication;

/** An auto-generated type for paginating through multiple MobilePlatformApplications. */
export type MobilePlatformApplicationConnection = {
  __typename?: 'MobilePlatformApplicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<MobilePlatformApplicationEdge>;
  /** A list of nodes that are contained in MobilePlatformApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<MobilePlatformApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for an Android based mobile platform application. */
export type MobilePlatformApplicationCreateAndroidInput = {
  /** Whether Android App Links are supported by this app. */
  appLinksEnabled: Scalars['Boolean']['input'];
  /** Android application ID. */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** The SHA256 fingerprints of the app’s signing certificate. */
  sha256CertFingerprints: Array<Scalars['String']['input']>;
};

/** The input fields for an Apple based mobile platform application. */
export type MobilePlatformApplicationCreateAppleInput = {
  /** The Apple app clip application ID. */
  appClipApplicationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether Apple app clips are enabled for this app. */
  appClipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apple application ID. */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Whether Apple shared web credentials are enabled for this app. */
  sharedWebCredentialsEnabled: Scalars['Boolean']['input'];
  /** Whether Apple Universal Links are supported by this app. */
  universalLinksEnabled: Scalars['Boolean']['input'];
};

/** The input fields for a mobile application platform type. */
export type MobilePlatformApplicationCreateInput = {
  /** Android based mobile platform application. */
  android?: InputMaybe<MobilePlatformApplicationCreateAndroidInput>;
  /** Apple based mobile platform application. */
  apple?: InputMaybe<MobilePlatformApplicationCreateAppleInput>;
};

/** Return type for `mobilePlatformApplicationCreate` mutation. */
export type MobilePlatformApplicationCreatePayload = {
  __typename?: 'MobilePlatformApplicationCreatePayload';
  /** Created mobile platform application. */
  mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MobilePlatformApplicationUserError>;
};

/** Return type for `mobilePlatformApplicationDelete` mutation. */
export type MobilePlatformApplicationDeletePayload = {
  __typename?: 'MobilePlatformApplicationDeletePayload';
  /** The ID of the mobile platform application that was just deleted. */
  deletedMobilePlatformApplicationId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MobilePlatformApplicationUserError>;
};

/** An auto-generated type which holds one MobilePlatformApplication and a cursor during pagination. */
export type MobilePlatformApplicationEdge = {
  __typename?: 'MobilePlatformApplicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of MobilePlatformApplicationEdge. */
  node: MobilePlatformApplication;
};

/** The input fields for an Android based mobile platform application. */
export type MobilePlatformApplicationUpdateAndroidInput = {
  /** Whether Android App Links are supported by this app. */
  appLinksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Android application ID. */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** The SHA256 fingerprints of the app’s signing certificate. */
  sha256CertFingerprints?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input fields for an Apple based mobile platform application. */
export type MobilePlatformApplicationUpdateAppleInput = {
  /** The Apple App Clip application ID. */
  appClipApplicationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether Apple App Clips are enabled for this app. */
  appClipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apple application ID. */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Whether Apple shared web credentials are enabled for this app. */
  sharedWebCredentialsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Apple Universal Links are supported by this app. */
  universalLinksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for the mobile platform application platform type. */
export type MobilePlatformApplicationUpdateInput = {
  /** Android based Mobile Platform Application. */
  android?: InputMaybe<MobilePlatformApplicationUpdateAndroidInput>;
  /** Apple based Mobile Platform Application. */
  apple?: InputMaybe<MobilePlatformApplicationUpdateAppleInput>;
};

/** Return type for `mobilePlatformApplicationUpdate` mutation. */
export type MobilePlatformApplicationUpdatePayload = {
  __typename?: 'MobilePlatformApplicationUpdatePayload';
  /** Created mobile platform application. */
  mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MobilePlatformApplicationUserError>;
};

/** An error in the input of a mutation. Mutations return `UserError` objects to indicate validation failures, such as invalid field values or business logic violations, that prevent the operation from completing. */
export type MobilePlatformApplicationUserError = DisplayableError & {
  __typename?: 'MobilePlatformApplicationUserError';
  /** The error code. */
  code?: Maybe<MobilePlatformApplicationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MobilePlatformApplicationUserError`. */
export enum MobilePlatformApplicationUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** Represents a Shopify hosted 3D model. */
export type Model3d = File & Media & Node & {
  __typename?: 'Model3d';
  /** A word or phrase to describe the contents or the function of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The 3d model's bounding box information. */
  boundingBox?: Maybe<Model3dBoundingBox>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** The 3d model's filename. */
  filename: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  mediaErrors: Array<MediaError>;
  /** The warnings attached to the media. */
  mediaWarnings: Array<MediaWarning>;
  /** The 3d model's original source. */
  originalSource?: Maybe<Model3dSource>;
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /** The 3d model's sources. */
  sources: Array<Model3dSource>;
  /** Current status of the media. */
  status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Bounding box information of a 3d model. */
export type Model3dBoundingBox = {
  __typename?: 'Model3dBoundingBox';
  /** Size in meters of the smallest volume which contains the 3d model. */
  size: Vector3;
};

/**
 * A source for a Shopify-hosted 3d model.
 *
 * Types of sources include GLB and USDZ formatted 3d models, where the former
 * is an original 3d model and the latter has been converted from the original.
 *
 * If the original source is in GLB format and over 15 MBs in size, then both the
 * original and the USDZ formatted source are optimized to reduce the file size.
 */
export type Model3dSource = {
  __typename?: 'Model3dSource';
  /** The 3d model source's filesize. */
  filesize: Scalars['Int']['output'];
  /** The 3d model source's format. */
  format: Scalars['String']['output'];
  /** The 3d model source's MIME type. */
  mimeType: Scalars['String']['output'];
  /** The 3d model source's URL. */
  url: Scalars['String']['output'];
};

/** A collection of monetary values in their respective currencies. Used throughout the API for multi-currency pricing and transactions, when an amount in the shop's currency is converted to the customer's currency of choice. The `presentmentMoney` field contains the amount in the customer's selected currency. The `shopMoney` field contains the equivalent in the shop's base currency. */
export type MoneyBag = {
  __typename?: 'MoneyBag';
  /** Amount in presentment currency. */
  presentmentMoney: MoneyV2;
  /** Amount in shop currency. */
  shopMoney: MoneyV2;
};

/**
 * An input collection of monetary values in their respective currencies.
 * Represents an amount in the shop's currency and the amount as converted to the customer's currency of choice (the presentment currency).
 */
export type MoneyBagInput = {
  /** Amount in presentment currency. If this isn't given then we assume that the presentment currency is the same as the shop's currency. */
  presentmentMoney?: InputMaybe<MoneyInput>;
  /** Amount in shop currency. */
  shopMoney: MoneyInput;
};

/** The input fields for a monetary value with currency. */
export type MoneyInput = {
  /** Decimal money amount. */
  amount: Scalars['Decimal']['input'];
  /** Currency of the money. */
  currencyCode: CurrencyCode;
};

/** A precise monetary value and its associated currency. Combines a decimal amount with a three-letter currency code to express prices, costs, and other financial values throughout the API. For example, 12.99 USD. */
export type MoneyV2 = {
  __typename?: 'MoneyV2';
  /**
   * A monetary value in decimal format, allowing for precise representation of cents or fractional
   * currency. For example, 12.99.
   */
  amount: Scalars['Decimal']['output'];
  /**
   * The three-letter currency code that represents a world currency used in a store. Currency codes
   * include standard [standard ISO 4217 codes](https://en.wikipedia.org/wiki/ISO_4217), legacy codes,
   * and non-standard codes. For example, USD.
   */
  currencyCode: CurrencyCode;
};

/**
 * The input for moving a single object to a specific position in a set.
 *
 * Provide this input only for objects whose position actually changed; do not send inputs for the entire set.
 *
 * - id: The ID (GID) of the object to move.
 * - newPosition: The zero-based index of the object's position within the set at the time this move is applied.
 *
 * Moves are applied sequentially, so `newPosition` for each move is evaluated after all prior moves in the same list.
 * If `newPosition` is greater than or equal to the number of objects, the object is moved to the end of the set.
 * Values do not have to be unique. Objects not included in the move list keep their relative order, aside from any displacement caused by the moves.
 */
export type MoveInput = {
  /** The ID of the object to be moved. */
  id: Scalars['ID']['input'];
  /** Zero-based index of the object's position at the time this move is applied. If the value is >= the number of objects, the object is placed at the end. */
  newPosition: Scalars['UnsignedInt64']['input'];
};

/** The schema's entry point for all mutation operations. */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Updates the email state value for an abandonment.
   * @deprecated Use `abandonmentUpdateActivitiesDeliveryStatuses` instead.
   */
  abandonmentEmailStateUpdate?: Maybe<AbandonmentEmailStateUpdatePayload>;
  /** Updates the marketing activities delivery statuses for an abandonment. */
  abandonmentUpdateActivitiesDeliveryStatuses?: Maybe<AbandonmentUpdateActivitiesDeliveryStatusesPayload>;
  /**
   * Creates a one-time charge for app features or services that don't require recurring billing. This mutation is ideal for apps that sell individual features, premium content, or services on a per-use basis rather than subscription models.
   *
   * For example, a design app might charge merchants once for premium templates, or a marketing app could bill for individual campaign setups without ongoing monthly fees.
   *
   * Use the `AppPurchaseOneTimeCreate` mutation to:
   * - Charge for premium features or content purchases
   * - Bill for professional services or setup fees
   * - Generate revenue from one-time digital product sales
   *
   * The mutation returns a confirmation URL that merchants must visit to approve the charge. Test and development stores are not charged, allowing safe testing of billing flows.
   *
   * Explore one-time billing options on the [app purchases page](https://shopify.dev/docs/apps/launch/billing/support-one-time-purchases).
   */
  appPurchaseOneTimeCreate?: Maybe<AppPurchaseOneTimeCreatePayload>;
  /**
   * Revokes previously granted access scopes from an app installation, allowing merchants to reduce an app's permissions without completely uninstalling it. This provides granular control over what data and functionality apps can access.
   *
   * For example, if a merchant no longer wants an app to access customer information but still wants to use its inventory features, they can revoke the customer-related scopes while keeping inventory permissions active.
   *
   * Use the `appRevokeAccessScopes` mutation to:
   * - Remove specific permissions from installed apps
   * - Maintain app functionality while minimizing data exposure
   *
   * The mutation returns details about which scopes were successfully revoked and any errors that prevented certain permissions from being removed.
   *
   * Learn more about [managing app permissions](https://shopify.dev/docs/apps/build/authentication-authorization/app-installation/manage-access-scopes#revoke-granted-scopes-dynamically).
   */
  appRevokeAccessScopes?: Maybe<AppRevokeAccessScopesPayload>;
  /**
   * Cancels an active app subscription, stopping future billing cycles. The cancellation behavior depends on the `replacementBehavior` setting - it can either disable auto-renewal (allowing the subscription to continue until the end of the current billing period) or immediately cancel with prorated refunds.
   *
   * When a merchant decides to discontinue using subscription features, this mutation provides a clean cancellation workflow that respects billing periods and merchant expectations.
   *
   * Use the `AppSubscriptionCancel` mutation to:
   * - Process merchant-initiated subscription cancellations
   * - Terminate subscriptions due to policy violations or account issues
   * - Handle subscription cancellations during app uninstallation workflows
   *
   * The cancellation timing and merchant access depends on the `replacementBehavior` setting and the app's specific implementation of subscription management.
   *
   * For subscription lifecycle management and cancellation best practices, consult the [subscription management guide](https://shopify.dev/docs/apps/launch/billing/subscription-billing).
   */
  appSubscriptionCancel?: Maybe<AppSubscriptionCancelPayload>;
  /**
   * Creates a recurring or usage-based [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) that charges merchants for app features and services. The subscription includes one or more [`AppSubscriptionLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscriptionLineItem) objects that define the pricing structure, billing intervals, and optional [`AppSubscriptionDiscount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscriptionDiscount) values.
   *
   * Returns a [confirmation URL](https://shopify.dev/docs/api/admin-graphql/latest/mutations/appSubscriptionCreate#returns-confirmationUrl) where the merchant approves or declines the charges. After approval, the subscription becomes active and billing begins after any trial period expires. You can specify [`AppSubscriptionReplacementBehavior`](https://shopify.dev/docs/api/admin-graphql/latest/enums/AppSubscriptionReplacementBehavior) to control how this subscription interacts with existing active subscriptions.
   *
   * Learn more about [creating app subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/create-time-based-subscriptions).
   */
  appSubscriptionCreate?: Maybe<AppSubscriptionCreatePayload>;
  /**
   * Updates the capped amount on usage-based billing for an [`AppSubscriptionLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscriptionLineItem). Enables you to modify the maximum charge limit that prevents merchants from exceeding a specified threshold during their billing period.
   *
   * The mutation returns a [confirmation URL](https://shopify.dev/docs/api/admin-graphql/latest/mutations/appSubscriptionCreate#returns-confirmationUrl) where the merchant must approve the new pricing limit before it takes effect. Use this when adjusting usage limits based on merchant needs or changing pricing models.
   *
   * Learn more about [updating the maximum charge for a subscription](https://shopify.dev/docs/apps/launch/billing/subscription-billing/update-max-charge).
   */
  appSubscriptionLineItemUpdate?: Maybe<AppSubscriptionLineItemUpdatePayload>;
  /**
   * Extends the trial period for an existing app subscription. Trial extensions give merchants additional time to use the app before committing to paid billing.
   *
   * Requires the subscription ID and the number of days to extend (between one and 1000). The extension modifies the existing trial end date, allowing continued access to subscription features without immediate billing. Returns the updated [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription).
   *
   * Learn more about [offering free trials](https://shopify.dev/docs/apps/launch/billing/offer-free-trials).
   */
  appSubscriptionTrialExtend?: Maybe<AppSubscriptionTrialExtendPayload>;
  /**
   * Uninstalls an [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) from a shop. Apps use this mutation to uninstall themselves programmatically, removing their [`AppInstallation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppInstallation) from the merchant's store.
   *
   * When an app uninstalls, Shopify automatically performs cleanup tasks, such as deleting [`WebhookSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/WebhookSubscription) objects and [admin links](https://shopify.dev/docs/apps/build/admin/admin-links) associated with the app.
   *
   * Learn more about [app lifecycle management](https://shopify.dev/docs/apps/build/authentication-authorization/app-installation/uninstall-app-api-request).
   *
   * > Caution:
   * > This action is irreversible. You can't restore an uninstalled app's configuration or data. Before you uninstall an app, make sure that you no longer need to make API calls for the store in which the app has been installed.
   */
  appUninstall?: Maybe<AppUninstallPayload>;
  /**
   * Creates a usage charge for an app subscription with usage-based pricing. The charge counts toward the capped amount limit set when creating the subscription.
   *
   * Usage records track consumption of app features or services on a per-use basis. You provide the charge amount, a description of what you consumed, and the subscription line item ID. The optional [`idempotencyKey`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppUsageRecord#field-idempotencyKey) parameter prevents duplicate charges if you send the same request multiple times.
   *
   * If the new charge would cause total usage charges in the current billing interval to exceed the capped amount, then the mutation returns an error.
   *
   * Learn more about [creating usage-based subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/create-usage-based-subscriptions).
   */
  appUsageRecordCreate?: Maybe<AppUsageRecordCreatePayload>;
  /**
   * Creates an [`Article`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article). Articles are content pieces that include a title, body text, and author information.
   *
   * You can publish the article immediately or schedule it with a specific publish date. You can customize the article's URL handle, apply custom templates for rendering, and add optional fields like [tags](https://shopify.dev/docs/api/admin-graphql/latest/mutations/articleCreate#arguments-article.fields.tags), an [image](https://shopify.dev/docs/api/admin-graphql/latest/mutations/articleCreate#arguments-article.fields.image), and [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
   *
   * The mutation validates article content and ensures proper blog association. Error handling provides specific feedback for content requirements.
   */
  articleCreate?: Maybe<ArticleCreatePayload>;
  /**
   * Permanently deletes a blog article from a shop's blog. This mutation removes the article and all associated metadata.
   *
   * For example, when outdated product information or seasonal content needs removal, merchants can use this mutation to clean up their blog.
   *
   * Use the `articleDelete` mutation to:
   * - Remove outdated or incorrect blog content
   * - Clean up seasonal or time-sensitive articles
   * - Maintain blog organization
   *
   * The deletion is permanent and returns the deleted article's ID for confirmation.
   */
  articleDelete?: Maybe<ArticleDeletePayload>;
  /**
   * Updates an existing [`Article`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article). You can modify the article's content, metadata, publication status, and associated properties like author information and tags.
   *
   * If you update the [`handle`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/articleUpdate#arguments-article.fields.handle), then you can optionally create a redirect from the old URL to the new one by setting [`redirectNewHandle`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/articleUpdate#arguments-article.fields.redirectNewHandle) to `true`.
   */
  articleUpdate?: Maybe<ArticleUpdatePayload>;
  /** Update the backup region that is used when we have no better signal of what region a buyer is in. */
  backupRegionUpdate?: Maybe<BackupRegionUpdatePayload>;
  /**
   * Creates a new blog within a shop, establishing a container for organizing articles.
   *
   * For example, a fitness equipment retailer launching a wellness blog would use this mutation to create the blog, enabling them to publish workout guides and nutrition tips.
   *
   * Use the `blogCreate` mutation to:
   * - Launch new content marketing initiatives
   * - Create separate blogs for different content themes
   * - Establish spaces for article organization
   *
   * The mutation validates blog settings and establishes the structure for article publishing.
   */
  blogCreate?: Maybe<BlogCreatePayload>;
  /**
   * Permanently deletes a blog from a shop. This mutation removes the blog container and its organizational structure.
   *
   * For example, when consolidating multiple seasonal blogs into a single year-round content strategy, merchants can use this mutation to remove unused blogs.
   *
   * Use the `blogDelete` mutation to:
   * - Remove unused or outdated blogs
   * - Consolidate content organization
   * - Clean up blog structure
   *
   * The deletion is permanent and returns the deleted blog's ID for confirmation.
   */
  blogDelete?: Maybe<BlogDeletePayload>;
  /**
   * Updates an existing blog's configuration and settings. This mutation allows merchants to modify blog properties to keep their content strategy current.
   *
   * For example, a merchant might update their blog's title from "Company News" to "Sustainability Stories" when shifting their content focus, or modify the handle to improve URL structure.
   *
   * Use the `blogUpdate` mutation to:
   * - Change blog titles for rebranding
   * - Modify blog handles for better URLs
   * - Adjust comment settings and moderation preferences
   *
   * The mutation returns the updated blog with any validation errors.
   */
  blogUpdate?: Maybe<BlogUpdatePayload>;
  /**
   * Starts the cancelation process of a running bulk operation.
   *
   * There may be a short delay from when a cancelation starts until the operation is actually canceled.
   */
  bulkOperationCancel?: Maybe<BulkOperationCancelPayload>;
  /**
   * Creates and runs a [bulk operation](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation) to import data asynchronously. This mutation executes a specified GraphQL mutation multiple times using input data from a [JSONL](http://jsonlines.org/) file that you've uploaded to Shopify.
   *
   * The operation processes each line in your JSONL file as a separate mutation execution. The operation delivers results in a JSONL file when it completes. Bulk mutation operations and [`bulkOperationRunQuery`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/bulkoperationrunquery) operations can run at the same time per shop. The number of concurrent operations that an app can run depends on the API version. For the applicable concurrency limits, refer to the [bulk operations guide](https://shopify.dev/docs/api/usage/bulk-operations/imports).
   *
   * Learn more about [bulk importing data](https://shopify.dev/docs/api/usage/bulk-operations/imports).
   */
  bulkOperationRunMutation?: Maybe<BulkOperationRunMutationPayload>;
  /**
   * Creates and runs a [bulk operation](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation) to fetch data asynchronously. The operation processes your GraphQL query in the background and returns results in a [JSONL](http://jsonlines.org/) file when complete.
   *
   * Bulk query and bulk mutation operations can run at the same time per shop. The number of concurrent operations that an app can run depends on the API version. For the applicable concurrency limits, refer to the [bulk operations guide](https://shopify.dev/docs/api/usage/bulk-operations/queries). The query must include at least one connection field and supports up to five connections with a maximum nesting depth of two levels.
   *
   * > Note: Results remain available for seven days after completion.
   *
   * For more information, see the [bulk operations guide](https://shopify.dev/docs/api/usage/bulk-operations/queries).
   */
  bulkOperationRunQuery?: Maybe<BulkOperationRunQueryPayload>;
  /** Creates product feedback for multiple products. */
  bulkProductResourceFeedbackCreate?: Maybe<BulkProductResourceFeedbackCreatePayload>;
  /**
   * Creates a carrier service that provides real-time shipping rates to Shopify. Carrier services provide real-time shipping rates from external providers like FedEx, UPS, or custom shipping solutions. The carrier service connects to your external shipping rate calculation system through a callback URL.
   *
   * When customers reach checkout, Shopify sends order details to your callback URL and displays the returned shipping rates. The service must be active to provide rates during checkout.
   */
  carrierServiceCreate?: Maybe<CarrierServiceCreatePayload>;
  /** Removes an existing carrier service. */
  carrierServiceDelete?: Maybe<CarrierServiceDeletePayload>;
  /** Updates a carrier service. Only the app that creates a carrier service can update it. */
  carrierServiceUpdate?: Maybe<CarrierServiceUpdatePayload>;
  /**
   * Creates a cart transform function that lets merchants customize how products are bundled and presented during checkout. This gives merchants powerful control over their merchandising strategy by allowing apps to modify cart line items programmatically, supporting advanced approaches like dynamic bundles or personalized product recommendations.
   *
   * For example, a bundle app might create a cart transform that automatically groups related products (like a camera, lens, and case) into a single bundle line item when customers add them to their cart, complete with bundle pricing and unified presentation.
   *
   * Use `CartTransformCreate` to:
   * - Deploy custom bundling logic to merchant stores
   * - Enable dynamic product grouping during checkout
   * - Implement personalized product recommendations
   * - Create conditional offers based on cart contents
   * - Support complex pricing strategies for product combinations
   *
   * The mutation processes synchronously and returns the created cart transform along with any validation errors. Once created, the cart transform function becomes active for the shop and will process cart modifications according to your defined logic. Cart transforms integrate with [Shopify Functions](https://shopify.dev/docs/api/functions) to provide powerful customization capabilities while maintaining checkout performance.
   *
   * Cart Transform functions can be configured to block checkout on failure or allow graceful degradation, giving you control over how errors are handled in the customer experience.
   *
   * Learn more about [customized bundles](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle).
   */
  cartTransformCreate?: Maybe<CartTransformCreatePayload>;
  /**
   * Removes an existing cart transform function from the merchant's store, disabling any customized bundle or cart modification logic it provided. This mutation persistently deletes the transform configuration and stops all associated cart processing.
   *
   * For example, when discontinuing a bundle app or removing specific merchandising features, you would delete the corresponding cart transform to ensure customers no longer see the bundled products or modified cart behavior.
   *
   * Use `CartTransformDelete` to:
   * - Deactivate customized bundle logic when removing app features
   * - Clean up unused transform functions
   * - Disable cart modifications during app uninstallation
   * - Remove outdated merchandising strategies
   * - Restore default cart behavior for merchants
   *
   * The deletion processes immediately and returns the ID of the removed cart transform for confirmation. Once deleted, the transform function stops processing new cart operations, though existing cart sessions may retain their current state until refresh. This ensures a clean transition without disrupting active customer sessions.
   *
   * Consider the timing of deletions carefully, as removing transforms during peak shopping periods could affect customer experience if they have active carts with transformed items.
   *
   * Learn more about [managing cart transforms](https://shopify.dev/docs/apps/selling-strategies/bundles).
   */
  cartTransformDelete?: Maybe<CartTransformDeletePayload>;
  /** Creates a cash drawer in a provided location. */
  cashDrawerCreate?: Maybe<CashDrawerCreatePayload>;
  /** Finds or creates a cash drawer for cash management. Also ensures the provided device is assigned to the drawer. */
  cashDrawerFindOrCreate?: Maybe<CashDrawerFindOrCreatePayload>;
  /** Updates a cash drawer. */
  cashDrawerUpdate?: Maybe<CashDrawerUpdatePayload>;
  /** Create a cash management reason code. */
  cashManagementReasonCodeCreate?: Maybe<CashManagementReasonCodeCreatePayload>;
  /** Deletes a cash management reason code. */
  cashManagementReasonCodeDelete?: Maybe<CashManagementReasonCodeDeletePayload>;
  /**
   * Modifies which contexts, like [markets](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) or B2B [company locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation), can access a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog). You can add or remove contexts to control where the catalog's products and prices are available.
   *
   * Learn more about [managing catalog contexts](https://shopify.dev/docs/apps/build/markets/new-markets/catalogs) and [managing B2B catalogs](https://shopify.dev/docs/apps/build/b2b/manage-catalogs).
   */
  catalogContextUpdate?: Maybe<CatalogContextUpdatePayload>;
  /**
   * Creates a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) that controls product availability and pricing for specific contexts like [markets](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) or B2B [company locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation).
   *
   * ### Publications and Price Lists
   *
   * - **[`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)** objects control which products are visible in a catalog. Publications are **optional**. When a publication isn't associated with a catalog, product availability is determined by the sales channel.
   * - **[`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList)** objects define custom pricing for products in a catalog.
   *
   * You can optionally associate a publication and price list when creating the catalog, or add them later using separate mutations.
   *
   * ### When to use Publications
   *
   * **Create a publication only if you need to:**
   * - Limit which products are visible in a specific context (e.g., show different products to different company locations or markets)
   * - Publish a curated subset of your product catalog
   *
   * **Do NOT create a publication if:**
   * - You want product availability determined by the sales channel
   * - You only need to customize pricing (use a price list without a publication)
   *
   * > **Important:** For company location catalogs that only require custom pricing, create the catalog with a price list but without a publication.
   *
   * Learn more about [managing catalog contexts](https://shopify.dev/docs/apps/build/markets/new-markets/catalogs) and [using catalogs for different markets](https://shopify.dev/docs/apps/build/markets/catalogs-different-markets).
   */
  catalogCreate?: Maybe<CatalogCreatePayload>;
  /** Delete a catalog. */
  catalogDelete?: Maybe<CatalogDeletePayload>;
  /**
   * Updates an existing [catalog's](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) configuration. Catalogs control product publishing and pricing for specific contexts like [markets](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) or B2B [company locations](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation).
   *
   * You can modify the catalog's title, status, and associated context. You can also update the [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) that determines pricing adjustments or the [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) that controls which products customers see.
   */
  catalogUpdate?: Maybe<CatalogUpdatePayload>;
  /**
   * Creates a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) representing a connection between the shop and an external selling platform account. Use this mutation after a merchant authenticates with an external platform to establish the publishing destination for product syndication and, for order-generating channels, order import.
   *
   * The platform resolves the [channel specification](https://shopify.dev/docs/apps/build/sales-channels/channel-config-extension) identified by `specificationHandle`, determines its country coverage, intersects with the shop's available region markets, and establishes product feeds for all matching regions. Product feeds immediately begin emitting events to the application's webhook or event subscription.
   *
   * If the specification sets `expects_online_store_parity` and no matching region markets exist, the mutation returns an error. If the specification doesn't require online store parity and no matching region markets exist, a channel subordinate to shop defaults is created automatically.
   */
  channelCreate?: Maybe<ChannelCreatePayload>;
  /** Deletes a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) from the shop. All associated product feeds are removed. Existing orders attributed to the channel are preserved. The channel must have been created via [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate). */
  channelDelete?: Maybe<ChannelDeletePayload>;
  /**
   * Triggers a full product resync for the specified [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). All published products are added to the channel's product feed attention set, causing the next poll or event-triggered consumption to receive current state for the complete catalog. Use this mutation after initial channel setup, after recovering from a prolonged outage, or when the channel's external catalog has drifted from Shopify's state.
   *
   * The sync can be scoped to a specific country and language. When neither is specified, all country-language combinations covered by the channel's specification are triggered.
   */
  channelFullSync?: Maybe<ChannelFullSyncPayload>;
  /**
   * Updates the properties of an existing [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Use this mutation to update account information — such as the display name shown in Shopify Admin — or to bind the channel to a different channel specification.
   *
   * Updating the `specificationHandle` triggers re-evaluation of the specification's country coverage against the shop's region markets, reconciling product feeds accordingly. This is also the mechanism for migrating legacy channel records to the multi-channel model by assigning a specification handle.
   */
  channelUpdate?: Maybe<ChannelUpdatePayload>;
  /** Updates a checkout and accounts configuration. */
  checkoutAndAccountsConfigurationUpdate?: Maybe<CheckoutAndAccountsConfigurationUpdatePayload>;
  /**
   * Updates the visual branding for a [`CheckoutProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutProfile), customizing how checkout displays to customers. Creates new branding settings if none exist, or modifies existing settings.
   *
   * The mutation accepts two levels of customization through the [`CheckoutBrandingInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CheckoutBrandingInput) input object. [`designSystem`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/checkoutBrandingUpsert#arguments-checkoutBrandingInput.fields.designSystem) defines foundational brand attributes like colors, typography, and corner radius that apply consistently throughout checkout. [`customizations`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/checkoutBrandingUpsert#arguments-checkoutBrandingInput.fields.customizations) defines styles for specific parts of the UI, individual components, or groups of components like the header, buttons, form fields, and sections.
   *
   * Changes to a published checkout profile display immediately in the store's checkout. You can preview draft profiles in the Shopify admin's checkout editor before publishing.
   *
   * Learn more about [checkout styling](https://shopify.dev/docs/apps/checkout/styling).
   * @deprecated Use `checkoutAndAccountsConfigurationUpdate` instead.
   */
  checkoutBrandingUpsert?: Maybe<CheckoutBrandingUpsertPayload>;
  /**
   * Adds multiple products to an existing collection in a single operation. This mutation provides an efficient way to bulk-manage collection membership without individual product updates.
   *
   * For example, when merchants create seasonal collections, they can add dozens of related products at once rather than updating each product individually. A clothing store might add all winter jackets to a "Winter Collection" in one operation.
   *
   * Use `CollectionAddProducts` to:
   * - Bulk-add products to collections for efficient catalog management
   * - Implement collection building tools in admin interfaces
   * - Organize collection membership during bulk product operations
   * - Reduce API calls when managing large product sets
   *
   * The mutation processes multiple product additions and returns success status along with any errors encountered during the operation. Products are added to the collection while preserving existing collection settings.
   *
   * Learn more about [collection management](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   * @deprecated Use `collectionUpdate` with inclusion.selectionsToAdd instead.
   */
  collectionAddProducts?: Maybe<CollectionAddProductsPayload>;
  /**
   * Adds products to a [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) asynchronously and returns a [`Job`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Job) to track the operation's progress. This mutation handles large product sets efficiently by processing them in the background.
   *
   * You can poll the returned job using the [`job`](https://shopify.dev/docs/api/admin-graphql/latest/queries/job) query to monitor completion status.
   *
   * > Note:
   * > This mutation adds products in the order specified in the [`productIds`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/collectionAddProducts#arguments-productIds) argument.
   * @deprecated Use `collectionUpdate` with inclusion.selectionsToAdd instead.
   */
  collectionAddProductsV2?: Maybe<CollectionAddProductsV2Payload>;
  /** Creates a shareable collection source that can later be linked to one or more collections. */
  collectionConditionsSourceCreate?: Maybe<CollectionConditionsSourceCreatePayload>;
  /** Deletes a shareable collection source owned by the calling app. */
  collectionConditionsSourceDelete?: Maybe<CollectionConditionsSourceDeletePayload>;
  /** Updates a shareable collection source owned by the calling app. */
  collectionConditionsSourceUpdate?: Maybe<CollectionConditionsSourceUpdatePayload>;
  /**
   * Creates a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection)
   * to group [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) together
   * in the [online store](https://shopify.dev/docs/apps/build/online-store) and
   * other [sales channels](https://shopify.dev/docs/apps/build/sales-channels).
   * For example, an athletics store might create different collections for running attire, shoes, and accessories.
   *
   * Use the `collectionCreate` mutation when you need to:
   *
   * - Create a new collection for a product launch or campaign
   * - Organize products by category, season, or promotion
   * - Automate product grouping using conditions (for example, by tag, type, or price)
   *
   * Collections can include products manually and can also include products automatically based on rules, sources,
   * or conditions.
   *
   * **Defining a collection's membership**
   *
   * Define membership with `sources` on the `collection` argument
   * ([`CollectionCreateInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CollectionCreateInput)).
   * Each source adds products through `conditions` (such as product tag, title, or metafield—see
   * [`CollectionSourceInclusionConditionInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CollectionSourceInclusionConditionInput)
   * for the full list) and through manual `selections`.
   *
   * > Note:
   * > The `input` argument and its `ruleSet` field are deprecated. Existing integrations should migrate to
   * `collection` and `sources` — a `ruleSet` rule maps to an equivalent source `condition` (for example, a
   * tag rule becomes a `productTag` condition). If both `collection` and `input` are provided, `collection`
   * is used.
   *
   * > Note:
   * > The created collection is unpublished by default. To make it available to customers,
   * use the [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish)
   * mutation after creation.
   *
   * Learn more about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
   */
  collectionCreate?: Maybe<CollectionCreatePayload>;
  /**
   * Deletes a collection and removes it permanently from the store. This operation cannot be undone and will remove the collection from all sales channels where it was published.
   *
   * For example, when merchants discontinue seasonal promotions or reorganize their catalog structure, they can delete outdated collections like "Back to School 2023" to keep their store organized.
   *
   * Use `CollectionDelete` to:
   * - Remove outdated or unused collections from stores
   * - Clean up collection structures during catalog reorganization
   * - Implement collection management tools with deletion capabilities
   *
   * Products within the deleted collection remain in the store but are no longer grouped under that collection.
   *
   * Learn more about [collection management](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   */
  collectionDelete?: Maybe<CollectionDeletePayload>;
  /**
   * Duplicates a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   *
   * An existing collection ID and new title are required.
   *
   * ## Publication Duplication
   *
   * Publications may be excluded by passing `copyPublications: false` in the input.
   *
   * ## Metafields
   * Metafield values are not duplicated if the unique values capability is enabled.
   */
  collectionDuplicate?: Maybe<CollectionDuplicatePayload>;
  /**
   * Publishes a collection to a channel.
   * @deprecated Use `publishablePublish` instead.
   */
  collectionPublish?: Maybe<CollectionPublishPayload>;
  /**
   * Removes multiple manually included products from a collection in a single operation. This mutation can process large product sets (up to 250 products) and may take significant time to complete for collections with many products.
   *
   * For example, when ending a seasonal promotion, merchants can remove all sale items from a "Summer Clearance" collection at once rather than editing each product individually.
   *
   * Use `CollectionRemoveProducts` to:
   * - Bulk-remove products from collections efficiently
   * - Clean up collection membership during catalog updates
   * - Implement automated collection management workflows
   *
   * The operation processes asynchronously to avoid timeouts and performance issues, especially for large product sets.
   *
   * Learn more about [collection management](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   * @deprecated Use `collectionUpdate` with inclusions.selectionsToRemove instead.
   */
  collectionRemoveProducts?: Maybe<CollectionRemoveProductsPayload>;
  /**
   * Asynchronously reorders products within a specified collection. Instead of returning an updated collection, this mutation returns a job, which should be [polled](https://shopify.dev/api/admin-graphql/latest/queries/job). The [`Collection.sortOrder`](https://shopify.dev/api/admin-graphql/latest/objects/Collection#field-collection-sortorder) must be `MANUAL`.
   *
   * How to use this mutation:
   * - Provide only the products that actually moved in the `moves` list; do not send the entire product list. For example: to move the product at index 1 to index N, send a single move for that product with `newPosition: N`.
   * - Each move is applied sequentially in the order provided.
   * - `newPosition` is a zero-based index within the collection at the moment the move is applied (after any prior moves in the list).
   * - Products not included in `moves` keep their relative order, aside from any displacement caused by the moves.
   * - If `newPosition` is greater than or equal to the number of products, the product is placed at the end.
   *
   * Example:
   * - Initial order: [A, B, C, D, E] (indices 0..4)
   * - Moves (applied in order):
   *   - E -> newPosition: 1
   *   - C -> newPosition: 4
   * - Result: [A, E, B, D, C]
   *
   * Displaced products will have their position altered in a consistent manner with no gaps.
   */
  collectionReorderProducts?: Maybe<CollectionReorderProductsPayload>;
  /**
   * Unpublishes a collection.
   * @deprecated Use `publishableUnpublish` instead.
   */
  collectionUnpublish?: Maybe<CollectionUnpublishPayload>;
  /**
   * Updates a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection),
   * modifying its properties, products, or publication settings. Collections help organize
   * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) together
   * in the [online store](https://shopify.dev/docs/apps/build/online-store) and
   * other [sales channels](https://shopify.dev/docs/apps/build/sales-channels).
   *
   * Use the `collectionUpdate` mutation to programmatically modify collections in scenarios such as:
   *
   * - Updating collection details, like title, description, or image
   * - Modifying SEO metadata for better search visibility
   * - Changing which products are included in a collection by updating its rules, sources, or conditions
   * - Updating custom data using [metafields](https://shopify.dev/docs/apps/build/custom-data/metafields)
   *
   * Collections can include products manually and can also include products automatically based on rules, sources,
   * or conditions. When product membership is updated through rules, sources, or conditions, the operation might
   * be processed asynchronously. In these cases, the mutation returns a [`job`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Job) object
   * that you can use to track the progress of the update.
   *
   * To publish or unpublish collections to specific sales channels, use the dedicated
   * [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish) and
   * [`publishableUnpublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishableUnpublish) mutations.
   *
   * Learn more about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
   */
  collectionUpdate?: Maybe<CollectionUpdatePayload>;
  /**
   * Add, remove and update `CombinedListing`s of a given Product.
   *
   * `CombinedListing`s are comprised of multiple products to create a single listing. There are two kinds of products used in a `CombinedListing`:
   *
   * 1. Parent products
   * 2. Child products
   *
   * The parent product is created with a `productCreate` with a `CombinedListingRole` of `PARENT`. Once created, you can associate child products with the parent product using this mutation. Parent products represent the idea of a product (e.g. Shoe).
   *
   * Child products represent a particular option value (or combination of option values) of a parent product. For instance, with your Shoe parent product, you may have several child products representing specific colors of the shoe (e.g. Shoe - Blue). You could also have child products representing more than a single option (e.g. Shoe - Blue/Canvas, Shoe - Blue/Leather, etc...).
   *
   * The combined listing is the association of parent product to one or more child products.
   *
   * Learn more about [Combined Listings](https://shopify.dev/apps/selling-strategies/combined-listings).
   */
  combinedListingUpdate?: Maybe<CombinedListingUpdatePayload>;
  /**
   * Approves a pending comment, making it visible to store visitors on the associated blog article.
   *
   * For example, when a customer submits a question about a product in a blog post, merchants can approve the comment to make it publicly visible.
   *
   * Use the `commentApprove` mutation to:
   * - Publish pending comments after review
   * - Enable customer discussions on blog articles
   * - Maintain quality control over comments
   *
   * Once approved, the comment becomes visible to all store visitors.
   */
  commentApprove?: Maybe<CommentApprovePayload>;
  /**
   * Permanently removes a comment from a blog article.
   *
   * For example, when a comment contains spam links or inappropriate language that violates store policies, merchants can delete it entirely.
   *
   * Use the `commentDelete` mutation to:
   * - Remove spam or inappropriate comments permanently
   * - Clean up irrelevant discussions
   * - Maintain content standards on blog articles
   *
   * Deletion is permanent and can't be undone.
   */
  commentDelete?: Maybe<CommentDeletePayload>;
  /**
   * Reverses a spam classification on a comment, restoring it to normal moderation status. This mutation allows merchants to change their decision when a comment has been manually marked as spam.
   *
   * For example, when a merchant reviews comments marked as spam and finds a legitimate customer question, they can use this mutation to restore the comment's normal status and make it eligible for approval.
   *
   * Use the `commentNotSpam` mutation to:
   * - Unmark comments that were marked as spam
   * - Restore comments to normal moderation status
   * - Move comments back to the approval queue
   *
   * This action changes the comment's status from spam back to pending, where it can then be approved or managed according to standard moderation practices.
   */
  commentNotSpam?: Maybe<CommentNotSpamPayload>;
  /**
   * Marks a comment as spam, removing it from public view. This mutation enables merchants to quickly handle unwanted promotional content, malicious links, or other spam that appears in blog discussions.
   *
   * For example, when a comment contains suspicious links to unrelated products or services, merchants can mark it as spam to immediately hide it from customers.
   *
   * Use the `commentSpam` mutation to:
   * - Hide promotional or malicious comments from public view
   * - Protect customers from potentially harmful links
   * - Maintain professional discussion quality on blog articles
   *
   * Spam-marked comments can be reviewed later and potentially restored using the `commentNotSpam` mutation if they were incorrectly classified.
   */
  commentSpam?: Maybe<CommentSpamPayload>;
  /** Deletes a list of companies. */
  companiesDelete?: Maybe<CompaniesDeletePayload>;
  /** Deletes a company address. */
  companyAddressDelete?: Maybe<CompanyAddressDeletePayload>;
  /**
   * Adds an existing [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) as a contact to a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company).  Companies are business entities that make purchases from the merchant's store. Use this mutation when you have a customer who needs to be associated with a B2B company to make purchases on behalf of that company.
   *
   * The mutation returns the newly created [`CompanyContact`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyContact) that links the customer to the company. After assignment, the customer becomes a company contact who can place orders on behalf of the company with access to any catalogs, pricing, and payment terms configured for the company's locations.
   */
  companyAssignCustomerAsContact?: Maybe<CompanyAssignCustomerAsContactPayload>;
  /** Assigns the main contact for the company. */
  companyAssignMainContact?: Maybe<CompanyAssignMainContactPayload>;
  /** Assigns a role to a contact for a location. */
  companyContactAssignRole?: Maybe<CompanyContactAssignRolePayload>;
  /** Assigns roles on a company contact. */
  companyContactAssignRoles?: Maybe<CompanyContactAssignRolesPayload>;
  /** Creates a company contact and the associated customer. */
  companyContactCreate?: Maybe<CompanyContactCreatePayload>;
  /** Deletes a company contact. */
  companyContactDelete?: Maybe<CompanyContactDeletePayload>;
  /** Removes a company contact from a Company. */
  companyContactRemoveFromCompany?: Maybe<CompanyContactRemoveFromCompanyPayload>;
  /** Revokes a role on a company contact. */
  companyContactRevokeRole?: Maybe<CompanyContactRevokeRolePayload>;
  /** Revokes roles on a company contact. */
  companyContactRevokeRoles?: Maybe<CompanyContactRevokeRolesPayload>;
  /** Sends the company contact a welcome email. */
  companyContactSendWelcomeEmail?: Maybe<CompanyContactSendWelcomeEmailPayload>;
  /** Updates a company contact. */
  companyContactUpdate?: Maybe<CompanyContactUpdatePayload>;
  /** Deletes one or more company contacts. */
  companyContactsDelete?: Maybe<CompanyContactsDeletePayload>;
  /**
   * Creates a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) for B2B commerce. This mutation creates the company and can optionally create an initial [`CompanyContact`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyContact) and [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) in a single operation. Company contacts are people who place orders on behalf of the company. Company locations are branches or offices with their own billing and shipping addresses.
   *
   * > Note: Creating a company without a `name` [returns an error](https://shopify.dev/docs/api/admin-graphql/latest/mutations/companycreate?example=creating-a-company-without-a-name-returns-an-error).
   *
   * Learn more about [creating companies for B2B](https://shopify.dev/docs/apps/build/b2b/start-building#step-1-create-a-company).
   */
  companyCreate?: Maybe<CompanyCreatePayload>;
  /** Deletes a company. */
  companyDelete?: Maybe<CompanyDeletePayload>;
  /** Updates an address on a company location. */
  companyLocationAssignAddress?: Maybe<CompanyLocationAssignAddressPayload>;
  /** Assigns roles on a company location. */
  companyLocationAssignRoles?: Maybe<CompanyLocationAssignRolesPayload>;
  /** Creates one or more mappings between a staff member at a shop and a company location. */
  companyLocationAssignStaffMembers?: Maybe<CompanyLocationAssignStaffMembersPayload>;
  /**
   * Assigns tax exemptions to the company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  companyLocationAssignTaxExemptions?: Maybe<CompanyLocationAssignTaxExemptionsPayload>;
  /**
   * Creates a new location for a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company). Company locations are branches or offices where B2B customers can place orders with specific pricing, catalogs, and payment terms.
   *
   * Creates a company location. Each location can have its own billing and shipping addresses, tax settings, and [`buyer experience configuration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration). You can assign [staff members](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) and [`CompanyContact`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyContact) objects to manage the location.
   */
  companyLocationCreate?: Maybe<CompanyLocationCreatePayload>;
  /**
   * Creates a tax registration for a company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  companyLocationCreateTaxRegistration?: Maybe<CompanyLocationCreateTaxRegistrationPayload>;
  /** Deletes a company location. */
  companyLocationDelete?: Maybe<CompanyLocationDeletePayload>;
  /** Deletes one or more existing mappings between a staff member at a shop and a company location. */
  companyLocationRemoveStaffMembers?: Maybe<CompanyLocationRemoveStaffMembersPayload>;
  /** Revokes roles on a company location. */
  companyLocationRevokeRoles?: Maybe<CompanyLocationRevokeRolesPayload>;
  /**
   * Revokes tax exemptions from the company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  companyLocationRevokeTaxExemptions?: Maybe<CompanyLocationRevokeTaxExemptionsPayload>;
  /**
   * Revokes tax registration on a company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  companyLocationRevokeTaxRegistration?: Maybe<CompanyLocationRevokeTaxRegistrationPayload>;
  /** Sets the tax settings for a company location. */
  companyLocationTaxSettingsUpdate?: Maybe<CompanyLocationTaxSettingsUpdatePayload>;
  /**
   * Updates a company location's information and B2B checkout settings. Company locations are branches or offices where [`CompanyContact`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyContact) members place orders on behalf of the company. Contacts must be assigned to a location through `roleAssignments` to place orders.
   *
   * The mutation modifies details such as the location's name, contact information, preferred locale, and internal notes. You can also configure the B2B checkout experience through [`BuyerExperienceConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BuyerExperienceConfiguration) settings that control whether orders require merchant review, [`PaymentTermsTemplate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTermsTemplate) settings, shipping address editing permissions, and [`DepositConfiguration`](https://shopify.dev/docs/api/admin-graphql/latest/unions/DepositConfiguration) requirements.
   *
   * Learn more about [managing company locations](https://shopify.dev/docs/apps/build/b2b/manage-client-company-locations).
   */
  companyLocationUpdate?: Maybe<CompanyLocationUpdatePayload>;
  /** Deletes a list of company locations. */
  companyLocationsDelete?: Maybe<CompanyLocationsDeletePayload>;
  /** Revokes the main contact from the company. */
  companyRevokeMainContact?: Maybe<CompanyRevokeMainContactPayload>;
  /**
   * Updates a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) with new information. Companies represent business customers that can have multiple contacts and locations with specific pricing, payment terms, and checkout settings.
   *
   * The mutation accepts the company's ID and an input object containing the fields to update. You can modify the company name, add or update internal notes, set an external ID for integration with other systems, or adjust the customer relationship start date.
   *
   * Learn more about [building B2B features](https://shopify.dev/docs/apps/build/b2b/start-building).
   */
  companyUpdate?: Maybe<CompanyUpdatePayload>;
  /** Update or create consent policies in bulk. */
  consentPolicyUpdate?: Maybe<ConsentPolicyUpdatePayload>;
  /** Add tax exemptions for the customer. */
  customerAddTaxExemptions?: Maybe<CustomerAddTaxExemptionsPayload>;
  /**
   * Creates a new [`MailingAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress) for a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer). You can optionally set the address as the customer's default address.
   *
   * You can only add addresses to existing customers. Each customer can have multiple addresses.
   */
  customerAddressCreate?: Maybe<CustomerAddressCreatePayload>;
  /** Deletes a customer's address. */
  customerAddressDelete?: Maybe<CustomerAddressDeletePayload>;
  /** Updates a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s [`MailingAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress). You can modify any field of the address and optionally set it as the customer's default address. */
  customerAddressUpdate?: Maybe<CustomerAddressUpdatePayload>;
  /**
   * Cancels a pending erasure of a customer's data. Read more [here](https://help.shopify.com/manual/privacy-and-security/privacy/processing-customer-data-requests#cancel-customer-data-erasure).
   *
   * To request an erasure of a customer's data use the [customerRequestDataErasure mutation](https://shopify.dev/api/admin-graphql/unstable/mutations/customerRequestDataErasure).
   */
  customerCancelDataErasure?: Maybe<CustomerCancelDataErasurePayload>;
  /**
   * Creates a new [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) in the store.
   *
   * Accepts customer details including contact information, marketing consent preferences, and tax exemptions through the [`CustomerInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CustomerInput) input object. You can also associate [`metafields`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/MetafieldInput) and tags to organize and extend customer data.
   *
   * Apps using protected customer data must meet Shopify's [protected customer data requirements](https://shopify.dev/docs/apps/launch/protected-customer-data#requirements).
   */
  customerCreate?: Maybe<CustomerCreatePayload>;
  /**
   * Deletes a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) from the store. You can only delete customers who haven't placed any [orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
   *
   * Apps using protected customer data must meet Shopify's [protected customer data requirements](https://shopify.dev/docs/apps/launch/protected-customer-data#requirements).
   */
  customerDelete?: Maybe<CustomerDeletePayload>;
  /**
   * Updates a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s email marketing consent information. The customer must have an email address to update their consent. Records the [marketing state](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerEmailAddress#field-marketingState) (such as subscribed, pending, unsubscribed), [opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerEmailAddress#field-marketingOptInLevel), and when and where the customer gave or withdrew consent.
   *
   * Only three values are accepted as input: SUBSCRIBED, UNSUBSCRIBED, and PENDING.
   * NOT_SUBSCRIBED, REDACTED, and INVALID cannot be set via this mutation; they are
   * read-only or internally-set states.
   */
  customerEmailMarketingConsentUpdate?: Maybe<CustomerEmailMarketingConsentUpdatePayload>;
  /**
   * Generates a one-time activation URL for a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) whose legacy customer account isn't yet enabled. Use this after importing customers or creating accounts that need activation.
   *
   * The generated URL expires after 30 days and becomes invalid if you generate a new one.
   *
   * > Note: The generated URL only works when legacy customer accounts are enabled on the shop. It only works for customers with disabled or invited [`account states`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer#field-Customer.fields.state). Attempting to generate a URL for an already-enabled customer returns an error.
   */
  customerGenerateAccountActivationUrl?: Maybe<CustomerGenerateAccountActivationUrlPayload>;
  /**
   * Merges two customers.
   *
   * The `customerOneId` and `customerTwoId` arguments don't guarantee which customer is kept. Shopify
   * selects the resulting customer in this order:
   * 1. If `overrideFields.customerIdOfEmailToKeep` is provided and valid, then the selected customer is kept.
   * 2. If exactly one customer has an email address, then that customer is kept.
   * 3. If both customers have email addresses, then account state and email marketing consent determine
   *    the customer that's kept: an `enabled` account wins over other account states; otherwise, an
   *    `invited` account can win when consent doesn't already prefer `subscribed` or `pending`; otherwise
   *    the consent result is used. If those rules don't prefer either customer, then `customerTwoId` is kept.
   * 4. If neither customer has an email address, then `customerTwoId` is kept.
   *
   * Use `customerMergePreview` and `resultingCustomerId` to check which customer will be kept before merging.
   */
  customerMerge?: Maybe<CustomerMergePayload>;
  /**
   * Creates a vaulted payment method for a customer from duplication data.
   *
   * This data must be obtained from another shop within the same organization.
   *
   * Currently, this only supports Shop Pay payment methods. This is only available for selected partner apps.
   */
  customerPaymentMethodCreateFromDuplicationData?: Maybe<CustomerPaymentMethodCreateFromDuplicationDataPayload>;
  /**
   * Creates a credit card payment method for a customer using a session id.
   * These values are only obtained through card imports happening from a PCI compliant environment.
   * Please use customerPaymentMethodRemoteCreate if you are not managing credit cards directly.
   */
  customerPaymentMethodCreditCardCreate?: Maybe<CustomerPaymentMethodCreditCardCreatePayload>;
  /** Updates an existing vaulted credit card payment method for a customer, including billing address and card details. Requires a valid cardserver session from a PCI-compliant environment. Use this when a customer's card details have changed (e.g., new expiration date or replacement card) and ongoing subscriptions or saved payment methods need to be updated. */
  customerPaymentMethodCreditCardUpdate?: Maybe<CustomerPaymentMethodCreditCardUpdatePayload>;
  /**
   * Returns encrypted data that can be used to duplicate the payment method in another shop within the same organization.
   *
   * Currently, this only supports Shop Pay payment methods. This is only available for selected partner apps.
   */
  customerPaymentMethodGetDuplicationData?: Maybe<CustomerPaymentMethodGetDuplicationDataPayload>;
  /**
   * Returns a URL that allows the customer to update a specific payment method.
   *
   * Currently, `customerPaymentMethodGetUpdateUrl` only supports Shop Pay.
   */
  customerPaymentMethodGetUpdateUrl?: Maybe<CustomerPaymentMethodGetUpdateUrlPayload>;
  /** Creates a vaulted PayPal billing agreement for a customer, enabling recurring charges through PayPal. The billing agreement ID (starting with 'B-') must be obtained from PayPal. Once created, this payment method can be used for subscription billing or future order payments without requiring the customer to re-authenticate with PayPal. */
  customerPaymentMethodPaypalBillingAgreementCreate?: Maybe<CustomerPaymentMethodPaypalBillingAgreementCreatePayload>;
  /** Updates the billing address associated with a customer's vaulted PayPal billing agreement. Use this when a customer's billing information has changed and their PayPal payment method record in Shopify needs to be updated accordingly. */
  customerPaymentMethodPaypalBillingAgreementUpdate?: Maybe<CustomerPaymentMethodPaypalBillingAgreementUpdatePayload>;
  /**
   * Creates a customer payment method using identifiers from remote payment gateways like Stripe, Authorize.Net, or Braintree. Imports existing payment methods from external gateways and associates them with [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) objects in Shopify.
   *
   * The operation processes payment methods asynchronously. The returned [`CustomerPaymentMethod`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPaymentMethod) initially has incomplete details while Shopify validates and processes the remote gateway information. Use the [`customerPaymentMethod`](https://shopify.dev/docs/api/admin-graphql/latest/queries/customerPaymentMethod) query to retrieve the payment method status until all details are available or the payment method is revoked.
   *
   * Learn more about [migrating customer payment methods from remote gateways](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/migrate-to-subscriptions-api/migrate-customer-information#step-2-import-payment-methods-for-customers).
   */
  customerPaymentMethodRemoteCreate?: Maybe<CustomerPaymentMethodRemoteCreatePayload>;
  /** Revokes a customer's vaulted payment method, preventing it from being used for future charges such as subscriptions, draft orders, or other payments. Revocation will fail if the payment method has active subscription contracts. Use this when a customer requests removal of their stored payment information or when a payment method is no longer valid. */
  customerPaymentMethodRevoke?: Maybe<CustomerPaymentMethodRevokePayload>;
  /** Sends an email to a customer containing a secure link to update a specific vaulted payment method. This is commonly used when a customer's credit card is expiring or has been declined, and they need to provide updated payment details for ongoing subscriptions. The email can be customized with sender and BCC fields. */
  customerPaymentMethodSendUpdateEmail?: Maybe<CustomerPaymentMethodSendUpdateEmailPayload>;
  /** Remove tax exemptions from a customer. */
  customerRemoveTaxExemptions?: Maybe<CustomerRemoveTaxExemptionsPayload>;
  /** Replace tax exemptions for a customer. */
  customerReplaceTaxExemptions?: Maybe<CustomerReplaceTaxExemptionsPayload>;
  /**
   * Enqueues a request to erase customer's data. Read more [here](https://help.shopify.com/manual/privacy-and-security/privacy/processing-customer-data-requests#erase-customer-personal-data).
   *
   * To cancel the data erasure request use the [customerCancelDataErasure mutation](https://shopify.dev/api/admin-graphql/unstable/mutations/customerCancelDataErasure).
   */
  customerRequestDataErasure?: Maybe<CustomerRequestDataErasurePayload>;
  /** Creates a customer segment members query. */
  customerSegmentMembersQueryCreate?: Maybe<CustomerSegmentMembersQueryCreatePayload>;
  /**
   * Sends an email invitation for a customer to create a legacy customer account. The invitation lets customers set up their password and activate their account in the online store.
   *
   * You can optionally customize the email content including the subject, sender, recipients, and message body. If you don't provide email customization, the store uses its default account invitation template.
   *
   * > Note: The invite only works when legacy customer accounts are enabled on the shop.
   */
  customerSendAccountInviteEmail?: Maybe<CustomerSendAccountInviteEmailPayload>;
  /**
   * Creates or updates a customer in a single mutation.
   *
   * Use this mutation when syncing information from an external data source into Shopify.
   *
   * This mutation can be used to create a new customer, update an existing customer by id, or
   * upsert a customer by a unique key (email or phone).
   *
   * To create a new customer omit the `identifier` argument.
   * To update an existing customer, include the `identifier` with the id of the customer to update.
   *
   * To perform an 'upsert' by unique key (email or phone)
   * use the `identifier` argument to upsert a customer by a unique key (email or phone). If a customer
   * with the specified unique key exists, it will be updated. If not, a new customer will be created with
   * that unique key.
   *
   * As of API version 2022-10, apps using protected customer data must meet the
   * protected customer data [requirements](https://shopify.dev/apps/store/data-protection/protected-customer-data)
   *
   * Any list field (e.g.
   * [addresses](https://shopify.dev/api/admin-graphql/unstable/input-objects/MailingAddressInput),
   * will be updated so that all included entries are either created or updated, and all existing entries not
   * included will be deleted.
   *
   * All other fields will be updated to the value passed. Omitted fields will not be updated.
   */
  customerSet?: Maybe<CustomerSetPayload>;
  /**
   * Updates a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s SMS marketing consent information. The customer must have a phone number on their account to receive SMS marketing.
   *
   * You can set whether the customer subscribes or unsubscribes to SMS marketing and specify the [opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerSmsMarketingConsentUpdate#arguments-input.fields.smsMarketingConsent.marketingOptInLevel). Optionally include when the consent was collected and which [location](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerSmsMarketingConsentUpdate#arguments-input.fields.smsMarketingConsent.sourceLocationId) collected it.
   */
  customerSmsMarketingConsentUpdate?: Maybe<CustomerSmsMarketingConsentUpdatePayload>;
  /**
   * Updates a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s attributes including personal information and [`tax exemptions`](https://shopify.dev/docs/api/admin-graphql/latest/enums/TaxExemption).
   *
   * Apps using protected customer data must meet Shopify's [protected customer data requirements](https://shopify.dev/docs/apps/launch/protected-customer-data#requirements).
   */
  customerUpdate?: Maybe<CustomerUpdatePayload>;
  /** Updates a customer's default address. */
  customerUpdateDefaultAddress?: Maybe<CustomerUpdateDefaultAddressPayload>;
  /**
   * Updates a [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)'s WhatsApp marketing consent information. Shopify identifies the customer's WhatsApp account by their [phone number](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPhoneNumber).
   *
   * You can subscribe or unsubscribe the customer from WhatsApp marketing and specify the [opt-in level](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate#arguments-input.fields.whatsAppMarketingConsent.optInLevel). You can also include when and [where](https://shopify.dev/docs/api/admin-graphql/latest/mutations/customerWhatsAppMarketingConsentUpdate#arguments-input.fields.whatsAppMarketingConsent.sourceLocationId) the consent was collected.
   */
  customerWhatsAppMarketingConsentUpdate?: Maybe<CustomerWhatsAppMarketingConsentUpdatePayload>;
  /** Opt out a customer from data sale. */
  dataSaleOptOut?: Maybe<DataSaleOptOutPayload>;
  /**
   * Creates a [`DelegateAccessToken`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DelegateAccessToken) with a subset of the parent token's permissions.
   *
   * Delegate access tokens enable secure permission delegation to subsystems or services that need limited access to shop resources. Each token inherits only the scopes you specify, ensuring subsystems operate with minimal required permissions rather than full app access.
   *
   * Learn more about [delegating access tokens to subsystems](https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/use-delegate-tokens).
   */
  delegateAccessTokenCreate?: Maybe<DelegateAccessTokenCreatePayload>;
  /** Destroys a delegate access token. */
  delegateAccessTokenDestroy?: Maybe<DelegateAccessTokenDestroyPayload>;
  /** Activates and deactivates delivery customizations. */
  deliveryCustomizationActivation?: Maybe<DeliveryCustomizationActivationPayload>;
  /** Creates a delivery customization. */
  deliveryCustomizationCreate?: Maybe<DeliveryCustomizationCreatePayload>;
  /** Creates a delivery customization. */
  deliveryCustomizationDelete?: Maybe<DeliveryCustomizationDeletePayload>;
  /** Updates a delivery customization. */
  deliveryCustomizationUpdate?: Maybe<DeliveryCustomizationUpdatePayload>;
  /**
   * Creates a [`DeliveryProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryProfile) that defines shipping rates for specific products and locations.
   *
   * A delivery profile groups products with their shipping zones and rates. You can associate profiles with [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to customize shipping for subscriptions and pre-orders. Each profile contains [`DeliveryProfileLocationGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryProfileLocationGroup) objects that specify which [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects ship to which [`DeliveryZone`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryZone) objects with specific [`DeliveryMethodDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryMethodDefinition) objects and rates.
   *
   * Learn more about [building delivery profiles](https://shopify.dev/docs/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
   */
  deliveryProfileCreate?: Maybe<DeliveryProfileCreatePayload>;
  /** Enqueue the removal of a delivery profile. */
  deliveryProfileRemove?: Maybe<DeliveryProfileRemovePayload>;
  /**
   * Updates a [`DeliveryProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryProfile)'s configuration, including its shipping zones, rates, and associated products.
   *
   * Modify location groups to control which fulfillment [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects serve specific geographic areas. Add or remove shipping zones with custom countries and provinces. Create or update shipping methods with rate definitions and delivery conditions. Associate or dissociate [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects and [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects to determine which products use this profile's shipping rules.
   *
   * The mutation supports partial updates through dedicated input fields for creating, updating, and deleting specific components without affecting the entire profile structure.
   *
   * Learn more about [building delivery profiles](https://shopify.dev/docs/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles).
   */
  deliveryProfileUpdate?: Maybe<DeliveryProfileUpdatePayload>;
  /** Updates the delivery promise participants by adding or removing owners based on a branded promise handle. */
  deliveryPromiseParticipantsUpdate?: Maybe<DeliveryPromiseParticipantsUpdatePayload>;
  /** Creates or updates a delivery promise provider. Currently restricted to select approved delivery promise partners. */
  deliveryPromiseProviderUpsert?: Maybe<DeliveryPromiseProviderUpsertPayload>;
  /** Set the delivery settings for a shop. */
  deliverySettingUpdate?: Maybe<DeliverySettingUpdatePayload>;
  /**
   * Assigns a location as the shipping origin while using legacy compatibility mode for multi-location delivery profiles.
   * Deprecated as of 2026-04 and will be removed in a future version as single origin shipping mode has been retired.
   * @deprecated Single origin shipping mode is no longer supported.
   */
  deliveryShippingOriginAssign?: Maybe<DeliveryShippingOriginAssignPayload>;
  /** Activates an automatic discount. */
  discountAutomaticActivate?: Maybe<DiscountAutomaticActivatePayload>;
  /**
   * Creates an automatic discount that's managed by an app.
   * Use this mutation with [Shopify Functions](https://shopify.dev/docs/apps/build/functions)
   * when you need advanced, custom, or dynamic discount capabilities that aren't supported by
   * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to create an automatic discount using an app's
   * "Volume" discount type that applies a percentage
   * off when customers purchase more than the minimum quantity of a product. For an example implementation,
   * refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To create code discounts with custom logic, use the
   * [`discountCodeAppCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeAppCreate)
   * mutation.
   */
  discountAutomaticAppCreate?: Maybe<DiscountAutomaticAppCreatePayload>;
  /**
   * Updates an existing automatic discount that's managed by an app using
   * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
   * Use this mutation when you need advanced, custom, or
   * dynamic discount capabilities that aren't supported by
   * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to update a new "Volume" discount type that applies a percentage
   * off when customers purchase more than the minimum quantity of a product. For an example implementation,
   * refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To update code discounts with custom logic, use the
   * [`discountCodeAppUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeAppUpdate)
   * mutation instead.
   */
  discountAutomaticAppUpdate?: Maybe<DiscountAutomaticAppUpdatePayload>;
  /**
   * Creates an
   * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To create code discounts, use the
   * [`discountCodeBasicCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicCreate)
   * mutation.
   */
  discountAutomaticBasicCreate?: Maybe<DiscountAutomaticBasicCreatePayload>;
  /**
   * Updates an existing
   * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To update code discounts, use the
   * [`discountCodeBasicUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicUpdate)
   * mutation instead.
   */
  discountAutomaticBasicUpdate?: Maybe<DiscountAutomaticBasicUpdatePayload>;
  /**
   * Deletes multiple automatic discounts in a single operation, providing efficient bulk management for stores with extensive discount catalogs. This mutation processes deletions asynchronously to handle large volumes without blocking other operations.
   *
   * For example, when cleaning up expired seasonal promotions or removing outdated automatic discounts across product categories, merchants can delete dozens of discounts simultaneously rather than processing each individually.
   *
   * Use `DiscountAutomaticBulkDelete` to:
   * - Remove multiple automatic discounts efficiently
   * - Clean up expired or obsolete promotions
   * - Streamline discount management workflows
   * - Process large-scale discount removals asynchronously
   *
   * The operation returns a job object for tracking deletion progress and any validation errors encountered during processing.
   *
   * Learn more about [discount management](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomatic).
   */
  discountAutomaticBulkDelete?: Maybe<DiscountAutomaticBulkDeletePayload>;
  /**
   * Creates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To create code discounts, use the
   * [`discountCodeBxgyCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBxgyCreate)
   * mutation.
   */
  discountAutomaticBxgyCreate?: Maybe<DiscountAutomaticBxgyCreatePayload>;
  /**
   * Updates an existing
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To update code discounts, use the
   * [`discountCodeBxgyUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBxgyUpdate)
   * mutation instead.
   */
  discountAutomaticBxgyUpdate?: Maybe<DiscountAutomaticBxgyUpdatePayload>;
  /** Deactivates an automatic discount. */
  discountAutomaticDeactivate?: Maybe<DiscountAutomaticDeactivatePayload>;
  /**
   * Deletes an existing automatic discount from the store, permanently removing it from all future order calculations. This mutation provides a clean way to remove promotional campaigns that are no longer needed.
   *
   * For example, when a seasonal promotion ends or a flash sale concludes, merchants can use this mutation to ensure the discount no longer applies to new orders while preserving historical order data.
   *
   * Use `DiscountAutomaticDelete` to:
   * - Remove expired promotional campaigns
   * - Clean up test discounts during development
   * - Delete automatic discounts that conflict with new promotions
   * - Maintain a clean discount configuration
   *
   * The mutation returns the ID of the deleted discount for confirmation and any validation errors if the deletion cannot be completed. Once deleted, the automatic discount will no longer appear in discount lists or apply to new customer orders.
   */
  discountAutomaticDelete?: Maybe<DiscountAutomaticDeletePayload>;
  /**
   * Creates automatic free shipping discounts that apply to qualifying orders without requiring discount codes. These promotions automatically activate when customers meet specified criteria, streamlining the checkout experience.
   *
   * For example, a store might create an automatic free shipping discount for orders over variable pricing to encourage larger purchases, or offer free shipping to specific customer segments during promotional periods.
   *
   * Use `DiscountAutomaticFreeShippingCreate` to:
   * - Set up code-free shipping promotions
   * - Create order value-based shipping incentives
   * - Target specific customer groups with shipping benefits
   * - Establish location-based shipping discounts
   *
   * The mutation validates discount configuration and returns the created automatic discount node along with any configuration errors that need resolution.
   *
   * Learn more about [automatic discounts](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticNode).
   */
  discountAutomaticFreeShippingCreate?: Maybe<DiscountAutomaticFreeShippingCreatePayload>;
  /**
   * Updates existing automatic free shipping discounts, allowing merchants to modify promotion criteria, shipping destinations, and eligibility requirements without recreating the entire discount structure.
   *
   * For example, extending a holiday free shipping promotion to include additional countries, adjusting the minimum order value threshold, or expanding customer eligibility to include new segments.
   *
   * Use `DiscountAutomaticFreeShippingUpdate` to:
   * - Modify shipping discount thresholds and criteria
   * - Expand or restrict geographic availability
   * - Update customer targeting and eligibility rules
   * - Adjust promotion timing and activation periods
   *
   * Changes take effect immediately for new orders, while the mutation validates all modifications and reports any configuration conflicts through user errors.
   *
   * Learn more about [managing automatic discounts](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping).
   */
  discountAutomaticFreeShippingUpdate?: Maybe<DiscountAutomaticFreeShippingUpdatePayload>;
  /**
   * Adds tags to multiple [discounts](https://help.shopify.com/manual/discounts/discount-types) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount IDs
   *
   * For example, you can add tags to price rules that match a search criteria, or add tags to a predefined set of price rules.
   */
  discountBulkTagsAdd?: Maybe<DiscountBulkTagsAddPayload>;
  /**
   * Removes tags from multiple [discounts](https://help.shopify.com/manual/discounts/discount-types) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount IDs
   *
   * For example, you can delete tags from price rules that match a search criteria, or delete tags from a predefined set of price rules.
   */
  discountBulkTagsRemove?: Maybe<DiscountBulkTagsRemovePayload>;
  /**
   * Activates a previously created code discount, making it available for customers to use during checkout. This mutation transitions inactive discount codes into an active state where they can be applied to orders.
   *
   * For example, after creating a "SUMMER20" discount code but leaving it inactive during setup, merchants can activate it when ready to launch their summer promotion campaign.
   *
   * Use `DiscountCodeActivate` to:
   * - Launch scheduled promotional campaigns
   * - Reactivate previously paused discount codes
   * - Enable discount codes after configuration changes
   * - Control the timing of discount availability
   *
   * The mutation returns the updated discount code node with its new active status and handles any validation errors that might prevent activation, such as conflicting discount rules or invalid date ranges.
   */
  discountCodeActivate?: Maybe<DiscountCodeActivatePayload>;
  /**
   * Creates a code discount. The discount type must be provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions). Functions can implement [order](https://shopify.dev/docs/api/functions/reference/order-discounts), [product](https://shopify.dev/docs/api/functions/reference/product-discounts), or [shipping](https://shopify.dev/docs/api/functions/reference/shipping-discounts) discount functions. Use this mutation with Shopify Functions when you need custom logic beyond [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to create a code discount using an app's "Volume" discount type that applies a percentage off when customers purchase more than the minimum quantity
   * of a product. For an example implementation, refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To create automatic discounts with custom logic, use [`discountAutomaticAppCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticAppCreate).
   */
  discountCodeAppCreate?: Maybe<DiscountCodeAppCreatePayload>;
  /**
   * Updates a code discount, where the discount type is provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions). Use this mutation when you need advanced, custom, or dynamic discount capabilities that aren't supported by [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * > Note:
   * > To update automatic discounts, use [`discountAutomaticAppUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticAppUpdate).
   */
  discountCodeAppUpdate?: Maybe<DiscountCodeAppUpdatePayload>;
  /**
   * Creates an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticBasicCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBasicCreate) mutation.
   */
  discountCodeBasicCreate?: Maybe<DiscountCodeBasicCreatePayload>;
  /**
   * Updates an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off.
   *
   * > Note:
   * > To update discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticBasicUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBasicUpdate) mutation.
   */
  discountCodeBasicUpdate?: Maybe<DiscountCodeBasicUpdatePayload>;
  /**
   * Activates multiple [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can activate discounts for all codes that match a search criteria, or activate a predefined set of discount codes.
   */
  discountCodeBulkActivate?: Maybe<DiscountCodeBulkActivatePayload>;
  /**
   * Deactivates multiple [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can deactivate discounts for all codes that match a search criteria, or deactivate a predefined set of discount codes.
   */
  discountCodeBulkDeactivate?: Maybe<DiscountCodeBulkDeactivatePayload>;
  /**
   * Deletes multiple [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can delete discounts for all codes that match a search criteria, or delete a predefined set of discount codes.
   */
  discountCodeBulkDelete?: Maybe<DiscountCodeBulkDeletePayload>;
  /**
   * Creates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the
   * [`discountAutomaticBxgyCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBxgyCreate)
   * mutation.
   */
  discountCodeBxgyCreate?: Maybe<DiscountCodeBxgyCreatePayload>;
  /**
   * Updates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To update discounts that are automatically applied on a cart and at checkout, use the
   * [`discountAutomaticBxgyUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBxgyUpdate)
   * mutation.
   */
  discountCodeBxgyUpdate?: Maybe<DiscountCodeBxgyUpdatePayload>;
  /**
   * Temporarily suspends a code discount without permanently removing it from the store. Deactivation allows merchants to pause promotional campaigns while preserving the discount configuration for potential future use.
   *
   * For example, when a flash sale needs to end immediately or a discount code requires temporary suspension due to inventory issues, merchants can deactivate it to stop new redemptions while keeping the discount structure intact.
   *
   * Use `DiscountCodeDeactivate` to:
   * - Pause active promotional campaigns timely
   * - Temporarily suspend problematic discount codes
   * - Control discount availability during inventory shortages
   * - Maintain discount history while stopping usage
   *
   * Deactivated discounts remain in the system and can be reactivated later, unlike deletion which persistently removes the code. Customers attempting to use deactivated codes will receive appropriate error messages.
   */
  discountCodeDeactivate?: Maybe<DiscountCodeDeactivatePayload>;
  /**
   * Removes a code discount from the store, making it permanently unavailable for customer use. This mutation provides a clean way to eliminate discount codes that are no longer needed or have been replaced.
   *
   * For example, when a seasonal promotion ends or a discount code has been compromised, merchants can delete it entirely rather than just deactivating it, ensuring customers cannot attempt to use expired promotional codes.
   *
   * Use `DiscountCodeDelete` to:
   * - persistently remove outdated promotional codes
   * - Clean up discount code lists after campaigns end
   * - Eliminate compromised or leaked discount codes
   * - Maintain organized discount management
   *
   * Once deleted, the discount code cannot be recovered and any customer attempts to use it will fail. This differs from deactivation, which preserves the code for potential future reactivation.
   */
  discountCodeDelete?: Maybe<DiscountCodeDeletePayload>;
  /**
   * Creates an [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticFreeShippingCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticFreeShippingCreate) mutation.
   */
  discountCodeFreeShippingCreate?: Maybe<DiscountCodeFreeShippingCreatePayload>;
  /**
   * Updates a [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To update a free shipping discount that's automatically applied on a cart and at checkout, use the [`discountAutomaticFreeShippingUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticFreeShippingUpdate) mutation.
   */
  discountCodeFreeShippingUpdate?: Maybe<DiscountCodeFreeShippingUpdatePayload>;
  /**
   * Asynchronously delete
   * [discount codes](https://help.shopify.com/manual/discounts/discount-types#discount-codes)
   * in bulk that customers can use to redeem a discount.
   */
  discountCodeRedeemCodeBulkDelete?: Maybe<DiscountCodeRedeemCodeBulkDeletePayload>;
  /**
   * Asynchronously add
   * [discount codes](https://help.shopify.com/manual/discounts/discount-types#discount-codes)
   * in bulk that customers can use to redeem a discount. You can use the `discountRedeemCodeBulkAdd` mutation
   * to automate the distribution of discount codes through emails or other
   * marketing channels.
   */
  discountRedeemCodeBulkAdd?: Maybe<DiscountRedeemCodeBulkAddPayload>;
  /** Updates the evidence package for a Shopify Payments dispute. Merchants submit evidence — such as shipping confirmations, customer communications, and refund policies — to contest a dispute filed by a cardholder. This mutation updates the evidence fields. */
  disputeEvidenceUpdate?: Maybe<DisputeEvidenceUpdatePayload>;
  /** Adds tags to multiple draft orders. */
  draftOrderBulkAddTags?: Maybe<DraftOrderBulkAddTagsPayload>;
  /** Deletes multiple draft orders. */
  draftOrderBulkDelete?: Maybe<DraftOrderBulkDeletePayload>;
  /** Removes tags from multiple draft orders. */
  draftOrderBulkRemoveTags?: Maybe<DraftOrderBulkRemoveTagsPayload>;
  /**
   * Calculates the properties of a [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) without creating it. Returns pricing information including [`CalculatedDraftOrderLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedDraftOrderLineItem) totals, shipping charges, applicable discounts, and tax calculations based on the provided [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) and [`MailingAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress) information.
   *
   * Use this mutation to preview total taxes and prices before creating a draft order. It's particularly useful when working with B2B [`PurchasingEntity`](https://shopify.dev/docs/api/admin-graphql/latest/unions/PurchasingEntity) or when you need to determine costs without committing to a draft order. Learn more about [calculating draft orders for B2B purchasing entities](https://shopify.dev/docs/apps/build/b2b/draft-orders#step-1-calculate-a-draft-order-for-a-purchasing-entity).
   */
  draftOrderCalculate?: Maybe<DraftOrderCalculatePayload>;
  /**
   * Completes a [draft order](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) and
   * converts it into a [regular order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
   * The order appears in the merchant's orders list, and the customer can be notified about their order.
   *
   * Use the `draftOrderComplete` mutation when a merchant is ready to finalize a draft order and create a real
   * order in their store. The `draftOrderComplete` mutation also supports sales channel attribution for tracking
   * order sources using the [`sourceName`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderComplete#arguments-sourceName)
   * argument, [cart validation](https://shopify.dev/docs/apps/build/checkout/cart-checkout-validation)
   * controls for app integrations, and detailed error reporting for failed completions.
   *
   * You can complete a draft order with different [payment scenarios](https://help.shopify.com/manual/fulfillment/managing-orders/payments):
   *
   * - Mark the order as paid immediately.
   * - Set the order as payment pending using [payment terms](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms).
   * - Specify a custom payment amount.
   * - Select a specific payment gateway.
   *
   * > Note:
   * > When completing a draft order, inventory is [committed](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states)
   * for the items in the order. This means the items will no longer be available for other customers to purchase.
   * Make sure to verify inventory availability before completing the draft order.
   */
  draftOrderComplete?: Maybe<DraftOrderCompletePayload>;
  /**
   * Creates a [draft order](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder)
   * with attributes such as customer information, line items, shipping and billing addresses, and payment terms.
   * Draft orders are useful for merchants that need to:
   *
   * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
   * - Send invoices to customers with a secure checkout link.
   * - Use custom items to represent additional costs or products not in inventory.
   * - Re-create orders manually from active sales channels.
   * - Sell products at discount or wholesale rates.
   * - Take pre-orders.
   *
   * After creating a draft order, you can:
   * - Send an invoice to the customer using the [`draftOrderInvoiceSend`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderInvoiceSend) mutation.
   * - Complete the draft order using the [`draftOrderComplete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderComplete) mutation.
   * - Update the draft order using the [`draftOrderUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderUpdate) mutation.
   * - Duplicate a draft order using the [`draftOrderDuplicate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderDuplicate) mutation.
   * - Delete the draft order using the [`draftOrderDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderDelete) mutation.
   *
   * > Note:
   * > When you create a draft order, you can't [reserve or hold inventory](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) for the items in the order by default.
   * > However, you can reserve inventory using the [`reserveInventoryUntil`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderCreate#arguments-input.fields.reserveInventoryUntil) input.
   */
  draftOrderCreate?: Maybe<DraftOrderCreatePayload>;
  /** Creates a draft order from order. */
  draftOrderCreateFromOrder?: Maybe<DraftOrderCreateFromOrderPayload>;
  /** Deletes a draft order. */
  draftOrderDelete?: Maybe<DraftOrderDeletePayload>;
  /** Duplicates a draft order. */
  draftOrderDuplicate?: Maybe<DraftOrderDuplicatePayload>;
  /** Previews a draft order invoice email. */
  draftOrderInvoicePreview?: Maybe<DraftOrderInvoicePreviewPayload>;
  /** Sends an invoice email for a [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder). The invoice includes a secure checkout link for reviewing and paying for the order. Use the [`email`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderInvoiceSend#arguments-email) argument to customize the email, such as the subject and message. */
  draftOrderInvoiceSend?: Maybe<DraftOrderInvoiceSendPayload>;
  /**
   * Updates a draft order.
   *
   * If a checkout has been started for a draft order, any update to the draft will unlink the checkout. Checkouts
   * are created but not immediately completed when opening the merchant credit card modal in the admin, and when a
   * buyer opens the invoice URL. This is usually fine, but there is an edge case where a checkout is in progress
   * and the draft is updated before the checkout completes. This will not interfere with the checkout and order
   * creation, but if the link from draft to checkout is broken the draft will remain open even after the order is
   * created.
   */
  draftOrderUpdate?: Maybe<DraftOrderUpdatePayload>;
  /**
   * Updates the server pixel to connect to an EventBridge endpoint.
   * Running this mutation deletes any previous subscriptions for the server pixel.
   */
  eventBridgeServerPixelUpdate?: Maybe<EventBridgeServerPixelUpdatePayload>;
  /**
   * Creates a webhook subscription that notifies your [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) when specific events occur in a shop. Webhooks push event data to your endpoint immediately when changes happen, eliminating the need for polling.
   *
   * This mutation configures webhook delivery to an Amazon EventBridge partner event source. You can filter events using [Shopify API search syntax](https://shopify.dev/docs/api/usage/search-syntax) to receive only relevant webhooks, control which data fields are included in webhook payloads, and specify metafield namespaces to include.
   *
   * > Note:
   * > The Webhooks API version [configured in your app](https://shopify.dev/docs/apps/build/webhooks/subscribe/use-newer-api-version) determines the API version for webhook events. You can't specify it per subscription.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   * @deprecated Use `webhookSubscriptionCreate` instead.
   */
  eventBridgeWebhookSubscriptionCreate?: Maybe<EventBridgeWebhookSubscriptionCreatePayload>;
  /**
   * Updates an Amazon EventBridge webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   * @deprecated Use `webhookSubscriptionUpdate` instead.
   */
  eventBridgeWebhookSubscriptionUpdate?: Maybe<EventBridgeWebhookSubscriptionUpdatePayload>;
  extensions: ShopifyGraphQlExtensions;
  /** Acknowledges file update failure by resetting FAILED status to READY and clearing any media errors. */
  fileAcknowledgeUpdateFailed?: Maybe<FileAcknowledgeUpdateFailedPayload>;
  /**
   * Creates file assets for a store from external URLs or files that were previously uploaded using the
   * [`stagedUploadsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/stageduploadscreate)
   * mutation.
   *
   * Use the `fileCreate` mutation to add various types of media and documents to your store. These files are added to the
   * [**Files** page](https://shopify.com/admin/settings/files) in the Shopify admin and can be referenced by other
   * resources in your store.
   *
   * The `fileCreate` mutation supports multiple file types:
   *
   * - **Images**: Product photos, variant images, and general store imagery
   * - **Videos**: Shopify-hosted videos for product demonstrations and marketing
   * - **External videos**: YouTube and Vimeo videos for enhanced product experiences
   * - **3D models**: Interactive 3D representations of products
   * - **Generic files**: PDFs, documents, and other file types for store resources
   *
   * The mutation handles duplicate filenames using configurable resolution modes that automatically append UUIDs,
   * replace existing files, or raise errors when conflicts occur.
   *
   * > Note:
   * > Files are processed asynchronously. Check the
   * > [`fileStatus`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/File#fields-fileStatus)
   * > field to monitor processing completion. The maximum number of files that can be created in a single batch is 250.
   *
   * After creating files, you can make subsequent updates using the following mutations:
   *
   * - [`fileUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fileUpdate):
   * Update file properties such as alt text or replace file contents while preserving the same URL.
   * - [`fileDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fileDelete):
   * Remove files from your store when they are no longer needed.
   *
   * To list all files in your store, use the
   * [`files`](https://shopify.dev/docs/api/admin-graphql/latest/queries/files) query.
   *
   * Learn how to manage
   * [product media and file assets](https://shopify.dev/docs/apps/build/online-store/product-media)
   * in your app.
   */
  fileCreate?: Maybe<FileCreatePayload>;
  /**
   * Deletes file assets that were previously uploaded to your store.
   *
   * Use the `fileDelete` mutation to permanently remove media and file assets from your store when they are no longer needed.
   * This mutation handles the complete removal of files from both your store's file library and any associated references
   * to products or other resources.
   *
   * The `fileDelete` mutation supports removal of multiple file types:
   *
   * - **Images**: Product photos, variant images, and general store imagery
   * - **Videos**: Shopify-hosted videos for product demonstrations and marketing content
   * - **External Videos**: YouTube and Vimeo videos linked to your products
   * - **3D models**: Interactive 3D representations of products
   * - **Generic files**: PDFs, documents, and other file types stored in your
   * [**Files** page](https://shopify.com/admin/settings/files)
   *
   * When you delete files that are referenced by products, the mutation automatically removes those references and
   * reorders any remaining media to maintain proper positioning. Product file references are database relationships
   * managed through a media reference system, not just links in product descriptions. The Shopify admin provides a UI
   * to manage these relationships, and when files are deleted, the system automatically cleans up all references.
   * Files that are currently being processed by other operations are rejected to prevent conflicts.
   *
   * > Caution:
   * > File deletion is permanent and can't be undone. When you delete a file that's being used in your store,
   * > it will immediately stop appearing wherever it was displayed. For example, if you delete a product image,
   * > that product will show a broken image or placeholder on your storefront and in the admin. The same applies
   * > to any other files linked from themes, blog posts, or pages. Before deleting files, you can use the
   * > [`files` query](https://shopify.dev/api/admin-graphql/latest/queries/files) to list and review
   * > your store's file assets.
   *
   * Learn how to manage
   * [product media and file assets](https://shopify.dev/docs/apps/build/online-store/product-media)
   * in your app.
   */
  fileDelete?: Maybe<FileDeletePayload>;
  /**
   * Updates properties, content, and metadata associated with an existing file asset that has already been uploaded to Shopify.
   *
   * Use the `fileUpdate` mutation to modify various aspects of files already stored in your store.
   * Files can be updated individually or in batches.
   *
   * The `fileUpdate` mutation supports updating multiple file properties:
   *
   * - **Alt text**: Update accessibility descriptions for images and other media.
   * - **File content**: Replace image or generic file content while maintaining the same URL.
   * - **Filename**: Modify file names (extension must match the original).
   * - **Product references**: Add or remove associations between files and products. Removing file-product associations
   * deletes the file from the product's media gallery and clears the image from any product variants that were using it.
   *
   * The mutation handles different file types with specific capabilities:
   *
   * - **Images**: Update preview images, original source, filename, and alt text.
   * - **Generic files**: Update original source, filename, and alt text.
   * - **Videos and 3D models**: Update alt text and product references.
   *
   * > Note:
   * > Files must be in `ready` state before they can be updated. The mutation includes file locking to prevent
   * > conflicts during updates. You can't simultaneously update both `originalSource` and `previewImageSource`.
   *
   * After updating files, you can use related mutations for additional file management:
   *
   * - [`fileCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fileCreate):
   * Create new file assets from external URLs or staged uploads.
   * - [`fileDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fileDelete):
   * Remove files from your store when they are no longer needed.
   *
   * Learn how to manage
   * [product media and file assets](https://shopify.dev/docs/apps/build/online-store/product-media)
   * in your app.
   */
  fileUpdate?: Maybe<FileUpdatePayload>;
  /** Generates a signature for a Flow action payload. */
  flowGenerateSignature?: Maybe<FlowGenerateSignaturePayload>;
  /** Triggers any workflows that begin with the trigger specified in the request body. To learn more, refer to [_Create Shopify Flow triggers_](https://shopify.dev/apps/flow/triggers). */
  flowTriggerReceive?: Maybe<FlowTriggerReceivePayload>;
  /**
   * Cancels an existing [`Fulfillment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Fulfillment) and reverses its effects on associated [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. When you cancel a fulfillment, the system creates new fulfillment orders for the cancelled items so they can be fulfilled again.
   *
   * The cancellation affects fulfillment orders differently based on their fulfillment status. If a fulfillment order was entirely fulfilled, then it automatically closes. If a fulfillment order is partially fulfilled, then the remaining quantities adjust to include the cancelled items. The system creates new fulfillment orders at the original [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) when items are still stocked there, or at alternative locations based on the store's fulfillment priority settings.
   *
   * Learn more about [canceling fulfillments](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-7-cancel-a-fulfillment).
   */
  fulfillmentCancel?: Maybe<FulfillmentCancelPayload>;
  /** Creates a fulfillment constraint rule and its metafield. */
  fulfillmentConstraintRuleCreate?: Maybe<FulfillmentConstraintRuleCreatePayload>;
  /** Deletes a fulfillment constraint rule and its metafields. */
  fulfillmentConstraintRuleDelete?: Maybe<FulfillmentConstraintRuleDeletePayload>;
  /** Update a fulfillment constraint rule. */
  fulfillmentConstraintRuleUpdate?: Maybe<FulfillmentConstraintRuleUpdatePayload>;
  /**
   * Creates a fulfillment for one or more [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects. The fulfillment orders are associated with the same [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) and are assigned to the same [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location).
   *
   * Use this mutation to mark items as fulfilled when they're ready to ship. You can specify tracking information, customer notification preferences, and which [`FulfillmentOrderLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentorderlineitem) objects to fulfill from each fulfillment order. If you don't specify line items, then the mutation fulfills all items in the fulfillment order.
   *
   * Learn more about [building fulfillment solutions](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/build-fulfillment-solutions#create-a-fulfillment).
   */
  fulfillmentCreate?: Maybe<FulfillmentCreatePayload>;
  /**
   * Creates a fulfillment for one or many fulfillment orders.
   * The fulfillment orders are associated with the same order and are assigned to the same location.
   * @deprecated Use `fulfillmentCreate` instead.
   */
  fulfillmentCreateV2?: Maybe<FulfillmentCreateV2Payload>;
  /**
   * Creates a [`FulfillmentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) to track the shipment status and location of items that have shipped. Events capture status updates like carrier pickup, in transit, out for delivery, or delivered.
   *
   * Each event records the timestamp and current status of the [`Fulfillment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Fulfillment). You can include optional details such as the location where the event occurred, estimated arrival time, and messages for tracking purposes.
   */
  fulfillmentEventCreate?: Maybe<FulfillmentEventCreatePayload>;
  /** Accept a cancellation request sent to a fulfillment service for a fulfillment order. */
  fulfillmentOrderAcceptCancellationRequest?: Maybe<FulfillmentOrderAcceptCancellationRequestPayload>;
  /**
   * Accepts a fulfillment request that the fulfillment service has received for a [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) which signals that the fulfillment service will process and fulfill the order. The fulfillment service can optionally provide a message to the merchant and an estimated shipped date when accepting the request.
   *
   * Learn more about [accepting fulfillment requests](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#accept-a-fulfillment-request).
   */
  fulfillmentOrderAcceptFulfillmentRequest?: Maybe<FulfillmentOrderAcceptFulfillmentRequestPayload>;
  /**
   * Cancels a [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) and creates a replacement fulfillment order to represent the work left to be done. The original fulfillment order will be marked as closed.
   *
   * This mutation works when the fulfillment order has a `SUBMITTED` or `CANCELLATION_REQUESTED` status. For `SUBMITTED` orders, cancellation happens immediately because the fulfillment service hasn't accepted the request.
   *
   * > Note: Orders that have had cancellation requested but the cancellation has yet to be accepted by the fulfillment service might still have work completed despite cancellation.
   */
  fulfillmentOrderCancel?: Maybe<FulfillmentOrderCancelPayload>;
  /**
   * Marks an in-progress fulfillment order as incomplete,
   * indicating the fulfillment service is unable to ship any remaining items,
   * and closes the fulfillment request.
   *
   * This mutation can only be called for fulfillment orders that meet the following criteria:
   *   - Assigned to a fulfillment service location,
   *   - The fulfillment request has been accepted,
   *   - The fulfillment order status is `IN_PROGRESS`.
   *
   * This mutation can only be called by the fulfillment service app that accepted the fulfillment request.
   * Calling this mutation returns the control of the fulfillment order to the merchant, allowing them to
   * move the fulfillment order line items to another location and fulfill from there,
   * remove and refund the line items, or to request fulfillment from the same fulfillment service again.
   *
   * Closing a fulfillment order is explained in
   * [the fulfillment service guide](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-7-optional-close-a-fulfillment-order).
   */
  fulfillmentOrderClose?: Maybe<FulfillmentOrderClosePayload>;
  /**
   * Applies a fulfillment hold on a fulfillment order.
   *
   * As of the
   * [2025-01 API version](https://shopify.dev/changelog/apply-multiple-holds-to-a-single-fulfillment-order),
   * the mutation can be successfully executed on fulfillment orders that are already on hold.
   * To place multiple holds on a fulfillment order, apps need to supply the
   * [handle](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentHold#field-handle)
   * field. Each app can place up to
   * 10 active holds
   * per fulfillment order. If an app attempts to place more than this, the mutation will return
   * [a user error indicating that the limit has been reached](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderHoldUserErrorCode#value-fulfillmentorderholdlimitreached).
   * The app would need to release one of its existing holds before being able to apply a new one.
   */
  fulfillmentOrderHold?: Maybe<FulfillmentOrderHoldPayload>;
  /**
   * Marks [fulfillment order line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrderLineItem) as ready for customer pickup. When executed, this mutation automatically sends a "Ready For Pickup" notification to the customer.
   *
   * Use this mutation for local pickup orders after the items have been prepared and are available for the customer to collect. You can specify one or more [fulfillment order](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects by providing the fulfillment order IDs in the [`lineItemsByFulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/PreparedFulfillmentOrderLineItemsInput) field. This allows you to mark fulfillment order line items from different fulfillment orders as ready for pickup.
   */
  fulfillmentOrderLineItemsPreparedForPickup?: Maybe<FulfillmentOrderLineItemsPreparedForPickupPayload>;
  /**
   * Merges a set or multiple sets of fulfillment orders together into one based on
   * line item inputs and quantities.
   */
  fulfillmentOrderMerge?: Maybe<FulfillmentOrderMergePayload>;
  /**
   * Changes the location which is assigned to fulfill a number of unfulfilled fulfillment order line items.
   *
   * Moving a fulfillment order will fail in the following circumstances:
   *
   * * The fulfillment order is closed.
   * * The fulfillment order has had progress manually reported. To move a fulfillment order that has had progress manually reported, the fulfillment order must first be marked as open resolving the ongoing progress state.
   * * The destination location doesn't stock the requested inventory item.
   * * The API client doesn't have the correct permissions.
   *
   * Line items which have already been fulfilled can't be re-assigned
   * and will always remain assigned to the original location.
   *
   * You can't change the assigned location while a fulfillment order has a
   * [request status](https://shopify.dev/docs/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus)
   * of `SUBMITTED`, `ACCEPTED`, `CANCELLATION_REQUESTED`, or `CANCELLATION_REJECTED`.
   * These request statuses mean that a fulfillment order is awaiting action by a fulfillment service
   * and can't be re-assigned without first having the fulfillment service accept a cancellation request.
   * This behavior is intended to prevent items from being fulfilled by multiple locations or fulfillment services.
   *
   * ### How re-assigning line items affects fulfillment orders
   *
   * **First scenario:** Re-assign all line items belonging to a fulfillment order to a new location.
   *
   * In this case, the
   * [assignedLocation](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentorder#field-fulfillmentorder-assignedlocation)
   * of the original fulfillment order will be updated to the new location.
   *
   * **Second scenario:** Re-assign a subset of the line items belonging to a fulfillment order to a new location.
   * You can specify a subset of line items using the `fulfillmentOrderLineItems` parameter
   * (available as of the `2023-04` API version),
   * or specify that the original fulfillment order contains line items which have already been fulfilled.
   *
   * If the new location is already assigned to another active fulfillment order, on the same order, then
   * a new fulfillment order is created. The existing fulfillment order is closed and line items are recreated
   * in a new fulfillment order.
   */
  fulfillmentOrderMove?: Maybe<FulfillmentOrderMovePayload>;
  /**
   * Marks a scheduled fulfillment order as open.
   *
   * From API version 2026-01, this will also mark a fulfillment order as open when it is assigned to a merchant managed location and has had progress reported.
   */
  fulfillmentOrderOpen?: Maybe<FulfillmentOrderOpenPayload>;
  /** Rejects a cancellation request sent to a fulfillment service for a fulfillment order. */
  fulfillmentOrderRejectCancellationRequest?: Maybe<FulfillmentOrderRejectCancellationRequestPayload>;
  /** Rejects a fulfillment request sent to a fulfillment service for a fulfillment order. */
  fulfillmentOrderRejectFulfillmentRequest?: Maybe<FulfillmentOrderRejectFulfillmentRequestPayload>;
  /** Releases the fulfillment hold on a fulfillment order. */
  fulfillmentOrderReleaseHold?: Maybe<FulfillmentOrderReleaseHoldPayload>;
  /** Reports the progress of an open or in-progress fulfillment order. */
  fulfillmentOrderReportProgress?: Maybe<FulfillmentOrderReportProgressPayload>;
  /**
   * Reschedules a scheduled fulfillment order.
   *
   * Updates the value of the `fulfillAt` field on a scheduled fulfillment order.
   *
   * The fulfillment order will be marked as ready for fulfillment at this date and time.
   */
  fulfillmentOrderReschedule?: Maybe<FulfillmentOrderReschedulePayload>;
  /**
   * Splits [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects by moving the specified [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects and quantities into a new fulfillment order.
   *
   * If the original fulfillment order can't be split due to its current state, then the mutation creates a replacement fulfillment order instead.
   */
  fulfillmentOrderSplit?: Maybe<FulfillmentOrderSplitPayload>;
  /** Sends a cancellation request to the fulfillment service of a fulfillment order. */
  fulfillmentOrderSubmitCancellationRequest?: Maybe<FulfillmentOrderSubmitCancellationRequestPayload>;
  /**
   * Sends a fulfillment request to the fulfillment service assigned to a [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder). The fulfillment service must then accept or reject the request before processing can begin.
   *
   * You can either request fulfillment for all line items or specify individual items with quantities for partial fulfillment. When requesting partial fulfillment, Shopify splits the original fulfillment order into two: one with the submitted items and another with the remaining unsubmitted items. Include an optional message to communicate special instructions to the fulfillment service, such as gift wrapping or handling requirements.
   *
   * Learn more about [managing fulfillment requests as a fulfillment service](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-4-act-on-fulfillment-requests).
   */
  fulfillmentOrderSubmitFulfillmentRequest?: Maybe<FulfillmentOrderSubmitFulfillmentRequestPayload>;
  /**
   * Route the fulfillment orders to an alternative location, according to the shop's order routing settings. This involves:
   * * Finding an alternate location that can fulfill the fulfillment orders.
   * * Assigning the fulfillment orders to the new location.
   */
  fulfillmentOrdersReroute?: Maybe<FulfillmentOrdersReroutePayload>;
  /** Sets the latest date and time by which the fulfillment orders need to be fulfilled. */
  fulfillmentOrdersSetFulfillmentDeadline?: Maybe<FulfillmentOrdersSetFulfillmentDeadlinePayload>;
  /**
   * Creates a fulfillment service.
   *
   * ## Fulfillment service location
   *
   * When creating a fulfillment service, a new location will be automatically created on the shop
   * and will be associated with this fulfillment service.
   * This location will be named after the fulfillment service and inherit the shop's address.
   *
   * If you are using API version `2023-10` or later, and you need to specify custom attributes for the fulfillment service location
   * (for example, to change its address to a country different from the shop's country),
   * use the
   * [LocationEdit](https://shopify.dev/api/admin-graphql/latest/mutations/locationEdit)
   * mutation after creating the fulfillment service.
   */
  fulfillmentServiceCreate?: Maybe<FulfillmentServiceCreatePayload>;
  /** Deletes a fulfillment service. */
  fulfillmentServiceDelete?: Maybe<FulfillmentServiceDeletePayload>;
  /**
   * Updates the [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) configuration, including its name, callback URL, and operational settings.
   *
   * The mutation modifies how the fulfillment service handles inventory tracking, shipping requirements, and package tracking support.
   *
   * > Note:
   * > To update the physical address or other location details of the fulfillment service, use the [`locationEdit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationEdit) mutation instead.
   *
   * Learn more about [editing fulfillment service locations](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-2-edit-locations).
   */
  fulfillmentServiceUpdate?: Maybe<FulfillmentServiceUpdatePayload>;
  /**
   * Updates tracking information for a fulfillment, including the carrier name, tracking numbers, and tracking URLs. You can provide either single or multiple tracking numbers for shipments with multiple packages.
   *
   * The mutation accepts a [`FulfillmentTrackingInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/FulfillmentTrackingInput) that supports both single tracking (using [`number`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate#arguments-trackingInfoInput.fields.number) and [`url`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate#arguments-trackingInfoInput.fields.url) fields) and multi-package tracking (using [`numbers`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate#arguments-trackingInfoInput.fields.numbers) and [`urls`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate#arguments-trackingInfoInput.fields.urls) fields). When you specify a [supported carrier name](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies), Shopify automatically generates tracking URLs for the provided tracking numbers.
   *
   * You can optionally notify customers about tracking updates with the [`notifyCustomer`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate#arguments-notifyCustomer) argument. When enabled, customers receive shipping update emails with tracking details and receive notifications about future updates to the fulfillment.
   *
   * Learn more about [enabling tracking support](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-9-optional-enable-tracking-support) for fulfillment services.
   */
  fulfillmentTrackingInfoUpdate?: Maybe<FulfillmentTrackingInfoUpdatePayload>;
  /**
   * Updates tracking information for a fulfillment.
   * @deprecated Use `fulfillmentTrackingInfoUpdate` instead.
   */
  fulfillmentTrackingInfoUpdateV2?: Maybe<FulfillmentTrackingInfoUpdateV2Payload>;
  /**
   * Creates a new [`GiftCard`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCard) with a specified initial value. You can assign the gift card to a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) or create it without assignment for manual distribution.
   *
   * You can customize the gift card with an optional code, expiration date, and internal note. If you don't provide a code, the system generates a random 16 character alphanumeric code. The mutation also supports scheduling gift card notifications to recipients, with a personalized message, through the [`recipientAttributes`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/GiftCardCreateInput#fields-recipientAttributes) field on the `GiftCardCreateInput` input object.
   */
  giftCardCreate?: Maybe<GiftCardCreatePayload>;
  /** Adds funds to an existing gift card, increasing its available balance. Use this when a merchant wants to top up a customer's gift card — for example, as a promotional bonus, a customer service gesture, or to reload a reusable gift card. */
  giftCardCredit?: Maybe<GiftCardCreditPayload>;
  /**
   * Deactivate a gift card. A deactivated gift card cannot be used by a customer.
   * A deactivated gift card cannot be re-enabled.
   */
  giftCardDeactivate?: Maybe<GiftCardDeactivatePayload>;
  /** Removes funds from a gift card, decreasing its available balance. Use this for manual balance adjustments — for example, correcting an accidental over-credit or applying a fee. */
  giftCardDebit?: Maybe<GiftCardDebitPayload>;
  /**
   * Creates or updates a
   * [`gift card`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCard)
   * product. This mutation is specifically designed for gift card products and automatically sets
   * the `giftCard` field to `true`, applies gift card variant defaults (non-taxable, no shipping
   * required, inventory untracked), and omits fields that aren't relevant to gift cards.
   *
   * For list fields like
   * [`variants`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet#arguments-input.fields.variants),
   * the mutation performs a full replacement: it creates new entries, updates existing ones, and
   * removes any entries not included in the input. For all other fields, only included fields
   * change and omitted fields remain unchanged.
   *
   * You can run the mutation synchronously to receive the updated product immediately, or
   * asynchronously by setting
   * [`synchronous`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet#arguments-synchronous)`: false`
   * to receive a
   * [`ProductSetOperation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductSetOperation)
   * object instead. Use the
   * [`productOperation`](https://shopify.dev/docs/api/admin-graphql/latest/queries/productOperation)
   * query to check the status and retrieve the product details when running asynchronously.
   *
   * > Note:
   * > The
   * [`issuanceCurrency`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet#arguments-input.fields.issuanceCurrency)
   * and [`crossCurrencyRedeemable`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/giftCardProductSet#arguments-input.fields.crossCurrencyRedeemable) fields can only be set during product creation. They can't be changed after the product is created.
   */
  giftCardProductSet?: Maybe<GiftCardProductSetPayload>;
  /**
   * Sends a gift card notification. If the gift card has a designated recipient,
   * a purchase confirmation is sent instead. Both default email templates include the gift card code.
   *
   * By default, gift card notifications use the linked order's contact details, with the assigned customer's
   * details as a fallback. Purchase confirmations use the assigned customer's contact details.
   *
   * The gift card must have an assigned customer with an email address or phone number.
   * Returns an error without sending if the selected contact source has no contact information.
   * When both an email address and a phone number are available, the notification is sent by email.
   */
  giftCardSendNotificationToCustomer?: Maybe<GiftCardSendNotificationToCustomerPayload>;
  /** Sends a notification to the designated recipient of a gift card, delivering the gift card code and redemption instructions. The notification is delivered using the recipient's available contact method. Use this to deliver or re-deliver the gift card to the intended recipient. */
  giftCardSendNotificationToRecipient?: Maybe<GiftCardSendNotificationToRecipientPayload>;
  /** Updates the properties of an existing gift card, such as its expiration date, note, or template suffix. Use this to modify gift card details — for example, extending an expiration date for a loyal customer or adding an internal note for tracking purposes. */
  giftCardUpdate?: Maybe<GiftCardUpdatePayload>;
  /**
   * Activates an inventory item at a [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) by creating an [`InventoryLevel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) that tracks stock quantities. This enables you to manage inventory for a [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) at the specified location.
   *
   * When you activate an inventory item, you can set its initial quantities. The [`available`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryActivate#arguments-available) argument sets the quantity that's available for sale. [`onHand`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryActivate#arguments-onHand) argument sets the total physical quantity at the location. If you don't specify quantities, then `available` and `onHand` default to zero.
   *
   * > Caution:
   * > As of version `2026-01`, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of version `2026-04`, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   *
   * Learn more about [managing inventory quantities and states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states).
   */
  inventoryActivate?: Maybe<InventoryActivatePayload>;
  /**
   * Adjusts quantities for inventory items by applying incremental changes at specific locations. Each adjustment modifies the quantity by a delta value rather than setting an absolute amount.
   *
   * The mutation tracks adjustments with a reason code and optional reference URI for audit trails. Returns an [`InventoryAdjustmentGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryAdjustmentGroup) that records all changes made in the operation.
   *
   * Learn more about [managing inventory quantities and states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#adjust-inventory-quantities).
   *
   * > Caution:
   * > As of version `2026-01`, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of version `2026-04`, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryAdjustQuantities?: Maybe<InventoryAdjustQuantitiesPayload>;
  /**
   * Activates or deactivates an inventory item at multiple locations. When you activate an [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) at a [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location), that location can stock and track quantities for that item. When you deactivate an inventory item at a location, the inventory item is no longer stocked at that location.
   *
   * The mutation accepts an inventory item ID and a list of location-specific activation settings. It returns the updated inventory item and any activated [`InventoryLevel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) objects.
   *
   * Learn more about [managing inventory quantities and states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
   */
  inventoryBulkToggleActivation?: Maybe<InventoryBulkToggleActivationPayload>;
  /** Removes an inventory item's quantities from a location, and turns off inventory at the location. */
  inventoryDeactivate?: Maybe<InventoryDeactivatePayload>;
  /** Updates an [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem)'s properties including whether inventory is tracked, cost, SKU, and whether shipping is required. Inventory items represent the goods available to be shipped to customers. */
  inventoryItemUpdate?: Maybe<InventoryItemUpdatePayload>;
  /**
   * Moves inventory quantities for a single inventory item between different states at a single location. Use this mutation to reallocate inventory across quantity states without moving it between locations.
   *
   * Each change specifies the quantity to move, the source state and location, and the destination state and location. The mutation returns an [`InventoryAdjustmentGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryAdjustmentGroup) that tracks all changes made in a single operation, providing an audit trail with the reason and reference document URI.
   *
   * > Caution:
   * > As of version `2026-01`, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of version `2026-04`, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryMoveQuantities?: Maybe<InventoryMoveQuantitiesPayload>;
  /**
   * Sets an inventory item's on-hand quantities to specific absolute values at designated locations. The mutation takes a reason for tracking purposes and a reference document URI for audit trails.
   *
   * Returns an [`InventoryAdjustmentGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryAdjustmentGroup) that tracks all changes made in this operation, including the delta values calculated from the previous quantities.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   * @deprecated Use `inventorySetQuantities` to set on_hand or available quantites instead.
   */
  inventorySetOnHandQuantities?: Maybe<InventorySetOnHandQuantitiesPayload>;
  /**
   * Set quantities of specified name using absolute values. This mutation supports compare-and-swap (CAS) functionality to handle
   * concurrent requests properly.
   *
   * As of 2026-04, each quantity in `quantities` must include a `changeFromQuantity` value. The mutation only updates the
   * quantity if the persisted quantity matches `changeFromQuantity`, and otherwise returns a `CHANGE_FROM_QUANTITY_STALE` error.
   * In order to opt out of the check for a quantity, explicitly pass `null` as its `changeFromQuantity`. Omitting
   * `changeFromQuantity` returns an error.
   *
   * Before 2026-04, if `ignoreCompareQuantity` is not set to true,
   * the mutation will only update the quantity if the persisted quantity matches the `compareQuantity` value.
   * If the `compareQuantity` value does not match the persisted value, the mutation will return an error. In order to opt out
   * of the `compareQuantity` check, the `ignoreCompareQuantity` argument can be set to true.
   *
   * > Note:
   * > Only use this mutation if calling on behalf of a system that acts as the source of truth for inventory quantities,
   * > otherwise please consider using the [inventoryAdjustQuantities](https://shopify.dev/api/admin-graphql/latest/mutations/inventoryAdjustQuantities) mutation.
   * >
   * >
   * > Opting out of the compare-and-swap check can lead to inaccurate inventory quantities if multiple requests are made concurrently.
   * > It is recommended to always pass the expected current quantity as `changeFromQuantity` (or `compareQuantity` before 2026-04)
   * > to ensure the accuracy of the inventory quantities, and to opt out of the check (with a `null` `changeFromQuantity`, or
   * > `ignoreCompareQuantity` before 2026-04) only when necessary.
   * > For more information, refer to the [compare and swap documentation](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#compare-and-swap).
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventorySetQuantities?: Maybe<InventorySetQuantitiesPayload>;
  /**
   * Adds items to an inventory shipment.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryShipmentAddItems?: Maybe<InventoryShipmentAddItemsPayload>;
  /**
   * Adds a draft shipment to an inventory transfer.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryShipmentCreate?: Maybe<InventoryShipmentCreatePayload>;
  /**
   * Adds an in-transit shipment to an inventory transfer.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryShipmentCreateInTransit?: Maybe<InventoryShipmentCreateInTransitPayload>;
  /** Deletes an inventory shipment. Only draft shipments can be deleted. */
  inventoryShipmentDelete?: Maybe<InventoryShipmentDeletePayload>;
  /** Marks a draft inventory shipment as in transit. */
  inventoryShipmentMarkInTransit?: Maybe<InventoryShipmentMarkInTransitPayload>;
  /**
   * Receive an inventory shipment.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryShipmentReceive?: Maybe<InventoryShipmentReceivePayload>;
  /** Remove items from an inventory shipment. */
  inventoryShipmentRemoveItems?: Maybe<InventoryShipmentRemoveItemsPayload>;
  /** Sets the barcode on an inventory shipment. */
  inventoryShipmentSetBarcode?: Maybe<InventoryShipmentSetBarcodePayload>;
  /** Edits the tracking info on an inventory shipment. */
  inventoryShipmentSetTracking?: Maybe<InventoryShipmentSetTrackingPayload>;
  /** Updates items on an inventory shipment. */
  inventoryShipmentUpdateItemQuantities?: Maybe<InventoryShipmentUpdateItemQuantitiesPayload>;
  /** Cancels an inventory transfer. */
  inventoryTransferCancel?: Maybe<InventoryTransferCancelPayload>;
  /**
   * Creates a draft inventory transfer to move inventory items between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects in your store. The transfer tracks which items to move, their quantities, and the origin and destination locations.
   *
   * Use [`inventoryTransferMarkAsReadyToShip`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryTransferMarkAsReadyToShip) to mark the transfer as ready to ship.
   *
   * > Caution:
   * > As of version `2026-01`, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of version `2026-04`, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryTransferCreate?: Maybe<InventoryTransferCreatePayload>;
  /**
   * Creates an inventory transfer in ready to ship.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryTransferCreateAsReadyToShip?: Maybe<InventoryTransferCreateAsReadyToShipPayload>;
  /** Deletes an inventory transfer. */
  inventoryTransferDelete?: Maybe<InventoryTransferDeletePayload>;
  /**
   * This mutation allows duplicating an existing inventory transfer. The duplicated transfer will have the same
   * line items and quantities as the original transfer, but will be in a draft state with no shipments.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryTransferDuplicate?: Maybe<InventoryTransferDuplicatePayload>;
  /** Edits an inventory transfer. */
  inventoryTransferEdit?: Maybe<InventoryTransferEditPayload>;
  /** Sets an inventory transfer to ready to ship. */
  inventoryTransferMarkAsReadyToShip?: Maybe<InventoryTransferMarkAsReadyToShipPayload>;
  /**
   * This mutation removes [`InventoryTransferLineItem`s](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem),
   * or portions of them, from a `DRAFT` or `READY_TO_SHIP` Transfer.
   *
   * For each referenced line item, if its entire quantity is still unallocated to a
   * shipment, the line item is removed; otherwise the line item remains on the
   * transfer with its quantity reduced to the allocated portion. Quantity allocated
   * to a shipment (whether the shipment is in draft, in transit, or already
   * received) is preserved.
   *
   * On `READY_TO_SHIP` transfers, removing items also returns the affected reserved
   * quantity to available inventory at the origin location.
   *
   * To change the quantity of a line item without removing it, use
   * [`inventoryTransferSetItems`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryTransferSetItems).
   */
  inventoryTransferRemoveItems?: Maybe<InventoryTransferRemoveItemsPayload>;
  /**
   * This mutation sets the quantity for one or more line items on a Transfer.
   *
   * Only the items you include in the `lineItems` field are updated. Items already on
   * the transfer but not referenced in your update will stay unchanged. Each inventory
   * item may appear at most once in `lineItems`; duplicate `inventoryItemId` entries
   * are rejected.
   *
   * For each entry in `lineItems`:
   * - If the inventory item isn't yet on the transfer, a new line item is added with
   *   the provided quantity.
   * - If the inventory item is already on the transfer, the provided quantity
   *   replaces the line item's [`processableQuantity`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem#field-InventoryTransferLineItem.fields.processableQuantity).
   *   Any quantity outside the processable portion (for example, already shipped or
   *   picked for shipment) is preserved, so the resulting total quantity equals the
   *   preserved portion plus the provided quantity.
   *
   * Passing a quantity of `0` is only allowed for transfers in `DRAFT` status; on
   * `READY_TO_SHIP` or `IN_PROGRESS` transfers it returns an `INVALID_QUANTITY` error.
   * On `DRAFT` transfers, `quantity: 0` leaves a zero-quantity line item on the
   * transfer; it does not remove the item. To remove a line item from a transfer, use
   * [`inventoryTransferRemoveItems`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/inventoryTransferRemoveItems).
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  inventoryTransferSetItems?: Maybe<InventoryTransferSetItemsPayload>;
  /**
   * Activates a location so that you can stock inventory at the location. Refer to the
   * [`isActive`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location#field-isactive) and
   * [`activatable`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location#field-activatable)
   * fields on the `Location` object.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  locationActivate?: Maybe<LocationActivatePayload>;
  /**
   * Adds a new [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where you can stock inventory and fulfill orders. Locations represent physical places like warehouses, retail stores, or fulfillment centers.
   *
   * The location requires a name and address with at least a country code. You can specify whether the location fulfills online orders, which determines if its inventory is available for online sales. You can also attach custom [metafields](https://shopify.dev/docs/apps/build/custom-data) to store additional information about the location.
   */
  locationAdd?: Maybe<LocationAddPayload>;
  /**
   * Deactivates a location and moves inventory, pending orders, and moving transfers " "to a destination location.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  locationDeactivate?: Maybe<LocationDeactivatePayload>;
  /** Deletes a location. */
  locationDelete?: Maybe<LocationDeletePayload>;
  /**
   * Updates the properties of an existing [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location). You can modify the location's name, address, whether it fulfills online orders, and custom [`metafields`](https://shopify.dev/docs/apps/build/custom-data).
   *
   * Apps that created a [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) can edit the associated location to ensure accurate representation of their fulfillment network.
   *
   * > Note:
   * > You can't disable the [`fulfillsOnlineOrders`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationEdit#arguments-input.fields.fulfillsOnlineOrders) setting for fulfillment service locations.
   *
   * Learn more about [editing locations for fulfillment services](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-2-edit-locations).
   */
  locationEdit?: Maybe<LocationEditPayload>;
  /** Disables local pickup for a location. */
  locationLocalPickupDisable?: Maybe<LocationLocalPickupDisablePayload>;
  /** Enables local pickup for a location so customers can collect their orders in person. Configures the estimated pickup time that customers see at checkout and optional instructions for finding or accessing the pickup location. */
  locationLocalPickupEnable?: Maybe<LocationLocalPickupEnablePayload>;
  /**
   * Creates a [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) to deliver customized shopping experiences. Markets define various aspects of the buyer experience including pricing, product availability, custom content, inventory and fulfillment priorities, and payment methods.
   *
   * Define conditions to match buyers by region, company location, retail location, or other criteria. Configure [`MarketCurrencySettings`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketCurrencySettings) to control currency behavior. Set [`MarketPriceInclusions`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketPriceInclusions) to determine tax and duty display. Assign [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) objects and [`MarketWebPresence`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketWebPresence) configurations to control product availability and SEO strategy.
   *
   * Learn more about [Shopify Markets](https://shopify.dev/docs/apps/build/markets).
   */
  marketCreate?: Maybe<MarketCreatePayload>;
  /**
   * Updates currency settings of a market.
   * @deprecated Use `marketCreate` and `marketUpdate` for creating and updating
   * market currency settings, respectively. Removed in API version 2027-01.
   *
   */
  marketCurrencySettingsUpdate?: Maybe<MarketCurrencySettingsUpdatePayload>;
  /** Deletes a market definition. */
  marketDelete?: Maybe<MarketDeletePayload>;
  /** Creates or updates market localizations. */
  marketLocalizationsRegister?: Maybe<MarketLocalizationsRegisterPayload>;
  /** Deletes market localizations. */
  marketLocalizationsRemove?: Maybe<MarketLocalizationsRemovePayload>;
  /**
   * Deletes a market region.
   * @deprecated Use `marketUpdate` instead.
   */
  marketRegionDelete?: Maybe<MarketRegionDeletePayload>;
  /**
   * Creates regions that belong to an existing market.
   * @deprecated This mutation is deprecated and will be removed in the future. Use `marketCreate` or `marketUpdate` instead.
   */
  marketRegionsCreate?: Maybe<MarketRegionsCreatePayload>;
  /**
   * Deletes a list of market regions.
   * @deprecated Use `marketUpdate` instead.
   */
  marketRegionsDelete?: Maybe<MarketRegionsDeletePayload>;
  /** Updates the properties of a market. */
  marketUpdate?: Maybe<MarketUpdatePayload>;
  /**
   * Creates a web presence for a market.
   * @deprecated Use `webPresenceCreate` instead.
   */
  marketWebPresenceCreate?: Maybe<MarketWebPresenceCreatePayload>;
  /**
   * Deletes a market web presence.
   * @deprecated Use `webPresenceDelete` instead.
   */
  marketWebPresenceDelete?: Maybe<MarketWebPresenceDeletePayload>;
  /**
   * Updates a market web presence.
   * @deprecated Use `webPresenceUpdate` instead.
   */
  marketWebPresenceUpdate?: Maybe<MarketWebPresenceUpdatePayload>;
  /** Deletes all external marketing activities. Deletion is performed by a background job, as it may take a bit of time to complete if a large number of activities are to be deleted. Attempting to create or modify external activities before the job has completed will result in the create/update/upsert mutation returning an error. */
  marketingActivitiesDeleteAllExternal?: Maybe<MarketingActivitiesDeleteAllExternalPayload>;
  /** Create new marketing activity. Marketing activity app extensions are deprecated and will be removed in the near future. */
  marketingActivityCreate?: Maybe<MarketingActivityCreatePayload>;
  /**
   * Creates a new external marketing activity.
   * @deprecated Use `marketingActivityUpsertExternal` instead.
   */
  marketingActivityCreateExternal?: Maybe<MarketingActivityCreateExternalPayload>;
  /** Deletes an external marketing activity. */
  marketingActivityDeleteExternal?: Maybe<MarketingActivityDeleteExternalPayload>;
  /** Updates a marketing activity with the latest information. Marketing activity app extensions are deprecated and will be removed in the near future. */
  marketingActivityUpdate?: Maybe<MarketingActivityUpdatePayload>;
  /** Update an external marketing activity. */
  marketingActivityUpdateExternal?: Maybe<MarketingActivityUpdateExternalPayload>;
  /** Creates a new external marketing activity or updates an existing one. When optional fields are absent or null, associated information will be removed from an existing marketing activity. */
  marketingActivityUpsertExternal?: Maybe<MarketingActivityUpsertExternalPayload>;
  /** Creates a new marketing engagement for a marketing activity. */
  marketingEngagementCreate?: Maybe<MarketingEngagementCreatePayload>;
  /**
   * Marks engagement data for a channel so it no longer appears in reports. Activity-level data cannot be deleted directly; delete the MarketingActivity instead.
   * @deprecated Channel-level engagements are deprecated. Activity-level engagement data cannot be deleted directly; delete the MarketingActivity instead.
   */
  marketingEngagementsDelete?: Maybe<MarketingEngagementsDeletePayload>;
  /**
   * Creates a navigation [`Menu`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Menu) for the online store. Menus organize links that help customers navigate to [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), [pages](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page), [blogs](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog), and custom URLs.
   *
   * Each menu requires a unique handle for identification and can contain multiple [`MenuItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MenuItem) objects with nested sub-items up to three levels deep.
   */
  menuCreate?: Maybe<MenuCreatePayload>;
  /** Deletes a menu. */
  menuDelete?: Maybe<MenuDeletePayload>;
  /**
   * Updates a [`Menu`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Menu) for display on the storefront. Modifies the menu's title and navigation structure, including nested [`MenuItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MenuItem) objects. You can update the handle for non-default menus.
   *
   * The items argument accepts a list of menu items with their nested structure. Each item can include nested items to create multi-level navigation hierarchies. Default menus have restricted updates—you can't change their handles.
   */
  menuUpdate?: Maybe<MenuUpdatePayload>;
  /**
   * Creates a [`MetafieldDefinition`](https://shopify.dev/docs/api/admin-graphql/current/objects/MetafieldDefinition) that establishes structure and validation rules for metafields. The definition specifies the data type, validation constraints, and access permissions for metafields with a given namespace and key combination.
   *
   * When you create a new definition, the system validates any existing unstructured metafields matching the same owner type, namespace, and key against it. The system updates each valid metafield's type to match the definition. Invalid metafields remain unchanged but must conform to the definition when updated.
   *
   * Learn more about [creating metafield definitions](https://shopify.dev/docs/apps/build/custom-data/metafields/definitions).
   */
  metafieldDefinitionCreate?: Maybe<MetafieldDefinitionCreatePayload>;
  /**
   * Deletes a [`MetafieldDefinition`](https://shopify.dev/docs/api/admin-graphql/current/objects/MetafieldDefinition). You can identify the definition by providing either its owner type, namespace, and key, or its global ID.
   *
   * When you set [`deleteAllAssociatedMetafields`](https://shopify.dev/docs/api/admin-graphql/current/mutations/metafieldDefinitionDelete#arguments-deleteAllAssociatedMetafields) to `true`, the mutation asynchronously deletes all [`Metafield`](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) objects that use this definition. This option must be `true` when deleting definitions under the `$app` namespace.
   *
   * Learn more about [deleting metafield definitions](https://shopify.dev/docs/apps/build/custom-data/metafields/definitions).
   */
  metafieldDefinitionDelete?: Maybe<MetafieldDefinitionDeletePayload>;
  /**
   * You can organize your metafields in your Shopify admin by pinning/unpinning metafield definitions.
   * The order of your pinned metafield definitions determines the order in which your metafields are displayed
   * on the corresponding pages in your Shopify admin. By default, only pinned metafields are automatically displayed.
   */
  metafieldDefinitionPin?: Maybe<MetafieldDefinitionPinPayload>;
  /**
   * You can organize your metafields in your Shopify admin by pinning/unpinning metafield definitions.
   * The order of your pinned metafield definitions determines the order in which your metafields are displayed
   * on the corresponding pages in your Shopify admin. By default, only pinned metafields are automatically displayed.
   */
  metafieldDefinitionUnpin?: Maybe<MetafieldDefinitionUnpinPayload>;
  /**
   * Updates a [`MetafieldDefinition`](https://shopify.dev/docs/api/admin-graphql/current/objects/MetafieldDefinition)'s configuration and settings. You can modify the definition's name, description, validation rules, access settings, capabilities, and constraints.
   *
   * The mutation updates access settings that control visibility across different APIs, such as the [GraphQL Admin API](https://shopify.dev/docs/api/admin-graphql), [Storefront API](https://shopify.dev/docs/api/storefront), and [Customer Account API](https://shopify.dev/docs/api/customer). It also enables capabilities like admin filtering or unique value validation, and modifies constraints that determine which resource subtypes the definition applies to.
   *
   * > Note: The type, namespace, key, and owner type identify the definition and so can't be changed.
   *
   * Learn more about [updating metafield definitions](https://shopify.dev/docs/apps/build/custom-data/metafields/definitions).
   */
  metafieldDefinitionUpdate?: Maybe<MetafieldDefinitionUpdatePayload>;
  /**
   * Deletes [`Metafield`](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) objects in bulk by specifying combinations of owner ID, namespace, and key.
   *
   * Returns the identifiers of successfully deleted metafields. If a specified metafield doesn't exist, then the mutation still succeeds but returns `null` for that identifier in the response.
   */
  metafieldsDelete?: Maybe<MetafieldsDeletePayload>;
  /**
   * Sets metafield values. Metafield values will be set regardless if they were previously created or not.
   *
   * Allows a maximum of 25 metafields to be set at a time, with a maximum total request payload size of 10MB.
   *
   * This operation is atomic, meaning no changes are persisted if an error is encountered.
   *
   * As of `2024-07`, this operation supports compare-and-set functionality to better handle concurrent requests.
   * If `compareDigest` is set for any metafield, the mutation will only set that metafield if the persisted metafield value matches the digest used on `compareDigest`.
   * If the metafield doesn't exist yet, but you want to guarantee that the operation will run in a safe manner, set `compareDigest` to `null`.
   * The `compareDigest` value can be acquired by querying the metafield object and selecting `compareDigest` as a field.
   * If the `compareDigest` value does not match the digest for the persisted value, the mutation will return an error.
   * You can opt out of write guarantees by not sending `compareDigest` in the request.
   */
  metafieldsSet?: Maybe<MetafieldsSetPayload>;
  /** Asynchronously delete metaobjects and their associated metafields in bulk. */
  metaobjectBulkDelete?: Maybe<MetaobjectBulkDeletePayload>;
  /**
   * Creates a metaobject entry based on an existing [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition). The type must match a definition that already exists in the shop.
   *
   * Specify field values using key-value pairs that correspond to the field definitions. The mutation generates a unique handle automatically if you don't provide one. You can also configure capabilities like publishable status to control the metaobject's visibility across channels.
   *
   * Learn more about [managing metaobjects](https://shopify.dev/docs/apps/build/custom-data/metaobjects/manage-metaobjects).
   */
  metaobjectCreate?: Maybe<MetaobjectCreatePayload>;
  /**
   * Creates a metaobject definition that establishes the structure for custom data objects in your store. The definition specifies the fields, data types, and access permissions that all [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) entries of this type share.
   *
   * Use the `type` field to create a unique namespace for your metaobjects. Prefix the type with `$app:` to reserve the definition for your app's exclusive use. The definition can include capabilities like publishable status or translation eligibility, to extend how metaobjects integrate with Shopify's features.
   *
   * Learn more about [managing metaobjects](https://shopify.dev/docs/apps/build/custom-data/metaobjects/manage-metaobjects).
   */
  metaobjectDefinitionCreate?: Maybe<MetaobjectDefinitionCreatePayload>;
  /**
   * Deletes the specified metaobject definition.
   * Also deletes all related metafield definitions, metaobjects, and metafields asynchronously.
   */
  metaobjectDefinitionDelete?: Maybe<MetaobjectDefinitionDeletePayload>;
  /**
   * Updates a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition)'s configuration and field structure. You can modify the definition's name, description, display name key, access controls, and capabilities, as well as those of all its fields.
   *
   * The mutation supports reordering fields when `resetFieldOrder` is `true`, which arranges submitted fields first followed by alphabetized omitted fields.
   *
   * Learn more about [managing metaobjects](https://shopify.dev/docs/apps/build/custom-data/metaobjects/manage-metaobjects).
   */
  metaobjectDefinitionUpdate?: Maybe<MetaobjectDefinitionUpdatePayload>;
  /** Deletes the specified metaobject and its associated metafields. */
  metaobjectDelete?: Maybe<MetaobjectDeletePayload>;
  /**
   * Updates a [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) with new field values, handle, or capabilities. [Metaobjects](https://shopify.dev/docs/apps/build/custom-data#what-are-metaobjects) are custom data structures that extend Shopify's data model.
   *
   * You can modify field values mapped to the metaobject's [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition), update the handle for a unique identifier, and adjust capabilities like publishing status. When updating the handle, you can optionally create a redirect from the old handle to maintain existing references.
   */
  metaobjectUpdate?: Maybe<MetaobjectUpdatePayload>;
  /**
   * Creates or updates a [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) based on its handle. If a metaobject with the specified handle exists, the mutation updates it with the provided field values. If no matching metaobject exists, the mutation creates a new one.
   *
   * The handle serves as a unique identifier within a metaobject type. Field values map to the [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition)'s field keys and overwrite existing values during updates.
   */
  metaobjectUpsert?: Maybe<MetaobjectUpsertPayload>;
  /** Create a mobile platform application. */
  mobilePlatformApplicationCreate?: Maybe<MobilePlatformApplicationCreatePayload>;
  /** Delete a mobile platform application. */
  mobilePlatformApplicationDelete?: Maybe<MobilePlatformApplicationDeletePayload>;
  /** Update a mobile platform application. */
  mobilePlatformApplicationUpdate?: Maybe<MobilePlatformApplicationUpdatePayload>;
  /**
   * Deletes an order attribution definition for the calling app on the current shop. Existing orders
   * attributed to this definition are preserved.
   *
   * Learn more in the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution).
   */
  orderAttributionDefinitionDelete?: Maybe<OrderAttributionDefinitionDeletePayload>;
  /**
   * Upserts an order attribution definition for the calling app on the current shop. Apps can use
   * attribution definitions to label orders they route to a shop, replacing or augmenting any definitions
   * shipped declaratively via the `order_attribution_config` extension.
   *
   * Learn more in the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution).
   *
   * If a definition with the same handle exists for this app on the shop, the supplied input fields are
   * merged onto it; fields omitted from the input are left unchanged. Otherwise a new definition is
   * created. To explicitly clear the stored `icon` on an existing definition, pass `icon: null`.
   */
  orderAttributionDefinitionUpsert?: Maybe<OrderAttributionDefinitionUpsertPayload>;
  /**
   * Cancels an order, with options for refunding, restocking inventory, and customer notification.
   *
   * > Caution:
   * > Order cancellation is irreversible. An order that has been cancelled can't be restored to its original state.
   *
   * Use the `orderCancel` mutation to programmatically cancel orders in scenarios such as:
   *
   * - Customer-requested cancellations due to size, color, or other preference changes
   * - Payment processing failures or declined transactions
   * - Fraud detection and prevention
   * - Insufficient inventory availability
   * - Staff errors in order processing
   * - Wholesale or B2B order management workflows
   *
   * The `orderCancel` mutation provides flexible refund options including refunding to original payment methods
   * or issuing store credit. If a payment was only authorized (temporarily held) but not yet charged,
   * that hold will be automatically released when the order is cancelled, even if you choose not to refund other payments.
   *
   * The mutation supports different cancellation reasons: customer requests, payment declines, fraud,
   * inventory issues, staff errors, or other unspecified reasons. Each cancellation can include optional
   * staff notes for internal documentation (notes aren't visible to customers).
   *
   * An order can only be cancelled if it meets the following criteria:
   *
   * - The order hasn't already been cancelled.
   * - The order has no pending payment authorizations.
   * - The order has no active returns in progress.
   * - The order has no outstanding fulfillments that can't be cancelled.
   *
   * Orders might be assigned to locations that become
   * [deactivated](https://help.shopify.com/manual/fulfillment/setup/locations-management#deactivate-and-reactivate-locations)
   * after the order was created. When cancelling such orders, inventory behavior depends on payment status:
   *
   * - **Paid orders**: Cancellation will fail with an error if restocking is enabled, since inventory
   * can't be returned to deactivated locations.
   * - **Unpaid orders**: Cancellation succeeds but inventory is not restocked anywhere, even when the
   * restock option is enabled. The committed inventory effectively becomes unavailable rather than being
   * returned to stock at the deactivated location.
   *
   * After you cancel an order, you can still make limited updates to certain fields (like
   * notes and tags) using the
   * [`orderUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderUpdate).
   *
   * For partial refunds or more complex refund scenarios on active orders,
   * such as refunding only specific line items while keeping the rest of the order fulfilled,
   * consider using the [`refundCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate)
   * mutation instead of full order cancellation.
   *
   * Learn how to build apps that integrate with
   * [order management and fulfillment processes](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  orderCancel?: Maybe<OrderCancelPayload>;
  /**
   * Captures payment for an authorized transaction on an order. Use this mutation to claim the money that was previously
   * reserved by an authorization transaction.
   *
   * The `orderCapture` mutation can be used in the following scenarios:
   *
   * - To capture the full amount of an authorized transaction
   * - To capture a partial payment by specifying an amount less than the total order amount
   * - To perform multiple captures on the same order, as long as the order transaction is
   * [multi-capturable](https://shopify.dev/docs/api/admin-graphql/latest/objects/ordertransaction#field-OrderTransaction.fields.multiCapturable)
   *
   * > Note:
   * > Multi-capture functionality is only available to stores on a
   * [Shopify Plus plan](https://help.shopify.com/manual/intro-to-shopify/pricing-plans/plans-features/shopify-plus-plan).
   * For multi-currency orders, the [`currency`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCapture#arguments-input.fields.currency)
   * field is required and should match the presentment currency from the order.
   *
   * After capturing a payment, you can:
   *
   * - View the transaction details including status, amount, and processing information.
   * - Track the captured amount in both shop and presentment currencies.
   * - Monitor the transaction's settlement status.
   *
   * Learn more about [order transactions](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction).
   */
  orderCapture?: Maybe<OrderCapturePayload>;
  /**
   * Marks an open [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) as closed. A closed order is one where merchants fulfill or cancel all [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects and complete all financial transactions.
   *
   * Once closed, the order indicates that no further work is required. The order's [`closedAt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-closedAt) timestamp is set when this mutation completes successfully.
   */
  orderClose?: Maybe<OrderClosePayload>;
  /**
   * Creates an order with attributes such as customer information, line items, and shipping and billing addresses.
   *
   * Use the `orderCreate` mutation to programmatically generate orders in scenarios where
   * orders aren't created through the standard checkout process, such as when importing orders from an external
   * system or creating orders for wholesale customers.
   *
   * The `orderCreate` mutation doesn't support applying multiple discounts, such as discounts on line items.
   * Automatic discounts won't be applied unless you replicate the logic of those discounts in your custom
   * implementation. You can [apply a discount code](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/OrderCreateDiscountCodeInput),
   * but only one discount code can be set for each order.
   *
   * > Note:
   * > If you're using the `orderCreate` mutation with a
   * > [trial](https://help.shopify.com/manual/intro-to-shopify/pricing-plans/free-trial) or
   * > [development store](https://shopify.dev/docs/api/development-stores), then you can create a
   * > maximum of five new orders per minute.
   *
   * After you create an order, you can make subsequent edits to the order using one of the following mutations:
   * * [`orderUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderUpdate):
   * Used for simple updates to an order, such as changing the order's note, tags, or customer information.
   * * [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin):
   * Used when you need to make significant updates to an order, such as adding or removing line items, changing
   * quantities, or modifying discounts. The `orderEditBegin` mutation initiates an order editing session,
   * allowing you to make multiple changes before finalizing them. Learn more about using the `orderEditBegin`
   * mutation to [edit existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   *
   * Learn how to build apps that integrate with
   * [order management and fulfillment processes](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  orderCreate?: Maybe<OrderCreatePayload>;
  /**
   * Creates a payment for an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) using a stored [`PaymentMandate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentMandate). A payment mandate represents the customer's authorization to charge their payment method for deferred payments, such as pre-orders or try-before-you-buy purchases.
   *
   * The mutation processes the payment asynchronously and returns a [`Job`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Job) for tracking the payment status. You can specify the payment amount to collect, and use the [`autoCapture`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCreateMandatePayment#arguments-autoCapture) argument to either immediately capture the payment or only authorize it for later capture. Each payment request requires a unique [`idempotencyKey`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCreateMandatePayment#arguments-idempotencyKey) to prevent duplicate charges. Subsequent calls with the same key return the original payment result rather than creating a new payment.
   *
   * Learn more about [deferred payments and payment mandates](https://shopify.dev/docs/apps/build/purchase-options/deferred#charging-the-remaining-balance) and [idempotent requests](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  orderCreateMandatePayment?: Maybe<OrderCreateMandatePaymentPayload>;
  /**
   * Records a manual payment for an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) that isn't fully paid. Use this mutation to track payments received outside the standard checkout process, such as cash, check, bank transfer, or other offline payment methods.
   *
   * You can specify the payment [amount](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCreateManualPayment#arguments-amount), [method name](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCreateManualPayment#arguments-paymentMethodName), and [when it was processed](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCreateManualPayment#arguments-processedAt).
   */
  orderCreateManualPayment?: Maybe<OrderCreateManualPaymentPayload>;
  /** Removes customer from an order. */
  orderCustomerRemove?: Maybe<OrderCustomerRemovePayload>;
  /** Sets a customer on an order. */
  orderCustomerSet?: Maybe<OrderCustomerSetPayload>;
  /**
   * Permanently deletes an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) from the store.
   *
   * You can only delete [specific order types](https://help.shopify.com/manual/orders/cancel-delete-order#delete-an-order). Other orders you can cancel using the [`orderCancel`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCancel) mutation instead.
   *
   * > Caution:
   * > This action is irreversible. You can't recover deleted orders.
   */
  orderDelete?: Maybe<OrderDeletePayload>;
  /**
   * Adds a custom line item to an existing [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). Custom line items represent products or services not in your catalog, such as gift wrapping, installation fees, or one-off charges.
   *
   * Creates a [`CalculatedLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedLineItem) with the specified title, price, and quantity. Changes remain in the edit session until you commit them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
   *
   * Learn more about [adding custom line items](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders#add-a-custom-line-item).
   */
  orderEditAddCustomItem?: Maybe<OrderEditAddCustomItemPayload>;
  /**
   * Applies a discount to a [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) during an order edit session. The discount can be either a fixed amount or percentage value.
   *
   * To modify pricing on specific line items, use this mutation after starting an order edit with the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) mutation. The changes remain staged until you commit them with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
   *
   * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   */
  orderEditAddLineItemDiscount?: Maybe<OrderEditAddLineItemDiscountPayload>;
  /**
   * Adds a custom shipping line to an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) during an edit session. Specify the shipping title and price to create a new [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine).
   *
   *  Returns a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) showing the order with edits applied but not yet saved. To save your changes, use the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation.
   *
   * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   */
  orderEditAddShippingLine?: Maybe<OrderEditAddShippingLinePayload>;
  /**
   * Adds a [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) as a line item to an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) that's being edited. The mutation respects the variant's contextual pricing.
   *
   * You can specify a [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) to check for inventory availability and control whether duplicate variants are allowed. The [`quantity`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditAddVariant#arguments-quantity) must be a positive value.
   *
   * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders#add-a-new-variant).
   */
  orderEditAddVariant?: Maybe<OrderEditAddVariantPayload>;
  /**
   * Starts an order editing session that enables you to modify an existing [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). This mutation creates an [`OrderEditSession`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderEditSession) and returns a [`CalculatedOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CalculatedOrder) showing how the order looks with your changes applied.
   *
   * Order editing follows a three-step workflow: Begin the edit with [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin), apply changes using mutations like [`orderEditAddVariant`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditAddVariant) or [`orderEditSetQuantity`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditSetQuantity), and then save the changes with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation. The session tracks all staged changes until you commit or abandon them.
   *
   * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   */
  orderEditBegin?: Maybe<OrderEditBeginPayload>;
  /**
   * Applies staged changes from an order editing session to the original order. This finalizes all modifications made during the edit session, including changes to line items, quantities, discounts, and shipping lines.
   *
   * Order editing follows a three-step workflow: start with [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin) to create an editing session, apply changes using various orderEdit mutations, and then save the changes with the [`orderEditCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditCommit) mutation. The mutation can optionally notify the customer of changes and add staff notes for internal tracking.
   *
   * You can only edit unfulfilled line items. If an edit changes the total order value, then the customer might need to pay a balance or receive a refund.
   *
   * Learn more about [editing existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   */
  orderEditCommit?: Maybe<OrderEditCommitPayload>;
  /** Removes a discount on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  orderEditRemoveDiscount?: Maybe<OrderEditRemoveDiscountPayload>;
  /**
   * Removes a line item discount that was applied as part of an order edit.
   * @deprecated Use `orderEditRemoveDiscount` instead.
   */
  orderEditRemoveLineItemDiscount?: Maybe<OrderEditRemoveLineItemDiscountPayload>;
  /** Removes a shipping line from an existing order. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  orderEditRemoveShippingLine?: Maybe<OrderEditRemoveShippingLinePayload>;
  /**
   * Sets the quantity of a line item on an order that's being edited. Use this mutation to increase, decrease, or remove items by adjusting their quantities.
   *
   * Setting the quantity to zero effectively removes the line item from the order. The item still exists as a data structure with zero quantity. When decreasing quantities, you can optionally restock the removed items to inventory by setting the `restock` parameter to `true`.
   *
   * Learn more about [editing workflows for existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   */
  orderEditSetQuantity?: Maybe<OrderEditSetQuantityPayload>;
  /** Updates a manual line level discount on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  orderEditUpdateDiscount?: Maybe<OrderEditUpdateDiscountPayload>;
  /** Updates a shipping line on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  orderEditUpdateShippingLine?: Maybe<OrderEditUpdateShippingLinePayload>;
  /**
   * Sends an email invoice for an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
   *
   * You can customize the email recipient, sender, and subject line using the [`email`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderInvoiceSend#arguments-email) argument.
   *
   * > Note:
   * > Use store or staff account email addresses for the [`from`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderInvoiceSend#arguments-email.fields.from) and [`bcc`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderInvoiceSend#arguments-email.fields.bcc) input fields.
   */
  orderInvoiceSend?: Maybe<OrderInvoiceSendPayload>;
  /**
   * Marks an order as paid by recording a payment transaction for the outstanding amount.
   *
   * Use the `orderMarkAsPaid` mutation to record payments received outside the standard checkout
   * process. The `orderMarkAsPaid` mutation is particularly useful in scenarios where:
   *
   * - Orders were created with manual payment methods (cash on delivery, bank deposit, money order)
   * - Payments were received offline and need to be recorded in the system
   * - Previously authorized payments need to be captured manually
   * - Orders require manual payment reconciliation due to external payment processing
   *
   * The mutation validates that the order can be marked as paid before processing.
   * An order can be marked as paid only if it has a positive outstanding balance and its
   * [financial status](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.displayFinancialStatus)
   * isn't already `PAID`. The mutation will either create a new sale transaction for the full
   * outstanding amount or capture an existing authorized transaction, depending on the order's current payment state.
   *
   * After successfully marking an order as paid, the order's financial status is updated to
   * reflect the payment, and payment events are logged for tracking and analytics
   * purposes.
   *
   * Learn more about [managing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps)
   * in apps.
   */
  orderMarkAsPaid?: Maybe<OrderMarkAsPaidPayload>;
  /** Opens a closed order. */
  orderOpen?: Maybe<OrderOpenPayload>;
  /** Creates a risk assessment for a specific order using the provided risk level and facts. Shopify sends an `orders/risk_assessment_changed` webhook when the assessment is created. */
  orderRiskAssessmentCreate?: Maybe<OrderRiskAssessmentCreatePayload>;
  /**
   * Updates the attributes of an order, such as the customer's email, the shipping address for the order,
   * tags, and [metafields](https://shopify.dev/docs/apps/build/custom-data) associated with the order.
   *
   * If you need to make significant updates to an order, such as adding or removing line items, changing
   * quantities, or modifying discounts, then use
   * the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin)
   * mutation instead. The `orderEditBegin` mutation initiates an order editing session,
   * allowing you to make multiple changes before finalizing them. Learn more about using the `orderEditBegin`
   * mutation to [edit existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   *
   * If you need to remove a customer from an order, then use the [`orderCustomerRemove`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderCustomerRemove)
   * mutation instead.
   *
   * Learn how to build apps that integrate with
   * [order management and fulfillment processes](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  orderUpdate?: Maybe<OrderUpdatePayload>;
  /**
   * Creates a [`Page`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page) for the online store.
   *
   * Pages contain custom content like "About Us" or "Contact" information that merchants display outside their product catalog. The page requires a [`title`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page#field-Page.fields.title) and can include HTML content, publishing settings, and custom [template suffixes](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page#field-Page.fields.templateSuffix). You can control visibility through the [`isPublished`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page#field-Page.fields.isPublished) flag or schedule publication with a specific date.
   *
   * The mutation returns the complete page object upon successful creation or validation errors if the input is invalid.
   */
  pageCreate?: Maybe<PageCreatePayload>;
  /**
   * Permanently deletes a page from the online store.
   *
   * For example, merchants might delete seasonal landing pages after campaigns end, or remove outdated policy pages when terms change.
   *
   * Use the `pageDelete` mutation to:
   * - Remove outdated or unnecessary pages
   * - Clean up seasonal landing pages
   * - Delete duplicate pages
   *
   * The deletion is permanent and returns the deleted page's ID for confirmation.
   */
  pageDelete?: Maybe<PageDeletePayload>;
  /**
   * Updates an existing page's content and settings.
   *
   * For example, merchants can update their "Shipping Policy" page when rates change, or refresh their "About Us" page with new team information.
   *
   * Use the `pageUpdate` mutation to:
   * - Update page content and titles
   * - Modify publication status
   * - Change page handles for URL structure
   * - Adjust template settings
   *
   * The mutation supports partial updates, allowing specific changes while preserving other page properties.
   */
  pageUpdate?: Maybe<PageUpdatePayload>;
  /** Activates or deactivates payment customizations for the shop. Payment customizations allow apps to hide, reorder, or rename payment methods at checkout based on cart contents, customer attributes, or other conditions. Use this to toggle customizations on or off without deleting them. */
  paymentCustomizationActivation?: Maybe<PaymentCustomizationActivationPayload>;
  /** Creates a new payment customization for the shop. Payment customizations let apps modify the payment methods shown at checkout — hiding, reordering, or renaming options based on cart contents, customer attributes, or other business logic. */
  paymentCustomizationCreate?: Maybe<PaymentCustomizationCreatePayload>;
  /** Permanently deletes a payment customization. Once deleted, the customization will no longer affect which payment methods appear at checkout. */
  paymentCustomizationDelete?: Maybe<PaymentCustomizationDeletePayload>;
  /** Updates an existing payment customization, modifying its configuration for how payment methods are displayed at checkout. Use this to change the customization's title or enabled state. The customization's function can't be changed once set; create a new payment customization to use a different function. */
  paymentCustomizationUpdate?: Maybe<PaymentCustomizationUpdatePayload>;
  /** Sends an email payment reminder for a payment schedule. */
  paymentReminderSend?: Maybe<PaymentReminderSendPayload>;
  /**
   * Captures payment for a due [`PaymentSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentSchedule) using the vaulted payment method associated with the order.
   *
   * The mutation resolves the order and mandate from the given payment schedule, then initiates
   * an asynchronous payment capture. Use the returned `jobResult` to poll for the status of the
   * payment capture.
   */
  paymentScheduleCapture?: Maybe<PaymentScheduleCapturePayload>;
  /** Create payment terms on an order. To create payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  paymentTermsCreate?: Maybe<PaymentTermsCreatePayload>;
  /** Delete payment terms for an order. To delete payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  paymentTermsDelete?: Maybe<PaymentTermsDeletePayload>;
  /** Update payment terms on an order. To update payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  paymentTermsUpdate?: Maybe<PaymentTermsUpdatePayload>;
  /** Assigns a point of sale device to a cash drawer, removing any prior assignment. */
  pointOfSaleDeviceAssignToCashDrawer?: Maybe<PointOfSaleDeviceAssignToCashDrawerPayload>;
  /** Adds an adjustment to a point of sale device payment session. */
  pointOfSaleDevicePaymentSessionAdjust?: Maybe<PointOfSaleDevicePaymentSessionAdjustPayload>;
  /** Closes a point of sale device payment session. */
  pointOfSaleDevicePaymentSessionClose?: Maybe<PointOfSaleDevicePaymentSessionClosePayload>;
  /** Records a mid-session cash count for a point of sale device payment session. */
  pointOfSaleDevicePaymentSessionCount?: Maybe<PointOfSaleDevicePaymentSessionCountPayload>;
  /** Opens a point of sale device payment session. */
  pointOfSaleDevicePaymentSessionOpen?: Maybe<PointOfSaleDevicePaymentSessionOpenPayload>;
  /** Installs storefront generation preview for shop. */
  previewInstall?: Maybe<PreviewInstallPayload>;
  /**
   * Creates a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). Price lists enable contextual pricing by defining fixed prices or percentage-based adjustments.
   *
   * The price list requires a unique name, currency for fixed prices, and parent adjustment settings that determine how the system calculates prices relative to base prices. To apply contextual pricing, link the price list to a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog). When that catalog's context is matched, customers receive the price list's prices.
   *
   * Learn more about [building catalogs with price lists](https://shopify.dev/docs/apps/build/markets/build-catalog#step-2-associate-a-price-list-with-the-catalog).
   */
  priceListCreate?: Maybe<PriceListCreatePayload>;
  /** Deletes a price list. For example, you can delete a price list so that it no longer applies for products in the associated market. */
  priceListDelete?: Maybe<PriceListDeletePayload>;
  /**
   * Creates or updates fixed prices on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). Use this mutation to set specific prices for [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects that override the price list's default percentage-based adjustments.
   *
   * When you add fixed prices, the mutation replaces any existing fixed prices for those variants on the price list.
   */
  priceListFixedPricesAdd?: Maybe<PriceListFixedPricesAddPayload>;
  /**
   * Sets or removes fixed prices for all variants of a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). Simplifies pricing management when all variants of a product should have the same price on a price list, rather than setting individual variant prices.
   *
   * When you add a fixed price for a product, all its [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects receive the same price on the price list. When you remove a product's fixed prices, all variant prices revert to the price list's adjustment rules.
   */
  priceListFixedPricesByProductUpdate?: Maybe<PriceListFixedPricesByProductUpdatePayload>;
  /** Deletes specific fixed prices from a price list using a product variant ID. You can use the `priceListFixedPricesDelete` mutation to delete a set of fixed prices from a price list. After deleting the set of fixed prices from the price list, the price of each product variant reverts to the original price that was determined by the price list adjustment. */
  priceListFixedPricesDelete?: Maybe<PriceListFixedPricesDeletePayload>;
  /**
   * Updates fixed prices on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). This mutation lets you add new fixed prices for specific [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects and remove existing prices in a single operation.
   *
   * Use this mutation to modify variant pricing on a price list by providing prices to add and variant IDs to delete.
   *
   * Learn more about [setting fixed prices for product variants](https://shopify.dev/docs/apps/build/markets/build-catalog#step-3-set-fixed-prices-for-specific-product-variants).
   */
  priceListFixedPricesUpdate?: Maybe<PriceListFixedPricesUpdatePayload>;
  /**
   * Updates a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList)'s configuration, including its name, currency, [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) association, and pricing adjustments.
   *
   * Changing the currency removes all fixed prices from the price list. The affected [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects revert to prices calculated from the price list's adjustment settings.
   */
  priceListUpdate?: Maybe<PriceListUpdatePayload>;
  /** Disable a shop's privacy features. */
  privacyFeaturesDisable?: Maybe<PrivacyFeaturesDisablePayload>;
  /**
   * Creates a product bundle that groups multiple [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects together as components. The bundle appears as a single product in the store, with its price determined by the parent product and inventory calculated from the component products.
   *
   * The mutation runs asynchronously and returns a [`ProductBundleOperation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductBundleOperation) object to track the creation status. Poll the operation using the [`productOperation`](https://shopify.dev/docs/api/admin-graphql/latest/queries/productOperation) query to determine when the bundle is ready.
   *
   * Learn more about [creating product fixed bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-product-fixed-bundle#step-1-create-a-bundle).
   */
  productBundleCreate?: Maybe<ProductBundleCreatePayload>;
  /** Updates a product bundle or componentized product. */
  productBundleUpdate?: Maybe<ProductBundleUpdatePayload>;
  /**
   * Changes the status of a product. This allows you to set the availability of the product across all channels.
   * @deprecated Use `productUpdate` instead.
   */
  productChangeStatus?: Maybe<ProductChangeStatusPayload>;
  /**
   * Creates a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * with attributes such as title, description, vendor, and media.
   *
   * The `productCreate` mutation helps you create many products at once, avoiding the tedious or time-consuming
   * process of adding them one by one in the Shopify admin. Common examples include creating products for a
   * new collection, launching a new product line, or adding seasonal products.
   *
   * You can define product
   * [options](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption) and
   * [values](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue),
   * allowing you to create products with different variations like sizes or colors. You can also associate media
   * files to your products, including images and videos.
   *
   * The `productCreate` mutation only supports creating a product with its initial
   * [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant).
   * To create multiple product variants for a single product and manage prices, use the
   * [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * mutation.
   *
   * > Note:
   * > The `productCreate` mutation has a [throttle](https://shopify.dev/docs/api/usage/rate-limits#resource-based-rate-limits)
   * > that takes effect when a store has 50,000 product variants. After this threshold is reached, no more than
   * > 1,000 new product variants can be created per day.
   *
   * After you create a product, you can make subsequent edits to the product using one of the following mutations:
   *
   * - [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish):
   * Used to publish the product and make it available to customers. The `productCreate` mutation creates products
   * in an unpublished state by default, so you must perform a separate operation to publish the product.
   * - [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate):
   * Used to update a single product, such as changing the product's title, description, vendor, or associated media.
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet):
   * Used to perform multiple operations on products, such as creating or modifying product options and variants.
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productCreate?: Maybe<ProductCreatePayload>;
  /**
   * Adds media files to a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), such as images, videos, or 3D models. Media files enhance product listings by providing visual representations that help customers understand the product.
   *
   * The mutation accepts an array of [`CreateMediaInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CreateMediaInput) objects, each specifying the source URL, content type, and optional alt text.
   *
   * You can add multiple media files in a single request. The mutation adds all valid files and returns errors for any invalid ones.
   * @deprecated Use `productUpdate` or `productSet` instead.
   */
  productCreateMedia?: Maybe<ProductCreateMediaPayload>;
  /**
   * Permanently deletes a product and all its associated data, including variants, media, publications, and inventory items.
   *
   * Use the `productDelete` mutation to programmatically remove products from your store when they need to be
   * permanently deleted from your catalog, such as when removing discontinued items, cleaning up test data, or
   * synchronizing with external inventory management systems.
   *
   * The `productDelete` mutation removes the product from all associated collections,
   * and removes all associated data for the product, including:
   *
   * - All product variants and their inventory items
   * - Product media (images, videos) that are not referenced by other products
   * - [Product options](https://shopify.dev/api/admin-graphql/latest/objects/ProductOption) and [option values](https://shopify.dev/api/admin-graphql/latest/objects/ProductOptionValue)
   * - Product publications across all sales channels
   * - Product tags and metadata associations
   *
   * The `productDelete` mutation also has the following effects on existing orders and transactions:
   *
   * - **Draft orders**: Existing draft orders that reference this product will retain the product information as stored data, but the product reference will be removed. Draft orders can still be completed with the stored product details.
   * - **Completed orders and refunds**: Previously completed orders that included this product aren't affected. The product information in completed orders is preserved for record-keeping, and existing refunds for this product remain valid and processable.
   *
   * > Caution:
   * > Product deletion is irreversible. After a product is deleted, it can't be recovered. Consider archiving
   * > or unpublishing products instead if you might need to restore them later.
   *
   * If you need to delete a large product, such as one that has many
   * [variants](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant)
   * that are active at several
   * [locations](https://shopify.dev/api/admin-graphql/latest/objects/Location),
   * you might encounter timeout errors. To avoid these timeout errors, you can set the
   * [`synchronous`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productDelete#arguments-synchronous)
   * parameter to `false` to run the deletion asynchronously, which returns a
   * [`ProductDeleteOperation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductDeleteOperation)
   * that you can monitor for completion status.
   *
   * If you need more granular control over product cleanup, consider using these alternative mutations:
   *
   * - [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate):
   * Update the product status to archived or unpublished instead of deleting.
   * - [`productVariantsBulkDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkDelete):
   * Delete specific variants while keeping the product.
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete):
   * Delete the choices available for a product, such as size, color, or material.
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model).
   */
  productDelete?: Maybe<ProductDeletePayload>;
  /**
   * Deletes media from a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), such as images, videos, and 3D models.
   *
   * When you delete media images, the mutation also removes any corresponding product images. The mutation returns the IDs of both the deleted media and any product images that the deletion removed.
   *
   * > Caution:
   * > This action is irreversible. You can't recover deleted media.
   * @deprecated Use `fileUpdate` instead.
   */
  productDeleteMedia?: Maybe<ProductDeleteMediaPayload>;
  /**
   * Duplicates a product.
   *
   * If you need to duplicate a large product, such as one that has many
   * [variants](https://shopify.dev/api/admin-graphql/latest/input-objects/ProductVariantInput)
   * that are active at several
   * [locations](https://shopify.dev/api/admin-graphql/latest/input-objects/InventoryLevelInput),
   * you might encounter timeout errors.
   *
   * To avoid these timeout errors, include the `synchronous: false` argument in this mutation to perform
   * the duplication asynchronously.
   *
   * Metafield values are not duplicated if the unique values capability is enabled.
   */
  productDuplicate?: Maybe<ProductDuplicatePayload>;
  /** Creates a product feed for a specific publication. */
  productFeedCreate?: Maybe<ProductFeedCreatePayload>;
  /** Deletes a product feed for a specific publication. */
  productFeedDelete?: Maybe<ProductFeedDeletePayload>;
  /** Runs the full product sync for a given shop. */
  productFullSync?: Maybe<ProductFullSyncPayload>;
  /** Adds multiple selling plan groups to a product. */
  productJoinSellingPlanGroups?: Maybe<ProductJoinSellingPlanGroupsPayload>;
  /** Removes multiple groups from a product. */
  productLeaveSellingPlanGroups?: Maybe<ProductLeaveSellingPlanGroupsPayload>;
  /**
   * Updates an [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption)
   * on a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product),
   * such as size, color, or material. Each option includes a name, position, and a list of values. The combination
   * of a product option and value creates a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant).
   *
   * Use the `productOptionUpdate` mutation for the following use cases:
   *
   * - **Update product choices**: Modify an existing option, like "Size" (Small, Medium, Large) or
   * "Color" (Red, Blue, Green), so customers can select their preferred variant.
   * - **Enable personalization features**: Update an option (for example, "Engraving text") to let customers customize their purchase.
   * - **Offer seasonal or limited edition products**: Update a value
   * (for example, "Holiday red") on an existing option to support limited-time or seasonal variants.
   * - **Integrate with apps that manage product configuration**: Allow third-party apps to update options, like
   * "Bundle size", when customers select or customize
   * [product bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles).
   * - **Link options to metafields**: Associate a product option with a custom
   * [metafield](https://shopify.dev/docs/apps/build/custom-data), like "Fabric code", for
   * richer integrations with other systems or apps.
   *
   * > Note:
   * > The `productOptionUpdate` mutation enforces strict data integrity for product options and variants.
   * All option positions must be sequential, and every option should be used by at least one variant.
   *
   * After you update a product option, you can further manage a product's configuration using related mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsReorder)
   * - [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate)
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productOptionUpdate?: Maybe<ProductOptionUpdatePayload>;
  /**
   * Creates one or more [options](https://shopify.dev/docs/api/admin-graphql/current/objects/ProductOption)
   * on a [product](https://shopify.dev/docs/api/admin-graphql/current/objects/Product),
   * such as size, color, or material. Each option includes a name, position, and a list of values. The combination
   * of a product option and value creates a [product variant](https://shopify.dev/docs/api/admin-graphql/current/objects/ProductVariant).
   *
   * Use the `productOptionsCreate` mutation for the following use cases:
   *
   * - **Add product choices**: Add a new option, like "Size" (Small, Medium, Large) or
   * "Color" (Red, Blue, Green), to an existing product so customers can select their preferred variant.
   * - **Enable personalization features**: Add options such as "Engraving text" to let customers customize their purchase.
   * - **Offer seasonal or limited edition products**: Add a new value
   * (for example, "Holiday red") to an existing option to support limited-time or seasonal variants.
   * - **Integrate with apps that manage product configuration**: Allow third-party apps to add options, like
   * "Bundle size", when customers select or customize
   * [product bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles).
   * - **Link options to metafields**: Associate a product option with a custom
   * [metafield](https://shopify.dev/docs/apps/build/custom-data), like "Fabric code", for
   * richer integrations with other systems or apps.
   *
   * > Note:
   * > The `productOptionsCreate` mutation enforces strict data integrity for product options and variants.
   * All option positions must be sequential, and every option should be used by at least one variant.
   * If you use the [`CREATE` variant strategy](https://shopify.dev/docs/api/admin-graphql/current/mutations/productOptionsCreate#arguments-variantStrategy.enums.CREATE), consider the maximum allowed number of variants for each product is 2048.
   *
   * If the product already has an option with the same name, then the mutation returns an
   * `OPTION_ALREADY_EXISTS` error. A product that has only its default variant is the exception,
   * because its implicit `Title` option is a placeholder that the mutation replaces.
   * To declare the complete set of options and variants that a product
   * should have, and let Shopify create, update, or remove them to match, use the
   * [`productSet`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productSet) mutation instead.
   *
   * After you create product options, you can further manage a product's configuration using related mutations:
   *
   * - [`productOptionUpdate`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productOptionUpdate)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productOptionsReorder)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productOptionsDelete)
   * - [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productVariantsBulkCreate)
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productVariantsBulkUpdate)
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/current/mutations/productSet)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productOptionsCreate?: Maybe<ProductOptionsCreatePayload>;
  /**
   * Deletes one or more [options](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption)
   * from a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product). Product options
   * define the choices available for a product, such as size, color, or material.
   *
   * > Caution:
   * > Removing an option can affect a product's
   * > [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) and their
   * > configuration. Deleting an option might also delete associated option values and, depending on the chosen
   * > [strategy](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productoptionsdelete#arguments-strategy),
   * > might affect variants.
   *
   * Use the `productOptionsDelete` mutation for the following use cases:
   *
   * - **Simplify product configuration**: Remove obsolete or unnecessary options
   * (for example, discontinue "Material" if all variants are now the same material).
   * - **Clean up after seasonal or limited-time offerings**: Delete options that are no longer
   * relevant (for example, "Holiday edition").
   * - **Automate catalog management**: Enable apps or integrations to programmatically remove options as product
   * data changes.
   *
   * > Note:
   * > The `productOptionsDelete` mutation enforces strict data integrity for product options and variants.
   * > All option positions must remain sequential, and every remaining option must be used by at least one variant.
   *
   * After you delete a product option, you can further manage a product's configuration using related mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionUpdate)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsReorder)
   * - [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate)
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productOptionsDelete?: Maybe<ProductOptionsDeletePayload>;
  /**
   * Reorders the [options](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption) and
   * [option values](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue) on a
   * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product),
   * updating the order in which [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * are presented to customers.
   *
   * The `productOptionsReorder` mutation accepts a list of product options, each identified by `id` or `name`, and an
   * optional list of values (also by `id` or `name`) specifying the new order. The order of options in the
   * mutation's input determines their new positions (for example, the first option becomes `option1`).
   * The order of values within each option determines their new positions. The mutation recalculates the order of
   * variants based on the new option and value order.
   *
   * Suppose a product has the following variants:
   *
   * 1. `"Red / Small"`
   * 2. `"Green / Medium"`
   * 3. `"Blue / Small"`
   *
   * You reorder options and values:
   *
   * ```
   * options: [
   *   { name: "Size", values: [{ name: "Small" }, { name: "Medium" }] },
   *   { name: "Color", values: [{ name: "Green" }, { name: "Red" }, { name: "Blue" }] }
   * ]
   * ```
   *
   * The resulting variant order will be:
   *
   * 1. `"Small / Green"`
   * 2. `"Small / Red"`
   * 3. `"Small / Blue"`
   * 4. `"Medium / Green"`
   *
   * Use the `productOptionsReorder` mutation for the following use cases:
   *
   * - **Change the order of product options**: For example, display "Color" before "Size" in a store.
   * - **Reorder option values within an option**: For example, show "Red" before "Blue" in a color picker.
   * - **Control the order of product variants**: The order of options and their values determines the sequence in which variants are listed and selected.
   * - **Highlight best-selling options**: Present the most popular or relevant options and values first.
   * - **Promote merchandising strategies**: Highlight seasonal colors, limited editions, or featured sizes.
   *
   * > Note:
   * > The `productOptionsReorder` mutation enforces strict data integrity for product options and variants.
   * > All option positions must be sequential, and every option should be used by at least one variant.
   *
   * After you reorder product options, you can further manage a product's configuration using related mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete)
   * - [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate)
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [managing product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productOptionsReorder?: Maybe<ProductOptionsReorderPayload>;
  /**
   * Publishes a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) to specified [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) objects.
   *
   * Products sold exclusively on subscription (`requiresSellingPlan: true`) can only be published to online stores.
   * @deprecated Use `publishablePublish` instead.
   */
  productPublish?: Maybe<ProductPublishPayload>;
  /**
   * Reorders [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Media) attached to a product, changing their sequence in product displays. The operation processes asynchronously to handle [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) with large media collections.
   *
   * Specify the [product ID](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productReorderMedia#arguments-id) and an array of [moves](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productReorderMedia#arguments-moves), where each move contains a media ID and its new zero-based position.
   *
   * > Note:
   * > Only include media items that need repositioning. Unchanged items maintain their relative order automatically.
   *
   * The mutation returns a [`Job`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Job) to track the reordering progress. Poll the job status to determine when the operation completes and media positions update across all sales channels.
   *
   * Learn more about [reordering product media](https://shopify.dev/docs/apps/build/online-store/product-media#step-6-reorder-media-objects).
   */
  productReorderMedia?: Maybe<ProductReorderMediaPayload>;
  /**
   * Performs multiple operations to create or update products in a single request.
   *
   * Use the `productSet` mutation to sync information from an external data source into Shopify, manage large
   * product catalogs, and perform batch updates. The mutation is helpful for bulk product management, including price
   * adjustments, inventory updates, and product lifecycle management.
   *
   * The behavior of `productSet` depends on the type of field it's modifying:
   *
   * - **For list fields**: Creates new entries, updates existing entries, and deletes existing entries
   * that aren't included in the mutation's input. Common examples of list fields include
   * [`collections`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet#arguments-input.fields.collections),
   * [`metafields`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet#arguments-input.fields.metafields),
   * and [`variants`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet#arguments-input.fields.variants).
   *
   * - **For all other field types**: Updates only the included fields. Any omitted fields will remain unchanged.
   *
   * > Note:
   * > By default, stores have a limit of 2048 product variants for each product.
   *
   * You can run `productSet` in one of the following modes:
   *
   * - **Synchronously**: Returns the updated product in the response.
   * - **Asynchronously**: Returns a [`ProductSetOperation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductSetOperation) object.
   * Use the [`productOperation`](https://shopify.dev/api/admin-graphql/latest/queries/productOperation) query to check the status of the operation and
   * retrieve details of the updated product and its product variants.
   *
   * If you need to only manage product variants, then use one of the following mutations:
   *
   * - [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate)
   * - [`productVariantsBulkDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkDelete)
   *
   * If you need to only manage product options, then use one of the following mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionUpdate)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsReorder)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete)
   *
   * Learn more about [syncing product data from an external source](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/sync-data).
   */
  productSet?: Maybe<ProductSetPayload>;
  /**
   * Unpublishes a product.
   * @deprecated Use `publishableUnpublish` instead.
   */
  productUnpublish?: Maybe<ProductUnpublishPayload>;
  /**
   * Updates a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * with attributes such as title, description, vendor, and media.
   *
   * The `productUpdate` mutation helps you modify many products at once, avoiding the tedious or time-consuming
   * process of updating them one by one in the Shopify admin. Common examples including updating
   * product details like status or tags.
   *
   * The `productUpdate` mutation doesn't support updating
   * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant).
   * To update multiple product variants for a single product and manage prices, use the
   * [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate)
   * mutation.
   *
   * > Note:
   * > The `productUpdate` mutation has a [throttle](https://shopify.dev/docs/api/usage/rate-limits#resource-based-rate-limits)
   * > that takes effect when a store has 50,000 product variants. After this threshold is reached, no more than
   * > 1,000 new product variants can be updated per day.
   *
   * After updating a product, you can make additional changes using one of the following mutations:
   *
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet):
   * Used to perform multiple operations on products, such as creating or modifying product options and variants.
   * - [`publishablePublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publishablePublish):
   * Used to publish the product and make it available to customers, if the product is currently unpublished.
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productUpdate?: Maybe<ProductUpdatePayload>;
  /**
   * Updates properties of media attached to a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product). You can modify alt text for accessibility or change preview images for existing media items.
   *
   * Provide the product ID and an array of [`UpdateMediaInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/UpdateMediaInput) objects. Each update specifies the media's ID and the properties to change. Updates apply only to media already attached to the product and don't affect their position in the product gallery.
   * @deprecated Use `fileUpdate` instead.
   */
  productUpdateMedia?: Maybe<ProductUpdateMediaPayload>;
  /**
   * Appends existing media from a product to specific variants of that product, creating associations between media files and particular product options. This allows different variants to showcase relevant images or videos.
   *
   * For example, a t-shirt product might have color variants where each color variant displays only the images showing that specific color, helping customers see exactly what they're purchasing.
   *
   * Use `ProductVariantAppendMedia` to:
   * - Associate specific images with product variants for accurate display
   * - Build variant-specific media management in product interfaces
   * - Implement automated media assignment based on variant attributes
   *
   * The operation links existing product media to variants without duplicating files, maintaining efficient media storage while enabling variant-specific displays.
   *
   * Learn more about [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant).
   */
  productVariantAppendMedia?: Maybe<ProductVariantAppendMediaPayload>;
  /** Detaches media from product variants. */
  productVariantDetachMedia?: Maybe<ProductVariantDetachMediaPayload>;
  /** Adds multiple selling plan groups to a product variant. */
  productVariantJoinSellingPlanGroups?: Maybe<ProductVariantJoinSellingPlanGroupsPayload>;
  /** Remove multiple groups from a product variant. */
  productVariantLeaveSellingPlanGroups?: Maybe<ProductVariantLeaveSellingPlanGroupsPayload>;
  /**
   * Creates new bundles, updates component quantities in existing bundles, and removes bundle components for one or multiple [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
   *
   * Each bundle variant can contain up to 30 component variants with specified quantities. After an app assigns components to a bundle, only that app can manage those components.
   *
   * > Note:
   * > For most use cases, use [`productBundleCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productBundleCreate) instead, which creates product fixed bundles. `productVariantRelationshipBulkUpdate` is for [variant fixed bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-variant-fixed-bundle), where each variant has its own component configuration.
   */
  productVariantRelationshipBulkUpdate?: Maybe<ProductVariantRelationshipBulkUpdatePayload>;
  /**
   * Creates multiple [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * for a single [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) in one operation.
   * You can run this mutation directly or as part of a [bulk operation](https://shopify.dev/docs/api/usage/bulk-operations/imports)
   * for large-scale catalog updates.
   *
   * Use the `productVariantsBulkCreate` mutation to efficiently add new product variants—such as different sizes,
   * colors, or materials—to an existing product. The mutation is helpful if you need to add product variants in bulk,
   * such as importing from an external system.
   *
   * The mutation supports:
   *
   * - Creating variants with custom option values
   * - Associating media (for example, images, videos, and 3D models) with the product or its variants
   * - Handling complex product configurations
   *
   * > Note:
   * > By default, stores have a limit of 2048 product variants for each product.
   *
   * After creating variants, you can make additional changes using one of the following mutations:
   *
   * - [`productVariantsBulkUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkUpdate):
   * Updates multiple product variants for a single product in one operation.
   * - [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet):
   * Used to perform multiple operations on products, such as creating or modifying product options and variants.
   *
   * You can also specifically manage product options through related mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionUpdate)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsReorder)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productVariantsBulkCreate?: Maybe<ProductVariantsBulkCreatePayload>;
  /** Deletes multiple variants in a single [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product). Specify the product ID and an array of variant IDs to remove variants in bulk. You can call this mutation directly or through the [`bulkOperationRunMutation`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/bulkOperationRunMutation) mutation. Returns the updated product and any [`UserError`](https://shopify.dev/docs/api/admin-graphql/latest/objects/UserError) objects. */
  productVariantsBulkDelete?: Maybe<ProductVariantsBulkDeletePayload>;
  /** Reorders multiple variants in a single product. This mutation can be called directly or via the bulkOperation. */
  productVariantsBulkReorder?: Maybe<ProductVariantsBulkReorderPayload>;
  /**
   * Updates multiple [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * for a single [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) in one operation.
   * You can run this mutation directly or as part of a [bulk operation](https://shopify.dev/docs/api/usage/bulk-operations/imports)
   * for large-scale catalog updates.
   *
   * Use the `productVariantsBulkUpdate` mutation to efficiently modify product variants—such as different sizes,
   * colors, or materials—associated with an existing product. The mutation is helpful if you need to update a
   * product's variants in bulk, such as importing from an external system.
   *
   * The mutation supports:
   *
   * - Updating variants with custom option values
   * - Associating media (for example, images, videos, and 3D models) with the product or its variants
   * - Handling complex product configurations
   *
   * > Note:
   * > By default, stores have a limit of 2048 product variants for each product.
   *
   * After creating variants, you can make additional changes using the
   * [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet) mutation,
   * which is used to perform multiple operations on products, such as creating or modifying product options and variants.
   *
   * You can also specifically manage product options through related mutations:
   *
   * - [`productOptionsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsCreate)
   * - [`productOptionUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionUpdate)
   * - [`productOptionsReorder`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsReorder)
   * - [`productOptionsDelete`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productOptionsDelete)
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  productVariantsBulkUpdate?: Maybe<ProductVariantsBulkUpdatePayload>;
  /**
   * Updates the server pixel to connect to a Google PubSub endpoint.
   * Running this mutation deletes any previous subscriptions for the server pixel.
   */
  pubSubServerPixelUpdate?: Maybe<PubSubServerPixelUpdatePayload>;
  /**
   * Creates a webhook subscription that notifies your [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) when specific events occur in a shop. Webhooks push event data to your endpoint immediately when changes happen, eliminating the need for polling.
   *
   * This mutation configures webhook delivery to a Google Cloud Pub/Sub topic. You can filter events using [Shopify API search syntax](https://shopify.dev/docs/api/usage/search-syntax) to receive only relevant webhooks, control which data fields are included in webhook payloads, and specify metafield namespaces to include.
   *
   * > Note:
   * > The Webhooks API version [configured in your app](https://shopify.dev/docs/apps/build/webhooks/subscribe/use-newer-api-version) determines the API version for webhook events. You can't specify it per subscription.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   * @deprecated Use `webhookSubscriptionCreate` instead.
   */
  pubSubWebhookSubscriptionCreate?: Maybe<PubSubWebhookSubscriptionCreatePayload>;
  /**
   * Updates a Google Cloud Pub/Sub webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   * @deprecated Use `webhookSubscriptionUpdate` instead.
   */
  pubSubWebhookSubscriptionUpdate?: Maybe<PubSubWebhookSubscriptionUpdatePayload>;
  /**
   * Creates a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) that controls which [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) customers can access through a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog).
   *
   * ### When to create a publication
   *
   * Publications are **optional** for catalogs. Only create a publication if you need to control which products are visible in a specific catalog context. When a publication isn't associated with a catalog, product availability is determined by the sales channel.
   *
   * **Create a publication if you need to:**
   * - Restrict product visibility to a subset of your inventory for a specific market or company location
   * - Publish different product selections to different contexts
   *
   * **Do NOT create a publication if:**
   * - You want product availability determined by the sales channel
   * - You only need custom pricing (use a price list on the catalog instead)
   *
   * ### Configuration options
   *
   * You can create an empty publication and add products later, or prepopulate it with all existing products. The [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publicationCreate#arguments-input.fields.autoPublish) field determines whether the publication automatically adds newly created products.
   */
  publicationCreate?: Maybe<PublicationCreatePayload>;
  /** Deletes a publication. */
  publicationDelete?: Maybe<PublicationDeletePayload>;
  /**
   * Updates a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   *
   * You can add or remove [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) from the publication, with a maximum of 50 items per operation. The [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/publicationUpdate#arguments-input.fields.autoPublish) field determines whether new products automatically display in this publication.
   */
  publicationUpdate?: Maybe<PublicationUpdatePayload>;
  /**
   * Publishes a resource, such as a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) or [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), to one or more [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   *
   * For products to be visible in a channel, they must have an active [`ProductStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/ProductStatus). Products sold exclusively on subscription (`requiresSellingPlan: true`) can only be published to online stores.
   *
   * You can schedule future publication by providing a publish date. Only online store channels support [scheduled publishing](https://shopify.dev/docs/apps/build/sales-channels/scheduled-product-publishing).
   */
  publishablePublish?: Maybe<PublishablePublishPayload>;
  /**
   * Publishes a resource to the current [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) associated with the requesting app. The system determines the current channel by the app's API client ID. Resources include [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects that implement the [`Publishable`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Publishable) interface.
   *
   * For products to be visible in the channel, they must have an active [`ProductStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/ProductStatus). Products sold exclusively on subscription ([`requiresSellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product#field-Product.fields.requiresSellingPlan): `true`) can only be published to online stores.
   * @deprecated Use `publishablePublish` instead.
   */
  publishablePublishToCurrentChannel?: Maybe<PublishablePublishToCurrentChannelPayload>;
  /**
   * Unpublishes a resource, such as a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) or [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), from one or more [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication). The resource remains in your store but becomes unavailable to customers.
   *
   * For products to be visible in a channel, they must have an active [`ProductStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/ProductStatus).
   */
  publishableUnpublish?: Maybe<PublishableUnpublishPayload>;
  /**
   * Unpublishes a resource from the current channel. If the resource is a product, then it's visible in the channel only if the product status is `active`.
   * @deprecated Use `publishableUnpublish` instead.
   */
  publishableUnpublishToCurrentChannel?: Maybe<PublishableUnpublishToCurrentChannelPayload>;
  /**
   * Updates quantity pricing on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) for specific [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects. You can set fixed prices (see [`PriceListPrice`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceListPrice)), quantity rules, and quantity price breaks in a single operation.
   *
   * [`QuantityRule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/QuantityRule) objects define minimum, maximum, and increment constraints for ordering. [`QuantityPriceBreak`](https://shopify.dev/docs/api/admin-graphql/latest/objects/QuantityPriceBreak) objects offer tiered pricing based on purchase volume.
   *
   * The mutation executes delete operations before create operations and doesn't allow partial updates.
   *
   * > Note: If any requested change fails, then the mutation doesn't apply any of the changes.
   */
  quantityPricingByVariantUpdate?: Maybe<QuantityPricingByVariantUpdatePayload>;
  /**
   * Creates or updates existing quantity rules on a price list.
   * You can use the `quantityRulesAdd` mutation to set order level minimums, maximumums and increments for specific product variants.
   */
  quantityRulesAdd?: Maybe<QuantityRulesAddPayload>;
  /**
   * Deletes specific quantity rules from a price list using a product variant ID.
   * You can use the `quantityRulesDelete` mutation to delete a set of quantity rules from a price list.
   */
  quantityRulesDelete?: Maybe<QuantityRulesDeletePayload>;
  /**
   * Creates a refund for an order, allowing you to process returns and issue payments back to customers.
   *
   * Use the `refundCreate` mutation to programmatically process refunds in scenarios where you need to
   * return money to customers, such as when handling returns, processing chargebacks, or correcting
   * order errors.
   *
   * The `refundCreate` mutation supports various refund scenarios:
   *
   * - Refunding line items with optional restocking
   * - Refunding shipping costs
   * - Refunding duties and import taxes
   * - Refunding additional fees
   * - Processing refunds through different payment methods
   * - Issuing store credit refunds (when enabled)
   *
   * You can create both full and partial refunds, and optionally allow over-refunding in specific
   * cases.
   *
   * After creating a refund, you can track its status and details through the order's
   * [`refunds`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.refunds)
   * field. The refund is associated with the order and can be used for reporting and reconciliation purposes.
   *
   * Learn more about
   * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
   * and [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties).
   *
   * > Note:
   * > The refunding behavior of the `refundCreate` mutation is similar to the
   * [`returnRefund`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnRefund)
   * mutation. The key difference is that the `refundCreate` mutation lets you to specify restocking behavior
   * for line items, whereas the `returnRefund` mutation focuses solely on handling the financial refund without
   * any restocking input.
   *
   * > Caution:
   * > As of 2026-01, this mutation supports an optional idempotency key using the `@idempotent` directive.
   * > As of 2026-04, the idempotency key is required and must be provided using the `@idempotent` directive.
   * > For more information, see the [idempotency documentation](https://shopify.dev/docs/api/usage/idempotent-requests).
   */
  refundCreate?: Maybe<RefundCreatePayload>;
  /** Removes return and/or exchange lines from a return. */
  removeFromReturn?: Maybe<RemoveFromReturnPayload>;
  /**
   * Approves a customer's return request.
   * If this mutation is successful, then the `Return.status` field of the
   * approved return is set to `OPEN`.
   */
  returnApproveRequest?: Maybe<ReturnApproveRequestPayload>;
  /**
   * Cancels a return and restores the items back to being fulfilled.
   * Canceling a return is only available before any work has been done
   * on the return (such as an inspection or refund).
   */
  returnCancel?: Maybe<ReturnCancelPayload>;
  /**
   * Indicates a return is complete, either when a refund has been made and items restocked,
   * or simply when it has been marked as returned in the system.
   */
  returnClose?: Maybe<ReturnClosePayload>;
  /**
   * Creates a return from an existing order that has at least one fulfilled
   * [line item](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem)
   * that hasn't yet been refunded. If you create a return on an archived order, then the order is automatically
   * unarchived.
   *
   * Use the `returnCreate` mutation when your workflow involves
   * [approving](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnApproveRequest) or
   * [declining](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnDeclineRequest) requested returns
   * outside of the Shopify platform.
   *
   * The `returnCreate` mutation performs the following actions:
   *
   * - Creates a return in the `OPEN` state, and assumes that the return request from the customer has already been
   * approved
   * - Creates a [reverse fulfillment order](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
   * and enables you to create a [reverse delivery](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
   * for the reverse fulfillment order
   *
   * After you've created a return, use the
   * [`return`](https://shopify.dev/docs/api/admin-graphql/latest/queries/return) query to retrieve the
   * return by its ID. Learn more about providing a
   * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
   * for merchants.
   */
  returnCreate?: Maybe<ReturnCreatePayload>;
  /**
   * Declines a return on an order.
   * When a return is declined, each `ReturnLineItem.fulfillmentLineItem` can be associated to a new return.
   * Use the `ReturnCreate` or `ReturnRequest` mutation to initiate a new return.
   */
  returnDeclineRequest?: Maybe<ReturnDeclineRequestPayload>;
  /**
   * Removes return lines from a return.
   * @deprecated Use `removeFromReturn` instead.
   */
  returnLineItemRemoveFromReturn?: Maybe<ReturnLineItemRemoveFromReturnPayload>;
  /**
   * Processes a return by confirming which items customers return and exchange, handling their disposition, and optionally issuing refunds. This mutation confirms the quantities for [`ReturnLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ReturnLineItem) and [`ExchangeLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ExchangeLineItem) objects previously created on the [`Return`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return).
   *
   * For returned items, you specify how to handle them through dispositions such as restocking or disposal. The mutation creates [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) objects for exchange items and records all transactions in the merchant's financial reports. You can optionally issue refunds through financial transfers, apply refund duties, and refund shipping costs.
   *
   * Learn more about [processing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management).
   */
  returnProcess?: Maybe<ReturnProcessPayload>;
  /**
   * Creates a refund for items being returned when the return status is `OPEN` or `CLOSED`. This mutation processes the financial aspects of a return by refunding line items, shipping costs, and duties back to the customer.
   * @deprecated Use `returnProcess` instead.
   */
  returnRefund?: Maybe<ReturnRefundPayload>;
  /** Reopens a closed return. */
  returnReopen?: Maybe<ReturnReopenPayload>;
  /**
   * Creates a return request that requires merchant approval before processing. The return has its status set to `REQUESTED` and the merchant must approve or decline it.
   *
   * Use this mutation when customers initiate returns that need review. After creating a requested return, use [`returnApproveRequest`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnApproveRequest) to approve it or [`returnDeclineRequest`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnDeclineRequest) to decline it.
   *
   * For returns that should be immediately open for processing, use the [`returnCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnCreate) mutation instead.
   *
   * Learn more about [building return management workflows](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management).
   */
  returnRequest?: Maybe<ReturnRequestPayload>;
  /** Creates a new reverse delivery with associated external shipping information. */
  reverseDeliveryCreateWithShipping?: Maybe<ReverseDeliveryCreateWithShippingPayload>;
  /** Updates a reverse delivery with associated external shipping information. */
  reverseDeliveryShippingUpdate?: Maybe<ReverseDeliveryShippingUpdatePayload>;
  /** Disposes reverse fulfillment order line items. */
  reverseFulfillmentOrderDispose?: Maybe<ReverseFulfillmentOrderDisposePayload>;
  /** Creates a saved search. */
  savedSearchCreate?: Maybe<SavedSearchCreatePayload>;
  /** Delete a saved search. */
  savedSearchDelete?: Maybe<SavedSearchDeletePayload>;
  /** Updates a saved search. */
  savedSearchUpdate?: Maybe<SavedSearchUpdatePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   *
   * Creates a new script tag.
   */
  scriptTagCreate?: Maybe<ScriptTagCreatePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   *
   * Deletes a script tag.
   */
  scriptTagDelete?: Maybe<ScriptTagDeletePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   *
   * Updates a script tag.
   */
  scriptTagUpdate?: Maybe<ScriptTagUpdatePayload>;
  /** Creates a segment. */
  segmentCreate?: Maybe<SegmentCreatePayload>;
  /** Deletes a segment. */
  segmentDelete?: Maybe<SegmentDeletePayload>;
  /** Updates a segment. */
  segmentUpdate?: Maybe<SegmentUpdatePayload>;
  /** Adds multiple product variants to a selling plan group. */
  sellingPlanGroupAddProductVariants?: Maybe<SellingPlanGroupAddProductVariantsPayload>;
  /** Adds multiple products to a selling plan group. */
  sellingPlanGroupAddProducts?: Maybe<SellingPlanGroupAddProductsPayload>;
  /**
   * Creates a selling plan group that defines how products can be sold and purchased. A selling plan group represents a selling method such as "Subscribe and save", "Pre-order", or "Try before you buy" and contains one or more selling plans with specific billing, delivery, and pricing policies.
   *
   * Use the [`resources`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/sellingPlanGroupCreate#arguments-resources) argument to associate products or product variants with the group during creation. You can also add products later using [`sellingPlanGroupAddProducts`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/sellingPlanGroupAddProducts) or [`sellingPlanGroupAddProductVariants`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/sellingPlanGroupAddProductVariants).
   *
   * Learn more about [building selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan#step-1-create-a-selling-plan-group) or explore [examples of creating TBYB and other selling plan groups](https://shopify.dev/docs/api/admin-graphql/latest/mutations/sellingPlanGroupCreate?example=create-a-tbyb-selling-plan-group).
   */
  sellingPlanGroupCreate?: Maybe<SellingPlanGroupCreatePayload>;
  /** Delete a Selling Plan Group. This does not affect subscription contracts. */
  sellingPlanGroupDelete?: Maybe<SellingPlanGroupDeletePayload>;
  /** Removes multiple product variants from a selling plan group. */
  sellingPlanGroupRemoveProductVariants?: Maybe<SellingPlanGroupRemoveProductVariantsPayload>;
  /** Removes multiple products from a selling plan group. */
  sellingPlanGroupRemoveProducts?: Maybe<SellingPlanGroupRemoveProductsPayload>;
  /** Update a Selling Plan Group. */
  sellingPlanGroupUpdate?: Maybe<SellingPlanGroupUpdatePayload>;
  /** Creates a new unconfigured server pixel. A single server pixel can exist for an app and shop combination. If you call this mutation when a server pixel already exists, then an error will return. */
  serverPixelCreate?: Maybe<ServerPixelCreatePayload>;
  /** Deletes the Server Pixel associated with the current app & shop. */
  serverPixelDelete?: Maybe<ServerPixelDeletePayload>;
  /**
   * Purchases a shipping label for a fulfillment order.
   *
   * The `shippingLabelPurchase` mutation buys one shipping label for one fulfillment order using Shopify Shipping.
   * The mutation validates the fulfillment order, shipment details, package information, and available rates before it starts an asynchronous label purchase.
   *
   * > Note:
   * > The shop must have accepted the Shopify Shipping terms of service before an app can purchase labels.
   * >
   * > FedEx label purchases are not supported.
   *
   * After validation, the mutation builds the shipment details, fetches available rates, selects a rate, and enqueues the label purchase. If you provide `preferredRateSelection`, the mutation attempts to purchase the matching carrier and service. If you don't provide `preferredRateSelection`, the mutation uses Shopify Shipping's default rate selection.
   *
   * Default rate selection first tries to keep the fulfillment order's buyer-selected delivery method when available. If no buyer-selected rate matches, the mutation uses the shop's preferred carrier and service when configured. Otherwise, it uses Shopify's recommended rate for the shipment destination.
   *
   * For Merchant of Record (MoR) and Markets Pro orders, the mutation first removes rates from carriers that don't support Markets Pro.
   *
   * A shipping label can be purchased only when the fulfillment order meets the following criteria:
   *
   * - The fulfillment order is fulfillable and requires shipping.
   * - The order has a destination shipping address.
   * - The fulfillment order has an assigned location that can be used as the origin address.
   * - The shipment has a valid shipping date, package, weight, and required customs information.
   * - At least one shipping rate is available for the shipment.
   *
   * The mutation can return errors in two places:
   *
   * - Synchronous validation errors are returned in the mutation's `userErrors` field. For example, invalid fulfillment orders, invalid package dimensions, missing customs information, or unavailable rates.
   * - Asynchronous purchase-processing errors are returned in the `ShippingLabelPurchaseResult.errors` field after the purchase starts. For example, carrier availability, connection, billing, or other purchase-processing failures.
   *
   * Use the returned `ShippingLabelPurchaseResult.id` to poll the purchase status with the `node` query. The result starts with a status of `PENDING_PURCHASE` and ends with `PURCHASED` or `PURCHASE_FAILED`. When the purchase succeeds, `shippingLabels` contains the purchased label.
   */
  shippingLabelPurchase?: Maybe<ShippingLabelPurchasePayload>;
  /** Deletes a shipping package. */
  shippingPackageDelete?: Maybe<ShippingPackageDeletePayload>;
  /**
   * Set a shipping package as the default.
   * The default shipping package is the one used to calculate shipping costs on checkout.
   */
  shippingPackageMakeDefault?: Maybe<ShippingPackageMakeDefaultPayload>;
  /** Updates a shipping package. */
  shippingPackageUpdate?: Maybe<ShippingPackageUpdatePayload>;
  /** Deletes a locale for a shop. This also deletes all translations of this locale. */
  shopLocaleDisable?: Maybe<ShopLocaleDisablePayload>;
  /** Adds a locale for a shop. The newly added locale is in the unpublished state. */
  shopLocaleEnable?: Maybe<ShopLocaleEnablePayload>;
  /** Updates a locale for a shop. */
  shopLocaleUpdate?: Maybe<ShopLocaleUpdatePayload>;
  /** Updates a shop policy. */
  shopPolicyUpdate?: Maybe<ShopPolicyUpdatePayload>;
  /**
   * The `ResourceFeedback` object lets your app report the status of shops and their resources. For example, if
   * your app is a marketplace channel, then you can use resource feedback to alert merchants that they need to connect their marketplace account by signing in.
   *
   * Resource feedback notifications are displayed to the merchant on the home screen of their Shopify admin, and in the product details view for any products that are published to your app.
   *
   * This resource should be used only in cases where you're describing steps that a merchant is required to complete. If your app offers optional or promotional set-up steps, or if it makes recommendations, then don't use resource feedback to let merchants know about them.
   *
   * ## Sending feedback on a shop
   *
   * You can send resource feedback on a shop to let the merchant know what steps they need to take to make sure that your app is set up correctly. Feedback can have one of two states: `REQUIRES_ACTION` or `ACCEPTED`. You need to send a `REQUIRES_ACTION` feedback request for each step that the merchant is required to complete.
   *
   * If there are multiple set-up steps that require merchant action, then send feedback with a state of `REQUIRES_ACTION` as merchants complete prior steps. When all required actions are resolved, send an `ACCEPTED` feedback request to clear the active feedback signal.
   *
   * ### Clearing feedback with ACCEPTED
   * Sending `state: ACCEPTED` removes the active feedback entry. After this mutation succeeds, reading `channel.resourceFeedback`, `app.feedback`, or the `feedback` field on this payload may return `null`—this is expected behavior, not a mutation failure. A `null` result means no outstanding feedback exists for the channel.
   *
   * ### Important
   * Sending feedback replaces previously sent feedback for the shop. Send a new `shopResourceFeedbackCreate` mutation to push the latest state of a shop or its resources to Shopify.
   */
  shopResourceFeedbackCreate?: Maybe<ShopResourceFeedbackCreatePayload>;
  /** Creates an alternate currency payout for a Shopify Payments account. */
  shopifyPaymentsPayoutAlternateCurrencyCreate?: Maybe<ShopifyPaymentsPayoutAlternateCurrencyCreatePayload>;
  /**
   * Generates the URL and signed paramaters needed to upload an asset to Shopify.
   * @deprecated Use `stagedUploadsCreate` instead.
   */
  stagedUploadTargetGenerate?: Maybe<StagedUploadTargetGeneratePayload>;
  /**
   * Uploads multiple images.
   * @deprecated Use `stagedUploadsCreate` instead.
   */
  stagedUploadTargetsGenerate?: Maybe<StagedUploadTargetsGeneratePayload>;
  /**
   * Creates staged upload targets for file uploads such as images, videos, and 3D models.
   *
   * Use the `stagedUploadsCreate` mutation instead of direct file creation mutations when:
   *
   * - **Uploading large files**: Files over a few MB benefit from staged uploads for better reliability
   * - **Uploading media files**: Videos, 3D models, and high-resolution images
   * - **Bulk importing**: CSV files, product catalogs, or other bulk data
   * - **Using external file sources**: When files are stored remotely and need to be transferred to Shopify
   *
   * The `stagedUploadsCreate` mutation is the first step in Shopify's secure two-step upload process:
   *
   * **Step 1: Create staged upload targets** (this mutation)
   * - Generate secure, temporary upload URLs for your files.
   * - Receive authentication parameters for the upload.
   *
   * **Step 2: Upload files and create assets**
   * - Upload your files directly to the provided URLs using the authentication parameters.
   * - Use the returned `resourceUrl` as the `originalSource` in subsequent mutations like `fileCreate`.
   *
   * This approach provides better performance for large files, handles network interruptions gracefully,
   * and ensures secure file transfers to Shopify's storage infrastructure.
   *
   * > Note:
   * > File size is required when uploading
   * > [`VIDEO`](https://shopify.dev/docs/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#enums-VIDEO) or
   * > [`MODEL_3D`](https://shopify.dev/docs/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#enums-MODEL_3D)
   * > resources.
   *
   * After creating staged upload targets, complete the process by:
   *
   * 1. **Uploading files**: Send your files to the returned [`url`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StagedMediaUploadTarget#field-StagedMediaUploadTarget.fields.url) using the provided
   * [`parameters`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StagedMediaUploadTarget#field-StagedMediaUploadTarget.fields.parameters)
   * for authentication
   * 2. **Creating file assets**: Use the [`resourceUrl`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StagedMediaUploadTarget#field-StagedMediaUploadTarget.fields.resourceUrl)
   * as the `originalSource` in mutations such as:
   *    - [`fileCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fileCreate):
   *      Creates file assets from staged uploads
   *    - [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate):
   *      Updates products with new media from staged uploads
   *
   * Learn more about [uploading media to Shopify](https://shopify.dev/apps/online-store/media/products).
   */
  stagedUploadsCreate?: Maybe<StagedUploadsCreatePayload>;
  /**
   * Activates the specified standard metafield definition from its template.
   *
   * Refer to the [list of standard metafield definition templates](https://shopify.dev/apps/metafields/definitions/standard-definitions).
   */
  standardMetafieldDefinitionEnable?: Maybe<StandardMetafieldDefinitionEnablePayload>;
  /** Enables the specified standard metaobject definition from its template. */
  standardMetaobjectDefinitionEnable?: Maybe<StandardMetaobjectDefinitionEnablePayload>;
  /**
   * Adds funds to a [`StoreCreditAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StoreCreditAccount) by creating a [`StoreCreditAccountCreditTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StoreCreditAccountCreditTransaction). The mutation accepts either a store credit account ID, a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) ID, or a [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) ID. When you provide a customer or company location ID, it automatically creates an account if one doesn't exist for the specified currency.
   *
   * Store credit accounts are currency-specific. A single owner can have multiple accounts, each holding a different currency. Use the most appropriate currency for the given store credit account owner.
   *
   * Credits can optionally include an expiration date.
   */
  storeCreditAccountCredit?: Maybe<StoreCreditAccountCreditPayload>;
  /** Creates a debit transaction that decreases the store credit account balance by the given amount. */
  storeCreditAccountDebit?: Maybe<StoreCreditAccountDebitPayload>;
  /**
   * Creates a storefront access token that delegates unauthenticated access scopes to clients using the [Storefront API](https://shopify.dev/docs/api/storefront). The token provides public access to storefront resources without requiring customer authentication.
   *
   * Each shop can have up to 100 active [`StorefrontAccessToken`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StorefrontAccessToken) objects. Headless storefronts, mobile apps, and other client applications typically use these tokens to access public storefront data.
   *
   * Learn more about [building with the Storefront API](https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/getting-started).
   */
  storefrontAccessTokenCreate?: Maybe<StorefrontAccessTokenCreatePayload>;
  /** Deletes a storefront access token. */
  storefrontAccessTokenDelete?: Maybe<StorefrontAccessTokenDeletePayload>;
  /**
   * Creates a billing attempt to charge for a [`SubscriptionContract`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract). The mutation processes either the payment for the current billing cycle or for a specific cycle, if selected.
   *
   * The mutation creates an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) when successful. Failed billing attempts include a [`processingError`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionBillingAttemptCreate#returns-subscriptionBillingAttempt.fields.processingError) field with error details.
   *
   * > Tip:
   * > Use the [`idempotencyKey`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionBillingAttemptCreate#arguments-subscriptionBillingAttemptInput.fields.idempotencyKey) to ensure the billing attempt executes only once, preventing duplicate charges if the request is retried.
   *
   * You can target a specific billing cycle using the [`billingCycleSelector`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/SubscriptionBillingCycleSelector) to bill past or future cycles. The [`originTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt#field-SubscriptionBillingAttempt.fields.originTime) parameter adjusts fulfillment scheduling for attempts completed after the expected billing date.
   *
   * Learn more about [creating billing attempts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract#step-4-create-a-billing-attempt).
   */
  subscriptionBillingAttemptCreate?: Maybe<SubscriptionBillingAttemptCreatePayload>;
  /** Asynchronously queries and charges all subscription billing cycles whose [billingAttemptExpectedDate](https://shopify.dev/api/admin-graphql/latest/objects/SubscriptionBillingCycle#field-billingattemptexpecteddate) values fall within a specified date range and meet additional filtering criteria. The results of this action can be retrieved using the [subscriptionBillingCycleBulkResults](https://shopify.dev/api/admin-graphql/latest/queries/subscriptionBillingCycleBulkResults) query. */
  subscriptionBillingCycleBulkCharge?: Maybe<SubscriptionBillingCycleBulkChargePayload>;
  /** Asynchronously queries all subscription billing cycles whose [billingAttemptExpectedDate](https://shopify.dev/api/admin-graphql/latest/objects/SubscriptionBillingCycle#field-billingattemptexpecteddate) values fall within a specified date range and meet additional filtering criteria. The results of this action can be retrieved using the [subscriptionBillingCycleBulkResults](https://shopify.dev/api/admin-graphql/latest/queries/subscriptionBillingCycleBulkResults) query. */
  subscriptionBillingCycleBulkSearch?: Maybe<SubscriptionBillingCycleBulkSearchPayload>;
  /** Creates a new subscription billing attempt for a specified billing cycle. This is the alternative mutation for [subscriptionBillingAttemptCreate](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionBillingAttemptCreate). For more information, refer to [Create a subscription contract](https://shopify.dev/docs/apps/selling-strategies/subscriptions/contracts/create#step-4-create-a-billing-attempt). */
  subscriptionBillingCycleCharge?: Maybe<SubscriptionBillingCycleChargePayload>;
  /**
   * Commits the updates of a Subscription Billing Cycle Contract draft.
   *
   * Commits are rate limited per subscription contract across all apps on the store. If you exceed the limit, then the mutation returns a top-level `THROTTLED` error and doesn't commit. Wait before you retry.
   */
  subscriptionBillingCycleContractDraftCommit?: Maybe<SubscriptionBillingCycleContractDraftCommitPayload>;
  /** Concatenates a contract to a Subscription Draft. */
  subscriptionBillingCycleContractDraftConcatenate?: Maybe<SubscriptionBillingCycleContractDraftConcatenatePayload>;
  /** Edit the contents of a subscription contract for the specified billing cycle. */
  subscriptionBillingCycleContractEdit?: Maybe<SubscriptionBillingCycleContractEditPayload>;
  /** Delete the schedule and contract edits of the selected subscription billing cycle. */
  subscriptionBillingCycleEditDelete?: Maybe<SubscriptionBillingCycleEditDeletePayload>;
  /** Delete the current and future schedule and contract edits of a list of subscription billing cycles. */
  subscriptionBillingCycleEditsDelete?: Maybe<SubscriptionBillingCycleEditsDeletePayload>;
  /** Modify the schedule of a specific billing cycle. */
  subscriptionBillingCycleScheduleEdit?: Maybe<SubscriptionBillingCycleScheduleEditPayload>;
  /** Skips a Subscription Billing Cycle. */
  subscriptionBillingCycleSkip?: Maybe<SubscriptionBillingCycleSkipPayload>;
  /** Unskips a Subscription Billing Cycle. */
  subscriptionBillingCycleUnskip?: Maybe<SubscriptionBillingCycleUnskipPayload>;
  /** Activates a Subscription Contract. Contract status must be either active, paused, or failed. */
  subscriptionContractActivate?: Maybe<SubscriptionContractActivatePayload>;
  /** Creates a Subscription Contract. */
  subscriptionContractAtomicCreate?: Maybe<SubscriptionContractAtomicCreatePayload>;
  /** Cancels a Subscription Contract. */
  subscriptionContractCancel?: Maybe<SubscriptionContractCancelPayload>;
  /**
   * Creates a subscription contract draft, which is an intention to create a new subscription. The draft lets you incrementally build and modify subscription details before committing them to create the actual [`SubscriptionContract`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract).
   *
   * The mutation requires [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) information, billing details, and contract configuration including the [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy). You can specify the [`CustomerPaymentMethod`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPaymentMethod), the [`MailingAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress) for shipping, and subscription intervals.
   *
   * After you create the draft, you can either modify it with the [`subscriptionDraftUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftUpdate) mutation or finalize and create the active subscription contract with [`subscriptionDraftCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftCommit).
   *
   * This mutation and the draft-based flow are deprecated in favor of the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
   *
   * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract).
   * @deprecated Use [`subscriptionContractCreateCalculate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionContractCreateCalculate) instead.
   */
  subscriptionContractCreate?: Maybe<SubscriptionContractCreatePayload>;
  /** Expires a Subscription Contract. */
  subscriptionContractExpire?: Maybe<SubscriptionContractExpirePayload>;
  /** Fails a Subscription Contract. */
  subscriptionContractFail?: Maybe<SubscriptionContractFailPayload>;
  /** Pauses a Subscription Contract. */
  subscriptionContractPause?: Maybe<SubscriptionContractPausePayload>;
  /**
   * Allows for the easy change of a Product in a Contract or a Product price change.
   *
   * Changes are rate limited per subscription contract across all apps on the store. If you exceed the limit, then the mutation returns a top-level `THROTTLED` error and doesn't change the contract. Wait before you retry.
   */
  subscriptionContractProductChange?: Maybe<SubscriptionContractProductChangePayload>;
  /**
   * Sets the next billing date of a Subscription Contract. This field is managed by the apps.
   *         Alternatively you can utilize our
   *         [Billing Cycles APIs](https://shopify.dev/docs/apps/selling-strategies/subscriptions/billing-cycles),
   *         which provide auto-computed billing dates and additional functionalities.
   */
  subscriptionContractSetNextBillingDate?: Maybe<SubscriptionContractSetNextBillingDatePayload>;
  /**
   * Creates a draft of an existing [`SubscriptionContract`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract). The draft captures the current state of the contract and allows incremental modifications through draft mutations such as [`subscriptionDraftLineAdd`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftLineAdd), [`subscriptionDraftDiscountAdd`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftDiscountAdd), and [`subscriptionDraftUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftUpdate).
   *
   * Changes remain in draft state and don't affect the live contract until committed. After you've made all necessary changes to the draft, commit it using [`subscriptionDraftCommit`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftCommit) to apply the updates to the original contract.
   *
   * This mutation and the draft-based edit flow are deprecated in favor of the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
   *
   * Learn more about [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract#step-2-create-a-draft-of-an-existing-contract).
   * @deprecated Use [`subscriptionContractUpdateCalculate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionContractUpdateCalculate) instead.
   */
  subscriptionContractUpdate?: Maybe<SubscriptionContractUpdatePayload>;
  /**
   * Commits the updates of a Subscription Contract draft.
   *
   * Commits are rate limited per subscription contract across all apps on the store. If you exceed the limit, then the mutation returns a top-level `THROTTLED` error and doesn't commit. Wait before you retry.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftCommit?: Maybe<SubscriptionDraftCommitPayload>;
  /**
   * Adds a subscription discount to a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftDiscountAdd?: Maybe<SubscriptionDraftDiscountAddPayload>;
  /**
   * Applies a code discount on the subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftDiscountCodeApply?: Maybe<SubscriptionDraftDiscountCodeApplyPayload>;
  /**
   * Removes a subscription discount from a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftDiscountRemove?: Maybe<SubscriptionDraftDiscountRemovePayload>;
  /**
   * Updates a subscription discount on a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftDiscountUpdate?: Maybe<SubscriptionDraftDiscountUpdatePayload>;
  /**
   * Adds a subscription free shipping discount to a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftFreeShippingDiscountAdd?: Maybe<SubscriptionDraftFreeShippingDiscountAddPayload>;
  /**
   * Updates a subscription free shipping discount on a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftFreeShippingDiscountUpdate?: Maybe<SubscriptionDraftFreeShippingDiscountUpdatePayload>;
  /**
   * Adds a subscription line to a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftLineAdd?: Maybe<SubscriptionDraftLineAddPayload>;
  /**
   * Removes a subscription line from a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftLineRemove?: Maybe<SubscriptionDraftLineRemovePayload>;
  /**
   * Updates a subscription line on a subscription draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftLineUpdate?: Maybe<SubscriptionDraftLineUpdatePayload>;
  /**
   * Updates a Subscription Draft.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraftUpdate?: Maybe<SubscriptionDraftUpdatePayload>;
  /**
   * Adds tags to a resource. If the resource type doesn't support tagging, the `id` argument returns a resource-not-found error.
   *
   * Tags help merchants organize and filter resources. See the [`tags`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/tagsAdd#arguments-tags) argument for supported input formats.
   *
   * Learn more about [using tags to organize subscription orders](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/fulfillments/sync-orders-subscriptions#order-tagging).
   */
  tagsAdd?: Maybe<TagsAddPayload>;
  /**
   * Removes tags from a resource. If the resource type doesn't support tagging, the `id` argument returns a resource-not-found error.
   *
   * Tags are searchable keywords that help organize and filter these resources.
   */
  tagsRemove?: Maybe<TagsRemovePayload>;
  /** Allows tax app configurations for tax partners. */
  taxAppConfigure?: Maybe<TaxAppConfigurePayload>;
  /**
   * Creates a tax summary for a given order.
   * If both an order ID and a start and end time are provided, the order ID will be used.
   */
  taxSummaryCreate?: Maybe<TaxSummaryCreatePayload>;
  /**
   * Creates a theme from an external URL or staged upload. The theme source can either be a ZIP file hosted at a public URL or files previously uploaded using the [`stagedUploadsCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/stageduploadscreate) mutation. The theme displays in the [Themes page](https://admin.shopify.com/themes) in the Shopify admin.
   *
   * New themes have an [`UNPUBLISHED`](https://shopify.dev//docs/api/admin-graphql/latest/mutations/themeCreate#arguments-role.enums.UNPUBLISHED) role by default. You can optionally specify a [`DEVELOPMENT`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/themeCreate#arguments-role.enums.DEVELOPMENT) role for temporary themes used during development.
   */
  themeCreate?: Maybe<ThemeCreatePayload>;
  /** Deletes a theme. */
  themeDelete?: Maybe<ThemeDeletePayload>;
  /** Duplicates a theme. */
  themeDuplicate?: Maybe<ThemeDuplicatePayload>;
  /** Copy theme files. Copying to existing theme files will overwrite them. */
  themeFilesCopy?: Maybe<ThemeFilesCopyPayload>;
  /** Deletes a theme's files. */
  themeFilesDelete?: Maybe<ThemeFilesDeletePayload>;
  /**
   * Creates or updates theme files in an online store theme. This mutation allows batch operations on multiple theme files, either creating new files or overwriting existing ones with the same filename.
   *
   * > Note: You can process a maximum of 50 files in a single request.
   *
   * Each file requires a filename and body content. The body must specify a [`type`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/themeFilesUpsert#arguments-files.fields.body.type) with the corresponding [`value`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/themeFilesUpsert#arguments-files.fields.body.value). The mutation returns a [`job`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/themeFilesUpsert#returns-job) field for tracking asynchronous operations and an [`upsertedThemeFiles`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/themeFilesUpsert#returns-upsertedThemeFiles) field with details about the processed files.
   */
  themeFilesUpsert?: Maybe<ThemeFilesUpsertPayload>;
  /** Publishes a theme. */
  themePublish?: Maybe<ThemePublishPayload>;
  /** Updates a theme. */
  themeUpdate?: Maybe<ThemeUpdatePayload>;
  /** Trigger the voiding of an uncaptured authorization transaction. */
  transactionVoid?: Maybe<TransactionVoidPayload>;
  /**
   * Creates or updates translations for a resource's [translatable content](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent).
   *
   * Each translation requires a digest value from the resource's translatable content. Use the [`translatableResource`](https://shopify.dev/docs/api/admin-graphql/latest/queries/translatableResource) query to get a resource's translatable content and digest values before creating translations. You can optionally scope translations to specific markets using the `marketId` field in each translation input.
   *
   * Learn more about [managing translations](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
   */
  translationsRegister?: Maybe<TranslationsRegisterPayload>;
  /** Deletes translations. */
  translationsRemove?: Maybe<TranslationsRemovePayload>;
  /** Asynchronously delete [URL redirects](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) in bulk. */
  urlRedirectBulkDeleteAll?: Maybe<UrlRedirectBulkDeleteAllPayload>;
  /**
   * Asynchronously delete [URLRedirect](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect)
   * objects in bulk by IDs.
   * Learn more about [URLRedirect](https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect)
   * objects.
   */
  urlRedirectBulkDeleteByIds?: Maybe<UrlRedirectBulkDeleteByIdsPayload>;
  /** Asynchronously delete redirects in bulk. */
  urlRedirectBulkDeleteBySavedSearch?: Maybe<UrlRedirectBulkDeleteBySavedSearchPayload>;
  /** Asynchronously delete redirects in bulk. */
  urlRedirectBulkDeleteBySearch?: Maybe<UrlRedirectBulkDeleteBySearchPayload>;
  /** Creates a [`UrlRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object. */
  urlRedirectCreate?: Maybe<UrlRedirectCreatePayload>;
  /** Deletes a [`UrlRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object. */
  urlRedirectDelete?: Maybe<UrlRedirectDeletePayload>;
  /**
   * Creates a [`UrlRedirectImport`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirectImport) object.
   *
   * After creating the `UrlRedirectImport` object, the `UrlRedirectImport` request can be performed using the [`urlRedirectImportSubmit`](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportSubmit) mutation.
   */
  urlRedirectImportCreate?: Maybe<UrlRedirectImportCreatePayload>;
  /**
   * Submits a `UrlRedirectImport` request to be processed.
   *
   * The `UrlRedirectImport` request is first created with the [`urlRedirectImportCreate`](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportCreate) mutation.
   */
  urlRedirectImportSubmit?: Maybe<UrlRedirectImportSubmitPayload>;
  /** Updates a URL redirect. */
  urlRedirectUpdate?: Maybe<UrlRedirectUpdatePayload>;
  /**
   * Creates a cart and checkout validation: a server-side rule enforced before a customer can complete checkout. Each validation is powered by a cart and checkout validation function that you provide using `functionId` or `functionHandle`.
   *
   * Use `validationCreate` to apply custom rules at checkout, such as limiting item quantities, enforcing order minimums or maximums, or blocking checkout for restricted shipping addresses. Validations run on Shopify's servers and are enforced throughout checkout, so they can't be bypassed by the client.
   *
   * Validation errors always block checkout progress. The `blockOnFailure` field controls whether runtime exceptions, such as timeouts, also block checkout.
   */
  validationCreate?: Maybe<ValidationCreatePayload>;
  /** Deletes a cart and checkout validation, removing its rule from the shop's checkout. Once deleted, its cart and checkout validation function no longer runs during checkout. */
  validationDelete?: Maybe<ValidationDeletePayload>;
  /**
   * Updates a cart and checkout validation. Use `validationUpdate` to rename it, toggle whether it's enabled at checkout, change its `blockOnFailure` behavior, or update its metafields.
   *
   * Validation errors always block checkout progress. The `blockOnFailure` field controls whether runtime exceptions, such as timeouts, also block checkout.
   */
  validationUpdate?: Maybe<ValidationUpdatePayload>;
  /**
   * Activate a [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by creating a web pixel record on the store where you installed your app.
   *
   * When you run the `webPixelCreate` mutation, Shopify validates it
   * against the settings definition in `shopify.extension.toml`. If the `settings` input field doesn't match
   * the schema that you defined, then the mutation fails. Learn how to
   * define [web pixel settings](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings).
   */
  webPixelCreate?: Maybe<WebPixelCreatePayload>;
  /** Deletes the web pixel shop settings. */
  webPixelDelete?: Maybe<WebPixelDeletePayload>;
  /**
   * Activate a [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by updating a web pixel record on the store where you installed your app.
   *
   * When you run the `webPixelUpdate` mutation, Shopify validates it
   * against the settings definition in `shopify.extension.toml`. If the `settings` input field doesn't match
   * the schema that you defined, then the mutation fails. Learn how to
   * define [web pixel settings](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings).
   */
  webPixelUpdate?: Maybe<WebPixelUpdatePayload>;
  /** Creates a web presence. */
  webPresenceCreate?: Maybe<WebPresenceCreatePayload>;
  /** Deletes a web presence. */
  webPresenceDelete?: Maybe<WebPresenceDeletePayload>;
  /** Updates a web presence. */
  webPresenceUpdate?: Maybe<WebPresenceUpdatePayload>;
  /**
   * Creates a webhook subscription that notifies your [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) when specific events occur in a shop. Webhooks push event data to your endpoint immediately when changes happen, eliminating the need for polling.
   *
   * The subscription configuration supports multiple endpoint types including HTTPS URLs, Google Pub/Sub topics, and AWS EventBridge event sources. You can filter events using [Shopify API search syntax](https://shopify.dev/docs/api/usage/search-syntax) to receive only relevant webhooks, control which data fields are included in webhook payloads, and specify metafield namespaces to include.
   *
   * > Note:
   * > The Webhooks API version [configured in your app](https://shopify.dev/docs/apps/build/webhooks/subscribe/use-newer-api-version) determines the API version for webhook events. You can't specify it per subscription.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  webhookSubscriptionCreate?: Maybe<WebhookSubscriptionCreatePayload>;
  /**
   * Deletes a [`WebhookSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/WebhookSubscription) and stops all future webhooks to its endpoint. Returns the deleted subscription's ID for confirmation.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  webhookSubscriptionDelete?: Maybe<WebhookSubscriptionDeletePayload>;
  /**
   * Updates a webhook subscription's configuration. Modify the endpoint URL, event filters, included fields, or metafield namespaces without recreating the subscription.
   *
   * The mutation accepts a [`WebhookSubscriptionInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/WebhookSubscriptionInput) that specifies the new configuration. You can switch between endpoint types (HTTP, Pub/Sub, EventBridge) by providing a different URI format. Updates apply atomically without interrupting webhook delivery.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  webhookSubscriptionUpdate?: Maybe<WebhookSubscriptionUpdatePayload>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAbandonmentEmailStateUpdateArgs = {
  emailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailState: AbandonmentEmailState;
  emailStateChangeReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAbandonmentUpdateActivitiesDeliveryStatusesArgs = {
  abandonmentId: Scalars['ID']['input'];
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryStatus: AbandonmentDeliveryState;
  deliveryStatusChangeReason?: InputMaybe<Scalars['String']['input']>;
  marketingActivityId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppPurchaseOneTimeCreateArgs = {
  name: Scalars['String']['input'];
  price: MoneyInput;
  returnUrl: Scalars['URL']['input'];
  test?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppRevokeAccessScopesArgs = {
  scopes: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionCancelArgs = {
  id: Scalars['ID']['input'];
  prorate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionCreateArgs = {
  lineItems: Array<AppSubscriptionLineItemInput>;
  name: Scalars['String']['input'];
  replacementBehavior?: InputMaybe<AppSubscriptionReplacementBehavior>;
  returnUrl: Scalars['URL']['input'];
  test?: InputMaybe<Scalars['Boolean']['input']>;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionLineItemUpdateArgs = {
  cappedAmount: MoneyInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionTrialExtendArgs = {
  days: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppUsageRecordCreateArgs = {
  description: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  price: MoneyInput;
  subscriptionLineItemId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleCreateArgs = {
  article: ArticleCreateInput;
  blog?: InputMaybe<ArticleBlogInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleUpdateArgs = {
  article: ArticleUpdateInput;
  blog?: InputMaybe<ArticleBlogInput>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBackupRegionUpdateArgs = {
  region?: InputMaybe<BackupRegionUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogCreateArgs = {
  blog: BlogCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogUpdateArgs = {
  blog: BlogUpdateInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationCancelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationRunMutationArgs = {
  clientIdentifier?: InputMaybe<Scalars['String']['input']>;
  mutation: Scalars['String']['input'];
  stagedUploadPath: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationRunQueryArgs = {
  groupObjects?: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkProductResourceFeedbackCreateArgs = {
  feedbackInput: Array<ProductResourceFeedbackInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceCreateArgs = {
  input: DeliveryCarrierServiceCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceUpdateArgs = {
  input: DeliveryCarrierServiceUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCartTransformCreateArgs = {
  blockOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  metafields?: InputMaybe<Array<MetafieldInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCartTransformDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCashDrawerCreateArgs = {
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCashDrawerFindOrCreateArgs = {
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  pointOfSaleDeviceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCashDrawerUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CashDrawerUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCashManagementReasonCodeCreateArgs = {
  code: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCashManagementReasonCodeDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogContextUpdateArgs = {
  catalogId: Scalars['ID']['input'];
  contextsToAdd?: InputMaybe<CatalogContextInput>;
  contextsToRemove?: InputMaybe<CatalogContextInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogCreateArgs = {
  input: CatalogCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogDeleteArgs = {
  deleteDependentResources?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CatalogUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationChannelCreateArgs = {
  input: ChannelCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationChannelFullSyncArgs = {
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  channelId: Scalars['ID']['input'];
  country?: InputMaybe<CountryCode>;
  language?: InputMaybe<LanguageCode>;
  updatedAtSince?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ChannelUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCheckoutAndAccountsConfigurationUpdateArgs = {
  configuration: CheckoutAndAccountsConfigurationInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCheckoutBrandingUpsertArgs = {
  checkoutBrandingInput?: InputMaybe<CheckoutBrandingInput>;
  checkoutProfileId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionAddProductsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionAddProductsV2Args = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionConditionsSourceCreateArgs = {
  input: CollectionCreateConditionsSourceInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionConditionsSourceDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionConditionsSourceUpdateArgs = {
  input: CollectionUpdateConditionsSourceInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionCreateArgs = {
  collection?: InputMaybe<CollectionCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionDeleteArgs = {
  input: CollectionDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionDuplicateArgs = {
  input: CollectionDuplicateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionPublishArgs = {
  input: CollectionPublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionRemoveProductsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionReorderProductsArgs = {
  id: Scalars['ID']['input'];
  moves: Array<MoveInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionUnpublishArgs = {
  input: CollectionUnpublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionUpdateArgs = {
  collection?: InputMaybe<CollectionUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCombinedListingUpdateArgs = {
  optionsAndValues?: InputMaybe<Array<OptionAndValueInput>>;
  parentProductId: Scalars['ID']['input'];
  productsAdded?: InputMaybe<Array<ChildProductRelationInput>>;
  productsEdited?: InputMaybe<Array<ChildProductRelationInput>>;
  productsRemovedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentApproveArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentNotSpamArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentSpamArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompaniesDeleteArgs = {
  companyIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAddressDeleteArgs = {
  addressId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAssignCustomerAsContactArgs = {
  companyId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAssignMainContactArgs = {
  companyContactId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactAssignRoleArgs = {
  companyContactId: Scalars['ID']['input'];
  companyContactRoleId: Scalars['ID']['input'];
  companyLocationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactAssignRolesArgs = {
  companyContactId: Scalars['ID']['input'];
  rolesToAssign: Array<CompanyContactRoleAssign>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactCreateArgs = {
  companyId: Scalars['ID']['input'];
  input: CompanyContactInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactDeleteArgs = {
  companyContactId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRemoveFromCompanyArgs = {
  companyContactId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRevokeRoleArgs = {
  companyContactId: Scalars['ID']['input'];
  companyContactRoleAssignmentId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRevokeRolesArgs = {
  companyContactId: Scalars['ID']['input'];
  revokeAll?: InputMaybe<Scalars['Boolean']['input']>;
  roleAssignmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactSendWelcomeEmailArgs = {
  companyContactId: Scalars['ID']['input'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactUpdateArgs = {
  companyContactId: Scalars['ID']['input'];
  input: CompanyContactInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactsDeleteArgs = {
  companyContactIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignAddressArgs = {
  address: CompanyAddressInput;
  addressTypes: Array<CompanyAddressType>;
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignRolesArgs = {
  companyLocationId: Scalars['ID']['input'];
  rolesToAssign: Array<CompanyLocationRoleAssign>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignStaffMembersArgs = {
  companyLocationId: Scalars['ID']['input'];
  staffMemberIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignTaxExemptionsArgs = {
  companyLocationId: Scalars['ID']['input'];
  taxExemptions: Array<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationCreateArgs = {
  companyId: Scalars['ID']['input'];
  input: CompanyLocationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationCreateTaxRegistrationArgs = {
  locationId: Scalars['ID']['input'];
  taxId: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationDeleteArgs = {
  companyLocationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRemoveStaffMembersArgs = {
  companyLocationStaffMemberAssignmentIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeRolesArgs = {
  companyLocationId: Scalars['ID']['input'];
  rolesToRevoke: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeTaxExemptionsArgs = {
  companyLocationId: Scalars['ID']['input'];
  taxExemptions: Array<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeTaxRegistrationArgs = {
  companyLocationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationTaxSettingsUpdateArgs = {
  companyLocationId: Scalars['ID']['input'];
  exemptionsToAssign?: InputMaybe<Array<TaxExemption>>;
  exemptionsToRemove?: InputMaybe<Array<TaxExemption>>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  taxRegistrationId?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationUpdateArgs = {
  companyLocationId: Scalars['ID']['input'];
  input: CompanyLocationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationsDeleteArgs = {
  companyLocationIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyRevokeMainContactArgs = {
  companyId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyUpdateArgs = {
  companyId: Scalars['ID']['input'];
  input: CompanyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationConsentPolicyUpdateArgs = {
  consentPolicies: Array<ConsentPolicyInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerAddTaxExemptionsArgs = {
  customerId: Scalars['ID']['input'];
  taxExemptions: Array<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerAddressCreateArgs = {
  address: MailingAddressInput;
  customerId: Scalars['ID']['input'];
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerAddressDeleteArgs = {
  addressId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerAddressUpdateArgs = {
  address: MailingAddressInput;
  addressId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerCancelDataErasureArgs = {
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerCreateArgs = {
  input: CustomerInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerDeleteArgs = {
  input: CustomerDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerEmailMarketingConsentUpdateArgs = {
  input: CustomerEmailMarketingConsentUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerGenerateAccountActivationUrlArgs = {
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerMergeArgs = {
  customerOneId: Scalars['ID']['input'];
  customerTwoId: Scalars['ID']['input'];
  overrideFields?: InputMaybe<CustomerMergeOverrideFields>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreateFromDuplicationDataArgs = {
  billingAddress: MailingAddressInput;
  customerId: Scalars['ID']['input'];
  encryptedDuplicationData: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreditCardCreateArgs = {
  billingAddress: MailingAddressInput;
  customerId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreditCardUpdateArgs = {
  billingAddress: MailingAddressInput;
  id: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodGetDuplicationDataArgs = {
  customerPaymentMethodId: Scalars['ID']['input'];
  targetCustomerId: Scalars['ID']['input'];
  targetShopId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodGetUpdateUrlArgs = {
  customerPaymentMethodId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodPaypalBillingAgreementCreateArgs = {
  billingAddress?: InputMaybe<MailingAddressInput>;
  billingAgreementId: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodPaypalBillingAgreementUpdateArgs = {
  billingAddress: MailingAddressInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodRemoteCreateArgs = {
  customerId: Scalars['ID']['input'];
  remoteReference: CustomerPaymentMethodRemoteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodRevokeArgs = {
  customerPaymentMethodId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodSendUpdateEmailArgs = {
  customerPaymentMethodId: Scalars['ID']['input'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerRemoveTaxExemptionsArgs = {
  customerId: Scalars['ID']['input'];
  taxExemptions: Array<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerReplaceTaxExemptionsArgs = {
  customerId: Scalars['ID']['input'];
  taxExemptions: Array<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerRequestDataErasureArgs = {
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSegmentMembersQueryCreateArgs = {
  input: CustomerSegmentMembersQueryInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSendAccountInviteEmailArgs = {
  customerId: Scalars['ID']['input'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSetArgs = {
  identifier?: InputMaybe<CustomerSetIdentifiers>;
  input: CustomerSetInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSmsMarketingConsentUpdateArgs = {
  input: CustomerSmsMarketingConsentUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerUpdateArgs = {
  input: CustomerInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerUpdateDefaultAddressArgs = {
  addressId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerWhatsAppMarketingConsentUpdateArgs = {
  input: CustomerWhatsAppMarketingConsentUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDataSaleOptOutArgs = {
  email: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDelegateAccessTokenCreateArgs = {
  input: DelegateAccessTokenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDelegateAccessTokenDestroyArgs = {
  accessToken: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationActivationArgs = {
  enabled: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationCreateArgs = {
  deliveryCustomization: DeliveryCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationUpdateArgs = {
  deliveryCustomization: DeliveryCustomizationInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileCreateArgs = {
  profile: DeliveryProfileInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileRemoveArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  profile: DeliveryProfileInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryPromiseParticipantsUpdateArgs = {
  brandedPromiseHandle: Scalars['String']['input'];
  ownersToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownersToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryPromiseProviderUpsertArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentDelay?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryShippingOriginAssignArgs = {
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticActivateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticAppCreateArgs = {
  automaticAppDiscount: DiscountAutomaticAppInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticAppUpdateArgs = {
  automaticAppDiscount: DiscountAutomaticAppInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBasicCreateArgs = {
  automaticBasicDiscount: DiscountAutomaticBasicInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBasicUpdateArgs = {
  automaticBasicDiscount: DiscountAutomaticBasicInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBxgyCreateArgs = {
  automaticBxgyDiscount: DiscountAutomaticBxgyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBxgyUpdateArgs = {
  automaticBxgyDiscount: DiscountAutomaticBxgyInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticDeactivateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticFreeShippingCreateArgs = {
  freeShippingAutomaticDiscount: DiscountAutomaticFreeShippingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticFreeShippingUpdateArgs = {
  freeShippingAutomaticDiscount: DiscountAutomaticFreeShippingInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountBulkTagsAddArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountBulkTagsRemoveArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeActivateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeAppCreateArgs = {
  codeAppDiscount: DiscountCodeAppInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeAppUpdateArgs = {
  codeAppDiscount: DiscountCodeAppInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBasicCreateArgs = {
  basicCodeDiscount: DiscountCodeBasicInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBasicUpdateArgs = {
  basicCodeDiscount: DiscountCodeBasicInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkActivateArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkDeactivateArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBxgyCreateArgs = {
  bxgyCodeDiscount: DiscountCodeBxgyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBxgyUpdateArgs = {
  bxgyCodeDiscount: DiscountCodeBxgyInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeDeactivateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeFreeShippingCreateArgs = {
  freeShippingCodeDiscount: DiscountCodeFreeShippingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeFreeShippingUpdateArgs = {
  freeShippingCodeDiscount: DiscountCodeFreeShippingInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeRedeemCodeBulkDeleteArgs = {
  discountId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountRedeemCodeBulkAddArgs = {
  codes: Array<DiscountRedeemCodeInput>;
  discountId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDisputeEvidenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShopifyPaymentsDisputeEvidenceUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkAddTagsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkRemoveTagsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCalculateArgs = {
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
  paymentGatewayId?: InputMaybe<Scalars['ID']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCreateArgs = {
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCreateFromOrderArgs = {
  orderId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderDeleteArgs = {
  input: DraftOrderDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderDuplicateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderInvoicePreviewArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderInvoiceSendArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeServerPixelUpdateArgs = {
  arn: Scalars['ARN']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID']['input'];
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileAcknowledgeUpdateFailedArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileCreateArgs = {
  files: Array<FileCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileDeleteArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileUpdateArgs = {
  files: Array<FileUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFlowGenerateSignatureArgs = {
  id: Scalars['ID']['input'];
  payload: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFlowTriggerReceiveArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCancelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleCreateArgs = {
  deliveryMethodTypes: Array<DeliveryMethodType>;
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  metafields?: InputMaybe<Array<MetafieldInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleUpdateArgs = {
  deliveryMethodTypes: Array<DeliveryMethodType>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCreateArgs = {
  fulfillment: FulfillmentInput;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCreateV2Args = {
  fulfillment: FulfillmentV2Input;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentEventCreateArgs = {
  fulfillmentEvent: FulfillmentEventInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderAcceptCancellationRequestArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderAcceptFulfillmentRequestArgs = {
  estimatedShippedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderCancelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderCloseArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderHoldArgs = {
  fulfillmentHold: FulfillmentOrderHoldInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderLineItemsPreparedForPickupArgs = {
  input: FulfillmentOrderLineItemsPreparedForPickupInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderMergeArgs = {
  fulfillmentOrderMergeInputs: Array<FulfillmentOrderMergeInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderMoveArgs = {
  fulfillmentOrderLineItems?: InputMaybe<Array<FulfillmentOrderLineItemInput>>;
  id: Scalars['ID']['input'];
  newLocationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderOpenArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRejectCancellationRequestArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRejectFulfillmentRequestArgs = {
  id: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<IncomingRequestLineItemInput>>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<FulfillmentOrderRejectionReason>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderReleaseHoldArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  holdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderReportProgressArgs = {
  id: Scalars['ID']['input'];
  progressReport?: InputMaybe<FulfillmentOrderReportProgressInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRescheduleArgs = {
  fulfillAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSplitArgs = {
  fulfillmentOrderSplits: Array<FulfillmentOrderSplitInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSubmitCancellationRequestArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSubmitFulfillmentRequestArgs = {
  fulfillmentOrderLineItems?: InputMaybe<Array<FulfillmentOrderLineItemInput>>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrdersRerouteArgs = {
  excludedLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fulfillmentOrderIds: Array<Scalars['ID']['input']>;
  includedLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrdersSetFulfillmentDeadlineArgs = {
  fulfillmentDeadline: Scalars['DateTime']['input'];
  fulfillmentOrderIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceCreateArgs = {
  callbackUrl?: InputMaybe<Scalars['URL']['input']>;
  inventoryManagement?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  requiresShippingMethod?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSupport?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceDeleteArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  inventoryAction?: InputMaybe<FulfillmentServiceDeleteInventoryAction>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceUpdateArgs = {
  callbackUrl?: InputMaybe<Scalars['URL']['input']>;
  id: Scalars['ID']['input'];
  inventoryManagement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresShippingMethod?: InputMaybe<Scalars['Boolean']['input']>;
  trackingSupport?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentTrackingInfoUpdateArgs = {
  fulfillmentId: Scalars['ID']['input'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  trackingInfoInput: FulfillmentTrackingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentTrackingInfoUpdateV2Args = {
  fulfillmentId: Scalars['ID']['input'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  trackingInfoInput: FulfillmentTrackingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardCreateArgs = {
  input: GiftCardCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardCreditArgs = {
  creditInput: GiftCardCreditInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardDeactivateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardDebitArgs = {
  debitInput: GiftCardDebitInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardProductSetArgs = {
  identifier?: InputMaybe<ProductSetIdentifiers>;
  input: GiftCardProductSetInput;
  synchronous?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardSendNotificationToCustomerArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardSendNotificationToRecipientArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardUpdateArgs = {
  id: Scalars['ID']['input'];
  input: GiftCardUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryActivateArgs = {
  available?: InputMaybe<Scalars['Int']['input']>;
  inventoryItemId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  onHand?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryAdjustQuantitiesArgs = {
  input: InventoryAdjustQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryBulkToggleActivationArgs = {
  inventoryItemId: Scalars['ID']['input'];
  inventoryItemUpdates: Array<InventoryBulkToggleActivationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryDeactivateArgs = {
  inventoryLevelId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryItemUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InventoryItemInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryMoveQuantitiesArgs = {
  input: InventoryMoveQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventorySetOnHandQuantitiesArgs = {
  input: InventorySetOnHandQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventorySetQuantitiesArgs = {
  input: InventorySetQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentAddItemsArgs = {
  id: Scalars['ID']['input'];
  lineItems: Array<InventoryShipmentLineItemInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentCreateArgs = {
  input: InventoryShipmentCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentCreateInTransitArgs = {
  input: InventoryShipmentCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentMarkInTransitArgs = {
  dateShipped?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentReceiveArgs = {
  bulkReceiveAction?: InputMaybe<InventoryShipmentReceiveLineItemReason>;
  dateReceived?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<InventoryShipmentReceiveItemInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentRemoveItemsArgs = {
  id: Scalars['ID']['input'];
  lineItems: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentSetBarcodeArgs = {
  barcode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentSetTrackingArgs = {
  id: Scalars['ID']['input'];
  tracking: InventoryShipmentTrackingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryShipmentUpdateItemQuantitiesArgs = {
  id: Scalars['ID']['input'];
  items?: InputMaybe<Array<InventoryShipmentUpdateItemQuantitiesInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferCancelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferCreateArgs = {
  input: InventoryTransferCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferCreateAsReadyToShipArgs = {
  input: InventoryTransferCreateAsReadyToShipInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferDuplicateArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferEditArgs = {
  id: Scalars['ID']['input'];
  input: InventoryTransferEditInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferMarkAsReadyToShipArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferRemoveItemsArgs = {
  input: InventoryTransferRemoveItemsInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryTransferSetItemsArgs = {
  input: InventoryTransferSetItemsInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationActivateArgs = {
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationAddArgs = {
  input: LocationAddInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationDeactivateArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationDeleteArgs = {
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationEditArgs = {
  id: Scalars['ID']['input'];
  input: LocationEditInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationLocalPickupDisableArgs = {
  locationId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationLocalPickupEnableArgs = {
  localPickupSettings: DeliveryLocationLocalPickupEnableInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketCreateArgs = {
  input: MarketCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketCurrencySettingsUpdateArgs = {
  input: MarketCurrencySettingsUpdateInput;
  marketId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketLocalizationsRegisterArgs = {
  marketLocalizations: Array<MarketLocalizationRegisterInput>;
  resourceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketLocalizationsRemoveArgs = {
  marketIds: Array<Scalars['ID']['input']>;
  marketLocalizationKeys: Array<Scalars['String']['input']>;
  resourceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionsCreateArgs = {
  marketId: Scalars['ID']['input'];
  regions: Array<MarketRegionCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionsDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketUpdateArgs = {
  id: Scalars['ID']['input'];
  input: MarketUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceCreateArgs = {
  marketId: Scalars['ID']['input'];
  webPresence: MarketWebPresenceCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceDeleteArgs = {
  webPresenceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceUpdateArgs = {
  webPresence: MarketWebPresenceUpdateInput;
  webPresenceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityCreateArgs = {
  input: MarketingActivityCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityCreateExternalArgs = {
  input: MarketingActivityCreateExternalInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityDeleteExternalArgs = {
  marketingActivityId?: InputMaybe<Scalars['ID']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpdateArgs = {
  input: MarketingActivityUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpdateExternalArgs = {
  input: MarketingActivityUpdateExternalInput;
  marketingActivityId?: InputMaybe<Scalars['ID']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpsertExternalArgs = {
  input: MarketingActivityUpsertExternalInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingEngagementCreateArgs = {
  marketingActivityId?: InputMaybe<Scalars['ID']['input']>;
  marketingEngagement: MarketingEngagementInput;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuCreateArgs = {
  handle: Scalars['String']['input'];
  items: Array<MenuItemCreateInput>;
  title: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuUpdateArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  items: Array<MenuItemUpdateInput>;
  title: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionCreateArgs = {
  definition: MetafieldDefinitionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionDeleteArgs = {
  deleteAllAssociatedMetafields?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<MetafieldDefinitionIdentifierInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionPinArgs = {
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<MetafieldDefinitionIdentifierInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionUnpinArgs = {
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<MetafieldDefinitionIdentifierInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionUpdateArgs = {
  definition: MetafieldDefinitionUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldsDeleteArgs = {
  metafields: Array<MetafieldIdentifierInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldsSetArgs = {
  metafields: Array<MetafieldsSetInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectBulkDeleteArgs = {
  where: MetaobjectBulkDeleteWhereCondition;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectCreateArgs = {
  metaobject: MetaobjectCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionCreateArgs = {
  definition: MetaobjectDefinitionCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionUpdateArgs = {
  definition: MetaobjectDefinitionUpdateInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectUpdateArgs = {
  id: Scalars['ID']['input'];
  metaobject: MetaobjectUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectUpsertArgs = {
  handle: MetaobjectHandleInput;
  metaobject?: InputMaybe<MetaobjectUpsertInput>;
  values?: InputMaybe<Scalars['JSON']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationCreateArgs = {
  input: MobilePlatformApplicationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: MobilePlatformApplicationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderAttributionDefinitionDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderAttributionDefinitionUpsertArgs = {
  input: OrderAttributionDefinitionUpsertInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCancelArgs = {
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
  reason: OrderCancelReason;
  refundMethod?: InputMaybe<OrderCancelRefundMethodInput>;
  restock: Scalars['Boolean']['input'];
  staffNote?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCaptureArgs = {
  input: OrderCaptureInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCloseArgs = {
  input: OrderCloseInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCreateArgs = {
  options?: InputMaybe<OrderCreateOptionsInput>;
  order: OrderCreateOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCreateMandatePaymentArgs = {
  amount?: InputMaybe<MoneyInput>;
  autoCapture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  mandateId: Scalars['ID']['input'];
  paymentScheduleId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCreateManualPaymentArgs = {
  amount?: InputMaybe<MoneyInput>;
  id: Scalars['ID']['input'];
  paymentMethodName?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCustomerRemoveArgs = {
  orderId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCustomerSetArgs = {
  customerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderDeleteArgs = {
  orderId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddCustomItemArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  price: MoneyInput;
  quantity: Scalars['Int']['input'];
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddLineItemDiscountArgs = {
  discount: OrderEditAppliedDiscountInput;
  id: Scalars['ID']['input'];
  lineItemId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddShippingLineArgs = {
  id: Scalars['ID']['input'];
  shippingLine: OrderEditAddShippingLineInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddVariantArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  variantId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditBeginArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditCommitArgs = {
  id: Scalars['ID']['input'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  staffNote?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveDiscountArgs = {
  discountApplicationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveLineItemDiscountArgs = {
  discountApplicationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveShippingLineArgs = {
  id: Scalars['ID']['input'];
  shippingLineId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditSetQuantityArgs = {
  id: Scalars['ID']['input'];
  lineItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  restock?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditUpdateDiscountArgs = {
  discount: OrderEditAppliedDiscountInput;
  discountApplicationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditUpdateShippingLineArgs = {
  id: Scalars['ID']['input'];
  shippingLine: OrderEditUpdateShippingLineInput;
  shippingLineId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderInvoiceSendArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderMarkAsPaidArgs = {
  input: OrderMarkAsPaidInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderOpenArgs = {
  input: OrderOpenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderRiskAssessmentCreateArgs = {
  orderRiskAssessmentInput: OrderRiskAssessmentCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderUpdateArgs = {
  input: OrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPageCreateArgs = {
  page: PageCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPageDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPageUpdateArgs = {
  id: Scalars['ID']['input'];
  page: PageUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationActivationArgs = {
  enabled: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationCreateArgs = {
  paymentCustomization: PaymentCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationUpdateArgs = {
  id: Scalars['ID']['input'];
  paymentCustomization: PaymentCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentReminderSendArgs = {
  paymentScheduleId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentScheduleCaptureArgs = {
  paymentScheduleId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsCreateArgs = {
  paymentTermsAttributes: PaymentTermsCreateInput;
  referenceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsDeleteArgs = {
  input: PaymentTermsDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsUpdateArgs = {
  input: PaymentTermsUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPointOfSaleDeviceAssignToCashDrawerArgs = {
  cashDrawerId: Scalars['ID']['input'];
  pointOfSaleDeviceId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPointOfSaleDevicePaymentSessionAdjustArgs = {
  cash: MoneyInput;
  note?: InputMaybe<Scalars['String']['input']>;
  pointOfSaleDevicePaymentSessionId: Scalars['ID']['input'];
  reasonCodeId?: InputMaybe<Scalars['ID']['input']>;
  staffMemberId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPointOfSaleDevicePaymentSessionCloseArgs = {
  balance: MoneyInput;
  note?: InputMaybe<Scalars['String']['input']>;
  pointOfSaleDevicePaymentSessionId: Scalars['ID']['input'];
  reasonCodeId?: InputMaybe<Scalars['ID']['input']>;
  staffMemberId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPointOfSaleDevicePaymentSessionCountArgs = {
  balance: MoneyInput;
  note?: InputMaybe<Scalars['String']['input']>;
  pointOfSaleDevicePaymentSessionId: Scalars['ID']['input'];
  reasonCodeId?: InputMaybe<Scalars['ID']['input']>;
  staffMemberId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPointOfSaleDevicePaymentSessionOpenArgs = {
  balance?: InputMaybe<MoneyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pointOfSaleDeviceId: Scalars['ID']['input'];
  reasonCodeId?: InputMaybe<Scalars['ID']['input']>;
  staffMemberId: Scalars['ID']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPreviewInstallArgs = {
  storefrontGenerationPreviewUuid: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListCreateArgs = {
  input: PriceListCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesAddArgs = {
  priceListId: Scalars['ID']['input'];
  prices: Array<PriceListPriceInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesByProductUpdateArgs = {
  priceListId: Scalars['ID']['input'];
  pricesToAdd?: InputMaybe<Array<PriceListProductPriceInput>>;
  pricesToDeleteByProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesDeleteArgs = {
  priceListId: Scalars['ID']['input'];
  variantIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesUpdateArgs = {
  priceListId: Scalars['ID']['input'];
  pricesToAdd: Array<PriceListPriceInput>;
  variantIdsToDelete: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PriceListUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPrivacyFeaturesDisableArgs = {
  featuresToDisable: Array<PrivacyFeaturesEnum>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductBundleCreateArgs = {
  input: ProductBundleCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductBundleUpdateArgs = {
  input: ProductBundleUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductChangeStatusArgs = {
  productId: Scalars['ID']['input'];
  status: ProductStatus;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductCreateArgs = {
  media?: InputMaybe<Array<CreateMediaInput>>;
  product?: InputMaybe<ProductCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductCreateMediaArgs = {
  media: Array<CreateMediaInput>;
  productId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDeleteArgs = {
  input: ProductDeleteInput;
  synchronous?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDeleteMediaArgs = {
  mediaIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDuplicateArgs = {
  includeImages?: InputMaybe<Scalars['Boolean']['input']>;
  includeTranslations?: InputMaybe<Scalars['Boolean']['input']>;
  newStatus?: InputMaybe<ProductStatus>;
  newTitle: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  synchronous?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFeedCreateArgs = {
  input?: InputMaybe<ProductFeedInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFeedDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFullSyncArgs = {
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  updatedAtSince?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductJoinSellingPlanGroupsArgs = {
  id: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductLeaveSellingPlanGroupsArgs = {
  id: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionUpdateArgs = {
  option: OptionUpdateInput;
  optionValuesToAdd?: InputMaybe<Array<OptionValueCreateInput>>;
  optionValuesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionValuesToUpdate?: InputMaybe<Array<OptionValueUpdateInput>>;
  productId: Scalars['ID']['input'];
  variantStrategy?: InputMaybe<ProductOptionUpdateVariantStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsCreateArgs = {
  options: Array<OptionCreateInput>;
  productId: Scalars['ID']['input'];
  variantStrategy?: InputMaybe<ProductOptionCreateVariantStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsDeleteArgs = {
  options: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  strategy?: InputMaybe<ProductOptionDeleteStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsReorderArgs = {
  options: Array<OptionReorderInput>;
  productId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductPublishArgs = {
  input: ProductPublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductReorderMediaArgs = {
  id: Scalars['ID']['input'];
  moves: Array<MoveInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductSetArgs = {
  identifier?: InputMaybe<ProductSetIdentifiers>;
  input: ProductSetInput;
  synchronous?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUnpublishArgs = {
  input: ProductUnpublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUpdateArgs = {
  identifier?: InputMaybe<ProductUpdateIdentifiers>;
  media?: InputMaybe<Array<CreateMediaInput>>;
  product?: InputMaybe<ProductUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUpdateMediaArgs = {
  media: Array<UpdateMediaInput>;
  productId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantAppendMediaArgs = {
  productId: Scalars['ID']['input'];
  variantMedia: Array<ProductVariantAppendMediaInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantDetachMediaArgs = {
  productId: Scalars['ID']['input'];
  variantMedia: Array<ProductVariantDetachMediaInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantJoinSellingPlanGroupsArgs = {
  id: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantLeaveSellingPlanGroupsArgs = {
  id: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantRelationshipBulkUpdateArgs = {
  input: Array<ProductVariantRelationshipUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkCreateArgs = {
  media?: InputMaybe<Array<CreateMediaInput>>;
  productId: Scalars['ID']['input'];
  strategy?: InputMaybe<ProductVariantsBulkCreateStrategy>;
  variants: Array<ProductVariantsBulkInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkDeleteArgs = {
  productId: Scalars['ID']['input'];
  variantsIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkReorderArgs = {
  positions: Array<ProductVariantPositionInput>;
  productId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkUpdateArgs = {
  allowPartialUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<CreateMediaInput>>;
  productId: Scalars['ID']['input'];
  variants: Array<ProductVariantsBulkInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubServerPixelUpdateArgs = {
  pubSubProject: Scalars['String']['input'];
  pubSubTopic: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: PubSubWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID']['input'];
  webhookSubscription: PubSubWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationCreateArgs = {
  input: PublicationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PublicationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishablePublishArgs = {
  id: Scalars['ID']['input'];
  input: Array<PublicationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishablePublishToCurrentChannelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishableUnpublishArgs = {
  id: Scalars['ID']['input'];
  input: Array<PublicationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishableUnpublishToCurrentChannelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityPricingByVariantUpdateArgs = {
  input: QuantityPricingByVariantUpdateInput;
  priceListId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityRulesAddArgs = {
  priceListId: Scalars['ID']['input'];
  quantityRules: Array<QuantityRuleInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityRulesDeleteArgs = {
  priceListId: Scalars['ID']['input'];
  variantIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationRefundCreateArgs = {
  input: RefundInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationRemoveFromReturnArgs = {
  exchangeLineItems?: InputMaybe<Array<ExchangeLineItemRemoveFromReturnInput>>;
  returnId: Scalars['ID']['input'];
  returnLineItems?: InputMaybe<Array<ReturnLineItemRemoveFromReturnInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnApproveRequestArgs = {
  input: ReturnApproveRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCancelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCloseArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCreateArgs = {
  returnInput: ReturnInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnDeclineRequestArgs = {
  input: ReturnDeclineRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnLineItemRemoveFromReturnArgs = {
  returnId: Scalars['ID']['input'];
  returnLineItems: Array<ReturnLineItemRemoveFromReturnInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnProcessArgs = {
  input: ReturnProcessInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnRefundArgs = {
  returnRefundInput: ReturnRefundInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnReopenArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnRequestArgs = {
  input: ReturnRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseDeliveryCreateWithShippingArgs = {
  labelInput?: InputMaybe<ReverseDeliveryLabelInput>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDeliveryLineItems: Array<ReverseDeliveryLineItemInput>;
  reverseFulfillmentOrderId: Scalars['ID']['input'];
  trackingInput?: InputMaybe<ReverseDeliveryTrackingInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseDeliveryShippingUpdateArgs = {
  labelInput?: InputMaybe<ReverseDeliveryLabelInput>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDeliveryId: Scalars['ID']['input'];
  trackingInput?: InputMaybe<ReverseDeliveryTrackingInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseFulfillmentOrderDisposeArgs = {
  dispositionInputs: Array<ReverseFulfillmentOrderDisposeInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchCreateArgs = {
  input: SavedSearchCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchDeleteArgs = {
  input: SavedSearchDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchUpdateArgs = {
  input: SavedSearchUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagCreateArgs = {
  input: ScriptTagInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ScriptTagInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentCreateArgs = {
  name: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentUpdateArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupAddProductVariantsArgs = {
  id: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupAddProductsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupCreateArgs = {
  input: SellingPlanGroupInput;
  resources?: InputMaybe<SellingPlanGroupResourceInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupRemoveProductVariantsArgs = {
  id: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupRemoveProductsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SellingPlanGroupInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingLabelPurchaseArgs = {
  shippingLabelPurchase: ShippingLabelPurchaseInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageMakeDefaultArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageUpdateArgs = {
  id: Scalars['ID']['input'];
  shippingPackage: CustomShippingPackageInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleDisableArgs = {
  locale: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleEnableArgs = {
  locale: Scalars['String']['input'];
  marketWebPresenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleUpdateArgs = {
  locale: Scalars['String']['input'];
  shopLocale: ShopLocaleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopPolicyUpdateArgs = {
  shopPolicy: ShopPolicyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopResourceFeedbackCreateArgs = {
  input: ResourceFeedbackCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopifyPaymentsPayoutAlternateCurrencyCreateArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  currency: CurrencyCode;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadTargetGenerateArgs = {
  input: StagedUploadTargetGenerateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadTargetsGenerateArgs = {
  input: Array<StageImageInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadsCreateArgs = {
  input: Array<StagedUploadInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationStandardMetafieldDefinitionEnableArgs = {
  access?: InputMaybe<StandardMetafieldDefinitionAccessInput>;
  capabilities?: InputMaybe<MetafieldCapabilityCreateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  ownerType: MetafieldOwnerType;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationStandardMetaobjectDefinitionEnableArgs = {
  type: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStoreCreditAccountCreditArgs = {
  creditInput: StoreCreditAccountCreditInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStoreCreditAccountDebitArgs = {
  debitInput: StoreCreditAccountDebitInput;
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStorefrontAccessTokenCreateArgs = {
  input: StorefrontAccessTokenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationStorefrontAccessTokenDeleteArgs = {
  input: StorefrontAccessTokenDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingAttemptCreateArgs = {
  subscriptionBillingAttemptInput: SubscriptionBillingAttemptInput;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleBulkChargeArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  billingAttemptExpectedDateRange: SubscriptionBillingCyclesDateRangeSelector;
  filters?: InputMaybe<SubscriptionBillingCycleBulkFilters>;
  inventoryPolicy?: InputMaybe<SubscriptionBillingAttemptInventoryPolicy>;
  paymentProcessingPolicy?: InputMaybe<SubscriptionBillingAttemptPaymentProcessingPolicy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleBulkSearchArgs = {
  billingAttemptExpectedDateRange: SubscriptionBillingCyclesDateRangeSelector;
  filters?: InputMaybe<SubscriptionBillingCycleBulkFilters>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleChargeArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  billingCycleSelector: SubscriptionBillingCycleSelector;
  inventoryPolicy?: InputMaybe<SubscriptionBillingAttemptInventoryPolicy>;
  paymentProcessingPolicy?: InputMaybe<SubscriptionBillingAttemptPaymentProcessingPolicy>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractDraftCommitArgs = {
  draftId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractDraftConcatenateArgs = {
  concatenatedBillingCycleContracts: Array<SubscriptionBillingCycleInput>;
  draftId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractEditArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleEditDeleteArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleEditsDeleteArgs = {
  contractId: Scalars['ID']['input'];
  targetSelection: SubscriptionBillingCyclesTargetSelection;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleScheduleEditArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
  input: SubscriptionBillingCycleScheduleEditInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleSkipArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleUnskipArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractActivateArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractAtomicCreateArgs = {
  input: SubscriptionContractAtomicCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractCancelArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractCreateArgs = {
  input: SubscriptionContractCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractExpireArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractFailArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractPauseArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractProductChangeArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  input: SubscriptionContractProductChangeInput;
  lineId: Scalars['ID']['input'];
  subscriptionContractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractSetNextBillingDateArgs = {
  contractId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractUpdateArgs = {
  actor?: InputMaybe<SubscriptionActor>;
  contractId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftCommitArgs = {
  draftId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountAddArgs = {
  draftId: Scalars['ID']['input'];
  input: SubscriptionManualDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountCodeApplyArgs = {
  draftId: Scalars['ID']['input'];
  redeemCode: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountRemoveArgs = {
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountUpdateArgs = {
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
  input: SubscriptionManualDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftFreeShippingDiscountAddArgs = {
  draftId: Scalars['ID']['input'];
  input: SubscriptionFreeShippingDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftFreeShippingDiscountUpdateArgs = {
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
  input: SubscriptionFreeShippingDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineAddArgs = {
  draftId: Scalars['ID']['input'];
  input: SubscriptionLineInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineRemoveArgs = {
  draftId: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineUpdateArgs = {
  draftId: Scalars['ID']['input'];
  input: SubscriptionLineUpdateInput;
  lineId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftUpdateArgs = {
  draftId: Scalars['ID']['input'];
  input: SubscriptionDraftInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationTagsAddArgs = {
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTagsRemoveArgs = {
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTaxAppConfigureArgs = {
  ready: Scalars['Boolean']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationTaxSummaryCreateArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ThemeRole>;
  source: Scalars['URL']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeDuplicateArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesCopyArgs = {
  files: Array<ThemeFilesCopyFileInput>;
  themeId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesDeleteArgs = {
  files: Array<Scalars['String']['input']>;
  themeId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesUpsertArgs = {
  files: Array<OnlineStoreThemeFilesUpsertFileInput>;
  themeId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemePublishArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OnlineStoreThemeInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationTransactionVoidArgs = {
  parentTransactionId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationTranslationsRegisterArgs = {
  resourceId: Scalars['ID']['input'];
  translations: Array<TranslationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTranslationsRemoveArgs = {
  locales: Array<Scalars['String']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  resourceId: Scalars['ID']['input'];
  translationKeys: Array<Scalars['String']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteBySavedSearchArgs = {
  savedSearchId: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteBySearchArgs = {
  search: Scalars['String']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectCreateArgs = {
  urlRedirect: UrlRedirectInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectImportCreateArgs = {
  url: Scalars['URL']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectImportSubmitArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectUpdateArgs = {
  id: Scalars['ID']['input'];
  urlRedirect: UrlRedirectInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationCreateArgs = {
  validation: ValidationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationUpdateArgs = {
  id: Scalars['ID']['input'];
  validation: ValidationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelCreateArgs = {
  webPixel: WebPixelInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelUpdateArgs = {
  id: Scalars['ID']['input'];
  webPixel: WebPixelInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPresenceCreateArgs = {
  input: WebPresenceCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPresenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPresenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: WebPresenceUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: WebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID']['input'];
  webhookSubscription: WebhookSubscriptionInput;
};

/**
 * A signed upload parameter for uploading an asset to Shopify.
 *
 * Deprecated in favor of
 * [StagedUploadParameter](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadParameter),
 * which is used in
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget)
 * and returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type MutationsStagedUploadTargetGenerateUploadParameter = {
  __typename?: 'MutationsStagedUploadTargetGenerateUploadParameter';
  /** The upload parameter name. */
  name: Scalars['String']['output'];
  /** The upload parameter value. */
  value: Scalars['String']['output'];
};

/**
 * A default cursor that you can use in queries to paginate your results. Each edge in a connection can
 * return a cursor, which is a reference to the edge's position in the connection. You can use an edge's cursor as
 * the starting point to retrieve the nodes before or after it in a connection.
 *
 * To learn more about using cursor-based pagination, refer to
 * [Paginating results with GraphQL](https://shopify.dev/api/usage/pagination-graphql).
 */
export type Navigable = {
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
};

/** A navigation item, holding basic link attributes. */
export type NavigationItem = {
  __typename?: 'NavigationItem';
  /** The unique identifier of the navigation item. */
  id: Scalars['String']['output'];
  /** The name of the navigation item. */
  title: Scalars['String']['output'];
  /** The URL of the page that the navigation item links to. */
  url: Scalars['URL']['output'];
};

/**
 * An object with an ID field to support global identification, in accordance with the
 * [Relay specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface).
 * This interface is used by the [node](https://shopify.dev/api/admin-graphql/unstable/queries/node)
 * and [nodes](https://shopify.dev/api/admin-graphql/unstable/queries/nodes) queries.
 */
export type Node = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** The valid values for the notification usage, specifying the intended notification environment usage for certain operations. */
export enum NotificationUsage {
  /** The notification environment is sms. */
  Sms = 'SMS',
  /** The notification environment is web. */
  Web = 'WEB'
}

/** The input fields for dimensions of an object. */
export type ObjectDimensionsInput = {
  /** The height in `unit`s. */
  height: Scalars['Float']['input'];
  /** The length in `unit`s. */
  length: Scalars['Float']['input'];
  /** Unit of measurement for `length`, `width`, and `height`. */
  unit: LengthUnit;
  /** The width in `unit`s. */
  width: Scalars['Float']['input'];
};

/** The shop's online store channel. */
export type OnlineStore = {
  __typename?: 'OnlineStore';
  /** Storefront password information. */
  passwordProtection: OnlineStorePasswordProtection;
};

/** Storefront password information. */
export type OnlineStorePasswordProtection = {
  __typename?: 'OnlineStorePasswordProtection';
  /** Whether the storefront password is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** Online Store preview URL of the object. */
export type OnlineStorePreviewable = {
  /** The [preview URL](https://help.shopify.com/manual/online-store/setting-up#preview-your-store) for the online store. */
  onlineStorePreviewUrl?: Maybe<Scalars['URL']['output']>;
};

/**
 * A theme for display on the storefront. Themes control the visual appearance and functionality of the online store through templates, stylesheets, and assets that determine how [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), and other content display to customers.
 *
 * Each theme has a [role](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.role) that indicates its status. Main themes are live on the storefront, unpublished themes are inactive, demo themes require purchase before publishing, and development themes are temporary for previewing during development. The theme includes [translations](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.translations) for multi-language support.
 */
export type OnlineStoreTheme = HasPublishedTranslations & Node & {
  __typename?: 'OnlineStoreTheme';
  /** The date and time when the theme was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The files in the theme. */
  files?: Maybe<OnlineStoreThemeFileConnection>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the theme, set by the merchant. */
  name: Scalars['String']['output'];
  /** The prefix of the theme. */
  prefix: Scalars['String']['output'];
  /** Whether the theme is processing. */
  processing: Scalars['Boolean']['output'];
  /** Whether the theme processing failed. */
  processingFailed: Scalars['Boolean']['output'];
  /** The role of the theme. */
  role: ThemeRole;
  /** The theme store ID. */
  themeStoreId?: Maybe<Scalars['Int']['output']>;
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The date and time when the theme was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A theme for display on the storefront. Themes control the visual appearance and functionality of the online store through templates, stylesheets, and assets that determine how [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), and other content display to customers.
 *
 * Each theme has a [role](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.role) that indicates its status. Main themes are live on the storefront, unpublished themes are inactive, demo themes require purchase before publishing, and development themes are temporary for previewing during development. The theme includes [translations](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.translations) for multi-language support.
 */
export type OnlineStoreThemeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filenames?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A theme for display on the storefront. Themes control the visual appearance and functionality of the online store through templates, stylesheets, and assets that determine how [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection), and other content display to customers.
 *
 * Each theme has a [role](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.role) that indicates its status. Main themes are live on the storefront, unpublished themes are inactive, demo themes require purchase before publishing, and development themes are temporary for previewing during development. The theme includes [translations](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-OnlineStoreTheme.fields.translations) for multi-language support.
 */
export type OnlineStoreThemeTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** An auto-generated type for paginating through multiple OnlineStoreThemes. */
export type OnlineStoreThemeConnection = {
  __typename?: 'OnlineStoreThemeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OnlineStoreThemeEdge>;
  /** A list of nodes that are contained in OnlineStoreThemeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OnlineStoreTheme>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one OnlineStoreTheme and a cursor during pagination. */
export type OnlineStoreThemeEdge = {
  __typename?: 'OnlineStoreThemeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OnlineStoreThemeEdge. */
  node: OnlineStoreTheme;
};

/** Represents a theme file. */
export type OnlineStoreThemeFile = {
  __typename?: 'OnlineStoreThemeFile';
  /** The body of the theme file. */
  body: OnlineStoreThemeFileBody;
  /** The md5 digest of the theme file for data integrity. */
  checksumMd5?: Maybe<Scalars['String']['output']>;
  /** The content type of the theme file. */
  contentType: Scalars['String']['output'];
  /** The date and time when the theme file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the theme file. */
  filename: Scalars['String']['output'];
  /** The size of the theme file in bytes. */
  size: Scalars['UnsignedInt64']['output'];
  /** The date and time when the theme file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the body of a theme file. */
export type OnlineStoreThemeFileBody = OnlineStoreThemeFileBodyBase64 | OnlineStoreThemeFileBodyText | OnlineStoreThemeFileBodyUrl;

/** Represents the base64 encoded body of a theme file. */
export type OnlineStoreThemeFileBodyBase64 = {
  __typename?: 'OnlineStoreThemeFileBodyBase64';
  /** The body of the theme file, base64 encoded. */
  contentBase64: Scalars['String']['output'];
};

/** The input fields for the theme file body. */
export type OnlineStoreThemeFileBodyInput = {
  /** The input type of the theme file body. */
  type: OnlineStoreThemeFileBodyInputType;
  /** The body of the theme file. */
  value: Scalars['String']['input'];
};

/** The input type for a theme file body. */
export enum OnlineStoreThemeFileBodyInputType {
  /** The base64 encoded body of a theme file. */
  Base64 = 'BASE64',
  /** The text body of the theme file. */
  Text = 'TEXT',
  /** The url of the body of a theme file. */
  Url = 'URL'
}

/** Represents the body of a theme file. */
export type OnlineStoreThemeFileBodyText = {
  __typename?: 'OnlineStoreThemeFileBodyText';
  /** The body of the theme file. */
  content: Scalars['String']['output'];
};

/** Represents the url of the body of a theme file. */
export type OnlineStoreThemeFileBodyUrl = {
  __typename?: 'OnlineStoreThemeFileBodyUrl';
  /** The short lived url for the body of the theme file. */
  url: Scalars['URL']['output'];
};

/** An auto-generated type for paginating through multiple OnlineStoreThemeFiles. */
export type OnlineStoreThemeFileConnection = {
  __typename?: 'OnlineStoreThemeFileConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OnlineStoreThemeFileEdge>;
  /** A list of nodes that are contained in OnlineStoreThemeFileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OnlineStoreThemeFile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
  /** List of errors that occurred during the request. */
  userErrors: Array<OnlineStoreThemeFileReadResult>;
};

/** An auto-generated type which holds one OnlineStoreThemeFile and a cursor during pagination. */
export type OnlineStoreThemeFileEdge = {
  __typename?: 'OnlineStoreThemeFileEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OnlineStoreThemeFileEdge. */
  node: OnlineStoreThemeFile;
};

/** Represents the result of a copy, delete, or write operation performed on a theme file. */
export type OnlineStoreThemeFileOperationResult = {
  __typename?: 'OnlineStoreThemeFileOperationResult';
  /** The md5 digest of the theme file for data integrity. */
  checksumMd5?: Maybe<Scalars['String']['output']>;
  /** The date and time when the theme file was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of the theme file. */
  filename: Scalars['String']['output'];
  /** The size of the theme file in bytes. */
  size: Scalars['UnsignedInt64']['output'];
  /** The date and time when the theme file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the result of a read operation performed on a theme asset. */
export type OnlineStoreThemeFileReadResult = {
  __typename?: 'OnlineStoreThemeFileReadResult';
  /** Type that indicates the result of the operation. */
  code: OnlineStoreThemeFileResultType;
  /** Unique identifier associated with the operation and the theme file. */
  filename: Scalars['String']['output'];
};

/** Type of a theme file operation result. */
export enum OnlineStoreThemeFileResultType {
  /** Operation was malformed or invalid. */
  BadRequest = 'BAD_REQUEST',
  /** Operation faced a conflict with the current state of the file. */
  Conflict = 'CONFLICT',
  /** Operation encountered an error. */
  Error = 'ERROR',
  /** Operation file could not be found. */
  NotFound = 'NOT_FOUND',
  /** Operation was successful. */
  Success = 'SUCCESS',
  /** Operation timed out. */
  Timeout = 'TIMEOUT',
  /** Operation could not be processed due to issues with input data. */
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY'
}

/** The input fields for the file to create or update. */
export type OnlineStoreThemeFilesUpsertFileInput = {
  /** The body of the theme file. */
  body: OnlineStoreThemeFileBodyInput;
  /** The filename of the theme file. */
  filename: Scalars['String']['input'];
};

/** User errors for theme file operations. */
export type OnlineStoreThemeFilesUserErrors = DisplayableError & {
  __typename?: 'OnlineStoreThemeFilesUserErrors';
  /** The error code. */
  code?: Maybe<OnlineStoreThemeFilesUserErrorsCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The filename of the theme file. */
  filename?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OnlineStoreThemeFilesUserErrors`. */
export enum OnlineStoreThemeFilesUserErrorsCode {
  /** Access denied. */
  AccessDenied = 'ACCESS_DENIED',
  /** There are files with the same filename. */
  DuplicateFileInput = 'DUPLICATE_FILE_INPUT',
  /** Error. */
  Error = 'ERROR',
  /** The file is invalid. */
  FileValidationError = 'FILE_VALIDATION_ERROR',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** Theme contextualization and condition types are not compatible with each other. */
  ThemeContextualizationNotCompatibleWithConditionTypes = 'THEME_CONTEXTUALIZATION_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** There are theme files with conflicts. */
  ThemeFilesConflict = 'THEME_FILES_CONFLICT',
  /** This action is not available on your current plan. Please upgrade to access theme editing features. */
  ThemeLimitedPlan = 'THEME_LIMITED_PLAN',
  /** Too many updates in a short period. Please try again later. */
  Throttled = 'THROTTLED'
}

/** The input fields for Theme attributes to update. */
export type OnlineStoreThemeInput = {
  /** The new name of the theme. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for the options and values of the combined listing. */
export type OptionAndValueInput = {
  /** The linked metafield for the product's option. */
  linkedMetafield?: InputMaybe<LinkedMetafieldInput>;
  /** The name of the Product's Option. */
  name: Scalars['String']['input'];
  /** The ID of the option to update. If not present, the option will be created. */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** The ordered values of the Product's Option. */
  values: Array<Scalars['String']['input']>;
};

/** The input fields for creating a product option. */
export type OptionCreateInput = {
  /** Specifies the metafield the option is linked to. */
  linkedMetafield?: InputMaybe<LinkedMetafieldCreateInput>;
  /** Name of the option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the option. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Values associated with the option. */
  values?: InputMaybe<Array<OptionValueCreateInput>>;
};

/** The input fields for reordering a product option and/or its values. */
export type OptionReorderInput = {
  /** Specifies the product option to reorder by ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies the product option to reorder by name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Values associated with the option. */
  values?: InputMaybe<Array<OptionValueReorderInput>>;
};

/** The input fields for creating or updating a product option. */
export type OptionSetInput = {
  /** Specifies the product option to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies the metafield the option is linked to. */
  linkedMetafield?: InputMaybe<LinkedMetafieldCreateInput>;
  /** Name of the option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the option. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Value associated with an option. */
  values?: InputMaybe<Array<OptionValueSetInput>>;
};

/** The input fields for updating a product option. */
export type OptionUpdateInput = {
  /** Specifies the product option to update. */
  id: Scalars['ID']['input'];
  /** Specifies the metafield the option is linked to. */
  linkedMetafield?: InputMaybe<LinkedMetafieldUpdateInput>;
  /** Name of the option. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the option. */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields required to create a product option value. */
export type OptionValueCreateInput = {
  /** Metafield value associated with an option. */
  linkedMetafieldValue?: InputMaybe<Scalars['String']['input']>;
  /** Value associated with an option. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for reordering a product option value. */
export type OptionValueReorderInput = {
  /** Specifies the product option value by ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies the product option value by name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for creating or updating a product option value. */
export type OptionValueSetInput = {
  /** Specifies the product option value. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Value associated with an option. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for updating a product option value. */
export type OptionValueUpdateInput = {
  /** Specifies the product option value. */
  id: Scalars['ID']['input'];
  /** Metafield value associated with an option. */
  linkedMetafieldValue?: InputMaybe<Scalars['String']['input']>;
  /** Value associated with an option. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type Order = CommentEventSubject & HasEvents & HasLocalizationExtensions & HasLocalizedFields & HasMetafieldDefinitions & HasMetafields & LegacyInteroperability & Node & {
  __typename?: 'Order';
  /** A list of additional fees applied to an order, such as duties, import fees, or [tax lines](https://shopify.dev/docs/api/admin-graphql/latest/objects/order#field-Order.fields.additionalFees.taxLines). */
  additionalFees: Array<AdditionalFee>;
  /** A list of sales agreements associated with the order, such as contracts defining payment terms, or delivery schedules between merchants and customers. */
  agreements: SalesAgreementConnection;
  /** A list of messages that appear on the **Orders** page in the Shopify admin. These alerts provide merchants with important information about an order's status or required actions. */
  alerts: Array<ResourceAlert>;
  /**
   * The application that created the order. For example, "Online Store", "Point of Sale", or a custom app name.
   * Use this to identify the order source for attribution and fulfillment workflows.
   * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  app?: Maybe<OrderApp>;
  /** The attribution details for the order. */
  attribution?: Maybe<OrderAttribution>;
  /**
   * The billing address associated with the payment method selected by the customer for an order.
   * Returns `null` if no billing address was provided during checkout.
   */
  billingAddress?: Maybe<MailingAddress>;
  /** Whether the billing address matches the [shipping address](https://shopify.dev/docs/api/admin-graphql/latest/objects/order#field-Order.fields.shippingAddress). Returns `true` if both addresses are the same, and `false` if they're different or if an address is missing. */
  billingAddressMatchesShippingAddress: Scalars['Boolean']['output'];
  /** Whether an order can be manually marked as paid. Returns `false` if the order is already paid, is canceled, has pending [Shopify Payments](https://help.shopify.com/en/manual/payments/shopify-payments/payouts) transactions, or has a negative payment amount. */
  canMarkAsPaid: Scalars['Boolean']['output'];
  /**
   * Whether order notifications can be sent to the customer.
   * Returns `true` if the customer has a valid [email address](https://shopify.dev/docs/api/admin-graphql/latest/objects/order#field-Order.fields.email).
   */
  canNotifyCustomer: Scalars['Boolean']['output'];
  /** The reason provided for an order cancellation. For example, a merchant might cancel an order if there's insufficient inventory. Returns `null` if the order hasn't been canceled. */
  cancelReason?: Maybe<OrderCancelReason>;
  /** Details of an order's cancellation, if it has been canceled. This includes the reason, date, and any [staff notes](https://shopify.dev/api/admin-graphql/latest/objects/OrderCancellation#field-OrderCancellation.fields.staffNote). */
  cancellation?: Maybe<OrderCancellation>;
  /**
   * The date and time in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601) when an order was canceled.
   * Returns `null` if the order hasn't been canceled.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether an authorized payment for an order can be captured.
   * Returns `true` if an authorized payment exists that hasn't been fully captured yet. Learn more about [capturing payments](https://help.shopify.com/en/manual/fulfillment/managing-orders/payments/capturing-payments).
   */
  capturable: Scalars['Boolean']['output'];
  /**
   * The total discount amount that applies to the entire order in shop currency, before returns, refunds, order edits, and cancellations.
   * @deprecated Use `cartDiscountAmountSet` instead.
   */
  cartDiscountAmount?: Maybe<Scalars['Money']['output']>;
  /** The total discount amount applied at the time the order was created, displayed in both shop and presentment currencies, before returns, refunds, order edits, and cancellations. This field only includes discounts applied to the entire order. */
  cartDiscountAmountSet?: Maybe<MoneyBag>;
  /** The token associated with the cart that was used to create the order. */
  cartToken?: Maybe<Scalars['String']['output']>;
  /**
   * The sales channel from which an order originated, such as the [Online Store](https://shopify.dev/docs/apps/build/app-surfaces#online-store) or [Shopify POS](https://shopify.dev/docs/apps/build/app-surfaces#point-of-sale).
   * @deprecated Use `publication` instead.
   */
  channel?: Maybe<Channel>;
  /**
   * Details about the sales channel that created the order, such as the [channel app type](https://shopify.dev/docs/api/admin-graphql/latest/objects/channel#field-Channel.fields.channelType)
   * and [channel name](https://shopify.dev/docs/api/admin-graphql/latest/objects/ChannelDefinition#field-ChannelDefinition.fields.channelName), which helps to track order sources.
   * @deprecated Use `attribution` instead.
   */
  channelInformation?: Maybe<ChannelInformation>;
  /** The token associated with the checkout that was used to create the order. Useful for correlating an order with the checkout it originated from, including in web pixels and analytics workflows. */
  checkoutToken?: Maybe<Scalars['String']['output']>;
  /** The IP address of the customer who placed the order. Useful for fraud detection and geographic analysis. */
  clientIp?: Maybe<Scalars['String']['output']>;
  /** Whether an order is closed. An order is considered closed if all its line items have been fulfilled or canceled, and all financial transactions are complete. */
  closed: Scalars['Boolean']['output'];
  /** The date and time [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601) when an order was closed. Shopify automatically records this timestamp when all items have been fulfilled or canceled, and all financial transactions are complete. Returns `null` if the order isn't closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A customer-facing order identifier, often shown instead of the sequential order name.
   * It uses a random alphanumeric format (for example, `XPAV284CT`) and isn't guaranteed to be unique across orders.
   */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Whether inventory has been reserved for an order. Returns `true` if inventory quantities for an order's [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) have been reserved.
   * Learn more about [managing inventory quantities and states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states).
   */
  confirmed: Scalars['Boolean']['output'];
  /** The date and time in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601) when an order was created. This timestamp is set when the customer completes checkout and remains unchanged throughout an order's lifecycle. */
  createdAt: Scalars['DateTime']['output'];
  /** The shop currency when the order was placed. For example, "USD" or "CAD". */
  currencyCode: CurrencyCode;
  /** The current total of all discounts applied to the entire order, after returns, refunds, order edits, and cancellations. This includes discount codes, automatic discounts, and other promotions that affect the whole order rather than individual line items. To get the original discount amount at the time of order creation, use the [`cartDiscountAmountSet`](https://shopify.dev/docs/api/admin-graphql/latest/objects/order#field-Order.fields.cartDiscountAmountSet) field. */
  currentCartDiscountAmountSet: MoneyBag;
  /**
   * The current shipping price after applying refunds and discounts.
   * If the parent `order.taxesIncluded` field is true, then this price includes taxes. Otherwise, this field is the pre-tax price.
   */
  currentShippingPriceSet: MoneyBag;
  /** The current sum of the quantities for all line items that contribute to the order's subtotal price, after returns, refunds, order edits, and cancellations. */
  currentSubtotalLineItemsQuantity: Scalars['Int']['output'];
  /**
   * The total price of the order, after returns and refunds, in shop and presentment currencies.
   * This includes taxes and discounts.
   */
  currentSubtotalPriceSet: MoneyBag;
  /**
   * A list of all tax lines applied to line items on the order, after returns.
   * Tax line prices represent the total price for all tax lines with the same `rate` and `title`.
   */
  currentTaxLines: Array<TaxLine>;
  /** The current total of all additional fees for an order, after any returns or modifications. Modifications include returns, refunds, order edits, and cancellations. Additional fees can include charges such as duties, import fees, and special handling. */
  currentTotalAdditionalFeesSet?: Maybe<MoneyBag>;
  /**
   * The total amount discounted on the order after returns and refunds, in shop and presentment currencies.
   * This includes both order and line level discounts.
   */
  currentTotalDiscountsSet: MoneyBag;
  /** The current total duties amount for an order, after any returns or modifications. Modifications include returns, refunds, order edits, and cancellations. */
  currentTotalDutiesSet?: Maybe<MoneyBag>;
  /**
   * The total price of the order, after returns, in shop and presentment currencies.
   * This includes taxes and discounts.
   */
  currentTotalPriceSet: MoneyBag;
  /** The sum of the prices of all tax lines applied to line items on the order, after returns and refunds, in shop and presentment currencies. */
  currentTotalTaxSet: MoneyBag;
  /** The total weight of the order after returns and refunds, in grams. */
  currentTotalWeight: Scalars['UnsignedInt64']['output'];
  /** A list of additional information that has been attached to the order. For example, gift message, delivery instructions, or internal notes. */
  customAttributes: Array<Attribute>;
  /**
   * The customer who placed an order. Returns `null` if an order was created through a checkout without customer authentication, such as a guest checkout.
   * Learn more about [customer accounts](https://help.shopify.com/manual/customers/customer-accounts).
   */
  customer?: Maybe<Customer>;
  /**
   * Whether the customer agreed to receive marketing emails at the time of purchase.
   * Use this to ensure compliance with marketing consent laws and to segment customers for email campaigns.
   * Learn more about [building customer segments](https://shopify.dev/docs/apps/build/marketing-analytics/customer-segments).
   */
  customerAcceptsMarketing: Scalars['Boolean']['output'];
  /**
   * The customer's visits and interactions with the online store before placing the order.
   * @deprecated Use `customerJourneySummary` instead.
   */
  customerJourney?: Maybe<CustomerJourney>;
  /**
   * The customer's visits and interactions with the online store before placing the order.
   * Use this to understand customer behavior, attribution sources, and marketing effectiveness to optimize your sales funnel.
   */
  customerJourneySummary?: Maybe<CustomerJourneySummary>;
  /**
   * The customer's language and region preference at the time of purchase. For example, "en" for English, "fr-CA" for French (Canada), or "es-MX" for Spanish (Mexico).
   * Use this to provide localized customer service and targeted marketing in the customer's preferred language.
   */
  customerLocale?: Maybe<Scalars['String']['output']>;
  /**
   * A list of discounts that are applied to the order, excluding order edits and refunds.
   * Includes discount codes, automatic discounts, and other promotions that reduce the order total.
   */
  discountApplications: DiscountApplicationConnection;
  /** The discount code used for an order. Returns `null` if no discount code was applied. */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** The discount codes used for the order. Multiple codes can be applied to a single order. */
  discountCodes: Array<Scalars['String']['output']>;
  /**
   * The primary address of the customer, prioritizing shipping address over billing address when both are available.
   * Returns `null` if neither shipping address nor billing address was provided.
   */
  displayAddress?: Maybe<MailingAddress>;
  /** An order's financial status for display in the Shopify admin. */
  displayFinancialStatus?: Maybe<OrderDisplayFinancialStatus>;
  /**
   * The order's fulfillment status that displays in the Shopify admin to merchants. For example, an order might be unfulfilled or scheduled.
   * For detailed processing, use the [`FulfillmentOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  displayFulfillmentStatus: OrderDisplayFulfillmentStatus;
  /**
   * A list of payment disputes associated with the order, such as chargebacks or payment inquiries.
   * Disputes occur when customers challenge transactions with their bank or payment provider.
   */
  disputes: Array<OrderDisputeSummary>;
  /**
   * Whether duties are included in the subtotal price of the order.
   * Duties are import taxes charged by customs authorities when goods cross international borders.
   */
  dutiesIncluded: Scalars['Boolean']['output'];
  /** Whether the order has had any edits applied. For example, adding or removing line items, updating quantities, or changing prices. */
  edited: Scalars['Boolean']['output'];
  /**
   * The email address associated with the customer for this order.
   * Used for sending order confirmations, shipping notifications, and other order-related communications.
   * Returns `null` if no email address was provided during checkout.
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Whether taxes on the order are estimated.
   * This field returns `false` when taxes on the order are finalized and aren't subject to any changes.
   */
  estimatedTaxes: Scalars['Boolean']['output'];
  /** A list of events associated with the order. Events track significant changes and activities related to the order, such as creation, payment, fulfillment, and cancellation. */
  events: EventConnection;
  /**
   * A list of ExchangeV2s for the order.
   * @deprecated Use `returns` instead.
   */
  exchangeV2s: ExchangeV2Connection;
  /**
   * Whether there are line items that can be fulfilled.
   * This field returns `false` when the order has no fulfillable line items.
   * For a more granular view of the fulfillment status, refer to the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  fulfillable: Scalars['Boolean']['output'];
  /**
   * A list of [fulfillment orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentOrder) for an order.
   * Each fulfillment order groups [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-Order.fields.lineItems) that are fulfilled together,
   * allowing an order to be processed in parts if needed.
   */
  fulfillmentOrders: FulfillmentOrderConnection;
  /** A list of shipments for the order. Fulfillments represent the physical shipment of products to customers. */
  fulfillments: Array<Fulfillment>;
  /** The total number of fulfillments for the order, including canceled ones. */
  fulfillmentsCount?: Maybe<Count>;
  /** Whether the order has been paid in full. This field returns `true` when the total amount received equals or exceeds the order total. */
  fullyPaid: Scalars['Boolean']['output'];
  /** Whether the merchant has added a timeline comment to the order. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The URL of the first page of the online store that the customer visited before they submitted the order.
   * @deprecated Use `customerJourneySummary.lastVisit.landingPageHtml` instead
   */
  landingPageDisplayText?: Maybe<Scalars['String']['output']>;
  /**
   * The first page of the online store that the customer visited before they submitted the order.
   * @deprecated Use `customerJourneySummary.lastVisit.landingPage` instead
   */
  landingPageUrl?: Maybe<Scalars['URL']['output']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** A list of the order's line items. Line items represent the individual products and quantities that make up the order. */
  lineItems: LineItemConnection;
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  localizationExtensions: LocalizationExtensionConnection;
  /** List of localized fields for the resource. */
  localizedFields: LocalizedFieldConnection;
  /**
   * The legal business structure that the merchant operates under for this order, such as an LLC, corporation, or partnership.
   * Used for tax reporting, legal compliance, and determining which business entity is responsible for the order.
   */
  merchantBusinessEntity: BusinessEntity;
  /** Whether the order can be edited by the merchant. Returns `false` for orders that can't be modified, such as canceled orders or orders with specific payment statuses. */
  merchantEditable: Scalars['Boolean']['output'];
  /** A list of reasons why the order can't be edited. For example, canceled orders can't be edited. */
  merchantEditableErrors: Array<Scalars['String']['output']>;
  /** The application acting as the Merchant of Record for the order. The Merchant of Record is responsible for tax collection and remittance. */
  merchantOfRecordApp?: Maybe<OrderApp>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /**
   * The unique identifier for the order that appears on the order page in the Shopify admin and the **Order status** page.
   * For example, "#1001", "EN1001", or "1001-A".
   * This value isn't unique across multiple stores. Use this field to identify orders in the Shopify admin and for order tracking.
   */
  name: Scalars['String']['output'];
  /**
   * The net payment for the order, based on the total amount received minus the total amount refunded, in shop currency.
   * @deprecated Use `netPaymentSet` instead.
   */
  netPayment: Scalars['Money']['output'];
  /** The net payment for the order, based on the total amount received minus the total amount refunded, in shop and presentment currencies. */
  netPaymentSet: MoneyBag;
  /**
   * A list of line items that can't be fulfilled.
   * For example, tips and fully refunded line items can't be fulfilled.
   * For a more granular view of the fulfillment status, refer to the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  nonFulfillableLineItems: LineItemConnection;
  /**
   * The note associated with the order.
   * Contains additional information or instructions added by merchants or customers during the order process.
   * Commonly used for special delivery instructions, gift messages, or internal processing notes.
   * The maximum length is 5000 characters.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** The order number used to generate the name using the store's configured order number prefix/suffix. This number isn't guaranteed to follow a consecutive integer sequence (e.g. 1, 2, 3..), nor is it guaranteed to be unique across multiple stores, or even for a single store. */
  number: Scalars['Int']['output'];
  /**
   * The total amount of all additional fees, such as import fees or taxes, that were applied when an order was created.
   * Returns `null` if additional fees aren't applicable.
   */
  originalTotalAdditionalFeesSet?: Maybe<MoneyBag>;
  /** The total amount of duties calculated when an order was created, before any modifications. Modifications include returns, refunds, order edits, and cancellations. Use [`currentTotalDutiesSet`](https://shopify.dev/docs/api/admin-graphql/latest/objects/order#field-Order.fields.currentTotalDutiesSet) to retrieve the current duties amount after adjustments. */
  originalTotalDutiesSet?: Maybe<MoneyBag>;
  /**
   * The total price of the order at the time of order creation, in shop and presentment currencies.
   * Use this to compare the original order value against the current total after edits, returns, or refunds.
   */
  originalTotalPriceSet: MoneyBag;
  /**
   * The payment collection details for the order, including payment status, outstanding amounts, and collection information.
   * Use this to understand when and how payments should be collected, especially for orders with deferred or installment payment terms.
   */
  paymentCollectionDetails: OrderPaymentCollectionDetails;
  /**
   * A list of the names of all payment gateways used for the order.
   * For example, "Shopify Payments" and "Cash on Delivery (COD)".
   */
  paymentGatewayNames: Array<Scalars['String']['output']>;
  /** The payment terms associated with the order, such as net payment due dates or early payment discounts. Payment terms define when and how an order should be paid. Returns `null` if no specific payment terms were set for the order. */
  paymentTerms?: Maybe<PaymentTerms>;
  /**
   * The phone number associated with the customer for this order.
   * Useful for contacting customers about shipping updates, delivery notifications, or order issues.
   * Returns `null` if no phone number was provided during checkout.
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * The fulfillment location that was assigned when the order was created.
   * Orders can have multiple fulfillment orders. These fulfillment orders can each be assigned to a different location which is responsible for fulfilling a subset of the items in an order. The `Order.physicalLocation` field will only point to one of these locations.
   * Use the [`FulfillmentOrder`](https://shopify.dev/api/admin-graphql/latest/objects/fulfillmentorder)
   * object for up to date fulfillment location information.
   * @deprecated Use `fulfillmentOrders` to get the fulfillment location for the order
   */
  physicalLocation?: Maybe<Location>;
  /**
   * The purchase order (PO) number that's associated with an order.
   * This is typically provided by business customers who require a PO number for their procurement.
   */
  poNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The currency used by the customer when placing the order. For example, "USD", "EUR", or "CAD".
   * This may differ from the shop's base currency when serving international customers or using multi-currency pricing.
   */
  presentmentCurrencyCode: CurrencyCode;
  /**
   * The date and time in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601) when the order was processed.
   * This date and time might not match the date and time when the order was created.
   */
  processedAt: Scalars['DateTime']['output'];
  /** Whether the customer also purchased items from other stores in the network. */
  productNetwork: Scalars['Boolean']['output'];
  /** The sales channel that the order was created from, such as the [Online Store](https://shopify.dev/docs/apps/build/app-surfaces#online-store) or [Shopify POS](https://shopify.dev/docs/apps/build/app-surfaces#point-of-sale). */
  publication?: Maybe<Publication>;
  /**
   * The business entity that placed the order, including company details and purchasing relationships.
   * Used for B2B transactions to track which company or organization is responsible for the purchase and payment terms.
   */
  purchasingEntity?: Maybe<PurchasingEntity>;
  /**
   * The marketing referral code from the link that the customer clicked to visit the store.
   * Supports the following URL attributes: "ref", "source", or "r".
   * For example, if the URL is `{shop}.myshopify.com/products/slide?ref=j2tj1tn2`, then this value is `j2tj1tn2`.
   * @deprecated Use `customerJourneySummary.lastVisit.referralCode` instead
   */
  referralCode?: Maybe<Scalars['String']['output']>;
  /**
   * A web domain or short description of the source that sent the customer to your online store. For example, "shopify.com" or "email".
   * @deprecated Use `customerJourneySummary.lastVisit.referralInfoHtml` instead
   */
  referrerDisplayText?: Maybe<Scalars['String']['output']>;
  /**
   * The URL of the webpage where the customer clicked a link that sent them to your online store.
   * @deprecated Use `customerJourneySummary.lastVisit.referrerUrl` instead
   */
  referrerUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The difference between the suggested and actual refund amount of all refunds that have been applied to the order.
   * A positive value indicates a difference in the merchant's favor, and a negative value indicates a difference in the customer's favor.
   */
  refundDiscrepancySet: MoneyBag;
  /**
   * Whether the order can be refunded based on its payment transactions.
   * Returns `false` for orders with no eligible payment transactions, such as fully refunded orders or orders with non-refundable payment methods.
   */
  refundable: Scalars['Boolean']['output'];
  /**
   * A list of refunds that have been applied to the order.
   * Refunds represent money returned to customers for returned items, cancellations, or adjustments.
   */
  refunds: Array<Refund>;
  /** The URL of the source that the order originated from, if found in the domain registry. Returns `null` if the source URL isn't in the domain registry. */
  registeredSourceUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * Whether the order requires physical shipping to the customer.
   * Returns `false` for digital-only orders (such as gift cards or downloadable products) and `true` for orders with physical products that need delivery.
   * Use this to determine shipping workflows and logistics requirements.
   */
  requiresShipping: Scalars['Boolean']['output'];
  /**
   * Whether any line items on the order can be restocked into inventory.
   * Returns `false` for digital products, custom items, or items that can't be resold.
   */
  restockable: Scalars['Boolean']['output'];
  /** The physical location where a retail order is created or completed, except for draft POS orders completed using the "mark as paid" flow in the Shopify admin, which return `null`. Transactions associated with the order might have been processed at a different location. */
  retailLocation?: Maybe<Location>;
  /**
   * The order's aggregated return status for display purposes.
   * Indicates the overall state of returns for the order, helping merchants track and manage the return process.
   */
  returnStatus: OrderReturnStatus;
  /**
   * The returns associated with the order.
   * Contains information about items that customers have requested to return, including return reasons, status, and refund details.
   * Use this to track and manage the return process for order items.
   */
  returns: ReturnConnection;
  /**
   * The risk assessment summary for the order.
   * Provides fraud analysis and risk scoring to help you identify potentially fraudulent orders.
   * Use this to make informed decisions about order fulfillment and payment processing.
   */
  risk: OrderRiskSummary;
  /**
   * The fraud risk level of the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.riskLevel which allows for more granular risk levels, including PENDING and NONE.
   */
  riskLevel: OrderRiskLevel;
  /**
   * A list of risks associated with the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment, which provides enhanced capabilities such as distinguishing risks from their provider.
   */
  risks: Array<OrderRisk>;
  /**
   * The shipping address where the order will be delivered.
   * Contains the customer's delivery location for fulfillment and shipping label generation.
   * Returns `null` for digital orders or orders that don't require shipping.
   */
  shippingAddress?: Maybe<MailingAddress>;
  /**
   * A summary of all shipping costs on the order.
   * Aggregates shipping charges, discounts, and taxes to provide a single view of delivery costs.
   */
  shippingLine?: Maybe<ShippingLine>;
  /**
   * The shipping methods applied to the order.
   * Each shipping line represents a shipping option chosen during checkout, including the carrier, service level, and cost.
   * Use this to understand shipping charges and delivery options for the order.
   */
  shippingLines: ShippingLineConnection;
  /**
   * The Shopify Protect details for the order, including fraud protection status and coverage information.
   * Shopify Protect helps protect eligible orders against fraudulent chargebacks.
   * Returns `null` if Shopify Protect is disabled for the shop or the order isn't eligible for protection.
   * Learn more about [Shopify Protect](https://www.shopify.com/protect).
   */
  shopifyProtect?: Maybe<ShopifyProtectOrderSummary>;
  /**
   * A unique POS or third party order identifier.
   * For example, "1234-12-1000" or "111-98567-54". The [`receiptNumber`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order#field-receiptNumber) field is derived from this value for POS orders.
   */
  sourceIdentifier?: Maybe<Scalars['String']['output']>;
  /** The name of the source associated with the order, such as "web", "mobile_app", or "pos". Use this field to identify the platform where the order was placed. */
  sourceName?: Maybe<Scalars['String']['output']>;
  /**
   * The staff member who created or is responsible for the order.
   * Useful for tracking which team member handled phone orders, manual orders, or order modifications.
   * Returns `null` for orders created directly by customers through the online store.
   */
  staffMember?: Maybe<StaffMember>;
  /**
   * The URL where customers can check their order's current status, including tracking information and delivery updates.
   * Provides order tracking links in emails, apps, or customer communications.
   */
  statusPageUrl: Scalars['URL']['output'];
  /**
   * The sum of quantities for all line items that contribute to the order's subtotal price.
   * This excludes quantities for items like tips, shipping costs, or gift cards that don't affect the subtotal.
   * Use this to quickly understand the total item count for pricing calculations.
   */
  subtotalLineItemsQuantity: Scalars['Int']['output'];
  /**
   * The sum of the prices for all line items after discounts and before returns, in shop currency.
   * If `taxesIncluded` is `true`, then the subtotal also includes tax.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  subtotalPrice?: Maybe<Scalars['Money']['output']>;
  /**
   * The sum of the prices for all line items after discounts and before returns, in shop and presentment currencies.
   * If `taxesIncluded` is `true`, then the subtotal also includes tax.
   */
  subtotalPriceSet?: Maybe<MoneyBag>;
  /**
   * A calculated refund suggestion for the order based on specified line items, shipping, and duties.
   * Use this to preview refund amounts, taxes, and processing fees before creating an actual refund.
   */
  suggestedRefund?: Maybe<SuggestedRefund>;
  /**
   * A comma separated list of tags associated with the order. Updating `tags` overwrites
   * any existing tags that were previously added to the order. To add new tags without overwriting
   * existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags: Array<Scalars['String']['output']>;
  /**
   * Whether taxes are exempt on the order.
   * Returns `true` for orders where the customer or business has a valid tax exemption, such as non-profit organizations or tax-free purchases.
   * Use this to understand if tax calculations were skipped during checkout.
   */
  taxExempt: Scalars['Boolean']['output'];
  /**
   * A list of all tax lines applied to line items on the order, before returns.
   * Tax line prices represent the total price for all tax lines with the same `rate` and `title`.
   */
  taxLines: Array<TaxLine>;
  /**
   * Whether taxes are included in the subtotal price of the order.
   * When `true`, the subtotal and line item prices include tax amounts. When `false`, taxes are calculated and displayed separately.
   */
  taxesIncluded: Scalars['Boolean']['output'];
  /**
   * Whether the order is a test.
   * Test orders are made using the Shopify Bogus Gateway or a payment provider with test mode enabled.
   * A test order can't be converted into a real order and vice versa.
   */
  test: Scalars['Boolean']['output'];
  /**
   * The authorized amount that's uncaptured or undercaptured, in shop currency.
   * This amount isn't adjusted for returns.
   * @deprecated Use `totalCapturableSet` instead.
   */
  totalCapturable: Scalars['Money']['output'];
  /**
   * The authorized amount that's uncaptured or undercaptured, in shop and presentment currencies.
   * This amount isn't adjusted for returns.
   */
  totalCapturableSet: MoneyBag;
  /** The total rounding adjustment applied to payments or refunds for an order involving cash payments. Applies to some countries where cash transactions are rounded to the nearest currency denomination. */
  totalCashRoundingAdjustment: CashRoundingAdjustment;
  /**
   * The total amount discounted on the order before returns, in shop currency.
   * This includes both order and line level discounts.
   * @deprecated Use `totalDiscountsSet` instead.
   */
  totalDiscounts?: Maybe<Scalars['Money']['output']>;
  /**
   * The total amount discounted on the order before returns, in shop and presentment currencies.
   * This includes both order and line level discounts.
   */
  totalDiscountsSet?: Maybe<MoneyBag>;
  /**
   * The total amount not yet transacted for the order, in shop and presentment currencies.
   * A positive value indicates a difference in the merchant's favor (payment from customer to merchant) and a negative value indicates a difference in the customer's favor (refund from merchant to customer).
   */
  totalOutstandingSet: MoneyBag;
  /**
   * The total price of the order, before returns, in shop currency.
   * This includes taxes and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  totalPrice: Scalars['Money']['output'];
  /**
   * The total price of the order, before returns, in shop and presentment currencies.
   * This includes taxes and discounts.
   */
  totalPriceSet: MoneyBag;
  /**
   * The total amount received from the customer before returns, in shop currency.
   * @deprecated Use `totalReceivedSet` instead.
   */
  totalReceived: Scalars['Money']['output'];
  /** The total amount received from the customer before returns, in shop and presentment currencies. */
  totalReceivedSet: MoneyBag;
  /**
   * The total amount that was refunded, in shop currency.
   * @deprecated Use `totalRefundedSet` instead.
   */
  totalRefunded: Scalars['Money']['output'];
  /** The total amount that was refunded, in shop and presentment currencies. */
  totalRefundedSet: MoneyBag;
  /** The total amount of shipping that was refunded, in shop and presentment currencies. */
  totalRefundedShippingSet: MoneyBag;
  /**
   * The total shipping amount before discounts and returns, in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  totalShippingPrice: Scalars['Money']['output'];
  /** The total shipping costs returned to the customer, in shop and presentment currencies. This includes fees and any related discounts that were refunded. */
  totalShippingPriceSet: MoneyBag;
  /**
   * The total tax amount before returns, in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  totalTax?: Maybe<Scalars['Money']['output']>;
  /** The total tax amount before returns, in shop and presentment currencies. */
  totalTaxSet?: Maybe<MoneyBag>;
  /**
   * The sum of all tip amounts for the order, in shop currency.
   * @deprecated Use `totalTipReceivedSet` instead.
   */
  totalTipReceived: MoneyV2;
  /** The sum of all tip amounts for the order, in shop and presentment currencies. */
  totalTipReceivedSet: MoneyBag;
  /** The total weight of the order before returns, in grams. */
  totalWeight?: Maybe<Scalars['UnsignedInt64']['output']>;
  /** A list of transactions associated with the order. */
  transactions: Array<OrderTransaction>;
  /** The number of transactions associated with the order. */
  transactionsCount?: Maybe<Count>;
  /** Whether no payments have been made for the order. */
  unpaid: Scalars['Boolean']['output'];
  /** The date and time in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601) when the order was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderExchangeV2sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayable?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderFulfillmentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderLocalizedFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Array<CountryCode>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  purposes?: InputMaybe<Array<LocalizedFieldPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderNonFulfillableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderRefundsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderReturnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderRisksArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderShippingLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRemovals?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderStatusPageUrlArgs = {
  audience?: InputMaybe<Audience>;
  notificationUsage?: InputMaybe<NotificationUsage>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderSuggestedRefundArgs = {
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  refundLineItems?: InputMaybe<Array<RefundLineItemInput>>;
  refundMethodAllocation?: InputMaybe<RefundMethodAllocation>;
  refundShipping?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAmount?: InputMaybe<Scalars['Money']['input']>;
  suggestFullRefund?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Order` object represents a customer's request to purchase one or more products from a store. Use the `Order` object to handle the complete purchase lifecycle from checkout to fulfillment.
 *
 * Use the `Order` object when you need to:
 *
 * - Display order details on customer account pages or admin dashboards.
 * - Create orders for phone sales, wholesale customers, or subscription services.
 * - Update order information like shipping addresses, notes, or fulfillment status.
 * - Process returns, exchanges, and partial refunds.
 * - Generate invoices, receipts, and shipping labels.
 *
 * The `Order` object serves as the central hub connecting customer information, product details, payment processing, and fulfillment data within the GraphQL Admin API schema.
 *
 * > Note:
 * > Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older records,
 * > then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions). If your app is granted
 * > access, then you can add the `read_all_orders`, `read_orders`, and `write_orders` scopes.
 *
 * > Caution:
 * > Only use orders data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/docs/api/usage/access-scopes#requesting-specific-permissions) for apps that don't have a legitimate use for the associated data.
 *
 * Learn more about [building apps for orders and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment).
 */
export type OrderTransactionsArgs = {
  capturable?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  manuallyResolvable?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The possible order action types for a
 * [sales agreement](https://shopify.dev/api/admin-graphql/latest/interfaces/salesagreement).
 */
export enum OrderActionType {
  /** An order with a purchase or charge. */
  Order = 'ORDER',
  /** An edit to the order. */
  OrderEdit = 'ORDER_EDIT',
  /** A refund on the order. */
  Refund = 'REFUND',
  /** A return on the order. */
  Return = 'RETURN',
  /** An unknown agreement action. Represents new actions that may be added in future versions. */
  Unknown = 'UNKNOWN'
}

/** An order adjustment accounts for the difference between a calculated and actual refund amount. */
export type OrderAdjustment = Node & {
  __typename?: 'OrderAdjustment';
  /** The amount of the order adjustment in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** An optional reason that explains a discrepancy between calculated and actual refund amounts. */
  reason?: Maybe<OrderAdjustmentDiscrepancyReason>;
  /** The tax amount of the order adjustment in shop and presentment currencies. */
  taxAmountSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple OrderAdjustments. */
export type OrderAdjustmentConnection = {
  __typename?: 'OrderAdjustmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OrderAdjustmentEdge>;
  /** A list of nodes that are contained in OrderAdjustmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OrderAdjustment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Discrepancy reasons for order adjustments. */
export enum OrderAdjustmentDiscrepancyReason {
  /** The discrepancy reason is customer. */
  Customer = 'CUSTOMER',
  /** The discrepancy reason is damage. */
  Damage = 'DAMAGE',
  /** The discrepancy reason is balance adjustment. */
  FullReturnBalancingAdjustment = 'FULL_RETURN_BALANCING_ADJUSTMENT',
  /** The discrepancy reason is pending refund. */
  PendingRefundDiscrepancy = 'PENDING_REFUND_DISCREPANCY',
  /** The discrepancy reason is not one of the predefined reasons. */
  RefundDiscrepancy = 'REFUND_DISCREPANCY',
  /** The discrepancy reason is restocking. */
  Restock = 'RESTOCK'
}

/** An auto-generated type which holds one OrderAdjustment and a cursor during pagination. */
export type OrderAdjustmentEdge = {
  __typename?: 'OrderAdjustmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderAdjustmentEdge. */
  node: OrderAdjustment;
};

/** Discrepancy reasons for order adjustments. */
export enum OrderAdjustmentInputDiscrepancyReason {
  /** The discrepancy reason is customer. */
  Customer = 'CUSTOMER',
  /** The discrepancy reason is damage. */
  Damage = 'DAMAGE',
  /** The discrepancy reason is not one of the predefined reasons. */
  Other = 'OTHER',
  /** The discrepancy reason is restocking. */
  Restock = 'RESTOCK'
}

/** An agreement associated with an order placement. */
export type OrderAgreement = SalesAgreement & {
  __typename?: 'OrderAgreement';
  /** The application that created the agreement. */
  app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  happenedAt: Scalars['DateTime']['output'];
  /** The unique ID for the agreement. */
  id: Scalars['ID']['output'];
  /** The order associated with the agreement. */
  order: Order;
  /** The reason the agremeent was created. */
  reason: OrderActionType;
  /** The sales associated with the agreement. */
  sales: SaleConnection;
  /** The staff member associated with the agreement. */
  user?: Maybe<StaffMember>;
};


/** An agreement associated with an order placement. */
export type OrderAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Identifies the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created an order. Common sources include "online store" for web purchases, "Point of Sale" for in-person sales, or custom app names for orders created through third-party integrations.
 *
 * Use this information to track order attribution, analyze sales channels, and route orders to appropriate fulfillment workflows based on their source.
 */
export type OrderApp = {
  __typename?: 'OrderApp';
  /** The application icon. */
  icon: Image;
  /** The application ID. */
  id: Scalars['ID']['output'];
  /** The name of the application. */
  name: Scalars['String']['output'];
};

/** The attribution details for an order. */
export type OrderAttribution = {
  __typename?: 'OrderAttribution';
  /** The display name of the attribution source. */
  displayName: Scalars['String']['output'];
  /** An identifier for the attribution source. */
  handle: Scalars['String']['output'];
  /** Sanitized SVG content used as the attribution source icon. */
  icon?: Maybe<Scalars['String']['output']>;
};

/**
 * An attribution definition that an app can use to label orders it routes to a shop.
 * Definitions can be supplied declaratively via the `order_attribution_config` extension or created
 * dynamically per-shop via the Admin API.
 * Learn more in the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution).
 */
export type OrderAttributionDefinition = Node & {
  __typename?: 'OrderAttributionDefinition';
  /** A human-readable name for the definition, displayed in Shopify Admin and on order details. */
  displayName: Scalars['String']['output'];
  /** A unique identifier for the definition, scoped to the calling app on a single shop. Used as the `attribution_handle` value when an app attributes an order to this definition. */
  handle: Scalars['String']['output'];
  /** Sanitized SVG content used as the icon for orders attributed to this definition. May be null when no icon is provided. */
  icon?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** An auto-generated type for paginating through multiple OrderAttributionDefinitions. */
export type OrderAttributionDefinitionConnection = {
  __typename?: 'OrderAttributionDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OrderAttributionDefinitionEdge>;
  /** A list of nodes that are contained in OrderAttributionDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OrderAttributionDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `orderAttributionDefinitionDelete` mutation. */
export type OrderAttributionDefinitionDeletePayload = {
  __typename?: 'OrderAttributionDefinitionDeletePayload';
  /** The ID of the deleted order attribution definition. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderAttributionDefinitionDeleteUserError>;
};

/** An error that occurs during the execution of `OrderAttributionDefinitionDelete`. */
export type OrderAttributionDefinitionDeleteUserError = DisplayableError & {
  __typename?: 'OrderAttributionDefinitionDeleteUserError';
  /** The error code. */
  code?: Maybe<OrderAttributionDefinitionDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderAttributionDefinitionDeleteUserError`. */
export enum OrderAttributionDefinitionDeleteUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one OrderAttributionDefinition and a cursor during pagination. */
export type OrderAttributionDefinitionEdge = {
  __typename?: 'OrderAttributionDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderAttributionDefinitionEdge. */
  node: OrderAttributionDefinition;
};

/** The input fields for upserting an order attribution definition. */
export type OrderAttributionDefinitionUpsertInput = {
  /** A human-readable name for the definition, displayed in Shopify Admin and on order details. */
  displayName: Scalars['String']['input'];
  /** A unique identifier for the definition, scoped to the calling app on a single shop. Case insensitive. Used to match an existing definition when upserting. */
  handle: Scalars['String']['input'];
  /** Sanitized SVG content used as the icon for orders attributed to this definition. Must conform to the platform's SVG sanitization rules and a 0 0 20 20 viewbox. Omit this field to leave the existing icon unchanged on update, or pass `null` to clear it. */
  icon?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `orderAttributionDefinitionUpsert` mutation. */
export type OrderAttributionDefinitionUpsertPayload = {
  __typename?: 'OrderAttributionDefinitionUpsertPayload';
  /** The order attribution definition that was upserted. */
  orderAttributionDefinition?: Maybe<OrderAttributionDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderAttributionDefinitionUpsertUserError>;
};

/** An error that occurs during the execution of `OrderAttributionDefinitionUpsert`. */
export type OrderAttributionDefinitionUpsertUserError = DisplayableError & {
  __typename?: 'OrderAttributionDefinitionUpsertUserError';
  /** The error code. */
  code?: Maybe<OrderAttributionDefinitionUpsertUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderAttributionDefinitionUpsertUserError`. */
export enum OrderAttributionDefinitionUpsertUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `orderCancel` mutation. */
export type OrderCancelPayload = {
  __typename?: 'OrderCancelPayload';
  /** The job that asynchronously cancels the order. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  orderCancelUserErrors: Array<OrderCancelUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `orderCancelUserErrors` instead.
   */
  userErrors: Array<UserError>;
};

/** Represents the reason for the order's cancellation. */
export enum OrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = 'CUSTOMER',
  /** Payment was declined. */
  Declined = 'DECLINED',
  /** The order was fraudulent. */
  Fraud = 'FRAUD',
  /** There was insufficient inventory. */
  Inventory = 'INVENTORY',
  /** The order was canceled for an unlisted reason. */
  Other = 'OTHER',
  /** Staff made an error. */
  Staff = 'STAFF'
}

/** The input fields used to specify the refund method for an order cancellation. */
export type OrderCancelRefundMethodInput = {
  /** Whether to refund to the original payment method. */
  originalPaymentMethodsRefund?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to refund to store credit. */
  storeCreditRefund?: InputMaybe<OrderCancelStoreCreditRefundInput>;
};

/** The input fields used to refund to store credit. */
export type OrderCancelStoreCreditRefundInput = {
  /** The expiration date of the store credit. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Errors related to order cancellation. */
export type OrderCancelUserError = DisplayableError & {
  __typename?: 'OrderCancelUserError';
  /** The error code. */
  code?: Maybe<OrderCancelUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCancelUserError`. */
export enum OrderCancelUserErrorCode {
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** An order refund was requested but the user does not have the refund_orders permission. */
  NoRefundPermission = 'NO_REFUND_PERMISSION',
  /** An order refund was requested but the user does not have the refund_to_store_credit permission. */
  NoRefundToStoreCreditPermission = 'NO_REFUND_TO_STORE_CREDIT_PERMISSION',
  /** A store credit order refund was requested but the order is a B2B order. */
  StoreCreditRefundB2BNotSupported = 'STORE_CREDIT_REFUND_B2B_NOT_SUPPORTED',
  /** A store credit order refund was requested but the expiration date is in the past. */
  StoreCreditRefundExpirationInPast = 'STORE_CREDIT_REFUND_EXPIRATION_IN_PAST',
  /** A store credit order refund was requested but the order has no customer. */
  StoreCreditRefundMissingCustomer = 'STORE_CREDIT_REFUND_MISSING_CUSTOMER'
}

/** Details about the order cancellation. */
export type OrderCancellation = {
  __typename?: 'OrderCancellation';
  /** Staff provided note for the order cancellation. */
  staffNote?: Maybe<Scalars['String']['output']>;
};

/** The input fields for the authorized transaction to capture and the total amount to capture from it. */
export type OrderCaptureInput = {
  /** The amount to capture. The capture amount can't be greater than the amount of the authorized transaction. */
  amount: Scalars['Money']['input'];
  /** The currency (in ISO format) that's used to capture the order. This must be the presentment currency (the currency used by the customer) and is a required field for orders where the currency and presentment currency differ. */
  currency?: InputMaybe<CurrencyCode>;
  /**
   * Indicates whether this is to be the final capture for the order transaction. Only applies to
   * Shopify Payments authorizations which are multi-capturable. If true, any uncaptured amount from the
   * authorization will be voided after the capture is completed. If false, the authorization will remain open
   * for future captures.
   *
   * For multi-capturable authorizations, this defaults to false if not provided. This field has no effect on
   * authorizations which aren't multi-capturable (can only be captured once), or on other types of
   * transactions.
   */
  finalCapture?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the order to capture. */
  id: Scalars['ID']['input'];
  /** The ID of the authorized transaction to capture. */
  parentTransactionId: Scalars['ID']['input'];
};

/** Return type for `orderCapture` mutation. */
export type OrderCapturePayload = {
  __typename?: 'OrderCapturePayload';
  /** The created capture transaction. */
  transaction?: Maybe<OrderTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for specifying an open order to close. */
export type OrderCloseInput = {
  /** The ID of the order to close. */
  id: Scalars['ID']['input'];
};

/** Return type for `orderClose` mutation. */
export type OrderClosePayload = {
  __typename?: 'OrderClosePayload';
  /** The closed order. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type for paginating through multiple Orders. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OrderEdge>;
  /** A list of nodes that are contained in OrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Order>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for identifying an existing customer to associate with the order. */
export type OrderCreateAssociateCustomerAttributesInput = {
  /**
   * The email of the customer to associate to the order.
   *
   *               > Note:
   *               > If both this email input field and the email on `OrderCreateOrderInput` are provided, this field will
   *               > take precedence.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer to associate to the order. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for a note attribute for an order. */
export type OrderCreateCustomAttributeInput = {
  /** The key or name of the custom attribute. */
  key: Scalars['String']['input'];
  /** The value of the custom attribute. */
  value: Scalars['String']['input'];
};

/** The input fields for creating a customer's mailing address. */
export type OrderCreateCustomerAddressInput = {
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** The name of the city, district, village, or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer's company or organization. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The name of the country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A unique phone number for the customer. Formatted using E.164 standard. For example, _+16135551111_. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The region of the address, such as the province, state, or district. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for a customer to associate with an order. Allows creation of a new customer or specifying an existing one. */
export type OrderCreateCustomerInput = {
  /** An existing customer to associate with the order, specified by ID. */
  toAssociate?: InputMaybe<OrderCreateAssociateCustomerAttributesInput>;
  /** A new customer to create or update and associate with the order. */
  toUpsert?: InputMaybe<OrderCreateUpsertCustomerAttributesInput>;
};

/** The input fields for a discount code to apply to an order. Only one type of discount can be applied to an order. */
export type OrderCreateDiscountCodeInput = {
  /** A free shipping discount code applied to the shipping on an order. */
  freeShippingDiscountCode?: InputMaybe<OrderCreateFreeShippingDiscountCodeAttributesInput>;
  /** A fixed amount discount code applied to the line items on the order. */
  itemFixedDiscountCode?: InputMaybe<OrderCreateFixedDiscountCodeAttributesInput>;
  /** A percentage discount code applied to the line items on the order. */
  itemPercentageDiscountCode?: InputMaybe<OrderCreatePercentageDiscountCodeAttributesInput>;
};

/** The status of payments associated with the order. Can only be set when the order is created. */
export enum OrderCreateFinancialStatus {
  /** The payments have been authorized. */
  Authorized = 'AUTHORIZED',
  /** The payments have been expired. */
  Expired = 'EXPIRED',
  /** The payments have been paid. */
  Paid = 'PAID',
  /** The order has been partially paid. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** The payments have been partially refunded. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The payments are pending. Payment might fail in this state. Check again to confirm whether the payments have been paid successfully. */
  Pending = 'PENDING',
  /** The payments have been refunded. */
  Refunded = 'REFUNDED',
  /** The payments have been voided. */
  Voided = 'VOIDED'
}

/** The input fields for a fixed amount discount code to apply to an order. */
export type OrderCreateFixedDiscountCodeAttributesInput = {
  /** The amount that's deducted from the order total. When you create an order, this value is the monetary amount to deduct. */
  amountSet?: InputMaybe<MoneyBagInput>;
  /** The discount code that was entered at checkout. */
  code: Scalars['String']['input'];
};

/** The input fields for a free shipping discount code to apply to an order. */
export type OrderCreateFreeShippingDiscountCodeAttributesInput = {
  /** The discount code that was entered at checkout. */
  code: Scalars['String']['input'];
};

/** The input fields for a fulfillment to create for an order. */
export type OrderCreateFulfillmentInput = {
  /** The ID of the location to fulfill the order from. */
  locationId: Scalars['ID']['input'];
  /** Whether the customer should be notified of changes with the fulfillment. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The address at which the fulfillment occurred. */
  originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /** The status of the shipment. */
  shipmentStatus?: InputMaybe<FulfillmentEventStatus>;
  /**
   * The name of the tracking company.
   *
   * If you specify a tracking company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies),
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface. This doesn't mean
   * that Shopify automatically updates the fulfillment's `shipment_status` field in Admin.
   * The same tracking company will be applied to all tracking numbers specified.
   *
   * For tracking companies whose `shipment_status` field is updated automatically, see the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers).
   *
   * > Note:
   * > Send the tracking company name exactly as written in
   * > [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * > (capitalization matters).
   */
  trackingCompany?: InputMaybe<Scalars['String']['input']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The order's status in terms of fulfilled line items. */
export enum OrderCreateFulfillmentStatus {
  /** Every line item in the order has been fulfilled. */
  Fulfilled = 'FULFILLED',
  /** At least one line item in the order has been fulfilled. */
  Partial = 'PARTIAL',
  /** Every line item in the order has been restocked and the order canceled. */
  Restocked = 'RESTOCKED'
}

/** The types of behavior to use when updating inventory. */
export enum OrderCreateInputsInventoryBehavior {
  /** Do not claim inventory. */
  Bypass = 'BYPASS',
  /** Ignore the product's inventory policy and claim inventory. */
  DecrementIgnoringPolicy = 'DECREMENT_IGNORING_POLICY',
  /** Follow the product's inventory policy and claim inventory, if possible. */
  DecrementObeyingPolicy = 'DECREMENT_OBEYING_POLICY'
}

/** The input fields for a line item to create for an order. */
export type OrderCreateLineItemInput = {
  /**
   * The handle of a fulfillment service that stocks the product variant belonging to a line item.
   *
   *               This is a third-party fulfillment service in the following scenarios:
   *
   *               **Scenario 1**
   *               - The product variant is stocked by a single fulfillment service.
   *               - The [FulfillmentService](/api/admin-graphql/latest/objects/FulfillmentService) is a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   *               **Scenario 2**
   *               - Multiple fulfillment services stock the product variant.
   *               - The last time that the line item was unfulfilled, it was awaiting fulfillment by a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   *               If none of the above conditions are met, then the fulfillment service has the `manual` handle.
   */
  fulfillmentService?: InputMaybe<Scalars['String']['input']>;
  /** Whether the item is a gift card. If true, then the item is not taxed or considered for shipping charges. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The price of the item before discounts have been applied in the shop currency. */
  priceSet?: InputMaybe<MoneyBagInput>;
  /** The ID of the product that the line item belongs to. Can be `null` if the original product associated with the order is deleted at a later date. */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of custom information for the item that has been added to the cart. Often used to provide product customization options. */
  properties?: InputMaybe<Array<OrderCreateLineItemPropertyInput>>;
  /** The number of items that were purchased. */
  quantity: Scalars['Int']['input'];
  /** Whether the item requires shipping. */
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The item's SKU (stock keeping unit). */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** A list of tax line objects, each of which details a tax applied to the item. */
  taxLines?: InputMaybe<Array<OrderCreateTaxLineInput>>;
  /** Whether the item was taxable. */
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the product. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant. If both `productId` and `variantId` are provided, then the product ID that corresponds to the `variantId` is used. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** The title of the product variant. */
  variantTitle?: InputMaybe<Scalars['String']['input']>;
  /** The name of the item's supplier. */
  vendor?: InputMaybe<Scalars['String']['input']>;
  /** The weight of the line item. This will take precedence over the weight of the product variant, if one was specified. */
  weight?: InputMaybe<WeightInput>;
};

/** The input fields for a line item property for an order. */
export type OrderCreateLineItemPropertyInput = {
  /** The name of the line item property. */
  name: Scalars['String']['input'];
  /** The value of the line item property. */
  value: Scalars['String']['input'];
};

/** A job result for tracking the status of a mandate payment request on an order. */
export type OrderCreateMandatePaymentJobResult = JobResult & Node & {
  __typename?: 'OrderCreateMandatePaymentJobResult';
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** Returns any errors that occurred during the mandate payment. */
  errors: Array<UserError>;
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
  /** The order associated with the mandate payment request. */
  order?: Maybe<Order>;
  /** The current status of the mandate payment request. */
  status: OrderCreateMandatePaymentStatus;
};

/** Return type for `orderCreateMandatePayment` mutation. */
export type OrderCreateMandatePaymentPayload = {
  __typename?: 'OrderCreateMandatePaymentPayload';
  /** The async job used for charging the payment. */
  job?: Maybe<Job>;
  /** The job result for tracking the status of the mandate payment request. */
  jobResult?: Maybe<OrderCreateMandatePaymentJobResult>;
  /** The Unique ID for the created payment. */
  paymentReferenceId?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderCreateMandatePaymentUserError>;
};

/** Represents the status of a mandate payment request. */
export enum OrderCreateMandatePaymentStatus {
  /** The mandate payment has failed. */
  Failed = 'FAILED',
  /** The mandate payment request has been initiated. */
  Started = 'STARTED',
  /** The mandate payment has been completed successfully. */
  Succeeded = 'SUCCEEDED'
}

/** An error that occurs during the execution of `OrderCreateMandatePayment`. */
export type OrderCreateMandatePaymentUserError = DisplayableError & {
  __typename?: 'OrderCreateMandatePaymentUserError';
  /** The error code. */
  code?: Maybe<OrderCreateMandatePaymentUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCreateMandatePaymentUserError`. */
export enum OrderCreateMandatePaymentUserErrorCode {
  /** Errors for mandate payment on order. */
  OrderMandatePaymentErrorCode = 'ORDER_MANDATE_PAYMENT_ERROR_CODE'
}

/** An error that occurs during the execution of a order create manual payment mutation. */
export type OrderCreateManualPaymentOrderCreateManualPaymentError = DisplayableError & {
  __typename?: 'OrderCreateManualPaymentOrderCreateManualPaymentError';
  /** The error code. */
  code?: Maybe<OrderCreateManualPaymentOrderCreateManualPaymentErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCreateManualPaymentOrderCreateManualPaymentError`. */
export enum OrderCreateManualPaymentOrderCreateManualPaymentErrorCode {
  /** Amount exceeds the remaining balance. */
  AmountExceedsBalance = 'AMOUNT_EXCEEDS_BALANCE',
  /** Amount must be positive. */
  AmountNotPositive = 'AMOUNT_NOT_POSITIVE',
  /** The currency of the amount doesn't match the presentment currency of the order. */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** Payment gateway is not found. */
  GatewayNotFound = 'GATEWAY_NOT_FOUND',
  /** Order is temporarily unavailable. */
  OrderIsTemporarilyUnavailable = 'ORDER_IS_TEMPORARILY_UNAVAILABLE',
  /** Order is not found. */
  OrderNotFound = 'ORDER_NOT_FOUND',
  /** Indicates that the processedAt field is invalid, such as when it references a future date. */
  ProcessedAtInvalid = 'PROCESSED_AT_INVALID'
}

/** Return type for `orderCreateManualPayment` mutation. */
export type OrderCreateManualPaymentPayload = {
  __typename?: 'OrderCreateManualPaymentPayload';
  /** The order recorded a manual payment. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderCreateManualPaymentOrderCreateManualPaymentError>;
};

/**
 * The input fields that define the strategies for updating inventory and
 * whether to send shipping and order confirmations to customers.
 */
export type OrderCreateOptionsInput = {
  /**
   * The strategy for handling updates to inventory: not claiming inventory, ignoring inventory policies,
   * or following policies when claiming inventory.
   */
  inventoryBehaviour?: InputMaybe<OrderCreateInputsInventoryBehavior>;
  /** Whether to send a shipping confirmation to the customer. */
  sendFulfillmentReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send an order confirmation to the customer. */
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating an order. */
export type OrderCreateOrderInput = {
  /**
   * The mailing address associated with the payment method. This address is an optional field that won't be
   *                available on orders that don't require a payment method.
   *
   *               > Note:
   *               > If a customer is provided, this field or `shipping_address` (which has precedence) will be set as the
   *               > customer's default address. Additionally, if the provided customer is new or hasn't created an order yet
   *               > then their name will be set to the first/last name from this address (if provided).
   */
  billingAddress?: InputMaybe<MailingAddressInput>;
  /** Whether the customer consented to receive email updates from the shop. */
  buyerAcceptsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date and time ([ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format) when the order was closed. Returns null if the order isn't closed. */
  closedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID of the purchasing company's location for the order. */
  companyLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The shop-facing currency for the order. If not specified, then the shop's default currency is used. */
  currency?: InputMaybe<CurrencyCode>;
  /** A list of extra information that's added to the order. Appears in the **Additional details** section of an order details page. */
  customAttributes?: InputMaybe<Array<OrderCreateCustomAttributeInput>>;
  /** The customer to associate to the order. */
  customer?: InputMaybe<OrderCreateCustomerInput>;
  /** A discount code applied to the order. */
  discountCode?: InputMaybe<OrderCreateDiscountCodeInput>;
  /**
   * A new customer email address for the order.
   *
   *               > Note:
   *               > If a customer is provided, and no email is provided, the customer's email will be set to this field.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The financial status of the order. If not specified, then this will be derived through the given transactions. Note that it's possible to specify a status that doesn't match the given transactions and it will persist, but if an operation later occurs on the order, the status may then be recalculated to match the current state of transactions. */
  financialStatus?: InputMaybe<OrderCreateFinancialStatus>;
  /** The fulfillment to create for the order. This will apply to all line items. */
  fulfillment?: InputMaybe<OrderCreateFulfillmentInput>;
  /** The fulfillment status of the order. Will default to `unfulfilled` if not included. */
  fulfillmentStatus?: InputMaybe<OrderCreateFulfillmentStatus>;
  /** The line items to create for the order. */
  lineItems?: InputMaybe<Array<OrderCreateLineItemInput>>;
  /** A list of metafields to add to the order. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The order name, generated by combining the `order_number` property with the order prefix and suffix that are set in the merchant's [general settings](https://www.shopify.com/admin/settings/general). This is different from the `id` property, which is the ID of the order used by the API. This field can also be set by the API to be any string value. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The new contents for the note associated with the order. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** A new customer phone number for the order. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The purchase order number associated to this order. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The presentment currency that was used to display prices to the customer. This must be specified if any presentment currencies are used in the order. */
  presentmentCurrency?: InputMaybe<CurrencyCode>;
  /** The date and time ([ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format) when an order was processed. This value is the date that appears on your orders and that's used in the analytic reports. If you're importing orders from an app or another platform, then you can set processed_at to a date and time in the past to match when the original order was created. As of API version 2026-07, values in the future are clamped to the current time. In earlier versions, future values return a `PROCESSED_AT_INVALID` error. */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The website where the customer clicked a link to the shop. */
  referringSite?: InputMaybe<Scalars['URL']['input']>;
  /**
   * The mailing address to where the order will be shipped.
   *
   *               > Note:
   *               > If a customer is provided, this field (which has precedence) or `billing_address` will be set as the
   *               > customer's default address. Additionally, if the provided customer doesn't have a first or last name
   *               > then it will be set to the first/last name from this address (if provided).
   */
  shippingAddress?: InputMaybe<MailingAddressInput>;
  /** An array of objects, each of which details a shipping method used. */
  shippingLines?: InputMaybe<Array<OrderCreateShippingLineInput>>;
  /** The ID of the order placed on the originating platform. This value doesn't correspond to the Shopify ID that's generated from a completed draft. */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The source channel that the order is attributed to. Set this to the handle of an order attribution definition configured for your sales channel app, such as `youtube` or `channel:amazon-us`. To set up order attribution for your app, follow the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution). */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** A valid URL to the original order on the originating surface. This URL is displayed to merchants on the Order Details page. If the URL is invalid, then it won't be displayed. */
  sourceUrl?: InputMaybe<Scalars['URL']['input']>;
  /** A comma separated list of tags that have been added to the draft order. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of tax line objects, each of which details a tax applicable to the order. When creating an order through the API, tax lines can be specified on the order or the line items but not both. Tax lines specified on the order are split across the _taxable_ line items in the created order. */
  taxLines?: InputMaybe<Array<OrderCreateTaxLineInput>>;
  /** Whether taxes are included in the order subtotal. */
  taxesIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a test order. */
  test?: InputMaybe<Scalars['Boolean']['input']>;
  /** The payment transactions to create for the order. */
  transactions?: InputMaybe<Array<OrderCreateOrderTransactionInput>>;
  /** The ID of the user who processed the order, if applicable. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for a transaction to create for an order. */
export type OrderCreateOrderTransactionInput = {
  /** The amount of the transaction. */
  amountSet: MoneyBagInput;
  /** The authorization code associated with the transaction. */
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the device used to process the transaction. */
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the gateway the transaction was issued through. */
  gateway?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the gift card used for this transaction. */
  giftCardId?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of transaction. */
  kind?: InputMaybe<OrderTransactionKind>;
  /** The ID of the location where the transaction was processed. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** The date and time when the transaction was processed. */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The transaction receipt that the payment gateway attaches to the transaction.
   * The value of this field depends on which payment gateway processed the transaction.
   */
  receiptJson?: InputMaybe<Scalars['JSON']['input']>;
  /** The status of the transaction. */
  status?: InputMaybe<OrderTransactionStatus>;
  /** Whether the transaction is a test transaction. */
  test?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user who processed the transaction. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `orderCreate` mutation. */
export type OrderCreatePayload = {
  __typename?: 'OrderCreatePayload';
  /** The order that was created. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderCreateUserError>;
};

/** The input fields for a percentage discount code to apply to an order. */
export type OrderCreatePercentageDiscountCodeAttributesInput = {
  /** The discount code that was entered at checkout. */
  code: Scalars['String']['input'];
  /** The amount that's deducted from the order total. When you create an order, this value is the percentage to deduct. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** The input fields for a shipping line to create for an order. */
export type OrderCreateShippingLineInput = {
  /** A reference to the shipping method. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The price of this shipping method in the shop currency. Can't be negative. */
  priceSet: MoneyBagInput;
  /** The source of the shipping method. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** A list of tax line objects, each of which details a tax applicable to this shipping line. */
  taxLines?: InputMaybe<Array<OrderCreateTaxLineInput>>;
  /** The title of the shipping method. */
  title: Scalars['String']['input'];
};

/** The input fields for a tax line to create for an order. */
export type OrderCreateTaxLineInput = {
  /** Whether the channel that submitted the tax line is liable for remitting. A value of `null` indicates unknown liability for the tax line. */
  channelLiable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount added to the order for this tax in shop and presentment currencies after discounts are applied. */
  priceSet?: InputMaybe<MoneyBagInput>;
  /** The proportion of the item price that the tax represents as a decimal. */
  rate: Scalars['Decimal']['input'];
  /** The name of the tax line to create. */
  title: Scalars['String']['input'];
};

/** The input fields for creating a new customer object or identifying an existing customer to update & associate with the order. */
export type OrderCreateUpsertCustomerAttributesInput = {
  /** A list of addresses to associate with the customer. */
  addresses?: InputMaybe<Array<OrderCreateCustomerAddressInput>>;
  /**
   * The email address to update the customer with. If no `id` is provided, this is used to uniquely identify
   *                  the customer.
   *
   *                 > Note:
   *                 > If both this email input field and the email on `OrderCreateOrderInput` are provided, this field will
   *                 > take precedence.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the customer to associate to the order. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the customer that's used with [Multipass login](https://shopify.dev/api/multipass). */
  multipassIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** A note about the customer. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique phone number ([E.164 format](https://en.wikipedia.org/wiki/E.164)) for this customer.
   *                  Attempting to assign the same phone number to multiple customers returns an error. The property can be
   *                  set using different formats, but each format must represent a number that can be dialed from anywhere
   *                  in the world. The following formats are all valid:
   *                   - 6135551212
   *                   - +16135551212
   *                   - (613)555-1212
   *                   - +1 613-555-1212
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Tags that the shop owner has attached to the customer. A customer can have up to 250 tags. Each tag can have up to 255 characters. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the customer is exempt from paying taxes on their order. If `true`, then taxes won't be applied to an order at checkout. If `false`, then taxes will be applied at checkout. */
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An error that occurs during the execution of `OrderCreate`. */
export type OrderCreateUserError = DisplayableError & {
  __typename?: 'OrderCreateUserError';
  /** The error code. */
  code?: Maybe<OrderCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCreateUserError`. */
export enum OrderCreateUserErrorCode {
  /** Indicates that the line item fulfillment service handle is invalid. */
  FulfillmentServiceInvalid = 'FULFILLMENT_SERVICE_INVALID',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Indicates that the inventory claim failed during order creation. */
  InventoryClaimFailed = 'INVENTORY_CLAIM_FAILED',
  /** Indicates that the processed_at field is invalid, such as when it references a future date. */
  ProcessedAtInvalid = 'PROCESSED_AT_INVALID',
  /** Indicates that both customer_id and customer were provided - only one is permitted. */
  RedundantCustomerFields = 'REDUNDANT_CUSTOMER_FIELDS',
  /** Indicates that the shop is dormant and cannot create orders. */
  ShopDormant = 'SHOP_DORMANT',
  /** Indicates that the tax line rate is missing - only enforced for LineItem or ShippingLine-level tax lines. */
  TaxLineRateMissing = 'TAX_LINE_RATE_MISSING'
}

/** Return type for `orderCustomerRemove` mutation. */
export type OrderCustomerRemovePayload = {
  __typename?: 'OrderCustomerRemovePayload';
  /** The order that had its customer removed. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderCustomerRemoveUserError>;
};

/** Errors related to order customer removal. */
export type OrderCustomerRemoveUserError = DisplayableError & {
  __typename?: 'OrderCustomerRemoveUserError';
  /** The error code. */
  code?: Maybe<OrderCustomerRemoveUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCustomerRemoveUserError`. */
export enum OrderCustomerRemoveUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** An error ocurred while saving the order. */
  NotSaved = 'NOT_SAVED'
}

/** Return type for `orderCustomerSet` mutation. */
export type OrderCustomerSetPayload = {
  __typename?: 'OrderCustomerSetPayload';
  /** The order that had a customer set. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderCustomerSetUserError>;
};

/** Errors related to order customer set. */
export type OrderCustomerSetUserError = DisplayableError & {
  __typename?: 'OrderCustomerSetUserError';
  /** The error code. */
  code?: Maybe<OrderCustomerSetUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderCustomerSetUserError`. */
export enum OrderCustomerSetUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The customer does not have the permissions to place this order. */
  NotPermitted = 'NOT_PERMITTED',
  /** An error ocurred while saving the order. */
  NotSaved = 'NOT_SAVED'
}

/** Return type for `orderDelete` mutation. */
export type OrderDeletePayload = {
  __typename?: 'OrderDeletePayload';
  /** Deleted order ID. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderDeleteUserError>;
};

/** Errors related to deleting an order. */
export type OrderDeleteUserError = DisplayableError & {
  __typename?: 'OrderDeleteUserError';
  /** The error code. */
  code?: Maybe<OrderDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderDeleteUserError`. */
export enum OrderDeleteUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** Represents the order's current financial status. */
export enum OrderDisplayFinancialStatus {
  /** Displayed as **Authorized**. The payment provider has validated the customer's payment information. This status appears only for manual payment capture and indicates payments should be captured before the authorization period expires. */
  Authorized = 'AUTHORIZED',
  /** Displayed as **Expired**. Payment wasn't captured before the payment provider's deadline on an authorized order. Some payment providers use this status to indicate failed payment processing. */
  Expired = 'EXPIRED',
  /** Displayed as **Paid**. Payment was automatically or manually captured, or the order was marked as paid. */
  Paid = 'PAID',
  /** Displayed as **Partially paid**. A payment was manually captured for the order with an amount less than the full order value. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Displayed as **Partially refunded**. The amount refunded to a customer is less than the full amount paid for an order. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** Displayed as **Pending**. Orders have this status when the payment provider needs time to complete the payment, or when manual payment methods are being used. */
  Pending = 'PENDING',
  /** Displayed as **Refunded**. The full amount paid for an order was refunded to the customer. */
  Refunded = 'REFUNDED',
  /** Displayed as **Voided**. An authorized but uncaptured payment was voided, releasing the hold on the funds. This is the payment's financial status and is distinct from the order's status: an order can remain open even when its payment is voided. */
  Voided = 'VOIDED'
}

/** Represents the order's aggregated fulfillment status for display purposes. */
export enum OrderDisplayFulfillmentStatus {
  /** Displayed as **Fulfilled**. All the items in the order have been fulfilled. */
  Fulfilled = 'FULFILLED',
  /** Displayed as **In progress**. All of the items in the order have had a request for fulfillment sent to the fulfillment service or all of the items have been marked as in progress. */
  InProgress = 'IN_PROGRESS',
  /** Displayed as **On hold**. All of the unfulfilled items in this order are on hold. */
  OnHold = 'ON_HOLD',
  /** Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status. */
  Open = 'OPEN',
  /** Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled. */
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  /** Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by the "IN_PROGRESS" status. */
  PendingFulfillment = 'PENDING_FULFILLMENT',
  /** Displayed as **Request declined**. Some of the items in the order have been rejected for fulfillment by the fulfillment service. */
  RequestDeclined = 'REQUEST_DECLINED',
  /** Displayed as **Restocked**. All the items in the order have been restocked. Replaced by the "UNFULFILLED" status. */
  Restocked = 'RESTOCKED',
  /** Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time. */
  Scheduled = 'SCHEDULED',
  /** Displayed as **Unfulfilled**. None of the items in the order have been fulfilled. */
  Unfulfilled = 'UNFULFILLED'
}

/** A summary of the important details for a dispute on an order. */
export type OrderDisputeSummary = Node & {
  __typename?: 'OrderDisputeSummary';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The type that the dispute was initiated as. */
  initiatedAs: DisputeType;
  /** The current status of the dispute. */
  status: DisputeStatus;
};

/** An auto-generated type which holds one Order and a cursor during pagination. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderEdge. */
  node: Order;
};

/** Return type for `orderEditAddCustomItem` mutation. */
export type OrderEditAddCustomItemPayload = {
  __typename?: 'OrderEditAddCustomItemPayload';
  /** The custom line item that will be added to the order based on the current edits. */
  calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `orderEditAddLineItemDiscount` mutation. */
export type OrderEditAddLineItemDiscountPayload = {
  __typename?: 'OrderEditAddLineItemDiscountPayload';
  /** The discount applied to a line item during this order edit. */
  addedDiscountStagedChange?: Maybe<OrderStagedChangeAddLineItemDiscount>;
  /** The line item with the edits applied but not saved. */
  calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields used to add a shipping line. */
export type OrderEditAddShippingLineInput = {
  /** The price of the shipping line. */
  price: MoneyInput;
  /** The title of the shipping line. */
  title: Scalars['String']['input'];
};

/** Return type for `orderEditAddShippingLine` mutation. */
export type OrderEditAddShippingLinePayload = {
  __typename?: 'OrderEditAddShippingLinePayload';
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /**
   * The [calculated shipping line](https://shopify.dev/api/admin-graphql/latest/objects/calculatedshippingline)
   * that's added during this order edit.
   */
  calculatedShippingLine?: Maybe<CalculatedShippingLine>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderEditAddShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditAddShippingLine`. */
export type OrderEditAddShippingLineUserError = DisplayableError & {
  __typename?: 'OrderEditAddShippingLineUserError';
  /** The error code. */
  code?: Maybe<OrderEditAddShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderEditAddShippingLineUserError`. */
export enum OrderEditAddShippingLineUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `orderEditAddVariant` mutation. */
export type OrderEditAddVariantPayload = {
  __typename?: 'OrderEditAddVariantPayload';
  /**
   * The [calculated line item](https://shopify.dev/api/admin-graphql/latest/objects/calculatedlineitem)
   * that's added during this order edit.
   */
  calculatedLineItem?: Maybe<CalculatedLineItem>;
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An agreement associated with an edit to the order. */
export type OrderEditAgreement = SalesAgreement & {
  __typename?: 'OrderEditAgreement';
  /** The application that created the agreement. */
  app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  happenedAt: Scalars['DateTime']['output'];
  /** The unique ID for the agreement. */
  id: Scalars['ID']['output'];
  /** The reason the agremeent was created. */
  reason: OrderActionType;
  /** The sales associated with the agreement. */
  sales: SaleConnection;
  /** The staff member associated with the agreement. */
  user?: Maybe<StaffMember>;
};


/** An agreement associated with an edit to the order. */
export type OrderEditAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields used to add a discount during an order edit. */
export type OrderEditAppliedDiscountInput = {
  /** The description of the discount. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The value of the discount as a fixed amount. */
  fixedValue?: InputMaybe<MoneyInput>;
  /** The value of the discount as a percentage. */
  percentValue?: InputMaybe<Scalars['Float']['input']>;
};

/** Return type for `orderEditBegin` mutation. */
export type OrderEditBeginPayload = {
  __typename?: 'OrderEditBeginPayload';
  /** The order that will be edited. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session that was created. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `orderEditCommit` mutation. */
export type OrderEditCommitPayload = {
  __typename?: 'OrderEditCommitPayload';
  /** The order with changes applied. */
  order?: Maybe<Order>;
  /** Messages to display to the user after the staged changes are commmitted. */
  successMessages?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `orderEditRemoveDiscount` mutation. */
export type OrderEditRemoveDiscountPayload = {
  __typename?: 'OrderEditRemoveDiscountPayload';
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderEditRemoveDiscountUserError>;
};

/** An error that occurs during the execution of `OrderEditRemoveDiscount`. */
export type OrderEditRemoveDiscountUserError = DisplayableError & {
  __typename?: 'OrderEditRemoveDiscountUserError';
  /** The error code. */
  code?: Maybe<OrderEditRemoveDiscountUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderEditRemoveDiscountUserError`. */
export enum OrderEditRemoveDiscountUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `orderEditRemoveLineItemDiscount` mutation. */
export type OrderEditRemoveLineItemDiscountPayload = {
  __typename?: 'OrderEditRemoveLineItemDiscountPayload';
  /** The calculated line item after removal of the discount. */
  calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `orderEditRemoveShippingLine` mutation. */
export type OrderEditRemoveShippingLinePayload = {
  __typename?: 'OrderEditRemoveShippingLinePayload';
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderEditRemoveShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditRemoveShippingLine`. */
export type OrderEditRemoveShippingLineUserError = DisplayableError & {
  __typename?: 'OrderEditRemoveShippingLineUserError';
  /** The error code. */
  code?: Maybe<OrderEditRemoveShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderEditRemoveShippingLineUserError`. */
export enum OrderEditRemoveShippingLineUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** An edit session for an order. */
export type OrderEditSession = Node & {
  __typename?: 'OrderEditSession';
  /** The unique ID of the order edit session. */
  id: Scalars['ID']['output'];
};

/** Return type for `orderEditSetQuantity` mutation. */
export type OrderEditSetQuantityPayload = {
  __typename?: 'OrderEditSetQuantityPayload';
  /** The calculated line item with the edits applied but not saved. */
  calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** The calculated order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `orderEditUpdateDiscount` mutation. */
export type OrderEditUpdateDiscountPayload = {
  __typename?: 'OrderEditUpdateDiscountPayload';
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderEditUpdateDiscountUserError>;
};

/** An error that occurs during the execution of `OrderEditUpdateDiscount`. */
export type OrderEditUpdateDiscountUserError = DisplayableError & {
  __typename?: 'OrderEditUpdateDiscountUserError';
  /** The error code. */
  code?: Maybe<OrderEditUpdateDiscountUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderEditUpdateDiscountUserError`. */
export enum OrderEditUpdateDiscountUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** The input fields used to update a shipping line. */
export type OrderEditUpdateShippingLineInput = {
  /** The price of the shipping line. */
  price?: InputMaybe<MoneyInput>;
  /** The title of the shipping line. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `orderEditUpdateShippingLine` mutation. */
export type OrderEditUpdateShippingLinePayload = {
  __typename?: 'OrderEditUpdateShippingLinePayload';
  /** An order with the edits applied but not saved. */
  calculatedOrder?: Maybe<CalculatedOrder>;
  /** The order edit session with the edits applied but not saved. */
  orderEditSession?: Maybe<OrderEditSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderEditUpdateShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditUpdateShippingLine`. */
export type OrderEditUpdateShippingLineUserError = DisplayableError & {
  __typename?: 'OrderEditUpdateShippingLineUserError';
  /** The error code. */
  code?: Maybe<OrderEditUpdateShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderEditUpdateShippingLineUserError`. */
export enum OrderEditUpdateShippingLineUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** The input fields for identifying a order. */
export type OrderIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the order. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The ID of the order. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for specifying the information to be updated on an order when using the orderUpdate mutation. */
export type OrderInput = {
  /** A new list of custom attributes for the order. Overwrites the existing custom attributes. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /** A new customer email address for the order. Overwrites the existing email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the order to update. */
  id: Scalars['ID']['input'];
  /** A list of new [localized fields](https://shopify.dev/api/admin-graphql/latest/objects/localizedfield) to add to the existing list of localized fields for the order. */
  localizedFields?: InputMaybe<Array<LocalizedFieldInput>>;
  /** A list of new metafields to add to the existing metafields for the order. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The new contents for the note associated with the order. Overwrites the existing note. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** A new customer phone number for the order. Overwrites the existing phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The new purchase order number for the order. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The new shipping address for the order. Overwrites the existing shipping address. */
  shippingAddress?: InputMaybe<MailingAddressInput>;
  /** A new list of tags for the order. Overwrites the existing tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `orderInvoiceSend` mutation. */
export type OrderInvoiceSendPayload = {
  __typename?: 'OrderInvoiceSendPayload';
  /** The order associated with the invoice email. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderInvoiceSendUserError>;
};

/** An error that occurs during the execution of `OrderInvoiceSend`. */
export type OrderInvoiceSendUserError = DisplayableError & {
  __typename?: 'OrderInvoiceSendUserError';
  /** The error code. */
  code?: Maybe<OrderInvoiceSendUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderInvoiceSendUserError`. */
export enum OrderInvoiceSendUserErrorCode {
  /** An error occurred while sending the invoice. */
  OrderInvoiceSendUnsuccessful = 'ORDER_INVOICE_SEND_UNSUCCESSFUL'
}

/** The input fields for specifying the order to mark as paid. */
export type OrderMarkAsPaidInput = {
  /** The ID of the order to mark as paid. */
  id: Scalars['ID']['input'];
};

/** Return type for `orderMarkAsPaid` mutation. */
export type OrderMarkAsPaidPayload = {
  __typename?: 'OrderMarkAsPaidPayload';
  /** The order marked as paid. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for specifying a closed order to open. */
export type OrderOpenInput = {
  /** The ID of the order to open. */
  id: Scalars['ID']['input'];
};

/** Return type for `orderOpen` mutation. */
export type OrderOpenPayload = {
  __typename?: 'OrderOpenPayload';
  /** The opened order. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The payment collection details for an order that requires additional payment following an edit to the order. */
export type OrderPaymentCollectionDetails = {
  __typename?: 'OrderPaymentCollectionDetails';
  /** The URL to use for collecting an additional payment on the order. */
  additionalPaymentCollectionUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of vaulted payment methods for the order with their permissions. */
  vaultedPaymentMethods?: Maybe<Array<PaymentMandate>>;
};

/** The status of a customer's payment for an order. */
export type OrderPaymentStatus = {
  __typename?: 'OrderPaymentStatus';
  /** A message describing an error during the asynchronous processing of a payment. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the payment, initially returned by an `orderCreateMandatePayment` or `orderCreatePayment` mutation. */
  paymentReferenceId: Scalars['String']['output'];
  /** The status of the payment. */
  status: OrderPaymentStatusResult;
  /** The transaction associated with the payment. */
  transactions: Array<OrderTransaction>;
  /** A translated message describing an error during the asynchronous processing of a payment. */
  translatedErrorMessage?: Maybe<Scalars['String']['output']>;
};

/** The type of a payment status. */
export enum OrderPaymentStatusResult {
  /** The payment is authorized. */
  Authorized = 'AUTHORIZED',
  /** The payment is captured. */
  Captured = 'CAPTURED',
  /** There was an error initiating the payment. */
  Error = 'ERROR',
  /** The payment is awaiting processing. */
  Initiated = 'INITIATED',
  /** The payment is pending with the provider, and may take a while. */
  Pending = 'PENDING',
  /** The payment is still being processed. */
  Processing = 'PROCESSING',
  /** The payment is in purchased status. */
  Purchased = 'PURCHASED',
  /** Redirect required. */
  RedirectRequired = 'REDIRECT_REQUIRED',
  /** The payment is refunded. */
  Refunded = 'REFUNDED',
  /** Payment can be retried. */
  Retryable = 'RETRYABLE',
  /** The payment succeeded. */
  Success = 'SUCCESS',
  /** Status is unknown. */
  Unknown = 'UNKNOWN',
  /** The payment is voided. */
  Voided = 'VOIDED'
}

/**
 * The order's aggregated return status that's used for display purposes.
 * An order might have multiple returns, so this field communicates the prioritized return status.
 * The `OrderReturnStatus` enum is a supported filter parameter in the [`orders` query](https://shopify.dev/api/admin-graphql/latest/queries/orders#:~:text=reference_location_id-,return_status,-risk_level).
 */
export enum OrderReturnStatus {
  /** All return shipments from a return in this order were inspected. */
  InspectionComplete = 'INSPECTION_COMPLETE',
  /** Some items in the order are being returned. */
  InProgress = 'IN_PROGRESS',
  /** No items in the order were returned. */
  NoReturn = 'NO_RETURN',
  /** Some items in the order were returned. */
  Returned = 'RETURNED',
  /** Some returns in the order were not completed successfully. */
  ReturnFailed = 'RETURN_FAILED',
  /** A return was requested for some items in the order. */
  ReturnRequested = 'RETURN_REQUESTED'
}

/** Represents a fraud check on an order. This object is deprecated in favor of [OrderRiskAssessment](https://shopify.dev/api/admin-graphql/latest/objects/OrderRiskAssessment) and its enhanced capabilities. */
export type OrderRisk = {
  __typename?: 'OrderRisk';
  /**
   * Whether the risk level is shown in the Shopify admin. If false, then this order risk is ignored when Shopify determines the overall risk level for the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.facts.
   */
  display: Scalars['Boolean']['output'];
  /**
   * The likelihood that an order is fraudulent, based on this order risk. The level can be set by Shopify risk analysis or by an app.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.riskLevel which allows for more granular risk levels, including PENDING and NONE.
   */
  level?: Maybe<OrderRiskLevel>;
  /**
   * The risk message that's shown to the merchant in the Shopify admin.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.facts.
   */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * A risk assessment for an order.
 *
 * See the [example query "Retrieve order risk assessments"](https://shopify.dev/docs/api/admin-graphql/unstable/queries/order?example=retrieve-order-risk-assessments).
 */
export type OrderRiskAssessment = {
  __typename?: 'OrderRiskAssessment';
  /**
   * Facts included with the risk assessment. Fact values are specific to the provider.
   * See the [examples for the mutation orderRiskAssessmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/orderRiskAssessmentCreate#section-examples).
   */
  facts: Array<RiskFact>;
  /** The app that provided the assessment, `null` if the assessment was provided by Shopify. */
  provider?: Maybe<App>;
  /** The risk level assigned to the order. */
  riskLevel: RiskAssessmentResult;
};

/** The input fields for creating an order risk assessment. */
export type OrderRiskAssessmentCreateInput = {
  /** Facts to include with the risk assessment. Up to 20 facts can be provided. */
  facts: Array<OrderRiskAssessmentFactInput>;
  /** The ID of the order to assess. */
  orderId: Scalars['ID']['input'];
  /** The risk level assigned to the order. */
  riskLevel: RiskAssessmentResult;
};

/** Return type for `orderRiskAssessmentCreate` mutation. */
export type OrderRiskAssessmentCreatePayload = {
  __typename?: 'OrderRiskAssessmentCreatePayload';
  /** The created risk assessment. */
  orderRiskAssessment?: Maybe<OrderRiskAssessment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OrderRiskAssessmentCreateUserError>;
};

/** An error that occurs during the execution of `OrderRiskAssessmentCreate`. */
export type OrderRiskAssessmentCreateUserError = DisplayableError & {
  __typename?: 'OrderRiskAssessmentCreateUserError';
  /** The error code. */
  code?: Maybe<OrderRiskAssessmentCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `OrderRiskAssessmentCreateUserError`. */
export enum OrderRiskAssessmentCreateUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The order is marked as fulfilled and can no longer accept new order risk assessments. */
  OrderAlreadyFulfilled = 'ORDER_ALREADY_FULFILLED',
  /** More than 20 facts were provided for the order risk assessment. */
  TooManyFacts = 'TOO_MANY_FACTS'
}

/** The input fields for a risk assessment fact. */
export type OrderRiskAssessmentFactInput = {
  /** Descriptions longer than 256 characters are truncated. */
  description: Scalars['String']['input'];
  /** Indicates whether the fact contributes negatively, neutrally, or positively to risk. */
  sentiment: RiskFactSentiment;
};

/**
 * The likelihood that an order is fraudulent.
 * This enum is deprecated in favor of
 * [RiskAssessmentResult](https://shopify.dev/api/admin-graphql/latest/enums/RiskAssessmentResult)
 * which allows for more granular risk levels, including PENDING and NONE.
 */
export enum OrderRiskLevel {
  /** There is a high level of risk that this order is fraudulent. */
  High = 'HIGH',
  /** There is a low level of risk that this order is fraudulent. */
  Low = 'LOW',
  /** There is a medium level of risk that this order is fraudulent. */
  Medium = 'MEDIUM'
}

/** Possible recommendations for an order. */
export enum OrderRiskRecommendationResult {
  /** Recommends fulfilling the order. */
  Accept = 'ACCEPT',
  /** Recommends cancelling the order. */
  Cancel = 'CANCEL',
  /** Recommends investigating the order by contacting buyers. */
  Investigate = 'INVESTIGATE',
  /** There is no recommended action for the order. */
  None = 'NONE'
}

/**
 * Summary of risk characteristics for an order.
 *
 * See the [example query "Retrieve order risk assessments"](https://shopify.dev/docs/api/admin-graphql/unstable/queries/order?example=retrieve-order-risk-assessments).
 */
export type OrderRiskSummary = {
  __typename?: 'OrderRiskSummary';
  /** The risk assessments for the order. */
  assessments: Array<OrderRiskAssessment>;
  /** The recommended action for the order based on its risk assessments. */
  recommendation: OrderRiskRecommendationResult;
};

/** The set of valid sort keys for the Order query. */
export enum OrderSortKeys {
  /** Sorts by the date and time the order was created. */
  CreatedAt = 'CREATED_AT',
  /** Sorts by the current total price of an order in the shop currency, including any returns/refunds/removals. */
  CurrentTotalPrice = 'CURRENT_TOTAL_PRICE',
  /** Sorts by the customer's name. */
  CustomerName = 'CUSTOMER_NAME',
  /** Sort by shipping address to analyze regional sales patterns or plan logistics. */
  Destination = 'DESTINATION',
  /** Sorts by the financial status of the order. */
  FinancialStatus = 'FINANCIAL_STATUS',
  /** Sorts by the order's fulfillment status. */
  FulfillmentStatus = 'FULFILLMENT_STATUS',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sorts by the order number. */
  OrderNumber = 'ORDER_NUMBER',
  /** Sort by the purchase order number to match external procurement systems or track recent orders. */
  PoNumber = 'PO_NUMBER',
  /** Sorts by the date and time the order was processed. */
  ProcessedAt = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the total quantity of all line items to identify large purchases or analyze inventory demand patterns. */
  TotalItemsQuantity = 'TOTAL_ITEMS_QUANTITY',
  /** Sorts by the total sold price of an order in the shop currency, excluding any returns/refunds/removals. */
  TotalPrice = 'TOTAL_PRICE',
  /** Sorts by the date and time the order was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** A change that has been applied to an order. */
export type OrderStagedChange = OrderStagedChangeAddCustomItem | OrderStagedChangeAddLineItemDiscount | OrderStagedChangeAddShippingLine | OrderStagedChangeAddVariant | OrderStagedChangeDecrementItem | OrderStagedChangeIncrementItem | OrderStagedChangeRemoveDiscount | OrderStagedChangeRemoveShippingLine;

/**
 * A change to the order representing the addition of a
 * custom line item. For example, you might want to add gift wrapping service
 * as a custom line item.
 */
export type OrderStagedChangeAddCustomItem = {
  __typename?: 'OrderStagedChangeAddCustomItem';
  /** The price of an individual item without any discounts applied. This value can't be negative. */
  originalUnitPrice: MoneyV2;
  /** The quantity of the custom item to add to the order. This value must be greater than zero. */
  quantity: Scalars['Int']['output'];
  /** The title of the custom item. */
  title: Scalars['String']['output'];
};

/** The discount applied to an item that was added during the current order edit. */
export type OrderStagedChangeAddLineItemDiscount = {
  __typename?: 'OrderStagedChangeAddLineItemDiscount';
  /** The description of the discount. */
  description: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The pricing value of the discount. */
  value: PricingValue;
};

/**
 * A new [shipping line](https://shopify.dev/api/admin-graphql/latest/objects/shippingline)
 * added as part of an order edit.
 */
export type OrderStagedChangeAddShippingLine = {
  __typename?: 'OrderStagedChangeAddShippingLine';
  /** The phone number at the shipping address. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The shipping line's title that's shown to the buyer. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The price that applies to the shipping line. */
  price: MoneyV2;
  /** The title of the shipping line. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A change to the order representing the addition of an existing product variant. */
export type OrderStagedChangeAddVariant = {
  __typename?: 'OrderStagedChangeAddVariant';
  /** The quantity of the product variant that was added. */
  quantity: Scalars['Int']['output'];
  /** The product variant that was added. */
  variant: ProductVariant;
};

/** An auto-generated type for paginating through multiple OrderStagedChanges. */
export type OrderStagedChangeConnection = {
  __typename?: 'OrderStagedChangeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OrderStagedChangeEdge>;
  /** A list of nodes that are contained in OrderStagedChangeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OrderStagedChange>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An removal of items from an existing line item on the order. */
export type OrderStagedChangeDecrementItem = {
  __typename?: 'OrderStagedChangeDecrementItem';
  /** The number of items removed. */
  delta: Scalars['Int']['output'];
  /** The original line item. */
  lineItem: LineItem;
  /** The intention to restock the removed items. */
  restock: Scalars['Boolean']['output'];
};

/** An auto-generated type which holds one OrderStagedChange and a cursor during pagination. */
export type OrderStagedChangeEdge = {
  __typename?: 'OrderStagedChangeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderStagedChangeEdge. */
  node: OrderStagedChange;
};

/** An addition of items to an existing line item on the order. */
export type OrderStagedChangeIncrementItem = {
  __typename?: 'OrderStagedChangeIncrementItem';
  /** The number of items added. */
  delta: Scalars['Int']['output'];
  /** The original line item. */
  lineItem: LineItem;
};

/** A discount application removed during an order edit. */
export type OrderStagedChangeRemoveDiscount = {
  __typename?: 'OrderStagedChangeRemoveDiscount';
  /** The removed discount application. */
  discountApplication: DiscountApplication;
};

/** A shipping line removed during an order edit. */
export type OrderStagedChangeRemoveShippingLine = {
  __typename?: 'OrderStagedChangeRemoveShippingLine';
  /** The removed shipping line. */
  shippingLine: ShippingLine;
};

/**
 * The `OrderTransaction` object represents a payment transaction that's associated with an order. An order
 * transaction is a specific action or event that happens within the context of an order, such as a customer paying
 * for a purchase or receiving a refund, or other payment-related activity.
 *
 * Use the `OrderTransaction` object to capture the complete lifecycle of a payment, from initial
 * authorization to final settlement, including refunds and currency exchanges. Common use cases for using the
 * `OrderTransaction` object include:
 *
 * - Processing new payments for orders
 * - Managing payment authorizations and captures
 * - Processing refunds for returned items
 * - Tracking payment status and errors
 * - Managing multi-currency transactions
 * - Handling payment gateway integrations
 *
 * Each `OrderTransaction` object has a [`kind`](https://shopify.dev/docs/api/admin-graphql/latest/enums/OrderTransactionKind)
 * that defines the type of transaction and a [`status`](https://shopify.dev/docs/api/admin-graphql/latest/enums/OrderTransactionStatus)
 * that indicates the current state of the transaction. The object stores detailed information about payment
 * methods, gateway processing, and settlement details.
 *
 * Learn more about [payment processing](https://help.shopify.com/manual/payments)
 * and [payment gateway integrations](https://www.shopify.com/ca/payment-gateways).
 */
export type OrderTransaction = Node & {
  __typename?: 'OrderTransaction';
  /** The masked account number associated with the payment method. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of money.
   * @deprecated Use `amountSet` instead.
   */
  amount: Scalars['Money']['output'];
  /** The rounding adjustment applied on the cash amount in shop and presentment currencies. */
  amountRoundingSet?: Maybe<MoneyBag>;
  /** The amount and currency of the transaction in shop and presentment currencies. */
  amountSet: MoneyBag;
  /**
   * The amount and currency of the transaction.
   * @deprecated Use `amountSet` instead.
   */
  amountV2: MoneyV2;
  /**
   * Authorization code associated with the transaction.
   * @deprecated Use `paymentId` instead.
   */
  authorizationCode?: Maybe<Scalars['String']['output']>;
  /** The time when the authorization expires. This field is available only to stores on a Shopify Plus plan. */
  authorizationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** An adjustment on the transaction showing the amount lost or gained  due to fluctuations in the currency exchange rate. */
  currencyExchangeAdjustment?: Maybe<CurrencyExchangeAdjustment>;
  /** The Shopify Point of Sale device used to process the transaction. */
  device?: Maybe<PointOfSaleDevice>;
  /** A standardized error code, independent of the payment provider. */
  errorCode?: Maybe<OrderTransactionErrorCode>;
  /** The transaction fees charged on the order transaction. Only present for Shopify Payments transactions. */
  fees: Array<TransactionFee>;
  /** The human-readable payment gateway name used to process the transaction. */
  formattedGateway?: Maybe<Scalars['String']['output']>;
  /** The payment gateway used to process the transaction. */
  gateway?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The kind of transaction. */
  kind: OrderTransactionKind;
  /** The physical location where the transaction was processed. */
  location?: Maybe<Location>;
  /** Whether the transaction is processed by manual payment gateway. */
  manualPaymentGateway: Scalars['Boolean']['output'];
  /** Whether the transaction can be manually captured. */
  manuallyCapturable: Scalars['Boolean']['output'];
  /**
   * Specifies the available amount to refund on the gateway.
   * This value is only available for transactions of type `SuggestedRefund`.
   * @deprecated Use `maximumRefundableV2` instead.
   */
  maximumRefundable?: Maybe<Scalars['Money']['output']>;
  /**
   * Specifies the available amount with currency to refund on the gateway.
   * This value is only available for transactions of type `SuggestedRefund`.
   */
  maximumRefundableV2?: Maybe<MoneyV2>;
  /** Whether the transaction can be captured multiple times. */
  multiCapturable: Scalars['Boolean']['output'];
  /** The associated order. */
  order?: Maybe<Order>;
  /** The associated parent transaction, for example the authorization of a capture. */
  parentTransaction?: Maybe<OrderTransaction>;
  /** The payment details for the transaction. */
  paymentDetails?: Maybe<PaymentDetails>;
  /** The payment icon to display for the transaction. */
  paymentIcon?: Maybe<Image>;
  /** The payment ID associated with the transaction. */
  paymentId?: Maybe<Scalars['String']['output']>;
  /**
   * The payment method used for the transaction. This value is `null` if the payment method is unknown.
   * @deprecated Use `paymentIcon` instead.
   */
  paymentMethod?: Maybe<PaymentMethods>;
  /** Date and time when the transaction was processed. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The transaction receipt that the payment gateway attaches to the transaction.
   * > **Note:** This field is **gateway-specific** and **not a stable contract**.
   * > Its structure and contents can vary by payment gateway and may change without notice.
   * > Apps **shouldn't parse or rely on this field for business logic**; prefer typed fields on `OrderTransaction` and related objects.
   */
  receiptJson?: Maybe<Scalars['JSON']['output']>;
  /** The settlement currency. */
  settlementCurrency?: Maybe<CurrencyCode>;
  /** The rate used when converting the transaction amount to settlement currency. */
  settlementCurrencyRate?: Maybe<Scalars['Decimal']['output']>;
  /** Contains all Shopify Payments information related to an order transaction. This field is available only to stores on a Shopify Plus plan. */
  shopifyPaymentsSet?: Maybe<ShopifyPaymentsTransactionSet>;
  /** The status of this transaction. */
  status: OrderTransactionStatus;
  /** Whether the transaction is a test transaction. */
  test: Scalars['Boolean']['output'];
  /**
   * The amount of the original authorization that remains unsettled.
   * During a pending capture, this reflects the full outstanding balance including the pending amount.
   * When no capture is pending, this equals the capturable amount.
   * Only available when an amount is capturable or manually marked as paid.
   * @deprecated Use `totalUnsettledSet` instead.
   */
  totalUnsettled?: Maybe<Scalars['Money']['output']>;
  /**
   * The amount of the original authorization that remains unsettled, in shop and presentment currencies.
   * During a pending capture, this reflects the full outstanding balance including the pending amount.
   * When no capture is pending, this equals the capturable amount.
   * Only available when an amount is capturable or manually marked as paid.
   */
  totalUnsettledSet?: Maybe<MoneyBag>;
  /**
   * The amount with currency of the original authorization that remains unsettled.
   * During a pending capture, this reflects the full outstanding balance including the pending amount.
   * When no capture is pending, this equals the capturable amount.
   * Only available when an amount is capturable or manually marked as paid.
   * @deprecated Use `totalUnsettledSet` instead.
   */
  totalUnsettledV2?: Maybe<MoneyV2>;
  /** Staff member who was logged into the Shopify POS device when the transaction was processed. */
  user?: Maybe<StaffMember>;
};

/** An auto-generated type for paginating through multiple OrderTransactions. */
export type OrderTransactionConnection = {
  __typename?: 'OrderTransactionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<OrderTransactionEdge>;
  /** A list of nodes that are contained in OrderTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<OrderTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one OrderTransaction and a cursor during pagination. */
export type OrderTransactionEdge = {
  __typename?: 'OrderTransactionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderTransactionEdge. */
  node: OrderTransaction;
};

/** A standardized error code, independent of the payment provider. */
export enum OrderTransactionErrorCode {
  /** The payment method was invalid. */
  AmazonPaymentsInvalidPaymentMethod = 'AMAZON_PAYMENTS_INVALID_PAYMENT_METHOD',
  /** The maximum amount has been captured. */
  AmazonPaymentsMaxAmountCharged = 'AMAZON_PAYMENTS_MAX_AMOUNT_CHARGED',
  /** The maximum amount has been refunded. */
  AmazonPaymentsMaxAmountRefunded = 'AMAZON_PAYMENTS_MAX_AMOUNT_REFUNDED',
  /** The maximum of 10 authorizations has been captured for an order. */
  AmazonPaymentsMaxAuthorizationsCaptured = 'AMAZON_PAYMENTS_MAX_AUTHORIZATIONS_CAPTURED',
  /** The maximum of 10 refunds has been processed for an order. */
  AmazonPaymentsMaxRefundsProcessed = 'AMAZON_PAYMENTS_MAX_REFUNDS_PROCESSED',
  /** The order was canceled, which canceled all open authorizations. */
  AmazonPaymentsOrderReferenceCanceled = 'AMAZON_PAYMENTS_ORDER_REFERENCE_CANCELED',
  /** The order was not confirmed within three hours. */
  AmazonPaymentsStale = 'AMAZON_PAYMENTS_STALE',
  /** The transaction amount exceeds the maximum amount allowed. */
  AmountTooLarge = 'AMOUNT_TOO_LARGE',
  /** The transaction amount is below the minimum amount allowed. */
  AmountTooSmall = 'AMOUNT_TOO_SMALL',
  /** The 3D Secure authentication failed. */
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  /** The transaction requires 3D Secure authentication but was attempted without authentication. */
  AuthenticationRequired = 'AUTHENTICATION_REQUIRED',
  /** The authorization has expired. */
  AuthorizationExpired = 'AUTHORIZATION_EXPIRED',
  /** The issuer declined the transaction, the customer should contact their issuer for more details. */
  CallIssuer = 'CALL_ISSUER',
  /** The transaction was cancelled. */
  CancelledPayment = 'CANCELLED_PAYMENT',
  /** The card was declined. */
  CardDeclined = 'CARD_DECLINED',
  /** The transaction was declined due to suspected card testing activity. */
  CardTesting = 'CARD_TESTING',
  /** There is an error in the gateway or merchant configuration. */
  ConfigError = 'CONFIG_ERROR',
  /** The issuer declined the transaction without providing a specific reason. */
  DoNotHonor = 'DO_NOT_HONOR',
  /** The card is expired. */
  ExpiredCard = 'EXPIRED_CARD',
  /** The transaction was declined due to suspected fraudulent activity. */
  FraudSuspected = 'FRAUD_SUSPECTED',
  /** There was an unknown error with processing the payment. */
  GenericError = 'GENERIC_ERROR',
  /** The address is incorrect. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The card security code (CVC/CVV) is incorrect. */
  IncorrectCvc = 'INCORRECT_CVC',
  /** The card number is incorrect. */
  IncorrectNumber = 'INCORRECT_NUMBER',
  /** The PIN entered is incorrect. */
  IncorrectPin = 'INCORRECT_PIN',
  /** The ZIP or postal code doesn't match the one on file. */
  IncorrectZip = 'INCORRECT_ZIP',
  /** The payment instrument was declined. */
  InstrumentDeclined = 'INSTRUMENT_DECLINED',
  /** There are insufficient funds available to complete the transaction. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The amount is invalid. */
  InvalidAmount = 'INVALID_AMOUNT',
  /** The payment method is not available in the customer's country. */
  InvalidCountry = 'INVALID_COUNTRY',
  /** The currency isn't supported. */
  InvalidCurrency = 'INVALID_CURRENCY',
  /** The format of the CVC is incorrect. */
  InvalidCvc = 'INVALID_CVC',
  /** The format of the expiry date is incorrect. */
  InvalidExpiryDate = 'INVALID_EXPIRY_DATE',
  /** The format of the card number is incorrect. */
  InvalidNumber = 'INVALID_NUMBER',
  /** The payment method is invalid or not found. */
  InvalidPaymentMethod = 'INVALID_PAYMENT_METHOD',
  /** This payment method doesn't support the requested transaction type. */
  InvalidPurchaseType = 'INVALID_PURCHASE_TYPE',
  /** The transaction couldn't be processed due to an issue with the merchant account. */
  MerchantAccountError = 'MERCHANT_ACCOUNT_ERROR',
  /** The transaction was blocked due to the merchant's custom payment risk rule. */
  MerchantRule = 'MERCHANT_RULE',
  /** The payment method is momentarily unavailable. */
  PaymentMethodUnavailable = 'PAYMENT_METHOD_UNAVAILABLE',
  /** The payment method isn't supported. */
  PaymentMethodUnsupported = 'PAYMENT_METHOD_UNSUPPORTED',
  /** The transaction couldn't be processed due to an unexpected error with the payment provider. */
  PaymentProviderError = 'PAYMENT_PROVIDER_ERROR',
  /** The card has been reported as lost or stolen, and the card issuer has requested that the merchant keep the card and call the number on the back. */
  PickUpCard = 'PICK_UP_CARD',
  /** There was an error while processing the payment. */
  ProcessingError = 'PROCESSING_ERROR',
  /** The transaction retry attempt was declined. */
  RetryDeclined = 'RETRY_DECLINED',
  /** A real card was used but the gateway was in test mode. */
  TestModeLiveCard = 'TEST_MODE_LIVE_CARD',
  /** The payment instrument has exceeded the processing frequency limit. */
  TransactionLimitExceeded = 'TRANSACTION_LIMIT_EXCEEDED',
  /** The gateway or merchant configuration doesn't support a feature, such as network tokenization. */
  UnsupportedFeature = 'UNSUPPORTED_FEATURE'
}

/** The input fields for the information needed to create an order transaction. */
export type OrderTransactionInput = {
  /** The amount of money for this transaction. */
  amount: Scalars['Money']['input'];
  /** The payment gateway to use for this transaction. */
  gateway: Scalars['String']['input'];
  /** The kind of transaction. */
  kind: OrderTransactionKind;
  /** The ID of the order associated with the transaction. */
  orderId: Scalars['ID']['input'];
  /** The ID of the optional parent transaction, for example the authorization of a capture. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** The different kinds of order transactions. */
export enum OrderTransactionKind {
  /**
   * An amount reserved against the cardholder's funding source.
   * Money does not change hands until the authorization is captured.
   */
  Authorization = 'AUTHORIZATION',
  /** A transfer of the money that was reserved by an authorization. */
  Capture = 'CAPTURE',
  /** The money returned to the customer when they've paid too much during a cash transaction. */
  Change = 'CHANGE',
  /** An authorization for a payment taken with an EMV credit card reader. */
  EmvAuthorization = 'EMV_AUTHORIZATION',
  /**
   * A partial or full return of captured funds to the cardholder.
   * A refund can happen only after a capture is processed.
   */
  Refund = 'REFUND',
  /** An authorization and capture performed together in a single step. */
  Sale = 'SALE',
  /** A suggested refund transaction that can be used to create a refund. */
  SuggestedRefund = 'SUGGESTED_REFUND',
  /** A cancelation of an authorization transaction. */
  Void = 'VOID'
}

/** The different states that an `OrderTransaction` can have. */
export enum OrderTransactionStatus {
  /** Awaiting a response. */
  AwaitingResponse = 'AWAITING_RESPONSE',
  /** There was an error while processing the transaction. */
  Error = 'ERROR',
  /** The transaction failed. */
  Failure = 'FAILURE',
  /** The transaction is pending. */
  Pending = 'PENDING',
  /** The transaction succeeded. */
  Success = 'SUCCESS',
  /** The transaction status is unknown. */
  Unknown = 'UNKNOWN'
}

/** Return type for `orderUpdate` mutation. */
export type OrderUpdatePayload = {
  __typename?: 'OrderUpdatePayload';
  /** The updated order. */
  order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields that describe package information for the shipping label purchase. Exactly one of `customPackage` or `carrierPackage` must be provided. */
export type PackageInfoInput = {
  /** A standard package provided by the carrier. Mutually exclusive with `customPackage`. */
  carrierPackage?: InputMaybe<ShippingCarrierPackageInput>;
  /** A package with custom dimensions and empty-package weight. Mutually exclusive with `carrierPackage`. */
  customPackage?: InputMaybe<ShippingLabelPurchaseCustomPackageInput>;
};

/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type Page = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Navigable & Node & {
  __typename?: 'Page';
  /** The text content of the page, complete with HTML markup. */
  body: Scalars['HTML']['output'];
  /** The first 150 characters of the page body. If the page body contains more than 150 characters, additional characters are truncated by ellipses. */
  bodySummary: Scalars['String']['output'];
  /** The date and time (ISO 8601 format) of the page creation. */
  createdAt: Scalars['DateTime']['output'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /**
   * A unique, human-friendly string for the page.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether or not the page is visible. */
  isPublished: Scalars['Boolean']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /**
   * The date and time (ISO 8601 format) when the page became or will become visible.
   * Returns null when the page isn't visible.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The suffix of the template that's used to render the page. */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /** Title of the page. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The date and time (ISO 8601 format) of the latest page update. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type PageEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type PageMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type PageMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type PageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A standalone content page in the online store. Pages display HTML-formatted content for informational pages like "About Us", contact information, or shipping policies.
 *
 * Each page has a unique handle for URL routing and supports custom template suffixes for specialized layouts. Pages can be published or hidden, and include creation and update timestamps.
 */
export type PageTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** An auto-generated type for paginating through multiple Pages. */
export type PageConnection = {
  __typename?: 'PageConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PageEdge>;
  /** A list of nodes that are contained in PageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Page>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create a page. */
export type PageCreateInput = {
  /** The text content of the page, complete with HTML markup. */
  body?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-friendly string for the page. If no handle is specified, a handle will be generated automatically from the page title.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the page should be visible. Defaults to `true` if no publish date is specified. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input fields to create or update a metafield. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the page should become visible. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default page template is used.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the page. */
  title: Scalars['String']['input'];
};

/** Return type for `pageCreate` mutation. */
export type PageCreatePayload = {
  __typename?: 'PageCreatePayload';
  /** The page that was created. */
  page?: Maybe<Page>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PageCreateUserError>;
};

/** An error that occurs during the execution of `PageCreate`. */
export type PageCreateUserError = DisplayableError & {
  __typename?: 'PageCreateUserError';
  /** The error code. */
  code?: Maybe<PageCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PageCreateUserError`. */
export enum PageCreateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  InvalidPublishDate = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too big. */
  TooBig = 'TOO_BIG',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT'
}

/** Return type for `pageDelete` mutation. */
export type PageDeletePayload = {
  __typename?: 'PageDeletePayload';
  /** The ID of the deleted page. */
  deletedPageId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PageDeleteUserError>;
};

/** An error that occurs during the execution of `PageDelete`. */
export type PageDeleteUserError = DisplayableError & {
  __typename?: 'PageDeleteUserError';
  /** The error code. */
  code?: Maybe<PageDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PageDeleteUserError`. */
export enum PageDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** An auto-generated type which holds one Page and a cursor during pagination. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PageEdge. */
  node: Page;
};

/**
 * Returns information about pagination in a connection, in accordance with the
 * [Relay specification](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo).
 * For more information, please read our [GraphQL Pagination Usage Guide](https://shopify.dev/api/usage/pagination-graphql).
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last node in edges. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more pages to fetch following the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are any pages prior to the current page. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first node in edges. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The set of valid sort keys for the Page query. */
export enum PageSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** The input fields to update a page. */
export type PageUpdateInput = {
  /** The text content of the page, complete with HTML markup. */
  body?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-friendly string for the page. If no handle is specified, a handle will be generated automatically from the page title.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the page should be visible. Defaults to `true` if no publish date is specified. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input fields to create or update a metafield. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the page should become visible. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default page template is used.
   */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the page. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `pageUpdate` mutation. */
export type PageUpdatePayload = {
  __typename?: 'PageUpdatePayload';
  /** The page that was updated. */
  page?: Maybe<Page>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PageUpdateUserError>;
};

/** An error that occurs during the execution of `PageUpdate`. */
export type PageUpdateUserError = DisplayableError & {
  __typename?: 'PageUpdateUserError';
  /** The error code. */
  code?: Maybe<PageUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PageUpdateUserError`. */
export enum PageUpdateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  InvalidPublishDate = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too big. */
  TooBig = 'TOO_BIG',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** A payment customization. */
export type PaymentCustomization = HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'PaymentCustomization';
  /** The enabled status of the payment customization. */
  enabled: Scalars['Boolean']['output'];
  /** The error history on the most recent version of the payment customization. */
  errorHistory?: Maybe<FunctionsErrorHistory>;
  /** The ID of the Shopify Function implementing the payment customization. */
  functionId: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The Shopify Function implementing the payment customization. */
  shopifyFunction: ShopifyFunction;
  /** The title of the payment customization. */
  title: Scalars['String']['output'];
};


/** A payment customization. */
export type PaymentCustomizationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/** A payment customization. */
export type PaymentCustomizationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A payment customization. */
export type PaymentCustomizationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `paymentCustomizationActivation` mutation. */
export type PaymentCustomizationActivationPayload = {
  __typename?: 'PaymentCustomizationActivationPayload';
  /** The IDs of the updated payment customizations. */
  ids?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentCustomizationError>;
};

/** An auto-generated type for paginating through multiple PaymentCustomizations. */
export type PaymentCustomizationConnection = {
  __typename?: 'PaymentCustomizationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PaymentCustomizationEdge>;
  /** A list of nodes that are contained in PaymentCustomizationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PaymentCustomization>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `paymentCustomizationCreate` mutation. */
export type PaymentCustomizationCreatePayload = {
  __typename?: 'PaymentCustomizationCreatePayload';
  /** Returns the created payment customization. */
  paymentCustomization?: Maybe<PaymentCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentCustomizationError>;
};

/** Return type for `paymentCustomizationDelete` mutation. */
export type PaymentCustomizationDeletePayload = {
  __typename?: 'PaymentCustomizationDeletePayload';
  /** Returns the deleted payment customization ID. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentCustomizationError>;
};

/** An auto-generated type which holds one PaymentCustomization and a cursor during pagination. */
export type PaymentCustomizationEdge = {
  __typename?: 'PaymentCustomizationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PaymentCustomizationEdge. */
  node: PaymentCustomization;
};

/** An error that occurs during the execution of a payment customization mutation. */
export type PaymentCustomizationError = DisplayableError & {
  __typename?: 'PaymentCustomizationError';
  /** The error code. */
  code?: Maybe<PaymentCustomizationErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentCustomizationError`. */
export enum PaymentCustomizationErrorCode {
  /** Shop plan not eligible to use Functions from a custom app. */
  CustomAppFunctionNotEligible = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Function does not implement the required interface. */
  FunctionDoesNotImplement = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function ID cannot be changed. */
  FunctionIdCannotBeChanged = 'FUNCTION_ID_CANNOT_BE_CHANGED',
  /** Function not found. */
  FunctionNotFound = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FunctionPendingDeletion = 'FUNCTION_PENDING_DELETION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Could not create or update metafields. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** Maximum payment customizations are already enabled. */
  MaximumActivePaymentCustomizations = 'MAXIMUM_ACTIVE_PAYMENT_CUSTOMIZATIONS',
  /** The maximum number of payment customizations per shop has been reached. */
  MaximumPaymentCustomizations = 'MAXIMUM_PAYMENT_CUSTOMIZATIONS',
  /** Either function_id or function_handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function_id or function_handle can be provided, not both. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS',
  /** Shop must be on a Shopify Plus plan to activate payment customizations from a custom app. */
  PaymentCustomizationFunctionNotEligible = 'PAYMENT_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE',
  /** Payment customization not found. */
  PaymentCustomizationNotFound = 'PAYMENT_CUSTOMIZATION_NOT_FOUND',
  /** Required input field must be present. */
  RequiredInputField = 'REQUIRED_INPUT_FIELD'
}

/** The input fields to create and update a payment customization. */
export type PaymentCustomizationInput = {
  /** The enabled status of the payment customization. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Function handle scoped to your app ID. */
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  /** Additional metafields to associate to the payment customization. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The title of the payment customization. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `paymentCustomizationUpdate` mutation. */
export type PaymentCustomizationUpdatePayload = {
  __typename?: 'PaymentCustomizationUpdatePayload';
  /** Returns the updated payment customization. */
  paymentCustomization?: Maybe<PaymentCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentCustomizationError>;
};

/** Payment details related to a transaction. */
export type PaymentDetails = CardPaymentDetails | LocalPaymentMethodsPaymentDetails | PaypalWalletPaymentDetails | ShopPayInstallmentsPaymentDetails;

/** All possible instrument outputs for Payment Mandates. */
export type PaymentInstrument = BankAccount | VaultCreditCard | VaultPaypalBillingAgreement;

/**
 * A payment instrument and the permission
 * the owner of the instrument gives to the merchant to debit it.
 */
export type PaymentMandate = Node & {
  __typename?: 'PaymentMandate';
  /** The unique ID of a payment mandate. */
  id: Scalars['ID']['output'];
  /** The outputs details of the payment instrument. */
  paymentInstrument: PaymentInstrument;
};

/**
 * A payment mandate with resource information, representing the permission
 * the owner of the payment instrument gives to the merchant to debit it
 * for specific resources (e.g., Order, Subscriptions).
 */
export type PaymentMandateResource = {
  __typename?: 'PaymentMandateResource';
  /** The unique ID of the payment mandate. Matches the corresponding `CustomerPaymentMethod.id` token, so partners can identify which payment method to use for a given mandate scope (e.g., SUBSCRIPTIONS). */
  id: Scalars['ID']['output'];
  /** The ID of the resource that this payment method was created for. */
  resourceId?: Maybe<Scalars['ID']['output']>;
  /** The resource type that this payment method was created for (e.g., Order, Subscriptions). */
  resourceType?: Maybe<MandateResourceType>;
};

/** An auto-generated type for paginating through multiple PaymentMandateResources. */
export type PaymentMandateResourceConnection = {
  __typename?: 'PaymentMandateResourceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PaymentMandateResourceEdge>;
  /** A list of nodes that are contained in PaymentMandateResourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PaymentMandateResource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one PaymentMandateResource and a cursor during pagination. */
export type PaymentMandateResourceEdge = {
  __typename?: 'PaymentMandateResourceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PaymentMandateResourceEdge. */
  node: PaymentMandateResource;
};

/** Some of the payment methods used in Shopify. */
export enum PaymentMethods {
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** The payment method for Bancontact payment. */
  Bancontact = 'BANCONTACT',
  Bitcoin = 'BITCOIN',
  Bogus = 'BOGUS',
  /** The payment method for Cartes Bancaires payment. */
  CartesBancaires = 'CARTES_BANCAIRES',
  Dankort = 'DANKORT',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Dogecoin = 'DOGECOIN',
  /** The payment method for eftpos_au payment. */
  Eftpos = 'EFTPOS',
  /** The payment method for Elo payment. */
  Elo = 'ELO',
  Forbrugsforeningen = 'FORBRUGSFORENINGEN',
  /** The payment method for Interac payment. */
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Litecoin = 'LITECOIN',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Paypal = 'PAYPAL',
  /** The payment method for UnionPay payment. */
  Unionpay = 'UNIONPAY',
  Visa = 'VISA'
}

/** Return type for `paymentReminderSend` mutation. */
export type PaymentReminderSendPayload = {
  __typename?: 'PaymentReminderSendPayload';
  /** Whether the payment reminder email was successfully sent. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentReminderSendUserError>;
};

/** An error that occurs during the execution of `PaymentReminderSend`. */
export type PaymentReminderSendUserError = DisplayableError & {
  __typename?: 'PaymentReminderSendUserError';
  /** The error code. */
  code?: Maybe<PaymentReminderSendUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentReminderSendUserError`. */
export enum PaymentReminderSendUserErrorCode {
  /** An error occurred while sending the payment reminder. */
  PaymentReminderSendUnsuccessful = 'PAYMENT_REMINDER_SEND_UNSUCCESSFUL'
}

/** Represents the payment schedule for a single payment defined in the payment terms. */
export type PaymentSchedule = Node & {
  __typename?: 'PaymentSchedule';
  /**
   * Amount owed for this payment schedule.
   * @deprecated Use `balanceDue`, `totalBalance`, or `Order.totalOutstandingSet` instead.
   */
  amount: MoneyV2;
  /** Remaining balance to be captured for this payment schedule. */
  balanceDue: MoneyV2;
  /** Date and time when the payment schedule is paid or fulfilled. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the payment schedule is due. */
  due: Scalars['Boolean']['output'];
  /** Date and time when the payment schedule is due. */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Date and time when the invoice is sent. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The payment terms the payment schedule belongs to. */
  paymentTerms: PaymentTerms;
  /** Remaining balance to be paid or authorized by the customer for this payment schedule. */
  totalBalance: MoneyV2;
};

/** Return type for `paymentScheduleCapture` mutation. */
export type PaymentScheduleCapturePayload = {
  __typename?: 'PaymentScheduleCapturePayload';
  /** The async job used for charging the payment. */
  job?: Maybe<Job>;
  /** The job result for tracking the status of the payment capture. */
  jobResult?: Maybe<OrderCreateMandatePaymentJobResult>;
  /** The unique ID for the created payment. */
  paymentReferenceId?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentScheduleCaptureUserError>;
};

/** An error that occurs during the execution of `PaymentScheduleCapture`. */
export type PaymentScheduleCaptureUserError = DisplayableError & {
  __typename?: 'PaymentScheduleCaptureUserError';
  /** The error code. */
  code?: Maybe<PaymentScheduleCaptureUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentScheduleCaptureUserError`. */
export enum PaymentScheduleCaptureUserErrorCode {
  /** Errors for capturing a scheduled payment. */
  PaymentScheduleCaptureErrorCode = 'PAYMENT_SCHEDULE_CAPTURE_ERROR_CODE'
}

/** An auto-generated type for paginating through multiple PaymentSchedules. */
export type PaymentScheduleConnection = {
  __typename?: 'PaymentScheduleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PaymentScheduleEdge>;
  /** A list of nodes that are contained in PaymentScheduleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PaymentSchedule>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one PaymentSchedule and a cursor during pagination. */
export type PaymentScheduleEdge = {
  __typename?: 'PaymentScheduleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PaymentScheduleEdge. */
  node: PaymentSchedule;
};

/** The input fields used to create a payment schedule for payment terms. */
export type PaymentScheduleInput = {
  /** Specifies the date and time when the payment schedule is due. This field must be provided for fixed type payment terms. */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Specifies the date and time that the payment schedule was issued. This field must be provided for net type payment terms. */
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Settings related to payments. */
export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  /** List of the digital wallets which the shop supports. */
  supportedDigitalWallets: Array<DigitalWallet>;
};

/**
 * Payment conditions for an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) or [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder), including when payment is due and how it's scheduled. Payment terms are created from templates that specify net terms (payment due after a certain number of days) or fixed schedules with specific due dates. You can optionally provide custom payment schedules using [`PaymentScheduleInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/PaymentScheduleInput).
 *
 * Each payment term contains one or more [`PaymentSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentSchedule), which you can access through the [`paymentSchedules`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms#field-PaymentTerms.fields.paymentSchedules) field. Payment schedules contain detailed information for each payment installment.
 *
 * Learn more about [payment terms](https://shopify.dev/docs/apps/build/checkout/payments/payment-terms).
 */
export type PaymentTerms = Node & {
  __typename?: 'PaymentTerms';
  /** The draft order associated with the payment terms. */
  draftOrder?: Maybe<DraftOrder>;
  /** Whether payment terms have a payment schedule that's due. */
  due: Scalars['Boolean']['output'];
  /** Duration of payment terms in days based on the payment terms template used to create the payment terms. */
  dueInDays?: Maybe<Scalars['Int']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The order associated with the payment terms. */
  order?: Maybe<Order>;
  /** Whether the payment terms have overdue payment schedules. */
  overdue: Scalars['Boolean']['output'];
  /** List of schedules for the payment terms. */
  paymentSchedules: PaymentScheduleConnection;
  /** The name of the payment terms template used to create the payment terms. */
  paymentTermsName: Scalars['String']['output'];
  /** The payment terms template type used to create the payment terms. */
  paymentTermsType: PaymentTermsType;
  /** The payment terms name, translated into the shop admin's preferred language. */
  translatedName: Scalars['String']['output'];
};


/**
 * Payment conditions for an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) or [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder), including when payment is due and how it's scheduled. Payment terms are created from templates that specify net terms (payment due after a certain number of days) or fixed schedules with specific due dates. You can optionally provide custom payment schedules using [`PaymentScheduleInput`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/PaymentScheduleInput).
 *
 * Each payment term contains one or more [`PaymentSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentSchedule), which you can access through the [`paymentSchedules`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms#field-PaymentTerms.fields.paymentSchedules) field. Payment schedules contain detailed information for each payment installment.
 *
 * Learn more about [payment terms](https://shopify.dev/docs/apps/build/checkout/payments/payment-terms).
 */
export type PaymentTermsPaymentSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields used to create a payment terms. */
export type PaymentTermsCreateInput = {
  /** Specifies the payment schedules for the payment terms. */
  paymentSchedules?: InputMaybe<Array<PaymentScheduleInput>>;
  /** Specifies the payment terms template ID used to generate payment terms. */
  paymentTermsTemplateId: Scalars['ID']['input'];
};

/** Return type for `paymentTermsCreate` mutation. */
export type PaymentTermsCreatePayload = {
  __typename?: 'PaymentTermsCreatePayload';
  /** The created payment terms. */
  paymentTerms?: Maybe<PaymentTerms>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentTermsCreateUserError>;
};

/** An error that occurs during the execution of `PaymentTermsCreate`. */
export type PaymentTermsCreateUserError = DisplayableError & {
  __typename?: 'PaymentTermsCreateUserError';
  /** The error code. */
  code?: Maybe<PaymentTermsCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentTermsCreateUserError`. */
export enum PaymentTermsCreateUserErrorCode {
  /** An error occurred while creating payment terms. */
  PaymentTermsCreationUnsuccessful = 'PAYMENT_TERMS_CREATION_UNSUCCESSFUL'
}

/** The input fields used to delete the payment terms. */
export type PaymentTermsDeleteInput = {
  /** The ID of the payment terms being deleted. */
  paymentTermsId: Scalars['ID']['input'];
};

/** Return type for `paymentTermsDelete` mutation. */
export type PaymentTermsDeletePayload = {
  __typename?: 'PaymentTermsDeletePayload';
  /** The deleted payment terms ID. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentTermsDeleteUserError>;
};

/** An error that occurs during the execution of `PaymentTermsDelete`. */
export type PaymentTermsDeleteUserError = DisplayableError & {
  __typename?: 'PaymentTermsDeleteUserError';
  /** The error code. */
  code?: Maybe<PaymentTermsDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentTermsDeleteUserError`. */
export enum PaymentTermsDeleteUserErrorCode {
  /** An error occurred while deleting payment terms. */
  PaymentTermsDeleteUnsuccessful = 'PAYMENT_TERMS_DELETE_UNSUCCESSFUL'
}

/** The input fields to create payment terms. Payment terms set the date that payment is due. */
export type PaymentTermsInput = {
  /** Specifies the payment schedules for the payment terms. */
  paymentSchedules?: InputMaybe<Array<PaymentScheduleInput>>;
  /**
   * Specifies the ID of the payment terms template.
   *         Payment terms templates provide preset configurations to create common payment terms.
   *         Refer to the
   *         [PaymentTermsTemplate](https://shopify.dev/api/admin-graphql/latest/objects/paymenttermstemplate)
   *         object for more details.
   */
  paymentTermsTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents the payment terms template object. */
export type PaymentTermsTemplate = Node & {
  __typename?: 'PaymentTermsTemplate';
  /** The description of the payment terms template. */
  description: Scalars['String']['output'];
  /** The number of days between the issued date and due date if this is the net type of payment terms. */
  dueInDays?: Maybe<Scalars['Int']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the payment terms template. */
  name: Scalars['String']['output'];
  /** The type of the payment terms template. */
  paymentTermsType: PaymentTermsType;
  /** The translated payment terms template name. */
  translatedName: Scalars['String']['output'];
};

/** The type of a payment terms or a payment terms template. */
export enum PaymentTermsType {
  /** The payment terms or payment terms template is a fixed type. It's due on a specified date. */
  Fixed = 'FIXED',
  /** The payment terms or payment terms template is due on fulfillment. */
  Fulfillment = 'FULFILLMENT',
  /** The payment terms or payment terms template is a net type. It's due a number of days after issue. */
  Net = 'NET',
  /** The payment terms or payment terms template is due on receipt. */
  Receipt = 'RECEIPT',
  /** The type of the payment terms or payment terms template is unknown. */
  Unknown = 'UNKNOWN'
}

/** The input fields used to update the payment terms. */
export type PaymentTermsUpdateInput = {
  /** The attributes used to update the payment terms. */
  paymentTermsAttributes: PaymentTermsInput;
  /** The ID of the payment terms being updated. */
  paymentTermsId: Scalars['ID']['input'];
};

/** Return type for `paymentTermsUpdate` mutation. */
export type PaymentTermsUpdatePayload = {
  __typename?: 'PaymentTermsUpdatePayload';
  /** The updated payment terms. */
  paymentTerms?: Maybe<PaymentTerms>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PaymentTermsUpdateUserError>;
};

/** An error that occurs during the execution of `PaymentTermsUpdate`. */
export type PaymentTermsUpdateUserError = DisplayableError & {
  __typename?: 'PaymentTermsUpdateUserError';
  /** The error code. */
  code?: Maybe<PaymentTermsUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PaymentTermsUpdateUserError`. */
export enum PaymentTermsUpdateUserErrorCode {
  /** An error occurred while updating payment terms. */
  PaymentTermsUpdateUnsuccessful = 'PAYMENT_TERMS_UPDATE_UNSUCCESSFUL'
}

/** The set of valid sort keys for the Payout query. */
export enum PayoutSortKeys {
  /** Sort by the `adjustment_gross` value. */
  AdjustmentGross = 'ADJUSTMENT_GROSS',
  /** Sort by the `advance_gross` value. */
  AdvanceGross = 'ADVANCE_GROSS',
  /** Sort by the `amount` value. */
  Amount = 'AMOUNT',
  /** Sort by the `charge_gross` value. */
  ChargeGross = 'CHARGE_GROSS',
  /** Sort by the `duties_gross` value. */
  DutiesGross = 'DUTIES_GROSS',
  /** Sort by the `fee_amount` value. */
  FeeAmount = 'FEE_AMOUNT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `issued_at` value. */
  IssuedAt = 'ISSUED_AT',
  /** Sort by the `refund_gross` value. */
  RefundGross = 'REFUND_GROSS',
  /** Sort by the `shipping_label_gross` value. */
  ShippingLabelGross = 'SHIPPING_LABEL_GROSS',
  /** Sort by the `status` value. */
  Status = 'STATUS'
}

/** Represents a valid PayPal Express subscriptions gateway status. */
export enum PaypalExpressSubscriptionsGatewayStatus {
  /** The status is disabled. */
  Disabled = 'DISABLED',
  /** The status is enabled. */
  Enabled = 'ENABLED',
  /** The status is pending. */
  Pending = 'PENDING'
}

/** PayPal Wallet payment details related to a transaction. */
export type PaypalWalletPaymentDetails = BasePaymentDetails & {
  __typename?: 'PaypalWalletPaymentDetails';
  /** The name of payment method used by the buyer. */
  paymentMethodName?: Maybe<Scalars['String']['output']>;
};

/** A location for in-store pickup. */
export type PickupInStoreLocation = {
  __typename?: 'PickupInStoreLocation';
  /** The code of the pickup location. */
  code: Scalars['String']['output'];
  /** Distance from the buyer to the pickup location. */
  distanceFromBuyer?: Maybe<Distance>;
  /** A unique identifier for this pickup location. */
  handle: Scalars['String']['output'];
  /** Pickup instructions. */
  instructions: Scalars['String']['output'];
  /** The location ID of the pickup location. */
  locationId: Scalars['ID']['output'];
  /** The source of the pickup location. */
  source: Scalars['String']['output'];
  /** Title of the pickup location. */
  title: Scalars['String']['output'];
};

/** Represents a mobile device that Shopify Point of Sale has been installed on. */
export type PointOfSaleDevice = Node & {
  __typename?: 'PointOfSaleDevice';
  /** The currently open payment session for this device. Data is returned only if the device's location has a POS Pro subscription. */
  activePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** The cash drawer that this device is currently assigned to. Data is returned only if the device's location has a POS Pro subscription. */
  cashDrawer?: Maybe<CashDrawer>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Return type for `pointOfSaleDeviceAssignToCashDrawer` mutation. */
export type PointOfSaleDeviceAssignToCashDrawerPayload = {
  __typename?: 'PointOfSaleDeviceAssignToCashDrawerPayload';
  /** The point of sale device. */
  pointOfSaleDevice?: Maybe<PointOfSaleDevice>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PointOfSaleDeviceAssignToCashDrawerUserError>;
};

/** An error that occurs during the execution of `PointOfSaleDeviceAssignToCashDrawer`. */
export type PointOfSaleDeviceAssignToCashDrawerUserError = DisplayableError & {
  __typename?: 'PointOfSaleDeviceAssignToCashDrawerUserError';
  /** The error code. */
  code?: Maybe<PointOfSaleDeviceAssignToCashDrawerUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PointOfSaleDeviceAssignToCashDrawerUserError`. */
export enum PointOfSaleDeviceAssignToCashDrawerUserErrorCode {
  /** The cash drawer was not found. */
  CashDrawerNotFound = 'CASH_DRAWER_NOT_FOUND',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The cash drawer and point of sale device must be in the same location. */
  LocationMismatch = 'LOCATION_MISMATCH',
  /** The point of sale device was not found. */
  PointOfSaleDeviceNotFound = 'POINT_OF_SALE_DEVICE_NOT_FOUND'
}

/** An auto-generated type for paginating through multiple PointOfSaleDevices. */
export type PointOfSaleDeviceConnection = {
  __typename?: 'PointOfSaleDeviceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PointOfSaleDeviceEdge>;
  /** A list of nodes that are contained in PointOfSaleDeviceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PointOfSaleDevice>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one PointOfSaleDevice and a cursor during pagination. */
export type PointOfSaleDeviceEdge = {
  __typename?: 'PointOfSaleDeviceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PointOfSaleDeviceEdge. */
  node: PointOfSaleDevice;
};

/** Tracks the payment activity for a point of sale device. */
export type PointOfSaleDevicePaymentSession = Node & {
  __typename?: 'PointOfSaleDevicePaymentSession';
  /** The activities on the point of sale device payment session. */
  cashActivities: CashActivityConnection;
  /** The cash that was physically counted when the point of sale device payment session was closed. */
  cashCountedAtClose?: Maybe<MoneyV2>;
  /** The cash that was physically counted when the point of sale device payment session was opened. */
  cashCountedAtOpen: MoneyV2;
  /** The cash drawer associated with the point of sale device payment session. The session's sales andcash tracking activity will affect the cash drawer's balance. */
  cashDrawer: CashDrawer;
  /** The amount that the cash drawer balance was adjusted when the session was closed. */
  closingAdjustment?: Maybe<MoneyV2>;
  /** The counted balance of the cash drawer when the point of sale device payment session was closed. */
  closingBalance?: Maybe<MoneyV2>;
  /** The note associated with the point of sale device payment session closing. */
  closingNote?: Maybe<Scalars['String']['output']>;
  /** The staff member who closed the point of sale device payment session. */
  closingStaffMember?: Maybe<StaffMember>;
  /** The time the point of sale device payment session was closed. */
  closingTime?: Maybe<Scalars['DateTime']['output']>;
  /** The currency of the point of sale device payment session. */
  currency: Scalars['String']['output'];
  /** The expected cash when the point of sale device payment session was closed. */
  expectedCashAtClose?: Maybe<MoneyV2>;
  /** The expected balance of the cash drawer when the point of sale device payment session was opened. */
  expectedCashAtOpen: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location associated with the point of sale device payment session. The session's sales and cash tracking activity will contribute to the location's totals. */
  location: Location;
  /** The net cash sales for the point of sale device payment session. */
  netCashSales: MoneyV2;
  /** The net sales for the duration of this session. */
  netSales: MoneyV2;
  /** The note associated with the point of sale device payment session opening. */
  openingNote?: Maybe<Scalars['String']['output']>;
  /** The staff member who opened the point of sale device payment session. */
  openingStaffMember: StaffMember;
  /** The time the point of sale device payment session was opened. */
  openingTime: Scalars['DateTime']['output'];
  /** The point of sale device. */
  pointOfSaleDevice: PointOfSaleDevice;
  /** Whether the point of sale device payment session is open. Payments can't be processed or refunded during a closed session, and the cash drawer balance can't be adjusted or corrected. */
  status: PointOfSaleDevicePaymentSessionStatus;
  /** The total adjustments for the point of sale device payment session. */
  totalAdjustments: MoneyV2;
  /** The total cash refunds for the point of sale device payment session. */
  totalCashRefunds: MoneyV2;
  /** The total cash sales for the point of sale device payment session. */
  totalCashSales: MoneyV2;
  /** The total discrepancy for the point of sale device payment session. */
  totalDiscrepancy: MoneyV2;
  /** The sum of all refunds for the duration of this session. */
  totalRefunds: MoneyV2;
  /** The sum of all sales for the duration of this session. */
  totalSales: MoneyV2;
  /** Whether the point of sale device payment session totals are ready. */
  totalsReady: Scalars['Boolean']['output'];
};


/** Tracks the payment activity for a point of sale device. */
export type PointOfSaleDevicePaymentSessionCashActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  staffMemberId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `pointOfSaleDevicePaymentSessionAdjust` mutation. */
export type PointOfSaleDevicePaymentSessionAdjustPayload = {
  __typename?: 'PointOfSaleDevicePaymentSessionAdjustPayload';
  /** The adjusted point of sale device payment session. */
  pointOfSaleDevicePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `pointOfSaleDevicePaymentSessionClose` mutation. */
export type PointOfSaleDevicePaymentSessionClosePayload = {
  __typename?: 'PointOfSaleDevicePaymentSessionClosePayload';
  /** The closed point of sale device payment session. */
  pointOfSaleDevicePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PointOfSaleDevicePaymentSessionCloseUserError>;
};

/** An error that occurs during the execution of `PointOfSaleDevicePaymentSessionClose`. */
export type PointOfSaleDevicePaymentSessionCloseUserError = DisplayableError & {
  __typename?: 'PointOfSaleDevicePaymentSessionCloseUserError';
  /** The error code. */
  code?: Maybe<PointOfSaleDevicePaymentSessionCloseUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PointOfSaleDevicePaymentSessionCloseUserError`. */
export enum PointOfSaleDevicePaymentSessionCloseUserErrorCode {
  /** The currency code does not match the cash drawer currency. */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** Point of sale device payment session not closed. */
  FailedToCloseSession = 'FAILED_TO_CLOSE_SESSION',
  /** Point of sale device has no cash drawer associated with it. */
  NoCashDrawerAssociated = 'NO_CASH_DRAWER_ASSOCIATED',
  /** Point of sale device payment session not found. */
  PaymentSessionNotFound = 'PAYMENT_SESSION_NOT_FOUND',
  /** Reason code not found. */
  ReasonCodeNotFound = 'REASON_CODE_NOT_FOUND',
  /** Session is already closed. */
  SessionAlreadyClosed = 'SESSION_ALREADY_CLOSED',
  /** Staff member not found. */
  StaffMemberNotFound = 'STAFF_MEMBER_NOT_FOUND',
  /** Time cannot be before session opening time. */
  TimeBeforeSessionOpen = 'TIME_BEFORE_SESSION_OPEN'
}

/** An auto-generated type for paginating through multiple PointOfSaleDevicePaymentSessions. */
export type PointOfSaleDevicePaymentSessionConnection = {
  __typename?: 'PointOfSaleDevicePaymentSessionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PointOfSaleDevicePaymentSessionEdge>;
  /** A list of nodes that are contained in PointOfSaleDevicePaymentSessionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PointOfSaleDevicePaymentSession>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `pointOfSaleDevicePaymentSessionCount` mutation. */
export type PointOfSaleDevicePaymentSessionCountPayload = {
  __typename?: 'PointOfSaleDevicePaymentSessionCountPayload';
  /** The point of sale device payment session after recording the count. */
  pointOfSaleDevicePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PointOfSaleDevicePaymentSessionCountUserError>;
};

/** An error that occurs during the execution of `PointOfSaleDevicePaymentSessionCount`. */
export type PointOfSaleDevicePaymentSessionCountUserError = DisplayableError & {
  __typename?: 'PointOfSaleDevicePaymentSessionCountUserError';
  /** The error code. */
  code?: Maybe<PointOfSaleDevicePaymentSessionCountUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PointOfSaleDevicePaymentSessionCountUserError`. */
export enum PointOfSaleDevicePaymentSessionCountUserErrorCode {
  /** The currency code does not match the cash drawer currency. */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** Point of sale device payment session count not recorded. */
  FailedToRecordCount = 'FAILED_TO_RECORD_COUNT',
  /** Point of sale device has no cash drawer associated with it. */
  NoCashDrawerAssociated = 'NO_CASH_DRAWER_ASSOCIATED',
  /** Point of sale device payment session not found. */
  PaymentSessionNotFound = 'PAYMENT_SESSION_NOT_FOUND',
  /** Reason code not found. */
  ReasonCodeNotFound = 'REASON_CODE_NOT_FOUND',
  /** Session is already closed. */
  SessionAlreadyClosed = 'SESSION_ALREADY_CLOSED',
  /** Staff member not found. */
  StaffMemberNotFound = 'STAFF_MEMBER_NOT_FOUND',
  /** Time cannot be before session opening time. */
  TimeBeforeSessionOpen = 'TIME_BEFORE_SESSION_OPEN'
}

/** An auto-generated type which holds one PointOfSaleDevicePaymentSession and a cursor during pagination. */
export type PointOfSaleDevicePaymentSessionEdge = {
  __typename?: 'PointOfSaleDevicePaymentSessionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PointOfSaleDevicePaymentSessionEdge. */
  node: PointOfSaleDevicePaymentSession;
};

/** Return type for `pointOfSaleDevicePaymentSessionOpen` mutation. */
export type PointOfSaleDevicePaymentSessionOpenPayload = {
  __typename?: 'PointOfSaleDevicePaymentSessionOpenPayload';
  /** The created point of sale device payment session. */
  pointOfSaleDevicePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PointOfSaleDevicePaymentSessionOpenUserError>;
};

/** An error that occurs during the execution of `PointOfSaleDevicePaymentSessionOpen`. */
export type PointOfSaleDevicePaymentSessionOpenUserError = DisplayableError & {
  __typename?: 'PointOfSaleDevicePaymentSessionOpenUserError';
  /** The error code. */
  code?: Maybe<PointOfSaleDevicePaymentSessionOpenUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PointOfSaleDevicePaymentSessionOpenUserError`. */
export enum PointOfSaleDevicePaymentSessionOpenUserErrorCode {
  /** A point of sale device payment session is already open for this point of sale device. */
  AlreadyOpen = 'ALREADY_OPEN',
  /** The currency does not match the currency of the cash drawer. */
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  /** The point of sale device payment session was not created. */
  NotSaved = 'NOT_SAVED',
  /** The point_of_sale_device has no cash drawer associated with it. */
  NoCashDrawerAssociated = 'NO_CASH_DRAWER_ASSOCIATED',
  /** The point of sale device was not found. */
  PointOfSaleDeviceNotFound = 'POINT_OF_SALE_DEVICE_NOT_FOUND',
  /** The reason code was not found. */
  ReasonCodeNotFound = 'REASON_CODE_NOT_FOUND',
  /** The staff member was not found. */
  StaffMemberNotFound = 'STAFF_MEMBER_NOT_FOUND'
}

/** The set of valid sort keys for the PointOfSaleDevicePaymentSession query. */
export enum PointOfSaleDevicePaymentSessionSortKeys {
  /** Sort by the `closing_time` value. */
  ClosingTime = 'CLOSING_TIME',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `opening_time` value. */
  OpeningTime = 'OPENING_TIME'
}

/** The status of the point of sale device payment session. Payments can't be processed or refunded during a closed session, and the cash drawer balance can't be adjusted or corrected. */
export enum PointOfSaleDevicePaymentSessionStatus {
  /** The point of sale device payment session is closed. */
  Closed = 'CLOSED',
  /** The point of sale device payment session is open. */
  Open = 'OPEN'
}

/** The input fields for selecting a preferred shipping rate by carrier and service codes. */
export type PreferredRateSelectionInput = {
  /** The code identifying the carrier for the preferred rate. Examples include `usps`, `ups_shipping`, `dhl_express`, and `canada_post`. */
  carrierCode: Scalars['String']['input'];
  /** The carrier-defined service code for the preferred rate. */
  serviceCode: Scalars['String']['input'];
};

/** The input fields used to include the line items of a specified fulfillment order that should be marked as prepared for pickup by a customer. */
export type PreparedFulfillmentOrderLineItemsInput = {
  /** The ID of the fulfillment order. */
  fulfillmentOrderId: Scalars['ID']['input'];
};

/** Return type for `previewInstall` mutation. */
export type PreviewInstallPayload = {
  __typename?: 'PreviewInstallPayload';
  /** The installed theme. */
  newTheme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PreviewInstallUserError>;
};

/** An error that occurs during the execution of `PreviewInstall`. */
export type PreviewInstallUserError = DisplayableError & {
  __typename?: 'PreviewInstallUserError';
  /** The error code. */
  code?: Maybe<PreviewInstallUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PreviewInstallUserError`. */
export enum PreviewInstallUserErrorCode {
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR'
}

/** How to calculate the parent product variant's price while bulk updating variant relationships. */
export enum PriceCalculationType {
  /** The price of the parent will be the sum of the components price times their quantity. */
  ComponentsSum = 'COMPONENTS_SUM',
  /** The price of the parent will be set to the price provided. */
  Fixed = 'FIXED',
  /** The price of the parent will not be adjusted. */
  None = 'NONE'
}

/** The input fields for updating the price of a parent product variant. */
export type PriceInput = {
  /**
   * The specific type of calculation done to determine the price of the parent variant.
   * The price is calculated during Bundle creation. Updating a component variant won't recalculate the price.
   */
  calculation?: InputMaybe<PriceCalculationType>;
  /** The price of the parent product variant. This will be be used if calcualtion is set to 'FIXED'. */
  price?: InputMaybe<Scalars['Money']['input']>;
};

/**
 * A list that defines pricing for [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). Price lists override default product prices with either fixed prices or percentage-based adjustments.
 *
 * Each price list associates with a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) to determine which customers see the pricing. The catalog's context rules control when the price list applies, such as for specific markets, company locations, or apps.
 *
 * Learn how to [support different pricing models](https://shopify.dev/docs/apps/build/markets/build-catalog).
 */
export type PriceList = Node & {
  __typename?: 'PriceList';
  /** The catalog that the price list is associated with. */
  catalog?: Maybe<Catalog>;
  /** The date and time when the price list was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency for fixed prices associated with this price list. */
  currency: CurrencyCode;
  /** The number of fixed prices on the price list. */
  fixedPricesCount: Scalars['Int']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The unique name of the price list, used as a human-readable identifier. */
  name: Scalars['String']['output'];
  /** Relative adjustments to other prices. */
  parent?: Maybe<PriceListParent>;
  /** A list of prices associated with the price list. */
  prices: PriceListPriceConnection;
  /** A list of quantity rules associated with the price list, ordered by product variants. */
  quantityRules: QuantityRuleConnection;
};


/**
 * A list that defines pricing for [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). Price lists override default product prices with either fixed prices or percentage-based adjustments.
 *
 * Each price list associates with a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) to determine which customers see the pricing. The catalog's context rules control when the price list applies, such as for specific markets, company locations, or apps.
 *
 * Learn how to [support different pricing models](https://shopify.dev/docs/apps/build/markets/build-catalog).
 */
export type PriceListPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originType?: InputMaybe<PriceListPriceOriginType>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A list that defines pricing for [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant). Price lists override default product prices with either fixed prices or percentage-based adjustments.
 *
 * Each price list associates with a [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) to determine which customers see the pricing. The catalog's context rules control when the price list applies, such as for specific markets, company locations, or apps.
 *
 * Learn how to [support different pricing models](https://shopify.dev/docs/apps/build/markets/build-catalog).
 */
export type PriceListQuantityRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originType?: InputMaybe<QuantityRuleOriginType>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The type and value of a price list adjustment.
 *
 * For more information on price lists, refer to
 * [Support different pricing models](https://shopify.dev/apps/internationalization/product-price-lists).
 */
export type PriceListAdjustment = {
  __typename?: 'PriceListAdjustment';
  /** The type of price adjustment, such as percentage increase or decrease. */
  type: PriceListAdjustmentType;
  /**
   * The value of price adjustment, where positive numbers reduce the prices and negative numbers
   * increase them.
   */
  value: Scalars['Float']['output'];
};

/** The input fields to set a price list adjustment. */
export type PriceListAdjustmentInput = {
  /** The type of price adjustment, such as percentage increase or decrease. */
  type: PriceListAdjustmentType;
  /** The value of the price adjustment as specified by the `type`. */
  value: Scalars['Float']['input'];
};

/** Represents the settings of price list adjustments. */
export type PriceListAdjustmentSettings = {
  __typename?: 'PriceListAdjustmentSettings';
  /** The type of price list adjustment setting for compare at price. */
  compareAtMode: PriceListCompareAtMode;
};

/** The input fields to set a price list's adjustment settings. */
export type PriceListAdjustmentSettingsInput = {
  /** Determines how adjustments are applied to compare at prices. */
  compareAtMode?: PriceListCompareAtMode;
};

/** Represents a percentage price adjustment type. */
export enum PriceListAdjustmentType {
  /** Percentage decrease type. Prices will have a lower value. */
  PercentageDecrease = 'PERCENTAGE_DECREASE',
  /** Percentage increase type. Prices will have a higher value. */
  PercentageIncrease = 'PERCENTAGE_INCREASE'
}

/** Represents how the compare at price will be determined for a price list. */
export enum PriceListCompareAtMode {
  /** The compare at price is adjusted based on percentage specified in price list. */
  Adjusted = 'ADJUSTED',
  /** The compare at prices are set to `null` unless explicitly defined by a fixed price value. */
  Nullify = 'NULLIFY'
}

/** An auto-generated type for paginating through multiple PriceLists. */
export type PriceListConnection = {
  __typename?: 'PriceListConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PriceListEdge>;
  /** A list of nodes that are contained in PriceListEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PriceList>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create a price list. */
export type PriceListCreateInput = {
  /** The ID of the catalog to associate with this price list.If the catalog was already associated with another price list then it will be unlinked. */
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** Three letter currency code for fixed prices associated with this price list. */
  currency: CurrencyCode;
  /** The unique name of the price list, used as a human-readable identifier. */
  name: Scalars['String']['input'];
  /** Relative adjustments to other prices. */
  parent: PriceListParentCreateInput;
};

/** Return type for `priceListCreate` mutation. */
export type PriceListCreatePayload = {
  __typename?: 'PriceListCreatePayload';
  /** The newly created price list. */
  priceList?: Maybe<PriceList>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListUserError>;
};

/** Return type for `priceListDelete` mutation. */
export type PriceListDeletePayload = {
  __typename?: 'PriceListDeletePayload';
  /** The ID of the deleted price list. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListUserError>;
};

/** An auto-generated type which holds one PriceList and a cursor during pagination. */
export type PriceListEdge = {
  __typename?: 'PriceListEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PriceListEdge. */
  node: PriceList;
};

/** Return type for `priceListFixedPricesAdd` mutation. */
export type PriceListFixedPricesAddPayload = {
  __typename?: 'PriceListFixedPricesAddPayload';
  /** The list of fixed prices that were added to or updated in the price list. */
  prices?: Maybe<Array<PriceListPrice>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListPriceUserError>;
};

/** Error codes for failed price list fixed prices by product bulk update operations. */
export type PriceListFixedPricesByProductBulkUpdateUserError = DisplayableError & {
  __typename?: 'PriceListFixedPricesByProductBulkUpdateUserError';
  /** The error code. */
  code?: Maybe<PriceListFixedPricesByProductBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PriceListFixedPricesByProductBulkUpdateUserError`. */
export enum PriceListFixedPricesByProductBulkUpdateUserErrorCode {
  /** Duplicate ID in input. */
  DuplicateIdInInput = 'DUPLICATE_ID_IN_INPUT',
  /** IDs must be mutually exclusive across add or delete operations. */
  IdMustBeMutuallyExclusive = 'ID_MUST_BE_MUTUALLY_EXCLUSIVE',
  /** The issuance currency of a local currency gift card must match the price list currency. */
  LocalCurrencyGiftCardIssuanceCurrencyMismatch = 'LOCAL_CURRENCY_GIFT_CARD_ISSUANCE_CURRENCY_MISMATCH',
  /** The price of a local currency gift card cannot exceed the maximum gift card purchase limit. */
  LocalCurrencyGiftCardLimitExceeded = 'LOCAL_CURRENCY_GIFT_CARD_LIMIT_EXCEEDED',
  /** No update operations specified. */
  NoUpdateOperationsSpecified = 'NO_UPDATE_OPERATIONS_SPECIFIED',
  /** The currency specified does not match the price list's currency. */
  PricesToAddCurrencyMismatch = 'PRICES_TO_ADD_CURRENCY_MISMATCH',
  /** Exceeded the 10000 prices to add limit. */
  PriceLimitExceeded = 'PRICE_LIMIT_EXCEEDED',
  /** Price list does not exist. */
  PriceListDoesNotExist = 'PRICE_LIST_DOES_NOT_EXIST',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST'
}

/** Return type for `priceListFixedPricesByProductUpdate` mutation. */
export type PriceListFixedPricesByProductUpdatePayload = {
  __typename?: 'PriceListFixedPricesByProductUpdatePayload';
  /** The price list for which the fixed prices were modified. */
  priceList?: Maybe<PriceList>;
  /** The product for which the fixed prices were added. */
  pricesToAddProducts?: Maybe<Array<Product>>;
  /** The product for which the fixed prices were deleted. */
  pricesToDeleteProducts?: Maybe<Array<Product>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListFixedPricesByProductBulkUpdateUserError>;
};

/** Return type for `priceListFixedPricesDelete` mutation. */
export type PriceListFixedPricesDeletePayload = {
  __typename?: 'PriceListFixedPricesDeletePayload';
  /** A list of product variant IDs whose fixed prices were removed from the price list. */
  deletedFixedPriceVariantIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListPriceUserError>;
};

/** Return type for `priceListFixedPricesUpdate` mutation. */
export type PriceListFixedPricesUpdatePayload = {
  __typename?: 'PriceListFixedPricesUpdatePayload';
  /** A list of deleted variant IDs for prices. */
  deletedFixedPriceVariantIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The price list for which the fixed prices were modified. */
  priceList?: Maybe<PriceList>;
  /** The prices that were added to the price list. */
  pricesAdded?: Maybe<Array<PriceListPrice>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListPriceUserError>;
};

/**
 * Represents relative adjustments from one price list to other prices.
 *   You can use a `PriceListParent` to specify an adjusted relative price using a percentage-based
 *   adjustment. Adjusted prices work in conjunction with exchange rules and rounding.
 *
 *   [Adjustment types](https://shopify.dev/api/admin-graphql/latest/enums/pricelistadjustmenttype)
 *   support both percentage increases and decreases.
 */
export type PriceListParent = {
  __typename?: 'PriceListParent';
  /** A price list adjustment. */
  adjustment: PriceListAdjustment;
  /** A price list's settings for adjustment. */
  settings: PriceListAdjustmentSettings;
};

/** The input fields to create a price list adjustment. */
export type PriceListParentCreateInput = {
  /** The relative adjustments to other prices. */
  adjustment: PriceListAdjustmentInput;
  /** The price list adjustment settings. */
  settings?: InputMaybe<PriceListAdjustmentSettingsInput>;
};

/** The input fields used to update a price list's adjustment. */
export type PriceListParentUpdateInput = {
  /** The relative adjustments to other prices.. */
  adjustment: PriceListAdjustmentInput;
  /** The price list adjustment settings. */
  settings?: InputMaybe<PriceListAdjustmentSettingsInput>;
};

/**
 * Pricing for a [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). Represents the variant's price, compare-at price, and whether the price is fixed or calculated using percentage-based adjustments. The [`PriceListPriceOriginType`](https://shopify.dev/docs/api/admin-graphql/latest/enums/PriceListPriceOriginType) distinguishes between prices set directly on the price list (fixed) and prices calculated using the price list's adjustment configuration (relative).
 *
 * Learn more about [building catalogs with different pricing models](https://shopify.dev/docs/apps/build/markets/build-catalog).
 */
export type PriceListPrice = {
  __typename?: 'PriceListPrice';
  /** The compare-at price of the product variant on this price list. */
  compareAtPrice?: Maybe<MoneyV2>;
  /** The origin of a price, either fixed (defined on the price list) or relative (calculated using a price list adjustment configuration). */
  originType: PriceListPriceOriginType;
  /** The price of the product variant on this price list. */
  price: MoneyV2;
  /** A list of quantity breaks for the product variant. */
  quantityPriceBreaks: QuantityPriceBreakConnection;
  /** The product variant associated with this price. */
  variant: ProductVariant;
};


/**
 * Pricing for a [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) on a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList). Represents the variant's price, compare-at price, and whether the price is fixed or calculated using percentage-based adjustments. The [`PriceListPriceOriginType`](https://shopify.dev/docs/api/admin-graphql/latest/enums/PriceListPriceOriginType) distinguishes between prices set directly on the price list (fixed) and prices calculated using the price list's adjustment configuration (relative).
 *
 * Learn more about [building catalogs with different pricing models](https://shopify.dev/docs/apps/build/markets/build-catalog).
 */
export type PriceListPriceQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<QuantityPriceBreakSortKeys>;
};

/** An auto-generated type for paginating through multiple PriceListPrices. */
export type PriceListPriceConnection = {
  __typename?: 'PriceListPriceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PriceListPriceEdge>;
  /** A list of nodes that are contained in PriceListPriceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PriceListPrice>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one PriceListPrice and a cursor during pagination. */
export type PriceListPriceEdge = {
  __typename?: 'PriceListPriceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PriceListPriceEdge. */
  node: PriceListPrice;
};

/** The input fields for providing the fields and values to use when creating or updating a fixed price list price. */
export type PriceListPriceInput = {
  /** The compare-at price of the product variant on this price list. */
  compareAtPrice?: InputMaybe<MoneyInput>;
  /** The price of the product variant on this price list. */
  price: MoneyInput;
  /** The product variant ID associated with the price list price. */
  variantId: Scalars['ID']['input'];
};

/** Represents the origin of a price, either fixed (defined on the price list) or relative (calculated using a price list adjustment configuration). For examples, refer to [PriceList](https://shopify.dev/api/admin-graphql/latest/queries/priceList#section-examples). */
export enum PriceListPriceOriginType {
  /** The price is defined on the price list. */
  Fixed = 'FIXED',
  /** The price is relative to the adjustment type and value. */
  Relative = 'RELATIVE'
}

/** An error for a failed price list price operation. */
export type PriceListPriceUserError = DisplayableError & {
  __typename?: 'PriceListPriceUserError';
  /** The error code. */
  code?: Maybe<PriceListPriceUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PriceListPriceUserError`. */
export enum PriceListPriceUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The issuance currency of a local currency gift card must match the price list currency. */
  LocalCurrencyGiftCardIssuanceCurrencyMismatch = 'LOCAL_CURRENCY_GIFT_CARD_ISSUANCE_CURRENCY_MISMATCH',
  /** The price of a local currency gift card cannot exceed the maximum gift card purchase limit. */
  LocalCurrencyGiftCardLimitExceeded = 'LOCAL_CURRENCY_GIFT_CARD_LIMIT_EXCEEDED',
  /** The specified currency doesn't match the price list's currency. */
  PriceListCurrencyMismatch = 'PRICE_LIST_CURRENCY_MISMATCH',
  /** The price list doesn't exist. */
  PriceListNotFound = 'PRICE_LIST_NOT_FOUND',
  /** Only fixed prices can be deleted. */
  PriceNotFixed = 'PRICE_NOT_FIXED',
  /** A fixed price for the specified product variant doesn't exist. */
  VariantNotFound = 'VARIANT_NOT_FOUND'
}

/** The input fields representing the price for all variants of a product. */
export type PriceListProductPriceInput = {
  /** Specifies the compare-at price and currency to apply to the product's variants on the price list. */
  compareAtPrice?: InputMaybe<MoneyInput>;
  /** Specifies the price and currency to apply to the product's variants on the price list. */
  price: MoneyInput;
  /** Specifies the ID of the product to update its variants for. */
  productId: Scalars['ID']['input'];
};

/** The set of valid sort keys for the PriceList query. */
export enum PriceListSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME'
}

/** The input fields used to update a price list. */
export type PriceListUpdateInput = {
  /** The ID of the catalog to associate with this price list. */
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** The three-letter currency code for fixed prices associated with this price list. */
  currency?: InputMaybe<CurrencyCode>;
  /** The unique name of the price list, used as a human-readable identifier. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Relative adjustments to other prices. */
  parent?: InputMaybe<PriceListParentUpdateInput>;
};

/** Return type for `priceListUpdate` mutation. */
export type PriceListUpdatePayload = {
  __typename?: 'PriceListUpdatePayload';
  /** The updated price list. */
  priceList?: Maybe<PriceList>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PriceListUserError>;
};

/** Error codes for failed contextual pricing operations. */
export type PriceListUserError = DisplayableError & {
  __typename?: 'PriceListUserError';
  /** The error code. */
  code?: Maybe<PriceListUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PriceListUserError`. */
export enum PriceListUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Quantity price breaks can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CatalogContextDoesNotSupportQuantityPriceBreaks = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS',
  /** Quantity rules can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CatalogContextDoesNotSupportQuantityRules = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** The specified catalog does not exist. */
  CatalogDoesNotExist = 'CATALOG_DOES_NOT_EXIST',
  /** The price list currency must match the market catalog currency. */
  CatalogMarketAndPriceListCurrencyMismatch = 'CATALOG_MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH',
  /** Catalog has a price list already assigned. */
  CatalogTaken = 'CATALOG_TAKEN',
  /** Only one context rule option may be specified. */
  ContextRuleLimitOneOption = 'CONTEXT_RULE_LIMIT_ONE_OPTION',
  /** A country catalog cannot be assigned to a price list. */
  CountryPriceListAssignment = 'COUNTRY_PRICE_LIST_ASSIGNMENT',
  /** A price list’s currency must be the market currency. */
  CurrencyMarketMismatch = 'CURRENCY_MARKET_MISMATCH',
  /** The price list currency is not supported by the shop's payment gateway. */
  CurrencyNotSupported = 'CURRENCY_NOT_SUPPORTED',
  /** Something went wrong when trying to save the price list. Please try again. */
  GenericError = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The adjustment value must not be greater than 1000% for `type` `PERCENTAGE_INCREASE`. */
  InvalidAdjustmentMaxValue = 'INVALID_ADJUSTMENT_MAX_VALUE',
  /** The adjustment value must not be greater than 100% for `type` `PERCENTAGE_DECREASE`. */
  InvalidAdjustmentMinValue = 'INVALID_ADJUSTMENT_MIN_VALUE',
  /** The adjustment value must be a positive value and not be greater than 100% for `type` `PERCENTAGE_DECREASE` and not be greater than 1000% for `type` `PERCENTAGE_INCREASE`. */
  InvalidAdjustmentValue = 'INVALID_ADJUSTMENT_VALUE',
  /** The price list is currently being modified. Please try again later. */
  PriceListLocked = 'PRICE_LIST_LOCKED',
  /** Cannot create price list for a primary market. */
  PriceListNotAllowedForPrimaryMarket = 'PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET',
  /** The specified price list doesn't exist. */
  PriceListNotFound = 'PRICE_LIST_NOT_FOUND',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/**
 * A set of conditions, including entitlements and prerequisites, that must be met for a discount code to apply.
 *
 * > Note:
 * > Use the types and queries included our [discount tutorials](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL Admin API's [`PriceRule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceRule) object and [`DiscountCode`](https://shopify.dev/docs/api/admin-graphql/latest/unions/DiscountCode) union, and the REST Admin API's deprecated[`PriceRule`](https://shopify.dev/docs/api/admin-rest/unstable/resources/pricerule) resource.
 */
export type PriceRule = CommentEventSubject & HasEvents & LegacyInteroperability & Node & {
  __typename?: 'PriceRule';
  /** The maximum number of times that the price rule can be allocated onto an order. */
  allocationLimit?: Maybe<Scalars['Int']['output']>;
  /** The method by which the price rule's value is allocated to its entitled items. */
  allocationMethod: PriceRuleAllocationMethod;
  /** The application that created the price rule. */
  app?: Maybe<App>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  combinesWith: DiscountCombinesWith;
  /** The date and time when the price rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customers that can use this price rule. */
  customerSelection: PriceRuleCustomerSelection;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  discountClass: DiscountClass;
  /** The classes of the discount. */
  discountClasses: Array<DiscountClass>;
  /** List of the price rule's discount codes. */
  discountCodes: PriceRuleDiscountCodeConnection;
  /** How many discount codes associated with the price rule. */
  discountCodesCount?: Maybe<Count>;
  /** The date and time when the price rule ends. For open-ended price rules, use `null`. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Quantity of prerequisite items required for the price rule to be applicable,  compared to quantity of entitled items.
   * @deprecated Use `prerequisiteToEntitlementQuantityRatio` instead.
   */
  entitlementToPrerequisiteQuantityRatio?: Maybe<PriceRuleEntitlementToPrerequisiteQuantityRatio>;
  /** The paginated list of events associated with the price rule. */
  events: EventConnection;
  /** A list of the price rule's features. */
  features: Array<PriceRuleFeature>;
  /** Indicates whether there are any timeline comments on the price rule. */
  hasTimelineComment: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The items to which the price rule applies. */
  itemEntitlements: PriceRuleItemEntitlements;
  /** The items required for the price rule to be applicable. */
  itemPrerequisites: PriceRuleLineItemPrerequisites;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** Whether the price rule can be applied only once per customer. */
  oncePerCustomer: Scalars['Boolean']['output'];
  /** The number of the entitled items must fall within this range for the price rule to be applicable. */
  prerequisiteQuantityRange?: Maybe<PriceRuleQuantityRange>;
  /** The shipping cost must fall within this range for the price rule to be applicable. */
  prerequisiteShippingPriceRange?: Maybe<PriceRuleMoneyRange>;
  /** The sum of the entitled items subtotal prices must fall within this range for the price rule to be applicable. */
  prerequisiteSubtotalRange?: Maybe<PriceRuleMoneyRange>;
  /** Quantity of prerequisite items required for the price rule to be applicable,  compared to quantity of entitled items. */
  prerequisiteToEntitlementQuantityRatio?: Maybe<PriceRulePrerequisiteToEntitlementQuantityRatio>;
  /** URLs that can be used to share the discount. */
  shareableUrls: Array<PriceRuleShareableUrl>;
  /** The shipping lines to which the price rule applies. */
  shippingEntitlements: PriceRuleShippingLineEntitlements;
  /** The date and time when the price rule starts. */
  startsAt: Scalars['DateTime']['output'];
  /** The status of the price rule. */
  status: PriceRuleStatus;
  /** A detailed summary of the price rule. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The type of lines (line_item or shipping_line) to which the price rule applies. */
  target: PriceRuleTarget;
  /** The title of the price rule. */
  title: Scalars['String']['output'];
  /** The total sales from orders where the price rule was used. */
  totalSales?: Maybe<MoneyV2>;
  /**
   * A list of the price rule's features.
   * @deprecated Use `features` instead.
   */
  traits: Array<PriceRuleTrait>;
  /** The number of times that the price rule has been used. This value is updated asynchronously and can be different than the actual usage count. */
  usageCount: Scalars['Int']['output'];
  /** The maximum number of times that the price rule can be used in total. */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  /** A time period during which a price rule is applicable. */
  validityPeriod: PriceRuleValidityPeriod;
  /**
   * The value of the price rule.
   * @deprecated Use `valueV2` instead.
   */
  value: PriceRuleValue;
  /** The value of the price rule. */
  valueV2: PricingValue;
};


/**
 * A set of conditions, including entitlements and prerequisites, that must be met for a discount code to apply.
 *
 * > Note:
 * > Use the types and queries included our [discount tutorials](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL Admin API's [`PriceRule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceRule) object and [`DiscountCode`](https://shopify.dev/docs/api/admin-graphql/latest/unions/DiscountCode) union, and the REST Admin API's deprecated[`PriceRule`](https://shopify.dev/docs/api/admin-rest/unstable/resources/pricerule) resource.
 */
export type PriceRuleDiscountCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};


/**
 * A set of conditions, including entitlements and prerequisites, that must be met for a discount code to apply.
 *
 * > Note:
 * > Use the types and queries included our [discount tutorials](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL Admin API's [`PriceRule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceRule) object and [`DiscountCode`](https://shopify.dev/docs/api/admin-graphql/latest/unions/DiscountCode) union, and the REST Admin API's deprecated[`PriceRule`](https://shopify.dev/docs/api/admin-rest/unstable/resources/pricerule) resource.
 */
export type PriceRuleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** The method by which the price rule's value is allocated to its entitled items. */
export enum PriceRuleAllocationMethod {
  /** The value will be applied once across the entitled items. */
  Across = 'ACROSS',
  /** The value will be applied to each of the entitled items. */
  Each = 'EACH'
}

/** A selection of customers for whom the price rule applies. */
export type PriceRuleCustomerSelection = {
  __typename?: 'PriceRuleCustomerSelection';
  /** List of customers to whom the price rule applies. */
  customers: CustomerConnection;
  /** Whether the price rule applies to all customers. */
  forAllCustomers: Scalars['Boolean']['output'];
  /** A list of customer segments that contain the customers who can use the price rule. */
  segments: Array<Segment>;
};


/** A selection of customers for whom the price rule applies. */
export type PriceRuleCustomerSelectionCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};

/** A discount code of a price rule. */
export type PriceRuleDiscountCode = Node & {
  __typename?: 'PriceRuleDiscountCode';
  /** The application that created the discount code. */
  app?: Maybe<App>;
  /** The code to apply the discount. */
  code: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The number of times that the price rule has been used. This value is updated asynchronously and can be different than the actual usage count. */
  usageCount: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple PriceRuleDiscountCodes. */
export type PriceRuleDiscountCodeConnection = {
  __typename?: 'PriceRuleDiscountCodeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PriceRuleDiscountCodeEdge>;
  /** A list of nodes that are contained in PriceRuleDiscountCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<PriceRuleDiscountCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one PriceRuleDiscountCode and a cursor during pagination. */
export type PriceRuleDiscountCodeEdge = {
  __typename?: 'PriceRuleDiscountCodeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PriceRuleDiscountCodeEdge. */
  node: PriceRuleDiscountCode;
};

/** Quantity of prerequisite items required for the price rule to be applicable, compared to quantity of entitled items. */
export type PriceRuleEntitlementToPrerequisiteQuantityRatio = {
  __typename?: 'PriceRuleEntitlementToPrerequisiteQuantityRatio';
  /** The quantity of entitled items in the ratio. */
  entitlementQuantity: Scalars['Int']['output'];
  /** The quantity of prerequisite items in the ratio. */
  prerequisiteQuantity: Scalars['Int']['output'];
};

/** The list of features that can be supported by a price rule. */
export enum PriceRuleFeature {
  /** The price rule supports bulk discounts. */
  Bulk = 'BULK',
  /** The price rule supports Buy X, Get Y (BXGY) discounts. */
  BuyOneGetOne = 'BUY_ONE_GET_ONE',
  /** The price rule supports Buy X, Get Y (BXGY) discounts that specify a custom allocation limit. */
  BuyOneGetOneWithAllocationLimit = 'BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT',
  /** The price rule supports discounts that require a quantity. */
  QuantityDiscounts = 'QUANTITY_DISCOUNTS',
  /** The price rule targets specific customers. */
  SpecificCustomers = 'SPECIFIC_CUSTOMERS'
}

/** The value of a fixed amount price rule. */
export type PriceRuleFixedAmountValue = {
  __typename?: 'PriceRuleFixedAmountValue';
  /** The monetary value of the price rule. */
  amount: Scalars['Money']['output'];
};

/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlements = {
  __typename?: 'PriceRuleItemEntitlements';
  /** The collections to which the price rule applies. */
  collections: CollectionConnection;
  /** The product variants to which the price rule applies. */
  productVariants: ProductVariantConnection;
  /** The products to which the price rule applies. */
  products: ProductConnection;
  /** Whether the price rule applies to all line items. */
  targetAllLineItems: Scalars['Boolean']['output'];
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisites = {
  __typename?: 'PriceRuleLineItemPrerequisites';
  /** The collections required for the price rule to be applicable. */
  collections: CollectionConnection;
  /** The product variants required for the price rule to be applicable. */
  productVariants: ProductVariantConnection;
  /** The products required for the price rule to be applicable. */
  products: ProductConnection;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A money range within which the price rule is applicable. */
export type PriceRuleMoneyRange = {
  __typename?: 'PriceRuleMoneyRange';
  /** The lower bound of the money range. */
  greaterThan?: Maybe<Scalars['Money']['output']>;
  /** The lower bound or equal of the money range. */
  greaterThanOrEqualTo?: Maybe<Scalars['Money']['output']>;
  /** The upper bound of the money range. */
  lessThan?: Maybe<Scalars['Money']['output']>;
  /** The upper bound or equal of the money range. */
  lessThanOrEqualTo?: Maybe<Scalars['Money']['output']>;
};

/** The value of a percent price rule. */
export type PriceRulePercentValue = {
  __typename?: 'PriceRulePercentValue';
  /** The percent value of the price rule. */
  percentage: Scalars['Float']['output'];
};

/** Quantity of prerequisite items required for the price rule to be applicable, compared to quantity of entitled items. */
export type PriceRulePrerequisiteToEntitlementQuantityRatio = {
  __typename?: 'PriceRulePrerequisiteToEntitlementQuantityRatio';
  /** The quantity of entitled items in the ratio. */
  entitlementQuantity: Scalars['Int']['output'];
  /** The quantity of prerequisite items in the ratio. */
  prerequisiteQuantity: Scalars['Int']['output'];
};

/** A quantity range within which the price rule is applicable. */
export type PriceRuleQuantityRange = {
  __typename?: 'PriceRuleQuantityRange';
  /** The lower bound of the quantity range. */
  greaterThan?: Maybe<Scalars['Int']['output']>;
  /** The lower bound or equal of the quantity range. */
  greaterThanOrEqualTo?: Maybe<Scalars['Int']['output']>;
  /** The upper bound of the quantity range. */
  lessThan?: Maybe<Scalars['Int']['output']>;
  /** The upper bound or equal of the quantity range. */
  lessThanOrEqualTo?: Maybe<Scalars['Int']['output']>;
};

/** Shareable URL for the discount code associated with the price rule. */
export type PriceRuleShareableUrl = {
  __typename?: 'PriceRuleShareableUrl';
  /** The image URL of the item (product or collection) to which the discount applies. */
  targetItemImage?: Maybe<Image>;
  /** The type of page that's associated with the URL. */
  targetType: PriceRuleShareableUrlTargetType;
  /** The title of the page that's associated with the URL. */
  title: Scalars['String']['output'];
  /** The URL for the discount code. */
  url: Scalars['URL']['output'];
};

/** The type of page where a shareable price rule URL lands. */
export enum PriceRuleShareableUrlTargetType {
  /** The URL lands on a collection page. */
  Collection = 'COLLECTION',
  /** The URL lands on a home page. */
  Home = 'HOME',
  /** The URL lands on a product page. */
  Product = 'PRODUCT'
}

/** The shipping lines to which the price rule applies to. */
export type PriceRuleShippingLineEntitlements = {
  __typename?: 'PriceRuleShippingLineEntitlements';
  /** The codes for the countries to which the price rule applies to. */
  countryCodes: Array<CountryCode>;
  /**
   * Whether the price rule is applicable to countries that haven't been defined in the shop's shipping zones.
   * @deprecated This field is being retired. Price rules that set `includeRestOfWorld: true` will be converted to an explicit list of countries, and `countryCodes` will then return every country where the price rule applies.
   */
  includeRestOfWorld: Scalars['Boolean']['output'];
  /** Whether the price rule applies to all shipping lines. */
  targetAllShippingLines: Scalars['Boolean']['output'];
};

/** The status of the price rule. */
export enum PriceRuleStatus {
  /** The price rule is active. */
  Active = 'ACTIVE',
  /** The price rule is expired. */
  Expired = 'EXPIRED',
  /** The price rule is scheduled. */
  Scheduled = 'SCHEDULED'
}

/** The type of lines (line_item or shipping_line) to which the price rule applies. */
export enum PriceRuleTarget {
  /** The price rule applies to line items. */
  LineItem = 'LINE_ITEM',
  /** The price rule applies to shipping lines. */
  ShippingLine = 'SHIPPING_LINE'
}

/** The list of features that can be supported by a price rule. */
export enum PriceRuleTrait {
  /** The price rule supports bulk discounts. */
  Bulk = 'BULK',
  /** The price rule supports Buy X, Get Y (BXGY) discounts. */
  BuyOneGetOne = 'BUY_ONE_GET_ONE',
  /** The price rule supports Buy X, Get Y (BXGY) discounts that specify a custom allocation limit. */
  BuyOneGetOneWithAllocationLimit = 'BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT',
  /** The price rule supports discounts that require a quantity. */
  QuantityDiscounts = 'QUANTITY_DISCOUNTS',
  /** The price rule targets specific customers. */
  SpecificCustomers = 'SPECIFIC_CUSTOMERS'
}

/** A time period during which a price rule is applicable. */
export type PriceRuleValidityPeriod = {
  __typename?: 'PriceRuleValidityPeriod';
  /** The time after which the price rule becomes invalid. */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** The time after which the price rule is valid. */
  start: Scalars['DateTime']['output'];
};

/** The type of the price rule value. The price rule value might be a percentage value, or a fixed amount. */
export type PriceRuleValue = PriceRuleFixedAmountValue | PriceRulePercentValue;

/**
 * One type of value given to a customer when a discount is applied to an order.
 * The application of a discount with this value gives the customer the specified percentage off a specified item.
 */
export type PricingPercentageValue = {
  __typename?: 'PricingPercentageValue';
  /** The percentage value of the object. This is a number between -100 (free) and 0 (no discount). */
  percentage: Scalars['Float']['output'];
};

/** The type of value given to a customer when a discount is applied to an order. For example, the application of the discount might give the customer a percentage off a specified item. Alternatively, the application of the discount might give the customer a monetary value in a given currency off an order. */
export type PricingValue = MoneyV2 | PricingPercentageValue;

/** A country code from the `ISO 3166` standard. e.g. `CA` for Canada. */
export enum PrivacyCountryCode {
  /** The `ISO 3166` country code of `AC`. */
  Ac = 'AC',
  /** The `ISO 3166` country code of `AD`. */
  Ad = 'AD',
  /** The `ISO 3166` country code of `AE`. */
  Ae = 'AE',
  /** The `ISO 3166` country code of `AF`. */
  Af = 'AF',
  /** The `ISO 3166` country code of `AG`. */
  Ag = 'AG',
  /** The `ISO 3166` country code of `AI`. */
  Ai = 'AI',
  /** The `ISO 3166` country code of `AL`. */
  Al = 'AL',
  /** The `ISO 3166` country code of `AM`. */
  Am = 'AM',
  /** The `ISO 3166` country code of `AN`. */
  An = 'AN',
  /** The `ISO 3166` country code of `AO`. */
  Ao = 'AO',
  /** The `ISO 3166` country code of `AQ`. */
  Aq = 'AQ',
  /** The `ISO 3166` country code of `AR`. */
  Ar = 'AR',
  /** The `ISO 3166` country code of `AS`. */
  As = 'AS',
  /** The `ISO 3166` country code of `AT`. */
  At = 'AT',
  /** The `ISO 3166` country code of `AU`. */
  Au = 'AU',
  /** The `ISO 3166` country code of `AW`. */
  Aw = 'AW',
  /** The `ISO 3166` country code of `AX`. */
  Ax = 'AX',
  /** The `ISO 3166` country code of `AZ`. */
  Az = 'AZ',
  /** The `ISO 3166` country code of `BA`. */
  Ba = 'BA',
  /** The `ISO 3166` country code of `BB`. */
  Bb = 'BB',
  /** The `ISO 3166` country code of `BD`. */
  Bd = 'BD',
  /** The `ISO 3166` country code of `BE`. */
  Be = 'BE',
  /** The `ISO 3166` country code of `BF`. */
  Bf = 'BF',
  /** The `ISO 3166` country code of `BG`. */
  Bg = 'BG',
  /** The `ISO 3166` country code of `BH`. */
  Bh = 'BH',
  /** The `ISO 3166` country code of `BI`. */
  Bi = 'BI',
  /** The `ISO 3166` country code of `BJ`. */
  Bj = 'BJ',
  /** The `ISO 3166` country code of `BL`. */
  Bl = 'BL',
  /** The `ISO 3166` country code of `BM`. */
  Bm = 'BM',
  /** The `ISO 3166` country code of `BN`. */
  Bn = 'BN',
  /** The `ISO 3166` country code of `BO`. */
  Bo = 'BO',
  /** The `ISO 3166` country code of `BQ`. */
  Bq = 'BQ',
  /** The `ISO 3166` country code of `BR`. */
  Br = 'BR',
  /** The `ISO 3166` country code of `BS`. */
  Bs = 'BS',
  /** The `ISO 3166` country code of `BT`. */
  Bt = 'BT',
  /** The `ISO 3166` country code of `BV`. */
  Bv = 'BV',
  /** The `ISO 3166` country code of `BW`. */
  Bw = 'BW',
  /** The `ISO 3166` country code of `BY`. */
  By = 'BY',
  /** The `ISO 3166` country code of `BZ`. */
  Bz = 'BZ',
  /** The `ISO 3166` country code of `CA`. */
  Ca = 'CA',
  /** The `ISO 3166` country code of `CC`. */
  Cc = 'CC',
  /** The `ISO 3166` country code of `CD`. */
  Cd = 'CD',
  /** The `ISO 3166` country code of `CF`. */
  Cf = 'CF',
  /** The `ISO 3166` country code of `CG`. */
  Cg = 'CG',
  /** The `ISO 3166` country code of `CH`. */
  Ch = 'CH',
  /** The `ISO 3166` country code of `CI`. */
  Ci = 'CI',
  /** The `ISO 3166` country code of `CK`. */
  Ck = 'CK',
  /** The `ISO 3166` country code of `CL`. */
  Cl = 'CL',
  /** The `ISO 3166` country code of `CM`. */
  Cm = 'CM',
  /** The `ISO 3166` country code of `CN`. */
  Cn = 'CN',
  /** The `ISO 3166` country code of `CO`. */
  Co = 'CO',
  /** The `ISO 3166` country code of `CR`. */
  Cr = 'CR',
  /** The `ISO 3166` country code of `CU`. */
  Cu = 'CU',
  /** The `ISO 3166` country code of `CV`. */
  Cv = 'CV',
  /** The `ISO 3166` country code of `CW`. */
  Cw = 'CW',
  /** The `ISO 3166` country code of `CX`. */
  Cx = 'CX',
  /** The `ISO 3166` country code of `CY`. */
  Cy = 'CY',
  /** The `ISO 3166` country code of `CZ`. */
  Cz = 'CZ',
  /** The `ISO 3166` country code of `DE`. */
  De = 'DE',
  /** The `ISO 3166` country code of `DJ`. */
  Dj = 'DJ',
  /** The `ISO 3166` country code of `DK`. */
  Dk = 'DK',
  /** The `ISO 3166` country code of `DM`. */
  Dm = 'DM',
  /** The `ISO 3166` country code of `DO`. */
  Do = 'DO',
  /** The `ISO 3166` country code of `DZ`. */
  Dz = 'DZ',
  /** The `ISO 3166` country code of `EC`. */
  Ec = 'EC',
  /** The `ISO 3166` country code of `EE`. */
  Ee = 'EE',
  /** The `ISO 3166` country code of `EG`. */
  Eg = 'EG',
  /** The `ISO 3166` country code of `EH`. */
  Eh = 'EH',
  /** The `ISO 3166` country code of `ER`. */
  Er = 'ER',
  /** The `ISO 3166` country code of `ES`. */
  Es = 'ES',
  /** The `ISO 3166` country code of `ET`. */
  Et = 'ET',
  /** The `ISO 3166` country code of `FI`. */
  Fi = 'FI',
  /** The `ISO 3166` country code of `FJ`. */
  Fj = 'FJ',
  /** The `ISO 3166` country code of `FK`. */
  Fk = 'FK',
  /** The `ISO 3166` country code of `FM`. */
  Fm = 'FM',
  /** The `ISO 3166` country code of `FO`. */
  Fo = 'FO',
  /** The `ISO 3166` country code of `FR`. */
  Fr = 'FR',
  /** The `ISO 3166` country code of `GA`. */
  Ga = 'GA',
  /** The `ISO 3166` country code of `GB`. */
  Gb = 'GB',
  /** The `ISO 3166` country code of `GD`. */
  Gd = 'GD',
  /** The `ISO 3166` country code of `GE`. */
  Ge = 'GE',
  /** The `ISO 3166` country code of `GF`. */
  Gf = 'GF',
  /** The `ISO 3166` country code of `GG`. */
  Gg = 'GG',
  /** The `ISO 3166` country code of `GH`. */
  Gh = 'GH',
  /** The `ISO 3166` country code of `GI`. */
  Gi = 'GI',
  /** The `ISO 3166` country code of `GL`. */
  Gl = 'GL',
  /** The `ISO 3166` country code of `GM`. */
  Gm = 'GM',
  /** The `ISO 3166` country code of `GN`. */
  Gn = 'GN',
  /** The `ISO 3166` country code of `GP`. */
  Gp = 'GP',
  /** The `ISO 3166` country code of `GQ`. */
  Gq = 'GQ',
  /** The `ISO 3166` country code of `GR`. */
  Gr = 'GR',
  /** The `ISO 3166` country code of `GS`. */
  Gs = 'GS',
  /** The `ISO 3166` country code of `GT`. */
  Gt = 'GT',
  /** The `ISO 3166` country code of `GU`. */
  Gu = 'GU',
  /** The `ISO 3166` country code of `GW`. */
  Gw = 'GW',
  /** The `ISO 3166` country code of `GY`. */
  Gy = 'GY',
  /** The `ISO 3166` country code of `HK`. */
  Hk = 'HK',
  /** The `ISO 3166` country code of `HM`. */
  Hm = 'HM',
  /** The `ISO 3166` country code of `HN`. */
  Hn = 'HN',
  /** The `ISO 3166` country code of `HR`. */
  Hr = 'HR',
  /** The `ISO 3166` country code of `HT`. */
  Ht = 'HT',
  /** The `ISO 3166` country code of `HU`. */
  Hu = 'HU',
  /** The `ISO 3166` country code of `ID`. */
  Id = 'ID',
  /** The `ISO 3166` country code of `IE`. */
  Ie = 'IE',
  /** The `ISO 3166` country code of `IL`. */
  Il = 'IL',
  /** The `ISO 3166` country code of `IM`. */
  Im = 'IM',
  /** The `ISO 3166` country code of `IN`. */
  In = 'IN',
  /** The `ISO 3166` country code of `IO`. */
  Io = 'IO',
  /** The `ISO 3166` country code of `IQ`. */
  Iq = 'IQ',
  /** The `ISO 3166` country code of `IR`. */
  Ir = 'IR',
  /** The `ISO 3166` country code of `IS`. */
  Is = 'IS',
  /** The `ISO 3166` country code of `IT`. */
  It = 'IT',
  /** The `ISO 3166` country code of `JE`. */
  Je = 'JE',
  /** The `ISO 3166` country code of `JM`. */
  Jm = 'JM',
  /** The `ISO 3166` country code of `JO`. */
  Jo = 'JO',
  /** The `ISO 3166` country code of `JP`. */
  Jp = 'JP',
  /** The `ISO 3166` country code of `KE`. */
  Ke = 'KE',
  /** The `ISO 3166` country code of `KG`. */
  Kg = 'KG',
  /** The `ISO 3166` country code of `KH`. */
  Kh = 'KH',
  /** The `ISO 3166` country code of `KI`. */
  Ki = 'KI',
  /** The `ISO 3166` country code of `KM`. */
  Km = 'KM',
  /** The `ISO 3166` country code of `KN`. */
  Kn = 'KN',
  /** The `ISO 3166` country code of `KP`. */
  Kp = 'KP',
  /** The `ISO 3166` country code of `KR`. */
  Kr = 'KR',
  /** The `ISO 3166` country code of `KW`. */
  Kw = 'KW',
  /** The `ISO 3166` country code of `KY`. */
  Ky = 'KY',
  /** The `ISO 3166` country code of `KZ`. */
  Kz = 'KZ',
  /** The `ISO 3166` country code of `LA`. */
  La = 'LA',
  /** The `ISO 3166` country code of `LB`. */
  Lb = 'LB',
  /** The `ISO 3166` country code of `LC`. */
  Lc = 'LC',
  /** The `ISO 3166` country code of `LI`. */
  Li = 'LI',
  /** The `ISO 3166` country code of `LK`. */
  Lk = 'LK',
  /** The `ISO 3166` country code of `LR`. */
  Lr = 'LR',
  /** The `ISO 3166` country code of `LS`. */
  Ls = 'LS',
  /** The `ISO 3166` country code of `LT`. */
  Lt = 'LT',
  /** The `ISO 3166` country code of `LU`. */
  Lu = 'LU',
  /** The `ISO 3166` country code of `LV`. */
  Lv = 'LV',
  /** The `ISO 3166` country code of `LY`. */
  Ly = 'LY',
  /** The `ISO 3166` country code of `MA`. */
  Ma = 'MA',
  /** The `ISO 3166` country code of `MC`. */
  Mc = 'MC',
  /** The `ISO 3166` country code of `MD`. */
  Md = 'MD',
  /** The `ISO 3166` country code of `ME`. */
  Me = 'ME',
  /** The `ISO 3166` country code of `MF`. */
  Mf = 'MF',
  /** The `ISO 3166` country code of `MG`. */
  Mg = 'MG',
  /** The `ISO 3166` country code of `MH`. */
  Mh = 'MH',
  /** The `ISO 3166` country code of `MK`. */
  Mk = 'MK',
  /** The `ISO 3166` country code of `ML`. */
  Ml = 'ML',
  /** The `ISO 3166` country code of `MM`. */
  Mm = 'MM',
  /** The `ISO 3166` country code of `MN`. */
  Mn = 'MN',
  /** The `ISO 3166` country code of `MO`. */
  Mo = 'MO',
  /** The `ISO 3166` country code of `MP`. */
  Mp = 'MP',
  /** The `ISO 3166` country code of `MQ`. */
  Mq = 'MQ',
  /** The `ISO 3166` country code of `MR`. */
  Mr = 'MR',
  /** The `ISO 3166` country code of `MS`. */
  Ms = 'MS',
  /** The `ISO 3166` country code of `MT`. */
  Mt = 'MT',
  /** The `ISO 3166` country code of `MU`. */
  Mu = 'MU',
  /** The `ISO 3166` country code of `MV`. */
  Mv = 'MV',
  /** The `ISO 3166` country code of `MW`. */
  Mw = 'MW',
  /** The `ISO 3166` country code of `MX`. */
  Mx = 'MX',
  /** The `ISO 3166` country code of `MY`. */
  My = 'MY',
  /** The `ISO 3166` country code of `MZ`. */
  Mz = 'MZ',
  /** The `ISO 3166` country code of `NA`. */
  Na = 'NA',
  /** The `ISO 3166` country code of `NC`. */
  Nc = 'NC',
  /** The `ISO 3166` country code of `NE`. */
  Ne = 'NE',
  /** The `ISO 3166` country code of `NF`. */
  Nf = 'NF',
  /** The `ISO 3166` country code of `NG`. */
  Ng = 'NG',
  /** The `ISO 3166` country code of `NI`. */
  Ni = 'NI',
  /** The `ISO 3166` country code of `NL`. */
  Nl = 'NL',
  /** The `ISO 3166` country code of `NO`. */
  No = 'NO',
  /** The `ISO 3166` country code of `NP`. */
  Np = 'NP',
  /** The `ISO 3166` country code of `NR`. */
  Nr = 'NR',
  /** The `ISO 3166` country code of `NS`. */
  Ns = 'NS',
  /** The `ISO 3166` country code of `NU`. */
  Nu = 'NU',
  /** The `ISO 3166` country code of `NZ`. */
  Nz = 'NZ',
  /** The `ISO 3166` country code of `OM`. */
  Om = 'OM',
  /** The `ISO 3166` country code of `PA`. */
  Pa = 'PA',
  /** The `ISO 3166` country code of `PE`. */
  Pe = 'PE',
  /** The `ISO 3166` country code of `PF`. */
  Pf = 'PF',
  /** The `ISO 3166` country code of `PG`. */
  Pg = 'PG',
  /** The `ISO 3166` country code of `PH`. */
  Ph = 'PH',
  /** The `ISO 3166` country code of `PK`. */
  Pk = 'PK',
  /** The `ISO 3166` country code of `PL`. */
  Pl = 'PL',
  /** The `ISO 3166` country code of `PM`. */
  Pm = 'PM',
  /** The `ISO 3166` country code of `PN`. */
  Pn = 'PN',
  /** The `ISO 3166` country code of `PR`. */
  Pr = 'PR',
  /** The `ISO 3166` country code of `PS`. */
  Ps = 'PS',
  /** The `ISO 3166` country code of `PT`. */
  Pt = 'PT',
  /** The `ISO 3166` country code of `PW`. */
  Pw = 'PW',
  /** The `ISO 3166` country code of `PY`. */
  Py = 'PY',
  /** The `ISO 3166` country code of `QA`. */
  Qa = 'QA',
  /** The `ISO 3166` country code of `RE`. */
  Re = 'RE',
  /** The `ISO 3166` country code of `RO`. */
  Ro = 'RO',
  /** The `ISO 3166` country code of `RS`. */
  Rs = 'RS',
  /** The `ISO 3166` country code of `RU`. */
  Ru = 'RU',
  /** The `ISO 3166` country code of `RW`. */
  Rw = 'RW',
  /** The `ISO 3166` country code of `SA`. */
  Sa = 'SA',
  /** The `ISO 3166` country code of `SB`. */
  Sb = 'SB',
  /** The `ISO 3166` country code of `SC`. */
  Sc = 'SC',
  /** The `ISO 3166` country code of `SD`. */
  Sd = 'SD',
  /** The `ISO 3166` country code of `SE`. */
  Se = 'SE',
  /** The `ISO 3166` country code of `SG`. */
  Sg = 'SG',
  /** The `ISO 3166` country code of `SH`. */
  Sh = 'SH',
  /** The `ISO 3166` country code of `SI`. */
  Si = 'SI',
  /** The `ISO 3166` country code of `SJ`. */
  Sj = 'SJ',
  /** The `ISO 3166` country code of `SK`. */
  Sk = 'SK',
  /** The `ISO 3166` country code of `SL`. */
  Sl = 'SL',
  /** The `ISO 3166` country code of `SM`. */
  Sm = 'SM',
  /** The `ISO 3166` country code of `SN`. */
  Sn = 'SN',
  /** The `ISO 3166` country code of `SO`. */
  So = 'SO',
  /** The `ISO 3166` country code of `SR`. */
  Sr = 'SR',
  /** The `ISO 3166` country code of `SS`. */
  Ss = 'SS',
  /** The `ISO 3166` country code of `ST`. */
  St = 'ST',
  /** The `ISO 3166` country code of `SV`. */
  Sv = 'SV',
  /** The `ISO 3166` country code of `SX`. */
  Sx = 'SX',
  /** The `ISO 3166` country code of `SY`. */
  Sy = 'SY',
  /** The `ISO 3166` country code of `SZ`. */
  Sz = 'SZ',
  /** The `ISO 3166` country code of `TA`. */
  Ta = 'TA',
  /** The `ISO 3166` country code of `TC`. */
  Tc = 'TC',
  /** The `ISO 3166` country code of `TD`. */
  Td = 'TD',
  /** The `ISO 3166` country code of `TF`. */
  Tf = 'TF',
  /** The `ISO 3166` country code of `TG`. */
  Tg = 'TG',
  /** The `ISO 3166` country code of `TH`. */
  Th = 'TH',
  /** The `ISO 3166` country code of `TJ`. */
  Tj = 'TJ',
  /** The `ISO 3166` country code of `TK`. */
  Tk = 'TK',
  /** The `ISO 3166` country code of `TL`. */
  Tl = 'TL',
  /** The `ISO 3166` country code of `TM`. */
  Tm = 'TM',
  /** The `ISO 3166` country code of `TN`. */
  Tn = 'TN',
  /** The `ISO 3166` country code of `TO`. */
  To = 'TO',
  /** The `ISO 3166` country code of `TR`. */
  Tr = 'TR',
  /** The `ISO 3166` country code of `TT`. */
  Tt = 'TT',
  /** The `ISO 3166` country code of `TV`. */
  Tv = 'TV',
  /** The `ISO 3166` country code of `TW`. */
  Tw = 'TW',
  /** The `ISO 3166` country code of `TZ`. */
  Tz = 'TZ',
  /** The `ISO 3166` country code of `UA`. */
  Ua = 'UA',
  /** The `ISO 3166` country code of `UG`. */
  Ug = 'UG',
  /** The `ISO 3166` country code of `UM`. */
  Um = 'UM',
  /** The `ISO 3166` country code of `US`. */
  Us = 'US',
  /** The `ISO 3166` country code of `UY`. */
  Uy = 'UY',
  /** The `ISO 3166` country code of `UZ`. */
  Uz = 'UZ',
  /** The `ISO 3166` country code of `VA`. */
  Va = 'VA',
  /** The `ISO 3166` country code of `VC`. */
  Vc = 'VC',
  /** The `ISO 3166` country code of `VE`. */
  Ve = 'VE',
  /** The `ISO 3166` country code of `VG`. */
  Vg = 'VG',
  /** The `ISO 3166` country code of `VI`. */
  Vi = 'VI',
  /** The `ISO 3166` country code of `VN`. */
  Vn = 'VN',
  /** The `ISO 3166` country code of `VU`. */
  Vu = 'VU',
  /** The `ISO 3166` country code of `WF`. */
  Wf = 'WF',
  /** The `ISO 3166` country code of `WS`. */
  Ws = 'WS',
  /** The `ISO 3166` country code of `XK`. */
  Xk = 'XK',
  /** The `ISO 3166` country code of `XX`. */
  Xx = 'XX',
  /** The `ISO 3166` country code of `YE`. */
  Ye = 'YE',
  /** The `ISO 3166` country code of `YT`. */
  Yt = 'YT',
  /** The `ISO 3166` country code of `ZA`. */
  Za = 'ZA',
  /** The `ISO 3166` country code of `ZM`. */
  Zm = 'ZM',
  /** The `ISO 3166` country code of `ZW`. */
  Zw = 'ZW'
}

/** Return type for `privacyFeaturesDisable` mutation. */
export type PrivacyFeaturesDisablePayload = {
  __typename?: 'PrivacyFeaturesDisablePayload';
  /** The privacy features that were disabled. */
  featuresDisabled?: Maybe<Array<PrivacyFeaturesEnum>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PrivacyFeaturesDisableUserError>;
};

/** An error that occurs during the execution of `PrivacyFeaturesDisable`. */
export type PrivacyFeaturesDisableUserError = DisplayableError & {
  __typename?: 'PrivacyFeaturesDisableUserError';
  /** The error code. */
  code?: Maybe<PrivacyFeaturesDisableUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PrivacyFeaturesDisableUserError`. */
export enum PrivacyFeaturesDisableUserErrorCode {
  /** Failed to disable privacy features. */
  Failed = 'FAILED'
}

/** The input fields for a shop's privacy settings. */
export enum PrivacyFeaturesEnum {
  /** The cookie banner feature. */
  CookieBanner = 'COOKIE_BANNER',
  /** The data sale opt out page feature. */
  DataSaleOptOutPage = 'DATA_SALE_OPT_OUT_PAGE',
  /** The privacy policy feature. */
  PrivacyPolicy = 'PRIVACY_POLICY'
}

/** A shop's privacy policy settings. */
export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  /** Whether the policy is auto managed. */
  autoManaged: Scalars['Boolean']['output'];
  /** Policy template supported locales. */
  supportedLocales: Array<Scalars['String']['output']>;
};

/** A shop's privacy settings. */
export type PrivacySettings = {
  __typename?: 'PrivacySettings';
  /** Banner customizations for the 'cookie banner'. */
  banner?: Maybe<CookieBanner>;
  /** A shop's data sale opt out page (e.g. CCPA). */
  dataSaleOptOutPage?: Maybe<DataSaleOptOutPage>;
  /** A shop's privacy policy settings. */
  privacyPolicy?: Maybe<PrivacyPolicy>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type Product = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & LegacyInteroperability & Navigable & Node & OnlineStorePreviewable & Publishable & {
  __typename?: 'Product';
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  availablePublicationsCount?: Maybe<Count>;
  /**
   * The description of the product, with
   * HTML tags. For example, the description might include
   * bold `<strong></strong>` and italic `<i></i>` text.
   * @deprecated Use `descriptionHtml` instead.
   */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /**
   * A list of [components](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-product-fixed-bundle)
   * that are associated with a product in a bundle.
   */
  bundleComponents: ProductBundleComponentConnection;
  /** A list of consolidated options for a product in a bundle. */
  bundleConsolidatedOptions?: Maybe<Array<ComponentizedProductsBundleConsolidatedOption>>;
  /**
   * The category of a product
   * from [Shopify's Standard Product Taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17).
   */
  category?: Maybe<TaxonomyCategory>;
  /**
   * A list of [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection)
   * that include the product.
   */
  collections: CollectionConnection;
  /**
   * A special product type that combines separate products from a store into a single product listing.
   * [Combined listings](https://shopify.dev/apps/build/product-merchandising/combined-listings) are connected
   * by a shared option, such as color, model, or dimension.
   */
  combinedListing?: Maybe<CombinedListing>;
  /**
   * The [role of the product](https://shopify.dev/docs/apps/build/product-merchandising/combined-listings/build-for-combined-listings)
   * in a combined listing.
   *
   * If `null`, then the product isn't part of any combined listing.
   */
  combinedListingRole?: Maybe<CombinedListingsRole>;
  /**
   * The [compare-at price range](https://help.shopify.com/manual/products/details/product-pricing/sale-pricing)
   * of the product in the shop's default currency.
   */
  compareAtPriceRange?: Maybe<ProductCompareAtPriceRange>;
  /** The pricing that applies to a customer in a specific context. For example, a price might vary depending on the customer's location. Only active markets are considered in the price resolution. */
  contextualPricing: ProductContextualPricing;
  /** The date and time when the product was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The custom product type specified by the merchant.
   * @deprecated Use `productType` instead.
   */
  customProductType?: Maybe<Scalars['String']['output']>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /**
   * A single-line description of the product,
   * with [HTML tags](https://developer.mozilla.org/en-US/docs/Web/HTML) removed.
   */
  description: Scalars['String']['output'];
  /**
   * The description of the product, with
   * HTML tags. For example, the description might include
   * bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml: Scalars['HTML']['output'];
  /**
   * Stripped description of the product, single line with HTML tags removed.
   * Truncated to 60 characters.
   * @deprecated Use `description` instead.
   */
  descriptionPlainSummary: Scalars['String']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /**
   * The featured image for the product.
   * @deprecated Use `featuredMedia` instead.
   */
  featuredImage?: Maybe<Image>;
  /**
   * The featured [media](https://shopify.dev/docs/apps/build/online-store/product-media)
   * associated with the product.
   */
  featuredMedia?: Maybe<Media>;
  /**
   * The information that lets merchants know what steps they need to take
   * to make sure that the app is set up correctly.
   *
   * For example, if a merchant hasn't set up a product correctly in the app,
   * then the feedback might include a message that says "You need to add a price
   * to this product".
   */
  feedback?: Maybe<ResourceFeedback>;
  /** The gift card settings for this product. Only available on gift card products. */
  giftCardSettings?: Maybe<GiftCardProductSettings>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view the gift card in a store. */
  giftCardTemplateSuffix?: Maybe<Scalars['String']['output']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   */
  handle: Scalars['String']['output'];
  /** Whether the product has only a single variant with the default option and value. */
  hasOnlyDefaultVariant: Scalars['Boolean']['output'];
  /** Whether the product has variants that are out of stock. */
  hasOutOfStockVariants: Scalars['Boolean']['output'];
  /**
   * Whether at least one of the product variants requires
   * [bundle components](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-product-fixed-bundle).
   *
   * Learn more about
   * [store eligibility for bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles#store-eligibility).
   */
  hasVariantsThatRequiresComponents: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The images associated with the product.
   * @deprecated Use `media` instead.
   */
  images: ImageConnection;
  /**
   * Whether the product
   * is in a specified
   * [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
   */
  inCollection: Scalars['Boolean']['output'];
  /** Whether the product is a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The [media](https://shopify.dev/docs/apps/build/online-store/product-media) associated with the product. Valid media are images, 3D models, videos. */
  media: MediaConnection;
  /**
   * The total count of [media](https://shopify.dev/docs/apps/build/online-store/product-media)
   * that's associated with a product.
   */
  mediaCount?: Maybe<Count>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The [preview URL](https://help.shopify.com/manual/online-store/setting-up#preview-your-store) for the online store. */
  onlineStorePreviewUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The product's URL on the online store.
   * If `null`, then the product isn't published to the online store sales channel.
   */
  onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * A list of product options. The limit is defined by the
   * [shop's resource limits for product options](https://shopify.dev/docs/api/admin-graphql/latest/objects/Shop#field-resourcelimits) (`Shop.resourceLimits.maxProductOptions`).
   */
  options: Array<ProductOption>;
  /**
   * The price range of the product.
   * @deprecated Use `priceRangeV2` instead.
   */
  priceRange: ProductPriceRange;
  /**
   * The minimum and maximum prices of a product, expressed in decimal numbers.
   * For example, if the product is priced between $10.00 and $50.00,
   * then the price range is $10.00 - $50.00.
   */
  priceRangeV2: ProductPriceRangeV2;
  /**
   * The product category specified by the merchant.
   * @deprecated Use `category` instead.
   */
  productCategory?: Maybe<ProductCategory>;
  /**
   * A list of products that contain at least one variant associated with
   * at least one of the current products' variants via group relationship.
   */
  productComponents: ProductComponentTypeConnection;
  /**
   * A count of unique products that contain at least one variant associated with
   * at least one of the current products' variants via group relationship.
   */
  productComponentsCount?: Maybe<Count>;
  /** A list of products that has a variant that contains any of this product's variants as a component. */
  productParents: ProductConnection;
  /**
   * A list of the channels where the product is published.
   * @deprecated Use `resourcePublications` instead.
   */
  productPublications: ProductPublicationConnection;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType: Scalars['String']['output'];
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  publicationCount: Scalars['Int']['output'];
  /**
   * A list of the channels where the product is published.
   * @deprecated Use `resourcePublications` instead.
   */
  publications: ProductPublicationConnection;
  /** The date and time when the product was published to the online store. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the product is published for a customer only in a specified context. For example, a product might be published for a customer only in a specific location. */
  publishedInContext: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  publishedOnCurrentChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  publishedOnPublication: Scalars['Boolean']['output'];
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan: true`), then the product is unpublished from all channels, except the online store.
   */
  requiresSellingPlan: Scalars['Boolean']['output'];
  /**
   * The resource that's either published or staged to be published to
   * the [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * @deprecated Use `resourcePublications` instead.
   */
  resourcePublicationOnCurrentPublication?: Maybe<ResourcePublicationV2>;
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  resourcePublications: ResourcePublicationConnection;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   */
  resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * By default, only publications to `APP` catalog types are returned.
   * For `Product` and `ProductVariant`, use the `catalogType` argument to retrieve
   * publications for other catalog types, such as `COMPANY_LOCATION` (B2B) or `MARKET`.
   * `Collection` only supports publications to `APP` catalog types.
   */
  resourcePublicationsV2: ResourcePublicationV2Connection;
  /**
   * Whether the merchant can make changes to the product when they
   * [edit the order](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders)
   * associated with the product. For example, a merchant might be restricted from changing product details when they
   * edit an order.
   */
  restrictedForResource?: Maybe<RestrictedForResource>;
  /**
   * A count of [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product.
   * @deprecated Use `sellingPlanGroupsCount` instead.
   */
  sellingPlanGroupCount: Scalars['Int']['output'];
  /**
   * A list of all [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product either directly, or through the product's variants.
   */
  sellingPlanGroups: SellingPlanGroupConnection;
  /**
   * A count of [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product.
   */
  sellingPlanGroupsCount?: Maybe<Count>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo: Seo;
  /**
   * The standardized product type in the Shopify product taxonomy.
   * @deprecated Use `productCategory` instead.
   */
  standardizedProductType?: Maybe<StandardizedProductType>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  status: ProductStatus;
  /**
   * The Storefront GraphQL API ID of the `Product`.
   *
   * The Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  storefrontId: Scalars['StorefrontID']['output'];
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites
   * any existing tags that were previously added to the product. To add new tags without overwriting
   * existing tags, use the [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags: Array<Scalars['String']['output']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view the product in a store. */
  templateSuffix?: Maybe<Scalars['String']['output']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  title: Scalars['String']['output'];
  /** The quantity of inventory that's in stock. */
  totalInventory: Scalars['Int']['output'];
  /**
   * The number of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * that are associated with the product.
   * @deprecated Use `variantsCount` instead.
   */
  totalVariants: Scalars['Int']['output'];
  /**
   * Whether [inventory tracking](https://help.shopify.com/manual/products/inventory/getting-started-with-inventory/set-up-inventory-tracking)
   * has been enabled for the product.
   */
  tracksInventory: Scalars['Boolean']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  unpublishedPublications: PublicationConnection;
  /**
   * The date and time when the product was last modified.
   * A product's `updatedAt` value can change for different reasons. For example, if an order
   * is placed for a product that has inventory tracking set up, then the inventory adjustment
   * is counted as an update.
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * A list of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) associated with the product.
   * If querying a single product at the root, you can fetch up to 2048 variants.
   */
  variants: ProductVariantConnection;
  /**
   * The number of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * that are associated with the product.
   */
  variantsCount?: Maybe<Count>;
  /**
   * A list of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * associated with the product that are members of the specified
   * [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   *
   * Returns null for products whose collection membership is product-scoped rather than variant-scoped.
   */
  variantsInCollection?: Maybe<ProductVariantConnection>;
  /**
   * The number of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * associated with the product that are members of the specified
   * [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   */
  variantsInCollectionCount?: Maybe<Count>;
  /** The name of the product's vendor. */
  vendor: Scalars['String']['output'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductBundleComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductContextualPricingArgs = {
  context: ContextualPricingContext;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductInCollectionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductMediaSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductProductComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductProductParentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedInContextArgs = {
  context: ContextualPublicationContext;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedOnChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedOnPublicationArgs = {
  publicationId: Scalars['ID']['input'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductRestrictedForResourceArgs = {
  calculatedOrderId: Scalars['ID']['input'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductVariantsInCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductVariantsInCollectionCountArgs = {
  collectionId: Scalars['ID']['input'];
};

/** The product's component information. */
export type ProductBundleComponent = {
  __typename?: 'ProductBundleComponent';
  /** The product that's related as a component. */
  componentProduct: Product;
  /** The list of products' variants that are components. */
  componentVariants: ProductVariantConnection;
  /** The number of component variants for the product component. */
  componentVariantsCount?: Maybe<Count>;
  /**
   * The options in the parent and the component options they're connected to, along with the chosen option values
   * that appear in the bundle.
   */
  optionSelections: Array<ProductBundleComponentOptionSelection>;
  /**
   * The quantity of the component product set for this bundle line.
   * It will be null if there's a quantityOption present.
   */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The quantity as option of the component product. It will be null if there's a quantity set. */
  quantityOption?: Maybe<ProductBundleComponentQuantityOption>;
};


/** The product's component information. */
export type ProductBundleComponentComponentVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple ProductBundleComponents. */
export type ProductBundleComponentConnection = {
  __typename?: 'ProductBundleComponentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductBundleComponentEdge>;
  /** A list of nodes that are contained in ProductBundleComponentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductBundleComponent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductBundleComponent and a cursor during pagination. */
export type ProductBundleComponentEdge = {
  __typename?: 'ProductBundleComponentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductBundleComponentEdge. */
  node: ProductBundleComponent;
};

/** The input fields for a single component related to a componentized product. */
export type ProductBundleComponentInput = {
  /** The options to use in the component product, and the values for the option. */
  optionSelections: Array<ProductBundleComponentOptionSelectionInput>;
  /** The ID of the component product to add to the bundle product. */
  productId: Scalars['ID']['input'];
  /** The quantity of the component product to add to the bundle product. This field can't exceed 2000. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * New option to be created on the bundle parent that enables the buyer to select different quantities for
   * this component (e.g. two-pack, three-pack). Can only be used if quantity isn't set.
   */
  quantityOption?: InputMaybe<ProductBundleComponentQuantityOptionInput>;
};

/** A relationship between a component option and a parent option. */
export type ProductBundleComponentOptionSelection = {
  __typename?: 'ProductBundleComponentOptionSelection';
  /** The option that existed on the component product prior to the fixed bundle creation. */
  componentOption: ProductOption;
  /** The option that was created on the parent product. */
  parentOption?: Maybe<ProductOption>;
  /** The component option values that are actively selected for this relationship. */
  values: Array<ProductBundleComponentOptionSelectionValue>;
};

/** The input fields for a single option related to a component product. */
export type ProductBundleComponentOptionSelectionInput = {
  /** The ID of the option present on the component product. */
  componentOptionId: Scalars['ID']['input'];
  /** The name to create for this option on the parent product. */
  name: Scalars['String']['input'];
  /** Array of selected option values. */
  values: Array<Scalars['String']['input']>;
};

/** The status of a component option value related to a bundle. */
export enum ProductBundleComponentOptionSelectionStatus {
  /** The component option value is not selected as sellable in the bundle. */
  Deselected = 'DESELECTED',
  /** The component option value was not initially selected, but is now available for the bundle. */
  New = 'NEW',
  /** The component option value is selected as sellable in the bundle. */
  Selected = 'SELECTED',
  /** The component option value was selected, is no longer available for the bundle. */
  Unavailable = 'UNAVAILABLE'
}

/** A component option value related to a bundle line. */
export type ProductBundleComponentOptionSelectionValue = {
  __typename?: 'ProductBundleComponentOptionSelectionValue';
  /** Selection status of the option. */
  selectionStatus: ProductBundleComponentOptionSelectionStatus;
  /** The value of the option. */
  value: Scalars['String']['output'];
};

/** A quantity option related to a bundle. */
export type ProductBundleComponentQuantityOption = {
  __typename?: 'ProductBundleComponentQuantityOption';
  /** The name of the option value. */
  name: Scalars['String']['output'];
  /** The option that was created on the parent product. */
  parentOption?: Maybe<ProductOption>;
  /** The quantity values of the option. */
  values: Array<ProductBundleComponentQuantityOptionValue>;
};

/** Input for the quantity option related to a component product. This will become a new option on the parent bundle product that doesn't have a corresponding option on the component. */
export type ProductBundleComponentQuantityOptionInput = {
  /** The option name to create on the parent product. */
  name: Scalars['String']['input'];
  /** Array of option values. */
  values: Array<ProductBundleComponentQuantityOptionValueInput>;
};

/** A quantity option value related to a componentized product. */
export type ProductBundleComponentQuantityOptionValue = {
  __typename?: 'ProductBundleComponentQuantityOptionValue';
  /** The name of the option value. */
  name: Scalars['String']['output'];
  /** The quantity of the option value. */
  quantity: Scalars['Int']['output'];
};

/** The input fields for a single quantity option value related to a component product. */
export type ProductBundleComponentQuantityOptionValueInput = {
  /** The name associated with the option, e.g. one-pack, two-pack. */
  name: Scalars['String']['input'];
  /** How many of the variant will be included for the option value (e.g. two-pack has quantity 2). */
  quantity: Scalars['Int']['input'];
};

/** The input fields for mapping a consolidated option to a specific component option. */
export type ProductBundleConsolidatedOptionComponentInput = {
  /**
   * The ID of the component option that this consolidated option maps to.
   * If null, this selection targets the component's quantity option with the given name.
   */
  componentOptionId?: InputMaybe<Scalars['ID']['input']>;
  /** The value to use for the component option (e.g., 'Small', 'Red'). */
  componentOptionValue: Scalars['String']['input'];
};

/** The input fields for a consolidated option on a componentized product. */
export type ProductBundleConsolidatedOptionInput = {
  /** The name of the consolidated option (e.g., 'Size', 'Color'). */
  optionName: Scalars['String']['input'];
  /** The option selections that define how this consolidated option maps to component options. */
  optionSelections: Array<ProductBundleConsolidatedOptionSelectionInput>;
};

/** The input fields for a consolidated option selection that maps to component options. */
export type ProductBundleConsolidatedOptionSelectionInput = {
  /** The component mappings that define how this option value maps to specific component options. */
  components: Array<ProductBundleConsolidatedOptionComponentInput>;
  /** The value for this consolidated option selection (e.g., 'Small', 'Medium', 'Large'). */
  optionValue: Scalars['String']['input'];
};

/** The input fields for creating a componentized product. */
export type ProductBundleCreateInput = {
  /** The component products to bundle with the bundle product. */
  components: Array<ProductBundleComponentInput>;
  /** The consolidated options of the componentized product to create, if provided. */
  consolidatedOptions?: InputMaybe<Array<ProductBundleConsolidatedOptionInput>>;
  /** The title of the product to create. */
  title: Scalars['String']['input'];
};

/** Return type for `productBundleCreate` mutation. */
export type ProductBundleCreatePayload = {
  __typename?: 'ProductBundleCreatePayload';
  /** The asynchronous ProductBundleOperation creating the product bundle or componentized product. */
  productBundleOperation?: Maybe<ProductBundleOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Defines errors encountered while managing a product bundle. */
export type ProductBundleMutationUserError = DisplayableError & {
  __typename?: 'ProductBundleMutationUserError';
  /** The error code. */
  code?: Maybe<ProductBundleMutationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductBundleMutationUserError`. */
export enum ProductBundleMutationUserErrorCode {
  /** Something went wrong, please try again. */
  GenericError = 'GENERIC_ERROR',
  /** Input is not valid. */
  InvalidInput = 'INVALID_INPUT',
  /** Error processing request in the background job. */
  JobError = 'JOB_ERROR',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST'
}

/**
 * An entity that represents details of an asynchronous
 * [ProductBundleCreate](https://shopify.dev/api/admin-graphql/current/mutations/productBundleCreate) or
 * [ProductBundleUpdate](https://shopify.dev/api/admin-graphql/current/mutations/productBundleUpdate) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned when the bundle was created or updated, this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the created or updated product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductBundleOperation = Node & ProductOperation & {
  __typename?: 'ProductBundleOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product on which the operation is being performed. */
  product?: Maybe<Product>;
  /** The status of this operation. */
  status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  userErrors: Array<ProductBundleMutationUserError>;
};

/** The input fields for updating a componentized product. */
export type ProductBundleUpdateInput = {
  /** The components to update existing ones. If none provided, no changes occur. Note: This replaces, not adds to, current components. */
  components?: InputMaybe<Array<ProductBundleComponentInput>>;
  /** The consolidated options of the componentized product to update, if provided. */
  consolidatedOptions?: InputMaybe<Array<ProductBundleConsolidatedOptionInput>>;
  /** The ID of the componentized product to update. */
  productId: Scalars['ID']['input'];
  /** The title to rename the componentized product to, if provided. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `productBundleUpdate` mutation. */
export type ProductBundleUpdatePayload = {
  __typename?: 'ProductBundleUpdatePayload';
  /** The asynchronous ProductBundleOperation updating the product bundle or componentized product. */
  productBundleOperation?: Maybe<ProductBundleOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The details of a specific product category within Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). Provides access to the associated [`ProductTaxonomyNode`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductTaxonomyNode). */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** The product taxonomy node associated with the product category. */
  productTaxonomyNode?: Maybe<ProductTaxonomyNode>;
};

/** Return type for `productChangeStatus` mutation. */
export type ProductChangeStatusPayload = {
  __typename?: 'ProductChangeStatusPayload';
  /** The product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductChangeStatusUserError>;
};

/** An error that occurs during the execution of `ProductChangeStatus`. */
export type ProductChangeStatusUserError = DisplayableError & {
  __typename?: 'ProductChangeStatusUserError';
  /** The error code. */
  code?: Maybe<ProductChangeStatusUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductChangeStatusUserError`. */
export enum ProductChangeStatusUserErrorCode {
  /** Cannot be unarchived because combined listings are not compatible with this store. */
  CombinedListingsNotCompatibleWithShop = 'COMBINED_LISTINGS_NOT_COMPATIBLE_WITH_SHOP',
  /** Product could not be found. */
  ProductNotFound = 'PRODUCT_NOT_FOUND'
}

/** The input fields to claim ownership for Product features such as Bundles. */
export type ProductClaimOwnershipInput = {
  /**
   * Claiming ownership of bundles lets the app render a custom UI for the bundles' card on the
   * products details page in the Shopify admin.
   *
   * Bundle ownership can only be claimed when creating the product. If you create `ProductVariantComponents`
   * in any of its product variants, then the bundle ownership is automatically assigned to the app making the call.
   *
   * [Learn more](https://shopify.dev/docs/apps/selling-strategies/bundles/product-config).
   */
  bundles?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The set of valid sort keys for products belonging to a collection. */
export enum ProductCollectionSortKeys {
  /** Sort by best selling. */
  BestSelling = 'BEST_SELLING',
  /** Sort by collection default order. */
  CollectionDefault = 'COLLECTION_DEFAULT',
  /** Sort by creation time. */
  Created = 'CREATED',
  /** Sort by id. */
  Id = 'ID',
  /** Sort by manual order. */
  Manual = 'MANUAL',
  /** Sort by price. */
  Price = 'PRICE',
  /** Sort by relevance. */
  Relevance = 'RELEVANCE',
  /** Sort by title. */
  Title = 'TITLE'
}

/** The compare-at price range of the product. */
export type ProductCompareAtPriceRange = {
  __typename?: 'ProductCompareAtPriceRange';
  /** The highest variant's compare-at price. */
  maxVariantCompareAtPrice: MoneyV2;
  /** The lowest variant's compare-at price. */
  minVariantCompareAtPrice: MoneyV2;
};

/** The product component information. */
export type ProductComponentType = {
  __typename?: 'ProductComponentType';
  /** The list of products' variants that are components. */
  componentVariants: ProductVariantConnection;
  /** The number of component variants for the product component. */
  componentVariantsCount?: Maybe<Count>;
  /** The list of products' variants that are not components. */
  nonComponentVariants: ProductVariantConnection;
  /** The number of non_components variants for the product component. */
  nonComponentVariantsCount?: Maybe<Count>;
  /** The product that's a component. */
  product: Product;
};


/** The product component information. */
export type ProductComponentTypeComponentVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The product component information. */
export type ProductComponentTypeNonComponentVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple ProductComponentTypes. */
export type ProductComponentTypeConnection = {
  __typename?: 'ProductComponentTypeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductComponentTypeEdge>;
  /** A list of nodes that are contained in ProductComponentTypeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductComponentType>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductComponentType and a cursor during pagination. */
export type ProductComponentTypeEdge = {
  __typename?: 'ProductComponentTypeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductComponentTypeEdge. */
  node: ProductComponentType;
};

/** An auto-generated type for paginating through multiple Products. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductEdge>;
  /** A list of nodes that are contained in ProductEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Product>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The price of a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) in a specific country. Shows the minimum and maximum variant prices through the price range and the count of fixed quantity rules that apply to the product's variants in the given pricing context. */
export type ProductContextualPricing = {
  __typename?: 'ProductContextualPricing';
  /** The number of fixed quantity rules for the product's variants on the price list. */
  fixedQuantityRulesCount: Scalars['Int']['output'];
  /** The pricing of the variant with the highest price in the given context. */
  maxVariantPricing?: Maybe<ProductVariantContextualPricing>;
  /** The pricing of the variant with the lowest price in the given context. */
  minVariantPricing?: Maybe<ProductVariantContextualPricing>;
  /**
   * The minimum and maximum prices of a product, expressed in decimal numbers.
   * For example, if the product is priced between $10.00 and $50.00,
   * then the price range is $10.00 - $50.00.
   */
  priceRange: ProductPriceRangeV2;
};

/** The input fields required to create a product. */
export type ProductCreateInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** A list of collection IDs to associate with the product. */
  collectionsToJoin?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The role of the product in a [combined listing](https://shopify.dev/apps/build/product-merchandising/combined-listings). */
  combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** Whether the product is a gift card. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  giftCardTemplateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-readable string that's used to identify the product in URLs. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated (unless that handle
   * is already taken, in which case a suffix is added to make the handle unique).
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** A list of product options and option values. Maximum product options: three. There's no limit on the number of option values. */
  productOptions?: InputMaybe<Array<OptionCreateInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan: true`), then the product is unpublished from all channels except the online store.
   */
  requiresSellingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  status?: InputMaybe<ProductStatus>;
  /**
   * A list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name for the product that displays to customers. If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated.
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product's vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `productCreateMedia` mutation. */
export type ProductCreateMediaPayload = {
  __typename?: 'ProductCreateMediaPayload';
  /** The newly created media. */
  media?: Maybe<Array<Media>>;
  /** The list of errors that occurred from executing the mutation. */
  mediaUserErrors: Array<MediaUserError>;
  /** The product associated with the media. */
  product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  userErrors: Array<UserError>;
};

/** Return type for `productCreate` mutation. */
export type ProductCreatePayload = {
  __typename?: 'ProductCreatePayload';
  /** The product object. */
  product?: Maybe<Product>;
  /** The shop associated with the product. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for specifying the product to delete. */
export type ProductDeleteInput = {
  /** The ID of the product. */
  id: Scalars['ID']['input'];
};

/** Return type for `productDeleteMedia` mutation. */
export type ProductDeleteMediaPayload = {
  __typename?: 'ProductDeleteMediaPayload';
  /** List of media IDs which were deleted. */
  deletedMediaIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of product image IDs which were deleted. */
  deletedProductImageIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  mediaUserErrors: Array<MediaUserError>;
  /** The product associated with the deleted media. */
  product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  userErrors: Array<UserError>;
};

/**
 * An entity that represents details of an asynchronous
 * [ProductDelete](https://shopify.dev/api/admin-graphql/current/mutations/productDelete) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned when the product was deleted, this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `deletedProductId` field provides the ID of the deleted product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductDeleteOperation = Node & ProductOperation & {
  __typename?: 'ProductDeleteOperation';
  /** The ID of the deleted product. */
  deletedProductId?: Maybe<Scalars['ID']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product on which the operation is being performed. */
  product?: Maybe<Product>;
  /** The status of this operation. */
  status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  userErrors: Array<UserError>;
};

/** Return type for `productDelete` mutation. */
export type ProductDeletePayload = {
  __typename?: 'ProductDeletePayload';
  /** The ID of the deleted product. */
  deletedProductId?: Maybe<Scalars['ID']['output']>;
  /** The product delete operation, returned when run in asynchronous mode. */
  productDeleteOperation?: Maybe<ProductDeleteOperation>;
  /** The shop associated with the product. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * Controls which product discounts can apply together on the same cart line. By
 * default, only one product discount applies per line. Available only on a Shopify
 * Plus plan.
 *
 * For discounts to apply together, they must match tags in both directions. Each
 * discount has two tag sets: the tags that identify the discount, and the tags that
 * it agrees to apply with. Use the `tags` field on the discount input to set the
 * discount's own tags. Use this input object to set the tags that the discount can
 * apply with. Two discounts apply together only if each one allows at least one tag
 * that the other is tagged with. Any number of product discounts can apply to the
 * same line if this two-way match holds for every pair in the group.
 *
 * Example: Discount A is tagged with `LOYALTY` and allows `SEASONAL`, and Discount B
 * is tagged with `SEASONAL` and allows `LOYALTY`. They apply together. To add a
 * third discount, it must meet the same mutual-match rule with both A and B.
 *
 * Buy X Get Y discounts stack only on the customer-gets products (GY), not the
 * customer-buys products (BX). See
 * [Limitations for discount combinations](https://help.shopify.com/manual/discounts/discount-combinations#considerations)
 * for details.
 */
export type ProductDiscountsWithTagsOnSameCartLineInput = {
  /**
   * The tags to add to this discount's combination list. This field doesn't add
   * tags to the discount itself. To change the tags on the discount, use the
   * discount input's `tags` field or the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * and [`tagsRemove`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsremove)
   * mutations.
   *
   * If another product discount has a matching tag and also allows at least one
   * tag on this discount, then both discounts can apply to the same cart line.
   */
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The tags to remove from this discount's combination list. This field doesn't
   * remove tags from the discount itself. To change the tags on the discount, use
   * the discount input's `tags` field or the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * and [`tagsRemove`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsremove)
   * mutations.
   *
   * If this discount and another product discount still match tags in both
   * directions after the removal, then both discounts can still apply to the same
   * cart line.
   */
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a product duplication job. */
export type ProductDuplicateJob = {
  __typename?: 'ProductDuplicateJob';
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
};

/**
 * An entity that represents details of an asynchronous
 * [ProductDuplicate](https://shopify.dev/api/admin-graphql/current/mutations/productDuplicate) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned
 * [when the product was duplicated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously),
 * this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the original product.
 *
 * The `newProduct` field provides the details of the new duplicate of the product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductDuplicateOperation = Node & ProductOperation & {
  __typename?: 'ProductDuplicateOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The newly created duplicate of the original product. */
  newProduct?: Maybe<Product>;
  /** The product on which the operation is being performed. */
  product?: Maybe<Product>;
  /** The status of this operation. */
  status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  userErrors: Array<UserError>;
};

/** Return type for `productDuplicate` mutation. */
export type ProductDuplicatePayload = {
  __typename?: 'ProductDuplicatePayload';
  /** The asynchronous job that duplicates the product images. */
  imageJob?: Maybe<Job>;
  /** The duplicated product. */
  newProduct?: Maybe<Product>;
  /** The product duplicate operation, returned when run in asynchronous mode. */
  productDuplicateOperation?: Maybe<ProductDuplicateOperation>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one Product and a cursor during pagination. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductEdge. */
  node: Product;
};

/** A product feed. */
export type ProductFeed = Node & {
  __typename?: 'ProductFeed';
  /** The ID of the channel to associate with the product feed. */
  channelId: Scalars['ID']['output'];
  /** The country of the product feed. */
  country?: Maybe<CountryCode>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The language of the product feed. */
  language?: Maybe<LanguageCode>;
  /** The status of the product feed. */
  status: ProductFeedStatus;
};

/** An auto-generated type for paginating through multiple ProductFeeds. */
export type ProductFeedConnection = {
  __typename?: 'ProductFeedConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductFeedEdge>;
  /** A list of nodes that are contained in ProductFeedEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductFeed>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `productFeedCreate` mutation. */
export type ProductFeedCreatePayload = {
  __typename?: 'ProductFeedCreatePayload';
  /** The newly created product feed. */
  productFeed?: Maybe<ProductFeed>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductFeedCreateUserError>;
};

/** An error that occurs during the execution of `ProductFeedCreate`. */
export type ProductFeedCreateUserError = DisplayableError & {
  __typename?: 'ProductFeedCreateUserError';
  /** The error code. */
  code?: Maybe<ProductFeedCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductFeedCreateUserError`. */
export enum ProductFeedCreateUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input value is already taken. */
  Taken = 'TAKEN'
}

/** Return type for `productFeedDelete` mutation. */
export type ProductFeedDeletePayload = {
  __typename?: 'ProductFeedDeletePayload';
  /** The ID of the product feed that was deleted. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductFeedDeleteUserError>;
};

/** An error that occurs during the execution of `ProductFeedDelete`. */
export type ProductFeedDeleteUserError = DisplayableError & {
  __typename?: 'ProductFeedDeleteUserError';
  /** The error code. */
  code?: Maybe<ProductFeedDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductFeedDeleteUserError`. */
export enum ProductFeedDeleteUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** An auto-generated type which holds one ProductFeed and a cursor during pagination. */
export type ProductFeedEdge = {
  __typename?: 'ProductFeedEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductFeedEdge. */
  node: ProductFeed;
};

/** The input fields required to create a product feed. */
export type ProductFeedInput = {
  /** The ID of the channel to associate with the product feed. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** The country of the product feed. */
  country: CountryCode;
  /** The language of the product feed. */
  language: LanguageCode;
};

/** The valid values for the status of product feed. */
export enum ProductFeedStatus {
  /** The product feed is active. */
  Active = 'ACTIVE',
  /** The product feed is inactive. */
  Inactive = 'INACTIVE'
}

/** Return type for `productFullSync` mutation. */
export type ProductFullSyncPayload = {
  __typename?: 'ProductFullSyncPayload';
  /** The ID for the full sync operation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductFullSyncUserError>;
};

/** An error that occurs during the execution of `ProductFullSync`. */
export type ProductFullSyncUserError = DisplayableError & {
  __typename?: 'ProductFullSyncUserError';
  /** The error code. */
  code?: Maybe<ProductFullSyncUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductFullSyncUserError`. */
export enum ProductFullSyncUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** The input fields for identifying a product. */
export type ProductIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the product. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The handle of the product. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The set of valid sort keys for the ProductImage query. */
export enum ProductImageSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION'
}

/** The input fields for creating or updating a product. */
export type ProductInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** A list of collection IDs to associate with the product. */
  collectionsToJoin?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The collection IDs to disassociate from the product. */
  collectionsToLeave?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The role of the product in a [combined listing](https://shopify.dev/apps/build/product-merchandising/combined-listings).
   * You can specify this field only when you create a product.
   */
  combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** Whether the product is a gift card. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  giftCardTemplateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-readable string that's used to identify the product in URLs. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated (unless that handle
   * is already taken, in which case a suffix is added to make the handle unique).
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /**
   * The product's ID.
   *
   * If you're creating a product, then you don't need to pass the `id` as input to the
   * [`productCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productCreate) mutation.
   * If you're updating a product, then you do need to pass the `id` as input to the
   * [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate) mutation
   * to identify which product you want to update.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /**
   * A list of product options and option values. Maximum product options: three. There's no limit on the number of option values.
   * This input is supported only with the [`productCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productCreate)
   * mutation.
   */
  productOptions?: InputMaybe<Array<OptionCreateInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan: true`), then the product is unpublished from all channels except the online store.
   */
  requiresSellingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  status?: InputMaybe<ProductStatus>;
  /**
   * A list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name for the product that displays to customers. If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated.
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product's vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `productJoinSellingPlanGroups` mutation. */
export type ProductJoinSellingPlanGroupsPayload = {
  __typename?: 'ProductJoinSellingPlanGroupsPayload';
  /** The product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Return type for `productLeaveSellingPlanGroups` mutation. */
export type ProductLeaveSellingPlanGroupsPayload = {
  __typename?: 'ProductLeaveSellingPlanGroupsPayload';
  /** The product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** The set of valid sort keys for the ProductMedia query. */
export enum ProductMediaSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION'
}

/** An interface representing asynchronous operations on products. Tracks the status and details of background product mutations like `productSet`, `productDelete`, `productDuplicate`, and `productBundle` operations. Provides status field (CREATED, ACTIVE, COMPLETE) and product field to monitor long-running product operations. */
export type ProductOperation = {
  /** The product on which the operation is being performed. */
  product?: Maybe<Product>;
  /** The status of this operation. */
  status: ProductOperationStatus;
};

/** Represents the state of this product operation. */
export enum ProductOperationStatus {
  /** Operation is currently running. */
  Active = 'ACTIVE',
  /** Operation is complete. */
  Complete = 'COMPLETE',
  /** Operation has been created. */
  Created = 'CREATED'
}

/**
 * A product attribute that customers can choose from, such as "Size", "Color", or "Material". [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects use options to define the different variations available for purchase. Each option has a name and a set of possible values that combine to create [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * The option includes its display position, associated values, and optional [`LinkedMetafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LinkedMetafield) for structured data. Options support translations for international selling and track which [`ProductOptionValue`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue) objects that variants actively use versus unused values that exist without associated variants.
 */
export type ProductOption = HasPublishedTranslations & Node & {
  __typename?: 'ProductOption';
  /** The date and time when the product option was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The metafield identifier linked to this option. */
  linkedMetafield?: Maybe<LinkedMetafield>;
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** Similar to values, option_values returns all the corresponding option value objects to the product option, including values not assigned to any variants. */
  optionValues: Array<ProductOptionValue>;
  /** The product option's position. */
  position: Scalars['Int']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The corresponding value to the product option name. */
  values: Array<Scalars['String']['output']>;
};


/**
 * A product attribute that customers can choose from, such as "Size", "Color", or "Material". [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects use options to define the different variations available for purchase. Each option has a name and a set of possible values that combine to create [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * The option includes its display position, associated values, and optional [`LinkedMetafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LinkedMetafield) for structured data. Options support translations for international selling and track which [`ProductOptionValue`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue) objects that variants actively use versus unused values that exist without associated variants.
 */
export type ProductOptionTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** The set of variant strategies available for use in the `productOptionsCreate` mutation. */
export enum ProductOptionCreateVariantStrategy {
  /**
   * Existing variants are updated with the first option value of each added option. New variants are
   * created for each combination of existing variant option values and new option values.
   */
  Create = 'CREATE',
  /**
   * No additional variants are created in response to the added options. Existing variants are updated with the
   * first option value of each option added.
   */
  LeaveAsIs = 'LEAVE_AS_IS'
}

/** The set of strategies available for use on the `productOptionDelete` mutation. */
export enum ProductOptionDeleteStrategy {
  /** The default strategy, the specified `Option` may only have one corresponding `value`. */
  Default = 'DEFAULT',
  /** An `Option` with multiple `values` can be deleted, but the operation only succeeds if no product variants get deleted. */
  NonDestructive = 'NON_DESTRUCTIVE',
  /** An `Option` with multiple `values` can be deleted. Remaining variants will be deleted, highest `position` first, in the event of duplicates being detected. */
  Position = 'POSITION'
}

/** Return type for `productOptionUpdate` mutation. */
export type ProductOptionUpdatePayload = {
  __typename?: 'ProductOptionUpdatePayload';
  /** The product with which the option being updated is associated. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductOptionUpdateUserError>;
};

/** Error codes for failed `ProductOptionUpdate` mutation. */
export type ProductOptionUpdateUserError = DisplayableError & {
  __typename?: 'ProductOptionUpdateUserError';
  /** The error code. */
  code?: Maybe<ProductOptionUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductOptionUpdateUserError`. */
export enum ProductOptionUpdateUserErrorCode {
  /** An option cannot have both metafield linked and nonlinked option values. */
  CannotCombineLinkedAndNonlinkedOptionValues = 'CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES',
  /** The number of variants will be above the limit after this operation. */
  CannotCreateVariantsAboveLimit = 'CANNOT_CREATE_VARIANTS_ABOVE_LIMIT',
  /** Deleting all option values of an option is not allowed. */
  CannotDeleteAllOptionValuesInOption = 'CANNOT_DELETE_ALL_OPTION_VALUES_IN_OPTION',
  /** Cannot update the option because it would result in deleting variants, and you don't have the required permissions. */
  CannotDeleteVariantWithoutPermission = 'CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION',
  /** An option cannot be left only with option values that are not linked to any variant. */
  CannotLeaveOptionsWithoutVariants = 'CANNOT_LEAVE_OPTIONS_WITHOUT_VARIANTS',
  /** At least one of the product variants has invalid SKUs. */
  CannotMakeChangesIfVariantIsMissingRequiredSku = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option value. */
  DuplicatedOptionValue = 'DUPLICATED_OPTION_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DuplicateLinkedOption = 'DUPLICATE_LINKED_OPTION',
  /** Invalid metafield value for linked option. */
  InvalidMetafieldValueForLinkedOption = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** The name provided is not valid. */
  InvalidName = 'INVALID_NAME',
  /** The option position provided is not valid. */
  InvalidPosition = 'INVALID_POSITION',
  /** A key is missing in the input. */
  KeyMissingInInput = 'KEY_MISSING_IN_INPUT',
  /** No valid metafield definition found for linked option. */
  LinkedMetafieldDefinitionNotFound = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Linked options are currently not supported for this shop. */
  LinkedOptionsNotSupportedForShop = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** Updating the linked_metafield of an option requires a linked_metafield_value for each option value. */
  LinkedOptionUpdateMissingValues = 'LINKED_OPTION_UPDATE_MISSING_VALUES',
  /** On create, this key cannot be used. */
  NoKeyOnCreate = 'NO_KEY_ON_CREATE',
  /** Option already exists. */
  OptionAlreadyExists = 'OPTION_ALREADY_EXISTS',
  /** Option does not exist. */
  OptionDoesNotExist = 'OPTION_DOES_NOT_EXIST',
  /** An option linked to the provided metafield already exists. */
  OptionLinkedMetafieldAlreadyTaken = 'OPTION_LINKED_METAFIELD_ALREADY_TAKEN',
  /** Option name is too long. */
  OptionNameTooLong = 'OPTION_NAME_TOO_LONG',
  /** Option values count is over the allowed limit. */
  OptionValuesOverLimit = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value already exists. */
  OptionValueAlreadyExists = 'OPTION_VALUE_ALREADY_EXISTS',
  /** Performing conflicting actions on an option value. */
  OptionValueConflictingOperation = 'OPTION_VALUE_CONFLICTING_OPERATION',
  /** Option value does not exist. */
  OptionValueDoesNotExist = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value with variants linked cannot be deleted. */
  OptionValueHasVariants = 'OPTION_VALUE_HAS_VARIANTS',
  /** Option value name is too long. */
  OptionValueNameTooLong = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** The number of option values created with the MANAGE strategy would exceed the variant limit. */
  TooManyVariantsCreated = 'TOO_MANY_VARIANTS_CREATED',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** The set of variant strategies available for use in the `productOptionUpdate` mutation. */
export enum ProductOptionUpdateVariantStrategy {
  /**
   * Variants are not created nor deleted in response to option values to add or delete.
   * In cases where deleting a variant would be necessary to complete the operation, an error will be returned.
   */
  LeaveAsIs = 'LEAVE_AS_IS',
  /**
   * Variants are created and deleted according to the option values to add and to delete.
   *
   * If an option value is added, a new variant will be added for each existing option combination
   * available on the product. For example, if the existing options are `Size` and `Color`, with
   * values `S`/`XL` and `Red`/`Blue`, adding a new option value `Green` for the option `Color` will create
   * variants with the option value combinations `S`/`Green` and `XL`/`Green`.
   *
   * If an option value is deleted, all variants referencing that option value will be deleted.
   */
  Manage = 'MANAGE'
}

/**
 * A specific value for a [`ProductOption`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption), such as "Red" or "Blue" for a "Color" option. Each value can be assigned to [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects to create different versions of a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product).
 *
 * The value tracks whether any variants currently use it through the [`hasVariants`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue#field-hasVariants) field. Values can include visual representations through swatches that display colors or images. When linked to a [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield), the [`linkedMetafieldValue`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue#field-linkedMetafieldValue) provides additional structured data for the option value.
 */
export type ProductOptionValue = HasPublishedTranslations & Node & {
  __typename?: 'ProductOptionValue';
  /** Whether the product option value has any linked variants. */
  hasVariants: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The value of the linked metafield. */
  linkedMetafieldValue?: Maybe<Scalars['String']['output']>;
  /** The name of the product option value. */
  name: Scalars['String']['output'];
  /** The swatch associated with the product option value. */
  swatch?: Maybe<ProductOptionValueSwatch>;
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/**
 * A specific value for a [`ProductOption`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption), such as "Red" or "Blue" for a "Color" option. Each value can be assigned to [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects to create different versions of a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product).
 *
 * The value tracks whether any variants currently use it through the [`hasVariants`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue#field-hasVariants) field. Values can include visual representations through swatches that display colors or images. When linked to a [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield), the [`linkedMetafieldValue`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue#field-linkedMetafieldValue) provides additional structured data for the option value.
 */
export type ProductOptionValueTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** A swatch associated with a product option value. */
export type ProductOptionValueSwatch = {
  __typename?: 'ProductOptionValueSwatch';
  /** The color representation of the swatch. */
  color?: Maybe<Scalars['Color']['output']>;
  /** An image representation of the swatch. */
  image?: Maybe<MediaImage>;
};

/** Return type for `productOptionsCreate` mutation. */
export type ProductOptionsCreatePayload = {
  __typename?: 'ProductOptionsCreatePayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductOptionsCreateUserError>;
};

/** Error codes for failed `ProductOptionsCreate` mutation. */
export type ProductOptionsCreateUserError = DisplayableError & {
  __typename?: 'ProductOptionsCreateUserError';
  /** The error code. */
  code?: Maybe<ProductOptionsCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductOptionsCreateUserError`. */
export enum ProductOptionsCreateUserErrorCode {
  /** Cannot combine linked metafield and option values. */
  CannotCombineLinkedMetafieldAndOptionValues = 'CANNOT_COMBINE_LINKED_METAFIELD_AND_OPTION_VALUES',
  /** At least one of the product variants has invalid SKUs. */
  CannotMakeChangesIfVariantIsMissingRequiredSku = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option name. */
  DuplicatedOptionName = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DuplicatedOptionValue = 'DUPLICATED_OPTION_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DuplicateLinkedOption = 'DUPLICATE_LINKED_OPTION',
  /** Invalid metafield value for linked option. */
  InvalidMetafieldValueForLinkedOption = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** The name provided is not valid. */
  InvalidName = 'INVALID_NAME',
  /** No valid metafield definition found for linked option. */
  LinkedMetafieldDefinitionNotFound = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Cannot specify 'linkedMetafieldValue' for an option that is not linked to a metafield. */
  LinkedMetafieldValueWithoutLinkedOption = 'LINKED_METAFIELD_VALUE_WITHOUT_LINKED_OPTION',
  /** Linked options are currently not supported for this shop. */
  LinkedOptionsNotSupportedForShop = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** Missing metafield values for linked option. */
  MissingMetafieldValuesForLinkedOption = 'MISSING_METAFIELD_VALUES_FOR_LINKED_OPTION',
  /** Cannot create new options without values for all existing variants. */
  NewOptionWithoutValueForExistingVariants = 'NEW_OPTION_WITHOUT_VALUE_FOR_EXISTING_VARIANTS',
  /** Options count is over the allowed limit. */
  OptionsOverLimit = 'OPTIONS_OVER_LIMIT',
  /** Option already exists. */
  OptionAlreadyExists = 'OPTION_ALREADY_EXISTS',
  /** An option linked to the provided metafield already exists. */
  OptionLinkedMetafieldAlreadyTaken = 'OPTION_LINKED_METAFIELD_ALREADY_TAKEN',
  /** Each option must have a name specified. */
  OptionNameMissing = 'OPTION_NAME_MISSING',
  /** Option name is too long. */
  OptionNameTooLong = 'OPTION_NAME_TOO_LONG',
  /** If specified, position field must be present in all option inputs. */
  OptionPositionMissing = 'OPTION_POSITION_MISSING',
  /** Each option must have at least one option value specified. */
  OptionValuesMissing = 'OPTION_VALUES_MISSING',
  /** Option values count is over the allowed limit. */
  OptionValuesOverLimit = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value name is too long. */
  OptionValueNameTooLong = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Position must be between 1 and the maximum number of options per product. */
  PositionOutOfBounds = 'POSITION_OUT_OF_BOUNDS',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** The number of option values created with the CREATE strategy would exceed the variant limit. */
  TooManyVariantsCreated = 'TOO_MANY_VARIANTS_CREATED',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** Return type for `productOptionsDelete` mutation. */
export type ProductOptionsDeletePayload = {
  __typename?: 'ProductOptionsDeletePayload';
  /** IDs of the options deleted. */
  deletedOptionsIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductOptionsDeleteUserError>;
};

/** Error codes for failed `ProductOptionsDelete` mutation. */
export type ProductOptionsDeleteUserError = DisplayableError & {
  __typename?: 'ProductOptionsDeleteUserError';
  /** The error code. */
  code?: Maybe<ProductOptionsDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductOptionsDeleteUserError`. */
export enum ProductOptionsDeleteUserErrorCode {
  /** Can't delete option with multiple values. */
  CannotDeleteOptionWithMultipleValues = 'CANNOT_DELETE_OPTION_WITH_MULTIPLE_VALUES',
  /** Cannot perform option deletion because it would result in deleting variants, and you don't have the required permissions. */
  CannotDeleteVariantWithoutPermission = 'CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION',
  /** At least one of the product variants has invalid SKUs. */
  CannotMakeChangesIfVariantIsMissingRequiredSku = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Cannot delete options without deleting variants. */
  CannotUseNonDestructiveStrategy = 'CANNOT_USE_NON_DESTRUCTIVE_STRATEGY',
  /** Options do not belong to the same product. */
  OptionsDoNotBelongToTheSameProduct = 'OPTIONS_DO_NOT_BELONG_TO_THE_SAME_PRODUCT',
  /** Option does not exist. */
  OptionDoesNotExist = 'OPTION_DOES_NOT_EXIST',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** Return type for `productOptionsReorder` mutation. */
export type ProductOptionsReorderPayload = {
  __typename?: 'ProductOptionsReorderPayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductOptionsReorderUserError>;
};

/** Error codes for failed `ProductOptionsReorder` mutation. */
export type ProductOptionsReorderUserError = DisplayableError & {
  __typename?: 'ProductOptionsReorderUserError';
  /** The error code. */
  code?: Maybe<ProductOptionsReorderUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductOptionsReorderUserError`. */
export enum ProductOptionsReorderUserErrorCode {
  /** At least one of the product variants has invalid SKUs. */
  CannotMakeChangesIfVariantIsMissingRequiredSku = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option name. */
  DuplicatedOptionName = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DuplicatedOptionValue = 'DUPLICATED_OPTION_VALUE',
  /** Missing option name. */
  MissingOptionName = 'MISSING_OPTION_NAME',
  /** Missing option value. */
  MissingOptionValue = 'MISSING_OPTION_VALUE',
  /** Cannot specify different options or option values using mixed id and name reference key. */
  MixingIdAndNameKeysIsNotAllowed = 'MIXING_ID_AND_NAME_KEYS_IS_NOT_ALLOWED',
  /** On reorder, this key cannot be used. */
  NoKeyOnReorder = 'NO_KEY_ON_REORDER',
  /** Option id does not exist. */
  OptionIdDoesNotExist = 'OPTION_ID_DOES_NOT_EXIST',
  /** Option name does not exist. */
  OptionNameDoesNotExist = 'OPTION_NAME_DOES_NOT_EXIST',
  /** Option value does not exist. */
  OptionValueDoesNotExist = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value id does not exist. */
  OptionValueIdDoesNotExist = 'OPTION_VALUE_ID_DOES_NOT_EXIST',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED'
}

/** The price range of the product. */
export type ProductPriceRange = {
  __typename?: 'ProductPriceRange';
  /** The highest variant's price. */
  maxVariantPrice: MoneyV2;
  /** The lowest variant's price. */
  minVariantPrice: MoneyV2;
};

/** The price range of the product. */
export type ProductPriceRangeV2 = {
  __typename?: 'ProductPriceRangeV2';
  /** The highest variant's price. */
  maxVariantPrice: MoneyV2;
  /** The lowest variant's price. */
  minVariantPrice: MoneyV2;
};

/** Represents the channels where a product is published. */
export type ProductPublication = {
  __typename?: 'ProductPublication';
  /** The channel where the product was or is published. */
  channel: Channel;
  /** Whether the publication is published or not. */
  isPublished: Scalars['Boolean']['output'];
  /** The product that was or is going to be published on the channel. */
  product: Product;
  /** The date that the product was or is going to be published on the channel. */
  publishDate?: Maybe<Scalars['DateTime']['output']>;
};

/** An auto-generated type for paginating through multiple ProductPublications. */
export type ProductPublicationConnection = {
  __typename?: 'ProductPublicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductPublicationEdge>;
  /** A list of nodes that are contained in ProductPublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductPublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductPublication and a cursor during pagination. */
export type ProductPublicationEdge = {
  __typename?: 'ProductPublicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductPublicationEdge. */
  node: ProductPublication;
};

/** The input fields for specifying a publication to which a product will be published. */
export type ProductPublicationInput = {
  /** ID of the publication. */
  publicationId?: InputMaybe<Scalars['ID']['input']>;
  /** The date and time that the product was (or will be) published. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The input fields for specifying a product to publish and the channels to publish it to. */
export type ProductPublishInput = {
  /** The product to create or update publications for. */
  id: Scalars['ID']['input'];
  /** The publication that the product is published to. */
  productPublications: Array<ProductPublicationInput>;
};

/** Return type for `productPublish` mutation. */
export type ProductPublishPayload = {
  __typename?: 'ProductPublishPayload';
  /** The product that has been published. */
  product?: Maybe<Product>;
  /**
   * The channels where the product is published.
   * @deprecated Use Product.publications instead.
   */
  productPublications?: Maybe<Array<ProductPublication>>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `productReorderMedia` mutation. */
export type ProductReorderMediaPayload = {
  __typename?: 'ProductReorderMediaPayload';
  /** The asynchronous job which reorders the media. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  mediaUserErrors: Array<MediaUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  userErrors: Array<UserError>;
};

/**
 * Reports the status of product for a Sales Channel or Storefront API.
 * This might include why a product is not available in a Sales Channel
 * and how a merchant might fix this.
 */
export type ProductResourceFeedback = {
  __typename?: 'ProductResourceFeedback';
  /** The channel this feedback is for. */
  channel?: Maybe<Channel>;
  /**
   * The time when the feedback was generated. Used to help determine whether
   * incoming feedback is outdated compared to existing feedback.
   */
  feedbackGeneratedAt: Scalars['DateTime']['output'];
  /** The feedback messages presented to the merchant. */
  messages: Array<Scalars['String']['output']>;
  /** The ID of the product associated with the feedback. */
  productId: Scalars['ID']['output'];
  /** The timestamp of the product associated with the feedback. */
  productUpdatedAt: Scalars['DateTime']['output'];
  /** Conveys the state of the feedback and whether it requires merchant action or not. */
  state: ResourceFeedbackState;
};

/** The input fields used to create a product feedback. */
export type ProductResourceFeedbackInput = {
  /** The ID of the channel that the feedback is for. Used to scope feedback to a specific sales channel when the app has multiple channels. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The date and time when the payload is constructed.
   * Used to help determine whether incoming feedback is outdated compared to feedback already received, and if it should be ignored upon arrival.
   */
  feedbackGeneratedAt: Scalars['DateTime']['input'];
  /**
   * A concise set of copy strings to be displayed to merchants. Used to guide merchants in resolving problems that your app encounters when trying to make use of their products.
   * You can specify up to ten messages. Each message is limited to 100 characters.
   */
  messages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ID of the product that the feedback was created on. */
  productId: Scalars['ID']['input'];
  /** The timestamp of the product associated with the feedback. */
  productUpdatedAt: Scalars['DateTime']['input'];
  /** Whether the merchant needs to take action on the product. */
  state: ResourceFeedbackState;
};

/** A sale associated with a product. */
export type ProductSale = Sale & {
  __typename?: 'ProductSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line item for the associated sale. */
  lineItem: LineItem;
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** The input fields required to identify a resource. */
export type ProductSetIdentifiers = {
  /** Custom ID of product to upsert. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** Handle of product to upsert. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** ID of product to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields required to create or update a product via ProductSet mutation. */
export type ProductSetInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** The IDs of collections that this product will be a member of. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The role of the product in a product grouping. It can only be set during creation. */
  combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /**
   * The files to associate with the product.
   *
   * Complexity cost: 1.9 per file.
   */
  files?: InputMaybe<Array<FileSetInput>>;
  /** Whether the product is a gift card. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  giftCardTemplateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-readable string that's used to identify the product in URLs. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated (unless that handle
   * is already taken, in which case a suffix is added to make the handle unique).
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /**
   * The metafields to associate with this product.
   *
   * Complexity cost: 0.4 per metafield.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** List of custom product options and option values (maximum of 3 per product). */
  productOptions?: InputMaybe<Array<OptionSetInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the product can only be purchased with a selling plan (subscription). Products that are sold exclusively on subscription can only be created on online stores. If set to `true` on an already existing product, then the product will be marked unavailable on channels that don't support subscriptions. */
  requiresSellingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo?: InputMaybe<SeoInput>;
  /** The status of the product. */
  status?: InputMaybe<ProductStatus>;
  /**
   * A list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name for the product that displays to customers. If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated.
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * A list of variants associated with the product.
   *
   * Complexity cost: 0.2 per variant.
   */
  variants?: InputMaybe<Array<ProductVariantSetInput>>;
  /** The name of the product's vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields required to set inventory quantities using `productSet` mutation. */
export type ProductSetInventoryInput = {
  /** The ID of the location of the inventory quantity being set. */
  locationId: Scalars['ID']['input'];
  /** The name of the inventory quantity being set. Must be one of `available` or `on_hand`. */
  name: Scalars['String']['input'];
  /** The values to which each quantities will be set. */
  quantity: Scalars['Int']['input'];
};

/**
 * An entity that represents details of an asynchronous
 * [ProductSet](https://shopify.dev/api/admin-graphql/current/mutations/productSet) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned
 * [when the product was created or updated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously),
 * this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the created or updated product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductSetOperation = Node & ProductOperation & {
  __typename?: 'ProductSetOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product on which the operation is being performed. */
  product?: Maybe<Product>;
  /** The status of this operation. */
  status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  userErrors: Array<ProductSetUserError>;
};

/** Return type for `productSet` mutation. */
export type ProductSetPayload = {
  __typename?: 'ProductSetPayload';
  /** The product object. */
  product?: Maybe<Product>;
  /** The product set operation, returned when run in asynchronous mode. */
  productSetOperation?: Maybe<ProductSetOperation>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductSetUserError>;
};

/** Defines errors for ProductSet mutation. */
export type ProductSetUserError = DisplayableError & {
  __typename?: 'ProductSetUserError';
  /** The error code. */
  code?: Maybe<ProductSetUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductSetUserError`. */
export enum ProductSetUserErrorCode {
  /** An option cannot have both metafield linked and nonlinked option values. */
  CannotCombineLinkedAndNonlinkedOptionValues = 'CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** Duplicated metafield value for linked option. */
  DuplicatedMetafieldValue = 'DUPLICATED_METAFIELD_VALUE',
  /** Duplicated option name. */
  DuplicatedOptionName = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DuplicatedOptionValue = 'DUPLICATED_OPTION_VALUE',
  /** Duplicated value. */
  DuplicatedValue = 'DUPLICATED_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DuplicateLinkedOption = 'DUPLICATE_LINKED_OPTION',
  /** Something went wrong, please try again. */
  GenericError = 'GENERIC_ERROR',
  /** Gift card products can only be created after they have been activated. */
  GiftCardsNotActivated = 'GIFT_CARDS_NOT_ACTIVATED',
  /** The product gift_card attribute cannot be changed after creation. */
  GiftCardAttributeCannotBeChanged = 'GIFT_CARD_ATTRIBUTE_CANNOT_BE_CHANGED',
  /** Handle already in use. Please provide a new handle. */
  HandleNotUnique = 'HANDLE_NOT_UNIQUE',
  /** The id field is not allowed if identifier is provided. */
  IdNotAllowed = 'ID_NOT_ALLOWED',
  /** The identifier value does not match the value of the corresponding field in the input. */
  InputMismatch = 'INPUT_MISMATCH',
  /** Input is not valid. */
  InvalidInput = 'INVALID_INPUT',
  /** Metafield is not valid. */
  InvalidMetafield = 'INVALID_METAFIELD',
  /** Invalid metafield value for linked option. */
  InvalidMetafieldValueForLinkedOption = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** Product is not valid. */
  InvalidProduct = 'INVALID_PRODUCT',
  /** Product variant is not valid. */
  InvalidVariant = 'INVALID_VARIANT',
  /** Inventory quantity input exceeds the limit of 50000. Consider using separate `inventorySetQuantities` mutations. */
  InventoryQuantitiesLimitExceeded = 'INVENTORY_QUANTITIES_LIMIT_EXCEEDED',
  /** Error processing request in the background job. */
  JobError = 'JOB_ERROR',
  /** No valid metafield definition found for linked option. */
  LinkedMetafieldDefinitionNotFound = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Linked options are currently not supported for this shop. */
  LinkedOptionsNotSupportedForShop = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** The input argument `metafields` (if present) must contain the `customId` value. */
  MetafieldMismatch = 'METAFIELD_MISMATCH',
  /** The input field corresponding to the identifier is required. */
  MissingFieldRequired = 'MISSING_FIELD_REQUIRED',
  /** Resource matching the identifier was not found. */
  NotFound = 'NOT_FOUND',
  /** Options over limit. */
  OptionsOverLimit = 'OPTIONS_OVER_LIMIT',
  /** Option does not exist. */
  OptionDoesNotExist = 'OPTION_DOES_NOT_EXIST',
  /** Each option must have at least one option value specified. */
  OptionValuesMissing = 'OPTION_VALUES_MISSING',
  /** Option values over limit. */
  OptionValuesOverLimit = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value does not exist. */
  OptionValueDoesNotExist = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Must specify product options when updating variants. */
  ProductOptionsInputMissing = 'PRODUCT_OPTIONS_INPUT_MISSING',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Product variant does not exist. */
  ProductVariantDoesNotExist = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Must specify variants when updating options. */
  VariantsInputMissing = 'VARIANTS_INPUT_MISSING',
  /** Number of product variants exceeds shop limit. */
  VariantsOverLimit = 'VARIANTS_OVER_LIMIT'
}

/** The set of valid sort keys for the Product query. */
export enum ProductSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `inventory_total` value. */
  InventoryTotal = 'INVENTORY_TOTAL',
  /** Sort by the `product_type` value. */
  ProductType = 'PRODUCT_TYPE',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  Vendor = 'VENDOR'
}

/** The possible product statuses. */
export enum ProductStatus {
  /** The product is ready to sell and can be published to sales channels and apps. Products with an active status aren't automatically published to sales channels, such as the online store, or apps. By default, existing products are set to active. */
  Active = 'ACTIVE',
  /** The product is no longer being sold and isn't available to customers on sales channels and apps. */
  Archived = 'ARCHIVED',
  /** The product isn't ready to sell and is unavailable to customers on sales channels and apps. By default, duplicated and unarchived products are set to draft. */
  Draft = 'DRAFT',
  /** The product is active but you need a direct link to view it. The product doesn't show up in search, collections, or product recommendations. It will be returned in Storefront API and Liquid only when referenced individually by handle, id, or metafield reference.This status is only visible from 2025-10 and up, is translated to active in older versions and can't be changed from unlisted in older versions. */
  Unlisted = 'UNLISTED'
}

/** Represents a [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17) node. */
export type ProductTaxonomyNode = Node & {
  __typename?: 'ProductTaxonomyNode';
  /** The full name of the product taxonomy node. For example,  Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Beds. */
  fullName: Scalars['String']['output'];
  /** The ID of the product taxonomy node. */
  id: Scalars['ID']['output'];
  /** Whether the node is a leaf node. */
  isLeaf: Scalars['Boolean']['output'];
  /** Whether the node is a root node. */
  isRoot: Scalars['Boolean']['output'];
  /** The name of the product taxonomy node. For example, Dog Beds. */
  name: Scalars['String']['output'];
};

/** The input fields for specifying a product to unpublish from a channel and the sales channels to unpublish it from. */
export type ProductUnpublishInput = {
  /** The ID of the product to create or update publications for. */
  id: Scalars['ID']['input'];
  /** The channels to unpublish the product from. */
  productPublications: Array<ProductPublicationInput>;
};

/** Return type for `productUnpublish` mutation. */
export type ProductUnpublishPayload = {
  __typename?: 'ProductUnpublishPayload';
  /** The product that has been unpublished. */
  product?: Maybe<Product>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields required to identify a product for update. */
export type ProductUpdateIdentifiers = {
  /** Custom ID of product to update. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** Handle of product to update. */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** ID of product to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields for updating a product. */
export type ProductUpdateInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** A list of collection IDs to associate with the product. */
  collectionsToJoin?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The collection IDs to disassociate from the product. */
  collectionsToLeave?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Whether to delete metafields whose constraints don't match the product's category.
   * Can only be used when updating the product's category.
   */
  deleteConflictingConstrainedMetafields?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  giftCardTemplateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique, human-readable string that's used to identify the product in URLs. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated (unless that handle
   * is already taken, in which case a suffix is added to make the handle unique).
   */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** The product's ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  productType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  redirectNewHandle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan: true`), then the product is unpublished from all channels except the online store.
   */
  requiresSellingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  status?: InputMaybe<ProductStatus>;
  /**
   * A list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  templateSuffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name for the product that displays to customers. If no handle is explicitly provided, then the title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses" and no handle is provided, then the handle `black-sunglasses` is generated.
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product's vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `productUpdateMedia` mutation. */
export type ProductUpdateMediaPayload = {
  __typename?: 'ProductUpdateMediaPayload';
  /** The updated media object. */
  media?: Maybe<Array<Media>>;
  /** The list of errors that occurred from executing the mutation. */
  mediaUserErrors: Array<MediaUserError>;
  /** The product on which media was updated. */
  product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  userErrors: Array<UserError>;
};

/** Return type for `productUpdate` mutation. */
export type ProductUpdatePayload = {
  __typename?: 'ProductUpdatePayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariant = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & LegacyInteroperability & Navigable & Node & Publishable & {
  __typename?: 'ProductVariant';
  /** Whether the product variant is available for sale. */
  availableForSale: Scalars['Boolean']['output'];
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  availablePublicationsCount?: Maybe<Count>;
  /** The value of the barcode associated with the product. */
  barcode?: Maybe<Scalars['String']['output']>;
  /** The compare-at price of the variant in the default shop currency. */
  compareAtPrice?: Maybe<Scalars['Money']['output']>;
  /** The pricing that applies for a customer in a given context. As of API version 2025-04, only active markets are considered in the price resolution. */
  contextualPricing: ProductVariantContextualPricing;
  /** The date and time when the variant was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  defaultCursor: Scalars['String']['output'];
  /** The [delivery profile](https://shopify.dev/api/admin-graphql/latest/objects/DeliveryProfile) for the variant. */
  deliveryProfile?: Maybe<DeliveryProfile>;
  /** Display name of the variant, based on product's title + variant's title. */
  displayName: Scalars['String']['output'];
  /** The paginated list of events associated with the host subject. */
  events: EventConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The featured image for the variant.
   * @deprecated Use `media` instead.
   */
  image?: Maybe<Image>;
  /** The inventory item, which is used to query for inventory information. */
  inventoryItem: InventoryItem;
  /** Whether customers are allowed to place an order for the product variant when it's out of stock. */
  inventoryPolicy: ProductVariantInventoryPolicy;
  /** The total sellable quantity of the variant. */
  inventoryQuantity?: Maybe<Scalars['Int']['output']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The media associated with the product variant. */
  media: MediaConnection;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position: Scalars['Int']['output'];
  /**
   * List of prices and compare-at prices in the presentment currencies for this shop.
   * @deprecated Use `contextualPricing` instead.
   */
  presentmentPrices: ProductVariantPricePairConnection;
  /** The price of the product variant in the default shop currency. */
  price: Scalars['Money']['output'];
  /** The product that this variant belongs to. */
  product: Product;
  /** A list of products that have product variants that contain this variant as a product component. */
  productParents: ProductConnection;
  /** A list of the product variant components. */
  productVariantComponents: ProductVariantComponentConnection;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  publicationCount: Scalars['Int']['output'];
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  publishedOnCurrentChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  publishedOnPublication: Scalars['Boolean']['output'];
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be omitted
   * from channels that don't support bundles.
   */
  requiresComponents: Scalars['Boolean']['output'];
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  resourcePublications: ResourcePublicationConnection;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   */
  resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * By default, only publications to `APP` catalog types are returned.
   * For `Product` and `ProductVariant`, use the `catalogType` argument to retrieve
   * publications for other catalog types, such as `COMPANY_LOCATION` (B2B) or `MARKET`.
   * `Collection` only supports publications to `APP` catalog types.
   */
  resourcePublicationsV2: ResourcePublicationV2Connection;
  /** List of product options applied to the variant. */
  selectedOptions: Array<SelectedOption>;
  /**
   * The total sellable quantity of the variant for online channels.
   * This doesn't represent the total available inventory or capture
   * [limitations based on customer location](https://help.shopify.com/manual/markets/inventory_and_fulfillment).
   */
  sellableOnlineQuantity: Scalars['Int']['output'];
  /**
   * Count of selling plan groups associated with the product variant.
   * @deprecated Use `sellingPlanGroupsCount` instead.
   */
  sellingPlanGroupCount: Scalars['Int']['output'];
  /** A list of all selling plan groups defined in the current shop associated with the product variant. */
  sellingPlanGroups: SellingPlanGroupConnection;
  /** Count of selling plan groups associated with the product variant. */
  sellingPlanGroupsCount?: Maybe<Count>;
  /** Whether to show the unit price for this product variant. */
  showUnitPrice: Scalars['Boolean']['output'];
  /**
   * A case-sensitive identifier for the product variant in the shop.
   * Required in order to connect to a fulfillment service.
   */
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * The Storefront GraphQL API ID of the `ProductVariant`.
   *
   * The Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  storefrontId: Scalars['StorefrontID']['output'];
  /**
   * Avalara tax code for the product variant. Applies only to the stores that have the Avalara AvaTax app installed.
   * @deprecated This field should no longer be used in new integrations. This field will not be available in future API versions.
   */
  taxCode?: Maybe<Scalars['String']['output']>;
  /** Whether a tax is charged when the product variant is sold. */
  taxable: Scalars['Boolean']['output'];
  /** The title of the product variant. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The unit price value for the variant based on the variant measurement. */
  unitPrice?: Maybe<MoneyV2>;
  /** The unit price measurement for the variant. */
  unitPriceMeasurement?: Maybe<UnitPriceMeasurement>;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  unpublishedPublications: PublicationConnection;
  /** The date and time (ISO 8601 format) when the product variant was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantContextualPricingArgs = {
  context: ContextualPricingContext;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantPresentmentPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  presentmentCurrencies?: InputMaybe<Array<CurrencyCode>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantProductParentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantProductVariantComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantPublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantPublishedOnChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantPublishedOnPublicationArgs = {
  publicationId: Scalars['ID']['input'];
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `ProductVariant` object represents a version of a
 * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
 * that comes in more than one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
 * such as size or color. For example, if a merchant sells t-shirts with options for size and color, then a small,
 * blue t-shirt would be one product variant and a large, blue t-shirt would be another.
 *
 * Use the `ProductVariant` object to manage the full lifecycle and configuration of a product's variants. Common
 * use cases for using the `ProductVariant` object include:
 *
 * - Tracking inventory for each variant
 * - Setting unique prices for each variant
 * - Assigning barcodes and SKUs to connect variants to fulfillment services
 * - Attaching variant-specific images and media
 * - Setting delivery and tax requirements
 * - Supporting product bundles, subscriptions, and selling plans
 *
 * A `ProductVariant` is associated with a parent
 * [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) object.
 * `ProductVariant` serves as the central link between a product's merchandising configuration, inventory,
 * pricing, fulfillment, and sales channels within the GraphQL Admin API schema. Each variant
 * can reference other GraphQL types such as:
 *
 * - [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem): Used for inventory tracking
 * - [`Image`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Image): Used for variant-specific images
 * - [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup): Used for subscriptions and selling plans
 *
 * Learn more about [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
 */
export type ProductVariantUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields required to append media to a single variant. */
export type ProductVariantAppendMediaInput = {
  /** Specifies the media to append to the variant. */
  mediaIds: Array<Scalars['ID']['input']>;
  /** Specifies the variant to which media will be appended. */
  variantId: Scalars['ID']['input'];
};

/** Return type for `productVariantAppendMedia` mutation. */
export type ProductVariantAppendMediaPayload = {
  __typename?: 'ProductVariantAppendMediaPayload';
  /** The product associated with the variants and media. */
  product?: Maybe<Product>;
  /** The product variants that were updated. */
  productVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MediaUserError>;
};

/**
 * A product variant component that is included within a bundle.
 *
 * These are the individual product variants that make up a bundle product,
 * where each component has a specific required quantity.
 */
export type ProductVariantComponent = Node & {
  __typename?: 'ProductVariantComponent';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product variant associated with the component. */
  productVariant: ProductVariant;
  /** The required quantity of the component. */
  quantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple ProductVariantComponents. */
export type ProductVariantComponentConnection = {
  __typename?: 'ProductVariantComponentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductVariantComponentEdge>;
  /** A list of nodes that are contained in ProductVariantComponentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductVariantComponent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductVariantComponent and a cursor during pagination. */
export type ProductVariantComponentEdge = {
  __typename?: 'ProductVariantComponentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantComponentEdge. */
  node: ProductVariantComponent;
};

/** An auto-generated type for paginating through multiple ProductVariants. */
export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductVariantEdge>;
  /** A list of nodes that are contained in ProductVariantEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductVariant>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/**
 * The price of a product variant in a specific country.
 * Prices vary between countries.
 */
export type ProductVariantContextualPricing = {
  __typename?: 'ProductVariantContextualPricing';
  /** The final compare-at price after all adjustments are applied. */
  compareAtPrice?: Maybe<MoneyV2>;
  /** The final price after all adjustments are applied. */
  price: MoneyV2;
  /** A list of quantity breaks for the product variant. */
  quantityPriceBreaks: QuantityPriceBreakConnection;
  /** The quantity rule applied for a given context. */
  quantityRule: QuantityRule;
  /** The unit price value for the given context based on the variant measurement. */
  unitPrice?: Maybe<MoneyV2>;
};


/**
 * The price of a product variant in a specific country.
 * Prices vary between countries.
 */
export type ProductVariantContextualPricingQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<QuantityPriceBreakSortKeys>;
};

/** The input fields required to detach media from a single variant. */
export type ProductVariantDetachMediaInput = {
  /** Specifies the media to detach from the variant. */
  mediaIds: Array<Scalars['ID']['input']>;
  /** Specifies the variant from which media will be detached. */
  variantId: Scalars['ID']['input'];
};

/** Return type for `productVariantDetachMedia` mutation. */
export type ProductVariantDetachMediaPayload = {
  __typename?: 'ProductVariantDetachMediaPayload';
  /** The product associated with the variants and media. */
  product?: Maybe<Product>;
  /** The product variants that were updated. */
  productVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MediaUserError>;
};

/** An auto-generated type which holds one ProductVariant and a cursor during pagination. */
export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantEdge. */
  node: ProductVariant;
};

/** The input fields for the bundle components for core. */
export type ProductVariantGroupRelationshipInput = {
  /** The ID of the product variant that's a component of the bundle. */
  id: Scalars['ID']['input'];
  /** The number of units of the product variant required to construct one unit of the bundle. */
  quantity: Scalars['Int']['input'];
};

/** The input fields for identifying a product variant. */
export type ProductVariantIdentifierInput = {
  /** The [custom ID](https://shopify.dev/docs/apps/build/custom-data/metafields/working-with-custom-ids) of the product variant. */
  customId?: InputMaybe<UniqueMetafieldValueInput>;
  /** The ID of the product variant. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The valid values for the inventory policy of a product variant once it is out of stock. */
export enum ProductVariantInventoryPolicy {
  /** Customers can buy this product variant after it's out of stock. */
  Continue = 'CONTINUE',
  /** Customers can't buy this product variant after it's out of stock. */
  Deny = 'DENY'
}

/** Return type for `productVariantJoinSellingPlanGroups` mutation. */
export type ProductVariantJoinSellingPlanGroupsPayload = {
  __typename?: 'ProductVariantJoinSellingPlanGroupsPayload';
  /** The product variant object. */
  productVariant?: Maybe<ProductVariant>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Return type for `productVariantLeaveSellingPlanGroups` mutation. */
export type ProductVariantLeaveSellingPlanGroupsPayload = {
  __typename?: 'ProductVariantLeaveSellingPlanGroupsPayload';
  /** The product variant object. */
  productVariant?: Maybe<ProductVariant>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** The input fields representing a product variant position. */
export type ProductVariantPositionInput = {
  /** Specifies the ID of the product variant to update. */
  id: Scalars['ID']['input'];
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position: Scalars['Int']['input'];
};

/** The compare-at price and price of a variant sharing a currency. */
export type ProductVariantPricePair = {
  __typename?: 'ProductVariantPricePair';
  /** The compare-at price of the variant with associated currency. */
  compareAtPrice?: Maybe<MoneyV2>;
  /** The price of the variant with associated currency. */
  price: MoneyV2;
};

/** An auto-generated type for paginating through multiple ProductVariantPricePairs. */
export type ProductVariantPricePairConnection = {
  __typename?: 'ProductVariantPricePairConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ProductVariantPricePairEdge>;
  /** A list of nodes that are contained in ProductVariantPricePairEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ProductVariantPricePair>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductVariantPricePair and a cursor during pagination. */
export type ProductVariantPricePairEdge = {
  __typename?: 'ProductVariantPricePairEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantPricePairEdge. */
  node: ProductVariantPricePair;
};

/** Return type for `productVariantRelationshipBulkUpdate` mutation. */
export type ProductVariantRelationshipBulkUpdatePayload = {
  __typename?: 'ProductVariantRelationshipBulkUpdatePayload';
  /** The product variants with successfully updated product variant relationships. */
  parentProductVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductVariantRelationshipBulkUpdateUserError>;
};

/** An error that occurs during the execution of `ProductVariantRelationshipBulkUpdate`. */
export type ProductVariantRelationshipBulkUpdateUserError = DisplayableError & {
  __typename?: 'ProductVariantRelationshipBulkUpdateUserError';
  /** The error code. */
  code?: Maybe<ProductVariantRelationshipBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductVariantRelationshipBulkUpdateUserError`. */
export enum ProductVariantRelationshipBulkUpdateUserErrorCode {
  /** Combined listing cannot be child product variants. */
  ChildProductVariantCannotBeCombinedListing = 'CHILD_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING',
  /** A parent product variant cannot contain itself as a component. */
  CircularReference = 'CIRCULAR_REFERENCE',
  /** A parent product variant must not contain duplicate product variant relationships. */
  DuplicateProductVariantRelationship = 'DUPLICATE_PRODUCT_VARIANT_RELATIONSHIP',
  /** Exceeded the maximum allowable product variant relationships in a parent product variant. */
  ExceededProductVariantRelationshipLimit = 'EXCEEDED_PRODUCT_VARIANT_RELATIONSHIP_LIMIT',
  /** Unable to create parent product variant. */
  FailedToCreate = 'FAILED_TO_CREATE',
  /** Unable to remove product variant relationships. */
  FailedToRemove = 'FAILED_TO_REMOVE',
  /** Unable to update product variant relationships. */
  FailedToUpdate = 'FAILED_TO_UPDATE',
  /** Unable to update parent product variant price. */
  FailedToUpdateParentProductVariantPrice = 'FAILED_TO_UPDATE_PARENT_PRODUCT_VARIANT_PRICE',
  /** Product variant relationships must have a quantity greater than 0. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** The product variant relationships to remove must be specified if all the parent product variant's components aren't being removed. */
  MustSpecifyComponents = 'MUST_SPECIFY_COMPONENTS',
  /** Nested parent product variants aren't supported. */
  NestedParentProductVariant = 'NESTED_PARENT_PRODUCT_VARIANT',
  /** Combined listing cannot be parent product variants. */
  ParentProductVariantCannotBeCombinedListing = 'PARENT_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING',
  /** Gift cards cannot be parent product variants. */
  ParentProductVariantCannotBeGiftCard = 'PARENT_PRODUCT_VARIANT_CANNOT_BE_GIFT_CARD',
  /** Parent product variants cannot require a selling plan. */
  ParentProductVariantCannotRequireSellingPlan = 'PARENT_PRODUCT_VARIANT_CANNOT_REQUIRE_SELLING_PLAN',
  /** A parent product variant ID or product ID must be provided. */
  ParentRequired = 'PARENT_REQUIRED',
  /** The products for these product variants are already owned by another App. */
  ProductExpanderAppOwnershipAlreadyExists = 'PRODUCT_EXPANDER_APP_OWNERSHIP_ALREADY_EXISTS',
  /** Some of the provided product variants are not components of the specified parent product variant. */
  ProductVariantsNotComponents = 'PRODUCT_VARIANTS_NOT_COMPONENTS',
  /** The product variants were not found. */
  ProductVariantsNotFound = 'PRODUCT_VARIANTS_NOT_FOUND',
  /** A Core type relationship cannot be added to a composite product variant with SFN type relationships. */
  ProductVariantRelationshipTypeConflict = 'PRODUCT_VARIANT_RELATIONSHIP_TYPE_CONFLICT',
  /** Unexpected error. */
  UnexpectedError = 'UNEXPECTED_ERROR',
  /** Multipack bundles are not supported. */
  UnsupportedMultipackRelationship = 'UNSUPPORTED_MULTIPACK_RELATIONSHIP',
  /** A price must be provided for a parent product variant if the price calculation is set to fixed. */
  UpdateParentVariantPriceRequired = 'UPDATE_PARENT_VARIANT_PRICE_REQUIRED'
}

/** The input fields for updating a composite product variant. */
export type ProductVariantRelationshipUpdateInput = {
  /** A product ID which contains product variants that have relationships with other variants. */
  parentProductId?: InputMaybe<Scalars['ID']['input']>;
  /** The product variant ID representing that which contains the relationships with other variants. */
  parentProductVariantId?: InputMaybe<Scalars['ID']['input']>;
  /** Method in which to update the price of the parent product variant. */
  priceInput?: InputMaybe<PriceInput>;
  /** The product variants and associated quantitites to add to the product variant. */
  productVariantRelationshipsToCreate?: InputMaybe<Array<ProductVariantGroupRelationshipInput>>;
  /** The bundle component product variants to be removed from the product variant. */
  productVariantRelationshipsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The product variants and associated quantitites to update in specified product variant. */
  productVariantRelationshipsToUpdate?: InputMaybe<Array<ProductVariantGroupRelationshipInput>>;
  /** Whether to remove all components from the product variant. The default value is `false`. */
  removeAllProductVariantRelationships?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for specifying a product variant to create or update. */
export type ProductVariantSetInput = {
  /** The value of the barcode associated with the product. */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** The compare-at price of the variant. */
  compareAtPrice?: InputMaybe<Scalars['Money']['input']>;
  /**
   * The file to associate with the variant.
   *
   * Complexity cost: 0.6 per variant file.
   *
   * Any file specified here must also be specified in the `files` input for the product.
   */
  file?: InputMaybe<FileSetInput>;
  /** Specifies the product variant to update or create a new variant if absent. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The inventory item associated with the variant, used for unit cost. */
  inventoryItem?: InputMaybe<InventoryItemInput>;
  /** Whether customers are allowed to place an order for the product variant when it's out of stock. Defaults to `DENY`. */
  inventoryPolicy?: InputMaybe<ProductVariantInventoryPolicy>;
  /**
   * The inventory quantities at each location where the variant is stocked.
   * If you're updating an existing variant, then you can only update the
   * quantities at locations where the variant is already stocked.
   *
   * The total number of inventory quantities across all variants in the mutation can't exceed 50000.
   */
  inventoryQuantities?: InputMaybe<Array<ProductSetInventoryInput>>;
  /**
   * Additional customizable information about the product variant.
   *
   * Complexity cost: 0.4 per variant metafield.
   */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The custom properties that a shop owner uses to define product variants. */
  optionValues: Array<VariantOptionValueInput>;
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The price of the variant. */
  price?: InputMaybe<Scalars['Money']['input']>;
  /** Indicates whether the product variant is created as published or unpublished. This option is only available for new product variants. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be omitted
   * from channels that don't support bundles.
   */
  requiresComponents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not unit price should be shown for this product variant. */
  showUnitPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU for the variant. Case-sensitive string. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** The tax code associated with the variant. */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Whether the variant is taxable. */
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unit price measurement for the product variant. */
  unitPriceMeasurement?: InputMaybe<UnitPriceMeasurementInput>;
};

/** The set of valid sort keys for the ProductVariant query. */
export enum ProductVariantSortKeys {
  /** Sort by the `full_title` value. */
  FullTitle = 'FULL_TITLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by available inventory quantity in the location specified by the `query:"location_id:"` argument.
   * Don't use this sort key when no `location_id` in query is specified.
   */
  InventoryLevelsAvailable = 'INVENTORY_LEVELS_AVAILABLE',
  /** Sort by the `inventory_management` value. */
  InventoryManagement = 'INVENTORY_MANAGEMENT',
  /** Sort by the `inventory_policy` value. */
  InventoryPolicy = 'INVENTORY_POLICY',
  /** Sort by the `inventory_quantity` value. */
  InventoryQuantity = 'INVENTORY_QUANTITY',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `popular` value. */
  Popular = 'POPULAR',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `sku` value. */
  Sku = 'SKU',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** Return type for `productVariantsBulkCreate` mutation. */
export type ProductVariantsBulkCreatePayload = {
  __typename?: 'ProductVariantsBulkCreatePayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The newly created variants. */
  productVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductVariantsBulkCreateUserError>;
};

/** The set of strategies available for use on the `productVariantsBulkCreate` mutation. */
export enum ProductVariantsBulkCreateStrategy {
  /** The default strategy. Deletes the standalone default ("Default Title") variant when it's the only variant on the product. Preserves the standalone custom variant. */
  Default = 'DEFAULT',
  /** Preserves the existing standalone variant when the product has only a single default ("Default Title") or a single custom variant. */
  PreserveStandaloneVariant = 'PRESERVE_STANDALONE_VARIANT',
  /** Deletes the existing standalone variant when the product has only a single default ("Default Title") or custom variant. */
  RemoveStandaloneVariant = 'REMOVE_STANDALONE_VARIANT'
}

/** Error codes for failed product variant bulk create mutations. */
export type ProductVariantsBulkCreateUserError = DisplayableError & {
  __typename?: 'ProductVariantsBulkCreateUserError';
  /** The error code. */
  code?: Maybe<ProductVariantsBulkCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkCreateUserError`. */
export enum ProductVariantsBulkCreateUserErrorCode {
  /** Cannot set name for an option value linked to a metafield. */
  CannotSetNameForLinkedOptionValue = 'CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE',
  /** Variant price must be greater than or equal to zero. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Invalid input detected. */
  Invalid = 'INVALID',
  /** Input is invalid. */
  InvalidInput = 'INVALID_INPUT',
  /** Inventory quantity input exceeds the limit of 50000. Consider using separate `inventorySetQuantities` mutations. */
  InventoryQuantitiesLimitExceeded = 'INVENTORY_QUANTITIES_LIMIT_EXCEEDED',
  /** Price must be 0 for variants of products with a gift card issuance currency. */
  LocalCurrencyGiftCardPriceMustBeZero = 'LOCAL_CURRENCY_GIFT_CARD_PRICE_MUST_BE_ZERO',
  /** Input must be for this product. */
  MustBeForThisProduct = 'MUST_BE_FOR_THIS_PRODUCT',
  /** Variant options are not enough. */
  NeedToAddOptionValues = 'NEED_TO_ADD_OPTION_VALUES',
  /** Price cannot take a negative value. */
  NegativePriceValue = 'NEGATIVE_PRICE_VALUE',
  /** Input is not defined for this shop. */
  NotDefinedForShop = 'NOT_DEFINED_FOR_SHOP',
  /** On create, this key cannot be used. */
  NoKeyOnCreate = 'NO_KEY_ON_CREATE',
  /** Variant options are more than the product options. */
  OptionValuesForNumberOfUnknownOptions = 'OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** You reached the limit of available SKUs in your current plan. */
  SubscriptionViolation = 'SUBSCRIPTION_VIOLATION',
  /** Inventory locations cannot exceed the allowed resource limit or 10. */
  TooManyInventoryLocations = 'TOO_MANY_INVENTORY_LOCATIONS',
  /** Quantity could not be set. The location was not found. */
  TrackedVariantLocationNotFound = 'TRACKED_VARIANT_LOCATION_NOT_FOUND',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION',
  /** Variant already exists. */
  VariantAlreadyExists = 'VARIANT_ALREADY_EXISTS',
  /** Variant options already exist. Please change the variant option(s). */
  VariantAlreadyExistsChangeOptionValue = 'VARIANT_ALREADY_EXISTS_CHANGE_OPTION_VALUE'
}

/** Return type for `productVariantsBulkDelete` mutation. */
export type ProductVariantsBulkDeletePayload = {
  __typename?: 'ProductVariantsBulkDeletePayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductVariantsBulkDeleteUserError>;
};

/** Error codes for failed bulk variant delete mutations. */
export type ProductVariantsBulkDeleteUserError = DisplayableError & {
  __typename?: 'ProductVariantsBulkDeleteUserError';
  /** The error code. */
  code?: Maybe<ProductVariantsBulkDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkDeleteUserError`. */
export enum ProductVariantsBulkDeleteUserErrorCode {
  /** The variant does not exist. */
  AtLeastOneVariantDoesNotBelongToTheProduct = 'AT_LEAST_ONE_VARIANT_DOES_NOT_BELONG_TO_THE_PRODUCT',
  /** Cannot delete default variant. */
  CannotDeleteLastVariant = 'CANNOT_DELETE_LAST_VARIANT',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** The input fields for specifying a product variant to create as part of a variant bulk mutation. */
export type ProductVariantsBulkInput = {
  /** The value of the barcode associated with the product variant. */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** The compare-at price of the variant. */
  compareAtPrice?: InputMaybe<Scalars['Money']['input']>;
  /** Specifies the product variant to update or delete. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The inventory item associated with the variant, used for unit cost. */
  inventoryItem?: InputMaybe<InventoryItemInput>;
  /** Whether customers are allowed to place an order for the variant when it's out of stock. Defaults to `DENY`. */
  inventoryPolicy?: InputMaybe<ProductVariantInventoryPolicy>;
  /**
   * The inventory quantities at each location where the variant is stocked. The number of elements
   * in the array of inventory quantities can't exceed the amount specified for the plan.
   * Supported as input with the `productVariantsBulkCreate` mutation only.
   */
  inventoryQuantities?: InputMaybe<Array<InventoryLevelInput>>;
  /** The ID of the media that's associated with the variant. */
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  /** The URL of the media to associate with the variant. */
  mediaSrc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The additional customizable information about the product variant. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The custom properties that a shop owner uses to define product variants. */
  optionValues?: InputMaybe<Array<VariantOptionValueInput>>;
  /** The price of the variant. */
  price?: InputMaybe<Scalars['Money']['input']>;
  /** Indicates whether the product variant is created as published or unpublished. This option is only available for new product variants. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Adjust inventory quantities with deltas. */
  quantityAdjustments?: InputMaybe<Array<InventoryAdjustmentInput>>;
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be
   * omitted from channels that don't support bundles.
   */
  requiresComponents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the unit price should be shown for this product variant. */
  showUnitPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The tax code associated with the variant. */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Whether the variant is taxable. */
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unit price measurement for the product variant. */
  unitPriceMeasurement?: InputMaybe<UnitPriceMeasurementInput>;
};

/** Return type for `productVariantsBulkReorder` mutation. */
export type ProductVariantsBulkReorderPayload = {
  __typename?: 'ProductVariantsBulkReorderPayload';
  /** The updated product. */
  product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductVariantsBulkReorderUserError>;
};

/** Error codes for failed bulk product variants reorder operation. */
export type ProductVariantsBulkReorderUserError = DisplayableError & {
  __typename?: 'ProductVariantsBulkReorderUserError';
  /** The error code. */
  code?: Maybe<ProductVariantsBulkReorderUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkReorderUserError`. */
export enum ProductVariantsBulkReorderUserErrorCode {
  /** Product variant IDs must be unique. */
  DuplicatedVariantId = 'DUPLICATED_VARIANT_ID',
  /** Something went wrong, please try again. */
  GenericError = 'GENERIC_ERROR',
  /** Product variant position cannot be zero or negative number. */
  InvalidPosition = 'INVALID_POSITION',
  /** Product variant does not exist. */
  MissingVariant = 'MISSING_VARIANT',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST'
}

/** Return type for `productVariantsBulkUpdate` mutation. */
export type ProductVariantsBulkUpdatePayload = {
  __typename?: 'ProductVariantsBulkUpdatePayload';
  /** The updated product object. */
  product?: Maybe<Product>;
  /** The updated variants. */
  productVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ProductVariantsBulkUpdateUserError>;
};

/** Error codes for failed variant bulk update mutations. */
export type ProductVariantsBulkUpdateUserError = DisplayableError & {
  __typename?: 'ProductVariantsBulkUpdateUserError';
  /** The error code. */
  code?: Maybe<ProductVariantsBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkUpdateUserError`. */
export enum ProductVariantsBulkUpdateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Cannot set name for an option value linked to a metafield. */
  CannotSetNameForLinkedOptionValue = 'CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE',
  /** Mutually exclusive input fields provided. */
  CannotSpecifyBoth = 'CANNOT_SPECIFY_BOTH',
  /** The price of the variant must be greater than or equal to zero. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Input is invalid. */
  InvalidInput = 'INVALID_INPUT',
  /** Metafield value is invalid. */
  InvalidValue = 'INVALID_VALUE',
  /** Inventory quantity input exceeds the limit of 50000. Consider using separate `inventorySetQuantities` mutations. */
  InventoryQuantitiesLimitExceeded = 'INVENTORY_QUANTITIES_LIMIT_EXCEEDED',
  /** Price must be 0 for variants of products with a gift card issuance currency. */
  LocalCurrencyGiftCardPriceMustBeZero = 'LOCAL_CURRENCY_GIFT_CARD_PRICE_MUST_BE_ZERO',
  /** Input must be for this product. */
  MustBeForThisProduct = 'MUST_BE_FOR_THIS_PRODUCT',
  /** Mandatory field input field missing. */
  MustSpecifyOneOfPair = 'MUST_SPECIFY_ONE_OF_PAIR',
  /** Variant options are not enough. */
  NeedToAddOptionValues = 'NEED_TO_ADD_OPTION_VALUES',
  /** Price cannot take a negative value. */
  NegativePriceValue = 'NEGATIVE_PRICE_VALUE',
  /** Input is not defined for this shop. */
  NotDefinedForShop = 'NOT_DEFINED_FOR_SHOP',
  /** Inventory quantities cannot be provided during update. */
  NoInventoryQuantitesDuringUpdate = 'NO_INVENTORY_QUANTITES_DURING_UPDATE',
  /** Inventory quantities can only be provided during create. To update inventory for existing variants, use inventoryAdjustQuantities. */
  NoInventoryQuantitiesOnVariantsUpdate = 'NO_INVENTORY_QUANTITIES_ON_VARIANTS_UPDATE',
  /** Option does not exist. */
  OptionDoesNotExist = 'OPTION_DOES_NOT_EXIST',
  /** Variant options are more than the product options. */
  OptionValuesForNumberOfUnknownOptions = 'OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS',
  /** Option value does not exist. */
  OptionValueDoesNotExist = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value name is too long. */
  OptionValueNameTooLong = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  ProductSuspended = 'PRODUCT_SUSPENDED',
  /** Product variant does not exist. */
  ProductVariantDoesNotExist = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Product variant is missing ID attribute. */
  ProductVariantIdMissing = 'PRODUCT_VARIANT_ID_MISSING',
  /** You reached the limit of available SKUs in your current plan. */
  SubscriptionViolation = 'SUBSCRIPTION_VIOLATION',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Operation is not supported for a combined listing parent product. */
  UnsupportedCombinedListingParentOperation = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION',
  /** The variant already exists. */
  VariantAlreadyExists = 'VARIANT_ALREADY_EXISTS'
}

/** The set of valid sort keys for the ProfileItem query. */
export enum ProfileItemSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `inventory_total` value. */
  InventoryTotal = 'INVENTORY_TOTAL',
  /** Sort by the `product_type` value. */
  ProductType = 'PRODUCT_TYPE',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  Vendor = 'VENDOR'
}

/** Return type for `pubSubServerPixelUpdate` mutation. */
export type PubSubServerPixelUpdatePayload = {
  __typename?: 'PubSubServerPixelUpdatePayload';
  /** The server pixel as configured by the mutation. */
  serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsServerPixelUserError>;
};

/** Return type for `pubSubWebhookSubscriptionCreate` mutation. */
export type PubSubWebhookSubscriptionCreatePayload = {
  __typename?: 'PubSubWebhookSubscriptionCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PubSubWebhookSubscriptionCreateUserError>;
  /** The webhook subscription that was created. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An error that occurs during the execution of `PubSubWebhookSubscriptionCreate`. */
export type PubSubWebhookSubscriptionCreateUserError = DisplayableError & {
  __typename?: 'PubSubWebhookSubscriptionCreateUserError';
  /** The error code. */
  code?: Maybe<PubSubWebhookSubscriptionCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PubSubWebhookSubscriptionCreateUserError`. */
export enum PubSubWebhookSubscriptionCreateUserErrorCode {
  /** Invalid parameters provided. */
  InvalidParameters = 'INVALID_PARAMETERS',
  /** Address for this topic has already been taken. */
  Taken = 'TAKEN'
}

/** The input fields for a PubSub webhook subscription. */
export type PubSubWebhookSubscriptionInput = {
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The format in which the webhook subscription should send the data. */
  format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. Only the fields specified will be included in the webhook payload. If null, then all fields will be included. Learn more about [modifying webhook payloads](https://shopify.dev/docs/apps/build/webhooks/customize/modify_payloads). */
  includeFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  metafieldNamespaces?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of identifiers specifying metafields to include in the webhook payload. */
  metafields?: InputMaybe<Array<HasMetafieldsMetafieldIdentifierInput>>;
  /** A human-readable name for the webhook subscription. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The Pub/Sub project ID. */
  pubSubProject: Scalars['String']['input'];
  /** The Pub/Sub topic ID. */
  pubSubTopic: Scalars['String']['input'];
};

/** Return type for `pubSubWebhookSubscriptionUpdate` mutation. */
export type PubSubWebhookSubscriptionUpdatePayload = {
  __typename?: 'PubSubWebhookSubscriptionUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PubSubWebhookSubscriptionUpdateUserError>;
  /** The webhook subscription that was updated. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An error that occurs during the execution of `PubSubWebhookSubscriptionUpdate`. */
export type PubSubWebhookSubscriptionUpdateUserError = DisplayableError & {
  __typename?: 'PubSubWebhookSubscriptionUpdateUserError';
  /** The error code. */
  code?: Maybe<PubSubWebhookSubscriptionUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PubSubWebhookSubscriptionUpdateUserError`. */
export enum PubSubWebhookSubscriptionUpdateUserErrorCode {
  /** Invalid parameters provided. */
  InvalidParameters = 'INVALID_PARAMETERS',
  /** Address for this topic has already been taken. */
  Taken = 'TAKEN'
}

/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type Publication = Node & {
  __typename?: 'Publication';
  /**
   * The app associated with the publication.
   * @deprecated Use [AppCatalog.apps](https://shopify.dev/api/admin-graphql/unstable/objects/AppCatalog#connection-appcatalog-apps) instead.
   */
  app: App;
  /** Whether new products are automatically published to this publication. */
  autoPublish: Scalars['Boolean']['output'];
  /** The catalog associated with the publication. */
  catalog?: Maybe<Catalog>;
  /** The channels associated with the publication. */
  channels?: Maybe<ChannelConnection>;
  /** The list of collection publication records, each representing the publication status and details for a collection published to this publication (typically channel). */
  collectionPublicationsV3: ResourcePublicationConnection;
  /** The list of collections published to the publication. */
  collections: CollectionConnection;
  /** Whether the collection is available to the publication. */
  hasCollection: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The list of products included, but not necessarily published, in the publication. */
  includedProducts: ProductConnection;
  /** The count of products included in the publication. Limited to a maximum of 10000 by default. */
  includedProductsCount?: Maybe<Count>;
  /**
   * Name of the publication.
   * @deprecated Use [Catalog.title](https://shopify.dev/api/admin-graphql/unstable/interfaces/Catalog#field-catalog-title) instead.
   */
  name: Scalars['String']['output'];
  /** A background operation associated with this publication. */
  operation?: Maybe<PublicationOperation>;
  /** The product publications for the list of products published to the publication. */
  productPublicationsV3: ResourcePublicationConnection;
  /** The list of products published to the publication. */
  products: ProductConnection;
  /** Whether the publication supports future publishing. */
  supportsFuturePublishing: Scalars['Boolean']['output'];
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationCollectionPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationHasCollectionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationIncludedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationIncludedProductsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationProductPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A group of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) that are published to an app.
 *
 * Each publication manages which products and collections display on its associated [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel). Merchants can automatically publish products when they're created if [`autoPublish`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.autoPublish) is enabled, or manually control publication through publication records.
 *
 * Publications support scheduled publishing through future publish dates for online store channels, allowing merchants to coordinate product launches and promotional campaigns. The [`catalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication#field-Publication.fields.catalog) field links to pricing and availability rules specific to that publication's context.
 */
export type PublicationProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};

/** An auto-generated type for paginating through multiple Publications. */
export type PublicationConnection = {
  __typename?: 'PublicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<PublicationEdge>;
  /** A list of nodes that are contained in PublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Publication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for creating a publication. */
export type PublicationCreateInput = {
  /** Whether to automatically add newly created products to this publication. */
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the catalog. */
  catalogId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to create an empty publication or prepopulate it with all products. */
  defaultState?: InputMaybe<PublicationCreateInputPublicationDefaultState>;
};

/** The input fields for the possible values for the default state of a publication. */
export enum PublicationCreateInputPublicationDefaultState {
  /** The publication is populated with all products. */
  AllProducts = 'ALL_PRODUCTS',
  /** The publication is empty. */
  Empty = 'EMPTY'
}

/** Return type for `publicationCreate` mutation. */
export type PublicationCreatePayload = {
  __typename?: 'PublicationCreatePayload';
  /** The publication that's been created. */
  publication?: Maybe<Publication>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PublicationUserError>;
};

/** Return type for `publicationDelete` mutation. */
export type PublicationDeletePayload = {
  __typename?: 'PublicationDeletePayload';
  /** The ID of the publication that was deleted. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PublicationUserError>;
};

/** An auto-generated type which holds one Publication and a cursor during pagination. */
export type PublicationEdge = {
  __typename?: 'PublicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of PublicationEdge. */
  node: Publication;
};

/** The input fields required to publish a resource. */
export type PublicationInput = {
  /** ID of the publication. */
  publicationId?: InputMaybe<Scalars['ID']['input']>;
  /** The date and time that the resource was published. Setting this to a date in the future will schedule the resource to be published. Only online store channels support future publishing. This field has no effect if you include it in the `publishableUnpublish` mutation. */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The possible types of publication operations. */
export type PublicationOperation = AddAllProductsOperation | CatalogCsvOperation | PublicationResourceOperation;

/** A bulk update operation on a publication. */
export type PublicationResourceOperation = Node & ResourceOperation & {
  __typename?: 'PublicationResourceOperation';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  processedRowCount?: Maybe<Scalars['Int']['output']>;
  /** Represents a rows objects within this background operation. */
  rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  status: ResourceOperationStatus;
};

/** The input fields for updating a publication. */
export type PublicationUpdateInput = {
  /** Whether new products should be automatically published to the publication. */
  autoPublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of publishable IDs to add. The maximum number of publishables to update simultaneously is 50. */
  publishablesToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of publishable IDs to remove. The maximum number of publishables to update simultaneously is 50. */
  publishablesToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Return type for `publicationUpdate` mutation. */
export type PublicationUpdatePayload = {
  __typename?: 'PublicationUpdatePayload';
  /** The publication that's been updated. */
  publication?: Maybe<Publication>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<PublicationUserError>;
};

/** Defines errors encountered while managing a publication. */
export type PublicationUserError = DisplayableError & {
  __typename?: 'PublicationUserError';
  /** The error code. */
  code?: Maybe<PublicationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `PublicationUserError`. */
export enum PublicationUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Products and variants cannot be updated together. */
  CannotCombineProductsAndVariants = 'CANNOT_COMBINE_PRODUCTS_AND_VARIANTS',
  /** Cannot modify a catalog for an app. */
  CannotModifyAppCatalog = 'CANNOT_MODIFY_APP_CATALOG',
  /** Can't modify a publication that belongs to an app catalog. */
  CannotModifyAppCatalogPublication = 'CANNOT_MODIFY_APP_CATALOG_PUBLICATION',
  /** Cannot modify a catalog for a market. */
  CannotModifyMarketCatalog = 'CANNOT_MODIFY_MARKET_CATALOG',
  /** Can't modify a publication that belongs to a market catalog. */
  CannotModifyMarketCatalogPublication = 'CANNOT_MODIFY_MARKET_CATALOG_PUBLICATION',
  /** Catalog does not exist. */
  CatalogNotFound = 'CATALOG_NOT_FOUND',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Publishable ID not found. */
  InvalidPublishableId = 'INVALID_PUBLISHABLE_ID',
  /** Market does not exist. */
  MarketNotFound = 'MARKET_NOT_FOUND',
  /** The product is currently being modified. Please try again later. */
  ProductLockError = 'PRODUCT_LOCK_ERROR',
  /** A product publication cannot be created because the catalog type associated with this publication does not permit publications of this product type. */
  ProductTypeIncompatibleWithCatalogType = 'PRODUCT_TYPE_INCOMPATIBLE_WITH_CATALOG_TYPE',
  /** The publication is currently being modified. Please try again later. */
  PublicationLocked = 'PUBLICATION_LOCKED',
  /** Publication not found. */
  PublicationNotFound = 'PUBLICATION_NOT_FOUND',
  /** The limit for simultaneous publication updates has been exceeded. */
  PublicationUpdateLimitExceeded = 'PUBLICATION_UPDATE_LIMIT_EXCEEDED',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Can't perform this action on a publication. */
  UnsupportedPublicationAction = 'UNSUPPORTED_PUBLICATION_ACTION',
  /** A catalog publication can only contain products. */
  UnsupportedPublishableType = 'UNSUPPORTED_PUBLISHABLE_TYPE',
  /** Variants in a single operation must belong to the same product. */
  VariantsBelongToMultipleProducts = 'VARIANTS_BELONG_TO_MULTIPLE_PRODUCTS',
  /** Variant publishing is not supported for this product type. */
  VariantPublishingUnsupportedProductType = 'VARIANT_PUBLISHING_UNSUPPORTED_PRODUCT_TYPE'
}

/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type Publishable = {
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  availablePublicationsCount?: Maybe<Count>;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  publicationCount: Scalars['Int']['output'];
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  publishedOnCurrentChannel: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  publishedOnPublication: Scalars['Boolean']['output'];
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  resourcePublications: ResourcePublicationConnection;
  /**
   * The total number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, including publications with
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * To get a count that excludes publications with feedback errors, use `availablePublicationsCount`.
   */
  resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * By default, only publications to `APP` catalog types are returned.
   * For `Product` and `ProductVariant`, use the `catalogType` argument to retrieve
   * publications for other catalog types, such as `COMPANY_LOCATION` (B2B) or `MARKET`.
   * `Collection` only supports publications to `APP` catalog types.
   */
  resourcePublicationsV2: ResourcePublicationV2Connection;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  unpublishedPublications: PublicationConnection;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublishedOnChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublishedOnPublicationArgs = {
  publicationId: Scalars['ID']['input'];
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `publishablePublish` mutation. */
export type PublishablePublishPayload = {
  __typename?: 'PublishablePublishPayload';
  /** Resource that has been published. */
  publishable?: Maybe<Publishable>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `publishablePublishToCurrentChannel` mutation. */
export type PublishablePublishToCurrentChannelPayload = {
  __typename?: 'PublishablePublishToCurrentChannelPayload';
  /** Resource that has been published. */
  publishable?: Maybe<Publishable>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `publishableUnpublish` mutation. */
export type PublishableUnpublishPayload = {
  __typename?: 'PublishableUnpublishPayload';
  /** Resource that has been unpublished. */
  publishable?: Maybe<Publishable>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `publishableUnpublishToCurrentChannel` mutation. */
export type PublishableUnpublishToCurrentChannelPayload = {
  __typename?: 'PublishableUnpublishToCurrentChannelPayload';
  /** Resource that has been unpublished. */
  publishable?: Maybe<Publishable>;
  /** The user's shop. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Represents information about the purchasing company for the order or draft order. */
export type PurchasingCompany = {
  __typename?: 'PurchasingCompany';
  /** The company associated to the order or draft order. */
  company: Company;
  /** The company contact associated to the order or draft order. */
  contact?: Maybe<CompanyContact>;
  /** The company location associated to the order or draft order. */
  location: CompanyLocation;
};

/** The input fields for a purchasing company, which is a combination of company, company contact, and company location. */
export type PurchasingCompanyInput = {
  /** ID of the company contact. */
  companyContactId: Scalars['ID']['input'];
  /** ID of the company. */
  companyId: Scalars['ID']['input'];
  /** ID of the company location. */
  companyLocationId: Scalars['ID']['input'];
};

/** Represents information about the purchasing entity for the order or draft order. */
export type PurchasingEntity = Customer | PurchasingCompany;

/** The input fields for a purchasing entity. Can either be a customer or a purchasing company. */
export type PurchasingEntityInput = {
  /** Represents a customer. Null if there's a purchasing company. */
  customerId?: InputMaybe<Scalars['ID']['input']>;
  /** Represents a purchasing company. Null if there's a customer. */
  purchasingCompany?: InputMaybe<PurchasingCompanyInput>;
};

/**
 * Quantity price breaks lets you offer different rates that are based on the
 * amount of a specific variant being ordered.
 */
export type QuantityPriceBreak = Node & {
  __typename?: 'QuantityPriceBreak';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Minimum quantity required to reach new quantity break price. */
  minimumQuantity: Scalars['Int']['output'];
  /** The price of variant after reaching the minimum quanity. */
  price: MoneyV2;
  /** The price list associated with this quantity break. */
  priceList: PriceList;
  /** The product variant associated with this quantity break. */
  variant: ProductVariant;
};

/** An auto-generated type for paginating through multiple QuantityPriceBreaks. */
export type QuantityPriceBreakConnection = {
  __typename?: 'QuantityPriceBreakConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<QuantityPriceBreakEdge>;
  /** A list of nodes that are contained in QuantityPriceBreakEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<QuantityPriceBreak>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one QuantityPriceBreak and a cursor during pagination. */
export type QuantityPriceBreakEdge = {
  __typename?: 'QuantityPriceBreakEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of QuantityPriceBreakEdge. */
  node: QuantityPriceBreak;
};

/** The input fields and values to use when creating quantity price breaks. */
export type QuantityPriceBreakInput = {
  /** The minimum required quantity for a variant to qualify for this price. */
  minimumQuantity: Scalars['Int']['input'];
  /** The price of the product variant when its quantity meets the break's minimum quantity. */
  price: MoneyInput;
  /** The product variant ID associated with the quantity break. */
  variantId: Scalars['ID']['input'];
};

/** The set of valid sort keys for the QuantityPriceBreak query. */
export enum QuantityPriceBreakSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `minimum_quantity` value. */
  MinimumQuantity = 'MINIMUM_QUANTITY'
}

/** The input fields used to update quantity pricing. */
export type QuantityPricingByVariantUpdateInput = {
  /** A list of fixed prices to add. */
  pricesToAdd: Array<PriceListPriceInput>;
  /** A list of variant IDs that identify which fixed prices to remove. */
  pricesToDeleteByVariantId: Array<Scalars['ID']['input']>;
  /** A list of quantity price breaks to add. */
  quantityPriceBreaksToAdd: Array<QuantityPriceBreakInput>;
  /** A list of quantity price break IDs that identify which quantity breaks to remove. */
  quantityPriceBreaksToDelete: Array<Scalars['ID']['input']>;
  /** A list of product variant IDs that identify which quantity breaks to remove. */
  quantityPriceBreaksToDeleteByVariantId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of quantity rules to add. */
  quantityRulesToAdd: Array<QuantityRuleInput>;
  /** A list of variant IDs that identify which quantity rules to remove. */
  quantityRulesToDeleteByVariantId: Array<Scalars['ID']['input']>;
};

/** Return type for `quantityPricingByVariantUpdate` mutation. */
export type QuantityPricingByVariantUpdatePayload = {
  __typename?: 'QuantityPricingByVariantUpdatePayload';
  /** The variants for which quantity pricing was created successfully in the price list. */
  productVariants?: Maybe<Array<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<QuantityPricingByVariantUserError>;
};

/** Error codes for failed volume pricing operations. */
export type QuantityPricingByVariantUserError = DisplayableError & {
  __typename?: 'QuantityPricingByVariantUserError';
  /** The error code. */
  code?: Maybe<QuantityPricingByVariantUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `QuantityPricingByVariantUserError`. */
export enum QuantityPricingByVariantUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Something went wrong when trying to update quantity pricing. Please try again later. */
  GenericError = 'GENERIC_ERROR',
  /** Price list and fixed price currency mismatch. */
  PriceAddCurrencyMismatch = 'PRICE_ADD_CURRENCY_MISMATCH',
  /** Prices to add inputs must be unique by variant id. */
  PriceAddDuplicateInputForVariant = 'PRICE_ADD_DUPLICATE_INPUT_FOR_VARIANT',
  /** The issuance currency of a local currency gift card must match the price list currency. */
  PriceAddLocalCurrencyGiftCardIssuanceCurrencyMismatch = 'PRICE_ADD_LOCAL_CURRENCY_GIFT_CARD_ISSUANCE_CURRENCY_MISMATCH',
  /** The price of a local currency gift card cannot exceed the maximum gift card purchase limit. */
  PriceAddLocalCurrencyGiftCardLimitExceeded = 'PRICE_ADD_LOCAL_CURRENCY_GIFT_CARD_LIMIT_EXCEEDED',
  /** Fixed price's variant not found. */
  PriceAddVariantNotFound = 'PRICE_ADD_VARIANT_NOT_FOUND',
  /** Price is not fixed. */
  PriceDeletePriceNotFixed = 'PRICE_DELETE_PRICE_NOT_FIXED',
  /** Fixed price's variant not found. */
  PriceDeleteVariantNotFound = 'PRICE_DELETE_VARIANT_NOT_FOUND',
  /** Price List does not exist. */
  PriceListNotFound = 'PRICE_LIST_NOT_FOUND',
  /** Price list and quantity price break currency mismatch. */
  QuantityPriceBreakAddCurrencyMismatch = 'QUANTITY_PRICE_BREAK_ADD_CURRENCY_MISMATCH',
  /** Quantity price breaks to add inputs must be unique by variant id and minimum quantity. */
  QuantityPriceBreakAddDuplicateInputForVariantAndMin = 'QUANTITY_PRICE_BREAK_ADD_DUPLICATE_INPUT_FOR_VARIANT_AND_MIN',
  /** Failed to save quantity price break. */
  QuantityPriceBreakAddFailedToSave = 'QUANTITY_PRICE_BREAK_ADD_FAILED_TO_SAVE',
  /** Invalid quantity price break. */
  QuantityPriceBreakAddInvalid = 'QUANTITY_PRICE_BREAK_ADD_INVALID',
  /** Exceeded the allowed number of quantity price breaks per variant. */
  QuantityPriceBreakAddLimitExceeded = 'QUANTITY_PRICE_BREAK_ADD_LIMIT_EXCEEDED',
  /** Quantity price break miniumum is higher than the quantity rule maximum. */
  QuantityPriceBreakAddMinHigherThanQuantityRulesMax = 'QUANTITY_PRICE_BREAK_ADD_MIN_HIGHER_THAN_QUANTITY_RULES_MAX',
  /** Quantity price break miniumum is less than the quantity rule minimum. */
  QuantityPriceBreakAddMinLowerThanQuantityRulesMin = 'QUANTITY_PRICE_BREAK_ADD_MIN_LOWER_THAN_QUANTITY_RULES_MIN',
  /** Quantity price break miniumum is not multiple of the quantity rule increment. */
  QuantityPriceBreakAddMinNotAMultipleOfQuantityRulesIncrement = 'QUANTITY_PRICE_BREAK_ADD_MIN_NOT_A_MULTIPLE_OF_QUANTITY_RULES_INCREMENT',
  /** Quantity price break's fixed price not found. */
  QuantityPriceBreakAddPriceListPriceNotFound = 'QUANTITY_PRICE_BREAK_ADD_PRICE_LIST_PRICE_NOT_FOUND',
  /** Quantity price break variant not found. */
  QuantityPriceBreakAddVariantNotFound = 'QUANTITY_PRICE_BREAK_ADD_VARIANT_NOT_FOUND',
  /** Variant to delete by is not found. */
  QuantityPriceBreakDeleteByVariantIdVariantNotFound = 'QUANTITY_PRICE_BREAK_DELETE_BY_VARIANT_ID_VARIANT_NOT_FOUND',
  /** Failed to delete quantity price break. */
  QuantityPriceBreakDeleteFailed = 'QUANTITY_PRICE_BREAK_DELETE_FAILED',
  /** Quantity price break not found. */
  QuantityPriceBreakDeleteNotFound = 'QUANTITY_PRICE_BREAK_DELETE_NOT_FOUND',
  /** Quantity rule catalog context not supported. */
  QuantityRuleAddCatalogContextNotSupported = 'QUANTITY_RULE_ADD_CATALOG_CONTEXT_NOT_SUPPORTED',
  /** Quantity rules to add inputs must be unique by variant id. */
  QuantityRuleAddDuplicateInputForVariant = 'QUANTITY_RULE_ADD_DUPLICATE_INPUT_FOR_VARIANT',
  /** Quantity rule increment is greater than minimum. */
  QuantityRuleAddIncrementIsGreaterThanMinimum = 'QUANTITY_RULE_ADD_INCREMENT_IS_GREATER_THAN_MINIMUM',
  /** Quantity rule increment is less than one. */
  QuantityRuleAddIncrementIsLessThanOne = 'QUANTITY_RULE_ADD_INCREMENT_IS_LESS_THAN_ONE',
  /** Quantity rule increment must be a multiple of the quantity price break minimum. */
  QuantityRuleAddIncrementNotAMultipleOfQuantityPriceBreakMin = 'QUANTITY_RULE_ADD_INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule maximum is less than one. */
  QuantityRuleAddMaximumIsLessThanOne = 'QUANTITY_RULE_ADD_MAXIMUM_IS_LESS_THAN_ONE',
  /** Quantity rule maximum is not a multiple of increment. */
  QuantityRuleAddMaximumNotAMultipleOfIncrement = 'QUANTITY_RULE_ADD_MAXIMUM_NOT_A_MULTIPLE_OF_INCREMENT',
  /** Quantity rule maximum is less than the quantity price break minimum. */
  QuantityRuleAddMaxLowerThanQuantityPriceBreakMin = 'QUANTITY_RULE_ADD_MAX_LOWER_THAN_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule minimum is greater than maximum. */
  QuantityRuleAddMinimumGreaterThanMaximum = 'QUANTITY_RULE_ADD_MINIMUM_GREATER_THAN_MAXIMUM',
  /** Quantity rule minimum is less than one. */
  QuantityRuleAddMinimumIsLessThanOne = 'QUANTITY_RULE_ADD_MINIMUM_IS_LESS_THAN_ONE',
  /** Quantity rule minimum is not a multiple of increment. */
  QuantityRuleAddMinimumNotAMultipleOfIncrement = 'QUANTITY_RULE_ADD_MINIMUM_NOT_A_MULTIPLE_OF_INCREMENT',
  /** Quantity rule minimum is higher than the quantity price break minimum. */
  QuantityRuleAddMinHigherThanQuantityPriceBreakMin = 'QUANTITY_RULE_ADD_MIN_HIGHER_THAN_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule variant not found. */
  QuantityRuleAddVariantNotFound = 'QUANTITY_RULE_ADD_VARIANT_NOT_FOUND',
  /** Quantity rule not found. */
  QuantityRuleDeleteRuleNotFound = 'QUANTITY_RULE_DELETE_RULE_NOT_FOUND',
  /** Quantity rule variant not found. */
  QuantityRuleDeleteVariantNotFound = 'QUANTITY_RULE_DELETE_VARIANT_NOT_FOUND'
}

/** The quantity rule for the product variant in a given context. */
export type QuantityRule = {
  __typename?: 'QuantityRule';
  /**
   * The value that specifies the quantity increment between minimum and maximum of the rule.
   * Only quantities divisible by this value will be considered valid.
   *
   * The increment must be lower than or equal to the minimum and the maximum, and both minimum and maximum
   * must be divisible by this value.
   */
  increment: Scalars['Int']['output'];
  /** Whether the quantity rule fields match one increment, one minimum and no maximum. */
  isDefault: Scalars['Boolean']['output'];
  /**
   * An optional value that defines the highest allowed quantity purchased by the customer.
   * If defined, maximum must be lower than or equal to the minimum and must be a multiple of the increment.
   */
  maximum?: Maybe<Scalars['Int']['output']>;
  /**
   * The value that defines the lowest allowed quantity purchased by the customer.
   * The minimum must be a multiple of the quantity rule's increment.
   */
  minimum: Scalars['Int']['output'];
  /** Whether the values of the quantity rule were explicitly set. */
  originType: QuantityRuleOriginType;
  /** The product variant for which the quantity rule is applied. */
  productVariant: ProductVariant;
};

/** An auto-generated type for paginating through multiple QuantityRules. */
export type QuantityRuleConnection = {
  __typename?: 'QuantityRuleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<QuantityRuleEdge>;
  /** A list of nodes that are contained in QuantityRuleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<QuantityRule>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one QuantityRule and a cursor during pagination. */
export type QuantityRuleEdge = {
  __typename?: 'QuantityRuleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of QuantityRuleEdge. */
  node: QuantityRule;
};

/** The input fields for the per-order quantity rule to be applied on the product variant. */
export type QuantityRuleInput = {
  /** The quantity increment. */
  increment: Scalars['Int']['input'];
  /** The maximum quantity. */
  maximum?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum quantity. */
  minimum: Scalars['Int']['input'];
  /** Product variant on which to apply the quantity rule. */
  variantId: Scalars['ID']['input'];
};

/** The origin of quantity rule on a price list. */
export enum QuantityRuleOriginType {
  /** Quantity rule is explicitly defined. */
  Fixed = 'FIXED',
  /** Quantity rule falls back to the relative rule. */
  Relative = 'RELATIVE'
}

/** An error for a failed quantity rule operation. */
export type QuantityRuleUserError = DisplayableError & {
  __typename?: 'QuantityRuleUserError';
  /** The error code. */
  code?: Maybe<QuantityRuleUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `QuantityRuleUserError`. */
export enum QuantityRuleUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Quantity rules can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CatalogContextDoesNotSupportQuantityRules = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** Quantity rule inputs must be unique by variant id. */
  DuplicateInputForVariant = 'DUPLICATE_INPUT_FOR_VARIANT',
  /** Something went wrong when trying to save the quantity rule. Please try again later. */
  GenericError = 'GENERIC_ERROR',
  /** Value must be greater than or equal to 1. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Increment must be lower than or equal to the minimum. */
  IncrementIsGreaterThanMinimum = 'INCREMENT_IS_GREATER_THAN_MINIMUM',
  /** Increment must be a multiple of all quantity price break minimums associated with this variant in the specified price list. */
  IncrementNotAMultipleOfQuantityPriceBreakMinimum = 'INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MINIMUM',
  /** Maximum must be greater than or equal to all quantity price break minimums associated with this variant in the specified price list. */
  MaximumIsLowerThanQuantityPriceBreakMinimum = 'MAXIMUM_IS_LOWER_THAN_QUANTITY_PRICE_BREAK_MINIMUM',
  /** The maximum must be a multiple of the increment. */
  MaximumNotMultipleOfIncrement = 'MAXIMUM_NOT_MULTIPLE_OF_INCREMENT',
  /** Minimum must be lower than or equal to the maximum. */
  MinimumIsGreaterThanMaximum = 'MINIMUM_IS_GREATER_THAN_MAXIMUM',
  /** Minimum must be less than or equal to all quantity price break minimums associated with this variant in the specified price list. */
  MinimumIsHigherThanQuantityPriceBreakMinimum = 'MINIMUM_IS_HIGHER_THAN_QUANTITY_PRICE_BREAK_MINIMUM',
  /** The minimum must be a multiple of the increment. */
  MinimumNotMultipleOfIncrement = 'MINIMUM_NOT_MULTIPLE_OF_INCREMENT',
  /** Price list does not exist. */
  PriceListDoesNotExist = 'PRICE_LIST_DOES_NOT_EXIST',
  /** Product variant ID does not exist. */
  ProductVariantDoesNotExist = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Quantity rule for variant associated with the price list provided does not exist. */
  VariantQuantityRuleDoesNotExist = 'VARIANT_QUANTITY_RULE_DOES_NOT_EXIST'
}

/** Return type for `quantityRulesAdd` mutation. */
export type QuantityRulesAddPayload = {
  __typename?: 'QuantityRulesAddPayload';
  /** The list of quantity rules that were added to or updated in the price list. */
  quantityRules?: Maybe<Array<QuantityRule>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<QuantityRuleUserError>;
};

/** Return type for `quantityRulesDelete` mutation. */
export type QuantityRulesDeletePayload = {
  __typename?: 'QuantityRulesDeletePayload';
  /** A list of product variant IDs whose quantity rules were removed from the price list. */
  deletedQuantityRulesVariantIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<QuantityRuleUserError>;
};

/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRoot = {
  __typename?: 'QueryRoot';
  /**
   * Returns a list of abandoned checkouts. A checkout is considered abandoned when a customer adds contact information but doesn't complete their purchase. Includes both abandoned and recovered checkouts.
   *
   * Each checkout provides [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) details, [`AbandonedCheckoutLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AbandonedCheckoutLineItem) objects, pricing information, and a recovery URL for re-engaging customers who didn't complete their purchase.
   */
  abandonedCheckouts: AbandonedCheckoutConnection;
  /** Returns the count of abandoned checkouts for the given shop. Limited to a maximum of 10000 by default. */
  abandonedCheckoutsCount?: Maybe<Count>;
  /** Returns a `Abandonment` resource by ID. */
  abandonment?: Maybe<Abandonment>;
  /** Returns an Abandonment by the Abandoned Checkout ID. */
  abandonmentByAbandonedCheckoutId?: Maybe<Abandonment>;
  /**
   * Retrieves an [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) by its ID. If no ID is provided, returns details about the currently authenticated app. The query provides access to app details including title, icon, and pricing information.
   *
   * If the app isn't installed on the current shop, then the [`installation`](https://shopify.dev/docs/api/admin-graphql/latest/queries/app#returns-App.fields.installation) field will be `null`.
   */
  app?: Maybe<App>;
  /**
   * Retrieves an app by its unique handle. The handle is a URL-friendly identifier for the app.
   *
   * Returns the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) if found, or `null` if no app exists with the specified handle.
   */
  appByHandle?: Maybe<App>;
  /**
   * Retrieves an [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) by its client ID (API key). Returns the app's configuration, installation status, [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, and developer information.
   *
   * Returns `null` if no app exists with the specified client ID.
   */
  appByKey?: Maybe<App>;
  /** An app discount type. */
  appDiscountType?: Maybe<AppDiscountType>;
  /** A list of app discount types installed by apps. */
  appDiscountTypes: Array<AppDiscountType>;
  /** A list of app discount types installed by apps. */
  appDiscountTypesNodes: AppDiscountTypeConnection;
  /**
   * Retrieves an [`AppInstallation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppInstallation) by ID. If no ID is provided, returns the installation for the currently authenticated [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App). The query provides essential data for validating installation state and managing app functionality within a store.
   *
   * Use this query to access installation details including granted [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects, active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects, [`AppCredit`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppCredit) objects, [`AppPurchaseOneTime`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppPurchaseOneTime) objects, and app-specific metadata.
   *
   * Learn more about [app installation](https://shopify.dev/docs/apps/build/authentication-authorization/app-installation).
   */
  appInstallation?: Maybe<AppInstallation>;
  /**
   * A paginated list of [`AppInstallation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppInstallation) objects across multiple stores where your app is installed. Use this query to monitor installation status, track billing and subscriptions through [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects, and review granted [`AccessScope`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AccessScope) objects.
   *
   * Filter by [`AppInstallationCategory`](https://shopify.dev/docs/api/admin-graphql/latest/enums/AppInstallationCategory) to find specific types of installations (such as POS or channel apps) and by [`AppInstallationPrivacy`](https://shopify.dev/docs/api/admin-graphql/latest/enums/AppInstallationPrivacy) to scope to public or private installations.
   */
  appInstallations: AppInstallationConnection;
  /** Returns a `Article` resource by ID. */
  article?: Maybe<Article>;
  /** List of article authors for the shop. */
  articleAuthors: ArticleAuthorConnection;
  /** List of all article tags. */
  articleTags: Array<Scalars['String']['output']>;
  /**
   * Returns a paginated list of articles from the shop's blogs. [`Article`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article) objects are blog posts that contain content like text, images, and tags.
   *
   * Supports [cursor-based pagination](https://shopify.dev/docs/api/usage/pagination-graphql) to control the number of articles returned and their order. Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/articles#arguments-query) argument to filter results by specific criteria.
   */
  articles: ArticleConnection;
  /**
   * The paginated list of fulfillment orders assigned to the shop locations owned by the app.
   *
   * Assigned fulfillment orders are fulfillment orders that are set to be fulfilled from locations
   * managed by
   * [fulfillment services](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
   * that are registered by the app.
   * One app (api_client) can host multiple fulfillment services on a shop.
   * Each fulfillment service manages a dedicated location on a shop.
   * Assigned fulfillment orders can have associated
   * [fulfillment requests](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus),
   * or might currently not be requested to be fulfilled.
   *
   * The app must have the `read_assigned_fulfillment_orders`
   * [access scope](https://shopify.dev/docs/api/usage/access-scopes)
   * to be able to retrieve the fulfillment orders assigned to its locations.
   *
   * All assigned fulfillment orders (except those with the `CLOSED` status) will be returned by default.
   * Perform filtering with the `assignmentStatus` argument
   * to receive only fulfillment orders that have been requested to be fulfilled.
   */
  assignedFulfillmentOrders: FulfillmentOrderConnection;
  /**
   * Returns a `DiscountAutomatic` resource by ID.
   * @deprecated Use `automaticDiscountNode` instead.
   */
  automaticDiscount?: Maybe<DiscountAutomatic>;
  /**
   * Returns a `DiscountAutomaticNode` resource by ID.
   * @deprecated Use `discountNode` instead.
   */
  automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /**
   * Returns a list of [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts).
   * @deprecated Use `discountNodes` instead.
   */
  automaticDiscountNodes: DiscountAutomaticNodeConnection;
  /** List of the shop's automatic discount saved searches. */
  automaticDiscountSavedSearches: SavedSearchConnection;
  /**
   * Returns a list of automatic discounts that are applied in the cart and at checkout without requiring a discount code.
   * @deprecated Use `automaticDiscountNodes` instead. This will be removed in 2027-01.
   */
  automaticDiscounts: DiscountAutomaticConnection;
  /** The geographic regions that you can set as the [`Shop`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Shop)'s backup region. The backup region serves as a fallback when the system can't determine a buyer's actual location. */
  availableBackupRegions: Array<MarketRegion>;
  /** Returns a list of activated carrier services and associated shop locations that support them. */
  availableCarrierServices: Array<DeliveryCarrierServiceAndLocations>;
  /** Returns all locales that Shopify supports. Each [`Locale`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Locale) includes an ISO code and human-readable name. Use this query to discover which locales you can enable on a shop with the [`shopLocaleEnable`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/shopLocaleEnable) mutation. */
  availableLocales: Array<Locale>;
  /** The backup region of the shop. */
  backupRegion: MarketRegion;
  /** Returns a `Blog` resource by ID. */
  blog?: Maybe<Blog>;
  /**
   * Returns a paginated list of the shop's [`Blog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Blog) objects. Blogs serve as containers for [`Article`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article) objects and provide content management capabilities for the store's editorial content.
   *
   * Supports [cursor-based pagination](https://shopify.dev/docs/api/usage/pagination-graphql) to control the number of blogs returned and their order. Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/blogs#arguments-query) argument to filter results by specific criteria.
   */
  blogs: BlogConnection;
  /** Count of blogs. Limited to a maximum of 10000 by default. */
  blogsCount?: Maybe<Count>;
  /** Returns a `BulkOperation` resource by ID. */
  bulkOperation?: Maybe<BulkOperation>;
  /** Returns the app's bulk operations meeting the specified filters. Defaults to sorting by created_at, with newest operations first. */
  bulkOperations: BulkOperationConnection;
  /**
   * Returns the list of [business entities](https://shopify.dev/docs/api/admin-graphql/latest/objects/BusinessEntity) associated with the shop. Use this query to retrieve business entities for assigning to markets, managing payment providers per entity, or viewing entity attribution on orders.
   *
   * Each shop can have multiple business entities with one designated as primary. To identify the primary entity in the query results, set the [`primary`](https://shopify.dev/docs/api/admin-graphql/latest/queries/businessEntities#returns-BusinessEntity.fields.primary) field to `true`.
   *
   * Learn more about [managing multiple legal entities](https://shopify.dev/docs/apps/build/markets/multiple-entities).
   */
  businessEntities: Array<BusinessEntity>;
  /** Returns a Business Entity by ID. */
  businessEntity?: Maybe<BusinessEntity>;
  /** Returns a `DeliveryCarrierService` resource by ID. */
  carrierService?: Maybe<DeliveryCarrierService>;
  /** A paginated list of carrier services configured for the shop. Carrier services provide real-time shipping rates from external providers like FedEx, UPS, or custom shipping solutions. Use the `query` parameter to filter results by attributes such as active status. */
  carrierServices: DeliveryCarrierServiceConnection;
  /**
   * Retrieves all cart transform functions currently deployed by your app within the merchant's store. This query provides comprehensive access to your active cart modification logic, enabling management and monitoring of bundling and merchandising features.
   *
   * The query returns paginated results with full cart transform details, including function IDs, configuration settings, and operational status.
   *
   * Cart Transform ownership is scoped to your API client, ensuring you only see and manage functions deployed by your specific app. This isolation prevents conflicts between different apps while maintaining security boundaries for sensitive merchandising logic.
   *
   * Learn more about [managing cart transforms](https://shopify.dev/docs/api/functions/latest/cart-transform).
   */
  cartTransforms: CartTransformConnection;
  /** Returns a `CashDrawer` resource by ID. */
  cashDrawer?: Maybe<CashDrawer>;
  /** A list of cash drawers in the shop. */
  cashDrawers: CashDrawerConnection;
  /** Summary of cash management data for a location. Data is returned only if the location has a POS Pro subscription. */
  cashManagementLocationSummary: CashManagementSummary;
  /** Returns the cash management reason codes for the shop. */
  cashManagementReasonCodes: CashManagementReasonCodeConnection;
  /** Summary of cash management data across all locations with a POS Pro subscription for a shop, filtered by currency. */
  cashManagementShopSummary: CashManagementSummary;
  /** Returns a `CashTrackingSession` resource by ID. */
  cashTrackingSession?: Maybe<CashTrackingSession>;
  /**
   * Returns a shop's cash tracking sessions for locations with a POS Pro subscription.
   *
   * Tip: To query for cash tracking sessions in bulk, you can
   * [perform a bulk operation](https://shopify.dev/docs/api/usage/bulk-operations/queries).
   */
  cashTrackingSessions: CashTrackingSessionConnection;
  /**
   * Retrieves a [catalog](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) by its ID.
   * A catalog represents a list of products with publishing and pricing information,
   * and can be associated with a context, such as a market, company location, or app.
   *
   * Use the `catalog` query to retrieve information associated with the following workflows:
   *
   * - Managing product publications across different contexts
   * - Setting up contextual pricing with price lists
   * - Managing market-specific product availability
   * - Configuring B2B customer catalogs
   *
   * There are several types of catalogs:
   *
   * - [`MarketCatalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketCatalog)
   * - [`AppCatalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppCatalog)
   * - [`CompanyLocationCatalog`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocationCatalog)
   *
   * Learn more about [catalogs for different markets](https://shopify.dev/docs/apps/build/markets/catalogs-different-markets).
   */
  catalog?: Maybe<Catalog>;
  /** Returns the most recent catalog operations for the shop. */
  catalogOperations: Array<ResourceOperation>;
  /**
   * Returns a paginated list of catalogs for the shop. Catalogs control which products are published and how they're priced in different contexts, such as international markets (Canada vs. United States), B2B company locations (different branches of the same business), or specific sales channels (such as online store vs. POS).
   *
   * Filter catalogs by [`type`](https://shopify.dev/docs/api/admin-graphql/latest/queries/catalogs#arguments-type) and use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/catalogs#arguments-query) argument to search and filter by additional criteria.
   *
   * Learn more about [Shopify Catalogs](https://shopify.dev/docs/apps/build/markets/catalogs-different-markets).
   */
  catalogs: CatalogConnection;
  /** The count of catalogs belonging to the shop. Limited to a maximum of 10000 by default. */
  catalogsCount?: Maybe<Count>;
  /** Returns a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) by ID. The channel must belong to the calling application. */
  channel?: Maybe<Channel>;
  /** Returns a [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) by its unique string handle. The handle is either set explicitly during [`channelCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/channelCreate) or auto-generated from the specification handle and account ID. The channel must belong to the calling application. */
  channelByHandle?: Maybe<Channel>;
  /** The list of [`Channel`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel) objects on the shop. When the calling application supports multi-channel, only channels established by the calling application are returned. Each channel represents an authenticated connection to an external selling platform such as a marketplace, social media platform, online store, or point-of-sale system. */
  channels: ChannelConnection;
  /** A checkout and accounts configuration for a shop. */
  checkoutAndAccountsConfiguration?: Maybe<CheckoutAndAccountsConfiguration>;
  /** List of checkout and accounts configurations on a shop. */
  checkoutAndAccountsConfigurations?: Maybe<CheckoutAndAccountsConfigurationConnection>;
  /**
   * Returns the visual customizations for checkout for a given [checkout profile](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutProfile).
   *
   * To update checkout branding settings, use the [`checkoutBrandingUpsert`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/checkoutBrandingUpsert) mutation. Learn more about [customizing checkout's appearance](https://shopify.dev/docs/apps/build/checkout/styling).
   * @deprecated Use `checkoutAndAccountsConfiguration` instead.
   */
  checkoutBranding?: Maybe<CheckoutBranding>;
  /**
   * Returns a [`CheckoutProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CheckoutProfile). Checkout profiles define the branding settings and UI extensions for a store's checkout experience. Stores can have one published profile that renders on their live checkout and multiple draft profiles for testing customizations in the checkout editor.
   * @deprecated Use `checkoutAndAccountsConfiguration` instead.
   */
  checkoutProfile?: Maybe<CheckoutProfile>;
  /**
   * List of checkout profiles on a shop.
   * @deprecated Use `checkoutAndAccountsConfigurations` instead.
   */
  checkoutProfiles: CheckoutProfileConnection;
  /**
   * Returns a [code discount](https://help.shopify.com/manual/discounts/discount-types#discount-codes) resource by ID.
   * @deprecated Use `discountNode` instead.
   */
  codeDiscountNode?: Maybe<DiscountCodeNode>;
  /**
   * Retrieves a [code discount](https://help.shopify.com/manual/discounts/discount-types#discount-codes) by its discount code. The search is case-insensitive, enabling you to find discounts regardless of how customers enter the code.
   *
   * Returns a [`DiscountCodeNode`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeNode) that contains the underlying discount details, which could be a basic [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount), a ["Buy X Get Y" (BXGY) discount](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y), a [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping), or an [app-provided discount](https://help.shopify.com/manual/discounts/discount-types/discounts-with-apps).
   *
   * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts).
   */
  codeDiscountNodeByCode?: Maybe<DiscountCodeNode>;
  /**
   * Returns a list of [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes).
   * @deprecated Use `discountNodes` instead.
   */
  codeDiscountNodes: DiscountCodeNodeConnection;
  /** List of the shop's code discount saved searches. */
  codeDiscountSavedSearches: SavedSearchConnection;
  /**
   * Retrieves a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) by its ID.
   * A collection represents a grouping of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * that merchants can display and sell as a group in their [online store](https://shopify.dev/docs/apps/build/online-store) and
   * other [sales channels](https://shopify.dev/docs/apps/build/sales-channels).
   *
   * Use the `collection` query when you need to:
   *
   * - Manage collection publishing across sales channels
   * - Access collection metadata and SEO information
   * - Work with collection conditions and product relationships
   *
   * A collection determines which products it includes through conditions that automatically include
   * products that match, and through manual selections of individual products. Each collection has
   * associated metadata including title, description, handle, image, and
   * [metafields](https://shopify.dev/docs/apps/build/custom-data/metafields).
   */
  collection?: Maybe<Collection>;
  /**
   * Retrieves a collection by its unique handle identifier. Handles provide a URL-friendly way to reference collections and are commonly used in storefront URLs and navigation.
   *
   * For example, a collection with the title "Summer Sale" might have the handle `summer-sale`, allowing you to fetch it directly without knowing the internal ID.
   *
   * Use `CollectionByHandle` to:
   * - Fetch collections for storefront display and navigation
   * - Build collection-based URLs and routing systems
   * - Validate collection existence before displaying content
   *
   * Handles are automatically generated from collection titles but can be customized by merchants for SEO and branding purposes.
   *
   * Learn more about [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection).
   * @deprecated Use `collectionByIdentifier` instead.
   */
  collectionByHandle?: Maybe<Collection>;
  /** Return a collection by an identifier. */
  collectionByIdentifier?: Maybe<Collection>;
  /** Lists all metafield definitions that can be used to create collection conditions. */
  collectionConditionMetafieldDefinitions: Array<CollectionConditionMetafieldDefinitionInterface>;
  /** Returns the shareable collection sources owned by the given app for the shop. */
  collectionConditionsSources: CollectionConditionsSourceConnection;
  /** Returns the apps that publish shareable collection sources for the shop, paginated. */
  collectionConditionsSourcesByApp: CollectionConditionsSourcesByAppConnection;
  /**
   * Lists all rules that can be used to create collections.
   * @deprecated Use `CollectionSourceInclusionCondition*` and `CollectionSourceExclusionCondition*` types instead.
   */
  collectionRulesConditions: Array<CollectionRuleConditions>;
  /** Returns a list of the shop's collection saved searches. */
  collectionSavedSearches: SavedSearchConnection;
  /**
   * Retrieves a list of [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection)
   * in a store. Collections are groups of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * that merchants can organize for display in their [online store](https://shopify.dev/docs/apps/build/online-store) and
   * other [sales channels](https://shopify.dev/docs/apps/build/sales-channels).
   * For example, an athletics store might create different collections for running attire, shoes, and accessories.
   *
   * Use the `collections` query when you need to:
   *
   * - Build a browsing interface for a store's product groupings.
   * - Create collection searching, sorting, and filtering experiences (for example, by title, type, or published status).
   * - Sync collection data with external systems.
   *
   * The `collections` query supports [pagination](https://shopify.dev/docs/api/usage/pagination-graphql)
   * for large catalogs and [saved searches](https://shopify.dev/docs/api/admin-graphql/latest/queries/collections#arguments-savedSearchId)
   * for frequently used collection queries.
   *
   * The `collections` query returns collections with their associated metadata, including:
   *
   * - Basic collection information (title, description, handle, and type)
   * - Collection image and SEO metadata
   * - Product count and product relationships
   * - Collection rules or conditions
   * - Publishing status and publication details
   * - Metafields and custom attributes
   *
   * Learn more about [using metafields with collection conditions](https://shopify.dev/docs/apps/build/custom-data/metafields/use-metafield-capabilities).
   */
  collections: CollectionConnection;
  /** Count of collections. Limited to a maximum of 10000 by default. */
  collectionsCount?: Maybe<Count>;
  /** Returns a `Comment` resource by ID. */
  comment?: Maybe<Comment>;
  /** List of the shop's comments. */
  comments: CommentConnection;
  /**
   * A paginated list of companies in the shop. [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) objects are business entities that purchase from the merchant.
   *
   * Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/companies#arguments-query) argument to filter companies by attributes like name or externalId. Sort and paginate results to handle large datasets efficiently. Learn more about [Shopify API search syntax](https://shopify.dev/docs/api/usage/search-syntax).
   */
  companies: CompanyConnection;
  /** The number of companies for a shop. Limited to a maximum of 10000 by default. */
  companiesCount?: Maybe<Count>;
  /** Returns a `Company` resource by ID. */
  company?: Maybe<Company>;
  /** Returns a `CompanyContact` resource by ID. */
  companyContact?: Maybe<CompanyContact>;
  /** Returns a `CompanyContactRole` resource by ID. */
  companyContactRole?: Maybe<CompanyContactRole>;
  /** Returns a `CompanyLocation` resource by ID. */
  companyLocation?: Maybe<CompanyLocation>;
  /**
   * A paginated list of [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects for B2B customers. Company locations represent individual branches or offices of a [`Company`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Company) where B2B orders can be placed.
   *
   * Each location can have its own billing and shipping addresses, tax settings, [`PaymentTerms`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PaymentTerms), and [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) assignments with custom pricing. Use the query parameter to search locations by name or other attributes.
   *
   * Learn more about [managing company locations](https://shopify.dev/docs/apps/build/b2b/manage-client-company-locations).
   */
  companyLocations: CompanyLocationConnection;
  /** Returns the customer privacy consent policies of a shop. */
  consentPolicy: Array<ConsentPolicy>;
  /** List of countries and regions for which consent policies can be created or updated. */
  consentPolicyRegions: Array<ConsentPolicyRegion>;
  /**
   * Returns the [`AppInstallation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppInstallation) for the currently authenticated app. Provides access to granted access scopes, active [`AppSubscription`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppSubscription) objects, and billing information for your app.
   *
   * Use this query to check which permissions your app has, monitor subscription status, or retrieve [`AppCredit`](https://shopify.dev/docs/api/admin-graphql/latest/objects/AppCredit) objects. Learn more about [managing access scopes](https://shopify.dev/docs/api/usage/access-scopes#checking-granted-access-scopes), [subscription billing](https://shopify.dev/docs/apps/launch/billing/subscription-billing), and [app credits](https://shopify.dev/docs/apps/launch/billing/award-app-credits).
   */
  currentAppInstallation: AppInstallation;
  /**
   * Returns the current app's most recent [`BulkOperation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BulkOperation). Bulk query and bulk mutation operations can run at the same time per shop. The number of concurrent operations that an app can run depends on the API version. For the applicable concurrency limits, refer to the [bulk operations guide](https://shopify.dev/docs/api/usage/bulk-operations/queries).
   *
   * The operation type parameter determines whether to retrieve the most recent query or mutation bulk operation. Use this query to check the operation's status, track its progress, and retrieve the result URL when it completes.
   * @deprecated Use `bulkOperations` with status filter instead.
   */
  currentBulkOperation?: Maybe<BulkOperation>;
  /** The staff member making the API request. */
  currentStaffMember?: Maybe<StaffMember>;
  /** Returns a `Customer` resource by ID. */
  customer?: Maybe<Customer>;
  /** Returns a `CustomerAccountPage` resource by ID. */
  customerAccountPage?: Maybe<CustomerAccountPage>;
  /** List of the shop's customer account pages. */
  customerAccountPages?: Maybe<CustomerAccountPageConnection>;
  /** Return a customer by an identifier. */
  customerByIdentifier?: Maybe<Customer>;
  /** Returns the status of a customer merge request job. */
  customerMergeJobStatus?: Maybe<CustomerMergeRequest>;
  /**
   * Returns a preview of a customer merge request.
   *
   * The `customerOneId` and `customerTwoId` arguments don't guarantee which customer is kept. Shopify
   * selects the resulting customer in this order:
   * 1. If `overrideFields.customerIdOfEmailToKeep` is provided and valid, then the selected customer is kept.
   * 2. If exactly one customer has an email address, then that customer is kept.
   * 3. If both customers have email addresses, then account state and email marketing consent determine
   *    the customer that's kept: an `enabled` account wins over other account states; otherwise, an
   *    `invited` account can win when consent doesn't already prefer `subscribed` or `pending`; otherwise
   *    the consent result is used. If those rules don't prefer either customer, then `customerTwoId` is kept.
   * 4. If neither customer has an email address, then `customerTwoId` is kept.
   */
  customerMergePreview: CustomerMergePreview;
  /** Returns a vaulted customer payment method by its ID, including the instrument type (credit card, PayPal, etc.), billing address, and current status. Optionally includes revoked payment methods. Use this to look up a specific saved payment method for a customer — for example, to check whether a subscription's payment method is still valid or to display stored payment details. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /**
   * List of the shop's customer saved searches.
   * @deprecated Use `segments` instead.
   */
  customerSavedSearches: SavedSearchConnection;
  /**
   * A paginated list of customers that belong to an individual [`Segment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment). Segments group customers based on criteria defined through [ShopifyQL queries](https://shopify.dev/docs/api/shopifyql/segment-query-language-reference). Access segment members with their profile information and purchase summary data. The connection includes statistics for analyzing segment attributes (such as average and sum calculations) and a total count of all members.
   * The maximum page size is 1000.
   */
  customerSegmentMembers: CustomerSegmentMemberConnection;
  /** Returns a `CustomerSegmentMembersQuery` resource by ID. */
  customerSegmentMembersQuery?: Maybe<CustomerSegmentMembersQuery>;
  /** Whether a member, which is a customer, belongs to a segment. */
  customerSegmentMembership: SegmentMembershipResponse;
  /**
   * Returns a list of [customers](https://shopify.dev/api/admin-graphql/latest/objects/Customer) in your Shopify store, including key information such as name, email, location, and purchase history.
   * Use this query to segment your audience, personalize marketing campaigns, or analyze customer behavior by applying filters based on location, order history, marketing preferences and tags.
   * The `customers` query supports [pagination](https://shopify.dev/api/usage/pagination-graphql) and [sorting](https://shopify.dev/api/admin-graphql/latest/enums/CustomerSortKeys).
   */
  customers: CustomerConnection;
  /** The number of customers. Limited to a maximum of 10000 by default. */
  customersCount?: Maybe<Count>;
  /**
   * The paginated list of deletion events.
   * @deprecated Use `events` instead.
   */
  deletionEvents: DeletionEventConnection;
  /** The delivery customization. */
  deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The delivery customizations. */
  deliveryCustomizations: DeliveryCustomizationConnection;
  /**
   * Retrieves a [`DeliveryProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryProfile) by ID. Delivery profiles group shipping settings for specific [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects that ship from selected [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects to [delivery zones](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryZone with defined rates.
   *
   * Learn more about [delivery profiles](https://shopify.dev/docs/apps/build/purchase-options/deferred/delivery-and-deferment#whats-a-delivery-profile).
   */
  deliveryProfile?: Maybe<DeliveryProfile>;
  /**
   * Returns a paginated list of [`DeliveryProfile`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryProfile) objects for the shop. Delivery profiles group [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects that share shipping rates and zones.
   *
   * Each profile contains [`DeliveryLocationGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryLocationGroup) objects that organize fulfillment [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects and their associated delivery zones. [`DeliveryZone`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DeliveryZone) objects define geographic regions with specific shipping methods and rates. Use the [`merchantOwnedOnly`](https://shopify.dev/docs/api/admin-graphql/latest/queries/deliveryProfiles#arguments-merchantOwnedOnly) filter to exclude profiles that third-party apps manage.
   *
   * Learn more about [delivery profiles](https://shopify.dev/docs/apps/build/purchase-options/deferred/delivery-and-deferment#whats-a-delivery-profile).
   */
  deliveryProfiles: DeliveryProfileConnection;
  /** Returns delivery promise participants. */
  deliveryPromiseParticipants?: Maybe<DeliveryPromiseParticipantConnection>;
  /** Lookup a delivery promise provider. */
  deliveryPromiseProvider?: Maybe<DeliveryPromiseProvider>;
  /** Represents the delivery promise settings for a shop. */
  deliveryPromiseSettings: DeliveryPromiseSetting;
  /** The total number of discount codes for the shop. Limited to a maximum of 10000 by default. */
  discountCodesCount?: Maybe<Count>;
  /** Returns a `DiscountNode` resource by ID. */
  discountNode?: Maybe<DiscountNode>;
  /** Returns a list of discounts. */
  discountNodes: DiscountNodeConnection;
  /** The total number of discounts for the shop. Limited to a maximum of 10000 by default. */
  discountNodesCount?: Maybe<Count>;
  /** Returns a `DiscountRedeemCodeBulkCreation` resource by ID. */
  discountRedeemCodeBulkCreation?: Maybe<DiscountRedeemCodeBulkCreation>;
  /** List of the shop's redeemed discount code saved searches. */
  discountRedeemCodeSavedSearches: SavedSearchConnection;
  /** List of tags associated to discounts. */
  discountTags: StringConnection;
  /** Returns a `ShopifyPaymentsDispute` resource by ID. */
  dispute?: Maybe<ShopifyPaymentsDispute>;
  /** Returns a `ShopifyPaymentsDisputeEvidence` resource by ID. */
  disputeEvidence?: Maybe<ShopifyPaymentsDisputeEvidence>;
  /** Returns a paginated list of all Shopify Payments disputes for the shop. Disputes occur when a buyer files a complaint with their payments provider, and the merchant must provide evidence to contest it. Each dispute includes the status, amount, reason, and associated order. Use this to monitor and manage open chargebacks and track dispute resolution outcomes. */
  disputes: ShopifyPaymentsDisputeConnection;
  /** Returns a `Domain` resource by ID. */
  domain?: Maybe<Domain>;
  /**
   * Retrieves a [draft order](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) by its ID.
   * A draft order is an order created by a merchant on behalf of their
   * customers. Draft orders contain all necessary order details (products, pricing, customer information)
   * but require payment to be accepted before they can be converted into
   * [completed orders](https://shopify.dev/docs/api/admin-graphql/latest/mutations/draftOrderComplete).
   *
   * Use the `draftOrder` query to retrieve information associated with the following workflows:
   *
   * - Creating orders for phone, in-person, or chat sales
   * - Sending invoices to customers with secure checkout links
   * - Managing custom items and additional costs
   * - Selling products at discount or wholesale rates
   * - Processing pre-orders and saving drafts for later completion
   *
   * A draft order is associated with a
   * [customer](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer)
   * and contains multiple [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrderLineItem).
   * Each draft order has a [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder#field-DraftOrder.fields.status),
   * which indicates its progress through the sales workflow.
   */
  draftOrder?: Maybe<DraftOrder>;
  /**
   * Available delivery options for a [`DraftOrder`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DraftOrder) based on the provided input. The query returns shipping rates, local delivery rates, and pickup locations that merchants can choose from when creating draft orders.
   *
   * Accepts draft order details including [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, [`MailingAddress`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MailingAddress) for shipping, and discounts to determine which delivery methods are available. Pagination parameters control the number of local pickup options returned.
   */
  draftOrderAvailableDeliveryOptions: DraftOrderAvailableDeliveryOptions;
  /** List of the shop's draft order saved searches. */
  draftOrderSavedSearches: SavedSearchConnection;
  /** Returns a `DraftOrderTag` resource by ID. */
  draftOrderTag?: Maybe<DraftOrderTag>;
  /** List of saved draft orders. */
  draftOrders: DraftOrderConnection;
  /** Returns the number of draft orders that match the query. Limited to a maximum of 10000 by default. */
  draftOrdersCount?: Maybe<Count>;
  /** Retrieves a single event by ID. Events chronicle activities in your store such as resource creation, updates, or staff comments. The query returns an [`Event`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Event) interface of type [`BasicEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BasicEvent) or [`CommentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CommentEvent). */
  event?: Maybe<Event>;
  /**
   * A paginated list of events that chronicle activities in the store. [`Event`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Event) is an interface implemented by types such as [`BasicEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/BasicEvent) and [`CommentEvent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CommentEvent) that track actions such as creating [`Article`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Article) objects, fulfilling [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects, adding [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects, or staff comments on timelines.
   *
   * The query supports filtering and sorting to help you find specific events or audit store activity over time.
   */
  events?: Maybe<EventConnection>;
  /** Count of events. Limited to a maximum of 10000. */
  eventsCount?: Maybe<Count>;
  extensions: ShopifyGraphQlExtensions;
  /** A list of the shop's file saved searches. */
  fileSavedSearches: SavedSearchConnection;
  /**
   * Retrieves a paginated list of files that have been uploaded to a Shopify store. Files represent digital assets
   * that merchants can upload to their store for various purposes including product images, marketing materials,
   * documents, and brand assets.
   *
   * Use the `files` query to retrieve information associated with the following workflows:
   *
   * - [Managing product media and images](https://shopify.dev/docs/apps/build/online-store/product-media)
   * - [Theme development and asset management](https://shopify.dev/docs/storefronts/themes/store/success/brand-assets)
   * - Brand asset management and [checkout branding](https://shopify.dev/docs/apps/build/checkout/styling/add-favicon)
   *
   * Files can include multiple [content types](https://shopify.dev/docs/api/admin-graphql/latest/enums/FileContentType),
   * such as images, videos, 3D models, and generic files. Each file has
   * properties like dimensions, file size, alt text for accessibility, and upload status. Files can be filtered
   * by [media type](https://shopify.dev/docs/api/admin-graphql/latest/enums/MediaContentType) and can be associated with
   * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product),
   * [themes](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme),
   * and other store resources.
   */
  files: FileConnection;
  /** Returns the access policy for a finance app . */
  financeAppAccessPolicy: FinanceAppAccessPolicy;
  /** Returns Know Your Customer (KYC) information for the shop's Shopify Payments account. KYC data includes verified identity and business details collected during onboarding. This is primarily used by embedded finance apps (e.g., Shopify Balance, Bill Pay) that need to verify the merchant's identity without requiring a separate KYC process. */
  financeKycInformation?: Maybe<FinanceKycInformation>;
  /**
   * Retrieves a [`Fulfillment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Fulfillment) by its ID. A fulfillment is a record that the merchant has completed their work required for one or more line items in an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). It includes tracking information, [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) objects, and the status of the fulfillment.
   *
   * Use this query to track the progress of shipped items, view tracking details, or check [fulfillment events](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentEvent) for example when a package is out for delivery or delivered.
   */
  fulfillment?: Maybe<Fulfillment>;
  /** The fulfillment constraint rules that belong to a shop. */
  fulfillmentConstraintRules: Array<FulfillmentConstraintRule>;
  /** Returns a `FulfillmentOrder` resource by ID. */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The paginated list of all fulfillment orders.
   * The returned fulfillment orders are filtered according to the
   * [fulfillment order access scopes](https://shopify.dev/api/admin-graphql/latest/objects/fulfillmentorder#api-access-scopes)
   * granted to the app.
   *
   * Use this query to retrieve fulfillment orders assigned to merchant-managed locations,
   * third-party fulfillment service locations, or all kinds of locations together.
   *
   * For fetching only the fulfillment orders assigned to the app's locations, use the
   * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
   * connection.
   */
  fulfillmentOrders: FulfillmentOrderConnection;
  /**
   * Returns a [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) by its ID. The service can manage inventory, process fulfillment requests, and provide tracking details through callback endpoints or directly calling Shopify's APIs.
   *
   * When you register a fulfillment service, Shopify automatically creates an associated [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) where fulfillment order's can be assigned to be processed.
   *
   * Learn more about [building fulfillment service apps](https://shopify.dev/docs/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services).
   */
  fulfillmentService?: Maybe<FulfillmentService>;
  /**
   * Retrieves a [`GiftCard`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCard) by its ID. Returns the gift card's balance, transaction history, [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) information, and whether it's enabled.
   *
   * Additional fields include the initial value, expiration date, deactivation timestamp (if applicable), and the associated [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) if the gift card was purchased by a customer through checkout. Gift cards that merchants create manually won't have an associated order.
   */
  giftCard?: Maybe<GiftCard>;
  /** The configuration for the shop's gift cards. */
  giftCardConfiguration: GiftCardConfiguration;
  /**
   * Returns a paginated list of [`GiftCard`](https://shopify.dev/docs/api/admin-graphql/latest/objects/GiftCard) objects issued for the shop.
   *
   * You can filter gift cards by attributes such as status, last characters of the code, balance status, and other values using the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/giftCards#arguments-query) parameter. You can also apply [`SavedSearch`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SavedSearch) objects to filter results.
   */
  giftCards: GiftCardConnection;
  /** Returns the total count of gift cards that have been issued by the shop. Use this for dashboard summaries or to understand the scale of a merchant's gift card program. The count includes all gift cards regardless of status (active, disabled, or fully redeemed). Limited to a maximum of 10000 by default. */
  giftCardsCount?: Maybe<Count>;
  /**
   * Retrieves an [inventory item](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) by its ID. An inventory item represents the inventory for a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant), and holds the stock keeping unit (SKU), whether quantities are tracked, shipping requirements, and customs information.
   *
   * Use the [`inventoryLevels`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem#field-InventoryItem.fields.inventoryLevels) field to get the [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) for each location that stocks the item, and the level's [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read its inventory quantities by name.
   *
   * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
   */
  inventoryItem?: Maybe<InventoryItem>;
  /** Returns a list of inventory items. */
  inventoryItems: InventoryItemConnection;
  /**
   * Retrieves an [inventory level](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel) by its ID. An inventory level exists for an inventory item at each location that stocks it. Each inventory level has a [`quantities`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel#field-InventoryLevel.fields.quantities) field to read the inventory quantity by name. Quantity names represent the [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory.
   *
   * The [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) and [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects each have an `inventoryLevels` field. Use it to find the ID of an inventory level.
   *
   * Learn more about [inventory object relationships](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
   */
  inventoryLevel?: Maybe<InventoryLevel>;
  /** Returns the shop's inventory configuration, including all inventory quantity names. Quantity names represent different [inventory states](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps#inventory-states) that merchants use to track inventory. */
  inventoryProperties: InventoryProperties;
  /** Retrieves an [`InventoryShipment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryShipment) by ID. Returns tracking details, [`InventoryShipmentLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryShipmentLineItem) objects with quantities, and the shipment's current [`InventoryShipmentStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryShipmentStatus). */
  inventoryShipment?: Maybe<InventoryShipment>;
  /**
   * Returns a paginated list of [`InventoryShipment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryShipment) objects.
   *
   * Supports filtering by barcode (e.g. `barcode:"12345"`), status (e.g. `status:"draft"` or `status:"in_transit"`), and destination (e.g. `destination_id:12345`).
   */
  inventoryShipments?: Maybe<InventoryShipmentConnection>;
  /** Returns an [`InventoryTransfer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransfer) by ID. Inventory transfers track the movement of inventory between locations, including origin and destination details, [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects, quantities, and [`InventoryTransferStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/InventoryTransferStatus) values. */
  inventoryTransfer?: Maybe<InventoryTransfer>;
  /**
   * Returns a paginated list of [`InventoryTransfer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransfer) objects between locations. Transfers track the movement of [`InventoryItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem) objects between [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) objects.
   *
   * Supports filtering transfers using query parameters and sorting by various criteria. Use the connection's edges to access transfer details including [`InventoryTransferLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryTransferLineItem) objects, quantities, and shipment status.
   */
  inventoryTransfers: InventoryTransferConnection;
  /** Returns a Job resource by ID. Used to check the status of internal jobs and any applicable changes. */
  job?: Maybe<Job>;
  /**
   * Retrieves a [`Location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location) by its ID. Locations are physical places where merchants store inventory, such as warehouses, retail stores, or fulfillment centers.
   *
   * Each location tracks inventory levels, fulfillment capabilities, and address information. Active locations can stock products and fulfill orders based on their configuration settings.
   */
  location?: Maybe<Location>;
  /** Return a location by an identifier. */
  locationByIdentifier?: Maybe<Location>;
  /**
   * A paginated list of inventory locations where merchants can stock [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) items and fulfill [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) items.
   *
   * Returns only active locations by default. Use the [`includeInactive`](https://shopify.dev/docs/api/admin-graphql/latest/queries/locations#arguments-includeInactive) argument to retrieve deactivated locations that can no longer stock inventory or fulfill orders. Use the [`includeLegacy`](https://shopify.dev/docs/api/admin-graphql/latest/queries/locations#arguments-includeLegacy) argument to include locations that [`FulfillmentService`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentService) apps manage. Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/locations#arguments-query) argument to filter by location attributes like name, address, and whether local pickup is enabled.
   */
  locations: LocationConnection;
  /**
   * Returns a list of all origin locations available for a delivery profile.
   * @deprecated Use `locationsAvailableForDeliveryProfilesConnection` instead.
   */
  locationsAvailableForDeliveryProfiles?: Maybe<Array<Location>>;
  /** Returns a list of all origin locations available for a delivery profile. */
  locationsAvailableForDeliveryProfilesConnection: LocationConnection;
  /** Returns the count of locations for the given shop. Limited to a maximum of 10000 by default. */
  locationsCount?: Maybe<Count>;
  /** Returns a list of fulfillment orders that are on hold. */
  manualHoldsFulfillmentOrders: FulfillmentOrderConnection;
  /** Returns a `Market` resource by ID. */
  market?: Maybe<Market>;
  /**
   * Returns the applicable market for a customer based on where they are in the world.
   * @deprecated This `market_by_geography` field will be removed in a future version of the API.
   */
  marketByGeography?: Maybe<Market>;
  /** A resource that can have localized values for different markets. */
  marketLocalizableResource?: Maybe<MarketLocalizableResource>;
  /** Resources that can have localized values for different markets. */
  marketLocalizableResources: MarketLocalizableResourceConnection;
  /** Resources that can have localized values for different markets. */
  marketLocalizableResourcesByIds: MarketLocalizableResourceConnection;
  /** A list of marketing activities associated with the marketing app. */
  marketingActivities: MarketingActivityConnection;
  /** Returns a `MarketingActivity` resource by ID. */
  marketingActivity?: Maybe<MarketingActivity>;
  /** Returns a `MarketingEvent` resource by ID. */
  marketingEvent?: Maybe<MarketingEvent>;
  /** A list of marketing events associated with the marketing app. */
  marketingEvents: MarketingEventConnection;
  /**
   * Returns a paginated list of [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) objects configured for the shop. Markets match buyers based on defined conditions to deliver customized shopping experiences.
   *
   * Filter markets by [`MarketType`](https://shopify.dev/docs/api/admin-graphql/latest/enums/MarketType) and [`MarketStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/MarketStatus), search by name, and control sort order. Retrieve market configurations including [`MarketCurrencySettings`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketCurrencySettings), [`MarketWebPresence`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketWebPresence) objects, and [`MarketConditions`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketConditions).
   *
   * Learn more about [Shopify Markets](https://shopify.dev/docs/apps/build/markets).
   */
  markets: MarketConnection;
  /** The resolved values for a buyer signal. */
  marketsResolvedValues: MarketsResolvedValues;
  /** Returns a `Menu` resource by ID. */
  menu?: Maybe<Menu>;
  /**
   * Retrieves navigation menus. Menus organize content into hierarchical navigation structures that merchants can display in the online store (for example, in headers, footers, and sidebars) and customer accounts.
   *
   * Each [`Menu`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Menu) contains a handle for identification, a title for display, and a collection of [`MenuItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MenuItem) objects that can be nested up to 3 levels deep. Default menus have protected handles that can't be modified.
   */
  menus: MenuConnection;
  /**
   * Retrieves a [`MetafieldDefinition`](https://shopify.dev/docs/api/admin-graphql/current/objects/MetafieldDefinition) by its identifier. You can identify a definition using either its owner type, namespace, and key, or its global ID.
   *
   * Use this query to inspect a definition's configuration, including its data type, validations, access settings, and the count of [metafields](https://shopify.dev/docs/api/admin-graphql/current/objects/Metafield) using it.
   */
  metafieldDefinition?: Maybe<MetafieldDefinition>;
  /**
   * The available metafield types that you can use when creating [`MetafieldDefinition`](https://shopify.dev/docs/api/admin-graphql/current/objects/MetafieldDefinition) objects. Each type specifies what kind of data it stores (such as boolean, color, date, or references), its category, and which validations it supports.
   *
   * For a list of supported types and their capabilities, refer to the [metafield types documentation](https://shopify.dev/docs/apps/metafields/types).
   */
  metafieldDefinitionTypes: Array<MetafieldDefinitionType>;
  /** Returns a list of metafield definitions. */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /** Retrieves a single [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) by its global ID. [Metaobjects](https://shopify.dev/docs/apps/build/custom-data#what-are-metaobjects) store custom structured data based on defined schemas. The returned metaobject includes its fields with values, display name, handle, and associated metadata like update timestamps and capabilities. */
  metaobject?: Maybe<Metaobject>;
  /** Retrieves a [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) by its handle and type. Handles are unique identifiers within a metaobject type. */
  metaobjectByHandle?: Maybe<Metaobject>;
  /**
   * Retrieves a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition) by its global ID. Metaobject definitions provide the structure and fields for metaobjects.
   *
   * The definition includes field configurations, access settings, display preferences, and capabilities that determine how [metaobjects](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) of this type behave across the Shopify platform.
   */
  metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** Retrieves a [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition) by its type. The type serves as a unique identifier that distinguishes one metaobject definition from another. */
  metaobjectDefinitionByType?: Maybe<MetaobjectDefinition>;
  /**
   * Returns a paginated list of all [`MetaobjectDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MetaobjectDefinition) objects configured for the store. Metaobject definitions provide the schema for creating custom data structures composed of individual fields. Each definition specifies the field types, access permissions, and capabilities for [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) entries of that type. Use this query to discover available metaobject types before creating or querying metaobject entries.
   *
   * Learn more about [managing metaobjects](https://shopify.dev/docs/apps/build/custom-data/metaobjects/manage-metaobjects).
   */
  metaobjectDefinitions: MetaobjectDefinitionConnection;
  /**
   * Returns a paginated list of [`Metaobject`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metaobject) entries for a specific type. Metaobjects are custom data structures that extend Shopify's data model with merchant or app-specific data types.
   *
   * Filter results using the query parameter with a search syntax for metaobject fields. Use `fields.{key}:{value}` to filter by field values, supporting any field previously marked as filterable.
   *
   * Results are ordered by metaobject ID in ascending order by default. The `sortKey` parameter accepts `id`, `type`, `updated_at`, or `display_name` to control result ordering. Pass `reverse: true` to invert the order.
   *
   * Learn more about [querying metaobjects by field value](https://shopify.dev/docs/apps/build/custom-data/metafields/query-by-metafield-value).
   */
  metaobjects: MetaobjectConnection;
  /** Return a mobile platform application by its ID. */
  mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** List the mobile platform applications. */
  mobilePlatformApplications: MobilePlatformApplicationConnection;
  /**
   * Returns a specific node (any object that implements the
   * [Node](https://shopify.dev/api/admin-graphql/latest/interfaces/Node)
   * interface) by ID, in accordance with the
   * [Relay specification](https://relay.dev/docs/guides/graphql-server-specification/#object-identification).
   * This field is commonly used for refetching an object.
   */
  node?: Maybe<Node>;
  /**
   * Returns the list of nodes (any objects that implement the
   * [Node](https://shopify.dev/api/admin-graphql/latest/interfaces/Node)
   * interface) with the given IDs, in accordance with the
   * [Relay specification](https://relay.dev/docs/guides/graphql-server-specification/#object-identification).
   */
  nodes: Array<Maybe<Node>>;
  /** The shop's online store channel. */
  onlineStore: OnlineStore;
  /**
   * The `order` query retrieves an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/order) by its ID. This query provides access to comprehensive order information such as customer details, line items, financial data, and fulfillment status.
   *
   * Use the `order` query to retrieve information associated with the following processes:
   *
   * - [Order management and fulfillment](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps)
   * - [Financial reporting](https://help.shopify.com/manual/finance)
   * - [Customer purchase history](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/customers-reports) and [transaction analysis](https://shopify.dev/docs/apps/launch/billing/view-charges-earnings#transaction-data-through-the-graphql-admin-api)
   * - [Shipping](https://shopify.dev/docs/apps/build/checkout/delivery-shipping) and [inventory management](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps)
   *
   * You can only retrieve the last 60 days worth of orders from a store by default. If you want to access older orders, then you need to [request access to all orders](https://shopify.dev/docs/api/usage/access-scopes#orders-permissions).
   *
   * For large order datasets, consider using [bulk operations](https://shopify.dev/docs/api/usage/bulk-operations/queries).
   * Bulk operations handle pagination automatically and allow you to retrieve data asynchronously without being constrained by API rate limits.
   * Learn more about [creating orders](https://shopify.dev/docs/api/admin-graphql/latest/mutations/ordercreate) and [building order management apps](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  order?: Maybe<Order>;
  /**
   * Returns approved order attribution definitions for the calling app on the current shop.
   * Learn more in the [order attribution guide](https://shopify.dev/docs/apps/build/sales-channels/order-attribution).
   */
  orderAttributionDefinitions: OrderAttributionDefinitionConnection;
  /** Return an order by an identifier. */
  orderByIdentifier?: Maybe<Order>;
  /** Returns a `OrderEditSession` resource by ID. */
  orderEditSession?: Maybe<OrderEditSession>;
  /**
   * Retrieves the status of a deferred payment by its payment reference ID. Use this query to monitor the processing status of payments that are initiated through payment mutations. Deferred payments are called [payment terms](https://shopify.dev/docs/apps/build/checkout/payments/payment-terms) in the API.
   *
   * The query returns an [`OrderPaymentStatus`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderPaymentStatus) object that includes the current payment status, any error messages, and associated transactions. Poll this query to track [asynchronous payment processing](https://shopify.dev/docs/apps/build/payments/processing) after initiating a deferred payment.
   */
  orderPaymentStatus?: Maybe<OrderPaymentStatus>;
  /** Returns [saved searches](https://shopify.dev/docs/api/admin-graphql/latest/objects/SavedSearch) for orders in the shop. Saved searches store search queries with their filters and search terms. */
  orderSavedSearches: SavedSearchConnection;
  /**
   * Returns a list of [orders](https://shopify.dev/api/admin-graphql/latest/objects/Order) placed in the store, including data such as order status, customer, and line item details.
   * Use the `orders` query to build reports, analyze sales performance, or automate fulfillment workflows. The `orders` query supports [pagination](https://shopify.dev/docs/api/usage/pagination-graphql),
   * [sorting](https://shopify.dev/docs/api/admin-graphql/latest/queries/orders#arguments-sortKey), and [filtering](https://shopify.dev/docs/api/admin-graphql/latest/queries/orders#arguments-query).
   */
  orders: OrderConnection;
  /**
   * Returns the number of [orders](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) in the shop. You can filter orders using [search syntax](https://shopify.dev/docs/api/usage/search-syntax) or a [`SavedSearch`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SavedSearch), and set a maximum count limit to control query performance.
   *
   * Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/ordersCount#arguments-query) argument to filter the count by criteria like order status, financial state, or fulfillment status. The response includes both the count value and its precision, indicating whether the count is exact or an estimate.
   *
   * > Note:
   * > The count is limited to 10,000 orders by default. Use the [`limit`](https://shopify.dev/docs/api/admin-graphql/latest/queries/ordersCount#arguments-limit) argument to adjust this value, or pass `null` for no limit. Limited to a maximum of 10000 by default.
   */
  ordersCount?: Maybe<Count>;
  /** Returns a `Page` resource by ID. */
  page?: Maybe<Page>;
  /**
   * A paginated list of pages from the online store. [`Page`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Page) objects are content pages that merchants create to provide information to customers, such as "About Us", "Contact", or policy pages.
   *
   * The query supports filtering with a [search query](https://shopify.dev/docs/api/usage/search-syntax) and sorting by various criteria. Advanced filtering is available through saved searches using the [`savedSearchId`](https://shopify.dev/docs/api/admin-graphql/latest/queries/pages#arguments-savedSearchId) argument.
   */
  pages: PageConnection;
  /** Count of pages. Limited to a maximum of 10000 by default. */
  pagesCount?: Maybe<Count>;
  /** The payment customization. */
  paymentCustomization?: Maybe<PaymentCustomization>;
  /** The payment customizations. */
  paymentCustomizations: PaymentCustomizationConnection;
  /** The list of payment terms templates eligible for all shops and users. */
  paymentTermsTemplates: Array<PaymentTermsTemplate>;
  /** The number of pendings orders. Limited to a maximum of 10000. */
  pendingOrdersCount?: Maybe<Count>;
  /** Returns a `PointOfSaleDevice` resource by ID. */
  pointOfSaleDevice?: Maybe<PointOfSaleDevice>;
  /** Lookup a point of sale device payment session by ID. */
  pointOfSaleDevicePaymentSession?: Maybe<PointOfSaleDevicePaymentSession>;
  /** A list of point of sale device payment sessions in the shop. Cash management data is returned only for locations with a POS Pro subscription. */
  pointOfSaleDevicePaymentSessions: PointOfSaleDevicePaymentSessionConnection;
  /**
   * Returns a [`PriceList`](https://shopify.dev/docs/api/admin-graphql/latest/objects/PriceList) by ID. You can use price lists to specify either fixed prices or adjusted relative prices that override initial [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) prices.
   *
   * Price lists enable contextual pricing for the [`Catalog`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/Catalog) they are associated to. Each price list can define fixed prices for specific [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects or percentage-based adjustments relative to other prices.
   */
  priceList?: Maybe<PriceList>;
  /** All price lists for a shop. */
  priceLists: PriceListConnection;
  /**
   * The primary market of the shop.
   * @deprecated Use `backupRegion` instead.
   */
  primaryMarket: Market;
  /** Privacy related settings for a shop. */
  privacySettings: PrivacySettings;
  /**
   * Retrieves a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) by its ID.
   * A product is an item that a merchant can sell in their store.
   *
   * Use the `product` query when you need to:
   *
   * - Access essential product data (for example, title, description, price, images, SEO metadata, and metafields).
   * - Build product detail pages and manage inventory.
   * - Handle international sales with localized pricing and content.
   * - Manage product variants and product options.
   *
   * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
   */
  product?: Maybe<Product>;
  /**
   * Retrieves a [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) using its handle. A handle is a unique, URL-friendly string that Shopify automatically generates from the product's title.
   *
   * Returns `null` if no product exists with the specified handle.
   * @deprecated Use `productByIdentifier` instead.
   */
  productByHandle?: Maybe<Product>;
  /** Return a product by an identifier. */
  productByIdentifier?: Maybe<Product>;
  /** Returns the product duplicate job. */
  productDuplicateJob: ProductDuplicateJob;
  /** Returns a ProductFeed resource by ID. */
  productFeed?: Maybe<ProductFeed>;
  /** The product feeds for the shop. */
  productFeeds: ProductFeedConnection;
  /**
   * Returns a ProductOperation resource by ID.
   *
   * This can be used to query the
   * [ProductSetOperation](https://shopify.dev/api/admin-graphql/current/objects/ProductSetOperation), using
   * the ID that was returned
   * [when the product was created or updated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously)
   * by the
   * [ProductSet](https://shopify.dev/api/admin-graphql/current/mutations/productSet) mutation.
   *
   * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
   *
   * The `product` field provides the details of the created or updated product.
   *
   * For the
   * [ProductSetOperation](https://shopify.dev/api/admin-graphql/current/objects/ProductSetOperation), the
   * `userErrors` field provides mutation errors that occurred during the operation.
   */
  productOperation?: Maybe<ProductOperation>;
  /**
   * Retrieves product resource feedback for the currently authenticated app, providing insights into product data quality, completeness, and optimization opportunities. This feedback helps apps guide merchants toward better product listings and improved store performance.
   *
   * For example, an SEO app might receive feedback indicating that certain products lack meta descriptions or have suboptimal titles, enabling the app to provide specific recommendations for improving search visibility and conversion rates.
   *
   * Use `ProductResourceFeedback` to:
   * - Display product optimization recommendations to merchants
   * - Identify data quality issues across product catalogs
   * - Build product improvement workflows and guided experiences
   * - Track progress on product listing completeness and quality
   * - Implement automated product auditing and scoring systems
   * - Generate reports on catalog health and optimization opportunities
   * - Provide contextual suggestions within product editing interfaces
   *
   * The feedback system evaluates products against various criteria including SEO best practices, required fields, media quality, and sales channel requirements. Each feedback item includes specific details about the issue, suggested improvements, and priority levels.
   *
   * Feedback is app-specific and reflects the particular focus of your application - marketing apps receive different insights than inventory management apps. The system continuously updates as merchants make changes, providing real-time guidance for product optimization.
   *
   * This resource is particularly valuable for apps that help merchants improve their product listings, optimize for search engines, or enhance their overall catalog quality. The feedback enables proactive suggestions rather than reactive problem-solving.
   *
   * Learn more about [product optimization](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product).
   */
  productResourceFeedback?: Maybe<ProductResourceFeedback>;
  /** Returns a list of the shop's product saved searches. */
  productSavedSearches: SavedSearchConnection;
  /**
   * Returns tags added to [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects in the shop. Provides a paginated list of tag strings.
   *
   * The maximum page size is 5000 tags per request. Tags are returned as simple strings through a [`StringConnection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StringConnection).
   * The maximum page size is 5000.
   */
  productTags?: Maybe<StringConnection>;
  /**
   * Returns a paginated list of product types assigned to [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) in the store. The maximum page size is 1000.
   * The maximum page size is 1000.
   */
  productTypes?: Maybe<StringConnection>;
  /**
   * Retrieves a [product variant](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) by its ID.
   *
   * A product variant is a specific version of a
   * [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) that comes in more than
   * one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
   * such as size or color. For example, if a merchant sells t-shirts with options for size and color,
   * then a small, blue t-shirt would be one product variant and a large, blue t-shirt would be another.
   *
   * Use the `productVariant` query when you need to:
   *
   * - Access essential product variant data (for example, title, price, image, and metafields).
   * - Build product detail pages and manage inventory.
   * - Handle international sales with localized pricing and content.
   * - Manage product variants that are part of a bundle or selling plan.
   *
   * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
   */
  productVariant?: Maybe<ProductVariant>;
  /** Return a product variant by an identifier. */
  productVariantByIdentifier?: Maybe<ProductVariant>;
  /**
   * Retrieves a list of [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * associated with a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product).
   *
   * A product variant is a specific version of a product that comes in more than
   * one [option](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption),
   * such as size or color. For example, if a merchant sells t-shirts with options for size and color,
   * then a small, blue t-shirt would be one product variant and a large, blue t-shirt would be another.
   *
   * Use the `productVariants` query when you need to:
   *
   * - Search for product variants by attributes such as SKU, barcode, or inventory quantity.
   * - Filter product variants by attributes, such as whether they're gift cards or have custom metafields.
   * - Fetch product variants for bulk operations, such as updating prices or inventory.
   * - Preload data for product variants, such as inventory items, selected options, or associated products.
   *
   * The `productVariants` query supports [pagination](https://shopify.dev/docs/api/usage/pagination-graphql)
   * to handle large product catalogs and [saved searches](https://shopify.dev/docs/api/admin-graphql/latest/queries/productVariants#arguments-savedSearchId)
   * for frequently used product variant queries.
   *
   * The `productVariants` query returns product variants with their associated metadata, including:
   *
   * - Basic product variant information (for example, title, SKU, barcode, price, and inventory)
   * - Media attachments (for example, images and videos)
   * - Associated products, selling plans, bundles, and metafields
   *
   * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
   */
  productVariants: ProductVariantConnection;
  /** Count of product variants. Limited to a maximum of 10000 by default. */
  productVariantsCount?: Maybe<Count>;
  /**
   * The list of vendors added to products.
   * The maximum page size is 1000.
   */
  productVendors?: Maybe<StringConnection>;
  /**
   * Retrieves a list of [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * in a store. Products are the items that merchants can sell in their store.
   *
   * Use the `products` query when you need to:
   *
   * - Build a browsing interface for a product catalog.
   * - Create product [searching](https://shopify.dev/docs/api/usage/search-syntax), [sorting](https://shopify.dev/docs/api/admin-graphql/latest/queries/products#arguments-sortKey), and [filtering](https://shopify.dev/docs/api/admin-graphql/latest/queries/products#arguments-query) experiences.
   * - Implement product recommendations.
   * - Sync product data with external systems.
   *
   * The `products` query supports [pagination](https://shopify.dev/docs/api/usage/pagination-graphql)
   * to handle large product catalogs and [saved searches](https://shopify.dev/docs/api/admin-graphql/latest/queries/products#arguments-savedSearchId)
   * for frequently used product queries.
   *
   * The `products` query returns products with their associated metadata, including:
   *
   * - Basic product information (for example, title, description, vendor, and type)
   * - Product options and product variants, with their prices and inventory
   * - Media attachments (for example, images and videos)
   * - SEO metadata
   * - Product categories and tags
   * - Product availability and publishing statuses
   *
   * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components).
   */
  products: ProductConnection;
  /** Count of products. Limited to a maximum of 10000 by default. */
  productsCount?: Maybe<Count>;
  /** The list of publicly-accessible Admin API versions, including supported versions, the release candidate, and unstable versions. */
  publicApiVersions: Array<ApiVersion>;
  /**
   * Retrieves a [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication) by [`ID`](https://shopify.dev/docs/api/usage/gids).
   *
   * Returns `null` if the publication doesn't exist.
   */
  publication?: Maybe<Publication>;
  /**
   * Returns a paginated list of [`Publication`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   *
   * Filter publications by [`CatalogType`](https://shopify.dev/docs/api/admin-graphql/latest/enums/CatalogType).
   */
  publications: PublicationConnection;
  /** Count of publications. Limited to a maximum of 10000 by default. */
  publicationsCount?: Maybe<Count>;
  /** Returns a count of published products by publication ID. Limited to a maximum of 10000 by default. */
  publishedProductsCount?: Maybe<Count>;
  /**
   * Retrieves a [refund](https://shopify.dev/docs/api/admin-graphql/latest/objects/Refund) by its ID.
   * A refund represents a financial record of money returned to a customer from an order.
   * It provides a comprehensive view of all refunded amounts, transactions, and restocking
   * instructions associated with returning products or correcting order issues.
   *
   * Use the `refund` query to retrieve information associated with the following workflows:
   *
   * - Displaying refund details in order management interfaces
   * - Building customer service tools for reviewing refund history
   * - Creating reports on refunded amounts and reasons
   * - Auditing refund transactions and payment gateway records
   * - Tracking inventory impacts from refunded items
   *
   * A refund is associated with an
   * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
   * and includes [refund line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/RefundLineItem)
   * that specify which items were refunded. Each refund processes through
   * [order transactions](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
   * that handle the actual money transfer back to the customer.
   */
  refund?: Maybe<Refund>;
  /**
   * Retrieves a return by its ID. A return represents the intent of a buyer to ship one or more items from an
   * order back to a merchant or a third-party fulfillment location.
   *
   * Use the `return` query to retrieve information associated with the following workflows:
   *
   * - [Managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
   * - [Processing exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges)
   * - [Tracking reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders)
   *
   * A return is associated with an
   * [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
   * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
   * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
   * which indicates the state of the return.
   */
  return?: Maybe<Return>;
  /**
   * Calculates the financial outcome of a [`Return`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return) without creating it. Use this query to preview return costs before initiating the actual return process.
   *
   * The calculation provides detailed breakdowns of refund amounts, taxes, [`RestockingFee`](https://shopify.dev/docs/api/admin-graphql/latest/objects/RestockingFee) charges, return shipping fees, and order-level discount adjustments based on the [`FulfillmentLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentLineItem) objects that customers select for return.
   *
   * Learn more about building for [return management](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management).
   */
  returnCalculate?: Maybe<CalculatedReturn>;
  /**
   * Returns the full library of available return reason definitions.
   *
   * Use this query to retrieve the standardized return reasons available for creating returns.
   * Filter by IDs or handles to get specific definitions.
   *
   * Only non-deleted reasons should be shown to customers when creating new returns.
   * Deleted reasons have been replaced with better alternatives and are no longer recommended.
   * However, they remain valid options and may still appear on existing returns.
   */
  returnReasonDefinitions: ReturnReasonDefinitionConnection;
  /** Returns a `ReturnableFulfillment` resource by ID. */
  returnableFulfillment?: Maybe<ReturnableFulfillment>;
  /** List of returnable fulfillments. */
  returnableFulfillments: ReturnableFulfillmentConnection;
  /** Lookup a reverse delivery by ID. */
  reverseDelivery?: Maybe<ReverseDelivery>;
  /** Lookup a reverse fulfillment order by ID. */
  reverseFulfillmentOrder?: Maybe<ReverseFulfillmentOrder>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   *
   * Returns a `ScriptTag` resource by ID.
   */
  scriptTag?: Maybe<ScriptTag>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   *
   * A list of script tags.
   */
  scriptTags: ScriptTagConnection;
  /**
   * Retrieves a customer [`Segment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment) by ID. Segments are dynamic groups of customers that meet specific criteria defined through [ShopifyQL queries](https://shopify.dev/docs/api/shopifyql/segment-query-language-reference).
   *
   * Use segments for targeted marketing campaigns, analyzing customer behavior, or creating personalized experiences. Each segment includes its name, creation date, and the query that defines which [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) objects belong to it.
   */
  segment?: Maybe<Segment>;
  /** A list of filter suggestions associated with a segment. A segment is a group of members (commonly customers) that meet specific criteria. */
  segmentFilterSuggestions: SegmentFilterConnection;
  /** A list of filters. */
  segmentFilters: SegmentFilterConnection;
  /**
   * A list of a shop's segment migrations.
   * @deprecated Use the migrated segment ID and query `segment` directly.
   */
  segmentMigrations: SegmentMigrationConnection;
  /** The list of suggested values corresponding to a particular filter for a segment. A segment is a group of members, such as customers, that meet specific criteria. */
  segmentValueSuggestions: SegmentValueConnection;
  /**
   * Returns a paginated list of [`Segment`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment) objects for the shop. Segments are dynamic groups of customers that meet specific criteria defined through [ShopifyQL queries](https://shopify.dev/docs/api/shopifyql/segment-query-language-reference). You can filter segments by search query and sort them by creation date or other criteria.
   *
   * The query supports standard [pagination](https://shopify.dev/docs/api/usage/pagination-graphql) arguments and returns a [`SegmentConnection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SegmentConnection) containing segment details including names, creation dates, and the query definitions that determine segment membership.
   */
  segments: SegmentConnection;
  /** The number of segments for a shop. Limited to a maximum of 10000 by default. */
  segmentsCount?: Maybe<Count>;
  /** Returns a `SellingPlanGroup` resource by ID. */
  sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /**
   * Retrieves a paginated list of [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) objects that belong to the app making the API call. Selling plan groups are selling methods like subscriptions, preorders, or other purchase options that merchants offer to customers.
   *
   * Each group has one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that define specific billing and delivery schedules, pricing adjustments, and policies. Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/sellingPlanGroups#arguments-query) argument to search by name or filter results by other criteria.
   *
   * Learn more about [building selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   */
  sellingPlanGroups: SellingPlanGroupConnection;
  /** The server pixel configured by the app. */
  serverPixel?: Maybe<ServerPixel>;
  /** Returns a `ShippingLabel` resource by ID. */
  shippingLabel?: Maybe<ShippingLabel>;
  /**
   * Returns the Shop resource corresponding to the access token used in the request. The Shop resource contains
   * business and store management settings for the shop.
   */
  shop: Shop;
  /** The shop's billing preferences, including the currency for paying for apps and services. Use this to create [app charges in the merchant's local billing currency](https://shopify.dev/docs/apps/launch/billing#supported-currencies), helping them budget their app spend without exposure to exchange rate fluctuations. */
  shopBillingPreferences: ShopBillingPreferences;
  /**
   * Returns the locales enabled on a shop. Each locale represents a language for translations and determines how content displays to customers in different markets.
   *
   * Use the optional `published` argument to filter for only the locales that are visible to customers. The response includes the ISO locale code, whether it's the shop's primary locale, and which [`MarketWebPresence`](https://shopify.dev/docs/api/admin-graphql/latest/objects/MarketWebPresence) objects use each locale.
   */
  shopLocales: Array<ShopLocale>;
  /** Returns a single Shop Pay payment request receipt by its ID. Payment request receipts document completed Shop Pay transactions, including the amount, customer details, and payment status. Use this to look up a specific Shop Pay transaction for order reconciliation or customer support. */
  shopPayPaymentRequestReceipt?: Maybe<ShopPayPaymentRequestReceipt>;
  /** Returns a paginated list of Shop Pay payment request receipts for the shop. Each receipt documents a completed Shop Pay transaction. Use this to review Shop Pay transaction history, generate reports, or audit Shop Pay payment activity. */
  shopPayPaymentRequestReceipts?: Maybe<ShopPayPaymentRequestReceiptConnection>;
  /**
   * Returns a Shopify Function by its ID.
   * [Functions](https://shopify.dev/apps/build/functions)
   * enable you to customize Shopify's backend logic at defined parts of the commerce loop.
   */
  shopifyFunction?: Maybe<ShopifyFunction>;
  /**
   * Returns Shopify Functions owned by the querying API client installed on the shop. [Functions](https://shopify.dev/docs/apps/build/functions) enable you to customize
   * Shopify's backend logic at specific points in the commerce loop, such as discounts,
   * checkout validation, and fulfillment.
   *
   * You can filter the results by API type to find specific function implementations,
   * or by whether they provide a merchant configuration interface in the Shopify Admin.
   *
   * The response includes details about each function's configuration, including its
   * title, description, API version, and the input query used to provide data to the function logic.
   *
   * Learn more about [building functions](https://shopify.dev/docs/api/functions).
   */
  shopifyFunctions: ShopifyFunctionConnection;
  /**
   * Returns the Shopify Payments account information for the shop. Includes current balances across all currencies, payout schedules, and bank account configurations.
   *
   * The account includes [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records showing charges, refunds, and adjustments that affect your balance. Also includes [`ShopifyPaymentsDispute`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsDispute) records and [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) history between the account and connected [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) configurations.
   */
  shopifyPaymentsAccount?: Maybe<ShopifyPaymentsAccount>;
  /**
   * Executes a [ShopifyQL query](https://shopify.dev/docs/apps/build/shopifyql) to analyze store data and returns results in a tabular format.
   *
   * The response includes column metadata with names, data types, and display names, along with the actual data rows. If the query contains syntax errors, then the response provides parse error messages instead of table data.
   *
   * Read the [ShopifyQL reference documentation](https://shopify.dev/docs/api/shopifyql) for more information on how to write ShopifyQL queries.
   */
  shopifyqlQuery?: Maybe<ShopifyqlQueryResponse>;
  /**
   * Retrieves a [staff member](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) by ID. If no ID is provided, the query returns the staff member that's making the request. A staff member is a user who can access the Shopify admin to manage store operations.
   *
   * Provides staff member details such as email, name, and shop owner status. When querying the current user (with or without an ID), additional [private data](https://shopify.dev/docs/api/admin-graphql/latest/queries/staffMember#returns-StaffMember.fields.privateData) becomes available.
   */
  staffMember?: Maybe<StaffMember>;
  /**
   * Returns a paginated list of [`StaffMember`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StaffMember) objects for the shop. Staff members are users who can access the Shopify admin to manage store operations.
   *
   * Supports filtering by account type, email, and name, with an option to sort results. The query returns a [`StaffMemberConnection`](https://shopify.dev/docs/api/admin-graphql/latest/connections/StaffMemberConnection) for [cursor-based pagination](https://shopify.dev/docs/api/usage/pagination-graphql).
   */
  staffMembers?: Maybe<StaffMemberConnection>;
  /**
   * Retrieves preset metafield definition templates for common use cases. Each template provides a reserved namespace and key combination for specific purposes like product subtitles, care guides, or ISBN numbers. Use these templates to create standardized metafields across your store. Filter templates by constraint status or exclude those you've already activated.
   *
   * See the [list of standard metafield definitions](https://shopify.dev/docs/apps/build/custom-data/metafields/list-of-standard-definitions) for available templates.
   */
  standardMetafieldDefinitionTemplates: StandardMetafieldDefinitionTemplateConnection;
  /** Retrieves a [`StoreCreditAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/StoreCreditAccount) by ID. Store credit accounts hold monetary balances that account owners can use at checkout. The owner is either a [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) or a [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation). */
  storeCreditAccount?: Maybe<StoreCreditAccount>;
  /** Returns the store credit configuration for a shop, including whether store credit is enabled for customers at checkout. Use this to display the current state of a merchant's store credit program or check eligibility before issuing store credit to customers. */
  storeCreditConfiguration: StoreCreditConfiguration;
  /** Returns a `SubscriptionBillingAttempt` resource by ID. */
  subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** Returns subscription billing attempts on a store. */
  subscriptionBillingAttempts: SubscriptionBillingAttemptConnection;
  /** Returns a subscription billing cycle found either by cycle index or date. */
  subscriptionBillingCycle?: Maybe<SubscriptionBillingCycle>;
  /**
   * Retrieves the results of the asynchronous job for the subscription billing cycle bulk action based on the specified job ID.
   * This query can be used to obtain the billing cycles that match the criteria defined in the subscriptionBillingCycleBulkSearch and subscriptionBillingCycleBulkCharge mutations.
   */
  subscriptionBillingCycleBulkResults: SubscriptionBillingCycleConnection;
  /** Returns subscription billing cycles for a contract ID. */
  subscriptionBillingCycles: SubscriptionBillingCycleConnection;
  /**
   * Retrieves a [`SubscriptionContract`](https://shopify.dev/docs/api/customer/latest/objects/SubscriptionContract) by ID.
   *
   * The contract tracks the subscription's lifecycle through various [statuses](https://shopify.dev/docs/api/admin-graphql/latest/queries/subscriptionContract#returns-SubscriptionContract.fields.status), and links to related billing attempts, generated [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects, and the customer's [`CustomerPaymentMethod`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CustomerPaymentMethod).
   */
  subscriptionContract?: Maybe<SubscriptionContract>;
  /**
   * Returns a [`SubscriptionContractConnection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContractConnection) containing [subscription contracts](https://shopify.dev/docs/api/customer/latest/objects/SubscriptionContract). Subscription contracts are agreements between [customers](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) and merchants for recurring purchases with defined billing and delivery schedules.
   *
   * Filter results with the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/subscriptionContracts#arguments-query) argument. You can paginate results using standard [cursor-based pagination](https://shopify.dev/docs/api/usage/pagination-graphql).
   */
  subscriptionContracts: SubscriptionContractConnection;
  /**
   * Returns a Subscription Draft resource by ID.
   * @deprecated Use the [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api) instead.
   */
  subscriptionDraft?: Maybe<SubscriptionDraft>;
  /**
   * Access to Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17) for categorizing products. The [`Taxonomy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Taxonomy) organizes products into a hierarchical tree structure with categories, attributes, and values.
   *
   * Query categories using search terms, or navigate the hierarchy by requesting children, siblings, or descendants of specific categories. Each [`TaxonomyCategory`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TaxonomyCategory) includes its position in the tree, parent-child relationships, and associated attributes for that product category.
   */
  taxonomy?: Maybe<Taxonomy>;
  /**
   * Transactions representing a movement of money between customers and the shop. Each transaction records the amount, payment method, processing details, and the associated [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order).
   *
   * Positive amounts indicate customer payments to the merchant. Negative amounts represent refunds from the merchant to the customer. Use the [`query`](https://shopify.dev/docs/api/admin-graphql/latest/queries/tenderTransactions#arguments-query) parameter to filter transactions by attributes such as transaction ID, processing date, and point-of-sale device ID.
   */
  tenderTransactions: TenderTransactionConnection;
  /** Returns an [`OnlineStoreTheme`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme) by its ID. Use this query to retrieve theme metadata and access the theme's [`files`](https://shopify.dev/docs/api/admin-graphql/latest/queries/theme#returns-OnlineStoreTheme.fields.files), which include templates, assets, [translations](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme#field-published_translations), and configuration files. */
  theme?: Maybe<OnlineStoreTheme>;
  /**
   * Returns a paginated list of [`OnlineStoreTheme`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OnlineStoreTheme) objects for the online store. Themes control the appearance and layout of the storefront.
   *
   * You can filter themes by [`role`](https://shopify.dev/docs/api/admin-graphql/latest/queries/themes#arguments-roles) to find specific theme types, such as `MAIN` for the published theme and `UNPUBLISHED` for draft themes.
   */
  themes?: Maybe<OnlineStoreThemeConnection>;
  /**
   * Retrieves a resource that has translatable fields. Returns the resource's [`Translation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Translation) objects for different locales and markets, along with the original [`TranslatableContent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent) and digest values needed to register new translations. Provides access to existing translations, translatable content with digest hashes for translation registration, and nested translatable resources like [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects or [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
   *
   * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
   */
  translatableResource?: Maybe<TranslatableResource>;
  /**
   * Returns a paginated list of [`TranslatableResource`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableResource) objects for a specific resource type. Each resource provides translatable content and digest values needed for the [`translationsRegister`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister) mutation.
   *
   * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
   *
   *         Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
   */
  translatableResources: TranslatableResourceConnection;
  /**
   * Returns a paginated list of [`TranslatableResource`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableResource) objects for the specified resource IDs. Each resource provides translatable content and digest values needed for the [`translationsRegister`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister) mutation.
   *
   * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
   */
  translatableResourcesByIds: TranslatableResourceConnection;
  /** Returns a `UrlRedirect` resource by ID. */
  urlRedirect?: Maybe<UrlRedirect>;
  /** Returns a `UrlRedirectImport` resource by ID. */
  urlRedirectImport?: Maybe<UrlRedirectImport>;
  /** A list of the shop's URL redirect saved searches. */
  urlRedirectSavedSearches: SavedSearchConnection;
  /** A list of redirects for a shop. */
  urlRedirects: UrlRedirectConnection;
  /** Count of redirects. Limited to a maximum of 10000 by default. */
  urlRedirectsCount?: Maybe<Count>;
  /** Validation available on the shop. */
  validation?: Maybe<Validation>;
  /** Validations available on the shop. */
  validations: ValidationConnection;
  /**
   * Returns a
   * [web pixel](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by ID.
   */
  webPixel?: Maybe<WebPixel>;
  /** The web presences for the shop. */
  webPresences?: Maybe<MarketWebPresenceConnection>;
  /**
   * Returns a webhook subscription by ID.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  webhookSubscription?: Maybe<WebhookSubscription>;
  /**
   * Retrieves a paginated list of webhook subscriptions created using the API for the current app and shop.
   *
   * > Note: Returns only shop-scoped subscriptions, not app-scoped subscriptions configured in TOML files.
   *
   * Subscription details include event topics, endpoint URIs, filtering rules, field inclusion settings, and metafield namespace permissions. Results support cursor-based pagination that you can filter by topic, format, or custom search criteria.
   *
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  webhookSubscriptions: WebhookSubscriptionConnection;
  /**
   * The count of webhook subscriptions.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe). Limited to a maximum of 10000 by default.
   */
  webhookSubscriptionsCount?: Maybe<Count>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonedCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<AbandonedCheckoutSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonedCheckoutsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonmentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonmentByAbandonedCheckoutIdArgs = {
  abandonedCheckoutId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppByKeyArgs = {
  apiKey: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppDiscountTypeArgs = {
  functionId: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppDiscountTypesNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppInstallationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AppInstallationCategory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  privacy?: InputMaybe<AppInstallationPrivacy>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<AppInstallationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticleArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticleAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticleTagsArgs = {
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<ArticleTagSort>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ArticleSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAssignedFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignmentStatus?: InputMaybe<FulfillmentOrderAssignmentStatus>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<AutomaticDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<AutomaticDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<BlogSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBulkOperationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBulkOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<BulkOperationsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBusinessEntityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCarrierServiceArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCarrierServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CarrierServiceSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCartTransformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashDrawerArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashDrawersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashManagementLocationSummaryArgs = {
  endDate: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashManagementReasonCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashManagementShopSummaryArgs = {
  currencyCode: CurrencyCode;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashTrackingSessionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashTrackingSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CashTrackingSessionsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CatalogSortKeys>;
  type?: InputMaybe<CatalogType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CatalogType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootChannelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootChannelByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutAndAccountsConfigurationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutAndAccountsConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CheckoutAndAccountsConfigurationsGraphQlSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutBrandingArgs = {
  checkoutProfileId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutProfileArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CheckoutProfileSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodeByCodeArgs = {
  code: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<CodeDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionByIdentifierArgs = {
  identifier: CollectionIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionConditionsSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appId: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionConditionsSourcesByAppArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCommentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CommentSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanySortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompaniesCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyContactArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyContactRoleArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyLocationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootConsentPolicyArgs = {
  consentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<PrivacyCountryCode>;
  dataSaleOptOutRequired?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCurrentBulkOperationArgs = {
  type?: InputMaybe<BulkOperationType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerAccountPageArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerAccountPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerByIdentifierArgs = {
  identifier: CustomerIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerMergeJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerMergePreviewArgs = {
  customerOneId: Scalars['ID']['input'];
  customerTwoId: Scalars['ID']['input'];
  overrideFields?: InputMaybe<CustomerMergeOverrideFields>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerPaymentMethodArgs = {
  id: Scalars['ID']['input'];
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CustomerSavedSearchSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembersQueryArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembershipArgs = {
  customerId: Scalars['ID']['input'];
  segmentIds: Array<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomersCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeletionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DeletionEventSortKeys>;
  subjectTypes?: InputMaybe<Array<DeletionEventSubjectType>>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryCustomizationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryCustomizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryProfileArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  merchantOwnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryPromiseParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandedPromiseHandle: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryPromiseProviderArgs = {
  locationId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountCodesCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodesCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountRedeemCodeBulkCreationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountRedeemCodeSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DiscountTagSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputeEvidenceArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDomainArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderAvailableDeliveryOptionsArgs = {
  input: DraftOrderAvailableDeliveryOptionsInput;
  localPickupCount?: InputMaybe<Scalars['Int']['input']>;
  localPickupFrom?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderTagArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrdersCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFileSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<FileSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentServiceArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<GiftCardSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryItemArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryLevelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryShipmentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<InventoryShipmentSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryTransfersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<TransferSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootJobArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationByIdentifierArgs = {
  identifier: LocationIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsAvailableForDeliveryProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootManualHoldsFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketByGeographyArgs = {
  countryCode: CountryCode;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourceArgs = {
  resourceId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceType: MarketLocalizableResourceType;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourcesByIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceIds: Array<Scalars['ID']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketingActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  remoteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<MarketingActivitySortKeys>;
  utm?: InputMaybe<UtmInput>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingActivityArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingEventArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MarketingEventSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MarketsSortKeys>;
  type?: InputMaybe<MarketType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketsResolvedValuesArgs = {
  buyerSignal: BuyerSignalInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMenuArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MenuSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldDefinitionArgs = {
  identifier?: InputMaybe<MetafieldDefinitionIdentifierInput>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  constraintStatus?: InputMaybe<MetafieldDefinitionConstraintStatus>;
  constraintSubtype?: InputMaybe<MetafieldDefinitionConstraintSubtypeIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  ownerType: MetafieldOwnerType;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectByHandleArgs = {
  handle: MetaobjectHandleInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionByTypeArgs = {
  type: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMobilePlatformApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMobilePlatformApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderAttributionDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderByIdentifierArgs = {
  identifier: OrderIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderEditSessionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderPaymentStatusArgs = {
  orderId: Scalars['ID']['input'];
  paymentReferenceId: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrdersCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPageArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<PageSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPagesCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentCustomizationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentCustomizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentTermsTemplatesArgs = {
  paymentTermsType?: InputMaybe<PaymentTermsType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPointOfSaleDeviceArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPointOfSaleDevicePaymentSessionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPointOfSaleDevicePaymentSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<PointOfSaleDevicePaymentSessionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPriceListArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPriceListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<PriceListSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductByIdentifierArgs = {
  identifier: ProductIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductDuplicateJobArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductFeedArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductFeedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductOperationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductResourceFeedbackArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantByIdentifierArgs = {
  identifier: ProductVariantIdentifierInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationsCountArgs = {
  catalogType?: InputMaybe<CatalogType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublishedProductsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootRefundArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnCalculateArgs = {
  input: CalculateReturnInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnReasonDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  handles?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ReturnReasonDefinitionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnableFulfillmentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnableFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['ID']['input'];
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReverseDeliveryArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReverseFulfillmentOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootScriptTagArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootScriptTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  src?: InputMaybe<Scalars['URL']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentFilterSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentMigrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentValueSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterQueryName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  functionParameterQueryName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SegmentSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSellingPlanGroupArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SellingPlanGroupSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShippingLabelArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopLocalesArgs = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopPayPaymentRequestReceiptArgs = {
  token: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopPayPaymentRequestReceiptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopPayPaymentRequestReceiptsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopifyFunctionArgs = {
  id: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopifyFunctionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiType?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  useCreationUi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopifyqlQueryArgs = {
  query: Scalars['String']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStaffMemberArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StaffMembersSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStandardMetafieldDefinitionTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  constraintStatus?: InputMaybe<MetafieldDefinitionConstraintStatus>;
  constraintSubtype?: InputMaybe<MetafieldDefinitionConstraintSubtypeIdentifier>;
  excludeActivated?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStoreCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingAttemptArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SubscriptionBillingAttemptsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCycleArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCycleBulkResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingCyclesDateRangeSelector?: InputMaybe<SubscriptionBillingCyclesDateRangeSelector>;
  billingCyclesIndexRangeSelector?: InputMaybe<SubscriptionBillingCyclesIndexRangeSelector>;
  contractId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionContractArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SubscriptionContractsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionDraftArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTenderTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootThemeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootThemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<ThemeRole>>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourceArgs = {
  resourceId: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceType: TranslatableResourceType;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourcesByIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceIds: Array<Scalars['ID']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectImportArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<UrlRedirectSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootValidationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootValidationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ValidationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebPixelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebPresencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<WebhookSubscriptionFormat>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<WebhookSubscriptionSortKeys>;
  topics?: InputMaybe<Array<WebhookSubscriptionTopic>>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionsCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The `Refund` object represents a financial record of money returned to a customer from an order.
 * It provides a comprehensive view of all refunded amounts, transactions, and restocking instructions
 * associated with returning products or correcting order issues.
 *
 * The `Refund` object provides information to:
 *
 * - Process customer returns and issue payments back to customers
 * - Handle partial or full refunds for line items with optional inventory restocking
 * - Refund shipping costs, duties, and additional fees
 * - Issue store credit refunds as an alternative to original payment method returns
 * - Track and reconcile all financial transactions related to refunds
 *
 * Each `Refund` object maintains detailed records of what was refunded, how much was refunded,
 * which payment transactions were involved, and any inventory restocking that occurred. The refund
 * can include multiple components such as product line items, shipping charges, taxes, duties, and
 * additional fees, all calculated with proper currency handling for international orders.
 *
 * Refunds are always associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can optionally be linked to a [return](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return)
 * if the refund was initiated through the returns process. The refund tracks both the presentment currency
 * (what the customer sees) and the shop currency for accurate financial reporting.
 *
 * > Note:
 * > The existence of a `Refund` object doesn't guarantee that the money has been returned to the customer.
 * > The actual financial processing happens through associated
 * > [`OrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
 * > objects, which can be in various states, such as pending, processing, success, or failure.
 * > To determine if money has actually been refunded, check the
 * > [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction#field-OrderTransaction.fields.status)
 * > of the associated transactions.
 *
 * Learn more about
 * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management),
 * [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties), and
 * [processing refunds](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate).
 */
export type Refund = LegacyInteroperability & Node & {
  __typename?: 'Refund';
  /** The date and time when the refund was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of the refunded duties as part of this refund. */
  duties?: Maybe<Array<RefundDuty>>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The optional note associated with the refund. */
  note?: Maybe<Scalars['String']['output']>;
  /** The order associated with the refund. */
  order: Order;
  /** The order adjustments that are attached with the refund. */
  orderAdjustments: OrderAdjustmentConnection;
  /** The date and time when the refund was processed. */
  processedAt: Scalars['DateTime']['output'];
  /** The `RefundLineItem` resources attached to the refund. */
  refundLineItems: RefundLineItemConnection;
  /** The `RefundShippingLine` resources attached to the refund. */
  refundShippingLines: RefundShippingLineConnection;
  /** The return associated with the refund. */
  return?: Maybe<Return>;
  /** The staff member who created the refund. */
  staffMember?: Maybe<StaffMember>;
  /**
   * The total amount across all transactions for the refund.
   * @deprecated Use `totalRefundedSet` instead.
   */
  totalRefunded: MoneyV2;
  /** The total amount across all transactions for the refund, in shop and presentment currencies. */
  totalRefundedSet: MoneyBag;
  /** The transactions associated with the refund. */
  transactions: OrderTransactionConnection;
  /** The date and time when the refund was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The `Refund` object represents a financial record of money returned to a customer from an order.
 * It provides a comprehensive view of all refunded amounts, transactions, and restocking instructions
 * associated with returning products or correcting order issues.
 *
 * The `Refund` object provides information to:
 *
 * - Process customer returns and issue payments back to customers
 * - Handle partial or full refunds for line items with optional inventory restocking
 * - Refund shipping costs, duties, and additional fees
 * - Issue store credit refunds as an alternative to original payment method returns
 * - Track and reconcile all financial transactions related to refunds
 *
 * Each `Refund` object maintains detailed records of what was refunded, how much was refunded,
 * which payment transactions were involved, and any inventory restocking that occurred. The refund
 * can include multiple components such as product line items, shipping charges, taxes, duties, and
 * additional fees, all calculated with proper currency handling for international orders.
 *
 * Refunds are always associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can optionally be linked to a [return](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return)
 * if the refund was initiated through the returns process. The refund tracks both the presentment currency
 * (what the customer sees) and the shop currency for accurate financial reporting.
 *
 * > Note:
 * > The existence of a `Refund` object doesn't guarantee that the money has been returned to the customer.
 * > The actual financial processing happens through associated
 * > [`OrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
 * > objects, which can be in various states, such as pending, processing, success, or failure.
 * > To determine if money has actually been refunded, check the
 * > [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction#field-OrderTransaction.fields.status)
 * > of the associated transactions.
 *
 * Learn more about
 * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management),
 * [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties), and
 * [processing refunds](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate).
 */
export type RefundOrderAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Refund` object represents a financial record of money returned to a customer from an order.
 * It provides a comprehensive view of all refunded amounts, transactions, and restocking instructions
 * associated with returning products or correcting order issues.
 *
 * The `Refund` object provides information to:
 *
 * - Process customer returns and issue payments back to customers
 * - Handle partial or full refunds for line items with optional inventory restocking
 * - Refund shipping costs, duties, and additional fees
 * - Issue store credit refunds as an alternative to original payment method returns
 * - Track and reconcile all financial transactions related to refunds
 *
 * Each `Refund` object maintains detailed records of what was refunded, how much was refunded,
 * which payment transactions were involved, and any inventory restocking that occurred. The refund
 * can include multiple components such as product line items, shipping charges, taxes, duties, and
 * additional fees, all calculated with proper currency handling for international orders.
 *
 * Refunds are always associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can optionally be linked to a [return](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return)
 * if the refund was initiated through the returns process. The refund tracks both the presentment currency
 * (what the customer sees) and the shop currency for accurate financial reporting.
 *
 * > Note:
 * > The existence of a `Refund` object doesn't guarantee that the money has been returned to the customer.
 * > The actual financial processing happens through associated
 * > [`OrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
 * > objects, which can be in various states, such as pending, processing, success, or failure.
 * > To determine if money has actually been refunded, check the
 * > [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction#field-OrderTransaction.fields.status)
 * > of the associated transactions.
 *
 * Learn more about
 * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management),
 * [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties), and
 * [processing refunds](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate).
 */
export type RefundRefundLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Refund` object represents a financial record of money returned to a customer from an order.
 * It provides a comprehensive view of all refunded amounts, transactions, and restocking instructions
 * associated with returning products or correcting order issues.
 *
 * The `Refund` object provides information to:
 *
 * - Process customer returns and issue payments back to customers
 * - Handle partial or full refunds for line items with optional inventory restocking
 * - Refund shipping costs, duties, and additional fees
 * - Issue store credit refunds as an alternative to original payment method returns
 * - Track and reconcile all financial transactions related to refunds
 *
 * Each `Refund` object maintains detailed records of what was refunded, how much was refunded,
 * which payment transactions were involved, and any inventory restocking that occurred. The refund
 * can include multiple components such as product line items, shipping charges, taxes, duties, and
 * additional fees, all calculated with proper currency handling for international orders.
 *
 * Refunds are always associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can optionally be linked to a [return](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return)
 * if the refund was initiated through the returns process. The refund tracks both the presentment currency
 * (what the customer sees) and the shop currency for accurate financial reporting.
 *
 * > Note:
 * > The existence of a `Refund` object doesn't guarantee that the money has been returned to the customer.
 * > The actual financial processing happens through associated
 * > [`OrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
 * > objects, which can be in various states, such as pending, processing, success, or failure.
 * > To determine if money has actually been refunded, check the
 * > [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction#field-OrderTransaction.fields.status)
 * > of the associated transactions.
 *
 * Learn more about
 * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management),
 * [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties), and
 * [processing refunds](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate).
 */
export type RefundRefundShippingLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Refund` object represents a financial record of money returned to a customer from an order.
 * It provides a comprehensive view of all refunded amounts, transactions, and restocking instructions
 * associated with returning products or correcting order issues.
 *
 * The `Refund` object provides information to:
 *
 * - Process customer returns and issue payments back to customers
 * - Handle partial or full refunds for line items with optional inventory restocking
 * - Refund shipping costs, duties, and additional fees
 * - Issue store credit refunds as an alternative to original payment method returns
 * - Track and reconcile all financial transactions related to refunds
 *
 * Each `Refund` object maintains detailed records of what was refunded, how much was refunded,
 * which payment transactions were involved, and any inventory restocking that occurred. The refund
 * can include multiple components such as product line items, shipping charges, taxes, duties, and
 * additional fees, all calculated with proper currency handling for international orders.
 *
 * Refunds are always associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can optionally be linked to a [return](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return)
 * if the refund was initiated through the returns process. The refund tracks both the presentment currency
 * (what the customer sees) and the shop currency for accurate financial reporting.
 *
 * > Note:
 * > The existence of a `Refund` object doesn't guarantee that the money has been returned to the customer.
 * > The actual financial processing happens through associated
 * > [`OrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction)
 * > objects, which can be in various states, such as pending, processing, success, or failure.
 * > To determine if money has actually been refunded, check the
 * > [status](https://shopify.dev/docs/api/admin-graphql/latest/objects/OrderTransaction#field-OrderTransaction.fields.status)
 * > of the associated transactions.
 *
 * Learn more about
 * [managing returns](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management),
 * [refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties), and
 * [processing refunds](https://shopify.dev/docs/api/admin-graphql/latest/mutations/refundCreate).
 */
export type RefundTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An agreement between the merchant and customer to refund all or a portion of the order. */
export type RefundAgreement = SalesAgreement & {
  __typename?: 'RefundAgreement';
  /** The application that created the agreement. */
  app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  happenedAt: Scalars['DateTime']['output'];
  /** The unique ID for the agreement. */
  id: Scalars['ID']['output'];
  /** The reason the agremeent was created. */
  reason: OrderActionType;
  /** The refund associated with the agreement. */
  refund: Refund;
  /** The sales associated with the agreement. */
  sales: SaleConnection;
  /** The staff member associated with the agreement. */
  user?: Maybe<StaffMember>;
};


/** An agreement between the merchant and customer to refund all or a portion of the order. */
export type RefundAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple Refunds. */
export type RefundConnection = {
  __typename?: 'RefundConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<RefundEdge>;
  /** A list of nodes that are contained in RefundEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Refund>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `refundCreate` mutation. */
export type RefundCreatePayload = {
  __typename?: 'RefundCreatePayload';
  /** The order associated with the created refund. */
  order?: Maybe<Order>;
  /** The created refund. */
  refund?: Maybe<Refund>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Represents a refunded duty. */
export type RefundDuty = {
  __typename?: 'RefundDuty';
  /** The amount of a refunded duty in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** The duty associated with this refunded duty. */
  originalDuty?: Maybe<Duty>;
};

/** The input fields required to reimburse duties on a refund. */
export type RefundDutyInput = {
  /** The ID of the duty in the refund. */
  dutyId: Scalars['ID']['input'];
  /** The type of refund for this duty. */
  refundType?: InputMaybe<RefundDutyRefundType>;
};

/** The type of refund to perform for a particular refund duty. */
export enum RefundDutyRefundType {
  /** The duty is fully refunded. */
  Full = 'FULL',
  /** The duty is proportionally refunded based on the quantity of the refunded line item. */
  Proportional = 'PROPORTIONAL'
}

/** An auto-generated type which holds one Refund and a cursor during pagination. */
export type RefundEdge = {
  __typename?: 'RefundEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of RefundEdge. */
  node: Refund;
};

/** The input fields to create a refund. */
export type RefundInput = {
  /** Whether to allow the total refunded amount to surpass the amount paid for the order. */
  allowOverRefunding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The currency that is used to refund the order. This must be the presentment currency, which is the currency used by the customer. This is a required field for orders where the currency and presentment currency differ. */
  currency?: InputMaybe<CurrencyCode>;
  /** An optional reason for a discrepancy between calculated and actual refund amounts. */
  discrepancyReason?: InputMaybe<OrderAdjustmentInputDiscrepancyReason>;
  /** An optional note that's attached to the refund. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send a refund notification to the customer. */
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the order that's being refunded. */
  orderId: Scalars['ID']['input'];
  /** The date and time when the refund is being processed. If not provided, it will be set to the current time. */
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** A list of duties to refund. */
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  /** A list of line items to refund. */
  refundLineItems?: InputMaybe<Array<RefundLineItemInput>>;
  /** A list of instructions to process the financial outcome of the refund. */
  refundMethods?: InputMaybe<Array<RefundMethodInput>>;
  /** The input fields that are required to reimburse shipping costs. */
  shipping?: InputMaybe<ShippingRefundInput>;
  /** A list of transactions involved in the refund. */
  transactions?: InputMaybe<Array<OrderTransactionInput>>;
};

/**
 * A [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) or [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) being refunded from an order. Each refund line item tracks the quantity, pricing, and restocking details for items returned to the merchant.
 *
 * The refund line item links to the original [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) from the [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) and includes financial information such as the refunded price, subtotal, and taxes in both shop and presentment currencies. The [`restockType`](https://shopify.dev/docs/api/admin-graphql/latest/objects/RefundLineItem#field-RefundLineItem.fields.restockType) field indicates whether and how the merchant restocks the returned items to inventory, while the [`location`](https://shopify.dev/docs/api/admin-graphql/latest/objects/RefundLineItem#field-RefundLineItem.fields.location) field specifies where restocking occurs.
 */
export type RefundLineItem = {
  __typename?: 'RefundLineItem';
  /** A globally-unique ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The `LineItem` resource associated to the refunded line item. */
  lineItem: LineItem;
  /** The inventory restock location. */
  location?: Maybe<Location>;
  /**
   * The price of a refunded line item.
   * @deprecated Use `priceSet` instead.
   */
  price: Scalars['Money']['output'];
  /** The price of a refunded line item in shop and presentment currencies. */
  priceSet: MoneyBag;
  /** The quantity of a refunded line item. */
  quantity: Scalars['Int']['output'];
  /** The type of restock for the refunded line item. */
  restockType: RefundLineItemRestockType;
  /** Whether the refunded line item was restocked. Not applicable in the context of a SuggestedRefund. */
  restocked: Scalars['Boolean']['output'];
  /**
   * The subtotal price of a refunded line item.
   * @deprecated Use `subtotalSet` instead.
   */
  subtotal: Scalars['Money']['output'];
  /** The subtotal price of a refunded line item in shop and presentment currencies. */
  subtotalSet: MoneyBag;
  /**
   * The total tax charged on a refunded line item.
   * @deprecated Use `totalTaxSet` instead.
   */
  totalTax: Scalars['Money']['output'];
  /** The total tax charged on a refunded line item in shop and presentment currencies. */
  totalTaxSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple RefundLineItems. */
export type RefundLineItemConnection = {
  __typename?: 'RefundLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<RefundLineItemEdge>;
  /** A list of nodes that are contained in RefundLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<RefundLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one RefundLineItem and a cursor during pagination. */
export type RefundLineItemEdge = {
  __typename?: 'RefundLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of RefundLineItemEdge. */
  node: RefundLineItem;
};

/** The input fields required to reimburse line items on a refund. */
export type RefundLineItemInput = {
  /** The ID of the line item in the refund. */
  lineItemId: Scalars['ID']['input'];
  /** The intended location for restocking. If the `restockType` is set to `NO_RESTOCK`, then this value is empty. */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the associated line item to be refunded. */
  quantity: Scalars['Int']['input'];
  /** The type of restock for this line item. */
  restockType?: InputMaybe<RefundLineItemRestockType>;
};

/** The type of restock performed for a particular refund line item. */
export enum RefundLineItemRestockType {
  /** The refund line item was canceled. Use this when restocking unfulfilled line items. */
  Cancel = 'CANCEL',
  /** Deprecated. The refund line item was restocked, without specifically beingidentified as a return or cancelation. This value is not accepted when creating new refunds. */
  LegacyRestock = 'LEGACY_RESTOCK',
  /** Refund line item was not restocked. */
  NoRestock = 'NO_RESTOCK',
  /** The refund line item was returned. Use this when restocking line items that were fulfilled. */
  Return = 'RETURN'
}

/** The different methods that a refund amount can be allocated to. */
export enum RefundMethodAllocation {
  /** The refund is to original payment methods. */
  OriginalPaymentMethods = 'ORIGINAL_PAYMENT_METHODS',
  /** The refund is to store credit. */
  StoreCredit = 'STORE_CREDIT'
}

/** The input fields for processing the financial outcome of a refund. */
export type RefundMethodInput = {
  /** The details of the refund to store credit. */
  storeCreditRefund?: InputMaybe<StoreCreditRefundInput>;
};

/** The financial transfer details for a return outcome that results in a refund. */
export type RefundReturnOutcome = {
  __typename?: 'RefundReturnOutcome';
  /** The total monetary value to be refunded in shop and presentment currencies. */
  amount: MoneyBag;
  /** A list of suggested refund methods. */
  suggestedRefundMethods: Array<SuggestedRefundMethod>;
  /** A list of suggested order transactions. */
  suggestedTransactions: Array<SuggestedOrderTransaction>;
};

/** The input fields for the shipping cost to refund. */
export type RefundShippingInput = {
  /** Whether to refund the full shipping amount. */
  fullRefund?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The input fields required to refund shipping cost, in the presentment currency of the order.
   * This overrides the `fullRefund` argument.
   * This field defaults to 0.00 when not provided and when the `fullRefund` argument is false.
   */
  shippingRefundAmount?: InputMaybe<MoneyInput>;
};

/** A shipping line item that's included in a refund. */
export type RefundShippingLine = Node & {
  __typename?: 'RefundShippingLine';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The `ShippingLine` resource associated to the refunded shipping line item. */
  shippingLine: ShippingLine;
  /** The subtotal amount of the refund shipping line in shop and presentment currencies. */
  subtotalAmountSet: MoneyBag;
  /** The tax amount of the refund shipping line in shop and presentment currencies. */
  taxAmountSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple RefundShippingLines. */
export type RefundShippingLineConnection = {
  __typename?: 'RefundShippingLineConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<RefundShippingLineEdge>;
  /** A list of nodes that are contained in RefundShippingLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<RefundShippingLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one RefundShippingLine and a cursor during pagination. */
export type RefundShippingLineEdge = {
  __typename?: 'RefundShippingLineEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of RefundShippingLineEdge. */
  node: RefundShippingLine;
};

/** A condition checking the visitor's region. */
export type RegionsCondition = {
  __typename?: 'RegionsCondition';
  /** The application level for the condition. */
  applicationLevel?: Maybe<MarketConditionApplicationType>;
  /** The regions that comprise the market. */
  regions: MarketRegionConnection;
};


/** A condition checking the visitor's region. */
export type RegionsConditionRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for a remote Authorize.net customer payment profile. */
export type RemoteAuthorizeNetCustomerPaymentProfileInput = {
  /** The customerPaymentProfileId value from the Authorize.net API. */
  customerPaymentProfileId: Scalars['String']['input'];
  /** The customerProfileId value from the Authorize.net API. */
  customerProfileId: Scalars['String']['input'];
};

/** The input fields for a remote Braintree customer payment profile. */
export type RemoteBraintreePaymentMethodInput = {
  /** The `customer_id` value from the Braintree API. */
  customerId: Scalars['String']['input'];
  /** The `payment_method_token` value from the Braintree API. */
  paymentMethodToken: Scalars['String']['input'];
};

/** The input fields for a remote stripe payment method. */
export type RemoteStripePaymentMethodInput = {
  /** The customer_id value from the Stripe API. */
  customerId: Scalars['String']['input'];
  /** The payment_method_id value from the Stripe API. */
  paymentMethodId: Scalars['String']['input'];
};

/** Return type for `removeFromReturn` mutation. */
export type RemoveFromReturnPayload = {
  __typename?: 'RemoveFromReturnPayload';
  /** The modified return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The resolved price inclusivity attributes. */
export type ResolvedPriceInclusivity = {
  __typename?: 'ResolvedPriceInclusivity';
  /** Whether duties are included in the price. */
  dutiesIncluded: Scalars['Boolean']['output'];
  /** Whether taxes are included in the price. */
  taxesIncluded: Scalars['Boolean']['output'];
};

/**
 * An alert message that appears in the Shopify admin about a problem with a store resource, with 1 or more actions to take. For example, you could use an alert to indicate that you're not charging taxes on some product variants.
 * They can optionally have a specific icon and be dismissed by merchants.
 */
export type ResourceAlert = {
  __typename?: 'ResourceAlert';
  /**
   * Buttons in the alert that link to related information.
   * For example, _Edit variants_.
   */
  actions: Array<ResourceAlertAction>;
  /** The secondary text in the alert that includes further information or instructions about how to solve a problem. */
  content: Scalars['HTML']['output'];
  /**
   * Unique identifier that appears when an alert is manually closed by the merchant.
   * Most alerts can't be manually closed.
   */
  dismissibleHandle?: Maybe<Scalars['String']['output']>;
  /** An icon that's optionally displayed with the alert. */
  icon?: Maybe<ResourceAlertIcon>;
  /** Indication of how important the alert is. */
  severity: ResourceAlertSeverity;
  /** The primary text in the alert that includes information or describes the problem. */
  title: Scalars['String']['output'];
};

/** An action associated to a resource alert, such as editing variants. */
export type ResourceAlertAction = {
  __typename?: 'ResourceAlertAction';
  /** Whether the action appears as a button or as a link. */
  primary: Scalars['Boolean']['output'];
  /** Resource for the action to show. */
  show?: Maybe<Scalars['String']['output']>;
  /** The text for the button in the alert. For example, _Edit variants_. */
  title: Scalars['String']['output'];
  /** The target URL that the button links to. */
  url: Scalars['URL']['output'];
};

/** The available icons for resource alerts. */
export enum ResourceAlertIcon {
  /** A checkmark inside a circle. */
  CheckmarkCircle = 'CHECKMARK_CIRCLE',
  /** A lowercase `i` inside a circle. */
  InformationCircle = 'INFORMATION_CIRCLE'
}

/** The possible severity levels for a resource alert. */
export enum ResourceAlertSeverity {
  /** Indicates a critical alert. For example, a blocked app. */
  Critical = 'CRITICAL',
  /** Indicates a neutral alert. For example, an accepted dispute. */
  Default = 'DEFAULT',
  /** @deprecated `ERROR` severity is being deprecated in favour of `WARNING` or `CRITICAL` instead. */
  Error = 'ERROR',
  /** Indicates an informative alert. For example, an escalated dispute. */
  Info = 'INFO',
  /** Indicates a success alert. For example, a winning a dispute. */
  Success = 'SUCCESS',
  /** Indicates an informative alert. For example, a new dispute. */
  Warning = 'WARNING'
}

/** Represents feedback from apps about a resource, and the steps required to set up the apps on the shop. */
export type ResourceFeedback = {
  __typename?: 'ResourceFeedback';
  /**
   * Feedback from an app about the steps a merchant needs to take to set up the app on their store.
   * @deprecated Use `details` instead.
   */
  appFeedback: Array<AppFeedback>;
  /** List of AppFeedback detailing issues regarding a resource. */
  details: Array<AppFeedback>;
  /** Summary of resource feedback pertaining to the resource. */
  summary: Scalars['String']['output'];
};

/** The input fields for a resource feedback object. */
export type ResourceFeedbackCreateInput = {
  /** The ID of the channel that the feedback is for. Used to scope feedback to a specific sales channel when the app has multiple channels. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The date and time when the feedback was generated. Used to help determine whether
   * incoming feedback is outdated compared to existing feedback.
   */
  feedbackGeneratedAt: Scalars['DateTime']['input'];
  /**
   * If the feedback state is `requires_action`, then you can send a string message that communicates the action to be taken by the merchant.
   * The string must be a single message up to 100 characters long and must end with a period.
   * You need to adhere to the message formatting rules or your requests will fail:
   * - `[Explanation of the problem]. [Suggested action].`
   *
   * **Examples:**
   * - `[Your app name]` isn't connected. Connect your account to use this sales channel. `[Learn more]`
   * - `[Your app name]` isn't configured. Agree to the terms and conditions to use this app. `[Learn more]`
   * Both `Your app name` and `Learn more` (a button which directs merchants to your app) are automatically populated in the Shopify admin.
   */
  messages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The state of the feedback and whether it requires merchant action. */
  state: ResourceFeedbackState;
};

/** The state of the resource feedback. */
export enum ResourceFeedbackState {
  /** No action required from merchant. */
  Accepted = 'ACCEPTED',
  /** The merchant needs to resolve an issue with the resource. */
  RequiresAction = 'REQUIRES_ACTION'
}

/** Represents a merchandising background operation interface. */
export type ResourceOperation = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  processedRowCount?: Maybe<Scalars['Int']['output']>;
  /** Represents a rows objects within this background operation. */
  rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  status: ResourceOperationStatus;
};

/** Represents the state of this catalog operation. */
export enum ResourceOperationStatus {
  /** Operation is currently running. */
  Active = 'ACTIVE',
  /** Operation is complete. */
  Complete = 'COMPLETE',
  /** Operation has been created. */
  Created = 'CREATED'
}

/**
 * A resource publication represents information about the publication of a resource.
 * An instance of `ResourcePublication`, unlike `ResourcePublicationV2`, can be neither published or scheduled to be published.
 *
 * See [ResourcePublicationV2](/api/admin-graphql/latest/objects/ResourcePublicationV2) for more context.
 */
export type ResourcePublication = {
  __typename?: 'ResourcePublication';
  /**
   * The channel the resource publication is published to.
   * @deprecated Use `publication` instead.
   */
  channel: Channel;
  /**
   * Whether the resource publication is published. Also returns true if the resource publication is scheduled to be published.
   * If false, then the resource publication is neither published nor scheduled to be published.
   */
  isPublished: Scalars['Boolean']['output'];
  /** The publication the resource publication is published to. */
  publication: Publication;
  /**
   * The date that the resource publication was or is going to be published to the publication.
   * If the product isn't published, then this field returns an epoch timestamp.
   */
  publishDate: Scalars['DateTime']['output'];
  /** The resource published to the publication. */
  publishable: Publishable;
};

/** An auto-generated type for paginating through multiple ResourcePublications. */
export type ResourcePublicationConnection = {
  __typename?: 'ResourcePublicationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ResourcePublicationEdge>;
  /** A list of nodes that are contained in ResourcePublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ResourcePublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ResourcePublication and a cursor during pagination. */
export type ResourcePublicationEdge = {
  __typename?: 'ResourcePublicationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ResourcePublicationEdge. */
  node: ResourcePublication;
};

/**
 * A resource publication represents information about the publication of a resource.
 * Unlike `ResourcePublication`, an instance of `ResourcePublicationV2` can't be unpublished. It must either be published or scheduled to be published.
 *
 * See [ResourcePublication](/api/admin-graphql/latest/objects/ResourcePublication) for more context.
 */
export type ResourcePublicationV2 = {
  __typename?: 'ResourcePublicationV2';
  /**
   * Whether the resource publication is published. If true, then the resource publication is published to the publication.
   * If false, then the resource publication is staged to be published to the publication.
   */
  isPublished: Scalars['Boolean']['output'];
  /** The publication the resource publication is published to. */
  publication: Publication;
  /** The date that the resource publication was or is going to be published to the publication. */
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  /** The resource published to the publication. */
  publishable: Publishable;
};

/** An auto-generated type for paginating through multiple ResourcePublicationV2s. */
export type ResourcePublicationV2Connection = {
  __typename?: 'ResourcePublicationV2Connection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ResourcePublicationV2Edge>;
  /** A list of nodes that are contained in ResourcePublicationV2Edge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ResourcePublicationV2>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ResourcePublicationV2 and a cursor during pagination. */
export type ResourcePublicationV2Edge = {
  __typename?: 'ResourcePublicationV2Edge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ResourcePublicationV2Edge. */
  node: ResourcePublicationV2;
};

/**
 * A restocking fee is a fee captured as part of a return to cover the costs of handling a return line item.
 * Typically, this would cover the costs of inspecting, repackaging, and restocking the item.
 */
export type RestockingFee = Fee & {
  __typename?: 'RestockingFee';
  /** The amount of the restocking fee, in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** The unique ID for the Fee. */
  id: Scalars['ID']['output'];
  /** The value of the fee as a percentage. */
  percentage: Scalars['Float']['output'];
};

/** The input fields for a restocking fee. */
export type RestockingFeeInput = {
  /** The value of the fee as a percentage. */
  percentage: Scalars['Float']['input'];
};

/** Information about product is restricted for a given resource. */
export type RestrictedForResource = {
  __typename?: 'RestrictedForResource';
  /** Returns true when the product is restricted for the given resource. */
  restricted: Scalars['Boolean']['output'];
  /** Restriction reason for the given resource. */
  restrictedReason: Scalars['String']['output'];
};

/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type Return = Node & {
  __typename?: 'Return';
  /** The date and time when the return was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the return was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Additional information about the declined return. */
  decline?: Maybe<ReturnDecline>;
  /** The exchange line items attached to the return. */
  exchangeLineItems: ExchangeLineItemConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the return. */
  name: Scalars['String']['output'];
  /** The order that the return belongs to. */
  order: Order;
  /** The list of refunds associated with the return. */
  refunds: RefundConnection;
  /** The date and time when the return was approved. */
  requestApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The return line items attached to the return. */
  returnLineItems: ReturnLineItemTypeConnection;
  /** The return shipping fees for the return. */
  returnShippingFees: Array<ReturnShippingFee>;
  /** The list of reverse fulfillment orders for the return. */
  reverseFulfillmentOrders: ReverseFulfillmentOrderConnection;
  /** The staff member that created the return. */
  staffMember?: Maybe<StaffMember>;
  /** The status of the return. */
  status: ReturnStatus;
  /** A suggested financial outcome for the return. */
  suggestedFinancialOutcome?: Maybe<SuggestedReturnFinancialOutcome>;
  /**
   * A suggested refund for the return.
   * @deprecated Use `suggestedFinancialOutcome` instead.
   */
  suggestedRefund?: Maybe<SuggestedReturnRefund>;
  /** The sum of all return line item quantities for the return. */
  totalQuantity: Scalars['Int']['output'];
  /** The order transactions created from the return. */
  transactions: OrderTransactionConnection;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnExchangeLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRemovedItems?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processingStatus?: InputMaybe<ReturnProcessingStatusFilterInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnRefundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnReturnLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processingStatus?: InputMaybe<ReturnProcessingStatusFilterInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnReverseFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnSuggestedFinancialOutcomeArgs = {
  exchangeLineItems: Array<SuggestedOutcomeExchangeLineItemInput>;
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  refundMethodAllocation?: InputMaybe<RefundMethodAllocation>;
  refundShipping?: InputMaybe<RefundShippingInput>;
  returnLineItems: Array<SuggestedOutcomeReturnLineItemInput>;
  tipLineId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnSuggestedRefundArgs = {
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  refundShipping?: InputMaybe<RefundShippingInput>;
  returnRefundLineItems: Array<ReturnRefundLineItemInput>;
};


/**
 * The `Return` object represents the intent of a buyer to ship one or more items from an order back to a merchant
 * or a third-party fulfillment location. A return is associated with an [order](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order)
 * and can include multiple return [line items](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem).
 * Each return has a [status](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps#return-statuses),
 * which indicates the state of the return.
 *
 * Use the `Return` object to capture the financial, logistical,
 * and business intent of a return. For example, you can identify eligible items for a return and issue customers
 * a refund for returned items on behalf of the merchant.
 *
 * Learn more about providing a
 * [return management workflow](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management)
 * for merchants. You can also manage [exchanges](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-exchanges),
 * [reverse fulfillment orders](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-fulfillment-orders),
 * and [reverse deliveries](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/manage-reverse-deliveries)
 * on behalf of merchants.
 */
export type ReturnTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An agreement between the merchant and customer for a return. */
export type ReturnAgreement = SalesAgreement & {
  __typename?: 'ReturnAgreement';
  /** The application that created the agreement. */
  app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  happenedAt: Scalars['DateTime']['output'];
  /** The unique ID for the agreement. */
  id: Scalars['ID']['output'];
  /** The reason the agremeent was created. */
  reason: OrderActionType;
  /** The return associated with the agreement. */
  return: Return;
  /** The sales associated with the agreement. */
  sales: SaleConnection;
  /** The staff member associated with the agreement. */
  user?: Maybe<StaffMember>;
};


/** An agreement between the merchant and customer for a return. */
export type ReturnAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for approving a customer's return request. */
export type ReturnApproveRequestInput = {
  /** The ID of the return that's being approved. */
  id: Scalars['ID']['input'];
  /**
   * Notify the customer when a return request is approved.
   * The customer will only receive a notification if `Order.email` is present.
   */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `returnApproveRequest` mutation. */
export type ReturnApproveRequestPayload = {
  __typename?: 'ReturnApproveRequestPayload';
  /** The approved return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** Return type for `returnCancel` mutation. */
export type ReturnCancelPayload = {
  __typename?: 'ReturnCancelPayload';
  /** The canceled return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** Return type for `returnClose` mutation. */
export type ReturnClosePayload = {
  __typename?: 'ReturnClosePayload';
  /** The closed return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** An auto-generated type for paginating through multiple Returns. */
export type ReturnConnection = {
  __typename?: 'ReturnConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReturnEdge>;
  /** A list of nodes that are contained in ReturnEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Return>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `returnCreate` mutation. */
export type ReturnCreatePayload = {
  __typename?: 'ReturnCreatePayload';
  /** The created return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** Additional information about why a merchant declined the customer's return request. */
export type ReturnDecline = {
  __typename?: 'ReturnDecline';
  /**
   * The notification message sent to the customer about their declined return request.
   * Maximum length: 500 characters.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** The reason the customer's return request was declined. */
  reason: ReturnDeclineReason;
};

/** The reason why the merchant declined a customer's return request. */
export enum ReturnDeclineReason {
  /** The return contains final sale items. */
  FinalSale = 'FINAL_SALE',
  /** The return is declined for another reason. */
  Other = 'OTHER',
  /** The return period has ended. */
  ReturnPeriodEnded = 'RETURN_PERIOD_ENDED'
}

/** The input fields for declining a customer's return request. */
export type ReturnDeclineRequestInput = {
  /**
   * The notification message that's sent to a customer about their declined return request.
   * Maximum length: 500 characters.
   */
  declineNote?: InputMaybe<Scalars['String']['input']>;
  /** The reason why the merchant declined the customer's return request. */
  declineReason: ReturnDeclineReason;
  /** The ID of the return that's being declined. */
  id: Scalars['ID']['input'];
  /**
   * Notify the customer when a return request is declined.
   * The customer will only receive a notification if `Order.email` is present.
   */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `returnDeclineRequest` mutation. */
export type ReturnDeclineRequestPayload = {
  __typename?: 'ReturnDeclineRequestPayload';
  /** The declined return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** An auto-generated type which holds one Return and a cursor during pagination. */
export type ReturnEdge = {
  __typename?: 'ReturnEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReturnEdge. */
  node: Return;
};

/** Possible error codes that can be returned by `ReturnUserError`. */
export enum ReturnErrorCode {
  /** The requested resource already exists. */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** A requested resource could not be created. */
  CreationFailed = 'CREATION_FAILED',
  /** The input value should be equal to the value allowed. */
  EqualTo = 'EQUAL_TO',
  /** A required feature is not enabled. */
  FeatureNotEnabled = 'FEATURE_NOT_ENABLED',
  /** The input value should be greater than the minimum allowed value. */
  GreaterThan = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The requested configuration cannot be applied to this standard return policy which is managed for you in compliance with relevant regulations. */
  IncompatibleWithStandardPolicy = 'INCOMPATIBLE_WITH_STANDARD_POLICY',
  /** Unexpected internal error happened. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** A resource was not in the correct state for the operation to succeed. */
  InvalidState = 'INVALID_STATE',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The user does not have permission to perform the operation. */
  MissingPermission = 'MISSING_PERMISSION',
  /** A requested notification could not be sent. */
  NotificationFailed = 'NOTIFICATION_FAILED',
  /** The input value is not a number. */
  NotANumber = 'NOT_A_NUMBER',
  /** A requested item is not editable. */
  NotEditable = 'NOT_EDITABLE',
  /** A requested item could not be found. */
  NotFound = 'NOT_FOUND',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too big. */
  TooBig = 'TOO_BIG',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** Too many arguments provided. */
  TooManyArguments = 'TOO_MANY_ARGUMENTS',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** The input value is the wrong length. */
  WrongLength = 'WRONG_LENGTH'
}

/** The input fields for a return. */
export type ReturnInput = {
  /** The new line items to be added to the order. */
  exchangeLineItems?: InputMaybe<Array<ExchangeLineItemInput>>;
  /** The ID of the order to be returned. */
  orderId: Scalars['ID']['input'];
  /** The UTC date and time when the return was first solicited by the customer. */
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The return line items list to be handled. */
  returnLineItems: Array<ReturnLineItemInput>;
  /** The return shipping fee to capture. */
  returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/**
 * An item that a customer returns from a fulfilled order. Links to the original [`FulfillmentLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/FulfillmentLineItem) and tracks quantities through the return process.
 *
 * The line item includes the customer's reason for returning the item and any additional notes. It also tracks processing status with separate quantities for items that are processable, processed, refundable, and refunded. You can apply optional restocking fees to cover handling costs.
 *
 * Learn more about [creating a return](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnCreate).
 */
export type ReturnLineItem = Node & ReturnLineItemType & {
  __typename?: 'ReturnLineItem';
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** The fulfillment line item from which items are returned. */
  fulfillmentLineItem: FulfillmentLineItem;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The quantity that can be processed. */
  processableQuantity: Scalars['Int']['output'];
  /** The quantity that has been processed. */
  processedQuantity: Scalars['Int']['output'];
  /** The quantity being returned. */
  quantity: Scalars['Int']['output'];
  /** The quantity that can be refunded. */
  refundableQuantity: Scalars['Int']['output'];
  /** The quantity that was refunded. */
  refundedQuantity: Scalars['Int']['output'];
  /** The restocking fee for the return line item. */
  restockingFee?: Maybe<RestockingFee>;
  /**
   * The reason for returning the item.
   * @deprecated Use `returnReasonDefinition` instead. This field will be removed in the future.
   */
  returnReason: ReturnReason;
  /** The standardized reason for why the item is being returned. */
  returnReasonDefinition?: Maybe<ReturnReasonDefinition>;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  returnReasonNote: Scalars['String']['output'];
  /** The total weight of the item. */
  totalWeight?: Maybe<Weight>;
  /** The quantity that has't been processed. */
  unprocessedQuantity: Scalars['Int']['output'];
  /** The total line price after all discounts on the line item, including both line item level discounts and code-based line item discounts, are applied. */
  withCodeDiscountedTotalPriceSet: MoneyBag;
};

/** The input fields for a return line item. */
export type ReturnLineItemInput = {
  /**
   * The ID of the fulfillment line item to be returned.
   * Specifically, this field expects a `FulfillmentLineItem.id`.
   */
  fulfillmentLineItemId: Scalars['ID']['input'];
  /** The quantity of the item to be returned. */
  quantity: Scalars['Int']['input'];
  /** The restocking fee to capture. */
  restockingFee?: InputMaybe<RestockingFeeInput>;
  /** The ID of a [`ReturnReasonDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ReturnReasonDefinition). Accepts any ID from the full library of reasons available via [`returnReasonDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/returnReasonDefinitions), not limited to the suggested reasons for the line item. */
  returnReasonDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * A note about the reason that the item is being returned.
   * Maximum length: 255 characters.
   */
  returnReasonNote?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for a removing a return line item from a return. */
export type ReturnLineItemRemoveFromReturnInput = {
  /** The quantity of the associated return line item to be removed. */
  quantity: Scalars['Int']['input'];
  /** The ID of the return line item to remove. */
  returnLineItemId: Scalars['ID']['input'];
};

/** Return type for `returnLineItemRemoveFromReturn` mutation. */
export type ReturnLineItemRemoveFromReturnPayload = {
  __typename?: 'ReturnLineItemRemoveFromReturnPayload';
  /** The modified return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** A return line item of any type. */
export type ReturnLineItemType = {
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The quantity that can be processed. */
  processableQuantity: Scalars['Int']['output'];
  /** The quantity that has been processed. */
  processedQuantity: Scalars['Int']['output'];
  /** The quantity being returned. */
  quantity: Scalars['Int']['output'];
  /** The quantity that can be refunded. */
  refundableQuantity: Scalars['Int']['output'];
  /** The quantity that was refunded. */
  refundedQuantity: Scalars['Int']['output'];
  /**
   * The reason for returning the item.
   * @deprecated Use `returnReasonDefinition` instead. This field will be removed in the future.
   */
  returnReason: ReturnReason;
  /** The standardized reason for why the item is being returned. */
  returnReasonDefinition?: Maybe<ReturnReasonDefinition>;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  returnReasonNote: Scalars['String']['output'];
  /** The quantity that has't been processed. */
  unprocessedQuantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple ReturnLineItemTypes. */
export type ReturnLineItemTypeConnection = {
  __typename?: 'ReturnLineItemTypeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReturnLineItemTypeEdge>;
  /** A list of nodes that are contained in ReturnLineItemTypeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReturnLineItemType>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnLineItemType and a cursor during pagination. */
export type ReturnLineItemTypeEdge = {
  __typename?: 'ReturnLineItemTypeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReturnLineItemTypeEdge. */
  node: ReturnLineItemType;
};

/** The financial transfer details for the return outcome. */
export type ReturnOutcomeFinancialTransfer = InvoiceReturnOutcome | RefundReturnOutcome;

/** The input fields for an exchange line item. */
export type ReturnProcessExchangeLineItemInput = {
  /** The ID of the exchange line item. */
  id: Scalars['ID']['input'];
  /** The quantity of the exchange line item. */
  quantity: Scalars['Int']['input'];
};

/** The input fields for the financial transfer for the return. */
export type ReturnProcessFinancialTransferInput = {
  /** Issue a refund for the return. */
  issueRefund?: InputMaybe<ReturnProcessRefundInput>;
};

/** The input fields for processing a return. */
export type ReturnProcessInput = {
  /** The exchange line items list to be handled. */
  exchangeLineItems?: InputMaybe<Array<ReturnProcessExchangeLineItemInput>>;
  /** The financial transfer for the return. */
  financialTransfer?: InputMaybe<ReturnProcessFinancialTransferInput>;
  /** The note for the return. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Whether to notify the customer about the return. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The refund duties list to be handled. */
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  /** The shipping cost to refund. */
  refundShipping?: InputMaybe<RefundShippingInput>;
  /** The ID of the return to be processed. */
  returnId: Scalars['ID']['input'];
  /** The return line items list to be handled. */
  returnLineItems?: InputMaybe<Array<ReturnProcessReturnLineItemInput>>;
  /** ID of the tip line item. */
  tipLineId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `returnProcess` mutation. */
export type ReturnProcessPayload = {
  __typename?: 'ReturnProcessPayload';
  /** The processed return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The input fields for the refund for the return. */
export type ReturnProcessRefundInput = {
  /** Whether to allow the total refunded amount to surpass the amount paid for the order. */
  allowOverRefunding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order transactions for the refund. */
  orderTransactions: Array<ReturnRefundOrderTransactionInput>;
  /** A list of instructions to process the financial outcome of the refund. */
  refundMethods?: InputMaybe<Array<RefundMethodInput>>;
};

/** The input fields for a return line item. */
export type ReturnProcessReturnLineItemInput = {
  /** The dispositions for the return line item. */
  dispositions?: InputMaybe<Array<ReverseFulfillmentOrderDisposeInput>>;
  /** The ID of the return line item. */
  id: Scalars['ID']['input'];
  /** The quantity of the return line item. */
  quantity: Scalars['Int']['input'];
};

/** Filter line items based on processing status. */
export enum ReturnProcessingStatusFilterInput {
  /** Only include line items that have some processable quantity. */
  Processable = 'PROCESSABLE',
  /** Only include line items that have been processed. */
  Processed = 'PROCESSED'
}

/** The reason for returning the return line item. */
export enum ReturnReason {
  /** The item is returned because the buyer did not like the color. Displays as **Color**. */
  Color = 'COLOR',
  /** The item is returned because it is damaged or defective. Displays as **Damaged or defective**. */
  Defective = 'DEFECTIVE',
  /** The item is returned because it was not as described. Displays as **Item not as described**. */
  NotAsDescribed = 'NOT_AS_DESCRIBED',
  /** The item is returned for another reason. For this value, a return reason note is also provided. Displays as **Other**. */
  Other = 'OTHER',
  /** The item is returned because the size was too large. Displays as **Size was too large**. */
  SizeTooLarge = 'SIZE_TOO_LARGE',
  /** The item is returned because the size was too small. Displays as **Size was too small**. */
  SizeTooSmall = 'SIZE_TOO_SMALL',
  /** The item is returned because the buyer did not like the style. Displays as **Style**. */
  Style = 'STYLE',
  /** The item is returned because of an unknown reason. Displays as **Unknown**. */
  Unknown = 'UNKNOWN',
  /** The item is returned because the customer changed their mind. Displays as **Customer changed their mind**. */
  Unwanted = 'UNWANTED',
  /** The item is returned because the customer received the wrong one. Displays as **Received the wrong item**. */
  WrongItem = 'WRONG_ITEM'
}

/**
 * A standardized reason for returning an item.
 *
 * - Shopify offers an expanded library of return reasons available to all merchants
 * - For each product, Shopify suggests a curated subset of reasons based on the product's category
 * - Suggested reasons aren't the only valid options. When creating a return via the API, you can use any reason from the [full library](https://shopify.dev/docs/api/admin-graphql/latest/queries/returnReasonDefinitions).
 */
export type ReturnReasonDefinition = Node & {
  __typename?: 'ReturnReasonDefinition';
  /**
   * Whether the return reason has been removed from taxonomy.
   *
   * Deleted reasons should not be presented to customers when creating new returns, but may still
   * appear on existing returns that were created before the reason was deleted. This field enables
   * graceful deprecation of return reasons without breaking historical data.
   */
  deleted: Scalars['Boolean']['output'];
  /**
   * A unique, human-readable, stable identifier for the return reason.
   *
   * Example values include "arrived-late", "comfort", "too-tight", "color-too-bright", and "quality".
   * The handle remains consistent across API versions and localizations, making it suitable for programmatic use.
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The localized, user-facing name of the return reason.
   *
   * This field returns the reason name in the requested locale, automatically falling back to
   * English if no translation is available. Use this field when displaying return reasons to
   * customers or merchants.
   */
  name: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple ReturnReasonDefinitions. */
export type ReturnReasonDefinitionConnection = {
  __typename?: 'ReturnReasonDefinitionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReturnReasonDefinitionEdge>;
  /** A list of nodes that are contained in ReturnReasonDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReturnReasonDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnReasonDefinition and a cursor during pagination. */
export type ReturnReasonDefinitionEdge = {
  __typename?: 'ReturnReasonDefinitionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReturnReasonDefinitionEdge. */
  node: ReturnReasonDefinition;
};

/** The set of valid sort keys for the ReturnReasonDefinition query. */
export enum ReturnReasonDefinitionSortKeys {
  /** Sort by the `handle` value. */
  Handle = 'HANDLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME'
}

/** The input fields to refund a return. */
export type ReturnRefundInput = {
  /** Whether to send a refund notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of transactions involved in refunding the return. */
  orderTransactions?: InputMaybe<Array<ReturnRefundOrderTransactionInput>>;
  /** A list of duties to refund. */
  refundDuties?: InputMaybe<Array<RefundDutyInput>>;
  /** The shipping amount to refund. */
  refundShipping?: InputMaybe<RefundShippingInput>;
  /** The ID of the return. */
  returnId: Scalars['ID']['input'];
  /** A list of return line items to refund. */
  returnRefundLineItems: Array<ReturnRefundLineItemInput>;
};

/** The input fields for a return refund line item. */
export type ReturnRefundLineItemInput = {
  /** The quantity of the return line item to be refunded. */
  quantity: Scalars['Int']['input'];
  /** The ID of the return line item to be refunded. */
  returnLineItemId: Scalars['ID']['input'];
};

/** The input fields to create order transactions when refunding a return. */
export type ReturnRefundOrderTransactionInput = {
  /** The ID of the parent order transaction. The transaction must be of kind `CAPTURE` or a `SALE`. */
  parentId: Scalars['ID']['input'];
  /** The amount of money for the transaction in the presentment currency of the order. */
  transactionAmount: MoneyInput;
};

/** Return type for `returnRefund` mutation. */
export type ReturnRefundPayload = {
  __typename?: 'ReturnRefundPayload';
  /** The created refund. */
  refund?: Maybe<Refund>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** Return type for `returnReopen` mutation. */
export type ReturnReopenPayload = {
  __typename?: 'ReturnReopenPayload';
  /** The reopened return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The input fields for requesting a return. */
export type ReturnRequestInput = {
  /** The ID of the order that's being returned. */
  orderId: Scalars['ID']['input'];
  /** The line items that are being handled in the return. */
  returnLineItems: Array<ReturnRequestLineItemInput>;
  /** The return shipping fee to capture. */
  returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/** The input fields for a return line item. */
export type ReturnRequestLineItemInput = {
  /**
   * A note from the customer that describes the item to be returned.
   * For example, the note can communicate issues with the item to the merchant.
   * Maximum length: 300 characters.
   */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the fulfillment line item to be returned.
   * Specifically, this field expects a `FulfillmentLineItem.id`.
   */
  fulfillmentLineItemId: Scalars['ID']['input'];
  /** The quantity of the item that's being returned. */
  quantity: Scalars['Int']['input'];
  /** The restocking fee to capture. */
  restockingFee?: InputMaybe<RestockingFeeInput>;
  /** The ID of a [`ReturnReasonDefinition`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ReturnReasonDefinition). Accepts any ID from the full library of reasons available via [`returnReasonDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/returnReasonDefinitions), not limited to the suggested reasons for the line item. */
  returnReasonDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `returnRequest` mutation. */
export type ReturnRequestPayload = {
  __typename?: 'ReturnRequestPayload';
  /** The requested return. */
  return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** A return shipping fee is a fee captured as part of a return to cover the costs of shipping the return. */
export type ReturnShippingFee = Fee & {
  __typename?: 'ReturnShippingFee';
  /** The amount of the return shipping fee, in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** The unique ID for the Fee. */
  id: Scalars['ID']['output'];
};

/** The input fields for a return shipping fee. */
export type ReturnShippingFeeInput = {
  /** The value of the fee as a fixed amount in the presentment currency of the order. */
  amount: MoneyInput;
};

/** The status of a return. */
export enum ReturnStatus {
  /** The return has been canceled. */
  Canceled = 'CANCELED',
  /** The return has been completed. */
  Closed = 'CLOSED',
  /** The return was declined. */
  Declined = 'DECLINED',
  /** The return is in progress. */
  Open = 'OPEN',
  /** The return was requested. */
  Requested = 'REQUESTED'
}

/** An error that occurs during the execution of a return mutation. */
export type ReturnUserError = DisplayableError & {
  __typename?: 'ReturnUserError';
  /** The error code. */
  code?: Maybe<ReturnErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * A delivered order that's eligible to be returned to the merchant. Provides the items from completed fulfillments that customers can select when initiating a return.
 *
 * Use returnable fulfillments to determine which items are eligible for return before creating a [`Return`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return) with the [`returnCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnCreate) mutation. The line items show quantities that are available for return.
 *
 * Learn more about [building return management workflows](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management).
 */
export type ReturnableFulfillment = Node & {
  __typename?: 'ReturnableFulfillment';
  /** The fulfillment that the returnable fulfillment refers to. */
  fulfillment: Fulfillment;
  /** The unique ID of the Returnable Fulfillment. */
  id: Scalars['ID']['output'];
  /** The list of returnable fulfillment line items. */
  returnableFulfillmentLineItems: ReturnableFulfillmentLineItemConnection;
};


/**
 * A delivered order that's eligible to be returned to the merchant. Provides the items from completed fulfillments that customers can select when initiating a return.
 *
 * Use returnable fulfillments to determine which items are eligible for return before creating a [`Return`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Return) with the [`returnCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/returnCreate) mutation. The line items show quantities that are available for return.
 *
 * Learn more about [building return management workflows](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/build-return-management).
 */
export type ReturnableFulfillmentReturnableFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple ReturnableFulfillments. */
export type ReturnableFulfillmentConnection = {
  __typename?: 'ReturnableFulfillmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReturnableFulfillmentEdge>;
  /** A list of nodes that are contained in ReturnableFulfillmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReturnableFulfillment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnableFulfillment and a cursor during pagination. */
export type ReturnableFulfillmentEdge = {
  __typename?: 'ReturnableFulfillmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReturnableFulfillmentEdge. */
  node: ReturnableFulfillment;
};

/** A returnable fulfillment line item. */
export type ReturnableFulfillmentLineItem = {
  __typename?: 'ReturnableFulfillmentLineItem';
  /** The fulfillment line item that can be returned. */
  fulfillmentLineItem: FulfillmentLineItem;
  /** The quantity available to be returned. */
  quantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple ReturnableFulfillmentLineItems. */
export type ReturnableFulfillmentLineItemConnection = {
  __typename?: 'ReturnableFulfillmentLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReturnableFulfillmentLineItemEdge>;
  /** A list of nodes that are contained in ReturnableFulfillmentLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReturnableFulfillmentLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnableFulfillmentLineItem and a cursor during pagination. */
export type ReturnableFulfillmentLineItemEdge = {
  __typename?: 'ReturnableFulfillmentLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReturnableFulfillmentLineItemEdge. */
  node: ReturnableFulfillmentLineItem;
};

/**
 * A reverse delivery is a post-fulfillment object that represents a buyer sending a package to a merchant.
 * For example, a buyer requests a return, and a merchant sends the buyer a shipping label.
 * The reverse delivery contains the context of the items sent back, how they're being sent back
 * (for example, a shipping label), and the current state of the delivery (tracking information).
 */
export type ReverseDelivery = Node & {
  __typename?: 'ReverseDelivery';
  /** The deliverable associated with the reverse delivery. */
  deliverable?: Maybe<ReverseDeliveryDeliverable>;
  /** The ID of the reverse delivery. */
  id: Scalars['ID']['output'];
  /** The reverse delivery line items attached to the reverse delivery. */
  reverseDeliveryLineItems: ReverseDeliveryLineItemConnection;
  /** The `ReverseFulfillmentOrder` associated with the reverse delivery. */
  reverseFulfillmentOrder: ReverseFulfillmentOrder;
};


/**
 * A reverse delivery is a post-fulfillment object that represents a buyer sending a package to a merchant.
 * For example, a buyer requests a return, and a merchant sends the buyer a shipping label.
 * The reverse delivery contains the context of the items sent back, how they're being sent back
 * (for example, a shipping label), and the current state of the delivery (tracking information).
 */
export type ReverseDeliveryReverseDeliveryLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple ReverseDeliveries. */
export type ReverseDeliveryConnection = {
  __typename?: 'ReverseDeliveryConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReverseDeliveryEdge>;
  /** A list of nodes that are contained in ReverseDeliveryEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReverseDelivery>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `reverseDeliveryCreateWithShipping` mutation. */
export type ReverseDeliveryCreateWithShippingPayload = {
  __typename?: 'ReverseDeliveryCreateWithShippingPayload';
  /** The created reverse delivery. */
  reverseDelivery?: Maybe<ReverseDelivery>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The delivery method and artifacts associated with a reverse delivery. */
export type ReverseDeliveryDeliverable = ReverseDeliveryShippingDeliverable;

/** An auto-generated type which holds one ReverseDelivery and a cursor during pagination. */
export type ReverseDeliveryEdge = {
  __typename?: 'ReverseDeliveryEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReverseDeliveryEdge. */
  node: ReverseDelivery;
};

/** The input fields for a reverse label. */
export type ReverseDeliveryLabelInput = {
  /** The URL of the label file. If a label file was uploaded to be attached to the delivery, then provide the temporary staged URL. */
  fileUrl: Scalars['URL']['input'];
};

/** The return label file information for a reverse delivery. */
export type ReverseDeliveryLabelV2 = {
  __typename?: 'ReverseDeliveryLabelV2';
  /** The date and time when the reverse delivery label was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A public link that can be used to download the label image. */
  publicFileUrl?: Maybe<Scalars['URL']['output']>;
  /** The date and time when the reverse delivery label was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The details about a reverse delivery line item. */
export type ReverseDeliveryLineItem = Node & {
  __typename?: 'ReverseDeliveryLineItem';
  /** The dispositions of the item. */
  dispositions: Array<ReverseFulfillmentOrderDisposition>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The expected number of units. */
  quantity: Scalars['Int']['output'];
  /** The corresponding reverse fulfillment order line item. */
  reverseFulfillmentOrderLineItem: ReverseFulfillmentOrderLineItem;
};

/** An auto-generated type for paginating through multiple ReverseDeliveryLineItems. */
export type ReverseDeliveryLineItemConnection = {
  __typename?: 'ReverseDeliveryLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReverseDeliveryLineItemEdge>;
  /** A list of nodes that are contained in ReverseDeliveryLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReverseDeliveryLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReverseDeliveryLineItem and a cursor during pagination. */
export type ReverseDeliveryLineItemEdge = {
  __typename?: 'ReverseDeliveryLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReverseDeliveryLineItemEdge. */
  node: ReverseDeliveryLineItem;
};

/** The input fields for a reverse delivery line item. */
export type ReverseDeliveryLineItemInput = {
  /** The quantity of the item to be included in the delivery. */
  quantity: Scalars['Int']['input'];
  /** The ID of the related reverse fulfillment order line item. */
  reverseFulfillmentOrderLineItemId: Scalars['ID']['input'];
};

/** A reverse shipping deliverable that may include a label and tracking information. */
export type ReverseDeliveryShippingDeliverable = {
  __typename?: 'ReverseDeliveryShippingDeliverable';
  /** The return label attached to the reverse delivery. */
  label?: Maybe<ReverseDeliveryLabelV2>;
  /** The information to track the reverse delivery. */
  tracking?: Maybe<ReverseDeliveryTrackingV2>;
};

/** Return type for `reverseDeliveryShippingUpdate` mutation. */
export type ReverseDeliveryShippingUpdatePayload = {
  __typename?: 'ReverseDeliveryShippingUpdatePayload';
  /** The updated reverse delivery. */
  reverseDelivery?: Maybe<ReverseDelivery>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The input fields for tracking information about a return delivery. */
export type ReverseDeliveryTrackingInput = {
  /** The tracking number for the label. */
  number?: InputMaybe<Scalars['String']['input']>;
  /** The tracking URL for the carrier. If the carrier isn't supported by Shopify, then provide the tracking URL of the delivery. */
  url?: InputMaybe<Scalars['URL']['input']>;
};

/** Represents the information used to track a reverse delivery. */
export type ReverseDeliveryTrackingV2 = {
  __typename?: 'ReverseDeliveryTrackingV2';
  /** The provider of the tracking information, in a human-readable format for display purposes. */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** The identifier used by the courier to identify the shipment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The URL to track a shipment. */
  url?: Maybe<Scalars['URL']['output']>;
};

/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrder = Node & {
  __typename?: 'ReverseFulfillmentOrder';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The list of reverse fulfillment order line items for the reverse fulfillment order. */
  lineItems: ReverseFulfillmentOrderLineItemConnection;
  /** The order associated with the reverse fulfillment order. */
  order?: Maybe<Order>;
  /** The list of reverse deliveries for the reverse fulfillment order. */
  reverseDeliveries: ReverseDeliveryConnection;
  /** The status of the reverse fulfillment order. */
  status: ReverseFulfillmentOrderStatus;
  /**
   * The current confirmation for the reverse fulfillment order from a third-party logistics service.
   * If no third-party service is involved, then this value is `nil`.
   */
  thirdPartyConfirmation?: Maybe<ReverseFulfillmentOrderThirdPartyConfirmation>;
};


/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrderReverseDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple ReverseFulfillmentOrders. */
export type ReverseFulfillmentOrderConnection = {
  __typename?: 'ReverseFulfillmentOrderConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReverseFulfillmentOrderEdge>;
  /** A list of nodes that are contained in ReverseFulfillmentOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReverseFulfillmentOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to dispose a reverse fulfillment order line item. */
export type ReverseFulfillmentOrderDisposeInput = {
  /** The final arrangement for the reverse fulfillment order line item. */
  dispositionType: ReverseFulfillmentOrderDispositionType;
  /**
   * The ID of the location where the reverse fulfillment order line item is to be disposed.
   *         This is required when the disposition type is RESTOCKED.
   */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the reverse fulfillment order line item to dispose. */
  quantity: Scalars['Int']['input'];
  /** The ID of the reverse fulfillment order line item. */
  reverseFulfillmentOrderLineItemId: Scalars['ID']['input'];
};

/** Return type for `reverseFulfillmentOrderDispose` mutation. */
export type ReverseFulfillmentOrderDisposePayload = {
  __typename?: 'ReverseFulfillmentOrderDisposePayload';
  /** The disposed reverse fulfillment order line items. */
  reverseFulfillmentOrderLineItems?: Maybe<Array<ReverseFulfillmentOrderLineItem>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ReturnUserError>;
};

/** The details of the arrangement of an item. */
export type ReverseFulfillmentOrderDisposition = Node & {
  __typename?: 'ReverseFulfillmentOrderDisposition';
  /** The date and time when the disposition was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location where the disposition occurred. */
  location?: Maybe<Location>;
  /** The number of disposed units. */
  quantity: Scalars['Int']['output'];
  /** The final arrangement of an item. */
  type: ReverseFulfillmentOrderDispositionType;
};

/** The final arrangement of an item from a reverse fulfillment order. */
export enum ReverseFulfillmentOrderDispositionType {
  /** An item that was expected but absent. */
  Missing = 'MISSING',
  /** An item that wasn't restocked. */
  NotRestocked = 'NOT_RESTOCKED',
  /** An item that requires further processing before being restocked or discarded. */
  ProcessingRequired = 'PROCESSING_REQUIRED',
  /** An item that was restocked. */
  Restocked = 'RESTOCKED'
}

/** An auto-generated type which holds one ReverseFulfillmentOrder and a cursor during pagination. */
export type ReverseFulfillmentOrderEdge = {
  __typename?: 'ReverseFulfillmentOrderEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReverseFulfillmentOrderEdge. */
  node: ReverseFulfillmentOrder;
};

/** The details about a reverse fulfillment order line item. */
export type ReverseFulfillmentOrderLineItem = Node & {
  __typename?: 'ReverseFulfillmentOrderLineItem';
  /** The dispositions of the item. */
  dispositions: Array<ReverseFulfillmentOrderDisposition>;
  /** The corresponding fulfillment line item for a reverse fulfillment order line item. */
  fulfillmentLineItem?: Maybe<FulfillmentLineItem>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The total number of units to be processed. */
  totalQuantity: Scalars['Int']['output'];
};

/** An auto-generated type for paginating through multiple ReverseFulfillmentOrderLineItems. */
export type ReverseFulfillmentOrderLineItemConnection = {
  __typename?: 'ReverseFulfillmentOrderLineItemConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ReverseFulfillmentOrderLineItemEdge>;
  /** A list of nodes that are contained in ReverseFulfillmentOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ReverseFulfillmentOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReverseFulfillmentOrderLineItem and a cursor during pagination. */
export type ReverseFulfillmentOrderLineItemEdge = {
  __typename?: 'ReverseFulfillmentOrderLineItemEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ReverseFulfillmentOrderLineItemEdge. */
  node: ReverseFulfillmentOrderLineItem;
};

/** The status of a reverse fulfillment order. */
export enum ReverseFulfillmentOrderStatus {
  /** The reverse fulfillment order has been canceled. */
  Canceled = 'CANCELED',
  /** The reverse fulfillment order has been completed. */
  Closed = 'CLOSED',
  /** The reverse fulfillment order is in progress. */
  Open = 'OPEN'
}

/** The third-party confirmation of a reverse fulfillment order. */
export type ReverseFulfillmentOrderThirdPartyConfirmation = {
  __typename?: 'ReverseFulfillmentOrderThirdPartyConfirmation';
  /** The status of the reverse fulfillment order third-party confirmation. */
  status: ReverseFulfillmentOrderThirdPartyConfirmationStatus;
};

/** The status of a reverse fulfillment order third-party confirmation. */
export enum ReverseFulfillmentOrderThirdPartyConfirmationStatus {
  /** The reverse fulfillment order was accepted by the fulfillment service. */
  Accepted = 'ACCEPTED',
  /** The reverse fulfillment order cancelation was accepted by the fulfillment service. */
  CancelAccepted = 'CANCEL_ACCEPTED',
  /** The reverse fulfillment order cancelation was rejected by the fulfillment service. */
  CancelRejected = 'CANCEL_REJECTED',
  /** The reverse fulfillment order is awaiting acceptance by the fulfillment service. */
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  /** The reverse fulfillment order is awaiting cancelation by the fulfillment service. */
  PendingCancelation = 'PENDING_CANCELATION',
  /** The reverse fulfillment order was rejected by the fulfillment service. */
  Rejected = 'REJECTED'
}

/** Possible risk levels for an order risk assessment. */
export enum RiskAssessmentResult {
  /** Indicates a high likelihood that the order is fraudulent. */
  High = 'HIGH',
  /** Indicates a low likelihood that the order is fraudulent. */
  Low = 'LOW',
  /** Indicates a medium likelihood that the order is fraudulent. */
  Medium = 'MEDIUM',
  /** Indicates that the risk assessment will not provide a recommendation for the order. */
  None = 'NONE',
  /** Indicates that the risk assessment is still pending. */
  Pending = 'PENDING'
}

/** Additional context provided with an order risk assessment. Facts may not affect the order's risk recommendation. */
export type RiskFact = {
  __typename?: 'RiskFact';
  /** Descriptions longer than 256 characters are truncated. */
  description: Scalars['String']['output'];
  /** Indicates whether the fact contributes negatively, neutrally, or positively to risk. */
  sentiment: RiskFactSentiment;
};

/** Possible sentiments for a risk fact. */
export enum RiskFactSentiment {
  /** A negative contributor that increases the risk. */
  Negative = 'NEGATIVE',
  /** A neutral contributor with regard to risk. */
  Neutral = 'NEUTRAL',
  /** A positive contributor that lowers the risk. */
  Positive = 'POSITIVE'
}

/** A row count represents rows on background operation. */
export type RowCount = {
  __typename?: 'RowCount';
  /** Estimated number of rows contained within this background operation. */
  count: Scalars['Int']['output'];
  /** Whether the operation exceeds max number of reportable rows. */
  exceedsMax: Scalars['Boolean']['output'];
};

/** SEO information. */
export type Seo = {
  __typename?: 'SEO';
  /** SEO Description. */
  description?: Maybe<Scalars['String']['output']>;
  /** SEO Title. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The input fields for SEO information. */
export type SeoInput = {
  /** SEO description of the product. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** SEO title of the product. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** An individual sale record associated with a sales agreement. Every money value in an order's sales data is represented in the currency's smallest unit. When amounts are divided across multiple line items, such as taxes or order discounts, the amounts might not divide evenly across all of the line items on the order. To address this, the remaining currency units that couldn't be divided evenly are allocated one at a time, starting with the first line item, until they are all accounted for. In aggregate, the values sum up correctly. In isolation, one line item might have a different tax or discount amount than another line item of the same price, before taxes and discounts. This is because the amount could not be divided evenly across the items. The allocation of currency units across line items is immutable. After they are allocated, currency units are never reallocated or redistributed among the line items. */
export type Sale = {
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** The possible order action types for a sale. */
export enum SaleActionType {
  /** A purchase or charge. */
  Order = 'ORDER',
  /** A removal or return. */
  Return = 'RETURN',
  /** An unknown order action. Represents new actions that may be added in future versions. */
  Unknown = 'UNKNOWN',
  /** A change to the price, taxes, or discounts for a prior purchase. */
  Update = 'UPDATE'
}

/** The additional fee details for a line item. */
export type SaleAdditionalFee = Node & {
  __typename?: 'SaleAdditionalFee';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the additional fee. */
  name: Scalars['String']['output'];
  /** The price of the additional fee. */
  price: MoneyBag;
  /** A list of taxes charged on the additional fee. */
  taxLines: Array<TaxLine>;
};

/** An auto-generated type for paginating through multiple Sales. */
export type SaleConnection = {
  __typename?: 'SaleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SaleEdge>;
  /** A list of nodes that are contained in SaleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Sale>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one Sale and a cursor during pagination. */
export type SaleEdge = {
  __typename?: 'SaleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SaleEdge. */
  node: Sale;
};

/** The possible line types for a sale record. One of the possible order line types for a sale is an adjustment. Sales adjustments occur when a refund is issued for a line item that is either more or less than the total value of the line item. Examples are restocking fees and goodwill payments. When this happens, Shopify produces a sales agreement with sale records for each line item that is returned or refunded and an additional sale record for the adjustment (for example, a restocking fee). The sales records for the returned or refunded items represent the reversal of the original line item sale value. The additional adjustment sale record represents the difference between the original total value of all line items that were refunded, and the actual amount refunded. */
export enum SaleLineType {
  /** An additional fee. */
  AdditionalFee = 'ADDITIONAL_FEE',
  /** A sale adjustment. */
  Adjustment = 'ADJUSTMENT',
  /** A duty charge. */
  Duty = 'DUTY',
  /** A fee charge. */
  Fee = 'FEE',
  /** A gift card. */
  GiftCard = 'GIFT_CARD',
  /** A product purchased, returned or exchanged. */
  Product = 'PRODUCT',
  /** A shipping cost. */
  Shipping = 'SHIPPING',
  /** A tip added by the customer. */
  Tip = 'TIP',
  /** An unknown sale line. Represents new types that may be added in future versions. */
  Unknown = 'UNKNOWN'
}

/** The tax allocated to a sale from a single tax line. */
export type SaleTax = {
  __typename?: 'SaleTax';
  /** The portion of the total tax amount on the related sale that comes from the associated tax line. */
  amount: MoneyBag;
  /** The unique ID for the sale tax. */
  id: Scalars['ID']['output'];
  /** The tax line associated with the sale. */
  taxLine: TaxLine;
};

/** A contract between a merchant and a customer to do business. Shopify creates a sales agreement whenever an order is placed, edited, or refunded. A sales agreement has one or more sales records, which provide itemized details about the initial agreement or subsequent changes made to the order. For example, when a customer places an order, Shopify creates the order, generates a sales agreement, and records a sale for each line item purchased in the order. A sale record is specific to a type of order line. Order lines can represent different things such as a purchased product, a tip added by a customer, shipping costs collected at checkout, and more. */
export type SalesAgreement = {
  /** The application that created the agreement. */
  app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  happenedAt: Scalars['DateTime']['output'];
  /** The unique ID for the agreement. */
  id: Scalars['ID']['output'];
  /** The reason the agremeent was created. */
  reason: OrderActionType;
  /** The sales associated with the agreement. */
  sales: SaleConnection;
  /** The staff member associated with the agreement. */
  user?: Maybe<StaffMember>;
};


/** A contract between a merchant and a customer to do business. Shopify creates a sales agreement whenever an order is placed, edited, or refunded. A sales agreement has one or more sales records, which provide itemized details about the initial agreement or subsequent changes made to the order. For example, when a customer places an order, Shopify creates the order, generates a sales agreement, and records a sale for each line item purchased in the order. A sale record is specific to a type of order line. Order lines can represent different things such as a purchased product, a tip added by a customer, shipping costs collected at checkout, and more. */
export type SalesAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple SalesAgreements. */
export type SalesAgreementConnection = {
  __typename?: 'SalesAgreementConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SalesAgreementEdge>;
  /** A list of nodes that are contained in SalesAgreementEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SalesAgreement>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SalesAgreement and a cursor during pagination. */
export type SalesAgreementEdge = {
  __typename?: 'SalesAgreementEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SalesAgreementEdge. */
  node: SalesAgreement;
};

/**
 * A representation of a search query in the Shopify admin used on resource index views. Preserves complex queries with search terms and filters, enabling merchants to quickly access frequently used data views. For example, a saved search can be applied to the product index table to filter products. The query string combines free-text search terms with structured filters to narrow results based on resource attributes.
 *
 * The search applies to a specific resource type such as [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer), [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product), [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order), or [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects.
 */
export type SavedSearch = LegacyInteroperability & Node & {
  __typename?: 'SavedSearch';
  /** The filters of a saved search. */
  filters: Array<SearchFilter>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The name of a saved search. */
  name: Scalars['String']['output'];
  /** The query string of a saved search. This includes search terms and filters. */
  query: Scalars['String']['output'];
  /** The type of resource this saved search is searching in. */
  resourceType: SearchResultType;
  /** The search terms of a saved search. */
  searchTerms: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple SavedSearches. */
export type SavedSearchConnection = {
  __typename?: 'SavedSearchConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SavedSearchEdge>;
  /** A list of nodes that are contained in SavedSearchEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SavedSearch>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields to create a saved search. */
export type SavedSearchCreateInput = {
  /** A descriptive name of the saved search. */
  name: Scalars['String']['input'];
  /** The query string of a saved search. This includes search terms and filters. */
  query: Scalars['String']['input'];
  /** The type of resource this saved search is searching in. */
  resourceType: SearchResultType;
};

/** Return type for `savedSearchCreate` mutation. */
export type SavedSearchCreatePayload = {
  __typename?: 'SavedSearchCreatePayload';
  /** The saved search that was created. */
  savedSearch?: Maybe<SavedSearch>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields to delete a saved search. */
export type SavedSearchDeleteInput = {
  /** ID of the saved search to delete. */
  id: Scalars['ID']['input'];
};

/** Return type for `savedSearchDelete` mutation. */
export type SavedSearchDeletePayload = {
  __typename?: 'SavedSearchDeletePayload';
  /** The ID of the saved search that was deleted. */
  deletedSavedSearchId?: Maybe<Scalars['ID']['output']>;
  /** The shop of the saved search that was deleted. */
  shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one SavedSearch and a cursor during pagination. */
export type SavedSearchEdge = {
  __typename?: 'SavedSearchEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SavedSearchEdge. */
  node: SavedSearch;
};

/** The input fields to update a saved search. */
export type SavedSearchUpdateInput = {
  /** ID of the saved search to update. */
  id: Scalars['ID']['input'];
  /** A descriptive name of the saved search. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The query string of a saved search. This included search terms and filters. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `savedSearchUpdate` mutation. */
export type SavedSearchUpdatePayload = {
  __typename?: 'SavedSearchUpdatePayload';
  /** The saved search that was updated. */
  savedSearch?: Maybe<SavedSearch>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The set of valid sort keys for the ScheduledChange query. */
export enum ScheduledChangeSortKeys {
  /** Sort by the `expected_at` value. */
  ExpectedAt = 'EXPECTED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/**
 * Script discount applications capture the intentions of a discount that
 * was created by a Shopify Script for an order's line item or shipping line.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type ScriptDiscountApplication = DiscountApplication & {
  __typename?: 'ScriptDiscountApplication';
  /** The method by which the discount's value is applied to its entitled items. */
  allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * The description of the application as defined by the Script.
   * @deprecated Use `title` instead.
   */
  description: Scalars['String']['output'];
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  index: Scalars['Int']['output'];
  /** How the discount amount is distributed on the discounted lines. */
  targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  targetType: DiscountApplicationTargetType;
  /** The title of the application as defined by the Script. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: PricingValue;
};

/**
 * <div class="note"><h4>Theme app extensions</h4>
 *   <p>If your app integrates with a Shopify theme and you plan to submit it to the Shopify App Store, you must use theme app extensions instead of Script tags. Script tags can only be used with vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
 *
 *
 * A script tag represents remote JavaScript code that is loaded into the pages of a shop's storefront or the **Order status** page of checkout.
 */
export type ScriptTag = LegacyInteroperability & Node & {
  __typename?: 'ScriptTag';
  /**
   * Whether the Shopify CDN can cache and serve the script tag.
   * If `true`, then the script will be cached and served by the CDN.
   * The cache expires 15 minutes after the script tag is successfully returned.
   * If `false`, then the script will be served as is.
   */
  cache: Scalars['Boolean']['output'];
  /** The date and time when the script tag was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The page or pages on the online store that the script should be included. */
  displayScope: ScriptTagDisplayScope;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The URL to the remote script. */
  src: Scalars['URL']['output'];
  /** The date and time when the script tag was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple ScriptTags. */
export type ScriptTagConnection = {
  __typename?: 'ScriptTagConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ScriptTagEdge>;
  /** A list of nodes that are contained in ScriptTagEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ScriptTag>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `scriptTagCreate` mutation. */
export type ScriptTagCreatePayload = {
  __typename?: 'ScriptTagCreatePayload';
  /** The script tag that was created. */
  scriptTag?: Maybe<ScriptTag>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `scriptTagDelete` mutation. */
export type ScriptTagDeletePayload = {
  __typename?: 'ScriptTagDeletePayload';
  /** The ID of the deleted script tag. */
  deletedScriptTagId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The page or pages on the online store where the script should be included. */
export enum ScriptTagDisplayScope {
  /**
   * Include the script on both the web storefront and the <b>Order status</b> page.
   * @deprecated `ALL` is deprecated. Use `ONLINE_STORE` instead.
   *
   */
  All = 'ALL',
  /** Include the script only on the web storefront. */
  OnlineStore = 'ONLINE_STORE',
  /**
   * Include the script only on the <b>Order status</b> page.
   * @deprecated `ORDER_STATUS` is deprecated and unavailable as a mutation input.
   *
   */
  OrderStatus = 'ORDER_STATUS'
}

/** An auto-generated type which holds one ScriptTag and a cursor during pagination. */
export type ScriptTagEdge = {
  __typename?: 'ScriptTagEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ScriptTagEdge. */
  node: ScriptTag;
};

/**
 * The input fields for a script tag. This input object is used when creating or updating
 * a script tag to specify its URL, where it should be included, and how it will be cached.
 */
export type ScriptTagInput = {
  /**
   * Whether the Shopify CDN can cache and serve the script tag.
   * If `true`, then the script will be cached and served by the CDN.
   * The cache expires 15 minutes after the script tag is successfully returned.
   * If `false`, then the script is served as is.
   * The default value is `false`.
   */
  cache?: InputMaybe<Scalars['Boolean']['input']>;
  /** The page or pages on the online store where the script should be included. */
  displayScope?: InputMaybe<ScriptTagDisplayScope>;
  /** The URL of the remote script. For example: `https://example.com/path/to/script.js`. */
  src?: InputMaybe<Scalars['URL']['input']>;
};

/** Return type for `scriptTagUpdate` mutation. */
export type ScriptTagUpdatePayload = {
  __typename?: 'ScriptTagUpdatePayload';
  /** The script tag that was updated. */
  scriptTag?: Maybe<ScriptTag>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A filter in a search query represented by a key value pair. */
export type SearchFilter = {
  __typename?: 'SearchFilter';
  /** The key of the search filter. */
  key: Scalars['String']['output'];
  /** The value of the search filter. */
  value: Scalars['String']['output'];
};

/** A list of search filters along with their specific options in value and label pair for filtering. */
export type SearchFilterOptions = {
  __typename?: 'SearchFilterOptions';
  /** A list of options that can be use to filter product availability. */
  productAvailability: Array<FilterOption>;
};

/** Represents an individual result returned from a search. */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** Returns the search result description text. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the Image resource presented to accompany a search result. */
  image?: Maybe<Image>;
  /** Returns the resource represented by the search result. */
  reference: Node;
  /** Returns the resource title. */
  title: Scalars['String']['output'];
  /** Returns the absolute URL to the resource in the search result. */
  url: Scalars['URL']['output'];
};

/** The connection type for SearchResult. */
export type SearchResultConnection = {
  __typename?: 'SearchResultConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SearchResultEdge>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
  /**
   * An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page.
   * @deprecated The provided information is not accurate.
   */
  resultsAfterCount: Scalars['Int']['output'];
};

/** An auto-generated type which holds one SearchResult and a cursor during pagination. */
export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SearchResultEdge. */
  node: SearchResult;
};

/** Specifies the type of resources to be returned from a search. */
export enum SearchResultType {
  /** An article. */
  Article = 'ARTICLE',
  /** A balance transaction. */
  BalanceTransaction = 'BALANCE_TRANSACTION',
  /** A blog. */
  Blog = 'BLOG',
  Collection = 'COLLECTION',
  Customer = 'CUSTOMER',
  /** A code discount redeem code. */
  DiscountRedeemCode = 'DISCOUNT_REDEEM_CODE',
  DraftOrder = 'DRAFT_ORDER',
  /** A file. */
  File = 'FILE',
  /** An inventory transfer. */
  InventoryTransfer = 'INVENTORY_TRANSFER',
  Order = 'ORDER',
  /** A page. */
  Page = 'PAGE',
  PriceRule = 'PRICE_RULE',
  Product = 'PRODUCT',
  /** A URL redirect. */
  UrlRedirect = 'URL_REDIRECT'
}

/**
 * A group of [customers](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) that meet specific criteria defined through [ShopifyQL query](https://shopify.dev/docs/api/shopifyql/segment-query-language-reference) conditions. Common use cases for segments include customer analytics, targeted marketing campaigns, and automated discount eligibility.
 *
 * The segment's [`query`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment#field-query) field contains ShopifyQL conditions that determine membership, such as purchase history, location, or engagement patterns. Tracks when the segment was created with [`creationDate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment#field-creationDate) and when it was last modified with [`lastEditDate`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Segment#field-lastEditDate).
 */
export type Segment = Node & {
  __typename?: 'Segment';
  /** The date and time when the segment was added to the store. */
  creationDate: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The date and time when the segment was last updated. */
  lastEditDate: Scalars['DateTime']['output'];
  /** The name of the segment. */
  name: Scalars['String']['output'];
  /** A precise definition of the segment. The definition is composed of a combination of conditions on facts about customers. */
  query: Scalars['String']['output'];
};

/** A filter that takes a value that's associated with an object. For example, the `tags` field is associated with the [`Customer`](/api/admin-graphql/latest/objects/Customer) object. */
export type SegmentAssociationFilter = SegmentFilter & {
  __typename?: 'SegmentAssociationFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** The statistics of a given attribute. */
export type SegmentAttributeStatistics = {
  __typename?: 'SegmentAttributeStatistics';
  /** The average of a given attribute. */
  average: Scalars['Float']['output'];
  /** The sum of a given attribute. */
  sum: Scalars['Float']['output'];
};

/** A filter with a Boolean value that's been added to a segment query. */
export type SegmentBooleanFilter = SegmentFilter & {
  __typename?: 'SegmentBooleanFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple Segments. */
export type SegmentConnection = {
  __typename?: 'SegmentConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SegmentEdge>;
  /** A list of nodes that are contained in SegmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Segment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `segmentCreate` mutation. */
export type SegmentCreatePayload = {
  __typename?: 'SegmentCreatePayload';
  /** The newly created segment. */
  segment?: Maybe<Segment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A filter with a date value that's been added to a segment query. */
export type SegmentDateFilter = SegmentFilter & {
  __typename?: 'SegmentDateFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** Return type for `segmentDelete` mutation. */
export type SegmentDeletePayload = {
  __typename?: 'SegmentDeletePayload';
  /** ID of the deleted segment. */
  deletedSegmentId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one Segment and a cursor during pagination. */
export type SegmentEdge = {
  __typename?: 'SegmentEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SegmentEdge. */
  node: Segment;
};

/**
 * Categorical filter options for building customer segments using predefined value sets like countries, subscription statuses, or order frequencies.
 *
 * For example, a "Customer Location" enum filter provides options like "United States," "Canada," and "United Kingdom."
 *
 * Use this object to:
 * - Access available categorical filter options
 * - Understand filter capabilities and constraints
 * - Build user interfaces for segment creation
 *
 * Includes localized display names, indicates whether multiple values can be selected, and provides technical query names for API operations.
 */
export type SegmentEnumFilter = SegmentFilter & {
  __typename?: 'SegmentEnumFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** A filter that's used to segment customers based on the date that an event occured. For example, the `product_bought` event filter allows you to segment customers based on what products they've bought. */
export type SegmentEventFilter = SegmentFilter & {
  __typename?: 'SegmentEventFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The parameters for an event segment filter. */
  parameters: Array<SegmentEventFilterParameter>;
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
  /** The return value type for an event segment filter. */
  returnValueType: Scalars['String']['output'];
};

/** The parameters for an event segment filter. */
export type SegmentEventFilterParameter = {
  __typename?: 'SegmentEventFilterParameter';
  /** Whether the parameter accepts a list of values. */
  acceptsMultipleValues: Scalars['Boolean']['output'];
  /** The localized description of the parameter. */
  localizedDescription: Scalars['String']['output'];
  /** The localized name of the parameter. */
  localizedName: Scalars['String']['output'];
  /** The parameter maximum value range. */
  maxRange?: Maybe<Scalars['Float']['output']>;
  /** The parameter minimum value range. */
  minRange?: Maybe<Scalars['Float']['output']>;
  /** Whether the parameter is optional. */
  optional: Scalars['Boolean']['output'];
  /** The type of the parameter. */
  parameterType: Scalars['String']['output'];
  /** The query name of the parameter. */
  queryName: Scalars['String']['output'];
};

/** The filters used in segment queries associated with a shop. */
export type SegmentFilter = {
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple SegmentFilters. */
export type SegmentFilterConnection = {
  __typename?: 'SegmentFilterConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SegmentFilterEdge>;
  /** A list of nodes that are contained in SegmentFilterEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SegmentFilter>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentFilter and a cursor during pagination. */
export type SegmentFilterEdge = {
  __typename?: 'SegmentFilterEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SegmentFilterEdge. */
  node: SegmentFilter;
};

/** A filter with a double-precision, floating-point value that's been added to a segment query. */
export type SegmentFloatFilter = SegmentFilter & {
  __typename?: 'SegmentFloatFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** The maximum range a filter can have. */
  maxRange?: Maybe<Scalars['Float']['output']>;
  /** The minimum range a filter can have. */
  minRange?: Maybe<Scalars['Float']['output']>;
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** A filter with an integer that's been added to a segment query. */
export type SegmentIntegerFilter = SegmentFilter & {
  __typename?: 'SegmentIntegerFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** The maximum range a filter can have. */
  maxRange?: Maybe<Scalars['Float']['output']>;
  /** The minimum range a filter can have. */
  minRange?: Maybe<Scalars['Float']['output']>;
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** The response type for the `segmentMembership` object. */
export type SegmentMembership = {
  __typename?: 'SegmentMembership';
  /** A Boolean that indicates whether or not the customer in the query is a member of the segment, which is identified using the `segmentId`. */
  isMember: Scalars['Boolean']['output'];
  /** A `segmentId` that's used for testing membership. */
  segmentId: Scalars['ID']['output'];
};

/** A list of maps that contain `segmentId` IDs and `isMember` Booleans. The maps represent segment memberships. */
export type SegmentMembershipResponse = {
  __typename?: 'SegmentMembershipResponse';
  /** The membership status for the given list of segments. */
  memberships: Array<SegmentMembership>;
};

/**
 * A segment and its corresponding saved search.
 * For example, you can use `SegmentMigration` to retrieve the segment ID that corresponds to a saved search ID.
 */
export type SegmentMigration = {
  __typename?: 'SegmentMigration';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The ID of the saved search. */
  savedSearchId: Scalars['ID']['output'];
  /** The ID of the segment. */
  segmentId?: Maybe<Scalars['ID']['output']>;
};

/** An auto-generated type for paginating through multiple SegmentMigrations. */
export type SegmentMigrationConnection = {
  __typename?: 'SegmentMigrationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SegmentMigrationEdge>;
  /** A list of nodes that are contained in SegmentMigrationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SegmentMigration>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentMigration and a cursor during pagination. */
export type SegmentMigrationEdge = {
  __typename?: 'SegmentMigrationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SegmentMigrationEdge. */
  node: SegmentMigration;
};

/** The set of valid sort keys for the Segment query. */
export enum SegmentSortKeys {
  /** Sort by the `creation_date` value. */
  CreationDate = 'CREATION_DATE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `last_edit_date` value. */
  LastEditDate = 'LAST_EDIT_DATE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE'
}

/** The statistics of a given segment. */
export type SegmentStatistics = {
  __typename?: 'SegmentStatistics';
  /** The statistics of a given attribute. */
  attributeStatistics: SegmentAttributeStatistics;
};


/** The statistics of a given segment. */
export type SegmentStatisticsAttributeStatisticsArgs = {
  attributeName: Scalars['String']['input'];
};

/** A filter with a string that's been added to a segment query. */
export type SegmentStringFilter = SegmentFilter & {
  __typename?: 'SegmentStringFilter';
  /** The localized name of the filter. */
  localizedName: Scalars['String']['output'];
  /** Whether a file can have multiple values for a single customer. */
  multiValue: Scalars['Boolean']['output'];
  /** The query name of the filter. */
  queryName: Scalars['String']['output'];
};

/** Return type for `segmentUpdate` mutation. */
export type SegmentUpdatePayload = {
  __typename?: 'SegmentUpdatePayload';
  /** The updated segment. */
  segment?: Maybe<Segment>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/**
 * A list of suggested values associated with an individual segment. A
 * segment is a group of members, such as customers, that meet specific
 * criteria.
 */
export type SegmentValue = {
  __typename?: 'SegmentValue';
  /** The localized version of the value's name. This name is displayed to the merchant. */
  localizedValue: Scalars['String']['output'];
  /** The name of the query associated with the suggestion. */
  queryName: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple SegmentValues. */
export type SegmentValueConnection = {
  __typename?: 'SegmentValueConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SegmentValueEdge>;
  /** A list of nodes that are contained in SegmentValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SegmentValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentValue and a cursor during pagination. */
export type SegmentValueEdge = {
  __typename?: 'SegmentValueEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SegmentValueEdge. */
  node: SegmentValue;
};

/**
 * Properties used by customers to select a product variant.
 * Products can have multiple options, like different sizes or colors.
 */
export type SelectedOption = {
  __typename?: 'SelectedOption';
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** The product option’s value object. */
  optionValue: ProductOptionValue;
  /** The product option’s value. */
  value: Scalars['String']['output'];
};

/** The input fields for the selected variant option of the combined listing. */
export type SelectedVariantOptionInput = {
  /** The metaobject value of the linked metafield. */
  linkedMetafieldValue?: InputMaybe<Scalars['String']['input']>;
  /** The name of the parent product's option. */
  name: Scalars['String']['input'];
  /** The selected option value of the parent product's option. */
  value: Scalars['String']['input'];
};

/**
 * How a product can be sold and purchased through recurring billing or deferred purchase options. Defines the specific terms for subscriptions, pre-orders, or try-before-you-buy offers, including when to bill customers, when to fulfill orders, and what pricing adjustments to apply.
 *
 * Each selling plan has billing, delivery, and pricing policies that control the purchase experience. The plan's [`options`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.options) and [`category`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.category) help merchants organize and report on different selling strategies. Plans are grouped within a [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) that associates them with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * > Caution:
 * > Selling plans and associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 *
 * Learn more about [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan).
 */
export type SellingPlan = HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & {
  __typename?: 'SellingPlan';
  /** A selling plan policy which describes the recurring billing details. */
  billingPolicy: SellingPlanBillingPolicy;
  /** The category used to classify the selling plan for reporting purposes. */
  category?: Maybe<SellingPlanCategory>;
  /** The date and time when the selling plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A selling plan policy which describes the delivery details. */
  deliveryPolicy: SellingPlanDeliveryPolicy;
  /** Buyer facing string which describes the selling plan commitment. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** When to reserve inventory for a selling plan. */
  inventoryPolicy?: Maybe<SellingPlanInventoryPolicy>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /**
   * A customer-facing description of the selling plan.
   *
   * If your store supports multiple currencies, then don't include country-specific pricing content, such as "Buy monthly, get 10$ CAD off". This field won't be converted to reflect different currencies.
   */
  name: Scalars['String']['output'];
  /** The values of all options available on the selling plan. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  options: Array<Scalars['String']['output']>;
  /** Relative position of the selling plan for display. A lower position will be displayed before a higher position. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Selling plan pricing details. */
  pricingPolicies: Array<SellingPlanPricingPolicy>;
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/**
 * How a product can be sold and purchased through recurring billing or deferred purchase options. Defines the specific terms for subscriptions, pre-orders, or try-before-you-buy offers, including when to bill customers, when to fulfill orders, and what pricing adjustments to apply.
 *
 * Each selling plan has billing, delivery, and pricing policies that control the purchase experience. The plan's [`options`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.options) and [`category`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.category) help merchants organize and report on different selling strategies. Plans are grouped within a [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) that associates them with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * > Caution:
 * > Selling plans and associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 *
 * Learn more about [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan).
 */
export type SellingPlanMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * How a product can be sold and purchased through recurring billing or deferred purchase options. Defines the specific terms for subscriptions, pre-orders, or try-before-you-buy offers, including when to bill customers, when to fulfill orders, and what pricing adjustments to apply.
 *
 * Each selling plan has billing, delivery, and pricing policies that control the purchase experience. The plan's [`options`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.options) and [`category`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.category) help merchants organize and report on different selling strategies. Plans are grouped within a [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) that associates them with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * > Caution:
 * > Selling plans and associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 *
 * Learn more about [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan).
 */
export type SellingPlanMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * How a product can be sold and purchased through recurring billing or deferred purchase options. Defines the specific terms for subscriptions, pre-orders, or try-before-you-buy offers, including when to bill customers, when to fulfill orders, and what pricing adjustments to apply.
 *
 * Each selling plan has billing, delivery, and pricing policies that control the purchase experience. The plan's [`options`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.options) and [`category`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.category) help merchants organize and report on different selling strategies. Plans are grouped within a [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) that associates them with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * > Caution:
 * > Selling plans and associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 *
 * Learn more about [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan).
 */
export type SellingPlanMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * How a product can be sold and purchased through recurring billing or deferred purchase options. Defines the specific terms for subscriptions, pre-orders, or try-before-you-buy offers, including when to bill customers, when to fulfill orders, and what pricing adjustments to apply.
 *
 * Each selling plan has billing, delivery, and pricing policies that control the purchase experience. The plan's [`options`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.options) and [`category`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan#field-SellingPlan.fields.category) help merchants organize and report on different selling strategies. Plans are grouped within a [`SellingPlanGroup`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlanGroup) that associates them with [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects.
 *
 * > Caution:
 * > Selling plans and associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 *
 * Learn more about [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan).
 */
export type SellingPlanTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Specifies the date when delivery or fulfillment is completed by a merchant for a given time cycle. You can also
 * define a cutoff for which customers are eligible to enter this cycle and the desired behavior for customers who
 * start their subscription inside the cutoff period.
 *
 * Some example scenarios where anchors can be useful to implement advanced delivery behavior:
 * - A merchant starts fulfillment on a specific date every month.
 * - A merchant wants to bill the 1st of every quarter.
 * - A customer expects their delivery every Tuesday.
 *
 * For more details, see [About Selling Plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans#anchors).
 */
export type SellingPlanAnchor = {
  __typename?: 'SellingPlanAnchor';
  /**
   * The cutoff day for the anchor. Specifies a buffer period before the anchor date for orders to be included in a
   * delivery or fulfillment cycle.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` is MONTHDAY, then the value must be between 1-31.
   *
   * If `type` is YEARDAY, then the value must be `null`.
   */
  cutoffDay?: Maybe<Scalars['Int']['output']>;
  /**
   * The day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` isn't WEEKDAY, then the value must be between 1-31.
   */
  day: Scalars['Int']['output'];
  /**
   * The month of the anchor. If type is different than YEARDAY, then the value must
   * be `null` or between 1-12.
   */
  month?: Maybe<Scalars['Int']['output']>;
  /** Represents the anchor type, it can be one one of WEEKDAY, MONTHDAY, YEARDAY. */
  type: SellingPlanAnchorType;
};

/** The input fields required to create or update a selling plan anchor. */
export type SellingPlanAnchorInput = {
  /**
   * The cutoff day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` is MONTHDAY, then the value must be between 1-31.
   *
   * If `type` is YEARDAY, then the value must be `null`.
   *
   * This field should only be set if the cutoff field for the delivery policy is `null`.
   */
  cutoffDay?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` isn't WEEKDAY, then the value must be between 1-31.
   */
  day?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The month of the anchor. If type is different than YEARDAY, then the value must
   * be `null` or between 1-12.
   */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Represents the anchor type, must be one of WEEKDAY, MONTHDAY, YEARDAY. */
  type?: InputMaybe<SellingPlanAnchorType>;
};

/** Represents the anchor type. */
export enum SellingPlanAnchorType {
  /** Which day of the month, between 1-31. */
  Monthday = 'MONTHDAY',
  /** Which day of the week, between 1-7. */
  Weekday = 'WEEKDAY',
  /** Which days of the month and year, month between 1-12, and day between 1-31. */
  Yearday = 'YEARDAY'
}

/**
 * Represents the billing frequency associated to the selling plan (for example, bill every week, or bill every
 * three months). The selling plan billing policy and associated records (selling plan groups, selling plans, pricing
 * policies, and delivery policy) are deleted 48 hours after a merchant uninstalls their subscriptions app.
 * We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanBillingPolicy = SellingPlanFixedBillingPolicy | SellingPlanRecurringBillingPolicy;

/** The input fields that are required to create or update a billing policy type. */
export type SellingPlanBillingPolicyInput = {
  /** The fixed billing policy details. */
  fixed?: InputMaybe<SellingPlanFixedBillingPolicyInput>;
  /** The recurring billing policy details. */
  recurring?: InputMaybe<SellingPlanRecurringBillingPolicyInput>;
};

/**
 * The category of the selling plan. For the `OTHER` category,
 *          you must fill out our [request form](https://docs.google.com/forms/d/e/1FAIpQLSeU18Xmw0Q61V8wdH-dfGafFqIBfRchQKUO8WAF3yJTvgyyZQ/viewform),
 *          where we'll review your request for a new purchase option.
 */
export enum SellingPlanCategory {
  /** The selling plan is for anything not in one of the other categories. */
  Other = 'OTHER',
  /** The selling plan is for pre-orders. */
  PreOrder = 'PRE_ORDER',
  /** The selling plan is for subscriptions. */
  Subscription = 'SUBSCRIPTION',
  /** The selling plan is for try before you buy purchases. */
  TryBeforeYouBuy = 'TRY_BEFORE_YOU_BUY'
}

/** The amount charged at checkout when the full amount isn't charged at checkout. */
export type SellingPlanCheckoutCharge = {
  __typename?: 'SellingPlanCheckoutCharge';
  /** The charge type for the checkout charge. */
  type: SellingPlanCheckoutChargeType;
  /** The charge value for the checkout charge. */
  value: SellingPlanCheckoutChargeValue;
};

/** The input fields that are required to create or update a checkout charge. */
export type SellingPlanCheckoutChargeInput = {
  /** The checkout charge type defined by the policy. */
  type?: InputMaybe<SellingPlanCheckoutChargeType>;
  /** The checkout charge value defined by the policy. */
  value?: InputMaybe<SellingPlanCheckoutChargeValueInput>;
};

/** The percentage value of the price used for checkout charge. */
export type SellingPlanCheckoutChargePercentageValue = {
  __typename?: 'SellingPlanCheckoutChargePercentageValue';
  /** The percentage value of the price used for checkout charge. */
  percentage: Scalars['Float']['output'];
};

/** The checkout charge when the full amount isn't charged at checkout. */
export enum SellingPlanCheckoutChargeType {
  /** The checkout charge is a percentage of the product or variant price. */
  Percentage = 'PERCENTAGE',
  /** The checkout charge is a fixed price amount. */
  Price = 'PRICE'
}

/** The portion of the price to be charged at checkout. */
export type SellingPlanCheckoutChargeValue = MoneyV2 | SellingPlanCheckoutChargePercentageValue;

/** The input fields required to create or update an checkout charge value. */
export type SellingPlanCheckoutChargeValueInput = {
  /** The fixed value for an checkout charge. */
  fixedValue?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage value. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** An auto-generated type for paginating through multiple SellingPlans. */
export type SellingPlanConnection = {
  __typename?: 'SellingPlanConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SellingPlanEdge>;
  /** A list of nodes that are contained in SellingPlanEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SellingPlan>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/**
 * Represents the delivery frequency associated to the selling plan (for example, deliver every month, or deliver
 * every other week). The selling plan delivery policy and associated records (selling plan groups, selling plans,
 * pricing policies, and billing policy) are deleted 48 hours after a merchant uninstalls their subscriptions app.
 * We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanDeliveryPolicy = SellingPlanFixedDeliveryPolicy | SellingPlanRecurringDeliveryPolicy;

/** The input fields that are required to create or update a delivery policy. */
export type SellingPlanDeliveryPolicyInput = {
  /** The fixed delivery policy details. */
  fixed?: InputMaybe<SellingPlanFixedDeliveryPolicyInput>;
  /** The recurring delivery policy details. */
  recurring?: InputMaybe<SellingPlanRecurringDeliveryPolicyInput>;
};

/** An auto-generated type which holds one SellingPlan and a cursor during pagination. */
export type SellingPlanEdge = {
  __typename?: 'SellingPlanEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanEdge. */
  node: SellingPlan;
};

/**
 * The fixed selling plan billing policy defines how much of the price of the product will be billed to customer
 * at checkout. If there is an outstanding balance, it determines when it will be paid.
 */
export type SellingPlanFixedBillingPolicy = {
  __typename?: 'SellingPlanFixedBillingPolicy';
  /** The checkout charge when the full amount isn't charged at checkout. */
  checkoutCharge: SellingPlanCheckoutCharge;
  /** The exact time when to capture the full payment. */
  remainingBalanceChargeExactTime?: Maybe<Scalars['DateTime']['output']>;
  /** The period after remaining_balance_charge_trigger, before capturing the full payment. Expressed as an ISO8601 duration. */
  remainingBalanceChargeTimeAfterCheckout?: Maybe<Scalars['String']['output']>;
  /** When to capture payment for amount due. */
  remainingBalanceChargeTrigger: SellingPlanRemainingBalanceChargeTrigger;
};

/** The input fields required to create or update a fixed billing policy. */
export type SellingPlanFixedBillingPolicyInput = {
  /** The checkout charge policy for the selling plan. */
  checkoutCharge?: InputMaybe<SellingPlanCheckoutChargeInput>;
  /** The date and time to capture the full payment. */
  remainingBalanceChargeExactTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The period after capturing the payment for the amount due (`remainingBalanceChargeTrigger`), and before capturing the full payment. Expressed as an ISO8601 duration. */
  remainingBalanceChargeTimeAfterCheckout?: InputMaybe<Scalars['String']['input']>;
  /** When to capture the payment for the amount due. */
  remainingBalanceChargeTrigger?: InputMaybe<SellingPlanRemainingBalanceChargeTrigger>;
};

/** Represents a fixed selling plan delivery policy. */
export type SellingPlanFixedDeliveryPolicy = {
  __typename?: 'SellingPlanFixedDeliveryPolicy';
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors: Array<SellingPlanAnchor>;
  /** A buffer period for orders to be included in next fulfillment anchor. */
  cutoff?: Maybe<Scalars['Int']['output']>;
  /** The date and time when the fulfillment should trigger. */
  fulfillmentExactTime?: Maybe<Scalars['DateTime']['output']>;
  /** What triggers the fulfillment. The value must be one of ANCHOR, ASAP, EXACT_TIME, or UNKNOWN. */
  fulfillmentTrigger: SellingPlanFulfillmentTrigger;
  /**
   * Whether the delivery policy is merchant or buyer-centric.
   * Buyer-centric delivery policies state the time when the buyer will receive the goods.
   * Merchant-centric delivery policies state the time when the fulfillment should be started.
   * Currently, only merchant-centric delivery policies are supported.
   */
  intent: SellingPlanFixedDeliveryPolicyIntent;
  /** The fulfillment or delivery behavior of the first fulfillment when the order is placed before the anchor. The default value for this field is `ASAP`. */
  preAnchorBehavior: SellingPlanFixedDeliveryPolicyPreAnchorBehavior;
};

/** The input fields required to create or update a fixed delivery policy. */
export type SellingPlanFixedDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors?: InputMaybe<Array<SellingPlanAnchorInput>>;
  /** Number of days which represent a buffer period for orders to be included in a cycle. */
  cutoff?: InputMaybe<Scalars['Int']['input']>;
  /** The date and time when the fulfillment should trigger. */
  fulfillmentExactTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** What triggers the fulfillment. */
  fulfillmentTrigger?: InputMaybe<SellingPlanFulfillmentTrigger>;
  /** Whether the delivery policy is merchant or buyer-centric. */
  intent?: InputMaybe<SellingPlanFixedDeliveryPolicyIntent>;
  /** The pre-anchor behavior. */
  preAnchorBehavior?: InputMaybe<SellingPlanFixedDeliveryPolicyPreAnchorBehavior>;
};

/** Possible intentions of a Delivery Policy. */
export enum SellingPlanFixedDeliveryPolicyIntent {
  /** A merchant-centric delivery policy. Mark this delivery policy to define when the merchant should start fulfillment. */
  FulfillmentBegin = 'FULFILLMENT_BEGIN'
}

/** The fulfillment or delivery behavior of the first fulfillment when the orderis placed before the anchor. */
export enum SellingPlanFixedDeliveryPolicyPreAnchorBehavior {
  /** Orders placed can be fulfilled / delivered immediately. Orders placed inside a cutoff can be fulfilled / delivered at the next anchor. */
  Asap = 'ASAP',
  /**
   * Orders placed can be fulfilled / delivered at the next anchor date.
   * Orders placed inside a cutoff will skip the next anchor and can be fulfilled /
   * delivered at the following anchor.
   */
  Next = 'NEXT'
}

/**
 * Represents the pricing policy of a subscription or deferred purchase option selling plan.
 * The selling plan fixed pricing policy works with the billing and delivery policy
 * to determine the final price. Discounts are divided among fulfillments.
 * For example, a subscription with a $10 discount and two deliveries will have a $5
 * discount applied to each delivery.
 */
export type SellingPlanFixedPricingPolicy = SellingPlanPricingPolicyBase & {
  __typename?: 'SellingPlanFixedPricingPolicy';
  /** The price adjustment type. */
  adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** The date and time when the fixed selling plan pricing policy was created. */
  createdAt: Scalars['DateTime']['output'];
};

/** The input fields required to create or update a fixed selling plan pricing policy. */
export type SellingPlanFixedPricingPolicyInput = {
  /** Price adjustment type defined by the policy. */
  adjustmentType?: InputMaybe<SellingPlanPricingPolicyAdjustmentType>;
  /** Price adjustment value defined by the policy. */
  adjustmentValue?: InputMaybe<SellingPlanPricingPolicyValueInput>;
  /** ID of the pricing policy. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Describes what triggers fulfillment. */
export enum SellingPlanFulfillmentTrigger {
  /** Use the anchor values to calculate fulfillment date. */
  Anchor = 'ANCHOR',
  /** As soon as possible. */
  Asap = 'ASAP',
  /** At an exact time defined by the fulfillment_exact_time field. */
  ExactTime = 'EXACT_TIME',
  /** Unknown. Usually to be determined in the future. */
  Unknown = 'UNKNOWN'
}

/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroup = HasPublishedTranslations & Node & {
  __typename?: 'SellingPlanGroup';
  /** The ID for app, exposed in Liquid and product JSON. */
  appId?: Maybe<Scalars['String']['output']>;
  /** Whether the given product is directly associated to the selling plan group. */
  appliesToProduct: Scalars['Boolean']['output'];
  /** Whether the given product variant is directly associated to the selling plan group. */
  appliesToProductVariant: Scalars['Boolean']['output'];
  /** Whether any of the product variants of the given product are associated to the selling plan group. */
  appliesToProductVariants: Scalars['Boolean']['output'];
  /** The date and time when the selling plan group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The merchant-facing description of the selling plan group. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The merchant-facing label of the selling plan group. */
  merchantCode: Scalars['String']['output'];
  /** The buyer-facing label of the selling plan group. */
  name: Scalars['String']['output'];
  /** The values of all options available on the selling plan group. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  options: Array<Scalars['String']['output']>;
  /** The relative position of the selling plan group for display. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Product variants associated to the selling plan group. */
  productVariants: ProductVariantConnection;
  /** A count of product variants associated to the selling plan group. */
  productVariantsCount?: Maybe<Count>;
  /** Products associated to the selling plan group. */
  products: ProductConnection;
  /** A count of products associated to the selling plan group. */
  productsCount?: Maybe<Count>;
  /** Selling plans associated to the selling plan group. */
  sellingPlans: SellingPlanConnection;
  /** A summary of the policies associated to the selling plan group. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductArgs = {
  productId: Scalars['ID']['input'];
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductVariantArgs = {
  productVariantId: Scalars['ID']['input'];
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductVariantsArgs = {
  productId: Scalars['ID']['input'];
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupProductVariantsCountArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupSellingPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A selling method that defines how products can be sold through purchase options like subscriptions, pre-orders, or try-before-you-buy. Groups one or more [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan) objects that share the same selling method and options.
 *
 * The group provides buyer-facing labels and merchant-facing descriptions for the selling method. Associates [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) objects with selling plan groups to offer them through these purchase options.
 *
 * > Caution:
 * > Selling plan groups and their associated records are automatically deleted 48 hours after a merchant uninstalls the [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) that created them. Back up these records if you need to restore them later.
 */
export type SellingPlanGroupTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `sellingPlanGroupAddProductVariants` mutation. */
export type SellingPlanGroupAddProductVariantsPayload = {
  __typename?: 'SellingPlanGroupAddProductVariantsPayload';
  /** The updated selling plan group. */
  sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupAddProducts` mutation. */
export type SellingPlanGroupAddProductsPayload = {
  __typename?: 'SellingPlanGroupAddProductsPayload';
  /** The updated selling plan group. */
  sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** An auto-generated type for paginating through multiple SellingPlanGroups. */
export type SellingPlanGroupConnection = {
  __typename?: 'SellingPlanGroupConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SellingPlanGroupEdge>;
  /** A list of nodes that are contained in SellingPlanGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SellingPlanGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `sellingPlanGroupCreate` mutation. */
export type SellingPlanGroupCreatePayload = {
  __typename?: 'SellingPlanGroupCreatePayload';
  /** The created selling plan group object. */
  sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupDelete` mutation. */
export type SellingPlanGroupDeletePayload = {
  __typename?: 'SellingPlanGroupDeletePayload';
  /** The ID of the deleted selling plan group object. */
  deletedSellingPlanGroupId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** An auto-generated type which holds one SellingPlanGroup and a cursor during pagination. */
export type SellingPlanGroupEdge = {
  __typename?: 'SellingPlanGroupEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanGroupEdge. */
  node: SellingPlanGroup;
};

/** The input fields required to create or update a selling plan group. */
export type SellingPlanGroupInput = {
  /** ID for app, exposed in Liquid and product JSON. */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Merchant facing description of the selling plan group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Merchant facing label of the selling plan group. */
  merchantCode?: InputMaybe<Scalars['String']['input']>;
  /** Buyer facing label of the selling plan group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The values of all options available on the selling plan group. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Relative value for display purposes of the selling plan group. A lower position will be displayed before a higher one. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** List of selling plans to create. */
  sellingPlansToCreate?: InputMaybe<Array<SellingPlanInput>>;
  /** List of selling plans ids to delete. */
  sellingPlansToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of selling plans to update. */
  sellingPlansToUpdate?: InputMaybe<Array<SellingPlanInput>>;
};

/** Return type for `sellingPlanGroupRemoveProductVariants` mutation. */
export type SellingPlanGroupRemoveProductVariantsPayload = {
  __typename?: 'SellingPlanGroupRemoveProductVariantsPayload';
  /** The removed product variant ids. */
  removedProductVariantIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupRemoveProducts` mutation. */
export type SellingPlanGroupRemoveProductsPayload = {
  __typename?: 'SellingPlanGroupRemoveProductsPayload';
  /** The removed product ids. */
  removedProductIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** The input fields for resource association with a Selling Plan Group. */
export type SellingPlanGroupResourceInput = {
  /** The IDs of the Products to add to the Selling Plan Group. */
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs of the Variants to add to the Selling Plan Group. */
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The set of valid sort keys for the SellingPlanGroup query. */
export enum SellingPlanGroupSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Return type for `sellingPlanGroupUpdate` mutation. */
export type SellingPlanGroupUpdatePayload = {
  __typename?: 'SellingPlanGroupUpdatePayload';
  /** The IDs of the deleted Subscription Plans. */
  deletedSellingPlanIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The updated Selling Plan Group. */
  sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SellingPlanGroupUserError>;
};

/** Represents a selling plan group custom error. */
export type SellingPlanGroupUserError = DisplayableError & {
  __typename?: 'SellingPlanGroupUserError';
  /** The error code. */
  code?: Maybe<SellingPlanGroupUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `SellingPlanGroupUserError`. */
export enum SellingPlanGroupUserErrorCode {
  /** Billing and delivery policy types must be the same. */
  BillingAndDeliveryPolicyTypesMustBeTheSame = 'BILLING_AND_DELIVERY_POLICY_TYPES_MUST_BE_THE_SAME',
  /** Billing policy's interval is too large. */
  BillingPolicyIntervalTooLarge = 'BILLING_POLICY_INTERVAL_TOO_LARGE',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** A fixed billing policy's checkout charge value and type must match. */
  CheckoutChargeValueAndTypeMustMatch = 'CHECKOUT_CHARGE_VALUE_AND_TYPE_MUST_MATCH',
  /** Delivery policy's interval is too large. */
  DeliveryPolicyIntervalTooLarge = 'DELIVERY_POLICY_INTERVAL_TOO_LARGE',
  /** The input value should be equal to the value allowed. */
  EqualTo = 'EQUAL_TO',
  /** Could not add the resource to the selling plan group. */
  ErrorAddingResourceToGroup = 'ERROR_ADDING_RESOURCE_TO_GROUP',
  /** A fixed billing policy's fulfillment_exact_time must not be present when the fulfillment_trigger isn't EXACT_TIME. */
  FulfillmentExactTimeNotAllowed = 'FULFILLMENT_EXACT_TIME_NOT_ALLOWED',
  /** A fixed billing policy's fulfillment_exact_time can't be blank when the fulfillment_trigger is EXACT_TIME. */
  FulfillmentExactTimeRequired = 'FULFILLMENT_EXACT_TIME_REQUIRED',
  /** The input value should be greater than the minimum allowed value. */
  GreaterThan = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Selling plan group could not be deleted. */
  GroupCouldNotBeDeleted = 'GROUP_COULD_NOT_BE_DELETED',
  /** Selling plan group does not exist. */
  GroupDoesNotExist = 'GROUP_DOES_NOT_EXIST',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The input submitted is invalid. */
  InvalidInput = 'INVALID_INPUT',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** A fixed delivery policy with an ANCHOR fulfillment_trigger must have exactly one anchor. */
  MustHaveExactlyOneAnchor = 'MUST_HAVE_EXACTLY_ONE_ANCHOR',
  /** The input value is not a number. */
  NotANumber = 'NOT_A_NUMBER',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** Only one billing policy type can be defined. */
  OnlyNeedOneBillingPolicyType = 'ONLY_NEED_ONE_BILLING_POLICY_TYPE',
  /** A fixed billing policy's checkout charge can have at most one value. */
  OnlyNeedOneCheckoutChargeValue = 'ONLY_NEED_ONE_CHECKOUT_CHARGE_VALUE',
  /** Only one delivery policy type can be defined. */
  OnlyNeedOneDeliveryPolicyType = 'ONLY_NEED_ONE_DELIVERY_POLICY_TYPE',
  /** Only one pricing policy type can be defined. */
  OnlyNeedOnePricingPolicyType = 'ONLY_NEED_ONE_PRICING_POLICY_TYPE',
  /** Only one pricing policy adjustment value type can be defined. */
  OnlyNeedOnePricingPolicyValue = 'ONLY_NEED_ONE_PRICING_POLICY_VALUE',
  /** A selling plan can't have both fixed and recurring billing policies. */
  OnlyOneOfFixedOrRecurringBilling = 'ONLY_ONE_OF_FIXED_OR_RECURRING_BILLING',
  /** A selling plan can't have both fixed and recurring delivery policies. */
  OnlyOneOfFixedOrRecurringDelivery = 'ONLY_ONE_OF_FIXED_OR_RECURRING_DELIVERY',
  /** Selling plan does not exist. */
  PlanDoesNotExist = 'PLAN_DOES_NOT_EXIST',
  /** Selling plan ID must be specified to update. */
  PlanIdMustBeSpecifiedToUpdate = 'PLAN_ID_MUST_BE_SPECIFIED_TO_UPDATE',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** Pricing policy's adjustment value and adjustment type must match. */
  PricingPolicyAdjustmentValueAndTypeMustMatch = 'PRICING_POLICY_ADJUSTMENT_VALUE_AND_TYPE_MUST_MATCH',
  /** Product does not exist. */
  ProductDoesNotExist = 'PRODUCT_DOES_NOT_EXIST',
  /** Product variant does not exist. */
  ProductVariantDoesNotExist = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** A fixed billing policy's remaining_balance_charge_exact_time must not be present when the remaining_balance_charge_trigger isn't EXACT_TIME. */
  RemainingBalanceChargeExactTimeNotAllowed = 'REMAINING_BALANCE_CHARGE_EXACT_TIME_NOT_ALLOWED',
  /** A fixed billing policy's remaining_balance_charge_exact_time can't be blank when the remaining_balance_charge_trigger is EXACT_TIME. */
  RemainingBalanceChargeExactTimeRequired = 'REMAINING_BALANCE_CHARGE_EXACT_TIME_REQUIRED',
  /** A fixed billing policy's remaining_balance_charge_time_after_checkout must be present and greater than zero when the remaining_balance_charge_trigger is TIME_AFTER_CHECKOUT. */
  RemainingBalanceChargeTimeAfterCheckoutMustBeGreaterThanZero = 'REMAINING_BALANCE_CHARGE_TIME_AFTER_CHECKOUT_MUST_BE_GREATER_THAN_ZERO',
  /** A fixed billing policy's remaining_balance_charge_trigger can't be NO_REMAINING_BALANCE when the checkout_charge_type is PERCENTAGE and checkout_charge_value is less than 100. */
  RemainingBalanceChargeTriggerNoRemainingBalanceOnPartialPercentageCheckoutCharge = 'REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PARTIAL_PERCENTAGE_CHECKOUT_CHARGE',
  /** A fixed billing policy's remaining_balance_charge_trigger can't be NO_REMAINING_BALANCE when the checkout_charge_type is PRICE. */
  RemainingBalanceChargeTriggerNoRemainingBalanceOnPriceCheckoutCharge = 'REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PRICE_CHECKOUT_CHARGE',
  /** A fixed billing policy's remaining_balance_charge_trigger must be NO_REMAINING_BALANCE when the checkout_charge_type is PERCENTAGE and checkout_charge_value is 100. */
  RemainingBalanceChargeTriggerOnFullCheckout = 'REMAINING_BALANCE_CHARGE_TRIGGER_ON_FULL_CHECKOUT',
  /** The selling plan list provided contains 1 or more invalid IDs. */
  ResourceListContainsInvalidIds = 'RESOURCE_LIST_CONTAINS_INVALID_IDS',
  /** The selling plan group list provided is empty. */
  ResourceListIsEmpty = 'RESOURCE_LIST_IS_EMPTY',
  /** A fixed delivery policy's anchors must not be present when the fulfillment_trigger isn't ANCHOR. */
  SellingPlanAnchorsNotAllowed = 'SELLING_PLAN_ANCHORS_NOT_ALLOWED',
  /** A fixed delivery policy's anchors must be present when the fulfillment_trigger is ANCHOR. */
  SellingPlanAnchorsRequired = 'SELLING_PLAN_ANCHORS_REQUIRED',
  /** Selling plan's billing and delivery policies anchors must be equal. */
  SellingPlanBillingAndDeliveryPolicyAnchorsMustBeEqual = 'SELLING_PLAN_BILLING_AND_DELIVERY_POLICY_ANCHORS_MUST_BE_EQUAL',
  /** Selling plan's billing cycle must be a multiple of delivery cycle. */
  SellingPlanBillingCycleMustBeAMultipleOfDeliveryCycle = 'SELLING_PLAN_BILLING_CYCLE_MUST_BE_A_MULTIPLE_OF_DELIVERY_CYCLE',
  /** Missing billing policy. */
  SellingPlanBillingPolicyMissing = 'SELLING_PLAN_BILLING_POLICY_MISSING',
  /** Must include at least one selling plan. */
  SellingPlanCountLowerBound = 'SELLING_PLAN_COUNT_LOWER_BOUND',
  /** Exceeded the selling plan limit (31). */
  SellingPlanCountUpperBound = 'SELLING_PLAN_COUNT_UPPER_BOUND',
  /** Missing delivery policy. */
  SellingPlanDeliveryPolicyMissing = 'SELLING_PLAN_DELIVERY_POLICY_MISSING',
  /** Cannot have multiple selling plans with the same name. */
  SellingPlanDuplicateName = 'SELLING_PLAN_DUPLICATE_NAME',
  /** Cannot have multiple selling plans with the same options. */
  SellingPlanDuplicateOptions = 'SELLING_PLAN_DUPLICATE_OPTIONS',
  /** A fixed selling plan can have at most one pricing policy. */
  SellingPlanFixedPricingPoliciesLimit = 'SELLING_PLAN_FIXED_PRICING_POLICIES_LIMIT',
  /** Selling plan's billing policy max cycles must be greater than min cycles. */
  SellingPlanMaxCyclesMustBeGreaterThanMinCycles = 'SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES',
  /** Cannot define option2 on this selling plan as there's no label on the parent selling plan group. */
  SellingPlanMissingOption2LabelOnParentGroup = 'SELLING_PLAN_MISSING_OPTION2_LABEL_ON_PARENT_GROUP',
  /** Cannot define option3 on this selling plan as there's no label on the parent selling plan group. */
  SellingPlanMissingOption3LabelOnParentGroup = 'SELLING_PLAN_MISSING_OPTION3_LABEL_ON_PARENT_GROUP',
  /** Selling plan's option2 is required because option2 exists. */
  SellingPlanOption2RequiredAsDefinedOnParentGroup = 'SELLING_PLAN_OPTION2_REQUIRED_AS_DEFINED_ON_PARENT_GROUP',
  /** Selling plan's option3 is required because option3 exists. */
  SellingPlanOption3RequiredAsDefinedOnParentGroup = 'SELLING_PLAN_OPTION3_REQUIRED_AS_DEFINED_ON_PARENT_GROUP',
  /** Selling plans can't have more than 2 pricing policies. */
  SellingPlanPricingPoliciesLimit = 'SELLING_PLAN_PRICING_POLICIES_LIMIT',
  /** Selling plan's pricing policies must contain one fixed pricing policy. */
  SellingPlanPricingPoliciesMustContainAFixedPricingPolicy = 'SELLING_PLAN_PRICING_POLICIES_MUST_CONTAIN_A_FIXED_PRICING_POLICY',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too big. */
  TooBig = 'TOO_BIG',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** The input value is the wrong length. */
  WrongLength = 'WRONG_LENGTH'
}

/** The input fields to create or update a selling plan. */
export type SellingPlanInput = {
  /** Selling plan policy which describes the billing details. */
  billingPolicy?: InputMaybe<SellingPlanBillingPolicyInput>;
  /** The category used to classify this selling plan for reporting purposes. */
  category?: InputMaybe<SellingPlanCategory>;
  /** A selling plan policy which describes the delivery details. */
  deliveryPolicy?: InputMaybe<SellingPlanDeliveryPolicyInput>;
  /** Buyer facing string which describes the selling plan commitment. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selling plan. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A selling plan policy which describes the inventory details. */
  inventoryPolicy?: InputMaybe<SellingPlanInventoryPolicyInput>;
  /** Additional customizable information to associate with the SellingPlan. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** Buyer facing string which describes the selling plan content. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The values of all options available on the selling plan. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Relative value for display purposes of this plan. A lower position will be displayed before a higher one. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The pricing policies which describe the pricing details. Each selling plan
   * can only contain a maximum of 2 pricing policies.
   */
  pricingPolicies?: InputMaybe<Array<SellingPlanPricingPolicyInput>>;
};

/** Represents valid selling plan interval. */
export enum SellingPlanInterval {
  /** Day interval. */
  Day = 'DAY',
  /** Month interval. */
  Month = 'MONTH',
  /** Week interval. */
  Week = 'WEEK',
  /** Year interval. */
  Year = 'YEAR'
}

/** The selling plan inventory policy. */
export type SellingPlanInventoryPolicy = {
  __typename?: 'SellingPlanInventoryPolicy';
  /** When to reserve inventory for the order. */
  reserve: SellingPlanReserve;
};

/** The input fields required to create or update an inventory policy. */
export type SellingPlanInventoryPolicyInput = {
  /** When to reserve inventory for the order. The value must be ON_FULFILLMENT or ON_SALE. */
  reserve?: InputMaybe<SellingPlanReserve>;
};

/**
 * Represents the type of pricing associated to the selling plan (for example, a $10 or 20% discount that is set
 * for a limited period or that is fixed for the duration of the subscription). Selling plan pricing policies and
 * associated records (selling plan groups, selling plans, billing policy, and delivery policy) are deleted 48
 * hours after a merchant uninstalls their subscriptions app. We recommend backing up these records if you need
 * to restore them later.
 */
export type SellingPlanPricingPolicy = SellingPlanFixedPricingPolicy | SellingPlanRecurringPricingPolicy;

/** Represents a selling plan pricing policy adjustment type. */
export enum SellingPlanPricingPolicyAdjustmentType {
  /** Fixed amount off adjustment. */
  FixedAmount = 'FIXED_AMOUNT',
  /** Percentage off adjustment. */
  Percentage = 'PERCENTAGE',
  /** Price of the policy. */
  Price = 'PRICE'
}

/** Represents a selling plan pricing policy adjustment value type. */
export type SellingPlanPricingPolicyAdjustmentValue = MoneyV2 | SellingPlanPricingPolicyPercentageValue;

/** Represents selling plan pricing policy common fields. */
export type SellingPlanPricingPolicyBase = {
  /** The price adjustment type. */
  adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
};

/** The input fields required to create or update a selling plan pricing policy. */
export type SellingPlanPricingPolicyInput = {
  /** Fixed pricing policy details. */
  fixed?: InputMaybe<SellingPlanFixedPricingPolicyInput>;
  /** Recurring pricing policy details. */
  recurring?: InputMaybe<SellingPlanRecurringPricingPolicyInput>;
};

/** The percentage value of a selling plan pricing policy percentage type. */
export type SellingPlanPricingPolicyPercentageValue = {
  __typename?: 'SellingPlanPricingPolicyPercentageValue';
  /** The percentage value. */
  percentage: Scalars['Float']['output'];
};

/** The input fields required to create or update a pricing policy adjustment value. */
export type SellingPlanPricingPolicyValueInput = {
  /** The fixed value for an fixed amount off or a new policy price. */
  fixedValue?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage value. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents a recurring selling plan billing policy. */
export type SellingPlanRecurringBillingPolicy = {
  __typename?: 'SellingPlanRecurringBillingPolicy';
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  anchors: Array<SellingPlanAnchor>;
  /** The date and time when the selling plan billing policy was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The billing frequency, it can be either: day, week, month or year. */
  interval: SellingPlanInterval;
  /** The number of intervals between billings. */
  intervalCount: Scalars['Int']['output'];
  /** Maximum number of billing iterations. */
  maxCycles?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of billing iterations. */
  minCycles?: Maybe<Scalars['Int']['output']>;
};

/** The input fields required to create or update a recurring billing policy. */
export type SellingPlanRecurringBillingPolicyInput = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  anchors?: InputMaybe<Array<SellingPlanAnchorInput>>;
  /** The billing frequency, it can be either: day, week, month or year. */
  interval?: InputMaybe<SellingPlanInterval>;
  /** The number of intervals between billings. */
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of billing iterations. */
  maxCycles?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of billing iterations. */
  minCycles?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a recurring selling plan delivery policy. */
export type SellingPlanRecurringDeliveryPolicy = {
  __typename?: 'SellingPlanRecurringDeliveryPolicy';
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors: Array<SellingPlanAnchor>;
  /** The date and time when the selling plan delivery policy was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Number of days which represent a buffer period for orders to be included in a cycle. */
  cutoff?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the delivery policy is merchant or buyer-centric.
   * Buyer-centric delivery policies state the time when the buyer will receive the goods.
   * Merchant-centric delivery policies state the time when the fulfillment should be started.
   * Currently, only merchant-centric delivery policies are supported.
   */
  intent: SellingPlanRecurringDeliveryPolicyIntent;
  /** The delivery frequency, it can be either: day, week, month or year. */
  interval: SellingPlanInterval;
  /** The number of intervals between deliveries. */
  intervalCount: Scalars['Int']['output'];
  /** The fulfillment or delivery behavior of the first fulfillment when the order is placed before the anchor. The default value for this field is `ASAP`. */
  preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior;
};

/** The input fields to create or update a recurring delivery policy. */
export type SellingPlanRecurringDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors?: InputMaybe<Array<SellingPlanAnchorInput>>;
  /** Number of days which represent a buffer period for orders to be included in a cycle. */
  cutoff?: InputMaybe<Scalars['Int']['input']>;
  /** Intention of this delivery policy, it can be either: delivery or fulfillment. */
  intent?: InputMaybe<SellingPlanRecurringDeliveryPolicyIntent>;
  /** The delivery frequency, it can be either: day, week, month or year. */
  interval?: InputMaybe<SellingPlanInterval>;
  /** The number of intervals between deliveries. */
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  /** The pre-anchor behavior. It can be either: asap or next. */
  preAnchorBehavior?: InputMaybe<SellingPlanRecurringDeliveryPolicyPreAnchorBehavior>;
};

/** Whether the delivery policy is merchant or buyer-centric. */
export enum SellingPlanRecurringDeliveryPolicyIntent {
  /** A merchant-centric delivery policy. Mark this delivery policy to define when the merchant should start fulfillment. */
  FulfillmentBegin = 'FULFILLMENT_BEGIN'
}

/** The fulfillment or delivery behaviors of the first fulfillment when the orderis placed before the anchor. */
export enum SellingPlanRecurringDeliveryPolicyPreAnchorBehavior {
  /** The orders placed can be fulfilled or delivered immediately. The orders placed inside a cutoff can be fulfilled or delivered at the next anchor. */
  Asap = 'ASAP',
  /**
   * The orders placed can be fulfilled or delivered at the next anchor date.
   * The orders placed inside a cutoff will skip the next anchor and can be fulfilled or
   * delivered at the following anchor.
   */
  Next = 'NEXT'
}

/** Represents a recurring selling plan pricing policy. It applies after the fixed pricing policy. By using the afterCycle parameter, you can specify the cycle when the recurring pricing policy comes into effect. Recurring pricing policies are not available for deferred purchase options. */
export type SellingPlanRecurringPricingPolicy = SellingPlanPricingPolicyBase & {
  __typename?: 'SellingPlanRecurringPricingPolicy';
  /** The price adjustment type. */
  adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** Cycle after which this pricing policy applies. */
  afterCycle?: Maybe<Scalars['Int']['output']>;
  /** The date and time when the recurring selling plan pricing policy was created. */
  createdAt: Scalars['DateTime']['output'];
};

/** The input fields required to create or update a recurring selling plan pricing policy. */
export type SellingPlanRecurringPricingPolicyInput = {
  /** Price adjustment type defined by the policy. */
  adjustmentType?: InputMaybe<SellingPlanPricingPolicyAdjustmentType>;
  /** Price adjustment value defined by the policy. */
  adjustmentValue?: InputMaybe<SellingPlanPricingPolicyValueInput>;
  /** Cycle after which the pricing policy applies. */
  afterCycle: Scalars['Int']['input'];
  /** ID of the pricing policy. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** When to capture the payment for the remaining amount due. */
export enum SellingPlanRemainingBalanceChargeTrigger {
  /** At an exact time defined by the remaining_balance_charge_exact_time field. */
  ExactTime = 'EXACT_TIME',
  /** When there's no remaining balance to be charged after checkout. */
  NoRemainingBalance = 'NO_REMAINING_BALANCE',
  /** When the order is fulfilled. */
  OnFulfillment = 'ON_FULFILLMENT',
  /** After the duration defined by the remaining_balance_charge_time_after_checkout field. */
  TimeAfterCheckout = 'TIME_AFTER_CHECKOUT'
}

/** When to reserve inventory for a selling plan. */
export enum SellingPlanReserve {
  /** Reserve inventory when order is fulfilled. */
  OnFulfillment = 'ON_FULFILLMENT',
  /** Reserve inventory at time of sale. */
  OnSale = 'ON_SALE'
}

/** A server pixel stores configuration for streaming customer interactions to an EventBridge or PubSub endpoint. */
export type ServerPixel = Node & {
  __typename?: 'ServerPixel';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The current state of this server pixel. */
  status?: Maybe<ServerPixelStatus>;
  /** Address of the EventBridge or PubSub endpoint. */
  webhookEndpointAddress?: Maybe<Scalars['String']['output']>;
};

/** Return type for `serverPixelCreate` mutation. */
export type ServerPixelCreatePayload = {
  __typename?: 'ServerPixelCreatePayload';
  /** The new server pixel. */
  serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsServerPixelUserError>;
};

/** Return type for `serverPixelDelete` mutation. */
export type ServerPixelDeletePayload = {
  __typename?: 'ServerPixelDeletePayload';
  /** The ID of the server pixel that was deleted, if one was deleted. */
  deletedServerPixelId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsServerPixelUserError>;
};

/** The current state of a server pixel. */
export enum ServerPixelStatus {
  /** This server pixel is connected: it will stream customer events to the endpoint if it is configured properly. */
  Connected = 'CONNECTED',
  /** This server pixel is disconnected: it does not stream events to the endpoint and an endpoint address has been added to the server pixel. */
  DisconnectedConfigured = 'DISCONNECTED_CONFIGURED',
  /** This server pixel is disconnected and unconfigured: it does not stream events to the endpoint and no endpoint address had been added to the server pixel. */
  DisconnectedUnconfigured = 'DISCONNECTED_UNCONFIGURED'
}

/** The set of valid sort keys for the ShipmentLineItem query. */
export enum ShipmentLineItemSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The input fields for a carrier-defined package to use for the shipping label purchase. */
export type ShippingCarrierPackageInput = {
  /** The code identifying the carrier that supplies the package. Examples include `usps`, `ups_shipping`, `dhl_express`, and `canada_post`. */
  carrierCode: Scalars['String']['input'];
  /** The code identifying the carrier package type. */
  carrierPackageCode: Scalars['String']['input'];
  /** The carrier-defined display name for the package. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The shipping configuration attached to a market. Defines the shipping
 * options available when a buyer is resolved to that market.
 */
export type ShippingConfiguration = {
  __typename?: 'ShippingConfiguration';
  /** Whether shipping is enabled for this market. When false, customers in this market won't see any shipping options. */
  isEnabled: Scalars['Boolean']['output'];
  /** The shipping options configured for this market. */
  optionDefinitions: DeliveryOptionDefinitionConnection;
  /** The number of shipping options in this configuration. */
  optionDefinitionsCount: Count;
};


/**
 * The shipping configuration attached to a market. Defines the shipping
 * options available when a buyer is resolved to that market.
 */
export type ShippingConfigurationOptionDefinitionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The shipping configuration attached to a market. Defines the shipping
 * options available when a buyer is resolved to that market.
 */
export type ShippingConfigurationOptionDefinitionsCountArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for creating a market's shipping configuration. */
export type ShippingConfigurationCreateInput = {
  /** Whether shipping is enabled for this market. When false, customers in this market won't see shipping options at checkout. */
  isEnabled: Scalars['Boolean']['input'];
  /** Shipping options to create for the market. */
  optionDefinitions?: InputMaybe<Array<DeliveryOptionDefinitionCreateInput>>;
};

/** The input fields for updating a market's shipping configuration. */
export type ShippingConfigurationUpdateInput = {
  /** Whether shipping is enabled for this market. When false, customers in this market won't see shipping options at checkout. Defaults to true when the market has no shipping configuration; otherwise preserves the existing value. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping options to create for this market. */
  optionDefinitionsToCreate?: InputMaybe<Array<DeliveryOptionDefinitionCreateInput>>;
  /** The IDs of shipping options to remove. */
  optionDefinitionsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Shipping options to update, matched by ID. */
  optionDefinitionsToUpdate?: InputMaybe<Array<DeliveryOptionDefinitionUpdateInput>>;
};

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum ShippingDiscountClass {
  /** Combined as a shipping discount. */
  Shipping = 'SHIPPING'
}

/** Types of shipping documents. */
export enum ShippingDocumentType {
  /** The customs form document for the shipment. */
  CustomsForm = 'CUSTOMS_FORM',
  /** The shipping label document for the shipment. */
  Label = 'LABEL'
}

/** File format for label. */
export enum ShippingEnumsFileFormat {
  /** PDF file format. */
  Pdf = 'PDF',
  /** ZPL file format. */
  Zpl = 'ZPL'
}

/** The optional shipping label for this fulfillment. */
export type ShippingLabel = Node & {
  __typename?: 'ShippingLabel';
  /** Indicates whether the label is cancellable or not. */
  cancellable: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The location of the shipping origin. This will be null when the shipping origin is unknown. */
  location?: Maybe<Location>;
  /** Indicates whether the label was printed or not. */
  printed: Scalars['Boolean']['output'];
  /** The documents for a shipping label. */
  shippingDocuments: Array<ShippingObjectsShippingDocument>;
  /** Tracking information for the shipping label. */
  trackingInfo?: Maybe<FulfillmentTrackingInfo>;
};

/** The input fields for a custom package to use for the shipping label purchase. */
export type ShippingLabelPurchaseCustomPackageInput = {
  /** The outside dimensions of the shipping package. */
  dimensions: ObjectDimensionsInput;
  /** The package type. Defaults to `BOX`. */
  type?: InputMaybe<ShippingPackageType>;
  /** The weight of the empty package. */
  weight: WeightInput;
};

/** The shipping label purchase processing failure. */
export type ShippingLabelPurchaseError = DisplayableError & {
  __typename?: 'ShippingLabelPurchaseError';
  /** The error code. */
  code?: Maybe<ShippingLabelPurchaseErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ShippingLabelPurchaseError`. */
export enum ShippingLabelPurchaseErrorCode {
  /** The carrier is not available for this label. Please try another carrier. */
  CarrierNotAvailable = 'CARRIER_NOT_AVAILABLE',
  /** We could not reach the shipping carrier. Please try again in a few minutes. */
  ConnectionError = 'CONNECTION_ERROR',
  /** The requested shop's shipping account is disabled. Please contact support. */
  DisabledShippingAccount = 'DISABLED_SHIPPING_ACCOUNT',
  /** There is another shipping label being purchased for this order. */
  JobNotEnqueued = 'JOB_NOT_ENQUEUED',
  /** Kill switch is enabled for this carrier. */
  KillSwitch = 'KILL_SWITCH',
  /** A non-recoverable error occurred while purchasing the label. Review the shipment details and try again. */
  PermanentError = 'PERMANENT_ERROR',
  /** We are still processing the purchase for this label. */
  PurchaseInProgress = 'PURCHASE_IN_PROGRESS',
  /** The shipping label could not be purchased due to invalid information. Please verify the shipping address, package weight and dimensions, and customs details (for international shipments). */
  PurchaseLabelValidationError = 'PURCHASE_LABEL_VALIDATION_ERROR',
  /** An error occurred while purchasing the label. Please try again. */
  TransientError = 'TRANSIENT_ERROR',
  /** An unknown error occurred while purchasing the label. */
  UnknownError = 'UNKNOWN_ERROR'
}

/** The input fields for the fulfillment order, shipping date and time, package details, weight, notification setting, and optional rate preference used to purchase a shipping label. */
export type ShippingLabelPurchaseInput = {
  /** The ID of the fulfillment order to create the shipping label for. The fulfillment order must be fulfillable, require shipping, and have a destination shipping address. */
  fulfillmentOrderId: Scalars['ID']['input'];
  /** Whether to notify the customer after the shipping label is purchased. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** A custom ship-from origin address that overrides the fulfillment order's assigned location for this label. If not provided, the assigned location is used. */
  originAddress?: InputMaybe<MailingAddressInput>;
  /** The package to use for the shipment. Provide either a custom package or a carrier-provided package. */
  packageInfo?: InputMaybe<PackageInfoInput>;
  /** The preferred carrier and service to use for the shipping label. If omitted, the mutation uses Shopify Shipping's default rate selection. */
  preferredRateSelection?: InputMaybe<PreferredRateSelectionInput>;
  /** The date and time when the package is expected to be shipped. The value must not be in the past. */
  shippingDatetime: Scalars['DateTime']['input'];
  /** Total shipment weight, including the items being fulfilled and the package. If omitted, the total weight used is calculated using the weight of the empty package and the weight of the fulfillable line items. */
  totalWeight?: InputMaybe<WeightInput>;
};

/** Return type for `shippingLabelPurchase` mutation. */
export type ShippingLabelPurchasePayload = {
  __typename?: 'ShippingLabelPurchasePayload';
  /** The asynchronous purchase result. Query this object to track purchase status, retrieve purchased shipping labels, or inspect purchase-processing errors. */
  shippingLabelPurchaseResult?: Maybe<ShippingLabelPurchaseResult>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShippingLabelPurchaseUserError>;
};

/** Tracks the progress of an asynchronous shipping label purchase request. */
export type ShippingLabelPurchaseResult = JobResult & Node & {
  __typename?: 'ShippingLabelPurchaseResult';
  /** This indicates if the job is still queued or has been run. */
  done: Scalars['Boolean']['output'];
  /** Purchase-processing errors for the request. Synchronous validation errors are returned from the `shippingLabelPurchase` mutation's `userErrors` field instead. */
  errors: Array<ShippingLabelPurchaseError>;
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  id: Scalars['ID']['output'];
  /** The shipping labels created by the purchase request. Labels are returned only after successful purchase. */
  shippingLabels: Array<ShippingLabel>;
  /** The current purchase status. A purchase starts as `PENDING_PURCHASE` and ends as either `PURCHASED` or `PURCHASE_FAILED`. */
  status: ShippingLabelPurchaseResultStatus;
};

/** The status of a shipping label purchase result. */
export enum ShippingLabelPurchaseResultStatus {
  /** Purchase is pending. */
  PendingPurchase = 'PENDING_PURCHASE',
  /** Purchase succeeded. */
  Purchased = 'PURCHASED',
  /** Purchase failed. */
  PurchaseFailed = 'PURCHASE_FAILED'
}

/** An error that occurs during the execution of `ShippingLabelPurchase`. */
export type ShippingLabelPurchaseUserError = DisplayableError & {
  __typename?: 'ShippingLabelPurchaseUserError';
  /** The error code. */
  code?: Maybe<ShippingLabelPurchaseUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ShippingLabelPurchaseUserError`. */
export enum ShippingLabelPurchaseUserErrorCode {
  /** The API client lacks write access to the provided fulfillment order. */
  AccessDenied = 'ACCESS_DENIED',
  /** The intent is trying to set an adaptive shipping state on a non-adaptive shipping order. */
  AdaptiveShippingStateInvalid = 'ADAPTIVE_SHIPPING_STATE_INVALID',
  /** At least 1 item should be fulfilled. */
  AtLeast_1ItemRequired = 'AT_LEAST_1_ITEM_REQUIRED',
  /** The selected shipping carrier cannot be purchased through this API. */
  CarrierNotSupported = 'CARRIER_NOT_SUPPORTED',
  /** The fulfillment order is not eligible for label purchase. Review the fulfillment order details and try again. */
  FulfillmentOrderInvalid = 'FULFILLMENT_ORDER_INVALID',
  /** Package dimensions must be greater than zero. */
  InvalidPackageDimensions = 'INVALID_PACKAGE_DIMENSIONS',
  /** Shipping labels may not be purchased at this time. Please try again later. */
  KillSwitch = 'KILL_SWITCH',
  /** Missing country of origin. */
  MissingCountryOfOrigin = 'MISSING_COUNTRY_OF_ORIGIN',
  /** Missing harmonized system code. */
  MissingHsCode = 'MISSING_HS_CODE',
  /** Missing insurance coverage amount. */
  MissingInsuranceCoverageAmount = 'MISSING_INSURANCE_COVERAGE_AMOUNT',
  /** Missing insurance coverage currency. */
  MissingInsuranceCoverageCurrency = 'MISSING_INSURANCE_COVERAGE_CURRENCY',
  /** Shipping date is required for purchase. */
  MissingShippingDate = 'MISSING_SHIPPING_DATE',
  /** Shipping rate selection is required for purchase. */
  MissingShippingRate = 'MISSING_SHIPPING_RATE',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The requested carrier package does not match the preferred rate selection carrier. */
  PackageCarrierMismatch = 'PACKAGE_CARRIER_MISMATCH',
  /** The shipping intent has a phone number that is not fully qualified for the destination address. */
  PhoneNumberNotFullyQualifiedDestination = 'PHONE_NUMBER_NOT_FULLY_QUALIFIED_DESTINATION',
  /** The shipping intent has a phone number that is not fully qualified for the origin address. */
  PhoneNumberNotFullyQualifiedOrigin = 'PHONE_NUMBER_NOT_FULLY_QUALIFIED_ORIGIN',
  /** Pickup point orders cannot be purchased through this API. Purchase the shipping label through the Shopify admin. */
  PickupPointNotSupported = 'PICKUP_POINT_NOT_SUPPORTED',
  /** The label purchase failed. Please review the shipment details and try again. */
  PurchaseFailed = 'PURCHASE_FAILED',
  /** Rates for the shipping label were not found. Please review the shipment details and try again. */
  RatesNotFound = 'RATES_NOT_FOUND',
  /** Shipping date has already passed. */
  ShippingDateInThePast = 'SHIPPING_DATE_IN_THE_PAST',
  /** Shopify Shipping terms of service have not been accepted. Purchase a shipping label through the Shopify admin first. */
  TermsOfServiceNotAccepted = 'TERMS_OF_SERVICE_NOT_ACCEPTED',
  /** Non-zero total weight is required for purchase. */
  TotalWeightZero = 'TOTAL_WEIGHT_ZERO'
}

/** The shipping method that customers select for an order. Includes pricing details, carrier information, and any applied discounts or taxes. */
export type ShippingLine = {
  __typename?: 'ShippingLine';
  /**
   * A reference to the carrier service that provided the rate.
   * Present when the rate was computed by a third-party carrier service.
   */
  carrierIdentifier?: Maybe<Scalars['String']['output']>;
  /** A reference to the shipping method. */
  code?: Maybe<Scalars['String']['output']>;
  /** The date and time when the shipping line was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The current shipping price after applying refunds, after applying discounts. If the parent `order.taxesIncluded`` field is true, then this price includes taxes. Otherwise, this field is the pre-tax price. */
  currentDiscountedPriceSet: MoneyBag;
  /** Whether the shipping line is custom or not. */
  custom: Scalars['Boolean']['output'];
  /** The general classification of the delivery method. */
  deliveryCategory?: Maybe<Scalars['String']['output']>;
  /** The discounts that have been allocated to the shipping line. */
  discountAllocations: Array<DiscountAllocation>;
  /**
   * The pre-tax shipping price with discounts applied.
   * As of API version 2024-07, this will be calculated including cart level discounts, such as the free shipping discount.
   * @deprecated Use `discountedPriceSet` instead.
   */
  discountedPrice: MoneyV2;
  /**
   * The shipping price after applying discounts. If the parent order.taxesIncluded field is true, then this price includes taxes. If not, it's the pre-tax price.
   * As of API version 2024-07, this will be calculated including cart level discounts, such as the free shipping discount.
   */
  discountedPriceSet: MoneyBag;
  /** A globally-unique ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the shipping line has been removed. */
  isRemoved: Scalars['Boolean']['output'];
  /**
   * The shipping price without any discounts applied. If the parent order.taxesIncluded field is true, then this price includes taxes. Otherwise, this field is the pre-tax price.
   * @deprecated Use `originalPriceSet` instead.
   */
  originalPrice: MoneyV2;
  /** The shipping price without any discounts applied. If the parent order.taxesIncluded field is true, then this price includes taxes. Otherwise, this field is the pre-tax price. */
  originalPriceSet: MoneyBag;
  /** The phone number at the shipping address. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the price of the shipping line.
   * @deprecated Use `originalPriceSet` instead.
   */
  price: Scalars['Money']['output'];
  /**
   * The fulfillment service requested for the shipping method.
   * Present if the shipping method requires processing by a third party fulfillment service.
   * @deprecated requestedFulfillmentService is no longer in use. Order routing does not use the requestedFulfillmentService during order and fulfillment order creation.
   */
  requestedFulfillmentService?: Maybe<FulfillmentService>;
  /** A unique identifier for the shipping rate. The format can change without notice and isn't meant to be shown to users. */
  shippingRateHandle?: Maybe<Scalars['String']['output']>;
  /** Returns the rate source for the shipping line. */
  source?: Maybe<Scalars['String']['output']>;
  /** The TaxLine objects connected to this shipping line. */
  taxLines: Array<TaxLine>;
  /** Returns the title of the shipping line. */
  title: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple ShippingLines. */
export type ShippingLineConnection = {
  __typename?: 'ShippingLineConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShippingLineEdge>;
  /** A list of nodes that are contained in ShippingLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShippingLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShippingLine and a cursor during pagination. */
export type ShippingLineEdge = {
  __typename?: 'ShippingLineEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShippingLineEdge. */
  node: ShippingLine;
};

/**
 * The input fields for specifying the shipping details for the draft order.
 *
 * > Note:
 * > A custom shipping line includes a title and price with `shippingRateHandle` set to `nil`. A shipping line with a carrier-provided shipping rate (currently set via the Shopify admin) includes the shipping rate handle.
 */
export type ShippingLineInput = {
  /** Price of the shipping rate with currency. If provided, `price` will be ignored. */
  priceWithCurrency?: InputMaybe<MoneyInput>;
  /** A unique identifier for the shipping rate. */
  shippingRateHandle?: InputMaybe<Scalars['String']['input']>;
  /** Title of the shipping rate. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A sale associated with a shipping charge. */
export type ShippingLineSale = Sale & {
  __typename?: 'ShippingLineSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The shipping line item for the associated sale. `shippingLine` is not available if the `SaleActionType` is a return. */
  shippingLine?: Maybe<ShippingLine>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** Represents a shipping document. */
export type ShippingObjectsShippingDocument = {
  __typename?: 'ShippingObjectsShippingDocument';
  /** The type of the shipping document. */
  documentType: ShippingDocumentType;
  /** File format of the shipping document. */
  format?: Maybe<ShippingEnumsFileFormat>;
  /** The last time the document was printed. */
  printedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The shipping label associated with the shipping document. */
  shippingLabelId: Scalars['ID']['output'];
  /** URL of the shipping document. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Return type for `shippingPackageDelete` mutation. */
export type ShippingPackageDeletePayload = {
  __typename?: 'ShippingPackageDeletePayload';
  /** The ID of the deleted shipping package. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `shippingPackageMakeDefault` mutation. */
export type ShippingPackageMakeDefaultPayload = {
  __typename?: 'ShippingPackageMakeDefaultPayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Type of a shipping package. */
export enum ShippingPackageType {
  /** A shipping box. */
  Box = 'BOX',
  /** An envelope. */
  Envelope = 'ENVELOPE',
  /** A flat rate packaging supplied by a carrier. */
  FlatRate = 'FLAT_RATE',
  /** A soft-pack, bubble-wrap or vinyl envelope. */
  SoftPack = 'SOFT_PACK'
}

/** Return type for `shippingPackageUpdate` mutation. */
export type ShippingPackageUpdatePayload = {
  __typename?: 'ShippingPackageUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** A shipping option associated with order delivery that includes pricing and service information. */
export type ShippingRate = {
  __typename?: 'ShippingRate';
  /** Human-readable unique identifier for this shipping rate. */
  handle: Scalars['String']['output'];
  /** The cost associated with the shipping rate. */
  price: MoneyV2;
  /** The name of the shipping rate. */
  title: Scalars['String']['output'];
};

/** Represents the shipping costs refunded on the Refund. */
export type ShippingRefund = {
  __typename?: 'ShippingRefund';
  /**
   * The monetary value of the shipping fees to be refunded.
   * @deprecated Use `amountSet` instead.
   */
  amount: Scalars['Money']['output'];
  /** The monetary value of the shipping fees to be refunded in shop and presentment currencies. */
  amountSet: MoneyBag;
  /**
   * The maximum amount of shipping fees currently refundable.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  maximumRefundable: Scalars['Money']['output'];
  /** The maximum amount of shipping fees currently refundable in shop and presentment currencies. */
  maximumRefundableSet: MoneyBag;
  /**
   * The monetary value of the tax allocated to shipping fees to be refunded.
   * @deprecated Use `taxSet` instead.
   */
  tax: Scalars['Money']['output'];
  /** The monetary value of the tax allocated to shipping fees to be refunded in shop and presentment currencies. */
  taxSet: MoneyBag;
};

/** The input fields that are required to reimburse shipping costs. */
export type ShippingRefundInput = {
  /** The monetary value of the shipping fees to be reimbursed. */
  amount?: InputMaybe<Scalars['Money']['input']>;
  /** Whether a full refund is provided. */
  fullRefund?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type Shop = HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & {
  __typename?: 'Shop';
  /** Account owner information. */
  accountOwner: StaffMember;
  /** A list of the shop's active alert messages that appear in the Shopify admin. */
  alerts: Array<ShopAlert>;
  /**
   * A list of the shop's product categories. Limit: 500 product categories.
   * @deprecated Use `allProductCategoriesList` instead.
   */
  allProductCategories: Array<ProductCategory>;
  /** A list of the shop's product categories. Limit: 500 product categories. */
  allProductCategoriesList: Array<TaxonomyCategory>;
  /**
   * The token required to query the shop's reports or dashboards.
   * @deprecated Not supported anymore.
   */
  analyticsToken: Scalars['String']['output'];
  /**
   * The paginated list of fulfillment orders assigned to the shop locations owned by the app.
   *
   * Assigned fulfillment orders are fulfillment orders that are set to be fulfilled from locations
   * managed by
   * [fulfillment services](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
   * that are registered by the app.
   * One app (api_client) can host multiple fulfillment services on a shop.
   * Each fulfillment service manages a dedicated location on a shop.
   * Assigned fulfillment orders can have associated
   * [fulfillment requests](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus),
   * or might currently not be requested to be fulfilled.
   *
   * The app must have `read_assigned_fulfillment_orders`
   * [access scope](https://shopify.dev/docs/api/usage/access-scopes)
   * to be able to retrieve fulfillment orders assigned to its locations.
   *
   * All assigned fulfillment orders (except those with the `CLOSED` status) will be returned by default.
   * Perform filtering with the `assignmentStatus` argument
   * to receive only fulfillment orders that have been requested to be fulfilled.
   * @deprecated Use `QueryRoot.assignedFulfillmentOrders` instead. Details: https://shopify.dev/changelog/moving-the-shop-assignedfulfillmentorders-connection-to-queryroot
   */
  assignedFulfillmentOrders: FulfillmentOrderConnection;
  /** The list of sales channels not currently installed on the shop. */
  availableChannelApps: AppConnection;
  /**
   * The shop's billing address information.
   * @deprecated Use `shopAddress` instead.
   */
  billingAddress: ShopAddress;
  /**
   * List of all channel definitions associated with a shop.
   * @deprecated Use [`QueryRoot.orderAttributionDefinitions`](https://shopify.dev/docs/api/admin-graphql/latest/queries/orderAttributionDefinitions) and select `id`, `handle`, `displayName`, and `icon` instead.
   */
  channelDefinitionsForInstalledChannels: Array<AvailableChannelDefinitionsByChannel>;
  /**
   * List of the shop's active sales channels.
   * @deprecated Use `QueryRoot.channels` instead.
   */
  channels: ChannelConnection;
  /** Specifies whether the shop supports checkouts via Checkout API. */
  checkoutApiSupported: Scalars['Boolean']['output'];
  /**
   * List of the shop's collections.
   * @deprecated Use `QueryRoot.collections` instead.
   */
  collections: CollectionConnection;
  /**
   * The public-facing contact email address for the shop.
   * Customers will use this email to communicate with the shop owner.
   */
  contactEmail: Scalars['String']['output'];
  /** Countries that have been defined in shipping zones for the shop. */
  countriesInShippingZones: CountriesInShippingZones;
  /** The date and time when the shop was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The three letter code for the currency that the shop sells in. */
  currencyCode: CurrencyCode;
  /** How currencies are displayed on your store. */
  currencyFormats: CurrencyFormats;
  /** The presentment currency settings for the shop excluding the shop's own currency. */
  currencySettings: CurrencySettingConnection;
  /** Whether customer accounts are required, optional, or disabled for the shop. */
  customerAccounts: ShopCustomerAccountsSetting;
  /** Information about the shop's customer accounts. */
  customerAccountsV2: CustomerAccountsV2;
  /** A list of tags that have been added to customer accounts. */
  customerTags: StringConnection;
  /**
   * Customer accounts associated to the shop.
   * @deprecated Use `QueryRoot.customers` instead.
   */
  customers: CustomerConnection;
  /** The shop's meta description used in search engine results. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The domains configured for the shop.
   * @deprecated Use `domainsPaginated` instead.
   */
  domains: Array<Domain>;
  /** A list of tags that have been added to draft orders. */
  draftOrderTags: StringConnection;
  /**
   * The shop owner's email address.
   * Shopify will use this email address to communicate with the shop owner.
   */
  email: Scalars['String']['output'];
  /** The presentment currencies enabled for the shop. */
  enabledPresentmentCurrencies: Array<CurrencyCode>;
  /** The entitlements for a shop. */
  entitlements: EntitlementsType;
  /** The set of features enabled for the shop. */
  features: ShopFeatures;
  /**
   * The paginated list of merchant-managed and third-party fulfillment orders.
   * @deprecated Use `QueryRoot.fulfillmentOrders` instead.
   */
  fulfillmentOrders: FulfillmentOrderConnection;
  /** List of the shop's installed fulfillment services. */
  fulfillmentServices: Array<FulfillmentService>;
  /** The shop's time zone as defined by the IANA. */
  ianaTimezone: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * List of the shop's inventory items.
   * @deprecated Use `QueryRoot.inventoryItems` instead.
   */
  inventoryItems: InventoryItemConnection;
  /**
   * The number of pendings orders on the shop.
   * Limited to a maximum of 10000.
   * @deprecated Use `QueryRoot.pendingOrdersCount` instead.
   */
  limitedPendingOrderCount: LimitedPendingOrderCount;
  /**
   * List of active locations of the shop.
   * @deprecated Use `QueryRoot.locations` instead.
   */
  locations: LocationConnection;
  /** Whether SMS marketing has been enabled on the shop's checkout configuration settings. */
  marketingSmsConsentEnabledAtCheckout: Scalars['Boolean']['output'];
  /** The approval signals for a shop to support onboarding to channel apps. */
  merchantApprovalSignals?: Maybe<MerchantApprovalSignals>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The shop's .myshopify.com domain name. */
  myshopifyDomain: Scalars['String']['output'];
  /** The shop's name. */
  name: Scalars['String']['output'];
  /** The shop's settings related to navigation. */
  navigationSettings: Array<NavigationItem>;
  /** The prefix that appears before order numbers. */
  orderNumberFormatPrefix: Scalars['String']['output'];
  /** The suffix that appears after order numbers. */
  orderNumberFormatSuffix: Scalars['String']['output'];
  /** A list of tags that have been added to orders. */
  orderTags: StringConnection;
  /**
   * A list of the shop's orders.
   * @deprecated Use `QueryRoot.orders` instead.
   */
  orders: OrderConnection;
  /** The shop's settings related to payments. */
  paymentSettings: PaymentSettings;
  /** The shop's billing plan. */
  plan: ShopPlan;
  /** The primary domain of the shop's online store. */
  primaryDomain: Domain;
  /**
   * The list of all images of all products for the shop.
   * @deprecated Use `files` instead. See [filesQuery](https://shopify.dev/docs/api/admin-graphql/latest/queries/files) and its [query](https://shopify.dev/docs/api/admin-graphql/latest/queries/files#argument-query) argument for more information.
   */
  productImages: ImageConnection;
  /**
   * A list of tags that have been added to products.
   * @deprecated Use `QueryRoot.productTags` instead.
   */
  productTags: StringConnection;
  /**
   * The list of types added to products.
   * @deprecated Use `QueryRoot.productTypes` instead.
   */
  productTypes: StringConnection;
  /**
   * List of the shop's product variants.
   * @deprecated Use `QueryRoot.productVariants` instead.
   */
  productVariants: ProductVariantConnection;
  /**
   * The list of vendors added to products.
   * @deprecated Use `QueryRoot.productVendors` instead.
   */
  productVendors: StringConnection;
  /**
   * List of the shop's products.
   * @deprecated Use `QueryRoot.products`.
   */
  products: ProductConnection;
  /**
   * The number of publications for the shop.
   * @deprecated Use `QueryRoot.publicationsCount` instead.
   */
  publicationCount: Scalars['Int']['output'];
  /** The shop's limits for specific resources. For example, the maximum number ofvariants allowed per product, or the maximum number of locations allowed. */
  resourceLimits: ShopResourceLimits;
  /** The URL of the rich text editor that can be used for mobile devices. */
  richTextEditorUrl: Scalars['URL']['output'];
  /** Fetches a list of admin search results by a specified query. */
  search: SearchResultConnection;
  /** The list of search filter options for the shop. These can be used to filter productvisibility for the shop. */
  searchFilters: SearchFilterOptions;
  /** Whether the shop has outstanding setup steps. */
  setupRequired: Scalars['Boolean']['output'];
  /** The list of countries that the shop ships to. */
  shipsToCountries: Array<CountryCode>;
  /** The shop's address information as it will appear to buyers. */
  shopAddress: ShopAddress;
  /** The name of the shop owner. */
  shopOwnerName: Scalars['String']['output'];
  /** The list of all legal policies associated with a shop. */
  shopPolicies: Array<ShopPolicy>;
  /**
   * The paginated list of the shop's staff members.
   * @deprecated Use `QueryRoot.staffMembers` instead.
   */
  staffMembers: StaffMemberConnection;
  /** The storefront access token of a private application. These are scoped per-application. */
  storefrontAccessTokens: StorefrontAccessTokenConnection;
  /**
   * The URL of the shop's storefront.
   * @deprecated Use `url` instead.
   */
  storefrontUrl: Scalars['URL']['output'];
  /** Whether the shop charges taxes for shipping. */
  taxShipping: Scalars['Boolean']['output'];
  /** Whether applicable taxes are included in the shop's product prices. */
  taxesIncluded: Scalars['Boolean']['output'];
  /** The shop's time zone abbreviation. */
  timezoneAbbreviation: Scalars['String']['output'];
  /** The shop's time zone offset. */
  timezoneOffset: Scalars['String']['output'];
  /** The shop's time zone offset expressed as a number of minutes. */
  timezoneOffsetMinutes: Scalars['Int']['output'];
  /** Whether transactional SMS sent by Shopify have been disabled for a shop. */
  transactionalSmsDisabled: Scalars['Boolean']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The shop's unit system for weights and measures. */
  unitSystem: UnitSystem;
  /** The date and time when the shop was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL of the shop's online store. */
  url: Scalars['URL']['output'];
  /** The shop's primary unit of weight for products and shipping. */
  weightUnit: WeightUnit;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopAssignedFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignmentStatus?: InputMaybe<FulfillmentOrderAssignmentStatus>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopAvailableChannelAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopCurrencySettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopCustomerTagsArgs = {
  first: Scalars['Int']['input'];
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopDraftOrderTagsArgs = {
  first: Scalars['Int']['input'];
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopOrderTagsArgs = {
  first: Scalars['Int']['input'];
  sort?: InputMaybe<ShopTagSort>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductTagsArgs = {
  first: Scalars['Int']['input'];
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductTypesArgs = {
  first: Scalars['Int']['input'];
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductVendorsArgs = {
  first: Scalars['Int']['input'];
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  types?: InputMaybe<Array<SearchResultType>>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopStorefrontAccessTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The central configuration and settings hub for a Shopify store. Access business information, operational preferences, feature availability, and store-wide settings that control how the shop operates.
 *
 * Includes core business details like the shop name, contact emails, billing address, and currency settings. The shop configuration determines customer account requirements, available sales channels, enabled features, payment settings, and policy documents. Also provides access to shop-level resources such as staff members, fulfillment services, navigation settings, and storefront access tokens.
 */
export type ShopTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** An address for a shop. */
export type ShopAddress = Node & {
  __typename?: 'ShopAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the company or organization. */
  company?: Maybe<Scalars['String']['output']>;
  /** Whether the address coordinates are valid. */
  coordinatesValidated: Scalars['Boolean']['output'];
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   * @deprecated Use `countryCodeV2` instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   */
  countryCodeV2?: Maybe<CountryCode>;
  /**
   * The first name.
   * @deprecated Always null in this context.
   */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address, customized by the provided arguments. */
  formatted: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The last name.
   * @deprecated Always null in this context.
   */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * The full name, based on firstName and lastName.
   * @deprecated Always null in this context.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A phone number associated with the address.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  phone?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};


/** An address for a shop. */
export type ShopAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An alert message that appears in the Shopify admin about a problem with a store setting, with an action to take. For example, you could show an alert to ask the merchant to enter their billing information to activate Shopify Plus. */
export type ShopAlert = {
  __typename?: 'ShopAlert';
  /** The text for the button in the alert that links to related information. For example, _Add credit card_. */
  action: ShopAlertAction;
  /** A description of the alert and further information, such as whether the merchant will be charged. */
  description: Scalars['String']['output'];
};

/** An action associated to a shop alert, such as adding a credit card. */
export type ShopAlertAction = {
  __typename?: 'ShopAlertAction';
  /** The text for the button in the alert. For example, _Add credit card_. */
  title: Scalars['String']['output'];
  /** The target URL that the button links to. */
  url: Scalars['URL']['output'];
};

/** Billing preferences for the shop. */
export type ShopBillingPreferences = {
  __typename?: 'ShopBillingPreferences';
  /** The currency the shop uses to pay for apps and services. */
  currency: CurrencyCode;
};

/**
 * Possible branding of a shop.
 * Branding can be used to define the look of a shop including its styling and logo in the Shopify Admin.
 */
export enum ShopBranding {
  /** Shop has Rogers branding. */
  Rogers = 'ROGERS',
  /** Shop has Shopify branding. */
  Shopify = 'SHOPIFY',
  /** Shop has Shopify Gold branding. */
  ShopifyGold = 'SHOPIFY_GOLD',
  /** Shop has Shopify Plus branding. */
  ShopifyPlus = 'SHOPIFY_PLUS'
}

/** Represents the shop's customer account requirement preference. */
export enum ShopCustomerAccountsSetting {
  Disabled = 'DISABLED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/**
 * Represents the feature set available to the shop.
 * Most fields specify whether a feature is enabled for a shop, and some fields return information
 * related to specific features.
 */
export type ShopFeatures = {
  __typename?: 'ShopFeatures';
  /** Whether a shop has access to Avalara AvaTax. */
  avalaraAvatax: Scalars['Boolean']['output'];
  /** The branding of the shop, which influences its look and feel in the Shopify admin. */
  branding: ShopBranding;
  /** Represents the Bundles feature configuration for the shop. */
  bundles: BundlesFeature;
  /** Whether the buyer experience deposit configuration is enabled. */
  buyerExperienceDepositEnabled: Scalars['Boolean']['output'];
  /** Whether a shop's online store can have CAPTCHA protection. */
  captcha: Scalars['Boolean']['output'];
  /**
   * Whether a shop's online store can have CAPTCHA protection for domains not managed by Shopify.
   * @deprecated No longer required for external domains
   */
  captchaExternalDomains: Scalars['Boolean']['output'];
  /** Represents the cart transform feature configuration for the shop. */
  cartTransform: CartTransformFeature;
  /**
   * Whether the delivery profiles functionality is enabled for this shop.
   * @deprecated Delivery profiles are now 100% enabled across Shopify.
   */
  deliveryProfiles: Scalars['Boolean']['output'];
  /** Whether the direct connection catalog assignment is enabled. */
  directConnectionCatalogAssignmentEnabled: Scalars['Boolean']['output'];
  /** Whether a shop has access to the Google Analytics dynamic remarketing feature. */
  dynamicRemarketing: Scalars['Boolean']['output'];
  /** Whether a shop can be migrated to use Shopify subscriptions. */
  eligibleForSubscriptionMigration: Scalars['Boolean']['output'];
  /** Whether a shop is configured properly to sell subscriptions. */
  eligibleForSubscriptions: Scalars['Boolean']['output'];
  /** Whether a shop can create gift cards. */
  giftCards: Scalars['Boolean']['output'];
  /**
   * Whether a shop displays Harmonized System codes on products. This is used for customs when shipping
   * internationally.
   */
  harmonizedSystemCode: Scalars['Boolean']['output'];
  /**
   * Whether a shop can enable international domains.
   * @deprecated All shops have international domains through Shopify Markets.
   */
  internationalDomains: Scalars['Boolean']['output'];
  /**
   * Whether a shop can enable international price overrides.
   * @deprecated Use the `markets` field on `EntitlementsType`.
   * Each market entitlement has a `catalogs` field that indicates
   * whether the shop's markets have access to catalogs and price overrides.
   *
   */
  internationalPriceOverrides: Scalars['Boolean']['output'];
  /**
   * Whether a shop can enable international price rules.
   * @deprecated Use the `markets` field on `EntitlementsType`.
   * Each market entitlement has a `catalogs` field that indicates
   * whether the shop's markets have access to catalogs and price overrides.
   *
   */
  internationalPriceRules: Scalars['Boolean']['output'];
  /** Whether a shop has enabled a legacy subscription gateway to handle older subscriptions. */
  legacySubscriptionGatewayEnabled: Scalars['Boolean']['output'];
  /**
   * Whether to show the Live View metrics in the Shopify admin. Live view is hidden from merchants that are on a trial
   * or don't have a storefront.
   */
  liveView: Scalars['Boolean']['output'];
  /** Whether market-driven shipping is enabled for the shop. */
  marketDrivenShipping: Scalars['Boolean']['output'];
  /**
   * Whether a shop has access to the onboarding visual.
   * @deprecated No longer supported.
   */
  onboardingVisual: Scalars['Boolean']['output'];
  /** Whether a shop is configured to sell subscriptions with PayPal Express. */
  paypalExpressSubscriptionGatewayStatus: PaypalExpressSubscriptionsGatewayStatus;
  /** Whether a shop has access to all reporting features. */
  reports: Scalars['Boolean']['output'];
  /** Whether a shop has ever had subscription products. */
  sellsSubscriptions: Scalars['Boolean']['output'];
  /**
   * Whether the shop has a Shopify Plus subscription.
   * @deprecated Use Shop.plan.shopifyPlus instead.
   */
  shopifyPlus: Scalars['Boolean']['output'];
  /** Whether to show metrics in the Shopify admin. Metrics are hidden for new merchants until they become meaningful. */
  showMetrics: Scalars['Boolean']['output'];
  /** Whether a shop has an online store. */
  storefront: Scalars['Boolean']['output'];
  /** Whether a shop is eligible for Sub Country Markets. */
  subCountryMarketsEnabled: Scalars['Boolean']['output'];
  /**
   * Whether a shop is eligible for Unified Markets.
   * @deprecated Unified Markets is enabled for all shops. Remove checks against this field.
   */
  unifiedMarkets: Scalars['Boolean']['output'];
  /** Whether a shop is using Shopify Balance. */
  usingShopifyBalance: Scalars['Boolean']['output'];
};

/** A locale that's been enabled on a shop. */
export type ShopLocale = {
  __typename?: 'ShopLocale';
  /** The locale ISO code. */
  locale: Scalars['String']['output'];
  /** The market web presences that use the locale. */
  marketWebPresences: Array<MarketWebPresence>;
  /** The human-readable locale name. */
  name: Scalars['String']['output'];
  /** Whether the locale is the default locale for the shop. */
  primary: Scalars['Boolean']['output'];
  /** Whether the locale is visible to buyers. */
  published: Scalars['Boolean']['output'];
};

/** Return type for `shopLocaleDisable` mutation. */
export type ShopLocaleDisablePayload = {
  __typename?: 'ShopLocaleDisablePayload';
  /** ISO code of the locale that was deleted. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `shopLocaleEnable` mutation. */
export type ShopLocaleEnablePayload = {
  __typename?: 'ShopLocaleEnablePayload';
  /** ISO code of the locale that was enabled. */
  shopLocale?: Maybe<ShopLocale>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for a shop locale. */
export type ShopLocaleInput = {
  /** The market web presences on which the locale should be enabled. Pass in an empty array to remove the locale across all market web presences. */
  marketWebPresenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the locale is published. Only published locales are visible to the buyer. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `shopLocaleUpdate` mutation. */
export type ShopLocaleUpdatePayload = {
  __typename?: 'ShopLocaleUpdatePayload';
  /** The locale that was updated. */
  shopLocale?: Maybe<ShopLocale>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Shop Pay Installments payment details related to a transaction. */
export type ShopPayInstallmentsPaymentDetails = BasePaymentDetails & {
  __typename?: 'ShopPayInstallmentsPaymentDetails';
  /** The name of payment method used by the buyer. */
  paymentMethodName?: Maybe<Scalars['String']['output']>;
};

/** Represents a Shop Pay payment request. */
export type ShopPayPaymentRequest = {
  __typename?: 'ShopPayPaymentRequest';
  /** The discounts for the payment request order. */
  discounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  /** The line items for the payment request. */
  lineItems: Array<ShopPayPaymentRequestLineItem>;
  /** The presentment currency for the payment request. */
  presentmentCurrency: CurrencyCode;
  /** The delivery method type for the payment request. */
  selectedDeliveryMethodType: ShopPayPaymentRequestDeliveryMethodType;
  /** The shipping address for the payment request. */
  shippingAddress?: Maybe<ShopPayPaymentRequestContactField>;
  /** The shipping lines for the payment request. */
  shippingLines: Array<ShopPayPaymentRequestShippingLine>;
  /** The subtotal amount for the payment request. */
  subtotal: MoneyV2;
  /** The total amount for the payment request. */
  total: MoneyV2;
  /** The total shipping price for the payment request. */
  totalShippingPrice?: Maybe<ShopPayPaymentRequestTotalShippingPrice>;
  /** The total tax for the payment request. */
  totalTax?: Maybe<MoneyV2>;
};

/** Represents a contact field for a Shop Pay payment request. */
export type ShopPayPaymentRequestContactField = {
  __typename?: 'ShopPayPaymentRequestContactField';
  /** The first address line of the contact field. */
  address1: Scalars['String']['output'];
  /** The second address line of the contact field. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the contact field. */
  city: Scalars['String']['output'];
  /** The company name of the contact field. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country of the contact field. */
  countryCode: Scalars['String']['output'];
  /** The email of the contact field. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the contact field. */
  firstName: Scalars['String']['output'];
  /** The last name of the contact field. */
  lastName: Scalars['String']['output'];
  /** The phone number of the contact field. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The postal code of the contact field. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The province of the contact field. */
  provinceCode?: Maybe<Scalars['String']['output']>;
};

/** Represents the delivery method type for a Shop Pay payment request. */
export enum ShopPayPaymentRequestDeliveryMethodType {
  /** The delivery method type is pickup. */
  Pickup = 'PICKUP',
  /** The delivery method type is shipping. */
  Shipping = 'SHIPPING'
}

/** Represents a discount for a Shop Pay payment request. */
export type ShopPayPaymentRequestDiscount = {
  __typename?: 'ShopPayPaymentRequestDiscount';
  /** The amount of the discount. */
  amount: MoneyV2;
  /** The label of the discount. */
  label: Scalars['String']['output'];
};

/** Represents an image for a Shop Pay payment request line item. */
export type ShopPayPaymentRequestImage = {
  __typename?: 'ShopPayPaymentRequestImage';
  /** The alt text of the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The source URL of the image. */
  url: Scalars['String']['output'];
};

/** Represents a line item for a Shop Pay payment request. */
export type ShopPayPaymentRequestLineItem = {
  __typename?: 'ShopPayPaymentRequestLineItem';
  /** The final item price for the line item. */
  finalItemPrice: MoneyV2;
  /** The final line price for the line item. */
  finalLinePrice: MoneyV2;
  /** The image of the line item. */
  image?: Maybe<ShopPayPaymentRequestImage>;
  /** The item discounts for the line item. */
  itemDiscounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  /** The label of the line item. */
  label: Scalars['String']['output'];
  /** The line discounts for the line item. */
  lineDiscounts?: Maybe<Array<ShopPayPaymentRequestDiscount>>;
  /** The original item price for the line item. */
  originalItemPrice?: Maybe<MoneyV2>;
  /** The original line price for the line item. */
  originalLinePrice?: Maybe<MoneyV2>;
  /** The quantity of the line item. */
  quantity: Scalars['Int']['output'];
  /** Whether the line item requires shipping. */
  requiresShipping?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the line item. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** The receipt of Shop Pay payment request session submission. */
export type ShopPayPaymentRequestReceipt = {
  __typename?: 'ShopPayPaymentRequestReceipt';
  /** The date and time when the payment request receipt was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The order that's associated with the payment request receipt. */
  order?: Maybe<Order>;
  /** The shop pay payment request object. */
  paymentRequest: ShopPayPaymentRequest;
  /** The status of the payment request session submission. */
  processingStatus: ShopPayPaymentRequestReceiptProcessingStatus;
  /** The source identifier provided in the `ShopPayPaymentRequestSessionCreate` mutation. */
  sourceIdentifier: Scalars['String']['output'];
  /** The token of the receipt, initially returned by an `ShopPayPaymentRequestSessionSubmit` mutation. */
  token: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple ShopPayPaymentRequestReceipts. */
export type ShopPayPaymentRequestReceiptConnection = {
  __typename?: 'ShopPayPaymentRequestReceiptConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopPayPaymentRequestReceiptEdge>;
  /** A list of nodes that are contained in ShopPayPaymentRequestReceiptEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopPayPaymentRequestReceipt>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopPayPaymentRequestReceipt and a cursor during pagination. */
export type ShopPayPaymentRequestReceiptEdge = {
  __typename?: 'ShopPayPaymentRequestReceiptEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopPayPaymentRequestReceiptEdge. */
  node: ShopPayPaymentRequestReceipt;
};

/**
 * The processing status of a Shop Pay payment request.
 * Represents the different states a payment request can be in during its lifecycle,
 * from initial creation through to completion or failure.
 */
export type ShopPayPaymentRequestReceiptProcessingStatus = {
  __typename?: 'ShopPayPaymentRequestReceiptProcessingStatus';
  /** A standardized error code, independent of the payment provider. */
  errorCode?: Maybe<ShopPayPaymentRequestReceiptProcessingStatusErrorCode>;
  /** The message of the payment request receipt. */
  message?: Maybe<Scalars['String']['output']>;
  /** The state of the payment request receipt. */
  state: ShopPayPaymentRequestReceiptProcessingStatusState;
};

/** A standardized error code, independent of the payment provider. */
export enum ShopPayPaymentRequestReceiptProcessingStatusErrorCode {
  /** The amount is too small. */
  AmountTooSmall = 'AMOUNT_TOO_SMALL',
  /** Call the card issuer. */
  CallIssuer = 'CALL_ISSUER',
  /** The card was declined. */
  CardDeclined = 'CARD_DECLINED',
  /** There is an error in the gateway or merchant configuration. */
  ConfigError = 'CONFIG_ERROR',
  /** Too many failed CVV verification attempts. */
  CvvAttemptsExceeded = 'CVV_ATTEMPTS_EXCEEDED',
  /** The card is expired. */
  ExpiredCard = 'EXPIRED_CARD',
  /** The card issuer has flagged the transaction as potentially fraudulent. */
  FraudSuspected = 'FRAUD_SUSPECTED',
  /** There was an unknown error with processing the payment. */
  GenericError = 'GENERIC_ERROR',
  /** The address does not match the card number. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The CVC does not match the card number. */
  IncorrectCvc = 'INCORRECT_CVC',
  /** The card number is incorrect. */
  IncorrectNumber = 'INCORRECT_NUMBER',
  /** The entered PIN is incorrect. */
  IncorrectPin = 'INCORRECT_PIN',
  /** The ZIP or postal code does not match the card number. */
  IncorrectZip = 'INCORRECT_ZIP',
  /** The amount is either too high or too low for the provider. */
  InvalidAmount = 'INVALID_AMOUNT',
  /** The payment method is not available in the customer's country. */
  InvalidCountry = 'INVALID_COUNTRY',
  /** The format of the CVC is incorrect. */
  InvalidCvc = 'INVALID_CVC',
  /** The format of the expiry date is incorrect. */
  InvalidExpiryDate = 'INVALID_EXPIRY_DATE',
  /** The format of the card number is incorrect. */
  InvalidNumber = 'INVALID_NUMBER',
  /** The payment method is momentarily unavailable. */
  PaymentMethodUnavailable = 'PAYMENT_METHOD_UNAVAILABLE',
  /** The card has been reported as lost or stolen, and the card issuer has requested that the merchant keep the card and call the number on the back. */
  PickUpCard = 'PICK_UP_CARD',
  /** There was an error while processing the payment. */
  ProcessingError = 'PROCESSING_ERROR',
  /** A real card was used but the gateway was in test mode. */
  TestModeLiveCard = 'TEST_MODE_LIVE_CARD',
  /** The 3D Secure check failed. */
  ThreeDSecureFailed = 'THREE_D_SECURE_FAILED',
  /** The gateway or merchant configuration doesn't support a feature, such as network tokenization. */
  UnsupportedFeature = 'UNSUPPORTED_FEATURE'
}

/** The state of the payment request receipt. */
export enum ShopPayPaymentRequestReceiptProcessingStatusState {
  /** The payment request requires action from the buyer. */
  ActionRequired = 'ACTION_REQUIRED',
  /** The payment request processing completed successfully. */
  Completed = 'COMPLETED',
  /** The payment request processing failed. */
  Failed = 'FAILED',
  /** The payment request currently being processed. */
  Processing = 'PROCESSING',
  /** The payment request is ready and queued to be processed. */
  Ready = 'READY'
}

/** The set of valid sort keys for the ShopPayPaymentRequestReceipts query. */
export enum ShopPayPaymentRequestReceiptsSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Represents a shipping line for a Shop Pay payment request. */
export type ShopPayPaymentRequestShippingLine = {
  __typename?: 'ShopPayPaymentRequestShippingLine';
  /** The amount for the shipping line. */
  amount: MoneyV2;
  /** The code of the shipping line. */
  code: Scalars['String']['output'];
  /** The label of the shipping line. */
  label: Scalars['String']['output'];
};

/** Represents a shipping total for a Shop Pay payment request. */
export type ShopPayPaymentRequestTotalShippingPrice = {
  __typename?: 'ShopPayPaymentRequestTotalShippingPrice';
  /** The discounts for the shipping total. */
  discounts: Array<ShopPayPaymentRequestDiscount>;
  /** The final total for the shipping line. */
  finalTotal: MoneyV2;
  /** The original total for the shipping line. */
  originalTotal?: Maybe<MoneyV2>;
};

/** The shop's billing plan and subscription details. Indicates the plan tier (such as Basic, Advanced, or Plus), whether the shop has a Shopify Plus subscription, and if it's a dev store for testing. */
export type ShopPlan = {
  __typename?: 'ShopPlan';
  /**
   * The name of the shop's billing plan.
   * @deprecated Use `publicDisplayName` instead.
   */
  displayName: Scalars['String']['output'];
  /** Whether the shop is a partner development shop for testing purposes. */
  partnerDevelopment: Scalars['Boolean']['output'];
  /** The public display name of the shop's billing plan. Possible values are: Advanced, Agentic, Agentic Enterprise, Basic, Development, Grow, Inactive, Lite, Other, Paused, Plus, Plus Trial, Retail, Shop Component, Staff Business, Starter, and Trial. */
  publicDisplayName: Scalars['String']['output'];
  /** Whether the shop has a Shopify Plus subscription. */
  shopifyPlus: Scalars['Boolean']['output'];
};

/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type ShopPolicy = HasPublishedTranslations & Node & {
  __typename?: 'ShopPolicy';
  /** The text of the policy. The maximum size is 512kb. */
  body: Scalars['HTML']['output'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the policy was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The translated title of the policy. For example, Refund Policy or Politique de remboursement. */
  title: Scalars['String']['output'];
  /** The published translations associated with the resource. */
  translations: Array<Translation>;
  /** The shop policy type. */
  type: ShopPolicyType;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the policy was last modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** The public URL of the policy. */
  url: Scalars['URL']['output'];
};


/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type ShopPolicyTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible error codes that can be returned by `ShopPolicyUserError`. */
export enum ShopPolicyErrorCode {
  /** The input value is too big. */
  TooBig = 'TOO_BIG'
}

/** The input fields required to update a policy. */
export type ShopPolicyInput = {
  /** Policy text, maximum size of 512kb. */
  body: Scalars['String']['input'];
  /** The shop policy type. */
  type: ShopPolicyType;
};

/** Available shop policy types. */
export enum ShopPolicyType {
  /** The contact information. */
  ContactInformation = 'CONTACT_INFORMATION',
  /** The legal notice. */
  LegalNotice = 'LEGAL_NOTICE',
  /** The privacy policy. */
  PrivacyPolicy = 'PRIVACY_POLICY',
  /** The refund policy. */
  RefundPolicy = 'REFUND_POLICY',
  /** The shipping policy. */
  ShippingPolicy = 'SHIPPING_POLICY',
  /** The cancellation policy. */
  SubscriptionPolicy = 'SUBSCRIPTION_POLICY',
  /** The terms of sale. */
  TermsOfSale = 'TERMS_OF_SALE',
  /** The terms of service. */
  TermsOfService = 'TERMS_OF_SERVICE'
}

/** Return type for `shopPolicyUpdate` mutation. */
export type ShopPolicyUpdatePayload = {
  __typename?: 'ShopPolicyUpdatePayload';
  /** The shop policy that has been updated. */
  shopPolicy?: Maybe<ShopPolicy>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopPolicyUserError>;
};

/** An error that occurs during the execution of a shop policy mutation. */
export type ShopPolicyUserError = DisplayableError & {
  __typename?: 'ShopPolicyUserError';
  /** The error code. */
  code?: Maybe<ShopPolicyErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Return type for `shopResourceFeedbackCreate` mutation. */
export type ShopResourceFeedbackCreatePayload = {
  __typename?: 'ShopResourceFeedbackCreatePayload';
  /** The shop feedback that's created. Returns `null` when `state: ACCEPTED` is used, because setting state to `ACCEPTED` clears the active feedback signal. A `null` value here indicates success, not an error. */
  feedback?: Maybe<AppFeedback>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopResourceFeedbackCreateUserError>;
};

/** An error that occurs during the execution of `ShopResourceFeedbackCreate`. */
export type ShopResourceFeedbackCreateUserError = DisplayableError & {
  __typename?: 'ShopResourceFeedbackCreateUserError';
  /** The error code. */
  code?: Maybe<ShopResourceFeedbackCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ShopResourceFeedbackCreateUserError`. */
export enum ShopResourceFeedbackCreateUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The feedback date cannot be set in the future. */
  FeedbackDateInFuture = 'FEEDBACK_DATE_IN_FUTURE',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The feedback for a later version of the resource was already accepted. */
  OutdatedFeedback = 'OUTDATED_FEEDBACK',
  /** The input value needs to be blank. */
  Present = 'PRESENT'
}

/** Resource limits of a shop. */
export type ShopResourceLimits = {
  __typename?: 'ShopResourceLimits';
  /** Maximum number of locations allowed. */
  locationLimit: Scalars['Int']['output'];
  /** Maximum number of product options allowed. */
  maxProductOptions: Scalars['Int']['output'];
  /** The maximum number of variants allowed per product. */
  maxProductVariants: Scalars['Int']['output'];
  /** Whether the shop has reached the limit of the number of URL redirects it can make for resources. */
  redirectLimitReached: Scalars['Boolean']['output'];
};

/** Possible sort of tags. */
export enum ShopTagSort {
  /** Alphabetical sort. */
  Alphabetical = 'ALPHABETICAL',
  /** Popularity sort. */
  Popular = 'POPULAR'
}

/** A Shopify Function. */
export type ShopifyFunction = {
  __typename?: 'ShopifyFunction';
  /** The API type of the Shopify Function. */
  apiType: Scalars['String']['output'];
  /** The API version of the Shopify Function. */
  apiVersion: Scalars['String']['output'];
  /** The app that owns the Shopify Function. */
  app: App;
  /** The App Bridge information for the Shopify Function. */
  appBridge: FunctionsAppBridge;
  /** The client ID of the app that owns the Shopify Function. */
  appKey: Scalars['String']['output'];
  /** The description of the Shopify Function. */
  description?: Maybe<Scalars['String']['output']>;
  /** The handle of the Shopify Function. */
  handle: Scalars['String']['output'];
  /** The ID of the Shopify Function. */
  id: Scalars['String']['output'];
  /** The input query of the Shopify Function. */
  inputQuery?: Maybe<Scalars['String']['output']>;
  /** The title of the Shopify Function. */
  title: Scalars['String']['output'];
  /** If the Shopify Function uses the creation UI in the Admin. */
  useCreationUi: Scalars['Boolean']['output'];
};

/** An auto-generated type for paginating through multiple ShopifyFunctions. */
export type ShopifyFunctionConnection = {
  __typename?: 'ShopifyFunctionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopifyFunctionEdge>;
  /** A list of nodes that are contained in ShopifyFunctionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopifyFunction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyFunction and a cursor during pagination. */
export type ShopifyFunctionEdge = {
  __typename?: 'ShopifyFunctionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopifyFunctionEdge. */
  node: ShopifyFunction;
};

export type ShopifyGraphQlCostExtension = {
  __typename?: 'ShopifyGraphQlCostExtension';
  actualQueryCost: Scalars['Int']['output'];
  requestedQueryCost: Scalars['Int']['output'];
  throttleStatus: ShopifyGraphQlCostExtensionThrottleStatus;
};

export type ShopifyGraphQlCostExtensionThrottleStatus = {
  __typename?: 'ShopifyGraphQlCostExtensionThrottleStatus';
  currentlyAvailable: Scalars['Int']['output'];
  maximumAvailable: Scalars['Int']['output'];
  restoreRate: Scalars['Int']['output'];
};

export type ShopifyGraphQlExtensions = {
  __typename?: 'ShopifyGraphQlExtensions';
  cost: ShopifyGraphQlCostExtension;
};

/**
 * Financial account information for merchants using Shopify Payments. Tracks current balances across all supported currencies, payout schedules, and [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records.
 *
 * The account includes configuration details such as [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) objects for receiving [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) transfers, statement descriptors that appear on customer credit card statements, and the [`ShopifyPaymentsPayoutSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSchedule) that determines when funds transfer to your bank. Access balance transactions to review individual charges, refunds, and adjustments that affect your account balance. Query payouts to track money movement between your Shopify Payments balance and bank accounts.
 */
export type ShopifyPaymentsAccount = Node & {
  __typename?: 'ShopifyPaymentsAccount';
  /** The name of the account opener. */
  accountOpenerName?: Maybe<Scalars['String']['output']>;
  /** Whether the Shopify Payments setup is completed. */
  activated: Scalars['Boolean']['output'];
  /** Current balances in all currencies for the account. */
  balance: Array<MoneyV2>;
  /** A list of balance transactions associated with the shop. */
  balanceTransactions: ShopifyPaymentsBalanceTransactionConnection;
  /** All bank accounts configured for the Shopify Payments account. */
  bankAccounts: ShopifyPaymentsBankAccountConnection;
  /**
   * The statement descriptor used for charges.
   *
   * The statement descriptor appears on a customer's credit card or bank statement when they make a purchase.
   * @deprecated Use `chargeStatementDescriptors` instead.
   */
  chargeStatementDescriptor?: Maybe<Scalars['String']['output']>;
  /**
   * The statement descriptors used for charges.
   *
   * These descriptors appear on a customer's credit card or bank statement when they make a purchase.
   */
  chargeStatementDescriptors?: Maybe<ShopifyPaymentsChargeStatementDescriptor>;
  /** The Shopify Payments account country. */
  country: Scalars['String']['output'];
  /** The default payout currency for the Shopify Payments account. */
  defaultCurrency: CurrencyCode;
  /** All disputes that originated from a transaction made with the Shopify Payments account. */
  disputes: ShopifyPaymentsDisputeConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Whether the Shopify Payments account can be onboarded. */
  onboardable: Scalars['Boolean']['output'];
  /** The payout schedule for the account. */
  payoutSchedule: ShopifyPaymentsPayoutSchedule;
  /**
   * The descriptor used for payouts.
   *
   * The descriptor appears on a merchant's bank statement when they receive a payout.
   */
  payoutStatementDescriptor?: Maybe<Scalars['String']['output']>;
  /** All current and previous payouts made between the account and the bank account. */
  payouts: ShopifyPaymentsPayoutConnection;
};


/**
 * Financial account information for merchants using Shopify Payments. Tracks current balances across all supported currencies, payout schedules, and [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records.
 *
 * The account includes configuration details such as [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) objects for receiving [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) transfers, statement descriptors that appear on customer credit card statements, and the [`ShopifyPaymentsPayoutSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSchedule) that determines when funds transfer to your bank. Access balance transactions to review individual charges, refunds, and adjustments that affect your account balance. Query payouts to track money movement between your Shopify Payments balance and bank accounts.
 */
export type ShopifyPaymentsAccountBalanceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hideTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<BalanceTransactionSortKeys>;
};


/**
 * Financial account information for merchants using Shopify Payments. Tracks current balances across all supported currencies, payout schedules, and [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records.
 *
 * The account includes configuration details such as [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) objects for receiving [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) transfers, statement descriptors that appear on customer credit card statements, and the [`ShopifyPaymentsPayoutSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSchedule) that determines when funds transfer to your bank. Access balance transactions to review individual charges, refunds, and adjustments that affect your account balance. Query payouts to track money movement between your Shopify Payments balance and bank accounts.
 */
export type ShopifyPaymentsAccountBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Financial account information for merchants using Shopify Payments. Tracks current balances across all supported currencies, payout schedules, and [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records.
 *
 * The account includes configuration details such as [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) objects for receiving [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) transfers, statement descriptors that appear on customer credit card statements, and the [`ShopifyPaymentsPayoutSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSchedule) that determines when funds transfer to your bank. Access balance transactions to review individual charges, refunds, and adjustments that affect your account balance. Query payouts to track money movement between your Shopify Payments balance and bank accounts.
 */
export type ShopifyPaymentsAccountDisputesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Financial account information for merchants using Shopify Payments. Tracks current balances across all supported currencies, payout schedules, and [`ShopifyPaymentsBalanceTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBalanceTransaction) records.
 *
 * The account includes configuration details such as [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount) objects for receiving [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) transfers, statement descriptors that appear on customer credit card statements, and the [`ShopifyPaymentsPayoutSchedule`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSchedule) that determines when funds transfer to your bank. Access balance transactions to review individual charges, refunds, and adjustments that affect your account balance. Query payouts to track money movement between your Shopify Payments balance and bank accounts.
 */
export type ShopifyPaymentsAccountPayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<PayoutSortKeys>;
  transactionType?: InputMaybe<ShopifyPaymentsPayoutTransactionType>;
};

/** A Shopify Payments address. */
export type ShopifyPaymentsAddressBasic = {
  __typename?: 'ShopifyPaymentsAddressBasic';
  /** Line 1 of the address. */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Line 2 of the address. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The address city. */
  city?: Maybe<Scalars['String']['output']>;
  /** The address country. */
  country?: Maybe<Scalars['String']['output']>;
  /** The address postal code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The address state/province/zone. */
  zone?: Maybe<Scalars['String']['output']>;
};

/** The adjustment order object. */
export type ShopifyPaymentsAdjustmentOrder = {
  __typename?: 'ShopifyPaymentsAdjustmentOrder';
  /** The amount of the adjustment order. */
  amount: MoneyV2;
  /** The fee of the adjustment order. */
  fees: MoneyV2;
  /** The link to the adjustment order. */
  link: Scalars['URL']['output'];
  /** The name of the adjustment order. */
  name: Scalars['String']['output'];
  /** The net of the adjustment order. */
  net: MoneyV2;
  /** The ID of the order transaction. */
  orderTransactionId: Scalars['BigInt']['output'];
};

/** The order associated to the balance transaction. */
export type ShopifyPaymentsAssociatedOrder = {
  __typename?: 'ShopifyPaymentsAssociatedOrder';
  /** The ID of the associated order. */
  id: Scalars['ID']['output'];
  /** The name of the associated order. */
  name: Scalars['String']['output'];
};

/** A transaction that contributes to a Shopify Payments account balance. Records money movement from charges, refunds, payouts, adjustments, or other payment activities. Includes the gross amount, processing fees, and resulting net amount that affects the account balance. Links to the source of the transaction and associated [`ShopifyPaymentsPayout`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout) details, with optional references to [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order) objects or adjustment reasons when applicable. */
export type ShopifyPaymentsBalanceTransaction = Node & {
  __typename?: 'ShopifyPaymentsBalanceTransaction';
  /**
   * The reason for the adjustment that's associated with the transaction.
   *             If the source_type isn't an adjustment, the value will be null.
   */
  adjustmentReason?: Maybe<Scalars['String']['output']>;
  /** The adjustment orders associated to the transaction. */
  adjustmentsOrders: Array<ShopifyPaymentsAdjustmentOrder>;
  /** The amount contributing to the balance transaction. */
  amount: MoneyV2;
  /** The associated order for the balance transaction. */
  associatedOrder?: Maybe<ShopifyPaymentsAssociatedOrder>;
  /** Payout assoicated with the transaction. */
  associatedPayout: ShopifyPaymentsBalanceTransactionAssociatedPayout;
  /** The fee amount contributing to the balance transaction. */
  fee: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The net amount contributing to the merchant's balance. */
  net: MoneyV2;
  /** The ID of the resource leading to the transaction. */
  sourceId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * The id of the
   *             [Order Transaction](https://shopify.dev/docs/admin-api/rest/reference/orders/transaction)
   *
   *             that resulted in this balance transaction.
   */
  sourceOrderTransactionId?: Maybe<Scalars['BigInt']['output']>;
  /** The source type of the balance transaction. */
  sourceType?: Maybe<ShopifyPaymentsSourceType>;
  /** Wether the tranaction was created in test mode. */
  test: Scalars['Boolean']['output'];
  /** The date and time when the balance transaction was processed. */
  transactionDate: Scalars['DateTime']['output'];
  /** The type of transaction. */
  type: ShopifyPaymentsTransactionType;
};

/** The payout associated with a balance transaction. */
export type ShopifyPaymentsBalanceTransactionAssociatedPayout = {
  __typename?: 'ShopifyPaymentsBalanceTransactionAssociatedPayout';
  /** The ID of the payout associated with the balance transaction. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The status of the payout associated with the balance transaction. */
  status?: Maybe<ShopifyPaymentsBalanceTransactionPayoutStatus>;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsBalanceTransactions. */
export type ShopifyPaymentsBalanceTransactionConnection = {
  __typename?: 'ShopifyPaymentsBalanceTransactionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopifyPaymentsBalanceTransactionEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsBalanceTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopifyPaymentsBalanceTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsBalanceTransaction and a cursor during pagination. */
export type ShopifyPaymentsBalanceTransactionEdge = {
  __typename?: 'ShopifyPaymentsBalanceTransactionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopifyPaymentsBalanceTransactionEdge. */
  node: ShopifyPaymentsBalanceTransaction;
};

/** The payout status of the balance transaction. */
export enum ShopifyPaymentsBalanceTransactionPayoutStatus {
  /** The transaction requires action before it can be paid out. */
  ActionRequired = 'ACTION_REQUIRED',
  /** The payout has been canceled by Shopify. */
  Canceled = 'CANCELED',
  /** The payout has been declined by the bank. */
  Failed = 'FAILED',
  /**
   * The payout has been submitted to the bank.
   * @deprecated Use `SCHEDULED` instead.
   */
  InTransit = 'IN_TRANSIT',
  /** The payout has been successfully deposited into the bank. */
  Paid = 'PAID',
  /** The transaction has not been assigned a payout yet. */
  Pending = 'PENDING',
  /**
   * The payout has been created and had transactions assigned to it, but
   * it has not yet been submitted to the bank.
   */
  Scheduled = 'SCHEDULED'
}

/** A bank account that can receive payouts. */
export type ShopifyPaymentsBankAccount = Node & {
  __typename?: 'ShopifyPaymentsBankAccount';
  /** The last digits of the account number (the rest is redacted). */
  accountNumberLastDigits: Scalars['String']['output'];
  /** The name of the bank. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** The country of the bank. */
  country: CountryCode;
  /** The date that the bank account was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency of the bank account. */
  currency: CurrencyCode;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** All current and previous payouts made between the account and the bank account. */
  payouts: ShopifyPaymentsPayoutConnection;
  /** The status of the bank account. */
  status: ShopifyPaymentsBankAccountStatus;
};


/** A bank account that can receive payouts. */
export type ShopifyPaymentsBankAccountPayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  savedSearchId?: InputMaybe<Scalars['ID']['input']>;
  sortKey?: InputMaybe<PayoutSortKeys>;
  transactionType?: InputMaybe<ShopifyPaymentsPayoutTransactionType>;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsBankAccounts. */
export type ShopifyPaymentsBankAccountConnection = {
  __typename?: 'ShopifyPaymentsBankAccountConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopifyPaymentsBankAccountEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsBankAccountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopifyPaymentsBankAccount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsBankAccount and a cursor during pagination. */
export type ShopifyPaymentsBankAccountEdge = {
  __typename?: 'ShopifyPaymentsBankAccountEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopifyPaymentsBankAccountEdge. */
  node: ShopifyPaymentsBankAccount;
};

/** The bank account status. */
export enum ShopifyPaymentsBankAccountStatus {
  /** A payout to the bank account failed. */
  Errored = 'ERRORED',
  /** A bank account that hasn't had any activity and that's not validated. */
  New = 'NEW',
  /** It was determined that the bank account exists. */
  Validated = 'VALIDATED',
  /** Bank account validation was successful. */
  Verified = 'VERIFIED'
}

/** The business type of a Shopify Payments account. */
export enum ShopifyPaymentsBusinessType {
  /** The business type is a corporation. */
  Corporation = 'CORPORATION',
  /** The business type is a free zone establishment. */
  FreeZoneEstablishment = 'FREE_ZONE_ESTABLISHMENT',
  /** The business type is a free zone LLC. */
  FreeZoneLlc = 'FREE_ZONE_LLC',
  /** The business type is a government. */
  Government = 'GOVERNMENT',
  /** The business type is an incorporated partnership. */
  IncorporatedPartnership = 'INCORPORATED_PARTNERSHIP',
  /** The business is an individual. */
  Individual = 'INDIVIDUAL',
  /** The business type is a Limited Liability Company. */
  Llc = 'LLC',
  /** The business type is a non profit. */
  NonProfit = 'NON_PROFIT',
  /** The business type is a non profit (incorporated). */
  NonProfitIncorporated = 'NON_PROFIT_INCORPORATED',
  /** The business type is a non profit (registered charity). */
  NonProfitRegisteredCharity = 'NON_PROFIT_REGISTERED_CHARITY',
  /** The business type is a non profit (unincorporated). */
  NonProfitUnincorporated = 'NON_PROFIT_UNINCORPORATED',
  /** The business type is a non profit (unincorporated_association). */
  NonProfitUnincorporatedAssociation = 'NON_PROFIT_UNINCORPORATED_ASSOCIATION',
  /** The business type is not set. This is usually because onboarding is incomplete. */
  NotSet = 'NOT_SET',
  /** The business type is a partnership. */
  Partnership = 'PARTNERSHIP',
  /** The business type is a private corporation. */
  PrivateCorporation = 'PRIVATE_CORPORATION',
  /** The business type is a private multi member LLC. */
  PrivateMultiMemberLlc = 'PRIVATE_MULTI_MEMBER_LLC',
  /** The business type is a private partnership. */
  PrivatePartnership = 'PRIVATE_PARTNERSHIP',
  /** The business type is a private single member LLC. */
  PrivateSingleMemberLlc = 'PRIVATE_SINGLE_MEMBER_LLC',
  /** The business type is a private unincorporated association. */
  PrivateUnincorporatedAssociation = 'PRIVATE_UNINCORPORATED_ASSOCIATION',
  /** The business type is a public company. */
  PublicCompany = 'PUBLIC_COMPANY',
  /** The business type is a public corporation. */
  PublicCorporation = 'PUBLIC_CORPORATION',
  /** The business type is a public partnership. */
  PublicPartnership = 'PUBLIC_PARTNERSHIP',
  /** The business type is a sole establishment. */
  SoleEstablishment = 'SOLE_ESTABLISHMENT',
  /** The business type is a sole proprietorship. */
  SoleProp = 'SOLE_PROP',
  /** The business type is an unincorporated partnership. */
  UnincorporatedPartnership = 'UNINCORPORATED_PARTNERSHIP'
}

/** The charge descriptors for a payments account. */
export type ShopifyPaymentsChargeStatementDescriptor = {
  /** The default charge statement descriptor. */
  default?: Maybe<Scalars['String']['output']>;
  /** The prefix of the statement descriptor. */
  prefix: Scalars['String']['output'];
};

/** The charge descriptors for a payments account. */
export type ShopifyPaymentsDefaultChargeStatementDescriptor = ShopifyPaymentsChargeStatementDescriptor & {
  __typename?: 'ShopifyPaymentsDefaultChargeStatementDescriptor';
  /** The default charge statement descriptor. */
  default?: Maybe<Scalars['String']['output']>;
  /** The prefix of the statement descriptor. */
  prefix: Scalars['String']['output'];
};

/** A dispute occurs when a buyer questions the legitimacy of a charge with their financial institution. */
export type ShopifyPaymentsDispute = LegacyInteroperability & Node & {
  __typename?: 'ShopifyPaymentsDispute';
  /** The total amount disputed by the cardholder. */
  amount: MoneyV2;
  /** The evidence associated with the dispute. */
  disputeEvidence: ShopifyPaymentsDisputeEvidence;
  /** The deadline for evidence submission. */
  evidenceDueBy?: Maybe<Scalars['DateTime']['output']>;
  /** The date when evidence was sent. Returns null if evidence hasn't yet been sent. */
  evidenceSentOn?: Maybe<Scalars['DateTime']['output']>;
  /** The date when this dispute was resolved. Returns null if the dispute isn't yet resolved. */
  finalizedOn?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The date when this dispute was initiated. */
  initiatedAt: Scalars['DateTime']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The order that contains the charge that's under dispute. */
  order?: Maybe<Order>;
  /** The reason of the dispute. */
  reasonDetails: ShopifyPaymentsDisputeReasonDetails;
  /** The current state of the dispute. */
  status: DisputeStatus;
  /** Indicates if this dispute is still in the inquiry phase or has turned into a chargeback. */
  type: DisputeType;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsDisputes. */
export type ShopifyPaymentsDisputeConnection = {
  __typename?: 'ShopifyPaymentsDisputeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopifyPaymentsDisputeEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsDisputeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopifyPaymentsDispute>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsDispute and a cursor during pagination. */
export type ShopifyPaymentsDisputeEdge = {
  __typename?: 'ShopifyPaymentsDisputeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopifyPaymentsDisputeEdge. */
  node: ShopifyPaymentsDispute;
};

/** The evidence associated with the dispute. */
export type ShopifyPaymentsDisputeEvidence = Node & {
  __typename?: 'ShopifyPaymentsDisputeEvidence';
  /** The activity logs associated with the dispute evidence. */
  accessActivityLog?: Maybe<Scalars['String']['output']>;
  /** The billing address that's provided by the customer. */
  billingAddress?: Maybe<MailingAddress>;
  /** The cancellation policy disclosure associated with the dispute evidence. */
  cancellationPolicyDisclosure?: Maybe<Scalars['String']['output']>;
  /** The cancellation policy file associated with the dispute evidence. */
  cancellationPolicyFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The cancellation rebuttal associated with the dispute evidence. */
  cancellationRebuttal?: Maybe<Scalars['String']['output']>;
  /** The customer communication file associated with the dispute evidence. */
  customerCommunicationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The customer's email address. */
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  /** The customer's first name. */
  customerFirstName?: Maybe<Scalars['String']['output']>;
  /** The customer's last name. */
  customerLastName?: Maybe<Scalars['String']['output']>;
  /** The customer purchase ip for this dispute evidence. */
  customerPurchaseIp?: Maybe<Scalars['String']['output']>;
  /** The dispute associated with the evidence. */
  dispute: ShopifyPaymentsDispute;
  /** The file uploads associated with the dispute evidence. */
  disputeFileUploads: Array<ShopifyPaymentsDisputeFileUpload>;
  /** The fulfillments associated with the dispute evidence. */
  fulfillments: Array<ShopifyPaymentsDisputeFulfillment>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product description for this dispute evidence. */
  productDescription?: Maybe<Scalars['String']['output']>;
  /** The refund policy disclosure associated with the dispute evidence. */
  refundPolicyDisclosure?: Maybe<Scalars['String']['output']>;
  /** The refund policy file associated with the dispute evidence. */
  refundPolicyFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The refund refusal explanation associated with dispute evidence. */
  refundRefusalExplanation?: Maybe<Scalars['String']['output']>;
  /** The service documentation file associated with the dispute evidence. */
  serviceDocumentationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The mailing address for shipping that's provided by the customer. */
  shippingAddress?: Maybe<MailingAddress>;
  /** The shipping documentation file associated with the dispute evidence. */
  shippingDocumentationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** Whether the dispute evidence is submitted. */
  submitted: Scalars['Boolean']['output'];
  /** The uncategorized file associated with the dispute evidence. */
  uncategorizedFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The uncategorized text for the dispute evidence. */
  uncategorizedText?: Maybe<Scalars['String']['output']>;
};

/** The possible dispute evidence file types. */
export enum ShopifyPaymentsDisputeEvidenceFileType {
  /** Cancellation Policy File. */
  CancellationPolicyFile = 'CANCELLATION_POLICY_FILE',
  /** Customer Communication File. */
  CustomerCommunicationFile = 'CUSTOMER_COMMUNICATION_FILE',
  /** Refund Policy File. */
  RefundPolicyFile = 'REFUND_POLICY_FILE',
  /** Response Summary File. */
  ResponseSummaryFile = 'RESPONSE_SUMMARY_FILE',
  /** Service Documentation File. */
  ServiceDocumentationFile = 'SERVICE_DOCUMENTATION_FILE',
  /** Shipping Documentation File. */
  ShippingDocumentationFile = 'SHIPPING_DOCUMENTATION_FILE',
  /** Uncategorized File. */
  UncategorizedFile = 'UNCATEGORIZED_FILE'
}

/** The input fields required to update a dispute evidence object. */
export type ShopifyPaymentsDisputeEvidenceUpdateInput = {
  /** Activity logs. */
  accessActivityLog?: InputMaybe<Scalars['String']['input']>;
  /** Cancellation policy disclosure. */
  cancellationPolicyDisclosure?: InputMaybe<Scalars['String']['input']>;
  /** Cancellation policy file. */
  cancellationPolicyFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Cancellation rebuttal. */
  cancellationRebuttal?: InputMaybe<Scalars['String']['input']>;
  /** Customer communication file. */
  customerCommunicationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Customer email address. */
  customerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Customer first name. */
  customerFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Customer last name. */
  customerLastName?: InputMaybe<Scalars['String']['input']>;
  /** Refund policy disclosure. */
  refundPolicyDisclosure?: InputMaybe<Scalars['String']['input']>;
  /** Refund policy file. */
  refundPolicyFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Refund refusal explanation. */
  refundRefusalExplanation?: InputMaybe<Scalars['String']['input']>;
  /** Service documentation file. */
  serviceDocumentationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** The shipping address associated with the dispute evidence. */
  shippingAddress?: InputMaybe<MailingAddressInput>;
  /** Shipping documentation file. */
  shippingDocumentationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Uncategorized file. */
  uncategorizedFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Uncategorized text. */
  uncategorizedText?: InputMaybe<Scalars['String']['input']>;
};

/** The file upload associated with the dispute evidence. */
export type ShopifyPaymentsDisputeFileUpload = Node & {
  __typename?: 'ShopifyPaymentsDisputeFileUpload';
  /** The type of the file for the dispute evidence. */
  disputeEvidenceType?: Maybe<ShopifyPaymentsDisputeEvidenceFileType>;
  /** The file size. */
  fileSize: Scalars['Int']['output'];
  /** The file type. */
  fileType: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The original file name. */
  originalFileName?: Maybe<Scalars['String']['output']>;
  /** The URL for accessing the file. */
  url: Scalars['URL']['output'];
};

/** The input fields required to update a dispute file upload object. */
export type ShopifyPaymentsDisputeFileUploadUpdateInput = {
  /** Whether to delete this file upload. */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the file upload to be updated. */
  id: Scalars['ID']['input'];
};

/** The fulfillment associated with dispute evidence. */
export type ShopifyPaymentsDisputeFulfillment = Node & {
  __typename?: 'ShopifyPaymentsDisputeFulfillment';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The shipping carrier for this fulfillment. */
  shippingCarrier?: Maybe<Scalars['String']['output']>;
  /** The shipping date for this fulfillment. */
  shippingDate?: Maybe<Scalars['Date']['output']>;
  /** The shipping tracking number for this fulfillment. */
  shippingTrackingNumber?: Maybe<Scalars['String']['output']>;
};

/** The reason for the dispute provided by the cardholder's bank. */
export enum ShopifyPaymentsDisputeReason {
  /** The customer's bank can't process the charge. */
  BankCannotProcess = 'BANK_CANNOT_PROCESS',
  /** The customer claims that the purchased product was returned or the transaction was otherwise canceled, but you haven't yet provided a refund or credit. */
  CreditNotProcessed = 'CREDIT_NOT_PROCESSED',
  /** The customer initiated the dispute. Contact the customer for additional details on why the payment was disputed. */
  CustomerInitiated = 'CUSTOMER_INITIATED',
  /** The customer's bank can't proceed with the debit since it hasn't been authorized. */
  DebitNotAuthorized = 'DEBIT_NOT_AUTHORIZED',
  /** The customer claims they were charged multiple times for the same product or service. */
  Duplicate = 'DUPLICATE',
  /** The cardholder claims that they didn’t authorize the payment. */
  Fraudulent = 'FRAUDULENT',
  /** The dispute is uncategorized, so you should contact the customer for additional details to find out why the payment was disputed. */
  General = 'GENERAL',
  /** The customer account associated with the purchase is incorrect. */
  IncorrectAccountDetails = 'INCORRECT_ACCOUNT_DETAILS',
  /** The customer's bank account has insufficient funds. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The card issuer believes the disputed transaction doesn't conform to the network rules. These disputes occur when transactions don't meet card network requirements and may incur additional network fees if escalated for resolution. */
  Noncompliant = 'NONCOMPLIANT',
  /** The customer claims they did not receive the products or services purchased. */
  ProductNotReceived = 'PRODUCT_NOT_RECEIVED',
  /** The product or service was received but was defective, damaged, or not as described. */
  ProductUnacceptable = 'PRODUCT_UNACCEPTABLE',
  /** The customer claims that you continued to charge them after a subscription was canceled. */
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  /** The customer doesn’t recognize the payment appearing on their card statement. */
  Unrecognized = 'UNRECOGNIZED'
}

/** Details regarding a dispute reason. */
export type ShopifyPaymentsDisputeReasonDetails = {
  __typename?: 'ShopifyPaymentsDisputeReasonDetails';
  /** The raw code provided by the payment network. */
  networkReasonCode?: Maybe<Scalars['String']['output']>;
  /** The reason for the dispute provided by the cardholder's banks. */
  reason: ShopifyPaymentsDisputeReason;
};

/** Presents all Shopify Payments information related to an extended authorization. */
export type ShopifyPaymentsExtendedAuthorization = {
  __typename?: 'ShopifyPaymentsExtendedAuthorization';
  /** The time after which the extended authorization expires. After the expiry, the merchant is unable to capture the payment. */
  extendedAuthorizationExpiresAt: Scalars['DateTime']['output'];
  /** The time after which capture will incur an additional fee. */
  standardAuthorizationExpiresAt: Scalars['DateTime']['output'];
};

/** The charge descriptors for a Japanese payments account. */
export type ShopifyPaymentsJpChargeStatementDescriptor = ShopifyPaymentsChargeStatementDescriptor & {
  __typename?: 'ShopifyPaymentsJpChargeStatementDescriptor';
  /** The default charge statement descriptor. */
  default?: Maybe<Scalars['String']['output']>;
  /**
   * The charge statement descriptor in kana.
   * @deprecated This field is deprecated and will be removed in a future release.
   */
  kana?: Maybe<Scalars['String']['output']>;
  /**
   * The charge statement descriptor in kanji.
   * @deprecated This field is deprecated and will be removed in a future release.
   */
  kanji?: Maybe<Scalars['String']['output']>;
  /** The prefix of the statement descriptor. */
  prefix: Scalars['String']['output'];
};

/** A MerchantCategoryCode (MCC) is a four-digit number listed in ISO 18245 for retail financial services and used to classify the business by the type of goods or services it provides. */
export type ShopifyPaymentsMerchantCategoryCode = {
  __typename?: 'ShopifyPaymentsMerchantCategoryCode';
  /** The category of the MCC. */
  category: Scalars['String']['output'];
  /** The category label of the MCC. */
  categoryLabel: Scalars['String']['output'];
  /** A four-digit number listed in ISO 18245. */
  code: Scalars['Int']['output'];
  /** The ID of the MCC. */
  id: Scalars['Int']['output'];
  /** The subcategory label of the MCC. */
  subcategoryLabel: Scalars['String']['output'];
};

/**
 * A transfer of funds between a merchant's Shopify Payments balance and their [`ShopifyPaymentsBankAccount`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsBankAccount). Provides the [net amount](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout#field-ShopifyPaymentsPayout.fields.net), [issue date](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayout#field-ShopifyPaymentsPayout.fields.issuedAt), and current [`ShopifyPaymentsPayoutStatus`](https://shopify.dev/docs/api/admin-graphql/latest/enums/ShopifyPaymentsPayoutStatus).
 *
 * The payout includes a [`ShopifyPaymentsPayoutSummary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShopifyPaymentsPayoutSummary) that breaks down fees and gross amounts by transaction type, such as charges, refunds, and adjustments. The [`ShopifyPaymentsPayoutTransactionType`](https://shopify.dev/docs/api/admin-graphql/latest/enums/ShopifyPaymentsPayoutTransactionType) indicates whether funds move into the bank account (deposit) or back to Shopify Payments (withdrawal).
 */
export type ShopifyPaymentsPayout = LegacyInteroperability & Node & {
  __typename?: 'ShopifyPaymentsPayout';
  /**
   * The bank account for the payout.
   * @deprecated Use `destinationAccount` instead.
   */
  bankAccount?: Maybe<ShopifyPaymentsBankAccount>;
  /** The business entity associated with the payout. */
  businessEntity: BusinessEntity;
  /** A unique trace ID from the financial institution. Use this reference number to track the payout with your provider. */
  externalTraceId?: Maybe<Scalars['String']['output']>;
  /**
   * The total amount and currency of the payout.
   * @deprecated Use `net` instead.
   */
  gross: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The exact time when the payout was issued. The payout only contains
   * balance transactions that were available at this time.
   */
  issuedAt: Scalars['DateTime']['output'];
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The total amount and currency of the payout. */
  net: MoneyV2;
  /** The transfer status of the payout. */
  status: ShopifyPaymentsPayoutStatus;
  /** The summary of the payout. */
  summary: ShopifyPaymentsPayoutSummary;
  /** The direction of the payout. */
  transactionType: ShopifyPaymentsPayoutTransactionType;
};

/** Return type for `shopifyPaymentsPayoutAlternateCurrencyCreate` mutation. */
export type ShopifyPaymentsPayoutAlternateCurrencyCreatePayload = {
  __typename?: 'ShopifyPaymentsPayoutAlternateCurrencyCreatePayload';
  /** The resulting alternate currency payout created. */
  payout?: Maybe<ShopifyPaymentsToolingProviderPayout>;
  /** Whether the alternate currency payout was created successfully. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyPaymentsPayoutAlternateCurrencyCreateUserError>;
};

/** An error that occurs during the execution of `ShopifyPaymentsPayoutAlternateCurrencyCreate`. */
export type ShopifyPaymentsPayoutAlternateCurrencyCreateUserError = DisplayableError & {
  __typename?: 'ShopifyPaymentsPayoutAlternateCurrencyCreateUserError';
  /** The error code. */
  code?: Maybe<ShopifyPaymentsPayoutAlternateCurrencyCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ShopifyPaymentsPayoutAlternateCurrencyCreateUserError`. */
export enum ShopifyPaymentsPayoutAlternateCurrencyCreateUserErrorCode {
  /** Failed to create payout, there is no eligible balance in this currency. */
  AlternateCurrencyPayoutFailedNoEligibleBalance = 'ALTERNATE_CURRENCY_PAYOUT_FAILED_NO_ELIGIBLE_BALANCE',
  /** Failed to create payout due to an error from Stripe. */
  AlternateCurrencyPayoutFailedStripeError = 'ALTERNATE_CURRENCY_PAYOUT_FAILED_STRIPE_ERROR',
  /** No Stripe provider account was found. */
  MissingProviderAccount = 'MISSING_PROVIDER_ACCOUNT',
  /** Failed to create payout due to an error from Shopify Core. */
  UnknownCoreError = 'UNKNOWN_CORE_ERROR'
}

/** An auto-generated type for paginating through multiple ShopifyPaymentsPayouts. */
export type ShopifyPaymentsPayoutConnection = {
  __typename?: 'ShopifyPaymentsPayoutConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ShopifyPaymentsPayoutEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsPayoutEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<ShopifyPaymentsPayout>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsPayout and a cursor during pagination. */
export type ShopifyPaymentsPayoutEdge = {
  __typename?: 'ShopifyPaymentsPayoutEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ShopifyPaymentsPayoutEdge. */
  node: ShopifyPaymentsPayout;
};

/** The interval at which payouts are sent to the connected bank account. */
export enum ShopifyPaymentsPayoutInterval {
  /** Each business day. */
  Daily = 'DAILY',
  /** Payouts will not be automatically made. */
  Manual = 'MANUAL',
  /** Each month, on the day of month specified by monthlyAnchor. */
  Monthly = 'MONTHLY',
  /** Each week, on the day of week specified by weeklyAnchor. */
  Weekly = 'WEEKLY'
}

/** The payment schedule for a payments account. */
export type ShopifyPaymentsPayoutSchedule = {
  __typename?: 'ShopifyPaymentsPayoutSchedule';
  /** The interval at which payouts are sent to the connected bank account. */
  interval: ShopifyPaymentsPayoutInterval;
  /**
   * The day of the month funds will be paid out.
   *
   * The value can be any day of the month from the 1st to the 31st.
   * If the payment interval is set to monthly, this value will be used.
   * Payouts scheduled between 29-31st of the month are sent on the last day of shorter months.
   */
  monthlyAnchor?: Maybe<Scalars['Int']['output']>;
  /**
   * The day of the week funds will be paid out.
   *
   * The value can be any weekday from Monday to Friday.
   * If the payment interval is set to weekly, this value will be used.
   */
  weeklyAnchor?: Maybe<DayOfTheWeek>;
};

/** The transfer status of the payout. */
export enum ShopifyPaymentsPayoutStatus {
  /** The payout has been canceled by Shopify. */
  Canceled = 'CANCELED',
  /** The payout has been declined by the bank. */
  Failed = 'FAILED',
  /**
   * The payout has been submitted to the bank.
   * @deprecated Use `SCHEDULED` instead.
   */
  InTransit = 'IN_TRANSIT',
  /** The payout has been successfully deposited into the bank. */
  Paid = 'PAID',
  /**
   * The payout has been created and had transactions assigned to it, but
   * it has not yet been submitted to the bank.
   */
  Scheduled = 'SCHEDULED'
}

/**
 * Breakdown of the total fees and gross of each of the different types of transactions associated
 * with the payout.
 */
export type ShopifyPaymentsPayoutSummary = {
  __typename?: 'ShopifyPaymentsPayoutSummary';
  /** Total fees for all adjustments including disputes. */
  adjustmentsFee: MoneyV2;
  /** Total gross amount for all adjustments including disputes. */
  adjustmentsGross: MoneyV2;
  /** Total fees for all advances. */
  advanceFees: MoneyV2;
  /** Total gross amount for all advances. */
  advanceGross: MoneyV2;
  /** Total fees for all charges. */
  chargesFee: MoneyV2;
  /** Total gross amount for all charges. */
  chargesGross: MoneyV2;
  /** Total fees for all refunds. */
  refundsFee: MoneyV2;
  /** Total gross amount for all refunds. */
  refundsFeeGross: MoneyV2;
  /** Total fees for all reserved funds. */
  reservedFundsFee: MoneyV2;
  /** Total gross amount for all reserved funds. */
  reservedFundsGross: MoneyV2;
  /** Total fees for all retried payouts. */
  retriedPayoutsFee: MoneyV2;
  /** Total gross amount for all retried payouts. */
  retriedPayoutsGross: MoneyV2;
  /** Total amount for all usdc rebate credit balance adjustments. */
  usdcRebateCreditAmount: MoneyV2;
};

/** The possible transaction types for a payout. */
export enum ShopifyPaymentsPayoutTransactionType {
  /** The payout is a deposit. */
  Deposit = 'DEPOSIT',
  /** The payout is a withdrawal. */
  Withdrawal = 'WITHDRAWAL'
}

/** Presents all Shopify Payments specific information related to an order refund. */
export type ShopifyPaymentsRefundSet = {
  __typename?: 'ShopifyPaymentsRefundSet';
  /** The acquirer reference number (ARN) code generated for Visa/Mastercard transactions. */
  acquirerReferenceNumber?: Maybe<Scalars['String']['output']>;
};

/** The possible source types for a balance transaction. */
export enum ShopifyPaymentsSourceType {
  /** The adjustment source type. */
  Adjustment = 'ADJUSTMENT',
  /** The adjustment_reversal source type. */
  AdjustmentReversal = 'ADJUSTMENT_REVERSAL',
  /** The charge source type. */
  Charge = 'CHARGE',
  /** The dispute source type. */
  Dispute = 'DISPUTE',
  /** The refund source type. */
  Refund = 'REFUND',
  /** The system_adjustment source type. */
  SystemAdjustment = 'SYSTEM_ADJUSTMENT',
  /** The transfer source type. */
  Transfer = 'TRANSFER'
}

/** A typed identifier that represents an individual within a tax jurisdiction. */
export type ShopifyPaymentsTaxIdentification = {
  __typename?: 'ShopifyPaymentsTaxIdentification';
  /** The type of the identification. */
  taxIdentificationType: ShopifyPaymentsTaxIdentificationType;
  /** The value of the identification. */
  value: Scalars['String']['output'];
};

/** The type of tax identification field. */
export enum ShopifyPaymentsTaxIdentificationType {
  /** Business EIN. */
  Ein = 'EIN',
  /** Full SSN. */
  FullSsn = 'FULL_SSN',
  /** The last 4 digits of the SSN. */
  SsnLast4Digits = 'SSN_LAST4_DIGITS'
}

/** Relevant reference information for an alternate currency payout. */
export type ShopifyPaymentsToolingProviderPayout = {
  __typename?: 'ShopifyPaymentsToolingProviderPayout';
  /** The balance amount the alternate currency payout was created for. */
  amount: MoneyV2;
  /** A timestamp for the arrival of the alternate currency payout. */
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  /** A timestamp for the creation of the alternate currency payout. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The currency alternate currency payout was created in. */
  currency: Scalars['String']['output'];
  /** The remote ID for the alternate currency payout. */
  remoteId: Scalars['String']['output'];
};

/** Presents all Shopify Payments specific information related to an order transaction. */
export type ShopifyPaymentsTransactionSet = {
  __typename?: 'ShopifyPaymentsTransactionSet';
  /** Contains all fields related to an extended authorization. */
  extendedAuthorizationSet?: Maybe<ShopifyPaymentsExtendedAuthorization>;
  /** Contains all fields related to a refund. */
  refundSet?: Maybe<ShopifyPaymentsRefundSet>;
};

/** The possible types of transactions. */
export enum ShopifyPaymentsTransactionType {
  /** The ach_bank_failure_debit_fee transaction type. */
  AchBankFailureDebitFee = 'ACH_BANK_FAILURE_DEBIT_FEE',
  /** The ach_bank_failure_debit_reversal_fee transaction type. */
  AchBankFailureDebitReversalFee = 'ACH_BANK_FAILURE_DEBIT_REVERSAL_FEE',
  /** The adjustment transaction type. */
  Adjustment = 'ADJUSTMENT',
  /** The ads_publisher_credit transaction type. */
  AdsPublisherCredit = 'ADS_PUBLISHER_CREDIT',
  /** The ads_publisher_credit_reversal transaction type. */
  AdsPublisherCreditReversal = 'ADS_PUBLISHER_CREDIT_REVERSAL',
  /** The advance transaction type. */
  Advance = 'ADVANCE',
  /** The advance funding transaction type. */
  AdvanceFunding = 'ADVANCE_FUNDING',
  /** The anomaly_credit transaction type. */
  AnomalyCredit = 'ANOMALY_CREDIT',
  /** The anomaly_credit_reversal transaction type. */
  AnomalyCreditReversal = 'ANOMALY_CREDIT_REVERSAL',
  /** The anomaly_debit transaction type. */
  AnomalyDebit = 'ANOMALY_DEBIT',
  /** The anomaly_debit_reversal transaction type. */
  AnomalyDebitReversal = 'ANOMALY_DEBIT_REVERSAL',
  /** The application_fee_refund transaction type. */
  ApplicationFeeRefund = 'APPLICATION_FEE_REFUND',
  /** The balance_transfer_inbound transaction type. */
  BalanceTransferInbound = 'BALANCE_TRANSFER_INBOUND',
  /** The balance_transfer_outbound transaction type. */
  BalanceTransferOutbound = 'BALANCE_TRANSFER_OUTBOUND',
  /** The billing_debit transaction type. */
  BillingDebit = 'BILLING_DEBIT',
  /** The billing_debit_reversal transaction type. */
  BillingDebitReversal = 'BILLING_DEBIT_REVERSAL',
  /** The channel_credit transaction type. */
  ChannelCredit = 'CHANNEL_CREDIT',
  /** The channel_credit_reversal transaction type. */
  ChannelCreditReversal = 'CHANNEL_CREDIT_REVERSAL',
  /** The channel_promotion_credit transaction type. */
  ChannelPromotionCredit = 'CHANNEL_PROMOTION_CREDIT',
  /** The channel_promotion_credit_reversal transaction type. */
  ChannelPromotionCreditReversal = 'CHANNEL_PROMOTION_CREDIT_REVERSAL',
  /** The channel_transfer_credit transaction type. */
  ChannelTransferCredit = 'CHANNEL_TRANSFER_CREDIT',
  /** The channel_transfer_credit_reversal transaction type. */
  ChannelTransferCreditReversal = 'CHANNEL_TRANSFER_CREDIT_REVERSAL',
  /** The channel_transfer_debit transaction type. */
  ChannelTransferDebit = 'CHANNEL_TRANSFER_DEBIT',
  /** The channel_transfer_debit_reversal transaction type. */
  ChannelTransferDebitReversal = 'CHANNEL_TRANSFER_DEBIT_REVERSAL',
  /** The charge transaction type. */
  Charge = 'CHARGE',
  /** The chargeback_fee transaction type. */
  ChargebackFee = 'CHARGEBACK_FEE',
  /** The chargeback_fee_refund transaction type. */
  ChargebackFeeRefund = 'CHARGEBACK_FEE_REFUND',
  /** The chargeback_hold transaction type. */
  ChargebackHold = 'CHARGEBACK_HOLD',
  /** The chargeback_hold_release transaction type. */
  ChargebackHoldRelease = 'CHARGEBACK_HOLD_RELEASE',
  /** The chargeback_protection_credit transaction type. */
  ChargebackProtectionCredit = 'CHARGEBACK_PROTECTION_CREDIT',
  /** The chargeback_protection_credit_reversal transaction type. */
  ChargebackProtectionCreditReversal = 'CHARGEBACK_PROTECTION_CREDIT_REVERSAL',
  /** The chargeback_protection_debit transaction type. */
  ChargebackProtectionDebit = 'CHARGEBACK_PROTECTION_DEBIT',
  /** The chargeback_protection_debit_reversal transaction type. */
  ChargebackProtectionDebitReversal = 'CHARGEBACK_PROTECTION_DEBIT_REVERSAL',
  /** The charge_adjustment transaction type. */
  ChargeAdjustment = 'CHARGE_ADJUSTMENT',
  /** The collections_credit transaction type. */
  CollectionsCredit = 'COLLECTIONS_CREDIT',
  /** The collections_credit_reversal transaction type. */
  CollectionsCreditReversal = 'COLLECTIONS_CREDIT_REVERSAL',
  /** The customs_duty transaction type. */
  CustomsDuty = 'CUSTOMS_DUTY',
  /** The customs_duty_adjustment transaction type. */
  CustomsDutyAdjustment = 'CUSTOMS_DUTY_ADJUSTMENT',
  /** The dispute_reversal transaction type. */
  DisputeReversal = 'DISPUTE_REVERSAL',
  /** The dispute_withdrawal transaction type. */
  DisputeWithdrawal = 'DISPUTE_WITHDRAWAL',
  /** The import_tax transaction type. */
  ImportTax = 'IMPORT_TAX',
  /** The import_tax_adjustment transaction type. */
  ImportTaxAdjustment = 'IMPORT_TAX_ADJUSTMENT',
  /** The tax refund transaction type. */
  ImportTaxRefund = 'IMPORT_TAX_REFUND',
  /** The lending_capital_refund transaction type. */
  LendingCapitalRefund = 'LENDING_CAPITAL_REFUND',
  /** The lending_capital_refund_reversal transaction type. */
  LendingCapitalRefundReversal = 'LENDING_CAPITAL_REFUND_REVERSAL',
  /** The lending_capital_remittance transaction type. */
  LendingCapitalRemittance = 'LENDING_CAPITAL_REMITTANCE',
  /** The lending_capital_remittance_reversal transaction type. */
  LendingCapitalRemittanceReversal = 'LENDING_CAPITAL_REMITTANCE_REVERSAL',
  /** The lending_credit transaction type. */
  LendingCredit = 'LENDING_CREDIT',
  /** The lending_credit_refund transaction type. */
  LendingCreditRefund = 'LENDING_CREDIT_REFUND',
  /** The lending_credit_refund_reversal transaction type. */
  LendingCreditRefundReversal = 'LENDING_CREDIT_REFUND_REVERSAL',
  /** The lending_credit_remittance transaction type. */
  LendingCreditRemittance = 'LENDING_CREDIT_REMITTANCE',
  /** The lending_credit_remittance_reversal transaction type. */
  LendingCreditRemittanceReversal = 'LENDING_CREDIT_REMITTANCE_REVERSAL',
  /** The lending_credit_reversal transaction type. */
  LendingCreditReversal = 'LENDING_CREDIT_REVERSAL',
  /** The lending_debit transaction type. */
  LendingDebit = 'LENDING_DEBIT',
  /** The lending_debit_reversal transaction type. */
  LendingDebitReversal = 'LENDING_DEBIT_REVERSAL',
  /** The marketplace_fee_credit transaction type. */
  MarketplaceFeeCredit = 'MARKETPLACE_FEE_CREDIT',
  /** The marketplace_fee_credit_reversal transaction type. */
  MarketplaceFeeCreditReversal = 'MARKETPLACE_FEE_CREDIT_REVERSAL',
  /** The markets_pro_credit transaction type. */
  MarketsProCredit = 'MARKETS_PRO_CREDIT',
  /** The merchant_goodwill_credit transaction type. */
  MerchantGoodwillCredit = 'MERCHANT_GOODWILL_CREDIT',
  /** The merchant_goodwill_credit_reversal transaction type. */
  MerchantGoodwillCreditReversal = 'MERCHANT_GOODWILL_CREDIT_REVERSAL',
  /** The merchant_to_merchant_credit transaction type. */
  MerchantToMerchantCredit = 'MERCHANT_TO_MERCHANT_CREDIT',
  /** The merchant_to_merchant_credit_reversal transaction type. */
  MerchantToMerchantCreditReversal = 'MERCHANT_TO_MERCHANT_CREDIT_REVERSAL',
  /** The merchant_to_merchant_debit transaction type. */
  MerchantToMerchantDebit = 'MERCHANT_TO_MERCHANT_DEBIT',
  /** The merchant_to_merchant_debit_reversal transaction type. */
  MerchantToMerchantDebitReversal = 'MERCHANT_TO_MERCHANT_DEBIT_REVERSAL',
  /** The promotion_credit transaction type. */
  PromotionCredit = 'PROMOTION_CREDIT',
  /** The promotion_credit_reversal transaction type. */
  PromotionCreditReversal = 'PROMOTION_CREDIT_REVERSAL',
  /** The referral_fee transaction type. */
  ReferralFee = 'REFERRAL_FEE',
  /** The referral_fee_tax transaction type. */
  ReferralFeeTax = 'REFERRAL_FEE_TAX',
  /** The refund transaction type. */
  Refund = 'REFUND',
  /** The refund_adjustment transaction type. */
  RefundAdjustment = 'REFUND_ADJUSTMENT',
  /** The refund_failure transaction type. */
  RefundFailure = 'REFUND_FAILURE',
  /** The reserved_funds transaction type. */
  ReservedFunds = 'RESERVED_FUNDS',
  /** The reserved_funds_reversal transaction type. */
  ReservedFundsReversal = 'RESERVED_FUNDS_REVERSAL',
  /** The reserved_funds_withdrawal transaction type. */
  ReservedFundsWithdrawal = 'RESERVED_FUNDS_WITHDRAWAL',
  /** The risk_reversal transaction type. */
  RiskReversal = 'RISK_REVERSAL',
  /** The risk_withdrawal transaction type. */
  RiskWithdrawal = 'RISK_WITHDRAWAL',
  /** The seller_protection_credit transaction type. */
  SellerProtectionCredit = 'SELLER_PROTECTION_CREDIT',
  /** The seller_protection_credit_reversal transaction type. */
  SellerProtectionCreditReversal = 'SELLER_PROTECTION_CREDIT_REVERSAL',
  /** The shipping_label transaction type. */
  ShippingLabel = 'SHIPPING_LABEL',
  /** The shipping_label_adjustment transaction type. */
  ShippingLabelAdjustment = 'SHIPPING_LABEL_ADJUSTMENT',
  /** The shipping_label_adjustment_base transaction type. */
  ShippingLabelAdjustmentBase = 'SHIPPING_LABEL_ADJUSTMENT_BASE',
  /** The shipping_label_adjustment_surcharge transaction type. */
  ShippingLabelAdjustmentSurcharge = 'SHIPPING_LABEL_ADJUSTMENT_SURCHARGE',
  /** The shipping_other_carrier_charge_adjustment transaction type. */
  ShippingOtherCarrierChargeAdjustment = 'SHIPPING_OTHER_CARRIER_CHARGE_ADJUSTMENT',
  /** The shipping_return_to_origin_adjustment transaction type. */
  ShippingReturnToOriginAdjustment = 'SHIPPING_RETURN_TO_ORIGIN_ADJUSTMENT',
  /** The shopify_collective_credit transaction type. */
  ShopifyCollectiveCredit = 'SHOPIFY_COLLECTIVE_CREDIT',
  /** The shopify_collective_credit_reversal transaction type. */
  ShopifyCollectiveCreditReversal = 'SHOPIFY_COLLECTIVE_CREDIT_REVERSAL',
  /** The shopify_collective_debit transaction type. */
  ShopifyCollectiveDebit = 'SHOPIFY_COLLECTIVE_DEBIT',
  /** The shopify_collective_debit_reversal transaction type. */
  ShopifyCollectiveDebitReversal = 'SHOPIFY_COLLECTIVE_DEBIT_REVERSAL',
  /** The shopify_source_credit transaction type. */
  ShopifySourceCredit = 'SHOPIFY_SOURCE_CREDIT',
  /** The shopify_source_credit_reversal transaction type. */
  ShopifySourceCreditReversal = 'SHOPIFY_SOURCE_CREDIT_REVERSAL',
  /** The shopify_source_debit transaction type. */
  ShopifySourceDebit = 'SHOPIFY_SOURCE_DEBIT',
  /** The shopify_source_debit_reversal transaction type. */
  ShopifySourceDebitReversal = 'SHOPIFY_SOURCE_DEBIT_REVERSAL',
  /** The shop_cash_billing_debit transaction type. */
  ShopCashBillingDebit = 'SHOP_CASH_BILLING_DEBIT',
  /** The shop_cash_billing_debit_reversal transaction type. */
  ShopCashBillingDebitReversal = 'SHOP_CASH_BILLING_DEBIT_REVERSAL',
  /** The shop_cash_campaign_billing_credit transaction type. */
  ShopCashCampaignBillingCredit = 'SHOP_CASH_CAMPAIGN_BILLING_CREDIT',
  /** The shop_cash_campaign_billing_credit_reversal transaction type. */
  ShopCashCampaignBillingCreditReversal = 'SHOP_CASH_CAMPAIGN_BILLING_CREDIT_REVERSAL',
  /** The shop_cash_campaign_billing_debit transaction type. */
  ShopCashCampaignBillingDebit = 'SHOP_CASH_CAMPAIGN_BILLING_DEBIT',
  /** The shop_cash_campaign_billing_debit_reversal transaction type. */
  ShopCashCampaignBillingDebitReversal = 'SHOP_CASH_CAMPAIGN_BILLING_DEBIT_REVERSAL',
  /** The shop_cash_credit transaction type. */
  ShopCashCredit = 'SHOP_CASH_CREDIT',
  /** The shop_cash_credit_reversal transaction type. */
  ShopCashCreditReversal = 'SHOP_CASH_CREDIT_REVERSAL',
  /** The shop_cash_refund_debit transaction type. */
  ShopCashRefundDebit = 'SHOP_CASH_REFUND_DEBIT',
  /** The shop_cash_refund_debit_reversal transaction type. */
  ShopCashRefundDebitReversal = 'SHOP_CASH_REFUND_DEBIT_REVERSAL',
  /** The stripe_fee transaction type. */
  StripeFee = 'STRIPE_FEE',
  /** The tax_adjustment_credit transaction type. */
  TaxAdjustmentCredit = 'TAX_ADJUSTMENT_CREDIT',
  /** The tax_adjustment_credit_reversal transaction type. */
  TaxAdjustmentCreditReversal = 'TAX_ADJUSTMENT_CREDIT_REVERSAL',
  /** The tax_adjustment_debit transaction type. */
  TaxAdjustmentDebit = 'TAX_ADJUSTMENT_DEBIT',
  /** The tax_adjustment_debit_reversal transaction type. */
  TaxAdjustmentDebitReversal = 'TAX_ADJUSTMENT_DEBIT_REVERSAL',
  /** The transfer transaction type. */
  Transfer = 'TRANSFER',
  /** The transfer_cancel transaction type. */
  TransferCancel = 'TRANSFER_CANCEL',
  /** The transfer_failure transaction type. */
  TransferFailure = 'TRANSFER_FAILURE',
  /** The transfer_refund transaction type. */
  TransferRefund = 'TRANSFER_REFUND',
  /** The vat_refund_credit transaction type. */
  VatRefundCredit = 'VAT_REFUND_CREDIT',
  /** The vat_refund_credit_reversal transaction type. */
  VatRefundCreditReversal = 'VAT_REFUND_CREDIT_REVERSAL'
}

/** The status of an order's eligibility for protection against fraudulent chargebacks by Shopify Protect. */
export enum ShopifyProtectEligibilityStatus {
  /**
   * The order is eligible for protection against fraudulent chargebacks.
   * If an order is updated, the order's eligibility may change and protection could be removed.
   */
  Eligible = 'ELIGIBLE',
  /** The order isn't eligible for protection against fraudulent chargebacks. */
  NotEligible = 'NOT_ELIGIBLE',
  /** The eligibility of the order is pending and has not yet been determined. */
  Pending = 'PENDING'
}

/** The eligibility details of an order's protection against fraudulent chargebacks by Shopify Protect. */
export type ShopifyProtectOrderEligibility = {
  __typename?: 'ShopifyProtectOrderEligibility';
  /** The status of whether an order is eligible for protection against fraudulent chargebacks. */
  status: ShopifyProtectEligibilityStatus;
};

/** A summary of Shopify Protect details for an order. */
export type ShopifyProtectOrderSummary = {
  __typename?: 'ShopifyProtectOrderSummary';
  /** The eligibility details of an order's protection against fraudulent chargebacks. */
  eligibility: ShopifyProtectOrderEligibility;
  /** The status of the order's protection against fraudulent chargebacks. */
  status: ShopifyProtectStatus;
};

/** The status of an order's protection with Shopify Protect. */
export enum ShopifyProtectStatus {
  /**
   * The protection for the order is active and eligible for reimbursement against fraudulent chargebacks.
   * If an order is updated, the order's eligibility may change and protection could become inactive.
   */
  Active = 'ACTIVE',
  /** The protection for an order isn't active because the order didn't meet eligibility requirements. */
  Inactive = 'INACTIVE',
  /** The order received a chargeback but the order wasn't protected because it didn't meet coverage requirements. */
  NotProtected = 'NOT_PROTECTED',
  /** The protection for the order is pending and has not yet been determined. */
  Pending = 'PENDING',
  /** The order received a fraudulent chargeback and it was protected. */
  Protected = 'PROTECTED'
}

/** Whether a column was explicitly requested in the query or dynamically generated. */
export enum ShopifyqlColumnOrigin {
  /** The column was dynamically generated (e.g. a comparison, total, benchmark, or attribution). */
  Generated = 'GENERATED',
  /** The column was explicitly requested in the query. */
  Requested = 'REQUESTED',
  /** The column origin is unspecified. */
  Unspecified = 'UNSPECIFIED'
}

/** Describes how a dynamically generated column relates to the query. */
export type ShopifyqlDynamicColumnMetadata = {
  __typename?: 'ShopifyqlDynamicColumnMetadata';
  /** The names of the dimension columns this column is aggregated (grouped) by. */
  aggregatedBy: Array<Scalars['String']['output']>;
  /** What the column is compared against. For benchmark columns, the percentile (e.g. `p50`); for comparison columns, the comparison period or date offset. Interpret based on `type`. */
  comparisonReference?: Maybe<Scalars['String']['output']>;
  /** The query column this dynamic column was derived from (e.g. `total_sales`). */
  originalColumnName?: Maybe<Scalars['String']['output']>;
  /** The kind of dynamic column. */
  type: ShopifyqlDynamicColumnType;
};

/** The kind of dynamically generated column. */
export enum ShopifyqlDynamicColumnType {
  /** An attribution column. */
  Attribution = 'ATTRIBUTION',
  /** An attribution column with comparison data. */
  AttributionComparison = 'ATTRIBUTION_COMPARISON',
  /** An attribution column with comparison and cumulative data. */
  AttributionComparisonCumulative = 'ATTRIBUTION_COMPARISON_CUMULATIVE',
  /** An attribution column with comparison data and totals. */
  AttributionComparisonTotals = 'ATTRIBUTION_COMPARISON_TOTALS',
  /** An attribution column with cumulative data. */
  AttributionCumulative = 'ATTRIBUTION_CUMULATIVE',
  /** An attribution column with percent-change data. */
  AttributionPercentChange = 'ATTRIBUTION_PERCENT_CHANGE',
  /** An attribution column with totals. */
  AttributionTotals = 'ATTRIBUTION_TOTALS',
  /** A benchmark data column. */
  Benchmarks = 'BENCHMARKS',
  /** A benchmark column with totals. */
  BenchmarkTotals = 'BENCHMARK_TOTALS',
  /** A comparison data column (the comparison period). */
  Comparison = 'COMPARISON',
  /** A comparison column with cumulative data. */
  ComparisonCumulative = 'COMPARISON_CUMULATIVE',
  /** A comparison column with totals. */
  ComparisonTotals = 'COMPARISON_TOTALS',
  /** A cumulative column. */
  Cumulative = 'CUMULATIVE',
  /** A percent-change column. */
  PercentChange = 'PERCENT_CHANGE',
  /** A percentage of the corresponding overall totals column. */
  PercentOfTotal = 'PERCENT_OF_TOTAL',
  /** A rollout results column. */
  RolloutResults = 'ROLLOUT_RESULTS',
  /** A column with totals. */
  Totals = 'TOTALS',
  /** Unspecified dynamic column type. */
  Unspecified = 'UNSPECIFIED'
}

/** Localized display text shown in place of a null cell in a ShopifyQL result row. */
export type ShopifyqlNullCellTranslation = {
  __typename?: 'ShopifyqlNullCellTranslation';
  /** The name of the column the translation applies to. */
  columnName: Scalars['String']['output'];
  /** The localized text to display in place of the null value. */
  displayText: Scalars['String']['output'];
};

/** A response to a ShopifyQL query. */
export type ShopifyqlQueryResponse = {
  __typename?: 'ShopifyqlQueryResponse';
  /** A list of parse errors, if parsing fails. */
  parseErrors: Array<Scalars['String']['output']>;
  /** The result in a tabular format with column and row data. */
  tableData?: Maybe<ShopifyqlTableData>;
};

/** Per-row metadata for a ShopifyQL result, aligned by index with the table's rows. */
export type ShopifyqlRowMetadata = {
  __typename?: 'ShopifyqlRowMetadata';
  /** Localized display text for null cells in this row, by column. */
  nullCellTranslations: Array<ShopifyqlNullCellTranslation>;
  /** Raw resource IDs associated with the row, aligned by column index. Each entry is the list of IDs for that column (empty when the cell has none). These are raw ShopifyQL identifiers (numeric IDs, or image URLs for some schemas), not GIDs. */
  rawResourceIds: Array<Array<Scalars['String']['output']>>;
  /** Names of the columns whose values were rolled into the top-N "Other" remainder bucket. */
  topNRemainderColumnNames: Array<Scalars['String']['output']>;
};

/** The result of a ShopifyQL query. */
export type ShopifyqlTableData = {
  __typename?: 'ShopifyqlTableData';
  /** The columns of the table. */
  columns: Array<ShopifyqlTableDataColumn>;
  /** Per-row metadata, aligned by index with `rows`. */
  rowMetadata: Array<ShopifyqlRowMetadata>;
  /** The rows of the table. */
  rows: Scalars['JSON']['output'];
};

/** Represents a column in a ShopifyQL query response. */
export type ShopifyqlTableDataColumn = {
  __typename?: 'ShopifyqlTableDataColumn';
  /** Whether the column was explicitly requested in the query or dynamically generated. */
  columnOrigin: ShopifyqlColumnOrigin;
  /** The data type of the column. */
  dataType: ColumnDataType;
  /** The human-readable display name of the column. */
  displayName: Scalars['String']['output'];
  /** Metadata describing how a dynamic column was generated (comparison, totals, benchmark, attribution, etc.). Null for non-dynamic columns. */
  dynamicColumnMetadata?: Maybe<ShopifyqlDynamicColumnMetadata>;
  /** The name of the column. */
  name: Scalars['String']['output'];
  /** A shortened display name for the column, suitable for compact UI such as metric tiles. */
  shortDisplayName?: Maybe<Scalars['String']['output']>;
  /** The element type of an array column or DAY_DURATION for a range column. */
  subType?: Maybe<ColumnDataType>;
};

/**
 * A user account that can access the Shopify admin to manage store operations. Includes personal information and account status.
 *
 * You can assign staff members to [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects for [B2B operations](https://shopify.dev/docs/apps/build/b2b), limiting their actions to those locations.
 */
export type StaffMember = Node & {
  __typename?: 'StaffMember';
  /** The type of account the staff member has. */
  accountType?: Maybe<AccountType>;
  /** Whether the staff member is active. */
  active: Scalars['Boolean']['output'];
  /** The image used as the staff member's avatar in the Shopify admin. */
  avatar: Image;
  /** The staff member's email address. */
  email: Scalars['String']['output'];
  /** Whether the staff member's account exists. */
  exists: Scalars['Boolean']['output'];
  /** The staff member's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The staff member's initials, if available. */
  initials?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the staff member is the shop owner. */
  isShopOwner: Scalars['Boolean']['output'];
  /** The staff member's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The staff member's preferred locale. Locale values use the format `language` or `language-COUNTRY`, where `language` is a two-letter language code, and `COUNTRY` is a two-letter country code. For example: `en` or `en-US` */
  locale: Scalars['String']['output'];
  /** The staff member's full name. */
  name: Scalars['String']['output'];
  /** The staff member's phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The data used to customize the Shopify admin experience for the staff member. */
  privateData: StaffMemberPrivateData;
};


/**
 * A user account that can access the Shopify admin to manage store operations. Includes personal information and account status.
 *
 * You can assign staff members to [`CompanyLocation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/CompanyLocation) objects for [B2B operations](https://shopify.dev/docs/apps/build/b2b), limiting their actions to those locations.
 */
export type StaffMemberAvatarArgs = {
  fallback?: InputMaybe<StaffMemberDefaultImage>;
};

/** An auto-generated type for paginating through multiple StaffMembers. */
export type StaffMemberConnection = {
  __typename?: 'StaffMemberConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StaffMemberEdge>;
  /** A list of nodes that are contained in StaffMemberEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<StaffMember>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Represents the fallback avatar image for a staff member. This is used only if the staff member has no avatar image. */
export enum StaffMemberDefaultImage {
  /** Returns a default avatar image for the staff member. */
  Default = 'DEFAULT',
  /** Returns a URL that returns a 404 error if the image is not present. */
  NotFound = 'NOT_FOUND',
  /** Returns a transparent avatar image for the staff member. */
  Transparent = 'TRANSPARENT'
}

/** An auto-generated type which holds one StaffMember and a cursor during pagination. */
export type StaffMemberEdge = {
  __typename?: 'StaffMemberEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StaffMemberEdge. */
  node: StaffMember;
};

/** Represents access permissions for a staff member. */
export enum StaffMemberPermission {
  /** The staff member can manage and install apps and channels. */
  Applications = 'APPLICATIONS',
  /** The staff member can manage and install sales channels. */
  Channels = 'CHANNELS',
  /** The staff member can create and edit customers. */
  CreateAndEditCustomers = 'CREATE_AND_EDIT_CUSTOMERS',
  /** The staff member can create and edit gift cards. */
  CreateAndEditGiftCards = 'CREATE_AND_EDIT_GIFT_CARDS',
  /** The staff member can create and edit markets. */
  CreateAndEditMarkets = 'CREATE_AND_EDIT_MARKETS',
  /** The staff member can view customers. */
  Customers = 'CUSTOMERS',
  /** The staff member can view the Shopify Home page, which includes sales information and other shop data. */
  Dashboard = 'DASHBOARD',
  /** The staff member can deactivate gift cards. */
  DeactivateGiftCards = 'DEACTIVATE_GIFT_CARDS',
  /** The staff member can delete customers. */
  DeleteCustomers = 'DELETE_CUSTOMERS',
  /** The staff member can delete markets. */
  DeleteMarkets = 'DELETE_MARKETS',
  /** The staff member can view, buy, and manage domains. */
  Domains = 'DOMAINS',
  /** The staff member can create, update, and delete draft orders. */
  DraftOrders = 'DRAFT_ORDERS',
  /** The staff member can update orders. */
  EditOrders = 'EDIT_ORDERS',
  /** The staff member can erase customer private data. */
  EraseCustomerData = 'ERASE_CUSTOMER_DATA',
  /** The staff member can export customers. */
  ExportCustomers = 'EXPORT_CUSTOMERS',
  /** The staff member can export gift cards. */
  ExportGiftCards = 'EXPORT_GIFT_CARDS',
  /**
   * The staff has the same permissions as the [store owner](https://shopify.dev/en/manual/your-account/staff-accounts/staff-permissions#store-owner-permissions) with some exceptions, such as modifying the account billing or deleting staff accounts.
   * @deprecated Use the list of the staff member's explicit permissions returned in the `StaffMember.permissions.userPermissions` field instead of `full` permission.
   */
  Full = 'FULL',
  /** The staff member can view, create, issue, and export gift cards to a CSV file. */
  GiftCards = 'GIFT_CARDS',
  /** The staff member can view and modify links and navigation menus. */
  Links = 'LINKS',
  /** The staff member can create, update, and delete locations where inventory is stocked or managed. */
  Locations = 'LOCATIONS',
  /** The staff member can view and create discount codes and automatic discounts, and export discounts to a CSV file. */
  Marketing = 'MARKETING',
  /** The staff member can view, create, and automate marketing campaigns. */
  MarketingSection = 'MARKETING_SECTION',
  /** The staff member can merge customers. */
  MergeCustomers = 'MERGE_CUSTOMERS',
  /** The staff member can view, create, update, delete, and cancel orders, and receive order notifications. The staff member can still create draft orders without this permission. */
  Orders = 'ORDERS',
  /** The staff member can view the Overview and Live view pages, which include sales information, and other shop and sales channels data. */
  Overviews = 'OVERVIEWS',
  /** The staff member can view, create, update, publish, and delete blog posts and pages. */
  Pages = 'PAGES',
  /** The staff member can pay for an order by using a vaulted card. */
  PayOrdersByVaultedCard = 'PAY_ORDERS_BY_VAULTED_CARD',
  /** The staff member can view the preferences and configuration of a shop. */
  Preferences = 'PREFERENCES',
  /** The staff member can view, create, import, and update products, collections, and inventory. */
  Products = 'PRODUCTS',
  /** The staff member can view and create all reports, which includes sales information and other shop data. */
  Reports = 'REPORTS',
  /** The staff member can request customer private data. */
  RequestCustomerData = 'REQUEST_CUSTOMER_DATA',
  /** The staff member can view, update, and publish themes. */
  Themes = 'THEMES',
  /**
   * The staff member can view and create translations.
   * @deprecated Unused.
   */
  Translations = 'TRANSLATIONS',
  /** The staff member can view markets. */
  ViewMarkets = 'VIEW_MARKETS'
}

/** Represents the data used to customize the Shopify admin experience for a logged-in staff member. */
export type StaffMemberPrivateData = {
  __typename?: 'StaffMemberPrivateData';
  /** The URL to the staff member's account settings page. */
  accountSettingsUrl: Scalars['URL']['output'];
  /** The date and time when the staff member was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Access permissions for the staff member.
   * @deprecated There's no alternative field to use instead.
   */
  permissions: Array<StaffMemberPermission>;
};

/** The set of valid sort keys for the StaffMembers query. */
export enum StaffMembersSortKeys {
  /** Sort by the `email` value. */
  Email = 'EMAIL',
  /** Sort by the `first_name` value. */
  FirstName = 'FIRST_NAME',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `last_name` value. */
  LastName = 'LAST_NAME'
}

/**
 * An image to be uploaded.
 *
 * Deprecated in favor of
 * [StagedUploadInput](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadInput),
 * which is used by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StageImageInput = {
  /** The image filename. */
  filename: Scalars['String']['input'];
  /** HTTP method to be used by the staged upload. */
  httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The image MIME type. */
  mimeType: Scalars['String']['input'];
  /** The image resource. */
  resource: StagedUploadTargetGenerateUploadResource;
};

/**
 * Information about a staged upload target, which should be used to send a request to upload
 * the file.
 *
 * For more information on the upload process, refer to
 * [Upload media to Shopify](https://shopify.dev/apps/online-store/media/products#step-1-upload-media-to-shopify).
 */
export type StagedMediaUploadTarget = {
  __typename?: 'StagedMediaUploadTarget';
  /** Parameters needed to authenticate a request to upload the file. */
  parameters: Array<StagedUploadParameter>;
  /**
   * The URL to be passed as `originalSource` in
   * [CreateMediaInput](https://shopify.dev/api/admin-graphql/latest/input-objects/CreateMediaInput)
   * and [FileCreateInput](https://shopify.dev/api/admin-graphql/2022-04/input-objects/FileCreateInput)
   * for the [productCreateMedia](https://shopify.dev/api/admin-graphql/2022-04/mutations/productCreateMedia)
   * and [fileCreate](https://shopify.dev/api/admin-graphql/2022-04/mutations/fileCreate)
   * mutations.
   */
  resourceUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The URL to use when sending an request to upload the file. Should be used in conjunction with
   * the parameters field.
   */
  url?: Maybe<Scalars['URL']['output']>;
};

/**
 * The possible HTTP methods that can be used when sending a request to upload a file using information from a
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget).
 */
export enum StagedUploadHttpMethodType {
  /** The POST HTTP method. */
  Post = 'POST',
  /** The PUT HTTP method. */
  Put = 'PUT'
}

/** The input fields for generating staged upload targets. */
export type StagedUploadInput = {
  /**
   * The size of the file to upload, in bytes. This is required when the request's resource property is set to
   * [VIDEO](https://shopify.dev/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#value-video)
   * or [MODEL_3D](https://shopify.dev/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#value-model3d).
   */
  fileSize?: InputMaybe<Scalars['UnsignedInt64']['input']>;
  /** The file's name and extension. */
  filename: Scalars['String']['input'];
  /**
   * The HTTP method to be used when sending a request to upload the file using the returned staged
   * upload target.
   */
  httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The file's MIME type. */
  mimeType: Scalars['String']['input'];
  /** The file's intended Shopify resource type. */
  resource: StagedUploadTargetGenerateUploadResource;
};

/**
 * The parameters required to authenticate a file upload request using a
 * [StagedMediaUploadTarget's url field](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget#field-stagedmediauploadtarget-url).
 *
 * For more information on the upload process, refer to
 * [Upload media to Shopify](https://shopify.dev/apps/online-store/media/products#step-1-upload-media-to-shopify).
 */
export type StagedUploadParameter = {
  __typename?: 'StagedUploadParameter';
  /** The parameter's name. */
  name: Scalars['String']['output'];
  /** The parameter's value. */
  value: Scalars['String']['output'];
};

/**
 * Information about the staged target.
 *
 * Deprecated in favor of
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget),
 * which is returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StagedUploadTarget = {
  __typename?: 'StagedUploadTarget';
  /** The parameters of an image to be uploaded. */
  parameters: Array<ImageUploadParameter>;
  /** The image URL. */
  url: Scalars['String']['output'];
};

/**
 * The required fields and parameters to generate the URL upload an"
 * asset to Shopify.
 *
 * Deprecated in favor of
 * [StagedUploadInput](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadInput),
 * which is used by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StagedUploadTargetGenerateInput = {
  /** The size of the file to upload, in bytes. */
  fileSize?: InputMaybe<Scalars['UnsignedInt64']['input']>;
  /** The filename of the asset being uploaded. */
  filename: Scalars['String']['input'];
  /** The HTTP method to be used by the staged upload. */
  httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The MIME type of the asset being uploaded. */
  mimeType: Scalars['String']['input'];
  /** The resource type being uploaded. */
  resource: StagedUploadTargetGenerateUploadResource;
};

/** Return type for `stagedUploadTargetGenerate` mutation. */
export type StagedUploadTargetGeneratePayload = {
  __typename?: 'StagedUploadTargetGeneratePayload';
  /** The signed parameters that can be used to upload the asset. */
  parameters: Array<MutationsStagedUploadTargetGenerateUploadParameter>;
  /** The signed URL where the asset can be uploaded. */
  url: Scalars['String']['output'];
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The resource type to receive. */
export enum StagedUploadTargetGenerateUploadResource {
  /**
   * Represents bulk mutation variables.
   *
   * For example, bulk mutation variables can be used for bulk operations using the
   * [bulkOperationRunMutation mutation](https://shopify.dev/api/admin-graphql/latest/mutations/bulkOperationRunMutation).
   */
  BulkMutationVariables = 'BULK_MUTATION_VARIABLES',
  /**
   * An image associated with a collection.
   *
   * For example, after uploading an image, you can use the
   * [collectionUpdate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/collectionUpdate)
   * to add the image to a collection.
   */
  CollectionImage = 'COLLECTION_IMAGE',
  /**
   * Represents a file associated with a dispute.
   *
   * For example, after uploading the file, you can add the file to a dispute using the
   * [disputeEvidenceUpdate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/disputeEvidenceUpdate).
   */
  DisputeFileUpload = 'DISPUTE_FILE_UPLOAD',
  /**
   * Represents any file other than HTML.
   *
   * For example, after uploading the file, you can add the file to the
   * [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  File = 'FILE',
  /**
   * An image.
   *
   * For example, after uploading an image, you can add the image to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia)
   * or to the [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  Image = 'IMAGE',
  /**
   * A Shopify hosted 3d model.
   *
   * For example, after uploading the 3d model, you can add the 3d model to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia).
   */
  Model_3D = 'MODEL_3D',
  /**
   * An image that's associated with a product.
   *
   * For example, after uploading the image, you can add the image to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia).
   * @deprecated Use IMAGE instead. This resource type will be removed in a future version.
   */
  ProductImage = 'PRODUCT_IMAGE',
  /**
   * Represents a label associated with a return.
   *
   * For example, once uploaded, this resource can be used to [create a
   * ReverseDelivery](https://shopify.dev/api/admin-graphql/unstable/mutations/reverseDeliveryCreateWithShipping).
   */
  ReturnLabel = 'RETURN_LABEL',
  /**
   * An image.
   *
   * For example, after uploading the image, you can add the image to the
   * [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  ShopImage = 'SHOP_IMAGE',
  /**
   * Represents a redirect CSV file.
   *
   * Example usage: This resource can be used for creating a
   * [UrlRedirectImport](https://shopify.dev/api/admin-graphql/2022-04/objects/UrlRedirectImport)
   * object for use in the
   * [urlRedirectImportCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportCreate).
   */
  UrlRedirectImport = 'URL_REDIRECT_IMPORT',
  /**
   * A Shopify-hosted video.
   *
   * For example, after uploading the video, you can add the video to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia)
   * or to the [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  Video = 'VIDEO'
}

/** Return type for `stagedUploadTargetsGenerate` mutation. */
export type StagedUploadTargetsGeneratePayload = {
  __typename?: 'StagedUploadTargetsGeneratePayload';
  /** The staged upload targets that were generated. */
  urls?: Maybe<Array<StagedUploadTarget>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `stagedUploadsCreate` mutation. */
export type StagedUploadsCreatePayload = {
  __typename?: 'StagedUploadsCreatePayload';
  /** The staged upload targets that were generated. */
  stagedTargets?: Maybe<Array<StagedMediaUploadTarget>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields for the access settings for the metafields under the standard definition. */
export type StandardMetafieldDefinitionAccessInput = {
  /** The Admin API access setting to use for the metafields under this definition. */
  admin?: InputMaybe<MetafieldAdminAccessInput>;
  /** The Customer Account API access setting to use for the metafields under this definition. */
  customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The Storefront API access setting to use for the metafields under this definition. */
  storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** Return type for `standardMetafieldDefinitionEnable` mutation. */
export type StandardMetafieldDefinitionEnablePayload = {
  __typename?: 'StandardMetafieldDefinitionEnablePayload';
  /** The metafield definition that was created. */
  createdDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StandardMetafieldDefinitionEnableUserError>;
};

/** An error that occurs during the execution of `StandardMetafieldDefinitionEnable`. */
export type StandardMetafieldDefinitionEnableUserError = DisplayableError & {
  __typename?: 'StandardMetafieldDefinitionEnableUserError';
  /** The error code. */
  code?: Maybe<StandardMetafieldDefinitionEnableUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `StandardMetafieldDefinitionEnableUserError`. */
export enum StandardMetafieldDefinitionEnableUserErrorCode {
  /** Admin access can only be specified for app-owned metafield definitions. */
  AdminAccessInputNotAllowed = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** The metafield definition capability cannot be disabled. */
  CapabilityCannotBeDisabled = 'CAPABILITY_CANNOT_BE_DISABLED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The metafield definition capability is invalid. */
  InvalidCapability = 'INVALID_CAPABILITY',
  /** The input combination is invalid. */
  InvalidInputCombination = 'INVALID_INPUT_COMBINATION',
  /** The associated standard metaobject definition template is not valid for the metafield definition and prevented enabling it. */
  InvalidStandardMetaobject = 'INVALID_STANDARD_METAOBJECT',
  /** The maximum number of definitions per owner type has been exceeded. */
  LimitExceeded = 'LIMIT_EXCEEDED',
  /** You have reached the maximum allowed definitions to be used as admin filters. */
  OwnerTypeLimitExceededForUseAsAdminFilters = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_USE_AS_ADMIN_FILTERS',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The standard metafield definition template was not found. */
  TemplateNotFound = 'TEMPLATE_NOT_FOUND',
  /** The definition type is not eligible to be used as collection condition. */
  TypeNotAllowedForConditions = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** The namespace and key is already in use for a set of your metafields. */
  UnstructuredAlreadyExists = 'UNSTRUCTURED_ALREADY_EXISTS',
  /** The metafield definition does not support pinning. */
  UnsupportedPinning = 'UNSUPPORTED_PINNING'
}

/**
 * Standard metafield definition templates provide preset configurations to create metafield definitions.
 * Each template has a specific namespace and key that we've reserved to have specific meanings for common use cases.
 *
 * Refer to the [list of standard metafield definitions](https://shopify.dev/apps/metafields/definitions/standard-definitions).
 */
export type StandardMetafieldDefinitionTemplate = Node & {
  __typename?: 'StandardMetafieldDefinitionTemplate';
  /** The description of the standard metafield definition. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The key owned by the definition after the definition has been activated. */
  key: Scalars['String']['output'];
  /** The human-readable name for the standard metafield definition. */
  name: Scalars['String']['output'];
  /** The namespace owned by the definition after the definition has been activated. */
  namespace: Scalars['String']['output'];
  /** The list of resource types that the standard metafield definition can be applied to. */
  ownerTypes: Array<MetafieldOwnerType>;
  /** The associated [metafield definition type](https://shopify.dev/apps/metafields/definitions/types) that the metafield stores. */
  type: MetafieldDefinitionType;
  /** The configured validations for the standard metafield definition. */
  validations: Array<MetafieldDefinitionValidation>;
  /** Whether metafields for the definition are by default visible using the Storefront API. */
  visibleToStorefrontApi: Scalars['Boolean']['output'];
};

/** An auto-generated type for paginating through multiple StandardMetafieldDefinitionTemplates. */
export type StandardMetafieldDefinitionTemplateConnection = {
  __typename?: 'StandardMetafieldDefinitionTemplateConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StandardMetafieldDefinitionTemplateEdge>;
  /** A list of nodes that are contained in StandardMetafieldDefinitionTemplateEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<StandardMetafieldDefinitionTemplate>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one StandardMetafieldDefinitionTemplate and a cursor during pagination. */
export type StandardMetafieldDefinitionTemplateEdge = {
  __typename?: 'StandardMetafieldDefinitionTemplateEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StandardMetafieldDefinitionTemplateEdge. */
  node: StandardMetafieldDefinitionTemplate;
};

/** Describes a capability that is enabled on a Metaobject Definition. */
export type StandardMetaobjectCapabilityTemplate = {
  __typename?: 'StandardMetaobjectCapabilityTemplate';
  /** The type of capability that's enabled for the metaobject definition. */
  capabilityType: MetaobjectCapabilityType;
};

/** Return type for `standardMetaobjectDefinitionEnable` mutation. */
export type StandardMetaobjectDefinitionEnablePayload = {
  __typename?: 'StandardMetaobjectDefinitionEnablePayload';
  /** The metaobject definition that was enabled using the standard template. */
  metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MetaobjectUserError>;
};

/** A preset field definition on a standard metaobject definition template. */
export type StandardMetaobjectDefinitionFieldTemplate = {
  __typename?: 'StandardMetaobjectDefinitionFieldTemplate';
  /** The administrative description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The key owned by the definition after the definition has been enabled. */
  key: Scalars['String']['output'];
  /** The human-readable name. */
  name: Scalars['String']['output'];
  /** The required status of the field within the object composition. */
  required: Scalars['Boolean']['output'];
  /** The associated [metafield definition type](https://shopify.dev/apps/metafields/definitions/types) that the metafield stores. */
  type: MetafieldDefinitionType;
  /** The configured validations for the standard metafield definition. */
  validations: Array<MetafieldDefinitionValidation>;
  /**
   * Whether metafields for the definition are by default visible using the Storefront API.
   * @deprecated Access control at the metaobject field definition level is deprecated and will be removed in 2027-01. Use the access field on the definition instead.
   */
  visibleToStorefrontApi: Scalars['Boolean']['output'];
};

/** Standard metaobject definition templates provide preset configurations to create metaobject definitions. */
export type StandardMetaobjectDefinitionTemplate = {
  __typename?: 'StandardMetaobjectDefinitionTemplate';
  /** Access configuration for the standard metaobject definition template. */
  access: MetaobjectAccess;
  /** The administrative description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The key of a field to reference as the display name for each object. */
  displayNameKey?: Maybe<Scalars['String']['output']>;
  /** The capabilities of the metaobject definition. */
  enabledCapabilities: Array<StandardMetaobjectCapabilityTemplate>;
  /** Templates for the associated field definitions. */
  fieldDefinitions: Array<StandardMetaobjectDefinitionFieldTemplate>;
  /** The human-readable name. */
  name: Scalars['String']['output'];
  /** The namespace owned by the definition after the definition has been enabled. */
  type: Scalars['String']['output'];
};

/** Represents the details of a specific type of product within the [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
export type StandardizedProductType = {
  __typename?: 'StandardizedProductType';
  /** The product taxonomy node associated with the standardized product type. */
  productTaxonomyNode?: Maybe<ProductTaxonomyNode>;
};

/**
 * A store credit account contains a monetary balance that can be redeemed at checkout for purchases in the shop.
 * The account is held in the specified currency and has an owner that cannot be transferred.
 *
 * The account balance is redeemable at checkout only when the owner is authenticated via [new customer accounts authentication](https://shopify.dev/docs/api/customer).
 */
export type StoreCreditAccount = Node & {
  __typename?: 'StoreCreditAccount';
  /** The current balance of the store credit account. */
  balance: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The owner of the store credit account. */
  owner: HasStoreCreditAccounts;
  /** The transaction history of the store credit account. */
  transactions: StoreCreditAccountTransactionConnection;
};


/**
 * A store credit account contains a monetary balance that can be redeemed at checkout for purchases in the shop.
 * The account is held in the specified currency and has an owner that cannot be transferred.
 *
 * The account balance is redeemable at checkout only when the owner is authenticated via [new customer accounts authentication](https://shopify.dev/docs/api/customer).
 */
export type StoreCreditAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<TransactionSortKeys>;
};

/** An auto-generated type for paginating through multiple StoreCreditAccounts. */
export type StoreCreditAccountConnection = {
  __typename?: 'StoreCreditAccountConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StoreCreditAccountEdge>;
  /** A list of nodes that are contained in StoreCreditAccountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<StoreCreditAccount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields for a store credit account credit transaction. */
export type StoreCreditAccountCreditInput = {
  /** The amount to credit the store credit account. */
  creditAmount: MoneyInput;
  /** The date and time when the credit expires. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Whether to send a notification to the account owner when the store credit is issued.
   * Defaults to `false`.
   */
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `storeCreditAccountCredit` mutation. */
export type StoreCreditAccountCreditPayload = {
  __typename?: 'StoreCreditAccountCreditPayload';
  /** The store credit account transaction that was created. */
  storeCreditAccountTransaction?: Maybe<StoreCreditAccountCreditTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StoreCreditAccountCreditUserError>;
};

/** A credit transaction which increases the store credit account balance. */
export type StoreCreditAccountCreditTransaction = Node & StoreCreditAccountTransaction & {
  __typename?: 'StoreCreditAccountCreditTransaction';
  /** The store credit account that the transaction belongs to. */
  account: StoreCreditAccount;
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The balance of the account after the transaction. */
  balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The event that caused the store credit account transaction. */
  event: StoreCreditSystemEvent;
  /**
   * The time at which the transaction expires.
   * Debit transactions will always spend the soonest expiring credit first.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The origin of the store credit account transaction. */
  origin?: Maybe<StoreCreditAccountTransactionOrigin>;
  /**
   * The remaining amount of the credit.
   * The remaining amount will decrease when a debit spends this credit. It may also increase if that debit is subsequently reverted.
   * In the event that the credit expires, the remaining amount will represent the amount that remained as the expiry ocurred.
   */
  remainingAmount: MoneyV2;
};

/** An error that occurs during the execution of `StoreCreditAccountCredit`. */
export type StoreCreditAccountCreditUserError = DisplayableError & {
  __typename?: 'StoreCreditAccountCreditUserError';
  /** The error code. */
  code?: Maybe<StoreCreditAccountCreditUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `StoreCreditAccountCreditUserError`. */
export enum StoreCreditAccountCreditUserErrorCode {
  /** The store credit account could not be found. */
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  /** The operation would cause the account's credit limit to be exceeded. */
  CreditLimitExceeded = 'CREDIT_LIMIT_EXCEEDED',
  /** The expiry date must be in the future. */
  ExpiresAtInPast = 'EXPIRES_AT_IN_PAST',
  /** The currency provided does not match the currency of the store credit account. */
  MismatchingCurrency = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used to credit a store credit account. */
  NegativeOrZeroAmount = 'NEGATIVE_OR_ZERO_AMOUNT',
  /** Owner does not exist. */
  OwnerNotFound = 'OWNER_NOT_FOUND',
  /** The currency provided is not currently supported. */
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY'
}

/** The input fields for a store credit account debit transaction. */
export type StoreCreditAccountDebitInput = {
  /** The amount to debit the store credit account. */
  debitAmount: MoneyInput;
};

/** Return type for `storeCreditAccountDebit` mutation. */
export type StoreCreditAccountDebitPayload = {
  __typename?: 'StoreCreditAccountDebitPayload';
  /** The store credit account transaction that was created. */
  storeCreditAccountTransaction?: Maybe<StoreCreditAccountDebitTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StoreCreditAccountDebitUserError>;
};

/**
 * A debit revert transaction which increases the store credit account balance.
 * Debit revert transactions are created automatically when a [store credit account debit transaction](https://shopify.dev/api/admin-graphql/latest/objects/StoreCreditAccountDebitTransaction) is reverted.
 *
 * Store credit account debit transactions are reverted when an order is cancelled, refunded or in the event of a payment failure at checkout.
 * The amount added to the balance is equal to the amount reverted on the original credit.
 */
export type StoreCreditAccountDebitRevertTransaction = Node & StoreCreditAccountTransaction & {
  __typename?: 'StoreCreditAccountDebitRevertTransaction';
  /** The store credit account that the transaction belongs to. */
  account: StoreCreditAccount;
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The balance of the account after the transaction. */
  balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The reverted debit transaction. */
  debitTransaction: StoreCreditAccountDebitTransaction;
  /** The event that caused the store credit account transaction. */
  event: StoreCreditSystemEvent;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The origin of the store credit account transaction. */
  origin?: Maybe<StoreCreditAccountTransactionOrigin>;
};

/** A debit transaction which decreases the store credit account balance. */
export type StoreCreditAccountDebitTransaction = Node & StoreCreditAccountTransaction & {
  __typename?: 'StoreCreditAccountDebitTransaction';
  /** The store credit account that the transaction belongs to. */
  account: StoreCreditAccount;
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The balance of the account after the transaction. */
  balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The event that caused the store credit account transaction. */
  event: StoreCreditSystemEvent;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The origin of the store credit account transaction. */
  origin?: Maybe<StoreCreditAccountTransactionOrigin>;
};

/** An error that occurs during the execution of `StoreCreditAccountDebit`. */
export type StoreCreditAccountDebitUserError = DisplayableError & {
  __typename?: 'StoreCreditAccountDebitUserError';
  /** The error code. */
  code?: Maybe<StoreCreditAccountDebitUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `StoreCreditAccountDebitUserError`. */
export enum StoreCreditAccountDebitUserErrorCode {
  /** The store credit account could not be found. */
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  /** The store credit account does not have sufficient funds to satisfy the request. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The currency provided does not match the currency of the store credit account. */
  MismatchingCurrency = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used to debit a store credit account. */
  NegativeOrZeroAmount = 'NEGATIVE_OR_ZERO_AMOUNT'
}

/** An auto-generated type which holds one StoreCreditAccount and a cursor during pagination. */
export type StoreCreditAccountEdge = {
  __typename?: 'StoreCreditAccountEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StoreCreditAccountEdge. */
  node: StoreCreditAccount;
};

/**
 * An expiration transaction which decreases the store credit account balance.
 * Expiration transactions are created automatically when a [store credit account credit transaction](https://shopify.dev/api/admin-graphql/latest/objects/StoreCreditAccountCreditTransaction) expires.
 *
 * The amount subtracted from the balance is equal to the remaining amount of the credit transaction.
 */
export type StoreCreditAccountExpirationTransaction = StoreCreditAccountTransaction & {
  __typename?: 'StoreCreditAccountExpirationTransaction';
  /** The store credit account that the transaction belongs to. */
  account: StoreCreditAccount;
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The balance of the account after the transaction. */
  balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The credit transaction which expired. */
  creditTransaction: StoreCreditAccountCreditTransaction;
  /** The event that caused the store credit account transaction. */
  event: StoreCreditSystemEvent;
  /** The origin of the store credit account transaction. */
  origin?: Maybe<StoreCreditAccountTransactionOrigin>;
};

/** Interface for a store credit account transaction. */
export type StoreCreditAccountTransaction = {
  /** The store credit account that the transaction belongs to. */
  account: StoreCreditAccount;
  /** The amount of the transaction. */
  amount: MoneyV2;
  /** The balance of the account after the transaction. */
  balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The event that caused the store credit account transaction. */
  event: StoreCreditSystemEvent;
  /** The origin of the store credit account transaction. */
  origin?: Maybe<StoreCreditAccountTransactionOrigin>;
};

/** An auto-generated type for paginating through multiple StoreCreditAccountTransactions. */
export type StoreCreditAccountTransactionConnection = {
  __typename?: 'StoreCreditAccountTransactionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StoreCreditAccountTransactionEdge>;
  /** A list of nodes that are contained in StoreCreditAccountTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<StoreCreditAccountTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one StoreCreditAccountTransaction and a cursor during pagination. */
export type StoreCreditAccountTransactionEdge = {
  __typename?: 'StoreCreditAccountTransactionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StoreCreditAccountTransactionEdge. */
  node: StoreCreditAccountTransaction;
};

/** The origin of a store credit account transaction. */
export type StoreCreditAccountTransactionOrigin = OrderTransaction;

/** The store credit configuration for a shop. */
export type StoreCreditConfiguration = {
  __typename?: 'StoreCreditConfiguration';
  /** Whether store credit is enabled for customers on checkout. */
  storeCreditEnabled: Scalars['Boolean']['output'];
};

/** The input fields to process a refund to store credit. */
export type StoreCreditRefundInput = {
  /** The amount to be issued as store credit. */
  amount: MoneyInput;
  /** An optional expiration date for the store credit being issued. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The event that caused the store credit account transaction. */
export enum StoreCreditSystemEvent {
  /** An adjustment was made to the store credit account. */
  Adjustment = 'ADJUSTMENT',
  /** Store credit was returned when an authorized payment was voided. */
  OrderCancellation = 'ORDER_CANCELLATION',
  /** Store credit was used as payment for an order. */
  OrderPayment = 'ORDER_PAYMENT',
  /** Store credit was refunded from an order. */
  OrderRefund = 'ORDER_REFUND',
  /** A store credit payment was reverted due to another payment method failing. */
  PaymentFailure = 'PAYMENT_FAILURE',
  /** A smaller amount of store credit was captured than was originally authorized. */
  PaymentReturned = 'PAYMENT_RETURNED',
  /** Store credit was used as payment for a recurring order. */
  RecurringPayment = 'RECURRING_PAYMENT',
  /** Tax finalization affected the store credit payment. */
  TaxFinalization = 'TAX_FINALIZATION'
}

/**
 * A token that delegates unauthenticated access scopes to clients that need to access the [Storefront API](https://shopify.dev/docs/api/storefront). Storefront access tokens enable headless storefronts and custom applications to interact with a store on behalf of customers without requiring authentication.
 *
 * The token provides specific permissions, such as reading [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) data, managing carts, or creating [`Customer`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Customer) accounts. An app can have a maximum of 100 active storefront access tokens for each [`Shop`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Shop).
 *
 * Learn more about [building with the Storefront API](https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/getting-started).
 */
export type StorefrontAccessToken = Node & {
  __typename?: 'StorefrontAccessToken';
  /** List of permissions associated with the token. */
  accessScopes: Array<AccessScope>;
  /** The issued public access token. */
  accessToken: Scalars['String']['output'];
  /** The date and time when the public access token was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** An arbitrary title for each token determined by the developer, used for reference         purposes. */
  title: Scalars['String']['output'];
  /** The date and time when the storefront access token was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An auto-generated type for paginating through multiple StorefrontAccessTokens. */
export type StorefrontAccessTokenConnection = {
  __typename?: 'StorefrontAccessTokenConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StorefrontAccessTokenEdge>;
  /** A list of nodes that are contained in StorefrontAccessTokenEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<StorefrontAccessToken>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `storefrontAccessTokenCreate` mutation. */
export type StorefrontAccessTokenCreatePayload = {
  __typename?: 'StorefrontAccessTokenCreatePayload';
  /** The user's shop. */
  shop: Shop;
  /** The storefront access token. */
  storefrontAccessToken?: Maybe<StorefrontAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** The input fields to delete a storefront access token. */
export type StorefrontAccessTokenDeleteInput = {
  /** The ID of the storefront access token to delete. */
  id: Scalars['ID']['input'];
};

/** Return type for `storefrontAccessTokenDelete` mutation. */
export type StorefrontAccessTokenDeletePayload = {
  __typename?: 'StorefrontAccessTokenDeletePayload';
  /** The ID of the deleted storefront access token. */
  deletedStorefrontAccessTokenId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one StorefrontAccessToken and a cursor during pagination. */
export type StorefrontAccessTokenEdge = {
  __typename?: 'StorefrontAccessTokenEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StorefrontAccessTokenEdge. */
  node: StorefrontAccessToken;
};

/** The input fields for a storefront access token. */
export type StorefrontAccessTokenInput = {
  /** A title for the storefront access token. */
  title: Scalars['String']['input'];
};

/** An auto-generated type for paginating through multiple Strings. */
export type StringConnection = {
  __typename?: 'StringConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<StringEdge>;
  /** A list of nodes that are contained in StringEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Scalars['String']['output']>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one String and a cursor during pagination. */
export type StringEdge = {
  __typename?: 'StringEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of StringEdge. */
  node: Scalars['String']['output'];
};

/** Stable identifier for why a collection cannot be referenced as a sub-collection target. */
export enum SubCollectionIneligibleReason {
  /** The referenced collection itself owns a sub-collection source (chains of depth > 1 are not supported). */
  ChainReference = 'CHAIN_REFERENCE',
  /** The referenced collection id does not parse as a positive integer or does not exist in the shop. */
  InvalidCollectionReference = 'INVALID_COLLECTION_REFERENCE',
  /** The referenced collection is one of the source's owning collections (a source cannot reference itself). */
  SelfReference = 'SELF_REFERENCE'
}

/** The actor who initiated a subscription action. */
export enum SubscriptionActor {
  /** The subscription action was initiated by a customer. */
  Customer = 'CUSTOMER',
  /** The subscription action was initiated by a merchant. */
  Merchant = 'MERCHANT',
  /** The subscription action was initiated by a partner. */
  Partner = 'PARTNER'
}

/** Represents an applied code discount. */
export type SubscriptionAppliedCodeDiscount = {
  __typename?: 'SubscriptionAppliedCodeDiscount';
  /** The unique ID. */
  id: Scalars['ID']['output'];
  /** The redeem code of the discount that applies on the subscription. */
  redeemCode: Scalars['String']['output'];
  /** The reason that the discount on the subscription draft is rejected. */
  rejectionReason?: Maybe<SubscriptionDiscountRejectionReason>;
};

/** The input fields for mapping a subscription line to a discount. */
export type SubscriptionAtomicLineInput = {
  /** The discount to be added to the subscription line. */
  discounts?: InputMaybe<Array<SubscriptionAtomicManualDiscountInput>>;
  /** The new subscription line. */
  line: SubscriptionLineInput;
};

/** The input fields for mapping a subscription line to a discount. */
export type SubscriptionAtomicManualDiscountInput = {
  /** The maximum number of times the subscription discount will be applied on orders. */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The title associated with the subscription discount. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Percentage or fixed amount value of the discount. */
  value?: InputMaybe<SubscriptionManualDiscountValueInput>;
};

/**
 * A record of an execution of the subscription billing process. Billing attempts use idempotency keys to avoid duplicate order creation.
 *
 * When a billing attempt completes successfully, it creates an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The attempt includes associated payment transactions and any errors that occur during billing. If 3D Secure authentication is required, the `nextActionUrl` field provides the redirect URL for customer verification.
 */
export type SubscriptionBillingAttempt = Node & {
  __typename?: 'SubscriptionBillingAttempt';
  /** The date and time when the billing attempt was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the billing attempt was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * A code corresponding to a payment error during processing.
   * @deprecated Use `state` instead.
   */
  errorCode?: Maybe<SubscriptionBillingAttemptErrorCode>;
  /**
   * A message describing a payment error during processing.
   * @deprecated Use `state` instead.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A unique key generated by the client to avoid duplicate payments. */
  idempotencyKey: Scalars['String']['output'];
  /**
   * The URL where the customer needs to be redirected so they can complete the 3D Secure payment flow.
   * @deprecated Use `state` instead.
   */
  nextActionUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The result of this billing attempt if completed successfully.
   * @deprecated Use `state` instead.
   */
  order?: Maybe<Order>;
  /**
   * The date and time used to calculate fulfillment intervals for a billing attempt that
   * successfully completed after the current anchor date. To prevent fulfillment from being
   * pushed to the next anchor date, this field can override the billing attempt date.
   */
  originTime?: Maybe<Scalars['DateTime']['output']>;
  /** The reference shared between retried payment attempts. */
  paymentGroupId?: Maybe<Scalars['String']['output']>;
  /** The reference shared between payment attempts with similar payment details. */
  paymentSessionId?: Maybe<Scalars['String']['output']>;
  /**
   * Error information from processing the billing attempt.
   * @deprecated Use `state` instead.
   */
  processingError?: Maybe<SubscriptionBillingAttemptProcessingError>;
  /**
   * Whether the billing attempt is still processing.
   * @deprecated Use `state` instead.
   */
  ready: Scalars['Boolean']['output'];
  /** Whether the billing attempt respects the merchant's inventory policy. */
  respectInventoryPolicy: Scalars['Boolean']['output'];
  /** The state of the billing attempt with state-specific data. */
  state: SubscriptionBillingAttemptState;
  /** The subscription contract. */
  subscriptionContract: SubscriptionContract;
  /** The transactions created by the billing attempt. */
  transactions: OrderTransactionConnection;
};


/**
 * A record of an execution of the subscription billing process. Billing attempts use idempotency keys to avoid duplicate order creation.
 *
 * When a billing attempt completes successfully, it creates an [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The attempt includes associated payment transactions and any errors that occur during billing. If 3D Secure authentication is required, the `nextActionUrl` field provides the redirect URL for customer verification.
 */
export type SubscriptionBillingAttemptTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The action required to continue processing the billing attempt. */
export type SubscriptionBillingAttemptAction = SubscriptionBillingAttemptPaymentChallenge;

/**
 * The billing attempt state that requires an action to resolve.
 * Must complete the action required for the billing attempt to continue being processed.
 */
export type SubscriptionBillingAttemptActionRequiredState = {
  __typename?: 'SubscriptionBillingAttemptActionRequiredState';
  /** The action required to resolve the billing attempt. */
  action: SubscriptionBillingAttemptAction;
};

/** An auto-generated type for paginating through multiple SubscriptionBillingAttempts. */
export type SubscriptionBillingAttemptConnection = {
  __typename?: 'SubscriptionBillingAttemptConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionBillingAttemptEdge>;
  /** A list of nodes that are contained in SubscriptionBillingAttemptEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionBillingAttempt>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `subscriptionBillingAttemptCreate` mutation. */
export type SubscriptionBillingAttemptCreatePayload = {
  __typename?: 'SubscriptionBillingAttemptCreatePayload';
  /** The subscription billing attempt. */
  subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BillingAttemptUserError>;
};

/** An auto-generated type which holds one SubscriptionBillingAttempt and a cursor during pagination. */
export type SubscriptionBillingAttemptEdge = {
  __typename?: 'SubscriptionBillingAttemptEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionBillingAttemptEdge. */
  node: SubscriptionBillingAttempt;
};

/** Possible error types for a subscription billing attempt. */
export type SubscriptionBillingAttemptError = SubscriptionBillingAttemptGeneralError | SubscriptionBillingAttemptInventoryError | SubscriptionBillingAttemptPaymentError | SubscriptionBillingAttemptUnexpectedError;

/**
 * The possible error codes associated with making billing attempts. The error codes supplement the
 * `error_message` to provide consistent results and help with dunning management.
 */
export enum SubscriptionBillingAttemptErrorCode {
  /** The amount exceeds the limit for this payment method. */
  AmountTooLarge = 'AMOUNT_TOO_LARGE',
  /** The amount is too small. */
  AmountTooSmall = 'AMOUNT_TOO_SMALL',
  /** There was an error during the payment authentication. */
  AuthenticationError = 'AUTHENTICATION_ERROR',
  /** Authentication failed during payment processing. */
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  /** Additional authentication is required to complete the payment. */
  AuthenticationRequired = 'AUTHENTICATION_REQUIRED',
  /** Payment method was canceled by buyer. */
  BuyerCanceledPaymentMethod = 'BUYER_CANCELED_PAYMENT_METHOD',
  /** The card issuer requires the cardholder to call them. */
  CallIssuer = 'CALL_ISSUER',
  /** The payment was cancelled. */
  CancelledPayment = 'CANCELLED_PAYMENT',
  /** The card was declined by the payment processor. */
  CardDeclined = 'CARD_DECLINED',
  /** Card number was incorrect. */
  CardNumberIncorrect = 'CARD_NUMBER_INCORRECT',
  /** The payment confirmation was rejected. */
  ConfirmationRejected = 'CONFIRMATION_REJECTED',
  /** Customer is invalid. */
  CustomerInvalid = 'CUSTOMER_INVALID',
  /** Customer was not found. */
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  /** The card issuer declined the transaction with a 'do not honor' response. */
  DoNotHonor = 'DO_NOT_HONOR',
  /** The required buyer action has expired. */
  ExpiredBuyerAction = 'EXPIRED_BUYER_ACTION',
  /** The card has expired. */
  ExpiredCard = 'EXPIRED_CARD',
  /** Payment method is expired. */
  ExpiredPaymentMethod = 'EXPIRED_PAYMENT_METHOD',
  /** Fraud was suspected. */
  FraudSuspected = 'FRAUD_SUSPECTED',
  /** Gift cards must have a price greater than zero. */
  FreeGiftCardNotAllowed = 'FREE_GIFT_CARD_NOT_ALLOWED',
  /** A generic payment error occurred. */
  GenericError = 'GENERIC_ERROR',
  /** The billing address provided is incorrect. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The card security code entered is incorrect. */
  IncorrectCvc = 'INCORRECT_CVC',
  /** The card number entered is incorrect. */
  IncorrectNumber = 'INCORRECT_NUMBER',
  /** The PIN entered is incorrect. */
  IncorrectPin = 'INCORRECT_PIN',
  /** The postal/ZIP code provided is incorrect. */
  IncorrectZip = 'INCORRECT_ZIP',
  /** Insufficient funds. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** Not enough inventory found. */
  InsufficientInventory = 'INSUFFICIENT_INVENTORY',
  /** The transaction amount is invalid for this payment method. */
  InvalidAmount = 'INVALID_AMOUNT',
  /** The billing address is invalid. */
  InvalidBillingAddress = 'INVALID_BILLING_ADDRESS',
  /** The currency is not supported for this payment method. */
  InvalidCurrency = 'INVALID_CURRENCY',
  /** The billing agreement ID or the transaction ID for the customer's payment method is invalid. */
  InvalidCustomerBillingAgreement = 'INVALID_CUSTOMER_BILLING_AGREEMENT',
  /** The card security code is invalid. */
  InvalidCvc = 'INVALID_CVC',
  /** The expiry date of the card provided is invalid. */
  InvalidExpiryDate = 'INVALID_EXPIRY_DATE',
  /** The card number is invalid. */
  InvalidNumber = 'INVALID_NUMBER',
  /** Payment method is invalid. Please update or create a new payment method. */
  InvalidPaymentMethod = 'INVALID_PAYMENT_METHOD',
  /** The purchase type is invalid for this payment method. */
  InvalidPurchaseType = 'INVALID_PURCHASE_TYPE',
  /** The payment request is invalid. */
  InvalidRequest = 'INVALID_REQUEST',
  /** The shipping address is either missing or invalid. */
  InvalidShippingAddress = 'INVALID_SHIPPING_ADDRESS',
  /** No inventory location found or enabled. */
  InventoryAllocationsNotFound = 'INVENTORY_ALLOCATIONS_NOT_FOUND',
  /** A payment has already been made for this invoice. */
  InvoiceAlreadyPaid = 'INVOICE_ALREADY_PAID',
  /** Merchant account configuration error. */
  MerchantAccountError = 'MERCHANT_ACCOUNT_ERROR',
  /** The transaction was declined due to a merchant-defined rule. */
  MerchantRule = 'MERCHANT_RULE',
  /** Non-test order limit reached. Use a test payment gateway to place another order. */
  NonTestOrderLimitReached = 'NON_TEST_ORDER_LIMIT_REACHED',
  /** The off-session payment was rejected and requires customer action. */
  OffSessionRejected = 'OFF_SESSION_REJECTED',
  /** Payment method was declined by processor. */
  PaymentMethodDeclined = 'PAYMENT_METHOD_DECLINED',
  /** Payment method cannot be used with the current payment gateway test mode configuration. */
  PaymentMethodIncompatibleWithGatewayConfig = 'PAYMENT_METHOD_INCOMPATIBLE_WITH_GATEWAY_CONFIG',
  /** Payment method was not found. */
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  /** Payment method is not specified on subscription contract. */
  PaymentMethodNotSpecified = 'PAYMENT_METHOD_NOT_SPECIFIED',
  /** The payment method type is not supported. */
  PaymentMethodUnsupported = 'PAYMENT_METHOD_UNSUPPORTED',
  /** An exception occurred with the payment provider. */
  PaymentProviderError = 'PAYMENT_PROVIDER_ERROR',
  /** Payment provider is not enabled. */
  PaymentProviderIsNotEnabled = 'PAYMENT_PROVIDER_IS_NOT_ENABLED',
  /** Paypal Error General. */
  PaypalErrorGeneral = 'PAYPAL_ERROR_GENERAL',
  /** A processing error occurred with the payment provider. */
  ProcessingError = 'PROCESSING_ERROR',
  /** Purchase Type is not supported. */
  PurchaseTypeNotSupported = 'PURCHASE_TYPE_NOT_SUPPORTED',
  /** The payment retry was declined. */
  RetryDeclined = 'RETRY_DECLINED',
  /** Gateway is in test mode and attempted to bill a live payment method. */
  TestMode = 'TEST_MODE',
  /** The transaction exceeds the cardholder's limit. */
  TransactionLimitExceeded = 'TRANSACTION_LIMIT_EXCEEDED',
  /** Transient error, try again later. */
  TransientError = 'TRANSIENT_ERROR',
  /** There was an unexpected error during the billing attempt. */
  UnexpectedError = 'UNEXPECTED_ERROR'
}

/** The billing attempt failed due to an error. */
export type SubscriptionBillingAttemptFailedState = {
  __typename?: 'SubscriptionBillingAttemptFailedState';
  /** The error that caused the billing attempt to fail. */
  error: SubscriptionBillingAttemptError;
};

/** An error that occurred during a subscription billing attempt that doesn't fit other categories. */
export type SubscriptionBillingAttemptGeneralError = {
  __typename?: 'SubscriptionBillingAttemptGeneralError';
  /** The error code for the failure. */
  code: SubscriptionBillingAttemptGeneralErrorCode;
};

/** Error codes for other billing attempt failures. */
export enum SubscriptionBillingAttemptGeneralErrorCode {
  /** Customer is invalid. */
  CustomerInvalid = 'CUSTOMER_INVALID',
  /** Customer was not found. */
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  /** Free gift cards are not allowed. */
  FreeGiftCardNotAllowed = 'FREE_GIFT_CARD_NOT_ALLOWED',
  /** Billing address is invalid. */
  InvalidBillingAddress = 'INVALID_BILLING_ADDRESS',
  /** Merchant account error. */
  MerchantAccountError = 'MERCHANT_ACCOUNT_ERROR',
  /** Non-test order limit reached. */
  NonTestOrderLimitReached = 'NON_TEST_ORDER_LIMIT_REACHED',
  /** Payment method test mode incompatible with gateway. */
  PaymentMethodIncompatibleWithGatewayConfig = 'PAYMENT_METHOD_INCOMPATIBLE_WITH_GATEWAY_CONFIG',
  /** Payment method was not found. */
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  /** Payment method not specified. */
  PaymentMethodNotSpecified = 'PAYMENT_METHOD_NOT_SPECIFIED',
  /** Payment provider is not enabled. */
  PaymentProviderIsNotEnabled = 'PAYMENT_PROVIDER_IS_NOT_ENABLED'
}

/** A base error type that applies to all uncategorized error classes. */
export type SubscriptionBillingAttemptGenericError = SubscriptionBillingAttemptProcessingError & {
  __typename?: 'SubscriptionBillingAttemptGenericError';
  /** The code for the error. */
  code: SubscriptionBillingAttemptErrorCode;
  /** An explanation of the error. */
  message: Scalars['String']['output'];
};

/** The input fields required to complete a subscription billing attempt. */
export type SubscriptionBillingAttemptInput = {
  /** The actor who initiated a subscription action. */
  actor?: InputMaybe<SubscriptionActor>;
  /**
   * Select the specific billing cycle to be billed.
   * Default to bill the current billing cycle if not specified.
   */
  billingCycleSelector?: InputMaybe<SubscriptionBillingCycleSelector>;
  /** A unique key generated by the client to avoid duplicate payments. For more information, refer to [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests). */
  idempotencyKey: Scalars['String']['input'];
  /**
   * The behaviour to follow when creating an order for a product variant
   *       when it's out of stock.
   */
  inventoryPolicy?: InputMaybe<SubscriptionBillingAttemptInventoryPolicy>;
  /**
   * The date and time used to calculate fulfillment intervals for a billing attempt that
   * successfully completed after the current anchor date. To prevent fulfillment from being
   * pushed to the next anchor date, this field can override the billing attempt date.
   */
  originTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Select payment processing policy for the billing attempt. Defaults to FAIL_UNLESS_VALID_PAYMENT_METHOD. */
  paymentProcessingPolicy?: InputMaybe<SubscriptionBillingAttemptPaymentProcessingPolicy>;
};

/** An inventory error caused by an issue with one or more of the contract merchandise lines. */
export type SubscriptionBillingAttemptInsufficientStockProductVariantsError = SubscriptionBillingAttemptProcessingError & {
  __typename?: 'SubscriptionBillingAttemptInsufficientStockProductVariantsError';
  /** The code for the error. */
  code: SubscriptionBillingAttemptErrorCode;
  /** A list of product variants that caused the insufficient inventory error. */
  insufficientStockProductVariants: ProductVariantConnection;
  /** An explanation of the error. */
  message: Scalars['String']['output'];
};


/** An inventory error caused by an issue with one or more of the contract merchandise lines. */
export type SubscriptionBillingAttemptInsufficientStockProductVariantsErrorInsufficientStockProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An inventory-related error that occurred during a subscription billing attempt. */
export type SubscriptionBillingAttemptInventoryError = {
  __typename?: 'SubscriptionBillingAttemptInventoryError';
  /** The error code for the inventory-related failure. */
  code: SubscriptionBillingAttemptInventoryErrorCode;
  /** A list of product variants that caused the insufficient inventory error. */
  insufficientStockProductVariants?: Maybe<ProductVariantConnection>;
};


/** An inventory-related error that occurred during a subscription billing attempt. */
export type SubscriptionBillingAttemptInventoryErrorInsufficientStockProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Error codes for inventory-related billing attempt failures. */
export enum SubscriptionBillingAttemptInventoryErrorCode {
  /** Insufficient inventory. */
  InsufficientInventory = 'INSUFFICIENT_INVENTORY',
  /** No inventory location found or enabled. */
  InventoryAllocationsNotFound = 'INVENTORY_ALLOCATIONS_NOT_FOUND'
}

/** The inventory policy for a billing attempt. */
export enum SubscriptionBillingAttemptInventoryPolicy {
  /**
   * Override the merchant's product variant
   *          inventory policy and allow overselling for this billing attempt.
   */
  AllowOverselling = 'ALLOW_OVERSELLING',
  /**
   * Respect the merchant's product variant
   *         inventory policy for this billing attempt.
   */
  ProductVariantInventoryPolicy = 'PRODUCT_VARIANT_INVENTORY_POLICY'
}

/** An inventory error caused by an issue with one or more of the contract merchandise lines. */
export type SubscriptionBillingAttemptOutOfStockProductVariantsError = SubscriptionBillingAttemptProcessingError & {
  __typename?: 'SubscriptionBillingAttemptOutOfStockProductVariantsError';
  /** The code for the error. */
  code: SubscriptionBillingAttemptErrorCode;
  /** An explanation of the error. */
  message: Scalars['String']['output'];
  /**
   * A list of responsible product variants.
   * @deprecated Use `subscriptionBillingAttemptInsufficientStockProductVariantsError` type instead.
   */
  outOfStockProductVariants: ProductVariantConnection;
};


/** An inventory error caused by an issue with one or more of the contract merchandise lines. */
export type SubscriptionBillingAttemptOutOfStockProductVariantsErrorOutOfStockProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A payment challenge that the customer must complete. */
export type SubscriptionBillingAttemptPaymentChallenge = {
  __typename?: 'SubscriptionBillingAttemptPaymentChallenge';
  /** URL to redirect the customer for authentication. */
  nextActionUrl: Scalars['URL']['output'];
  /** The status of the payment challenge. */
  status: SubscriptionBillingAttemptPaymentChallengeStatus;
};

/** The status of the billing attempt authentication process. */
export enum SubscriptionBillingAttemptPaymentChallengeStatus {
  /** The billing attempt is rejected because the customer action was required. The customer has not yet attempted to complete the challenge. */
  OffSessionRejected = 'OFF_SESSION_REJECTED',
  /** The customer was brought on session and challenged. */
  OnSessionChallenged = 'ON_SESSION_CHALLENGED'
}

/** A payment-related error that occurred during a subscription billing attempt. */
export type SubscriptionBillingAttemptPaymentError = {
  __typename?: 'SubscriptionBillingAttemptPaymentError';
  /** The error code for the payment failure. */
  code: SubscriptionBillingAttemptPaymentErrorCode;
};

/** Error codes for payment-related billing attempt failures. */
export enum SubscriptionBillingAttemptPaymentErrorCode {
  /** The transaction amount is too large. */
  AmountTooLarge = 'AMOUNT_TOO_LARGE',
  /** The transaction amount is too small. */
  AmountTooSmall = 'AMOUNT_TOO_SMALL',
  /** There was an error during the authentication. */
  AuthenticationError = 'AUTHENTICATION_ERROR',
  /** Authentication failed during the payment processing. */
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  /** Additional authentication is required for this payment. */
  AuthenticationRequired = 'AUTHENTICATION_REQUIRED',
  /** The buyer canceled the payment method. */
  BuyerCanceledPaymentMethod = 'BUYER_CANCELED_PAYMENT_METHOD',
  /** The card issuer requires the cardholder to call. */
  CallIssuer = 'CALL_ISSUER',
  /** The payment was cancelled. */
  CancelledPayment = 'CANCELLED_PAYMENT',
  /** The card was declined. */
  CardDeclined = 'CARD_DECLINED',
  /** The card number is incorrect. */
  CardNumberIncorrect = 'CARD_NUMBER_INCORRECT',
  /** The payment confirmation was rejected. */
  ConfirmationRejected = 'CONFIRMATION_REJECTED',
  /** The card issuer returned 'do not honor'. The customer should reach out to their card-issuing bank for more information. */
  DoNotHonor = 'DO_NOT_HONOR',
  /** The required buyer action has expired. */
  ExpiredBuyerAction = 'EXPIRED_BUYER_ACTION',
  /** The card has expired. */
  ExpiredCard = 'EXPIRED_CARD',
  /** Payment method has expired. */
  ExpiredPaymentMethod = 'EXPIRED_PAYMENT_METHOD',
  /** Fraud was suspected on this transaction. */
  FraudSuspected = 'FRAUD_SUSPECTED',
  /** A generic payment error occurred. */
  GenericError = 'GENERIC_ERROR',
  /** The billing address is incorrect. */
  IncorrectAddress = 'INCORRECT_ADDRESS',
  /** The card security code is incorrect. */
  IncorrectCvc = 'INCORRECT_CVC',
  /** The card number is incorrect. */
  IncorrectNumber = 'INCORRECT_NUMBER',
  /** The PIN is incorrect. */
  IncorrectPin = 'INCORRECT_PIN',
  /** The postal/ZIP code is incorrect. */
  IncorrectZip = 'INCORRECT_ZIP',
  /** The payment method has insufficient funds to complete the payment. */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The transaction amount is invalid. */
  InvalidAmount = 'INVALID_AMOUNT',
  /** The currency is not supported. */
  InvalidCurrency = 'INVALID_CURRENCY',
  /** The customer billing agreement is invalid. */
  InvalidCustomerBillingAgreement = 'INVALID_CUSTOMER_BILLING_AGREEMENT',
  /** The card security code is invalid. */
  InvalidCvc = 'INVALID_CVC',
  /** The expiry date is invalid. */
  InvalidExpiryDate = 'INVALID_EXPIRY_DATE',
  /** The card number is invalid. */
  InvalidNumber = 'INVALID_NUMBER',
  /** Payment method is invalid. */
  InvalidPaymentMethod = 'INVALID_PAYMENT_METHOD',
  /** The purchase type is invalid. */
  InvalidPurchaseType = 'INVALID_PURCHASE_TYPE',
  /** The payment request is invalid. */
  InvalidRequest = 'INVALID_REQUEST',
  /** The shipping address is invalid. */
  InvalidShippingAddress = 'INVALID_SHIPPING_ADDRESS',
  /** The invoice has already been paid. */
  InvoiceAlreadyPaid = 'INVOICE_ALREADY_PAID',
  /** The payment was declined due to a merchant rule. */
  MerchantRule = 'MERCHANT_RULE',
  /** The off-session payment was rejected. */
  OffSessionRejected = 'OFF_SESSION_REJECTED',
  /** Payment method was declined. */
  PaymentMethodDeclined = 'PAYMENT_METHOD_DECLINED',
  /** The payment method type is not supported. */
  PaymentMethodUnsupported = 'PAYMENT_METHOD_UNSUPPORTED',
  /** An exception occurred with the payment provider. */
  PaymentProviderError = 'PAYMENT_PROVIDER_ERROR',
  /** A general PayPal error occurred. */
  PaypalErrorGeneral = 'PAYPAL_ERROR_GENERAL',
  /** A processing error occurred. */
  ProcessingError = 'PROCESSING_ERROR',
  /** Purchase type is not supported. */
  PurchaseTypeNotSupported = 'PURCHASE_TYPE_NOT_SUPPORTED',
  /** The payment retry was declined. */
  RetryDeclined = 'RETRY_DECLINED',
  /** A test mode error occurred. */
  TestMode = 'TEST_MODE',
  /** The transaction exceeded the limit. */
  TransactionLimitExceeded = 'TRANSACTION_LIMIT_EXCEEDED',
  /** A transient error occurred, try again later. */
  TransientError = 'TRANSIENT_ERROR'
}

/** The payment processing policy for a billing attempt. */
export enum SubscriptionBillingAttemptPaymentProcessingPolicy {
  /**
   * Attempt to process payment on the billing attempt and fail the billing attempt if
   *         the payment method is not valid or if a payment method does not exist.
   */
  FailUnlessValidPaymentMethod = 'FAIL_UNLESS_VALID_PAYMENT_METHOD',
  /** Skip payment processing on the billing attempt and create an unpaid order. */
  SkipPaymentAndCreateUnpaidOrder = 'SKIP_PAYMENT_AND_CREATE_UNPAID_ORDER'
}

/** The billing attempt is currently being processed. */
export type SubscriptionBillingAttemptPendingState = {
  __typename?: 'SubscriptionBillingAttemptPendingState';
  /** Always true when the billing attempt is pending. */
  processing: Scalars['Boolean']['output'];
};

/** An error that prevented a billing attempt. */
export type SubscriptionBillingAttemptProcessingError = {
  /** The code for the error. */
  code: SubscriptionBillingAttemptErrorCode;
  /** An explanation of the error. */
  message: Scalars['String']['output'];
};

/** The state of a subscription billing attempt with state-specific data. */
export type SubscriptionBillingAttemptState = SubscriptionBillingAttemptActionRequiredState | SubscriptionBillingAttemptFailedState | SubscriptionBillingAttemptPendingState | SubscriptionBillingAttemptSuccessState;

/** The billing attempt completed successfully and created an order. */
export type SubscriptionBillingAttemptSuccessState = {
  __typename?: 'SubscriptionBillingAttemptSuccessState';
  /** The order created by the successful billing attempt. May be null if the order was deleted. */
  order?: Maybe<Order>;
};

/** An unexpected error that occurred during a subscription billing attempt. */
export type SubscriptionBillingAttemptUnexpectedError = {
  __typename?: 'SubscriptionBillingAttemptUnexpectedError';
  /** A message describing the unexpected error. */
  message: Scalars['String']['output'];
};

/** The set of valid sort keys for the SubscriptionBillingAttempts query. */
export enum SubscriptionBillingAttemptsSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** A subscription billing cycle. */
export type SubscriptionBillingCycle = {
  __typename?: 'SubscriptionBillingCycle';
  /** The date on which the billing attempt is expected to be made. */
  billingAttemptExpectedDate: Scalars['DateTime']['output'];
  /** The list of billing attempts associated with the billing cycle. */
  billingAttempts: SubscriptionBillingAttemptConnection;
  /** The end date of the billing cycle. */
  cycleEndAt: Scalars['DateTime']['output'];
  /** The index of the billing cycle. */
  cycleIndex: Scalars['Int']['output'];
  /** The start date of the billing cycle. */
  cycleStartAt: Scalars['DateTime']['output'];
  /** Whether this billing cycle was edited. */
  edited: Scalars['Boolean']['output'];
  /** The active edited contract for the billing cycle. */
  editedContract?: Maybe<SubscriptionBillingCycleEditedContract>;
  /** Whether this billing cycle was skipped. */
  skipped: Scalars['Boolean']['output'];
  /** The subscription contract that the billing cycle belongs to. */
  sourceContract: SubscriptionContract;
  /** The status of the billing cycle. */
  status: SubscriptionBillingCycleBillingCycleStatus;
};


/** A subscription billing cycle. */
export type SubscriptionBillingCycleBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The presence of billing attempts on Billing Cycles. */
export enum SubscriptionBillingCycleBillingAttemptStatus {
  /** Billing cycle has any number of billing attempts. */
  Any = 'ANY',
  /** Billing cycle has at least one billing attempt. */
  HasAttempt = 'HAS_ATTEMPT',
  /** Billing cycle has no billing attempts. */
  NoAttempt = 'NO_ATTEMPT'
}

/** The possible status values of a subscription billing cycle. */
export enum SubscriptionBillingCycleBillingCycleStatus {
  /** The billing cycle is billed. */
  Billed = 'BILLED',
  /** The billing cycle hasn't been billed. */
  Unbilled = 'UNBILLED'
}

/** Return type for `subscriptionBillingCycleBulkCharge` mutation. */
export type SubscriptionBillingCycleBulkChargePayload = {
  __typename?: 'SubscriptionBillingCycleBulkChargePayload';
  /** The asynchronous job that performs the action on the targeted billing cycles. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleBulkUserError>;
};

/** The input fields for filtering subscription billing cycles in bulk actions. */
export type SubscriptionBillingCycleBulkFilters = {
  /** Filters the billing cycles based on the presence of billing attempts. */
  billingAttemptStatus?: InputMaybe<SubscriptionBillingCycleBillingAttemptStatus>;
  /** Filters the billing cycles based on their status. */
  billingCycleStatus?: InputMaybe<Array<SubscriptionBillingCycleBillingCycleStatus>>;
  /** Filters the billing cycles based on the status of their associated subscription contracts. */
  contractStatus?: InputMaybe<Array<SubscriptionContractSubscriptionStatus>>;
};

/** Return type for `subscriptionBillingCycleBulkSearch` mutation. */
export type SubscriptionBillingCycleBulkSearchPayload = {
  __typename?: 'SubscriptionBillingCycleBulkSearchPayload';
  /** The asynchronous job that performs the action on the targeted billing cycles. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleBulkUserError>;
};

/** Represents an error that happens during the execution of subscriptionBillingCycles mutations. */
export type SubscriptionBillingCycleBulkUserError = DisplayableError & {
  __typename?: 'SubscriptionBillingCycleBulkUserError';
  /** The error code. */
  code?: Maybe<SubscriptionBillingCycleBulkUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleBulkUserError`. */
export enum SubscriptionBillingCycleBulkUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** End date can't be more than 24 hours in the future. */
  EndDateInTheFuture = 'END_DATE_IN_THE_FUTURE',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The range between start date and end date shouldn't be more than 1 week. */
  InvalidDateRange = 'INVALID_DATE_RANGE',
  /** Start date should be before end date. */
  StartDateBeforeEndDate = 'START_DATE_BEFORE_END_DATE'
}

/** Return type for `subscriptionBillingCycleCharge` mutation. */
export type SubscriptionBillingCycleChargePayload = {
  __typename?: 'SubscriptionBillingCycleChargePayload';
  /** The subscription billing attempt. */
  subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<BillingAttemptUserError>;
};

/** An auto-generated type for paginating through multiple SubscriptionBillingCycles. */
export type SubscriptionBillingCycleConnection = {
  __typename?: 'SubscriptionBillingCycleConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionBillingCycleEdge>;
  /** A list of nodes that are contained in SubscriptionBillingCycleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionBillingCycle>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `subscriptionBillingCycleContractDraftCommit` mutation. */
export type SubscriptionBillingCycleContractDraftCommitPayload = {
  __typename?: 'SubscriptionBillingCycleContractDraftCommitPayload';
  /** The committed Subscription Billing Cycle Edited Contract object. */
  contract?: Maybe<SubscriptionBillingCycleEditedContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionBillingCycleContractDraftConcatenate` mutation. */
export type SubscriptionBillingCycleContractDraftConcatenatePayload = {
  __typename?: 'SubscriptionBillingCycleContractDraftConcatenatePayload';
  /** The Subscription Draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionBillingCycleContractEdit` mutation. */
export type SubscriptionBillingCycleContractEditPayload = {
  __typename?: 'SubscriptionBillingCycleContractEditPayload';
  /** The draft subscription contract object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** An auto-generated type which holds one SubscriptionBillingCycle and a cursor during pagination. */
export type SubscriptionBillingCycleEdge = {
  __typename?: 'SubscriptionBillingCycleEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionBillingCycleEdge. */
  node: SubscriptionBillingCycle;
};

/** Return type for `subscriptionBillingCycleEditDelete` mutation. */
export type SubscriptionBillingCycleEditDeletePayload = {
  __typename?: 'SubscriptionBillingCycleEditDeletePayload';
  /** The list of updated billing cycles. */
  billingCycles?: Maybe<Array<SubscriptionBillingCycle>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleUserError>;
};

/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContract = SubscriptionContractBase & {
  __typename?: 'SubscriptionBillingCycleEditedContract';
  /** The subscription app that the subscription contract is registered to. */
  app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  appAdminUrl?: Maybe<Scalars['URL']['output']>;
  /** The billing cycles that the edited contract belongs to. */
  billingCycles: SubscriptionBillingCycleConnection;
  /** The date and time when the subscription contract was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency that's used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  customAttributes: Array<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery price for each billing of the subscription contract. */
  deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  discounts: SubscriptionManualDiscountConnection;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  lineCount: Scalars['Int']['output'];
  /** The list of subscription lines associated with the subscription contract. */
  lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  linesCount?: Maybe<Count>;
  /** The note field that will be applied to the generated orders. */
  note?: Maybe<Scalars['String']['output']>;
  /** A list of the subscription contract's orders. */
  orders: OrderConnection;
  /** The date and time when the subscription contract was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `subscriptionBillingCycleEditsDelete` mutation. */
export type SubscriptionBillingCycleEditsDeletePayload = {
  __typename?: 'SubscriptionBillingCycleEditsDeletePayload';
  /** The list of updated billing cycles. */
  billingCycles?: Maybe<Array<SubscriptionBillingCycle>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleUserError>;
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleUserError`. */
export enum SubscriptionBillingCycleErrorCode {
  /** Billing date cannot be set on skipped billing cycle. */
  BillingDateSetOnSkipped = 'BILLING_DATE_SET_ON_SKIPPED',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CycleIndexOutOfRange = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Can't find the billing cycle. */
  CycleNotFound = 'CYCLE_NOT_FOUND',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CycleStartDateOutOfRange = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** Billing cycle schedule edit input provided is empty. Must take in parameters to modify schedule. */
  EmptyBillingCycleEditScheduleInput = 'EMPTY_BILLING_CYCLE_EDIT_SCHEDULE_INPUT',
  /** Billing cycle has incomplete billing attempts in progress. */
  IncompleteBillingAttempts = 'INCOMPLETE_BILLING_ATTEMPTS',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The index selector is invalid. */
  InvalidCycleIndex = 'INVALID_CYCLE_INDEX',
  /** The date selector is invalid. */
  InvalidDate = 'INVALID_DATE',
  /** There's no contract or schedule edit associated with the targeted billing cycle(s). */
  NoCycleEdits = 'NO_CYCLE_EDITS',
  /** Billing date of a cycle cannot be set to a value outside of its billing date range. */
  OutOfBounds = 'OUT_OF_BOUNDS',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UpcomingCycleLimitExceeded = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/** The input fields for specifying the subscription contract and selecting the associated billing cycle. */
export type SubscriptionBillingCycleInput = {
  /** The ID of the subscription contract associated with the billing cycle. */
  contractId: Scalars['ID']['input'];
  /** Selects the billing cycle by date or index. */
  selector: SubscriptionBillingCycleSelector;
};

/** The input fields for parameters to modify the schedule of a specific billing cycle. */
export type SubscriptionBillingCycleScheduleEditInput = {
  /** Sets the expected billing date for the billing cycle. */
  billingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The reason for editing. */
  reason: SubscriptionBillingCycleScheduleEditInputScheduleEditReason;
  /** Sets the skip status for the billing cycle. */
  skip?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for possible reasons for editing the billing cycle's schedule. */
export enum SubscriptionBillingCycleScheduleEditInputScheduleEditReason {
  /** Buyer initiated the schedule edit. */
  BuyerInitiated = 'BUYER_INITIATED',
  /** Developer initiated the schedule edit. */
  DevInitiated = 'DEV_INITIATED',
  /** Merchant initiated the schedule edit. */
  MerchantInitiated = 'MERCHANT_INITIATED'
}

/** Return type for `subscriptionBillingCycleScheduleEdit` mutation. */
export type SubscriptionBillingCycleScheduleEditPayload = {
  __typename?: 'SubscriptionBillingCycleScheduleEditPayload';
  /** The updated billing cycle. */
  billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleUserError>;
};

/** The input fields to select SubscriptionBillingCycle by either date or index. Both past and future billing cycles can be selected. */
export type SubscriptionBillingCycleSelector = {
  /** Returns a billing cycle by date. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Returns a billing cycle by index. */
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** Return type for `subscriptionBillingCycleSkip` mutation. */
export type SubscriptionBillingCycleSkipPayload = {
  __typename?: 'SubscriptionBillingCycleSkipPayload';
  /** The updated billing cycle. */
  billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleSkipUserError>;
};

/** An error that occurs during the execution of `SubscriptionBillingCycleSkip`. */
export type SubscriptionBillingCycleSkipUserError = DisplayableError & {
  __typename?: 'SubscriptionBillingCycleSkipUserError';
  /** The error code. */
  code?: Maybe<SubscriptionBillingCycleSkipUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleSkipUserError`. */
export enum SubscriptionBillingCycleSkipUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `subscriptionBillingCycleUnskip` mutation. */
export type SubscriptionBillingCycleUnskipPayload = {
  __typename?: 'SubscriptionBillingCycleUnskipPayload';
  /** The updated billing cycle. */
  billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionBillingCycleUnskipUserError>;
};

/** An error that occurs during the execution of `SubscriptionBillingCycleUnskip`. */
export type SubscriptionBillingCycleUnskipUserError = DisplayableError & {
  __typename?: 'SubscriptionBillingCycleUnskipUserError';
  /** The error code. */
  code?: Maybe<SubscriptionBillingCycleUnskipUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleUnskipUserError`. */
export enum SubscriptionBillingCycleUnskipUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** The possible errors for a subscription billing cycle. */
export type SubscriptionBillingCycleUserError = DisplayableError & {
  __typename?: 'SubscriptionBillingCycleUserError';
  /** The error code. */
  code?: Maybe<SubscriptionBillingCycleErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The input fields to select a subset of subscription billing cycles within a date range. */
export type SubscriptionBillingCyclesDateRangeSelector = {
  /** The end date and time for the range. */
  endDate: Scalars['DateTime']['input'];
  /** The start date and time for the range. */
  startDate: Scalars['DateTime']['input'];
};

/** The input fields to select a subset of subscription billing cycles within an index range. */
export type SubscriptionBillingCyclesIndexRangeSelector = {
  /** The end index for the range. */
  endIndex: Scalars['Int']['input'];
  /** The start index for the range. */
  startIndex: Scalars['Int']['input'];
};

/** The set of valid sort keys for the SubscriptionBillingCycles query. */
export enum SubscriptionBillingCyclesSortKeys {
  /** Sort by the `cycle_index` value. */
  CycleIndex = 'CYCLE_INDEX',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** Select subscription billing cycles to be targeted. */
export enum SubscriptionBillingCyclesTargetSelection {
  /** Target all current and upcoming subscription billing cycles. */
  All = 'ALL'
}

/** Represents a Subscription Billing Policy. */
export type SubscriptionBillingPolicy = {
  __typename?: 'SubscriptionBillingPolicy';
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  anchors: Array<SellingPlanAnchor>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  intervalCount: Scalars['Int']['output'];
  /** Maximum amount of cycles after which the subscription ends. */
  maxCycles?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount of cycles required in the subscription. */
  minCycles?: Maybe<Scalars['Int']['output']>;
};

/** The input fields for a Subscription Billing Policy. */
export type SubscriptionBillingPolicyInput = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  anchors?: InputMaybe<Array<SellingPlanAnchorInput>>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  intervalCount: Scalars['Int']['input'];
  /** Maximum amount of cycles required in the subscription. */
  maxCycles?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum amount of cycles required in the subscription. */
  minCycles?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContract = Node & SubscriptionContractBase & {
  __typename?: 'SubscriptionContract';
  /** The subscription app that the subscription contract is registered to. */
  app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  appAdminUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of billing attempts associated with the subscription contract. */
  billingAttempts: SubscriptionBillingAttemptConnection;
  /** The billing policy associated with the subscription contract. */
  billingPolicy: SubscriptionBillingPolicy;
  /** The date and time when the subscription contract was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency that's used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  customAttributes: Array<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery policy associated with the subscription contract. */
  deliveryPolicy: SubscriptionDeliveryPolicy;
  /** The delivery price for each billing of the subscription contract. */
  deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  discounts: SubscriptionManualDiscountConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last billing error type of the contract. */
  lastBillingAttemptErrorType?: Maybe<SubscriptionContractLastBillingErrorType>;
  /** The current status of the last payment. */
  lastPaymentStatus?: Maybe<SubscriptionContractLastPaymentStatus>;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  lineCount: Scalars['Int']['output'];
  /** The list of subscription lines associated with the subscription contract. */
  lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  linesCount?: Maybe<Count>;
  /**
   * The next billing date for the subscription contract. This field is managed by the apps.
   *         Alternatively you can utilize our
   *         [Billing Cycles APIs](https://shopify.dev/docs/apps/selling-strategies/subscriptions/billing-cycles),
   *         which provide auto-computed billing dates and additional functionalities.
   */
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  /** The note field that will be applied to the generated orders. */
  note?: Maybe<Scalars['String']['output']>;
  /** A list of the subscription contract's orders. */
  orders: OrderConnection;
  /** The order from which this contract originated. */
  originOrder?: Maybe<Order>;
  /** The revision id of the contract. */
  revisionId: Scalars['UnsignedInt64']['output'];
  /** The current status of the subscription contract. */
  status: SubscriptionContractSubscriptionStatus;
  /** The date and time when the subscription contract was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContractBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContractCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContractDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContractLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A subscription contract that defines recurring purchases for a customer. Each contract specifies what products to deliver, when to bill and ship them, and at what price.
 *
 * The contract includes [`SubscriptionBillingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingPolicy) and [`SubscriptionDeliveryPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDeliveryPolicy) that control the frequency of charges and fulfillments. [`SubscriptionLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionLine) items define the products, quantities, and pricing for each recurring [`Order`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Order). The contract tracks [`SubscriptionBillingAttempt`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionBillingAttempt) records, payment status, and generated orders throughout its lifecycle. [`App`](https://shopify.dev/docs/api/admin-graphql/latest/objects/App) instances manage contracts through various status transitions including active, paused, failed, cancelled, or expired states.
 *
 * Learn more about [building subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract) and [updating subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract).
 */
export type SubscriptionContractOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `subscriptionContractActivate` mutation. */
export type SubscriptionContractActivatePayload = {
  __typename?: 'SubscriptionContractActivatePayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractStatusUpdateUserError>;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractAtomicCreateInput = {
  /** The actor who initiated a subscription action. */
  actor?: InputMaybe<SubscriptionActor>;
  /** The attributes used as input for the Subscription Draft. */
  contract: SubscriptionDraftInput;
  /** The currency used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** The ID of the customer to associate with the subscription contract. */
  customerId: Scalars['ID']['input'];
  /** A list of discount redeem codes to apply to the subscription contract. */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of new Subscription Lines. */
  lines: Array<SubscriptionAtomicLineInput>;
  /** The next billing date for the subscription contract.This field is independent of billing cycles.It stores metadata set by the apps, and thus not managed by Shopify.It can be queried from subscriptionContract.nextBillingDate. */
  nextBillingDate: Scalars['DateTime']['input'];
};

/** Return type for `subscriptionContractAtomicCreate` mutation. */
export type SubscriptionContractAtomicCreatePayload = {
  __typename?: 'SubscriptionContractAtomicCreatePayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Represents subscription contract common fields. */
export type SubscriptionContractBase = {
  /** The subscription app that the subscription contract is registered to. */
  app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  appAdminUrl?: Maybe<Scalars['URL']['output']>;
  /** The currency that's used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  customAttributes: Array<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery price for each billing of the subscription contract. */
  deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  discounts: SubscriptionManualDiscountConnection;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  lineCount: Scalars['Int']['output'];
  /** The list of subscription lines associated with the subscription contract. */
  lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  linesCount?: Maybe<Count>;
  /** The note field that will be applied to the generated orders. */
  note?: Maybe<Scalars['String']['output']>;
  /** A list of the subscription contract's orders. */
  orders: OrderConnection;
  /** The date and time when the subscription contract was updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return type for `subscriptionContractCancel` mutation. */
export type SubscriptionContractCancelPayload = {
  __typename?: 'SubscriptionContractCancelPayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractStatusUpdateUserError>;
};

/** An auto-generated type for paginating through multiple SubscriptionContracts. */
export type SubscriptionContractConnection = {
  __typename?: 'SubscriptionContractConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionContractEdge>;
  /** A list of nodes that are contained in SubscriptionContractEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionContract>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractCreateInput = {
  /** The actor who initiated a subscription action. */
  actor?: InputMaybe<SubscriptionActor>;
  /** The attributes used as input for the Subscription Draft. */
  contract: SubscriptionDraftInput;
  /** The currency used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** The ID of the customer to associate with the subscription contract. */
  customerId: Scalars['ID']['input'];
  /** The next billing date for the subscription contract. */
  nextBillingDate: Scalars['DateTime']['input'];
};

/** Return type for `subscriptionContractCreate` mutation. */
export type SubscriptionContractCreatePayload = {
  __typename?: 'SubscriptionContractCreatePayload';
  /** The Subscription Contract object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** An auto-generated type which holds one SubscriptionContract and a cursor during pagination. */
export type SubscriptionContractEdge = {
  __typename?: 'SubscriptionContractEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionContractEdge. */
  node: SubscriptionContract;
};

/** Possible error codes that can be returned by `SubscriptionContractUserError`. */
export enum SubscriptionContractErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Return type for `subscriptionContractExpire` mutation. */
export type SubscriptionContractExpirePayload = {
  __typename?: 'SubscriptionContractExpirePayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractStatusUpdateUserError>;
};

/** Return type for `subscriptionContractFail` mutation. */
export type SubscriptionContractFailPayload = {
  __typename?: 'SubscriptionContractFailPayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractStatusUpdateUserError>;
};

/** The possible values of the last billing error on a subscription contract. */
export enum SubscriptionContractLastBillingErrorType {
  /** Subscription billing attempt error due to customer error. */
  CustomerError = 'CUSTOMER_ERROR',
  /** Subscription billing attempt error due to inventory error. */
  InventoryError = 'INVENTORY_ERROR',
  /** All other billing attempt errors. */
  Other = 'OTHER',
  /** Subscription billing attempt error due to payment error. */
  PaymentError = 'PAYMENT_ERROR'
}

/** The possible status values of the last payment on a subscription contract. */
export enum SubscriptionContractLastPaymentStatus {
  /** Failed subscription billing attempt. */
  Failed = 'FAILED',
  /** Successful subscription billing attempt. */
  Succeeded = 'SUCCEEDED'
}

/** Return type for `subscriptionContractPause` mutation. */
export type SubscriptionContractPausePayload = {
  __typename?: 'SubscriptionContractPausePayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractStatusUpdateUserError>;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractProductChangeInput = {
  /** The price of the product. */
  currentPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The ID of the product variant the subscription line refers to. */
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `subscriptionContractProductChange` mutation. */
export type SubscriptionContractProductChangePayload = {
  __typename?: 'SubscriptionContractProductChangePayload';
  /** The new Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The updated Subscription Line. */
  lineUpdated?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionContractSetNextBillingDate` mutation. */
export type SubscriptionContractSetNextBillingDatePayload = {
  __typename?: 'SubscriptionContractSetNextBillingDatePayload';
  /** The updated Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionContractUserError>;
};

/** Possible error codes that can be returned by `SubscriptionContractStatusUpdateUserError`. */
export enum SubscriptionContractStatusUpdateErrorCode {
  /** Subscription contract status cannot be changed once terminated. */
  ContractTerminated = 'CONTRACT_TERMINATED',
  /** The input value is invalid. */
  Invalid = 'INVALID'
}

/** Represents a subscription contract status update error. */
export type SubscriptionContractStatusUpdateUserError = DisplayableError & {
  __typename?: 'SubscriptionContractStatusUpdateUserError';
  /** The error code. */
  code?: Maybe<SubscriptionContractStatusUpdateErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The possible status values of a subscription. */
export enum SubscriptionContractSubscriptionStatus {
  /** The contract is active and continuing per its policies. */
  Active = 'ACTIVE',
  /** The contract was ended by an unplanned customer action. */
  Cancelled = 'CANCELLED',
  /** The contract has ended per the expected circumstances. All billing and deliverycycles of the subscriptions were executed. */
  Expired = 'EXPIRED',
  /** The contract ended because billing failed and no further billing attempts are expected. */
  Failed = 'FAILED',
  /** The contract is temporarily paused and is expected to resume in the future. */
  Paused = 'PAUSED'
}

/** Return type for `subscriptionContractUpdate` mutation. */
export type SubscriptionContractUpdatePayload = {
  __typename?: 'SubscriptionContractUpdatePayload';
  /** The Subscription Contract object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Represents a Subscription Contract error. */
export type SubscriptionContractUserError = DisplayableError & {
  __typename?: 'SubscriptionContractUserError';
  /** The error code. */
  code?: Maybe<SubscriptionContractErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The set of valid sort keys for the SubscriptionContracts query. */
export enum SubscriptionContractsSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `status` value. */
  Status = 'STATUS',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents a Subscription Line Pricing Cycle Adjustment. */
export type SubscriptionCyclePriceAdjustment = {
  __typename?: 'SubscriptionCyclePriceAdjustment';
  /** Price adjustment type. */
  adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** Price adjustment value. */
  adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** The number of cycles required before this pricing policy applies. */
  afterCycle: Scalars['Int']['output'];
  /** The computed price after the adjustments applied. */
  computedPrice: MoneyV2;
};

/** Describes the delivery method to use to get the physical goods to the customer. */
export type SubscriptionDeliveryMethod = SubscriptionDeliveryMethodLocalDelivery | SubscriptionDeliveryMethodPickup | SubscriptionDeliveryMethodShipping;

/**
 * Specifies delivery method fields for a subscription draft.
 * This is an input union: one, and only one, field can be provided.
 * The field provided will determine which delivery method is to be used.
 */
export type SubscriptionDeliveryMethodInput = {
  /** The input fields for the local delivery method. */
  localDelivery?: InputMaybe<SubscriptionDeliveryMethodLocalDeliveryInput>;
  /** The input fields for the pickup delivery method. */
  pickup?: InputMaybe<SubscriptionDeliveryMethodPickupInput>;
  /** The input fields for the shipping delivery method. */
  shipping?: InputMaybe<SubscriptionDeliveryMethodShippingInput>;
};

/**
 * A subscription delivery method for local delivery.
 * The other subscription delivery methods can be found in the `SubscriptionDeliveryMethod` union type.
 */
export type SubscriptionDeliveryMethodLocalDelivery = {
  __typename?: 'SubscriptionDeliveryMethodLocalDelivery';
  /** The address to deliver to. */
  address: MailingAddress;
  /** The details of the local delivery method to use. */
  localDeliveryOption: SubscriptionDeliveryMethodLocalDeliveryOption;
};

/**
 * The input fields for a local delivery method.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodLocalDeliveryInput = {
  /** The address to deliver to. */
  address?: InputMaybe<MailingAddressInput>;
  /** The details of the local delivery method to use. */
  localDeliveryOption?: InputMaybe<SubscriptionDeliveryMethodLocalDeliveryOptionInput>;
};

/** The selected delivery option on a subscription contract. */
export type SubscriptionDeliveryMethodLocalDeliveryOption = {
  __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption';
  /** A custom reference to the delivery method for use with automations. */
  code?: Maybe<Scalars['String']['output']>;
  /** The details displayed to the customer to describe the local delivery option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The delivery instructions that the customer can provide to the merchant. */
  instructions?: Maybe<Scalars['String']['output']>;
  /**
   * The phone number that the customer provided to the merchant.
   * Formatted using E.164 standard. For example, `+16135551111`.
   */
  phone: Scalars['String']['output'];
  /** The presentment title of the local delivery option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the local delivery option. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The input fields for local delivery option. */
export type SubscriptionDeliveryMethodLocalDeliveryOptionInput = {
  /** A custom reference to the delivery method for use with automations. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The details displayed to the customer to describe the local delivery option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The delivery instructions that the customer can provide to the merchant. */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * The phone number that the customer must provide to the merchant.
   * Formatted using E.164 standard. For example, `+16135551111`.
   */
  phone: Scalars['String']['input'];
  /** The presentment title of the local delivery option. */
  presentmentTitle?: InputMaybe<Scalars['String']['input']>;
  /** The title of the local delivery option. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A delivery method with a pickup option. */
export type SubscriptionDeliveryMethodPickup = {
  __typename?: 'SubscriptionDeliveryMethodPickup';
  /** The details of the pickup delivery method to use. */
  pickupOption: SubscriptionDeliveryMethodPickupOption;
};

/**
 * The input fields for a pickup delivery method.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodPickupInput = {
  /** The details of the pickup method to use. */
  pickupOption?: InputMaybe<SubscriptionDeliveryMethodPickupOptionInput>;
};

/** Represents the selected pickup option on a subscription contract. */
export type SubscriptionDeliveryMethodPickupOption = {
  __typename?: 'SubscriptionDeliveryMethodPickupOption';
  /** A custom reference to the delivery method for use with automations. */
  code?: Maybe<Scalars['String']['output']>;
  /** The details displayed to the customer to describe the pickup option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The location where the customer will pick up the merchandise. */
  location: Location;
  /** The presentment title of the pickup option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the pickup option. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The input fields for pickup option. */
export type SubscriptionDeliveryMethodPickupOptionInput = {
  /** A custom reference to the delivery method for use with automations. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The details displayed to the customer to describe the pickup option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pickup location. */
  locationId: Scalars['ID']['input'];
  /** The presentment title of the pickup option. */
  presentmentTitle?: InputMaybe<Scalars['String']['input']>;
  /** The title of the pickup option. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shipping delivery method: a mailing address and a shipping option. */
export type SubscriptionDeliveryMethodShipping = {
  __typename?: 'SubscriptionDeliveryMethodShipping';
  /** The address to ship to. */
  address: MailingAddress;
  /** The details of the shipping method to use. */
  shippingOption: SubscriptionDeliveryMethodShippingOption;
};

/**
 * Specifies shipping delivery method fields.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodShippingInput = {
  /** The address to ship to. */
  address?: InputMaybe<MailingAddressInput>;
  /** The details of the shipping method to use. */
  shippingOption?: InputMaybe<SubscriptionDeliveryMethodShippingOptionInput>;
};

/** Represents the selected shipping option on a subscription contract. */
export type SubscriptionDeliveryMethodShippingOption = {
  __typename?: 'SubscriptionDeliveryMethodShippingOption';
  /**
   * The carrier service that's providing this shipping option.
   * This field isn't currently supported and returns null.
   * @deprecated This field has never been implemented.
   */
  carrierService?: Maybe<DeliveryCarrierService>;
  /** The code of the shipping option. */
  code?: Maybe<Scalars['String']['output']>;
  /** The description of the shipping option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The presentment title of the shipping option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the shipping option. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The input fields for shipping option. */
export type SubscriptionDeliveryMethodShippingOptionInput = {
  /** The carrier service ID of the shipping option. */
  carrierServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** The code of the shipping option. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The description of the shipping option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The presentment title of the shipping option. */
  presentmentTitle?: InputMaybe<Scalars['String']['input']>;
  /** The title of the shipping option. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The delivery option for a subscription contract. */
export type SubscriptionDeliveryOption = SubscriptionLocalDeliveryOption | SubscriptionPickupOption | SubscriptionShippingOption;

/** The result of the query to fetch delivery options for the subscription contract. */
export type SubscriptionDeliveryOptionResult = SubscriptionDeliveryOptionResultFailure | SubscriptionDeliveryOptionResultSuccess;

/** A failure to find the available delivery options for a subscription contract. */
export type SubscriptionDeliveryOptionResultFailure = {
  __typename?: 'SubscriptionDeliveryOptionResultFailure';
  /** The reason for the failure. */
  message?: Maybe<Scalars['String']['output']>;
};

/** The delivery option for a subscription contract. */
export type SubscriptionDeliveryOptionResultSuccess = {
  __typename?: 'SubscriptionDeliveryOptionResultSuccess';
  /** The available delivery options. */
  deliveryOptions: Array<SubscriptionDeliveryOption>;
};

/** Represents a Subscription Delivery Policy. */
export type SubscriptionDeliveryPolicy = {
  __typename?: 'SubscriptionDeliveryPolicy';
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors: Array<SellingPlanAnchor>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  interval: SellingPlanInterval;
  /** The number of delivery intervals between deliveries. */
  intervalCount: Scalars['Int']['output'];
};

/** The input fields for a Subscription Delivery Policy. */
export type SubscriptionDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  anchors?: InputMaybe<Array<SellingPlanAnchorInput>>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  intervalCount: Scalars['Int']['input'];
};

/** Subscription draft discount types. */
export type SubscriptionDiscount = SubscriptionAppliedCodeDiscount | SubscriptionManualDiscount;

/** Represents what a particular discount reduces from a line price. */
export type SubscriptionDiscountAllocation = {
  __typename?: 'SubscriptionDiscountAllocation';
  /** Allocation amount. */
  amount: MoneyV2;
  /** Discount that created the allocation. */
  discount: SubscriptionDiscount;
};

/** An auto-generated type for paginating through multiple SubscriptionDiscounts. */
export type SubscriptionDiscountConnection = {
  __typename?: 'SubscriptionDiscountConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionDiscountEdge>;
  /** A list of nodes that are contained in SubscriptionDiscountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionDiscount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionDiscount and a cursor during pagination. */
export type SubscriptionDiscountEdge = {
  __typename?: 'SubscriptionDiscountEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionDiscountEdge. */
  node: SubscriptionDiscount;
};

/** Represents the subscription lines the discount applies on. */
export type SubscriptionDiscountEntitledLines = {
  __typename?: 'SubscriptionDiscountEntitledLines';
  /** Specify whether the subscription discount will apply on all subscription lines. */
  all: Scalars['Boolean']['output'];
  /** The list of subscription lines associated with the subscription discount. */
  lines: SubscriptionLineConnection;
};


/** Represents the subscription lines the discount applies on. */
export type SubscriptionDiscountEntitledLinesLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The value of the discount and how it will be applied. */
export type SubscriptionDiscountFixedAmountValue = {
  __typename?: 'SubscriptionDiscountFixedAmountValue';
  /** The fixed amount value of the discount. */
  amount: MoneyV2;
  /** Whether the amount is applied per item. */
  appliesOnEachItem: Scalars['Boolean']['output'];
};

/** The percentage value of the discount. */
export type SubscriptionDiscountPercentageValue = {
  __typename?: 'SubscriptionDiscountPercentageValue';
  /** The percentage value of the discount. */
  percentage: Scalars['Int']['output'];
};

/** The reason a discount on a subscription draft was rejected. */
export enum SubscriptionDiscountRejectionReason {
  /** Discount is inactive. */
  CurrentlyInactive = 'CURRENTLY_INACTIVE',
  /** Given customer does not qualify for the discount. */
  CustomerNotEligible = 'CUSTOMER_NOT_ELIGIBLE',
  /** Customer usage limit has been reached. */
  CustomerUsageLimitReached = 'CUSTOMER_USAGE_LIMIT_REACHED',
  /** Purchase type does not qualify for the discount. */
  IncompatiblePurchaseType = 'INCOMPATIBLE_PURCHASE_TYPE',
  /** Internal error during discount code validation. */
  InternalError = 'INTERNAL_ERROR',
  /** Discount code is not found. */
  NotFound = 'NOT_FOUND',
  /** Discount does not apply to any of the given line items. */
  NoEntitledLineItems = 'NO_ENTITLED_LINE_ITEMS',
  /** No applicable shipping lines. */
  NoEntitledShippingLines = 'NO_ENTITLED_SHIPPING_LINES',
  /** Purchase amount of items does not qualify for the discount. */
  PurchaseNotInRange = 'PURCHASE_NOT_IN_RANGE',
  /** Quantity of items does not qualify for the discount. */
  QuantityNotInRange = 'QUANTITY_NOT_IN_RANGE',
  /** Discount usage limit has been reached. */
  UsageLimitReached = 'USAGE_LIMIT_REACHED'
}

/** The value of the discount and how it will be applied. */
export type SubscriptionDiscountValue = SubscriptionDiscountFixedAmountValue | SubscriptionDiscountPercentageValue;

/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraft = Node & {
  __typename?: 'SubscriptionDraft';
  /** The billing cycle that the subscription contract will be associated with. */
  billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The billing policy for the subscription contract. */
  billingPolicy: SubscriptionBillingPolicy;
  /** The billing cycles of the contracts that will be concatenated to the subscription contract. */
  concatenatedBillingCycles: SubscriptionBillingCycleConnection;
  /** The currency used for the subscription contract. */
  currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  customAttributes: Array<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  customer: Customer;
  /** The customer payment method used for the subscription contract. */
  customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The available delivery options for a given delivery address. Returns `null` for pending requests. */
  deliveryOptions?: Maybe<SubscriptionDeliveryOptionResult>;
  /** The delivery policy for the subscription contract. */
  deliveryPolicy: SubscriptionDeliveryPolicy;
  /** The delivery price for each billing the subscription contract. */
  deliveryPrice?: Maybe<MoneyV2>;
  /** The list of subscription discounts which will be associated with the subscription contract. */
  discounts: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be added to the subscription contract. */
  discountsAdded: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be removed from the subscription contract. */
  discountsRemoved: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be updated on the subscription contract. */
  discountsUpdated: SubscriptionDiscountConnection;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The list of subscription lines which will be associated with the subscription contract. */
  lines: SubscriptionLineConnection;
  /** The list of subscription lines to be added to the subscription contract. */
  linesAdded: SubscriptionLineConnection;
  /** The list of subscription lines to be removed from the subscription contract. */
  linesRemoved: SubscriptionLineConnection;
  /** The next billing date for the subscription contract. */
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  /** The note field that will be applied to the generated orders. */
  note?: Maybe<Scalars['String']['output']>;
  /** The original subscription contract. */
  originalContract?: Maybe<SubscriptionContract>;
  /**
   * Available Shipping Options for a given delivery address. Returns NULL for pending requests.
   * @deprecated Use `deliveryOptions` instead.
   */
  shippingOptions?: Maybe<SubscriptionShippingOptionResult>;
  /** The current status of the subscription contract. */
  status?: Maybe<SubscriptionContractSubscriptionStatus>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftConcatenatedBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftDeliveryOptionsArgs = {
  deliveryAddress?: InputMaybe<MailingAddressInput>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftDiscountsAddedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftDiscountsRemovedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftDiscountsUpdatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftLinesAddedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftLinesRemovedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The `SubscriptionDraft` object represents a draft version of a
 * [subscription contract](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract)
 * before it's committed. It serves as a staging area for making changes to an existing subscription or creating
 * a new one. The draft allows you to preview and modify various aspects of a subscription before applying the changes.
 * This object is deprecated in favor of the
 * [SubscriptionContractCalculation API](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/migrate-to-subscription-calculation-api).
 *
 * Use the `SubscriptionDraft` object to:
 *
 * - Add, remove, or modify subscription lines and their quantities
 * - Manage discounts (add, remove, or update manual and code-based discounts)
 * - Configure delivery options and shipping methods
 * - Set up billing and delivery policies
 * - Manage customer payment methods
 * - Add custom attributes and notes to generated orders
 * - Configure billing cycles and next billing dates
 * - Preview the projected state of the subscription
 *
 * Each `SubscriptionDraft` object maintains a projected state that shows how the subscription will look after the changes
 * are committed. This allows you to preview the impact of your modifications before applying them. The draft can be
 * associated with an existing subscription contract (for modifications) or used to create a new subscription.
 *
 * The draft remains in a draft state until it's committed, at which point the changes are applied to the subscription
 * contract and the draft is no longer accessible.
 *
 * Learn more about
 * [how subscription contracts work](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts)
 * and how to [build](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/build-a-subscription-contract),
 * [update](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/update-a-subscription-contract), and
 * [combine](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts/combine-subscription-contracts) subscription contracts.
 */
export type SubscriptionDraftShippingOptionsArgs = {
  deliveryAddress?: InputMaybe<MailingAddressInput>;
};

/** Return type for `subscriptionDraftCommit` mutation. */
export type SubscriptionDraftCommitPayload = {
  __typename?: 'SubscriptionDraftCommitPayload';
  /** The updated Subscription Contract object. */
  contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountAdd` mutation. */
export type SubscriptionDraftDiscountAddPayload = {
  __typename?: 'SubscriptionDraftDiscountAddPayload';
  /** The added Subscription Discount. */
  discountAdded?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountCodeApply` mutation. */
export type SubscriptionDraftDiscountCodeApplyPayload = {
  __typename?: 'SubscriptionDraftDiscountCodeApplyPayload';
  /** The added subscription discount. */
  appliedDiscount?: Maybe<SubscriptionAppliedCodeDiscount>;
  /** The subscription contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountRemove` mutation. */
export type SubscriptionDraftDiscountRemovePayload = {
  __typename?: 'SubscriptionDraftDiscountRemovePayload';
  /** The removed subscription draft discount. */
  discountRemoved?: Maybe<SubscriptionDiscount>;
  /** The subscription contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountUpdate` mutation. */
export type SubscriptionDraftDiscountUpdatePayload = {
  __typename?: 'SubscriptionDraftDiscountUpdatePayload';
  /** The updated Subscription Discount. */
  discountUpdated?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Possible error codes that can be returned by `SubscriptionDraftUserError`. */
export enum SubscriptionDraftErrorCode {
  /** This line has already been removed. */
  AlreadyRemoved = 'ALREADY_REMOVED',
  /** Cannot commit a contract draft with this mutation. Please use SubscriptionDraftCommit. */
  BillingCycleAbsent = 'BILLING_CYCLE_ABSENT',
  /** Billing policy cannot be updated for billing cycle contract drafts. */
  BillingCycleContractDraftBillingPolicyInvalid = 'BILLING_CYCLE_CONTRACT_DRAFT_BILLING_POLICY_INVALID',
  /** Delivery policy cannot be updated for billing cycle contract drafts. */
  BillingCycleContractDraftDeliveryPolicyInvalid = 'BILLING_CYCLE_CONTRACT_DRAFT_DELIVERY_POLICY_INVALID',
  /** Cannot commit a billing cycle contract draft with this mutation. Please use SubscriptionBillingCycleContractDraftCommit. */
  BillingCyclePresent = 'BILLING_CYCLE_PRESENT',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Subscription draft has been already committed. */
  Committed = 'COMMITTED',
  /** Contract draft must be a billing cycle contract draft for contract concatenation. */
  ConcatenationBillingCycleContractDraftRequired = 'CONCATENATION_BILLING_CYCLE_CONTRACT_DRAFT_REQUIRED',
  /** Cannot concatenate a contract draft from subscriptionContractCreate mutation. */
  ConcatenationUncommittedContractDraft = 'CONCATENATION_UNCOMMITTED_CONTRACT_DRAFT',
  /** Currency is not enabled. */
  CurrencyNotEnabled = 'CURRENCY_NOT_ENABLED',
  /** The customer doesn't exist. */
  CustomerDoesNotExist = 'CUSTOMER_DOES_NOT_EXIST',
  /** The payment method customer must be the same as the contract customer. */
  CustomerMismatch = 'CUSTOMER_MISMATCH',
  /** Customer is scheduled for redaction or has been redacted. */
  CustomerRedacted = 'CUSTOMER_REDACTED',
  /** The after cycle attribute must be unique between cycle discounts. */
  CycleDiscountsUniqueAfterCycle = 'CYCLE_DISCOUNTS_UNIQUE_AFTER_CYCLE',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CycleIndexOutOfRange = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Billing cycle selector requires exactly one of index or date to be provided. */
  CycleSelectorValidateOneOf = 'CYCLE_SELECTOR_VALIDATE_ONE_OF',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CycleStartDateOutOfRange = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** The delivery method can't be blank if any lines require shipping. */
  DeliveryMethodRequired = 'DELIVERY_METHOD_REQUIRED',
  /** The delivery policy interval must be a multiple of the billing policy interval. */
  DeliveryMustBeMultipleOfBilling = 'DELIVERY_MUST_BE_MULTIPLE_OF_BILLING',
  /** Concatenated contracts cannot contain duplicate subscription contracts. */
  DuplicateConcatenatedContracts = 'DUPLICATE_CONCATENATED_CONTRACTS',
  /** Maximum number of concatenated contracts on a billing cycle contract draft exceeded. */
  ExceededMaxConcatenatedContracts = 'EXCEEDED_MAX_CONCATENATED_CONTRACTS',
  /** The input value should be greater than the minimum allowed value. */
  GreaterThan = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Cannot update a subscription contract with a current or upcoming billing cycle contract edit. */
  HasFutureEdits = 'HAS_FUTURE_EDITS',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The adjustment value must the same type as the adjustment type. */
  InvalidAdjustmentType = 'INVALID_ADJUSTMENT_TYPE',
  /** The adjustment value must be either fixed_value or percentage. */
  InvalidAdjustmentValue = 'INVALID_ADJUSTMENT_VALUE',
  /** Next billing date is invalid. */
  InvalidBillingDate = 'INVALID_BILLING_DATE',
  /** Must have at least one line. */
  InvalidLines = 'INVALID_LINES',
  /** Note length is too long. */
  InvalidNoteLength = 'INVALID_NOTE_LENGTH',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** Customer payment method is required. */
  MissingCustomerPaymentMethod = 'MISSING_CUSTOMER_PAYMENT_METHOD',
  /** The local delivery options must be set for local delivery. */
  MissingLocalDeliveryOptions = 'MISSING_LOCAL_DELIVERY_OPTIONS',
  /** The value is not an integer. */
  NotAnInteger = 'NOT_AN_INTEGER',
  /** Value is not in range. */
  NotInRange = 'NOT_IN_RANGE',
  /** Discount must have at least one entitled line. */
  NoEntitledLines = 'NO_ENTITLED_LINES',
  /** Input value is not present. */
  Presence = 'PRESENCE',
  /** The maximum number of cycles must be greater than the minimum. */
  SellingPlanMaxCyclesMustBeGreaterThanMinCycles = 'SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES',
  /** Another operation updated the contract concurrently as the commit was in progress. */
  StaleContract = 'STALE_CONTRACT',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The contract draft has too many discounts. */
  TooManyDiscounts = 'TOO_MANY_DISCOUNTS',
  /** The contract draft has too many lines. */
  TooManyLines = 'TOO_MANY_LINES',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UpcomingCycleLimitExceeded = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/** Return type for `subscriptionDraftFreeShippingDiscountAdd` mutation. */
export type SubscriptionDraftFreeShippingDiscountAddPayload = {
  __typename?: 'SubscriptionDraftFreeShippingDiscountAddPayload';
  /** The added subscription free shipping discount. */
  discountAdded?: Maybe<SubscriptionManualDiscount>;
  /** The subscription contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftFreeShippingDiscountUpdate` mutation. */
export type SubscriptionDraftFreeShippingDiscountUpdatePayload = {
  __typename?: 'SubscriptionDraftFreeShippingDiscountUpdatePayload';
  /** The updated Subscription Discount. */
  discountUpdated?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** The input fields required to create a Subscription Draft. */
export type SubscriptionDraftInput = {
  /** The billing policy for the subscription contract. */
  billingPolicy?: InputMaybe<SubscriptionBillingPolicyInput>;
  /** A list of the custom attributes added to the subscription contract. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /** The delivery method for the subscription contract. */
  deliveryMethod?: InputMaybe<SubscriptionDeliveryMethodInput>;
  /** The delivery policy for the subscription contract. */
  deliveryPolicy?: InputMaybe<SubscriptionDeliveryPolicyInput>;
  /** The shipping price for each renewal the subscription contract. */
  deliveryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The next billing date for the subscription contract. */
  nextBillingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The note field that will be applied to the generated orders. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the payment method to be used for the subscription contract. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** The current status of the subscription contract. */
  status?: InputMaybe<SubscriptionContractSubscriptionStatus>;
};

/** Return type for `subscriptionDraftLineAdd` mutation. */
export type SubscriptionDraftLineAddPayload = {
  __typename?: 'SubscriptionDraftLineAddPayload';
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The added Subscription Line. */
  lineAdded?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftLineRemove` mutation. */
export type SubscriptionDraftLineRemovePayload = {
  __typename?: 'SubscriptionDraftLineRemovePayload';
  /** The list of updated subscription discounts impacted by the removed line. */
  discountsUpdated?: Maybe<Array<SubscriptionManualDiscount>>;
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The removed Subscription Line. */
  lineRemoved?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftLineUpdate` mutation. */
export type SubscriptionDraftLineUpdatePayload = {
  __typename?: 'SubscriptionDraftLineUpdatePayload';
  /** The Subscription Contract draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The updated Subscription Line. */
  lineUpdated?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftUpdate` mutation. */
export type SubscriptionDraftUpdatePayload = {
  __typename?: 'SubscriptionDraftUpdatePayload';
  /** The Subscription Draft object. */
  draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<SubscriptionDraftUserError>;
};

/** Represents a Subscription Draft error. */
export type SubscriptionDraftUserError = DisplayableError & {
  __typename?: 'SubscriptionDraftUserError';
  /** The error code. */
  code?: Maybe<SubscriptionDraftErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The input fields for a subscription free shipping discount on a contract. */
export type SubscriptionFreeShippingDiscountInput = {
  /** The maximum number of times the subscription free shipping discount will be applied on orders. */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The title associated with the subscription free shipping discount. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A product line item within a [`SubscriptionContract`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionContract). Each line represents a specific product variant that the customer subscribes to, including its quantity, pricing, and whether shipping is required.
 *
 * The line maintains references to the [`ProductVariant`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant), [`SellingPlan`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SellingPlan), and custom [`Attribute`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Attribute) objects. It tracks the current price and any scheduled price changes through its [`pricingPolicy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionPricingPolicy). You can modify lines through [`SubscriptionDraft`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SubscriptionDraft) objects without affecting the original contract until you commit changes.
 *
 * Learn more about [subscription contracts](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/contracts) and [selling plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
 */
export type SubscriptionLine = {
  __typename?: 'SubscriptionLine';
  /** The origin contract of the line if it was concatenated from another contract. */
  concatenatedOriginContract?: Maybe<SubscriptionContract>;
  /** The price per unit for the subscription line in the contract's currency. */
  currentPrice: MoneyV2;
  /** List of custom attributes associated to the line item. */
  customAttributes: Array<Attribute>;
  /** Discount allocations. */
  discountAllocations: Array<SubscriptionDiscountAllocation>;
  /** The unique ID. */
  id: Scalars['ID']['output'];
  /** Total line price including all discounts. */
  lineDiscountedPrice: MoneyV2;
  /** Describe the price changes of the line over time. */
  pricingPolicy?: Maybe<SubscriptionPricingPolicy>;
  /** The product ID associated with the subscription line. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The quantity of the unit selected for the subscription line. */
  quantity: Scalars['Int']['output'];
  /** Whether physical shipping is required for the variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /**
   * The selling plan ID associated to the line.
   *
   * Indicates which selling plan was used to create this
   * contract line initially. The selling plan ID is also used to
   * find the associated delivery profile.
   *
   * The subscription contract, subscription line, or selling plan might have
   * changed. As a result, the selling plan's attributes might not
   * match the information on the contract.
   */
  sellingPlanId?: Maybe<Scalars['ID']['output']>;
  /**
   * The selling plan name associated to the line. This name describes
   * the order line items created from this subscription line
   * for both merchants and customers.
   *
   * The value can be different from the selling plan's name, because both
   * the selling plan's name and the subscription line's selling_plan_name
   * attribute can be updated independently.
   */
  sellingPlanName?: Maybe<Scalars['String']['output']>;
  /** Variant SKU number of the item associated with the subscription line. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Whether the variant is taxable. */
  taxable: Scalars['Boolean']['output'];
  /** Product title of the item associated with the subscription line. */
  title: Scalars['String']['output'];
  /** The product variant ID associated with the subscription line. */
  variantId?: Maybe<Scalars['ID']['output']>;
  /** The image associated with the line item's variant or product. */
  variantImage?: Maybe<Image>;
  /** Product variant title of the item associated with the subscription line. */
  variantTitle?: Maybe<Scalars['String']['output']>;
};

/** An auto-generated type for paginating through multiple SubscriptionLines. */
export type SubscriptionLineConnection = {
  __typename?: 'SubscriptionLineConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionLineEdge>;
  /** A list of nodes that are contained in SubscriptionLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionLine and a cursor during pagination. */
export type SubscriptionLineEdge = {
  __typename?: 'SubscriptionLineEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionLineEdge. */
  node: SubscriptionLine;
};

/** The input fields required to add a new subscription line to a contract. */
export type SubscriptionLineInput = {
  /** The price of the product. */
  currentPrice: Scalars['Decimal']['input'];
  /** The custom attributes for this subscription line. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /** Describes expected price changes of the subscription line over time. */
  pricingPolicy?: InputMaybe<SubscriptionPricingPolicyInput>;
  /** The ID of the product variant the subscription line refers to. */
  productVariantId: Scalars['ID']['input'];
  /** The quantity of the product. */
  quantity: Scalars['Int']['input'];
  /** The selling plan for the subscription line. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The selling plan name for the subscription line.
   *
   * Defaults to using the selling plan's current name when not specified.
   */
  sellingPlanName?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields required to update a subscription line on a contract. */
export type SubscriptionLineUpdateInput = {
  /** The price of the product. */
  currentPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The custom attributes for this subscription line. */
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  /** Describes expected price changes of the subscription line over time. */
  pricingPolicy?: InputMaybe<SubscriptionPricingPolicyInput>;
  /** The ID of the product variant the subscription line refers to. */
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the product. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The selling plan for the subscription line. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** The selling plan name for the subscription line. */
  sellingPlanName?: InputMaybe<Scalars['String']['input']>;
};

/** A local delivery option for a subscription contract. */
export type SubscriptionLocalDeliveryOption = {
  __typename?: 'SubscriptionLocalDeliveryOption';
  /** The code of the local delivery option. */
  code: Scalars['String']['output'];
  /** The description of the local delivery option. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether a phone number is required for the local delivery option. */
  phoneRequired: Scalars['Boolean']['output'];
  /** The presentment title of the local delivery option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The price of the local delivery option. */
  price?: Maybe<MoneyV2>;
  /** The title of the local delivery option. */
  title: Scalars['String']['output'];
};

/** Custom subscription discount. */
export type SubscriptionManualDiscount = {
  __typename?: 'SubscriptionManualDiscount';
  /** Entitled line items used to apply the subscription discount on. */
  entitledLines: SubscriptionDiscountEntitledLines;
  /** The unique ID. */
  id: Scalars['ID']['output'];
  /** The maximum number of times the subscription discount will be applied on orders. */
  recurringCycleLimit?: Maybe<Scalars['Int']['output']>;
  /** The reason that the discount on the subscription draft is rejected. */
  rejectionReason?: Maybe<SubscriptionDiscountRejectionReason>;
  /** Type of line the discount applies on. */
  targetType: DiscountTargetType;
  /** The title associated with the subscription discount. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the subscription discount. */
  type: DiscountType;
  /** The number of times the discount was applied. */
  usageCount: Scalars['Int']['output'];
  /** The value of the subscription discount. */
  value: SubscriptionDiscountValue;
};

/** An auto-generated type for paginating through multiple SubscriptionManualDiscounts. */
export type SubscriptionManualDiscountConnection = {
  __typename?: 'SubscriptionManualDiscountConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<SubscriptionManualDiscountEdge>;
  /** A list of nodes that are contained in SubscriptionManualDiscountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<SubscriptionManualDiscount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionManualDiscount and a cursor during pagination. */
export type SubscriptionManualDiscountEdge = {
  __typename?: 'SubscriptionManualDiscountEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of SubscriptionManualDiscountEdge. */
  node: SubscriptionManualDiscount;
};

/** The input fields for the subscription lines the discount applies on. */
export type SubscriptionManualDiscountEntitledLinesInput = {
  /** Specify whether the subscription discount will apply on all subscription lines. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the lines to add to or remove from the subscription discount. */
  lines?: InputMaybe<SubscriptionManualDiscountLinesInput>;
};

/** The input fields for the fixed amount value of the discount and distribution on the lines. */
export type SubscriptionManualDiscountFixedAmountInput = {
  /** Fixed amount value. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the amount is intended per line item or once per subscription. */
  appliesOnEachItem?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields for a subscription discount on a contract. */
export type SubscriptionManualDiscountInput = {
  /** Entitled line items used to apply the subscription discount on. */
  entitledLines?: InputMaybe<SubscriptionManualDiscountEntitledLinesInput>;
  /** The maximum number of times the subscription discount will be applied on orders. */
  recurringCycleLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The title associated with the subscription discount. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Percentage or fixed amount value of the discount. */
  value?: InputMaybe<SubscriptionManualDiscountValueInput>;
};

/** The input fields for line items that the discount refers to. */
export type SubscriptionManualDiscountLinesInput = {
  /** The ID of the lines to add to the subscription discount. */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the lines to remove from the subscription discount. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input fields for the discount value and its distribution. */
export type SubscriptionManualDiscountValueInput = {
  /** Fixed amount input in the currency defined by the subscription. */
  fixedAmount?: InputMaybe<SubscriptionManualDiscountFixedAmountInput>;
  /** The percentage value of the discount. Value must be between 0 - 100. */
  percentage?: InputMaybe<Scalars['Int']['input']>;
};

/** A pickup option to deliver a subscription contract. */
export type SubscriptionPickupOption = {
  __typename?: 'SubscriptionPickupOption';
  /** The code of the pickup option. */
  code: Scalars['String']['output'];
  /** The description of the pickup option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The pickup location. */
  location: Location;
  /** Whether a phone number is required for the pickup option. */
  phoneRequired: Scalars['Boolean']['output'];
  /** The estimated amount of time it takes for the pickup to be ready. For example, "Usually ready in 24 hours".). */
  pickupTime: Scalars['String']['output'];
  /** The presentment title of the pickup option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The price of the pickup option. */
  price?: Maybe<MoneyV2>;
  /** The title of the pickup option. */
  title: Scalars['String']['output'];
};

/** Represents a Subscription Line Pricing Policy. */
export type SubscriptionPricingPolicy = {
  __typename?: 'SubscriptionPricingPolicy';
  /** The base price per unit for the subscription line in the contract's currency. */
  basePrice: MoneyV2;
  /** The adjustments per cycle for the subscription line. */
  cycleDiscounts: Array<SubscriptionCyclePriceAdjustment>;
};

/** The input fields for an array containing all pricing changes for each billing cycle. */
export type SubscriptionPricingPolicyCycleDiscountsInput = {
  /** The price adjustment type. */
  adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  adjustmentValue: SellingPlanPricingPolicyValueInput;
  /** The cycle after which the pricing policy applies. */
  afterCycle: Scalars['Int']['input'];
  /** The computed price after the adjustments are applied. */
  computedPrice: Scalars['Decimal']['input'];
};

/** The input fields for expected price changes of the subscription line over time. */
export type SubscriptionPricingPolicyInput = {
  /** The base price per unit for the subscription line in the contract's currency. */
  basePrice: Scalars['Decimal']['input'];
  /** An array containing all pricing changes for each billing cycle. */
  cycleDiscounts: Array<SubscriptionPricingPolicyCycleDiscountsInput>;
};

/** A shipping option to deliver a subscription contract. */
export type SubscriptionShippingOption = {
  __typename?: 'SubscriptionShippingOption';
  /**
   * The carrier service that's providing this shipping option.
   * This field isn't currently supported and returns null.
   * @deprecated This field has never been implemented.
   */
  carrierService?: Maybe<DeliveryCarrierService>;
  /** The code of the shipping option. */
  code: Scalars['String']['output'];
  /** The description of the shipping option. */
  description?: Maybe<Scalars['String']['output']>;
  /** If a phone number is required for the shipping option. */
  phoneRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The presentment title of the shipping option. */
  presentmentTitle?: Maybe<Scalars['String']['output']>;
  /** The price of the shipping option. */
  price?: Maybe<MoneyV2>;
  /** The title of the shipping option. */
  title: Scalars['String']['output'];
};

/** The result of the query to fetch shipping options for the subscription contract. */
export type SubscriptionShippingOptionResult = SubscriptionShippingOptionResultFailure | SubscriptionShippingOptionResultSuccess;

/** Failure determining available shipping options for delivery of a subscription contract. */
export type SubscriptionShippingOptionResultFailure = {
  __typename?: 'SubscriptionShippingOptionResultFailure';
  /** Failure reason. */
  message?: Maybe<Scalars['String']['output']>;
};

/** A shipping option for delivery of a subscription contract. */
export type SubscriptionShippingOptionResultSuccess = {
  __typename?: 'SubscriptionShippingOptionResultSuccess';
  /** Available shipping options. */
  shippingOptions: Array<SubscriptionShippingOption>;
};

/**
 * A suggested transaction. Suggested transaction are usually used in the context of refunds
 * and exchanges.
 */
export type SuggestedOrderTransaction = {
  __typename?: 'SuggestedOrderTransaction';
  /** The masked account number associated with the payment method. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of the transaction.
   * @deprecated Use `amountSet` instead.
   */
  amount: Scalars['Money']['output'];
  /** The amount and currency of the suggested order transaction in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** The human-readable payment gateway name suggested to process the transaction. */
  formattedGateway?: Maybe<Scalars['String']['output']>;
  /** The suggested payment gateway used to process the transaction. */
  gateway?: Maybe<Scalars['String']['output']>;
  /** Specifies the kind of the suggested order transaction. */
  kind: SuggestedOrderTransactionKind;
  /**
   * Specifies the available amount to refund on the gateway. Only available within SuggestedRefund.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  maximumRefundable?: Maybe<Scalars['Money']['output']>;
  /** Specifies the available amount to refund on the gateway in shop and presentment currencies. Only available within SuggestedRefund. */
  maximumRefundableSet?: Maybe<MoneyBag>;
  /** The associated parent transaction, for example the authorization of a capture. */
  parentTransaction?: Maybe<OrderTransaction>;
  /** The associated payment details related to the transaction. */
  paymentDetails?: Maybe<PaymentDetails>;
};

/** Specifies the kind of the suggested order transaction. */
export enum SuggestedOrderTransactionKind {
  /** A suggested refund transaction for an order. */
  SuggestedRefund = 'SUGGESTED_REFUND'
}

/** The input fields for an exchange line item. */
export type SuggestedOutcomeExchangeLineItemInput = {
  /** The ID of the exchange line item. */
  id: Scalars['ID']['input'];
  /** The quantity of the exchange line item. */
  quantity: Scalars['Int']['input'];
};

/** The input fields for a return line item. */
export type SuggestedOutcomeReturnLineItemInput = {
  /** The ID of the return line item. */
  id: Scalars['ID']['input'];
  /** The quantity of the return line item. */
  quantity: Scalars['Int']['input'];
};

/**
 * A refund amount that Shopify suggests based on the items, duties, and shipping costs that customers return. Provides a breakdown of all monetary values including subtotals, taxes, discounts, and the maximum refundable amount.
 *
 * The suggested refund includes [`RefundLineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/RefundLineItem) objects to refund with their quantities and restock instructions, [`RefundDuty`](https://shopify.dev/docs/api/admin-graphql/latest/objects/RefundDuty) objects for duty reimbursements, and [`ShippingRefund`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingRefund) for shipping cost refunds. Provides [`SuggestedOrderTransaction`](https://shopify.dev/docs/api/admin-graphql/latest/objects/SuggestedOrderTransaction) objects and the [`SuggestedRefundMethod`](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/SuggestedRefundMethod) interface to process the refund through the appropriate gateways.
 *
 * Learn more about [previewing and refunding duties](https://shopify.dev/docs/apps/build/orders-fulfillment/returns-apps/view-and-refund-duties#step-3-preview-a-refund-that-includes-duties).
 */
export type SuggestedRefund = {
  __typename?: 'SuggestedRefund';
  /**
   * The total monetary value to be refunded.
   * @deprecated Use `amountSet` instead.
   */
  amount: Scalars['Money']['output'];
  /** The total monetary value to be refunded in shop and presentment currencies. */
  amountSet: MoneyBag;
  /** The sum of all the discounted prices of the line items being refunded. */
  discountedSubtotalSet: MoneyBag;
  /**
   * The total monetary value available to refund.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  maximumRefundable: Scalars['Money']['output'];
  /** The total monetary value available to refund in shop and presentment currencies. */
  maximumRefundableSet: MoneyBag;
  /** A list of duties to be refunded from the order. */
  refundDuties: Array<RefundDuty>;
  /** A list of line items to be refunded, along with restock instructions. */
  refundLineItems: Array<RefundLineItem>;
  /** The shipping costs to be refunded from the order. */
  shipping: ShippingRefund;
  /**
   * The sum of all the prices of the line items being refunded.
   * @deprecated Use `subtotalSet` instead.
   */
  subtotal: Scalars['Money']['output'];
  /** The sum of all the prices of the line items being refunded in shop and presentment currencies. */
  subtotalSet: MoneyBag;
  /** A list of suggested refund methods. */
  suggestedRefundMethods: Array<SuggestedRefundMethod>;
  /** A list of suggested order transactions. */
  suggestedTransactions: Array<SuggestedOrderTransaction>;
  /** The total cart discount amount that was applied to all line items in this refund. */
  totalCartDiscountAmountSet: MoneyBag;
  /** The sum of all the duties being refunded from the order in shop and presentment currencies. The value must be positive. */
  totalDutiesSet: MoneyBag;
  /** The sum of the taxes being refunded from the order in shop and presentment currencies. The value must be positive. */
  totalTaxSet: MoneyBag;
  /**
   * The sum of the taxes being refunded from the order. The value must be positive.
   * @deprecated Use `totalTaxSet` instead.
   */
  totalTaxes: Scalars['Money']['output'];
};

/** Generic attributes of a suggested refund method. */
export type SuggestedRefundMethod = {
  /** The suggested amount to refund in shop and presentment currencies. */
  amount: MoneyBag;
  /** The maximum available amount to refund in shop and presentment currencies. */
  maximumRefundable: MoneyBag;
};

/** Represents a return financial outcome suggested by Shopify based on the items being reimbursed. You can then use the suggested outcome object to generate an actual refund or invoice for the return. */
export type SuggestedReturnFinancialOutcome = {
  __typename?: 'SuggestedReturnFinancialOutcome';
  /** The sum of all the discounted prices of the line items being refunded. */
  discountedSubtotal: MoneyBag;
  /** The financial transfer details for the return outcome. */
  financialTransfer?: Maybe<ReturnOutcomeFinancialTransfer>;
  /** The total monetary value available to refund in shop and presentment currencies. */
  maximumRefundable: MoneyBag;
  /** A list of duties to be refunded from the order. */
  refundDuties: Array<RefundDuty>;
  /** The shipping costs to be refunded from the order. */
  shipping: ShippingRefund;
  /** The sum of all the additional fees being refunded in shop and presentment currencies. The value must be positive. */
  totalAdditionalFees: MoneyBag;
  /** The total cart discount amount that was applied to all line items in this refund. */
  totalCartDiscountAmount: MoneyBag;
  /** The sum of all the duties being refunded from the order in shop and presentment currencies. The value must be positive. */
  totalDuties: MoneyBag;
  /** The sum of the taxes being refunded in shop and presentment currencies. The value must be positive. */
  totalTax: MoneyBag;
};

/** Represents a return refund suggested by Shopify based on the items being reimbursed. You can then use the suggested refund object to generate an actual refund for the return. */
export type SuggestedReturnRefund = {
  __typename?: 'SuggestedReturnRefund';
  /** The total monetary value to be refunded in shop and presentment currencies. */
  amount: MoneyBag;
  /** The sum of all the discounted prices of the line items being refunded. */
  discountedSubtotal: MoneyBag;
  /** The total monetary value available to refund in shop and presentment currencies. */
  maximumRefundable: MoneyBag;
  /** A list of duties to be refunded from the order. */
  refundDuties: Array<RefundDuty>;
  /** The shipping costs to be refunded from the order. */
  shipping: ShippingRefund;
  /** The sum of all the prices of the line items being refunded in shop and presentment currencies. */
  subtotal: MoneyBag;
  /** A list of suggested order transactions. */
  suggestedTransactions: Array<SuggestedOrderTransaction>;
  /** The total cart discount amount that was applied to all line items in this refund. */
  totalCartDiscountAmount: MoneyBag;
  /** The sum of all the duties being refunded from the order in shop and presentment currencies. The value must be positive. */
  totalDuties: MoneyBag;
  /** The sum of the taxes being refunded in shop and presentment currencies. The value must be positive. */
  totalTax: MoneyBag;
};

/** The suggested values for a refund to store credit. */
export type SuggestedStoreCreditRefund = SuggestedRefundMethod & {
  __typename?: 'SuggestedStoreCreditRefund';
  /** The suggested amount to refund in shop and presentment currencies. */
  amount: MoneyBag;
  /** The suggested expiration date for the store credit. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The maximum available amount to refund in shop and presentment currencies. */
  maximumRefundable: MoneyBag;
};

/** Return type for `tagsAdd` mutation. */
export type TagsAddPayload = {
  __typename?: 'TagsAddPayload';
  /** The object that was updated. */
  node?: Maybe<Node>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `tagsRemove` mutation. */
export type TagsRemovePayload = {
  __typename?: 'TagsRemovePayload';
  /** The object that was updated. */
  node?: Maybe<Node>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Tax app configuration of a merchant. */
export type TaxAppConfiguration = {
  __typename?: 'TaxAppConfiguration';
  /** State of the tax app configuration. */
  state: TaxPartnerState;
};

/** Return type for `taxAppConfigure` mutation. */
export type TaxAppConfigurePayload = {
  __typename?: 'TaxAppConfigurePayload';
  /** The updated tax app configuration. */
  taxAppConfiguration?: Maybe<TaxAppConfiguration>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TaxAppConfigureUserError>;
};

/** An error that occurs during the execution of `TaxAppConfigure`. */
export type TaxAppConfigureUserError = DisplayableError & {
  __typename?: 'TaxAppConfigureUserError';
  /** The error code. */
  code?: Maybe<TaxAppConfigureUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `TaxAppConfigureUserError`. */
export enum TaxAppConfigureUserErrorCode {
  /** Unable to update already active tax partner. */
  TaxPartnerAlreadyActive = 'TAX_PARTNER_ALREADY_ACTIVE',
  /** Unable to find the tax partner record. */
  TaxPartnerNotFound = 'TAX_PARTNER_NOT_FOUND',
  /** Unable to update tax partner state. */
  TaxPartnerStateUpdateFailed = 'TAX_PARTNER_STATE_UPDATE_FAILED'
}

/** Available customer tax exemptions. */
export enum TaxExemption {
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in British Columbia. */
  CaBcCommercialFisheryExemption = 'CA_BC_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid CONTRACTOR_EXEMPTION in British Columbia. */
  CaBcContractorExemption = 'CA_BC_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PRODUCTION_AND_MACHINERY_EXEMPTION in British Columbia. */
  CaBcProductionAndMachineryExemption = 'CA_BC_PRODUCTION_AND_MACHINERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in British Columbia. */
  CaBcResellerExemption = 'CA_BC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid SUB_CONTRACTOR_EXEMPTION in British Columbia. */
  CaBcSubContractorExemption = 'CA_BC_SUB_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid DIPLOMAT_EXEMPTION in Canada. */
  CaDiplomatExemption = 'CA_DIPLOMAT_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Manitoba. */
  CaMbCommercialFisheryExemption = 'CA_MB_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Manitoba. */
  CaMbFarmerExemption = 'CA_MB_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Manitoba. */
  CaMbResellerExemption = 'CA_MB_RESELLER_EXEMPTION',
  /** This customer is exempt from VPT (Vapour Products Tax) for holding a valid VPT_RESELLER_EXEMPTION in Newfoundland and Labrador. */
  CaNlVptResellerExemption = 'CA_NL_VPT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Nova Scotia. */
  CaNsCommercialFisheryExemption = 'CA_NS_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Nova Scotia. */
  CaNsFarmerExemption = 'CA_NS_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PURCHASE_EXEMPTION in Ontario. */
  CaOnPurchaseExemption = 'CA_ON_PURCHASE_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Prince Edward Island. */
  CaPeCommercialFisheryExemption = 'CA_PE_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Saskatchewan. */
  CaSkCommercialFisheryExemption = 'CA_SK_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid CONTRACTOR_EXEMPTION in Saskatchewan. */
  CaSkContractorExemption = 'CA_SK_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Saskatchewan. */
  CaSkFarmerExemption = 'CA_SK_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PRODUCTION_AND_MACHINERY_EXEMPTION in Saskatchewan. */
  CaSkProductionAndMachineryExemption = 'CA_SK_PRODUCTION_AND_MACHINERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Saskatchewan. */
  CaSkResellerExemption = 'CA_SK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid SUB_CONTRACTOR_EXEMPTION in Saskatchewan. */
  CaSkSubContractorExemption = 'CA_SK_SUB_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from VPT (Vapour Products Tax) for holding a valid VPT_RESELLER_EXEMPTION in Saskatchewan. */
  CaSkVptResellerExemption = 'CA_SK_VPT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid STATUS_CARD_EXEMPTION in Canada. */
  CaStatusCardExemption = 'CA_STATUS_CARD_EXEMPTION',
  /** This customer is exempt from VAT for purchases within the EU that is shipping from outside of customer's country, as well as purchases from the EU to the UK. */
  EuReverseChargeExemptionRule = 'EU_REVERSE_CHARGE_EXEMPTION_RULE',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Alaska. */
  UsAkResellerExemption = 'US_AK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Alabama. */
  UsAlResellerExemption = 'US_AL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Arkansas. */
  UsArResellerExemption = 'US_AR_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Arizona. */
  UsAzResellerExemption = 'US_AZ_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in California. */
  UsCaResellerExemption = 'US_CA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Colorado. */
  UsCoResellerExemption = 'US_CO_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Connecticut. */
  UsCtResellerExemption = 'US_CT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Washington DC. */
  UsDcResellerExemption = 'US_DC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Delaware. */
  UsDeResellerExemption = 'US_DE_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Florida. */
  UsFlResellerExemption = 'US_FL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Georgia. */
  UsGaResellerExemption = 'US_GA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Hawaii. */
  UsHiResellerExemption = 'US_HI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Iowa. */
  UsIaResellerExemption = 'US_IA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Idaho. */
  UsIdResellerExemption = 'US_ID_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Illinois. */
  UsIlResellerExemption = 'US_IL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Indiana. */
  UsInResellerExemption = 'US_IN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Kansas. */
  UsKsResellerExemption = 'US_KS_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Kentucky. */
  UsKyResellerExemption = 'US_KY_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Louisiana. */
  UsLaResellerExemption = 'US_LA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Massachusetts. */
  UsMaResellerExemption = 'US_MA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Maryland. */
  UsMdResellerExemption = 'US_MD_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Maine. */
  UsMeResellerExemption = 'US_ME_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Michigan. */
  UsMiResellerExemption = 'US_MI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Minnesota. */
  UsMnResellerExemption = 'US_MN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Missouri. */
  UsMoResellerExemption = 'US_MO_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Mississippi. */
  UsMsResellerExemption = 'US_MS_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Montana. */
  UsMtResellerExemption = 'US_MT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in North Carolina. */
  UsNcResellerExemption = 'US_NC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in North Dakota. */
  UsNdResellerExemption = 'US_ND_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Nebraska. */
  UsNeResellerExemption = 'US_NE_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Hampshire. */
  UsNhResellerExemption = 'US_NH_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Jersey. */
  UsNjResellerExemption = 'US_NJ_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Mexico. */
  UsNmResellerExemption = 'US_NM_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Nevada. */
  UsNvResellerExemption = 'US_NV_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New York. */
  UsNyResellerExemption = 'US_NY_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Ohio. */
  UsOhResellerExemption = 'US_OH_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Oklahoma. */
  UsOkResellerExemption = 'US_OK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Oregon. */
  UsOrResellerExemption = 'US_OR_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Pennsylvania. */
  UsPaResellerExemption = 'US_PA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Rhode Island. */
  UsRiResellerExemption = 'US_RI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in South Carolina. */
  UsScResellerExemption = 'US_SC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in South Dakota. */
  UsSdResellerExemption = 'US_SD_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Tennessee. */
  UsTnResellerExemption = 'US_TN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Texas. */
  UsTxResellerExemption = 'US_TX_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Utah. */
  UsUtResellerExemption = 'US_UT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Virginia. */
  UsVaResellerExemption = 'US_VA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Vermont. */
  UsVtResellerExemption = 'US_VT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Washington. */
  UsWaResellerExemption = 'US_WA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Wisconsin. */
  UsWiResellerExemption = 'US_WI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in West Virginia. */
  UsWvResellerExemption = 'US_WV_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Wyoming. */
  UsWyResellerExemption = 'US_WY_RESELLER_EXEMPTION'
}

/**
 * A tax applied to a [`LineItem`](https://shopify.dev/docs/api/admin-graphql/latest/objects/LineItem) or [`ShippingLine`](https://shopify.dev/docs/api/admin-graphql/latest/objects/ShippingLine). Includes the tax amount, rate, title, and whether the channel that submitted the tax is liable for remitting it.
 *
 * The tax amount in both shop and presentment currencies after applying discounts. Includes information about the tax rate, whether the channel is liable for remitting the tax, and other tax-related details.
 */
export type TaxLine = {
  __typename?: 'TaxLine';
  /** Whether the channel that submitted the tax line is liable for remitting. A value of null indicates unknown liability for this tax line. */
  channelLiable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The amount of tax, in shop currency, after discounts and before returns.
   * @deprecated Use `priceSet` instead.
   */
  price: Scalars['Money']['output'];
  /** The amount of tax, in shop and presentment currencies, after discounts and before returns. */
  priceSet: MoneyBag;
  /** The proportion of the line item price that the tax represents as a decimal. */
  rate?: Maybe<Scalars['Float']['output']>;
  /** The proportion of the line item price that the tax represents as a percentage. */
  ratePercentage?: Maybe<Scalars['Float']['output']>;
  /** The source of the tax. */
  source?: Maybe<Scalars['String']['output']>;
  /** The name of the tax. */
  title: Scalars['String']['output'];
};

/** State of the tax app configuration. */
export enum TaxPartnerState {
  /** App is configured and to be used for tax calculations. */
  Active = 'ACTIVE',
  /** App is not configured. */
  Pending = 'PENDING',
  /** App is configured, but not used for tax calculations. */
  Ready = 'READY'
}

/** Tax settings for a customer. */
export type TaxSettings = {
  __typename?: 'TaxSettings';
  /** The customer's tax ID. */
  taxId?: Maybe<Scalars['String']['output']>;
};

/** Return type for `taxSummaryCreate` mutation. */
export type TaxSummaryCreatePayload = {
  __typename?: 'TaxSummaryCreatePayload';
  /** A list of orders that were successfully enqueued to create a tax summary. */
  enqueuedOrders?: Maybe<Array<Order>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TaxSummaryCreateUserError>;
};

/** An error that occurs during the execution of `TaxSummaryCreate`. */
export type TaxSummaryCreateUserError = DisplayableError & {
  __typename?: 'TaxSummaryCreateUserError';
  /** The error code. */
  code?: Maybe<TaxSummaryCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `TaxSummaryCreateUserError`. */
export enum TaxSummaryCreateUserErrorCode {
  /** There was an error during enqueueing of the tax summary creation job(s). */
  GeneralError = 'GENERAL_ERROR',
  /** No order was not found. */
  OrderNotFound = 'ORDER_NOT_FOUND'
}

/**
 * Represents Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17) tree. Provides categories that you can filter by search criteria or hierarchical relationships.
 *
 * You can search categories globally, retrieve children of a specific category, find siblings, or get descendants. When you specify no filter arguments, you get all top-level categories in the taxonomy.
 */
export type Taxonomy = {
  __typename?: 'Taxonomy';
  /**
   * Returns the categories of the product taxonomy based on the arguments provided.
   * If a `search` argument is provided, then all categories that match the search query globally are returned.
   * If a `children_of` argument is provided, then all children of the specified category are returned.
   * If a `siblings_of` argument is provided, then all siblings of the specified category are returned.
   * If a `decendents_of` argument is provided, then all descendents of the specified category are returned.
   * If no arguments are provided, then all the top-level categories of the taxonomy are returned.
   */
  categories: TaxonomyCategoryConnection;
};


/**
 * Represents Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17) tree. Provides categories that you can filter by search criteria or hierarchical relationships.
 *
 * You can search categories globally, retrieve children of a specific category, find siblings, or get descendants. When you specify no filter arguments, you get all top-level categories in the taxonomy.
 */
export type TaxonomyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  childrenOf?: InputMaybe<Scalars['ID']['input']>;
  descendantsOf?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  siblingsOf?: InputMaybe<Scalars['ID']['input']>;
};

/** A Shopify product taxonomy attribute. */
export type TaxonomyAttribute = Node & {
  __typename?: 'TaxonomyAttribute';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/**
 * A product category within Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). Provides hierarchical organization through parent-child relationships, with each category tracking its ancestors, children, and level in the taxonomy tree.
 *
 * Categories include attributes specific to their product type and navigation properties like whether they're root, leaf, or archived categories. The taxonomy enables consistent product classification across Shopify and integrated marketplaces.
 */
export type TaxonomyCategory = Node & {
  __typename?: 'TaxonomyCategory';
  /** The IDs of the category's ancestor categories. */
  ancestorIds: Array<Scalars['ID']['output']>;
  /** The attributes of the taxonomy category. */
  attributes: TaxonomyCategoryAttributeConnection;
  /** The IDs of the category's child categories. */
  childrenIds: Array<Scalars['ID']['output']>;
  /** The full name of the taxonomy category. For example, Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Beds. */
  fullName: Scalars['String']['output'];
  /** The globally-unique ID of the TaxonomyCategory. */
  id: Scalars['ID']['output'];
  /** Whether the category is archived. The default value is `false`. */
  isArchived: Scalars['Boolean']['output'];
  /** Whether the category is a leaf category. A leaf category doesn't have any subcategories beneath it. For example, in Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Treadmills, Dog Treadmills is a leaf category. The value is `true` when there are no `childrenIds` specified. */
  isLeaf: Scalars['Boolean']['output'];
  /** Whether the category is a root category. A root category is at the top level of the category hierarchy and doesn't have a parent category. For example, Animals & Pet Supplies. The value is `true` when there's no `parentId` specified. */
  isRoot: Scalars['Boolean']['output'];
  /** The level of the category in the taxonomy tree. Levels indicate the depth of the category from the root. For example, in Animals & Pet Supplies > Pet Supplies > Dog Supplies, Animals & Pet Supplies is at level 1, Animals & Pet Supplies > Pet Supplies is at level 2, and Animals & Pet Supplies > Pet Supplies > Dog Supplies is at level 3. */
  level: Scalars['Int']['output'];
  /** The name of the taxonomy category. For example, Dog Beds. */
  name: Scalars['String']['output'];
  /** The ID of the category's parent category. */
  parentId?: Maybe<Scalars['ID']['output']>;
};


/**
 * A product category within Shopify's [standardized product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). Provides hierarchical organization through parent-child relationships, with each category tracking its ancestors, children, and level in the taxonomy tree.
 *
 * Categories include attributes specific to their product type and navigation properties like whether they're root, leaf, or archived categories. The taxonomy enables consistent product classification across Shopify and integrated marketplaces.
 */
export type TaxonomyCategoryAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A product taxonomy attribute interface. */
export type TaxonomyCategoryAttribute = TaxonomyAttribute | TaxonomyChoiceListAttribute | TaxonomyMeasurementAttribute;

/** An auto-generated type for paginating through multiple TaxonomyCategoryAttributes. */
export type TaxonomyCategoryAttributeConnection = {
  __typename?: 'TaxonomyCategoryAttributeConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<TaxonomyCategoryAttributeEdge>;
  /** A list of nodes that are contained in TaxonomyCategoryAttributeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<TaxonomyCategoryAttribute>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyCategoryAttribute and a cursor during pagination. */
export type TaxonomyCategoryAttributeEdge = {
  __typename?: 'TaxonomyCategoryAttributeEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of TaxonomyCategoryAttributeEdge. */
  node: TaxonomyCategoryAttribute;
};

/** An auto-generated type for paginating through multiple TaxonomyCategories. */
export type TaxonomyCategoryConnection = {
  __typename?: 'TaxonomyCategoryConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<TaxonomyCategoryEdge>;
  /** A list of nodes that are contained in TaxonomyCategoryEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<TaxonomyCategory>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyCategory and a cursor during pagination. */
export type TaxonomyCategoryEdge = {
  __typename?: 'TaxonomyCategoryEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of TaxonomyCategoryEdge. */
  node: TaxonomyCategory;
};

/** A Shopify product taxonomy choice list attribute. */
export type TaxonomyChoiceListAttribute = Node & {
  __typename?: 'TaxonomyChoiceListAttribute';
  /** The unique ID of the TaxonomyAttribute. */
  id: Scalars['ID']['output'];
  /** The name of the product taxonomy attribute. For example, Color. */
  name: Scalars['String']['output'];
  /** A list of values on the choice list attribute. */
  values: TaxonomyValueConnection;
};


/** A Shopify product taxonomy choice list attribute. */
export type TaxonomyChoiceListAttributeValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A Shopify product taxonomy measurement attribute. */
export type TaxonomyMeasurementAttribute = Node & {
  __typename?: 'TaxonomyMeasurementAttribute';
  /** The unique ID of the TaxonomyAttribute. */
  id: Scalars['ID']['output'];
  /** The name of the product taxonomy attribute. For example, Color. */
  name: Scalars['String']['output'];
  /** The product taxonomy attribute options. */
  options: Array<Attribute>;
};

/** Represents a Shopify product taxonomy value. */
export type TaxonomyValue = Node & {
  __typename?: 'TaxonomyValue';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the product taxonomy value. For example, Red. */
  name: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple TaxonomyValues. */
export type TaxonomyValueConnection = {
  __typename?: 'TaxonomyValueConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<TaxonomyValueEdge>;
  /** A list of nodes that are contained in TaxonomyValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<TaxonomyValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyValue and a cursor during pagination. */
export type TaxonomyValueEdge = {
  __typename?: 'TaxonomyValueEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of TaxonomyValueEdge. */
  node: TaxonomyValue;
};

/**
 * A TenderTransaction represents a transaction with financial impact on a shop's balance sheet. A tender transaction always
 * represents actual money movement between a buyer and a shop. TenderTransactions can be used instead of OrderTransactions
 * for reconciling a shop's cash flow. A TenderTransaction is immutable once created.
 */
export type TenderTransaction = Node & {
  __typename?: 'TenderTransaction';
  /** The amount and currency of the tender transaction. */
  amount: MoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The order that's related to the tender transaction. This value is null if the order has been deleted. */
  order?: Maybe<Order>;
  /** Information about the payment method used for the transaction. */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Date and time when the transaction was processed. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The remote gateway reference associated with the tender transaction. */
  remoteReference?: Maybe<Scalars['String']['output']>;
  /** Whether the transaction is a test transaction. */
  test: Scalars['Boolean']['output'];
  /** Information about the payment instrument used for the transaction. */
  transactionDetails?: Maybe<TenderTransactionDetails>;
  /** The staff member who performed the transaction. */
  user?: Maybe<StaffMember>;
};

/** An auto-generated type for paginating through multiple TenderTransactions. */
export type TenderTransactionConnection = {
  __typename?: 'TenderTransactionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<TenderTransactionEdge>;
  /** A list of nodes that are contained in TenderTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<TenderTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Information about the credit card used for this transaction. */
export type TenderTransactionCreditCardDetails = {
  __typename?: 'TenderTransactionCreditCardDetails';
  /** The name of the company that issued the customer's credit card. Example: `Visa`. */
  creditCardCompany?: Maybe<Scalars['String']['output']>;
  /** The customer's credit card number, with all digits except the last 4 redacted. Example: `•••• •••• •••• 1234` */
  creditCardNumber?: Maybe<Scalars['String']['output']>;
};

/** Information about the payment instrument used for this transaction. */
export type TenderTransactionDetails = TenderTransactionCreditCardDetails;

/** An auto-generated type which holds one TenderTransaction and a cursor during pagination. */
export type TenderTransactionEdge = {
  __typename?: 'TenderTransactionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of TenderTransactionEdge. */
  node: TenderTransaction;
};

/** Return type for `themeCreate` mutation. */
export type ThemeCreatePayload = {
  __typename?: 'ThemeCreatePayload';
  /** The theme that was created. */
  theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ThemeCreateUserError>;
};

/** An error that occurs during the execution of `ThemeCreate`. */
export type ThemeCreateUserError = DisplayableError & {
  __typename?: 'ThemeCreateUserError';
  /** The error code. */
  code?: Maybe<ThemeCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ThemeCreateUserError`. */
export enum ThemeCreateUserErrorCode {
  /** Invalid theme role for theme creation. */
  InvalidThemeRoleForThemeCreation = 'INVALID_THEME_ROLE_FOR_THEME_CREATION',
  /** Must be a zip file. */
  InvalidZip = 'INVALID_ZIP',
  /** Theme creation is not allowed for your shop's plan. */
  ThemeCreationNotAllowedForThemeLimitedPlan = 'THEME_CREATION_NOT_ALLOWED_FOR_THEME_LIMITED_PLAN',
  /** Zip is empty. */
  ZipIsEmpty = 'ZIP_IS_EMPTY',
  /**
   * May not be used to fetch a file bigger
   *             than 50MB.
   */
  ZipTooLarge = 'ZIP_TOO_LARGE'
}

/** Return type for `themeDelete` mutation. */
export type ThemeDeletePayload = {
  __typename?: 'ThemeDeletePayload';
  /** The ID of the deleted theme. */
  deletedThemeId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ThemeDeleteUserError>;
};

/** An error that occurs during the execution of `ThemeDelete`. */
export type ThemeDeleteUserError = DisplayableError & {
  __typename?: 'ThemeDeleteUserError';
  /** The error code. */
  code?: Maybe<ThemeDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ThemeDeleteUserError`. */
export enum ThemeDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** Return type for `themeDuplicate` mutation. */
export type ThemeDuplicatePayload = {
  __typename?: 'ThemeDuplicatePayload';
  /** The newly duplicated theme. */
  newTheme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ThemeDuplicateUserError>;
};

/** An error that occurs during the execution of `ThemeDuplicate`. */
export type ThemeDuplicateUserError = DisplayableError & {
  __typename?: 'ThemeDuplicateUserError';
  /** The error code. */
  code?: Maybe<ThemeDuplicateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ThemeDuplicateUserError`. */
export enum ThemeDuplicateUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND'
}

/** The input fields for the file copy. */
export type ThemeFilesCopyFileInput = {
  /** The new file where the content is copied to. */
  dstFilename: Scalars['String']['input'];
  /** The source file to copy from. */
  srcFilename: Scalars['String']['input'];
};

/** Return type for `themeFilesCopy` mutation. */
export type ThemeFilesCopyPayload = {
  __typename?: 'ThemeFilesCopyPayload';
  /** The resulting theme files. */
  copiedThemeFiles?: Maybe<Array<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themeFilesDelete` mutation. */
export type ThemeFilesDeletePayload = {
  __typename?: 'ThemeFilesDeletePayload';
  /** The resulting theme files. */
  deletedThemeFiles?: Maybe<Array<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themeFilesUpsert` mutation. */
export type ThemeFilesUpsertPayload = {
  __typename?: 'ThemeFilesUpsertPayload';
  /** The theme files write job triggered by the mutation. */
  job?: Maybe<Job>;
  /** The resulting theme files. */
  upsertedThemeFiles?: Maybe<Array<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themePublish` mutation. */
export type ThemePublishPayload = {
  __typename?: 'ThemePublishPayload';
  /** The theme that was published. */
  theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ThemePublishUserError>;
};

/** An error that occurs during the execution of `ThemePublish`. */
export type ThemePublishUserError = DisplayableError & {
  __typename?: 'ThemePublishUserError';
  /** The error code. */
  code?: Maybe<ThemePublishUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ThemePublishUserError`. */
export enum ThemePublishUserErrorCode {
  /** Theme publishing is not available during install. */
  CannotPublishThemeDuringInstall = 'CANNOT_PUBLISH_THEME_DURING_INSTALL',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** Theme publishing is not allowed on this plan. */
  ThemePublishNotAvailableForThemeLimitedPlan = 'THEME_PUBLISH_NOT_AVAILABLE_FOR_THEME_LIMITED_PLAN'
}

/** The role of the theme. */
export enum ThemeRole {
  /** The theme is archived if a merchant changes their plan and exceeds the maximum number of themes allowed. Archived themes can be downloaded by merchant, but can not be customized or published until the plan is upgraded. */
  Archived = 'ARCHIVED',
  /** The theme is installed as a trial from the Shopify Theme Store. It can be customized using the theme editor, but access to the code editor and the ability to publish the theme are restricted until it is purchased. */
  Demo = 'DEMO',
  /** The theme is automatically created by the CLI for previewing purposes when in a development session. */
  Development = 'DEVELOPMENT',
  /** The theme is locked if it is identified as unlicensed. Customization and publishing are restricted until the merchant resolves the licensing issue. */
  Locked = 'LOCKED',
  /** The currently published theme. There can only be one main theme at any time. */
  Main = 'MAIN',
  /**
   * The currently published theme that is only accessible to a mobile client.
   * @deprecated The feature for this role has been deprecated.
   */
  Mobile = 'MOBILE',
  /** The theme is currently not published. It can be transitioned to the main role if it is published by the merchant. */
  Unpublished = 'UNPUBLISHED'
}

/** Return type for `themeUpdate` mutation. */
export type ThemeUpdatePayload = {
  __typename?: 'ThemeUpdatePayload';
  /** The theme that was updated. */
  theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ThemeUpdateUserError>;
};

/** An error that occurs during the execution of `ThemeUpdate`. */
export type ThemeUpdateUserError = DisplayableError & {
  __typename?: 'ThemeUpdateUserError';
  /** The error code. */
  code?: Maybe<ThemeUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ThemeUpdateUserError`. */
export enum ThemeUpdateUserErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NotFound = 'NOT_FOUND',
  /** The input value is too long. */
  TooLong = 'TOO_LONG'
}

/** A sale associated with a tip. */
export type TipSale = Sale & {
  __typename?: 'TipSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line item for the associated sale. */
  lineItem: LineItem;
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** Transaction fee related to an order transaction. */
export type TransactionFee = Node & {
  __typename?: 'TransactionFee';
  /** Amount of the fee. */
  amount: MoneyV2;
  /** The date and time when the transaction fee was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Flat rate charge for a transaction. */
  flatFee: MoneyV2;
  /** Name of the credit card flat fee. */
  flatFeeName?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Percentage charge. */
  rate: Scalars['Decimal']['output'];
  /** Name of the credit card rate. */
  rateName?: Maybe<Scalars['String']['output']>;
  /** Tax amount charged on the fee. */
  taxAmount: MoneyV2;
  /** Name of the type of fee. */
  type: Scalars['String']['output'];
};

/** The set of valid sort keys for the Transaction query. */
export enum TransactionSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `expires_at` value. */
  ExpiresAt = 'EXPIRES_AT'
}

/** Return type for `transactionVoid` mutation. */
export type TransactionVoidPayload = {
  __typename?: 'TransactionVoidPayload';
  /** The created void transaction. */
  transaction?: Maybe<OrderTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TransactionVoidUserError>;
};

/** An error that occurs during the execution of `TransactionVoid`. */
export type TransactionVoidUserError = DisplayableError & {
  __typename?: 'TransactionVoidUserError';
  /** The error code. */
  code?: Maybe<TransactionVoidUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `TransactionVoidUserError`. */
export enum TransactionVoidUserErrorCode {
  /** Transaction must be a successful authorization. */
  AuthNotSuccessful = 'AUTH_NOT_SUCCESSFUL',
  /** Transaction must be voidable. */
  AuthNotVoidable = 'AUTH_NOT_VOIDABLE',
  /** A generic error occurred while attempting to void the transaction. */
  GenericError = 'GENERIC_ERROR',
  /** Transaction does not exist. */
  TransactionNotFound = 'TRANSACTION_NOT_FOUND'
}

/** The set of valid sort keys for the Transfer query. */
export enum TransferSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `destination_name` value. */
  DestinationName = 'DESTINATION_NAME',
  /** Sort by the `expected_shipment_arrival` value. */
  ExpectedShipmentArrival = 'EXPECTED_SHIPMENT_ARRIVAL',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
  /** Sort by the `origin_name` value. */
  OriginName = 'ORIGIN_NAME',
  /** Sort by the `source_name` value. */
  SourceName = 'SOURCE_NAME',
  /** Sort by the `status` value. */
  Status = 'STATUS'
}

/** Translatable content of a resource's field. */
export type TranslatableContent = {
  __typename?: 'TranslatableContent';
  /** Hash digest representation of the content value. */
  digest?: Maybe<Scalars['String']['output']>;
  /** The resource field that's being translated. */
  key: Scalars['String']['output'];
  /** Locale of the content. */
  locale: Scalars['String']['output'];
  /** Type of the translatable content. */
  type: LocalizableContentType;
  /** Content value. */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * A resource in Shopify that contains fields available for translation into different languages. Accesses the resource's translatable content, existing [`Translation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Translation) objects, and any nested resources that can also be translated.
 *
 * The [`TranslatableContent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent) includes field keys, values, and digest hashes needed when [registering translations](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister).
 *
 * You can retrieve translations for specific [`Locale`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Locale) and [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) configurations. Each translation includes an `outdated` flag indicating whether the original content has changed since that translation was last updated.
 *
 * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
 */
export type TranslatableResource = {
  __typename?: 'TranslatableResource';
  /** Nested translatable resources under the current resource. */
  nestedTranslatableResources: TranslatableResourceConnection;
  /** GID of the resource. */
  resourceId: Scalars['ID']['output'];
  /** Translatable content. */
  translatableContent: Array<TranslatableContent>;
  /** Translatable content translations (includes unpublished locales). */
  translations: Array<Translation>;
};


/**
 * A resource in Shopify that contains fields available for translation into different languages. Accesses the resource's translatable content, existing [`Translation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Translation) objects, and any nested resources that can also be translated.
 *
 * The [`TranslatableContent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent) includes field keys, values, and digest hashes needed when [registering translations](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister).
 *
 * You can retrieve translations for specific [`Locale`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Locale) and [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) configurations. Each translation includes an `outdated` flag indicating whether the original content has changed since that translation was last updated.
 *
 * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
 */
export type TranslatableResourceNestedTranslatableResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<TranslatableResourceType>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A resource in Shopify that contains fields available for translation into different languages. Accesses the resource's translatable content, existing [`Translation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Translation) objects, and any nested resources that can also be translated.
 *
 * The [`TranslatableContent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent) includes field keys, values, and digest hashes needed when [registering translations](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister).
 *
 * You can retrieve translations for specific [`Locale`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Locale) and [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) configurations. Each translation includes an `outdated` flag indicating whether the original content has changed since that translation was last updated.
 *
 * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
 */
export type TranslatableResourceTranslatableContentArgs = {
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A resource in Shopify that contains fields available for translation into different languages. Accesses the resource's translatable content, existing [`Translation`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Translation) objects, and any nested resources that can also be translated.
 *
 * The [`TranslatableContent`](https://shopify.dev/docs/api/admin-graphql/latest/objects/TranslatableContent) includes field keys, values, and digest hashes needed when [registering translations](https://shopify.dev/docs/api/admin-graphql/latest/mutations/translationsRegister).
 *
 * You can retrieve translations for specific [`Locale`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Locale) and [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) configurations. Each translation includes an `outdated` flag indicating whether the original content has changed since that translation was last updated.
 *
 * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
 */
export type TranslatableResourceTranslationsArgs = {
  locale: Scalars['String']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
  outdated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple TranslatableResources. */
export type TranslatableResourceConnection = {
  __typename?: 'TranslatableResourceConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<TranslatableResourceEdge>;
  /** A list of nodes that are contained in TranslatableResourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<TranslatableResource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** An auto-generated type which holds one TranslatableResource and a cursor during pagination. */
export type TranslatableResourceEdge = {
  __typename?: 'TranslatableResourceEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of TranslatableResourceEdge. */
  node: TranslatableResource;
};

/** Specifies the type of resources that are translatable. */
export enum TranslatableResourceType {
  /** A blog post. Translatable fields: `title`, `body_html`, `summary_html`, `handle`, `meta_title`, `meta_description`. */
  Article = 'ARTICLE',
  /** An article image. Translatable fields: `alt`. */
  ArticleImage = 'ARTICLE_IMAGE',
  /** A blog. Translatable fields: `title`, `handle`, `meta_title`, `meta_description`. */
  Blog = 'BLOG',
  /** A product collection. Translatable fields: `title`, `body_html`, `handle`, `meta_title`, `meta_description`. */
  Collection = 'COLLECTION',
  /** A collection image. Translatable fields: `alt`. */
  CollectionImage = 'COLLECTION_IMAGE',
  /** The delivery method definition. For example, "Standard", or "Expedited". Translatable fields: `name`, `description`. */
  DeliveryMethodDefinition = 'DELIVERY_METHOD_DEFINITION',
  /** An email template. Translatable fields: `title`, `body_html`. */
  EmailTemplate = 'EMAIL_TEMPLATE',
  /** A filter. Translatable fields: `label`. */
  Filter = 'FILTER',
  /** A link to direct users. Translatable fields: `title`. */
  Link = 'LINK',
  /** An image. Translatable fields: `alt`. */
  MediaImage = 'MEDIA_IMAGE',
  /** A category of links. Translatable fields: `title`. */
  Menu = 'MENU',
  /**
   * A Metafield. Translatable fields: `value`.
   * @deprecated Query metafields via their respective resource owners and use `Metafield.translatable` to determine which is translatable.
   */
  Metafield = 'METAFIELD',
  /** A Metaobject. Translatable fields are determined by the Metaobject type. */
  Metaobject = 'METAOBJECT',
  /** An online store theme. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreTheme = 'ONLINE_STORE_THEME',
  /** A theme app embed. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeAppEmbed = 'ONLINE_STORE_THEME_APP_EMBED',
  /** A theme json template. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeJsonTemplate = 'ONLINE_STORE_THEME_JSON_TEMPLATE',
  /** Locale file content of an online store theme. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeLocaleContent = 'ONLINE_STORE_THEME_LOCALE_CONTENT',
  /** A theme json section group. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeSectionGroup = 'ONLINE_STORE_THEME_SECTION_GROUP',
  /** A theme setting category. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeSettingsCategory = 'ONLINE_STORE_THEME_SETTINGS_CATEGORY',
  /** Shared static sections of an online store theme. Translatable fields: `dynamic keys based on theme data`. */
  OnlineStoreThemeSettingsDataSections = 'ONLINE_STORE_THEME_SETTINGS_DATA_SECTIONS',
  /** A packing slip template. Translatable fields: `body`. */
  PackingSlipTemplate = 'PACKING_SLIP_TEMPLATE',
  /** A page. Translatable fields: `title`, `body_html`, `handle`, `meta_title`, `meta_description`. */
  Page = 'PAGE',
  /** A payment gateway. Translatable fields: `name`, `message`, `before_payment_instructions`. */
  PaymentGateway = 'PAYMENT_GATEWAY',
  /** An online store product. Translatable fields: `title`, `body_html`, `handle`, `product_type`, `meta_title`, `meta_description`. */
  Product = 'PRODUCT',
  /**
   * An online store custom product property name. For example, "Size", "Color", or "Material".
   *         Translatable fields: `name`.
   */
  ProductOption = 'PRODUCT_OPTION',
  /** The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option. Translatable fields: `name`. */
  ProductOptionValue = 'PRODUCT_OPTION_VALUE',
  /** A selling plan. Translatable fields:`name`, `option1`, `option2`, `option3`, `description`. */
  SellingPlan = 'SELLING_PLAN',
  /** A selling plan group. Translatable fields: `name`, `option1`, `option2`, `option3`. */
  SellingPlanGroup = 'SELLING_PLAN_GROUP',
  /** A shop. Translatable fields: `meta_title`, `meta_description`. */
  Shop = 'SHOP',
  /** A shop policy. Translatable fields: `body`. */
  ShopPolicy = 'SHOP_POLICY'
}

/**
 * A localized version of a field on a resource. Translations enable merchants to provide content in multiple languages for [`Product`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) objects, [`Collection`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection) objects, and other store resources.
 *
 * Each translation specifies the locale, the field being translated (identified by its key), and the translated value. Translations can be market-specific, allowing different content for the same language across different markets, or available globally when no [`Market`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Market) is specified. The `outdated` flag indicates whether the original content has changed since this translation was last updated.
 *
 * Learn more about [managing translated content](https://shopify.dev/docs/apps/build/markets/manage-translated-content).
 */
export type Translation = {
  __typename?: 'Translation';
  /** On the resource that this translation belongs to, the reference to the value being translated. */
  key: Scalars['String']['output'];
  /** ISO code of the translation locale. */
  locale: Scalars['String']['output'];
  /** The market that the translation is specific to. Null value means the translation is available in all markets. */
  market?: Maybe<Market>;
  /** Whether the original content has changed since this translation was updated. */
  outdated: Scalars['Boolean']['output'];
  /** The date and time when the translation was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Translation value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Possible error codes that can be returned by `TranslationUserError`. */
export enum TranslationErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Translation value is invalid. */
  FailsResourceValidation = 'FAILS_RESOURCE_VALIDATION',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Locale language code is invalid. */
  InvalidCode = 'INVALID_CODE',
  /** Locale code format is invalid. */
  InvalidFormat = 'INVALID_FORMAT',
  /** Translation key is invalid. */
  InvalidKeyForModel = 'INVALID_KEY_FOR_MODEL',
  /**
   * The locale is missing on the market corresponding to the `marketId` argument.
   * @deprecated `invalid_locale_for_market` is deprecated because the creation of a locale that's specific to a market no longer needs to be tied to that market's URL.
   *
   */
  InvalidLocaleForMarket = 'INVALID_LOCALE_FOR_MARKET',
  /** Locale is invalid for the shop. */
  InvalidLocaleForShop = 'INVALID_LOCALE_FOR_SHOP',
  /** Market localizable content is invalid. */
  InvalidMarketLocalizableContent = 'INVALID_MARKET_LOCALIZABLE_CONTENT',
  /** Translatable content is invalid. */
  InvalidTranslatableContent = 'INVALID_TRANSLATABLE_CONTENT',
  /** The handle is already taken for this resource. */
  InvalidValueForHandleTranslation = 'INVALID_VALUE_FOR_HANDLE_TRANSLATION',
  /** The shop isn't allowed to operate on market custom content. */
  MarketCustomContentNotAllowed = 'MARKET_CUSTOM_CONTENT_NOT_ALLOWED',
  /** The market corresponding to the `marketId` argument doesn't exist. */
  MarketDoesNotExist = 'MARKET_DOES_NOT_EXIST',
  /** The market override locale creation failed. */
  MarketLocaleCreationFailed = 'MARKET_LOCALE_CREATION_FAILED',
  /** Resource does not exist. */
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  /** The specified resource can't be customized for a market. */
  ResourceNotMarketCustomizable = 'RESOURCE_NOT_MARKET_CUSTOMIZABLE',
  /** Resource is not translatable. */
  ResourceNotTranslatable = 'RESOURCE_NOT_TRANSLATABLE',
  /** Too many translation keys for the resource. */
  TooManyKeysForResource = 'TOO_MANY_KEYS_FOR_RESOURCE'
}

/** The input fields and values for creating or updating a translation. */
export type TranslationInput = {
  /** On the resource that this translation belongs to, the reference to the value being translated. */
  key: Scalars['String']['input'];
  /** ISO code of the locale being translated into. Only locales returned in `shopLocales` are valid. */
  locale: Scalars['String']['input'];
  /** The ID of the market that the translation is specific to. Not specifying this field means that the translation will be available in all markets. */
  marketId?: InputMaybe<Scalars['ID']['input']>;
  /** Hash digest representation of the content being translated. */
  translatableContentDigest: Scalars['String']['input'];
  /** The value of the translation. */
  value: Scalars['String']['input'];
};

/** Represents an error that happens during the execution of a translation mutation. */
export type TranslationUserError = DisplayableError & {
  __typename?: 'TranslationUserError';
  /** The error code. */
  code?: Maybe<TranslationErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Return type for `translationsRegister` mutation. */
export type TranslationsRegisterPayload = {
  __typename?: 'TranslationsRegisterPayload';
  /** The translations that were created or updated. */
  translations?: Maybe<Array<Translation>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TranslationUserError>;
};

/** Return type for `translationsRemove` mutation. */
export type TranslationsRemovePayload = {
  __typename?: 'TranslationsRemovePayload';
  /** The translations that were deleted. */
  translations?: Maybe<Array<Translation>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<TranslationUserError>;
};

/** Represents a typed custom attribute. */
export type TypedAttribute = {
  __typename?: 'TypedAttribute';
  /** Key or name of the attribute. */
  key: Scalars['String']['output'];
  /** Value of the attribute. */
  value: Scalars['String']['output'];
};

/**
 * Specifies the
 * [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters)
 * that are associated with a related marketing campaign.
 */
export type UtmInput = {
  /** The name of the UTM campaign. */
  campaign: Scalars['String']['input'];
  /** The UTM campaign medium. */
  medium: Scalars['String']['input'];
  /** The name of the website or application where the referral link exists. */
  source: Scalars['String']['input'];
};

/** Represents a set of UTM parameters. */
export type UtmParameters = {
  __typename?: 'UTMParameters';
  /** The name of a marketing campaign. */
  campaign?: Maybe<Scalars['String']['output']>;
  /** Identifies specific content in a marketing campaign. Used to differentiate between similar content or links in a marketing campaign to determine which is the most effective. */
  content?: Maybe<Scalars['String']['output']>;
  /** The medium of a marketing campaign, such as a banner or email newsletter. */
  medium?: Maybe<Scalars['String']['output']>;
  /** The source of traffic to the merchant's store, such as Google or an email newsletter. */
  source?: Maybe<Scalars['String']['output']>;
  /** Paid search terms used by a marketing campaign. */
  term?: Maybe<Scalars['String']['output']>;
};

/** The input fields that identify a unique valued metafield. */
export type UniqueMetafieldValueInput = {
  /** The key for the metafield. */
  key: Scalars['String']['input'];
  /** The container the metafield belongs to. If omitted, the app-reserved namespace will be used. */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The value of the metafield. */
  value: Scalars['String']['input'];
};

/** The measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml). */
export type UnitPriceMeasurement = {
  __typename?: 'UnitPriceMeasurement';
  /** The type of unit of measurement for the unit price measurement. */
  measuredType?: Maybe<UnitPriceMeasurementMeasuredType>;
  /** The quantity unit for the unit price measurement. */
  quantityUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  /** The quantity value for the unit price measurement. */
  quantityValue: Scalars['Float']['output'];
  /** The reference unit for the unit price measurement. */
  referenceUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  /** The reference value for the unit price measurement. */
  referenceValue: Scalars['Int']['output'];
};

/** The input fields for the measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml). */
export type UnitPriceMeasurementInput = {
  /** The quantity unit for the unit price measurement. */
  quantityUnit?: InputMaybe<UnitPriceMeasurementMeasuredUnit>;
  /** The quantity value for the unit price measurement. */
  quantityValue?: InputMaybe<Scalars['Float']['input']>;
  /** The reference unit for the unit price measurement. */
  referenceUnit?: InputMaybe<UnitPriceMeasurementMeasuredUnit>;
  /** The reference value for the unit price measurement. */
  referenceValue?: InputMaybe<Scalars['Int']['input']>;
};

/** The accepted types of unit of measurement. */
export enum UnitPriceMeasurementMeasuredType {
  /** Unit of measurements representing areas. */
  Area = 'AREA',
  /** Unit of measurements representing counts. */
  Count = 'COUNT',
  /** Unit of measurements representing lengths. */
  Length = 'LENGTH',
  /** The type of measurement is unknown. Upgrade to the latest version of the API to resolve this type. */
  Unknown = 'UNKNOWN',
  /** Unit of measurements representing volumes. */
  Volume = 'VOLUME',
  /** Unit of measurements representing weights. */
  Weight = 'WEIGHT'
}

/** The valid units of measurement for a unit price measurement. */
export enum UnitPriceMeasurementMeasuredUnit {
  /** 100 centiliters equals 1 liter. */
  Cl = 'CL',
  /** 100 centimeters equals 1 meter. */
  Cm = 'CM',
  /** Imperial system unit of volume (U.S. customary unit). */
  Floz = 'FLOZ',
  /** 1 foot equals 12 inches. */
  Ft = 'FT',
  /** Imperial system unit of area. */
  Ft2 = 'FT2',
  /** Metric system unit of weight. */
  G = 'G',
  /** 1 gallon equals 128 fluid ounces (U.S. customary unit). */
  Gal = 'GAL',
  /** Imperial system unit of length. */
  In = 'IN',
  /** 1 item, a unit of count. */
  Item = 'ITEM',
  /** 1 kilogram equals 1000 grams. */
  Kg = 'KG',
  /** Metric system unit of volume. */
  L = 'L',
  /** Imperial system unit of weight. */
  Lb = 'LB',
  /** Metric system unit of length. */
  M = 'M',
  /** Metric system unit of area. */
  M2 = 'M2',
  /** 1 cubic meter equals 1000 liters. */
  M3 = 'M3',
  /** 1000 milligrams equals 1 gram. */
  Mg = 'MG',
  /** 1000 milliliters equals 1 liter. */
  Ml = 'ML',
  /** 1000 millimeters equals 1 meter. */
  Mm = 'MM',
  /** 16 ounces equals 1 pound. */
  Oz = 'OZ',
  /** 1 pint equals 16 fluid ounces (U.S. customary unit). */
  Pt = 'PT',
  /** 1 quart equals 32 fluid ounces (U.S. customary unit). */
  Qt = 'QT',
  /** The unit of measurement is unknown. Upgrade to the latest version of the API to resolve this unit. */
  Unknown = 'UNKNOWN',
  /** 1 yard equals 36 inches. */
  Yd = 'YD'
}

/** Systems of weights and measures. */
export enum UnitSystem {
  /** Imperial system of weights and measures. */
  ImperialSystem = 'IMPERIAL_SYSTEM',
  /** Metric system of weights and measures. */
  MetricSystem = 'METRIC_SYSTEM'
}

/** This is represents new sale types that have been added in future API versions. You may update to a more recent API version to receive additional details about this sale. */
export type UnknownSale = Sale & {
  __typename?: 'UnknownSale';
  /** The type of order action that the sale represents. */
  actionType: SaleActionType;
  /** The unique ID for the sale. */
  id: Scalars['ID']['output'];
  /** The line type assocated with the sale. */
  lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** All individual taxes associated with the sale. */
  taxes: Array<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  totalTaxAmount: MoneyBag;
};

/** An unverified return line item. */
export type UnverifiedReturnLineItem = Node & ReturnLineItemType & {
  __typename?: 'UnverifiedReturnLineItem';
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The quantity that can be processed. */
  processableQuantity: Scalars['Int']['output'];
  /** The quantity that has been processed. */
  processedQuantity: Scalars['Int']['output'];
  /** The quantity being returned. */
  quantity: Scalars['Int']['output'];
  /** The quantity that can be refunded. */
  refundableQuantity: Scalars['Int']['output'];
  /** The quantity that was refunded. */
  refundedQuantity: Scalars['Int']['output'];
  /**
   * The reason for returning the item.
   * @deprecated Use `returnReasonDefinition` instead. This field will be removed in the future.
   */
  returnReason: ReturnReason;
  /** The standardized reason for why the item is being returned. */
  returnReasonDefinition?: Maybe<ReturnReasonDefinition>;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  returnReasonNote: Scalars['String']['output'];
  /** The unit price of the unverified return line item. */
  unitPrice: MoneyV2;
  /** The quantity that has't been processed. */
  unprocessedQuantity: Scalars['Int']['output'];
};

/** The input fields required to update a media object. */
export type UpdateMediaInput = {
  /** The alt text associated to the media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the media to update. */
  id: Scalars['ID']['input'];
  /** The source from which to update the media preview image. May be an external URL or staged upload URL. */
  previewImageSource?: InputMaybe<Scalars['String']['input']>;
};

/** The URL redirect for the online store. */
export type UrlRedirect = Node & {
  __typename?: 'UrlRedirect';
  /** The date and time when the URL redirect was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the URL redirect. */
  id: Scalars['ID']['output'];
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  path: Scalars['String']['output'];
  /** The target location where the user will be redirected to. */
  target: Scalars['String']['output'];
};

/** Return type for `urlRedirectBulkDeleteAll` mutation. */
export type UrlRedirectBulkDeleteAllPayload = {
  __typename?: 'UrlRedirectBulkDeleteAllPayload';
  /** The asynchronous job removing the redirects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** Return type for `urlRedirectBulkDeleteByIds` mutation. */
export type UrlRedirectBulkDeleteByIdsPayload = {
  __typename?: 'UrlRedirectBulkDeleteByIdsPayload';
  /** The asynchronous job removing the redirects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectBulkDeleteByIdsUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteByIds`. */
export type UrlRedirectBulkDeleteByIdsUserError = DisplayableError & {
  __typename?: 'UrlRedirectBulkDeleteByIdsUserError';
  /** The error code. */
  code?: Maybe<UrlRedirectBulkDeleteByIdsUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteByIdsUserError`. */
export enum UrlRedirectBulkDeleteByIdsUserErrorCode {
  /**
   * You must pass one or more [`URLRedirect`](
   *             https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect
   *           ) object IDs.
   */
  IdsEmpty = 'IDS_EMPTY'
}

/** Return type for `urlRedirectBulkDeleteBySavedSearch` mutation. */
export type UrlRedirectBulkDeleteBySavedSearchPayload = {
  __typename?: 'UrlRedirectBulkDeleteBySavedSearchPayload';
  /** The asynchronous job removing the redirects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectBulkDeleteBySavedSearchUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteBySavedSearch`. */
export type UrlRedirectBulkDeleteBySavedSearchUserError = DisplayableError & {
  __typename?: 'UrlRedirectBulkDeleteBySavedSearchUserError';
  /** The error code. */
  code?: Maybe<UrlRedirectBulkDeleteBySavedSearchUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteBySavedSearchUserError`. */
export enum UrlRedirectBulkDeleteBySavedSearchUserErrorCode {
  /** The saved search's query cannot match all entries or be empty. */
  InvalidSavedSearchQuery = 'INVALID_SAVED_SEARCH_QUERY',
  /** Saved search not found. */
  SavedSearchNotFound = 'SAVED_SEARCH_NOT_FOUND'
}

/** Return type for `urlRedirectBulkDeleteBySearch` mutation. */
export type UrlRedirectBulkDeleteBySearchPayload = {
  __typename?: 'UrlRedirectBulkDeleteBySearchPayload';
  /** The asynchronous job removing the redirects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectBulkDeleteBySearchUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteBySearch`. */
export type UrlRedirectBulkDeleteBySearchUserError = DisplayableError & {
  __typename?: 'UrlRedirectBulkDeleteBySearchUserError';
  /** The error code. */
  code?: Maybe<UrlRedirectBulkDeleteBySearchUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteBySearchUserError`. */
export enum UrlRedirectBulkDeleteBySearchUserErrorCode {
  /** Invalid search string. */
  InvalidSearchArgument = 'INVALID_SEARCH_ARGUMENT'
}

/** An auto-generated type for paginating through multiple UrlRedirects. */
export type UrlRedirectConnection = {
  __typename?: 'UrlRedirectConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<UrlRedirectEdge>;
  /** A list of nodes that are contained in UrlRedirectEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<UrlRedirect>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `urlRedirectCreate` mutation. */
export type UrlRedirectCreatePayload = {
  __typename?: 'UrlRedirectCreatePayload';
  /** The created redirect. */
  urlRedirect?: Maybe<UrlRedirect>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectUserError>;
};

/** Return type for `urlRedirectDelete` mutation. */
export type UrlRedirectDeletePayload = {
  __typename?: 'UrlRedirectDeletePayload';
  /** The ID of the deleted redirect. */
  deletedUrlRedirectId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectUserError>;
};

/** An auto-generated type which holds one UrlRedirect and a cursor during pagination. */
export type UrlRedirectEdge = {
  __typename?: 'UrlRedirectEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of UrlRedirectEdge. */
  node: UrlRedirect;
};

/** Possible error codes that can be returned by `UrlRedirectUserError`. */
export enum UrlRedirectErrorCode {
  /** Redirect could not be created. */
  CreateFailed = 'CREATE_FAILED',
  /** Redirect could not be deleted. */
  DeleteFailed = 'DELETE_FAILED',
  /** Redirect does not exist. */
  DoesNotExist = 'DOES_NOT_EXIST',
  /** Redirect could not be updated. */
  UpdateFailed = 'UPDATE_FAILED'
}

/**
 * A request to import a [`URLRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object
 * into the Online Store channel. Apps can use this to query the state of an `UrlRedirectImport` request.
 *
 * For more information, see [`url-redirect`](https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect)s.
 */
export type UrlRedirectImport = Node & {
  __typename?: 'UrlRedirectImport';
  /** The number of rows in the file. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The number of redirects created from the import. */
  createdCount?: Maybe<Scalars['Int']['output']>;
  /** The number of redirects that failed to be imported. */
  failedCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the import is finished. */
  finished: Scalars['Boolean']['output'];
  /** The date and time when the import finished. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the `UrlRedirectImport` object. */
  id: Scalars['ID']['output'];
  /** A list of up to three previews of the URL redirects to be imported. */
  previewRedirects: Array<UrlRedirectImportPreview>;
  /** The number of redirects updated during the import. */
  updatedCount?: Maybe<Scalars['Int']['output']>;
};

/** Return type for `urlRedirectImportCreate` mutation. */
export type UrlRedirectImportCreatePayload = {
  __typename?: 'UrlRedirectImportCreatePayload';
  /** The created `URLRedirectImport` object. */
  urlRedirectImport?: Maybe<UrlRedirectImport>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectImportUserError>;
};

/** Possible error codes that can be returned by `UrlRedirectImportUserError`. */
export enum UrlRedirectImportErrorCode {
  /** The import has already completed. */
  AlreadyImported = 'ALREADY_IMPORTED',
  /**
   * CSV file does not exist at given URL.
   * @deprecated This error code is never returned
   */
  FileDoesNotExist = 'FILE_DOES_NOT_EXIST',
  /** The import is already in progress. */
  InProgress = 'IN_PROGRESS',
  /** URL redirect import not found. */
  NotFound = 'NOT_FOUND'
}

/** A preview of a URL redirect import row. */
export type UrlRedirectImportPreview = {
  __typename?: 'UrlRedirectImportPreview';
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  path: Scalars['String']['output'];
  /** The target location where the user will be redirected to. */
  target: Scalars['String']['output'];
};

/** Return type for `urlRedirectImportSubmit` mutation. */
export type UrlRedirectImportSubmitPayload = {
  __typename?: 'UrlRedirectImportSubmitPayload';
  /** The asynchronous job importing the redirects. */
  job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectImportUserError>;
};

/** Represents an error that happens during execution of a redirect import mutation. */
export type UrlRedirectImportUserError = DisplayableError & {
  __typename?: 'UrlRedirectImportUserError';
  /** The error code. */
  code?: Maybe<UrlRedirectImportErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** The input fields to create or update a URL redirect. */
export type UrlRedirectInput = {
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** The target location where the user will be redirected to. */
  target?: InputMaybe<Scalars['String']['input']>;
};

/** The set of valid sort keys for the UrlRedirect query. */
export enum UrlRedirectSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `path` value. */
  Path = 'PATH',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  Relevance = 'RELEVANCE'
}

/** Return type for `urlRedirectUpdate` mutation. */
export type UrlRedirectUpdatePayload = {
  __typename?: 'UrlRedirectUpdatePayload';
  /** Returns the updated URL redirect. */
  urlRedirect?: Maybe<UrlRedirect>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UrlRedirectUserError>;
};

/** Represents an error that happens during execution of a redirect mutation. */
export type UrlRedirectUserError = DisplayableError & {
  __typename?: 'UrlRedirectUserError';
  /** The error code. */
  code?: Maybe<UrlRedirectErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** An error in the input of a mutation. Mutations return `UserError` objects to indicate validation failures, such as invalid field values or business logic violations, that prevent the operation from completing. */
export type UserError = DisplayableError & {
  __typename?: 'UserError';
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * A server-side validation that enforces business rules before customers complete their purchases. Each validation links to a [`ShopifyFunction`](https://shopify.dev/docs/api/functions/latest/cart-and-checkout-validation) that implements the validation logic.
 *
 * Validations run on Shopify's servers and are enforced throughout the checkout process. Validation errors always block checkout progress. The `blockOnFailure` setting determines whether runtime exceptions, like timeouts, also block checkout. Tracks runtime exception history for the validation function and supports custom data through [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 */
export type Validation = HasMetafieldDefinitions & HasMetafields & Node & {
  __typename?: 'Validation';
  /** Whether the validation should block on failures other than expected violations. */
  blockOnFailure: Scalars['Boolean']['output'];
  /** Whether the validation is enabled on the merchant checkout. */
  enabled: Scalars['Boolean']['output'];
  /** The error history on the most recent version of the validation function. */
  errorHistory?: Maybe<FunctionsErrorHistory>;
  /** Global ID for the validation. */
  id: Scalars['ID']['output'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use `QueryRoot.metafieldDefinitions` instead.
   */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  metafields: MetafieldConnection;
  /** The Shopify Function implementing the validation. */
  shopifyFunction: ShopifyFunction;
  /** The merchant-facing validation name. */
  title: Scalars['String']['output'];
};


/**
 * A server-side validation that enforces business rules before customers complete their purchases. Each validation links to a [`ShopifyFunction`](https://shopify.dev/docs/api/functions/latest/cart-and-checkout-validation) that implements the validation logic.
 *
 * Validations run on Shopify's servers and are enforced throughout the checkout process. Validation errors always block checkout progress. The `blockOnFailure` setting determines whether runtime exceptions, like timeouts, also block checkout. Tracks runtime exception history for the validation function and supports custom data through [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 */
export type ValidationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A server-side validation that enforces business rules before customers complete their purchases. Each validation links to a [`ShopifyFunction`](https://shopify.dev/docs/api/functions/latest/cart-and-checkout-validation) that implements the validation logic.
 *
 * Validations run on Shopify's servers and are enforced throughout the checkout process. Validation errors always block checkout progress. The `blockOnFailure` setting determines whether runtime exceptions, like timeouts, also block checkout. Tracks runtime exception history for the validation function and supports custom data through [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 */
export type ValidationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A server-side validation that enforces business rules before customers complete their purchases. Each validation links to a [`ShopifyFunction`](https://shopify.dev/docs/api/functions/latest/cart-and-checkout-validation) that implements the validation logic.
 *
 * Validations run on Shopify's servers and are enforced throughout the checkout process. Validation errors always block checkout progress. The `blockOnFailure` setting determines whether runtime exceptions, like timeouts, also block checkout. Tracks runtime exception history for the validation function and supports custom data through [`Metafield`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Metafield) objects.
 */
export type ValidationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An auto-generated type for paginating through multiple Validations. */
export type ValidationConnection = {
  __typename?: 'ValidationConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<ValidationEdge>;
  /** A list of nodes that are contained in ValidationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<Validation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** The input fields required to install a validation. */
export type ValidationCreateInput = {
  /** Whether the validation should block on failures other than expected violations. */
  blockOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the validation should be live on the merchant checkout. */
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The function handle representing the extension to install. */
  functionHandle?: InputMaybe<Scalars['String']['input']>;
  /** Additional metafields to associate to the validation. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The title of the validation. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `validationCreate` mutation. */
export type ValidationCreatePayload = {
  __typename?: 'ValidationCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ValidationUserError>;
  /** The created validation. */
  validation?: Maybe<Validation>;
};

/** Return type for `validationDelete` mutation. */
export type ValidationDeletePayload = {
  __typename?: 'ValidationDeletePayload';
  /** Returns the deleted validation ID. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ValidationUserError>;
};

/** An auto-generated type which holds one Validation and a cursor during pagination. */
export type ValidationEdge = {
  __typename?: 'ValidationEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of ValidationEdge. */
  node: Validation;
};

/** The set of valid sort keys for the Validation query. */
export enum ValidationSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID'
}

/** The input fields required to update a validation. */
export type ValidationUpdateInput = {
  /** Whether the validation should block on failures other than expected violations. */
  blockOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the validation should be live on the merchant checkout. */
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional metafields to associate to the validation. */
  metafields?: InputMaybe<Array<MetafieldInput>>;
  /** The title of the validation. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `validationUpdate` mutation. */
export type ValidationUpdatePayload = {
  __typename?: 'ValidationUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ValidationUserError>;
  /** The updated validation. */
  validation?: Maybe<Validation>;
};

/** An error that occurs during the execution of a validation mutation. */
export type ValidationUserError = DisplayableError & {
  __typename?: 'ValidationUserError';
  /** The error code. */
  code?: Maybe<ValidationUserErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `ValidationUserError`. */
export enum ValidationUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  AppNotAuthorized = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The metafield violates a capability restriction. */
  CapabilityViolation = 'CAPABILITY_VIOLATION',
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CustomAppFunctionNotEligible = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Owner type can't be used in this mutation. */
  DisallowedOwnerType = 'DISALLOWED_OWNER_TYPE',
  /** Function does not implement the required interface for this cart & checkout validation. */
  FunctionDoesNotImplement = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function not found. */
  FunctionNotFound = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FunctionPendingDeletion = 'FUNCTION_PENDING_DELETION',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** An internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** Cannot have more than 25 active validation functions. */
  MaxValidationsActivated = 'MAX_VALIDATIONS_ACTIVATED',
  /** Either function_id or function_handle must be provided. */
  MissingFunctionIdentifier = 'MISSING_FUNCTION_IDENTIFIER',
  /** Only one of function_id or function_handle can be provided, not both. */
  MultipleFunctionIdentifiers = 'MULTIPLE_FUNCTION_IDENTIFIERS',
  /** Validation not found. */
  NotFound = 'NOT_FOUND',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** Only unlisted apps can be used for this cart & checkout validation. */
  PublicAppNotAllowed = 'PUBLIC_APP_NOT_ALLOWED',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UnstructuredReservedNamespace = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** The input fields required to create or modify a product variant's option value. */
export type VariantOptionValueInput = {
  /** Specifies the product option value by ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Metafield value associated with an option. */
  linkedMetafieldValue?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the product option value by name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the product option by ID. */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies the product option by name. */
  optionName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a credit card payment instrument. */
export type VaultCreditCard = {
  __typename?: 'VaultCreditCard';
  /** The billing address of the card. */
  billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** The brand for the card. */
  brand: Scalars['String']['output'];
  /** Whether the card has been expired. */
  expired: Scalars['Boolean']['output'];
  /** The expiry month of the card. */
  expiryMonth: Scalars['Int']['output'];
  /** The expiry year of the card. */
  expiryYear: Scalars['Int']['output'];
  /** The last four digits for the card. */
  lastDigits: Scalars['String']['output'];
  /** The name of the card holder. */
  name: Scalars['String']['output'];
};

/** Represents a paypal billing agreement payment instrument. */
export type VaultPaypalBillingAgreement = {
  __typename?: 'VaultPaypalBillingAgreement';
  /** Whether the paypal billing agreement is inactive. */
  inactive: Scalars['Boolean']['output'];
  /** The paypal account name. */
  name: Scalars['String']['output'];
  /** The paypal account email address. */
  paypalAccountEmail: Scalars['String']['output'];
};

/**
 * Representation of 3d vectors and points. It can represent
 * either the coordinates of a point in space, a direction, or
 * size. Presented as an object with three floating-point values.
 */
export type Vector3 = {
  __typename?: 'Vector3';
  /** The x coordinate of Vector3. */
  x: Scalars['Float']['output'];
  /** The y coordinate of Vector3. */
  y: Scalars['Float']['output'];
  /** The z coordinate of Vector3. */
  z: Scalars['Float']['output'];
};

/** Represents a Shopify hosted video. */
export type Video = File & Media & Node & {
  __typename?: 'Video';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The video's duration in milliseconds. This value is `null` unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Any errors that have occurred on the file. */
  fileErrors: Array<FileError>;
  /** The status of the file. */
  fileStatus: FileStatus;
  /** The video's filename. */
  filename: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  mediaErrors: Array<MediaError>;
  /** The warnings attached to the media. */
  mediaWarnings: Array<MediaWarning>;
  /**
   * The video's original source. This value is `null` unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  originalSource?: Maybe<VideoSource>;
  /** The preview image for the media. */
  preview?: Maybe<MediaPreviewImage>;
  /**
   * The video's sources. This value is empty unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  sources: Array<VideoSource>;
  /** Current status of the media. */
  status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Represents a source for a Shopify hosted video.
 *
 * Types of sources include the original video, lower resolution versions of the original video,
 * and an m3u8 playlist file.
 *
 * Only [videos](https://shopify.dev/api/admin-graphql/latest/objects/video) with a status field
 * of [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready) have sources.
 */
export type VideoSource = {
  __typename?: 'VideoSource';
  /** The video source's file size in bytes. */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** The video source's file format extension. */
  format: Scalars['String']['output'];
  /** The video source's height. */
  height: Scalars['Int']['output'];
  /** The video source's MIME type. */
  mimeType: Scalars['String']['output'];
  /** The video source's URL. */
  url: Scalars['String']['output'];
  /** The video source's width. */
  width: Scalars['Int']['output'];
};

/**
 * The `WebPixel` object enables you to manage JavaScript code snippets
 * that run on an online store and collect
 * [behavioral data](https://shopify.dev/docs/api/web-pixels-api/standard-events)
 * for marketing campaign optimization and analytics.
 *
 * Learn how to create a
 * [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
 * to subscribe your app to events that are emitted by Shopify.
 */
export type WebPixel = Node & {
  __typename?: 'WebPixel';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * The
   * [settings object](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings)
   * for the web pixel. This object specifies configuration options that control the web pixel's functionality and behavior. You can find the settings for a web pixel in
   * `extensions/<your_extension_name>/shopify.extension.toml`.
   */
  settings: Scalars['JSON']['output'];
};

/** Return type for `webPixelCreate` mutation. */
export type WebPixelCreatePayload = {
  __typename?: 'WebPixelCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsWebPixelUserError>;
  /** The created web pixel settings. */
  webPixel?: Maybe<WebPixel>;
};

/** Return type for `webPixelDelete` mutation. */
export type WebPixelDeletePayload = {
  __typename?: 'WebPixelDeletePayload';
  /** The ID of the web pixel settings that was deleted. */
  deletedWebPixelId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsWebPixelUserError>;
};

/** The input fields for creating or updating a web pixel. */
export type WebPixelInput = {
  /**
   * The
   * [settings object](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings)
   * for the web pixel. This object specifies configuration options that control the web pixel's functionality and behavior.
   * You can find the settings for a web pixel in `extensions/<your_extension_name>/shopify.extension.toml`.
   */
  settings: Scalars['JSON']['input'];
};

/** Return type for `webPixelUpdate` mutation. */
export type WebPixelUpdatePayload = {
  __typename?: 'WebPixelUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ErrorsWebPixelUserError>;
  /** The updated web pixel settings. */
  webPixel?: Maybe<WebPixel>;
};

/** The input fields used to create a web presence. */
export type WebPresenceCreateInput = {
  /** The alternate locales for the web presence. */
  alternateLocales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default locale for the web presence. */
  defaultLocale: Scalars['String']['input'];
  /** The web presence's domain ID. This field must be `null` if the `subfolderSuffix` isn't `null`. */
  domainId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * For example: in `/en-us`, the subfolder suffix is `us`.
   * Only ASCII characters are allowed. This field must be `null` if the `domainId` isn't `null`.
   */
  subfolderSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `webPresenceCreate` mutation. */
export type WebPresenceCreatePayload = {
  __typename?: 'WebPresenceCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
  /** The created web presence object. */
  webPresence?: Maybe<MarketWebPresence>;
};

/** Return type for `webPresenceDelete` mutation. */
export type WebPresenceDeletePayload = {
  __typename?: 'WebPresenceDeletePayload';
  /** The ID of the deleted web presence. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
};

/** The input fields used to update a web presence. */
export type WebPresenceUpdateInput = {
  /** The alternate locales for the web presence. */
  alternateLocales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default locale for the web presence. */
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * Example: in `/en-us` the subfolder suffix is `us`.
   * Only ASCII characters are allowed.
   * This field must be null if subfolder suffix is not already defined for the web presence.
   */
  subfolderSuffix?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `webPresenceUpdate` mutation. */
export type WebPresenceUpdatePayload = {
  __typename?: 'WebPresenceUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<MarketUserError>;
  /** The web presence object. */
  webPresence?: Maybe<MarketWebPresence>;
};

/**
 * Connects your app to Amazon EventBridge so you can receive Shopify webhook events and process them through AWS's event-driven architecture. This gives you enterprise-grade scalability and lets you tap into the full AWS ecosystem for handling webhook traffic.
 *
 * For example, when a customer places an order, Shopify can publish the order creation event directly to your EventBridge partner source, allowing your AWS infrastructure to process the event through Lambda functions, SQS queues, or other AWS services.
 *
 * EventBridge endpoints provide enterprise-grade event routing and processing capabilities, making them ideal for apps that need to handle high-volume webhook traffic or integrate deeply with AWS services.
 *
 * Learn more about [webhook endpoints](https://shopify.dev/docs/apps/build/webhooks/subscribe/get-started).
 */
export type WebhookEventBridgeEndpoint = {
  __typename?: 'WebhookEventBridgeEndpoint';
  /** The ARN of this EventBridge partner event source. */
  arn: Scalars['ARN']['output'];
};

/**
 * An HTTPS endpoint that receives webhook events as POST requests, letting your app respond to Shopify events in real-time. This is the most common webhook endpoint type, allowing apps to process Shopify events through standard HTTP callbacks.
 *
 * For example, when setting up order notifications, your app would provide an HTTPS URL like `https://yourapp.com/webhooks/orders/create` to receive order creation events as JSON payloads.
 *
 * HTTP endpoints offer straightforward webhook integration with immediate event delivery, making them suitable for apps that need real-time notifications without complex infrastructure requirements.
 *
 * Learn more about [HTTP webhook configuration](https://shopify.dev/docs/apps/build/webhooks/subscribe/https).
 */
export type WebhookHttpEndpoint = {
  __typename?: 'WebhookHttpEndpoint';
  /** The URL to which the webhooks events are sent. */
  callbackUrl: Scalars['URL']['output'];
};

/**
 * Individual Google Cloud Pub/Sub topics that receive webhook events for reliable, asynchronous processing. This endpoint type lets your app tap into Google Cloud's messaging infrastructure to handle events at scale.
 *
 * For example, when inventory levels change, Shopify can publish these events to your Pub/Sub topic `projects/your-project/topics/inventory-updates`, allowing your Google Cloud functions or services to process inventory changes at their own pace.
 *
 * Pub/Sub endpoints provide reliable message delivery to Google Cloud Pub/Sub, making them excellent for apps that need to handle variable webhook volumes or integrate with Google Cloud Platform services.
 *
 * Learn more about [Pub/Sub webhook configuration](https://shopify.dev/docs/apps/build/webhooks/subscribe/get-started).
 */
export type WebhookPubSubEndpoint = {
  __typename?: 'WebhookPubSubEndpoint';
  /** The Google Cloud Pub/Sub project ID. */
  pubSubProject: Scalars['String']['output'];
  /** The Google Cloud Pub/Sub topic ID. */
  pubSubTopic: Scalars['String']['output'];
};

/**
 * A webhook subscription is a persisted data object created by an app using the REST Admin API or GraphQL Admin API.
 * It describes the topic that the app wants to receive, and a destination where Shopify should send webhooks of the specified topic.
 * When an event for a given topic occurs, the webhook subscription sends a relevant payload to the destination.
 * Learn more about the [webhooks system](https://shopify.dev/apps/webhooks).
 */
export type WebhookSubscription = LegacyInteroperability & Node & {
  __typename?: 'WebhookSubscription';
  /** The Admin API version that Shopify uses to serialize webhook events. This value is inherited from the app that created the webhook subscription. */
  apiVersion: ApiVersion;
  /**
   * The destination URI to which the webhook subscription will send a message when an event occurs.
   * @deprecated Use `uri` instead.
   */
  callbackUrl: Scalars['URL']['output'];
  /** The date and time when the webhook subscription was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The endpoint to which the webhook subscription will send events.
   * @deprecated Use `uri` instead.
   */
  endpoint: WebhookSubscriptionEndpoint;
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  filter?: Maybe<Scalars['String']['output']>;
  /** The format in which the webhook subscription should send the data. */
  format: WebhookSubscriptionFormat;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The list of fields to be included in the webhook subscription. Only the fields specified will be included in the webhook payload. If null, then all fields will be included. Learn more about [modifying webhook payloads](https://shopify.dev/docs/apps/build/webhooks/customize/modify-payloads). */
  includeFields: Array<Scalars['String']['output']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  legacyResourceId: Scalars['UnsignedInt64']['output'];
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  metafieldNamespaces: Array<Scalars['String']['output']>;
  /** The list of identifiers specifying metafields to include in the webhook subscription. */
  metafields: Array<WebhookSubscriptionMetafieldIdentifier>;
  /** A human-readable name for the webhook subscription. */
  name?: Maybe<Scalars['String']['output']>;
  /** The type of event that triggers the webhook. The topic determines when the webhook subscription sends a webhook, as well as what class of data object that webhook contains. */
  topic: WebhookSubscriptionTopic;
  /** The date and time when the webhook subscription was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URI to which the webhook subscription will send events. */
  uri: Scalars['String']['output'];
};

/** An auto-generated type for paginating through multiple WebhookSubscriptions. */
export type WebhookSubscriptionConnection = {
  __typename?: 'WebhookSubscriptionConnection';
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  edges: Array<WebhookSubscriptionEdge>;
  /** A list of nodes that are contained in WebhookSubscriptionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  nodes: Array<WebhookSubscription>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  pageInfo: PageInfo;
};

/** Return type for `webhookSubscriptionCreate` mutation. */
export type WebhookSubscriptionCreatePayload = {
  __typename?: 'WebhookSubscriptionCreatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
  /** The webhook subscription that was created. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Return type for `webhookSubscriptionDelete` mutation. */
export type WebhookSubscriptionDeletePayload = {
  __typename?: 'WebhookSubscriptionDeletePayload';
  /** The ID of the deleted webhook subscription. */
  deletedWebhookSubscriptionId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
};

/** An auto-generated type which holds one WebhookSubscription and a cursor during pagination. */
export type WebhookSubscriptionEdge = {
  __typename?: 'WebhookSubscriptionEdge';
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  cursor: Scalars['String']['output'];
  /** The item at the end of WebhookSubscriptionEdge. */
  node: WebhookSubscription;
};

/** An endpoint to which webhook subscriptions send webhooks events. */
export type WebhookSubscriptionEndpoint = WebhookEventBridgeEndpoint | WebhookHttpEndpoint | WebhookPubSubEndpoint;

/** The supported formats for webhook subscriptions. */
export enum WebhookSubscriptionFormat {
  Json = 'JSON',
  Xml = 'XML'
}

/** The input fields for a webhook subscription. */
export type WebhookSubscriptionInput = {
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The format in which the webhook subscription should send the data. */
  format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. Only the fields specified will be included in the webhook payload. If null, then all fields will be included. Learn more about [modifying webhook payloads](https://shopify.dev/docs/apps/build/webhooks/customize/modify_payloads). */
  includeFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  metafieldNamespaces?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of identifiers specifying metafields to include in the webhook payload. */
  metafields?: InputMaybe<Array<HasMetafieldsMetafieldIdentifierInput>>;
  /** A human-readable name for the webhook subscription. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URI where the webhook subscription should send events. Supports an HTTPS URL, a Google Pub/Sub URI (pubsub://{project-id}:{topic-id}) or an Amazon EventBridge event source ARN. */
  uri?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Webhook subscriptions let you receive instant notifications when important events happen in a merchant's store, so you can automate workflows and keep your systems in sync without constantly polling for updates.
 *
 * For example, a subscription might monitor `orders/create` events and send JSON payloads to `https://yourapp.com/webhooks/orders` whenever customers place new orders, enabling immediate order processing workflows.
 *
 * Use the `WebhookSubscription` object to:
 * - Monitor active webhook configurations
 * - Access subscription details like topics, endpoints, and filtering rules
 * - Retrieve creation and update timestamps for audit purposes
 * - Review API versions and format settings
 * - Examine metafield namespace configurations for extended data access
 *
 * Each subscription includes comprehensive configuration details such as the specific Shopify events being monitored, the destination endpoint (HTTP, EventBridge, or Pub/Sub), event filtering criteria, and payload customization settings. The subscription tracks its creation and modification history.
 *
 * Subscriptions can include advanced features like Shopify search syntax for event filtering to control
 * which events trigger notifications, specific field inclusion rules to control which fields are included
 * in the webhook payload, and metafield namespace access to capture custom store data. The API version
 * is inherited from the app that created the webhook subscription.
 *
 * The endpoint configuration varies by type - HTTP subscriptions include callback URLs, EventBridge subscriptions reference AWS ARNs, and Pub/Sub subscriptions specify Google Cloud project and topic details. This flexibility allows apps to integrate webhooks with their preferred infrastructure and event processing systems.
 *
 * Learn more about [webhook subscription management](https://shopify.dev/docs/apps/webhooks).
 */
export type WebhookSubscriptionMetafieldIdentifier = {
  __typename?: 'WebhookSubscriptionMetafieldIdentifier';
  /** The unique identifier for the metafield definition within its namespace. */
  key: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  namespace: Scalars['String']['output'];
};

/** The set of valid sort keys for the WebhookSubscription query. */
export enum WebhookSubscriptionSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID'
}

/**
 * The supported topics for webhook subscriptions. You can use webhook subscriptions to receive
 * notifications about particular events in a shop.
 *
 * You create [mandatory webhooks](https://shopify.dev/apps/webhooks/configuration/mandatory-webhooks#mandatory-compliance-webhooks) either via the
 * [Partner Dashboard](https://shopify.dev/apps/webhooks/configuration/mandatory-webhooks#subscribe-to-privacy-webhooks)
 * or by updating the [app configuration file](https://shopify.dev/apps/tools/cli/configuration#app-configuration-file-example).
 *
 * > Tip:
 * >To configure your subscription using the app configuration file, refer to the [full list of topic names](https://shopify.dev/docs/api/webhooks?reference=graphql).
 */
export enum WebhookSubscriptionTopic {
  /** The webhook topic for `app_purchases_one_time/update` events. Occurs whenever a one-time app charge is updated. */
  AppPurchasesOneTimeUpdate = 'APP_PURCHASES_ONE_TIME_UPDATE',
  /** The webhook topic for `app/scopes_update` events. Occurs whenever the access scopes of any installation are modified. Allows apps to keep track of the granted access scopes of their installations. */
  AppScopesUpdate = 'APP_SCOPES_UPDATE',
  /** The webhook topic for `app_subscriptions/approaching_capped_amount` events. Occurs when the balance used on an app subscription crosses 90% of the capped amount. */
  AppSubscriptionsApproachingCappedAmount = 'APP_SUBSCRIPTIONS_APPROACHING_CAPPED_AMOUNT',
  /** The webhook topic for `app_subscriptions/update` events. Occurs whenever an app subscription is updated. */
  AppSubscriptionsUpdate = 'APP_SUBSCRIPTIONS_UPDATE',
  /** The webhook topic for `app/uninstalled` events. Occurs whenever a shop has uninstalled the app. */
  AppUninstalled = 'APP_UNINSTALLED',
  /** The webhook topic for `attributed_sessions/first` events. Occurs whenever an order with a "first" attributed session is attributed. Requires the `read_marketing_events` scope. */
  AttributedSessionsFirst = 'ATTRIBUTED_SESSIONS_FIRST',
  /** The webhook topic for `attributed_sessions/last` events. Occurs whenever an order with a "last" attributed session is attributed. Requires the `read_marketing_events` scope. */
  AttributedSessionsLast = 'ATTRIBUTED_SESSIONS_LAST',
  /** The webhook topic for `audit_events/admin_api_activity` events. Triggers for each auditable Admin API request. This topic is limited to one active subscription per Plus store and requires the use of Google Cloud Pub/Sub or AWS EventBridge. Requires the `read_audit_events` scope. */
  AuditEventsAdminApiActivity = 'AUDIT_EVENTS_ADMIN_API_ACTIVITY',
  /** The webhook topic for `bulk_operations/finish` events. Notifies when a Bulk Operation finishes. */
  BulkOperationsFinish = 'BULK_OPERATIONS_FINISH',
  /** The webhook topic for `carts/create` events. Occurs when a cart is created in the online store. Other types of carts aren't supported. For example, the webhook doesn't support carts that are created in a custom storefront. Requires the `read_orders` scope. */
  CartsCreate = 'CARTS_CREATE',
  /** The webhook topic for `carts/update` events. Occurs when a cart is updated in the online store. Other types of carts aren't supported. For example, the webhook doesn't support carts that are updated in a custom storefront. Requires the `read_orders` scope. */
  CartsUpdate = 'CARTS_UPDATE',
  /** The webhook topic for `channels/delete` events. Occurs whenever a channel is deleted. Requires the `read_publications` scope. */
  ChannelsDelete = 'CHANNELS_DELETE',
  /** The webhook topic for `checkouts/create` events. Occurs whenever a checkout is created. Requires the `read_orders` scope. */
  CheckoutsCreate = 'CHECKOUTS_CREATE',
  /** The webhook topic for `checkouts/delete` events. Occurs whenever a checkout is deleted. Requires the `read_orders` scope. */
  CheckoutsDelete = 'CHECKOUTS_DELETE',
  /** The webhook topic for `checkouts/update` events. Occurs whenever a checkout is updated. Requires the `read_orders` scope. */
  CheckoutsUpdate = 'CHECKOUTS_UPDATE',
  /** The webhook topic for `checkout_and_accounts_configurations/update` events. The event occurs whenever a published checkout and account configuration is updated. */
  CheckoutAndAccountsConfigurationsUpdate = 'CHECKOUT_AND_ACCOUNTS_CONFIGURATIONS_UPDATE',
  /** The webhook topic for `collections/create` events. Occurs whenever a collection is created. Requires the `read_products` scope. */
  CollectionsCreate = 'COLLECTIONS_CREATE',
  /** The webhook topic for `collections/delete` events. Occurs whenever a collection is deleted. Requires the `read_products` scope. */
  CollectionsDelete = 'COLLECTIONS_DELETE',
  /** The webhook topic for `collections/update` events. Occurs whenever a collection is updated, including when a product is manually added or removed from the collection or when the collection rules change. Occurs once if multiple products are manually added or removed from a collection at the same time. Not fired when attribute changes affect whether a product matches a collection's rules. Requires the `read_products` scope. */
  CollectionsUpdate = 'COLLECTIONS_UPDATE',
  /** The webhook topic for `collection_listings/add` events. Occurs whenever a collection listing is added. Requires the `read_product_listings` scope. */
  CollectionListingsAdd = 'COLLECTION_LISTINGS_ADD',
  /** The webhook topic for `collection_listings/remove` events. Occurs whenever a collection listing is removed. Requires the `read_product_listings` scope. */
  CollectionListingsRemove = 'COLLECTION_LISTINGS_REMOVE',
  /** The webhook topic for `collection_listings/update` events. Occurs whenever a collection listing is updated. Requires the `read_product_listings` scope. */
  CollectionListingsUpdate = 'COLLECTION_LISTINGS_UPDATE',
  /** The webhook topic for `collection_publications/create` events. Occurs whenever a collection publication listing is created. Requires the `read_publications` scope. */
  CollectionPublicationsCreate = 'COLLECTION_PUBLICATIONS_CREATE',
  /** The webhook topic for `collection_publications/delete` events. Occurs whenever a collection publication listing is deleted. Requires the `read_publications` scope. */
  CollectionPublicationsDelete = 'COLLECTION_PUBLICATIONS_DELETE',
  /** The webhook topic for `collection_publications/update` events. Occurs whenever a collection publication listing is updated. Requires the `read_publications` scope. */
  CollectionPublicationsUpdate = 'COLLECTION_PUBLICATIONS_UPDATE',
  /** The webhook topic for `companies/create` events. Occurs whenever a company is created. Requires at least one of the following scopes: read_customers, read_companies. */
  CompaniesCreate = 'COMPANIES_CREATE',
  /** The webhook topic for `companies/delete` events. Occurs whenever a company is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  CompaniesDelete = 'COMPANIES_DELETE',
  /** The webhook topic for `companies/update` events. Occurs whenever a company is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  CompaniesUpdate = 'COMPANIES_UPDATE',
  /** The webhook topic for `company_contacts/create` events. Occurs whenever a company contact is created. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyContactsCreate = 'COMPANY_CONTACTS_CREATE',
  /** The webhook topic for `company_contacts/delete` events. Occurs whenever a company contact is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyContactsDelete = 'COMPANY_CONTACTS_DELETE',
  /** The webhook topic for `company_contacts/update` events. Occurs whenever a company contact is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyContactsUpdate = 'COMPANY_CONTACTS_UPDATE',
  /** The webhook topic for `company_contact_roles/assign` events. Occurs whenever a role is assigned to a contact at a location. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyContactRolesAssign = 'COMPANY_CONTACT_ROLES_ASSIGN',
  /** The webhook topic for `company_contact_roles/revoke` events. Occurs whenever a role is revoked from a contact at a location. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyContactRolesRevoke = 'COMPANY_CONTACT_ROLES_REVOKE',
  /** The webhook topic for `company_locations/create` events. Occurs whenever a company location is created. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyLocationsCreate = 'COMPANY_LOCATIONS_CREATE',
  /** The webhook topic for `company_locations/delete` events. Occurs whenever a company location is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyLocationsDelete = 'COMPANY_LOCATIONS_DELETE',
  /** The webhook topic for `company_locations/update` events. Occurs whenever a company location is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  CompanyLocationsUpdate = 'COMPANY_LOCATIONS_UPDATE',
  /** The webhook topic for `customers/create` events. Occurs whenever a customer is created. Requires the `read_customers` scope. */
  CustomersCreate = 'CUSTOMERS_CREATE',
  /** The webhook topic for `customers/delete` events. Occurs whenever a customer is deleted. Requires the `read_customers` scope. */
  CustomersDelete = 'CUSTOMERS_DELETE',
  /** The webhook topic for `customers/disable` events. Occurs whenever a customer account is disabled. Requires the `read_customers` scope. */
  CustomersDisable = 'CUSTOMERS_DISABLE',
  /** The webhook topic for `customers_email_marketing_consent/update` events. Occurs whenever a customer's email marketing consent is updated. Requires the `read_customers` scope. */
  CustomersEmailMarketingConsentUpdate = 'CUSTOMERS_EMAIL_MARKETING_CONSENT_UPDATE',
  /** The webhook topic for `customers/enable` events. Occurs whenever a customer account is enabled. Requires the `read_customers` scope. */
  CustomersEnable = 'CUSTOMERS_ENABLE',
  /** The webhook topic for `customers_marketing_consent/update` events. Occurs whenever a customer's SMS marketing consent is updated. Requires the `read_customers` scope. */
  CustomersMarketingConsentUpdate = 'CUSTOMERS_MARKETING_CONSENT_UPDATE',
  /** The webhook topic for `customers/merge` events. Triggers when two customers are merged Requires the `read_customer_merge` scope. */
  CustomersMerge = 'CUSTOMERS_MERGE',
  /** The webhook topic for `customers/purchasing_summary` events. Occurs when a customer sales history change. Requires the `read_customers` scope. */
  CustomersPurchasingSummary = 'CUSTOMERS_PURCHASING_SUMMARY',
  /** The webhook topic for `customers/update` events. Occurs whenever a customer is updated. Requires the `read_customers` scope. */
  CustomersUpdate = 'CUSTOMERS_UPDATE',
  /** The webhook topic for `customers_whats_app_marketing_consent/update` events. Occurs whenever a customer's WhatsApp marketing consent is updated. Requires the `read_customers` scope. */
  CustomersWhatsAppMarketingConsentUpdate = 'CUSTOMERS_WHATS_APP_MARKETING_CONSENT_UPDATE',
  /** The webhook topic for `customer_account_settings/update` events. Triggers when merchants change customer account setting. */
  CustomerAccountSettingsUpdate = 'CUSTOMER_ACCOUNT_SETTINGS_UPDATE',
  /** The webhook topic for `customer_groups/create` events. Occurs whenever a customer saved search is created. Requires the `read_customers` scope. */
  CustomerGroupsCreate = 'CUSTOMER_GROUPS_CREATE',
  /** The webhook topic for `customer_groups/delete` events. Occurs whenever a customer saved search is deleted. Requires the `read_customers` scope. */
  CustomerGroupsDelete = 'CUSTOMER_GROUPS_DELETE',
  /** The webhook topic for `customer_groups/update` events. Occurs whenever a customer saved search is updated. Requires the `read_customers` scope. */
  CustomerGroupsUpdate = 'CUSTOMER_GROUPS_UPDATE',
  /** The webhook topic for `customer.joined_segment` events. Triggers when a customer joins a segment. Requires the `read_customers` scope. */
  CustomerJoinedSegment = 'CUSTOMER_JOINED_SEGMENT',
  /** The webhook topic for `customer.left_segment` events. Triggers when a customer leaves a segment. Requires the `read_customers` scope. */
  CustomerLeftSegment = 'CUSTOMER_LEFT_SEGMENT',
  /** The webhook topic for `customer_payment_methods/create` events. Occurs whenever a customer payment method is created. Requires the `read_customer_payment_methods` scope. */
  CustomerPaymentMethodsCreate = 'CUSTOMER_PAYMENT_METHODS_CREATE',
  /** The webhook topic for `customer_payment_methods/revoke` events. Occurs whenever a customer payment method is revoked. Requires the `read_customer_payment_methods` scope. */
  CustomerPaymentMethodsRevoke = 'CUSTOMER_PAYMENT_METHODS_REVOKE',
  /** The webhook topic for `customer_payment_methods/update` events. Occurs whenever a customer payment method is updated. Requires the `read_customer_payment_methods` scope. */
  CustomerPaymentMethodsUpdate = 'CUSTOMER_PAYMENT_METHODS_UPDATE',
  /** The webhook topic for `customer.tags_added` events. Triggers when tags are added to a customer. Requires the `read_customers` scope. */
  CustomerTagsAdded = 'CUSTOMER_TAGS_ADDED',
  /** The webhook topic for `customer.tags_removed` events. Triggers when tags are removed from a customer. Requires the `read_customers` scope. */
  CustomerTagsRemoved = 'CUSTOMER_TAGS_REMOVED',
  /** The webhook topic for `delivery_promise_settings/update` events. Occurs when a promise setting is updated. Requires the `read_shipping` scope. */
  DeliveryPromiseSettingsUpdate = 'DELIVERY_PROMISE_SETTINGS_UPDATE',
  /** The webhook topic for `discounts/create` events. Occurs whenever a discount is created. Requires the `read_discounts` scope. */
  DiscountsCreate = 'DISCOUNTS_CREATE',
  /** The webhook topic for `discounts/delete` events. Occurs whenever a discount is deleted. Requires the `read_discounts` scope. */
  DiscountsDelete = 'DISCOUNTS_DELETE',
  /** The webhook topic for `discounts/redeemcode_added` events. Occurs whenever a redeem code is added to a code discount. Requires the `read_discounts` scope. */
  DiscountsRedeemcodeAdded = 'DISCOUNTS_REDEEMCODE_ADDED',
  /** The webhook topic for `discounts/redeemcode_removed` events. Occurs whenever a redeem code on a code discount is deleted. Requires the `read_discounts` scope. */
  DiscountsRedeemcodeRemoved = 'DISCOUNTS_REDEEMCODE_REMOVED',
  /** The webhook topic for `discounts/update` events. Occurs whenever a discount is updated. Requires the `read_discounts` scope. */
  DiscountsUpdate = 'DISCOUNTS_UPDATE',
  /** The webhook topic for `disputes/create` events. Occurs whenever a dispute is created. Requires the `read_shopify_payments_disputes` scope. */
  DisputesCreate = 'DISPUTES_CREATE',
  /** The webhook topic for `disputes/update` events. Occurs whenever a dispute is updated. Requires the `read_shopify_payments_disputes` scope. */
  DisputesUpdate = 'DISPUTES_UPDATE',
  /** The webhook topic for `domains/create` events. Occurs whenever a domain is created. */
  DomainsCreate = 'DOMAINS_CREATE',
  /** The webhook topic for `domains/destroy` events. Occurs whenever a domain is destroyed. */
  DomainsDestroy = 'DOMAINS_DESTROY',
  /** The webhook topic for `domains/update` events. Occurs whenever a domain is updated. */
  DomainsUpdate = 'DOMAINS_UPDATE',
  /** The webhook topic for `draft_orders/create` events. Occurs whenever a draft order is created. Requires the `read_draft_orders` scope. */
  DraftOrdersCreate = 'DRAFT_ORDERS_CREATE',
  /** The webhook topic for `draft_orders/delete` events. Occurs whenever a draft order is deleted. Requires the `read_draft_orders` scope. */
  DraftOrdersDelete = 'DRAFT_ORDERS_DELETE',
  /** The webhook topic for `draft_orders/update` events. Occurs whenever a draft order is updated. Requires the `read_draft_orders` scope. */
  DraftOrdersUpdate = 'DRAFT_ORDERS_UPDATE',
  /** The webhook topic for `finance_app_staff_member/delete` events. Triggers when a staff with access to all or some finance app has been removed. Requires the `read_financial_kyc_information` scope. */
  FinanceAppStaffMemberDelete = 'FINANCE_APP_STAFF_MEMBER_DELETE',
  /** The webhook topic for `finance_app_staff_member/grant` events. Triggers when a staff is granted access to all or some finance app. Requires the `read_financial_kyc_information` scope. */
  FinanceAppStaffMemberGrant = 'FINANCE_APP_STAFF_MEMBER_GRANT',
  /** The webhook topic for `finance_app_staff_member/revoke` events. Triggers when a staff's access to all or some finance app has been revoked. Requires the `read_financial_kyc_information` scope. */
  FinanceAppStaffMemberRevoke = 'FINANCE_APP_STAFF_MEMBER_REVOKE',
  /** The webhook topic for `finance_app_staff_member/update` events. Triggers when a staff's information has been updated. Requires the `read_financial_kyc_information` scope. */
  FinanceAppStaffMemberUpdate = 'FINANCE_APP_STAFF_MEMBER_UPDATE',
  /** The webhook topic for `finance_kyc_information/update` events. Occurs whenever shop's finance KYC information was updated Requires the `read_financial_kyc_information` scope. */
  FinanceKycInformationUpdate = 'FINANCE_KYC_INFORMATION_UPDATE',
  /** The webhook topic for `fulfillments/create` events. Occurs whenever a fulfillment is created. Requires at least one of the following scopes: read_fulfillments, read_marketplace_orders. */
  FulfillmentsCreate = 'FULFILLMENTS_CREATE',
  /** The webhook topic for `fulfillments/update` events. Occurs whenever a fulfillment is updated. Requires at least one of the following scopes: read_fulfillments, read_marketplace_orders. */
  FulfillmentsUpdate = 'FULFILLMENTS_UPDATE',
  /** The webhook topic for `fulfillment_events/create` events. Occurs whenever a fulfillment event is created. Requires the `read_fulfillments` scope. */
  FulfillmentEventsCreate = 'FULFILLMENT_EVENTS_CREATE',
  /** The webhook topic for `fulfillment_events/delete` events. Occurs whenever a fulfillment event is deleted. Requires the `read_fulfillments` scope. */
  FulfillmentEventsDelete = 'FULFILLMENT_EVENTS_DELETE',
  /**
   * The webhook topic for `fulfillment_holds/added` events. Occurs each time that a hold is added to a fulfillment order.
   *
   * For cases where multiple holds are applied to a fulfillment order, this webhook will trigger after each hold is applied.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentHoldsAdded = 'FULFILLMENT_HOLDS_ADDED',
  /**
   * The webhook topic for `fulfillment_holds/released` events. Occurs each time that a hold is released from a fulfillment order.
   * For cases where multiple holds are released from a fulfillment order a the same time, this webhook will trigger for each released hold.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentHoldsReleased = 'FULFILLMENT_HOLDS_RELEASED',
  /** The webhook topic for `fulfillment_orders/cancellation_request_accepted` events. Occurs when a 3PL accepts a fulfillment cancellation request, received from a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersCancellationRequestAccepted = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_ACCEPTED',
  /** The webhook topic for `fulfillment_orders/cancellation_request_rejected` events. Occurs when a 3PL rejects a fulfillment cancellation request, received from a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersCancellationRequestRejected = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_REJECTED',
  /** The webhook topic for `fulfillment_orders/cancellation_request_submitted` events. Occurs when a merchant requests a fulfillment request to be cancelled after that request was approved by a 3PL. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersCancellationRequestSubmitted = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_SUBMITTED',
  /** The webhook topic for `fulfillment_orders/cancelled` events. Occurs when a fulfillment order is cancelled. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersCancelled = 'FULFILLMENT_ORDERS_CANCELLED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_accepted` events. Occurs when a fulfillment service accepts a request to fulfill a fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersFulfillmentRequestAccepted = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_ACCEPTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_rejected` events. Occurs when a 3PL rejects a fulfillment request that was sent by a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersFulfillmentRequestRejected = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_REJECTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_submitted` events. Occurs when a merchant submits a fulfillment request to a 3PL. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersFulfillmentRequestSubmitted = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_SUBMITTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_service_failed_to_complete` events. Occurs when a fulfillment service intends to close an in_progress fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersFulfillmentServiceFailedToComplete = 'FULFILLMENT_ORDERS_FULFILLMENT_SERVICE_FAILED_TO_COMPLETE',
  /**
   * The webhook topic for `fulfillment_orders/hold_released` events. Occurs when a fulfillment order is released and is no longer on hold.
   *
   * If a fulfillment order has multiple holds then this webhook will only be triggered once when the last hold is released and the status of the fulfillment order is no longer `ON_HOLD`.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentOrdersHoldReleased = 'FULFILLMENT_ORDERS_HOLD_RELEASED',
  /** The webhook topic for `fulfillment_orders/line_items_prepared_for_local_delivery` events. Occurs whenever a fulfillment order's line items are prepared for local delivery. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersLineItemsPreparedForLocalDelivery = 'FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_LOCAL_DELIVERY',
  /** The webhook topic for `fulfillment_orders/line_items_prepared_for_pickup` events. Triggers when one or more of the line items for a fulfillment order are prepared for pickup Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersLineItemsPreparedForPickup = 'FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_PICKUP',
  /** The webhook topic for `fulfillment_orders/manually_reported_progress_stopped` events. Occurs when a fulfillment order that has previously been manually marked as in progress is marked back as open. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FulfillmentOrdersManuallyReportedProgressStopped = 'FULFILLMENT_ORDERS_MANUALLY_REPORTED_PROGRESS_STOPPED',
  /** The webhook topic for `fulfillment_orders/merged` events. Occurs when multiple fulfillment orders are merged into a single fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FulfillmentOrdersMerged = 'FULFILLMENT_ORDERS_MERGED',
  /**
   * The webhook topic for `fulfillment_orders/moved` events. Occurs whenever the location which is assigned to fulfill one or more fulfillment order line items is changed.
   *
   * * `original_fulfillment_order` - The final state of the original fulfillment order.
   * * `moved_fulfillment_order` - The fulfillment order which now contains the re-assigned line items.
   * * `source_location` - The original location which was assigned to fulfill the line items (available as of the `2023-04` API version).
   * * `destination_location_id` - The ID of the location which is now responsible for fulfilling the line items.
   *
   * **Note:** The [assignedLocation](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentorder#field-fulfillmentorder-assignedlocation)
   * of the `original_fulfillment_order` might be changed by the move operation.
   * If you need to determine the originally assigned location, then you should refer to the `source_location`.
   *
   * [Learn more about moving line items](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentOrderMove).
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentOrdersMoved = 'FULFILLMENT_ORDERS_MOVED',
  /** The webhook topic for `fulfillment_orders/order_routing_complete` events. Occurs when an order has finished being routed and it's fulfillment orders assigned to a fulfillment service's location. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_buyer_membership_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersOrderRoutingComplete = 'FULFILLMENT_ORDERS_ORDER_ROUTING_COMPLETE',
  /**
   * The webhook topic for `fulfillment_orders/placed_on_hold` events. Occurs when a fulfillment order transitions to the `ON_HOLD` status
   *
   * For cases where multiple holds are applied to a fulfillment order, this webhook will only trigger once when the first hold is applied and the fulfillment order status changes to `ON_HOLD`.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentOrdersPlacedOnHold = 'FULFILLMENT_ORDERS_PLACED_ON_HOLD',
  /** The webhook topic for `fulfillment_orders/progress_reported` events. Occurs when progress is reported for a fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FulfillmentOrdersProgressReported = 'FULFILLMENT_ORDERS_PROGRESS_REPORTED',
  /**
   * The webhook topic for `fulfillment_orders/rescheduled` events. Triggers when a fulfillment order is rescheduled.
   *
   * Fulfillment orders may be merged if they have the same `fulfillAt` datetime.
   * If the fulfillment order is merged then the resulting fulfillment order will be indicated in the webhook body.
   * Otherwise it will be the original fulfillment order with an updated `fulfill_at` datetime.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FulfillmentOrdersRescheduled = 'FULFILLMENT_ORDERS_RESCHEDULED',
  /** The webhook topic for `fulfillment_orders/scheduled_fulfillment_order_ready` events. Occurs whenever a fulfillment order which was scheduled becomes due. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FulfillmentOrdersScheduledFulfillmentOrderReady = 'FULFILLMENT_ORDERS_SCHEDULED_FULFILLMENT_ORDER_READY',
  /** The webhook topic for `fulfillment_orders/split` events. Occurs when a fulfillment order is split into multiple fulfillment orders. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FulfillmentOrdersSplit = 'FULFILLMENT_ORDERS_SPLIT',
  /** The webhook topic for `inventory_items/create` events. Occurs whenever an inventory item is created. Requires at least one of the following scopes: read_inventory, read_products. */
  InventoryItemsCreate = 'INVENTORY_ITEMS_CREATE',
  /** The webhook topic for `inventory_items/delete` events. Occurs whenever an inventory item is deleted. Requires at least one of the following scopes: read_inventory, read_products. */
  InventoryItemsDelete = 'INVENTORY_ITEMS_DELETE',
  /** The webhook topic for `inventory_items/update` events. Occurs whenever an inventory item is updated. Requires at least one of the following scopes: read_inventory, read_products. */
  InventoryItemsUpdate = 'INVENTORY_ITEMS_UPDATE',
  /** The webhook topic for `inventory_levels/connect` events. Occurs whenever an inventory level is connected. Requires the `read_inventory` scope. */
  InventoryLevelsConnect = 'INVENTORY_LEVELS_CONNECT',
  /** The webhook topic for `inventory_levels/disconnect` events. Occurs whenever an inventory level is disconnected. Requires the `read_inventory` scope. */
  InventoryLevelsDisconnect = 'INVENTORY_LEVELS_DISCONNECT',
  /** The webhook topic for `inventory_levels/update` events. Occurs whenever an inventory level is updated. Requires the `read_inventory` scope. */
  InventoryLevelsUpdate = 'INVENTORY_LEVELS_UPDATE',
  /** The webhook topic for `inventory_shipments/add_items` events. Occurs whenever items are added to a shipment. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsAddItems = 'INVENTORY_SHIPMENTS_ADD_ITEMS',
  /** The webhook topic for `inventory_shipments/create` events. Triggers when a shipment is created. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsCreate = 'INVENTORY_SHIPMENTS_CREATE',
  /** The webhook topic for `inventory_shipments/delete` events. Triggers when a shipment is deleted. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsDelete = 'INVENTORY_SHIPMENTS_DELETE',
  /** The webhook topic for `inventory_shipments/mark_in_transit` events. Triggers when a shipment is marked as in transit. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsMarkInTransit = 'INVENTORY_SHIPMENTS_MARK_IN_TRANSIT',
  /** The webhook topic for `inventory_shipments/receive_items` events. Triggers when items on a shipment are received. Requires the `read_inventory_shipments_received_items` scope. */
  InventoryShipmentsReceiveItems = 'INVENTORY_SHIPMENTS_RECEIVE_ITEMS',
  /** The webhook topic for `inventory_shipments/remove_items` events. Occurs whenever items are removed from a shipment. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsRemoveItems = 'INVENTORY_SHIPMENTS_REMOVE_ITEMS',
  /** The webhook topic for `inventory_shipments/update_item_quantities` events. Occurs whenever quantities change on a shipment. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsUpdateItemQuantities = 'INVENTORY_SHIPMENTS_UPDATE_ITEM_QUANTITIES',
  /** The webhook topic for `inventory_shipments/update_tracking` events. Triggers when tracking info on a shipment is updated. Requires the `read_inventory_shipments` scope. */
  InventoryShipmentsUpdateTracking = 'INVENTORY_SHIPMENTS_UPDATE_TRACKING',
  /** The webhook topic for `inventory_transfers/add_items` events. Occurs any time items are added to a transfer. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersAddItems = 'INVENTORY_TRANSFERS_ADD_ITEMS',
  /** The webhook topic for `inventory_transfers/cancel` events. Triggers when a transfer is canceled. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersCancel = 'INVENTORY_TRANSFERS_CANCEL',
  /** The webhook topic for `inventory_transfers/complete` events. Triggers when a transfer is completed. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersComplete = 'INVENTORY_TRANSFERS_COMPLETE',
  /** The webhook topic for `inventory_transfers/ready_to_ship` events. Triggers when a transfer is marked as ready to ship. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersReadyToShip = 'INVENTORY_TRANSFERS_READY_TO_SHIP',
  /** The webhook topic for `inventory_transfers/remove_items` events. Occurs any time items are removed from a transfer. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersRemoveItems = 'INVENTORY_TRANSFERS_REMOVE_ITEMS',
  /** The webhook topic for `inventory_transfers/updated` events. Triggers when a shipment belonging to the transfer is created, edited, or removed. Re-fetch the transfer to get the latest state. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersUpdated = 'INVENTORY_TRANSFERS_UPDATED',
  /** The webhook topic for `inventory_transfers/update_item_quantities` events. Occurs whenever the quantity of transfer line items changes. Requires the `read_inventory_transfers` scope. */
  InventoryTransfersUpdateItemQuantities = 'INVENTORY_TRANSFERS_UPDATE_ITEM_QUANTITIES',
  /** The webhook topic for `locales/create` events. Occurs whenever a shop locale is created Requires the `read_locales` scope. */
  LocalesCreate = 'LOCALES_CREATE',
  /** The webhook topic for `locales/destroy` events. Occurs whenever a shop locale is destroyed Requires the `read_locales` scope. */
  LocalesDestroy = 'LOCALES_DESTROY',
  /** The webhook topic for `locales/update` events. Occurs whenever a shop locale is updated, such as published or unpublished Requires the `read_locales` scope. */
  LocalesUpdate = 'LOCALES_UPDATE',
  /** The webhook topic for `locations/activate` events. Occurs whenever a deactivated location is re-activated. Requires the `read_locations` scope. */
  LocationsActivate = 'LOCATIONS_ACTIVATE',
  /** The webhook topic for `locations/create` events. Occurs whenever a location is created. Requires the `read_locations` scope. */
  LocationsCreate = 'LOCATIONS_CREATE',
  /** The webhook topic for `locations/deactivate` events. Occurs whenever a location is deactivated. Requires the `read_locations` scope. */
  LocationsDeactivate = 'LOCATIONS_DEACTIVATE',
  /** The webhook topic for `locations/delete` events. Occurs whenever a location is deleted. Requires the `read_locations` scope. */
  LocationsDelete = 'LOCATIONS_DELETE',
  /** The webhook topic for `locations/update` events. Occurs whenever a location is updated. Requires the `read_locations` scope. */
  LocationsUpdate = 'LOCATIONS_UPDATE',
  /** The webhook topic for `machine_translation_batch/completed` events. Occurs when a whole-shop machine translation batch completes. */
  MachineTranslationBatchCompleted = 'MACHINE_TRANSLATION_BATCH_COMPLETED',
  /** The webhook topic for `markets_backup_region/update` events. Occurs when a backup region is updated. Requires the `read_markets` scope. */
  MarketsBackupRegionUpdate = 'MARKETS_BACKUP_REGION_UPDATE',
  /** The webhook topic for `markets/create` events. Occurs when a new market is created. Requires the `read_markets` scope. */
  MarketsCreate = 'MARKETS_CREATE',
  /** The webhook topic for `markets/delete` events. Occurs when a market is deleted. Requires the `read_markets` scope. */
  MarketsDelete = 'MARKETS_DELETE',
  /** The webhook topic for `markets/update` events. Occurs when a market is updated. Requires the `read_markets` scope. */
  MarketsUpdate = 'MARKETS_UPDATE',
  /** The webhook topic for `metafield_definitions/create` events. Occurs when a metafield definition is created. Requires the `read_content` scope. */
  MetafieldDefinitionsCreate = 'METAFIELD_DEFINITIONS_CREATE',
  /** The webhook topic for `metafield_definitions/delete` events. Occurs when a metafield definition is deleted. Requires the `read_content` scope. */
  MetafieldDefinitionsDelete = 'METAFIELD_DEFINITIONS_DELETE',
  /** The webhook topic for `metafield_definitions/update` events. Occurs when a metafield definition is updated. Requires the `read_content` scope. */
  MetafieldDefinitionsUpdate = 'METAFIELD_DEFINITIONS_UPDATE',
  /** The webhook topic for `metaobjects/create` events. Occurs when a metaobject is created. Requires the `read_metaobjects` scope. */
  MetaobjectsCreate = 'METAOBJECTS_CREATE',
  /** The webhook topic for `metaobjects/delete` events. Occurs when a metaobject is deleted. Requires the `read_metaobjects` scope. */
  MetaobjectsDelete = 'METAOBJECTS_DELETE',
  /** The webhook topic for `metaobjects/update` events. Occurs when a metaobject is updated. Requires the `read_metaobjects` scope. */
  MetaobjectsUpdate = 'METAOBJECTS_UPDATE',
  /** The webhook topic for `orders/cancelled` events. Occurs whenever an order is cancelled. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  OrdersCancelled = 'ORDERS_CANCELLED',
  /** The webhook topic for `orders/create` events. Occurs whenever an order is created. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  OrdersCreate = 'ORDERS_CREATE',
  /** The webhook topic for `orders/delete` events. Occurs whenever an order is deleted. Requires the `read_orders` scope. */
  OrdersDelete = 'ORDERS_DELETE',
  /** The webhook topic for `orders/edited` events. Occurs whenever an order is edited. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  OrdersEdited = 'ORDERS_EDITED',
  /** The webhook topic for `orders/fulfilled` events. Occurs whenever an order is fulfilled. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  OrdersFulfilled = 'ORDERS_FULFILLED',
  /** The webhook topic for `orders/link_requested` events. Occurs whenever a customer requests a new order link from the expired order status page. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  OrdersLinkRequested = 'ORDERS_LINK_REQUESTED',
  /** The webhook topic for `orders/paid` events. Occurs whenever an order is paid. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  OrdersPaid = 'ORDERS_PAID',
  /** The webhook topic for `orders/partially_fulfilled` events. Occurs whenever an order is partially fulfilled. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  OrdersPartiallyFulfilled = 'ORDERS_PARTIALLY_FULFILLED',
  /**
   * The webhook topic for `orders/risk_assessment_changed` events. Triggers when a new risk assessment is available on the order.
   * This can be the first or a subsequent risk assessment.
   * New risk assessments can be provided until the order is marked as fulfilled.
   * Includes the risk level, risk facts, the provider and the order ID.
   * When the provider is Shopify, that field is null.
   * Does not include the risk recommendation for the order.
   * The Shop ID is available in the headers.
   *  Requires the `read_orders` scope.
   */
  OrdersRiskAssessmentChanged = 'ORDERS_RISK_ASSESSMENT_CHANGED',
  /** The webhook topic for `orders/shopify_protect_eligibility_changed` events. Occurs whenever Shopify Protect's eligibility for an order is changed. Requires the `read_orders` scope. */
  OrdersShopifyProtectEligibilityChanged = 'ORDERS_SHOPIFY_PROTECT_ELIGIBILITY_CHANGED',
  /** The webhook topic for `orders/updated` events. Occurs whenever an order is updated. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  OrdersUpdated = 'ORDERS_UPDATED',
  /** The webhook topic for `order_transactions/create` events. Occurs when a order transaction is created or when it's status is updated. Only occurs for transactions with a status of success, failure or error. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  OrderTransactionsCreate = 'ORDER_TRANSACTIONS_CREATE',
  /** The webhook topic for `payment_schedules/due` events. Occurs whenever payment schedules are due. Requires the `read_payment_terms` scope. */
  PaymentSchedulesDue = 'PAYMENT_SCHEDULES_DUE',
  /** The webhook topic for `payment_terms/create` events. Occurs whenever payment terms are created. Requires the `read_payment_terms` scope. */
  PaymentTermsCreate = 'PAYMENT_TERMS_CREATE',
  /** The webhook topic for `payment_terms/delete` events. Occurs whenever payment terms are deleted. Requires the `read_payment_terms` scope. */
  PaymentTermsDelete = 'PAYMENT_TERMS_DELETE',
  /** The webhook topic for `payment_terms/update` events. Occurs whenever payment terms are updated. Requires the `read_payment_terms` scope. */
  PaymentTermsUpdate = 'PAYMENT_TERMS_UPDATE',
  /** The webhook topic for `products/create` events. Occurs whenever a product is created. Requires the `read_products` scope. */
  ProductsCreate = 'PRODUCTS_CREATE',
  /** The webhook topic for `products/delete` events. Occurs whenever a product is deleted. Requires the `read_products` scope. */
  ProductsDelete = 'PRODUCTS_DELETE',
  /** The webhook topic for `products/update` events. Occurs whenever a product is updated, ordered, or variants are added, removed or updated. Requires the `read_products` scope. */
  ProductsUpdate = 'PRODUCTS_UPDATE',
  /** The webhook topic for `product_feeds/create` events. Triggers when product feed is created Requires the `read_product_listings` scope. */
  ProductFeedsCreate = 'PRODUCT_FEEDS_CREATE',
  /** The webhook topic for `product_feeds/full_sync` events. Triggers when a full sync for a product feed is performed Requires the `read_product_listings` scope. */
  ProductFeedsFullSync = 'PRODUCT_FEEDS_FULL_SYNC',
  /** The webhook topic for `product_feeds/full_sync_finish` events. Triggers when a full sync finishes Requires the `read_product_listings` scope. */
  ProductFeedsFullSyncFinish = 'PRODUCT_FEEDS_FULL_SYNC_FINISH',
  /** The webhook topic for `product_feeds/incremental_sync` events. Occurs whenever a product publication is created, updated or removed for a product feed Requires the `read_product_listings` scope. */
  ProductFeedsIncrementalSync = 'PRODUCT_FEEDS_INCREMENTAL_SYNC',
  /** The webhook topic for `product_feeds/update` events. Triggers when product feed is updated Requires the `read_product_listings` scope. */
  ProductFeedsUpdate = 'PRODUCT_FEEDS_UPDATE',
  /** The webhook topic for `product_listings/add` events. Occurs whenever an active product is listed on a channel. Requires the `read_product_listings` scope. */
  ProductListingsAdd = 'PRODUCT_LISTINGS_ADD',
  /** The webhook topic for `product_listings/remove` events. Occurs whenever a product listing is removed from the channel. Requires the `read_product_listings` scope. */
  ProductListingsRemove = 'PRODUCT_LISTINGS_REMOVE',
  /** The webhook topic for `product_listings/update` events. Occurs whenever a product publication is updated. Requires the `read_product_listings` scope. */
  ProductListingsUpdate = 'PRODUCT_LISTINGS_UPDATE',
  /** The webhook topic for `product_publications/create` events. Occurs whenever a product publication for an active product is created, or whenever an existing product publication is published on the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  ProductPublicationsCreate = 'PRODUCT_PUBLICATIONS_CREATE',
  /** The webhook topic for `product_publications/delete` events. Occurs whenever a product publication for an active product is removed, or whenever an existing product publication is unpublished from the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  ProductPublicationsDelete = 'PRODUCT_PUBLICATIONS_DELETE',
  /** The webhook topic for `product_publications/update` events. Occurs whenever a product publication is updated from the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  ProductPublicationsUpdate = 'PRODUCT_PUBLICATIONS_UPDATE',
  /** The webhook topic for `profiles/create` events. Occurs whenever a delivery profile is created Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  ProfilesCreate = 'PROFILES_CREATE',
  /** The webhook topic for `profiles/delete` events. Occurs whenever a delivery profile is deleted Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  ProfilesDelete = 'PROFILES_DELETE',
  /** The webhook topic for `profiles/update` events. Occurs whenever a delivery profile is updated Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  ProfilesUpdate = 'PROFILES_UPDATE',
  /** The webhook topic for `publications/delete` events. Occurs whenever a publication is deleted. Requires the `read_publications` scope. */
  PublicationsDelete = 'PUBLICATIONS_DELETE',
  /** The webhook topic for `refunds/create` events. Occurs whenever a new refund is created without errors on an order, independent from the movement of money. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  RefundsCreate = 'REFUNDS_CREATE',
  /** The webhook topic for `returns/approve` events. Occurs whenever a return is approved. This means `Return.status` is `OPEN`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsApprove = 'RETURNS_APPROVE',
  /** The webhook topic for `returns/cancel` events. Occurs whenever a return is canceled. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsCancel = 'RETURNS_CANCEL',
  /** The webhook topic for `returns/close` events. Occurs whenever a return is closed. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsClose = 'RETURNS_CLOSE',
  /** The webhook topic for `returns/decline` events. Occurs whenever a return is declined. This means `Return.status` is `DECLINED`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsDecline = 'RETURNS_DECLINE',
  /** The webhook topic for `returns/process` events. Occurs whenever a return is processed. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsProcess = 'RETURNS_PROCESS',
  /** The webhook topic for `returns/reopen` events. Occurs whenever a closed return is reopened. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsReopen = 'RETURNS_REOPEN',
  /** The webhook topic for `returns/request` events. Occurs whenever a return is requested. This means `Return.status` is `REQUESTED`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsRequest = 'RETURNS_REQUEST',
  /** The webhook topic for `returns/update` events. Occurs whenever a return is updated. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  ReturnsUpdate = 'RETURNS_UPDATE',
  /**
   * The webhook topic for `reverse_deliveries/attach_deliverable` events. Occurs whenever a deliverable is attached to a reverse delivery.
   * This occurs when a reverse delivery is created or updated with delivery metadata.
   * Metadata includes the delivery method, label, and tracking information associated with a reverse delivery.
   *  Requires at least one of the following scopes: read_returns, read_marketplace_returns.
   */
  ReverseDeliveriesAttachDeliverable = 'REVERSE_DELIVERIES_ATTACH_DELIVERABLE',
  /**
   * The webhook topic for `reverse_fulfillment_orders/dispose` events. Occurs whenever a disposition is made on a reverse fulfillment order.
   * This includes dispositions made on reverse deliveries that are associated with the reverse fulfillment order.
   *  Requires at least one of the following scopes: read_returns, read_marketplace_returns.
   */
  ReverseFulfillmentOrdersDispose = 'REVERSE_FULFILLMENT_ORDERS_DISPOSE',
  /** The webhook topic for `scheduled_product_listings/add` events. Occurs whenever a product is scheduled to be published. Requires the `read_product_listings` scope. */
  ScheduledProductListingsAdd = 'SCHEDULED_PRODUCT_LISTINGS_ADD',
  /** The webhook topic for `scheduled_product_listings/remove` events. Occurs whenever a product is no longer scheduled to be published. Requires the `read_product_listings` scope. */
  ScheduledProductListingsRemove = 'SCHEDULED_PRODUCT_LISTINGS_REMOVE',
  /** The webhook topic for `scheduled_product_listings/update` events. Occurs whenever a product's scheduled availability date changes. Requires the `read_product_listings` scope. */
  ScheduledProductListingsUpdate = 'SCHEDULED_PRODUCT_LISTINGS_UPDATE',
  /** The webhook topic for `segments/create` events. Occurs whenever a segment is created. Requires the `read_customers` scope. */
  SegmentsCreate = 'SEGMENTS_CREATE',
  /** The webhook topic for `segments/delete` events. Occurs whenever a segment is deleted. Requires the `read_customers` scope. */
  SegmentsDelete = 'SEGMENTS_DELETE',
  /** The webhook topic for `segments/update` events. Occurs whenever a segment is updated. Requires the `read_customers` scope. */
  SegmentsUpdate = 'SEGMENTS_UPDATE',
  /** The webhook topic for `selling_plan_groups/create` events. Notifies when a SellingPlanGroup is created. Requires the `read_products` scope. */
  SellingPlanGroupsCreate = 'SELLING_PLAN_GROUPS_CREATE',
  /** The webhook topic for `selling_plan_groups/delete` events. Notifies when a SellingPlanGroup is deleted. Requires the `read_products` scope. */
  SellingPlanGroupsDelete = 'SELLING_PLAN_GROUPS_DELETE',
  /** The webhook topic for `selling_plan_groups/update` events. Notifies when a SellingPlanGroup is updated. Requires the `read_products` scope. */
  SellingPlanGroupsUpdate = 'SELLING_PLAN_GROUPS_UPDATE',
  /** The webhook topic for `shipping_addresses/create` events. Occurs whenever a shipping address is created. Requires the `read_shipping` scope. */
  ShippingAddressesCreate = 'SHIPPING_ADDRESSES_CREATE',
  /** The webhook topic for `shipping_addresses/update` events. Occurs whenever a shipping address is updated. Requires the `read_shipping` scope. */
  ShippingAddressesUpdate = 'SHIPPING_ADDRESSES_UPDATE',
  /** The webhook topic for `shop/update` events. Occurs whenever a shop is updated. */
  ShopUpdate = 'SHOP_UPDATE',
  /** The webhook topic for `subscription_billing_attempts/challenged` events. Occurs when the financial instutition challenges the subscripttion billing attempt charge as per 3D Secure. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingAttemptsChallenged = 'SUBSCRIPTION_BILLING_ATTEMPTS_CHALLENGED',
  /** The webhook topic for `subscription_billing_attempts/failure` events. Occurs whenever a subscription billing attempt fails. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingAttemptsFailure = 'SUBSCRIPTION_BILLING_ATTEMPTS_FAILURE',
  /** The webhook topic for `subscription_billing_attempts/success` events. Occurs whenever a subscription billing attempt succeeds. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingAttemptsSuccess = 'SUBSCRIPTION_BILLING_ATTEMPTS_SUCCESS',
  /** The webhook topic for `subscription_billing_cycles/skip` events. Occurs whenever a subscription contract billing cycle is skipped. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingCyclesSkip = 'SUBSCRIPTION_BILLING_CYCLES_SKIP',
  /** The webhook topic for `subscription_billing_cycles/unskip` events. Occurs whenever a subscription contract billing cycle is unskipped. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingCyclesUnskip = 'SUBSCRIPTION_BILLING_CYCLES_UNSKIP',
  /** The webhook topic for `subscription_billing_cycle_edits/create` events. Occurs whenever a subscription contract billing cycle is edited. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingCycleEditsCreate = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_CREATE',
  /** The webhook topic for `subscription_billing_cycle_edits/delete` events. Occurs whenever a subscription contract billing cycle edit is deleted. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingCycleEditsDelete = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_DELETE',
  /** The webhook topic for `subscription_billing_cycle_edits/update` events. Occurs whenever a subscription contract billing cycle edit is updated. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionBillingCycleEditsUpdate = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_UPDATE',
  /** The webhook topic for `subscription_contracts/activate` events. Occurs when a subscription contract is activated. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsActivate = 'SUBSCRIPTION_CONTRACTS_ACTIVATE',
  /** The webhook topic for `subscription_contracts/cancel` events. Occurs when a subscription contract is canceled. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsCancel = 'SUBSCRIPTION_CONTRACTS_CANCEL',
  /** The webhook topic for `subscription_contracts/create` events. Occurs whenever a subscription contract is created. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsCreate = 'SUBSCRIPTION_CONTRACTS_CREATE',
  /** The webhook topic for `subscription_contracts/expire` events. Occurs when a subscription contract expires. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsExpire = 'SUBSCRIPTION_CONTRACTS_EXPIRE',
  /** The webhook topic for `subscription_contracts/fail` events. Occurs when a subscription contract is failed. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsFail = 'SUBSCRIPTION_CONTRACTS_FAIL',
  /** The webhook topic for `subscription_contracts/pause` events. Occurs when a subscription contract is paused. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsPause = 'SUBSCRIPTION_CONTRACTS_PAUSE',
  /** The webhook topic for `subscription_contracts/update` events. Occurs whenever a subscription contract is updated. Requires the `read_own_subscription_contracts` scope. */
  SubscriptionContractsUpdate = 'SUBSCRIPTION_CONTRACTS_UPDATE',
  /** The webhook topic for `tax_partners/update` events. Occurs whenever a tax partner is created or updated. Requires the `read_taxes` scope. */
  TaxPartnersUpdate = 'TAX_PARTNERS_UPDATE',
  /** The webhook topic for `tax_services/create` events. Occurs whenever a tax service is created. Requires the `read_taxes` scope. */
  TaxServicesCreate = 'TAX_SERVICES_CREATE',
  /** The webhook topic for `tax_services/update` events. Occurs whenver a tax service is updated. Requires the `read_taxes` scope. */
  TaxServicesUpdate = 'TAX_SERVICES_UPDATE',
  /** The webhook topic for `tax_summaries/create` events. Occurs when a tax summary is created. Consumed by tax partners. Requires at least one of the following scopes: read_fulfillments, read_marketplace_orders, read_orders. */
  TaxSummariesCreate = 'TAX_SUMMARIES_CREATE',
  /** The webhook topic for `tender_transactions/create` events. Occurs when a tender transaction is created. Requires the `read_orders` scope. */
  TenderTransactionsCreate = 'TENDER_TRANSACTIONS_CREATE',
  /** The webhook topic for `themes/create` events. Occurs whenever a theme is created. Does not occur when theme files are created. Requires the `read_themes` scope. */
  ThemesCreate = 'THEMES_CREATE',
  /** The webhook topic for `themes/delete` events. Occurs whenever a theme is deleted. Does not occur when theme files are deleted. Requires the `read_themes` scope. */
  ThemesDelete = 'THEMES_DELETE',
  /** The webhook topic for `themes/publish` events. Occurs whenever a theme with the main or mobile (deprecated) role is published. Requires the `read_themes` scope. */
  ThemesPublish = 'THEMES_PUBLISH',
  /** The webhook topic for `themes/update` events. Occurs whenever a theme is updated. Does not occur when theme files are updated. Requires the `read_themes` scope. */
  ThemesUpdate = 'THEMES_UPDATE',
  /** The webhook topic for `variants/in_stock` events. Occurs whenever a variant becomes in stock. Online channels receive this webhook only when the variant becomes in stock online. Requires the `read_products` scope. */
  VariantsInStock = 'VARIANTS_IN_STOCK',
  /** The webhook topic for `variants/out_of_stock` events. Occurs whenever a variant becomes out of stock. Online channels receive this webhook only when the variant becomes out of stock online. Requires the `read_products` scope. */
  VariantsOutOfStock = 'VARIANTS_OUT_OF_STOCK'
}

/** Return type for `webhookSubscriptionUpdate` mutation. */
export type WebhookSubscriptionUpdatePayload = {
  __typename?: 'WebhookSubscriptionUpdatePayload';
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<UserError>;
  /** The webhook subscription that was updated. */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/**
 * A weight measurement with its numeric value and unit. Used throughout the API, for example in shipping calculations, delivery conditions, order line items, and inventory measurements.
 *
 * The weight combines a decimal value with a standard unit of measurement to ensure consistent weight handling across different regional systems.
 */
export type Weight = {
  __typename?: 'Weight';
  /** The unit of measurement for `value`. */
  unit: WeightUnit;
  /** The weight value using the unit system specified with `unit`. */
  value: Scalars['Float']['output'];
};

/** The input fields for the weight unit and value inputs. */
export type WeightInput = {
  /** Unit of measurement for `value`. */
  unit: WeightUnit;
  /** The weight value using the unit system specified with `weight_unit`. */
  value: Scalars['Float']['input'];
};

/** Units of measurement for weight. */
export enum WeightUnit {
  /** Metric system unit of mass. */
  Grams = 'GRAMS',
  /** 1 kilogram equals 1000 grams. */
  Kilograms = 'KILOGRAMS',
  /** Imperial system unit of mass. */
  Ounces = 'OUNCES',
  /** 1 pound equals 16 ounces. */
  Pounds = 'POUNDS'
}

export type GetCurrentInstallationIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentInstallationIdQuery = { __typename?: 'QueryRoot', currentAppInstallation: { __typename?: 'AppInstallation', id: string } };

export type CreateAppDataMetafieldMutationVariables = Exact<{
  metafieldsSetInput: Array<MetafieldsSetInput> | MetafieldsSetInput;
}>;


export type CreateAppDataMetafieldMutation = { __typename?: 'Mutation', metafieldsSet?: { __typename?: 'MetafieldsSetPayload', metafields?: Array<{ __typename?: 'Metafield', id: string, namespace: string, key: string }> | null, userErrors: Array<{ __typename?: 'MetafieldsSetUserError', field?: Array<string> | null, message: string }> } | null };

export type AppSubscriptionFragmentFragment = { __typename?: 'AppSubscription', id: string, createdAt: any, currentPeriodEnd?: any | null, name: string, returnUrl: any, status: AppSubscriptionStatus, trialDays: number, lineItems: Array<{ __typename?: 'AppSubscriptionLineItem', id: string, plan: { __typename?: 'AppPlanV2', pricingDetails: { __typename?: 'AppRecurringPricing', interval: AppPricingInterval, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'AppUsagePricing', interval: AppPricingInterval, terms: string, balanceUsed: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cappedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } }> };

export type GetAppSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppSubscriptionQuery = { __typename?: 'QueryRoot', node?: { __typename?: 'AbandonedCheckout' } | { __typename?: 'AbandonedCheckoutLineItem' } | { __typename?: 'Abandonment' } | { __typename?: 'AddAllProductsOperation' } | { __typename?: 'AdditionalFee' } | { __typename?: 'App' } | { __typename?: 'AppCatalog' } | { __typename?: 'AppCredit' } | { __typename?: 'AppInstallation' } | { __typename?: 'AppPurchaseOneTime' } | { __typename?: 'AppRevenueAttributionRecord' } | { __typename?: 'AppSubscription', id: string, createdAt: any, currentPeriodEnd?: any | null, name: string, returnUrl: any, status: AppSubscriptionStatus, trialDays: number, lineItems: Array<{ __typename?: 'AppSubscriptionLineItem', id: string, plan: { __typename?: 'AppPlanV2', pricingDetails: { __typename?: 'AppRecurringPricing', interval: AppPricingInterval, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'AppUsagePricing', interval: AppPricingInterval, terms: string, balanceUsed: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cappedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } }> } | { __typename?: 'AppUsageRecord' } | { __typename?: 'Article' } | { __typename?: 'BasicEvent' } | { __typename?: 'Blog' } | { __typename?: 'BulkOperation' } | { __typename?: 'BusinessEntity' } | { __typename?: 'CalculatedOrder' } | { __typename?: 'CartTransform' } | { __typename?: 'CashDrawer' } | { __typename?: 'CashManagementCustomReasonCode' } | { __typename?: 'CashManagementDefaultReasonCode' } | { __typename?: 'CashManagementSystemReasonCode' } | { __typename?: 'CashTrackingAdjustment' } | { __typename?: 'CashTrackingSession' } | { __typename?: 'CatalogCsvOperation' } | { __typename?: 'Channel' } | { __typename?: 'ChannelDefinition' } | { __typename?: 'ChannelInformation' } | { __typename?: 'CheckoutAndAccountsConfiguration' } | { __typename?: 'CheckoutAndAccountsConfigurationOverride' } | { __typename?: 'CheckoutProfile' } | { __typename?: 'Collection' } | { __typename?: 'CollectionConditionsSource' } | { __typename?: 'CollectionSubCollectionsSource' } | { __typename?: 'Comment' } | { __typename?: 'CommentEvent' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyContact' } | { __typename?: 'CompanyContactRole' } | { __typename?: 'CompanyContactRoleAssignment' } | { __typename?: 'CompanyLocation' } | { __typename?: 'CompanyLocationCatalog' } | { __typename?: 'CompanyLocationStaffMemberAssignment' } | { __typename?: 'ConsentPolicy' } | { __typename?: 'CurrencyExchangeAdjustment' } | { __typename?: 'Customer' } | { __typename?: 'CustomerAccountAppExtensionPage' } | { __typename?: 'CustomerAccountNativePage' } | { __typename?: 'CustomerPaymentMethod' } | { __typename?: 'CustomerSegmentMembersQuery' } | { __typename?: 'CustomerVisit' } | { __typename?: 'DeliveryCarrierService' } | { __typename?: 'DeliveryCondition' } | { __typename?: 'DeliveryCountry' } | { __typename?: 'DeliveryCustomization' } | { __typename?: 'DeliveryLocationGroup' } | { __typename?: 'DeliveryMethod' } | { __typename?: 'DeliveryMethodDefinition' } | { __typename?: 'DeliveryParticipant' } | { __typename?: 'DeliveryProfile' } | { __typename?: 'DeliveryProfileItem' } | { __typename?: 'DeliveryPromiseParticipant' } | { __typename?: 'DeliveryPromiseProvider' } | { __typename?: 'DeliveryProvince' } | { __typename?: 'DeliveryRateDefinition' } | { __typename?: 'DeliveryZone' } | { __typename?: 'DiscountAutomaticBxgy' } | { __typename?: 'DiscountAutomaticNode' } | { __typename?: 'DiscountCodeNode' } | { __typename?: 'DiscountNode' } | { __typename?: 'DiscountRedeemCodeBulkCreation' } | { __typename?: 'Domain' } | { __typename?: 'DraftOrder' } | { __typename?: 'DraftOrderLineItem' } | { __typename?: 'DraftOrderTag' } | { __typename?: 'Duty' } | { __typename?: 'ExchangeLineItem' } | { __typename?: 'ExchangeV2' } | { __typename?: 'ExternalVideo' } | { __typename?: 'Fulfillment' } | { __typename?: 'FulfillmentConstraintRule' } | { __typename?: 'FulfillmentEvent' } | { __typename?: 'FulfillmentHold' } | { __typename?: 'FulfillmentLineItem' } | { __typename?: 'FulfillmentOrder' } | { __typename?: 'FulfillmentOrderDestination' } | { __typename?: 'FulfillmentOrderLineItem' } | { __typename?: 'FulfillmentOrderMerchantRequest' } | { __typename?: 'GenericFile' } | { __typename?: 'GiftCard' } | { __typename?: 'GiftCardCashOutTransaction' } | { __typename?: 'GiftCardCreditTransaction' } | { __typename?: 'GiftCardDebitTransaction' } | { __typename?: 'IdentityProviderSubject' } | { __typename?: 'InventoryAdjustmentGroup' } | { __typename?: 'InventoryItem' } | { __typename?: 'InventoryItemMeasurement' } | { __typename?: 'InventoryLevel' } | { __typename?: 'InventoryQuantity' } | { __typename?: 'InventoryShipment' } | { __typename?: 'InventoryShipmentLineItem' } | { __typename?: 'InventoryTransfer' } | { __typename?: 'InventoryTransferLineItem' } | { __typename?: 'LineItem' } | { __typename?: 'LineItemGroup' } | { __typename?: 'Location' } | { __typename?: 'MailingAddress' } | { __typename?: 'Market' } | { __typename?: 'MarketCatalog' } | { __typename?: 'MarketRegionCountry' } | { __typename?: 'MarketRegionSubdivision' } | { __typename?: 'MarketWebPresence' } | { __typename?: 'MarketingActivity' } | { __typename?: 'MarketingEvent' } | { __typename?: 'MediaImage' } | { __typename?: 'Menu' } | { __typename?: 'Metafield' } | { __typename?: 'MetafieldDefinition' } | { __typename?: 'Metaobject' } | { __typename?: 'MetaobjectDefinition' } | { __typename?: 'Model3d' } | { __typename?: 'OnlineStoreTheme' } | { __typename?: 'Order' } | { __typename?: 'OrderAdjustment' } | { __typename?: 'OrderAttributionDefinition' } | { __typename?: 'OrderCreateMandatePaymentJobResult' } | { __typename?: 'OrderDisputeSummary' } | { __typename?: 'OrderEditSession' } | { __typename?: 'OrderTransaction' } | { __typename?: 'Page' } | { __typename?: 'PaymentCustomization' } | { __typename?: 'PaymentMandate' } | { __typename?: 'PaymentSchedule' } | { __typename?: 'PaymentTerms' } | { __typename?: 'PaymentTermsTemplate' } | { __typename?: 'PointOfSaleDevice' } | { __typename?: 'PointOfSaleDevicePaymentSession' } | { __typename?: 'PriceList' } | { __typename?: 'PriceRule' } | { __typename?: 'PriceRuleDiscountCode' } | { __typename?: 'Product' } | { __typename?: 'ProductBundleOperation' } | { __typename?: 'ProductDeleteOperation' } | { __typename?: 'ProductDuplicateOperation' } | { __typename?: 'ProductFeed' } | { __typename?: 'ProductOption' } | { __typename?: 'ProductOptionValue' } | { __typename?: 'ProductSetOperation' } | { __typename?: 'ProductTaxonomyNode' } | { __typename?: 'ProductVariant' } | { __typename?: 'ProductVariantComponent' } | { __typename?: 'Publication' } | { __typename?: 'PublicationResourceOperation' } | { __typename?: 'QuantityPriceBreak' } | { __typename?: 'Refund' } | { __typename?: 'RefundShippingLine' } | { __typename?: 'Return' } | { __typename?: 'ReturnLineItem' } | { __typename?: 'ReturnReasonDefinition' } | { __typename?: 'ReturnableFulfillment' } | { __typename?: 'ReverseDelivery' } | { __typename?: 'ReverseDeliveryLineItem' } | { __typename?: 'ReverseFulfillmentOrder' } | { __typename?: 'ReverseFulfillmentOrderDisposition' } | { __typename?: 'ReverseFulfillmentOrderLineItem' } | { __typename?: 'SaleAdditionalFee' } | { __typename?: 'SavedSearch' } | { __typename?: 'ScriptTag' } | { __typename?: 'Segment' } | { __typename?: 'SellingPlan' } | { __typename?: 'SellingPlanGroup' } | { __typename?: 'ServerPixel' } | { __typename?: 'ShippingLabel' } | { __typename?: 'ShippingLabelPurchaseResult' } | { __typename?: 'Shop' } | { __typename?: 'ShopAddress' } | { __typename?: 'ShopPolicy' } | { __typename?: 'ShopifyPaymentsAccount' } | { __typename?: 'ShopifyPaymentsBalanceTransaction' } | { __typename?: 'ShopifyPaymentsBankAccount' } | { __typename?: 'ShopifyPaymentsDispute' } | { __typename?: 'ShopifyPaymentsDisputeEvidence' } | { __typename?: 'ShopifyPaymentsDisputeFileUpload' } | { __typename?: 'ShopifyPaymentsDisputeFulfillment' } | { __typename?: 'ShopifyPaymentsPayout' } | { __typename?: 'StaffMember' } | { __typename?: 'StandardMetafieldDefinitionTemplate' } | { __typename?: 'StoreCreditAccount' } | { __typename?: 'StoreCreditAccountCreditTransaction' } | { __typename?: 'StoreCreditAccountDebitRevertTransaction' } | { __typename?: 'StoreCreditAccountDebitTransaction' } | { __typename?: 'StorefrontAccessToken' } | { __typename?: 'SubscriptionBillingAttempt' } | { __typename?: 'SubscriptionContract' } | { __typename?: 'SubscriptionDraft' } | { __typename?: 'TaxonomyAttribute' } | { __typename?: 'TaxonomyCategory' } | { __typename?: 'TaxonomyChoiceListAttribute' } | { __typename?: 'TaxonomyMeasurementAttribute' } | { __typename?: 'TaxonomyValue' } | { __typename?: 'TenderTransaction' } | { __typename?: 'TransactionFee' } | { __typename?: 'UnverifiedReturnLineItem' } | { __typename?: 'UrlRedirect' } | { __typename?: 'UrlRedirectImport' } | { __typename?: 'Validation' } | { __typename?: 'Video' } | { __typename?: 'WebPixel' } | { __typename?: 'WebhookSubscription' } | null };

export type AppSubscriptionCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  returnUrl: Scalars['URL']['input'];
  lineItems: Array<AppSubscriptionLineItemInput> | AppSubscriptionLineItemInput;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppSubscriptionCreateMutation = { __typename?: 'Mutation', appSubscriptionCreate?: { __typename?: 'AppSubscriptionCreatePayload', confirmationUrl?: any | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }>, appSubscription?: { __typename?: 'AppSubscription', id: string, createdAt: any, currentPeriodEnd?: any | null, name: string, returnUrl: any, status: AppSubscriptionStatus, trialDays: number, lineItems: Array<{ __typename?: 'AppSubscriptionLineItem', id: string, plan: { __typename?: 'AppPlanV2', pricingDetails: { __typename?: 'AppRecurringPricing', interval: AppPricingInterval, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'AppUsagePricing', interval: AppPricingInterval, terms: string, balanceUsed: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cappedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } }> } | null } | null };

export type AppSubscriptionCancelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppSubscriptionCancelMutation = { __typename?: 'Mutation', appSubscriptionCancel?: { __typename?: 'AppSubscriptionCancelPayload', appSubscription?: { __typename?: 'AppSubscription', id: string, name: string, status: AppSubscriptionStatus } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type AppSubscriptionTrialExtendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
}>;


export type AppSubscriptionTrialExtendMutation = { __typename?: 'Mutation', appSubscriptionTrialExtend?: { __typename?: 'AppSubscriptionTrialExtendPayload', appSubscription?: { __typename?: 'AppSubscription', id: string, status: AppSubscriptionStatus, trialDays: number } | null, userErrors: Array<{ __typename?: 'AppSubscriptionTrialExtendUserError', field?: Array<string> | null, message: string, code?: AppSubscriptionTrialExtendUserErrorCode | null }> } | null };

export type AppUsageRecordCreateMutationVariables = Exact<{
  subscriptionLineItemId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  price: MoneyInput;
}>;


export type AppUsageRecordCreateMutation = { __typename?: 'Mutation', appUsageRecordCreate?: { __typename?: 'AppUsageRecordCreatePayload', appUsageRecord?: { __typename?: 'AppUsageRecord', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetCollectionsWithProductsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetCollectionsWithProductsQuery = { __typename?: 'QueryRoot', collections: { __typename?: 'CollectionConnection', edges: Array<{ __typename?: 'CollectionEdge', node: { __typename?: 'Collection', id: string, title: string, handle: string, products: { __typename?: 'ProductConnection', nodes: Array<{ __typename?: 'Product', id: string }> } } }> } };

export type CustomerFragmentFragment = { __typename?: 'Customer', createdAt: any, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, numberOfOrders: any, state: CustomerState, phone?: string | null, updatedAt: any, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }>, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

export type GetCustomersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'QueryRoot', customers: { __typename?: 'CustomerConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node: { __typename?: 'Customer', id: string, email?: string | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null } }> } };

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', createdAt: any, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, numberOfOrders: any, state: CustomerState, phone?: string | null, updatedAt: any, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }>, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null };

export type GetCustomerWithEventsAndActiveSubscriptionIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetCustomerWithEventsAndActiveSubscriptionIdsQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', createdAt: any, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, numberOfOrders: any, state: CustomerState, phone?: string | null, updatedAt: any, subscriptionContracts: { __typename?: 'SubscriptionContractConnection', edges: Array<{ __typename?: 'SubscriptionContractEdge', node: { __typename?: 'SubscriptionContract', id: string, orders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'Order', id: string } }> } } }> }, events: { __typename?: 'EventConnection', edges: Array<{ __typename?: 'EventEdge', node: { __typename?: 'BasicEvent', appTitle?: string | null, attributeToApp: boolean, attributeToUser: boolean, createdAt: any, criticalAlert: boolean, message: any, id: string } | { __typename?: 'CommentEvent', appTitle?: string | null, attributeToApp: boolean, attributeToUser: boolean, createdAt: any, criticalAlert: boolean, message: any, id: string } }> }, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }>, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null };

export type GetCustomerPaymentMethodsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerPaymentMethodsQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', paymentMethods: { __typename?: 'CustomerPaymentMethodConnection', edges: Array<{ __typename?: 'CustomerPaymentMethodEdge', node: { __typename?: 'CustomerPaymentMethod', id: string, revokedReason?: CustomerPaymentMethodRevocationReason | null, revokedAt?: any | null, instrument?: { __typename?: 'BankAccount' } | { __typename: 'CustomerCreditCard', brand: string, expiryMonth: number, expiryYear: number, lastDigits: string, isRevocable: boolean, maskedNumber: string, name: string } | { __typename: 'CustomerPaypalBillingAgreement', paypalAccountEmail?: string | null, isRevocable: boolean, inactive: boolean } | { __typename: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, maskedNumber: string, name: string } | null } }> } } | null };

export type CustomerCreateMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type CustomerCreateMutation = { __typename?: 'Mutation', customerCreate?: { __typename?: 'CustomerCreatePayload', customer?: { __typename?: 'Customer', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerUpdateDefaultAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type CustomerUpdateDefaultAddressMutation = { __typename?: 'Mutation', customerUpdateDefaultAddress?: { __typename?: 'CustomerUpdateDefaultAddressPayload', customer?: { __typename?: 'Customer', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerUpdateMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type CustomerUpdateMutation = { __typename?: 'Mutation', customerUpdate?: { __typename?: 'CustomerUpdatePayload', customer?: { __typename?: 'Customer', id: string, email?: string | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerAddressesQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CustomerAddressesQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }> } | null };

export type DeliveryProfileFragmentFragment = { __typename?: 'DeliveryProfile', activeMethodDefinitionsCount: number, default: boolean, id: string, locationsWithoutRatesCount: number, name: string, originLocationCount: number, zoneCountryCount: number, productVariantsCount?: { __typename?: 'Count', count: number } | null, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', countriesInAnyZone: Array<{ __typename?: 'DeliveryCountryAndZone', zone: string, country: { __typename?: 'DeliveryCountry', id: string } }>, locationGroup: { __typename?: 'DeliveryLocationGroup', id: string } }>, unassignedLocations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type LocationFragmentFragment = { __typename?: 'Location', id: string, name: string };

export type GetDeliveryProfilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveryProfilesQuery = { __typename?: 'QueryRoot', deliveryProfiles: { __typename?: 'DeliveryProfileConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DeliveryProfileEdge', cursor: string, node: { __typename?: 'DeliveryProfile', activeMethodDefinitionsCount: number, default: boolean, id: string, locationsWithoutRatesCount: number, name: string, originLocationCount: number, zoneCountryCount: number, sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanGroupEdge', node: { __typename?: 'SellingPlanGroup', id: string } }> }, productVariantsCount?: { __typename?: 'Count', count: number } | null, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', countriesInAnyZone: Array<{ __typename?: 'DeliveryCountryAndZone', zone: string, country: { __typename?: 'DeliveryCountry', id: string } }>, locationGroup: { __typename?: 'DeliveryLocationGroup', id: string } }>, unassignedLocations: Array<{ __typename?: 'Location', id: string, name: string }> } }> } };

export type GetDeliveryProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeliveryProfileQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', activeMethodDefinitionsCount: number, default: boolean, id: string, locationsWithoutRatesCount: number, name: string, originLocationCount: number, zoneCountryCount: number, productVariantsCount?: { __typename?: 'Count', count: number } | null, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', countriesInAnyZone: Array<{ __typename?: 'DeliveryCountryAndZone', zone: string, country: { __typename?: 'DeliveryCountry', id: string } }>, locationGroup: { __typename?: 'DeliveryLocationGroup', id: string } }>, unassignedLocations: Array<{ __typename?: 'Location', id: string, name: string }> } | null };

export type GetLocationsAvailableForDeliveryProfilesConnectionQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationsAvailableForDeliveryProfilesConnectionQuery = { __typename?: 'QueryRoot', locationsAvailableForDeliveryProfilesConnection: { __typename?: 'LocationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'LocationEdge', cursor: string, node: { __typename?: 'Location', id: string, name: string } }> } };

export type GetDeliveryProfileItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  profileItemsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveryProfileItemsQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, profileItems: { __typename?: 'DeliveryProfileItemConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DeliveryProfileItemEdge', cursor: string, node: { __typename?: 'DeliveryProfileItem', product: { __typename?: 'Product', id: string } } }> } } | null };

export type GetDeliveryProfileSellingPlanGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  sellingPlanGroupsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveryProfileSellingPlanGroupsQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanGroupEdge', cursor: string, node: { __typename?: 'SellingPlanGroup', id: string } }> } } | null };

export type DeliveryProfileLocationGroupZoneFragmentFragment = { __typename?: 'DeliveryLocationGroupZone', methodDefinitionCounts: { __typename?: 'DeliveryMethodDefinitionCounts', participantDefinitionsCount: number, rateDefinitionsCount: number }, zone: { __typename?: 'DeliveryZone', id: string, name: string, countries: Array<{ __typename?: 'DeliveryCountry', id: string, name: string, code: { __typename?: 'DeliveryCountryCodeOrRestOfWorld', countryCode?: CountryCode | null, restOfWorld: boolean }, provinces: Array<{ __typename?: 'DeliveryProvince', code: string, id: string, name: string }> }> } };

export type GetDeliveryProfileLocationGroupZonesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  locationGroupZonesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveryProfileLocationGroupZonesQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', locationGroupZones: { __typename?: 'DeliveryLocationGroupZoneConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DeliveryLocationGroupZoneEdge', cursor: string, node: { __typename?: 'DeliveryLocationGroupZone', methodDefinitionCounts: { __typename?: 'DeliveryMethodDefinitionCounts', participantDefinitionsCount: number, rateDefinitionsCount: number }, zone: { __typename?: 'DeliveryZone', id: string, name: string, countries: Array<{ __typename?: 'DeliveryCountry', id: string, name: string, code: { __typename?: 'DeliveryCountryCodeOrRestOfWorld', countryCode?: CountryCode | null, restOfWorld: boolean }, provinces: Array<{ __typename?: 'DeliveryProvince', code: string, id: string, name: string }> }> } } }> } }> } | null };

export type DeliveryMethodDefinitionFragmentFragment = { __typename?: 'DeliveryMethodDefinition', active: boolean, description?: string | null, id: string, name: string, methodConditions: Array<{ __typename?: 'DeliveryCondition', field: DeliveryConditionField, id: string, operator: DeliveryConditionOperator, conditionCriteria: { __typename?: 'MoneyV2', currencyCode: CurrencyCode, amount: any } | { __typename?: 'Weight', unit: WeightUnit, value: number } }>, rateProvider: { __typename?: 'DeliveryParticipant', id: string } | { __typename?: 'DeliveryRateDefinition', id: string, price: { __typename?: 'MoneyV2', currencyCode: CurrencyCode, amount: any } } };

export type GetDeliveryProfileLocationGroupZoneMethodDefinitionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locationGroupZonesCursor?: InputMaybe<Scalars['String']['input']>;
  methodDefinitionCount: Scalars['Int']['input'];
}>;


export type GetDeliveryProfileLocationGroupZoneMethodDefinitionsQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', locationGroupZones: { __typename?: 'DeliveryLocationGroupZoneConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DeliveryLocationGroupZoneEdge', cursor: string, node: { __typename?: 'DeliveryLocationGroupZone', methodDefinitions: { __typename?: 'DeliveryMethodDefinitionConnection', edges: Array<{ __typename?: 'DeliveryMethodDefinitionEdge', cursor: string, node: { __typename?: 'DeliveryMethodDefinition', active: boolean, description?: string | null, id: string, name: string, methodConditions: Array<{ __typename?: 'DeliveryCondition', field: DeliveryConditionField, id: string, operator: DeliveryConditionOperator, conditionCriteria: { __typename?: 'MoneyV2', currencyCode: CurrencyCode, amount: any } | { __typename?: 'Weight', unit: WeightUnit, value: number } }>, rateProvider: { __typename?: 'DeliveryParticipant', id: string } | { __typename?: 'DeliveryRateDefinition', id: string, price: { __typename?: 'MoneyV2', currencyCode: CurrencyCode, amount: any } } } }> } } }> } }> } | null };

export type GetDeliveryProfileLocationGroupLocationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveryProfileLocationGroupLocationsQuery = { __typename?: 'QueryRoot', deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, profileLocationGroups: Array<{ __typename?: 'DeliveryProfileLocationGroup', locationGroup: { __typename?: 'DeliveryLocationGroup', locations: { __typename?: 'LocationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'LocationEdge', cursor: string, node: { __typename?: 'Location', id: string, name: string } }> } } }> } | null };

export type DeliveryProfileCreateMutationVariables = Exact<{
  profile: DeliveryProfileInput;
}>;


export type DeliveryProfileCreateMutation = { __typename?: 'Mutation', deliveryProfileCreate?: { __typename?: 'DeliveryProfileCreatePayload', profile?: { __typename?: 'DeliveryProfile', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DeliveryProfileUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  profile: DeliveryProfileInput;
}>;


export type DeliveryProfileUpdateMutation = { __typename?: 'Mutation', deliveryProfileUpdate?: { __typename?: 'DeliveryProfileUpdatePayload', profile?: { __typename?: 'DeliveryProfile', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DeliveryProfileRemoveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeliveryProfileRemoveMutation = { __typename?: 'Mutation', deliveryProfileRemove?: { __typename?: 'DeliveryProfileRemovePayload', job?: { __typename?: 'Job', id: string, done: boolean } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DeliveryShippingOriginAssignMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type DeliveryShippingOriginAssignMutation = { __typename?: 'Mutation', deliveryShippingOriginAssign?: { __typename?: 'DeliveryShippingOriginAssignPayload', userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DiscountCodeFreeShippingFragmentFragment = { __typename?: 'DiscountCodeFreeShipping', appliesOnSubscription: boolean, title: string };

export type DiscountCodeBasicFragmentFragment = { __typename?: 'DiscountCodeBasic', appliesOncePerCustomer: boolean, asyncUsageCount: number, customerGets: { __typename?: 'DiscountCustomerGets', appliesOnSubscription: boolean, value: { __typename?: 'DiscountAmount', amount: { __typename?: 'MoneyV2', amount: any } } | { __typename?: 'DiscountOnQuantity', effect: { __typename?: 'DiscountAmount' } | { __typename?: 'DiscountPercentage', percentage: number }, quantity: { __typename?: 'DiscountQuantity', quantity: any } } | { __typename?: 'DiscountPercentage', percentage: number } } };

export type GetDiscountNodeByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetDiscountNodeByCodeQuery = { __typename?: 'QueryRoot', codeDiscountNodeByCode?: { __typename?: 'DiscountCodeNode', codeDiscount: { __typename: 'DiscountCodeApp' } | { __typename: 'DiscountCodeBasic', title: string, startsAt: any, endsAt?: any | null, status: DiscountStatus, recurringCycleLimit?: number | null, usageLimit?: number | null, appliesOncePerCustomer: boolean, asyncUsageCount: number, customerGets: { __typename?: 'DiscountCustomerGets', appliesOnSubscription: boolean, value: { __typename?: 'DiscountAmount', amount: { __typename?: 'MoneyV2', amount: any } } | { __typename?: 'DiscountOnQuantity', effect: { __typename?: 'DiscountAmount' } | { __typename?: 'DiscountPercentage', percentage: number }, quantity: { __typename?: 'DiscountQuantity', quantity: any } } | { __typename?: 'DiscountPercentage', percentage: number } } } | { __typename: 'DiscountCodeBxgy' } | { __typename: 'DiscountCodeFreeShipping', startsAt: any, endsAt?: any | null, status: DiscountStatus, recurringCycleLimit?: number | null, usageLimit?: number | null, asyncUsageCount: number, appliesOnSubscription: boolean, title: string } } | null };

export type GetDiscountCodeCombineWithOrderStatusQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetDiscountCodeCombineWithOrderStatusQuery = { __typename?: 'QueryRoot', discountNodes: { __typename?: 'DiscountNodeConnection', edges: Array<{ __typename?: 'DiscountNodeEdge', node: { __typename?: 'DiscountNode', id: string, discount: { __typename?: 'DiscountAutomaticApp' } | { __typename?: 'DiscountAutomaticBasic' } | { __typename?: 'DiscountAutomaticBxgy' } | { __typename?: 'DiscountAutomaticFreeShipping', title: string, discountClasses: Array<DiscountClass>, automaticShippingDiscountClass: ShippingDiscountClass, combinesWith: { __typename?: 'DiscountCombinesWith', orderDiscounts: boolean, productDiscounts: boolean, shippingDiscounts: boolean } } | { __typename?: 'DiscountCodeApp' } | { __typename?: 'DiscountCodeBasic', title: string, discountClasses: Array<DiscountClass>, discountClass: MerchandiseDiscountClass, combinesWith: { __typename?: 'DiscountCombinesWith', orderDiscounts: boolean, productDiscounts: boolean, shippingDiscounts: boolean } } | { __typename?: 'DiscountCodeBxgy' } | { __typename?: 'DiscountCodeFreeShipping', title: string, discountClasses: Array<DiscountClass>, shippingDiscountClass: ShippingDiscountClass, combinesWith: { __typename?: 'DiscountCombinesWith', orderDiscounts: boolean, productDiscounts: boolean, shippingDiscounts: boolean } } } }> } };

export type DraftOrderInnerOrderFragmentFragment = { __typename?: 'Order', id: string, name: string, shippingLine?: { __typename?: 'ShippingLine', shippingRateHandle?: string | null, title: string, originalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } | null, totalTaxSet?: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }>, lineItems: { __typename?: 'LineItemConnection', edges: Array<{ __typename?: 'LineItemEdge', node: { __typename?: 'LineItem', id: string, quantity: number, requiresShipping: boolean, sku?: string | null, title: string, variantTitle?: string | null, originalUnitPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, discountedTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, variant?: { __typename?: 'ProductVariant', id: string } | null } }> } };

export type DraftOrderCreateMutationVariables = Exact<{
  input: DraftOrderInput;
}>;


export type DraftOrderCreateMutation = { __typename?: 'Mutation', draftOrderCreate?: { __typename?: 'DraftOrderCreatePayload', draftOrder?: { __typename?: 'DraftOrder', id: string, invoiceUrl?: any | null } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DraftOrderCalculateMutationVariables = Exact<{
  input: DraftOrderInput;
}>;


export type DraftOrderCalculateMutation = { __typename?: 'Mutation', draftOrderCalculate?: { __typename?: 'DraftOrderCalculatePayload', calculatedDraftOrder?: { __typename?: 'CalculatedDraftOrder', subtotalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalShippingPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalTaxSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }>, availableShippingRates: Array<{ __typename?: 'ShippingRate', handle: string, title: string, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }> } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DraftOrderUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: DraftOrderInput;
}>;


export type DraftOrderUpdateMutation = { __typename?: 'Mutation', draftOrderUpdate?: { __typename?: 'DraftOrderUpdatePayload', draftOrder?: { __typename?: 'DraftOrder', id: string, ready: boolean, order?: { __typename?: 'Order', id: string, name: string, shippingLine?: { __typename?: 'ShippingLine', shippingRateHandle?: string | null, title: string, originalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } | null, totalTaxSet?: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }>, lineItems: { __typename?: 'LineItemConnection', edges: Array<{ __typename?: 'LineItemEdge', node: { __typename?: 'LineItem', id: string, quantity: number, requiresShipping: boolean, sku?: string | null, title: string, variantTitle?: string | null, originalUnitPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, discountedTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, variant?: { __typename?: 'ProductVariant', id: string } | null } }> } } | null } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type DraftOrderCompleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DraftOrderCompleteMutation = { __typename?: 'Mutation', draftOrderComplete?: { __typename?: 'DraftOrderCompletePayload', draftOrder?: { __typename?: 'DraftOrder', id: string, ready: boolean, order?: { __typename?: 'Order', cancelledAt?: any | null, closedAt?: any | null, processedAt: any, name: string, taxesIncluded: boolean, id: string, originalTotalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalDiscountsSet?: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null, totalTipReceivedSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalShippingPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, totalTaxSet?: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null, customer?: { __typename?: 'Customer', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null } | null, shippingLine?: { __typename?: 'ShippingLine', shippingRateHandle?: string | null, title: string, originalPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } | null, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }>, lineItems: { __typename?: 'LineItemConnection', edges: Array<{ __typename?: 'LineItemEdge', node: { __typename?: 'LineItem', id: string, quantity: number, requiresShipping: boolean, sku?: string | null, title: string, variantTitle?: string | null, originalUnitPriceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, discountedTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, variant?: { __typename?: 'ProductVariant', id: string } | null } }> } } | null } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type AnchorsFragmentFragment = { __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType };

export type SubscriptionLineFragmentFragment = { __typename?: 'SubscriptionLine', id: string, productId?: string | null, title: string, quantity: number, sellingPlanId?: string | null, sellingPlanName?: string | null, variantId?: string | null, variantTitle?: string | null, requiresShipping: boolean, sku?: string | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'SubscriptionDiscountAllocation', amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, discount: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }>, pricingPolicy?: { __typename?: 'SubscriptionPricingPolicy', basePrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cycleDiscounts: Array<{ __typename?: 'SubscriptionCyclePriceAdjustment', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle: number, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number }, computedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }> } | null, currentPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, lineDiscountedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

export type SubscriptionManualDiscountFragmentFragment = { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } };

export type SubscriptionAppliedCodeDiscountFragmentFragment = { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null };

export type MailingAddressFragmentFragment = { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null };

export type CancelFulfillmentOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelFulfillmentOrderMutation = { __typename?: 'Mutation', fulfillmentOrderCancel?: { __typename?: 'FulfillmentOrderCancelPayload', fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string } | null, replacementFulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string } | null, userErrors: Array<{ __typename?: 'FulfillmentOrderCancelError', field?: Array<string> | null, message: string }> } | null };

export type FulfillmentOrderRescheduleMutationVariables = Exact<{
  fulfillAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
}>;


export type FulfillmentOrderRescheduleMutation = { __typename?: 'Mutation', fulfillmentOrderReschedule?: { __typename?: 'FulfillmentOrderReschedulePayload', fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, fulfillAt?: any | null } | null, userErrors: Array<{ __typename?: 'FulfillmentOrderRescheduleUserError', field?: Array<string> | null, message: string }> } | null };

export type DiscountCodeBasicCreateMutationVariables = Exact<{
  basicCodeDiscount: DiscountCodeBasicInput;
}>;


export type DiscountCodeBasicCreateMutation = { __typename?: 'Mutation', discountCodeBasicCreate?: { __typename?: 'DiscountCodeBasicCreatePayload', codeDiscountNode?: { __typename?: 'DiscountCodeNode', id: string } | null, userErrors: Array<{ __typename?: 'DiscountUserError', field?: Array<string> | null, message: string }> } | null };

export type DiscountCodeBulkDeleteMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DiscountCodeBulkDeleteMutation = { __typename?: 'Mutation', discountCodeBulkDelete?: { __typename?: 'DiscountCodeBulkDeletePayload', job?: { __typename?: 'Job', id: string } | null, userErrors: Array<{ __typename?: 'DiscountUserError', field?: Array<string> | null, message: string }> } | null };

export type DiscountCodeDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DiscountCodeDeleteMutation = { __typename?: 'Mutation', discountCodeDelete?: { __typename?: 'DiscountCodeDeletePayload', deletedCodeDiscountId?: string | null, userErrors: Array<{ __typename?: 'DiscountUserError', field?: Array<string> | null, message: string }> } | null };

export type OrderFragmentFragment = { __typename?: 'Order', billingAddressMatchesShippingAddress: boolean, canMarkAsPaid: boolean, cancelledAt?: any | null, closed: boolean, closedAt?: any | null, createdAt: any, currencyCode: CurrencyCode, processedAt: any, billingAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, shippingAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, ratePercentage?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any } } }> };

export type LineItemFragmentFragment = { __typename?: 'LineItem', id: string, quantity: number, sku?: string | null, product?: { __typename?: 'Product', id: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, variant?: { __typename?: 'ProductVariant', id: string } | null, sellingPlan?: { __typename?: 'LineItemSellingPlan', sellingPlanId?: string | null, name: string } | null };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', billingAddressMatchesShippingAddress: boolean, canMarkAsPaid: boolean, cancelledAt?: any | null, closed: boolean, closedAt?: any | null, createdAt: any, currencyCode: CurrencyCode, processedAt: any, lineItems: { __typename?: 'LineItemConnection', edges: Array<{ __typename?: 'LineItemEdge', node: { __typename?: 'LineItem', id: string, quantity: number, sku?: string | null, product?: { __typename?: 'Product', id: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, variant?: { __typename?: 'ProductVariant', id: string } | null, sellingPlan?: { __typename?: 'LineItemSellingPlan', sellingPlanId?: string | null, name: string } | null } }> }, billingAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, shippingAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, taxLines: Array<{ __typename?: 'TaxLine', rate?: number | null, ratePercentage?: number | null, title: string, priceSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'MoneyV2', amount: any } } }> } | null };

export type GetOrderLineItemsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderLineItemsQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', lineItems: { __typename?: 'LineItemConnection', edges: Array<{ __typename?: 'LineItemEdge', cursor: string, node: { __typename?: 'LineItem', id: string, quantity: number, sku?: string | null, product?: { __typename?: 'Product', id: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, variant?: { __typename?: 'ProductVariant', id: string } | null, sellingPlan?: { __typename?: 'LineItemSellingPlan', sellingPlanId?: string | null, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } } | null };

export type GetOrderFulfillmentsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderFulfillmentsQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', fulfillmentOrders: { __typename?: 'FulfillmentOrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'FulfillmentOrderEdge', cursor: string, node: { __typename?: 'FulfillmentOrder', id: string, fulfillAt?: any | null, status: FulfillmentOrderStatus } }> } } | null };

export type CustomerVisitFragmentFragment = { __typename?: 'CustomerVisit', id: string, landingPage?: any | null, landingPageHtml?: any | null, occurredAt: any, referralCode?: string | null, referralInfoHtml: any, referrerUrl?: any | null, source: string, sourceDescription?: string | null, sourceType?: MarketingTactic | null, marketingEvent?: { __typename?: 'MarketingEvent', marketingChannelType?: MarketingChannel | null, description?: string | null, endedAt?: any | null, id: string, manageUrl?: any | null, previewUrl?: any | null, scheduledToEndAt?: any | null, sourceAndMedium: string, startedAt: any, type: MarketingTactic, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, utmParameters?: { __typename?: 'UTMParameters', campaign?: string | null, content?: string | null, medium?: string | null, source?: string | null, term?: string | null } | null };

export type GetOrderCustomerJourneySummaryQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderCustomerJourneySummaryQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', customerJourneySummary?: { __typename?: 'CustomerJourneySummary', customerOrderIndex?: number | null, daysToConversion?: number | null, ready: boolean, firstVisit?: { __typename?: 'CustomerVisit', id: string, landingPage?: any | null, landingPageHtml?: any | null, occurredAt: any, referralCode?: string | null, referralInfoHtml: any, referrerUrl?: any | null, source: string, sourceDescription?: string | null, sourceType?: MarketingTactic | null, marketingEvent?: { __typename?: 'MarketingEvent', marketingChannelType?: MarketingChannel | null, description?: string | null, endedAt?: any | null, id: string, manageUrl?: any | null, previewUrl?: any | null, scheduledToEndAt?: any | null, sourceAndMedium: string, startedAt: any, type: MarketingTactic, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, utmParameters?: { __typename?: 'UTMParameters', campaign?: string | null, content?: string | null, medium?: string | null, source?: string | null, term?: string | null } | null } | null, lastVisit?: { __typename?: 'CustomerVisit', id: string, landingPage?: any | null, landingPageHtml?: any | null, occurredAt: any, referralCode?: string | null, referralInfoHtml: any, referrerUrl?: any | null, source: string, sourceDescription?: string | null, sourceType?: MarketingTactic | null, marketingEvent?: { __typename?: 'MarketingEvent', marketingChannelType?: MarketingChannel | null, description?: string | null, endedAt?: any | null, id: string, manageUrl?: any | null, previewUrl?: any | null, scheduledToEndAt?: any | null, sourceAndMedium: string, startedAt: any, type: MarketingTactic, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, utmParameters?: { __typename?: 'UTMParameters', campaign?: string | null, content?: string | null, medium?: string | null, source?: string | null, term?: string | null } | null } | null, momentsCount?: { __typename?: 'Count', count: number } | null } | null } | null };

export type GetOrderCustomerJourneySummaryMomentsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
}>;


export type GetOrderCustomerJourneySummaryMomentsQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', customerJourneySummary?: { __typename?: 'CustomerJourneySummary', moments?: { __typename?: 'CustomerMomentConnection', edges: Array<{ __typename?: 'CustomerMomentEdge', node: { __typename?: 'CustomerVisit', id: string } }> } | null } | null } | null };

export type CreateOrderRefundMutationVariables = Exact<{
  input: RefundInput;
}>;


export type CreateOrderRefundMutation = { __typename?: 'Mutation', refundCreate?: { __typename?: 'RefundCreatePayload', order?: { __typename?: 'Order', id: string } | null, refund?: { __typename?: 'Refund', id: string, createdAt?: any | null, order: { __typename?: 'Order', id: string }, totalRefundedSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, shopMoney: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type OrderUpdateMutationVariables = Exact<{
  input: OrderInput;
}>;


export type OrderUpdateMutation = { __typename?: 'Mutation', orderUpdate?: { __typename?: 'OrderUpdatePayload', order?: { __typename?: 'Order', id: string, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }> } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type OrderEditBeginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderEditBeginMutation = { __typename?: 'Mutation', orderEditBegin?: { __typename?: 'OrderEditBeginPayload', calculatedOrder?: { __typename?: 'CalculatedOrder', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type OrderEditCommitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderEditCommitMutation = { __typename?: 'Mutation', orderEditCommit?: { __typename?: 'OrderEditCommitPayload', order?: { __typename?: 'Order', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type OrderEditAddVariantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  variantId: Scalars['ID']['input'];
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderEditAddVariantMutation = { __typename?: 'Mutation', orderEditAddVariant?: { __typename?: 'OrderEditAddVariantPayload', calculatedLineItem?: { __typename?: 'CalculatedLineItem', id: string } | null, calculatedOrder?: { __typename?: 'CalculatedOrder', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type OrderEditAddLineItemDiscountMutationVariables = Exact<{
  discount: OrderEditAppliedDiscountInput;
  id: Scalars['ID']['input'];
  lineItemId: Scalars['ID']['input'];
}>;


export type OrderEditAddLineItemDiscountMutation = { __typename?: 'Mutation', orderEditAddLineItemDiscount?: { __typename?: 'OrderEditAddLineItemDiscountPayload', addedDiscountStagedChange?: { __typename?: 'OrderStagedChangeAddLineItemDiscount', id: string } | null, calculatedLineItem?: { __typename?: 'CalculatedLineItem', id: string } | null, calculatedOrder?: { __typename?: 'CalculatedOrder', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetOrderNoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderNoteQuery = { __typename?: 'QueryRoot', order?: { __typename?: 'Order', id: string, note?: string | null } | null };

export type GetCustomerPaymentMethodQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerPaymentMethodQuery = { __typename?: 'QueryRoot', customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, revokedAt?: any | null, revokedReason?: CustomerPaymentMethodRevocationReason | null, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', brand: string, expiresSoon: boolean, expiryMonth: number, expiryYear: number, firstDigits?: string | null, lastDigits: string, maskedNumber: string, name: string, source?: string | null } | { __typename?: 'CustomerPaypalBillingAgreement', inactive: boolean, isRevocable: boolean, paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, inactive: boolean, maskedNumber: string, name: string } | null } | null };

export type CustomerPaymentMethodSendUpdateEmailMutationVariables = Exact<{
  customerPaymentMethodId: Scalars['ID']['input'];
  email?: InputMaybe<EmailInput>;
}>;


export type CustomerPaymentMethodSendUpdateEmailMutation = { __typename?: 'Mutation', customerPaymentMethodSendUpdateEmail?: { __typename?: 'CustomerPaymentMethodSendUpdateEmailPayload', customer?: { __typename?: 'Customer', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerPaymentMethodCreditCardCreateMutationVariables = Exact<{
  billingAddress: MailingAddressInput;
  customerId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
}>;


export type CustomerPaymentMethodCreditCardCreateMutation = { __typename?: 'Mutation', customerPaymentMethodCreditCardCreate?: { __typename?: 'CustomerPaymentMethodCreditCardCreatePayload', customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerPaymentMethodCreditCardUpdateMutationVariables = Exact<{
  billingAddress: MailingAddressInput;
  id: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
}>;


export type CustomerPaymentMethodCreditCardUpdateMutation = { __typename?: 'Mutation', customerPaymentMethodCreditCardUpdate?: { __typename?: 'CustomerPaymentMethodCreditCardUpdatePayload', customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerPaymentMethodRevokeMutationVariables = Exact<{
  customerPaymentMethodId: Scalars['ID']['input'];
}>;


export type CustomerPaymentMethodRevokeMutation = { __typename?: 'Mutation', customerPaymentMethodRevoke?: { __typename?: 'CustomerPaymentMethodRevokePayload', revokedCustomerPaymentMethodId?: string | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerPaymentMethodRemoteCreateMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  remoteReference: CustomerPaymentMethodRemoteInput;
}>;


export type CustomerPaymentMethodRemoteCreateMutation = { __typename?: 'Mutation', customerPaymentMethodRemoteCreate?: { __typename?: 'CustomerPaymentMethodRemoteCreatePayload', customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', name: string, brand: string, lastDigits: string, expiryMonth: number, expiryYear: number } | { __typename?: 'CustomerPaypalBillingAgreement' } | { __typename?: 'CustomerShopPayAgreement' } | null } | null, userErrors: Array<{ __typename?: 'CustomerPaymentMethodRemoteUserError', field?: Array<string> | null, message: string }> } | null };

export type CustomerPaymentMethodPaypalBillingAgreementCreateMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  billingAddress: MailingAddressInput;
  billingAgreementId: Scalars['String']['input'];
}>;


export type CustomerPaymentMethodPaypalBillingAgreementCreateMutation = { __typename?: 'Mutation', customerPaymentMethodPaypalBillingAgreementCreate?: { __typename?: 'CustomerPaymentMethodPaypalBillingAgreementCreatePayload', customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard' } | { __typename?: 'CustomerPaypalBillingAgreement', paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement' } | null } | null } | null };

export type GetProductCollectionsQueryVariables = Exact<{
  productCursor?: InputMaybe<Scalars['String']['input']>;
  collectionCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductCollectionsQuery = { __typename?: 'QueryRoot', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: string, collections: { __typename?: 'CollectionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'CollectionEdge', cursor: string, node: { __typename?: 'Collection', id: string, title: string, updatedAt: any, image?: { __typename?: 'Image', url: any, smallImage: any } | null } }> } } }> } };

export type GetShopCollectionsQueryVariables = Exact<{
  count: Scalars['Int']['input'];
}>;


export type GetShopCollectionsQuery = { __typename?: 'QueryRoot', collections: { __typename?: 'CollectionConnection', edges: Array<{ __typename?: 'CollectionEdge', node: { __typename?: 'Collection', id: string, title: string, handle: string } }> } };

export type GetCollectionByHandleQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type GetCollectionByHandleQuery = { __typename?: 'QueryRoot', collectionByIdentifier?: { __typename?: 'Collection', id: string, title: string, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: string, title: string } }> } } | null };

export type GetProductVariantsQueryVariables = Exact<{
  productsCursor?: InputMaybe<Scalars['String']['input']>;
  productVariantsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductVariantsQuery = { __typename?: 'QueryRoot', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: string, variants: { __typename?: 'ProductVariantConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'ProductVariantEdge', cursor: string, node: { __typename?: 'ProductVariant', id: string, updatedAt: any, taxable: boolean, title: string, price: any, inventoryQuantity?: number | null, inventoryPolicy: ProductVariantInventoryPolicy, inventoryItem: { __typename?: 'InventoryItem', id: string, sku?: string | null, requiresShipping: boolean, tracked: boolean, unitCost?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, measurement: { __typename?: 'InventoryItemMeasurement', id: string, weight?: { __typename?: 'Weight', unit: WeightUnit, value: number } | null } }, deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, name: string } | null, image?: { __typename?: 'Image', url: any, smallImage: any } | null } }> } } }> } };

export type GetProductVariantQueryVariables = Exact<{
  variantId: Scalars['ID']['input'];
}>;


export type GetProductVariantQuery = { __typename?: 'QueryRoot', productVariant?: { __typename?: 'ProductVariant', id: string, title: string, sku?: string | null, inventoryQuantity?: number | null, inventoryPolicy: ProductVariantInventoryPolicy, deliveryProfile?: { __typename?: 'DeliveryProfile', id: string, name: string } | null, inventoryItem: { __typename?: 'InventoryItem', tracked: boolean, requiresShipping: boolean, measurement: { __typename?: 'InventoryItemMeasurement', id: string, weight?: { __typename?: 'Weight', unit: WeightUnit, value: number } | null } } } | null };

export type ProductVariantsBulkUpdateMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  variants: Array<ProductVariantsBulkInput> | ProductVariantsBulkInput;
}>;


export type ProductVariantsBulkUpdateMutation = { __typename?: 'Mutation', productVariantsBulkUpdate?: { __typename?: 'ProductVariantsBulkUpdatePayload', product?: { __typename?: 'Product', id: string } | null, productVariants?: Array<{ __typename?: 'ProductVariant', id: string }> | null, userErrors: Array<{ __typename?: 'ProductVariantsBulkUpdateUserError', field?: Array<string> | null, message: string }> } | null };

export type SmallImageFragmentFragment = { __typename?: 'Product', images: { __typename?: 'ImageConnection', edges: Array<{ __typename?: 'ImageEdge', node: { __typename?: 'Image', url: any, smallImage: any } }> } };

export type GetProductsQueryVariables = Exact<{
  productsCursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'QueryRoot', products: { __typename?: 'ProductConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id: string, updatedAt: any, description: string, title: string, tags: Array<string>, productType: string, images: { __typename?: 'ImageConnection', edges: Array<{ __typename?: 'ImageEdge', node: { __typename?: 'Image', url: any, smallImage: any } }> } } }> } };

export type GetProductHandleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductHandleQuery = { __typename?: 'QueryRoot', product?: { __typename?: 'Product', handle: string } | null };

export type GetProductSmallImageQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductSmallImageQuery = { __typename?: 'QueryRoot', product?: { __typename?: 'Product', images: { __typename?: 'ImageConnection', edges: Array<{ __typename?: 'ImageEdge', node: { __typename?: 'Image', url: any, smallImage: any } }> } } | null };

export type ProductUpdateMutationVariables = Exact<{
  product?: InputMaybe<ProductUpdateInput>;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate?: { __typename?: 'ProductUpdatePayload', product?: { __typename?: 'Product', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetScriptTagsQueryVariables = Exact<{
  src?: InputMaybe<Scalars['URL']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetScriptTagsQuery = { __typename?: 'QueryRoot', scriptTags: { __typename?: 'ScriptTagConnection', edges: Array<{ __typename?: 'ScriptTagEdge', node: { __typename?: 'ScriptTag', id: string } }> } };

export type ScriptTagCreateMutationVariables = Exact<{
  input: ScriptTagInput;
}>;


export type ScriptTagCreateMutation = { __typename?: 'Mutation', scriptTagCreate?: { __typename?: 'ScriptTagCreatePayload', scriptTag?: { __typename?: 'ScriptTag', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type ScriptTagUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ScriptTagInput;
}>;


export type ScriptTagUpdateMutation = { __typename?: 'Mutation', scriptTagUpdate?: { __typename?: 'ScriptTagUpdatePayload', scriptTag?: { __typename?: 'ScriptTag', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type ScriptTagDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ScriptTagDeleteMutation = { __typename?: 'Mutation', scriptTagDelete?: { __typename?: 'ScriptTagDeletePayload', deletedScriptTagId?: string | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type SegmentCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  query: Scalars['String']['input'];
}>;


export type SegmentCreateMutation = { __typename?: 'Mutation', segmentCreate?: { __typename?: 'SegmentCreatePayload', segment?: { __typename?: 'Segment', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetSegmentsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
}>;


export type GetSegmentsQuery = { __typename?: 'QueryRoot', segments: { __typename?: 'SegmentConnection', nodes: Array<{ __typename?: 'Segment', id: string, name: string }> } };

export type SellingPlanFragmentFragment = { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } };

export type SellingPlanGroupFragmentFragment = { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null };

export type GetSellingPlanGroupsQueryVariables = Exact<{
  groupCursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellingPlanGroupsQuery = { __typename?: 'QueryRoot', sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanGroupEdge', cursor: string, node: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } }> } };

export type GetTrendingListSellingPlanGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrendingListSellingPlanGroupQuery = { __typename?: 'QueryRoot', sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', edges: Array<{ __typename?: 'SellingPlanGroupEdge', node: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } }> } };

export type GetAddonSellingPlanGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddonSellingPlanGroupQuery = { __typename?: 'QueryRoot', sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', edges: Array<{ __typename?: 'SellingPlanGroupEdge', node: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } }> } };

export type GetSavedBySellingPlanGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedBySellingPlanGroupsQuery = { __typename?: 'QueryRoot', sellingPlanGroups: { __typename?: 'SellingPlanGroupConnection', edges: Array<{ __typename?: 'SellingPlanGroupEdge', node: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } }> } };

export type GetOnlySellingPlanGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOnlySellingPlanGroupQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } | null };

export type GetSellingPlanGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sellingPlanCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellingPlanGroupQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, sellingPlans: { __typename?: 'SellingPlanConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanEdge', cursor: string, node: { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } }> }, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } | null };

export type SellingPlanGroupSellingPlansWithRateLimitsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type SellingPlanGroupSellingPlansWithRateLimitsQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', sellingPlans: { __typename?: 'SellingPlanConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanEdge', cursor: string, node: { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } }> } } | null, extensions: { __typename?: 'ShopifyGraphQlExtensions', cost: { __typename?: 'ShopifyGraphQlCostExtension', throttleStatus: { __typename?: 'ShopifyGraphQlCostExtensionThrottleStatus', currentlyAvailable: number, maximumAvailable: number, restoreRate: number } } } };

export type GetSellingPlanGroupSellingPlansQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellingPlanGroupSellingPlansQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', sellingPlans: { __typename?: 'SellingPlanConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SellingPlanEdge', cursor: string, node: { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } }> } } | null };

export type GetSellingPlanGroupProductsWithoutPaginationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
}>;


export type GetSellingPlanGroupProductsWithoutPaginationQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: string } }> } } | null };

export type GetSellingPlanGroupVariantsWithoutPaginationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
}>;


export type GetSellingPlanGroupVariantsWithoutPaginationQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', productVariants: { __typename?: 'ProductVariantConnection', edges: Array<{ __typename?: 'ProductVariantEdge', node: { __typename?: 'ProductVariant', id: string } }> } } | null };

export type GetSellingPlanGroupProductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellingPlanGroupProductsQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', products: { __typename?: 'ProductConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'ProductEdge', cursor: string, node: { __typename?: 'Product', id: string } }> } } | null };

export type GetSellingPlanGroupProductVariantsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSellingPlanGroupProductVariantsQuery = { __typename?: 'QueryRoot', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', productVariants: { __typename?: 'ProductVariantConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'ProductVariantEdge', cursor: string, node: { __typename?: 'ProductVariant', id: string, product: { __typename?: 'Product', id: string, handle: string } } }> } } | null };

export type GetSellingPlanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSellingPlanQuery = { __typename?: 'QueryRoot', node?: { __typename?: 'AbandonedCheckout' } | { __typename?: 'AbandonedCheckoutLineItem' } | { __typename?: 'Abandonment' } | { __typename?: 'AddAllProductsOperation' } | { __typename?: 'AdditionalFee' } | { __typename?: 'App' } | { __typename?: 'AppCatalog' } | { __typename?: 'AppCredit' } | { __typename?: 'AppInstallation' } | { __typename?: 'AppPurchaseOneTime' } | { __typename?: 'AppRevenueAttributionRecord' } | { __typename?: 'AppSubscription' } | { __typename?: 'AppUsageRecord' } | { __typename?: 'Article' } | { __typename?: 'BasicEvent' } | { __typename?: 'Blog' } | { __typename?: 'BulkOperation' } | { __typename?: 'BusinessEntity' } | { __typename?: 'CalculatedOrder' } | { __typename?: 'CartTransform' } | { __typename?: 'CashDrawer' } | { __typename?: 'CashManagementCustomReasonCode' } | { __typename?: 'CashManagementDefaultReasonCode' } | { __typename?: 'CashManagementSystemReasonCode' } | { __typename?: 'CashTrackingAdjustment' } | { __typename?: 'CashTrackingSession' } | { __typename?: 'CatalogCsvOperation' } | { __typename?: 'Channel' } | { __typename?: 'ChannelDefinition' } | { __typename?: 'ChannelInformation' } | { __typename?: 'CheckoutAndAccountsConfiguration' } | { __typename?: 'CheckoutAndAccountsConfigurationOverride' } | { __typename?: 'CheckoutProfile' } | { __typename?: 'Collection' } | { __typename?: 'CollectionConditionsSource' } | { __typename?: 'CollectionSubCollectionsSource' } | { __typename?: 'Comment' } | { __typename?: 'CommentEvent' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyContact' } | { __typename?: 'CompanyContactRole' } | { __typename?: 'CompanyContactRoleAssignment' } | { __typename?: 'CompanyLocation' } | { __typename?: 'CompanyLocationCatalog' } | { __typename?: 'CompanyLocationStaffMemberAssignment' } | { __typename?: 'ConsentPolicy' } | { __typename?: 'CurrencyExchangeAdjustment' } | { __typename?: 'Customer' } | { __typename?: 'CustomerAccountAppExtensionPage' } | { __typename?: 'CustomerAccountNativePage' } | { __typename?: 'CustomerPaymentMethod' } | { __typename?: 'CustomerSegmentMembersQuery' } | { __typename?: 'CustomerVisit' } | { __typename?: 'DeliveryCarrierService' } | { __typename?: 'DeliveryCondition' } | { __typename?: 'DeliveryCountry' } | { __typename?: 'DeliveryCustomization' } | { __typename?: 'DeliveryLocationGroup' } | { __typename?: 'DeliveryMethod' } | { __typename?: 'DeliveryMethodDefinition' } | { __typename?: 'DeliveryParticipant' } | { __typename?: 'DeliveryProfile' } | { __typename?: 'DeliveryProfileItem' } | { __typename?: 'DeliveryPromiseParticipant' } | { __typename?: 'DeliveryPromiseProvider' } | { __typename?: 'DeliveryProvince' } | { __typename?: 'DeliveryRateDefinition' } | { __typename?: 'DeliveryZone' } | { __typename?: 'DiscountAutomaticBxgy' } | { __typename?: 'DiscountAutomaticNode' } | { __typename?: 'DiscountCodeNode' } | { __typename?: 'DiscountNode' } | { __typename?: 'DiscountRedeemCodeBulkCreation' } | { __typename?: 'Domain' } | { __typename?: 'DraftOrder' } | { __typename?: 'DraftOrderLineItem' } | { __typename?: 'DraftOrderTag' } | { __typename?: 'Duty' } | { __typename?: 'ExchangeLineItem' } | { __typename?: 'ExchangeV2' } | { __typename?: 'ExternalVideo' } | { __typename?: 'Fulfillment' } | { __typename?: 'FulfillmentConstraintRule' } | { __typename?: 'FulfillmentEvent' } | { __typename?: 'FulfillmentHold' } | { __typename?: 'FulfillmentLineItem' } | { __typename?: 'FulfillmentOrder' } | { __typename?: 'FulfillmentOrderDestination' } | { __typename?: 'FulfillmentOrderLineItem' } | { __typename?: 'FulfillmentOrderMerchantRequest' } | { __typename?: 'GenericFile' } | { __typename?: 'GiftCard' } | { __typename?: 'GiftCardCashOutTransaction' } | { __typename?: 'GiftCardCreditTransaction' } | { __typename?: 'GiftCardDebitTransaction' } | { __typename?: 'IdentityProviderSubject' } | { __typename?: 'InventoryAdjustmentGroup' } | { __typename?: 'InventoryItem' } | { __typename?: 'InventoryItemMeasurement' } | { __typename?: 'InventoryLevel' } | { __typename?: 'InventoryQuantity' } | { __typename?: 'InventoryShipment' } | { __typename?: 'InventoryShipmentLineItem' } | { __typename?: 'InventoryTransfer' } | { __typename?: 'InventoryTransferLineItem' } | { __typename?: 'LineItem' } | { __typename?: 'LineItemGroup' } | { __typename?: 'Location' } | { __typename?: 'MailingAddress' } | { __typename?: 'Market' } | { __typename?: 'MarketCatalog' } | { __typename?: 'MarketRegionCountry' } | { __typename?: 'MarketRegionSubdivision' } | { __typename?: 'MarketWebPresence' } | { __typename?: 'MarketingActivity' } | { __typename?: 'MarketingEvent' } | { __typename?: 'MediaImage' } | { __typename?: 'Menu' } | { __typename?: 'Metafield' } | { __typename?: 'MetafieldDefinition' } | { __typename?: 'Metaobject' } | { __typename?: 'MetaobjectDefinition' } | { __typename?: 'Model3d' } | { __typename?: 'OnlineStoreTheme' } | { __typename?: 'Order' } | { __typename?: 'OrderAdjustment' } | { __typename?: 'OrderAttributionDefinition' } | { __typename?: 'OrderCreateMandatePaymentJobResult' } | { __typename?: 'OrderDisputeSummary' } | { __typename?: 'OrderEditSession' } | { __typename?: 'OrderTransaction' } | { __typename?: 'Page' } | { __typename?: 'PaymentCustomization' } | { __typename?: 'PaymentMandate' } | { __typename?: 'PaymentSchedule' } | { __typename?: 'PaymentTerms' } | { __typename?: 'PaymentTermsTemplate' } | { __typename?: 'PointOfSaleDevice' } | { __typename?: 'PointOfSaleDevicePaymentSession' } | { __typename?: 'PriceList' } | { __typename?: 'PriceRule' } | { __typename?: 'PriceRuleDiscountCode' } | { __typename?: 'Product' } | { __typename?: 'ProductBundleOperation' } | { __typename?: 'ProductDeleteOperation' } | { __typename?: 'ProductDuplicateOperation' } | { __typename?: 'ProductFeed' } | { __typename?: 'ProductOption' } | { __typename?: 'ProductOptionValue' } | { __typename?: 'ProductSetOperation' } | { __typename?: 'ProductTaxonomyNode' } | { __typename?: 'ProductVariant' } | { __typename?: 'ProductVariantComponent' } | { __typename?: 'Publication' } | { __typename?: 'PublicationResourceOperation' } | { __typename?: 'QuantityPriceBreak' } | { __typename?: 'Refund' } | { __typename?: 'RefundShippingLine' } | { __typename?: 'Return' } | { __typename?: 'ReturnLineItem' } | { __typename?: 'ReturnReasonDefinition' } | { __typename?: 'ReturnableFulfillment' } | { __typename?: 'ReverseDelivery' } | { __typename?: 'ReverseDeliveryLineItem' } | { __typename?: 'ReverseFulfillmentOrder' } | { __typename?: 'ReverseFulfillmentOrderDisposition' } | { __typename?: 'ReverseFulfillmentOrderLineItem' } | { __typename?: 'SaleAdditionalFee' } | { __typename?: 'SavedSearch' } | { __typename?: 'ScriptTag' } | { __typename?: 'Segment' } | { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } | { __typename?: 'SellingPlanGroup' } | { __typename?: 'ServerPixel' } | { __typename?: 'ShippingLabel' } | { __typename?: 'ShippingLabelPurchaseResult' } | { __typename?: 'Shop' } | { __typename?: 'ShopAddress' } | { __typename?: 'ShopPolicy' } | { __typename?: 'ShopifyPaymentsAccount' } | { __typename?: 'ShopifyPaymentsBalanceTransaction' } | { __typename?: 'ShopifyPaymentsBankAccount' } | { __typename?: 'ShopifyPaymentsDispute' } | { __typename?: 'ShopifyPaymentsDisputeEvidence' } | { __typename?: 'ShopifyPaymentsDisputeFileUpload' } | { __typename?: 'ShopifyPaymentsDisputeFulfillment' } | { __typename?: 'ShopifyPaymentsPayout' } | { __typename?: 'StaffMember' } | { __typename?: 'StandardMetafieldDefinitionTemplate' } | { __typename?: 'StoreCreditAccount' } | { __typename?: 'StoreCreditAccountCreditTransaction' } | { __typename?: 'StoreCreditAccountDebitRevertTransaction' } | { __typename?: 'StoreCreditAccountDebitTransaction' } | { __typename?: 'StorefrontAccessToken' } | { __typename?: 'SubscriptionBillingAttempt' } | { __typename?: 'SubscriptionContract' } | { __typename?: 'SubscriptionDraft' } | { __typename?: 'TaxonomyAttribute' } | { __typename?: 'TaxonomyCategory' } | { __typename?: 'TaxonomyChoiceListAttribute' } | { __typename?: 'TaxonomyMeasurementAttribute' } | { __typename?: 'TaxonomyValue' } | { __typename?: 'TenderTransaction' } | { __typename?: 'TransactionFee' } | { __typename?: 'UnverifiedReturnLineItem' } | { __typename?: 'UrlRedirect' } | { __typename?: 'UrlRedirectImport' } | { __typename?: 'Validation' } | { __typename?: 'Video' } | { __typename?: 'WebPixel' } | { __typename?: 'WebhookSubscription' } | null };

export type GetSellingPlansQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetSellingPlansQuery = { __typename?: 'QueryRoot', nodes: Array<{ __typename?: 'AbandonedCheckout' } | { __typename?: 'AbandonedCheckoutLineItem' } | { __typename?: 'Abandonment' } | { __typename?: 'AddAllProductsOperation' } | { __typename?: 'AdditionalFee' } | { __typename?: 'App' } | { __typename?: 'AppCatalog' } | { __typename?: 'AppCredit' } | { __typename?: 'AppInstallation' } | { __typename?: 'AppPurchaseOneTime' } | { __typename?: 'AppRevenueAttributionRecord' } | { __typename?: 'AppSubscription' } | { __typename?: 'AppUsageRecord' } | { __typename?: 'Article' } | { __typename?: 'BasicEvent' } | { __typename?: 'Blog' } | { __typename?: 'BulkOperation' } | { __typename?: 'BusinessEntity' } | { __typename?: 'CalculatedOrder' } | { __typename?: 'CartTransform' } | { __typename?: 'CashDrawer' } | { __typename?: 'CashManagementCustomReasonCode' } | { __typename?: 'CashManagementDefaultReasonCode' } | { __typename?: 'CashManagementSystemReasonCode' } | { __typename?: 'CashTrackingAdjustment' } | { __typename?: 'CashTrackingSession' } | { __typename?: 'CatalogCsvOperation' } | { __typename?: 'Channel' } | { __typename?: 'ChannelDefinition' } | { __typename?: 'ChannelInformation' } | { __typename?: 'CheckoutAndAccountsConfiguration' } | { __typename?: 'CheckoutAndAccountsConfigurationOverride' } | { __typename?: 'CheckoutProfile' } | { __typename?: 'Collection' } | { __typename?: 'CollectionConditionsSource' } | { __typename?: 'CollectionSubCollectionsSource' } | { __typename?: 'Comment' } | { __typename?: 'CommentEvent' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyContact' } | { __typename?: 'CompanyContactRole' } | { __typename?: 'CompanyContactRoleAssignment' } | { __typename?: 'CompanyLocation' } | { __typename?: 'CompanyLocationCatalog' } | { __typename?: 'CompanyLocationStaffMemberAssignment' } | { __typename?: 'ConsentPolicy' } | { __typename?: 'CurrencyExchangeAdjustment' } | { __typename?: 'Customer' } | { __typename?: 'CustomerAccountAppExtensionPage' } | { __typename?: 'CustomerAccountNativePage' } | { __typename?: 'CustomerPaymentMethod' } | { __typename?: 'CustomerSegmentMembersQuery' } | { __typename?: 'CustomerVisit' } | { __typename?: 'DeliveryCarrierService' } | { __typename?: 'DeliveryCondition' } | { __typename?: 'DeliveryCountry' } | { __typename?: 'DeliveryCustomization' } | { __typename?: 'DeliveryLocationGroup' } | { __typename?: 'DeliveryMethod' } | { __typename?: 'DeliveryMethodDefinition' } | { __typename?: 'DeliveryParticipant' } | { __typename?: 'DeliveryProfile' } | { __typename?: 'DeliveryProfileItem' } | { __typename?: 'DeliveryPromiseParticipant' } | { __typename?: 'DeliveryPromiseProvider' } | { __typename?: 'DeliveryProvince' } | { __typename?: 'DeliveryRateDefinition' } | { __typename?: 'DeliveryZone' } | { __typename?: 'DiscountAutomaticBxgy' } | { __typename?: 'DiscountAutomaticNode' } | { __typename?: 'DiscountCodeNode' } | { __typename?: 'DiscountNode' } | { __typename?: 'DiscountRedeemCodeBulkCreation' } | { __typename?: 'Domain' } | { __typename?: 'DraftOrder' } | { __typename?: 'DraftOrderLineItem' } | { __typename?: 'DraftOrderTag' } | { __typename?: 'Duty' } | { __typename?: 'ExchangeLineItem' } | { __typename?: 'ExchangeV2' } | { __typename?: 'ExternalVideo' } | { __typename?: 'Fulfillment' } | { __typename?: 'FulfillmentConstraintRule' } | { __typename?: 'FulfillmentEvent' } | { __typename?: 'FulfillmentHold' } | { __typename?: 'FulfillmentLineItem' } | { __typename?: 'FulfillmentOrder' } | { __typename?: 'FulfillmentOrderDestination' } | { __typename?: 'FulfillmentOrderLineItem' } | { __typename?: 'FulfillmentOrderMerchantRequest' } | { __typename?: 'GenericFile' } | { __typename?: 'GiftCard' } | { __typename?: 'GiftCardCashOutTransaction' } | { __typename?: 'GiftCardCreditTransaction' } | { __typename?: 'GiftCardDebitTransaction' } | { __typename?: 'IdentityProviderSubject' } | { __typename?: 'InventoryAdjustmentGroup' } | { __typename?: 'InventoryItem' } | { __typename?: 'InventoryItemMeasurement' } | { __typename?: 'InventoryLevel' } | { __typename?: 'InventoryQuantity' } | { __typename?: 'InventoryShipment' } | { __typename?: 'InventoryShipmentLineItem' } | { __typename?: 'InventoryTransfer' } | { __typename?: 'InventoryTransferLineItem' } | { __typename?: 'LineItem' } | { __typename?: 'LineItemGroup' } | { __typename?: 'Location' } | { __typename?: 'MailingAddress' } | { __typename?: 'Market' } | { __typename?: 'MarketCatalog' } | { __typename?: 'MarketRegionCountry' } | { __typename?: 'MarketRegionSubdivision' } | { __typename?: 'MarketWebPresence' } | { __typename?: 'MarketingActivity' } | { __typename?: 'MarketingEvent' } | { __typename?: 'MediaImage' } | { __typename?: 'Menu' } | { __typename?: 'Metafield' } | { __typename?: 'MetafieldDefinition' } | { __typename?: 'Metaobject' } | { __typename?: 'MetaobjectDefinition' } | { __typename?: 'Model3d' } | { __typename?: 'OnlineStoreTheme' } | { __typename?: 'Order' } | { __typename?: 'OrderAdjustment' } | { __typename?: 'OrderAttributionDefinition' } | { __typename?: 'OrderCreateMandatePaymentJobResult' } | { __typename?: 'OrderDisputeSummary' } | { __typename?: 'OrderEditSession' } | { __typename?: 'OrderTransaction' } | { __typename?: 'Page' } | { __typename?: 'PaymentCustomization' } | { __typename?: 'PaymentMandate' } | { __typename?: 'PaymentSchedule' } | { __typename?: 'PaymentTerms' } | { __typename?: 'PaymentTermsTemplate' } | { __typename?: 'PointOfSaleDevice' } | { __typename?: 'PointOfSaleDevicePaymentSession' } | { __typename?: 'PriceList' } | { __typename?: 'PriceRule' } | { __typename?: 'PriceRuleDiscountCode' } | { __typename?: 'Product' } | { __typename?: 'ProductBundleOperation' } | { __typename?: 'ProductDeleteOperation' } | { __typename?: 'ProductDuplicateOperation' } | { __typename?: 'ProductFeed' } | { __typename?: 'ProductOption' } | { __typename?: 'ProductOptionValue' } | { __typename?: 'ProductSetOperation' } | { __typename?: 'ProductTaxonomyNode' } | { __typename?: 'ProductVariant' } | { __typename?: 'ProductVariantComponent' } | { __typename?: 'Publication' } | { __typename?: 'PublicationResourceOperation' } | { __typename?: 'QuantityPriceBreak' } | { __typename?: 'Refund' } | { __typename?: 'RefundShippingLine' } | { __typename?: 'Return' } | { __typename?: 'ReturnLineItem' } | { __typename?: 'ReturnReasonDefinition' } | { __typename?: 'ReturnableFulfillment' } | { __typename?: 'ReverseDelivery' } | { __typename?: 'ReverseDeliveryLineItem' } | { __typename?: 'ReverseFulfillmentOrder' } | { __typename?: 'ReverseFulfillmentOrderDisposition' } | { __typename?: 'ReverseFulfillmentOrderLineItem' } | { __typename?: 'SaleAdditionalFee' } | { __typename?: 'SavedSearch' } | { __typename?: 'ScriptTag' } | { __typename?: 'Segment' } | { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } | { __typename?: 'SellingPlanGroup' } | { __typename?: 'ServerPixel' } | { __typename?: 'ShippingLabel' } | { __typename?: 'ShippingLabelPurchaseResult' } | { __typename?: 'Shop' } | { __typename?: 'ShopAddress' } | { __typename?: 'ShopPolicy' } | { __typename?: 'ShopifyPaymentsAccount' } | { __typename?: 'ShopifyPaymentsBalanceTransaction' } | { __typename?: 'ShopifyPaymentsBankAccount' } | { __typename?: 'ShopifyPaymentsDispute' } | { __typename?: 'ShopifyPaymentsDisputeEvidence' } | { __typename?: 'ShopifyPaymentsDisputeFileUpload' } | { __typename?: 'ShopifyPaymentsDisputeFulfillment' } | { __typename?: 'ShopifyPaymentsPayout' } | { __typename?: 'StaffMember' } | { __typename?: 'StandardMetafieldDefinitionTemplate' } | { __typename?: 'StoreCreditAccount' } | { __typename?: 'StoreCreditAccountCreditTransaction' } | { __typename?: 'StoreCreditAccountDebitRevertTransaction' } | { __typename?: 'StoreCreditAccountDebitTransaction' } | { __typename?: 'StorefrontAccessToken' } | { __typename?: 'SubscriptionBillingAttempt' } | { __typename?: 'SubscriptionContract' } | { __typename?: 'SubscriptionDraft' } | { __typename?: 'TaxonomyAttribute' } | { __typename?: 'TaxonomyCategory' } | { __typename?: 'TaxonomyChoiceListAttribute' } | { __typename?: 'TaxonomyMeasurementAttribute' } | { __typename?: 'TaxonomyValue' } | { __typename?: 'TenderTransaction' } | { __typename?: 'TransactionFee' } | { __typename?: 'UnverifiedReturnLineItem' } | { __typename?: 'UrlRedirect' } | { __typename?: 'UrlRedirectImport' } | { __typename?: 'Validation' } | { __typename?: 'Video' } | { __typename?: 'WebPixel' } | { __typename?: 'WebhookSubscription' } | null> };

export type SellingPlanGroupCreateMutationVariables = Exact<{
  input: SellingPlanGroupInput;
}>;


export type SellingPlanGroupCreateMutation = { __typename?: 'Mutation', sellingPlanGroupCreate?: { __typename?: 'SellingPlanGroupCreatePayload', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, sellingPlans: { __typename?: 'SellingPlanConnection', edges: Array<{ __typename?: 'SellingPlanEdge', node: { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } }> } } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SellingPlanGroupInput;
}>;


export type SellingPlanGroupUpdateMutation = { __typename?: 'Mutation', sellingPlanGroupUpdate?: { __typename?: 'SellingPlanGroupUpdatePayload', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, sellingPlans: { __typename?: 'SellingPlanConnection', edges: Array<{ __typename?: 'SellingPlanEdge', node: { __typename?: 'SellingPlan', description?: string | null, id: string, name: string, options: Array<string>, category?: SellingPlanCategory | null, metafield?: { __typename?: 'Metafield', value: string } | null, metafield_source_group?: { __typename?: 'Metafield', value: string } | null, pricingPolicies: Array<{ __typename?: 'SellingPlanFixedPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } } | { __typename?: 'SellingPlanRecurringPricingPolicy', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle?: number | null, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number } }>, billingPolicy: { __typename?: 'SellingPlanFixedBillingPolicy' } | { __typename?: 'SellingPlanRecurringBillingPolicy', interval: SellingPlanInterval, intervalCount: number, minCycles?: number | null, maxCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPolicy: { __typename?: 'SellingPlanFixedDeliveryPolicy' } | { __typename?: 'SellingPlanRecurringDeliveryPolicy', cutoff?: number | null, intent: SellingPlanRecurringDeliveryPolicyIntent, interval: SellingPlanInterval, intervalCount: number, preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> } } }> } } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SellingPlanGroupDeleteMutation = { __typename?: 'Mutation', sellingPlanGroupDelete?: { __typename?: 'SellingPlanGroupDeletePayload', deletedSellingPlanGroupId?: string | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type ProductJoinSellingPlanGroupsMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProductJoinSellingPlanGroupsMutation = { __typename?: 'Mutation', productJoinSellingPlanGroups?: { __typename?: 'ProductJoinSellingPlanGroupsPayload', product?: { __typename?: 'Product', id: string } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type ProductVariantJoinSellingPlanGroupsMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProductVariantJoinSellingPlanGroupsMutation = { __typename?: 'Mutation', productVariantJoinSellingPlanGroups?: { __typename?: 'ProductVariantJoinSellingPlanGroupsPayload', productVariant?: { __typename?: 'ProductVariant', id: string } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type ProductLeaveSellingPlanGroupsMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProductLeaveSellingPlanGroupsMutation = { __typename?: 'Mutation', productLeaveSellingPlanGroups?: { __typename?: 'ProductLeaveSellingPlanGroupsPayload', product?: { __typename?: 'Product', id: string } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type ProductVariantLeaveSellingPlanGroupsMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  sellingPlanGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProductVariantLeaveSellingPlanGroupsMutation = { __typename?: 'Mutation', productVariantLeaveSellingPlanGroups?: { __typename?: 'ProductVariantLeaveSellingPlanGroupsPayload', productVariant?: { __typename?: 'ProductVariant', id: string } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupAddProductsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlanGroupAddProductsMutation = { __typename?: 'Mutation', sellingPlanGroupAddProducts?: { __typename?: 'SellingPlanGroupAddProductsPayload', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupAddProductVariantsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlanGroupAddProductVariantsMutation = { __typename?: 'Mutation', sellingPlanGroupAddProductVariants?: { __typename?: 'SellingPlanGroupAddProductVariantsPayload', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, appId?: string | null, description?: string | null, merchantCode: string, name: string, options: Array<string>, summary?: string | null, position?: number | null, productsCount?: { __typename?: 'Count', count: number } | null, productVariantsCount?: { __typename?: 'Count', count: number } | null } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', field?: Array<string> | null, message: string }> } | null };

export type SellingPlansClientUpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SellingPlanGroupInput;
}>;


export type SellingPlansClientUpdateGroupMutation = { __typename?: 'Mutation', sellingPlanGroupUpdate?: { __typename?: 'SellingPlanGroupUpdatePayload', sellingPlanGroup?: { __typename?: 'SellingPlanGroup', id: string, sellingPlans: { __typename?: 'SellingPlanConnection', edges: Array<{ __typename?: 'SellingPlanEdge', node: { __typename?: 'SellingPlan', id: string, name: string } }> } } | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SellingPlansClientAddProductsToGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlansClientAddProductsToGroupMutation = { __typename?: 'Mutation', sellingPlanGroupAddProducts?: { __typename?: 'SellingPlanGroupAddProductsPayload', userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SellingPlansClientAddProductVariantsToGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlansClientAddProductVariantsToGroupMutation = { __typename?: 'Mutation', sellingPlanGroupAddProductVariants?: { __typename?: 'SellingPlanGroupAddProductVariantsPayload', userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupRemoveProductsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlanGroupRemoveProductsMutation = { __typename?: 'Mutation', sellingPlanGroupRemoveProducts?: { __typename?: 'SellingPlanGroupRemoveProductsPayload', removedProductIds?: Array<string> | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SellingPlanGroupRemoveProductVariantsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SellingPlanGroupRemoveProductVariantsMutation = { __typename?: 'Mutation', sellingPlanGroupRemoveProductVariants?: { __typename?: 'SellingPlanGroupRemoveProductVariantsPayload', removedProductVariantIds?: Array<string> | null, userErrors: Array<{ __typename?: 'SellingPlanGroupUserError', code?: SellingPlanGroupUserErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type ProductCreateMutationVariables = Exact<{
  product: ProductCreateInput;
  media?: InputMaybe<Array<CreateMediaInput> | CreateMediaInput>;
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productCreate?: { __typename?: 'ProductCreatePayload', product?: { __typename?: 'Product', id: string, descriptionHtml: any, title: string, status: ProductStatus, variants: { __typename?: 'ProductVariantConnection', edges: Array<{ __typename?: 'ProductVariantEdge', node: { __typename?: 'ProductVariant', id: string } }> } } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'QueryRoot', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationEdge', node: { __typename?: 'Location', id: string, inventoryLevels: { __typename?: 'InventoryLevelConnection', edges: Array<{ __typename?: 'InventoryLevelEdge', node: { __typename?: 'InventoryLevel', id: string, item: { __typename?: 'InventoryItem', id: string, variants?: { __typename?: 'ProductVariantConnection', edges: Array<{ __typename?: 'ProductVariantEdge', node: { __typename?: 'ProductVariant', id: string, title: string } }> } | null } } }> } } }> } };

export type GetShopEligibleForSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopEligibleForSubscriptionsQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', features: { __typename?: 'ShopFeatures', eligibleForSubscriptions: boolean } } };

export type GetShopSubscriptionGatewayEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopSubscriptionGatewayEnabledQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', features: { __typename?: 'ShopFeatures', legacySubscriptionGatewayEnabled: boolean } } };

export type GetShopEligibleForSubscriptionMigrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopEligibleForSubscriptionMigrationQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', features: { __typename?: 'ShopFeatures', eligibleForSubscriptionMigration: boolean } } };

export type GetShopLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopLocalesQuery = { __typename?: 'QueryRoot', shopLocales: Array<{ __typename?: 'ShopLocale', locale: string, name: string, primary: boolean, published: boolean }> };

export type GetShippableCountriesAndCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShippableCountriesAndCurrenciesQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', shipsToCountries: Array<CountryCode>, enabledPresentmentCurrencies: Array<CurrencyCode> } };

export type GetShippableCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShippableCountriesQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', shipsToCountries: Array<CountryCode> } };

export type GetShopCustomerAccountsVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopCustomerAccountsVersionQuery = { __typename?: 'QueryRoot', shop: { __typename?: 'Shop', customerAccountsV2: { __typename?: 'CustomerAccountsV2', customerAccountsVersion: CustomerAccountsVersion } } };

export type GetThemeFilesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filenames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetThemeFilesQuery = { __typename?: 'QueryRoot', theme?: { __typename?: 'OnlineStoreTheme', id: string, name: string, files?: { __typename?: 'OnlineStoreThemeFileConnection', nodes: Array<{ __typename?: 'OnlineStoreThemeFile', filename: string, body: { __typename?: 'OnlineStoreThemeFileBodyBase64' } | { __typename?: 'OnlineStoreThemeFileBodyText', content: string } | { __typename?: 'OnlineStoreThemeFileBodyUrl' } }> } | null } | null };

export type FlowTriggerReceiveMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type FlowTriggerReceiveMutation = { __typename?: 'Mutation', flowTriggerReceive?: { __typename?: 'FlowTriggerReceivePayload', userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetSubscriptionBillingAttemptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubscriptionBillingAttemptQuery = { __typename?: 'QueryRoot', subscriptionBillingAttempt?: { __typename?: 'SubscriptionBillingAttempt', completedAt?: any | null, createdAt: any, id: string, idempotencyKey: string, state: { __typename: 'SubscriptionBillingAttemptActionRequiredState', action: { __typename?: 'SubscriptionBillingAttemptPaymentChallenge', nextActionUrl: any } } | { __typename: 'SubscriptionBillingAttemptFailedState', error: { __typename: 'SubscriptionBillingAttemptGeneralError', generalCode: SubscriptionBillingAttemptGeneralErrorCode } | { __typename: 'SubscriptionBillingAttemptInventoryError', inventoryCode: SubscriptionBillingAttemptInventoryErrorCode } | { __typename: 'SubscriptionBillingAttemptPaymentError', paymentCode: SubscriptionBillingAttemptPaymentErrorCode } | { __typename: 'SubscriptionBillingAttemptUnexpectedError', message: string } } | { __typename: 'SubscriptionBillingAttemptPendingState', processing: boolean } | { __typename: 'SubscriptionBillingAttemptSuccessState', order?: { __typename?: 'Order', id: string } | null }, subscriptionContract: { __typename?: 'SubscriptionContract', id: string } } | null };

export type SubscriptionBillingAttemptCreateMutationVariables = Exact<{
  input: SubscriptionBillingAttemptInput;
  id: Scalars['ID']['input'];
}>;


export type SubscriptionBillingAttemptCreateMutation = { __typename?: 'Mutation', subscriptionBillingAttemptCreate?: { __typename?: 'SubscriptionBillingAttemptCreatePayload', subscriptionBillingAttempt?: { __typename?: 'SubscriptionBillingAttempt', completedAt?: any | null, createdAt: any, id: string, idempotencyKey: string, state: { __typename: 'SubscriptionBillingAttemptActionRequiredState', action: { __typename?: 'SubscriptionBillingAttemptPaymentChallenge', nextActionUrl: any } } | { __typename: 'SubscriptionBillingAttemptFailedState', error: { __typename: 'SubscriptionBillingAttemptGeneralError', generalCode: SubscriptionBillingAttemptGeneralErrorCode } | { __typename: 'SubscriptionBillingAttemptInventoryError', inventoryCode: SubscriptionBillingAttemptInventoryErrorCode } | { __typename: 'SubscriptionBillingAttemptPaymentError', paymentCode: SubscriptionBillingAttemptPaymentErrorCode } | { __typename: 'SubscriptionBillingAttemptUnexpectedError', message: string } } | { __typename: 'SubscriptionBillingAttemptPendingState', processing: boolean } | { __typename: 'SubscriptionBillingAttemptSuccessState', order?: { __typename?: 'Order', id: string } | null }, subscriptionContract: { __typename?: 'SubscriptionContract', id: string } } | null, userErrors: Array<{ __typename?: 'BillingAttemptUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionBillingCycleContractEditMutationVariables = Exact<{
  billingCycleInput: SubscriptionBillingCycleInput;
}>;


export type SubscriptionBillingCycleContractEditMutation = { __typename?: 'Mutation', subscriptionBillingCycleContractEdit?: { __typename?: 'SubscriptionBillingCycleContractEditPayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionBillingCycleContractDraftConcatenateMutationVariables = Exact<{
  concatenatedBillingCycleContracts: Array<SubscriptionBillingCycleInput> | SubscriptionBillingCycleInput;
  draftId: Scalars['ID']['input'];
}>;


export type SubscriptionBillingCycleContractDraftConcatenateMutation = { __typename?: 'Mutation', subscriptionBillingCycleContractDraftConcatenate?: { __typename?: 'SubscriptionBillingCycleContractDraftConcatenatePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionBillingCycleContractDraftCommitMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
}>;


export type SubscriptionBillingCycleContractDraftCommitMutation = { __typename?: 'Mutation', subscriptionBillingCycleContractDraftCommit?: { __typename?: 'SubscriptionBillingCycleContractDraftCommitPayload', userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', field?: Array<string> | null, message: string }> } | null };

export type DeliveryMethodLocalDeliveryFragment = { __typename?: 'SubscriptionDeliveryMethodLocalDelivery', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, localDeliveryOption: { __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption', code?: string | null, description?: string | null, instructions?: string | null, phone: string, presentmentTitle?: string | null, title?: string | null } };

export type DeliveryMethodShippingFragment = { __typename?: 'SubscriptionDeliveryMethodShipping', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, formatted: Array<string>, lastName?: string | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, shippingOption: { __typename?: 'SubscriptionDeliveryMethodShippingOption', code?: string | null, description?: string | null, title?: string | null } };

export type DeliveryMethodPickupFragment = { __typename?: 'SubscriptionDeliveryMethodPickup', pickupOption: { __typename?: 'SubscriptionDeliveryMethodPickupOption', code?: string | null, description?: string | null, presentmentTitle?: string | null, title?: string | null, location: { __typename?: 'Location', activatable: boolean, addressVerified: boolean, deactivatable: boolean, deletable: boolean, fulfillsOnlineOrders: boolean, hasActiveInventory: boolean, hasUnfulfilledOrders: boolean, id: string, isActive: boolean, name: string, shipsInventory: boolean, suggestedAddresses: Array<{ __typename?: 'LocationSuggestedAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: CountryCode | null, formatted: Array<string>, province?: string | null, provinceCode?: string | null, zip?: string | null }>, address: { __typename?: 'LocationAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, formatted: Array<string>, latitude?: number | null, longitude?: number | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } } } };

export type SubscriptionContractQueryFragmentFragment = { __typename?: 'SubscriptionContract', id: string, appAdminUrl?: any | null, createdAt: any, currencyCode: CurrencyCode, lastPaymentStatus?: SubscriptionContractLastPaymentStatus | null, nextBillingDate?: any | null, status: SubscriptionContractSubscriptionStatus, updatedAt: any, billingPolicy: { __typename?: 'SubscriptionBillingPolicy', interval: SellingPlanInterval, intervalCount: number, maxCycles?: number | null, minCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, numberOfOrders: any, updatedAt: any, state: CustomerState, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }> } | null, customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, revokedAt?: any | null, revokedReason?: CustomerPaymentMethodRevocationReason | null, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', brand: string, expiresSoon: boolean, expiryMonth: number, expiryYear: number, firstDigits?: string | null, lastDigits: string, maskedNumber: string, name: string, source?: string | null } | { __typename?: 'CustomerPaypalBillingAgreement', inactive: boolean, isRevocable: boolean, paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, inactive: boolean, maskedNumber: string, name: string } | null } | null, deliveryMethod?: { __typename?: 'SubscriptionDeliveryMethodLocalDelivery', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, localDeliveryOption: { __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption', code?: string | null, description?: string | null, instructions?: string | null, phone: string, presentmentTitle?: string | null, title?: string | null } } | { __typename?: 'SubscriptionDeliveryMethodPickup', pickupOption: { __typename?: 'SubscriptionDeliveryMethodPickupOption', code?: string | null, description?: string | null, presentmentTitle?: string | null, title?: string | null, location: { __typename?: 'Location', activatable: boolean, addressVerified: boolean, deactivatable: boolean, deletable: boolean, fulfillsOnlineOrders: boolean, hasActiveInventory: boolean, hasUnfulfilledOrders: boolean, id: string, isActive: boolean, name: string, shipsInventory: boolean, suggestedAddresses: Array<{ __typename?: 'LocationSuggestedAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: CountryCode | null, formatted: Array<string>, province?: string | null, provinceCode?: string | null, zip?: string | null }>, address: { __typename?: 'LocationAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, formatted: Array<string>, latitude?: number | null, longitude?: number | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } } } } | { __typename?: 'SubscriptionDeliveryMethodShipping', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, formatted: Array<string>, lastName?: string | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, shippingOption: { __typename?: 'SubscriptionDeliveryMethodShippingOption', code?: string | null, description?: string | null, title?: string | null } } | null, deliveryPolicy: { __typename?: 'SubscriptionDeliveryPolicy', interval: SellingPlanInterval, intervalCount: number, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, linesCount?: { __typename?: 'Count', count: number } | null, originOrder?: { __typename?: 'Order', id: string, processedAt: any, name: string } | null };

export type GetSubscriptionContractsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSubscriptionContractsQuery = { __typename?: 'QueryRoot', subscriptionContracts: { __typename?: 'SubscriptionContractConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionContractEdge', cursor: string, node: { __typename?: 'SubscriptionContract', id: string, appAdminUrl?: any | null, createdAt: any, currencyCode: CurrencyCode, lastPaymentStatus?: SubscriptionContractLastPaymentStatus | null, nextBillingDate?: any | null, status: SubscriptionContractSubscriptionStatus, updatedAt: any, billingPolicy: { __typename?: 'SubscriptionBillingPolicy', interval: SellingPlanInterval, intervalCount: number, maxCycles?: number | null, minCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, numberOfOrders: any, updatedAt: any, state: CustomerState, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }> } | null, customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, revokedAt?: any | null, revokedReason?: CustomerPaymentMethodRevocationReason | null, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', brand: string, expiresSoon: boolean, expiryMonth: number, expiryYear: number, firstDigits?: string | null, lastDigits: string, maskedNumber: string, name: string, source?: string | null } | { __typename?: 'CustomerPaypalBillingAgreement', inactive: boolean, isRevocable: boolean, paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, inactive: boolean, maskedNumber: string, name: string } | null } | null, deliveryMethod?: { __typename?: 'SubscriptionDeliveryMethodLocalDelivery', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, localDeliveryOption: { __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption', code?: string | null, description?: string | null, instructions?: string | null, phone: string, presentmentTitle?: string | null, title?: string | null } } | { __typename?: 'SubscriptionDeliveryMethodPickup', pickupOption: { __typename?: 'SubscriptionDeliveryMethodPickupOption', code?: string | null, description?: string | null, presentmentTitle?: string | null, title?: string | null, location: { __typename?: 'Location', activatable: boolean, addressVerified: boolean, deactivatable: boolean, deletable: boolean, fulfillsOnlineOrders: boolean, hasActiveInventory: boolean, hasUnfulfilledOrders: boolean, id: string, isActive: boolean, name: string, shipsInventory: boolean, suggestedAddresses: Array<{ __typename?: 'LocationSuggestedAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: CountryCode | null, formatted: Array<string>, province?: string | null, provinceCode?: string | null, zip?: string | null }>, address: { __typename?: 'LocationAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, formatted: Array<string>, latitude?: number | null, longitude?: number | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } } } } | { __typename?: 'SubscriptionDeliveryMethodShipping', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, formatted: Array<string>, lastName?: string | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, shippingOption: { __typename?: 'SubscriptionDeliveryMethodShippingOption', code?: string | null, description?: string | null, title?: string | null } } | null, deliveryPolicy: { __typename?: 'SubscriptionDeliveryPolicy', interval: SellingPlanInterval, intervalCount: number, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, linesCount?: { __typename?: 'Count', count: number } | null, originOrder?: { __typename?: 'Order', id: string, processedAt: any, name: string } | null } }> } };

export type GetSubscriptionContractsIdsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionContractsIdsQuery = { __typename?: 'QueryRoot', subscriptionContracts: { __typename?: 'SubscriptionContractConnection', edges: Array<{ __typename?: 'SubscriptionContractEdge', cursor: string, node: { __typename?: 'SubscriptionContract', id: string, createdAt: any } }> } };

export type GetSubscriptionContractOrderIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionContractOrderIdsQuery = { __typename?: 'QueryRoot', subscriptionContract?: { __typename?: 'SubscriptionContract', orders: { __typename?: 'OrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'OrderEdge', cursor: string, node: { __typename?: 'Order', id: string } }> } } | null };

export type GetSubscriptionContractsForCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionContractsForCustomerQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', subscriptionContracts: { __typename?: 'SubscriptionContractConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionContractEdge', cursor: string, node: { __typename?: 'SubscriptionContract', id: string, nextBillingDate?: any | null, status: SubscriptionContractSubscriptionStatus, customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string } | null, deliveryPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, linesCount?: { __typename?: 'Count', count: number } | null } }> } } | null };

export type GetSubscriptionContractQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubscriptionContractQuery = { __typename?: 'QueryRoot', subscriptionContract?: { __typename?: 'SubscriptionContract', id: string, appAdminUrl?: any | null, createdAt: any, currencyCode: CurrencyCode, lastPaymentStatus?: SubscriptionContractLastPaymentStatus | null, nextBillingDate?: any | null, status: SubscriptionContractSubscriptionStatus, updatedAt: any, billingPolicy: { __typename?: 'SubscriptionBillingPolicy', interval: SellingPlanInterval, intervalCount: number, maxCycles?: number | null, minCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, numberOfOrders: any, updatedAt: any, state: CustomerState, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null, amountSpent: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, defaultAddress?: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } | null, addresses: Array<{ __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, id: string, lastName?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }> } | null, customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, revokedAt?: any | null, revokedReason?: CustomerPaymentMethodRevocationReason | null, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', brand: string, expiresSoon: boolean, expiryMonth: number, expiryYear: number, firstDigits?: string | null, lastDigits: string, maskedNumber: string, name: string, source?: string | null } | { __typename?: 'CustomerPaypalBillingAgreement', inactive: boolean, isRevocable: boolean, paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, inactive: boolean, maskedNumber: string, name: string } | null } | null, deliveryMethod?: { __typename?: 'SubscriptionDeliveryMethodLocalDelivery', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, localDeliveryOption: { __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption', code?: string | null, description?: string | null, instructions?: string | null, phone: string, presentmentTitle?: string | null, title?: string | null } } | { __typename?: 'SubscriptionDeliveryMethodPickup', pickupOption: { __typename?: 'SubscriptionDeliveryMethodPickupOption', code?: string | null, description?: string | null, presentmentTitle?: string | null, title?: string | null, location: { __typename?: 'Location', activatable: boolean, addressVerified: boolean, deactivatable: boolean, deletable: boolean, fulfillsOnlineOrders: boolean, hasActiveInventory: boolean, hasUnfulfilledOrders: boolean, id: string, isActive: boolean, name: string, shipsInventory: boolean, suggestedAddresses: Array<{ __typename?: 'LocationSuggestedAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: CountryCode | null, formatted: Array<string>, province?: string | null, provinceCode?: string | null, zip?: string | null }>, address: { __typename?: 'LocationAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, formatted: Array<string>, latitude?: number | null, longitude?: number | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } } } } | { __typename?: 'SubscriptionDeliveryMethodShipping', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, formatted: Array<string>, lastName?: string | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, shippingOption: { __typename?: 'SubscriptionDeliveryMethodShippingOption', code?: string | null, description?: string | null, title?: string | null } } | null, deliveryPolicy: { __typename?: 'SubscriptionDeliveryPolicy', interval: SellingPlanInterval, intervalCount: number, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, linesCount?: { __typename?: 'Count', count: number } | null, originOrder?: { __typename?: 'Order', id: string, processedAt: any, name: string } | null } | null };

export type GetSubscriptionContractDiscountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  discountCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionContractDiscountsQuery = { __typename?: 'QueryRoot', subscriptionContract?: { __typename?: 'SubscriptionContract', discounts: { __typename?: 'SubscriptionManualDiscountConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionManualDiscountEdge', cursor: string, node: { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }> } } | null };

export type GetSubscriptionLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetSubscriptionLineItemsQuery = { __typename?: 'QueryRoot', subscriptionContract?: { __typename?: 'SubscriptionContract', lines: { __typename?: 'SubscriptionLineConnection', edges: Array<{ __typename?: 'SubscriptionLineEdge', node: { __typename?: 'SubscriptionLine', id: string, productId?: string | null, title: string, quantity: number, sellingPlanId?: string | null, sellingPlanName?: string | null, variantId?: string | null, variantTitle?: string | null, requiresShipping: boolean, sku?: string | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'SubscriptionDiscountAllocation', amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, discount: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }>, pricingPolicy?: { __typename?: 'SubscriptionPricingPolicy', basePrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cycleDiscounts: Array<{ __typename?: 'SubscriptionCyclePriceAdjustment', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle: number, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number }, computedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }> } | null, currentPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, lineDiscountedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }> } } | null };

export type GetSubscriptionContractLineCountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubscriptionContractLineCountQuery = { __typename?: 'QueryRoot', subscriptionContract?: { __typename?: 'SubscriptionContract', linesCount?: { __typename?: 'Count', count: number } | null } | null };

export type GetSubscriptionDraftShippingOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  deliveryAddress: MailingAddressInput;
}>;


export type GetSubscriptionDraftShippingOptionsQuery = { __typename?: 'QueryRoot', subscriptionDraft?: { __typename?: 'SubscriptionDraft', shippingOptions?: { __typename: 'SubscriptionShippingOptionResultFailure', message?: string | null } | { __typename: 'SubscriptionShippingOptionResultSuccess', shippingOptions: Array<{ __typename?: 'SubscriptionShippingOption', code: string, presentmentTitle?: string | null, title: string, carrierService?: { __typename?: 'DeliveryCarrierService', id: string, name?: string | null } | null, price?: { __typename?: 'MoneyV2', amount: any } | null }> } | null } | null };

export type SubscriptionContractCreateMutationVariables = Exact<{
  input: SubscriptionContractCreateInput;
}>;


export type SubscriptionContractCreateMutation = { __typename?: 'Mutation', subscriptionContractCreate?: { __typename?: 'SubscriptionContractCreatePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionContractUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubscriptionContractUpdateMutation = { __typename?: 'Mutation', subscriptionContractUpdate?: { __typename?: 'SubscriptionContractUpdatePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftUpdateMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  input: SubscriptionDraftInput;
}>;


export type SubscriptionDraftUpdateMutation = { __typename?: 'Mutation', subscriptionDraftUpdate?: { __typename?: 'SubscriptionDraftUpdatePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftLineAddMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  input: SubscriptionLineInput;
}>;


export type SubscriptionDraftLineAddMutation = { __typename?: 'Mutation', subscriptionDraftLineAdd?: { __typename?: 'SubscriptionDraftLineAddPayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, lineAdded?: { __typename?: 'SubscriptionLine', id: string, productId?: string | null, variantId?: string | null } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftLineUpdateMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
  input: SubscriptionLineUpdateInput;
}>;


export type SubscriptionDraftLineUpdateMutation = { __typename?: 'Mutation', subscriptionDraftLineUpdate?: { __typename?: 'SubscriptionDraftLineUpdatePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, lineUpdated?: { __typename?: 'SubscriptionLine', id: string, productId?: string | null, variantId?: string | null, currentPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftLineRemoveMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
}>;


export type SubscriptionDraftLineRemoveMutation = { __typename?: 'Mutation', subscriptionDraftLineRemove?: { __typename?: 'SubscriptionDraftLineRemovePayload', draft?: { __typename?: 'SubscriptionDraft', id: string } | null, lineRemoved?: { __typename?: 'SubscriptionLine', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftCommitMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
}>;


export type SubscriptionDraftCommitMutation = { __typename?: 'Mutation', subscriptionDraftCommit?: { __typename?: 'SubscriptionDraftCommitPayload', contract?: { __typename?: 'SubscriptionContract', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionContractSetNextBillingDateMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type SubscriptionContractSetNextBillingDateMutation = { __typename?: 'Mutation', subscriptionContractSetNextBillingDate?: { __typename?: 'SubscriptionContractSetNextBillingDatePayload', contract?: { __typename?: 'SubscriptionContract', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionContractUserError', field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftDiscountCodeApplyMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  redeemCode: Scalars['String']['input'];
}>;


export type SubscriptionDraftDiscountCodeApplyMutation = { __typename?: 'Mutation', subscriptionDraftDiscountCodeApply?: { __typename?: 'SubscriptionDraftDiscountCodeApplyPayload', appliedDiscount?: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftDiscountAddMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  input: SubscriptionManualDiscountInput;
}>;


export type SubscriptionDraftDiscountAddMutation = { __typename?: 'Mutation', subscriptionDraftDiscountAdd?: { __typename?: 'SubscriptionDraftDiscountAddPayload', discountAdded?: { __typename?: 'SubscriptionManualDiscount', id: string } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftDiscountRemoveMutationVariables = Exact<{
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
}>;


export type SubscriptionDraftDiscountRemoveMutation = { __typename?: 'Mutation', subscriptionDraftDiscountRemove?: { __typename?: 'SubscriptionDraftDiscountRemovePayload', discountRemoved?: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string } | { __typename?: 'SubscriptionManualDiscount', id: string } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftDiscountUpdateMutationVariables = Exact<{
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
  input: SubscriptionManualDiscountInput;
}>;


export type SubscriptionDraftDiscountUpdateMutation = { __typename?: 'Mutation', subscriptionDraftDiscountUpdate?: { __typename?: 'SubscriptionDraftDiscountUpdatePayload', discountUpdated?: { __typename?: 'SubscriptionManualDiscount', id: string } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftFreeShippingDiscountAddMutationVariables = Exact<{
  draftId: Scalars['ID']['input'];
  input: SubscriptionFreeShippingDiscountInput;
}>;


export type SubscriptionDraftFreeShippingDiscountAddMutation = { __typename?: 'Mutation', subscriptionDraftFreeShippingDiscountAdd?: { __typename?: 'SubscriptionDraftFreeShippingDiscountAddPayload', discountAdded?: { __typename?: 'SubscriptionManualDiscount', id: string } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type SubscriptionDraftFreeShippingDiscountUpdateMutationVariables = Exact<{
  discountId: Scalars['ID']['input'];
  draftId: Scalars['ID']['input'];
  input: SubscriptionFreeShippingDiscountInput;
}>;


export type SubscriptionDraftFreeShippingDiscountUpdateMutation = { __typename?: 'Mutation', subscriptionDraftFreeShippingDiscountUpdate?: { __typename?: 'SubscriptionDraftFreeShippingDiscountUpdatePayload', discountUpdated?: { __typename?: 'SubscriptionManualDiscount', id: string } | null, draft?: { __typename?: 'SubscriptionDraft', id: string } | null, userErrors: Array<{ __typename?: 'SubscriptionDraftUserError', code?: SubscriptionDraftErrorCode | null, field?: Array<string> | null, message: string }> } | null };

export type GetSubscriptionDraftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  deliveryAddress?: InputMaybe<MailingAddressInput>;
  includeDeliveryOptions: Scalars['Boolean']['input'];
}>;


export type GetSubscriptionDraftQuery = { __typename?: 'QueryRoot', subscriptionDraft?: { __typename?: 'SubscriptionDraft', id: string, currencyCode: CurrencyCode, nextBillingDate?: any | null, status?: SubscriptionContractSubscriptionStatus | null, billingPolicy: { __typename?: 'SubscriptionBillingPolicy', interval: SellingPlanInterval, intervalCount: number, maxCycles?: number | null, minCycles?: number | null, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, customer: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, numberOfOrders: any, state: CustomerState, defaultEmailAddress?: { __typename?: 'CustomerEmailAddress', emailAddress: string } | null, defaultPhoneNumber?: { __typename?: 'CustomerPhoneNumber', phoneNumber: string } | null }, customerPaymentMethod?: { __typename?: 'CustomerPaymentMethod', id: string, revokedAt?: any | null, revokedReason?: CustomerPaymentMethodRevocationReason | null, instrument?: { __typename?: 'BankAccount' } | { __typename?: 'CustomerCreditCard', brand: string, expiresSoon: boolean, expiryMonth: number, expiryYear: number, firstDigits?: string | null, lastDigits: string, maskedNumber: string, name: string, source?: string | null } | { __typename?: 'CustomerPaypalBillingAgreement', inactive: boolean, isRevocable: boolean, paypalAccountEmail?: string | null } | { __typename?: 'CustomerShopPayAgreement', expiresSoon: boolean, expiryMonth: number, expiryYear: number, lastDigits: string, inactive: boolean, maskedNumber: string, name: string } | null } | null, deliveryMethod?: { __typename?: 'SubscriptionDeliveryMethodLocalDelivery', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, localDeliveryOption: { __typename?: 'SubscriptionDeliveryMethodLocalDeliveryOption', code?: string | null, description?: string | null, instructions?: string | null, phone: string, presentmentTitle?: string | null, title?: string | null } } | { __typename?: 'SubscriptionDeliveryMethodPickup', pickupOption: { __typename?: 'SubscriptionDeliveryMethodPickupOption', code?: string | null, description?: string | null, presentmentTitle?: string | null, title?: string | null, location: { __typename?: 'Location', activatable: boolean, addressVerified: boolean, deactivatable: boolean, deletable: boolean, fulfillsOnlineOrders: boolean, hasActiveInventory: boolean, hasUnfulfilledOrders: boolean, id: string, isActive: boolean, name: string, shipsInventory: boolean, suggestedAddresses: Array<{ __typename?: 'LocationSuggestedAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: CountryCode | null, formatted: Array<string>, province?: string | null, provinceCode?: string | null, zip?: string | null }>, address: { __typename?: 'LocationAddress', address1?: string | null, address2?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, formatted: Array<string>, latitude?: number | null, longitude?: number | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null } } } } | { __typename?: 'SubscriptionDeliveryMethodShipping', address: { __typename?: 'MailingAddress', id: string, address1?: string | null, address2?: string | null, city?: string | null, company?: string | null, coordinatesValidated: boolean, country?: string | null, countryCodeV2?: CountryCode | null, firstName?: string | null, formatted: Array<string>, lastName?: string | null, name?: string | null, phone?: string | null, province?: string | null, provinceCode?: string | null, zip?: string | null }, shippingOption: { __typename?: 'SubscriptionDeliveryMethodShippingOption', code?: string | null, description?: string | null, title?: string | null } } | null, deliveryPolicy: { __typename?: 'SubscriptionDeliveryPolicy', interval: SellingPlanInterval, intervalCount: number, anchors: Array<{ __typename?: 'SellingPlanAnchor', day: number, month?: number | null, type: SellingPlanAnchorType }> }, deliveryPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, deliveryOptions?: { __typename?: 'SubscriptionDeliveryOptionResultFailure', message?: string | null } | { __typename?: 'SubscriptionDeliveryOptionResultSuccess', deliveryOptions: Array<{ __typename?: 'SubscriptionLocalDeliveryOption', code: string, description?: string | null, presentmentTitle?: string | null, title: string, price?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null } | { __typename?: 'SubscriptionPickupOption', code: string, description?: string | null, presentmentTitle?: string | null, title: string, price?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null } | { __typename?: 'SubscriptionShippingOption', code: string, description?: string | null, phoneRequired?: boolean | null, presentmentTitle?: string | null, title: string, price?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null }> } | null } | null };

export type GetSubscriptionDraftDiscountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  discountCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionDraftDiscountsQuery = { __typename?: 'QueryRoot', subscriptionDraft?: { __typename?: 'SubscriptionDraft', discounts: { __typename?: 'SubscriptionDiscountConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionDiscountEdge', cursor: string, node: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }> } } | null };

export type GetSubscriptionDraftLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  lineCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionDraftLineItemsQuery = { __typename?: 'QueryRoot', subscriptionDraft?: { __typename?: 'SubscriptionDraft', lines: { __typename?: 'SubscriptionLineConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionLineEdge', cursor: string, node: { __typename?: 'SubscriptionLine', id: string, productId?: string | null, title: string, quantity: number, sellingPlanId?: string | null, sellingPlanName?: string | null, variantId?: string | null, variantTitle?: string | null, requiresShipping: boolean, sku?: string | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'SubscriptionDiscountAllocation', amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, discount: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }>, pricingPolicy?: { __typename?: 'SubscriptionPricingPolicy', basePrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, cycleDiscounts: Array<{ __typename?: 'SubscriptionCyclePriceAdjustment', adjustmentType: SellingPlanPricingPolicyAdjustmentType, afterCycle: number, adjustmentValue: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | { __typename?: 'SellingPlanPricingPolicyPercentageValue', percentage: number }, computedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }> } | null, currentPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, lineDiscountedPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } }> } } | null };

export type GetSubscriptionDraftLineDiscountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  lineCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubscriptionDraftLineDiscountsQuery = { __typename?: 'QueryRoot', subscriptionDraft?: { __typename?: 'SubscriptionDraft', lines: { __typename?: 'SubscriptionLineConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'SubscriptionLineEdge', cursor: string, node: { __typename?: 'SubscriptionLine', discountAllocations: Array<{ __typename?: 'SubscriptionDiscountAllocation', amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, discount: { __typename?: 'SubscriptionAppliedCodeDiscount', id: string, redeemCode: string, rejectionReason?: SubscriptionDiscountRejectionReason | null } | { __typename?: 'SubscriptionManualDiscount', id: string, recurringCycleLimit?: number | null, rejectionReason?: SubscriptionDiscountRejectionReason | null, targetType: DiscountTargetType, title?: string | null, type: DiscountType, usageCount: number, entitledLines: { __typename?: 'SubscriptionDiscountEntitledLines', all: boolean }, value: { __typename?: 'SubscriptionDiscountFixedAmountValue', appliesOnEachItem: boolean, amount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'SubscriptionDiscountPercentageValue', percentage: number } } }> } }> } } | null };

export type AddTagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddTagsMutation = { __typename?: 'Mutation', tagsAdd?: { __typename?: 'TagsAddPayload', node?: { __typename?: 'AbandonedCheckout', id: string } | { __typename?: 'AbandonedCheckoutLineItem', id: string } | { __typename?: 'Abandonment', id: string } | { __typename?: 'AddAllProductsOperation', id: string } | { __typename?: 'AdditionalFee', id: string } | { __typename?: 'App', id: string } | { __typename?: 'AppCatalog', id: string } | { __typename?: 'AppCredit', id: string } | { __typename?: 'AppInstallation', id: string } | { __typename?: 'AppPurchaseOneTime', id: string } | { __typename?: 'AppRevenueAttributionRecord', id: string } | { __typename?: 'AppSubscription', id: string } | { __typename?: 'AppUsageRecord', id: string } | { __typename?: 'Article', id: string } | { __typename?: 'BasicEvent', id: string } | { __typename?: 'Blog', id: string } | { __typename?: 'BulkOperation', id: string } | { __typename?: 'BusinessEntity', id: string } | { __typename?: 'CalculatedOrder', id: string } | { __typename?: 'CartTransform', id: string } | { __typename?: 'CashDrawer', id: string } | { __typename?: 'CashManagementCustomReasonCode', id: string } | { __typename?: 'CashManagementDefaultReasonCode', id: string } | { __typename?: 'CashManagementSystemReasonCode', id: string } | { __typename?: 'CashTrackingAdjustment', id: string } | { __typename?: 'CashTrackingSession', id: string } | { __typename?: 'CatalogCsvOperation', id: string } | { __typename?: 'Channel', id: string } | { __typename?: 'ChannelDefinition', id: string } | { __typename?: 'ChannelInformation', id: string } | { __typename?: 'CheckoutAndAccountsConfiguration', id: string } | { __typename?: 'CheckoutAndAccountsConfigurationOverride', id: string } | { __typename?: 'CheckoutProfile', id: string } | { __typename?: 'Collection', id: string } | { __typename?: 'CollectionConditionsSource', id: string } | { __typename?: 'CollectionSubCollectionsSource', id: string } | { __typename?: 'Comment', id: string } | { __typename?: 'CommentEvent', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyAddress', id: string } | { __typename?: 'CompanyContact', id: string } | { __typename?: 'CompanyContactRole', id: string } | { __typename?: 'CompanyContactRoleAssignment', id: string } | { __typename?: 'CompanyLocation', id: string } | { __typename?: 'CompanyLocationCatalog', id: string } | { __typename?: 'CompanyLocationStaffMemberAssignment', id: string } | { __typename?: 'ConsentPolicy', id: string } | { __typename?: 'CurrencyExchangeAdjustment', id: string } | { __typename?: 'Customer', id: string } | { __typename?: 'CustomerAccountAppExtensionPage', id: string } | { __typename?: 'CustomerAccountNativePage', id: string } | { __typename?: 'CustomerPaymentMethod', id: string } | { __typename?: 'CustomerSegmentMembersQuery', id: string } | { __typename?: 'CustomerVisit', id: string } | { __typename?: 'DeliveryCarrierService', id: string } | { __typename?: 'DeliveryCondition', id: string } | { __typename?: 'DeliveryCountry', id: string } | { __typename?: 'DeliveryCustomization', id: string } | { __typename?: 'DeliveryLocationGroup', id: string } | { __typename?: 'DeliveryMethod', id: string } | { __typename?: 'DeliveryMethodDefinition', id: string } | { __typename?: 'DeliveryParticipant', id: string } | { __typename?: 'DeliveryProfile', id: string } | { __typename?: 'DeliveryProfileItem', id: string } | { __typename?: 'DeliveryPromiseParticipant', id: string } | { __typename?: 'DeliveryPromiseProvider', id: string } | { __typename?: 'DeliveryProvince', id: string } | { __typename?: 'DeliveryRateDefinition', id: string } | { __typename?: 'DeliveryZone', id: string } | { __typename?: 'DiscountAutomaticBxgy', id: string } | { __typename?: 'DiscountAutomaticNode', id: string } | { __typename?: 'DiscountCodeNode', id: string } | { __typename?: 'DiscountNode', id: string } | { __typename?: 'DiscountRedeemCodeBulkCreation', id: string } | { __typename?: 'Domain', id: string } | { __typename?: 'DraftOrder', id: string } | { __typename?: 'DraftOrderLineItem', id: string } | { __typename?: 'DraftOrderTag', id: string } | { __typename?: 'Duty', id: string } | { __typename?: 'ExchangeLineItem', id: string } | { __typename?: 'ExchangeV2', id: string } | { __typename?: 'ExternalVideo', id: string } | { __typename?: 'Fulfillment', id: string } | { __typename?: 'FulfillmentConstraintRule', id: string } | { __typename?: 'FulfillmentEvent', id: string } | { __typename?: 'FulfillmentHold', id: string } | { __typename?: 'FulfillmentLineItem', id: string } | { __typename?: 'FulfillmentOrder', id: string } | { __typename?: 'FulfillmentOrderDestination', id: string } | { __typename?: 'FulfillmentOrderLineItem', id: string } | { __typename?: 'FulfillmentOrderMerchantRequest', id: string } | { __typename?: 'GenericFile', id: string } | { __typename?: 'GiftCard', id: string } | { __typename?: 'GiftCardCashOutTransaction', id: string } | { __typename?: 'GiftCardCreditTransaction', id: string } | { __typename?: 'GiftCardDebitTransaction', id: string } | { __typename?: 'IdentityProviderSubject', id: string } | { __typename?: 'InventoryAdjustmentGroup', id: string } | { __typename?: 'InventoryItem', id: string } | { __typename?: 'InventoryItemMeasurement', id: string } | { __typename?: 'InventoryLevel', id: string } | { __typename?: 'InventoryQuantity', id: string } | { __typename?: 'InventoryShipment', id: string } | { __typename?: 'InventoryShipmentLineItem', id: string } | { __typename?: 'InventoryTransfer', id: string } | { __typename?: 'InventoryTransferLineItem', id: string } | { __typename?: 'LineItem', id: string } | { __typename?: 'LineItemGroup', id: string } | { __typename?: 'Location', id: string } | { __typename?: 'MailingAddress', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'MarketCatalog', id: string } | { __typename?: 'MarketRegionCountry', id: string } | { __typename?: 'MarketRegionSubdivision', id: string } | { __typename?: 'MarketWebPresence', id: string } | { __typename?: 'MarketingActivity', id: string } | { __typename?: 'MarketingEvent', id: string } | { __typename?: 'MediaImage', id: string } | { __typename?: 'Menu', id: string } | { __typename?: 'Metafield', id: string } | { __typename?: 'MetafieldDefinition', id: string } | { __typename?: 'Metaobject', id: string } | { __typename?: 'MetaobjectDefinition', id: string } | { __typename?: 'Model3d', id: string } | { __typename?: 'OnlineStoreTheme', id: string } | { __typename?: 'Order', id: string } | { __typename?: 'OrderAdjustment', id: string } | { __typename?: 'OrderAttributionDefinition', id: string } | { __typename?: 'OrderCreateMandatePaymentJobResult', id: string } | { __typename?: 'OrderDisputeSummary', id: string } | { __typename?: 'OrderEditSession', id: string } | { __typename?: 'OrderTransaction', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaymentCustomization', id: string } | { __typename?: 'PaymentMandate', id: string } | { __typename?: 'PaymentSchedule', id: string } | { __typename?: 'PaymentTerms', id: string } | { __typename?: 'PaymentTermsTemplate', id: string } | { __typename?: 'PointOfSaleDevice', id: string } | { __typename?: 'PointOfSaleDevicePaymentSession', id: string } | { __typename?: 'PriceList', id: string } | { __typename?: 'PriceRule', id: string } | { __typename?: 'PriceRuleDiscountCode', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'ProductBundleOperation', id: string } | { __typename?: 'ProductDeleteOperation', id: string } | { __typename?: 'ProductDuplicateOperation', id: string } | { __typename?: 'ProductFeed', id: string } | { __typename?: 'ProductOption', id: string } | { __typename?: 'ProductOptionValue', id: string } | { __typename?: 'ProductSetOperation', id: string } | { __typename?: 'ProductTaxonomyNode', id: string } | { __typename?: 'ProductVariant', id: string } | { __typename?: 'ProductVariantComponent', id: string } | { __typename?: 'Publication', id: string } | { __typename?: 'PublicationResourceOperation', id: string } | { __typename?: 'QuantityPriceBreak', id: string } | { __typename?: 'Refund', id: string } | { __typename?: 'RefundShippingLine', id: string } | { __typename?: 'Return', id: string } | { __typename?: 'ReturnLineItem', id: string } | { __typename?: 'ReturnReasonDefinition', id: string } | { __typename?: 'ReturnableFulfillment', id: string } | { __typename?: 'ReverseDelivery', id: string } | { __typename?: 'ReverseDeliveryLineItem', id: string } | { __typename?: 'ReverseFulfillmentOrder', id: string } | { __typename?: 'ReverseFulfillmentOrderDisposition', id: string } | { __typename?: 'ReverseFulfillmentOrderLineItem', id: string } | { __typename?: 'SaleAdditionalFee', id: string } | { __typename?: 'SavedSearch', id: string } | { __typename?: 'ScriptTag', id: string } | { __typename?: 'Segment', id: string } | { __typename?: 'SellingPlan', id: string } | { __typename?: 'SellingPlanGroup', id: string } | { __typename?: 'ServerPixel', id: string } | { __typename?: 'ShippingLabel', id: string } | { __typename?: 'ShippingLabelPurchaseResult', id: string } | { __typename?: 'Shop', id: string } | { __typename?: 'ShopAddress', id: string } | { __typename?: 'ShopPolicy', id: string } | { __typename?: 'ShopifyPaymentsAccount', id: string } | { __typename?: 'ShopifyPaymentsBalanceTransaction', id: string } | { __typename?: 'ShopifyPaymentsBankAccount', id: string } | { __typename?: 'ShopifyPaymentsDispute', id: string } | { __typename?: 'ShopifyPaymentsDisputeEvidence', id: string } | { __typename?: 'ShopifyPaymentsDisputeFileUpload', id: string } | { __typename?: 'ShopifyPaymentsDisputeFulfillment', id: string } | { __typename?: 'ShopifyPaymentsPayout', id: string } | { __typename?: 'StaffMember', id: string } | { __typename?: 'StandardMetafieldDefinitionTemplate', id: string } | { __typename?: 'StoreCreditAccount', id: string } | { __typename?: 'StoreCreditAccountCreditTransaction', id: string } | { __typename?: 'StoreCreditAccountDebitRevertTransaction', id: string } | { __typename?: 'StoreCreditAccountDebitTransaction', id: string } | { __typename?: 'StorefrontAccessToken', id: string } | { __typename?: 'SubscriptionBillingAttempt', id: string } | { __typename?: 'SubscriptionContract', id: string } | { __typename?: 'SubscriptionDraft', id: string } | { __typename?: 'TaxonomyAttribute', id: string } | { __typename?: 'TaxonomyCategory', id: string } | { __typename?: 'TaxonomyChoiceListAttribute', id: string } | { __typename?: 'TaxonomyMeasurementAttribute', id: string } | { __typename?: 'TaxonomyValue', id: string } | { __typename?: 'TenderTransaction', id: string } | { __typename?: 'TransactionFee', id: string } | { __typename?: 'UnverifiedReturnLineItem', id: string } | { __typename?: 'UrlRedirect', id: string } | { __typename?: 'UrlRedirectImport', id: string } | { __typename?: 'Validation', id: string } | { __typename?: 'Video', id: string } | { __typename?: 'WebPixel', id: string } | { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type RemoveTagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveTagsMutation = { __typename?: 'Mutation', tagsRemove?: { __typename?: 'TagsRemovePayload', node?: { __typename?: 'AbandonedCheckout', id: string } | { __typename?: 'AbandonedCheckoutLineItem', id: string } | { __typename?: 'Abandonment', id: string } | { __typename?: 'AddAllProductsOperation', id: string } | { __typename?: 'AdditionalFee', id: string } | { __typename?: 'App', id: string } | { __typename?: 'AppCatalog', id: string } | { __typename?: 'AppCredit', id: string } | { __typename?: 'AppInstallation', id: string } | { __typename?: 'AppPurchaseOneTime', id: string } | { __typename?: 'AppRevenueAttributionRecord', id: string } | { __typename?: 'AppSubscription', id: string } | { __typename?: 'AppUsageRecord', id: string } | { __typename?: 'Article', id: string } | { __typename?: 'BasicEvent', id: string } | { __typename?: 'Blog', id: string } | { __typename?: 'BulkOperation', id: string } | { __typename?: 'BusinessEntity', id: string } | { __typename?: 'CalculatedOrder', id: string } | { __typename?: 'CartTransform', id: string } | { __typename?: 'CashDrawer', id: string } | { __typename?: 'CashManagementCustomReasonCode', id: string } | { __typename?: 'CashManagementDefaultReasonCode', id: string } | { __typename?: 'CashManagementSystemReasonCode', id: string } | { __typename?: 'CashTrackingAdjustment', id: string } | { __typename?: 'CashTrackingSession', id: string } | { __typename?: 'CatalogCsvOperation', id: string } | { __typename?: 'Channel', id: string } | { __typename?: 'ChannelDefinition', id: string } | { __typename?: 'ChannelInformation', id: string } | { __typename?: 'CheckoutAndAccountsConfiguration', id: string } | { __typename?: 'CheckoutAndAccountsConfigurationOverride', id: string } | { __typename?: 'CheckoutProfile', id: string } | { __typename?: 'Collection', id: string } | { __typename?: 'CollectionConditionsSource', id: string } | { __typename?: 'CollectionSubCollectionsSource', id: string } | { __typename?: 'Comment', id: string } | { __typename?: 'CommentEvent', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'CompanyAddress', id: string } | { __typename?: 'CompanyContact', id: string } | { __typename?: 'CompanyContactRole', id: string } | { __typename?: 'CompanyContactRoleAssignment', id: string } | { __typename?: 'CompanyLocation', id: string } | { __typename?: 'CompanyLocationCatalog', id: string } | { __typename?: 'CompanyLocationStaffMemberAssignment', id: string } | { __typename?: 'ConsentPolicy', id: string } | { __typename?: 'CurrencyExchangeAdjustment', id: string } | { __typename?: 'Customer', id: string } | { __typename?: 'CustomerAccountAppExtensionPage', id: string } | { __typename?: 'CustomerAccountNativePage', id: string } | { __typename?: 'CustomerPaymentMethod', id: string } | { __typename?: 'CustomerSegmentMembersQuery', id: string } | { __typename?: 'CustomerVisit', id: string } | { __typename?: 'DeliveryCarrierService', id: string } | { __typename?: 'DeliveryCondition', id: string } | { __typename?: 'DeliveryCountry', id: string } | { __typename?: 'DeliveryCustomization', id: string } | { __typename?: 'DeliveryLocationGroup', id: string } | { __typename?: 'DeliveryMethod', id: string } | { __typename?: 'DeliveryMethodDefinition', id: string } | { __typename?: 'DeliveryParticipant', id: string } | { __typename?: 'DeliveryProfile', id: string } | { __typename?: 'DeliveryProfileItem', id: string } | { __typename?: 'DeliveryPromiseParticipant', id: string } | { __typename?: 'DeliveryPromiseProvider', id: string } | { __typename?: 'DeliveryProvince', id: string } | { __typename?: 'DeliveryRateDefinition', id: string } | { __typename?: 'DeliveryZone', id: string } | { __typename?: 'DiscountAutomaticBxgy', id: string } | { __typename?: 'DiscountAutomaticNode', id: string } | { __typename?: 'DiscountCodeNode', id: string } | { __typename?: 'DiscountNode', id: string } | { __typename?: 'DiscountRedeemCodeBulkCreation', id: string } | { __typename?: 'Domain', id: string } | { __typename?: 'DraftOrder', id: string } | { __typename?: 'DraftOrderLineItem', id: string } | { __typename?: 'DraftOrderTag', id: string } | { __typename?: 'Duty', id: string } | { __typename?: 'ExchangeLineItem', id: string } | { __typename?: 'ExchangeV2', id: string } | { __typename?: 'ExternalVideo', id: string } | { __typename?: 'Fulfillment', id: string } | { __typename?: 'FulfillmentConstraintRule', id: string } | { __typename?: 'FulfillmentEvent', id: string } | { __typename?: 'FulfillmentHold', id: string } | { __typename?: 'FulfillmentLineItem', id: string } | { __typename?: 'FulfillmentOrder', id: string } | { __typename?: 'FulfillmentOrderDestination', id: string } | { __typename?: 'FulfillmentOrderLineItem', id: string } | { __typename?: 'FulfillmentOrderMerchantRequest', id: string } | { __typename?: 'GenericFile', id: string } | { __typename?: 'GiftCard', id: string } | { __typename?: 'GiftCardCashOutTransaction', id: string } | { __typename?: 'GiftCardCreditTransaction', id: string } | { __typename?: 'GiftCardDebitTransaction', id: string } | { __typename?: 'IdentityProviderSubject', id: string } | { __typename?: 'InventoryAdjustmentGroup', id: string } | { __typename?: 'InventoryItem', id: string } | { __typename?: 'InventoryItemMeasurement', id: string } | { __typename?: 'InventoryLevel', id: string } | { __typename?: 'InventoryQuantity', id: string } | { __typename?: 'InventoryShipment', id: string } | { __typename?: 'InventoryShipmentLineItem', id: string } | { __typename?: 'InventoryTransfer', id: string } | { __typename?: 'InventoryTransferLineItem', id: string } | { __typename?: 'LineItem', id: string } | { __typename?: 'LineItemGroup', id: string } | { __typename?: 'Location', id: string } | { __typename?: 'MailingAddress', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'MarketCatalog', id: string } | { __typename?: 'MarketRegionCountry', id: string } | { __typename?: 'MarketRegionSubdivision', id: string } | { __typename?: 'MarketWebPresence', id: string } | { __typename?: 'MarketingActivity', id: string } | { __typename?: 'MarketingEvent', id: string } | { __typename?: 'MediaImage', id: string } | { __typename?: 'Menu', id: string } | { __typename?: 'Metafield', id: string } | { __typename?: 'MetafieldDefinition', id: string } | { __typename?: 'Metaobject', id: string } | { __typename?: 'MetaobjectDefinition', id: string } | { __typename?: 'Model3d', id: string } | { __typename?: 'OnlineStoreTheme', id: string } | { __typename?: 'Order', id: string } | { __typename?: 'OrderAdjustment', id: string } | { __typename?: 'OrderAttributionDefinition', id: string } | { __typename?: 'OrderCreateMandatePaymentJobResult', id: string } | { __typename?: 'OrderDisputeSummary', id: string } | { __typename?: 'OrderEditSession', id: string } | { __typename?: 'OrderTransaction', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaymentCustomization', id: string } | { __typename?: 'PaymentMandate', id: string } | { __typename?: 'PaymentSchedule', id: string } | { __typename?: 'PaymentTerms', id: string } | { __typename?: 'PaymentTermsTemplate', id: string } | { __typename?: 'PointOfSaleDevice', id: string } | { __typename?: 'PointOfSaleDevicePaymentSession', id: string } | { __typename?: 'PriceList', id: string } | { __typename?: 'PriceRule', id: string } | { __typename?: 'PriceRuleDiscountCode', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'ProductBundleOperation', id: string } | { __typename?: 'ProductDeleteOperation', id: string } | { __typename?: 'ProductDuplicateOperation', id: string } | { __typename?: 'ProductFeed', id: string } | { __typename?: 'ProductOption', id: string } | { __typename?: 'ProductOptionValue', id: string } | { __typename?: 'ProductSetOperation', id: string } | { __typename?: 'ProductTaxonomyNode', id: string } | { __typename?: 'ProductVariant', id: string } | { __typename?: 'ProductVariantComponent', id: string } | { __typename?: 'Publication', id: string } | { __typename?: 'PublicationResourceOperation', id: string } | { __typename?: 'QuantityPriceBreak', id: string } | { __typename?: 'Refund', id: string } | { __typename?: 'RefundShippingLine', id: string } | { __typename?: 'Return', id: string } | { __typename?: 'ReturnLineItem', id: string } | { __typename?: 'ReturnReasonDefinition', id: string } | { __typename?: 'ReturnableFulfillment', id: string } | { __typename?: 'ReverseDelivery', id: string } | { __typename?: 'ReverseDeliveryLineItem', id: string } | { __typename?: 'ReverseFulfillmentOrder', id: string } | { __typename?: 'ReverseFulfillmentOrderDisposition', id: string } | { __typename?: 'ReverseFulfillmentOrderLineItem', id: string } | { __typename?: 'SaleAdditionalFee', id: string } | { __typename?: 'SavedSearch', id: string } | { __typename?: 'ScriptTag', id: string } | { __typename?: 'Segment', id: string } | { __typename?: 'SellingPlan', id: string } | { __typename?: 'SellingPlanGroup', id: string } | { __typename?: 'ServerPixel', id: string } | { __typename?: 'ShippingLabel', id: string } | { __typename?: 'ShippingLabelPurchaseResult', id: string } | { __typename?: 'Shop', id: string } | { __typename?: 'ShopAddress', id: string } | { __typename?: 'ShopPolicy', id: string } | { __typename?: 'ShopifyPaymentsAccount', id: string } | { __typename?: 'ShopifyPaymentsBalanceTransaction', id: string } | { __typename?: 'ShopifyPaymentsBankAccount', id: string } | { __typename?: 'ShopifyPaymentsDispute', id: string } | { __typename?: 'ShopifyPaymentsDisputeEvidence', id: string } | { __typename?: 'ShopifyPaymentsDisputeFileUpload', id: string } | { __typename?: 'ShopifyPaymentsDisputeFulfillment', id: string } | { __typename?: 'ShopifyPaymentsPayout', id: string } | { __typename?: 'StaffMember', id: string } | { __typename?: 'StandardMetafieldDefinitionTemplate', id: string } | { __typename?: 'StoreCreditAccount', id: string } | { __typename?: 'StoreCreditAccountCreditTransaction', id: string } | { __typename?: 'StoreCreditAccountDebitRevertTransaction', id: string } | { __typename?: 'StoreCreditAccountDebitTransaction', id: string } | { __typename?: 'StorefrontAccessToken', id: string } | { __typename?: 'SubscriptionBillingAttempt', id: string } | { __typename?: 'SubscriptionContract', id: string } | { __typename?: 'SubscriptionDraft', id: string } | { __typename?: 'TaxonomyAttribute', id: string } | { __typename?: 'TaxonomyCategory', id: string } | { __typename?: 'TaxonomyChoiceListAttribute', id: string } | { __typename?: 'TaxonomyMeasurementAttribute', id: string } | { __typename?: 'TaxonomyValue', id: string } | { __typename?: 'TenderTransaction', id: string } | { __typename?: 'TransactionFee', id: string } | { __typename?: 'UnverifiedReturnLineItem', id: string } | { __typename?: 'UrlRedirect', id: string } | { __typename?: 'UrlRedirectImport', id: string } | { __typename?: 'Validation', id: string } | { __typename?: 'Video', id: string } | { __typename?: 'WebPixel', id: string } | { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type GetWebhookSubscriptionsQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWebhookSubscriptionsQuery = { __typename?: 'QueryRoot', webhookSubscriptions: { __typename?: 'WebhookSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'WebhookSubscriptionEdge', cursor: string, node: { __typename?: 'WebhookSubscription', id: string, topic: WebhookSubscriptionTopic, uri: string, endpoint: { __typename?: 'WebhookEventBridgeEndpoint', arn: any } | { __typename?: 'WebhookHttpEndpoint', callbackUrl: any } | { __typename?: 'WebhookPubSubEndpoint', pubSubProject: string, pubSubTopic: string } } }> } };

export type GetWebhookSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWebhookSubscriptionQuery = { __typename?: 'QueryRoot', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string, format: WebhookSubscriptionFormat, topic: WebhookSubscriptionTopic, includeFields: Array<string>, uri: string, endpoint: { __typename?: 'WebhookEventBridgeEndpoint', arn: any } | { __typename?: 'WebhookHttpEndpoint', callbackUrl: any } | { __typename?: 'WebhookPubSubEndpoint', pubSubProject: string, pubSubTopic: string } } | null };

export type WebhookSubscriptionCreateMutationVariables = Exact<{
  topic: WebhookSubscriptionTopic;
  webhookSubscription: WebhookSubscriptionInput;
}>;


export type WebhookSubscriptionCreateMutation = { __typename?: 'Mutation', webhookSubscriptionCreate?: { __typename?: 'WebhookSubscriptionCreatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type EventBridgeWebhookSubscriptionCreateMutationVariables = Exact<{
  topic: WebhookSubscriptionTopic;
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
}>;


export type EventBridgeWebhookSubscriptionCreateMutation = { __typename?: 'Mutation', eventBridgeWebhookSubscriptionCreate?: { __typename?: 'EventBridgeWebhookSubscriptionCreatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type PubSubWebhookSubscriptionCreateMutationVariables = Exact<{
  topic: WebhookSubscriptionTopic;
  webhookSubscription: PubSubWebhookSubscriptionInput;
}>;


export type PubSubWebhookSubscriptionCreateMutation = { __typename?: 'Mutation', pubSubWebhookSubscriptionCreate?: { __typename?: 'PubSubWebhookSubscriptionCreatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'PubSubWebhookSubscriptionCreateUserError', field?: Array<string> | null, message: string }> } | null };

export type WebhookSubscriptionUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  webhookSubscription: WebhookSubscriptionInput;
}>;


export type WebhookSubscriptionUpdateMutation = { __typename?: 'Mutation', webhookSubscriptionUpdate?: { __typename?: 'WebhookSubscriptionUpdatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type EventBridgeWebhookSubscriptionUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
}>;


export type EventBridgeWebhookSubscriptionUpdateMutation = { __typename?: 'Mutation', eventBridgeWebhookSubscriptionUpdate?: { __typename?: 'EventBridgeWebhookSubscriptionUpdatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export type PubSubWebhookSubscriptionUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  webhookSubscription: PubSubWebhookSubscriptionInput;
}>;


export type PubSubWebhookSubscriptionUpdateMutation = { __typename?: 'Mutation', pubSubWebhookSubscriptionUpdate?: { __typename?: 'PubSubWebhookSubscriptionUpdatePayload', webhookSubscription?: { __typename?: 'WebhookSubscription', id: string } | null, userErrors: Array<{ __typename?: 'PubSubWebhookSubscriptionUpdateUserError', field?: Array<string> | null, message: string }> } | null };

export type WebhookSubscriptionDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WebhookSubscriptionDeleteMutation = { __typename?: 'Mutation', webhookSubscriptionDelete?: { __typename?: 'WebhookSubscriptionDeletePayload', deletedWebhookSubscriptionId?: string | null, userErrors: Array<{ __typename?: 'UserError', field?: Array<string> | null, message: string }> } | null };

export const AppSubscriptionFragment = gql`
    fragment AppSubscriptionFragment on AppSubscription {
  id
  createdAt
  currentPeriodEnd
  lineItems {
    id
    plan {
      pricingDetails {
        ... on AppRecurringPricing {
          interval
          price {
            amount
            currencyCode
          }
        }
        ... on AppUsagePricing {
          balanceUsed {
            amount
            currencyCode
          }
          cappedAmount {
            amount
            currencyCode
          }
          interval
          terms
        }
      }
    }
  }
  name
  returnUrl
  status
  trialDays
}
    `;
export const MailingAddressFragment = gql`
    fragment MailingAddressFragment on MailingAddress {
  address1
  address2
  city
  company
  country
  countryCodeV2
  firstName
  id
  lastName
  latitude
  longitude
  name
  phone
  province
  provinceCode
  zip
}
    `;
export const CustomerFragment = gql`
    fragment CustomerFragment on Customer {
  addresses {
    ...MailingAddressFragment
  }
  createdAt
  defaultAddress {
    ...MailingAddressFragment
  }
  defaultEmailAddress {
    emailAddress
  }
  defaultPhoneNumber {
    phoneNumber
  }
  email
  firstName
  id
  lastName
  numberOfOrders
  state
  phone
  amountSpent {
    amount
    currencyCode
  }
  updatedAt
}
    ${MailingAddressFragment}`;
export const DeliveryProfileFragment = gql`
    fragment DeliveryProfileFragment on DeliveryProfile {
  activeMethodDefinitionsCount
  default
  id
  locationsWithoutRatesCount
  name
  originLocationCount
  productVariantsCount {
    count
  }
  profileLocationGroups {
    countriesInAnyZone {
      country {
        id
      }
      zone
    }
    locationGroup {
      id
    }
  }
  unassignedLocations {
    id
    name
  }
  zoneCountryCount
}
    `;
export const LocationFragment = gql`
    fragment LocationFragment on Location {
  id
  name
}
    `;
export const DeliveryProfileLocationGroupZoneFragment = gql`
    fragment DeliveryProfileLocationGroupZoneFragment on DeliveryLocationGroupZone {
  methodDefinitionCounts {
    participantDefinitionsCount
    rateDefinitionsCount
  }
  zone {
    id
    name
    countries {
      code {
        countryCode
        restOfWorld
      }
      id
      name
      provinces {
        code
        id
        name
      }
    }
  }
}
    `;
export const DeliveryMethodDefinitionFragment = gql`
    fragment DeliveryMethodDefinitionFragment on DeliveryMethodDefinition {
  active
  description
  id
  methodConditions {
    conditionCriteria {
      ... on MoneyV2 {
        currencyCode
        amount
      }
      ... on Weight {
        unit
        value
      }
    }
    field
    id
    operator
  }
  name
  rateProvider {
    ... on DeliveryParticipant {
      id
    }
    ... on DeliveryRateDefinition {
      id
      price {
        currencyCode
        amount
      }
    }
  }
}
    `;
export const DiscountCodeFreeShippingFragment = gql`
    fragment DiscountCodeFreeShippingFragment on DiscountCodeFreeShipping {
  appliesOnSubscription
  title
}
    `;
export const DiscountCodeBasicFragment = gql`
    fragment DiscountCodeBasicFragment on DiscountCodeBasic {
  appliesOncePerCustomer
  asyncUsageCount
  customerGets {
    appliesOnSubscription
    value {
      ... on DiscountAmount {
        amount {
          amount
        }
      }
      ... on DiscountPercentage {
        percentage
      }
      ... on DiscountOnQuantity {
        effect {
          ... on DiscountPercentage {
            percentage
          }
        }
        quantity {
          quantity
        }
      }
    }
  }
}
    `;
export const DraftOrderInnerOrderFragment = gql`
    fragment DraftOrderInnerOrderFragment on Order {
  id
  name
  shippingLine {
    originalPriceSet {
      shopMoney {
        amount
        currencyCode
      }
    }
    shippingRateHandle
    title
  }
  totalTaxSet {
    shopMoney {
      amount
      currencyCode
    }
  }
  taxLines {
    priceSet {
      shopMoney {
        amount
        currencyCode
      }
    }
    rate
    title
  }
  lineItems(first: 20) {
    edges {
      node {
        id
        originalUnitPriceSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        discountedTotalSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        quantity
        requiresShipping
        sku
        title
        variantTitle
        variant {
          id
        }
      }
    }
  }
}
    `;
export const SubscriptionAppliedCodeDiscountFragment = gql`
    fragment SubscriptionAppliedCodeDiscountFragment on SubscriptionAppliedCodeDiscount {
  id
  redeemCode
  rejectionReason
}
    `;
export const SubscriptionManualDiscountFragment = gql`
    fragment SubscriptionManualDiscountFragment on SubscriptionManualDiscount {
  id
  entitledLines {
    all
  }
  recurringCycleLimit
  rejectionReason
  targetType
  title
  type
  usageCount
  value {
    ... on SubscriptionDiscountFixedAmountValue {
      amount {
        amount
        currencyCode
      }
      appliesOnEachItem
    }
    ... on SubscriptionDiscountPercentageValue {
      percentage
    }
  }
}
    `;
export const SubscriptionLineFragment = gql`
    fragment SubscriptionLineFragment on SubscriptionLine {
  id
  productId
  title
  quantity
  sellingPlanId
  sellingPlanName
  variantId
  variantTitle
  requiresShipping
  customAttributes {
    key
    value
  }
  discountAllocations {
    amount {
      amount
      currencyCode
    }
    discount {
      ... on SubscriptionAppliedCodeDiscount {
        ...SubscriptionAppliedCodeDiscountFragment
      }
      ... on SubscriptionManualDiscount {
        ...SubscriptionManualDiscountFragment
      }
    }
  }
  sku
  pricingPolicy {
    basePrice {
      amount
      currencyCode
    }
    cycleDiscounts {
      adjustmentType
      adjustmentValue {
        ... on MoneyV2 {
          amount
          currencyCode
        }
        ... on SellingPlanPricingPolicyPercentageValue {
          percentage
        }
      }
      afterCycle
      computedPrice {
        amount
        currencyCode
      }
    }
  }
  currentPrice {
    amount
    currencyCode
  }
  lineDiscountedPrice {
    amount
    currencyCode
  }
}
    ${SubscriptionAppliedCodeDiscountFragment}
${SubscriptionManualDiscountFragment}`;
export const OrderFragment = gql`
    fragment OrderFragment on Order {
  billingAddress {
    ...MailingAddressFragment
  }
  shippingAddress {
    ...MailingAddressFragment
  }
  billingAddressMatchesShippingAddress
  canMarkAsPaid
  cancelledAt
  closed
  closedAt
  createdAt
  currencyCode
  customAttributes {
    key
    value
  }
  processedAt
  taxLines {
    priceSet {
      shopMoney {
        amount
      }
    }
    rate
    ratePercentage
    title
  }
}
    ${MailingAddressFragment}`;
export const LineItemFragment = gql`
    fragment LineItemFragment on LineItem {
  id
  product {
    id
  }
  customAttributes {
    key
    value
  }
  quantity
  sku
  variant {
    id
  }
  sellingPlan {
    sellingPlanId
    name
  }
}
    `;
export const CustomerVisitFragment = gql`
    fragment CustomerVisitFragment on CustomerVisit {
  id
  landingPage
  landingPageHtml
  marketingEvent {
    marketingChannelType
    description
    endedAt
    id
    manageUrl
    previewUrl
    scheduledToEndAt
    sourceAndMedium
    startedAt
    type
    utmCampaign
    utmMedium
    utmSource
  }
  occurredAt
  referralCode
  referralInfoHtml
  referrerUrl
  source
  sourceDescription
  sourceType
  utmParameters {
    campaign
    content
    medium
    source
    term
  }
}
    `;
export const SmallImageFragment = gql`
    fragment SmallImageFragment on Product {
  images(first: 1) {
    edges {
      node {
        url(
          transform: {maxHeight: 320, maxWidth: 320, preferredContentType: PNG, scale: 2}
        )
        smallImage: url(
          transform: {maxHeight: 74, maxWidth: 74, preferredContentType: PNG, scale: 2}
        )
      }
    }
  }
}
    `;
export const AnchorsFragment = gql`
    fragment AnchorsFragment on SellingPlanAnchor {
  day
  month
  type
}
    `;
export const SellingPlanFragment = gql`
    fragment SellingPlanFragment on SellingPlan {
  metafield(namespace: "smartrr_savedby", key: "source_selling_plan_id") {
    value
  }
  metafield_source_group: metafield(
    namespace: "smartrr_savedby"
    key: "source_selling_plan_group_id"
  ) {
    value
  }
  pricingPolicies {
    ... on SellingPlanFixedPricingPolicy {
      adjustmentType
      adjustmentValue {
        ... on MoneyV2 {
          amount
          currencyCode
        }
        ... on SellingPlanPricingPolicyPercentageValue {
          percentage
        }
      }
    }
    ... on SellingPlanRecurringPricingPolicy {
      adjustmentType
      adjustmentValue {
        ... on MoneyV2 {
          amount
          currencyCode
        }
        ... on SellingPlanPricingPolicyPercentageValue {
          percentage
        }
      }
      afterCycle
    }
  }
  billingPolicy {
    ... on SellingPlanRecurringBillingPolicy {
      anchors {
        ...AnchorsFragment
      }
      interval
      intervalCount
      minCycles
      maxCycles
    }
  }
  deliveryPolicy {
    ... on SellingPlanRecurringDeliveryPolicy {
      anchors {
        ...AnchorsFragment
      }
      cutoff
      intent
      interval
      intervalCount
      preAnchorBehavior
    }
  }
  description
  id
  name
  options
  category
}
    ${AnchorsFragment}`;
export const SellingPlanGroupFragment = gql`
    fragment SellingPlanGroupFragment on SellingPlanGroup {
  id
  appId
  description
  merchantCode
  name
  options
  productsCount {
    count
  }
  productVariantsCount {
    count
  }
  summary
  position
}
    `;
export const DeliveryMethodPickup = gql`
    fragment DeliveryMethodPickup on SubscriptionDeliveryMethodPickup {
  pickupOption {
    code
    description
    presentmentTitle
    title
    location {
      activatable
      addressVerified
      deactivatable
      deletable
      fulfillsOnlineOrders
      hasActiveInventory
      hasUnfulfilledOrders
      id
      isActive
      name
      shipsInventory
      suggestedAddresses {
        address1
        address2
        city
        country
        countryCode
        formatted
        province
        provinceCode
        zip
      }
      address {
        address1
        address2
        city
        country
        countryCode
        formatted
        latitude
        longitude
        phone
        province
        provinceCode
        zip
      }
    }
  }
}
    `;
export const DeliveryMethodShipping = gql`
    fragment DeliveryMethodShipping on SubscriptionDeliveryMethodShipping {
  address {
    id
    address1
    address2
    city
    company
    coordinatesValidated
    country
    countryCodeV2
    firstName
    formatted
    lastName
    name
    phone
    province
    provinceCode
    zip
  }
  shippingOption {
    code
    description
    title
  }
}
    `;
export const DeliveryMethodLocalDelivery = gql`
    fragment DeliveryMethodLocalDelivery on SubscriptionDeliveryMethodLocalDelivery {
  address {
    id
    address1
    address2
    city
    coordinatesValidated
    country
    countryCodeV2
    formatted
    phone
    province
    provinceCode
    zip
  }
  localDeliveryOption {
    code
    description
    instructions
    phone
    presentmentTitle
    title
  }
}
    `;
export const SubscriptionContractQueryFragment = gql`
    fragment SubscriptionContractQueryFragment on SubscriptionContract {
  id
  appAdminUrl
  billingPolicy {
    anchors {
      ...AnchorsFragment
    }
    interval
    intervalCount
    maxCycles
    minCycles
  }
  createdAt
  currencyCode
  customer {
    id
    firstName
    lastName
    defaultEmailAddress {
      emailAddress
    }
    defaultPhoneNumber {
      phoneNumber
    }
    email
    phone
    numberOfOrders
    updatedAt
    numberOfOrders
    state
    amountSpent {
      amount
      currencyCode
    }
    defaultAddress {
      ...MailingAddressFragment
    }
    addresses {
      ...MailingAddressFragment
    }
  }
  customerPaymentMethod(showRevoked: true) {
    id
    revokedAt
    revokedReason
    instrument {
      ... on CustomerCreditCard {
        brand
        expiresSoon
        expiryMonth
        expiryYear
        firstDigits
        lastDigits
        maskedNumber
        name
        source
      }
      ... on CustomerPaypalBillingAgreement {
        inactive
        isRevocable
        paypalAccountEmail
      }
      ... on CustomerShopPayAgreement {
        expiresSoon
        expiryMonth
        expiryYear
        lastDigits
        inactive
        maskedNumber
        name
      }
    }
  }
  deliveryMethod {
    ...DeliveryMethodPickup
    ...DeliveryMethodShipping
    ...DeliveryMethodLocalDelivery
  }
  deliveryPolicy {
    anchors {
      ...AnchorsFragment
    }
    interval
    intervalCount
  }
  deliveryPrice {
    amount
    currencyCode
  }
  lastPaymentStatus
  linesCount {
    count
  }
  nextBillingDate
  originOrder {
    id
    processedAt
    name
  }
  status
  updatedAt
}
    ${AnchorsFragment}
${MailingAddressFragment}
${DeliveryMethodPickup}
${DeliveryMethodShipping}
${DeliveryMethodLocalDelivery}`;
export const GetCurrentInstallationId = gql`
    query GetCurrentInstallationId {
  currentAppInstallation {
    id
  }
}
    `;
export const CreateAppDataMetafield = gql`
    mutation CreateAppDataMetafield($metafieldsSetInput: [MetafieldsSetInput!]!) {
  metafieldsSet(metafields: $metafieldsSetInput) {
    metafields {
      id
      namespace
      key
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetAppSubscription = gql`
    query GetAppSubscription($id: ID!) {
  node(id: $id) {
    ... on AppSubscription {
      ...AppSubscriptionFragment
    }
  }
}
    ${AppSubscriptionFragment}`;
export const AppSubscriptionCreate = gql`
    mutation AppSubscriptionCreate($name: String!, $returnUrl: URL!, $lineItems: [AppSubscriptionLineItemInput!]!, $trialDays: Int, $test: Boolean) {
  appSubscriptionCreate(
    name: $name
    returnUrl: $returnUrl
    lineItems: $lineItems
    trialDays: $trialDays
    test: $test
  ) {
    userErrors {
      field
      message
    }
    confirmationUrl
    appSubscription {
      ...AppSubscriptionFragment
    }
  }
}
    ${AppSubscriptionFragment}`;
export const AppSubscriptionCancel = gql`
    mutation appSubscriptionCancel($id: ID!) {
  appSubscriptionCancel(id: $id) {
    appSubscription {
      id
      name
      status
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const AppSubscriptionTrialExtend = gql`
    mutation appSubscriptionTrialExtend($id: ID!, $days: Int!) {
  appSubscriptionTrialExtend(id: $id, days: $days) {
    appSubscription {
      id
      status
      trialDays
    }
    userErrors {
      field
      message
      code
    }
  }
}
    `;
export const AppUsageRecordCreate = gql`
    mutation AppUsageRecordCreate($subscriptionLineItemId: ID!, $description: String!, $price: MoneyInput!) {
  appUsageRecordCreate(
    subscriptionLineItemId: $subscriptionLineItemId
    description: $description
    price: $price
  ) {
    appUsageRecord {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetCollectionsWithProducts = gql`
    query GetCollectionsWithProducts($query: String!) {
  collections(query: $query, first: 10) {
    edges {
      node {
        id
        title
        handle
        products(first: 50) {
          nodes {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetCustomers = gql`
    query GetCustomers($query: String!, $first: Int!, $cursor: String) {
  customers(query: $query, first: $first, after: $cursor) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        defaultEmailAddress {
          emailAddress
        }
        email
      }
    }
  }
}
    `;
export const GetCustomer = gql`
    query GetCustomer($id: ID!) {
  customer(id: $id) {
    ...CustomerFragment
  }
}
    ${CustomerFragment}`;
export const GetCustomerWithEventsAndActiveSubscriptionIds = gql`
    query GetCustomerWithEventsAndActiveSubscriptionIds($id: ID!, $first: Int!) {
  customer(id: $id) {
    ...CustomerFragment
    subscriptionContracts(first: $first) {
      edges {
        node {
          id
          orders(first: $first) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
    events(first: 50) {
      edges {
        node {
          appTitle
          attributeToApp
          attributeToUser
          createdAt
          criticalAlert
          message
          id
        }
      }
    }
  }
}
    ${CustomerFragment}`;
export const GetCustomerPaymentMethods = gql`
    query GetCustomerPaymentMethods($customerId: ID!, $first: Int!, $cursor: String) {
  customer(id: $customerId) {
    paymentMethods(first: $first, after: $cursor) {
      edges {
        node {
          id
          revokedReason
          revokedAt
          instrument {
            ... on CustomerPaypalBillingAgreement {
              paypalAccountEmail
              isRevocable
              inactive
              __typename
            }
            ... on CustomerCreditCard {
              brand
              expiryMonth
              expiryYear
              lastDigits
              isRevocable
              maskedNumber
              name
              __typename
            }
            ... on CustomerShopPayAgreement {
              expiresSoon
              expiryMonth
              expiryYear
              lastDigits
              maskedNumber
              name
              __typename
            }
          }
        }
      }
    }
  }
}
    `;
export const CustomerCreate = gql`
    mutation CustomerCreate($input: CustomerInput!) {
  customerCreate(input: $input) {
    customer {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerUpdateDefaultAddress = gql`
    mutation CustomerUpdateDefaultAddress($addressId: ID!, $customerId: ID!) {
  customerUpdateDefaultAddress(addressId: $addressId, customerId: $customerId) {
    customer {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerUpdate = gql`
    mutation CustomerUpdate($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      defaultEmailAddress {
        emailAddress
      }
      email
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerAddresses = gql`
    query CustomerAddresses($customerId: ID!) {
  customer(id: $customerId) {
    addresses {
      ...MailingAddressFragment
    }
  }
}
    ${MailingAddressFragment}`;
export const GetDeliveryProfiles = gql`
    query GetDeliveryProfiles($first: Int, $cursor: String) {
  deliveryProfiles(first: $first, after: $cursor) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...DeliveryProfileFragment
        sellingPlanGroups(first: 250) {
          pageInfo {
            hasNextPage
          }
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    ${DeliveryProfileFragment}`;
export const GetDeliveryProfile = gql`
    query GetDeliveryProfile($id: ID!) {
  deliveryProfile(id: $id) {
    ...DeliveryProfileFragment
  }
}
    ${DeliveryProfileFragment}`;
export const GetLocationsAvailableForDeliveryProfilesConnection = gql`
    query GetLocationsAvailableForDeliveryProfilesConnection($count: Int!, $cursor: String) {
  locationsAvailableForDeliveryProfilesConnection(first: $count, after: $cursor) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...LocationFragment
      }
    }
  }
}
    ${LocationFragment}`;
export const GetDeliveryProfileItems = gql`
    query GetDeliveryProfileItems($id: ID!, $count: Int!, $profileItemsCursor: String) {
  deliveryProfile(id: $id) {
    id
    profileItems(first: $count, after: $profileItemsCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          product {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetDeliveryProfileSellingPlanGroups = gql`
    query GetDeliveryProfileSellingPlanGroups($id: ID!, $count: Int!, $sellingPlanGroupsCursor: String) {
  deliveryProfile(id: $id) {
    id
    sellingPlanGroups(first: $count, after: $sellingPlanGroupsCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
}
    `;
export const GetDeliveryProfileLocationGroupZones = gql`
    query GetDeliveryProfileLocationGroupZones($id: ID!, $count: Int!, $locationGroupZonesCursor: String) {
  deliveryProfile(id: $id) {
    id
    profileLocationGroups {
      locationGroupZones(first: $count, after: $locationGroupZonesCursor) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            ...DeliveryProfileLocationGroupZoneFragment
          }
        }
      }
    }
  }
}
    ${DeliveryProfileLocationGroupZoneFragment}`;
export const GetDeliveryProfileLocationGroupZoneMethodDefinitions = gql`
    query GetDeliveryProfileLocationGroupZoneMethodDefinitions($id: ID!, $locationGroupZonesCursor: String, $methodDefinitionCount: Int!) {
  deliveryProfile(id: $id) {
    id
    profileLocationGroups {
      locationGroupZones(first: 1, after: $locationGroupZonesCursor) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            methodDefinitions(first: $methodDefinitionCount) {
              edges {
                cursor
                node {
                  ...DeliveryMethodDefinitionFragment
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DeliveryMethodDefinitionFragment}`;
export const GetDeliveryProfileLocationGroupLocations = gql`
    query GetDeliveryProfileLocationGroupLocations($id: ID!, $count: Int!, $cursor: String) {
  deliveryProfile(id: $id) {
    id
    profileLocationGroups {
      locationGroup {
        locations(first: $count, after: $cursor) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              ...LocationFragment
            }
          }
        }
      }
    }
  }
}
    ${LocationFragment}`;
export const DeliveryProfileCreate = gql`
    mutation DeliveryProfileCreate($profile: DeliveryProfileInput!) {
  deliveryProfileCreate(profile: $profile) {
    profile {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DeliveryProfileUpdate = gql`
    mutation DeliveryProfileUpdate($id: ID!, $profile: DeliveryProfileInput!) {
  deliveryProfileUpdate(id: $id, profile: $profile) {
    profile {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DeliveryProfileRemove = gql`
    mutation DeliveryProfileRemove($id: ID!) {
  deliveryProfileRemove(id: $id) {
    job {
      id
      done
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DeliveryShippingOriginAssign = gql`
    mutation DeliveryShippingOriginAssign($locationId: ID!) {
  deliveryShippingOriginAssign(locationId: $locationId) {
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetDiscountNodeByCode = gql`
    query GetDiscountNodeByCode($code: String!) {
  codeDiscountNodeByCode(code: $code) {
    codeDiscount {
      __typename
      ... on DiscountCodeFreeShipping {
        ...DiscountCodeFreeShippingFragment
        startsAt
        endsAt
        status
        recurringCycleLimit
        usageLimit
        asyncUsageCount
      }
      ... on DiscountCodeBasic {
        ...DiscountCodeBasicFragment
        title
        startsAt
        endsAt
        status
        recurringCycleLimit
        usageLimit
      }
    }
  }
}
    ${DiscountCodeFreeShippingFragment}
${DiscountCodeBasicFragment}`;
export const GetDiscountCodeCombineWithOrderStatus = gql`
    query GetDiscountCodeCombineWithOrderStatus($query: String!) {
  discountNodes(first: 1, query: $query) {
    edges {
      node {
        id
        discount {
          ... on DiscountCodeFreeShipping {
            title
            discountClasses
            shippingDiscountClass: discountClass
            combinesWith {
              orderDiscounts
              productDiscounts
              shippingDiscounts
            }
          }
          ... on DiscountCodeBasic {
            title
            discountClasses
            discountClass
            combinesWith {
              orderDiscounts
              productDiscounts
              shippingDiscounts
            }
          }
          ... on DiscountAutomaticFreeShipping {
            title
            discountClasses
            automaticShippingDiscountClass: discountClass
            combinesWith {
              orderDiscounts
              productDiscounts
              shippingDiscounts
            }
          }
        }
      }
    }
  }
}
    `;
export const DraftOrderCreate = gql`
    mutation DraftOrderCreate($input: DraftOrderInput!) {
  draftOrderCreate(input: $input) {
    draftOrder {
      id
      invoiceUrl
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DraftOrderCalculate = gql`
    mutation DraftOrderCalculate($input: DraftOrderInput!) {
  draftOrderCalculate(input: $input) {
    calculatedDraftOrder {
      subtotalPriceSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      totalPriceSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      totalShippingPriceSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      totalTaxSet {
        shopMoney {
          amount
          currencyCode
        }
      }
      taxLines {
        priceSet {
          presentmentMoney {
            amount
            currencyCode
          }
        }
        rate
        title
      }
      availableShippingRates {
        handle
        title
        price {
          amount
          currencyCode
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DraftOrderUpdate = gql`
    mutation DraftOrderUpdate($id: ID!, $input: DraftOrderInput!) {
  draftOrderUpdate(id: $id, input: $input) {
    draftOrder {
      id
      ready
      order {
        ...DraftOrderInnerOrderFragment
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${DraftOrderInnerOrderFragment}`;
export const DraftOrderComplete = gql`
    mutation DraftOrderComplete($id: ID!) {
  draftOrderComplete(id: $id) {
    draftOrder {
      id
      ready
      order {
        ...DraftOrderInnerOrderFragment
        cancelledAt
        closedAt
        processedAt
        name
        taxesIncluded
        originalTotalPriceSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        totalDiscountsSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        totalTipReceivedSet {
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
        }
        totalShippingPriceSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        totalTaxSet {
          shopMoney {
            amount
            currencyCode
          }
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
          }
          email
          firstName
          lastName
          phone
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${DraftOrderInnerOrderFragment}`;
export const CancelFulfillmentOrder = gql`
    mutation CancelFulfillmentOrder($id: ID!) {
  fulfillmentOrderCancel(id: $id) {
    fulfillmentOrder {
      id
    }
    replacementFulfillmentOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const FulfillmentOrderReschedule = gql`
    mutation fulfillmentOrderReschedule($fulfillAt: DateTime!, $id: ID!) {
  fulfillmentOrderReschedule(fulfillAt: $fulfillAt, id: $id) {
    fulfillmentOrder {
      id
      fulfillAt
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DiscountCodeBasicCreate = gql`
    mutation discountCodeBasicCreate($basicCodeDiscount: DiscountCodeBasicInput!) {
  discountCodeBasicCreate(basicCodeDiscount: $basicCodeDiscount) {
    codeDiscountNode {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DiscountCodeBulkDelete = gql`
    mutation discountCodeBulkDelete($ids: [ID!]) {
  discountCodeBulkDelete(ids: $ids) {
    job {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const DiscountCodeDelete = gql`
    mutation discountCodeDelete($id: ID!) {
  discountCodeDelete(id: $id) {
    deletedCodeDiscountId
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetOrder = gql`
    query GetOrder($id: ID!) {
  order(id: $id) {
    ...OrderFragment
    lineItems(first: 10) {
      edges {
        node {
          ...LineItemFragment
        }
      }
    }
  }
}
    ${OrderFragment}
${LineItemFragment}`;
export const GetOrderLineItems = gql`
    query GetOrderLineItems($orderId: ID!, $cursor: String) {
  order(id: $orderId) {
    lineItems(first: 1, after: $cursor) {
      edges {
        cursor
        node {
          id
          product {
            id
          }
          customAttributes {
            key
            value
          }
          quantity
          sku
          variant {
            id
          }
          sellingPlan {
            sellingPlanId
            name
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
}
    `;
export const GetOrderFulfillments = gql`
    query GetOrderFulfillments($orderId: ID!, $count: Int, $cursor: String) {
  order(id: $orderId) {
    fulfillmentOrders(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          fulfillAt
          status
        }
      }
    }
  }
}
    `;
export const GetOrderCustomerJourneySummary = gql`
    query GetOrderCustomerJourneySummary($orderId: ID!) {
  order(id: $orderId) {
    customerJourneySummary {
      customerOrderIndex
      daysToConversion
      firstVisit {
        ...CustomerVisitFragment
      }
      lastVisit {
        ...CustomerVisitFragment
      }
      momentsCount {
        count
      }
      ready
    }
  }
}
    ${CustomerVisitFragment}`;
export const GetOrderCustomerJourneySummaryMoments = gql`
    query GetOrderCustomerJourneySummaryMoments($orderId: ID!, $count: Int!) {
  order(id: $orderId) {
    customerJourneySummary {
      moments(first: $count) {
        edges {
          node {
            ... on CustomerVisit {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const CreateOrderRefund = gql`
    mutation CreateOrderRefund($input: RefundInput!) {
  refundCreate(input: $input) {
    order {
      id
    }
    refund {
      id
      createdAt
      order {
        id
      }
      totalRefundedSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const OrderUpdate = gql`
    mutation orderUpdate($input: OrderInput!) {
  orderUpdate(input: $input) {
    order {
      id
      customAttributes {
        key
        value
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const OrderEditBegin = gql`
    mutation orderEditBegin($id: ID!) {
  orderEditBegin(id: $id) {
    calculatedOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const OrderEditCommit = gql`
    mutation orderEditCommit($id: ID!) {
  orderEditCommit(id: $id) {
    order {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const OrderEditAddVariant = gql`
    mutation orderEditAddVariant($id: ID!, $quantity: Int!, $variantId: ID!, $allowDuplicates: Boolean) {
  orderEditAddVariant(
    id: $id
    quantity: $quantity
    variantId: $variantId
    allowDuplicates: $allowDuplicates
  ) {
    calculatedLineItem {
      id
    }
    calculatedOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const OrderEditAddLineItemDiscount = gql`
    mutation orderEditAddLineItemDiscount($discount: OrderEditAppliedDiscountInput!, $id: ID!, $lineItemId: ID!) {
  orderEditAddLineItemDiscount(
    discount: $discount
    id: $id
    lineItemId: $lineItemId
  ) {
    addedDiscountStagedChange {
      id
    }
    calculatedLineItem {
      id
    }
    calculatedOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetOrderNote = gql`
    query getOrderNote($id: ID!) {
  order(id: $id) {
    id
    note
  }
}
    `;
export const GetCustomerPaymentMethod = gql`
    query GetCustomerPaymentMethod($id: ID!) {
  customerPaymentMethod(id: $id) {
    id
    revokedAt
    revokedReason
    instrument {
      ... on CustomerCreditCard {
        brand
        expiresSoon
        expiryMonth
        expiryYear
        firstDigits
        lastDigits
        maskedNumber
        name
        source
      }
      ... on CustomerPaypalBillingAgreement {
        inactive
        isRevocable
        paypalAccountEmail
      }
      ... on CustomerShopPayAgreement {
        expiresSoon
        expiryMonth
        expiryYear
        lastDigits
        inactive
        maskedNumber
        name
      }
    }
  }
}
    `;
export const CustomerPaymentMethodSendUpdateEmail = gql`
    mutation CustomerPaymentMethodSendUpdateEmail($customerPaymentMethodId: ID!, $email: EmailInput) {
  customerPaymentMethodSendUpdateEmail(
    customerPaymentMethodId: $customerPaymentMethodId
    email: $email
  ) {
    customer {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerPaymentMethodCreditCardCreate = gql`
    mutation CustomerPaymentMethodCreditCardCreate($billingAddress: MailingAddressInput!, $customerId: ID!, $sessionId: String!) {
  customerPaymentMethodCreditCardCreate(
    billingAddress: $billingAddress
    customerId: $customerId
    sessionId: $sessionId
  ) {
    customerPaymentMethod {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerPaymentMethodCreditCardUpdate = gql`
    mutation CustomerPaymentMethodCreditCardUpdate($billingAddress: MailingAddressInput!, $id: ID!, $sessionId: String!) {
  customerPaymentMethodCreditCardUpdate(
    billingAddress: $billingAddress
    id: $id
    sessionId: $sessionId
  ) {
    customerPaymentMethod {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerPaymentMethodRevoke = gql`
    mutation CustomerPaymentMethodRevoke($customerPaymentMethodId: ID!) {
  customerPaymentMethodRevoke(customerPaymentMethodId: $customerPaymentMethodId) {
    revokedCustomerPaymentMethodId
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerPaymentMethodRemoteCreate = gql`
    mutation customerPaymentMethodRemoteCreate($customerId: ID!, $remoteReference: CustomerPaymentMethodRemoteInput!) {
  customerPaymentMethodRemoteCreate(
    customerId: $customerId
    remoteReference: $remoteReference
  ) {
    customerPaymentMethod {
      id
      instrument {
        ... on CustomerCreditCard {
          name
          brand
          lastDigits
          expiryMonth
          expiryYear
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const CustomerPaymentMethodPaypalBillingAgreementCreate = gql`
    mutation CustomerPaymentMethodPaypalBillingAgreementCreate($customerId: ID!, $billingAddress: MailingAddressInput!, $billingAgreementId: String!) {
  customerPaymentMethodPaypalBillingAgreementCreate(
    customerId: $customerId
    billingAddress: $billingAddress
    billingAgreementId: $billingAgreementId
  ) {
    customerPaymentMethod {
      id
      instrument {
        ... on CustomerPaypalBillingAgreement {
          paypalAccountEmail
        }
      }
    }
  }
}
    `;
export const GetProductCollections = gql`
    query GetProductCollections($productCursor: String, $collectionCursor: String) {
  products(first: 1, after: $productCursor) {
    edges {
      node {
        id
        collections(first: 1, after: $collectionCursor) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              id
              title
              updatedAt
              image {
                url(
                  transform: {maxHeight: 100, maxWidth: 100, preferredContentType: PNG, scale: 2}
                )
                smallImage: url(
                  transform: {maxHeight: 74, maxWidth: 74, preferredContentType: PNG, scale: 2}
                )
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetShopCollections = gql`
    query GetShopCollections($count: Int!) {
  collections(first: $count) {
    edges {
      node {
        id
        title
        handle
      }
    }
  }
}
    `;
export const GetCollectionByHandle = gql`
    query GetCollectionByHandle($handle: String!) {
  collectionByIdentifier(identifier: {handle: $handle}) {
    id
    title
    products(first: 200) {
      edges {
        node {
          id
          title
        }
      }
    }
  }
}
    `;
export const GetProductVariants = gql`
    query GetProductVariants($productsCursor: String, $productVariantsCursor: String) {
  products(first: 1, after: $productsCursor) {
    edges {
      node {
        id
        variants(first: 1, after: $productVariantsCursor) {
          pageInfo {
            hasNextPage
          }
          edges {
            cursor
            node {
              id
              updatedAt
              taxable
              title
              price
              inventoryQuantity
              inventoryPolicy
              inventoryItem {
                id
                sku
                requiresShipping
                tracked
                unitCost {
                  amount
                  currencyCode
                }
                measurement {
                  id
                  weight {
                    unit
                    value
                  }
                }
              }
              deliveryProfile {
                id
                name
              }
              image {
                url(
                  transform: {maxHeight: 320, maxWidth: 320, preferredContentType: PNG, scale: 2}
                )
                smallImage: url(
                  transform: {maxHeight: 74, maxWidth: 74, preferredContentType: PNG, scale: 2}
                )
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetProductVariant = gql`
    query GetProductVariant($variantId: ID!) {
  productVariant(id: $variantId) {
    id
    title
    sku
    inventoryQuantity
    inventoryPolicy
    deliveryProfile {
      id
      name
    }
    inventoryItem {
      tracked
      requiresShipping
      measurement {
        id
        weight {
          unit
          value
        }
      }
    }
  }
}
    `;
export const ProductVariantsBulkUpdate = gql`
    mutation productVariantsBulkUpdate($productId: ID!, $variants: [ProductVariantsBulkInput!]!) {
  productVariantsBulkUpdate(productId: $productId, variants: $variants) {
    product {
      id
    }
    productVariants {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetProducts = gql`
    query GetProducts($productsCursor: String, $query: String) {
  products(first: 1, after: $productsCursor, query: $query) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        updatedAt
        description
        title
        tags
        productType
        ...SmallImageFragment
      }
    }
  }
}
    ${SmallImageFragment}`;
export const GetProductHandle = gql`
    query GetProductHandle($id: ID!) {
  product(id: $id) {
    handle
  }
}
    `;
export const GetProductSmallImage = gql`
    query GetProductSmallImage($productId: ID!) {
  product(id: $productId) {
    ...SmallImageFragment
  }
}
    ${SmallImageFragment}`;
export const ProductUpdate = gql`
    mutation ProductUpdate($product: ProductUpdateInput) {
  productUpdate(product: $product) {
    product {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetScriptTags = gql`
    query GetScriptTags($src: URL, $first: Int!) {
  scriptTags(first: $first, src: $src) {
    edges {
      node {
        id
      }
    }
  }
}
    `;
export const ScriptTagCreate = gql`
    mutation ScriptTagCreate($input: ScriptTagInput!) {
  scriptTagCreate(input: $input) {
    scriptTag {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ScriptTagUpdate = gql`
    mutation ScriptTagUpdate($id: ID!, $input: ScriptTagInput!) {
  scriptTagUpdate(id: $id, input: $input) {
    scriptTag {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ScriptTagDelete = gql`
    mutation ScriptTagDelete($id: ID!) {
  scriptTagDelete(id: $id) {
    deletedScriptTagId
    userErrors {
      field
      message
    }
  }
}
    `;
export const SegmentCreate = gql`
    mutation segmentCreate($name: String!, $query: String!) {
  segmentCreate(name: $name, query: $query) {
    segment {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetSegments = gql`
    query getSegments($first: Int!, $query: String!) {
  segments(first: $first, query: $query) {
    nodes {
      id
      name
    }
  }
}
    `;
export const GetSellingPlanGroups = gql`
    query GetSellingPlanGroups($groupCursor: String, $query: String) {
  sellingPlanGroups(first: 10, after: $groupCursor, query: $query) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...SellingPlanGroupFragment
      }
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const GetTrendingListSellingPlanGroup = gql`
    query GetTrendingListSellingPlanGroup {
  sellingPlanGroups(first: 1, query: "name:[hidden][trending]*") {
    edges {
      node {
        ...SellingPlanGroupFragment
      }
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const GetAddonSellingPlanGroup = gql`
    query GetAddonSellingPlanGroup {
  sellingPlanGroups(first: 1, query: "name:[hidden][addon]*") {
    edges {
      node {
        ...SellingPlanGroupFragment
      }
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const GetSavedBySellingPlanGroups = gql`
    query GetSavedBySellingPlanGroups {
  sellingPlanGroups(first: 250, query: "name:[hidden][savedby]*") {
    edges {
      node {
        ...SellingPlanGroupFragment
      }
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const GetOnlySellingPlanGroup = gql`
    query GetOnlySellingPlanGroup($id: ID!) {
  sellingPlanGroup(id: $id) {
    ...SellingPlanGroupFragment
  }
}
    ${SellingPlanGroupFragment}`;
export const GetSellingPlanGroup = gql`
    query GetSellingPlanGroup($id: ID!, $sellingPlanCursor: String) {
  sellingPlanGroup(id: $id) {
    ...SellingPlanGroupFragment
    sellingPlans(first: 25, after: $sellingPlanCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SellingPlanFragment
        }
      }
    }
  }
}
    ${SellingPlanGroupFragment}
${SellingPlanFragment}`;
export const SellingPlanGroupSellingPlansWithRateLimits = gql`
    query SellingPlanGroupSellingPlansWithRateLimits($id: ID!, $count: Int!, $cursor: String) {
  sellingPlanGroup(id: $id) {
    sellingPlans(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SellingPlanFragment
        }
      }
    }
  }
  extensions @client {
    cost {
      throttleStatus {
        currentlyAvailable
        maximumAvailable
        restoreRate
      }
    }
  }
}
    ${SellingPlanFragment}`;
export const GetSellingPlanGroupSellingPlans = gql`
    query GetSellingPlanGroupSellingPlans($id: ID!, $count: Int!, $cursor: String) {
  sellingPlanGroup(id: $id) {
    sellingPlans(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SellingPlanFragment
        }
      }
    }
  }
}
    ${SellingPlanFragment}`;
export const GetSellingPlanGroupProductsWithoutPagination = gql`
    query GetSellingPlanGroupProductsWithoutPagination($id: ID!, $count: Int!) {
  sellingPlanGroup(id: $id) {
    products(first: $count) {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;
export const GetSellingPlanGroupVariantsWithoutPagination = gql`
    query GetSellingPlanGroupVariantsWithoutPagination($id: ID!, $count: Int!) {
  sellingPlanGroup(id: $id) {
    productVariants(first: $count) {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;
export const GetSellingPlanGroupProducts = gql`
    query GetSellingPlanGroupProducts($id: ID!, $count: Int!, $cursor: String) {
  sellingPlanGroup(id: $id) {
    products(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
}
    `;
export const GetSellingPlanGroupProductVariants = gql`
    query GetSellingPlanGroupProductVariants($id: ID!, $count: Int!, $cursor: String) {
  sellingPlanGroup(id: $id) {
    productVariants(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          product {
            id
            handle
          }
        }
      }
    }
  }
}
    `;
export const GetSellingPlan = gql`
    query GetSellingPlan($id: ID!) {
  node(id: $id) {
    ...SellingPlanFragment
  }
}
    ${SellingPlanFragment}`;
export const GetSellingPlans = gql`
    query GetSellingPlans($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...SellingPlanFragment
  }
}
    ${SellingPlanFragment}`;
export const SellingPlanGroupCreate = gql`
    mutation SellingPlanGroupCreate($input: SellingPlanGroupInput!) {
  sellingPlanGroupCreate(input: $input) {
    sellingPlanGroup {
      id
      sellingPlans(first: 25) {
        edges {
          node {
            ...SellingPlanFragment
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${SellingPlanFragment}`;
export const SellingPlanGroupUpdate = gql`
    mutation SellingPlanGroupUpdate($id: ID!, $input: SellingPlanGroupInput!) {
  sellingPlanGroupUpdate(id: $id, input: $input) {
    sellingPlanGroup {
      id
      sellingPlans(first: 25) {
        edges {
          node {
            ...SellingPlanFragment
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${SellingPlanFragment}`;
export const SellingPlanGroupDelete = gql`
    mutation SellingPlanGroupDelete($id: ID!) {
  sellingPlanGroupDelete(id: $id) {
    deletedSellingPlanGroupId
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const ProductJoinSellingPlanGroups = gql`
    mutation ProductJoinSellingPlanGroups($productId: ID!, $sellingPlanGroupIds: [ID!]!) {
  productJoinSellingPlanGroups(
    id: $productId
    sellingPlanGroupIds: $sellingPlanGroupIds
  ) {
    product {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ProductVariantJoinSellingPlanGroups = gql`
    mutation ProductVariantJoinSellingPlanGroups($productVariantId: ID!, $sellingPlanGroupIds: [ID!]!) {
  productVariantJoinSellingPlanGroups(
    id: $productVariantId
    sellingPlanGroupIds: $sellingPlanGroupIds
  ) {
    productVariant {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ProductLeaveSellingPlanGroups = gql`
    mutation ProductLeaveSellingPlanGroups($productId: ID!, $sellingPlanGroupIds: [ID!]!) {
  productLeaveSellingPlanGroups(
    id: $productId
    sellingPlanGroupIds: $sellingPlanGroupIds
  ) {
    product {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const ProductVariantLeaveSellingPlanGroups = gql`
    mutation ProductVariantLeaveSellingPlanGroups($productVariantId: ID!, $sellingPlanGroupIds: [ID!]!) {
  productVariantLeaveSellingPlanGroups(
    id: $productVariantId
    sellingPlanGroupIds: $sellingPlanGroupIds
  ) {
    productVariant {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SellingPlanGroupAddProducts = gql`
    mutation sellingPlanGroupAddProducts($id: ID!, $productIds: [ID!]!) {
  sellingPlanGroupAddProducts(id: $id, productIds: $productIds) {
    sellingPlanGroup {
      ...SellingPlanGroupFragment
    }
    userErrors {
      field
      message
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const SellingPlanGroupAddProductVariants = gql`
    mutation sellingPlanGroupAddProductVariants($id: ID!, $productVariantIds: [ID!]!) {
  sellingPlanGroupAddProductVariants(
    id: $id
    productVariantIds: $productVariantIds
  ) {
    sellingPlanGroup {
      ...SellingPlanGroupFragment
    }
    userErrors {
      field
      message
    }
  }
}
    ${SellingPlanGroupFragment}`;
export const SellingPlansClientUpdateGroup = gql`
    mutation sellingPlansClientUpdateGroup($id: ID!, $input: SellingPlanGroupInput!) {
  sellingPlanGroupUpdate(id: $id, input: $input) {
    sellingPlanGroup {
      id
      sellingPlans(first: 25) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const SellingPlansClientAddProductsToGroup = gql`
    mutation sellingPlansClientAddProductsToGroup($id: ID!, $productIds: [ID!]!) {
  sellingPlanGroupAddProducts(id: $id, productIds: $productIds) {
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const SellingPlansClientAddProductVariantsToGroup = gql`
    mutation sellingPlansClientAddProductVariantsToGroup($id: ID!, $productVariantIds: [ID!]!) {
  sellingPlanGroupAddProductVariants(
    id: $id
    productVariantIds: $productVariantIds
  ) {
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const SellingPlanGroupRemoveProducts = gql`
    mutation sellingPlanGroupRemoveProducts($id: ID!, $productIds: [ID!]!) {
  sellingPlanGroupRemoveProducts(id: $id, productIds: $productIds) {
    removedProductIds
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const SellingPlanGroupRemoveProductVariants = gql`
    mutation sellingPlanGroupRemoveProductVariants($id: ID!, $productVariantIds: [ID!]!) {
  sellingPlanGroupRemoveProductVariants(
    id: $id
    productVariantIds: $productVariantIds
  ) {
    removedProductVariantIds
    userErrors {
      code
      field
      message
    }
  }
}
    `;
export const ProductCreate = gql`
    mutation ProductCreate($product: ProductCreateInput!, $media: [CreateMediaInput!]) {
  productCreate(product: $product, media: $media) {
    product {
      id
      descriptionHtml
      title
      status
      variants(first: 5) {
        edges {
          node {
            id
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetLocations = gql`
    query GetLocations {
  locations(first: 5) {
    edges {
      node {
        id
        inventoryLevels(first: 5) {
          edges {
            node {
              id
              item {
                id
                variants(first: 1) {
                  edges {
                    node {
                      id
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetShopEligibleForSubscriptions = gql`
    query GetShopEligibleForSubscriptions {
  shop {
    features {
      eligibleForSubscriptions
    }
  }
}
    `;
export const GetShopSubscriptionGatewayEnabled = gql`
    query GetShopSubscriptionGatewayEnabled {
  shop {
    features {
      legacySubscriptionGatewayEnabled
    }
  }
}
    `;
export const GetShopEligibleForSubscriptionMigration = gql`
    query GetShopEligibleForSubscriptionMigration {
  shop {
    features {
      eligibleForSubscriptionMigration
    }
  }
}
    `;
export const GetShopLocales = gql`
    query GetShopLocales {
  shopLocales {
    locale
    name
    primary
    published
  }
}
    `;
export const GetShippableCountriesAndCurrencies = gql`
    query GetShippableCountriesAndCurrencies {
  shop {
    shipsToCountries
    enabledPresentmentCurrencies
  }
}
    `;
export const GetShippableCountries = gql`
    query GetShippableCountries {
  shop {
    shipsToCountries
  }
}
    `;
export const GetShopCustomerAccountsVersion = gql`
    query GetShopCustomerAccountsVersion {
  shop {
    customerAccountsV2 {
      customerAccountsVersion
    }
  }
}
    `;
export const GetThemeFiles = gql`
    query GetThemeFiles($id: ID!, $filenames: [String!]!, $first: Int!) {
  theme(id: $id) {
    id
    name
    files(filenames: $filenames, first: $first) {
      nodes {
        filename
        body {
          ... on OnlineStoreThemeFileBodyText {
            content
          }
        }
      }
    }
  }
}
    `;
export const FlowTriggerReceive = gql`
    mutation flowTriggerReceive($handle: String!, $payload: JSON) {
  flowTriggerReceive(handle: $handle, payload: $payload) {
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetSubscriptionBillingAttempt = gql`
    query GetSubscriptionBillingAttempt($id: ID!) {
  subscriptionBillingAttempt(id: $id) {
    completedAt
    createdAt
    id
    idempotencyKey
    state {
      __typename
      ... on SubscriptionBillingAttemptSuccessState {
        order {
          id
        }
      }
      ... on SubscriptionBillingAttemptFailedState {
        error {
          __typename
          ... on SubscriptionBillingAttemptUnexpectedError {
            message
          }
          ... on SubscriptionBillingAttemptPaymentError {
            paymentCode: code
          }
          ... on SubscriptionBillingAttemptGeneralError {
            generalCode: code
          }
          ... on SubscriptionBillingAttemptInventoryError {
            inventoryCode: code
          }
        }
      }
      ... on SubscriptionBillingAttemptActionRequiredState {
        action {
          ... on SubscriptionBillingAttemptPaymentChallenge {
            nextActionUrl
          }
        }
      }
      ... on SubscriptionBillingAttemptPendingState {
        processing
      }
    }
    subscriptionContract {
      id
    }
  }
}
    `;
export const SubscriptionBillingAttemptCreate = gql`
    mutation SubscriptionBillingAttemptCreate($input: SubscriptionBillingAttemptInput!, $id: ID!) {
  subscriptionBillingAttemptCreate(
    subscriptionBillingAttemptInput: $input
    subscriptionContractId: $id
  ) {
    subscriptionBillingAttempt {
      completedAt
      createdAt
      id
      idempotencyKey
      state {
        __typename
        ... on SubscriptionBillingAttemptSuccessState {
          order {
            id
          }
        }
        ... on SubscriptionBillingAttemptFailedState {
          error {
            __typename
            ... on SubscriptionBillingAttemptUnexpectedError {
              message
            }
            ... on SubscriptionBillingAttemptPaymentError {
              paymentCode: code
            }
            ... on SubscriptionBillingAttemptGeneralError {
              generalCode: code
            }
            ... on SubscriptionBillingAttemptInventoryError {
              inventoryCode: code
            }
          }
        }
        ... on SubscriptionBillingAttemptActionRequiredState {
          action {
            ... on SubscriptionBillingAttemptPaymentChallenge {
              nextActionUrl
            }
          }
        }
        ... on SubscriptionBillingAttemptPendingState {
          processing
        }
      }
      subscriptionContract {
        id
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionBillingCycleContractEdit = gql`
    mutation subscriptionBillingCycleContractEdit($billingCycleInput: SubscriptionBillingCycleInput!) {
  subscriptionBillingCycleContractEdit(billingCycleInput: $billingCycleInput) {
    draft {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionBillingCycleContractDraftConcatenate = gql`
    mutation subscriptionBillingCycleContractDraftConcatenate($concatenatedBillingCycleContracts: [SubscriptionBillingCycleInput!]!, $draftId: ID!) {
  subscriptionBillingCycleContractDraftConcatenate(
    concatenatedBillingCycleContracts: $concatenatedBillingCycleContracts
    draftId: $draftId
  ) {
    draft {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionBillingCycleContractDraftCommit = gql`
    mutation subscriptionBillingCycleContractDraftCommit($draftId: ID!) {
  subscriptionBillingCycleContractDraftCommit(draftId: $draftId) {
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetSubscriptionContracts = gql`
    query GetSubscriptionContracts($first: Int, $cursor: String, $reverse: Boolean) {
  subscriptionContracts(first: $first, after: $cursor, reverse: $reverse) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...SubscriptionContractQueryFragment
      }
    }
  }
}
    ${SubscriptionContractQueryFragment}`;
export const GetSubscriptionContractsIds = gql`
    query GetSubscriptionContractsIds($first: Int, $cursor: String) {
  subscriptionContracts(first: $first, after: $cursor, reverse: true) {
    edges {
      node {
        id
        createdAt
      }
      cursor
    }
  }
}
    `;
export const GetSubscriptionContractOrderIds = gql`
    query GetSubscriptionContractOrderIds($id: ID!, $orderCursor: String) {
  subscriptionContract(id: $id) {
    orders(first: 50, after: $orderCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
}
    `;
export const GetSubscriptionContractsForCustomer = gql`
    query GetSubscriptionContractsForCustomer($id: ID!, $first: Int, $cursor: String) {
  customer(id: $id) {
    subscriptionContracts(first: $first, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          customerPaymentMethod {
            id
          }
          deliveryPrice {
            amount
            currencyCode
          }
          id
          linesCount {
            count
          }
          nextBillingDate
          status
        }
      }
    }
  }
}
    `;
export const GetSubscriptionContract = gql`
    query GetSubscriptionContract($id: ID!) {
  subscriptionContract(id: $id) {
    ...SubscriptionContractQueryFragment
  }
}
    ${SubscriptionContractQueryFragment}`;
export const GetSubscriptionContractDiscounts = gql`
    query GetSubscriptionContractDiscounts($id: ID!, $discountCursor: String) {
  subscriptionContract(id: $id) {
    discounts(first: 10, after: $discountCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SubscriptionManualDiscountFragment
        }
      }
    }
  }
}
    ${SubscriptionManualDiscountFragment}`;
export const GetSubscriptionLineItems = gql`
    query GetSubscriptionLineItems($id: ID!, $first: Int!) {
  subscriptionContract(id: $id) {
    lines(first: $first) {
      edges {
        node {
          ...SubscriptionLineFragment
        }
      }
    }
  }
}
    ${SubscriptionLineFragment}`;
export const GetSubscriptionContractLineCount = gql`
    query GetSubscriptionContractLineCount($id: ID!) {
  subscriptionContract(id: $id) {
    linesCount {
      count
    }
  }
}
    `;
export const GetSubscriptionDraftShippingOptions = gql`
    query GetSubscriptionDraftShippingOptions($id: ID!, $deliveryAddress: MailingAddressInput!) {
  subscriptionDraft(id: $id) {
    shippingOptions(deliveryAddress: $deliveryAddress) {
      __typename
      ... on SubscriptionShippingOptionResultSuccess {
        shippingOptions {
          carrierService {
            id
            name
          }
          code
          presentmentTitle
          price {
            amount
          }
          title
        }
      }
      ... on SubscriptionShippingOptionResultFailure {
        message
      }
    }
  }
}
    `;
export const SubscriptionContractCreate = gql`
    mutation SubscriptionContractCreate($input: SubscriptionContractCreateInput!) {
  subscriptionContractCreate(input: $input) {
    draft {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionContractUpdate = gql`
    mutation SubscriptionContractUpdate($id: ID!) {
  subscriptionContractUpdate(contractId: $id) {
    draft {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftUpdate = gql`
    mutation SubscriptionDraftUpdate($draftId: ID!, $input: SubscriptionDraftInput!) {
  subscriptionDraftUpdate(draftId: $draftId, input: $input) {
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftLineAdd = gql`
    mutation SubscriptionDraftLineAdd($draftId: ID!, $input: SubscriptionLineInput!) {
  subscriptionDraftLineAdd(draftId: $draftId, input: $input) {
    draft {
      id
    }
    lineAdded {
      id
      productId
      variantId
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftLineUpdate = gql`
    mutation SubscriptionDraftLineUpdate($draftId: ID!, $lineId: ID!, $input: SubscriptionLineUpdateInput!) {
  subscriptionDraftLineUpdate(draftId: $draftId, lineId: $lineId, input: $input) {
    draft {
      id
    }
    lineUpdated {
      id
      productId
      variantId
      currentPrice {
        amount
        currencyCode
      }
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftLineRemove = gql`
    mutation SubscriptionDraftLineRemove($draftId: ID!, $lineId: ID!) {
  subscriptionDraftLineRemove(draftId: $draftId, lineId: $lineId) {
    draft {
      id
    }
    lineRemoved {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftCommit = gql`
    mutation SubscriptionDraftCommit($draftId: ID!) {
  subscriptionDraftCommit(draftId: $draftId) {
    contract {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionContractSetNextBillingDate = gql`
    mutation SubscriptionContractSetNextBillingDate($contractId: ID!, $date: DateTime!) {
  subscriptionContractSetNextBillingDate(contractId: $contractId, date: $date) {
    contract {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftDiscountCodeApply = gql`
    mutation SubscriptionDraftDiscountCodeApply($draftId: ID!, $redeemCode: String!) {
  subscriptionDraftDiscountCodeApply(draftId: $draftId, redeemCode: $redeemCode) {
    appliedDiscount {
      id
      redeemCode
      rejectionReason
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftDiscountAdd = gql`
    mutation SubscriptionDraftDiscountAdd($draftId: ID!, $input: SubscriptionManualDiscountInput!) {
  subscriptionDraftDiscountAdd(draftId: $draftId, input: $input) {
    discountAdded {
      id
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftDiscountRemove = gql`
    mutation SubscriptionDraftDiscountRemove($discountId: ID!, $draftId: ID!) {
  subscriptionDraftDiscountRemove(discountId: $discountId, draftId: $draftId) {
    discountRemoved {
      ... on SubscriptionAppliedCodeDiscount {
        id
      }
      ... on SubscriptionManualDiscount {
        id
      }
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftDiscountUpdate = gql`
    mutation SubscriptionDraftDiscountUpdate($discountId: ID!, $draftId: ID!, $input: SubscriptionManualDiscountInput!) {
  subscriptionDraftDiscountUpdate(
    discountId: $discountId
    draftId: $draftId
    input: $input
  ) {
    discountUpdated {
      id
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftFreeShippingDiscountAdd = gql`
    mutation SubscriptionDraftFreeShippingDiscountAdd($draftId: ID!, $input: SubscriptionFreeShippingDiscountInput!) {
  subscriptionDraftFreeShippingDiscountAdd(draftId: $draftId, input: $input) {
    discountAdded {
      id
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const SubscriptionDraftFreeShippingDiscountUpdate = gql`
    mutation SubscriptionDraftFreeShippingDiscountUpdate($discountId: ID!, $draftId: ID!, $input: SubscriptionFreeShippingDiscountInput!) {
  subscriptionDraftFreeShippingDiscountUpdate(
    discountId: $discountId
    draftId: $draftId
    input: $input
  ) {
    discountUpdated {
      id
    }
    draft {
      id
    }
    userErrors {
      ... on SubscriptionDraftUserError {
        code
        field
        message
      }
      field
      message
    }
  }
}
    `;
export const GetSubscriptionDraft = gql`
    query GetSubscriptionDraft($id: ID!, $deliveryAddress: MailingAddressInput, $includeDeliveryOptions: Boolean!) {
  subscriptionDraft(id: $id) {
    id
    billingPolicy {
      anchors {
        ...AnchorsFragment
      }
      interval
      intervalCount
      maxCycles
      minCycles
    }
    currencyCode
    customer {
      id
      firstName
      lastName
      defaultEmailAddress {
        emailAddress
      }
      defaultPhoneNumber {
        phoneNumber
      }
      email
      phone
      numberOfOrders
      state
    }
    customerPaymentMethod(showRevoked: true) {
      id
      revokedAt
      revokedReason
      instrument {
        ... on CustomerCreditCard {
          brand
          expiresSoon
          expiryMonth
          expiryYear
          firstDigits
          lastDigits
          maskedNumber
          name
          source
        }
        ... on CustomerPaypalBillingAgreement {
          inactive
          isRevocable
          paypalAccountEmail
        }
        ... on CustomerShopPayAgreement {
          expiresSoon
          expiryMonth
          expiryYear
          lastDigits
          inactive
          maskedNumber
          name
        }
      }
    }
    deliveryMethod {
      ...DeliveryMethodPickup
      ...DeliveryMethodShipping
      ...DeliveryMethodLocalDelivery
    }
    deliveryPolicy {
      anchors {
        ...AnchorsFragment
      }
      interval
      intervalCount
    }
    deliveryPrice {
      amount
      currencyCode
    }
    deliveryOptions(deliveryAddress: $deliveryAddress) @include(if: $includeDeliveryOptions) {
      ... on SubscriptionDeliveryOptionResultFailure {
        message
      }
      ... on SubscriptionDeliveryOptionResultSuccess {
        deliveryOptions {
          ... on SubscriptionShippingOption {
            code
            description
            phoneRequired
            presentmentTitle
            price {
              amount
              currencyCode
            }
            title
          }
          ... on SubscriptionPickupOption {
            code
            description
            presentmentTitle
            price {
              amount
              currencyCode
            }
            title
          }
          ... on SubscriptionLocalDeliveryOption {
            code
            description
            presentmentTitle
            price {
              amount
              currencyCode
            }
            title
          }
        }
      }
    }
    nextBillingDate
    status
  }
}
    ${AnchorsFragment}
${DeliveryMethodPickup}
${DeliveryMethodShipping}
${DeliveryMethodLocalDelivery}`;
export const GetSubscriptionDraftDiscounts = gql`
    query GetSubscriptionDraftDiscounts($id: ID!, $discountCursor: String) {
  subscriptionDraft(id: $id) {
    discounts(first: 10, after: $discountCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ... on SubscriptionAppliedCodeDiscount {
            ...SubscriptionAppliedCodeDiscountFragment
          }
          ... on SubscriptionManualDiscount {
            ...SubscriptionManualDiscountFragment
          }
        }
      }
    }
  }
}
    ${SubscriptionAppliedCodeDiscountFragment}
${SubscriptionManualDiscountFragment}`;
export const GetSubscriptionDraftLineItems = gql`
    query GetSubscriptionDraftLineItems($id: ID!, $lineCursor: String) {
  subscriptionDraft(id: $id) {
    lines(first: 10, after: $lineCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...SubscriptionLineFragment
        }
      }
    }
  }
}
    ${SubscriptionLineFragment}`;
export const GetSubscriptionDraftLineDiscounts = gql`
    query GetSubscriptionDraftLineDiscounts($id: ID!, $lineCursor: String) {
  subscriptionDraft(id: $id) {
    lines(first: 10, after: $lineCursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          discountAllocations {
            amount {
              amount
              currencyCode
            }
            discount {
              ... on SubscriptionAppliedCodeDiscount {
                ...SubscriptionAppliedCodeDiscountFragment
              }
              ... on SubscriptionManualDiscount {
                ...SubscriptionManualDiscountFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${SubscriptionAppliedCodeDiscountFragment}
${SubscriptionManualDiscountFragment}`;
export const AddTags = gql`
    mutation AddTags($id: ID!, $tags: [String!]!) {
  tagsAdd(id: $id, tags: $tags) {
    node {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const RemoveTags = gql`
    mutation RemoveTags($id: ID!, $tags: [String!]!) {
  tagsRemove(id: $id, tags: $tags) {
    node {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const GetWebhookSubscriptions = gql`
    query GetWebhookSubscriptions($count: Int) {
  webhookSubscriptions(first: $count) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        topic
        uri
        endpoint {
          ... on WebhookEventBridgeEndpoint {
            arn
          }
          ... on WebhookHttpEndpoint {
            callbackUrl
          }
          ... on WebhookPubSubEndpoint {
            pubSubProject
            pubSubTopic
          }
        }
      }
    }
  }
}
    `;
export const GetWebhookSubscription = gql`
    query GetWebhookSubscription($id: ID!) {
  webhookSubscription(id: $id) {
    id
    format
    topic
    includeFields
    uri
    endpoint {
      ... on WebhookEventBridgeEndpoint {
        arn
      }
      ... on WebhookHttpEndpoint {
        callbackUrl
      }
      ... on WebhookPubSubEndpoint {
        pubSubProject
        pubSubTopic
      }
    }
  }
}
    `;
export const WebhookSubscriptionCreate = gql`
    mutation WebhookSubscriptionCreate($topic: WebhookSubscriptionTopic!, $webhookSubscription: WebhookSubscriptionInput!) {
  webhookSubscriptionCreate(
    topic: $topic
    webhookSubscription: $webhookSubscription
  ) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const EventBridgeWebhookSubscriptionCreate = gql`
    mutation EventBridgeWebhookSubscriptionCreate($topic: WebhookSubscriptionTopic!, $webhookSubscription: EventBridgeWebhookSubscriptionInput!) {
  eventBridgeWebhookSubscriptionCreate(
    topic: $topic
    webhookSubscription: $webhookSubscription
  ) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const PubSubWebhookSubscriptionCreate = gql`
    mutation PubSubWebhookSubscriptionCreate($topic: WebhookSubscriptionTopic!, $webhookSubscription: PubSubWebhookSubscriptionInput!) {
  pubSubWebhookSubscriptionCreate(
    topic: $topic
    webhookSubscription: $webhookSubscription
  ) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const WebhookSubscriptionUpdate = gql`
    mutation WebhookSubscriptionUpdate($id: ID!, $webhookSubscription: WebhookSubscriptionInput!) {
  webhookSubscriptionUpdate(id: $id, webhookSubscription: $webhookSubscription) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const EventBridgeWebhookSubscriptionUpdate = gql`
    mutation EventBridgeWebhookSubscriptionUpdate($id: ID!, $webhookSubscription: EventBridgeWebhookSubscriptionInput!) {
  eventBridgeWebhookSubscriptionUpdate(
    id: $id
    webhookSubscription: $webhookSubscription
  ) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const PubSubWebhookSubscriptionUpdate = gql`
    mutation PubSubWebhookSubscriptionUpdate($id: ID!, $webhookSubscription: PubSubWebhookSubscriptionInput!) {
  pubSubWebhookSubscriptionUpdate(
    id: $id
    webhookSubscription: $webhookSubscription
  ) {
    webhookSubscription {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export const WebhookSubscriptionDelete = gql`
    mutation WebhookSubscriptionDelete($id: ID!) {
  webhookSubscriptionDelete(id: $id) {
    deletedWebhookSubscriptionId
    userErrors {
      field
      message
    }
  }
}
    `;